
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7eCZG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $9GVkD = parcelRequire("9GVkD");

const $2bc440c5b7704872$var$accessibilityUtilsPluginKey = new (0, $kCECX.PluginKey)('accessibilityUtilsPlugin');
const $2bc440c5b7704872$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($2bc440c5b7704872$var$accessibilityUtilsPluginKey, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2bc440c5b7704872$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $2bc440c5b7704872$var$accessibilityUtilsPluginKey.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: $2bc440c5b7704872$var$accessibilityUtilsPluginKey,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($2bc440c5b7704872$var$accessibilityUtilsPluginKey);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $2bc440c5b7704872$var$ContentComponent({ api: api }) {
    const { ariaLiveElementAttributes: ariaLiveElementAttributes, key: key, message: message } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'accessibilityUtils'
    ], (states)=>{
        return {
            ariaLiveElementAttributes: states.accessibilityUtilsState?.ariaLiveElementAttributes,
            key: states.accessibilityUtilsState?.key,
            message: states.accessibilityUtilsState?.message
        };
    });
    const role = ariaLiveElementAttributes?.priority === 'important' ? 'alert' : 'status';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        }
    }, message);
}
module.exports["accessibilityUtilsPlugin"] = $2bc440c5b7704872$export$8bab9b7a6db7fbeb;

});

parcelRegister("dYbu7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $luPs0 = parcelRequire("luPs0");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");





var $9WBFV = parcelRequire("9WBFV");


var $eEdSM = parcelRequire("eEdSM");


var $kCECX = parcelRequire("kCECX");

/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $4206d88bb6bf09d0$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        const { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $kCECX.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $4206d88bb6bf09d0$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $9WBFV.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $9WBFV.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ]))(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = tr.doc.type.schema;
        const alignmentApplied = (0, $9WBFV.toggleBlockMarkNext)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $9WBFV.changeImageAlignment)(align))(state, dispatch);
    };
const $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const alignmentApplied = (0, $9WBFV.changeImageAlignmentNext)(align)(tr);
        if (alignmentApplied) api?.analytics?.actions.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })(tr);
        return tr;
    };
const $4206d88bb6bf09d0$export$7364e99daa3bbf34 = (align, api, inputMethod)=>(state, dispatch)=>{
        return $4206d88bb6bf09d0$var$cascadeCommands([
            $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod),
            $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalytics(api?.analytics?.actions, align, inputMethod)
        ])(state, dispatch);
    };
const $4206d88bb6bf09d0$export$69636f7bd4c47a65 = (api, align, inputMethod)=>({ tr: tr })=>{
        $4206d88bb6bf09d0$var$changeBlockAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        $4206d88bb6bf09d0$var$changeImageAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        return tr;
    };


function $6e1ab1814f069c0a$export$e832373cff8dec22(api) {
    const list = {};
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignLeft).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('start', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignCenter).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('center', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.alignRight).common, (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)('end', api, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    return (0, $eBSR7.keymap)(list);
}



var $kpCD8 = parcelRequire("kpCD8");






var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");

const $ec4ef7b6447b9bb9$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $8HW7o.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $bjg0G.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};


function $35e6e74aabe4f7bc$var$createInitialPluginState(editorState, pluginConfig) {
    return {
        align: (0, $ec4ef7b6447b9bb9$export$fcb629559422d129)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $35e6e74aabe4f7bc$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('alignmentPlugin');
function $35e6e74aabe4f7bc$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $kpCD8.SafePlugin)({
        key: $35e6e74aabe4f7bc$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $35e6e74aabe4f7bc$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextPluginState = (0, $ec4ef7b6447b9bb9$export$fcb629559422d129)(nextState);
                const isEnabled = (0, $4206d88bb6bf09d0$export$f3f99b2459c4a09f)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($35e6e74aabe4f7bc$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}









var $3k5Tv = parcelRequire("3k5Tv");





var $d4948231fc8e9cf5$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $kSwu1 = parcelRequire("kSwu1");





var $5NB3T = parcelRequire("5NB3T");


var $6keIx = parcelRequire("6keIx");

var $hYOVX = parcelRequire("hYOVX");

var $12XbP = parcelRequire("12XbP");

var $5ttHX = parcelRequire("5ttHX");

var $5aXzT = parcelRequire("5aXzT");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");




























const $4c7fa596df2cd7ed$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
        label: (0, $5NB3T.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
        label: (0, $5NB3T.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
        label: (0, $5NB3T.alignmentMessages).alignCenter
    }
};
const $4c7fa596df2cd7ed$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $4c7fa596df2cd7ed$var$iconAndMessageMap[props.alignment];
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};











function $ae14d841fc6b2664$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $ldqjS.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content,
        titlePosition: 'bottom'
    });
}
var $ae14d841fc6b2664$export$2e2bcd8739ae039 = $ae14d841fc6b2664$var$AlignmentButton;


const $0b4982f0f832bb7b$var$alignmentWrapper = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $0b4982f0f832bb7b$var$alignmentWrapperStylesUnbounded = null;
const $0b4982f0f832bb7b$var$alignCenterKeyboardShortcut = (0, $ldqjS.alignCenter);
const $0b4982f0f832bb7b$var$alignRightKeyboardShortcut = (0, $ldqjS.alignRight);
const $0b4982f0f832bb7b$var$alignmentOptions = [
    {
        title: (0, $5NB3T.alignmentMessages).alignLeft,
        shortcut: (0, $ldqjS.alignLeft),
        value: 'start'
    },
    {
        title: (0, $5NB3T.alignmentMessages).alignCenter,
        shortcut: $0b4982f0f832bb7b$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $5NB3T.alignmentMessages).alignRight,
        shortcut: $0b4982f0f832bb7b$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $0b4982f0f832bb7b$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "alignment-buttons",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hekY6.default)([
            "_1e0c1txw _ca0qze3t _n3tdze3t _19bvu2gc _u5f3u2gc _p12f53f4 _gy1pv77o",
            "_1fvdglyw",
            className
        ])
    }, $0b4982f0f832bb7b$var$alignmentOptions.map((alignment)=>{
        const { value: value, title: title, shortcut: shortcut } = alignment;
        const message = intl.formatMessage(title);
        return /*#__PURE__*/ $cozmU.createElement((0, $ae14d841fc6b2664$export$2e2bcd8739ae039), {
            content: /*#__PURE__*/ $cozmU.createElement((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                alignment: value
            }),
            key: value,
            value: value,
            label: message,
            shortcut: shortcut,
            onClick: onClick,
            isSelected: value === selectedAlignment
        });
    }));
}
const $0b4982f0f832bb7b$var$_default_1 = (0, $kSwu1.injectIntl)($0b4982f0f832bb7b$var$Alignment);
var $0b4982f0f832bb7b$export$2e2bcd8739ae039 = $0b4982f0f832bb7b$var$_default_1;



function $4f8fa5cbf32e9355$var$_defineProperty(e, r, t) {
    return (r = $4f8fa5cbf32e9355$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4f8fa5cbf32e9355$var$_toPropertyKey(t) {
    var i = $4f8fa5cbf32e9355$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4f8fa5cbf32e9355$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $4f8fa5cbf32e9355$var$AlignmentToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, align: align, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = align ?? 'start';
        const title = intl.formatMessage((0, $5NB3T.alignmentMessages).alignment);
        const alignmentLabelMap = {
            start: intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft),
            center: intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter),
            end: intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight)
        };
        const ariaLabel = `${title}, ${alignmentLabelMap[alignment] ?? ''}`;
        const reducedSpacing = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? 'compact' : 'none';
        const items = [
            {
                key: 'alignmentLeft',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft),
                value: {
                    name: 'start'
                },
                isActive: align === 'start',
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6keIx.Shortcut), null, (0, $ldqjS.tooltip)((0, $ldqjS.alignLeft))),
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                    label: ""
                })
            },
            {
                key: 'alignmentCenter',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter),
                value: {
                    name: 'center'
                },
                isActive: align === 'center',
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6keIx.Shortcut), null, (0, $ldqjS.tooltip)((0, $ldqjS.alignCenter))),
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                    label: ""
                })
            },
            {
                key: 'alignmentRight',
                content: intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight),
                value: {
                    name: 'end'
                },
                isActive: align === 'end',
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6keIx.Shortcut), null, (0, $ldqjS.tooltip)((0, $ldqjS.alignRight))),
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))), {
                    label: ""
                })
            }
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12XbP.ToolbarDropdownWrapper), null, (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gLi18.DropdownMenuWithKeyboardNavigation), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            items: [
                {
                    items: items
                }
            ],
            isOpen: isOpen,
            onItemActivated: this.handleOnItemActivated,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onOpenChange: (attrs)=>this.setState({
                    isOpen: attrs?.isOpen
                }),
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            fitWidth: 200
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
            spacing: isReducedSpacing ? reducedSpacing : 'default',
            disabled: disabled,
            selected: isOpen,
            title: title,
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hYOVX.ToolbarDropdownTriggerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                alignment: alignment
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ttHX.ToolbarExpandIcon), null))
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GNtS.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen,
            handleClickOutside: (event)=>{
                if (event instanceof MouseEvent) this.hide({
                    isOpen: false,
                    event: event
                });
            },
            handleEscapeKeydown: this.hideOnEscape,
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU
            },
            fitWidth: 112,
            fitHeight: 80,
            closeOnTab: true,
            trigger: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
                spacing: isReducedSpacing ? reducedSpacing : 'default',
                disabled: disabled,
                selected: isOpen,
                title: title,
                className: "align-btn",
                "aria-label": ariaLabel,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hYOVX.ToolbarDropdownTriggerWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c7fa596df2cd7ed$export$e75cf43d5d0a9444), {
                    alignment: alignment
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ttHX.ToolbarExpandIcon), null)),
                ref: this.toolbarItemRef
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b4982f0f832bb7b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        ), {
            onClick: (align)=>this.changeAlignment(align, false),
            selectedAlignment: alignment
        })), !api?.primaryToolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5aXzT.ToolbarSeparator), null));
    }
    componentDidUpdate(_prevProps) {
        if (this.props.toolbarType !== (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).FLOATING && this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            this.toolbarItemRef.current?.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args);
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toolbarItemRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $4f8fa5cbf32e9355$var$_defineProperty(this, "state", {
            isOpen: false
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "changeAlignment", (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toggleOpen", ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "toggleOpenByKeyboard", (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "handleOnItemActivated", ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>this.changeAlignment(item.value.name, shouldCloseMenu));
        $4f8fa5cbf32e9355$var$_defineProperty(this, "hide", (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if (attrs?.event instanceof KeyboardEvent && attrs.event.key === 'Escape') this.toolbarItemRef?.current?.focus();
            }
        });
        $4f8fa5cbf32e9355$var$_defineProperty(this, "hideOnEscape", ()=>{
            this.hide();
            this.toolbarItemRef?.current?.focus();
        });
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$4f8fa5cbf32e9355$var$_defineProperty($4f8fa5cbf32e9355$var$AlignmentToolbar, "displayName", 'AlignmentToolbar');
const $4f8fa5cbf32e9355$var$_default_1 = (0, $kSwu1.injectIntl)($4f8fa5cbf32e9355$var$AlignmentToolbar);
var $4f8fa5cbf32e9355$export$2e2bcd8739ae039 = $4f8fa5cbf32e9355$var$_default_1;


const $6c9b0dc1d976046d$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true
};
function $6c9b0dc1d976046d$export$b15abb95157a91c7({ api: api, editorView: editorView }) {
    const { align: align, isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $cozmU.useCallback)((align)=>{
        return (0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)(align, api, (0, $krYZG.INPUT_METHOD).FLOATING_TB)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f8fa5cbf32e9355$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? false : $6c9b0dc1d976046d$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: $6c9b0dc1d976046d$var$FloatingToolbarSettings.disabled || !isEnabled,
        toolbarType: (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).FLOATING,
        api: api
    });
}














function $d6389b7d9d757985$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { align: align, isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $cozmU.useCallback)((align)=>(0, $4206d88bb6bf09d0$export$7364e99daa3bbf34)(align, api, (0, $krYZG.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch), [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f8fa5cbf32e9355$export$2e2bcd8739ae039), {
        align: align,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api,
        toolbarType: (0, $d4948231fc8e9cf5$export$a5d11b3163e4b1a5).PRIMARY
    });
}






var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");














var $a6nzD = parcelRequire("a6nzD");

var $lslMH = parcelRequire("lslMH");


var $ieeJu = parcelRequire("ieeJu");



















const $594f5b856ab4c87c$export$8a5a39b03f4aaab = ()=>({
        start: {
            key: (0, $3nacY.ALIGN_LEFT_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_LEFT_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_LEFT_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignLeft,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
            keymap: (0, $ldqjS.alignLeft)
        },
        center: {
            key: (0, $3nacY.ALIGN_CENTER_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_CENTER_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_CENTER_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignCenter,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
            keymap: (0, $ldqjS.alignCenter)
        },
        end: {
            key: (0, $3nacY.ALIGN_RIGHT_MENU_ITEM).key,
            type: (0, $3nacY.ALIGN_RIGHT_MENU_ITEM).type,
            rank: (0, $hVLmg.ALIGNMENT_MENU_SECTION_RANK)[(0, $3nacY.ALIGN_RIGHT_MENU_ITEM).key],
            label: (0, $5NB3T.alignmentMessages).alignRight,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
            keymap: (0, $ldqjS.alignRight)
        }
    });


const $3e48004ecc148ec6$export$4301fcd45f99f8a5 = ({ children: children, api: api })=>{
    const { align: align = 'start', isEnabled: isEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment',
        'interaction'
    ], (states)=>({
            align: states.interactionState?.interactionState === 'hasNotHadInteraction' && (0, $ieeJu.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true) ? 'start' : states.alignmentState?.align,
            isEnabled: states.alignmentState?.isEnabled
        }));
    const { icon: Icon } = (0, $594f5b856ab4c87c$export$8a5a39b03f4aaab)()[align];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $5NB3T.alignmentMessages).alignment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            size: "small",
            testId: `text-alignment-menu-${align}-icon`
        }),
        isDisabled: !isEnabled,
        testId: "text-alignment-menu",
        label: title,
        tooltipComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: title
        })
    }, children);
};















var $is7KY = parcelRequire("is7KY");


var $dVKvM = parcelRequire("dVKvM");

var $i9j2V = parcelRequire("i9j2V");


const $28ee2ef9ecf5849d$export$ff21a61af4a241d = ({ option: { label: label, icon: Icon, keymap: keymap }, api: api, alignment: alignment, parents: parents })=>{
    const { align: align } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        return {
            align: states.alignmentState?.align
        };
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shortcut = (0, $ldqjS.tooltip)(keymap);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        isSelected: align === alignment,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }),
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)(keymap),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            api?.core.actions.execute((0, $4206d88bb6bf09d0$export$69636f7bd4c47a65)(api, alignment, (0, $is7KY.getInputMethodFromParentKeys)(parents)));
        }
    }, formatMessage(label));
};









var $jgJIe = parcelRequire("jgJIe");

const $b6c847e432bd5d2d$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $3nacY.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title
    }, children);
};



const $2ac7a5076f35ec99$var$getAlignmentMenuItems = (api)=>{
    return Object.entries((0, $594f5b856ab4c87c$export$8a5a39b03f4aaab)()).map(([alignment, item])=>{
        const { key: key, type: type, rank: rank } = item;
        return {
            type: type,
            key: key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_MENU_SECTION).type,
                    key: (0, $3nacY.ALIGNMENT_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28ee2ef9ecf5849d$export$ff21a61af4a241d), {
                    api: api,
                    option: item,
                    alignment: alignment,
                    parents: parents
                });
            }
        };
    });
};
const $2ac7a5076f35ec99$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            type: (0, $3nacY.ALIGNMENT_GROUP).type,
            key: (0, $3nacY.ALIGNMENT_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TEXT_SECTION).type,
                    key: (0, $3nacY.TEXT_SECTION).key,
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.ALIGNMENT_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.ALIGNMENT_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.ALIGNMENT_MENU).type,
            key: (0, $3nacY.ALIGNMENT_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_GROUP).type,
                    key: (0, $3nacY.ALIGNMENT_GROUP).key,
                    rank: (0, $hVLmg.ALIGNMENT_GROUP_RANK)[(0, $3nacY.ALIGNMENT_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e48004ecc148ec6$export$4301fcd45f99f8a5), {
                    api: api
                }, children);
            }
        },
        {
            type: (0, $3nacY.ALIGNMENT_MENU_SECTION).type,
            key: (0, $3nacY.ALIGNMENT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.ALIGNMENT_MENU).type,
                    key: (0, $3nacY.ALIGNMENT_MENU).key,
                    rank: (0, $hVLmg.ALIGNMENT_MENU_RANK)[(0, $3nacY.ALIGNMENT_MENU_SECTION).key]
                },
                {
                    type: (0, $3nacY.TEXT_COLLAPSED_MENU).type,
                    key: (0, $3nacY.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $hVLmg.TEXT_COLLAPSED_MENU_RANK)[(0, $3nacY.ALIGNMENT_MENU_SECTION).key]
                }
            ],
            component: (0, $b6c847e432bd5d2d$export$4b1545b4f2016d26)
        },
        ...$2ac7a5076f35ec99$var$getAlignmentMenuItems(api)
    ];
};


const $d4ff49a147e1ecac$var$defaultConfig = {
    align: 'start'
};
const $d4ff49a147e1ecac$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6389b7d9d757985$export$94516d5cccf573e3), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2ac7a5076f35ec99$export$a758406ca53b86a5)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'alignment',
        component: primaryToolbarComponent
    });
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $luPs0.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $35e6e74aabe4f7bc$export$18d4026d1ea86bb1).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $35e6e74aabe4f7bc$export$ae829ec7b2625219)(dispatch, $d4ff49a147e1ecac$var$defaultConfig)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $6e1ab1814f069c0a$export$e832373cff8dec22)(api)
                }
            ];
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : ()=>{
                const toolbarDocking = (0, $ixfCV.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c9b0dc1d976046d$export$b15abb95157a91c7), {
                                api: api,
                                editorView: view
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 4,
                        pluginName: 'alignment'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["alignmentPlugin"] = $d4ff49a147e1ecac$export$48e8beb2d4cfb048;

});

parcelRegister("gLxaI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $fqVYq = parcelRequire("fqVYq");


var $epbW8 = parcelRequire("epbW8");


var $krYZG = parcelRequire("krYZG");

var $1SZMn = parcelRequire("1SZMn");


var $kCECX = parcelRequire("kCECX");


var $cI8RZ = parcelRequire("cI8RZ");





var $8nvEM = parcelRequire("8nvEM");


var $ieeJu = parcelRequire("ieeJu");




var $0bdaad0e85f57dec$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
    ACTIONS[ACTIONS["SET_HOVERED_ANNOTATION"] = 8] = "SET_HOVERED_ANNOTATION";
    ACTIONS[ACTIONS["FLUSH_PENDING_SELECTIONS"] = 9] = "FLUSH_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_PENDING_SELECTIONS"] = 10] = "SET_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_INLINE_COMMENTS_FETCHED"] = 11] = "SET_INLINE_COMMENTS_FETCHED";
    return ACTIONS;
}({});









var $3mJu6 = parcelRequire("3mJu6");


var $eSYrd = parcelRequire("eSYrd");


var $fRYCB = parcelRequire("fRYCB");

var $gWBVp = parcelRequire("gWBVp");








var $ixfCV = parcelRequire("ixfCV");

var $4dfa7de3992b5086$export$ad08e20e7e22e394 = /*#__PURE__*/ function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    AnnotationSelectionType["DISABLED"] = "disabled";
    AnnotationSelectionType["VALID"] = "valid";
    return AnnotationSelectionType;
}({});
const $4dfa7de3992b5086$var$prefix = 'ak-editor-annotation';
const $4dfa7de3992b5086$export$711f43d01b7e0019 = {
    prefix: $4dfa7de3992b5086$var$prefix,
    floatingComponent: `${$4dfa7de3992b5086$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$4dfa7de3992b5086$var$prefix}-toolbar-create-button`,
    componentSave: `${$4dfa7de3992b5086$var$prefix}-dummy-save-button`,
    componentClose: `${$4dfa7de3992b5086$var$prefix}-dummy-close-button`
};


function $f5fb2d59ed261397$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $f5fb2d59ed261397$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $f5fb2d59ed261397$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $f5fb2d59ed261397$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $f5fb2d59ed261397$export$c023470e9a462982($from).map($f5fb2d59ed261397$var$filterAnnotationIds);
    annotations.sort((a, b)=>$f5fb2d59ed261397$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $f5fb2d59ed261397$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $f5fb2d59ed261397$export$2ecc008effaefd6e = (doc)=>{
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($f5fb2d59ed261397$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
/*
 * verifies if annotation mark contains valid attributes
 */ const $f5fb2d59ed261397$var$validateAnnotationMark = (annotationMark)=>{
    const { id: id, annotationType: annotationType } = annotationMark.attrs;
    return validateAnnotationId(id) && validateAnnotationType(annotationType);
    function validateAnnotationId(id) {
        if (!id || typeof id !== 'string') return false;
        const invalidIds = [
            'null',
            'undefined'
        ];
        return !invalidIds.includes(id.toLowerCase());
    }
    function validateAnnotationType(type) {
        if (!type || typeof type !== 'string') return false;
        const allowedTypes = Object.values((0, $epbW8.AnnotationTypes));
        return allowedTypes.includes(type);
    }
};
const $f5fb2d59ed261397$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $f5fb2d59ed261397$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $8nvEM.Decoration).node(start, end, {
        class: `${(0, $eSYrd.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $f5fb2d59ed261397$export$824a8ce0be7d4e38.block
    });
    return (0, $8nvEM.Decoration).inline(start, end, {
        class: `${(0, $eSYrd.AnnotationSharedClassNames).draft}`
    }, {
        key: $f5fb2d59ed261397$export$824a8ce0be7d4e38.inline
    });
};
const $f5fb2d59ed261397$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $f5fb2d59ed261397$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $kCECX.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>node?.type.name === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    const anchorAnnotationMarks = node?.marks || [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    if (nodeBefore && annotationMark.isInSet(nodeBefore.marks)) {
        const existingMarkIds = marks.map((m)=>m.attrs.id);
        marks = marks.concat(...nodeBefore.marks.filter((m)=>!existingMarkIds.includes(m.attrs.id)));
    }
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $f5fb2d59ed261397$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $f5fb2d59ed261397$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [])=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $kCECX.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            if (supportedBlockNodes.includes(node.type.name)) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $f5fb2d59ed261397$export$31c5af77b755d41f(editorState, bookmark) {
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $f5fb2d59ed261397$export$544b399faf6001b7 = new (0, $kCECX.PluginKey)('inlineCommentPluginKey');
const $f5fb2d59ed261397$export$f05434c51e3762e = (state)=>{
    return $f5fb2d59ed261397$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $f5fb2d59ed261397$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $fRYCB.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $f5fb2d59ed261397$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) attributes = {
            inputMethod: inputMethod,
            overlap: $f5fb2d59ed261397$var$getAnnotationsInSelectionCount(state)
        };
        if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $f5fb2d59ed261397$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $f5fb2d59ed261397$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $f5fb2d59ed261397$export$af7e6fc08350a63d = (state, _supportedNodes = [])=>{
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $f5fb2d59ed261397$export$f05434c51e3762e(state) || {};
    const allowedInlineNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const isSelectionEmpty = selection.empty;
    const isTextOrAllSelection = selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.AllSelection);
    const isValidNodeSelection = selection instanceof (0, $kCECX.NodeSelection) && allowedInlineNodes.includes(selection.node.type.name);
    const isValidSelection = isTextOrAllSelection || isValidNodeSelection;
    // Allow media so that it can enter draft mode
    if ((0, $3mJu6.currentMediaNodeWithPos)(state)?.node) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
    if (isSelectionEmpty || !isValidSelection) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const containsInvalidNodes = $f5fb2d59ed261397$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    if (containsInvalidNodes) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
    if (disallowOnWhitespace && $f5fb2d59ed261397$export$6d32268ea00f42b0(selection, state.schema)) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) && (0, $fRYCB.isEmptyTextSelection)(selection, state.schema)) return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    return (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
};
const $f5fb2d59ed261397$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $fRYCB.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
const $f5fb2d59ed261397$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [])=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0;
};
function $f5fb2d59ed261397$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $gWBVp.isText)(node, schema)) {
            if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node.eq(content.lastChild) && // and there are multiple nodes
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $gWBVp.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $f5fb2d59ed261397$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $f5fb2d59ed261397$export$f05434c51e3762e(state);
    return !!commentsPluginState?.annotations && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $f5fb2d59ed261397$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $f5fb2d59ed261397$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $fRYCB.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $f5fb2d59ed261397$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $f5fb2d59ed261397$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $f5fb2d59ed261397$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $kCECX.NodeSelection)) {
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = node?.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            })) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};
const $f5fb2d59ed261397$export$98b0a2a6ba343064 = (state)=>{
    const annotations = $f5fb2d59ed261397$export$f05434c51e3762e(state)?.annotations;
    if (annotations) {
        /**
     * annotations type is { [key: string]: boolean };
     * Here, key represents mark.attr.id and it is used to find where annotation to be presented in the document.
     * When value is false, it means it is unresolved annotation.
     *
     * But sometimes annotation map has entry with key undefined somehow.
     * And it is not valid mark attribute id, so it won't be presented anywhere in the document.
     */ const unresolvedAnnotationKeys = Object.keys(annotations).filter((key)=>key !== 'undefined' && annotations[key] === false);
        return unresolvedAnnotationKeys.length > 0;
    }
    return false;
};


var $31323b7e8bd0e126$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED:
            return {
                ...pluginState,
                annotationsLoaded: true
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotationsLoaded: true,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE:
            return $31323b7e8bd0e126$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.supportedBlockNodes, action.data.targetNodeId, action.data.isOpeningMediaCommentFromToolbar);
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false,
                isOpeningMediaCommentFromToolbar: false,
                selectedAnnotations: []
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).ADD_INLINE_COMMENT:
            const updatedPluginState = $31323b7e8bd0e126$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined,
                ...pluginState.isAnnotationManagerEnabled && {
                    skipSelectionHandling: true
                }
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $31323b7e8bd0e126$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false,
                isOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION:
            return {
                ...pluginState,
                hoveredAnnotations: [
                    ...action.data.hoveredAnnotations
                ],
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS:
            return {
                ...pluginState,
                selectedAnnotations: action.data.canSetAsSelectedAnnotations ? [
                    ...pluginState.pendingSelectedAnnotations
                ] : pluginState.selectedAnnotations,
                pendingSelectedAnnotations: [],
                isInlineCommentViewClosed: false
            };
        case (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS:
            return {
                ...pluginState,
                pendingSelectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $31323b7e8bd0e126$var$getNewDraftState(pluginState, drafting, editorState, targetType, supportedBlockNodes, targetNodeId, isOpeningMediaCommentFromToolbar) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $8nvEM.DecorationSet).empty;
    const newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(editorState, newState.bookmark, supportedBlockNodes);
        const draftDecoration = (0, $f5fb2d59ed261397$export$b3b680ab7872fa4c)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    newState.isOpeningMediaCommentFromToolbar = isOpeningMediaCommentFromToolbar;
    return newState;
}



const $42647913cd19dc49$var$handleDocChanged = (tr, prevPluginState)=>{
    if (!tr.getMeta('replaceDocument')) return $42647913cd19dc49$var$getSelectionChangedHandler(false)(tr, prevPluginState);
    return {
        ...prevPluginState,
        dirtyAnnotations: true
    };
};
/**
 * Creates a handleDocChanged function with its own deleted annotations cache.
 * This ensures each editor instance has its own cache, avoiding cross-contamination.
 */ const $42647913cd19dc49$var$createHandleDocChanged = ()=>{
    // Cache for preserving deleted annotation resolved states through delete/undo cycles
    // This lives in closure scope per editor instance to avoid serialization and reduce state size
    const deletedAnnotationsCache = {};
    return (tr, prevPluginState)=>{
        if (tr.getMeta('replaceDocument')) return {
            ...prevPluginState,
            dirtyAnnotations: true
        };
        const updatedState = $42647913cd19dc49$var$getSelectionChangedHandler(false)(tr, prevPluginState);
        // Collect annotation IDs currently in the document
        const annotationIdsInDocument = new Set();
        tr.doc.descendants((node)=>{
            node.marks.forEach((mark)=>{
                if (mark.type.name === 'annotation') annotationIdsInDocument.add(mark.attrs.id);
            });
        });
        const annotationIdsInState = Object.keys(prevPluginState.annotations);
        // Early return if annotations haven't changed
        const annotationsHaveChanged = annotationIdsInDocument.size !== annotationIdsInState.length || annotationIdsInState.some((id)=>!annotationIdsInDocument.has(id));
        if (!annotationsHaveChanged) return updatedState;
        // Cache deleted annotations to be able to restore their resolved states on undo
        const updatedAnnotations = {};
        annotationIdsInState.forEach((id)=>{
            if (!annotationIdsInDocument.has(id)) deletedAnnotationsCache[id] = prevPluginState.annotations[id];
        });
        // Update annotations to match document state, preserving resolved states through delete/undo
        // Only include annotations that have a known resolved state - don't default new annotations to false
        // as this would cause them to briefly appear as unresolved before the provider sets their actual state
        annotationIdsInDocument.forEach((id)=>{
            const knownState = prevPluginState.annotations[id] ?? deletedAnnotationsCache[id];
            if (knownState !== undefined) updatedAnnotations[id] = knownState;
        });
        return {
            ...updatedState,
            annotations: updatedAnnotations
        };
    };
};
const $42647913cd19dc49$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $kCECX.NodeSelection)) {
        const bookmarkSelection = bookmark?.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $kCECX.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
			 * Currently, after updating the alt text of a mediaSingle node,
			 * the selection moves to the media node.
			 * (then will append a transaction to its parent node)
			 */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') return !bookmarkNode.firstChild?.eq(selectionNode);
            else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $42647913cd19dc49$var$getSelectionChangeHandlerOld = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (// If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $f5fb2d59ed261397$export$e171deb7d9f0a865)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $f5fb2d59ed261397$export$3bf994b39b13856a)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $f5fb2d59ed261397$export$a411569b9111c88e)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $42647913cd19dc49$var$getSelectionChangeHandlerNew = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $f5fb2d59ed261397$export$3bf994b39b13856a)(tr.selection, tr.doc);
        // NOTE: I've left this commented code here as a reference that the previous old code would reset the selected annotations
        // if the selection is empty. If this is no longer needed, we can remove this code.
        // if (selectedAnnotations.length === 0) {
        // 	return {
        // 		...pluginState,
        // 		pendingSelectedAnnotations: selectedAnnotations,
        // 		pendingSelectedAnnotationsUpdateCount:
        // 			pluginState.pendingSelectedAnnotationsUpdateCount + 1,
        // 		isInlineCommentViewClosed: true,
        // 		selectAnnotationMethod: undefined,
        // 	};
        // }
        if ((0, $f5fb2d59ed261397$export$a411569b9111c88e)(selectedAnnotations, pluginState.pendingSelectedAnnotations)) return {
            ...pluginState,
            pendingSelectedAnnotations: selectedAnnotations,
            pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $42647913cd19dc49$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>pluginState.isAnnotationManagerEnabled ? $42647913cd19dc49$var$getSelectionChangeHandlerNew(reopenCommentView)(tr, pluginState) : $42647913cd19dc49$var$getSelectionChangeHandlerOld(reopenCommentView)(tr, pluginState);
// Create the handler with cache once at module level
const $42647913cd19dc49$var$handleDocChangedWithSync = $42647913cd19dc49$var$createHandleDocChanged();
const $42647913cd19dc49$var$getDocChangedHandler = (tr, prevPluginState)=>{
    // Check feature flag at runtime to support test variants
    if ((0, $ieeJu.expValEquals)('platform_editor_annotations_sync_on_docchange', 'isEnabled', true)) return $42647913cd19dc49$var$handleDocChangedWithSync(tr, prevPluginState);
    return $42647913cd19dc49$var$handleDocChanged(tr, prevPluginState);
};
const $42647913cd19dc49$var$dest = (0, $cI8RZ.pluginFactory)((0, $f5fb2d59ed261397$export$544b399faf6001b7), (0, $31323b7e8bd0e126$export$2e2bcd8739ae039), {
    onSelectionChanged: $42647913cd19dc49$var$getSelectionChangedHandler(true),
    onDocChanged: $42647913cd19dc49$var$getDocChangedHandler,
    mapping: (tr, pluginState, editorState)=>{
        const { draftDecorationSet: draftDecorationSet, bookmark: bookmark } = pluginState;
        let mappedDecorationSet = (0, $8nvEM.DecorationSet).empty, mappedBookmark;
        let hasMappedDecorations = false;
        if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
        hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $f5fb2d59ed261397$export$824a8ce0be7d4e38)).includes(spec.key)).length > 0;
        // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
        // we need to reset bookmark to hide create component and to avoid invalid draft being published
        // We only perform this change when document selection has changed.
        if (!hasMappedDecorations && $42647913cd19dc49$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: undefined
        };
        if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
        // return same pluginState if mappings did not change
        if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
        return {
            ...pluginState,
            draftDecorationSet: mappedDecorationSet,
            bookmark: mappedBookmark
        };
    }
});
const $42647913cd19dc49$export$656c7661095efe2e = $42647913cd19dc49$var$dest.createPluginState;
const $42647913cd19dc49$export$8d4021544bdece00 = $42647913cd19dc49$var$dest.createCommand;












var $bhf6v = parcelRequire("bhf6v");








var $eOaGc = parcelRequire("eOaGc");





const $1bac1a5a00358626$var$isAnnotationStep = (step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark.type.name === 'annotation';
const $1bac1a5a00358626$var$addAnnotationMark = (id, supportedBlockNodes)=>(transaction, state)=>{
        const inlineCommentState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark, supportedBlockNodes);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            const tr = (0, $bhf6v.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // The mark may not be applied to the current "head" of the bookmark so determine what was applied
            // above and use that instead
            const annotationMarkStep = tr.steps.reverse().find($1bac1a5a00358626$var$isAnnotationStep);
            const headBasedOnMark = from === head ? annotationMarkStep?.from : annotationMarkStep?.to;
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, headBasedOnMark ?? head));
        }
        return tr;
    };
const $1bac1a5a00358626$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>(transaction, state)=>{
            let tr = $1bac1a5a00358626$var$addAnnotationMark(id, supportedBlockNodes)(transaction, state);
            editorAPI?.editorViewModeEffects?.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $1bac1a5a00358626$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $1bac1a5a00358626$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $krYZG.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $1bac1a5a00358626$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $f5fb2d59ed261397$export$a28639698c912d2c)(drafting, method)(state);
            editorAnalyticsAPI?.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const tr = $1bac1a5a00358626$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const isAutoScrollBugFixEnabled = pluginState?.featureFlagsPluginState?.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $1bac1a5a00358626$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark)
            });
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $1bac1a5a00358626$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $krYZG.ACTION).RESOLVED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$addPreemptiveGateErrorAnalytics = (editorAnalyticsAPI)=>(errorReason)=>(transaction, state)=>{
            const analyticsEvent = {
                action: (0, $krYZG.ACTION).ERROR,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorReason: errorReason
                }
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
            return transaction;
        };
const $1bac1a5a00358626$var$addDeleteAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {}
        };
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $1bac1a5a00358626$var$_default_1 = {
    addAnnotationMark: $1bac1a5a00358626$var$addAnnotationMark,
    addInlineComment: $1bac1a5a00358626$var$addInlineComment,
    handleDraftState: $1bac1a5a00358626$var$handleDraftState,
    addOpenCloseAnalytics: $1bac1a5a00358626$var$addOpenCloseAnalytics,
    addInsertAnalytics: $1bac1a5a00358626$var$addInsertAnalytics,
    addResolveAnalytics: $1bac1a5a00358626$var$addResolveAnalytics,
    addPreemptiveGateErrorAnalytics: $1bac1a5a00358626$var$addPreemptiveGateErrorAnalytics,
    addDeleteAnalytics: $1bac1a5a00358626$var$addDeleteAnalytics
};
var $1bac1a5a00358626$export$2e2bcd8739ae039 = $1bac1a5a00358626$var$_default_1;


const $0592d2368c2c3f07$export$2c4e3be4c627582b = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('commenting')({
        tr: tr
    });
};
const $0592d2368c2c3f07$export$dc07a25f8edf98a5 = (api, tr)=>{
    return api?.userIntent?.commands?.setCurrentUserIntent('default')({
        tr: tr
    });
};


const $5a3eafd29b4d037d$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // TODO: EDF-716 - This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $1SZMn.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, (tr, state)=>transformer((0, $1bac1a5a00358626$export$2e2bcd8739ae039).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, transformer);
    };
const $5a3eafd29b4d037d$export$da26c8d097933b72 = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).CLOSE_COMPONENT
    });
const $5a3eafd29b4d037d$export$ffa869a92c2481c3 = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $5a3eafd29b4d037d$export$a3833f7fc842f6da = ()=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENTS_FETCHED
    });
const $5a3eafd29b4d037d$export$940b79a08b19cea6 = (editorAnalyticsAPI)=>(canSetAsSelectedAnnotations, errorReason)=>{
        const command = {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).FLUSH_PENDING_SELECTIONS,
            data: {
                canSetAsSelectedAnnotations: canSetAsSelectedAnnotations
            }
        };
        if (!!errorReason) return (0, $42647913cd19dc49$export$8d4021544bdece00)(command, (tr, state)=>(0, $1bac1a5a00358626$export$2e2bcd8739ae039).addPreemptiveGateErrorAnalytics(editorAnalyticsAPI)(errorReason)(tr, state));
        return (0, $42647913cd19dc49$export$8d4021544bdece00)(command);
    };
const $5a3eafd29b4d037d$export$a99e2fe25edc1abd = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_PENDING_SELECTIONS,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    if (selection instanceof (0, $kCECX.NodeSelection) && (0, $f5fb2d59ed261397$export$bb7c9ea7da92cd01)(selection.node, supportedBlockNodes)) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $5a3eafd29b4d037d$export$75bee4cee90040 = (id, supportedNodes = [])=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($5a3eafd29b4d037d$var$removeInlineCommentFromNode(id, supportedNodes, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $5a3eafd29b4d037d$export$d087dc0f7213ba13 = (editorAnalyticsAPI)=>(id, supportedNodes = [])=>(state, dispatch)=>{
            const { tr: tr } = state;
            state.doc.descendants((node, pos)=>{
                // Inline comment on mediaInline is not supported as part of comments on media project
                // Thus, we skip the decoration for mediaInline node
                if (node.type.name === 'mediaInline') return false;
                const isSupportedBlockNode = node.isBlock && supportedNodes?.includes(node.type.name);
                node.marks.filter((mark)=>mark.type === state.schema.marks.annotation && mark.attrs.id === id).forEach((mark)=>{
                    if (isSupportedBlockNode) tr.removeNodeMark(pos, mark);
                    else tr.removeMark(pos, pos + node.nodeSize, mark);
                });
            });
            if (dispatch) {
                dispatch((0, $1bac1a5a00358626$export$2e2bcd8739ae039).addDeleteAnalytics(editorAnalyticsAPI)(tr, state));
                return true;
            }
            return false;
        };
const $5a3eafd29b4d037d$var$getDraftCommandAction = (drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorState) !== (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID) return false;
        return {
            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                supportedBlockNodes: supportedBlockNodes,
                targetNodeId: targetNodeId,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            }
        };
    };
};
const $5a3eafd29b4d037d$export$d80af6562490622d = (supportedBlockNodes = [])=>(node, viewMethod, isOpeningMediaCommentFromToolbar)=>(state, dispatch)=>{
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && supportedBlockNodes.includes(node.type.name)) {
                const unresolvedAnnotationMarks = (node?.marks || []).filter((mark)=>mark.type === annotation && !pluginState?.annotations[mark.attrs.id]).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), {
                            type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod,
                                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $5a3eafd29b4d037d$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [], api)=>(drafting, inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR, targetType = 'inline', targetNodeId, isOpeningMediaCommentFromToolbar)=>{
        const commandAction = $5a3eafd29b4d037d$var$getDraftCommandAction(drafting, targetType, targetNodeId, supportedBlockNodes, isOpeningMediaCommentFromToolbar);
        if (Boolean(api?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $1bac1a5a00358626$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)(state.tr, state);
            const newPluginState = commandAction(state);
            if (tr && newPluginState) {
                tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), newPluginState);
                if (drafting) (0, $0592d2368c2c3f07$export$2c4e3be4c627582b)(api, tr);
                else (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(api, tr);
                if (dispatch) dispatch(tr);
            } else return false;
            return true;
        };
        else return (0, $42647913cd19dc49$export$8d4021544bdece00)(commandAction, (0, $1bac1a5a00358626$export$2e2bcd8739ae039).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod));
    };
const $5a3eafd29b4d037d$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes)=>{
        const commandAction = (editorState)=>({
                type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        if (Boolean(editorAPI?.toolbar)) return (state, dispatch)=>{
            const tr = (0, $1bac1a5a00358626$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state.tr, state);
            tr.setMeta((0, $f5fb2d59ed261397$export$544b399faf6001b7), commandAction(state));
            (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(editorAPI, tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
        else return (0, $42647913cd19dc49$export$8d4021544bdece00)(commandAction, (0, $1bac1a5a00358626$export$2e2bcd8739ae039).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes));
    };
const $5a3eafd29b4d037d$export$ef4c42f03863dce9 = (mouseData)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $5a3eafd29b4d037d$export$1e715f68ff6f5a2f = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$export$c1805eee6fd0cf44 = (id)=>(0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).SET_HOVERED_ANNOTATION,
        data: {
            hoveredAnnotations: [
                {
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $5a3eafd29b4d037d$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $epbW8.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $epbW8.AnnotationTypes).INLINE_COMMENT) return $5a3eafd29b4d037d$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes)(state, dispatch);
            return false;
        };
const $5a3eafd29b4d037d$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $42647913cd19dc49$export$8d4021544bdece00)({
        type: (0, $0bdaad0e85f57dec$export$92a1a3b7554e9387).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};





const $7cab94c6d4281aad$export$802ec1d716a6bb1 = {
    ...(0, $epbW8.annotation),
    toDOM: (node)=>{
        return [
            'span',
            {
                // Needs id as a reference point
                id: node.attrs.id,
                // Used to determine if the annotation is active
                annotationType: node.attrs.annotationType,
                // Below are used for prosemirror (ie. copy/paste behaviour)
                'data-mark-type': 'annotation',
                'data-mark-annotation-type': node.attrs.annotationType,
                'data-id': node.attrs.id
            },
            0
        ];
    }
};









var $kpCD8 = parcelRequire("kpCD8");















const $d252fa5145d6fd3d$export$b3ab33741101ad90 = (isUnresolved, hasFocus, isHovered)=>{
    if (!isUnresolved) return;
    if (hasFocus) return (0, $eSYrd.AnnotationSharedClassNames).focus;
    if (isHovered) return (0, $eSYrd.AnnotationSharedClassNames).hover;
    return (0, $eSYrd.AnnotationSharedClassNames).blur;
};
const $d252fa5145d6fd3d$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $eSYrd.BlockAnnotationSharedClassNames).focus : (0, $eSYrd.BlockAnnotationSharedClassNames).blur;
};









var $bjg0G = parcelRequire("bjg0G");




const $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED = 'draft-not-started';
const $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS = 'draft-in-progress';
const $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_MISSING = 'range-no-longer-exists';
const $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_INVALID = 'invalid-range';
const $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID = 'id-not-valid';
const $fcd3fd145d889c5a$var$domRefFromPos = (view, position)=>{
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $bjg0G.findDomRefAtPos)(position, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return undefined;
    }
    return dom;
};
const $fcd3fd145d889c5a$export$86f3258f283eb796 = (editorView, _options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return false;
        const decoration = draftDecorationSet?.find();
        // If a draft decoration exists then we should block the user from creating a new one.
        if (!!decoration?.length) return false;
        return (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorView.state) === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).VALID;
    };
const $fcd3fd145d889c5a$export$768048043e8d2bcd = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        if (!!selectedAnnotations?.length) {
            // if there are selected annotations when starting a draft, we need to clear the selected annotations
            // before we start the draft.
            (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            // not only that but we need to also deselect any other annotations that are currently selected.
            selectedAnnotations?.forEach((annotation)=>{
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: annotation.id,
                        isSelected: false,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                    }
                });
            });
        }
        (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(true)(editorView.state, editorView.dispatch);
        const { draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        const decorations = draftDecorationSet?.find();
        // If the matching decorations is not found containing the id, it means something went wrong with the draft.
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_INVALID
        };
        const from = decorations[0].from;
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        options.annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                targetElement: targetElement,
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes
            }
        });
        return {
            success: true,
            targetElement: targetElement,
            // In Editor the action result is undefined, because the editor will perform the transaction on the document.
            actionResult: undefined,
            inlineNodeTypes: inlineNodeTypes
        };
    };
const $fcd3fd145d889c5a$export$eeeb486534738631 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        return {
            success: true
        };
    };
const $fcd3fd145d889c5a$export$8bc7b93e04771bda = (editorView, options)=>(id)=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet, bookmark: bookmark } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length || !bookmark) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_RANGE_MISSING
        };
        const from = decorations[0].from;
        (0, $5a3eafd29b4d037d$export$51eda81011da4982)(options.editorAnalyticsAPI, options.api)(id, (0, $epbW8.AnnotationTypes).INLINE_COMMENT, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        // Using the original decoration from position we should be able to locate the new target element.
        // This is because the new annotation will be created at the same position as the draft decoration.
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        // When a draft is applied it is automatically selected, so we need to set the selected annotation.
        // emit the event for the selected annotation.
        options.annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: id,
                isSelected: true,
                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
            }
        });
        return {
            success: true,
            targetElement: // Get the dom element from the newly created annotation and return it here.
            targetElement,
            // In Editor this is undefined, because the editor will update the document.
            actionResult: undefined
        };
    };
const $fcd3fd145d889c5a$export$1a473231c51c1d5b = (editorView, _options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet?.find();
        if (!decorations?.length) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const from = decorations[0].from;
        const targetElement = $fcd3fd145d889c5a$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        return {
            success: true,
            inlineNodeTypes: inlineNodeTypes,
            targetElement: targetElement,
            actionResult: undefined
        };
    };
const $fcd3fd145d889c5a$export$b8ac6bdd928e737c = (editorView, options)=>(id, isSelected)=>{
        const { annotations: annotations, isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlySelectedIndex = selectedAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlySelected = isCurrentlySelectedIndex !== -1;
        if (isSelected !== isCurrentlySelected) {
            // the annotation is selection is changing.
            if (isCurrentlySelected && !isSelected) {
                // the selected annotaion is being unselected, so we need to close the view.
                (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: false,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            } else if (!isCurrentlySelected && isSelected) {
                // the annotation is currently not selected and is being selected, so we need to open the view.
                (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(id)(editorView.state, editorView.dispatch);
                // the current annotations are going to be unselected. So we need to notify listeners of this change also.
                selectedAnnotations?.forEach((annotation)=>{
                    if (annotation.id !== id) options.annotationManager?.emit({
                        name: 'annotationSelectionChanged',
                        data: {
                            annotationId: annotation.id,
                            isSelected: false,
                            inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                        }
                    });
                });
                // Lastly we need to emit the event for the selected annotation.
                options.annotationManager?.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: true,
                        inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            }
        }
        return {
            success: true,
            isSelected: isSelected
        };
    };
const $fcd3fd145d889c5a$export$5ada3da2e2f0701f = (editorView, _options)=>(id, isHovered)=>{
        const { annotations: annotations, hoveredAnnotations: hoveredAnnotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlyHoveredIndex = hoveredAnnotations?.findIndex((annotation)=>annotation.id === id) ?? -1;
        const isCurrentlyHovered = isCurrentlyHoveredIndex !== -1;
        if (isHovered !== isCurrentlyHovered) {
            // the annotation in hovered is changing.
            if (isCurrentlyHovered && !isHovered) // the hovered annotaion is being unhovered, so we should remove the hover state.
            (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            else if (!isCurrentlyHovered && isHovered) // the annotation is currently not hovered and is being hovered.
            (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)(id)(editorView.state, editorView.dispatch);
        }
        return {
            success: true,
            isHovered: isHovered
        };
    };
const $fcd3fd145d889c5a$export$6baae9b3f0f9bdce = (editorView, options)=>(id)=>{
        const { annotations: annotations } = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!annotations?.hasOwnProperty(id)) return {
            success: false,
            reason: $fcd3fd145d889c5a$var$ERROR_REASON_ID_INVALID
        };
        (0, $5a3eafd29b4d037d$export$d087dc0f7213ba13)(options.editorAnalyticsAPI)(id, options.provider.supportedBlockNodes)(editorView.state, editorView.dispatch);
        return {
            success: true,
            actionResult: undefined
        };
    };









var $iLcY8 = parcelRequire("iLcY8");


var $ldqjS = parcelRequire("ldqjS");





var $83k8i = parcelRequire("83k8i");


var $gZpSA = parcelRequire("gZpSA");




var $6Ixg8 = parcelRequire("6Ixg8");


var $eDtFr = parcelRequire("eDtFr");







const $c64cd5f7ffbeb7e3$var$getValidNodes = (state)=>{
    const { schema: schema } = state;
    const { annotation: annotation } = schema.marks;
    return Object.keys(schema.nodes).reduce((acc, current)=>{
        const type = schema.nodes[current];
        if (type.allowsMarkType(annotation)) acc.push(type);
        return acc;
    }, []);
};
const $c64cd5f7ffbeb7e3$export$8921e02ce71849ce = ({ state: state, bookmark: bookmark })=>{
    if (!bookmark) return false;
    const { tr: tr } = state;
    const resolvedBookmark = bookmark.resolve(tr.doc);
    const isSelectionMatchingBookmark = resolvedBookmark.to === tr.selection.to && resolvedBookmark.from === tr.selection.from;
    return isSelectionMatchingBookmark;
};
const $c64cd5f7ffbeb7e3$export$4f0bdd9681380033 = (state)=>{
    return {
        items: [],
        nodeType: $c64cd5f7ffbeb7e3$var$getValidNodes(state),
        title: 'Annotation suppressed toolbar'
    };
};
const $c64cd5f7ffbeb7e3$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>({ state: state, intl: intl, isToolbarAbove: isToolbarAbove = false, _supportedNodes: _supportedNodes = [], api: api, createCommentExperience: createCommentExperience, annotationManager: annotationManager, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments = ()=>true, contentType: contentType })=>{
        const selectionValid = (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(state);
        const isMediaSelected = (0, $3mJu6.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes') ? (0, $83k8i.annotationMessages).createCommentDisabled : (0, $83k8i.annotationMessages).createCommentInvalid);
        const canAddComments = getCanAddComments();
        const isCommentButtonDisabled = !canAddComments || selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
        const disabledTooltipContent = !canAddComments ? intl.formatMessage((0, $83k8i.annotationMessages).noPermissionToAddComment, {
            contentType: contentType
        }) : commentDisabledMessage;
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: isCommentButtonDisabled || (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode),
            testId: (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingToolbarCreateButton,
            interactionName: 'start-inline-comment-action',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            tooltipContent: isCommentButtonDisabled ? disabledTooltipContent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $ldqjS.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                onCommentButtonMount && onCommentButtonMount();
                // Check if the selection includes an non-text inline node
                const inlineCommentPluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                const inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
                    doc: state.doc,
                    pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, inlineCommentPluginState?.bookmark)
                }) ?? [];
                const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).VIEWED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
                        isDisabled: selectionValid === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED,
                        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $iLcY8.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                editorAnalyticsAPI?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        pageMode: 'edit'
                    }
                });
                if (annotationManager) {
                    annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
                        if (canStartDraft) {
                            createCommentExperience?.start({
                                attributes: {
                                    pageClass: 'editor',
                                    commentType: 'inline',
                                    entryPoint: 'highlightActions'
                                }
                            });
                            createCommentExperience?.initExperience.start();
                            const result = annotationManager.startDraft();
                            if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                            // but the action was not completed, the result should contain a reason.
                            editorAnalyticsAPI?.fireAnalyticsEvent({
                                action: (0, $krYZG.ACTION).ERROR,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                                }
                            });
                        }
                    }).catch(()=>{
                        editorAnalyticsAPI?.fireAnalyticsEvent({
                            action: (0, $krYZG.ACTION).ERROR,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                errorReason: `toolbar-start-draft-preemptive-gate-error`
                            }
                        });
                    });
                    return true;
                } else {
                    createCommentExperience?.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'inline',
                            entryPoint: 'highlightActions'
                        }
                    });
                    createCommentExperience?.initExperience.start();
                    return (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(editorAnalyticsAPI)(true)(state, dispatch);
                }
            },
            supportsViewMode: true // TODO: MODES-3950 - Clean up this floating toolbar view mode logic,
        };
        const toolbarTitle = intl.formatMessage((0, $83k8i.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $gZpSA.calculateToolbarPositionAboveSelection) : (0, $gZpSA.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: $c64cd5f7ffbeb7e3$var$getValidNodes(state),
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated,
            pluginName: 'annotation'
        };
    };



const $4e917acc307ae91b$var$fetchProviderStates = async (provider, annotationIds)=>{
    if (!provider || !provider.getState) return {};
    const data = await provider.getState(annotationIds);
    const result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $epbW8.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $4e917acc307ae91b$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    const inlineCommentStates = await $4e917acc307ae91b$var$fetchProviderStates(provider, annotationIds);
    if (Object.keys(inlineCommentStates).length === 0) {
        const { annotationsLoaded: annotationsLoaded } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(editorView.state) || {};
        if (!annotationsLoaded && (0, $ixfCV.fg)('confluence_frontend_new_dangling_comments_ux')) (0, $5a3eafd29b4d037d$export$a3833f7fc842f6da)()(editorView.state, editorView.dispatch);
        return;
    }
    if (editorView.dispatch) (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $4e917acc307ae91b$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState, isAnnotationManagerEnabled = false)=>{
    return {
        annotationsLoaded: false,
        annotations: {},
        selectedAnnotations: [],
        hoveredAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false,
        pendingSelectedAnnotations: [],
        pendingSelectedAnnotationsUpdateCount: 0,
        isAnnotationManagerEnabled: isAnnotationManagerEnabled
    };
};
const $4e917acc307ae91b$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $5a3eafd29b4d037d$export$ef4c42f03863dce9)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $4e917acc307ae91b$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $1SZMn.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $4e917acc307ae91b$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $4e917acc307ae91b$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
        if (mouseData?.isSelecting) (0, $5a3eafd29b4d037d$export$ef4c42f03863dce9)({
            isSelecting: false
        })(state, dispatch);
    };
const $4e917acc307ae91b$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $5a3eafd29b4d037d$export$c6dc86fb1ced7a07)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $4e917acc307ae91b$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, featureFlagsPluginState: featureFlagsPluginState, annotationManager: annotationManager } = options;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $f5fb2d59ed261397$export$544b399faf6001b7),
        state: (0, $42647913cd19dc49$export$656c7661095efe2e)(options.dispatch, $4e917acc307ae91b$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState, !!annotationManager)),
        view (editorView) {
            let allowAnnotationFn;
            let startDraftFn;
            let clearDraftFn;
            let applyDraftFn;
            let getDraftFn;
            let setIsAnnotationSelectedFn;
            let setIsAnnotationHoveredFn;
            let clearAnnotationFn;
            if (annotationManager) {
                allowAnnotationFn = (0, $fcd3fd145d889c5a$export$86f3258f283eb796)(editorView, options);
                startDraftFn = (0, $fcd3fd145d889c5a$export$768048043e8d2bcd)(editorView, options);
                clearDraftFn = (0, $fcd3fd145d889c5a$export$eeeb486534738631)(editorView, options);
                applyDraftFn = (0, $fcd3fd145d889c5a$export$8bc7b93e04771bda)(editorView, options);
                getDraftFn = (0, $fcd3fd145d889c5a$export$1a473231c51c1d5b)(editorView, options);
                setIsAnnotationSelectedFn = (0, $fcd3fd145d889c5a$export$b8ac6bdd928e737c)(editorView, options);
                setIsAnnotationHoveredFn = (0, $fcd3fd145d889c5a$export$5ada3da2e2f0701f)(editorView, options);
                clearAnnotationFn = (0, $fcd3fd145d889c5a$export$6baae9b3f0f9bdce)(editorView, options);
                annotationManager.hook('allowAnnotation', allowAnnotationFn);
                annotationManager.hook('startDraft', startDraftFn);
                annotationManager.hook('clearDraft', clearDraftFn);
                annotationManager.hook('applyDraft', applyDraftFn);
                annotationManager.hook('getDraft', getDraftFn);
                annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                annotationManager.hook('clearAnnotation', clearAnnotationFn);
            }
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $4e917acc307ae91b$var$fetchState(provider, (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$4e917acc307ae91b$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$4e917acc307ae91b$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$4e917acc307ae91b$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$4e917acc307ae91b$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(annotationId)(editorView.state, editorView.dispatch);
            };
            const setHoveredAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
                else (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)(annotationId)(editorView.state, editorView.dispatch);
            };
            const removeHoveredannotationFn = ()=>{
                (0, $5a3eafd29b4d037d$export$c1805eee6fd0cf44)('')(editorView.state, editorView.dispatch);
            };
            const closeInlineCommentFn = ()=>{
                (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn).on('sethoveredannotation', setHoveredAnnotationFn).on('removehoveredannotation', removeHoveredannotationFn).on('closeinlinecomment', closeInlineCommentFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            /**
       * This flag is used to prevent the preemptive gate from being called multiple times while a check is in-flight.
       * If a check is still pending then it's most likely because the product is busy and trying to block the
       * selection of an annotation.
       */ let isPreemptiveGateActive = false;
            return {
                update (view, _prevState) {
                    const { selectedAnnotations: selectedAnnotations, annotations: annotations, isDrafting: isDrafting, bookmark: bookmark } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                    const { selectedAnnotations: prevSelectedAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(_prevState) || {};
                    const selectedAnnotationId = selectedAnnotations && selectedAnnotations.length !== 0 && selectedAnnotations[0].id ? selectedAnnotations[0].id : undefined;
                    // If the new state has an unresolved selected annotation, and it's different from
                    // the previous one then...
                    if (//This checks the selected annotation is different from the previous one
                    selectedAnnotationId && selectedAnnotationId !== prevSelectedAnnotations?.[0]?.id && // This ensures that the selected annotation is unresolved
                    annotations && annotations[selectedAnnotationId] === false) {
                        // ...we mark the select annotation experience as complete.
                        // The selectComponentExperience is using a simplified object, which is why it's type asserted.
                        options.selectCommentExperience?.selectAnnotation.complete(selectedAnnotationId);
                        // ...and start a new UFO press trace since the selected comment is changing
                        options.viewInlineCommentTraceUFOPress?.();
                    }
                    const { api: api } = options;
                    if (isDrafting && !view.state.selection.eq(_prevState.selection) && Boolean(api?.toolbar)) // It is possible that user update selection while having a active draft,
                    // so we need to reset the user intent to allow inline text toolbar to be visible
                    api?.core.actions.execute(({ tr: tr })=>{
                        if ((0, $c64cd5f7ffbeb7e3$export$8921e02ce71849ce)({
                            state: view.state,
                            bookmark: bookmark
                        })) (0, $0592d2368c2c3f07$export$2c4e3be4c627582b)(api, tr);
                        else (0, $0592d2368c2c3f07$export$dc07a25f8edf98a5)(api, tr);
                        return tr;
                    });
                    if (annotationManager) {
                        // In the Editor, Annotations can be selected in three ways:
                        // 1. By clicking on the annotation in the editor
                        // 2. By using the annotation manager to select the annotation
                        // 3. By moving the cursor to the annotation and using the keyboard to select it
                        // Item 1 & 3 need to be protected by the preemptive gate. This is because these actions could be performed by a user
                        // at a time when changing the selection could cause data loss.
                        // The following preemptive check is designed to cover these items.
                        const { pendingSelectedAnnotations: pendingSelectedAnnotations, pendingSelectedAnnotationsUpdateCount: pendingSelectedAnnotationsUpdateCount } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                        const { pendingSelectedAnnotationsUpdateCount: prevPendingSelectedAnnotationsUpdateCount } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(_prevState) || {};
                        if (!isPreemptiveGateActive && pendingSelectedAnnotationsUpdateCount !== prevPendingSelectedAnnotationsUpdateCount && !!pendingSelectedAnnotations?.length) {
                            // Need to set a lock to avoid calling gate multiple times. The lock will be released
                            // when the preemptive gate is complete.
                            isPreemptiveGateActive = true;
                            annotationManager.checkPreemptiveGate().then((canSelectAnnotation)=>{
                                const { isDrafting: isDrafting, pendingSelectedAnnotations: latestPendingSelectedAnnotations, selectedAnnotations: latestSelectedAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                                if (canSelectAnnotation) {
                                    if (isDrafting) // The user must have chosen to discard there draft. So before we flush the pending selections
                                    // we need to clear the draft if there is one.
                                    (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(options.editorAnalyticsAPI, undefined, options.api)(false)(view.state, view.dispatch);
                                    // Flush the pending selections into the selected annotations list.
                                    (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(true)(view.state, view.dispatch);
                                    latestSelectedAnnotations?.filter((annotation)=>latestPendingSelectedAnnotations?.findIndex((pendingAnnotation)=>pendingAnnotation.id === annotation.id) === -1).forEach((annotation)=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: annotation.id,
                                                isSelected: false,
                                                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                                            }
                                        });
                                    });
                                    // Notify the annotation manager that the pending selection has changed.
                                    latestPendingSelectedAnnotations?.forEach(({ id: id })=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: id,
                                                isSelected: true,
                                                inlineNodeTypes: (0, $fRYCB.getAnnotationInlineNodeTypes)(view.state, id) ?? []
                                            }
                                        });
                                    });
                                } else // Clears the pending selections if the preemptive gate returns false.
                                // We should need to worry about dispatching change events here because the pending selections
                                // are being aborted and the selections will remain unchanged.
                                (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false)(view.state, view.dispatch);
                            }).catch((error)=>{
                                // If an error has occured we will clear any pending selections to avoid accidentally setting the wrong thing.
                                (0, $5a3eafd29b4d037d$export$940b79a08b19cea6)(options.editorAnalyticsAPI)(false, 'pending-selection-preemptive-gate-error')(view.state, view.dispatch);
                            }).finally(()=>{
                                isPreemptiveGateActive = false;
                            });
                        }
                    }
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $5a3eafd29b4d037d$export$ffa869a92c2481c3)()(view.state, view.dispatch);
                    $4e917acc307ae91b$var$fetchState(provider, (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn).off('sethoveredannotation', setHoveredAnnotationFn).off('removehoveredannotation', removeHoveredannotationFn).off('closeinlinecomment', closeInlineCommentFn);
                    if (annotationManager) {
                        annotationManager.unhook('allowAnnotation', allowAnnotationFn);
                        annotationManager.unhook('startDraft', startDraftFn);
                        annotationManager.unhook('clearDraft', clearDraftFn);
                        annotationManager.unhook('applyDraft', applyDraftFn);
                        annotationManager.unhook('getDraft', getDraftFn);
                        annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                        annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                        annotationManager.unhook('clearAnnotation', clearAnnotationFn);
                    }
                }
            };
        },
        props: {
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state);
                    if (!pluginState?.mouseData.isSelecting) $4e917acc307ae91b$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    return $4e917acc307ae91b$var$onMouseUp(view.state, view.dispatch)(event);
                },
                click: (view, event)=>{
                    if (!(event.target instanceof HTMLElement)) return false;
                    // Find the nearest ancestor (or self) with the data-id attribute
                    const annotationId = event.target.closest('[data-id]')?.getAttribute('data-id');
                    if (!annotationId) return false;
                    const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(view.state);
                    const isSelected = pluginState?.selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                    // If the annotation is selected and the inline comment view is open, do nothing
                    // as the user is already in the comment view.
                    if (isSelected && !pluginState?.isInlineCommentViewClosed) return false;
                    const { annotations: annotations } = pluginState || {};
                    const isUnresolved = annotations && annotations[annotationId] === false;
                    if (!isUnresolved) return false;
                    if (annotationManager) {
                        // The manager disable setting the selected annotation on click because in the editor this is already
                        // handled by the selection update handler. When the manager is enabled, and a selection changes it's pushed into
                        // the pendingSelectedAnnotations array. This is then used to update the selection when the preemptive gate
                        // is released.
                        const isPendingSelection = pluginState?.pendingSelectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                        // If the annotation is selected and the inline comment view is open, do nothing
                        // as the user is already in the comment view.
                        if (isPendingSelection) return false;
                        (0, $5a3eafd29b4d037d$export$a99e2fe25edc1abd)(annotationId)(view.state, view.dispatch);
                    } else (0, $5a3eafd29b4d037d$export$1e715f68ff6f5a2f)(annotationId)(view.state, view.dispatch);
                    return true;
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed, hoveredAnnotations: hoveredAnnotations } = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state) || {};
                let decorations = draftDecorationSet ?? (0, $8nvEM.DecorationSet).empty;
                const focusDecorations = [];
                // TODO: EDITOR-760 - This needs to be optimised, it's not a good idea to scan the entire document
                // everytime we need to update the decorations. This handler will be called alot. We should be caching
                // the decorations in plugin state and only updating them when required.
                state.doc.descendants((node, pos)=>{
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlockNode = node.isBlock && provider.supportedBlockNodes?.includes(node.type.name);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!selectedAnnotations?.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id);
                            const isHovered = !isInlineCommentViewClosed && !!hoveredAnnotations?.some((hoveredAnnotation)=>hoveredAnnotation.id === mark.attrs.id);
                            if (isSupportedBlockNode) focusDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $d252fa5145d6fd3d$export$bb73203a2b3a63e2)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $f5fb2d59ed261397$export$824a8ce0be7d4e38).block
                            }));
                            else if ((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`
                                }, {
                                    key: (0, $f5fb2d59ed261397$export$824a8ce0be7d4e38).block
                                }));
                            } else focusDecorations.push((0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $d252fa5145d6fd3d$export$b3ab33741101ad90)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};









var $44cyU = parcelRequire("44cyU");


function $cd81b5c969c7454e$export$e832373cff8dec22(api) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addInlineComment).common, (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true, (0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    return (0, $44cyU.keymap)(list);
}



















var $4Qu9h = parcelRequire("4Qu9h");



















class $e7e8300dcbc69083$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}


const $395a577224af18f4$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
const $395a577224af18f4$var$selector = (states)=>{
    return {
        annotations: states.annotationState?.annotations,
        bookmark: states.annotationState?.bookmark,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        isOpeningMediaCommentFromToolbar: states.annotationState?.isOpeningMediaCommentFromToolbar,
        selectAnnotationMethod: states.annotationState?.selectAnnotationMethod,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isAnnotationManagerEnabled: states.annotationState?.isAnnotationManagerEnabled
    };
};
function $395a577224af18f4$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const { annotations: annotations, bookmark: bookmark, isInlineCommentViewClosed: isInlineCommentViewClosed, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, selectAnnotationMethod: selectAnnotationMethod, selectedAnnotations: selectedAnnotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'annotation'
    ], $395a577224af18f4$var$selector);
    const annotationsList = (0, $f5fb2d59ed261397$export$2ecc008effaefd6e)(editorView.state.doc);
    const selection = (0, $f5fb2d59ed261397$export$31c5af77b755d41f)(state, bookmark);
    const position = $395a577224af18f4$var$findPosForDOM(selection);
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $bjg0G.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $krYZG.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: error.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    // Network Status
    const networkStatusSelector = (0, $4Qu9h.useSharedPluginStateSelector)(editorAPI, 'connectivity.mode', {
        disabled: (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', false)
    });
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const inlineNodeTypes = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingComponent,
            "data-editor-popup": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CreateComponent, {
            dom: dom,
            textSelection: textSelection,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCreate: (id)=>{
                if (!isAnnotationManagerEnabled) {
                    const createAnnotationResult = (0, $5a3eafd29b4d037d$export$51eda81011da4982)(editorAnalyticsAPI, editorAPI)(id, (0, $epbW8.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes)(editorView.state, editorView.dispatch);
                    !editorView.hasFocus() && editorView.focus();
                    if (!createAnnotationResult) throw new Error('Failed to create annotation');
                }
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCreateError: (id)=>// This is called when optimistic create inline comment encounters an error,
                // in which case the optimistically added annotation must be removed.
                (0, $5a3eafd29b4d037d$export$75bee4cee90040)(id, inlineCommentProvider.supportedBlockNodes)(editorView.state, editorView.dispatch),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClose: ()=>{
                if (!isAnnotationManagerEnabled) {
                    (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(editorAnalyticsAPI, undefined, editorAPI)(false)(editorView.state, editorView.dispatch);
                    !editorView.hasFocus() && editorView.focus();
                }
            },
            inlineNodeTypes: inlineNodeTypes,
            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
            isOffline: (0, $6Ixg8.isOfflineMode)(networkStatusSelector)
        }));
    }
    // View Component
    const activeAnnotations = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    selectedAnnotations?.filter((mark)=>annotations && annotations[mark.id] === false) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        // fire analytics
        const payload = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: editorView.state.doc.nodeAt(position)?.type.name,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $fRYCB.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e7e8300dcbc69083$export$1fe5705f230796ba), {
        "data-editor-popup": "true",
        "data-testid": (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingComponent,
        key: (0, $f5fb2d59ed261397$export$1832a9899106877a)(activeAnnotations),
        onViewed: onAnnotationViewed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ViewComponent, {
        annotationsList: annotationsList,
        annotations: activeAnnotations,
        getInlineNodeTypes: getInlineNodeTypes,
        dom: dom,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDelete: (id)=>(0, $5a3eafd29b4d037d$export$75bee4cee90040)(id, inlineCommentProvider.supportedBlockNodes)(editorView.state, dispatch),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onResolve: (id)=>(0, $5a3eafd29b4d037d$export$4d8462ca3c146d0e)(editorAnalyticsAPI)({
                [id]: true
            }, (0, $1SZMn.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClose: ()=>{
            (0, $5a3eafd29b4d037d$export$da26c8d097933b72)()(editorView.state, editorView.dispatch);
        },
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: (0, $6Ixg8.isOfflineMode)(networkStatusSelector)
    }));
}






var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");





var $kSwu1 = parcelRequire("kSwu1");











var $bFSJa = parcelRequire("bFSJa");




var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");






























const $e802a94405541046$export$7a6737b74121da6f = ({ state: state, api: api, canAddComments: canAddComments })=>{
    const annotationSelectionType = state ? (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(state) : (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const isAnnotationSelectionInvalid = annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED;
    const isOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
    return {
        isAnnotationSelectionInvalid: isAnnotationSelectionInvalid,
        isOffline: isOffline,
        canAddComments: canAddComments,
        isDisabled: !canAddComments || isAnnotationSelectionInvalid || isOffline
    };
};
const $e802a94405541046$export$dd62b022312fd583 = ({ state: state, isVisible: isVisible, annotationSelectionType: annotationSelectionType })=>{
    const isMediaSelected = state ? (0, $3mJu6.currentMediaNodeWithPos)(state) : false;
    let isDrafting = false;
    if (state) isDrafting = (0, $f5fb2d59ed261397$export$544b399faf6001b7).getState(state)?.isDrafting || false;
    // comments on media can only be added via media floating toolbar
    if (isDrafting || isMediaSelected || annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID || !isVisible) return false;
    return true;
};
const $e802a94405541046$export$b5fd00fffbd8948d = ({ api: api })=>{
    api.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).CLICKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            source: 'highlightActionsMenu',
            pageMode: 'edit'
        }
    });
};
const $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent = ({ api: api, errorReason: errorReason })=>{
    api.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorReason: errorReason
        }
    });
};
const $e802a94405541046$export$aa79a97671c224b4 = ({ api: api, isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment, annotationSelectionType: annotationSelectionType })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).VIEWED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            isDisabled: annotationSelectionType === (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).DISABLED,
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            mode: (0, $iLcY8.MODE).EDITOR
        }
    });
};
const $e802a94405541046$export$c983cfb71edde6e4 = ({ annotationProviders: annotationProviders, api: api, state: state, dispatch: dispatch })=>{
    const annotationManager = annotationProviders?.annotationManager;
    if (annotationManager) {
        annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
            if (canStartDraft) {
                annotationProviders.createCommentExperience?.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'inline',
                        entryPoint: 'highlightActions'
                    }
                });
                annotationProviders.createCommentExperience?.initExperience.start();
                const result = annotationManager.startDraft();
                if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                // but the action was not completed, the result should contain a reason.
                $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent({
                    api: api,
                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                });
            }
        }).catch(()=>{
            $e802a94405541046$var$fireAnnotationErrorAnalyticsEvent({
                api: api,
                errorReason: `toolbar-start-draft-preemptive-gate-error`
            });
        });
        return true;
    } else {
        annotationProviders?.createCommentExperience?.start({
            attributes: {
                pageClass: 'editor',
                commentType: 'inline',
                entryPoint: 'highlightActions'
            }
        });
        annotationProviders?.createCommentExperience?.initExperience.start();
        return (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, undefined, api)(true)(state, dispatch);
    }
};


const $9f81a4d757ba3795$export$b0b121505277a396 = ({ state: state, annotationProviders: annotationProviders, api: api, annotationSelectionType: annotationSelectionType, bookmark: bookmark })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!state) return;
        if (annotationProviders?.inlineComment) annotationProviders.inlineComment.onCommentButtonMount?.();
        // Check if the selection includes an non-text inline node
        const inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: (0, $f5fb2d59ed261397$export$196f73a7cbac5e80)(state, bookmark)
        }) ?? [];
        const isNonTextInlineNodeInludedInComment = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
        (0, $e802a94405541046$export$aa79a97671c224b4)({
            api: api,
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            annotationSelectionType: annotationSelectionType
        });
    // for now trying to replicate current onMount logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



const $05c1ca35e1c29444$export$44a3d5aec3da3e9f = ({ api: api, annotationProviders: annotationProviders })=>{
    const { isVisible: isVisible, bookmark: bookmark } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], (states)=>({
            isVisible: states.annotationState?.isVisible,
            bookmark: states.annotationState?.bookmark
        }));
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const annotationSelectionType = editorView?.state ? (0, $f5fb2d59ed261397$export$af7e6fc08350a63d)(editorView.state) : (0, $4dfa7de3992b5086$export$ad08e20e7e22e394).INVALID;
    const { getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders?.inlineComment ?? {};
    (0, $9f81a4d757ba3795$export$b0b121505277a396)({
        state: editorView?.state,
        annotationProviders: annotationProviders,
        api: api,
        annotationSelectionType: annotationSelectionType,
        bookmark: bookmark
    });
    const intl = (0, $kSwu1.useIntl)();
    const onClick = ()=>{
        if (!api || !annotationProviders || !editorView?.state || !editorView?.dispatch) return;
        (0, $e802a94405541046$export$b5fd00fffbd8948d)({
            api: api
        });
        (0, $e802a94405541046$export$c983cfb71edde6e4)({
            annotationProviders: annotationProviders,
            api: api,
            state: editorView.state,
            dispatch: editorView.dispatch
        });
    };
    if (!(0, $e802a94405541046$export$dd62b022312fd583)({
        state: editorView?.state,
        isVisible: isVisible,
        annotationSelectionType: annotationSelectionType
    })) return null;
    const canAddComments = getCanAddComments ? getCanAddComments() : true;
    const commentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
    const commentDisabledMessage = intl.formatMessage((0, $ixfCV.fg)('editor_inline_comments_on_inline_nodes') ? (0, $83k8i.annotationMessages).createCommentDisabled : (0, $83k8i.annotationMessages).createCommentInvalid);
    const noPermissionToAddCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).noPermissionToAddComment, {
        contentType: contentType
    });
    const { isDisabled: isDisabled, isAnnotationSelectionInvalid: isAnnotationSelectionInvalid } = (0, $e802a94405541046$export$7a6737b74121da6f)({
        state: editorView?.state,
        api: api,
        canAddComments: canAddComments
    });
    const tooltipContentWhenDisabled = ()=>{
        if (!canAddComments) return noPermissionToAddCommentMessage;
        else if (isAnnotationSelectionInvalid) return commentDisabledMessage;
        else // i.e. isOffline. No tooltip message needed.
        return (0, $ieeJu.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true) ? undefined : commentDisabledMessage;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: isDisabled ? tooltipContentWhenDisabled() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: commentMessage,
            keymap: (0, $ldqjS.addInlineComment)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        testId: (0, $4dfa7de3992b5086$export$711f43d01b7e0019).floatingToolbarCreateButton,
        isDisabled: isDisabled
    }, commentMessage));
};


const $2eb2031ab7df2eff$export$a758406ca53b86a5 = (api, annotationProviders)=>{
    return [
        {
            type: (0, $3nacY.COLLAB_SECTION).type,
            key: (0, $3nacY.COLLAB_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.COMMENT_GROUP).type,
            key: (0, $3nacY.COMMENT_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.COLLAB_SECTION).type,
                    key: (0, $3nacY.COLLAB_SECTION).key,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.COMMENT_HERO_BUTTON).type,
            key: (0, $3nacY.COMMENT_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.COMMENT_GROUP).type,
                    key: (0, $3nacY.COMMENT_GROUP).key,
                    rank: (0, $hVLmg.COLLAB_SECTION_RANK)[(0, $3nacY.COMMENT_GROUP).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05c1ca35e1c29444$export$44a3d5aec3da3e9f), {
                    api: api,
                    annotationProviders: annotationProviders
                });
            }
        }
    ];
};


const $0eb166b24708d17a$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2eb2031ab7df2eff$export$a758406ca53b86a5)(api, annotationProviders));
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $7cab94c6d4281aad$export$802ec1d716a6bb1)
                }
            ];
        },
        actions: {
            hasAnyUnResolvedAnnotationInPage: $f5fb2d59ed261397$export$98b0a2a6ba343064,
            stripNonExistingAnnotations: $f5fb2d59ed261397$export$ca9ec32b395faf65,
            setInlineCommentDraftState: (0, $5a3eafd29b4d037d$export$2a7aec6fc438fa0b)(api?.analytics?.actions, annotationProviders?.inlineComment.supportedBlockNodes),
            showCommentForBlockNode: (0, $5a3eafd29b4d037d$export$d80af6562490622d)(annotationProviders?.inlineComment.supportedBlockNodes),
            setSelectedAnnotation: $5a3eafd29b4d037d$export$1e715f68ff6f5a2f,
            setPendingSelectedAnnotation: $5a3eafd29b4d037d$export$a99e2fe25edc1abd
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            delete clonedPluginState?.featureFlagsPluginState;
            return clonedPluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch })=>{
                        if (annotationProviders) return (0, $4e917acc307ae91b$export$e4aab3acac8f34b)({
                            dispatch: dispatch,
                            provider: annotationProviders.inlineComment,
                            editorAnalyticsAPI: api?.analytics?.actions,
                            featureFlagsPluginState: featureFlags,
                            selectCommentExperience: annotationProviders.selectCommentExperience,
                            viewInlineCommentTraceUFOPress: annotationProviders.viewInlineCommentTraceUFOPress,
                            annotationManager: annotationProviders.annotationManager,
                            api: api
                        });
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $cd81b5c969c7454e$export$e832373cff8dec22)(api);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            floatingToolbar (state) {
                const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                const bookmark = pluginState?.bookmark;
                if ((0, $c64cd5f7ffbeb7e3$export$8921e02ce71849ce)({
                    state: state,
                    bookmark: bookmark
                })) return (0, $c64cd5f7ffbeb7e3$export$4f0bdd9681380033)(state);
            },
            selectionToolbar (state, intl) {
                if (isToolbarAIFCEnabled) return;
                if (!annotationProviders) return;
                const pluginState = (0, $f5fb2d59ed261397$export$f05434c51e3762e)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    const { isToolbarAbove: isToolbarAbove, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders.inlineComment;
                    const toolbarConfig = (0, $c64cd5f7ffbeb7e3$export$6dd6ab35df8f7f86)(api?.analytics?.actions)({
                        state: state,
                        intl: intl,
                        isToolbarAbove: isToolbarAbove,
                        api: api,
                        createCommentExperience: annotationProviders.createCommentExperience,
                        annotationManager: annotationProviders.annotationManager,
                        onCommentButtonMount: onCommentButtonMount,
                        getCanAddComments: getCanAddComments,
                        contentType: contentType
                    });
                    if (!toolbarConfig) return undefined;
                    else return {
                        ...toolbarConfig,
                        rank: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 1 : undefined
                    };
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders || !editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0eb166b24708d17a$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $0eb166b24708d17a$var$selector = (states)=>{
    return {
        isVisible: states.annotationState?.isVisible,
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        annotations: states.annotationState?.annotations
    };
};
function $0eb166b24708d17a$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const annotationState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $0eb166b24708d17a$var$selector);
    // need to explicitly check for false as undefined is also a valid value to continue
    if (annotationState?.isVisible === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-editor-popup": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $395a577224af18f4$export$ce99d9856d415465), {
        providers: annotationProviders,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAnalyticsAPI: api?.analytics?.actions,
        editorAPI: api
    }));
}
module.exports["annotationPlugin"] = $0eb166b24708d17a$export$df895cff1a8daaf7;

});

parcelRegister("60Pfj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $icr1E = parcelRequire("icr1E");








var $3k5Tv = parcelRequire("3k5Tv");


var $2xhuI = parcelRequire("2xhuI");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $bcDqz = parcelRequire("bcDqz");





var $kCECX = parcelRequire("kCECX");

/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $7Y8M5 = parcelRequire("7Y8M5");

function $2c5192d22ce51ce3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c5192d22ce51ce3$export$2755d6ea511694ef = {
    name: "1a9lj0e",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-full, 9999px);min-width:var(--ds-space-400, 32px);margin-left:var(--ds-space-negative-050, -4px)"
};
const $2c5192d22ce51ce3$export$84e713f68a1110f7 = {
    name: "1g5siac",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:var(--ds-radius-full, 9999px);height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $2c5192d22ce51ce3$export$4aebd143f31d0c0d = (backgroundColor, textColor)=>/*#__PURE__*/ (0, $lOiVq.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7Y8M5.akEditorSmallZIndex),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: backgroundColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: textColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(9),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #FFFFFF)"}`,
        boxSizing: 'border-box'
    });






var $dOBRD = parcelRequire("dOBRD");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports




const $f7ab6790bfd0e9a1$export$1a8ce77350a239fa = (props)=>{
    const participantColor = props.api?.collabEdit?.actions?.getAvatarColor(props.presenceId ?? props.sessionId) ?? {
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
    };
    const avatar = props.name.substr(0, 1).toUpperCase();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $2c5192d22ce51ce3$export$4aebd143f31d0c0d)(participantColor?.backgroundColor, participantColor?.textColor),
        "data-testid": "editor-collab-badge"
    }, avatar);
};


const $74dae352f55c58dc$var$toAvatar = (participant, api, formatMessage)=>({
        name: participant.name || formatMessage((0, $icr1E.avatarGroupMessages).anonymousCollaborator),
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7ab6790bfd0e9a1$export$1a8ce77350a239fa), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId,
            presenceId: participant.presenceId
        })
    });
const $74dae352f55c58dc$var$_default_1 = (0, $dOBRD.default)($74dae352f55c58dc$var$toAvatar, function participantEquals([a], [b]) {
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId;
});
var $74dae352f55c58dc$export$2e2bcd8739ae039 = $74dae352f55c58dc$var$_default_1;


const $b9a68f91ae5e2d47$var$scrollToCollabCursor = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).MATCHED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SELECTION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        editorAPI?.core?.actions?.execute(({ tr: tr })=>{
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI?.core?.actions?.focus();
    }
};
const $b9a68f91ae5e2d47$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    const intl = (0, $kSwu1.useIntl)();
    // .slice() turns ReadonlyArray<CollabParticipant> into a mutable CollabParticipant[]
    const participants = props.participants?.toArray()?.slice();
    if (!participants) return null;
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $74dae352f55c58dc$export$2e2bcd8739ae039)(participant, editorAPI, intl.formatMessage));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2c5192d22ce51ce3$export$84e713f68a1110f7)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bcDqz.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags?.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $b9a68f91ae5e2d47$var$scrollToCollabCursor(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $ldbHR = parcelRequire("ldbHR");


var $gFEZF = parcelRequire("gFEZF");


const $3b97246b3b12f768$var$ID = (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, props.children);
const $3b97246b3b12f768$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $3b97246b3b12f768$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $2c5192d22ce51ce3$export$2755d6ea511694ef)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)(Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};


const $d7162b71707afb6b$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $2xhuI.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { sessionId: sessionId, activeParticipants: activeParticipants, initialised: initialised } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPI, [
        'collabEdit'
    ], (states)=>({
            sessionId: states.collabEditState?.sessionId,
            activeParticipants: states.collabEditState?.activeParticipants,
            initialised: states.collabEditState?.initialised
        }));
    if (!initialised) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9a68f91ae5e2d47$export$8232a93d94178362), {
        sessionId: sessionId,
        participants: activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b97246b3b12f768$export$c166df103ee37df9), {
        title: title,
        selected: selected,
        onClick: onClick,
        Component: Component
    }));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $d7162b71707afb6b$var$_default_1 = (0, $kSwu1.injectIntl)($d7162b71707afb6b$var$AvatarsWithPluginState);
var $d7162b71707afb6b$export$2e2bcd8739ae039 = $d7162b71707afb6b$var$_default_1;


function $6e842f53b8767f36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6e842f53b8767f36$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6e842f53b8767f36$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $lOiVq.css)($6e842f53b8767f36$var$toolbarButtonWrapper, "flex-grow:1;");
const $6e842f53b8767f36$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "aria-label": intl.formatMessage((0, $icr1E.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $6e842f53b8767f36$var$toolbarButtonWrapperFullWidth : $6e842f53b8767f36$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $d7162b71707afb6b$export$2e2bcd8739ae039), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $6e842f53b8767f36$export$2e2bcd8739ae039 = $6e842f53b8767f36$var$AvatarGroupPluginWrapper;



const $a8a812b290024729$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e842f53b8767f36$export$2e2bcd8739ae039), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props?.collabEdit,
            takeFullWidth: props?.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api?.analytics?.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) api?.primaryToolbar?.actions.registerComponent({
        name: 'avatarGroup',
        component: primaryToolbarComponent
    });
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !api?.primaryToolbar && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7162b71707afb6b$export$2e2bcd8739ae039), {
                    featureFlags: api?.featureFlags?.sharedState.currentState() ?? {},
                    editorAnalyticsAPI: api?.analytics?.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};
module.exports["avatarGroupPlugin"] = $a8a812b290024729$export$56985cb4934eb626;

});

parcelRegister("cX2jD", function(module, exports) {

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $eOaGc = parcelRequire("eOaGc");

const $eb881e8362450641$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $1A89X.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $eb881e8362450641$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $eb881e8362450641$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $eb881e8362450641$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $1A89X.SetAttrsStep);
        const isAttrStep = step instanceof (0, $eOaGc.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $eb881e8362450641$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$eb881e8362450641$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $eb881e8362450641$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $hdvEd.BatchAttrsStep)(data);
};


const $93904b52e4acc73e$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $eb881e8362450641$export$383250d570a1fb48
        }
    };
};
module.exports["batchAttributeUpdatesPlugin"] = $93904b52e4acc73e$export$5af772f765987c49;

});

parcelRegister("hdvEd", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $5aU9U = parcelRequire("5aU9U");

var $eOaGc = parcelRequire("eOaGc");

const $265200f861aad3fa$var$stepType = 'batchAttrs';
const $265200f861aad3fa$var$isValidData = (data)=>{
    if (data !== null && !Array.isArray(data)) return false;
    return !data.some((d)=>{
        const invalidPosition = typeof d.position !== 'number';
        const invalidNodeType = typeof d.nodeType !== 'string';
        const invalidAttrs = typeof d.attrs !== 'object';
        return invalidPosition || invalidNodeType || invalidAttrs;
    });
};
class $265200f861aad3fa$export$4fd0fe0f65803356 extends (0, $5aU9U.Step) {
    apply(doc) {
        const resultDoc = this.data.reduce((acc, value)=>{
            if (!acc.doc || acc.failed) return acc;
            const { position: position, attrs: attrs } = value;
            if (acc.doc && position > acc.doc.nodeSize || position < 0) return (0, $eOaGc.StepResult).fail(`Position ${position} out of document range.`);
            const target = acc.doc?.nodeAt(position);
            if (!target) return (0, $eOaGc.StepResult).fail(`No node at given position: ${position}`);
            if (target.isText) return (0, $eOaGc.StepResult).fail('Target is a text node. Attributes are not allowed.');
            const mergedAttrs = {
                ...target.attrs || {},
                ...attrs || {}
            };
            const updatedNode = target.type.create(mergedAttrs, null, target.marks);
            const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(updatedNode), 0, target.isLeaf ? 0 : 1);
            return (0, $eOaGc.StepResult).fromReplace(acc.doc, position, position + 1, slice);
        }, (0, $eOaGc.StepResult).ok(doc));
        return resultDoc;
    }
    invert(doc) {
        const previousData = this.data.reduce((acc, value)=>{
            const { position: position, nodeType: nodeType, attrs: nextAttrs } = value;
            if (position > doc.nodeSize) return acc;
            const target = doc.nodeAt(position);
            if (!target) return acc;
            if (target.isText) return acc;
            const previousAttrs = Object.keys(nextAttrs).reduce((attributesIterator, key)=>{
                const oldValue = target.attrs[key];
                attributesIterator[key] = oldValue;
                return attributesIterator;
            }, {});
            const prev = {
                position: position,
                nodeType: nodeType,
                attrs: previousAttrs
            };
            acc.push(prev);
            return acc;
        }, []);
        return new $265200f861aad3fa$export$4fd0fe0f65803356(previousData, true);
    }
    map(mapping) {
        const mappedData = this.data.reduce((acc, value)=>{
            const { position: position } = value;
            const mappedPosition = mapping.mapResult(position);
            if (mappedPosition.deleted) return acc;
            acc.push({
                ...value,
                position: mappedPosition.pos
            });
            return acc;
        }, []);
        if (mappedData.length === 0) return null;
        return new $265200f861aad3fa$export$4fd0fe0f65803356(mappedData, this.inverted);
    }
    toJSON() {
        return {
            stepType: $265200f861aad3fa$var$stepType,
            data: this.data,
            inverted: this.inverted
        };
    }
    static fromJSON(_schema, json) {
        const data = json?.data;
        if (!$265200f861aad3fa$var$isValidData(data)) throw new Error('Invalid input for BatchAttrsStep.fromJSON');
        return new $265200f861aad3fa$export$4fd0fe0f65803356(data, Boolean(json.inverted));
    }
    constructor(data, inverted = false){
        super(), this.data = data, this.inverted = inverted;
    }
}
(0, $5aU9U.Step).jsonID($265200f861aad3fa$var$stepType, $265200f861aad3fa$export$4fd0fe0f65803356);
module.exports["BatchAttrsStep"] = $265200f861aad3fa$export$4fd0fe0f65803356;

});

parcelRegister("1A89X", function(module, exports) {

var $5aU9U = parcelRequire("5aU9U");

var $eOaGc = parcelRequire("eOaGc");


var $aPdNQ = parcelRequire("aPdNQ");

class $7e4c18d2699116f4$export$8cfd0a0bfa522949 extends (0, $5aU9U.Step) {
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $eOaGc.StepResult).fail('No node at given position');
        if (target.isText) return (0, $eOaGc.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $aPdNQ.Fragment).empty, target.marks);
        const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $eOaGc.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $7e4c18d2699116f4$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $7e4c18d2699116f4$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
    constructor(pos, attrs){
        super();
        this.pos = void 0;
        this.attrs = void 0;
        this.pos = pos;
        this.attrs = attrs;
    }
}
(0, $5aU9U.Step).jsonID('setAttrs', $7e4c18d2699116f4$export$8cfd0a0bfa522949);
module.exports["SetAttrsStep"] = $7e4c18d2699116f4$export$8cfd0a0bfa522949;

});

parcelRegister("dHFAY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iQ6F7 = parcelRequire("iQ6F7");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $lVAkE = parcelRequire("lVAkE");


var $6FQH1 = parcelRequire("6FQH1");

const $bb8f0178a1bbd465$export$4c9c90f81bda40ce = ({ tr: tr })=>{
    const meta = {
        type: 'startPreserving'
    };
    return tr.setMeta((0, $6FQH1.selectionPreservationPluginKey), meta);
};
const $bb8f0178a1bbd465$export$7ee148889ab74bda = ({ tr: tr })=>{
    const meta = {
        type: 'stopPreserving'
    };
    return tr.setMeta((0, $6FQH1.selectionPreservationPluginKey), meta);
};


const $a155f8ac3d617cef$var$getKeyboardEventInfo = (event)=>{
    const key = event.key.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCut = isMetaCtrl && key === 'x';
    const isPaste = isMetaCtrl && key === 'v';
    const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
    const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey);
    const isDestructive = isDelete || isCut || isPaste || isUndo || isRedo;
    const isModifierOnly = [
        'control',
        'meta',
        'alt',
        'shift'
    ].includes(key) && !isMetaCtrl;
    const isCopy = isMetaCtrl && key === 'c';
    const isInert = isModifierOnly || isCopy;
    return {
        isDelete: isDelete,
        isDestructive: isDestructive,
        isInert: isInert
    };
};
const $a155f8ac3d617cef$export$f38920f5272efc06 = (api)=>(event)=>({ tr: tr })=>{
            if (!api) return tr;
            const { isDelete: isDelete, isDestructive: isDestructive, isInert: isInert } = $a155f8ac3d617cef$var$getKeyboardEventInfo(event);
            // Handle delete/backspace key presses with custom logic to ensure preserved selection is used
            if (isDelete) tr = (0, $lVAkE.deleteSelectedRange)(tr, api.blockControls?.sharedState.currentState()?.preservedSelection);
            const isBlockMenuOpen = api.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
            // When selected content is being removed/modified/undo/redo and the block menu is open
            // close the block menu and refocus the editor
            const shouldCloseBlockMenu = isDestructive && isBlockMenuOpen;
            if (shouldCloseBlockMenu) {
                api.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api.core.actions.focus({
                    scrollIntoView: false
                });
            }
            // Stop preserving when:
            // 1. Content is being removed (delete/cut/paste) OR
            // 2. Menu is closed AND user pressed a non-inert key (i.e. action which modifies selection or content)
            // 3. undo/redo actions
            const shouldStopPreservingSelection = isDestructive || !isBlockMenuOpen && !isInert;
            if (shouldStopPreservingSelection) (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                tr: tr
            });
            return tr;
        };



var $3BXSc = parcelRequire("3BXSc");

const $ae3c630ae8088563$export$e21678cf246ba963 = (mapping)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $3BXSc.key));
        return tr.setMeta((0, $3BXSc.key), {
            ...currMeta,
            preservedSelectionMapping: mapping
        });
    };



var $b3nYA = parcelRequire("b3nYA");


var $krYZG = parcelRequire("krYZG");


var $1xYQH = parcelRequire("1xYQH");








var $i2jOy = parcelRequire("i2jOy");





var $9aKak = parcelRequire("9aKak");

const $56dbb4d04b905509$var$getSelectionToIndex = (fromIndex, $to, depth)=>{
    const toIndex = $to.index(depth);
    const toIndexAfter = $to.indexAfter(depth);
    // If $to is at the start of a node (indexAfter === index), don't include that node
    // This occurs when the preserved selection is outside of inline positions at node boundaries
    if (toIndexAfter === toIndex && toIndex > fromIndex) return toIndex - 1;
    return toIndex;
};
const $56dbb4d04b905509$export$86c511a177340b22 = (api, direction)=>{
    return ({ tr: tr })=>{
        if (!(0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return tr;
        const preservedSelection = api?.blockControls.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection ?? tr.selection;
        // Use getNodeBoundsFromSelection to get the proper block boundaries
        const nodeBounds = (0, $9aKak.getNodeBoundsFromSelection)(selection);
        if (!nodeBounds) return tr;
        const currentNodePos = nodeBounds.from;
        const { $from: $from, $to: $to } = selection;
        const depth = tr.doc.resolve(currentNodePos).depth;
        const fromIndex = $from.index(depth);
        let trAfterNodeMove = tr;
        if (direction === (0, $1xYQH.DIRECTION).UP) {
            if (fromIndex > 0) {
                const moveToPos = $from.posAtIndex(fromIndex - 1, depth);
                trAfterNodeMove = (0, $b3nYA.moveNode)(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        } else {
            // selectionToIndex is the index of the last node in the selection
            const selectionToIndex = $56dbb4d04b905509$var$getSelectionToIndex(fromIndex, $to, depth);
            // Adding 2 so we jump over the next node to the position after it
            const moveToIndex = selectionToIndex + 2;
            if (moveToIndex <= $to.node(depth).childCount) {
                const moveToPos = $to.posAtIndex(moveToIndex, depth);
                trAfterNodeMove = (0, $b3nYA.moveNode)(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        }
        // map selection
        const mappedSelection = (0, $i2jOy.mapPreservedSelection)(selection, trAfterNodeMove);
        if (mappedSelection) trAfterNodeMove.setSelection(mappedSelection);
        //recalculate canMoveUp and canMoveDown
        const { moveUp: moveUp, moveDown: moveDown } = (0, $9aKak.canMoveNodeUpOrDown)(trAfterNodeMove);
        const currentMeta = trAfterNodeMove.getMeta((0, $3BXSc.key));
        const newMeta = {
            ...currentMeta,
            toggleMenu: {
                moveUp: moveUp,
                moveDown: moveDown
            }
        };
        return trAfterNodeMove.setMeta((0, $3BXSc.key), newMeta);
    };
};






var $jv11C = parcelRequire("jv11C");


var $aPdNQ = parcelRequire("aPdNQ");














var $aHnsS = parcelRequire("aHnsS");


var $irTNm = parcelRequire("irTNm");


var $icvkv = parcelRequire("icvkv");


var $izfLh = parcelRequire("izfLh");





var $SlYRR = parcelRequire("SlYRR");


var $hTjcC = parcelRequire("hTjcC");

const $fcbccc7790679e9d$var$createNewLayout = (schema, layoutContents)=>{
    if (layoutContents.length === 0 || layoutContents.length > (0, $icvkv.maxLayoutColumnSupported)()) return null;
    const width = (0, $hTjcC.DEFAULT_COLUMN_DISTRIBUTIONS)[layoutContents.length];
    if (!width) return null;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes || {};
    try {
        const layoutContent = (0, $aPdNQ.Fragment).fromArray(layoutContents.map((layoutContent)=>{
            return layoutColumn.createChecked({
                width: width
            }, layoutContent);
        }));
        const layoutSectionNode = layoutSection.createChecked(undefined, layoutContent);
        return layoutSectionNode;
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    return null;
};
const $fcbccc7790679e9d$var$moveToExistingLayout = (toLayout, toLayoutPos, sourceContent, from, to, tr, $originalFrom, $originalTo, api, selectMovedNode)=>{
    const isSameLayout = (0, $SlYRR.isInSameLayout)($originalFrom, $originalTo);
    const sourceContentEndPos = from + sourceContent.size;
    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, from, sourceContentEndPos);
    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
    if (isSameLayout) {
        // reorder columns
        tr.delete(from, sourceContentEndPos);
        const mappedTo = tr.mapping.map(to);
        tr.insert(mappedTo, sourceContent);
        if (selectMovedNode) tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(mappedTo))).scrollIntoView();
        (0, $aHnsS.attachMoveNodeAnalytics)(tr, (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', true, api, hasSelectedMultipleNodes);
    } else if (toLayout.childCount < (0, $icvkv.maxLayoutColumnSupported)()) {
        (0, $izfLh.removeFromSource)(tr, tr.doc.resolve(from), sourceContentEndPos);
        $fcbccc7790679e9d$var$insertToDestinationNoWidthUpdate(tr, tr.mapping.map(to), sourceContent);
        (0, $aHnsS.attachMoveNodeAnalytics)(tr, (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', false, api, hasSelectedMultipleNodes);
    }
    return tr;
};
/**
 * This function is similar to insertToDestination
 * But without update width step, mainly rely on the append transaction from layout.
 * @param tr
 * @param to
 * @param sourceNode
 * @returns
 */ const $fcbccc7790679e9d$var$insertToDestinationNoWidthUpdate = (tr, to, sourceContent)=>{
    const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
    let content = null;
    try {
        const sourceFragment = sourceContent;
        content = layoutColumn.createChecked({
            width: 0
        }, (0, $irTNm.isFragmentOfType)(sourceFragment, 'layoutColumn') ? sourceFragment.firstChild?.content : sourceFragment);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    if (content) tr.insert(to, content);
    return tr;
};
/**
 * Check if the node at `from` can be moved to node at `to` to create/expand a layout.
 * Returns the source and destination nodes and positions if it's a valid move, otherwise, undefined
 */ const $fcbccc7790679e9d$var$canMoveToLayout = (api, from, to, tr, moveNodeAtCursorPos)=>{
    if (from === to) return;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, doc: doc, bodiedSyncBlock: bodiedSyncBlock } = tr.doc.type.schema.nodes || {};
    // layout plugin does not exist
    if (!layoutSection || !layoutColumn) return;
    const $to = tr.doc.resolve(to);
    const allowedParentTypes = [
        doc,
        layoutSection
    ];
    if (bodiedSyncBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) allowedParentTypes.push(bodiedSyncBlock);
    // drop at invalid position, not top level, or not a layout column
    if (!$to.nodeAfter || !allowedParentTypes.includes($to.parent.type)) return;
    const $from = tr.doc.resolve(from);
    // invalid from position or dragging a layout
    if (!$from.nodeAfter || $from.nodeAfter.type === layoutSection) return;
    let sourceContent = $from.nodeAfter;
    let sourceFrom = from;
    let sourceTo = from + sourceContent.nodeSize;
    if (!moveNodeAtCursorPos) {
        const { anchor: anchor, head: head } = (0, $i2jOy.getMultiSelectionIfPosInside)(api, from);
        if (anchor !== undefined && head !== undefined) {
            sourceFrom = Math.min(anchor, head);
            sourceTo = Math.max(anchor, head);
            sourceContent = tr.doc.slice(sourceFrom, sourceTo).content;
            // TODO: ED-26959 - this might become expensive for large content, consider removing it if check has been done beforehand
            if ((0, $irTNm.containsNodeOfType)(sourceContent, 'layoutSection')) return;
        } else sourceContent = (0, $aPdNQ.Fragment).from($from.nodeAfter);
    }
    const toNode = $to.nodeAfter;
    return {
        toNode: toNode,
        $to: $to,
        sourceContent: sourceContent,
        $sourceFrom: tr.doc.resolve(sourceFrom),
        sourceTo: sourceTo
    };
};
const $fcbccc7790679e9d$var$removeBreakoutMarks = (tr, $from, to)=>{
    let fromContentWithoutBreakout = null;
    const { breakout: breakout } = tr.doc.type.schema.marks || {};
    tr.doc.nodesBetween($from.pos, to, (node, pos, parent)=>{
        // should never remove breakout from previous layoutSection
        if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
            if (node.type.name === 'layoutSection') return false;
        }
        // breakout doesn't exist on nested nodes
        if (parent?.type.name === 'doc' && node.marks.some((m)=>m.type === breakout)) tr.removeNodeMark(pos, breakout);
        // descending is not needed as  breakout doesn't exist on nested nodes
        return false;
    });
    // resolve again the source content after node updated (remove breakout marks)
    fromContentWithoutBreakout = tr.doc.slice($from.pos, to).content;
    return fromContentWithoutBreakout;
};
const $fcbccc7790679e9d$var$getBreakoutMode = (content, breakout)=>{
    if (content instanceof (0, $aPdNQ.Node)) return content.marks.find((m)=>m.type === breakout)?.attrs.mode;
    else if (content instanceof (0, $aPdNQ.Fragment)) {
        // Find the first breakout mode in the fragment
        let firstBreakoutMode;
        for(let i = 0; i < content.childCount; i++){
            const child = content.child(i);
            const breakoutMark = child.marks.find((m)=>m.type === breakout);
            if (breakoutMark) {
                firstBreakoutMode = breakoutMark.attrs.mode;
                break;
            }
        }
        return firstBreakoutMode;
    }
};
const $fcbccc7790679e9d$var$getBreakoutModeAndWidth = (content, breakout)=>{
    const findBreakoutMark = (node)=>node.marks.find((m)=>m.type === breakout);
    const extractBreakoutAttributes = (mark)=>mark ? {
            breakoutMode: mark.attrs.mode,
            breakoutWidth: mark.attrs.width
        } : null;
    if (content instanceof (0, $aPdNQ.Node)) return extractBreakoutAttributes(findBreakoutMark(content));
    else if (content instanceof (0, $aPdNQ.Fragment)) // Find the first breakout mode in the fragment
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        const breakoutMark = findBreakoutMark(child);
        if (breakoutMark) return extractBreakoutAttributes(breakoutMark);
    }
    return null;
};
const $fcbccc7790679e9d$export$6e686efeb3f3578c = (api)=>(from, to, options)=>({ tr: tr })=>{
            if (!api) return tr;
            const canMove = $fcbccc7790679e9d$var$canMoveToLayout(api, from, to, tr, options?.moveNodeAtCursorPos);
            if (!canMove) return tr;
            const { toNode: toNode, $to: $to, sourceContent: sourceContent, $sourceFrom: $sourceFrom, sourceTo: sourceTo } = canMove;
            const { layoutSection: layoutSection, layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
            const { breakout: breakout } = tr.doc.type.schema.marks || {};
            // get breakout mode from destination node,
            // if not found, get from source node,
            let breakoutMode;
            let breakoutWidth;
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) ({ breakoutMode: breakoutMode, breakoutWidth: breakoutWidth } = $fcbccc7790679e9d$var$getBreakoutModeAndWidth(toNode, breakout) || $fcbccc7790679e9d$var$getBreakoutModeAndWidth(sourceContent, breakout) || {});
            else breakoutMode = $fcbccc7790679e9d$var$getBreakoutMode(toNode, breakout) || $fcbccc7790679e9d$var$getBreakoutMode(sourceContent, breakout);
            // we don't want to remove marks when moving/re-ordering layoutSection
            const shouldRemoveMarks = $sourceFrom.node().type !== layoutSection;
            const fromContentBeforeBreakoutMarksRemoved = tr.doc.slice($sourceFrom.pos, sourceTo).content;
            // remove breakout from source content
            let fromContentWithoutBreakout = shouldRemoveMarks ? $fcbccc7790679e9d$var$removeBreakoutMarks(tr, $sourceFrom, sourceTo) : fromContentBeforeBreakoutMarksRemoved;
            if (!fromContentWithoutBreakout) return tr;
            if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            if (toNode.type === layoutSection) {
                const toPos = options?.moveToEnd ? to + toNode.nodeSize - 1 : to + 1;
                return $fcbccc7790679e9d$var$moveToExistingLayout(toNode, to, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else if (toNode.type === layoutColumn) {
                const toLayout = $to.parent;
                const toLayoutPos = to - $to.parentOffset - 1;
                const toPos = options?.moveToEnd ? to + toNode.nodeSize : to;
                return $fcbccc7790679e9d$var$moveToExistingLayout(toLayout, toLayoutPos, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options?.selectMovedNode);
            } else {
                let toNodeWithoutBreakout = toNode;
                // remove breakout from node;
                if (breakout && $to.nodeAfter && $to.nodeAfter.marks.some((m)=>m.type === breakout)) {
                    tr.removeNodeMark(to, breakout);
                    // resolve again the source node after node updated (remove breakout marks)
                    toNodeWithoutBreakout = tr.doc.resolve(to).nodeAfter || toNode;
                }
                if ((0, $irTNm.isFragmentOfType)(fromContentWithoutBreakout, 'layoutColumn') && fromContentWithoutBreakout.firstChild) fromContentWithoutBreakout = fromContentWithoutBreakout.firstChild.content;
                const layoutContents = options?.moveToEnd ? [
                    toNodeWithoutBreakout,
                    fromContentWithoutBreakout
                ] : [
                    fromContentWithoutBreakout,
                    toNodeWithoutBreakout
                ];
                const newLayout = $fcbccc7790679e9d$var$createNewLayout(tr.doc.type.schema, layoutContents);
                if (newLayout) {
                    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, $sourceFrom.pos, sourceTo);
                    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    tr = (0, $izfLh.removeFromSource)(tr, $sourceFrom, sourceTo);
                    const mappedTo = tr.mapping.map(to);
                    tr.delete(mappedTo, mappedTo + toNodeWithoutBreakout.nodeSize).insert(mappedTo, newLayout);
                    if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode,
                            width: breakoutWidth
                        })
                    ]);
                    else breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode
                        })
                    ]);
                    if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) // layout created via drag and drop will always be 2 columns
                    (0, $aHnsS.fireInsertLayoutAnalytics)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes, 2);
                    else (0, $aHnsS.fireInsertLayoutAnalytics)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes);
                }
                return tr;
            }
        };






var $kpCD8 = parcelRequire("kpCD8");





var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");




const $77f30cc17fbf24cf$export$fd198b85b7fd4b80 = new (0, $kCECX.PluginKey)('firstNodeDec');
const $77f30cc17fbf24cf$var$createFirstNodeDecSet = (state)=>{
    const firstNode = state.doc.firstChild;
    if (!firstNode) return (0, $8nvEM.DecorationSet).empty;
    const firstNodeDecoration = (0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $8nvEM.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0;',
        class: 'first-node-in-document'
    }) : (0, $8nvEM.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0'
    });
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        firstNodeDecoration
    ]);
};
const $77f30cc17fbf24cf$export$4a529dfc67d1b47b = ()=>new (0, $kpCD8.SafePlugin)({
        key: $77f30cc17fbf24cf$export$fd198b85b7fd4b80,
        state: {
            init (_, state) {
                return $77f30cc17fbf24cf$var$createFirstNodeDecSet(state);
            },
            apply (tr, currentState, _, newState) {
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
                // Reapply decorations if there are any steps that modify the document
                if (isDocChanged) return $77f30cc17fbf24cf$var$createFirstNodeDecSet(newState);
                return currentState;
            }
        },
        props: {
            decorations (state) {
                return $77f30cc17fbf24cf$export$fd198b85b7fd4b80.getState(state);
            }
        }
    });



var $cbY7C = parcelRequire("cbY7C");










/** Far-right margin width reserved for the Rovo button, where the Remix button must not show. */ const $21cd54fe956109a1$export$f71c1df40151e4dd = 80;



const $8ac8586c6f9c2f0b$export$2e0e85f705dfca46 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'stopEditing'
    }));
};
const $8ac8586c6f9c2f0b$export$67bd57d439e8e4eb = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'startEditing'
    }));
};
const $8ac8586c6f9c2f0b$export$62b9e387feb21f54 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'mouseLeave'
    }));
};
const $8ac8586c6f9c2f0b$export$681e7b82bbbeba93 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'mouseEnter'
    }));
};
const $8ac8586c6f9c2f0b$export$f6d493eea1569e93 = (view, side)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'setHoverSide',
        side: side
    }));
};
const $8ac8586c6f9c2f0b$export$2ded006fde40ec1d = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $78a32da2f9d512bf$export$d14f503a2a677768), {
        type: 'clearHoverSide'
    }));
};



const $1ea096474dcf7ec3$export$bab59f27a7347e45 = (view, event)=>{
    // Check if this is a keyboard shortcut (Ctrl/Cmd + key)
    const isShortcut = event.ctrlKey || event.metaKey || event.altKey;
    if (isShortcut) return false;
    // Only consider actual typing keys (not shortcuts)
    // We need to check if it's a single character key or a deletion key
    // and ensure it's not part of a shortcut
    const isTypingKey = // Single character keys (letters, numbers, symbols)
    event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete' || event.key === ' ' || event.key === 'Enter';
    if (!isTypingKey) return false;
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    // if user hasnt started typing yet, start timer
    if (!state?.isEditing) (0, $8ac8586c6f9c2f0b$export$67bd57d439e8e4eb)(view);
    return false;
};






var $h7MdN = parcelRequire("h7MdN");




/** Per-view pending hover state; avoids cross-editor singleton. */ const $4e83e20bfa47616e$var$pendingByView = new WeakMap();
/** Per-view RAF handle so clearPendingHoverSide cancels only that view's callback. */ const $4e83e20bfa47616e$var$rafIdByView = new WeakMap();
const $4e83e20bfa47616e$var$cancelScheduledProcessForView = (view)=>{
    const id = $4e83e20bfa47616e$var$rafIdByView.get(view);
    if (id !== undefined) {
        cancelAnimationFrame(id);
        $4e83e20bfa47616e$var$rafIdByView.delete(view);
    }
};
const $4e83e20bfa47616e$var$clearPendingHoverSide = (view)=>{
    $4e83e20bfa47616e$var$pendingByView.delete(view);
    $4e83e20bfa47616e$var$cancelScheduledProcessForView(view);
};
const $4e83e20bfa47616e$var$BLOCK_SELECTORS = '[data-node-anchor], [data-drag-handler-anchor-name]';
const $4e83e20bfa47616e$var$RIGHT_EDGE_SELECTOR = '[data-blocks-right-edge-button-container]';
// Top-level blocks (no block ancestor), matched by anchor attribute so it works under both the
// legacy and native-anchor schemes.
const $4e83e20bfa47616e$var$getRootBlocks = (view)=>Array.from(view.dom.querySelectorAll($4e83e20bfa47616e$var$BLOCK_SELECTORS)).filter((el)=>!el.parentElement?.closest($4e83e20bfa47616e$var$BLOCK_SELECTORS));
// Find the root block whose vertical bounds contain clientY. Returns the measured rect so callers
// can reuse it without re-measuring.
const $4e83e20bfa47616e$var$findBlockAtY = (view, clientY)=>{
    for (const el of $4e83e20bfa47616e$var$getRootBlocks(view)){
        const rect = el.getBoundingClientRect();
        if (clientY >= rect.top && clientY <= rect.bottom) return {
            block: el,
            rect: rect
        };
    }
    return null;
};
const $4e83e20bfa47616e$var$getRightMarginBoundary = (view)=>(view.dom.ownerDocument.defaultView?.innerWidth ?? Number.POSITIVE_INFINITY) - (0, $21cd54fe956109a1$export$f71c1df40151e4dd);
// Classify where the cursor sits in the right margin beside the block at its height, running the
// block lookup once so the caller doesn't traverse the DOM twice per mousemove.
const $4e83e20bfa47616e$var$classifyRightMarginPosition = (view, event)=>{
    const found = $4e83e20bfa47616e$var$findBlockAtY(view, event.clientY);
    if (!found) return null;
    if (event.clientX <= found.rect.right) return null;
    return event.clientX > $4e83e20bfa47616e$var$getRightMarginBoundary(view) ? {
        type: 'gap'
    } : {
        type: 'active',
        block: found.block
    };
};
/**
 * Process hover position and set left/right side. Only invoked when right-side controls are
 * enabled (confluence_remix_button_right_side_block_fg); handleMouseMove returns early otherwise.
 */ const $4e83e20bfa47616e$var$processHoverSide = (view, api)=>{
    const event = $4e83e20bfa47616e$var$pendingByView.get(view);
    if (!event) return;
    $4e83e20bfa47616e$var$pendingByView.delete(view);
    $4e83e20bfa47616e$var$rafIdByView.delete(view);
    const editorContentArea = view.dom.closest('.ak-editor-content-area');
    if (!(editorContentArea instanceof HTMLElement)) return;
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    const target = event.target instanceof HTMLElement ? event.target : null;
    // When hovering over block controls directly, infer side from which control we're over.
    // This is more reliable than bounds when controls are in portals outside the editor DOM.
    const rightEdgeElement = target?.closest($4e83e20bfa47616e$var$RIGHT_EDGE_SELECTOR);
    if (rightEdgeElement) {
        if (state?.hoverSide !== 'right') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'right');
        return;
    }
    const leftControlElement = target?.closest('[data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]');
    if (leftControlElement) {
        if (state?.hoverSide !== 'left') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'left');
        return;
    }
    // Added right-margin hover, gated so it can be rolled back. When off, fall through to midpoint.
    if ((0, $fqVYq.editorExperiment)('remix_button_right_margin_hover', true, {
        exposure: true
    })) {
        const closestBlock = target?.closest($4e83e20bfa47616e$var$BLOCK_SELECTORS);
        const blockElement = closestBlock instanceof HTMLElement ? closestBlock : null;
        // Not over a block: the cursor may be in the right margin beside content.
        const marginZone = blockElement ? null : $4e83e20bfa47616e$var$classifyRightMarginPosition(view, event);
        if (marginZone?.type === 'active' && api) {
            // handleMouseOver only reads event.target, so a target-only stand-in is enough here.
            (0, $h7MdN.handleMouseOver)(view, {
                target: marginZone.block
            }, api);
            // mouseenter doesn't fire over the click overlay, so clear isMouseOut here to re-show.
            if (state?.isMouseOut) (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view);
            if (state?.hoverSide !== 'right') (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, 'right');
            return;
        }
        // In the Rovo gap, dismiss the controls so the button doesn't linger over the Rovo button.
        if (marginZone?.type === 'gap' || event.clientX > $4e83e20bfa47616e$var$getRightMarginBoundary(view)) {
            if (!state?.isMouseOut) {
                (0, $8ac8586c6f9c2f0b$export$2ded006fde40ec1d)(view);
                (0, $8ac8586c6f9c2f0b$export$62b9e387feb21f54)(view);
            }
            return;
        }
    // Over a block: fall through to the midpoint split so the left half keeps the drag handle and
    // the right half shows the Remix button, matching the experiment-off behaviour.
    }
    // Pick the side from the content midpoint, keeping the original left/right halves.
    const { left: left, right: right } = editorContentArea.getBoundingClientRect();
    const midpoint = (left + right) / 2;
    const nextHoverSide = event.clientX > midpoint ? 'right' : 'left';
    if (state?.hoverSide !== nextHoverSide) (0, $8ac8586c6f9c2f0b$export$f6d493eea1569e93)(view, nextHoverSide);
};
const $4e83e20bfa47616e$export$3248c033e90a4ba0 = (view, event, rightSideControlsEnabled = false, api)=>{
    const state = (0, $78a32da2f9d512bf$export$27d80eabdcbf88a5)(view.state);
    // if user has stopped editing and moved their mouse, show block controls again
    if (state?.isEditing) (0, $8ac8586c6f9c2f0b$export$2e0e85f705dfca46)(view);
    // Only track hover side when right-side controls are enabled (single source: confluence_remix_button_right_side_block_fg via config)
    if (!rightSideControlsEnabled) return false;
    if (!(event instanceof MouseEvent)) return false;
    $4e83e20bfa47616e$var$pendingByView.set(view, event);
    $4e83e20bfa47616e$var$cancelScheduledProcessForView(view);
    const id = requestAnimationFrame(()=>{
        $4e83e20bfa47616e$var$processHoverSide(view, api);
    });
    $4e83e20bfa47616e$var$rafIdByView.set(view, id);
    return false;
};
const $4e83e20bfa47616e$export$fcff8e67f71577c3 = (view, rightSideControlsEnabled = false)=>{
    if (rightSideControlsEnabled) $4e83e20bfa47616e$var$clearPendingHoverSide(view);
    (0, $8ac8586c6f9c2f0b$export$62b9e387feb21f54)(view);
    return false;
};
const $4e83e20bfa47616e$export$2560ef85393729a7 = (view)=>{
    (0, $8ac8586c6f9c2f0b$export$681e7b82bbbeba93)(view);
    return false;
};


/** Elements that extend the editor hover area (block controls, right-edge button, etc.) */ const $78a32da2f9d512bf$var$BLOCK_CONTROLS_HOVER_AREA_SELECTOR = '[data-blocks-right-edge-button-container], [data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]';
const $78a32da2f9d512bf$var$MOUSE_LEAVE_DEBOUNCE_MS = 200;
/** ClickAreaBlock overlay that wraps the editor content and covers the right margin. */ const $78a32da2f9d512bf$var$CLICK_AREA_SELECTOR = '[data-editor-click-wrapper]';
const $78a32da2f9d512bf$var$isMovingToBlockControlsArea = (target)=>target instanceof Element && !!target.closest($78a32da2f9d512bf$var$BLOCK_CONTROLS_HOVER_AREA_SELECTOR);
/**
 * The right margin is covered by the ClickAreaBlock overlay, which sits outside .ak-editor-content-area.
 * Hovering there should still surface the right-side Remix button, so keep controls alive — but only on
 * the right (past the content's right edge), and not in the far-right Rovo gap. The left gutter must
 * dismiss like the experiment-off path, so it is treated as inactive.
 */ const $78a32da2f9d512bf$var$isOverActiveClickArea = (target, clientX)=>{
    if (!(target instanceof Element)) return false;
    const clickArea = target.closest($78a32da2f9d512bf$var$CLICK_AREA_SELECTOR);
    if (!clickArea) return false;
    const contentRight = clickArea.querySelector('.ak-editor-content-area')?.getBoundingClientRect().right;
    if (contentRight !== undefined && clientX <= contentRight) return false;
    const innerWidth = target.ownerDocument.defaultView?.innerWidth ?? Number.POSITIVE_INFINITY;
    return clientX <= innerWidth - (0, $21cd54fe956109a1$export$f71c1df40151e4dd);
};
const $78a32da2f9d512bf$export$d14f503a2a677768 = new (0, $kCECX.PluginKey)('interactionTrackingPlugin');
const $78a32da2f9d512bf$export$66f3b9297f4ee65b = (rightSideControlsEnabled = false, api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $78a32da2f9d512bf$export$d14f503a2a677768,
        state: {
            init () {
                const state = {
                    isEditing: false
                };
                if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) state.isMouseOut = false;
                return state;
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($78a32da2f9d512bf$export$d14f503a2a677768);
                const newState = {};
                switch(meta?.type){
                    case 'startEditing':
                        newState.isEditing = true;
                        break;
                    case 'stopEditing':
                        newState.isEditing = false;
                        break;
                    case 'mouseLeave':
                        newState.isMouseOut = true;
                        newState.hoverSide = undefined;
                        break;
                    case 'mouseEnter':
                        newState.isMouseOut = false;
                        break;
                    case 'setHoverSide':
                        newState.hoverSide = meta.side;
                        break;
                    case 'clearHoverSide':
                        newState.hoverSide = undefined;
                        break;
                }
                return {
                    ...pluginState,
                    ...newState
                };
            }
        },
        props: {
            handleKeyDown: $1ea096474dcf7ec3$export$bab59f27a7347e45,
            handleDOMEvents: {
                mousemove: (view, event)=>(0, $4e83e20bfa47616e$export$3248c033e90a4ba0)(view, event, rightSideControlsEnabled, api)
            }
        },
        view: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
            const editorContentArea = view.dom.closest('.ak-editor-content-area');
            // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
            let unbindMouseEnter;
            let unbindMouseLeave;
            let unbindDocumentMouseMove;
            let mouseLeaveTimeoutId = null;
            let lastMousePosition = {
                x: 0,
                y: 0
            };
            // The active right margin only counts as "still hovering" when our experiment is on;
            // otherwise leaving the content area (e.g. exiting left) must dismiss as on master.
            const marginHoverEnabled = (0, $fqVYq.editorExperiment)('remix_button_right_margin_hover', true);
            const scheduleMouseLeave = (event)=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
                // Keep controls visible when moving to block controls (or, with the experiment on,
                // the active right margin — the Rovo gap is excluded so controls still clear there).
                if (rightSideControlsEnabled && ($78a32da2f9d512bf$var$isMovingToBlockControlsArea(event.relatedTarget) || marginHoverEnabled && $78a32da2f9d512bf$var$isOverActiveClickArea(event.relatedTarget, event.clientX))) return;
                mouseLeaveTimeoutId = setTimeout(()=>{
                    mouseLeaveTimeoutId = null;
                    // Re-check after the debounce: keep controls if the cursor landed on block controls
                    // (or, with the experiment on, the active right margin).
                    if (rightSideControlsEnabled && typeof document !== 'undefined') {
                        const el = document.elementFromPoint(lastMousePosition.x, lastMousePosition.y);
                        if (el && ($78a32da2f9d512bf$var$isMovingToBlockControlsArea(el) || marginHoverEnabled && $78a32da2f9d512bf$var$isOverActiveClickArea(el, lastMousePosition.x))) return;
                    }
                    (0, $4e83e20bfa47616e$export$fcff8e67f71577c3)(view, rightSideControlsEnabled);
                }, $78a32da2f9d512bf$var$MOUSE_LEAVE_DEBOUNCE_MS);
            };
            const cancelScheduledMouseLeave = ()=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
            };
            if (editorContentArea) {
                if (rightSideControlsEnabled && typeof document !== 'undefined') unbindDocumentMouseMove = (0, $cbY7C.bind)(document, {
                    type: 'mousemove',
                    listener: (event)=>{
                        lastMousePosition = {
                            x: event.clientX,
                            y: event.clientY
                        };
                        // Catches block controls in portals that handleDOMEvents.mousemove misses.
                        // The right-margin overlay is only relevant with the experiment on.
                        const overClickArea = marginHoverEnabled && event.target instanceof Element && !!event.target.closest($78a32da2f9d512bf$var$CLICK_AREA_SELECTOR);
                        if (editorContentArea.contains(event.target) || $78a32da2f9d512bf$var$isMovingToBlockControlsArea(event.target) || overClickArea) (0, $4e83e20bfa47616e$export$3248c033e90a4ba0)(view, event, rightSideControlsEnabled, api);
                    },
                    options: {
                        passive: true
                    }
                });
                unbindMouseEnter = (0, $cbY7C.bind)(editorContentArea, {
                    type: 'mouseenter',
                    listener: ()=>{
                        if (rightSideControlsEnabled) cancelScheduledMouseLeave();
                        (0, $4e83e20bfa47616e$export$2560ef85393729a7)(view);
                    }
                });
                unbindMouseLeave = (0, $cbY7C.bind)(editorContentArea, {
                    type: 'mouseleave',
                    listener: (event)=>{
                        const e = event;
                        lastMousePosition = {
                            x: e.clientX,
                            y: e.clientY
                        };
                        if (rightSideControlsEnabled) scheduleMouseLeave(e);
                        else (0, $4e83e20bfa47616e$export$fcff8e67f71577c3)(view, false);
                    }
                });
            }
            return {
                destroy: ()=>{
                    if (rightSideControlsEnabled) {
                        cancelScheduledMouseLeave();
                        unbindDocumentMouseMove?.();
                    }
                    unbindMouseEnter?.();
                    unbindMouseLeave?.();
                }
            };
        } : undefined
    });
};
const $78a32da2f9d512bf$export$27d80eabdcbf88a5 = (state)=>{
    return $78a32da2f9d512bf$export$d14f503a2a677768.getState(state);
};













var $haNN4 = parcelRequire("haNN4");





var $kAPZe = parcelRequire("kAPZe");


















var $2RAus = parcelRequire("2RAus");




const $a1fa225e90ca0ccd$export$a61ec0b8c52b12b5 = (transactions)=>{
    return transactions.some((tr)=>tr.getMeta('pointer') && tr.selectionSet);
};
const $a1fa225e90ca0ccd$export$176558ea818a3e54 = (tr)=>{
    return tr.getMeta((0, $6FQH1.selectionPreservationPluginKey));
};
const $a1fa225e90ca0ccd$export$a7b6f48b0ef94ac5 = (tr)=>tr.getMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META)) === true;
const $a1fa225e90ca0ccd$export$36518d6d9145806a = (a, b)=>{
    return !a && !b || !!a && !!b && a.eq(b);
};
const $a1fa225e90ca0ccd$export$e6bc8ad830dbda92 = (selection, view, options)=>{
    try {
        if (options?.focusEditor && !view.hasFocus()) // The native browser selection is only painted while the editor owns focus.
        // Formatting toolbar interactions can move focus away before we restore the range.
        view.focus();
        const domSelection = window.getSelection();
        if (!domSelection) return;
        const doc = (0, $haNN4.getDocument)();
        if (!doc) return;
        // Convert ProseMirror selection to DOM selection using view.domAtPos
        const anchor = view.domAtPos(selection.anchor);
        const head = view.domAtPos(selection.head);
        if (!anchor || !head) return;
        // Create a new DOM range from the ProseMirror selection
        const range = doc.createRange();
        range.setStart(anchor.node, anchor.offset);
        range.setEnd(head.node, head.offset);
        // Update the DOM selection to match ProseMirror's selection
        domSelection.removeAllRanges();
        domSelection.addRange(range);
    } catch  {
    // Silently fail if DOM selection sync fails
    // This can happen if positions are invalid or DOM hasn't updated yet
    }
};


const $635b558f5a41e938$export$36720c70349457f = (api)=>()=>{
        return new (0, $kpCD8.SafePlugin)({
            key: (0, $6FQH1.selectionPreservationPluginKey),
            state: {
                init () {
                    if ((0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) return {
                        preservedSelection: undefined,
                        syncDomSelectionForDoc: undefined
                    };
                    else return {
                        preservedSelection: undefined
                    };
                },
                apply (tr, pluginState) {
                    const meta = (0, $a1fa225e90ca0ccd$export$176558ea818a3e54)(tr);
                    const newState = {
                        ...pluginState
                    };
                    if (meta?.type === 'startPreserving') {
                        newState.preservedSelection = (0, $i2jOy.createPreservedSelection)(tr.doc.resolve(tr.selection.from), tr.doc.resolve(tr.selection.to));
                        if ((0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) newState.syncDomSelectionForDoc = undefined;
                    } else if (meta?.type === 'stopPreserving') {
                        newState.preservedSelection = undefined;
                        if ((0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) newState.syncDomSelectionForDoc = undefined;
                    } else if (tr.docChanged) {
                        if (newState.preservedSelection) newState.preservedSelection = (0, $i2jOy.mapPreservedSelection)(newState.preservedSelection, tr);
                        if ((0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) newState.syncDomSelectionForDoc = (0, $a1fa225e90ca0ccd$export$a7b6f48b0ef94ac5)(tr) ? tr.doc : undefined;
                    }
                    if (!(0, $a1fa225e90ca0ccd$export$36518d6d9145806a)(newState.preservedSelection, pluginState.preservedSelection)) {
                        if (newState.preservedSelection) api?.core.actions.execute(api?.selection?.commands?.setBlockSelection(newState.preservedSelection));
                        else api?.core.actions.execute(api?.selection?.commands?.clearBlockSelection());
                    }
                    return newState;
                }
            },
            appendTransaction (transactions, _oldState, newState) {
                const pluginState = (0, $6FQH1.selectionPreservationPluginKey).getState(newState);
                const preservedSel = pluginState?.preservedSelection;
                const stateSel = newState.selection;
                if (!preservedSel) return null;
                // Auto-stop if user explicitly changes selection
                if ((0, $a1fa225e90ca0ccd$export$a61ec0b8c52b12b5)(transactions)) return (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                const selectionUnchanged = stateSel.from === preservedSel.from && stateSel.to === preservedSel.to;
                const selectionInvalid = preservedSel.from < 0 || preservedSel.to > newState.doc.content.size;
                if (selectionUnchanged || selectionInvalid) return null;
                const newSelection = (0, $i2jOy.createPreservedSelection)(newState.doc.resolve(preservedSel.from), newState.doc.resolve(preservedSel.to));
                // If selection becomes invalid, stop preserving
                if (!newSelection) return (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                    tr: newState.tr
                });
                return newState.tr.setSelection(newSelection);
            },
            view (initialView) {
                let view = initialView;
                const doc = (0, $haNN4.getDocument)();
                let pendingFormatSelectionSyncFrame;
                if (!doc) return {
                    update () {},
                    destroy () {}
                };
                const unbindDocumentMouseDown = (0, $cbY7C.bind)(doc, {
                    type: 'mousedown',
                    listener: (e)=>{
                        if (!(e.target instanceof HTMLElement)) return;
                        const { preservedSelection: preservedSelection } = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state) || {};
                        // If there is no current preserved selection or the editor is not focused, do nothing
                        if (!preservedSelection) return;
                        const clickedDragHandle = !!e.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR));
                        // When mouse down on a drag handle we continue preserving the selection
                        if (clickedDragHandle) return;
                        const clickedOutsideEditor = !e.target.closest('.ProseMirror');
                        // When mouse down outside the editor continue to preserve the selection
                        if (clickedOutsideEditor) return;
                        // Otherwise mouse down anywhere else in the editor stops preserving the selection
                        const tr = view.state.tr;
                        (0, $bb8f0178a1bbd465$export$7ee148889ab74bda)({
                            tr: tr
                        });
                        view.dispatch(tr);
                    },
                    // Use capture phase to stop preservation before appendTransaction runs,
                    // preventing unwanted selection restoration when the user clicks into the editor.
                    options: {
                        capture: true
                    }
                });
                return {
                    update (updateView, prevState) {
                        view = updateView;
                        const prevPreservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(prevState)?.preservedSelection;
                        const currPluginState = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state);
                        const currPreservedSelection = currPluginState?.preservedSelection;
                        const prevActiveNode = (0, $3BXSc.key).getState(prevState)?.activeNode;
                        const currActiveNode = (0, $3BXSc.key).getState(view.state)?.activeNode;
                        // Sync DOM selection when the preserved selection or active node changes
                        // AND the document has changed (e.g., nodes moved)
                        // This prevents stealing focus during menu navigation while still fixing ghost highlighting
                        const hasPreservedSelection = !!currPreservedSelection;
                        const preservedSelectionChanged = !(0, $a1fa225e90ca0ccd$export$36518d6d9145806a)(prevPreservedSelection, currPreservedSelection);
                        const activeNodeChanged = prevActiveNode !== currActiveNode;
                        const docChanged = prevState.doc !== view.state.doc;
                        const hasFormatSyncRequestForCurrentDoc = currPluginState?.syncDomSelectionForDoc === view.state.doc;
                        const shouldSyncDOMSelection = (hasPreservedSelection && (preservedSelectionChanged || activeNodeChanged) || (0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true) && hasFormatSyncRequestForCurrentDoc) && docChanged;
                        if (shouldSyncDOMSelection) {
                            const syncSelection = view.state.selection;
                            if ((0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) {
                                if (hasFormatSyncRequestForCurrentDoc) {
                                    if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                                    pendingFormatSelectionSyncFrame = requestAnimationFrame(()=>{
                                        pendingFormatSelectionSyncFrame = undefined;
                                        (0, $a1fa225e90ca0ccd$export$e6bc8ad830dbda92)(syncSelection, view, {
                                            focusEditor: true
                                        });
                                    });
                                } else (0, $a1fa225e90ca0ccd$export$e6bc8ad830dbda92)(syncSelection, view);
                            } else (0, $a1fa225e90ca0ccd$export$e6bc8ad830dbda92)(syncSelection, view);
                        }
                    },
                    destroy () {
                        if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                        unbindDocumentMouseDown();
                    }
                };
            },
            props: {
                handleKeyDown: (view, event)=>{
                    const { preservedSelection: preservedSelection } = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state) || {};
                    // If there is no current preserved selection, do nothing
                    if (!preservedSelection) return false;
                    api?.core?.actions.execute(api?.blockControls?.commands?.handleKeyDownWithPreservedSelection(event));
                    // While preserving selection, if user presses delete/backspace, prevent event from being
                    // handled by ProseMirror natively so that we can apply logic using the preserved selection.
                    return [
                        'backspace',
                        'delete'
                    ].includes(event.key.toLowerCase());
                }
            }
        });
    };



var $2w4SV = parcelRequire("2w4SV");


var $bOZni = parcelRequire("bOZni");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $2XHKU = parcelRequire("2XHKU");







var $fngNp = parcelRequire("fngNp");


var $7Y8M5 = parcelRequire("7Y8M5");











var $fKt2m = parcelRequire("fKt2m");

function $9d0abd7f97ed1440$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This anchor element selector disregards anchors that are solely utilized for size measurements,
 * including those within table rows and media.
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelector = '[data-drag-handler-anchor-name]:not([data-drag-handler-node-type="tableRow"], [data-drag-handler-node-type="media"])';
/**
 * Disregards anchors that can not have handles next to them, and so shouldn't have an extended hover zone
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"])`;
/**
 * Extended version that also excludes descendants of taskList.
 * preventing the ::after hover zone from blocking checkbox inputs in blockTaskItem nodes.
 */ const $9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"], [data-prosemirror-node-name="taskList"] [${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}])`;
const $9d0abd7f97ed1440$var$gutterPaddingWidth = ()=>(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? `${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px` : '100%';
const $9d0abd7f97ed1440$var$gutterPaddingLeft = ()=>(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? `-${(0, $7Y8M5.akEditorGutterPaddingDynamic)()}px` : '-100px';
const $9d0abd7f97ed1440$var$extendedHoverZone = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.block-ctrl-drag-preview ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $9d0abd7f97ed1440$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $9d0abd7f97ed1440$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // hover zone for layout column should be placed near the top of the column (where drag handle is)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&& [data-drag-handler-anchor-name][data-layout-column]::after': {
                content: '""',
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                top: `${-(0, $kAPZe.DRAG_HANDLE_WIDTH) / 2}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                height: `${(0, $kAPZe.DRAG_HANDLE_WIDTH)}px`,
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        //eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-blocks-drag-handle-container="true"] + [data-drag-handler-anchor-depth="0"]::after': {
            display: 'none'
        }
    });
const $9d0abd7f97ed1440$var$extendedHoverZoneNext = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.block-ctrl-drag-preview ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $hTjcC.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // Top level depth hover zone should extend to gutter padding area
            // we select the top level by using NOT nested anchor selector
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $9d0abd7f97ed1440$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $9d0abd7f97ed1440$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`[data-blocks-drag-handle-container="true"] + ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            display: 'none'
        }
    });
const $9d0abd7f97ed1440$var$layoutColumnExtendedHoverZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // hover zone for layout column should be placed near the top of the column (where drag handle is)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            content: '""',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            top: `${-(0, $kAPZe.DRAG_HANDLE_WIDTH) / 2}px`,
            left: 0,
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $kAPZe.DRAG_HANDLE_WIDTH)}px`,
            cursor: 'default',
            zIndex: 1
        }
    }
});
const $9d0abd7f97ed1440$var$layoutColumnWithoutHoverZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // when advanced_layouts is off, layout columns should not have hover zones, because there aren't any drag handles for layout columns
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            display: 'none'
        }
    }
});
const $9d0abd7f97ed1440$var$extendHoverZoneReduced = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $9d0abd7f97ed1440$var$extendHoverZoneReducedNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`> ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $9d0abd7f97ed1440$var$extendedDragZone = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $9d0abd7f97ed1440$var$extendedDragZoneNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $9d0abd7f97ed1440$var$paragraphWithTrailingBreakAsOnlyChild = '+ :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $9d0abd7f97ed1440$var$indentatedParagraphWithTrailingBreakAsOnlyChild = '+ div.fabric-editor-indentation-mark > :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $9d0abd7f97ed1440$var$paragraphWithPlaceholder = '+ p > .placeholder-decoration';
const $9d0abd7f97ed1440$var$dragHandleContainer = '.ProseMirror-widget[data-blocks-drag-handle-container="true"]';
const $9d0abd7f97ed1440$var$dragHandleSelector = 'button[data-testid="block-ctrl-drag-handle"]';
const $9d0abd7f97ed1440$var$dropTargetContainer = '.ProseMirror-widget[data-blocks-drop-target-container="true"]';
const $9d0abd7f97ed1440$var$dividerBodiedInCustomPanelWithNoIconSelector = '[data-panel-type].ak-editor-panel__no-icon .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + hr, [data-panel-type] hr:first-child';
const $9d0abd7f97ed1440$var$withInlineNodeStyleSelectors = [
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$paragraphWithTrailingBreakAsOnlyChild}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$indentatedParagraphWithTrailingBreakAsOnlyChild}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:has(${$9d0abd7f97ed1440$var$paragraphWithPlaceholder}) ${$9d0abd7f97ed1440$var$dragHandleSelector}`
].join(', ');
const $9d0abd7f97ed1440$var$withFormatInLayoutStyleFixSelectors = [
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + ${$9d0abd7f97ed1440$var$dropTargetContainer} + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$9d0abd7f97ed1440$var$dropTargetContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`,
    `${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-font-size > :is(h1, h2, h3, h4, h5, h6):first-child`
].join(', ');
/**
 * Please do not change change transform to display:none, or visibility:hidden
 * Otherwise it might break composition input for Chrome
 * https://product-fabric.atlassian.net/browse/ED-24136
 */ const $9d0abd7f97ed1440$var$withInlineNodeStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$9d0abd7f97ed1440$var$withInlineNodeStyleSelectors]: {
        transform: 'scale(0)'
    }
});
const $9d0abd7f97ed1440$var$legacyBreakoutWideLayoutStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '.ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
        '@media (width>=1280px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidth)}px`
        }
    }
});
const $9d0abd7f97ed1440$var$globalDnDStyle = {
    name: "rngdgu",
    styles: ".ProseMirror{[data-layout-content]{user-drag:none;}}"
};
var $9d0abd7f97ed1440$var$_ref = {
    name: "e9bpdb",
    styles: ".ProseMirror-widget:first-child + *:not([data-panel-type], .code-block, [data-node-type=\"nestedExpand\"], [data-node-type=\"expand\"], [data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}.ProseMirror-widget:first-child + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child, .ProseMirror-widget:first-child + .ProseMirror-widget + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child{margin-top:0 !important;}"
};
const $9d0abd7f97ed1440$var$globalStyles = ()=>$9d0abd7f97ed1440$var$_ref;
const $9d0abd7f97ed1440$var$topLevelNodeMarginStyles = {
    name: "u0m1xh",
    styles: ".ProseMirror{> .ProseMirror-widget:first-child + .ProseMirror-gapcursor + *:not([data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]), > .ProseMirror-widget:first-child + *:not([data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}> .ProseMirror-widget:first-child + .ProseMirror-widget + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child, > .ProseMirror-widget:first-child + .ProseMirror-gapcursor + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child{margin-top:0 !important;}}"
};
const $9d0abd7f97ed1440$var$withDividerInPanelStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$dividerBodiedInCustomPanelWithNoIconSelector}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$withDeleteLinesStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`p[data-drag-handler-anchor-name] ${$9d0abd7f97ed1440$var$dragHandleContainer}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'none !important'
    }
});
// Image dnd is broken in Firefox due to a previous fix for image caption https://product-fabric.atlassian.net/browse/ED-14034
// We could remove this fix if the previous issue is invalid
const $9d0abd7f97ed1440$var$withMediaSingleStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    ['.ProseMirror.ua-firefox .mediaSingleView-content-wrap[data-drag-handler-node-type="mediaSingle"][data-drag-handler-anchor-name], .ProseMirror.ua-firefox [data-drag-handler-anchor-name][data-drag-handler-node-type] .mediaSingleView-content-wrap']: {
        userSelect: 'auto',
        cursor: 'pointer'
    }
});
const $9d0abd7f97ed1440$var$withFormatInLayoutStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$withFormatInLayoutStyleFixSelectors}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$headingWithIndentationInLayoutStyleFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$9d0abd7f97ed1440$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $9d0abd7f97ed1440$var$withRelativePosStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelector}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $fngNp.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $9d0abd7f97ed1440$var$withRelativePosStyleNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$9d0abd7f97ed1440$var$dragHandlerAnchorSelectorNext}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $fngNp.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $9d0abd7f97ed1440$var$withAnchorNameZindexStyle = {
    name: "okzdt4",
    styles: ".ProseMirror{&& [data-drag-handler-anchor-depth=\"0\"][data-drag-handler-anchor-name]{z-index:1;}}"
};
const $9d0abd7f97ed1440$var$withAnchorNameZindexStyleNext = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}]:not([${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}] [${0, $fKt2m.NODE_ANCHOR_ATTR_NAME}])`]: {
            zIndex: 1
        }
    }
});
// This style is used to define width for block card (with datasource) that does not have layout
// In full-width editor, block card has width of full-width layout
// In fixed-width editor, block card has width of wide layout
const $9d0abd7f97ed1440$var$blockCardWithoutLayout = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-content-area.fabric-editor--full-width-mode .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor-block-card-width': `min(calc(100cqw - ${(0, $7Y8M5.akEditorBreakoutPadding)}px), 1800px)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        '--ak-editor-block-card-width': 'max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))'
    }
});
const $9d0abd7f97ed1440$var$nextAnchorSelector = [
    '&[data-node-anchor]',
    // adjacent sibling with anchor
    '&:not([data-node-anchor]) [data-node-anchor]:first-of-type',
    // first nested anchor inside adjacent sibling
    '&.ProseMirror-widget + [data-node-anchor]',
    // adjacent sibling with anchor (when next to a widget like gap cursor)
    '&.ProseMirror-widget + :not([data-node-anchor]) [data-node-anchor]:first-of-type' // first nested anchor inside adjacent sibling (when next to a widget like gap cursor)
].join(', ');
const $9d0abd7f97ed1440$var$dragHandlerAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-decorator-widget"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$9d0abd7f97ed1440$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-quick-insert-button"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$9d0abd7f97ed1440$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        }
    }
});
const $9d0abd7f97ed1440$var$activeControlsSelector = `[${(0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR)}], [${(0, $hTjcC.ACTIVE_QUICK_INSERT_ATTR)}]`;
// Applies anchor-name via node decoration attributes rather than adjacency CSS selectors.
// This is more reliable than dragHandlerAnchorStyles which depends on DOM structure.
// Only nodes decorated with data-active-drag-handle / data-active-quick-insert get anchor-name.
const $9d0abd7f97ed1440$var$staticControlsAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$9d0abd7f97ed1440$var$activeControlsSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
// Styles applied to nodes with anchors when dragging
const $9d0abd7f97ed1440$var$dragAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:not([data-node-anchor] [data-node-anchor])': {
            // all top level nodes with anchor
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:has([data-blocks-drop-target-container]) [data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-name="media"][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // first table row to avoid multiple anchors in table
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-prosemirror-node-name="table"] [data-prosemirror-node-name="tableRow"][data-node-anchor]:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $2XHKU.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $9d0abd7f97ed1440$export$cc5403d58ddfa812 = ({ api: api })=>{
    const { isDragging: isDraggingFromState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging
        }));
    const isDragging = (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true) ? isDraggingFromState : false;
    const shouldRenderAnchors = (0, $2XHKU.isCSSAnchorSupported)() && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $9d0abd7f97ed1440$var$globalStyles(),
            $9d0abd7f97ed1440$var$globalDnDStyle,
            (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $9d0abd7f97ed1440$var$extendedHoverZoneNext() : $9d0abd7f97ed1440$var$extendedHoverZone(),
            isDragging && ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $9d0abd7f97ed1440$var$extendedDragZoneNext : $9d0abd7f97ed1440$var$extendedDragZone),
            (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $9d0abd7f97ed1440$var$extendHoverZoneReducedNext : $9d0abd7f97ed1440$var$extendHoverZoneReduced : undefined,
            // platform_editor_controls note: this allows drag handles to render on empty lines
            toolbarFlagsEnabled ? undefined : $9d0abd7f97ed1440$var$withInlineNodeStyle,
            $9d0abd7f97ed1440$var$withDeleteLinesStyleFix,
            $9d0abd7f97ed1440$var$withMediaSingleStyleFix,
            $9d0abd7f97ed1440$var$legacyBreakoutWideLayoutStyle,
            $9d0abd7f97ed1440$var$headingWithIndentationInLayoutStyleFix,
            (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? $9d0abd7f97ed1440$var$blockCardWithoutLayout : undefined,
            $9d0abd7f97ed1440$var$withDividerInPanelStyleFix,
            $9d0abd7f97ed1440$var$withFormatInLayoutStyleFix,
            (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $9d0abd7f97ed1440$var$withRelativePosStyleNext : $9d0abd7f97ed1440$var$withRelativePosStyle,
            $9d0abd7f97ed1440$var$topLevelNodeMarginStyles,
            (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $9d0abd7f97ed1440$var$withAnchorNameZindexStyleNext : $9d0abd7f97ed1440$var$withAnchorNameZindexStyle,
            (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $ieeJu.expValEquals)('advanced_layouts', 'isEnabled', true) ? $9d0abd7f97ed1440$var$layoutColumnExtendedHoverZone : $9d0abd7f97ed1440$var$layoutColumnWithoutHoverZone,
            (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) ? // dragAnchorStyles sets anchor-name on ALL nodes during drag (needed for drop target positioning).
            // staticControlsAnchorStyles handles anchor-name via node decorations for non-drag state.
            // shouldRenderAnchors guards both: only apply anchor styles on browsers that support CSS anchor positioning.
            shouldRenderAnchors ? isDragging ? $9d0abd7f97ed1440$var$dragAnchorStyles : $9d0abd7f97ed1440$var$staticControlsAnchorStyles : false : shouldRenderAnchors && (isDragging ? $9d0abd7f97ed1440$var$dragAnchorStyles : $9d0abd7f97ed1440$var$dragHandlerAnchorStyles)
        ]
    });
};


const $ba9a19c78f543467$export$7a291905586a23d3 = ({ api: api, config: config })=>{
    const nodeDecorationRegistry = [];
    const rightSideControlsEnabled = config?.rightSideControlsEnabled ?? false;
    const quickInsertButtonEnabled = config?.quickInsertButtonEnabled ?? true;
    return {
        name: 'blockControls',
        actions: {
            getTextInfo: (editorView)=>{
                const blockControlsState = api?.blockControls?.sharedState.currentState();
                const preservedSelection = blockControlsState?.preservedSelection;
                if (preservedSelection && preservedSelection.from !== preservedSelection.to) {
                    // CellSelection covers a table: collect each selected cell's text joined with spaces
                    // so that adjacent cells are not fused (e.g. 'hello world' + 'foo' must not
                    // become 'hello worldfoo'). Intl.Segmenter word-counting requires correct
                    // word boundaries, which raw textContent fusion breaks.
                    if (preservedSelection instanceof (0, $8HW7o.CellSelection) && (0, $ieeJu.expValEquals)('remix_iw_block_menu_table_calc_fix', 'isEnabled', true)) {
                        // Use node(1) to reliably target the table node regardless of $anchorCell depth.
                        // node(-1) would return tableRow if $anchorCell is at tableCell depth.
                        const tableNode = preservedSelection.$anchorCell.node(1);
                        const cellTexts = [];
                        if (tableNode) // forEachCell iterates only the selected cells, not all cells in the table.
                        preservedSelection.forEachCell((cell)=>{
                            cellTexts.push(cell.textContent);
                        });
                        const textContent = cellTexts.filter(Boolean).join(' ');
                        return {
                            textLength: textContent.length,
                            textContent: textContent
                        };
                    }
                    const { from: from, to: to } = preservedSelection;
                    const textContent = editorView.state.doc.textBetween(from, to, '\n');
                    return {
                        textLength: textContent.length,
                        textContent: textContent
                    };
                }
                const pos = blockControlsState?.menuTriggerByNode?.pos;
                if (pos === null || pos === undefined) return null;
                const node = editorView.state.doc.nodeAt(pos);
                if (!node) return null;
                return {
                    textLength: node.textContent.length,
                    textContent: node.textContent
                };
            },
            registerNodeDecoration: (factory)=>{
                nodeDecorationRegistry.push(factory);
            },
            unregisterNodeDecoration: (type)=>{
                const idx = nodeDecorationRegistry.findIndex((f)=>f.type === type);
                if (idx !== -1) nodeDecorationRegistry.splice(idx, 1);
            }
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'blockControlsPmPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $3BXSc.createPlugin)(api, getIntl, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled)
                }
            ];
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) pmPlugins.push({
                name: 'blockControlsInteractionTrackingPlugin',
                plugin: ()=>(0, $78a32da2f9d512bf$export$66f3b9297f4ee65b)(rightSideControlsEnabled, api)
            });
            if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) pmPlugins.push({
                name: 'blockControlsSelectionPreservationPlugin',
                plugin: (0, $635b558f5a41e938$export$36720c70349457f)(api)
            });
            // platform_editor_controls note: quick insert rendering fixes
            if ((0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) pmPlugins.push({
                name: 'firstNodeDec',
                plugin: (0, $77f30cc17fbf24cf$export$4a529dfc67d1b47b)
            });
            return pmPlugins;
        },
        commands: {
            expandAndUpdateSelection: ({ startPos: startPos, selection: selection, isShiftPressed: isShiftPressed, nodeType: nodeType })=>({ tr: tr })=>{
                    (0, $2w4SV.expandAndUpdateSelection)({
                        tr: tr,
                        selection: selection,
                        startPos: startPos,
                        isShiftPressed: isShiftPressed,
                        nodeType: nodeType,
                        api: api
                    });
                    return tr;
                },
            moveNode: (0, $b3nYA.moveNode)(api),
            moveToLayout: (0, $fcbccc7790679e9d$export$6e686efeb3f3578c)(api),
            showDragHandleAt: (pos, anchorName, nodeType, handleOptions, rootPos, rootAnchorName, rootNodeType)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType,
                            handleOptions: handleOptions,
                            rootPos: rootPos,
                            rootAnchorName: rootAnchorName,
                            rootNodeType: rootNodeType
                        }
                    });
                    return tr;
                },
            toggleBlockMenu: (options)=>({ tr: tr })=>{
                    if (!(0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return tr;
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    const currentUserIntent = api?.userIntent?.sharedState.currentState()?.currentUserIntent;
                    const isMenuCurrentlyOpen = api?.blockControls?.sharedState.currentState()?.isMenuOpen;
                    if (options?.closeMenu) {
                        tr.setMeta((0, $3BXSc.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    // Do not open menu on layoutColumn and close opened menu when layoutColumn drag handle is clicked
                    if (options?.anchorName?.includes('layoutColumn')) {
                        if (currentUserIntent === 'blockMenuOpen') api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        tr.setMeta((0, $3BXSc.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        return tr;
                    }
                    let toggleMenuMeta = {
                        anchorName: options?.anchorName,
                        triggerByNode: options?.triggerByNode
                    };
                    const menuTriggerBy = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
                    if (options?.anchorName) {
                        const { moveUp: moveUp, moveDown: moveDown } = (0, $9aKak.canMoveNodeUpOrDown)(tr);
                        toggleMenuMeta = {
                            ...toggleMenuMeta,
                            moveUp: moveUp,
                            moveDown: moveDown,
                            openedViaKeyboard: options?.openedViaKeyboard
                        };
                    }
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        toggleMenu: toggleMenuMeta
                    });
                    if ((menuTriggerBy === undefined || !!menuTriggerBy && menuTriggerBy === options?.anchorName) && currentUserIntent === 'blockMenuOpen') {
                        const state = api?.blockControls.sharedState.currentState();
                        if (state?.isSelectedViaDragHandle) api?.userIntent?.commands.setCurrentUserIntent('dragHandleSelected')({
                            tr: tr
                        });
                        else // Toggled from drag handle
                        api?.userIntent?.commands.setCurrentUserIntent('default')({
                            tr: tr
                        });
                        // When closing the menu, restart the active session timer
                        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                    } else if (!isMenuCurrentlyOpen) // When opening the menu, pause the active session timer
                    {
                        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                            shouldStartTimer: false,
                            shouldPersistActiveSession: true
                        })({
                            tr: tr
                        });
                    }
                    return tr;
                },
            setNodeDragged: (getPos, anchorName, nodeType)=>({ tr: tr })=>{
                    const pos = getPos();
                    if (pos === undefined) return tr;
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        isDragging: true,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType
                        }
                    });
                    if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    })({
                        tr: tr
                    });
                    api?.userIntent?.commands.setCurrentUserIntent('dragging')({
                        tr: tr
                    });
                    return tr;
                },
            setMultiSelectPositions: (anchor, head)=>({ tr: tr })=>{
                    const { anchor: userAnchor, head: userHead } = tr.selection;
                    let $expandedAnchor, $expandedHead;
                    if (anchor !== undefined && head !== undefined) {
                        $expandedAnchor = tr.doc.resolve(anchor);
                        $expandedHead = tr.doc.resolve(head);
                    } else {
                        const expandedSelection = (0, $iQ6F7.expandSelectionBounds)(tr.selection.$anchor, tr.selection.$head);
                        $expandedAnchor = expandedSelection.$anchor;
                        $expandedHead = expandedSelection.$head;
                    }
                    api?.selection?.commands.setManualSelection($expandedAnchor.pos, $expandedHead.pos)({
                        tr: tr
                    });
                    const $from = $expandedAnchor.min($expandedHead);
                    const $to = $expandedAnchor.max($expandedHead);
                    let expandedNormalisedSel;
                    if ($from.nodeAfter === $to.nodeBefore) {
                        (0, $bOZni.selectNode)(tr, $from.pos, $expandedAnchor.node().type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if ($to.nodeBefore?.type.name === 'mediaSingle' || $from.nodeAfter?.type.name === 'mediaSingle') {
                        expandedNormalisedSel = new (0, $kCECX.TextSelection)($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    } else {
                        // this is to normalise the selection's boundaries to inline positions, preventing it from collapsing
                        expandedNormalisedSel = (0, $kCECX.TextSelection).between($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    }
                    const multiSelectDnD = {
                        anchor: $expandedAnchor.pos,
                        head: $expandedHead.pos,
                        textAnchor: expandedNormalisedSel.anchor,
                        textHead: expandedNormalisedSel.head,
                        userAnchor: userAnchor,
                        userHead: userHead
                    };
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        multiSelectDnD: multiSelectDnD
                    });
                    return tr;
                },
            setSelectedViaDragHandle: (isSelectedViaDragHandle)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $3BXSc.key));
                    return tr.setMeta((0, $3BXSc.key), {
                        ...currMeta,
                        isSelectedViaDragHandle: isSelectedViaDragHandle
                    });
                },
            mapPreservedSelection: (mapping)=>(0, $ae3c630ae8088563$export$e21678cf246ba963)(mapping),
            moveNodeWithBlockMenu: (direction)=>(0, $56dbb4d04b905509$export$86c511a177340b22)(api, direction),
            handleKeyDownWithPreservedSelection: (0, $a155f8ac3d617cef$export$f38920f5272efc06)(api),
            startPreservingSelection: ()=>(0, $bb8f0178a1bbd465$export$4c9c90f81bda40ce),
            stopPreservingSelection: ()=>(0, $bb8f0178a1bbd465$export$7ee148889ab74bda)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const sharedState = {
                isMenuOpen: (0, $3BXSc.key).getState(editorState)?.isMenuOpen ?? false,
                menuTriggerBy: (0, $3BXSc.key).getState(editorState)?.menuTriggerBy ?? undefined,
                menuTriggerByNode: (0, $3BXSc.key).getState(editorState)?.menuTriggerByNode ?? undefined,
                blockMenuOptions: (0, $3BXSc.key).getState(editorState)?.blockMenuOptions ?? undefined,
                activeNode: (0, $3BXSc.key).getState(editorState)?.activeNode ?? undefined,
                activeDropTargetNode: (0, $3BXSc.key).getState(editorState)?.activeDropTargetNode ?? undefined,
                isDragging: (0, $3BXSc.key).getState(editorState)?.isDragging ?? false,
                isPMDragging: (0, $3BXSc.key).getState(editorState)?.isPMDragging ?? false,
                multiSelectDnD: (0, $3BXSc.key).getState(editorState)?.multiSelectDnD ?? undefined,
                isShiftDown: (0, $3BXSc.key).getState(editorState)?.isShiftDown ?? undefined,
                lastDragCancelled: (0, $3BXSc.key).getState(editorState)?.lastDragCancelled ?? false,
                isEditing: (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.isEditing,
                isSelectedViaDragHandle: (0, $3BXSc.key).getState(editorState)?.isSelectedViaDragHandle ?? false
            };
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                sharedState.isMouseOut = (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.isMouseOut ?? false;
                // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
                sharedState.rightSideControlsEnabled = rightSideControlsEnabled;
                sharedState.hoverSide = rightSideControlsEnabled ? (0, $78a32da2f9d512bf$export$d14f503a2a677768).getState(editorState)?.hoverSide : undefined;
            }
            if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) sharedState.preservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(editorState)?.preservedSelection;
            return sharedState;
        },
        contentComponent () {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d0abd7f97ed1440$export$cc5403d58ddfa812), {
                api: api
            });
        }
    };
};
module.exports["blockControlsPlugin"] = $ba9a19c78f543467$export$7a291905586a23d3;

});

parcelRegister("fKt2m", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");

const $1f3d35a5748f6f52$export$ea34df48337a3b78 = 'data-node-anchor';
const $1f3d35a5748f6f52$export$195bd9e1fd438938 = 'data-prosemirror-node-name';
const $1f3d35a5748f6f52$export$684dbfb461b166c3 = ()=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return $1f3d35a5748f6f52$export$ea34df48337a3b78;
    return 'data-drag-handler-anchor-name';
};
const $1f3d35a5748f6f52$export$916bc5085eed228a = ()=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return $1f3d35a5748f6f52$export$195bd9e1fd438938;
    return 'data-drag-handler-node-type';
};
const $1f3d35a5748f6f52$var$isHeadingElement = (element)=>{
    const headingTags = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    return headingTags.includes(element.tagName);
};
const $1f3d35a5748f6f52$export$374251d21964e516 = (element)=>{
    if (!element) return '';
    const nodeType = element?.getAttribute($1f3d35a5748f6f52$export$195bd9e1fd438938);
    if (!nodeType) return '';
    if ($1f3d35a5748f6f52$var$isHeadingElement(element)) switch(element.tagName){
        case 'H1':
            return 'heading-1';
        case 'H2':
            return 'heading-2';
        case 'H3':
            return 'heading-3';
        case 'H4':
            return 'heading-4';
        case 'H5':
            return 'heading-5';
        case 'H6':
            return 'heading-6';
    }
    return nodeType;
};
module.exports["NODE_ANCHOR_ATTR_NAME"] = $1f3d35a5748f6f52$export$ea34df48337a3b78;
module.exports["NODE_NODE_TYPE_ATTR_NAME"] = $1f3d35a5748f6f52$export$195bd9e1fd438938;
module.exports["getAnchorAttrName"] = $1f3d35a5748f6f52$export$684dbfb461b166c3;
module.exports["getTypeNameAttrName"] = $1f3d35a5748f6f52$export$916bc5085eed228a;
module.exports["getTypeNameFromDom"] = $1f3d35a5748f6f52$export$374251d21964e516;

});

parcelRegister("hTjcC", function(module, exports) {

var $kAPZe = parcelRequire("kAPZe");


var $hy0gD = parcelRequire("hy0gD");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ixfCV = parcelRequire("ixfCV");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");

const $5c444c693a8a0d14$export$3c415fc37e843546 = 'data-active-drag-handle';
const $5c444c693a8a0d14$export$e9f85d19bcc65a35 = 'data-active-quick-insert';
const $5c444c693a8a0d14$export$f373eda827748b3 = 24;
const $5c444c693a8a0d14$export$aa77a5cc2a5f88a7 = 4;
const $5c444c693a8a0d14$export$5ad27d778a09d25c = (0, $7Y8M5.akRichMediaResizeZIndex) + (0, $7Y8M5.akEditorUnitZIndex); //place above legacy resizer
const $5c444c693a8a0d14$export$2cbe83499bf11891 = 8;
const $5c444c693a8a0d14$export$afbc9d6595284dfa = 4;
const $5c444c693a8a0d14$export$28e15aedc0c878e3 = 12;
const $5c444c693a8a0d14$export$e4842b8390e65360 = 2.5;
const $5c444c693a8a0d14$export$f0af6742db040d57 = (0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$28e15aedc0c878e3;
const $5c444c693a8a0d14$export$d2a2373f7346fed2 = 6; // 4px for the divider vertical padding and 2px for the divider height
const $5c444c693a8a0d14$export$d5bafa9c4e821a51 = 5;
const $5c444c693a8a0d14$export$1e2b3336ca8c087c = 2;
const $5c444c693a8a0d14$export$f8ee0d00a7415eee = 1;
const $5c444c693a8a0d14$export$7ca48bd6d02a13e0 = 3;
const $5c444c693a8a0d14$export$40d0d70c288e6373 = 3;
const $5c444c693a8a0d14$export$51dbe10140b62321 = 3;
const $5c444c693a8a0d14$export$45051ba26713425e = 8;
const $5c444c693a8a0d14$export$2d43c475787cc3b2 = 2;
const $5c444c693a8a0d14$export$bd30577e4ba2fc75 = 0;
const $5c444c693a8a0d14$export$47dad309b5731d64 = 8;
const $5c444c693a8a0d14$export$c8181a575a7964ef = 3;
const $5c444c693a8a0d14$export$acab25f15fd410d6 = 8;
const $5c444c693a8a0d14$export$355f64931df48ac6 = 24;
const $5c444c693a8a0d14$export$b2fc508ca59eba40 = 24;
const $5c444c693a8a0d14$export$c5ab994ee6fdf098 = 24;
const $5c444c693a8a0d14$export$8b6a8ea78955a3a3 = {
    width: $5c444c693a8a0d14$export$c5ab994ee6fdf098,
    height: $5c444c693a8a0d14$export$b2fc508ca59eba40
};
const $5c444c693a8a0d14$export$37704ab652bb303e = 16;
const $5c444c693a8a0d14$var$nodeTypeExcludeList = [
    'embedCard',
    'mediaSingle',
    'table'
];
const $5c444c693a8a0d14$var$breakoutResizableNodes = [
    'expand',
    'layoutSection',
    'codeBlock'
];
const $5c444c693a8a0d14$export$e5ea166c620fdfb2 = (nodeType, parentNodeType)=>{
    if (parentNodeType === 'syncBlock' || parentNodeType === 'bodiedSyncBlock') return $5c444c693a8a0d14$export$e4842b8390e65360;
    if (parentNodeType && parentNodeType !== 'doc') return $5c444c693a8a0d14$export$afbc9d6595284dfa;
    const breakoutResizableNodesList = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes) : (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...$5c444c693a8a0d14$var$breakoutResizableNodes,
        'rule',
        'panel'
    ] : $5c444c693a8a0d14$var$breakoutResizableNodes;
    if ((0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 20;
        else return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$2cbe83499bf11891 + 20;
    if ($5c444c693a8a0d14$var$nodeTypeExcludeList.includes(nodeType)) return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    return $5c444c693a8a0d14$export$2cbe83499bf11891;
};
const $5c444c693a8a0d14$export$5002400b4eb1f7c6 = (nodeType)=>{
    const breakoutResizableNodesList = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes) : (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...$5c444c693a8a0d14$var$breakoutResizableNodes,
        'rule',
        'panel'
    ] : $5c444c693a8a0d14$var$breakoutResizableNodes;
    if ($5c444c693a8a0d14$var$nodeTypeExcludeList.includes(nodeType) || (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) && breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 20;
        else return $5c444c693a8a0d14$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $5c444c693a8a0d14$export$28e15aedc0c878e3 + 12;
    return $5c444c693a8a0d14$export$2cbe83499bf11891;
};
const $5c444c693a8a0d14$export$5721e547e9b6cc17 = (nodeType)=>{
    switch(nodeType){
        case 'bodiedExtension':
            return '28px';
        case 'multiBodiedExtension':
            if ((0, $ixfCV.fg)('confluence_frontend_native_tabs_extension')) return '28px';
            return `${(0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$afbc9d6595284dfa}px`;
        case 'expand':
        case 'nestedExpand':
            return '24px';
        case 'layoutColumn':
            return '20px';
        case 'panel':
            return '40px';
        case 'tableCell':
            return '8px';
        case 'tableHeader':
            return '8px';
        default:
            return `${(0, $kAPZe.DRAG_HANDLE_WIDTH) + $5c444c693a8a0d14$export$afbc9d6595284dfa}px`;
    }
};
const $5c444c693a8a0d14$export$403b33ae238c7c59 = (nodeType, layout)=>{
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) switch(nodeType){
        case 'layoutSection':
            return $5c444c693a8a0d14$export$45051ba26713425e;
    }
    if ((nodeType === 'mediaSingle' || nodeType === 'embedCard') && layout && [
        'wrap-left',
        'wrap-right'
    ].includes(layout)) return $5c444c693a8a0d14$export$47dad309b5731d64;
    switch(nodeType){
        case 'rule':
            return -$5c444c693a8a0d14$export$d2a2373f7346fed2;
        case 'table':
            return $5c444c693a8a0d14$export$f373eda827748b3;
        case 'paragraph':
            return $5c444c693a8a0d14$export$2d43c475787cc3b2;
        case 'paragraph-small':
            return $5c444c693a8a0d14$export$bd30577e4ba2fc75;
        case 'heading-1':
            return $5c444c693a8a0d14$export$d5bafa9c4e821a51;
        case 'heading-2':
            return $5c444c693a8a0d14$export$1e2b3336ca8c087c;
        case 'heading-3':
            return -$5c444c693a8a0d14$export$f8ee0d00a7415eee;
        case 'heading-4':
            return -$5c444c693a8a0d14$export$7ca48bd6d02a13e0;
        case 'heading-5':
            return -$5c444c693a8a0d14$export$40d0d70c288e6373;
        case 'heading-6':
            return -$5c444c693a8a0d14$export$51dbe10140b62321;
        default:
            return 0;
    }
};
const $5c444c693a8a0d14$export$6475396024cc89ff = {
    [-24]: "var(--ds-space-negative-300, -24px)",
    [-20]: "var(--ds-space-negative-250, -20px)",
    [-16]: "var(--ds-space-negative-200, -16px)",
    [-12]: "var(--ds-space-negative-150, -12px)",
    [-8]: "var(--ds-space-negative-100, -8px)",
    [-6]: "var(--ds-space-negative-075, -6px)",
    [-4]: "var(--ds-space-negative-050, -4px)",
    [-2]: "var(--ds-space-negative-025, -2px)",
    0: "var(--ds-space-0, 0px)",
    2: "var(--ds-space-025, 2px)",
    4: "var(--ds-space-050, 4px)",
    6: "var(--ds-space-075, 6px)",
    8: "var(--ds-space-100, 8px)",
    12: "var(--ds-space-150, 12px)",
    16: "var(--ds-space-200, 16px)",
    20: "var(--ds-space-250, 20px)",
    24: "var(--ds-space-300, 24px)"
};
const $5c444c693a8a0d14$export$c4b2eae94cb9784e = Object.fromEntries(// 49 = -24 -> 0 -> 24 totaling 49 entries.
Array.from({
    length: 49
}, (_, index)=>{
    const currKeyValue = index - 24;
    const keyValues = Object.keys($5c444c693a8a0d14$export$6475396024cc89ff).map(Number);
    const value = keyValues.reduce((acc, curr)=>{
        return Math.abs(currKeyValue - curr) < Math.abs(currKeyValue - acc) ? curr : acc;
    }, 1000);
    return [
        currKeyValue,
        $5c444c693a8a0d14$export$6475396024cc89ff[value]
    ];
}));
const $5c444c693a8a0d14$export$67c6a77242c01faa = {
    paragraph: {
        top: '0.75rem',
        bottom: '0'
    },
    heading1: {
        top: '1.45833em',
        bottom: '0'
    },
    heading2: {
        top: '1.4em',
        bottom: '0'
    },
    heading3: {
        top: '1.31249em',
        bottom: '0'
    },
    heading4: {
        top: '1.25em',
        bottom: '0'
    },
    heading5: {
        top: '1.45833em',
        bottom: '0'
    },
    heading6: {
        top: '1.59091em',
        bottom: '0'
    },
    table: {
        top: '0',
        bottom: '0'
    },
    bulletList: {
        top: '10px',
        bottom: '0'
    },
    orderedList: {
        top: '10px',
        bottom: '0'
    },
    decisionList: {
        top: '0.5rem',
        bottom: '0'
    },
    taskList: {
        top: '0.75rem',
        bottom: '0'
    },
    codeBlock: {
        top: '0.75rem',
        bottom: '0'
    },
    panel: {
        top: '0.75rem',
        bottom: '0'
    },
    rule: {
        top: '1.5rem',
        bottom: '1.5rem'
    },
    mediaSingle: {
        top: '24px',
        bottom: '24px'
    },
    media: {
        top: '24px',
        bottom: '24px'
    },
    bodiedExtension: {
        top: '0',
        bottom: '0'
    },
    multiBodiedExtension: {
        top: '0',
        bottom: '0'
    },
    extension: {
        top: '0',
        bottom: '0'
    },
    layoutSection: {
        top: '0',
        bottom: '0'
    },
    blockquote: {
        top: '0',
        bottom: '0'
    },
    embedCard: {
        top: '24px',
        bottom: '24px'
    },
    blockCard: {
        top: '0.75rem',
        bottom: '0'
    },
    default: {
        top: '0',
        bottom: '0'
    }
};
const $5c444c693a8a0d14$export$ffe7e67ee4ab1502 = {
    table: {
        top: 24,
        bottom: 16
    },
    paragraph: {
        top: 12,
        bottom: 6
    },
    bulletList: {
        top: 16,
        bottom: 0
    },
    orderedList: {
        top: 16,
        bottom: 0
    },
    decisionList: {
        top: 12,
        bottom: 0
    },
    taskList: {
        top: 8,
        bottom: 0
    },
    codeBlock: {
        top: 12,
        bottom: 0
    },
    panel: {
        top: 8,
        bottom: 0
    },
    rule: {
        top: 24,
        bottom: 24
    },
    mediaSingle: {
        top: 24,
        bottom: 24
    },
    media: {
        top: 24,
        bottom: 24
    },
    bodiedExtension: {
        top: 0,
        bottom: 0
    },
    multiBodiedExtension: {
        top: 0,
        bottom: 0
    },
    extension: {
        top: 12,
        bottom: 12
    },
    heading1: {
        top: 40,
        bottom: 0
    },
    heading2: {
        top: 40,
        bottom: 0
    },
    heading3: {
        top: 36,
        bottom: 0
    },
    heading4: {
        top: 22,
        bottom: 0
    },
    heading5: {
        top: 22,
        bottom: 0
    },
    heading6: {
        top: 18,
        bottom: 0
    },
    layoutSection: {
        top: 8,
        bottom: 0
    },
    blockquote: {
        top: 12,
        bottom: 0
    },
    expand: {
        top: 4,
        bottom: 0
    },
    nestedExpand: {
        top: 1,
        bottom: 0
    },
    default: {
        top: 0,
        bottom: 0
    }
};
const $5c444c693a8a0d14$export$d77e6458bbcae98b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};
module.exports["ACTIVE_DRAG_HANDLE_ATTR"] = $5c444c693a8a0d14$export$3c415fc37e843546;
module.exports["ACTIVE_QUICK_INSERT_ATTR"] = $5c444c693a8a0d14$export$e9f85d19bcc65a35;
module.exports["DRAG_HANDLE_HEIGHT"] = $5c444c693a8a0d14$export$f373eda827748b3;
module.exports["DRAG_HANDLE_BORDER_RADIUS"] = $5c444c693a8a0d14$export$aa77a5cc2a5f88a7;
module.exports["DRAG_HANDLE_ZINDEX"] = $5c444c693a8a0d14$export$5ad27d778a09d25c;
module.exports["DRAG_HANDLE_MAX_WIDTH_PLUS_GAP"] = $5c444c693a8a0d14$export$f0af6742db040d57;
module.exports["DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$d2a2373f7346fed2;
module.exports["DRAG_HANDLE_H1_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$d5bafa9c4e821a51;
module.exports["DRAG_HANDLE_H2_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$1e2b3336ca8c087c;
module.exports["DRAG_HANDLE_H4_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$7ca48bd6d02a13e0;
module.exports["DRAG_HANDLE_H5_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$40d0d70c288e6373;
module.exports["DRAG_HANDLE_H6_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$51dbe10140b62321;
module.exports["DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$2d43c475787cc3b2;
module.exports["DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT"] = $5c444c693a8a0d14$export$bd30577e4ba2fc75;
module.exports["DRAG_HANDLE_MAX_SHIFT_CLICK_DEPTH"] = $5c444c693a8a0d14$export$c8181a575a7964ef;
module.exports["STICKY_CONTROLS_TOP_MARGIN"] = $5c444c693a8a0d14$export$acab25f15fd410d6;
module.exports["STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER"] = $5c444c693a8a0d14$export$355f64931df48ac6;
module.exports["QUICK_INSERT_HEIGHT"] = $5c444c693a8a0d14$export$b2fc508ca59eba40;
module.exports["QUICK_INSERT_WIDTH"] = $5c444c693a8a0d14$export$c5ab994ee6fdf098;
module.exports["QUICK_INSERT_DIMENSIONS"] = $5c444c693a8a0d14$export$8b6a8ea78955a3a3;
module.exports["QUICK_INSERT_LEFT_OFFSET"] = $5c444c693a8a0d14$export$37704ab652bb303e;
module.exports["dragHandleGap"] = $5c444c693a8a0d14$export$e5ea166c620fdfb2;
module.exports["rootElementGap"] = $5c444c693a8a0d14$export$5002400b4eb1f7c6;
module.exports["getNestedNodeLeftPaddingMargin"] = $5c444c693a8a0d14$export$5721e547e9b6cc17;
module.exports["topPositionAdjustment"] = $5c444c693a8a0d14$export$403b33ae238c7c59;
module.exports["spacingBetweenNodesForPreview"] = $5c444c693a8a0d14$export$67c6a77242c01faa;
module.exports["nodeMargins"] = $5c444c693a8a0d14$export$ffe7e67ee4ab1502;
module.exports["DEFAULT_COLUMN_DISTRIBUTIONS"] = $5c444c693a8a0d14$export$d77e6458bbcae98b;

});

parcelRegister("jWiWP", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $kAPZe = parcelRequire("kAPZe");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $hTjcC = parcelRequire("hTjcC");

const $6fa4b82a3edab148$var$STICKY_NODES = [
    'panel',
    'table',
    'expand',
    'layoutSection',
    'bodiedExtension'
];
const $6fa4b82a3edab148$export$3c9c03fbeb71a88 = (dom, type)=>{
    if (!dom) return 'auto';
    const table = dom.querySelector('table');
    const isTable = table && (!type || type === 'table');
    if (isTable) return `${dom.offsetTop + (table?.offsetTop || 0)}px`;
    else if (type === 'rule') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT)}px`;
    else if (type === 'layoutColumn') return `${-dom.offsetTop / 2}px`;
    else if (type === 'heading-1') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_H1_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-2') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_H2_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-3') return `${dom.offsetTop}px`;
    else if (type === 'heading-4') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H4_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-5') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H5_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-6') return `${dom.offsetTop - (0, $hTjcC.DRAG_HANDLE_H6_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph-small') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph') return `${dom.offsetTop + (0, $hTjcC.DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT)}px`;
    else return `${dom.offsetTop}px`;
};
const $6fa4b82a3edab148$export$c3d34436f1edd9bd = (dom, type, innerContainer, macroInteractionUpdates, parentType)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return type === 'layoutColumn' ? `${dom.offsetLeft + dom.clientWidth / 2 - (0, $hTjcC.DRAG_HANDLE_HEIGHT) / 2}px` : `${dom.offsetLeft - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $hTjcC.dragHandleGap)(type, parentType) - (0, $kAPZe.DRAG_HANDLE_WIDTH)}px`;
};
const $6fa4b82a3edab148$export$d106346a0f891cc2 = (dom, anchor, anchorRectCache)=>anchorRectCache?.getHeight(anchor) || dom?.offsetHeight;
const $6fa4b82a3edab148$var$getStickyNodes = (0, $dOBRD.default)(()=>[
        ...$6fa4b82a3edab148$var$STICKY_NODES,
        ...(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? [
            'multiBodiedExtension'
        ] : []
    ]);
const $6fa4b82a3edab148$export$f988e74eefbc47fc = (nodeType)=>{
    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && $6fa4b82a3edab148$var$getStickyNodes().includes(nodeType);
};
const $6fa4b82a3edab148$export$cc6777b6e60d5179 = (anchor, isSticky, isTopLevelNode, isLayoutColumn)=>{
    return (0, $fqVYq.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: `anchor(${anchor} end)`
    };
};
const $6fa4b82a3edab148$export$738fa80805cb522c = (nodeHeight, isSticky, isTopLevelNode, fallbackPxHeight, isLayoutColumn)=>{
    return (0, $fqVYq.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        height: 'unset'
    } : {
        height: `${nodeHeight || fallbackPxHeight}px`
    };
};
const $6fa4b82a3edab148$export$9a1c84c70b9df34 = (nodeType, isTopLevelNode)=>{
    return(// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    isTopLevelNode && [
        'table'
    ].includes(nodeType) && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1'));
};
module.exports["getTopPosition"] = $6fa4b82a3edab148$export$3c9c03fbeb71a88;
module.exports["getLeftPosition"] = $6fa4b82a3edab148$export$c3d34436f1edd9bd;
module.exports["getNodeHeight"] = $6fa4b82a3edab148$export$d106346a0f891cc2;
module.exports["shouldBeSticky"] = $6fa4b82a3edab148$export$f988e74eefbc47fc;
module.exports["getControlBottomCSSValue"] = $6fa4b82a3edab148$export$cc6777b6e60d5179;
module.exports["getControlHeightCSSValue"] = $6fa4b82a3edab148$export$738fa80805cb522c;
module.exports["shouldMaskNodeControls"] = $6fa4b82a3edab148$export$9a1c84c70b9df34;

});

parcelRegister("j8XGH", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $WABbQ = parcelRequire("WABbQ");

const $2c494448cfdcad64$export$f4b94aaa3c88263b = (doc, start)=>{
    const node = doc.nodeAt(start);
    if (!node) return false;
    if (node.type.name === 'mediaGroup' && node.childCount === 1) return new (0, $kCECX.NodeSelection)(doc.resolve(start + 1));
    return new (0, $kCECX.NodeSelection)(doc.resolve(start));
};
const $2c494448cfdcad64$export$301ee8a09bc7f6dc = (tr, tableNodePos)=>{
    (0, $WABbQ.selectTableClosestToPos)(tr, tr.doc.resolve(tableNodePos + 1));
    return tr;
};
const $2c494448cfdcad64$export$a35518af0efc77c7 = (tr, nodePos, nodeType)=>{
    if (nodeType === 'table') return $2c494448cfdcad64$export$301ee8a09bc7f6dc(tr, nodePos);
    const selection = $2c494448cfdcad64$export$f4b94aaa3c88263b(tr.doc, nodePos);
    if (selection) tr.setSelection(selection);
    return tr;
};
module.exports["getNodeSelectionForPos"] = $2c494448cfdcad64$export$f4b94aaa3c88263b;
module.exports["selectNodeAtPos"] = $2c494448cfdcad64$export$a35518af0efc77c7;

});

parcelRegister("bdkuW", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $rOV4B = parcelRequire("rOV4B");


var $3BXSc = parcelRequire("3BXSc");

const $36371d5e159b0ca8$export$79a8e1d39d3c2449 = ({ getPos: getPos, view: view, anchorName: anchorName })=>{
    let newAnchorName = anchorName || '';
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return newAnchorName;
    const pos = getPos();
    if (anchorName || pos === undefined) return newAnchorName;
    const node = view.state.doc.nodeAt(pos);
    const state = (0, $3BXSc.key).getState(view.state);
    if (state?.decorations) {
        const nodeDecs = (0, $rOV4B.findNodeDecs)(view.state, state.decorations, pos, pos + (node?.nodeSize ?? 0));
        const nodeDec = nodeDecs.at(0);
        if (!nodeDec) return newAnchorName;
        newAnchorName = nodeDec.spec.anchorName;
    }
    return newAnchorName;
};
module.exports["refreshAnchorName"] = $36371d5e159b0ca8$export$79a8e1d39d3c2449;

});

parcelRegister("lhJQI", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $7Y8M5 = parcelRequire("7Y8M5");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");

function $cd656ac427b6f5fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd656ac427b6f5fb$var$RIGHT_CONTROL_HIDE_DELAY_MS = 150;
const $cd656ac427b6f5fb$var$baseStyles = (0, $buxP3.xcss)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out'
});
const $cd656ac427b6f5fb$var$visibleStyles = (0, $buxP3.xcss)({
    opacity: 1,
    visibility: 'visible'
});
const $cd656ac427b6f5fb$var$hiddenStyles = (0, $buxP3.xcss)({
    opacity: 0,
    visibility: 'hidden'
});
const $cd656ac427b6f5fb$var$baseStylesCSS = /*#__PURE__*/ (0, $lOiVq.css)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $cd656ac427b6f5fb$var$visibleStylesCSS = {
    name: "nk3zlf",
    styles: "opacity:1;visibility:visible"
};
const $cd656ac427b6f5fb$var$hiddenStylesCSS = {
    name: "8792bh",
    styles: "opacity:0;visibility:hidden"
};
const $cd656ac427b6f5fb$export$e7448669708130cc = ({ api: api, children: children, controlSide: controlSide, forceVisibleOnMouseOut: forceVisibleOnMouseOut })=>{
    const { isTypeAheadOpen: isTypeAheadOpen, isEditing: isEditing, isMouseOut: isMouseOut, hoverSide: hoverSide, editorViewMode: editorViewMode, userIntent: userIntent, rightSideControlsEnabled: rightSideControlsEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'typeAhead',
        'blockControls',
        'editorViewMode',
        'userIntent'
    ], (states)=>({
            isTypeAheadOpen: states.typeAheadState?.isOpen,
            isEditing: states.blockControlsState?.isEditing,
            isMouseOut: states.blockControlsState?.isMouseOut,
            hoverSide: states.blockControlsState?.hoverSide,
            editorViewMode: states.editorViewModeState?.mode,
            userIntent: states.userIntentState?.currentUserIntent,
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled
        }));
    const isViewMode = editorViewMode === 'view';
    // rightSideControlsEnabled is the single source of truth (confluence_remix_button_right_side_block_fg from preset)
    // Both controls are restricted by side: the drag handle shows on the left half, the Remix button on
    // the right half (and the right margin), matching the midpoint split in handle-mouse-move.
    const shouldRestrictBySide = rightSideControlsEnabled && controlSide !== undefined && !isViewMode;
    // Only restrict by side when hoverSide is known (after mousemove). When undefined, show both
    // controls so drag handle is visible on load and for keyboard-only users.
    const sideHidden = shouldRestrictBySide && hoverSide !== undefined ? hoverSide !== controlSide : false;
    // In view mode with right-side controls, we delay hiding on isMouseOut (see below) so the right-edge
    // button stays visible when the user moves from the block toward the button (e.g. in edit/live
    // pages), avoiding flicker as the mouse crosses boundaries.
    const hideOnMouseOut = isMouseOut;
    // When forceVisibleOnMouseOut is true (e.g. drag handle focused via keyboard Shift+Ctrl+H),
    // override the mouse-out condition so the control stays visible regardless of mouse position.
    const shouldHideWhenMouseOut = forceVisibleOnMouseOut ? false : hideOnMouseOut;
    const shouldHideImmediate = isTypeAheadOpen || isEditing || shouldHideWhenMouseOut || userIntent === 'aiStreaming' || userIntent === 'viewingDiff' && (0, $ieeJu.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || sideHidden;
    // Delay hiding the right control in view mode to reduce flickering when moving from block
    // toward the right-edge button (avoids rapid show/hide as mouse crosses boundaries).
    const isRightControlViewMode = isViewMode && rightSideControlsEnabled && controlSide === 'right';
    // When in right-control view mode, we delay hiding so start visible; useEffect will update after delay
    const [delayedShouldHide, setDelayedShouldHide] = (0, $cozmU.useState)(false);
    const hideTimeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isRightControlViewMode) return;
        if (!shouldHideImmediate) {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            setDelayedShouldHide(false);
            return;
        }
        hideTimeoutRef.current = setTimeout(()=>{
            hideTimeoutRef.current = null;
            setDelayedShouldHide(true);
        }, $cd656ac427b6f5fb$var$RIGHT_CONTROL_HIDE_DELAY_MS);
        return ()=>{
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        };
    }, [
        shouldHideImmediate,
        isRightControlViewMode
    ]);
    const shouldHide = isRightControlViewMode ? delayedShouldHide : shouldHideImmediate;
    if ((0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $cd656ac427b6f5fb$var$baseStylesCSS,
            shouldHide ? $cd656ac427b6f5fb$var$hiddenStylesCSS : $cd656ac427b6f5fb$var$visibleStylesCSS
        ]
    }, children);
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: [
            $cd656ac427b6f5fb$var$baseStyles,
            shouldHide ? $cd656ac427b6f5fb$var$hiddenStyles : $cd656ac427b6f5fb$var$visibleStyles
        ]
    }, children);
};
module.exports["VisibilityContainer"] = $cd656ac427b6f5fb$export$e7448669708130cc;

});

parcelRegister("69FTU", function(module, exports) {

var $hTjcC = parcelRequire("hTjcC");

const $15abd54de8dd8e0e$export$78de92b32db40bc4 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return `${dom.offsetLeft - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $hTjcC.rootElementGap)(nodeType) - widgetDimensions.width}px`;
};
const $15abd54de8dd8e0e$export$6efb694a25295ec1 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    const gap = (0, $hTjcC.rootElementGap)(nodeType);
    const width = widgetDimensions.width;
    if (!innerContainer) return `${dom.offsetLeft + leftAdjustment + dom.offsetWidth - gap - width}px`;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth - gap - width}px` : `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth / 2 - gap - width}px`;
};
module.exports["getLeftPositionForRootElement"] = $15abd54de8dd8e0e$export$78de92b32db40bc4;
module.exports["getRightPositionForRootElement"] = $15abd54de8dd8e0e$export$6efb694a25295ec1;

});

parcelRegister("9ki8I", function(module, exports) {

var $dWeA1 = parcelRequire("dWeA1");

const $e0d48c9969d27ff1$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $dWeA1.border)
                }
            ];
        }
    });
module.exports["borderPlugin"] = $e0d48c9969d27ff1$export$39349c329288443f;

});

parcelRegister("fLS6B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $acWDI = parcelRequire("acWDI");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $lMCDO = parcelRequire("lMCDO");


var $1KOhB = parcelRequire("1KOhB");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $kCECX = parcelRequire("kCECX");

const $b9859c35f29c69d8$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('breakoutPlugin');
const $b9859c35f29c69d8$export$f05434c51e3762e = (state)=>$b9859c35f29c69d8$export$18d4026d1ea86bb1.getState(state) || undefined;






var $8aEKG = parcelRequire("8aEKG");

var $6MtNT = parcelRequire("6MtNT");


var $6SJ6d = parcelRequire("6SJ6d");











var $8dxef = parcelRequire("8dxef");

















var $6gBg9 = parcelRequire("6gBg9");





var $8QOo3 = parcelRequire("8QOo3");







const $a625bc7e8547ea8a$export$cc135306f1c4ff36 = ({ tr: tr, node: node, pos: pos, isLivePage: isLivePage })=>{
    if (isLivePage || (0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) {
        const wasExpandExpanded = (0, $8QOo3.expandedState).get(node);
        const newExpand = tr.doc.nodeAt(pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $8QOo3.expandedState).set(newExpand, wasExpandExpanded);
    }
};
const $a625bc7e8547ea8a$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true)) $a625bc7e8547ea8a$export$cc135306f1c4ff36({
        tr: tr,
        node: node.node,
        pos: node.pos,
        isLivePage: isLivePage
    });
    else if (isLivePage || (0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) {
        const wasExpandExpanded = (0, $8QOo3.expandedState).get(node.node);
        const newExpand = tr.doc.nodeAt(node.pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $8QOo3.expandedState).set(newExpand, wasExpandExpanded);
    }
};


function $370b3dd575cda351$export$2347aa63864fccd4(width, mode, pos, isLivePage) {
    return (state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
            state.schema.marks.breakout.create({
                width: width,
                mode: mode
            })
        ]);
        if (node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
            tr: tr,
            node: node,
            pos: pos,
            isLivePage: isLivePage
        });
        else if (node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(pos);
            const oldNode = node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        // keep current selection, necessary to not remove NodeSelection for keyboard resizing
        if (state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.eq(node)) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
        if (dispatch) dispatch(tr);
        return true;
    };
}


const $0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP = 10;
const $0f6d40dbf214f8ed$var$getAncestorResizableNode = (view, breakoutResizableNodes)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const selectedNode = selection.node;
        if (breakoutResizableNodes.has(selectedNode.type)) return {
            node: selectedNode,
            pos: selection.$from.pos
        };
    } else if (selection instanceof (0, $kCECX.TextSelection)) {
        let node = null;
        let nodePos = null;
        // only top level nodes are resizable
        const resolvedPos = view.state.doc.resolve(selection.$from.pos);
        const currentNode = resolvedPos.node(1);
        if (breakoutResizableNodes.has(currentNode.type)) {
            node = currentNode;
            nodePos = resolvedPos.before(1);
            return {
                node: node,
                pos: nodePos
            };
        }
    }
    return null;
};
const $0f6d40dbf214f8ed$export$bab59f27a7347e45 = (api)=>(view, event)=>{
        const browser = (0, $8dxef.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        if (metaKey && event.altKey && isBracketKey) {
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, rule: rule, panel: panel, panel_c1: panel_c1 } = view.state.schema.nodes;
            const breakoutResizableNodes = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? (0, $8aEKG.getBreakoutResizableNodeTypes)(view.state.schema, (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true)) : (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? new Set([
                expand,
                codeBlock,
                layoutSection,
                rule,
                panel,
                panel_c1
            ]) : new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            const result = $0f6d40dbf214f8ed$var$getAncestorResizableNode(view, breakoutResizableNodes);
            if (result) {
                const { node: node, pos: pos } = result;
                const breakoutMark = node?.marks.find((mark)=>mark.type.name === 'breakout');
                if (breakoutMark) {
                    const step = event.code === 'BracketRight' ? $0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP : -$0f6d40dbf214f8ed$var$KEYBOARD_RESIZE_STEP;
                    const newWidth = breakoutMark.attrs.width + step;
                    if (newWidth < (0, $7Y8M5.akEditorFullWidthLayoutWidth) && newWidth > (0, $7Y8M5.akEditorDefaultLayoutWidth)) {
                        const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
                        (0, $370b3dd575cda351$export$2347aa63864fccd4)(breakoutMark.attrs.width + step, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
                        view.focus();
                    }
                    return true;
                }
            }
        }
        return false;
    };






var $ixfCV = parcelRequire("ixfCV");








var $cbY7C = parcelRequire("cbY7C");


var $iwjSV = parcelRequire("iwjSV");


var $lFU5S = parcelRequire("lFU5S");


var $iSrRp = parcelRequire("iSrRp");


var $iN08H = parcelRequire("iN08H");


var $aLPNu = parcelRequire("aLPNu");





var $anBbz = parcelRequire("anBbz");


var $lpNn5 = parcelRequire("lpNn5");

const $5114ca5c92242368$var$getNodeName = (nodeName)=>{
    if (nodeName === 'layoutSection') return 'layout';
    else if (nodeName === 'codeBlock' || nodeName === 'expand') return nodeName;
    else if ((nodeName === 'rule' || nodeName === 'panel' || nodeName === 'panel_c1') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true)) return nodeName;
    else return 'node';
};
const $5114ca5c92242368$export$5c0a5eee165b9845 = {
    expand: (0, $lFU5S.messages).resizeExpand,
    codeBlock: (0, $lFU5S.messages).resizeCodeBlock,
    layout: (0, $lFU5S.messages).resizeLayout,
    rule: (0, $lFU5S.messages).resizeRule,
    panel: (0, $lFU5S.messages).resizePanel,
    panel_c1: (0, $lFU5S.messages).resizePanel,
    node: (0, $lFU5S.messages).resizeElement
};
const $5114ca5c92242368$var$RailWithTooltip = ({ rail: rail, target: target, intl: intl })=>{
    const [nodeName, setNodeName] = (0, $cozmU.useState)('node');
    (0, $cozmU.useLayoutEffect)(()=>{
        const node = target.querySelector('[data-prosemirror-node-name]');
        const name = $5114ca5c92242368$var$getNodeName(node?.dataset.prosemirrorNodeName);
        setNodeName(name);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($5114ca5c92242368$export$5c0a5eee165b9845[nodeName]),
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "pm-breakout-resize-handle-rail-inside-tooltip",
        ref: (el)=>{
            if (el && rail.parentNode !== el) el.appendChild(rail);
        }
    }));
};
const $5114ca5c92242368$export$2023dee10a108a1 = ({ target: target, onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
    let state = 'default';
    const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
    const createHandle = (side)=>{
        const handle = document.createElement('div');
        handle.contentEditable = 'false';
        handle.classList.add('pm-breakout-resize-handle-container');
        handle.style.gridColumn = side === 'left' ? '1' : '3';
        const rail = document.createElement('div');
        rail.classList.add('pm-breakout-resize-handle-rail');
        if (side === 'left') {
            handle.classList.add('pm-breakout-resize-handle-container--left');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-left');
        } else {
            handle.classList.add('pm-breakout-resize-handle-container--right');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-right');
        }
        const handleHitBox = document.createElement('div');
        handleHitBox.classList.add('pm-breakout-resize-handle-hit-box');
        const thumb = document.createElement('div');
        thumb.classList.add('pm-breakout-resize-handle-thumb');
        thumb.style.pointerEvents = 'none';
        rail.appendChild(thumb);
        const tooltipContainer = document.createElement('div');
        tooltipContainer.classList.add('pm-breakout-resize-handle-rail-wrapper');
        handle.appendChild(tooltipContainer);
        handle.appendChild(handleHitBox);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5114ca5c92242368$var$RailWithTooltip, {
                rail: rail,
                target: target,
                intl: intl
            }), tooltipContainer, key);
        return {
            handle: handle,
            rail: rail,
            handleHitBox: handleHitBox,
            destroyTooltip: ()=>nodeViewPortalProviderAPI.remove(key)
        };
    };
    const rightHandle = createHandle('right');
    // Remove const leftHandle during 'platform_editor_lovability_resize_dividers_panels' cleanup
    const leftHandle = isLeftResizeHandleDisabled ? undefined : createHandle('left');
    const registerHandle = (handleElement, handleSide)=>{
        return (0, $iSrRp.draggable)({
            element: handleElement,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $iN08H.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $aLPNu.preventUnhandled).start();
            },
            getInitialData: ()=>({
                    handleSide: handleSide
                }),
            onDragStart (args) {
                state = 'resizing';
                handleElement.classList.add('pm-breakout-resize-handle-container--active');
                onDragStart(args);
            },
            onDrag: onDrag,
            onDrop (args) {
                (0, $aLPNu.preventUnhandled).stop();
                state = 'default';
                handleElement.classList.remove('pm-breakout-resize-handle-container--active');
                onDrop(args);
            }
        });
    };
    const registerEvents = (element)=>{
        return [
            (0, $cbY7C.bind)(element, {
                type: 'mouseenter',
                listener: ()=>{
                    rightHandle.rail.style.setProperty('opacity', '1');
                    leftHandle?.rail.style.setProperty('opacity', '1');
                }
            }),
            (0, $cbY7C.bind)(element, {
                type: 'mouseleave',
                listener: ()=>{
                    if (state === 'resizing') return;
                    rightHandle.rail.style.removeProperty('opacity');
                    leftHandle?.rail.style.removeProperty('opacity');
                }
            })
        ];
    };
    const unbindFns = leftHandle ? // old code - left + right
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(leftHandle.handleHitBox),
        ...registerEvents(rightHandle.rail),
        ...registerEvents(leftHandle.rail)
    ] : // new code - right only
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(rightHandle.rail)
    ];
    const handleElement = 'rail';
    const destroyFns = leftHandle ? // old code - left + right
    [
        registerHandle(rightHandle[handleElement], 'right'),
        registerHandle(leftHandle[handleElement], 'left'),
        rightHandle.destroyTooltip,
        leftHandle.destroyTooltip
    ] : // new code - right only
    [
        registerHandle(rightHandle[handleElement], 'right'),
        rightHandle.destroyTooltip
    ];
    return {
        rightHandle: rightHandle.handle,
        leftHandle: leftHandle?.handle,
        destroy: (isChangeToViewMode)=>{
            destroyFns.forEach((destroyFn)=>destroyFn());
            unbindFns.forEach((unbindFn)=>unbindFn());
            if (isChangeToViewMode) {
                rightHandle.handle.parentElement?.removeChild(rightHandle.handle);
                leftHandle?.handle.parentElement?.removeChild(leftHandle.handle);
            }
        }
    };
};













var $dOBRD = parcelRequire("dOBRD");

const $5c8e412569aaa956$export$6065600df915db53 = 8;


var $cBSrP = parcelRequire("cBSrP");

var $2INqe = parcelRequire("2INqe");










const $b26ea474fd996270$var$WIDTHS = {
    MIN: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    WIDE: (0, $7Y8M5.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $7Y8M5.akEditorFullWidthLayoutWidth),
    MAX: (0, $7Y8M5.akEditorMaxLayoutWidth)
};
const $b26ea474fd996270$export$dd27ecfadfde9946 = {
    lineLengthLeft: 'grid_left',
    lineLengthRight: 'grid_right',
    wideLeft: 'wide_left',
    wideRight: 'wide_right',
    fullWidthLeft: 'full_width_left',
    fullWidthRight: 'full_width_right',
    maxWidthLeft: 'max_width_left',
    maxWidthRight: 'max_width_right'
};
const $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $b26ea474fd996270$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $b26ea474fd996270$export$47dec483f7d48a59 = (0, $dOBRD.default)((isResizing, newWidth, getEditorWidth, nodeType)=>{
    const guidelines = [];
    if (!isResizing) return guidelines;
    let innerPaddingOffset = 0;
    if (nodeType) switch(nodeType.name){
        case 'expand':
            innerPaddingOffset = (0, $5c8e412569aaa956$export$6065600df915db53) + (0, $2INqe.resizerHandleThumbWidth) + $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'layoutSection':
            innerPaddingOffset = (0, $cBSrP.LAYOUT_COLUMN_PADDING) + $b26ea474fd996270$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        default:
            break;
    }
    const { width: width } = getEditorWidth() || {};
    const padding = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const fullWidth = width ? Math.min($b26ea474fd996270$var$WIDTHS.FULL, width - 2 * padding - (0, $7Y8M5.akEditorGutterPadding)) : undefined;
    const maxWidth = width && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? Math.min($b26ea474fd996270$var$WIDTHS.MAX, width - 2 * padding - (0, $7Y8M5.akEditorGutterPadding)) : undefined;
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.lineLengthLeft,
        position: {
            x: -$b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.lineLengthRight,
        position: {
            x: $b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.wideLeft,
        position: {
            x: -$b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.WIDE
    });
    guidelines.push({
        key: $b26ea474fd996270$export$dd27ecfadfde9946.wideRight,
        position: {
            x: $b26ea474fd996270$var$roundToNearest($b26ea474fd996270$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $b26ea474fd996270$var$WIDTHS.WIDE
    });
    if (fullWidth) {
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.fullWidthLeft,
            position: {
                x: -$b26ea474fd996270$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.fullWidthRight,
            position: {
                x: $b26ea474fd996270$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
    }
    if (maxWidth) {
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.maxWidthLeft,
            position: {
                x: -$b26ea474fd996270$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
        guidelines.push({
            key: $b26ea474fd996270$export$dd27ecfadfde9946.maxWidthRight,
            position: {
                x: $b26ea474fd996270$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
    }
    return guidelines;
});





var $krYZG = parcelRequire("krYZG");

const $16eef43b12a02110$export$29574a7e6ffc8eb4 = (props)=>{
    return props.frameRateSamples.map((frameRateSample, index)=>({
            action: (0, $krYZG.ACTION).RESIZED_PERF_SAMPLING,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                nodeType: props.originalNode.type.name,
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $16eef43b12a02110$export$6b143296f4c6108b = ({ node: node, prevWidth: prevWidth, newWidth: newWidth })=>{
    return {
        action: (0, $krYZG.ACTION).RESIZED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            nodeType: node.type.name,
            prevWidth: prevWidth,
            newWidth: newWidth
        }
    };
};


/**
 * Measure the FPS of a resizing component.
 *
 * This is a simplified version of the `useMeasureFramerate` hook from `editor-plugin-table`.
 * (packages/editor/editor-plugin-table/src/pm-plugins/utils/analytics.ts)
 */ const $30161690decf9e20$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $30161690decf9e20$export$499e6cf908107611 = (config)=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config || {};
    let frameCount = 0;
    let lastTime = 0;
    let timeoutId;
    let frameRateSamples = [];
    const startMeasure = ()=>{
        frameCount = 0;
        lastTime = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 * @returns {number[]} An array of frame rate samples as integers.
	 * @example
	 * const samples = endMeasure(); // [60, 58, 62]
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples;
        frameRateSamples = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount / (deltaTime / 1000));
            frameRateSamples.push(frameRate);
        }
        frameCount = 0;
        lastTime = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 * @example
	 * const animate = () => {
	 *   countFrames();
	 *   requestAnimationFrame(animate);
	 * };
	 */ const countFrames = ()=>{
        if (frameRateSamples.length >= maxSamples && timeoutId) {
            clearTimeout(timeoutId);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime === 0) lastTime = performance.now();
        frameCount++;
        if (timeoutId) clearTimeout(timeoutId);
        if (performance.now() - lastTime > sampleRateMs) sampleFrameRate();
        else timeoutId = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};


const $a7d4f60c53187407$var$RESIZE_RATIO = 2;
const $a7d4f60c53187407$var$SNAP_GAP = 10;
const $a7d4f60c53187407$var$WIDTHS = {
    MIN: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    WIDE: (0, $7Y8M5.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $7Y8M5.akEditorFullWidthLayoutWidth),
    MAX: (0, $7Y8M5.akEditorMaxLayoutWidth)
};
function $a7d4f60c53187407$export$39e6ff87d188b0e6({ initialWidth: initialWidth, location: location, api: api, source: source }) {
    const directionMultiplier = source.data.handleSide === 'left' ? -1 : 1;
    const diffX = (location.current.input.clientX - location.initial.input.clientX) * $a7d4f60c53187407$var$RESIZE_RATIO * directionMultiplier;
    const width = api?.width.sharedState?.currentState()?.width || 0;
    const padding = width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const containerWidth = width - 2 * padding - (0, $7Y8M5.akEditorGutterPadding);
    // the node width may be greater than the container width so we resize using the smaller value
    const proposedWidth = Math.min(initialWidth, containerWidth) + diffX;
    const snapPoints = [
        $a7d4f60c53187407$var$WIDTHS.MIN,
        $a7d4f60c53187407$var$WIDTHS.WIDE,
        Math.min(containerWidth, $a7d4f60c53187407$var$WIDTHS.FULL)
    ];
    if ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) snapPoints.push(Math.min(containerWidth, $a7d4f60c53187407$var$WIDTHS.MAX));
    for (const snapPoint of snapPoints){
        if (snapPoint - $a7d4f60c53187407$var$SNAP_GAP < proposedWidth && snapPoint + $a7d4f60c53187407$var$SNAP_GAP > proposedWidth) return snapPoint;
    }
    const hardMax = (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? Math.min(containerWidth, $a7d4f60c53187407$var$WIDTHS.MAX) : Math.min(containerWidth, $a7d4f60c53187407$var$WIDTHS.FULL);
    return Math.max($a7d4f60c53187407$var$WIDTHS.MIN, Math.min(proposedWidth, hardMax));
}
function $a7d4f60c53187407$export$d3619fd797e636fb({ dom: dom, view: view, mark: mark, api: api }) {
    let node = null;
    let guidelines = [];
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $30161690decf9e20$export$499e6cf908107611)();
    const getEditorWidth = ()=>{
        return api?.width?.sharedState.currentState();
    };
    return {
        onDragStart: ()=>{
            startMeasure();
            const pos = view.posAtDOM(dom, 0);
            node = view.state.doc.nodeAt(pos);
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                tr.setMeta('is-resizer-resizing', true);
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'UPDATE_BREAKOUT_NODE',
                    data: {
                        node: node,
                        pos: pos,
                        start: pos,
                        depth: 0
                    }
                });
                return tr;
            });
        },
        onDrag: ({ location: location, source: source })=>{
            countFrames();
            const initialWidth = mark.attrs.width;
            const newWidth = $a7d4f60c53187407$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            guidelines = (0, $b26ea474fd996270$export$47dec483f7d48a59)(true, newWidth, getEditorWidth, node?.type);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const activeGuideline = guidelines.find((guideline)=>guideline.active && !guideline.key.startsWith('grid'));
            if (activeGuideline) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'UPDATE_ACTIVE_GUIDELINE_KEY',
                    data: {
                        activeGuidelineKey: activeGuideline.key
                    }
                });
                return tr;
            });
            if (!activeGuideline && api?.breakout.sharedState.currentState()?.activeGuidelineKey) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'CLEAR_ACTIVE_GUIDELINE_KEY'
                });
                return tr;
            });
            // dom is used for width calculations
            dom.style.setProperty((0, $5cef6fba358b19bd$export$4ce5e59f44ac1e3e), `${newWidth}px`);
        },
        onDrop ({ location: location, source: source }) {
            let payloads = [];
            const frameRateSamples = endMeasure();
            payloads = (0, $16eef43b12a02110$export$29574a7e6ffc8eb4)({
                docSize: view.state.doc.nodeSize,
                frameRateSamples: (0, $30161690decf9e20$export$52625746d6329c8a)(frameRateSamples),
                originalNode: node
            });
            const isResizedToFullWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('full_width') && guideline.active);
            let isResizedToMaxWidth = false;
            if ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) isResizedToMaxWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('max_width') && guideline.active);
            guidelines = (0, $b26ea474fd996270$export$47dec483f7d48a59)(false, 0, getEditorWidth);
            api?.guideline?.actions?.displayGuideline(view)({
                guidelines: guidelines
            });
            const pos = view.posAtDOM(dom, 0);
            const mode = mark.attrs.mode;
            const initialWidth = mark.attrs.width;
            let newWidth = isResizedToFullWidth ? $a7d4f60c53187407$var$WIDTHS.FULL : $a7d4f60c53187407$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            if ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
                if (isResizedToMaxWidth) newWidth = $a7d4f60c53187407$var$WIDTHS.MAX;
            }
            const isEditMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'edit';
            (0, $370b3dd575cda351$export$2347aa63864fccd4)(newWidth, mode, pos, isEditMode)(view.state, view.dispatch);
            dom.style.removeProperty((0, $5cef6fba358b19bd$export$4ce5e59f44ac1e3e));
            if (node) {
                const resizedPayload = (0, $16eef43b12a02110$export$6b143296f4c6108b)({
                    node: node,
                    prevWidth: initialWidth,
                    newWidth: newWidth
                });
                payloads.push(resizedPayload);
            }
            api?.core.actions.execute(({ tr: tr })=>{
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                payloads.forEach((payload)=>{
                    api.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                });
                tr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
                tr.setMeta((0, $8091fd80d3a27677$export$ca33a310187a5f87), {
                    type: 'RESET_STATE'
                });
                return tr;
            });
        }
    };
}


const $5cef6fba358b19bd$export$4ce5e59f44ac1e3e = '--local-resizing-width';
const $5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH = '7px';
// this function delays the resizer callbacks until the mark view DOM is attached to the DOM
const $5cef6fba358b19bd$var$scheduleResizeHandleSetup = (callback)=>{
    if (typeof window === 'undefined') return ()=>{};
    if (typeof window.requestAnimationFrame === 'function') {
        const frame = window.requestAnimationFrame(callback);
        return ()=>window.cancelAnimationFrame(frame);
    }
    const timeout = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(timeout);
};
class $5cef6fba358b19bd$export$4fb684fac6535bde {
    setupResizerCallbacks(dom, contentDOM, view, mark, api) {
        const callbacks = (0, $a7d4f60c53187407$export$d3619fd797e636fb)({
            dom: dom,
            view: view,
            mark: mark,
            api: api
        });
        const { leftHandle: leftHandle, rightHandle: rightHandle, destroy: destroy } = (0, $5114ca5c92242368$export$2023dee10a108a1)({
            target: contentDOM,
            ...callbacks,
            intl: this.intl,
            nodeViewPortalProviderAPI: this.nodeViewPortalProviderAPI
        });
        if (leftHandle) this.dom.prepend(leftHandle);
        this.dom.appendChild(rightHandle);
        this.destroyFn = destroy;
        this.isResizingInitialised = true;
    }
    setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingExperimentEnabled, api) {
        // cancel any pending setup before scheduling a new one
        this.cancelScheduledResizeHandleSetup?.();
        this.cancelScheduledResizeHandleSetup = undefined;
        // if panels and rules support breakout resizing,
        // set up the resizer callbacks
        if (isResizingExperimentEnabled) {
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            return;
        }
        // else if panels and rules don't support breakout resizing,
        // do NOT set up the resizer callbacks (yet)
        // wait for the mark view DOM to be attached to the DOM first
        this.cancelScheduledResizeHandleSetup = $5cef6fba358b19bd$var$scheduleResizeHandleSetup(()=>{
            this.cancelScheduledResizeHandleSetup = undefined;
            if (view.isDestroyed || !dom.isConnected) return;
            const pos = view.posAtDOM(dom, 0);
            const nodeName = view.state.doc.nodeAt(pos)?.type.name;
            // if the node is a panel or a rule, do NOT set up the resizer callbacks
            if (nodeName && [
                'panel',
                'rule',
                'panel_c1'
            ].includes(nodeName) || this.isResizingInitialised) return;
            // else, continue to set up the resizer callbacks
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        });
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        this.destroyFn?.();
        this.unsubscribeToViewModeChange?.();
        this.cancelScheduledResizeHandleSetup?.();
    }
    /**
   * Wrap node view in a resizing mark view
   * @param {Mark} mark - The breakout mark to resize
   * @param {EditorView} view - The editor view
   * @param {ExtractInjectionAPI<BreakoutPlugin> | undefined} api - The pluginInjectionAPI
   * @param {Function} getIntl - () => IntlShape
   * @param {PortalProviderAPI} - The nodeViewPortalProviderAPI
   * @example
   * ```ts
   * ```
   */ constructor(mark, view, api, getIntl, nodeViewPortalProviderAPI){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        this.destroyFn = void 0;
        this.cancelScheduledResizeHandleSetup = void 0;
        this.intl = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.unsubscribeToViewModeChange = void 0;
        this.isResizingInitialised = false;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        const isResizingExperimentEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        // DOM styles
        // Keep a three-column grid even when the left resize handle is disabled. The empty
        // left track preserves the original content alignment without translating `contentDOM`,
        // so floating UI anchored to the node (for example block drag handles) keeps its position.
        dom.style.transform = 'none';
        dom.style.display = 'grid';
        dom.style.justifyContent = 'center';
        // contentDOM styles
        contentDOM.style.gridColumn = '2';
        contentDOM.style.zIndex = '1';
        if (mark.attrs.width) dom.style.gridTemplateColumns = isResizingExperimentEnabled ? // new code - phantom left track + content + right handle
        `${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH} max(var(--ak-editor--breakout-min-width), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) ${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH}` : // old code - left handle + content + right handle
        `auto max(var(--ak-editor--breakout-min-width), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) auto`;
        else {
            if (isResizingExperimentEnabled) dom.style.gridTemplateColumns = `${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH} auto ${$5cef6fba358b19bd$var$RESIZE_HANDLE_TRACK_WIDTH}`;
            if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$5cef6fba358b19bd$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.view = view;
        this.mark = mark;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        const isLiveViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (!isLiveViewMode) (0, $ixfCV.fg)('platform_editor_lovability_resize_gracefully') ? this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingExperimentEnabled, api) : this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        this.unsubscribeToViewModeChange = api?.editorViewMode?.sharedState.onChange((sharedState)=>{
            if (sharedState.nextSharedState?.mode !== sharedState.prevSharedState?.mode) {
                if ((0, $ixfCV.fg)('platform_editor_lovability_resize_gracefully')) {
                    if (sharedState.nextSharedState?.mode === 'view') {
                        this.cancelScheduledResizeHandleSetup?.();
                        this.cancelScheduledResizeHandleSetup = undefined;
                        if (this.isResizingInitialised) {
                            this.destroyFn?.(true);
                            this.isResizingInitialised = false;
                        }
                    } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingExperimentEnabled, api);
                } else if (sharedState.nextSharedState?.mode === 'view' && this.isResizingInitialised) {
                    this.destroyFn?.(true);
                    this.isResizingInitialised = false;
                } else if (sharedState.nextSharedState?.mode === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            }
        });
    }
}



const $8091fd80d3a27677$var$addBreakoutToResizableNode = ({ node: node, pos: pos, newState: newState, newTr: newTr, breakoutResizableNodes: breakoutResizableNodes, isFullWidthEnabled: isFullWidthEnabled })=>{
    let updatedDocChanged = false;
    let updatedTr = newTr;
    const $pos = newState.doc.resolve(pos);
    const isTopLevelNode = $pos?.depth === 0;
    if (breakoutResizableNodes.has(node.type) && isTopLevelNode) {
        const { breakout: breakout } = newState.schema.marks;
        const { expand: expand } = newState.schema.nodes;
        const breakoutMark = node.marks.find((mark)=>mark.type === breakout);
        const isExpand = node.type === expand;
        if (!breakoutMark) {
            const width = isFullWidthEnabled ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : (0, $7Y8M5.akEditorDefaultLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width
                })
            ]);
            if (isExpand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        } else if (breakoutMark?.attrs.width === null || breakoutMark?.attrs.width === undefined) {
            const mode = breakoutMark.attrs.mode;
            // if breakout is present on node, but page appearance is 'full width' force width to full width to maintain backwards compatibility
            const newWidth = isFullWidthEnabled || mode === 'full-width' ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : (0, $7Y8M5.akEditorCalculatedWideLayoutWidth);
            updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: newWidth,
                    mode: mode
                })
            ]);
            if (isExpand) (0, $a625bc7e8547ea8a$export$cc135306f1c4ff36)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        }
    }
    return {
        updatedTr: updatedTr,
        updatedDocChanged: updatedDocChanged
    };
};
const $8091fd80d3a27677$export$ca33a310187a5f87 = new (0, $kCECX.PluginKey)('breakout-resizing');
const $8091fd80d3a27677$var$pluginState = {
    init () {
        return {
            breakoutNode: undefined,
            activeGuidelineLabel: undefined
        };
    },
    apply (tr, pluginState) {
        const meta = tr.getMeta($8091fd80d3a27677$export$ca33a310187a5f87);
        if (meta) switch(meta.type){
            case 'UPDATE_BREAKOUT_NODE':
                return {
                    ...pluginState,
                    breakoutNode: meta.data
                };
            case 'UPDATE_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: meta.data.activeGuidelineKey
                };
            case 'CLEAR_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: undefined
                };
            case 'RESET_STATE':
                return {
                    activeGuidelineLabel: undefined,
                    breakoutNode: undefined
                };
        }
        return pluginState;
    }
};
const $8091fd80d3a27677$export$522e3e76a011a0b1 = (api, getIntl, nodeViewPortalProviderAPI, options, isRuleAndPanelResizingEnabled = false)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $8091fd80d3a27677$export$ca33a310187a5f87,
        state: $8091fd80d3a27677$var$pluginState,
        props: {
            markViews: {
                breakout: (mark, view)=>{
                    return new (0, $5cef6fba358b19bd$export$4fb684fac6535bde)(mark, view, api, getIntl, nodeViewPortalProviderAPI);
                }
            },
            handleKeyDown: (0, $0f6d40dbf214f8ed$export$bab59f27a7347e45)(api)
        },
        appendTransaction (transactions, oldState, newState) {
            if (api?.editorViewMode?.sharedState.currentState()?.mode === 'view') return;
            let newTr = newState.tr;
            let hasDocChanged = false;
            const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, rule: rule, panel: panel, panel_c1: panel_c1 } = newState.schema.nodes;
            const breakoutResizableNodes = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? (0, $8aEKG.getBreakoutResizableNodeTypes)(newState.schema, isRuleAndPanelResizingEnabled) : isRuleAndPanelResizingEnabled ? new Set([
                expand,
                codeBlock,
                layoutSection,
                rule,
                panel,
                panel_c1
            ]) : new Set([
                expand,
                codeBlock,
                layoutSection
            ]);
            const isFullWidthEnabled = !(options?.allowBreakoutButton === true);
            if ((0, $6SJ6d.isReplaceDocOperation)(transactions, oldState)) newState.doc.forEach((node, pos)=>{
                const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $8091fd80d3a27677$var$addBreakoutToResizableNode({
                    node: node,
                    pos: pos,
                    newState: newState,
                    newTr: newTr,
                    breakoutResizableNodes: breakoutResizableNodes,
                    isFullWidthEnabled: isFullWidthEnabled
                });
                newTr = updatedTr;
                hasDocChanged = hasDocChanged || updatedDocChanged;
            });
            else transactions.forEach((tr)=>{
                const isAddingResizableNodes = tr.steps.some((step)=>(0, $6MtNT.stepAddsOneOf)(step, breakoutResizableNodes));
                if (isAddingResizableNodes) {
                    const changedNodes = (0, $6SJ6d.getChangedNodes)(tr);
                    changedNodes.forEach(({ node: node, pos: pos })=>{
                        const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $8091fd80d3a27677$var$addBreakoutToResizableNode({
                            node: node,
                            pos: pos,
                            newState: newState,
                            newTr: newTr,
                            breakoutResizableNodes: breakoutResizableNodes,
                            isFullWidthEnabled: isFullWidthEnabled
                        });
                        newTr = updatedTr;
                        hasDocChanged = hasDocChanged || updatedDocChanged;
                    });
                }
            });
            if (hasDocChanged) return newTr;
        }
    });
};






var $bjg0G = parcelRequire("bjg0G");




const $40620c4942718f97$var$supportedNodesForBreakout = [
    'codeBlock',
    'layoutSection',
    'expand'
];
const $40620c4942718f97$var$supportedNodesForBreakoutAdvancedLayouts = [
    'codeBlock',
    'expand'
];
function $40620c4942718f97$export$2e02ca5ba4632d0a(node) {
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) return $40620c4942718f97$var$supportedNodesForBreakoutAdvancedLayouts.indexOf(node.type.name) !== -1;
    return $40620c4942718f97$var$supportedNodesForBreakout.indexOf(node.type.name) !== -1;
}


function $3881b65b874c8445$export$b3e00d6ce0602166(selection) {
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const supportsBreakout = (0, $40620c4942718f97$export$2e02ca5ba4632d0a)(selection.node);
        if (supportsBreakout) return {
            pos: selection.from,
            start: selection.from,
            node: selection.node,
            // If a selected expand is in a doc, the depth of that expand is 0. Therefore
            // we don't need to subtract 1 or instantly return false if the depth is 0
            depth: selection.$anchor.depth
        };
    }
    const breakoutNode = (0, $bjg0G.findParentNode)((0, $40620c4942718f97$export$2e02ca5ba4632d0a))(selection);
    if (!breakoutNode || breakoutNode.depth === 0) // If this node doesn't exist or the only supporting node is the document
    // (with depth 0), then we're not inside a node that supports breakout
    return undefined;
    return {
        node: breakoutNode.node,
        start: breakoutNode.start,
        pos: breakoutNode.pos,
        depth: breakoutNode.depth - 1
    };
}



function $a2cf882edcb3c89a$export$7293881dc293b44d(state) {
    const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
    if (!node) return;
    const breakoutMark = node.node.marks.find((m)=>m.type.name === 'breakout');
    if (!breakoutMark) return;
    return breakoutMark.attrs.mode;
}






var $aiyg1 = parcelRequire("aiyg1");


var $7XIuB = parcelRequire("7XIuB");







const $582d6f147f320fca$var$GUIDELINE_KEY_TO_LAYOUT = {
    wide_left: 'wide',
    wide_right: 'wide',
    full_width_left: 'full-width',
    full_width_right: 'full-width',
    max_width_left: 'max',
    max_width_right: 'max'
};
const $582d6f147f320fca$export$ee321e647107007d = ({ api: api, editorView: editorView, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const breakoutNode = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'breakout.breakoutNode');
    const activeGuidelineKey = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'breakout.activeGuidelineKey');
    if (!breakoutNode || !activeGuidelineKey) return null;
    const element = (0, $bjg0G.findDomRefAtPos)(breakoutNode.pos, editorView.domAtPos.bind(editorView));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        target: element && element instanceof HTMLElement ? element : undefined,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        alignY: "bottom",
        alignX: "center",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiyg1.ResizerBreakoutModeLabel), {
        layout: $582d6f147f320fca$var$GUIDELINE_KEY_TO_LAYOUT[activeGuidelineKey]
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");











var $ldbHR = parcelRequire("ldbHR");


var $keRDK = parcelRequire("keRDK");

var $3LJVu = parcelRequire("3LJVu");











var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");


var $jp2Q3 = parcelRequire("jp2Q3");












function $f7a09a3667270750$export$8adb30fdfe0dc8a3(isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const marks = node.node.marks.filter((m)=>m.type.name !== 'breakout');
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, marks);
        if (node.node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}










function $947054a48b58065b$export$835e4fcd1fc926bc(mode, isLivePage) {
    return (state, dispatch)=>{
        const node = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
        if (!node) return false;
        const tr = state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, [
            state.schema.marks.breakout.create({
                mode: mode
            })
        ]);
        if (node.node.type === state.schema.nodes.expand) (0, $a625bc7e8547ea8a$export$322e23ed7d99ab86)(tr, node, isLivePage);
        else if (node.node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(node.pos);
            const oldNode = node.node;
            if (newNode) (0, $6gBg9.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            if (state.selection.$anchor.pos === node.pos) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, node.pos));
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}




function $2dbd0737d1a59e22$export$caf83e14f3995804(state) {
    if (!state.schema.marks.breakout) return false;
    const supportedNodeParent = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(state.selection);
    if (!supportedNodeParent) return false;
    // At the moment we can only breakout when the depth is 0, ie. doc is the only node
    // that supports breakout. This *could* change though.
    const parent = state.selection.$from.node(supportedNodeParent.depth);
    return parent.type.allowsMarkType(state.schema.marks.breakout);
}



const $0fd7dd3657f1434d$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& button': {
        background: "var(--ds-background-neutral, #0515240F)",
        color: "var(--ds-icon, #292A2E)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${"var(--ds-icon, #292A2E)"} !important`
        }
    }
});
const $0fd7dd3657f1434d$var$toolbarButtonNarrowScreenStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/design-system/no-nested-styles,  @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            visibility: 'hidden',
            opacity: 0
        }
    }
});
function $0fd7dd3657f1434d$var$getBreakoutNodeElement(pluginState, selection, editorView) {
    if (!pluginState.breakoutNode) return undefined;
    if (selection instanceof (0, $kCECX.NodeSelection) && (0, $40620c4942718f97$export$2e02ca5ba4632d0a)(selection.node)) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $bjg0G.findDomRefAtPos)(selection.from, editorView.domAtPos.bind(editorView));
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return (0, $bjg0G.findParentDomRefOfType)(pluginState.breakoutNode.node.type, editorView.domAtPos.bind(editorView))(selection);
}
const $0fd7dd3657f1434d$var$LayoutButton = ({ intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isLivePage: isLivePage, isBreakoutNodePresent: isBreakoutNodePresent, breakoutMode: breakoutModeProp, api: api })=>{
    const handleClick = (0, $cozmU.useCallback)((breakoutMode)=>{
        if (!editorView) return;
        const { state: state, dispatch: dispatch } = editorView;
        const breakoutNode = (0, $b9859c35f29c69d8$export$f05434c51e3762e)(state)?.breakoutNode;
        if ([
            'wide',
            'full-width'
        ].indexOf(breakoutMode) !== -1) {
            (0, $947054a48b58065b$export$835e4fcd1fc926bc)(breakoutMode, isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    mode: breakoutMode,
                    nodeType: breakoutNode?.node.type.name
                }
            });
        } else {
            (0, $f7a09a3667270750$export$8adb30fdfe0dc8a3)(isLivePage)(state, dispatch);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_BREAKOUT_MODE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    mode: 'center',
                    nodeType: breakoutNode?.node.type.name
                }
            });
        }
    }, [
        api?.analytics?.actions,
        editorView,
        isLivePage
    ]);
    if (!editorView) return null;
    if (!isBreakoutNodePresent || !(0, $2dbd0737d1a59e22$export$caf83e14f3995804)(editorView.state)) return null;
    const breakoutMode = breakoutModeProp;
    const titleMessage = (0, $3LJVu.getTitle)(breakoutMode);
    const title = formatMessage(titleMessage);
    const nextBreakoutMode = (0, $keRDK.getNextBreakoutMode)(breakoutMode);
    const belowOtherPopupsZIndex = (0, $jp2Q3.layers).layer() - 1;
    const pluginState = (0, $b9859c35f29c69d8$export$f05434c51e3762e)(editorView.state);
    if (!pluginState) return null;
    let element = $0fd7dd3657f1434d$var$getBreakoutNodeElement(pluginState, editorView.state.selection, editorView);
    if (!element) return null;
    const closestEl = element.querySelector(`.${(0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM}`);
    if (closestEl && closestEl.firstChild) // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    element = closestEl.firstChild;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        ariaLabel: title,
        target: element,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            5,
            0
        ],
        alignY: "start",
        alignX: "end",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        zIndex: belowOtherPopupsZIndex
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $0fd7dd3657f1434d$var$toolbarButtonWrapperStyles,
            (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $0fd7dd3657f1434d$var$toolbarButtonNarrowScreenStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        title: title,
        testId: titleMessage.id,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>handleClick(nextBreakoutMode),
        iconBefore: breakoutMode === 'full-width' ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
            label: title,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
            label: title,
            spacing: "spacious"
        })
    })));
};
$0fd7dd3657f1434d$var$LayoutButton.displayName = 'LayoutButton';
const $0fd7dd3657f1434d$var$_default_1 = (0, $kSwu1.injectIntl)($0fd7dd3657f1434d$var$LayoutButton);
var $0fd7dd3657f1434d$export$2e2bcd8739ae039 = $0fd7dd3657f1434d$var$_default_1;


class $267f2cb62f6991f2$var$BreakoutView {
    constructor(/**
   * Note: this is actually a PMMark -- however our version
   * of the prosemirror and prosemirror types mean using PMNode
   * is not problematic.
   */ mark, view, appearance){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.view = void 0;
        this.mark = void 0;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $lMCDO.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        dom.appendChild(contentDOM);
        dom.style.transform = 'none';
        dom.style.display = 'flex';
        dom.style.justifyContent = 'center';
        contentDOM.style.transition = `min-width 0.5s ${0, $7Y8M5.akEditorSwoopCubicBezier}`;
        if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
            if (mark.attrs.width) contentDOM.style.minWidth = `min(${mark.attrs.width}px, calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
            else {
                // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
                if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                if (mark.attrs.mode === 'wide') {
                    if (appearance && appearance === 'full-width' && (0, $fqVYq.editorExperiment)('single_column_layouts', true) && true) contentDOM.style.minWidth = `min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding)))`;
                    else contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
                }
            }
        } else {
            // original breakout algorithm is in calcBreakoutWidth from platform/packages/editor/editor-common/src/utils/breakout.ts
            if (mark.attrs.mode === 'full-width') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'wide') contentDOM.style.minWidth = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        this.dom = dom;
        this.mark = mark;
        this.view = view;
        this.contentDOM = contentDOM;
    }
}
function $267f2cb62f6991f2$var$shouldPluginStateUpdate(newBreakoutNode, currentBreakoutNode) {
    if (newBreakoutNode && currentBreakoutNode) return newBreakoutNode !== currentBreakoutNode;
    return newBreakoutNode || currentBreakoutNode ? true : false;
}
function $267f2cb62f6991f2$var$createPlugin(api, { dispatch: dispatch }, appearance) {
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
            },
            apply (tr, pluginState) {
                const breakoutNode = (0, $3881b65b874c8445$export$b3e00d6ce0602166)(tr.selection);
                if ($267f2cb62f6991f2$var$shouldPluginStateUpdate(breakoutNode, pluginState.breakoutNode)) {
                    const nextPluginState = {
                        ...pluginState,
                        breakoutNode: breakoutNode
                    };
                    dispatch((0, $b9859c35f29c69d8$export$18d4026d1ea86bb1), nextPluginState);
                    return nextPluginState;
                }
                return pluginState;
            }
        },
        key: (0, $b9859c35f29c69d8$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                // Note: When we upgrade to prosemirror 1.27.2 -- we should
                // move this to markViews.
                // See the following link for more details:
                // https://prosemirror.net/docs/ref/#view.EditorProps.nodeViews.
                breakout: (mark, view)=>{
                    return new $267f2cb62f6991f2$var$BreakoutView(mark, view, appearance);
                }
            }
        }
    });
}
const $267f2cb62f6991f2$var$LayoutButtonWrapper = ({ api: api, editorView: editorView, boundariesElement: boundariesElement, scrollableElement: scrollableElement, mountPoint: mountPoint })=>{
    const { editorDisabled: editorDisabled, isDragging: isDragging, isPMDragging: isPMDragging, mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode',
        'editorDisabled',
        'blockControls'
    ], (states)=>({
            isDragging: states.blockControlsState?.isDragging,
            isPMDragging: states.blockControlsState?.isPMDragging,
            mode: states.editorViewModeState?.mode,
            editorDisabled: states.editorDisabledState?.editorDisabled
        }));
    const [breakoutNodePresent, setBreakoutNodePresent] = (0, $cozmU.useState)(false);
    const [breakoutMode, setBreakoutMode] = (0, $cozmU.useState)(editorView ? (0, $a2cf882edcb3c89a$export$7293881dc293b44d)(editorView.state) : undefined);
    (0, $1KOhB.usePluginStateEffect)(api, [
        'breakout'
    ], ({ breakoutState: breakoutState })=>{
        if (!editorView) return;
        if (breakoutState?.breakoutNode && !breakoutNodePresent) setBreakoutNodePresent(true);
        if (!breakoutState?.breakoutNode && breakoutNodePresent) setBreakoutNodePresent(false);
        const nextBreakoutMode = (0, $a2cf882edcb3c89a$export$7293881dc293b44d)(editorView.state);
        if (nextBreakoutMode !== breakoutMode) setBreakoutMode(nextBreakoutMode);
    });
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'interaction.interactionState');
    if (interactionState === 'hasNotHadInteraction') return null;
    if (isDragging || isPMDragging) {
        if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) return null;
    }
    const isViewMode = mode === 'view';
    const isEditMode = mode === 'edit';
    return !isViewMode && editorDisabled === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fd7dd3657f1434d$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isLivePage: isEditMode,
        isBreakoutNodePresent: breakoutNodePresent,
        breakoutMode: breakoutMode,
        api: api
    }) : null;
};
const $267f2cb62f6991f2$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return [
                {
                    name: 'breakout-resizing',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $8091fd80d3a27677$export$522e3e76a011a0b1)(api, getIntl, nodeViewPortalProviderAPI, options, (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true))
                }
            ];
            return [
                {
                    name: 'breakout',
                    plugin: (props)=>$267f2cb62f6991f2$var$createPlugin(api, props, options?.appearance)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $acWDI.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                const resizingPluginState = (0, $8091fd80d3a27677$export$ca33a310187a5f87).getState(editorState);
                if (!resizingPluginState) return {
                    breakoutNode: undefined,
                    activeGuidelineKey: undefined
                };
                return resizingPluginState;
            }
            const pluginState = (0, $b9859c35f29c69d8$export$18d4026d1ea86bb1).getState(editorState);
            if (!pluginState) return {
                breakoutNode: undefined
            };
            return pluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $582d6f147f320fca$export$ee321e647107007d), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
            // This is a bit crappy, but should be resolved once we move to a static schema.
            if (options && !options.allowBreakoutButton) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($267f2cb62f6991f2$var$LayoutButtonWrapper, {
                api: api,
                mountPoint: popupsMountPoint,
                editorView: editorView,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["breakoutPlugin"] = $267f2cb62f6991f2$export$f56f43f1e6905418;

});

parcelRegister("cud1R", function(module, exports) {

var $c94QJ = parcelRequire("c94QJ");


var $ldqjS = parcelRequire("ldqjS");


var $4EksL = parcelRequire("4EksL");


var $77KCc = parcelRequire("77KCc");


var $44cyU = parcelRequire("44cyU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

function $b58cd291d696d4e1$export$317bc7037b2c3692() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $b58cd291d696d4e1$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $b58cd291d696d4e1$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, $b58cd291d696d4e1$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.shiftTab).common, $b58cd291d696d4e1$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.tab).common, $b58cd291d696d4e1$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveLeft).common, $b58cd291d696d4e1$var$gapCursorSelectLeftParentMediaSingle, list);
    return (0, $44cyU.keymap)(list);
}
const $b58cd291d696d4e1$var$createNewParagraphBelowCaption = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) return (0, $77KCc.createNewParagraphBelow)(state, dispatch);
    return false;
};
const $b58cd291d696d4e1$var$getOutOfCaption = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        if (dispatch) {
            const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(caption.pos + caption.node.nodeSize)));
            dispatch(tr);
        }
        return true;
    }
    return false;
};
const $b58cd291d696d4e1$var$selectParentMediaSingle = (state, dispatch)=>{
    if ((0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection)) {
        const mediaSingleParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent) {
            if (dispatch) {
                const tr = state.tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(mediaSingleParent.pos)));
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
const $b58cd291d696d4e1$var$gapCursorSelectLeftParentMediaSingle = (state, dispatch)=>{
    const caption = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        const mediaSingleParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent && state.selection.empty && state.tr.doc.resolve(state.selection.from).parentOffset === 0) {
            const gapCursorSelection = (0, $4EksL.GapCursorSelection).findFrom(state.tr.doc.resolve(mediaSingleParent.pos), 0, false);
            if (gapCursorSelection) {
                if (dispatch) {
                    const tr = state.tr.setSelection(gapCursorSelection);
                    dispatch(tr);
                }
                return true;
            }
        }
    }
    return false;
};



var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");





var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $haNN4 = parcelRequire("haNN4");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");


var $g9sVl = parcelRequire("g9sVl");


var $4aRaM = parcelRequire("4aRaM");


var $88npU = parcelRequire("88npU");

class $72bcb949a9452632$export$77884ce9af78bb82 extends (0, $4aRaM.SelectionBasedNodeView) {
    createDomRef() {
        const domRef = ((0, $haNN4.getDocument)() ?? document).createElement('figcaption');
        domRef.setAttribute('data-caption', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = ((0, $haNN4.getDocument)() ?? document).createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'caption-wrapper';
        dom.setAttribute('contenteditable', this.pluginInjectionApi?.editorDisabled?.sharedState.currentState()?.editorDisabled ? 'false' : 'true');
        return {
            dom: dom
        };
    }
    // ED-24114: We need to ignore mutations that are not related to the caption node
    // since these mutations can cause an infinite loop in React 18 when using createRoot
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    handleEditorDisabledChanged() {
        if (this.pluginInjectionApi?.editorDisabled) this.cleanupEditorDisabledListener = this.pluginInjectionApi.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    render(_props, forwardRef) {
        const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88npU.default), {
            selected: this.insideSelection(),
            hasContent: this.node.content.childCount > 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9sVl.NodeViewContentHole), {
            ref: forwardRef
        }));
        if (!this.intl || !(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
            value: this.intl
        }, children);
    }
    viewShouldUpdate(nextNode) {
        if (this.node.childCount !== nextNode.childCount) return true;
        const newSelected = this.insideSelection();
        const selectedStateChange = this.selected !== newSelected;
        this.selected = newSelected;
        return selectedStateChange;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, pluginInjectionApi, intl){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate);
        this.selected = this.insideSelection();
        this.cleanupEditorDisabledListener = void 0;
        this.pluginInjectionApi = void 0;
        this.intl = void 0;
        this.pluginInjectionApi = pluginInjectionApi;
        this.intl = intl;
        this.handleEditorDisabledChanged();
    }
}
function $72bcb949a9452632$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl) {
    return (node, view, getPos)=>{
        return new $72bcb949a9452632$export$77884ce9af78bb82(node, view, getPos, portalProviderAPI, eventDispatcher, {}, undefined, undefined, pluginInjectionApi, intl).init();
    };
}





const $46ec7991c9b12058$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('caption');


const $0c92a5e9920b7504$var$fireAnalytics = (tr, action, analyticsApi)=>{
    analyticsApi?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CAPTION
    })(tr);
};
var $0c92a5e9920b7504$export$2e2bcd8739ae039 = (portalProviderAPI, eventDispatcher, providerFactory, dispatch, pluginInjectionApi, intl)=>{
    const analyticsApi = pluginInjectionApi?.analytics?.actions;
    return new (0, $kpCD8.SafePlugin)({
        appendTransaction (transactions, oldState, newState) {
            // only run for transactions that change selection
            if (!transactions.find((tr)=>tr.selectionSet)) return;
            const newSelection = !newState.selection.eq(oldState.selection);
            const findCaption = (0, $bjg0G.findParentNodeOfType)(oldState.schema.nodes.caption);
            const oldSelectionCaption = findCaption(oldState.selection);
            const { tr: tr } = newState;
            // if selecting away from caption, or selecting a different caption
            if (newSelection && oldSelectionCaption) {
                if (oldSelectionCaption.node.childCount === 0) {
                    tr.delete(oldSelectionCaption.start - 1, oldSelectionCaption.start);
                    tr.setMeta('scrollIntoView', false);
                    $0c92a5e9920b7504$var$fireAnalytics(tr, (0, $krYZG.ACTION).DELETED, analyticsApi);
                    return tr;
                } else {
                    $0c92a5e9920b7504$var$fireAnalytics(tr, (0, $krYZG.ACTION).EDITED, analyticsApi);
                    return tr;
                }
            }
        },
        key: (0, $46ec7991c9b12058$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                caption: (0, $72bcb949a9452632$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl)
            }
        }
    });
};


const $a7f8921f2a545142$var$captionPlugin = ({ api: api })=>{
    return {
        name: 'caption',
        nodes () {
            return [
                {
                    name: 'caption',
                    node: (0, $c94QJ.caption)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'caption',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>(0, $0c92a5e9920b7504$export$2e2bcd8739ae039)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, getIntl())
                },
                {
                    name: 'captionKeymap',
                    plugin: (0, $b58cd291d696d4e1$export$317bc7037b2c3692)
                }
            ];
        }
    };
};
var $a7f8921f2a545142$export$2e2bcd8739ae039 = $a7f8921f2a545142$var$captionPlugin;
module.exports["default"] = $a7f8921f2a545142$export$2e2bcd8739ae039;

});

parcelRegister("4aRaM", function(module, exports) {

var $Igylv = parcelRequire("Igylv");

class $18a925a7be7b7815$export$9f83dc95adfbb293 extends (0, $Igylv.default) {
    /**
   * Update current node's start and end positions.
   *
   * Prefer `this.pos` rather than getPos(), because calling getPos is
   * expensive, unless you know you're definitely going to render.
   */ updatePos() {
        if (typeof this.getPos === 'boolean') return;
        const pos = this.getPos();
        if (typeof pos === 'number') {
            this.pos = pos;
            this.posEnd = pos + this.node.nodeSize;
        }
    }
    getPositionsWithDefault(pos, posEnd) {
        return {
            pos: typeof pos !== 'number' ? this.pos : pos,
            posEnd: typeof posEnd !== 'number' ? this.posEnd : posEnd
        };
    }
    selectNode() {
        this.isSelectedNode = true;
        this.update(this.node, this.decorations);
    }
    deselectNode() {
        this.isSelectedNode = false;
        this.update(this.node, this.decorations);
    }
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal);
        this.isSelectedNode = false;
        this.pos = void 0;
        this.posEnd = void 0;
        this.isNodeInsideSelection = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return from <= pos && to >= posEnd;
        };
        this.isSelectionInsideNode = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return pos < from && to < posEnd;
        };
        this.insideSelection = ()=>{
            const { selection: { from: from, to: to } } = this.view.state;
            return this.isSelectedNode || this.isSelectionInsideNode(from, to);
        };
        this.nodeInsideSelection = ()=>{
            const { selection: selection } = this.view.state;
            const { from: from, to: to } = selection;
            return this.isSelectedNode || this.isNodeInsideSelection(from, to);
        };
        this.updatePos();
    }
}
module.exports["SelectionBasedNodeView"] = $18a925a7be7b7815$export$9f83dc95adfbb293;

});

parcelRegister("40ukF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI2nS = parcelRequire("bI2nS");


var $jGK9e = parcelRequire("jGK9e");


var $k3XQC = parcelRequire("k3XQC");


var $ao034 = parcelRequire("ao034");

var $2WEO5 = parcelRequire("2WEO5");


var $cMyWi = parcelRequire("cMyWi");


var $ixfCV = parcelRequire("ixfCV");


var $mW7G5 = parcelRequire("mW7G5");


var $azoPw = parcelRequire("azoPw");


var $8Dx7s = parcelRequire("8Dx7s");




const $dc39c5d622176d3d$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $azoPw.blockCardWithLocalId) : (0, $azoPw.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};


/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $dtmRZ = parcelRequire("dtmRZ");





var $7Y8M5 = parcelRequire("7Y8M5");




// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $75ce2aa51e74c7ef$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $75ce2aa51e74c7ef$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $75ce2aa51e74c7ef$var$LINE_LENGTH = 760;
const $75ce2aa51e74c7ef$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $dtmRZ.embedCardWithLocalId) : (0, $dtmRZ.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $8Dx7s.convertToInlineCss)({
                    margin: $75ce2aa51e74c7ef$var$calcMargin(layout),
                    width: `${Math.ceil($75ce2aa51e74c7ef$var$calcPxFromPct(width / 100, $75ce2aa51e74c7ef$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $75ce2aa51e74c7ef$var$float(layout)
                }),
                ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};



var $dYkuB = parcelRequire("dYkuB");







const $7e11113c0b6b9b64$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $dYkuB.inlineCardWithLocalId) : (0, $dYkuB.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $8Dx7s.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: "var(--ds-link, #1868DB)",
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};



var $cbp6v = parcelRequire("cbp6v");


var $6JWmx = parcelRequire("6JWmx");


var $8dxef = parcelRequire("8dxef");


var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $1ddf8f052569320c$var$lookupPixel = 10;
const $1ddf8f052569320c$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $bjg0G.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $1ddf8f052569320c$var$lookupPixel : coord.bottom + $1ddf8f052569320c$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $bjg0G.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $1ddf8f052569320c$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $1ddf8f052569320c$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $kCECX.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $1ddf8f052569320c$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $8dxef.getBrowserInfo)();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveUp).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $1ddf8f052569320c$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $44cyU.keymap)(list);
}



var $LQnOI = parcelRequire("LQnOI");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");


var $3k3tn = parcelRequire("3k3tn");


var $kpCD8 = parcelRequire("kpCD8");


var $jWZvv = parcelRequire("jWZvv");








var $bwuOg = parcelRequire("bwuOg");








var $gofTh = parcelRequire("gofTh");


var $hMfrQ = parcelRequire("hMfrQ");


var $fqVYq = parcelRequire("fqVYq");


var $fTaxX = parcelRequire("fTaxX");


const $e90bca6485b64918$export$7da1e5b9c509a0c1 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $fTaxX.blockCardNodeView)(props);
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("fTaxX"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};









var $hvdgP = parcelRequire("hvdgP");


const $385788f5958a7d1b$export$eb946eb841dd1469 = (props)=>{
    const { isPageSSRed: isPageSSRed } = props;
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed) return (0, $hvdgP.embedCardNodeView)(props);
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("hvdgP"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};






var $ieeJu = parcelRequire("ieeJu");








const $5a0a9ec159d3141a$export$cd3f6a9b84ab8435 = (props)=>{
    const { isPageSSRed: isPageSSRed = false } = props;
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false) || (0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) || isPageSSRed) return (0, $gofTh.inlineCardNodeView)(props);
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("gofTh"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};



var $73Kv0 = parcelRequire("73Kv0");


var $kVd8s = parcelRequire("kVd8s");


var $krYZG = parcelRequire("krYZG");


var $brzQy = parcelRequire("brzQy");


var $gWBVp = parcelRequire("gWBVp");

var $2w79Z = parcelRequire("2w79Z");


var $eOaGc = parcelRequire("eOaGc");


var $kcs7l = parcelRequire("kcs7l");


var $8AEvG = parcelRequire("8AEvG");


var $aeh46 = parcelRequire("aeh46");


var $kwknI = parcelRequire("kwknI");

const $0689742eae39d3a4$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $0689742eae39d3a4$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $0689742eae39d3a4$var$isTransactionResolveReplace(tr);
    const isAutoConvert = $0689742eae39d3a4$var$isAutoConvertTr(tr);
    // History
    const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
    const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $0689742eae39d3a4$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $eOaGc.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $kwknI.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $gWBVp.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $kwknI.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $kwknI.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $kwknI.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $kwknI.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $kwknI.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $0689742eae39d3a4$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet.
		 * Also skip when the transaction is an auto-convert
		 * (e.g. a pasted link being converted to a native embed extension),
		 * because the link is being converted, not deleted by the user.
		 */ if (!isResolveReplace && !isAutoConvert) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $0689742eae39d3a4$var$getResolvePositions(tr, state);
        inserted.push(...(0, $kwknI.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $kwknI.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $0689742eae39d3a4$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $kwknI.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $kwknI.getNodeSubject)(inserted[i].node);
            if ($0689742eae39d3a4$var$isDatasourceUpgrade(previousSubject, currentSubject) || $0689742eae39d3a4$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $0689742eae39d3a4$var$UPDATE_ACTIONS = [
    (0, $krYZG.ACTION).CHANGED_TYPE,
    (0, $krYZG.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $0689742eae39d3a4$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $0689742eae39d3a4$var$UPDATE_ACTIONS.includes(action);
    });
};
const $0689742eae39d3a4$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $0689742eae39d3a4$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $kcs7l.pluginKey));
    return $0689742eae39d3a4$var$isMetadataQueue(pluginMeta);
};
const $0689742eae39d3a4$var$isMetadataQueue = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $0689742eae39d3a4$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $kcs7l.pluginKey));
    return $0689742eae39d3a4$var$isMetadataResolve(pluginMeta);
};
/**
 * Checks if the transaction is an auto-convert action
 * (e.g. a pasted link being converted to a native embed extension node).
 * In this case the link removal should not be tracked as a deletion.
 */ const $0689742eae39d3a4$var$isAutoConvertTr = (tr)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return false;
        return step.getMetadata().cardAction === 'AUTO_CONVERT';
    });
};
const $0689742eae39d3a4$var$isMetadataResolve = (metaData)=>{
    return $0689742eae39d3a4$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $0689742eae39d3a4$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $0689742eae39d3a4$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $kcs7l.pluginKey));
    if (!$0689742eae39d3a4$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $0689742eae39d3a4$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $8AEvG.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $kcs7l.pluginKey));
    if (!$0689742eae39d3a4$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $0689742eae39d3a4$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $8AEvG.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $0689742eae39d3a4$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $aeh46.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $aeh46.EVENT_SUBJECT).LINK;
const $0689742eae39d3a4$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $aeh46.EVENT_SUBJECT).LINK && currentSubject === (0, $aeh46.EVENT_SUBJECT).DATASOURCE;
function $0689742eae39d3a4$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $kVd8s.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $2w79Z.pmHistoryPluginKey));
        const isUndo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $0689742eae39d3a4$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $brzQy.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $0689742eae39d3a4$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $kwknI.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $kwknI.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $aeh46.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $kwknI.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $aeh46.EVENT).DELETED);
        pushEvents(inserted, (0, $aeh46.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}






var $4eqn3 = parcelRequire("4eqn3");

const $763d543a43740aab$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];


const $d456c0380d476625$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $bjg0G.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $4eqn3.isDatasourceNode)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $d456c0380d476625$export$8467cbb601c13bfc = (layout)=>{
    return (0, $763d543a43740aab$export$3f155c85880510c8).some((l)=>l === layout);
};



var $eHuhD = parcelRequire("eHuhD");







const $9a3e82568f11edf8$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $9a3e82568f11edf8$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $9a3e82568f11edf8$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $9a3e82568f11edf8$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $9a3e82568f11edf8$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $9a3e82568f11edf8$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $9a3e82568f11edf8$var$setResolvedToolbarAttributes = (state, action)=>{
    return {
        ...state,
        resolvedToolbarAttributesByUrl: {
            ...state.resolvedToolbarAttributesByUrl,
            [action.url]: action.attributes
        }
    };
};
const $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $9a3e82568f11edf8$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $9a3e82568f11edf8$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $9a3e82568f11edf8$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $9a3e82568f11edf8$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $9a3e82568f11edf8$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $9a3e82568f11edf8$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $9a3e82568f11edf8$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $9a3e82568f11edf8$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $9a3e82568f11edf8$var$queue(state, action);
        case 'SET_PROVIDER':
            return $9a3e82568f11edf8$var$setProvider(state, action);
        case 'RESOLVE':
            return $9a3e82568f11edf8$var$resolve(state, action);
        case 'REGISTER':
            return $9a3e82568f11edf8$var$register(state, action);
        case 'REMOVE_CARD':
            return $9a3e82568f11edf8$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $9a3e82568f11edf8$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setDatasourceTableRef(state, action);
        case 'SET_RESOLVED_TOOLBAR_ATTRIBUTES':
            return $9a3e82568f11edf8$var$setResolvedToolbarAttributes(state, action);
        case 'SET_CARD_LAYOUT':
            return $9a3e82568f11edf8$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $9a3e82568f11edf8$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $9a3e82568f11edf8$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $9a3e82568f11edf8$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $9a3e82568f11edf8$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $9a3e82568f11edf8$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $9a3e82568f11edf8$var$removeDatasourceStash(state, action);
    }
};













const $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $2w79Z.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $1552bb88269ab2b0$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>{
    const isEmbedFriendlyLocation = $1552bb88269ab2b0$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($1552bb88269ab2b0$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer), $1552bb88269ab2b0$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $1552bb88269ab2b0$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $k3XQC.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $1552bb88269ab2b0$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer)=>(resolvedCard)=>{
        $1552bb88269ab2b0$var$updateCardType(resolvedCard, options);
        (0, $6JWmx.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)(view.state, view.dispatch);
        return resolvedCard;
    };
const $1552bb88269ab2b0$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $6JWmx.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $1552bb88269ab2b0$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $cbp6v.setProvider)(cardProvider)(state.tr));
    });
};








const $ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
// Only the first resolved inline smart link is needed for PO spotlight targeting
const $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS = 1;
const $ce69229594a80c43$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $8AEvG.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $cbp6v.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $ce69229594a80c43$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, smartCardContext: smartCardContext, embedCardTransformers: embedCardTransformers } = options;
        const intl = pmPluginFactoryParams.getIntl();
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $3k3tn.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $gofTh.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? undefined : CompetitorPrompt,
                intl: (0, $iAEsk.isSSRStreaming)() ? intl : undefined,
                smartCardContext: (0, $iAEsk.isSSRStreaming)() ? smartCardContext : undefined
            }
        });
        return new (0, $kpCD8.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        resolvedToolbarAttributesByUrl: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        embedCardTransformers: embedCardTransformers,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $8AEvG.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $kcs7l.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $0689742eae39d3a4$export$c985b35883eaea59)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $kCECX.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    const newState = (0, $9a3e82568f11edf8$export$2e2bcd8739ae039)(pluginStateWithUpdatedPos, meta);
                    // Track the first resolved inline smart link for PO spotlight DOM targeting
                    if (meta.type === 'RESOLVE' && pluginState?.requests?.length && (0, $mW7G5.expVal)('cc_dnd_smart_link_changeboard_platform_css', 'isEnabled', false) && (0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) {
                        const resolvedRequest = pluginState.requests.find((req)=>req.url === meta.url);
                        if (resolvedRequest?.appearance === 'inline') {
                            if ((newState.resolvedInlineSmartLinks?.length ?? 0) < $ce69229594a80c43$var$MAX_RESOLVED_INLINE_SMART_LINKS) newState.resolvedInlineSmartLinks = [
                                ...newState.resolvedInlineSmartLinks ?? [],
                                {
                                    pos: resolvedRequest.pos,
                                    url: resolvedRequest.url,
                                    source: resolvedRequest.source
                                }
                            ];
                        }
                    }
                    if (!enableInlineUpgradeFeatures) return newState;
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $eHuhD.isLocalStorageKeyDiscovered)($ce69229594a80c43$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $4eqn3.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $4eqn3.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $1552bb88269ab2b0$export$96766f42428c9e7f)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $8AEvG.getPluginState)(view.state);
                        const oldState = (0, $8AEvG.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $bjg0G.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $jWZvv.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $d456c0380d476625$export$8467cbb601c13bfc)(node.attrs.layout) ? node.attrs.layout : (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $cbp6v.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $cbp6v.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $8AEvG.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $LQnOI.default)(()=>(0, $1552bb88269ab2b0$export$2007d0af08977743)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined, currentState?.embedCardTransformers?.embedCardNodeTransformer));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $5a0a9ec159d3141a$export$cd3f6a9b84ab8435)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $e90bca6485b64918$export$7da1e5b9c509a0c1)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? undefined : options.CompetitorPrompt,
                        intl: (0, $iAEsk.isSSRStreaming)() ? intl : undefined,
                        smartCardContext: (0, $iAEsk.isSSRStreaming)() ? smartCardContext : undefined
                    }),
                    embedCard: (0, $385788f5958a7d1b$export$eb946eb841dd1469)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? undefined : options.CompetitorPrompt,
                        intl: (0, $iAEsk.isSSRStreaming)() ? intl : undefined,
                        smartCardContext: (0, $iAEsk.isSSRStreaming)() ? smartCardContext : undefined
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $ce69229594a80c43$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $kcs7l.pluginKey)
        });
    };








const $e998f3a2cd995bba$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};






var $3k5Tv = parcelRequire("3k5Tv");






var $b1qV0 = parcelRequire("b1qV0");





var $dil4b = parcelRequire("dil4b");














var $cRImW = parcelRequire("cRImW");

const $9d9da0fd42d14aef$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $9d9da0fd42d14aef$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $cozmU.useCallback)(()=>{
        dispatch((0, $cbp6v.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $9d9da0fd42d14aef$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $9d9da0fd42d14aef$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $cRImW.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $9d9da0fd42d14aef$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $cozmU.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $6JWmx.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $6JWmx.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $9d9da0fd42d14aef$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $9d9da0fd42d14aef$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};


const $0b5999f9a6963362$var$selector = (states)=>{
    return {
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $0b5999f9a6963362$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $cMyWi.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $0b5999f9a6963362$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $0b5999f9a6963362$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dil4b.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d9da0fd42d14aef$export$95702e90d329951a), {
        view: editorView,
        cardContext: cardContext,
        datasourceId: datasourceId,
        componentType: componentType
    }));
};
const $0b5999f9a6963362$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0b5999f9a6963362$var$ModalWithState, {
        api: api,
        editorView: editorView
    }));
});
const $0b5999f9a6963362$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $b1qV0.default),
        datasourceId: (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $2WEO5.default),
        datasourceId: (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $ao034.default),
        datasourceId: (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $0b5999f9a6963362$export$2e2bcd8739ae039 = $0b5999f9a6963362$var$SafeModalWithState;









var $byDyt = parcelRequire("byDyt");





var $dgpXm = parcelRequire("dgpXm");





var $2iGHk = parcelRequire("2iGHk");

var $9DHhW = parcelRequire("9DHhW");


var $3u1Hp = parcelRequire("3u1Hp");


var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $d6a5e4838fef7689$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("6MSGo"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};











/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $46b2e73c10a9bafa$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $46b2e73c10a9bafa$export$8793fab959da70d1 = $46b2e73c10a9bafa$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $krYZG.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $krYZG.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $krYZG.INPUT_METHOD).AUTO_DETECT:
        case (0, $krYZG.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $krYZG.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $krYZG.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $krYZG.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$df2aa842dc5172b0 = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $krYZG.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $krYZG.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $46b2e73c10a9bafa$export$1cf3d8365b174bde = $46b2e73c10a9bafa$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $krYZG.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $46b2e73c10a9bafa$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $dgpXm.default) ? metadata.sourceEvent : null;
};


function $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $60ed0d15f281c988$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $dgpXm.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $60ed0d15f281c988$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $60ed0d15f281c988$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $dgpXm.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $60ed0d15f281c988$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $60ed0d15f281c988$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $60ed0d15f281c988$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $d6a5e4838fef7689$export$c82e48d9fd97c55b)();
    const eventHandlers = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $aeh46.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $aeh46.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $aeh46.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $60ed0d15f281c988$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
   * Subscribe to datasource events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $aeh46.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};






var $8hDyr = parcelRequire("8hDyr");








/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $5981dd7300ead08c$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $5981dd7300ead08c$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
   * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
   * to defer any heavy operations involving network
   *
   * The callbacks themselves should not be deferred, they should be called syncronously the moment
   * the events take place.
   */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $8hDyr.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $cozmU.useMemo)(()=>{
        return {
            [(0, $aeh46.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $kwknI.getUrl)(node);
                if (!url) return;
                const display = (0, $kwknI.appearanceForLink)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const creationMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $aeh46.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $kwknI.getUrl)(node);
                if (!url) return;
                const display = (0, $kwknI.appearanceForLink)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const updateMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const updateType = (0, $46b2e73c10a9bafa$export$df2aa842dc5172b0)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $aeh46.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $kwknI.getUrl)(node);
                if (!url) return;
                const display = (0, $kwknI.appearanceForLink)(node);
                const displayCategory = $5981dd7300ead08c$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $46b2e73c10a9bafa$export$b3b4df0d75d4c011)(metadata);
                const deleteMethod = (0, $46b2e73c10a9bafa$export$8793fab959da70d1)(metadata);
                const deleteType = (0, $46b2e73c10a9bafa$export$1cf3d8365b174bde)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
   * Subscribe to link events
   */ (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $aeh46.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};


class $2b23ce52995f75a4$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        if (!this.props.editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.EditorSmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $byDyt.EditorAnalyticsContext), {
            editorView: this.props.editorView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5981dd7300ead08c$export$aa142efb89c75ed5), this.props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60ed0d15f281c988$export$bddcbec746c26287), this.props))));
    }
}






var $19KQj = parcelRequire("19KQj");




const $9643dc942ac34a79$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $19KQj.useSmartLinkEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!events || !editorView) return;
        editorView.dispatch((0, $cbp6v.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $7XIuB = parcelRequire("7XIuB");


var $ldbHR = parcelRequire("ldbHR");


var $keRDK = parcelRequire("keRDK");

var $3LJVu = parcelRequire("3LJVu");


var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");











const $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: `${"var(--ds-background-neutral, #0515240F)"}`,
    color: `${"var(--ds-icon, #292A2E)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, #292A2E)"} !important`
    }
});
const $b4dc197bbbd70ac9$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $keRDK.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $cozmU.useMemo)(()=>{
        return formatMessage((0, $3LJVu.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        testId: testId,
        css: $b4dc197bbbd70ac9$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
            label: title
        }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
            label: title
        })
    }));
};
const $b4dc197bbbd70ac9$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $b4dc197bbbd70ac9$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $b4dc197bbbd70ac9$var$selector);
    const isDatasource = (0, $4eqn3.isDatasourceNode)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $d456c0380d476625$export$32844f9f273856e4)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $cbp6v.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)($b4dc197bbbd70ac9$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $d456c0380d476625$export$8467cbb601c13bfc)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
const $b4dc197bbbd70ac9$var$_default_1 = (0, $kSwu1.injectIntl)($b4dc197bbbd70ac9$var$LayoutButtonWrapper);
var $b4dc197bbbd70ac9$export$2e2bcd8739ae039 = $b4dc197bbbd70ac9$var$_default_1;


/* PasteDisplayAsMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $w6R6I = parcelRequire("w6R6I");


var $gxKDp = parcelRequire("gxKDp");





var $9bUBT = parcelRequire("9bUBT");


var $3nacY = parcelRequire("3nacY");

var $bFSJa = parcelRequire("bFSJa");


var $iso5o = parcelRequire("iso5o");


var $aPdNQ = parcelRequire("aPdNQ");





var $jgJIe = parcelRequire("jgJIe");

var $kwf4Z = parcelRequire("kwf4Z");


var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");





var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");







const $b980ccc002387570$var$getUrlFromTextLinkNode = (node)=>{
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = node.marks[0].attrs?.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $b980ccc002387570$var$getUrlFromInlineCardNode = (node)=>{
    if (node.type.name !== 'inlineCard') return undefined;
    const url = node.attrs?.url;
    return typeof url === 'string' ? url : undefined;
};
const $b980ccc002387570$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
const $b980ccc002387570$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $b980ccc002387570$var$getUrlFromTextLinkNode(topNode) ?? $b980ccc002387570$var$getUrlFromInlineCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $b980ccc002387570$var$significantChildren(topNode.content);
    if (children.length !== 1) return undefined;
    return $b980ccc002387570$var$getUrlFromTextLinkNode(children[0]) ?? $b980ccc002387570$var$getUrlFromInlineCardNode(children[0]);
};


const $ec88e53192e5c284$export$96b638002b74480f = [
    'url',
    'inline',
    'block',
    'embed'
];
const $ec88e53192e5c284$export$bfdec0913b4999e8 = (state, pasteStartPos, pasteEndPos)=>{
    let result;
    const docContentSize = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, docContentSize));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, docContentSize));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    try {
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type.name === 'inlineCard' || node.type.name === 'blockCard' || node.type.name === 'embedCard') {
                result = {
                    appearance: node.type.name === 'inlineCard' ? 'inline' : node.type.name === 'blockCard' ? 'block' : 'embed',
                    pos: pos
                };
                return false;
            }
            return true;
        });
    } catch  {
        return;
    }
    return result;
};


const $7e51d18aba717b05$export$3360e99680efcdd8 = 'smart-link-display-as-paste-menu-section';
const $7e51d18aba717b05$var$styles = {
    appearanceBox: "_2rko1qi0 _bfhkhfxm _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    iconWrapper: "_bfhkvuon _1e0c1txw _1bsb1osq _1bah1b1v",
    iconButton: "_2rko1qi0 _1h6d1l7x _1dqonqa1 _189ee4h9 _4cvr1h6o _syazi7uo _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek",
    iconButtonSelected: "_2rko1qi0 _1h6dq98m _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhk15s3 _syazi7uo _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq _irr3ufnl _1di6nozp",
    iconButtonDisabled: "_2rko1qi0 _1h6dbk0g _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhk187o _syaz1gmx _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq"
};
const $7e51d18aba717b05$var$AppearanceOptionIconButton = ({ appearance: appearance, currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, Icon: Icon, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $7e51d18aba717b05$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: (0, $w6R6I.cx)($7e51d18aba717b05$var$styles.iconButton, isDisabled && $7e51d18aba717b05$var$styles.iconButtonDisabled, !isDisabled && currentAppearance === appearance && $7e51d18aba717b05$var$styles.iconButtonSelected),
        "aria-label": label,
        "aria-pressed": currentAppearance === appearance,
        isDisabled: isDisabled,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label
    })));
};
const $7e51d18aba717b05$var$InlineAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "inline",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$BlockAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "block",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$EmbedAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "embed",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))),
        onClick: onClick
    });
const $7e51d18aba717b05$var$getCurrentPastedSlice = (api)=>{
    const apiWithPaste = api;
    const pasteState = apiWithPaste?.paste?.sharedState.currentState();
    const slice = pasteState?.lastContentPasted?.pastedSlice;
    return slice;
};
const $7e51d18aba717b05$var$getCardUrlAtPasteRange = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos })=>{
    const cardAtPasteRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteStartPos, pasteEndPos);
    const maybeAttrs = cardAtPasteRange ? editorView.state.doc.nodeAt(cardAtPasteRange.pos)?.attrs : undefined;
    const maybeUrl = maybeAttrs?.url ?? maybeAttrs?.data?.url;
    return typeof maybeUrl === 'string' ? maybeUrl : undefined;
};
const $7e51d18aba717b05$export$790142d87e85490c = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, targetPos: targetPos })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const maxPos = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, maxPos));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, maxPos));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    const isTargetPosInBounds = targetPos !== undefined && targetPos >= 0 && targetPos <= state.doc.content.size;
    try {
        const nextSelection = isTargetPosInBounds && targetPos !== undefined ? (0, $kCECX.NodeSelection).create(state.doc, targetPos) : (0, $kCECX.TextSelection).create(state.doc, from, to);
        const tr = state.tr.setSelection(nextSelection);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};
const $7e51d18aba717b05$export$1c4f761565a0a1c6 = (editorView)=>{
    const { state: state } = editorView;
    const linkMarkType = state.schema.marks.link;
    if (!linkMarkType) return;
    let firstLinkRange;
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        if (firstLinkRange || !node.isText) return;
        if (linkMarkType.isInSet(node.marks)) firstLinkRange = {
            from: pos,
            to: pos + node.nodeSize
        };
    });
    return firstLinkRange;
};
const $7e51d18aba717b05$export$50ed46eb055a4a90 = ({ editorView: editorView, targetPos: targetPos })=>{
    if (targetPos !== undefined || (0, $9bUBT.getActiveLinkMark)(editorView.state)) return;
    const firstLinkRange = $7e51d18aba717b05$export$1c4f761565a0a1c6(editorView);
    if (!firstLinkRange) return;
    const linkRangeSelectionTr = editorView.state.tr.setSelection((0, $kCECX.TextSelection).create(editorView.state.doc, firstLinkRange.from, firstLinkRange.to));
    editorView.dispatch(linkRangeSelectionTr);
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const toolbarDropdownMenu = (0, $kwf4Z.useToolbarDropdownMenu)();
    const smartCardContext = (0, $cMyWi.useSmartCardContext)();
    const frameRef = (0, $cozmU.useRef)(null);
    const isApplyingRef = (0, $cozmU.useRef)(false);
    const apiWithPasteOptionsToolbar = api;
    const pasteRange = (0, $3k5Tv.useSharedPluginStateWithSelector)(apiWithPasteOptionsToolbar, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return pluginState ? {
            pasteEndPos: pluginState.pasteEndPos,
            pasteStartPos: pluginState.pasteStartPos
        } : undefined;
    }); // Subscribe to card state so the menu re-renders when resolved card metadata updates.
    (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'card'
    ], (states)=>{
        return states.cardState;
    });
    const pastedLinkUrlFromSlice = (0, $b980ccc002387570$export$6f4c320e305ef7dc)($7e51d18aba717b05$var$getCurrentPastedSlice(api));
    const pastedLinkUrlFromCard = editorView && pasteRange ? $7e51d18aba717b05$var$getCardUrlAtPasteRange({
        editorView: editorView,
        pasteStartPos: pasteRange.pasteStartPos,
        pasteEndPos: pasteRange.pasteEndPos
    }) : undefined;
    const pastedLinkUrl = pastedLinkUrlFromSlice ?? pastedLinkUrlFromCard;
    const pastedLinkUrlState = pastedLinkUrl ? smartCardContext.value?.store?.getState()?.[pastedLinkUrl] : undefined;
    const hasResolvedSmartLinkData = Boolean(pastedLinkUrlState?.details);
    const currentAppearance = editorView && pasteRange ? (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(editorView.state, pasteRange.pasteStartPos, pasteRange.pasteEndPos)?.appearance ?? 'url' : undefined;
    const handleClick = (0, $cozmU.useCallback)((appearance)=>()=>{
            if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance || isApplyingRef.current) return;
            isApplyingRef.current = true;
            const { state: state, dispatch: dispatch } = editorView;
            const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteRange;
            const cardAtPasteRange = (0, $ec88e53192e5c284$export$bfdec0913b4999e8)(state, pasteStartPos, pasteEndPos);
            if (appearance === 'url') {
                if (cardAtPasteRange) (0, $6JWmx.changeSelectedCardToLink)(pastedLinkUrl, pastedLinkUrl, true, state.doc.nodeAt(cardAtPasteRange.pos) ?? undefined, cardAtPasteRange.pos, api?.analytics?.actions)(state, dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            const targetPos = cardAtPasteRange?.pos;
            if (targetPos !== undefined && targetPos < pasteStartPos) {
                isApplyingRef.current = false;
                return;
            }
            const didApplySelection = $7e51d18aba717b05$export$790142d87e85490c({
                editorView: editorView,
                pasteStartPos: pasteStartPos,
                pasteEndPos: pasteEndPos,
                targetPos: targetPos
            });
            if (!didApplySelection) {
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            $7e51d18aba717b05$export$50ed46eb055a4a90({
                editorView: editorView,
                targetPos: targetPos
            });
            frameRef.current = requestAnimationFrame(()=>{
                frameRef.current = null;
                (0, $6JWmx.setSelectedCardAppearance)(appearance, api?.analytics?.actions)(editorView.state, editorView.dispatch, editorView);
                toolbarDropdownMenu?.closeMenu(null);
                isApplyingRef.current = false;
            });
        }, [
        api,
        currentAppearance,
        editorView,
        pasteRange,
        pastedLinkUrl,
        toolbarDropdownMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
            isApplyingRef.current = false;
        };
    }, []);
    if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance) return null;
    const preview = allowEmbeds && pastedLinkUrl && smartCardContext.value?.extractors.getPreview(pastedLinkUrl, 'web');
    const blockCardNodeType = editorView.state.schema.nodes.blockCard;
    const embedCardNodeType = editorView.state.schema.nodes.embedCard;
    const isBlockSupportedFromAppearanceContext = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isEmbedSupportedFromAppearanceContext = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isSmartLinkConvertible = hasResolvedSmartLinkData;
    const isBlockSupportedFromSelection = allowBlockCards && blockCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(blockCardNodeType.createChecked({})), undefined);
    const isEmbedSupportedFromSelection = allowEmbeds && preview && embedCardNodeType && (0, $iso5o.isSupportedInParent)(editorView.state, (0, $aPdNQ.Fragment).from(embedCardNodeType.createChecked({})), undefined);
    const isBlockSupported = Boolean(isBlockSupportedFromAppearanceContext || isBlockSupportedFromSelection);
    const isEmbedSupported = Boolean(isEmbedSupportedFromAppearanceContext || isEmbedSupportedFromSelection);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $7e51d18aba717b05$var$styles.appearanceBox,
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$AppearanceOptionIconButton, {
        appearance: "url",
        currentAppearance: currentAppearance,
        isDisabled: false,
        label: intl.formatMessage((0, $gxKDp.appearancePropsMap).url.title),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
        onClick: handleClick('url')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$InlineAppearanceIconButton, {
        currentAppearance: currentAppearance,
        isDisabled: !isSmartLinkConvertible,
        label: intl.formatMessage((0, $gxKDp.appearancePropsMap).inline.title),
        onClick: handleClick('inline')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$BlockAppearanceIconButton, {
        currentAppearance: currentAppearance,
        isDisabled: !isSmartLinkConvertible || !isBlockSupported,
        label: intl.formatMessage((0, $gxKDp.appearancePropsMap).block.title),
        onClick: handleClick('block')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$EmbedAppearanceIconButton, {
        currentAppearance: currentAppearance,
        isDisabled: !isEmbedSupported,
        label: intl.formatMessage((0, $gxKDp.appearancePropsMap).embed.title),
        onClick: handleClick('embed')
    }));
};
const $7e51d18aba717b05$var$PasteDisplayAsMenuSection = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        title: intl.formatMessage({
            defaultMessage: "Display as",
            id: "fabric.editor.pasteDisplayAsMenu.displayAs"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$PasteDisplayAsMenuHorizontalView, {
        api: api,
        allowBlockCards: allowBlockCards,
        allowEmbeds: allowEmbeds
    }));
};
const $7e51d18aba717b05$export$996593790cad4497 = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, getEditorView: getEditorView, smartCardClientRef: smartCardClientRef })=>{
    const smartlinkAsyncHidden = async (context)=>{
        const { pastedUrl: pastedUrl } = context;
        if (!pastedUrl) return false;
        const isEnabled = (0, $ieeJu.expValEquals)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true);
        const smartCardClient = smartCardClientRef?.current;
        if (!isEnabled || !smartCardClient) return true;
        try {
            const response = await smartCardClient.fetchData(pastedUrl);
            return response.meta?.access !== 'granted';
        } catch  {
            // Network / auth errors → hide
            return true;
        }
    };
    return [
        {
            type: 'menu-section',
            key: $7e51d18aba717b05$export$3360e99680efcdd8,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: 60
                }
            ],
            isAsyncHidden: smartlinkAsyncHidden,
            isHidden: ()=>{
                if (!(0, $ieeJu.expValEquals)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                const apiWithPasteOptionsToolbar = api;
                const pasteRange = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                const editorView = getEditorView();
                if (!editorView || !pasteRange) return true;
                 // Slice-shape check — delegated to the toolbar plugin's shared
                // `notSingleLinkRule` via the structural cast (see note above).
                const rules = apiWithPasteOptionsToolbar?.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules();
                if (!rules || rules.notSingleLinkRule()) return true;
                 // Fallback: plain-text URL paste that the card plugin already resolved into a card node in the doc.
                const urlFromCard = $7e51d18aba717b05$var$getCardUrlAtPasteRange({
                    editorView: editorView,
                    pasteStartPos: pasteRange.pasteStartPos,
                    pasteEndPos: pasteRange.pasteEndPos
                });
                return !urlFromCard;
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e51d18aba717b05$var$PasteDisplayAsMenuSection, {
                    api: api,
                    allowBlockCards: allowBlockCards,
                    allowEmbeds: allowEmbeds
                })
        }
    ];
};



var $brpLB = parcelRequire("brpLB");

const $d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync = ({ clientRef: clientRef })=>{
    const smartCardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    (0, $cozmU.useEffect)(()=>{
        clientRef.current = smartCardContext?.connections?.client;
    }, [
        clientRef,
        smartCardContext?.connections?.client
    ]);
    return null;
};
const $d58cf3f7a16e5010$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $e998f3a2cd995bba$export$5115a388c364848d)();
    let instanceEmbedCardTransformers = options.embedCardTransformers;
    let editorViewForPasteMenu;
    const pasteMenuSmartCardClientRef = {
        current: undefined
    };
    const pasteMenuVariant = (0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    const shouldRegisterPasteDisplayAsMenu = options.enablePasteDisplayAsMenu && [
        'hasSpellingAndGrammar',
        'hasAltAiActions'
    ].includes(pasteMenuVariant);
    if (shouldRegisterPasteDisplayAsMenu) api?.uiControlRegistry?.actions.register((0, $7e51d18aba717b05$export$996593790cad4497)({
        api: api,
        allowBlockCards: options.onlyInlineCards ? false : options.allowBlockCards ?? true,
        allowEmbeds: options.onlyInlineCards ? false : options.allowEmbeds,
        getEditorView: ()=>editorViewForPasteMenu,
        smartCardClientRef: pasteMenuSmartCardClientRef
    }));
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $kcs7l.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $7e11113c0b6b9b64$export$290edac762b9f37c)()
                }
            ];
            // `onlyInlineCards` is a hard gate: when set, blockCard/embedCard
            // stay out of the schema regardless of allowBlockCards/allowEmbeds.
            if (options.onlyInlineCards) return nodes;
            nodes.push({
                name: 'blockCard',
                node: (0, $dc39c5d622176d3d$export$f664dd11022c8749)()
            });
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $75ce2aa51e74c7ef$export$f8faabd3267a007e)()
            });
            return nodes;
        },
        pmPlugins () {
            // onlyInlineCards forces block/embed off regardless of caller-passed flags,
            // keeping the schema gate (in nodes()) and the runtime gate in sync.
            const allowBlockCards = options.onlyInlineCards ? false : options.allowBlockCards ?? true;
            const allowEmbeds = options.onlyInlineCards ? false : options.allowEmbeds;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $ce69229594a80c43$export$ae829ec7b2625219)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowEmbeds: allowEmbeds,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        embedCardTransformers: instanceEmbedCardTransformers,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $1ddf8f052569320c$export$fc7a7a088775f35d)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            editorViewForPasteMenu = editorView;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRegisterPasteDisplayAsMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d58cf3f7a16e5010$var$PasteMenuSmartCardClientSync, {
                clientRef: pasteMenuSmartCardClientRef
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9643dc942ac34a79$export$e7d7ea2bc9a806d9), {
                editorView: editorView
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2b23ce52995f75a4$export$c083a9ed3df8f5ac), {
                cardPluginEvents: cardPluginEvents,
                editorView: editorView
            }), breakoutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4dc197bbbd70ac9$export$2e2bcd8739ae039), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                scrollableElement: popupsScrollableElement,
                boundariesElement: popupsBoundariesElement
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b5999f9a6963362$export$2e2bcd8739ae039), {
                api: api,
                editorView: editorView
            }));
        },
        commands: {
            queueCardsFromRange: (from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)=>({ tr: tr })=>(0, $6JWmx.queueCardsFromRange)(// Synthesise the minimal EditorState shape the impl actually reads.
                    {
                        schema: tr.doc.type.schema,
                        selection: tr.selection
                    }, tr, from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $cbp6v.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $cbp6v.hideLinkToolbar,
            queueCardsFromChangedTr: $6JWmx.queueCardsFromChangedTr,
            queueCardsFromRange: $6JWmx.queueCardsFromRange,
            registerEmbedCardTransformer: (transformers)=>{
                instanceEmbedCardTransformers = transformers;
            },
            resolveShortLinkUrl: async (url)=>{
                if (!options.provider) return undefined;
                try {
                    const provider = await options.provider;
                    // EditorCardProvider holds a CardClient instance internally. We access it
                    // directly to call fetchData, which gives us the raw ORS JSON-LD response
                    // including the canonical url field — something provider.resolve() does not
                    // surface. This is intentionally a structural cast rather than a typed
                    // dependency on EditorCardProvider's private API.
                    const clientHolder = provider;
                    const client = clientHolder.cardClient;
                    if (!client) return undefined;
                    const response = await client.fetchData(url);
                    // ORS returns a JsonLd.Response whose data union includes BaseData,
                    // BaseCollectionData, and BaseCollectionPage. We only care about the
                    // `url` field which is present on BaseData (Primitives.Object). Cast
                    // to a minimal shape rather than accessing through the full union type.
                    const data = response?.data;
                    if (!data) return undefined;
                    const urlField = data.url;
                    // Property<string | Link> can be a string, a Link object, or an array.
                    // Short-link responses always return a plain string URL.
                    if (typeof urlField === 'string' && urlField !== url) return urlField;
                    // Fallback: Link object shape with href or @id
                    if (urlField && typeof urlField === 'object' && !Array.isArray(urlField)) {
                        const linkObj = urlField;
                        const id = linkObj['@id'] ?? linkObj['href'];
                        if (typeof id === 'string' && id !== url) return id;
                    }
                } catch  {
                // Swallow errors — callers handle undefined
                }
                return undefined;
            },
            getStartingToolbarItems: (0, $brpLB.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $brpLB.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $brpLB.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssue),
                    description: formatMessage((0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? (0, $bI2nS.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $bI2nS.messages).datasourceJiraIssueDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    ...(0, $ixfCV.fg)('jim-lower-ranking-in-jira-macro-search') && {
                        priority: 500
                    },
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconDatasourceJiraIssue), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $cbp6v.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $k3XQC.canRenderDatasource)((0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $bI2nS.messages).datasourceAssetsObjectsDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconDatasourceAssetsObjects), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $cbp6v.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $4eqn3.isDatasourceConfigEditable)((0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $bI2nS.messages).datasourceConfluenceSearchDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconDatasourceConfluenceSearch), null),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $cbp6v.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};
module.exports["cardPlugin"] = $d58cf3f7a16e5010$export$2a6748328f902e16;

});

parcelRegister("gofTh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $LQnOI = parcelRequire("LQnOI");


var $iwjSV = parcelRequire("iwjSV");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $1jz5K = parcelRequire("1jz5K");

var $3F4bj = parcelRequire("3F4bj");


var $iIYTj = parcelRequire("iIYTj");


var $ixfCV = parcelRequire("ixfCV");


var $l8wPz = parcelRequire("l8wPz");


var $QXwxo = parcelRequire("QXwxo");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $mW7G5 = parcelRequire("mW7G5");


var $cbp6v = parcelRequire("cbp6v");


var $4eqn3 = parcelRequire("4eqn3");


var $cEgRX = parcelRequire("cEgRX");


var $brpLB = parcelRequire("brpLB");


var $gjNeV = parcelRequire("gjNeV");











var $b2XFx = parcelRequire("b2XFx");


var $kCECX = parcelRequire("kCECX");


var $jawC3 = parcelRequire("jawC3");


var $4aczz = parcelRequire("4aczz");


var $2Q7sv = parcelRequire("2Q7sv");


var $f21H2 = parcelRequire("f21H2");











var $kcs7l = parcelRequire("kcs7l");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $gBjHb = parcelRequire("gBjHb");











var $eHuhD = parcelRequire("eHuhD");

const $699123311af2c8a1$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $cozmU.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $cozmU.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $cozmU.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $cozmU.useMemo)(()=>isPulseEnabled && !(0, $eHuhD.isLocalStorageKeyDiscovered)((0, $eHuhD.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $699123311af2c8a1$export$2e2bcd8739ae039 = $699123311af2c8a1$var$useLinkUpgradeDiscoverability;


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $55fM8 = parcelRequire("55fM8");


var $kSwu1 = parcelRequire("kSwu1");


var $bI2nS = parcelRequire("bI2nS");


var $fngNp = parcelRequire("fngNp");


var $dPtk6 = parcelRequire("dPtk6");







const $d960cf2f754f7960$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $d960cf2f754f7960$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $d960cf2f754f7960$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $d960cf2f754f7960$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $d960cf2f754f7960$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};


function $81150d16e92dfb48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81150d16e92dfb48$var$DEBOUNCE_IN_MS = 5;
const $81150d16e92dfb48$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $81150d16e92dfb48$var$PADDING_IN_PX = 4;
const $81150d16e92dfb48$var$ICON_WIDTH_IN_PX = 14;
const $81150d16e92dfb48$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $81150d16e92dfb48$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $81150d16e92dfb48$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $81150d16e92dfb48$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $81150d16e92dfb48$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $81150d16e92dfb48$var$SMART_LINK_BACKGROUND_COLOR = "var(--ds-surface-raised, #FFFFFF)";
const $81150d16e92dfb48$var$SMART_LINK_ACTIVE_COLOR = "var(--ds-background-selected, #E9F2FE)";
const $81150d16e92dfb48$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $81150d16e92dfb48$var$containerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$81150d16e92dfb48$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $81150d16e92dfb48$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$81150d16e92dfb48$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $81150d16e92dfb48$var$getGradientWithColor($81150d16e92dfb48$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $81150d16e92dfb48$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $81150d16e92dfb48$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $81150d16e92dfb48$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $81150d16e92dfb48$var$labelStyles = {
    name: "1x9ph6u",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $81150d16e92dfb48$var$iconAndLabelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $81150d16e92dfb48$var$SMART_LINK_BACKGROUND_COLOR,
    color: "var(--ds-text-subtlest, #6B6E76)"
});
const $81150d16e92dfb48$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $81150d16e92dfb48$var$gradientStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $81150d16e92dfb48$var$getGradientWithColor($81150d16e92dfb48$var$SMART_LINK_BACKGROUND_COLOR)
});
const $81150d16e92dfb48$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $cozmU.useState)(false);
    const [showLabel, setShowLabel] = (0, $cozmU.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $cozmU.useState)(undefined);
    const maxOverlayWidth = (0, $cozmU.useRef)(0);
    const minOverlayWidth = (0, $cozmU.useRef)($81150d16e92dfb48$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $cozmU.useRef)(0);
    const containerRef = (0, $cozmU.useRef)(null);
    const setVisibility = (0, $cozmU.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $d960cf2f754f7960$export$a0e2858e1d1976ea)(containerRef, `.${$81150d16e92dfb48$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $d960cf2f754f7960$export$be02a7fcf666d65d)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $d960cf2f754f7960$export$ce3ffcce447cf028)(containerRef.current, marker) - $81150d16e92dfb48$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $81150d16e92dfb48$var$ICON_WIDTH_IN_PX + $81150d16e92dfb48$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $d960cf2f754f7960$export$a0e2858e1d1976ea)(containerRef, `.${$81150d16e92dfb48$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $d960cf2f754f7960$export$a0e2858e1d1976ea)(containerRef, `.${$81150d16e92dfb48$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $d960cf2f754f7960$export$bdfd7a9bf7c62c86)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($81150d16e92dfb48$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $81150d16e92dfb48$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const destinationUrl = (0, $f21H2.useDestinationUrl)(url) ?? url;
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage((0, $bI2nS.messages).inlineOverlay);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ...props,
        css: $81150d16e92dfb48$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "aria-hidden": "true",
        className: $81150d16e92dfb48$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $fngNp.ZERO_WIDTH_JOINER)), /*#__PURE__*/ (0, $lOiVq.jsx)("a", {
        css: [
            $81150d16e92dfb48$var$overlayStyles,
            showOverlay && $81150d16e92dfb48$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl : url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $81150d16e92dfb48$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $81150d16e92dfb48$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $81150d16e92dfb48$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $81150d16e92dfb48$var$iconStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
        label: label,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $81150d16e92dfb48$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $81150d16e92dfb48$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $81150d16e92dfb48$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $81150d16e92dfb48$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    }))))));
};
var $81150d16e92dfb48$export$2e2bcd8739ae039 = $81150d16e92dfb48$var$InlineCardOverlay;






var $7vzxX = parcelRequire("7vzxX");

function $030ee9b1d7c0f9ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $030ee9b1d7c0f9ec$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $030ee9b1d7c0f9ec$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $699123311af2c8a1$export$2e2bcd8739ae039)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $eHuhD.isLocalStorageKeyDiscovered)((0, $eHuhD.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $eHuhD.markLocalStorageKeyDiscovered)((0, $eHuhD.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $cozmU.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $cozmU.useMemo)(()=>{
        if (shouldShowLinkOverlay && !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && !(0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $81150d16e92dfb48$export$2e2bcd8739ae039), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onMouseEnter: ()=>handleOverlayChange(true),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: shouldShowLinkPulse && $030ee9b1d7c0f9ec$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gBjHb.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                attributes: (0, $4eqn3.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7vzxX.DiscoveryPulse), {
            localStorageKey: (0, $eHuhD.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $eHuhD.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay,
        isInline,
        placeholderUniqId
    ]);
};






var $gybyF = parcelRequire("gybyF");

const $92832cf5d4953875$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $gybyF.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $cozmU.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $cozmU.useCallback)(()=>{
        try {
            preview?.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        canPreview: !!preview,
        invokePreview: invokePreview
    }));
};



var $gofTh = parcelRequire("gofTh");

const $83775087cda75ea7$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $83775087cda75ea7$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isInserted, setIsInserted] = (0, $cozmU.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $cozmU.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const destinationUrl = (0, $f21H2.useDestinationUrl)(node.attrs.url);
    const onResolve = (0, $cozmU.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $kcs7l.pluginKey));
        if (metadata && metadata.type === 'REGISTER') (0, $cbp6v.registerRemoveOverlay)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $cbp6v.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $cozmU.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $cozmU.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $83775087cda75ea7$var$selector);
    const floatingToolbarNode = selection instanceof (0, $kCECX.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    });
    const innerCardWithOpenButtonOverlay = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2XFx.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            destinationUrl: destinationUrl,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gofTh.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            disablePreviewPanel: true
        })), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi,
        destinationUrl
    ]);
    const innerCardOriginal = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gofTh.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $cozmU.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return (mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless) && ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') || (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        }));
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view' && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
        exposure: true
    })) {
        const url = node.attrs.url;
        const cardState = cardContext?.value?.store?.getState()[url];
        if (cardState) {
            const ari = (0, $2Q7sv.getObjectAri)(cardState.details);
            const name = (0, $2Q7sv.getObjectName)(cardState.details);
            const iconUrl = (0, $2Q7sv.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && cardContext?.value?.isPreviewPanelAvailable?.({
                ari: ari
            });
            const openPreviewPanel = cardContext?.value?.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                const store = cardContext?.value?.store;
                const urlState = store?.getState()[url || ''];
                if (pluginInjectionApi?.analytics?.actions) pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HOVER_LABEL,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        previewType: previewType,
                        destinationProduct: urlState?.details?.meta?.product ?? null,
                        destinationSubproduct: urlState?.details?.meta?.subproduct ?? null
                    }
                });
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92832cf5d4953875$export$a43fddf3dfb4c066), {
                url: url,
                appearance: "inline"
            }, ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                // otherwise a use can click on smartlink itself to open the link in a new tab.
                const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                // When inside preview panel iframe, hide the overlay button
                const isInPreviewPanel = (0, $4aczz.isWithinPreviewPanelIFrame)();
                const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                if (isPreviewAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2XFx.default), {
                    isVisible: isResolvedViewRendered,
                    url: url,
                    destinationUrl: destinationUrl,
                    compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                    editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
                    view: view,
                    showPanelButton: showPanelButton,
                    showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (event)=>{
                        if (isPreviewPanelAvailable) {
                            event.preventDefault();
                            openPreviewPanel?.({
                                url: url,
                                ari: ari || '',
                                name: name || '',
                                iconUrl: iconUrl,
                                panelData: {
                                    embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $jawC3.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                                }
                            });
                            firePreviewPanelClickEvent({
                                previewType: 'panel'
                            });
                        } else if (isPreviewModalAvailable) {
                            event.preventDefault();
                            invokePreview?.();
                            firePreviewPanelClickEvent({
                                previewType: 'modal'
                            });
                        }
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gofTh.InlineCard), {
                    node: node,
                    view: view,
                    getPos: getPos,
                    useAlternativePreloader: useAlternativePreloader,
                    actionOptions: actionOptions,
                    onResolve: onResolve,
                    onClick: onClick,
                    cardContext: cardContext,
                    isHovered: isHovered,
                    isPageSSRed: isPageSSRed,
                    provider: provider,
                    pluginInjectionApi: pluginInjectionApi,
                    showHoverPreview: mode === 'view' && showHoverPreview,
                    disablePreviewPanel: true
                }));
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gofTh.InlineCard), {
                    node: node,
                    view: view,
                    getPos: getPos,
                    useAlternativePreloader: useAlternativePreloader,
                    actionOptions: actionOptions,
                    onResolve: onResolve,
                    onClick: onClick,
                    cardContext: cardContext,
                    isHovered: isHovered,
                    isPageSSRed: isPageSSRed,
                    provider: provider,
                    pluginInjectionApi: pluginInjectionApi,
                    showHoverPreview: mode === 'view' && showHoverPreview
                });
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $030ee9b1d7c0f9ec$export$cc11bcf19366e14b), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance
    }, innerCard) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`
    }, innerCard);
});


const $04040245a0d353eb$export$aff6291803939b05 = /*#__PURE__*/ (0, $cozmU.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))());
    const removeCardDispatched = (0, $cozmU.useRef)(false);
    const { getState: getSmartlinkState } = cardContext?.value?.store || {};
    const cardState = getSmartlinkState?.()[url || ''];
    (0, $cozmU.useEffect)(()=>{
        const id = refId.current;
        removeCardDispatched.current = false;
        return ()=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_inline_card_dispatch_guard', 'isEnabled', true) && removeCardDispatched.current) return;
            removeCardDispatched.current = true;
            const { tr: tr } = view.state;
            (0, $cbp6v.removeCard)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $cozmU.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $1jz5K.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $cozmU.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $LQnOI.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $cbp6v.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $cozmU.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $cozmU.useCallback)((event, data)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $brpLB.visitCardLinkAnalytics)(editorAnalyticsApi, (0, $krYZG.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open((0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? data?.destinationUrl ?? url : url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $cozmU.useMemo)(()=>{
        if ((isPageSSRed || cardState && (0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) && url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
            key: url,
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            key: url,
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        });
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardState
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(cardContext.Provider, {
        value: cardContext.value
    }, card) : data ? card : null;
});
const $04040245a0d353eb$var$WrappedInlineCardWithAwareness = (0, $gjNeV.Card)((0, $83775087cda75ea7$export$2b341c5236b55a2), (0, $3F4bj.default));
const $04040245a0d353eb$var$selectorWithCard = (states)=>({
        mode: states.editorViewModeState?.mode,
        resolvedInlineSmartLinks: states.cardState?.resolvedInlineSmartLinks
    });
const $04040245a0d353eb$var$selectorWithoutCard = (states)=>({
        mode: states.editorViewModeState?.mode,
        resolvedInlineSmartLinks: undefined
    });
function $04040245a0d353eb$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, intl: intl, smartCardContext: smartCardContext } = props;
    const { mode: mode, resolvedInlineSmartLinks: resolvedInlineSmartLinks } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, (0, $mW7G5.expVal)('cc_dnd_smart_link_changeboard_platform_css', 'isEnabled', false) && (0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree') ? [
        'editorViewMode',
        'card'
    ] : [
        'editorViewMode'
    ], (0, $mW7G5.expVal)('cc_dnd_smart_link_changeboard_platform_css', 'isEnabled', false) && (0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree') ? $04040245a0d353eb$var$selectorWithCard : $04040245a0d353eb$var$selectorWithoutCard);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) // Refresh cache in the background
        provider?.then((providerInstance)=>{
            providerInstance.refreshCache?.(props.node);
        });
    }, [
        provider,
        props.node
    ]);
    const linkPosition = (0, $cozmU.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const isChangeboardTarget = linkPosition !== undefined && resolvedInlineSmartLinks?.[0]?.pos === linkPosition;
    const inlineCardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($04040245a0d353eb$var$WrappedInlineCardWithAwareness, {
        node: node,
        view: view,
        getPos: getPos,
        actionOptions: actionOptions,
        useAlternativePreloader: useAlternativePreloader,
        pluginInjectionApi: pluginInjectionApi,
        onClickCallback: onClickCallback,
        isPageSSRed: isPageSSRed,
        provider: provider,
        appearance: "inline",
        ...enableInlineUpgradeFeatures && (0, $4eqn3.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
    }), CompetitorPromptComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cEgRX.SmartCardSSRReactContextsProvider), {
        intl: intl,
        smartCardContext: smartCardContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iIYTj.SmartLinkDraggable), {
        url: url,
        appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).INLINE,
        source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR,
        isChangeboardTarget: isChangeboardTarget
    }, inlineCardContent));
}
const $04040245a0d353eb$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };
module.exports["InlineCard"] = $04040245a0d353eb$export$aff6291803939b05;
module.exports["InlineCardNodeView"] = $04040245a0d353eb$export$2626b4e17577ac62;
module.exports["inlineCardNodeView"] = $04040245a0d353eb$export$ebfb9e1798b8aa0e;

});

parcelRegister("fTaxX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $LQnOI = parcelRequire("LQnOI");


var $iwjSV = parcelRequire("iwjSV");


var $8dxef = parcelRequire("8dxef");


var $iAEsk = parcelRequire("iAEsk");


var $Igylv = parcelRequire("Igylv");


var $1jz5K = parcelRequire("1jz5K");

var $KTiWz = parcelRequire("KTiWz");


var $k3XQC = parcelRequire("k3XQC");


var $iIYTj = parcelRequire("iIYTj");


var $ixfCV = parcelRequire("ixfCV");


var $l8wPz = parcelRequire("l8wPz");


var $QXwxo = parcelRequire("QXwxo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $jWZvv = parcelRequire("jWZvv");

var $6U5OC = parcelRequire("6U5OC");


var $3F4bj = parcelRequire("3F4bj");


var $h9Lux = parcelRequire("h9Lux");


var $lmL4n = parcelRequire("lmL4n");


var $cMyWi = parcelRequire("cMyWi");


var $bwuOg = parcelRequire("bwuOg");


var $dil4b = parcelRequire("dil4b");


var $byDyt = parcelRequire("byDyt");

const $22640694ffeeb016$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $22640694ffeeb016$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $22640694ffeeb016$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cMyWi.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $byDyt.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cMyWi.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lmL4n.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
    constructor(props){
        super(props);
        this.getDatasource = ()=>this.props.node.attrs.datasource;
        this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        };
        this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        };
        this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        };
        this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
}
class $22640694ffeeb016$export$9dd55813d0ee0514 extends (0, $Igylv.default) {
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dil4b.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $3F4bj.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jWZvv.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $h9Lux.calcBreakoutWidth)(attrs.layout || (0, $bwuOg.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($22640694ffeeb016$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.tableWidth = void 0;
        this.isNodeNested = void 0;
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
}



var $cbp6v = parcelRequire("cbp6v");


var $4eqn3 = parcelRequire("4eqn3");


var $cEgRX = parcelRequire("cEgRX");


var $gjNeV = parcelRequire("gjNeV");

class $6ee1e0f18b66d961$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $cbp6v.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
            key: url,
            url: url ?? data.url,
            container: this.scrollContainer,
            appearance: "block",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            platform: 'web',
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }), this.gapCursorSpan()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            key: url,
            url: url ?? data.url,
            container: this.scrollContainer,
            appearance: "block",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            platform: 'web',
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }), this.gapCursorSpan());
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).BLOCK,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, cardContext && cardContext.value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(cardContext.Provider, {
            value: cardContext.value
        }, cardInner) : data ? cardInner : null));
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $cbp6v.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        };
        this.removeCardDispatched = false;
        this.gapCursorSpan = ()=>{
            const browser = (0, $8dxef.getBrowserInfo)();
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                contentEditable: true
            });
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
    }
}
const $6ee1e0f18b66d961$var$WrappedBlockCard = (0, $gjNeV.Card)($6ee1e0f18b66d961$export$780882fb750d3c8d, (0, $KTiWz.default));
class $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0 extends (0, $Igylv.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $4eqn3.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $4eqn3.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cEgRX.SmartCardSSRReactContextsProvider), {
            intl: intl,
            smartCardContext: smartCardContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ee1e0f18b66d961$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        }));
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]') && (0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $6ee1e0f18b66d961$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: (0, $iAEsk.isSSRStreaming)() ? intl : undefined,
            smartCardContext: (0, $iAEsk.isSSRStreaming)() ? smartCardContext : undefined
        };
        const isDatasource = (0, $4eqn3.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $22640694ffeeb016$export$9dd55813d0ee0514)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $6ee1e0f18b66d961$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };
module.exports["BlockCardComponent"] = $6ee1e0f18b66d961$export$780882fb750d3c8d;
module.exports["blockCardNodeView"] = $6ee1e0f18b66d961$export$8c11099266e71f4;

});

parcelRegister("hvdgP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $LQnOI = parcelRequire("LQnOI");


var $iwjSV = parcelRequire("iwjSV");


var $1A89X = parcelRequire("1A89X");


var $8kONW = parcelRequire("8kONW");


var $iAEsk = parcelRequire("iAEsk");


var $3k5Tv = parcelRequire("3k5Tv");


var $Igylv = parcelRequire("Igylv");


var $1jz5K = parcelRequire("1jz5K");

var $aHoC6 = parcelRequire("aHoC6");

var $KTiWz = parcelRequire("KTiWz");


var $4Qu9h = parcelRequire("4Qu9h");


var $4mCw6 = parcelRequire("4mCw6");

var $jsWW5 = parcelRequire("jsWW5");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iIYTj = parcelRequire("iIYTj");


var $ixfCV = parcelRequire("ixfCV");


var $8m50u = parcelRequire("8m50u");


var $l8wPz = parcelRequire("l8wPz");

var $11zX6 = parcelRequire("11zX6");


var $QXwxo = parcelRequire("QXwxo");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $cbp6v = parcelRequire("cbp6v");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $89gPK = parcelRequire("89gPK");

var $b8ZJI = parcelRequire("b8ZJI");

var $76kDm = parcelRequire("76kDm");

var $e3qgT = parcelRequire("e3qgT");

var $bfl0n = parcelRequire("bfl0n");

var $fb9eF = parcelRequire("fb9eF");

var $3GQSw = parcelRequire("3GQSw");

var $h5qPS = parcelRequire("h5qPS");

var $34CLe = parcelRequire("34CLe");
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hNvnn = parcelRequire("hNvnn");

const $5cc79e9089d815ff$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("&>div{", (0, $hNvnn.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");



var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");








var $ieeJu = parcelRequire("ieeJu");




// Layouts where the left handle is the only resize handle today.
// These must keep the left handle.
// Remove during 'platform_editor_lovability_resize_dividers_panels' cleanup
const $a88eb3a81715ccd0$var$leftHandleOnlyLayouts = [
    'wrap-right',
    'align-end'
];
class $a88eb3a81715ccd0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $34CLe.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $34CLe.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
        else return 0, $7Y8M5.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $e3qgT.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $e3qgT.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $7Y8M5.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $11zX6.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $7Y8M5.akEditorMediaResizeHandlerPadding)
        };
        const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        const enable = {};
        (0, $bfl0n.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && !$a88eb3a81715ccd0$var$leftHandleOnlyLayouts.includes(layout)) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $fb9eF.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $5cc79e9089d815ff$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3GQSw.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            onResizeStart: (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? this.handleResizeStart : undefined,
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args);
        this.state = {
            offsetLeft: this.calcOffsetLeft()
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $76kDm.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $89gPK.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $b8ZJI.calcMediaPxWidth)({
                origWidth: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.handleResizeStart = ()=>{
            const { view: view, getPos: getPos } = this.props;
            if (typeof getPos === 'function') {
                const pos = getPos();
                if (typeof pos === 'number') {
                    const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                }
            }
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ] : [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $89gPK.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}
$a88eb3a81715ccd0$export$2e2bcd8739ae039.defaultProps = {
    aspectRatio: (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT)
};



var $cEgRX = parcelRequire("cEgRX");


var $fTaxX = parcelRequire("fTaxX");


var $gjNeV = parcelRequire("gjNeV");

const $dc083a8e67906b16$export$d79f14ec3c108fc0 = (url)=>{
    if ((0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true) && url && (0, $8kONW.isConfluenceSlideUrl)(url)) // Slides have a 16:9 canvas
    return 16 / 9;
    return undefined;
};
const $dc083a8e67906b16$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $dc083a8e67906b16$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $dc083a8e67906b16$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) / (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aHoC6.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth
        }, smartCard);
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a88eb3a81715ccd0$export$2e2bcd8739ae039), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled
    }, smartCard);
};
class $dc083a8e67906b16$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $cbp6v.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
            key: url,
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            key: url,
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iIYTj.SmartLinkDraggable), {
            url: url,
            appearance: (0, $iIYTj.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $iIYTj.SMART_LINK_DRAG_TYPES).EDITOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11zX6.EmbedResizeMessageListener), {
            embedIframeRef: this.embedIframeRef,
            onHeightUpdate: this.onHeightUpdate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc083a8e67906b16$var$CardInner, {
            pluginInjectionApi: pluginInjectionApi,
            smartCard: smartCard,
            hasPreview: hasPreview,
            getPosSafely: this.getPosSafely,
            view: view,
            getLineLength: this.getLineLength,
            eventDispatcher: this.props.eventDispatcher,
            updateSize: this.updateSize,
            getPos: getPos,
            aspectRatio: aspectRatio,
            allowResizing: allowResizing,
            heightAlone: heightAlone,
            cardProps: cardProps,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        })));
    }
    constructor(props){
        super(props);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = void 0;
        this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = void 0;
        this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        };
        this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: resolvedAspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            const aspectRatio = $dc083a8e67906b16$export$d79f14ec3c108fc0(url) ?? resolvedAspectRatio;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT), (0, $7Y8M5.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $cbp6v.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        };
        this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        };
        /**
     * Defers line-length measurement until the embed card DOM has fully rendered.
     *
     * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
     * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
     * Measuring at that moment would cache the bogus width and break resize calculations.
     * Scheduling a measurement on the next animation frame ensures layout has
     * settled. We then force the node view to re-render so `getLineLength`
     * re-runs and captures the correct width.
     */ this.scheduleLineLengthRemeasureRaf = (0, $LQnOI.default)((view)=>{
            if (view) this.forceUpdate();
        });
        this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $4mCw6.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        };
        /**
     * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
     * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
     * we will show embed window of appropriate size and avoid unnecessary content jumping.
     */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $LQnOI.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        };
        this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        };
        this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.removeCardDispatched = false;
        this.scrollContainer = (0, $1jz5K.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
}
const $dc083a8e67906b16$export$a2e44368c194a658 = (props)=>{
    const width = (0, $4Qu9h.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTaxX.BlockCardComponent), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc083a8e67906b16$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $dc083a8e67906b16$var$WrappedEmbedCardWithCondition = (0, $8m50u.componentWithCondition)(()=>(0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $dc083a8e67906b16$export$a2e44368c194a658, $dc083a8e67906b16$export$61b2782f78272a37);
const $dc083a8e67906b16$var$WrappedEmbedCard = (0, $gjNeV.Card)($dc083a8e67906b16$var$WrappedEmbedCardWithCondition, (0, $KTiWz.default));
class $dc083a8e67906b16$export$6789d7ecdc77631b extends (0, $Igylv.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cEgRX.SmartCardSSRReactContextsProvider), {
            intl: intl,
            smartCardContext: smartCardContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc083a8e67906b16$var$WrappedEmbedCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider
        }));
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]') && (0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return true;
        }
        return false;
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        this.unsubscribe = void 0;
        this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $dc083a8e67906b16$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: (0, $iAEsk.isSSRStreaming)() ? intl : undefined,
            smartCardContext: (0, $iAEsk.isSSRStreaming)() ? smartCardContext : undefined
        };
        return new $dc083a8e67906b16$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };
module.exports["embedCardNodeView"] = $dc083a8e67906b16$export$86904605fa83de6c;

});

parcelRegister("kVd8s", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

var $5aU9U = parcelRequire("5aU9U");

const $616ba2be6cd111db$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $616ba2be6cd111db$export$c1b7e6427b2a2113 extends (0, $5aU9U.Step) {
    invert() {
        return new $616ba2be6cd111db$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $eOaGc.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $eOaGc.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $616ba2be6cd111db$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $eOaGc.ReplaceStep)(0, 0, (0, $aPdNQ.Slice).empty);
    }
    constructor(pos, prev, next){
        super();
        this.prev = void 0;
        this.next = void 0;
        this.pos = void 0;
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $5aU9U.Step).jsonID($616ba2be6cd111db$export$3f33e36adb7672cc, $616ba2be6cd111db$export$c1b7e6427b2a2113);
module.exports["TableSortStep"] = $616ba2be6cd111db$export$c1b7e6427b2a2113;

});

parcelRegister("brzQy", function(module, exports) {

var $73Kv0 = parcelRequire("73Kv0");

function $b5456d47f1a39227$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $73Kv0.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
module.exports["getLinkMetadataFromTransaction"] = $b5456d47f1a39227$export$3aba02526a1e2e78;

});

parcelRegister("6MSGo", function(module, exports) {

let $4f11a49c85a977fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f11a49c85a977fe$var$load("dBHUb"),
    $4f11a49c85a977fe$var$load("5Rx9J"),
    $4f11a49c85a977fe$var$load("hZ2FX"),
    $4f11a49c85a977fe$var$load("dXcHK")
]).then(()=>parcelRequire('3hbWh'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("kaUwk", function(module, exports) {

var $7Glgp = parcelRequire("7Glgp");


var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $ieeJu = parcelRequire("ieeJu");


var $kCECX = parcelRequire("kCECX");

const $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a = new (0, $kCECX.PluginKey)('codeBidiWarningPlugin');



var $cozmU = parcelRequire("cozmU");


var $iwjSV = parcelRequire("iwjSV");


var $fYRS9 = parcelRequire("fYRS9");


var $cOjjv = parcelRequire("cOjjv");


var $cI8RZ = parcelRequire("cI8RZ");

var $gLqwM = parcelRequire("gLqwM");





var $f8497d9ba474775b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};


const $f6bb13725f8284cf$export$a4805b2c1b031d72 = (nodeViewPortalProviderAPI)=>(0, $cI8RZ.pluginFactory)((0, $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a), (0, $f8497d9ba474775b$export$2e2bcd8739ae039), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $gLqwM.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $f6bb13725f8284cf$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $f6bb13725f8284cf$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $8nvEM.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $8nvEM.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        return (0, $8nvEM.Decoration).widget(position, (_el)=>$f6bb13725f8284cf$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                renderKey: renderKey
            }), {
            destroy: (_el)=>{
            // removing portalprovider clean up due to a rendering bug
            // with this plugin under React 18. This matches the previous
            // React 16 behaviour which never cleaned up rendering.
            //
            // This will mean CodeBidi instances are not cleaned up, but
            // this is expected to be minimal due to the low frequency of
            // bidi characters in code blocks.
            //
            // We will fix this in a follow up ticket to rewrite the plugin
            // to use pure toDOM -> ED-26540
            // nodeViewPortalProviderAPI.remove(renderKey);
            }
        });
    }));
    return newBidiWarningsDecorationSet;
}
function $f6bb13725f8284cf$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, renderKey: renderKey }) {
    const element = document.createElement('span');
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYRS9.default), {
            bidiCharacter: bidiCharacter,
            skipChildren: true,
            label: codeBidiWarningLabel,
            tooltipEnabled: tooltipEnabled
        }), element, renderKey);
    return element;
}


const $e33c8cb52afde5db$export$ae829ec7b2625219 = (api, { dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $7Glgp.codeBidiWarningMessages).label);
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $f6bb13725f8284cf$export$a4805b2c1b031d72)(nodeViewPortalProviderAPI);
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a),
        state: createPluginState(dispatch, (state)=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return {
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            if (api?.limitedMode?.sharedState.currentState()?.enabled) return {
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            return {
                decorationSet: (0, $f6bb13725f8284cf$export$f1e73511389847e5)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                if ((0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return (0, $8nvEM.DecorationSet).empty;
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            }
        }
    });
};


const $1e6fd84d2484c0b4$export$d7bb9295cdf61833 = ({ config: config, api: api })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $e33c8cb52afde5db$export$ae829ec7b2625219)(api, options, config ?? {});
                    }
                }
            ];
        }
    });
module.exports["codeBidiWarningPlugin"] = $1e6fd84d2484c0b4$export$d7bb9295cdf61833;

});

parcelRegister("6faDz", function(module, exports) {
var $f938cc8eac375508$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});
module.exports["SortOrder"] = $f938cc8eac375508$export$7ae723045d45777a;

});

parcelRegister("cTqvh", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5aU9U = parcelRequire("5aU9U");

var $eOaGc = parcelRequire("eOaGc");


var $ksfbF = parcelRequire("ksfbF");

const $8ea32edfc3ed5131$var$EmptyCellNodeSize = 4;
function $8ea32edfc3ed5131$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $8ea32edfc3ed5131$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $ksfbF.removeColSpan)(cellNode.attrs, columns) : (0, $ksfbF.addColSpan)(cellNode.attrs, columns);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $8ea32edfc3ed5131$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $8ea32edfc3ed5131$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $8ea32edfc3ed5131$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $8ea32edfc3ed5131$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $8ea32edfc3ed5131$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $8ea32edfc3ed5131$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $8ea32edfc3ed5131$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $8ea32edfc3ed5131$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
	 * We need a correct map when a cell is added
	 * We need the normal map position minus the size of the cell you added it. Why?
	 * Having a table 3x3 and we add a new column at 2 creates this ranges
	 * [
	 *  10, 0, 4,
	 *  20, 0, 4,
	 *  30, 0, 4,
	 *  ]
	 *  Where:
	 *    * [10, 20, 30] are the original cell positions where we add the cells
	 *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
	 *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
	 *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
	 *  this is calculated in the given way
	 *    * Map the position using this step mapping function, this will return the cell in the next column
	 *    * Remove the diff (4 - 0 in this case) of the current position.
	 *  For a delete action this not happen, it will always return the right value
	 */ const offset = $8ea32edfc3ed5131$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $8ea32edfc3ed5131$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}



var $6i2ZP = parcelRequire("6i2ZP");

var $f719K = parcelRequire("f719K");

const $b04e0c29cd754110$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $b04e0c29cd754110$export$9854dd07bd861449(map, row, col) {
    const index = $b04e0c29cd754110$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $b04e0c29cd754110$export$b17f150b6103459c(map, row, col) {
    const index = $b04e0c29cd754110$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $b04e0c29cd754110$export$8575677d782d45d2(map, row, col) {
    const index = $b04e0c29cd754110$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $b04e0c29cd754110$export$d119febc0282b034(map, row, col) {
    const index = $b04e0c29cd754110$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}


function* $a7dcaae76018bf3d$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $6i2ZP.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = (0, $b04e0c29cd754110$export$858eb3bd69719bea)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $b04e0c29cd754110$export$9854dd07bd861449)(rect.map, row, col) && (0, $b04e0c29cd754110$export$8575677d782d45d2)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        const type = refColumn == null ? (0, $f719K.tableNodeTypes)(table.type.schema).cell : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        const cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}


function $b61f601a4103ec5b$export$718b3d71c384ca05(columnInfo, rect) {
    /**
	 * Algorithm explained
	 * Given a table like this:
	 *    | 5  | 10      |
	 *    | 15      | 20 |
	 *    | 25 | 30 | 35 |
	 * Represented by a table map like this:
	 *   rect.map = [5, 10, 10,
	 *              15, 15, 20,
	 *              25, 30, 35]
	 * And a have this inputs:
	 *   columnInfo[].from = [10, 15, 30]
	 *
	 * Algorithm:
	 *    * Initial state
	 *      start = 0;
	 *      end = 2 (rect.width - 1 === 3 - 1)
	 *    * Iterate until find first cell position
	 *      start = 1
	 *      end = 2 (min(start column + colspan - 1, start column + end column))
	 *    * Iterate until find second cell position
	 *      start = 1
	 *      end = 1
	 *    * Start === end return 1
	 */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}



var $8Z43Z = parcelRequire("8Z43Z");

function $93d00272b81b7e4d$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $8Z43Z.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}



function $eba1d02ee820732d$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $eba1d02ee820732d$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $eba1d02ee820732d$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $eba1d02ee820732d$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $b04e0c29cd754110$export$9854dd07bd861449)(rect.map, row, col);
}
function $eba1d02ee820732d$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    const to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $eba1d02ee820732d$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $eba1d02ee820732d$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $eba1d02ee820732d$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $eba1d02ee820732d$export$6a87112aa04a9486 {
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $eba1d02ee820732d$var$mergedRanges(ranges, rowRanges);
    }
    map(_mapping) {
        return [];
    }
    invert(_originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            const offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
    constructor(rowsSideEffect){
        this.rows = void 0;
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, _cell)=>{
                    if (!$eba1d02ee820732d$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $eba1d02ee820732d$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, _col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while(// Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    (nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $eba1d02ee820732d$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, _col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    // Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    while(nextRow = this.rows[i]){
                        $eba1d02ee820732d$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
}





class $c516c89356041e85$export$9d510b823609a5ac {
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $eOaGc.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $eOaGc.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
    constructor(tableSideEffect){
        this.table = void 0;
        if (tableSideEffect) this.table = tableSideEffect;
    }
}


class $22e2ab19cbd772b7$export$2e0f8a284a2635ac {
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $c516c89356041e85$export$9d510b823609a5ac).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $eba1d02ee820732d$export$6a87112aa04a9486).fromJSON(schema, json.rows);
        return sideEffects;
    }
    constructor(sideEffects){
        this.table = void 0;
        this.rows = void 0;
        this.table = new (0, $c516c89356041e85$export$9d510b823609a5ac)(sideEffects && sideEffects.table);
        this.rows = new (0, $eba1d02ee820732d$export$6a87112aa04a9486)(sideEffects && sideEffects.rows);
    }
}


const $37690b922d2adb2d$var$ADD_COLUMN_STEP = 'ak-add-column';
function $37690b922d2adb2d$var$printColumnInfo(columnInfo) {
    const cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $37690b922d2adb2d$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $37690b922d2adb2d$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $dOBRD.default)(()=>{
        const rect = (0, $93d00272b81b7e4d$export$7a7f743a3e044584)(doc, pos);
        const column = (0, $b61f601a4103ec5b$export$718b3d71c384ca05)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $37690b922d2adb2d$export$7f589f68a74fcd15 extends (0, $5aU9U.Step) {
    /**
   * Detect the column based on all the cells step in column info.
   * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
   * If isDelete
   *    Decrease colspan if one row has merged cell
   *    Remove all the cells using columnInfo.cellStep[].from
   * else
   *    Increase colspan if one row had merged cell
   *    Add all new cells at columnInfo.cellStep[].from,
   *      if there is columnInfo.cellStep[].newCell use it
   *      else create an empty cell
   *
   * @param doc Current document
   */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $eOaGc.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $eOaGc.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $93d00272b81b7e4d$export$7a7f743a3e044584)(doc, tablePos);
        } catch (e) {
            return (0, $eOaGc.StepResult).fail(e.message);
        }
        const column = (0, $b61f601a4103ec5b$export$718b3d71c384ca05)(this.columnInfo, tableRect);
        if (column === null) return (0, $eOaGc.StepResult).fail(`No column for this cells "${$37690b922d2adb2d$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $eOaGc.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $eOaGc.StepResult).ok(tr.doc);
    }
    /**
   * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
   * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
   * if cellStep.length === 0 remove the step
   * Create a new step with all the position updated
   * @param mapping
   */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $37690b922d2adb2d$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
   * if isDelete
   *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
   *    Create a copy of the node
   *    Create a new cellStep with the same positions but with the clone node as a content
   *    return new step inverted
   * else
   *    Remove the content from each columnInfo.cellStep[].content
   *    return new step inverted
   * @param originalDoc
   */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $37690b922d2adb2d$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $8ea32edfc3ed5131$export$1238fc51d97634a)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $37690b922d2adb2d$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
   * StepMap is created based on columnInfo.
   * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
   * if isDelete
   *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
   * else
   *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
   *
   * Ranges in ProseMirror are represented by each 3 elements in an array.
   * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
   * pos: Position in the document
   * currentSize: Represent the affected range, this will be pos + currentSize
   * newSize: Represent the new values, pos + newSize
   */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $8ea32edfc3ed5131$export$13a5db78deedf2bc)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $eOaGc.StepMap)(ranges);
    }
    /**
   * Try to merge this step with another one, to be applied directly
   * after it. Returns the merged step when possible, null if the
   * steps can't be merged.
   */ merge(_other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
   * Create a JSON-serializeable representation of this step. When
   * defining this for a custom subclass, make sure the result object
   * includes the step type's [JSON id](#transform.Step^jsonID) under
   * the `stepType` property.
   */ toJSON() {
        const addColumnStepJson = {
            stepType: $37690b922d2adb2d$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
   * Deserialize a step from its JSON representation. Will call
   * through to the step class' own implementation of this method.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJSON(schema, json) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $22e2ab19cbd772b7$export$2e0f8a284a2635ac).fromJSON(schema, json.sideEffects);
        return new $37690b922d2adb2d$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $93d00272b81b7e4d$export$7a7f743a3e044584)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $a7dcaae76018bf3d$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $8ea32edfc3ed5131$export$e2625d4b6ce2d04b)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $37690b922d2adb2d$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $a7dcaae76018bf3d$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $8ea32edfc3ed5131$export$e2625d4b6ce2d04b)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $8ea32edfc3ed5131$export$1e67a55385d21834)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = void 0;
        this.isDelete = void 0;
        this.columnInfo = void 0;
        this.sideEffectsHandler = void 0;
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $22e2ab19cbd772b7$export$2e0f8a284a2635ac)(addColumnStepInfo.sideEffects);
        this.columnInfo = $37690b922d2adb2d$var$createColumnInfo(addColumnStepInfo.cells);
    }
}
(0, $5aU9U.Step).jsonID($37690b922d2adb2d$var$ADD_COLUMN_STEP, $37690b922d2adb2d$export$7f589f68a74fcd15);
module.exports["AddColumnStep"] = $37690b922d2adb2d$export$7f589f68a74fcd15;

});

parcelRegister("8PVlW", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

/* Copied from type-ahead */ 
var $8tXCb = parcelRequire("8tXCb");





var $kCECX = parcelRequire("kCECX");

function $abdfd739e8743e5c$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $abdfd739e8743e5c$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        const mappedStart = start;
        const nodeNormalized = (0, $8tXCb.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $8tXCb.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $aPdNQ.Slice).maxOpen((0, $aPdNQ.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $abdfd739e8743e5c$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $kCECX.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $abdfd739e8743e5c$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $aPdNQ.Node) ? (0, $aPdNQ.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(start + (fragment?.size || 0))));
};
const $abdfd739e8743e5c$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $aPdNQ.Node) && node.isBlock) $abdfd739e8743e5c$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $abdfd739e8743e5c$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};


const $52780c65d060d523$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = options.insertAt ?? tr.selection;
        if (!(node instanceof (0, $aPdNQ.Node) || node instanceof (0, $aPdNQ.Fragment))) return false;
        (0, $abdfd739e8743e5c$export$a6d88483216c3859)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };


const $f02184b744e9f410$export$e8397698249f8f72 = (analyticsApi)=>({
        actions: {
            insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
                if (!state || !dispatch) return false;
                const { tr: tr } = state;
                (0, $52780c65d060d523$export$68b1ab6a0b98c537)({
                    node: node,
                    options: options
                })(tr);
                if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                dispatch(tr);
                return true;
            }
        },
        commands: {
            insert: ({ node: node, options: options })=>({ tr: tr })=>{
                    (0, $52780c65d060d523$export$68b1ab6a0b98c537)({
                        node: node,
                        options: options
                    })(tr);
                    if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                    return tr;
                }
        }
    });


const $a1e70661575fb7cf$export$8469b5a27995930b = ({ api: api })=>{
    const { actions: actions, commands: commands } = (0, $f02184b744e9f410$export$e8397698249f8f72)(api?.analytics?.actions);
    return {
        name: 'contentInsertion',
        actions: actions,
        commands: commands
    };
};
module.exports["contentInsertionPlugin"] = $a1e70661575fb7cf$export$8469b5a27995930b;

});

parcelRegister("l5MIu", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $l5MIu = parcelRequire("l5MIu");

const $a046056e2fb9f0f3$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $l5MIu.pluginKey), {
        changed: true
    });


const $88c05f26a72cea2c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('contextPanelPluginKey');
function $88c05f26a72cea2c$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $kpCD8.SafePlugin)({
        key: $88c05f26a72cea2c$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($88c05f26a72cea2c$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                    const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                    if (contentsLengthChanged || contentChanged) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($88c05f26a72cea2c$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $88c05f26a72cea2c$export$773ed6f43b4b1d8f = ({ config: config })=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $a046056e2fb9f0f3$export$6fbe08f3dbfbccb2),
            showPanel: config?.objectSideBar.showPanel && (0, $ixfCV.fg)('platform_editor_ai_object_sidebar_injection') ? (panel, behavior, panelWidth)=>config.objectSideBar.showPanel(panel, behavior, panelWidth) : undefined,
            closePanel: config?.objectSideBar.closePanel && (0, $ixfCV.fg)('platform_editor_ai_object_sidebar_injection') ? ()=>config.objectSideBar.closePanel() : undefined,
            closePanelById: config?.objectSideBar.closePanelById && (0, $ixfCV.fg)('platform_editor_ai_object_sidebar_injection') ? (id)=>config.objectSideBar.closePanelById(id) : undefined
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $88c05f26a72cea2c$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$88c05f26a72cea2c$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });
module.exports["pluginKey"] = $88c05f26a72cea2c$export$18d4026d1ea86bb1;
module.exports["contextPanelPlugin"] = $88c05f26a72cea2c$export$773ed6f43b4b1d8f;

});

parcelRegister("f2WDp", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $44cyU = parcelRequire("44cyU");


var $5Qi6J = parcelRequire("5Qi6J");


var $di3bZ = parcelRequire("di3bZ");


var $kCECX = parcelRequire("kCECX");

const $5b133ffbe6102189$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('customAutoformatPlugin');
const $5b133ffbe6102189$export$f05434c51e3762e = (editorState)=>$5b133ffbe6102189$export$18d4026d1ea86bb1.getState(editorState);
const $5b133ffbe6102189$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($5b133ffbe6102189$export$18d4026d1ea86bb1, action);
};


const $c66352c5e58ad2b4$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $5Qi6J.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $c66352c5e58ad2b4$export$44515d004ac96c3b = (docText, match)=>{
    const REPLACEMENT_CHARACTER = '\ufffc';
    const docTextStartChar = docText[0];
    const docTextEndSlice = docText.slice(1);
    const matchStartChar = match[0][0];
    const matchEndSlice = match[0].slice(1);
    const slicesMatch = docTextEndSlice === matchEndSlice;
    const isAlternator = docTextStartChar === '|';
    const isObjReplaceChar = matchStartChar === REPLACEMENT_CHARACTER;
    return slicesMatch && isAlternator && isObjReplaceChar;
};
const $c66352c5e58ad2b4$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            const canAutoformatAfterSoftbreak = $c66352c5e58ad2b4$export$44515d004ac96c3b(docText, match);
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0] || canAutoformatAfterSoftbreak) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $di3bZ.closeHistory)(tr));
    });
};


const $91a3efca43475222$var$MAX_MATCH = 500;
const $91a3efca43475222$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $91a3efca43475222$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};


const $f9b725b9553a4181$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $f9b725b9553a4181$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $f9b725b9553a4181$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $f9b725b9553a4181$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};


const $27481858f0f4c10f$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $f9b725b9553a4181$export$b373f08cf72033a1)(state, action);
        case 'resolved':
            return (0, $f9b725b9553a4181$export$d06d16b20ced9190)(state, action);
        case 'finish':
            return (0, $f9b725b9553a4181$export$5953b28951b32649)(state, action);
        case 'setProvider':
            return (0, $f9b725b9553a4181$export$1572b3eade6662f9)(state, action);
        default:
            return state;
    }
};
var $27481858f0f4c10f$export$2e2bcd8739ae039 = $27481858f0f4c10f$var$reduce;



const $48a603f91372504c$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $5b133ffbe6102189$export$18d4026d1ea86bb1));
                if (!meta) return remappedPluginState;
                return (0, $27481858f0f4c10f$export$2e2bcd8739ae039)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $91a3efca43475222$export$2b7343a2464fe84e)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $91a3efca43475222$export$2b7343a2464fe84e)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            /**
               * On Shift + Enter, after the first word an Object Replacement Character (/ufffc) is added.
               * We still want to match strings that start with an Object Replacement Character.
               */ // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchTyping: new RegExp('(\\s+|^|\\ufffc)' + rule + '(\\s|,|\\.)$'),
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $c66352c5e58ad2b4$export$c95e7d405e6ed1df)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            return {
                update (view) {
                    const currentState = (0, $5b133ffbe6102189$export$f05434c51e3762e)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $c66352c5e58ad2b4$export$e9a01ad76956fe83)(view, currentState);
                }
            };
        },
        key: (0, $5b133ffbe6102189$export$18d4026d1ea86bb1)
    });
};
const $48a603f91372504c$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $5b133ffbe6102189$export$c921af6adf4fd3e2)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $48a603f91372504c$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>$48a603f91372504c$export$1572b3eade6662f9(provider)(tr));
    });
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $48a603f91372504c$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $5b133ffbe6102189$export$f05434c51e3762e)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                previousProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$48a603f91372504c$export$1572b3eade6662f9(provider)(tr)) ?? false;
            }
        }
    };
};
module.exports["customAutoformatPlugin"] = $48a603f91372504c$export$aa4fc86248a63de6;

});

parcelRegister("7gk7g", function(module, exports) {

var $kHCzj = parcelRequire("kHCzj");

const $3e0cec82cb591abf$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $kHCzj.dataConsumer)
                }
            ];
        }
    });
module.exports["dataConsumerPlugin"] = $3e0cec82cb591abf$export$1dc90efb79c37811;

});

parcelRegister("4y9hw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eq809 = parcelRequire("eq809");


var $krYZG = parcelRequire("krYZG");


var $4y8CY = parcelRequire("4y8CY");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $e4nz6 = parcelRequire("e4nz6");


var $gZpSA = parcelRequire("gZpSA");


var $bjg0G = parcelRequire("bjg0G");


var $eDtFr = parcelRequire("eDtFr");


var $ixfCV = parcelRequire("ixfCV");





var $fRYCB = parcelRequire("fRYCB");

var $efgwK = parcelRequire("efgwK");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");





var $9aR69 = parcelRequire("9aR69");




const $d6888e0cf750b9a1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('datePlugin');


const $00d64b18d9375627$export$e029667a62135fd0 = (isQuickInsertAction)=>(state)=>{
        const tr = state.tr;
        const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = state.schema.nodes.date.createChecked({
            timestamp: (0, $efgwK.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $aPdNQ.Fragment).fromArray([
            dateNode,
            state.schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), newPluginState);
    };
const $00d64b18d9375627$export$ba69c8aeb784b528 = ()=>(state, dispatch)=>{
        const pluginState = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state);
        if (!pluginState || pluginState.showDatePickerAt === null) return false;
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            focusDateInput: true
        });
        dispatch(tr);
        return true;
    };
const $00d64b18d9375627$export$70b286c4fa24838 = (showDatePickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: showDatePickerAt
        }));
        return true;
    };
const $00d64b18d9375627$export$a903d799de0e4474 = ()=>(state, dispatch)=>{
        const { showDatePickerAt: showDatePickerAt } = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state) || {};
        if (!dispatch) return false;
        const tr = showDatePickerAt ? state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        }).setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showDatePickerAt + 2))) : state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            isNew: false
        });
        dispatch(tr);
        return false;
    };
const $00d64b18d9375627$export$7c3e79dfb4962626 = ({ date: date, pluginInjectionApi: pluginInjectionApi })=>{
    pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).COMMITTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DATE,
        attributes: {
            commitMethod: (0, $krYZG.INPUT_METHOD).BLUR,
            isValid: date !== undefined,
            isToday: (0, $9aR69.isToday)(date)
        }
    });
    return $00d64b18d9375627$export$a903d799de0e4474();
};
const $00d64b18d9375627$export$621a48d450e82cf = ()=>(state, dispatch)=>{
        const { $from: $from } = state.selection;
        const node = state.doc.nodeAt($from.pos);
        if (node && node.type.name === state.schema.nodes.date.name) {
            const showDatePickerAt = $from.pos;
            if (dispatch) dispatch(state.tr.setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                showDatePickerAt: showDatePickerAt
            }).setSelection((0, $kCECX.NodeSelection).create(state.doc, showDatePickerAt)));
        }
        return false;
    };
























const $eb817c60451a2df5$export$8993b403eaf979d2 = (pluginInjectionApi)=>({ tr: tr })=>{
        const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
        if (!showDatePickerAt) return tr;
        tr.delete(showDatePickerAt, showDatePickerAt + 1).setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
            showDatePickerAt: null,
            isNew: false
        });
        return tr;
    };
const $eb817c60451a2df5$export$b606a931fa97541b = (pluginInjectionApi)=>({ date: date, inputMethod: inputMethod, commitMethod: commitMethod, enterPressed: enterPressed = true })=>({ tr: tr })=>{
            const { schema: schema } = tr.doc.type;
            let timestamp;
            if (date) timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
            else timestamp = (0, $efgwK.todayTimestampInUTC)();
            if (inputMethod) {
                const resolvedInputMethod = (0, $ixfCV.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $krYZG.INPUT_METHOD).QUICK_INSERT;
                pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: resolvedInputMethod
                    }
                })(tr);
            }
            if (commitMethod) pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).COMMITTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DATE,
                attributes: {
                    commitMethod: commitMethod,
                    isValid: date !== undefined,
                    isToday: (0, $9aR69.isToday)(date)
                }
            })(tr);
            const { showDatePickerAt: showDatePickerAt } = pluginInjectionApi?.date?.sharedState.currentState() ?? {};
            if (!showDatePickerAt) {
                const dateNode = schema.nodes.date.createChecked({
                    timestamp: timestamp
                });
                const textNode = schema.text(' ');
                const fragment = (0, $aPdNQ.Fragment).fromArray([
                    dateNode,
                    textNode
                ]);
                const { from: from, to: to } = tr.selection;
                const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
                if (!insertable) {
                    const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
                    tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
                } else tr.replaceWith(from, to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, from));
                if (tr.docChanged) tr.scrollIntoView().setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                    isNew: true
                });
                return tr;
            }
            if (tr.doc.nodeAt(showDatePickerAt)) {
                if (enterPressed) // Setting selection to outside the date node causes showDatePickerAt
                // to be set to null by the PM plugin (onSelectionChanged), which will
                // immediately close the datepicker once a valid date is typed in.
                // Adding this check forces it to stay open until the user presses Enter.
                tr = tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(showDatePickerAt + 2)));
                tr = tr.setNodeMarkup(showDatePickerAt, schema.nodes.date, {
                    timestamp: timestamp
                }).setMeta((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), {
                    isNew: false
                }).scrollIntoView();
                if (!enterPressed) tr = tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, showDatePickerAt));
            }
            return tr;
        };





var $eBSR7 = parcelRequire("eBSR7");






var $kpCD8 = parcelRequire("kpCD8");


var $cI8RZ = parcelRequire("cI8RZ");






var $kSwu1 = parcelRequire("kSwu1");


var $8dxef = parcelRequire("8dxef");


var $8Dx7s = parcelRequire("8Dx7s");





var $fngNp = parcelRequire("fngNp");










const $32f222708c1a1235$export$55a93796ef2674d = (timestamp, intl, state, pos)=>{
    if (!state) return {
        color: undefined,
        displayString: (0, $efgwK.timestampToString)(timestamp, intl)
    };
    const { doc: doc, selection: selection } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    // We fall back to selection.$from even though it does not cover all use cases
    // eg. upon Editor init, selection is at the start, not at the Date node
    const $nodePos = typeof pos === 'number' ? doc.resolve(pos) : selection.$from;
    const parent = $nodePos.parent;
    let withinIncompleteTask = parent.type === taskItem && parent.attrs.state !== 'DONE';
    // If there is blockTaskItem in the schema and it's not nested in an incomplete task item,
    // check if it's nested in an incomplete block task item
    if (blockTaskItem && !withinIncompleteTask) {
        const blockTaskItemParent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($nodePos, blockTaskItem);
        // If nested in a blockTaskItem that is incomplete
        if (blockTaskItemParent) withinIncompleteTask = blockTaskItemParent.node.attrs.state !== 'DONE';
    }
    const color = withinIncompleteTask && (0, $efgwK.isPastDate)(timestamp) ? 'red' : undefined;
    const displayString = withinIncompleteTask ? (0, $efgwK.timestampToTaskContext)(timestamp, intl) : (0, $efgwK.timestampToString)(timestamp, intl);
    return {
        displayString: displayString,
        color: color
    };
};


let $ff58016aca28f78a$var$intlRef;
const $ff58016aca28f78a$export$dfa8d249b3ff4cf7 = (node)=>{
    $ff58016aca28f78a$var$intlRef = $ff58016aca28f78a$var$intlRef || (0, $kSwu1.createIntl)({
        locale: document.documentElement.lang || 'en-US'
    });
    const timestamp = node.attrs.timestamp;
    const displayString = (0, $efgwK.timestampToString)(timestamp, $ff58016aca28f78a$var$intlRef);
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        'aria-busy': 'true'
    };
    const attrs = {
        style: (0, $8Dx7s.convertToInlineCss)({
            // Taken from @atlaskit/date Component
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text, #292A2E)",
            borderRadius: "var(--ds-radius-small, 4px)",
            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
            margin: '0 1px'
        })
    };
    return [
        'span',
        wrapperAttrs,
        [
            'span',
            attrs,
            displayString
        ]
    ];
};
const $ff58016aca28f78a$export$3bf4edf3398258cf = (node, state, getPos, intl)=>{
    const timestamp = node.attrs.timestamp;
    const pos = getPos?.();
    const { displayString: displayString, color: color } = (0, $32f222708c1a1235$export$55a93796ef2674d)(timestamp, intl, state, pos);
    const nodeWrapperAttrs = {
        contenteditable: 'false',
        timestamp: timestamp,
        class: 'dateView-content-wrap inlineNodeView',
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-name': 'date',
        'data-prosemirror-node-inline': 'true',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        draggable: 'true'
    };
    if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) nodeWrapperAttrs['data-local-id'] = node.attrs.localId;
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp
    };
    const attrs = {
        class: !color ? '' : `date-node-color-${color}`,
        style: `white-space: unset`
    };
    return [
        'span',
        nodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            wrapperAttrs,
            [
                'span',
                attrs,
                displayString
            ]
        ],
        (0, $8dxef.getBrowserInfo)().android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $3705bb10050f2b09$export$9e959fa2f3aa27d3 {
    /**
   *
   * @param node
   * @param decorations
   * @example
   */ update(node, decorations) {
        // we're only interested in two scenarios to trigger a DOM update:
        // 		1. the date value (timestamp) has changed
        // 		2. A wrapping taskitem state (if present) has changed
        // in all other cases, we tell prosemirror to ignore DOM updates
        // if new changes are added to the DOM structure, they will need to be
        // coded here
        const hasDateChanged = node.attrs.timestamp !== this.node.attrs.timestamp;
        const parentTaskState = $3705bb10050f2b09$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
        const parentTaskStateChanged = parentTaskState !== this.parentTaskState;
        // update local state after comparisons ...
        this.parentTaskState = parentTaskState;
        this.node = node;
        const skipProseMirrorDomUpdate = !hasDateChanged && !parentTaskStateChanged;
        return skipProseMirrorDomUpdate;
    }
    static getParentTaskState(decorations) {
        const parentTaskDecoration = decorations.find((d)=>{
            return d.spec.dataTaskNodeCheckState !== undefined;
        });
        return parentTaskDecoration?.spec?.dataTaskNodeCheckState ?? '';
    }
    /**
   *
   * @param node
   * @param view
   * @param getPos
   * @param intl
   * @param decorations
   * @example
   */ constructor(node, view, getPos, intl, decorations){
        this.dom = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.parentTaskState = '';
        this.node = node;
        this.intl = intl;
        this.view = view;
        this.getPos = getPos;
        const spec = (0, $ff58016aca28f78a$export$3bf4edf3398258cf)(node, this.view.state, this.getPos, this.intl);
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom.addEventListener('click', (event)=>{
            event.stopImmediatePropagation();
            const { state: state, dispatch: dispatch } = this.view;
            (0, $00d64b18d9375627$export$70b286c4fa24838)(state.selection.from)(state, dispatch);
        });
        this.parentTaskState = $3705bb10050f2b09$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
    }
}






function $afd1413c588653ab$export$1650419e431d3ba3(pluginState, meta) {
    // If the same nodeview is clicked twice, calendar should close
    if (meta.showDatePickerAt === pluginState.showDatePickerAt) return {
        ...pluginState,
        showDatePickerAt: null
    };
    const { showDatePickerAt: showDatePickerAt, isNew: isNew } = pluginState;
    const { showDatePickerAt: showDatePickerAtMeta } = meta;
    // If date picker position has changed, it is no longer new
    if (showDatePickerAt && showDatePickerAtMeta && showDatePickerAt !== showDatePickerAtMeta && isNew) return {
        ...pluginState,
        ...meta,
        isNew: false
    };
    return {
        ...pluginState,
        ...meta
    };
}
function $afd1413c588653ab$export$83e1f26587c4acd2(tr, pluginState) {
    if (!pluginState.showDatePickerAt) return pluginState;
    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.showDatePickerAt);
    return {
        showDatePickerAt: deleted ? null : pos,
        isNew: pluginState.isNew,
        isDateEmpty: pluginState.isDateEmpty,
        focusDateInput: pluginState.focusDateInput,
        isInitialised: pluginState.isInitialised
    };
}
function $afd1413c588653ab$export$8a0edcfd4a8a0397(tr, pluginState) {
    if (tr.docChanged && $afd1413c588653ab$var$isDateNodeSelection(tr.selection)) return {
        ...pluginState,
        isQuickInsertAction: false,
        showDatePickerAt: tr.selection.from
    };
    else if (!$afd1413c588653ab$var$isDateNodeSelection(tr.selection) && !pluginState.isQuickInsertAction) {
        if (pluginState.showDatePickerAt) return {
            showDatePickerAt: null,
            isNew: false,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return pluginState;
    }
    return pluginState;
}
const $afd1413c588653ab$var$isDateNodeSelection = (selection)=>{
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const nodeTypeName = selection.node.type.name;
        return nodeTypeName === 'date';
    }
    return false;
};


const $ab0059a8179173ac$var$dest = (0, $cI8RZ.pluginFactory)((0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1), (0, $afd1413c588653ab$export$1650419e431d3ba3), {
    mapping: $afd1413c588653ab$export$83e1f26587c4acd2,
    onSelectionChanged: $afd1413c588653ab$export$8a0edcfd4a8a0397
});
const $ab0059a8179173ac$var$createPluginState = $ab0059a8179173ac$var$dest.createPluginState;
const $ab0059a8179173ac$export$f05434c51e3762e = $ab0059a8179173ac$var$dest.getPluginState;
const $ab0059a8179173ac$var$createPlugin = (pmPluginFactoryParams)=>{
    const { dispatch: dispatch } = pmPluginFactoryParams;
    const newPluginState = {
        showDatePickerAt: null,
        isNew: false,
        isDateEmpty: false,
        focusDateInput: false,
        isInitialised: true
    };
    return new (0, $kpCD8.SafePlugin)({
        state: $ab0059a8179173ac$var$createPluginState(dispatch, newPluginState),
        key: (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                date: (node, view, getPos, decorations)=>{
                    return new (0, $3705bb10050f2b09$export$9e959fa2f3aa27d3)(node, view, getPos, pmPluginFactoryParams.getIntl(), decorations);
                }
            }
        }
    });
};
var $ab0059a8179173ac$export$2e2bcd8739ae039 = $ab0059a8179173ac$var$createPlugin;


function $80232891f60757aa$export$e832373cff8dec22() {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.enter).common, (state, dispatch)=>{
        const datePlugin = (0, $ab0059a8179173ac$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (!datePlugin.showDatePickerAt) {
            (0, $00d64b18d9375627$export$621a48d450e82cf)()(state, dispatch);
            return true;
        }
        (0, $00d64b18d9375627$export$a903d799de0e4474)()(state, dispatch);
        return true;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch)=>{
        const datePlugin = (0, $ab0059a8179173ac$export$f05434c51e3762e)(state);
        const isDateNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (datePlugin.showDatePickerAt) {
            (0, $00d64b18d9375627$export$ba69c8aeb784b528)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $eBSR7.keymap)(list);
}
var $80232891f60757aa$export$2e2bcd8739ae039 = $80232891f60757aa$export$e832373cff8dec22;





const $a7a03d9dfd431126$var$DatePicker = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "n4oKT",
    name: "DatePicker",
    loader: ()=>(parcelRequire("kLNHA")).then((mod)=>mod.default),
    loading: ()=>null
});
function $a7a03d9dfd431126$var$getDateNode(editorView, showDatePickerAt) {
    if (!editorView) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $bjg0G.findDomRefAtPos)(showDatePickerAt, domAtPos);
    // Resolves ED-23702 for when the date is wrapped in an inline comment
    const dateNode = element?.classList.contains((0, $e4nz6.DateSharedCssClassName).DATE_CONTAINER) ? element : element?.querySelector(`.${(0, $e4nz6.DateSharedCssClassName).DATE_CONTAINER}`);
    return dateNode || element;
}
function $a7a03d9dfd431126$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi, weekStartDay: weekStartDay }) {
    const { editorDisabledState: editorDisabledState, dateState: dateState } = (0, $4y8CY.useSharedPluginState)(dependencyApi, [
        'date',
        'editorDisabled'
    ]);
    if (!dateState?.showDatePickerAt || editorDisabledState?.editorDisabled) return null;
    const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = dateState;
    const dateNode = $a7a03d9dfd431126$var$getDateNode(editorView, showDatePickerAt);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a7a03d9dfd431126$var$DatePicker, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        key: showDatePickerAt,
        element: dateNode,
        isNew: isNew,
        autoFocus: focusDateInput,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDelete: ()=>{
            if (!editorView) return;
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$8993b403eaf979d2)(dependencyApi));
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSelect: (date, commitMethod)=>{
            // Undefined means couldn't parse date, null means invalid (out of bounds) date
            if (date === undefined || date === null) return;
            if (!editorView) return;
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                commitMethod: commitMethod
            }));
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onTextChanged: (date)=>{
            dependencyApi?.core?.actions.execute((0, $eb817c60451a2df5$export$b606a931fa97541b)(dependencyApi)({
                date: date,
                enterPressed: false
            }));
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePicker: ()=>{
            if (!editorView) return;
            (0, $00d64b18d9375627$export$a903d799de0e4474)()(editorView.state, editorView.dispatch);
            editorView?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePickerWithAnalytics: ({ date: date })=>{
            if (!editorView) return;
            (0, $00d64b18d9375627$export$7c3e79dfb4962626)({
                date: date
            })(editorView.state, editorView.dispatch);
            editorView.focus();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        weekStartDay: weekStartDay
    });
}
const $a7a03d9dfd431126$var$datePlugin = ({ config: config = {}, api: api })=>({
        name: 'date',
        getSharedState (editorState) {
            if (!editorState) return {
                showDatePickerAt: null,
                isNew: false,
                focusDateInput: false,
                isInitialised: true
            };
            const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput, isInitialised: isInitialised } = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(editorState) || {};
            return {
                showDatePickerAt: showDatePickerAt,
                isNew: !!isNew,
                focusDateInput: !!focusDateInput,
                isInitialised: !!isInitialised
            };
        },
        commands: {
            insertDate: (0, $eb817c60451a2df5$export$b606a931fa97541b)(api),
            deleteDate: (0, $eb817c60451a2df5$export$8993b403eaf979d2)(api)
        },
        nodes () {
            return [
                {
                    name: 'date',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $eq809.dateWithLocalId) : (0, $eq809.date)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'date',
                    plugin: (pmPluginFactoryParams)=>{
                        $a7a03d9dfd431126$var$DatePicker.preload();
                        return (0, $ab0059a8179173ac$export$2e2bcd8739ae039)(pmPluginFactoryParams);
                    }
                },
                {
                    name: 'dateKeymap',
                    plugin: ()=>{
                        $a7a03d9dfd431126$var$DatePicker.preload();
                        return (0, $80232891f60757aa$export$2e2bcd8739ae039)();
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a7a03d9dfd431126$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                weekStartDay: config.weekStartDay
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'date',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).date),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).dateDescription),
                        priority: 800,
                        keywords: [
                            'calendar',
                            'day',
                            'time',
                            'today',
                            '/'
                        ],
                        keyshortcut: '//',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconDate), null),
                        action (insert, state, source) {
                            const tr = (0, $00d64b18d9375627$export$e029667a62135fd0)(true)(state);
                            api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CLICKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'date'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Date floating toolbar',
                    nodeType: [
                        state.schema.nodes.date
                    ],
                    getDomRef: (editorView)=>{
                        const dateState = (0, $d6888e0cf750b9a1$export$18d4026d1ea86bb1).getState(state);
                        const datePosition = dateState?.showDatePickerAt;
                        if (!datePosition) return undefined;
                        const domAtPos = editorView.domAtPos.bind(editorView);
                        const domRef = (0, $bjg0G.findDomRefAtPos)(datePosition, domAtPos);
                        const isHTMLElement = (element)=>{
                            return element instanceof HTMLElement;
                        };
                        if (isHTMLElement(domRef)) return domRef;
                        return undefined;
                    },
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Date floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && isViewMode() && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark;
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-date-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                                    description: intl.formatMessage((0, $83k8i.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    });
var $a7a03d9dfd431126$export$2e2bcd8739ae039 = $a7a03d9dfd431126$var$datePlugin;
module.exports["default"] = $a7a03d9dfd431126$export$2e2bcd8739ae039;

});

parcelRegister("9aR69", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");


var $58FyF = parcelRequire("58FyF");


var $fDAOo = parcelRequire("fDAOo");

var $b28e2808f9377f51$exports = {};
$parcel$export($b28e2808f9377f51$exports, "af", () => (parcelRequire("jdAIP")).default);
$parcel$export($b28e2808f9377f51$exports, "ar", () => (parcelRequire("lTSBl")).default);
$parcel$export($b28e2808f9377f51$exports, "arDZ", () => (parcelRequire("b7b2O")).default);
$parcel$export($b28e2808f9377f51$exports, "arEG", () => (parcelRequire("aAFll")).default);
$parcel$export($b28e2808f9377f51$exports, "arMA", () => (parcelRequire("aDiMe")).default);
$parcel$export($b28e2808f9377f51$exports, "arSA", () => (parcelRequire("cSVQD")).default);
$parcel$export($b28e2808f9377f51$exports, "arTN", () => (parcelRequire("c4IgH")).default);
$parcel$export($b28e2808f9377f51$exports, "az", () => (parcelRequire("f9xPZ")).default);
$parcel$export($b28e2808f9377f51$exports, "be", () => (parcelRequire("jmsQ6")).default);
$parcel$export($b28e2808f9377f51$exports, "beTarask", () => (parcelRequire("jhqet")).default);
$parcel$export($b28e2808f9377f51$exports, "bg", () => (parcelRequire("gCI9G")).default);
$parcel$export($b28e2808f9377f51$exports, "bn", () => (parcelRequire("gbABh")).default);
$parcel$export($b28e2808f9377f51$exports, "bs", () => (parcelRequire("gBLDk")).default);
$parcel$export($b28e2808f9377f51$exports, "ca", () => (parcelRequire("dNzyu")).default);
$parcel$export($b28e2808f9377f51$exports, "cs", () => (parcelRequire("8EGKX")).default);
$parcel$export($b28e2808f9377f51$exports, "cy", () => (parcelRequire("kLhpw")).default);
$parcel$export($b28e2808f9377f51$exports, "da", () => (parcelRequire("fIezj")).default);
$parcel$export($b28e2808f9377f51$exports, "de", () => (parcelRequire("d42EV")).default);
$parcel$export($b28e2808f9377f51$exports, "deAT", () => (parcelRequire("jiiAs")).default);
$parcel$export($b28e2808f9377f51$exports, "el", () => (parcelRequire("8RXQT")).default);
$parcel$export($b28e2808f9377f51$exports, "enAU", () => (parcelRequire("lGPlu")).default);
$parcel$export($b28e2808f9377f51$exports, "enCA", () => (parcelRequire("2Y0P5")).default);
$parcel$export($b28e2808f9377f51$exports, "enGB", () => (parcelRequire("8HKXv")).default);
$parcel$export($b28e2808f9377f51$exports, "enIE", () => (parcelRequire("hWN4g")).default);
$parcel$export($b28e2808f9377f51$exports, "enIN", () => (parcelRequire("kuDO4")).default);
$parcel$export($b28e2808f9377f51$exports, "enNZ", () => (parcelRequire("5FUh4")).default);
$parcel$export($b28e2808f9377f51$exports, "enUS", () => (parcelRequire("clx8d")).default);
$parcel$export($b28e2808f9377f51$exports, "enZA", () => (parcelRequire("aSFVd")).default);
$parcel$export($b28e2808f9377f51$exports, "eo", () => (parcelRequire("6unLC")).default);
$parcel$export($b28e2808f9377f51$exports, "es", () => (parcelRequire("gDEfH")).default);
$parcel$export($b28e2808f9377f51$exports, "et", () => (parcelRequire("czJqG")).default);
$parcel$export($b28e2808f9377f51$exports, "eu", () => (parcelRequire("jlS2G")).default);
$parcel$export($b28e2808f9377f51$exports, "faIR", () => (parcelRequire("eXL8E")).default);
$parcel$export($b28e2808f9377f51$exports, "fi", () => (parcelRequire("dqZrE")).default);
$parcel$export($b28e2808f9377f51$exports, "fr", () => (parcelRequire("k64l1")).default);
$parcel$export($b28e2808f9377f51$exports, "frCA", () => (parcelRequire("lFkXa")).default);
$parcel$export($b28e2808f9377f51$exports, "frCH", () => (parcelRequire("2p0ts")).default);
$parcel$export($b28e2808f9377f51$exports, "fy", () => (parcelRequire("aa0X5")).default);
$parcel$export($b28e2808f9377f51$exports, "gd", () => (parcelRequire("inBOb")).default);
$parcel$export($b28e2808f9377f51$exports, "gl", () => (parcelRequire("2gRR9")).default);
$parcel$export($b28e2808f9377f51$exports, "gu", () => (parcelRequire("lgykd")).default);
$parcel$export($b28e2808f9377f51$exports, "he", () => (parcelRequire("114nq")).default);
$parcel$export($b28e2808f9377f51$exports, "hi", () => (parcelRequire("68vmh")).default);
$parcel$export($b28e2808f9377f51$exports, "hr", () => (parcelRequire("c4pIC")).default);
$parcel$export($b28e2808f9377f51$exports, "ht", () => (parcelRequire("h3dgf")).default);
$parcel$export($b28e2808f9377f51$exports, "hu", () => (parcelRequire("5ykSD")).default);
$parcel$export($b28e2808f9377f51$exports, "hy", () => (parcelRequire("kOmGW")).default);
$parcel$export($b28e2808f9377f51$exports, "id", () => (parcelRequire("1ZhxU")).default);
$parcel$export($b28e2808f9377f51$exports, "is", () => (parcelRequire("5OgtV")).default);
$parcel$export($b28e2808f9377f51$exports, "it", () => (parcelRequire("9YZs4")).default);
$parcel$export($b28e2808f9377f51$exports, "itCH", () => (parcelRequire("56vLn")).default);
$parcel$export($b28e2808f9377f51$exports, "ja", () => (parcelRequire("lwYCg")).default);
$parcel$export($b28e2808f9377f51$exports, "jaHira", () => (parcelRequire("O69wG")).default);
$parcel$export($b28e2808f9377f51$exports, "ka", () => (parcelRequire("bDc9o")).default);
$parcel$export($b28e2808f9377f51$exports, "kk", () => (parcelRequire("5U0go")).default);
$parcel$export($b28e2808f9377f51$exports, "km", () => (parcelRequire("kNEVA")).default);
$parcel$export($b28e2808f9377f51$exports, "kn", () => (parcelRequire("dv5xe")).default);
$parcel$export($b28e2808f9377f51$exports, "ko", () => (parcelRequire("458wa")).default);
$parcel$export($b28e2808f9377f51$exports, "lb", () => (parcelRequire("a6iKE")).default);
$parcel$export($b28e2808f9377f51$exports, "lt", () => (parcelRequire("9Z9AE")).default);
$parcel$export($b28e2808f9377f51$exports, "lv", () => (parcelRequire("hskCx")).default);
$parcel$export($b28e2808f9377f51$exports, "mk", () => (parcelRequire("678Ci")).default);
$parcel$export($b28e2808f9377f51$exports, "mn", () => (parcelRequire("2QzpI")).default);
$parcel$export($b28e2808f9377f51$exports, "ms", () => (parcelRequire("5CNN8")).default);
$parcel$export($b28e2808f9377f51$exports, "mt", () => (parcelRequire("3SSHw")).default);
$parcel$export($b28e2808f9377f51$exports, "nb", () => (parcelRequire("3y6aU")).default);
$parcel$export($b28e2808f9377f51$exports, "nl", () => (parcelRequire("i6MM7")).default);
$parcel$export($b28e2808f9377f51$exports, "nlBE", () => (parcelRequire("3OBut")).default);
$parcel$export($b28e2808f9377f51$exports, "nn", () => (parcelRequire("blOmo")).default);
$parcel$export($b28e2808f9377f51$exports, "oc", () => (parcelRequire("h5aPN")).default);
$parcel$export($b28e2808f9377f51$exports, "pl", () => (parcelRequire("353ym")).default);
$parcel$export($b28e2808f9377f51$exports, "pt", () => (parcelRequire("8a7P0")).default);
$parcel$export($b28e2808f9377f51$exports, "ptBR", () => (parcelRequire("lBaG3")).default);
$parcel$export($b28e2808f9377f51$exports, "ro", () => (parcelRequire("29kXF")).default);
$parcel$export($b28e2808f9377f51$exports, "ru", () => (parcelRequire("gYfFg")).default);
$parcel$export($b28e2808f9377f51$exports, "sk", () => (parcelRequire("l2mTu")).default);
$parcel$export($b28e2808f9377f51$exports, "sl", () => (parcelRequire("bKFGE")).default);
$parcel$export($b28e2808f9377f51$exports, "sq", () => (parcelRequire("bL8hA")).default);
$parcel$export($b28e2808f9377f51$exports, "sr", () => (parcelRequire("1iyef")).default);
$parcel$export($b28e2808f9377f51$exports, "srLatn", () => (parcelRequire("6AuV3")).default);
$parcel$export($b28e2808f9377f51$exports, "sv", () => (parcelRequire("hVF75")).default);
$parcel$export($b28e2808f9377f51$exports, "ta", () => (parcelRequire("iZ7nC")).default);
$parcel$export($b28e2808f9377f51$exports, "te", () => (parcelRequire("cz4ad")).default);
$parcel$export($b28e2808f9377f51$exports, "th", () => (parcelRequire("9B6Ao")).default);
$parcel$export($b28e2808f9377f51$exports, "tr", () => (parcelRequire("azkPO")).default);
$parcel$export($b28e2808f9377f51$exports, "ug", () => (parcelRequire("fJC8B")).default);
$parcel$export($b28e2808f9377f51$exports, "uk", () => (parcelRequire("baKKw")).default);
$parcel$export($b28e2808f9377f51$exports, "uz", () => (parcelRequire("74d4N")).default);
$parcel$export($b28e2808f9377f51$exports, "uzCyrl", () => (parcelRequire("f2nvb")).default);
$parcel$export($b28e2808f9377f51$exports, "vi", () => (parcelRequire("28ZKr")).default);
$parcel$export($b28e2808f9377f51$exports, "zhCN", () => (parcelRequire("8tIg4")).default);
$parcel$export($b28e2808f9377f51$exports, "zhHK", () => (parcelRequire("l8E94")).default);
$parcel$export($b28e2808f9377f51$exports, "zhTW", () => (parcelRequire("bOvA7")).default);
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

var $jdAIP = parcelRequire("jdAIP");


var $lTSBl = parcelRequire("lTSBl");


var $b7b2O = parcelRequire("b7b2O");


var $aAFll = parcelRequire("aAFll");


var $aDiMe = parcelRequire("aDiMe");


var $cSVQD = parcelRequire("cSVQD");


var $c4IgH = parcelRequire("c4IgH");


var $f9xPZ = parcelRequire("f9xPZ");


var $jmsQ6 = parcelRequire("jmsQ6");


var $jhqet = parcelRequire("jhqet");


var $gCI9G = parcelRequire("gCI9G");


var $gbABh = parcelRequire("gbABh");


var $gBLDk = parcelRequire("gBLDk");


var $dNzyu = parcelRequire("dNzyu");


var $8EGKX = parcelRequire("8EGKX");


var $kLhpw = parcelRequire("kLhpw");


var $fIezj = parcelRequire("fIezj");


var $d42EV = parcelRequire("d42EV");


var $jiiAs = parcelRequire("jiiAs");


var $8RXQT = parcelRequire("8RXQT");


var $lGPlu = parcelRequire("lGPlu");


var $2Y0P5 = parcelRequire("2Y0P5");


var $8HKXv = parcelRequire("8HKXv");


var $hWN4g = parcelRequire("hWN4g");


var $kuDO4 = parcelRequire("kuDO4");


var $5FUh4 = parcelRequire("5FUh4");


var $clx8d = parcelRequire("clx8d");


var $aSFVd = parcelRequire("aSFVd");


var $6unLC = parcelRequire("6unLC");


var $gDEfH = parcelRequire("gDEfH");


var $czJqG = parcelRequire("czJqG");


var $jlS2G = parcelRequire("jlS2G");


var $eXL8E = parcelRequire("eXL8E");


var $dqZrE = parcelRequire("dqZrE");


var $k64l1 = parcelRequire("k64l1");


var $lFkXa = parcelRequire("lFkXa");


var $2p0ts = parcelRequire("2p0ts");


var $aa0X5 = parcelRequire("aa0X5");


var $inBOb = parcelRequire("inBOb");


var $2gRR9 = parcelRequire("2gRR9");


var $lgykd = parcelRequire("lgykd");


var $114nq = parcelRequire("114nq");


var $68vmh = parcelRequire("68vmh");


var $c4pIC = parcelRequire("c4pIC");


var $h3dgf = parcelRequire("h3dgf");


var $5ykSD = parcelRequire("5ykSD");


var $kOmGW = parcelRequire("kOmGW");


var $1ZhxU = parcelRequire("1ZhxU");


var $5OgtV = parcelRequire("5OgtV");


var $9YZs4 = parcelRequire("9YZs4");


var $56vLn = parcelRequire("56vLn");


var $lwYCg = parcelRequire("lwYCg");


var $O69wG = parcelRequire("O69wG");


var $bDc9o = parcelRequire("bDc9o");


var $5U0go = parcelRequire("5U0go");


var $kNEVA = parcelRequire("kNEVA");


var $dv5xe = parcelRequire("dv5xe");


var $458wa = parcelRequire("458wa");


var $a6iKE = parcelRequire("a6iKE");


var $9Z9AE = parcelRequire("9Z9AE");


var $hskCx = parcelRequire("hskCx");


var $678Ci = parcelRequire("678Ci");


var $2QzpI = parcelRequire("2QzpI");


var $5CNN8 = parcelRequire("5CNN8");


var $3SSHw = parcelRequire("3SSHw");


var $3y6aU = parcelRequire("3y6aU");


var $i6MM7 = parcelRequire("i6MM7");


var $3OBut = parcelRequire("3OBut");


var $blOmo = parcelRequire("blOmo");


var $h5aPN = parcelRequire("h5aPN");


var $353ym = parcelRequire("353ym");


var $8a7P0 = parcelRequire("8a7P0");


var $lBaG3 = parcelRequire("lBaG3");


var $29kXF = parcelRequire("29kXF");


var $gYfFg = parcelRequire("gYfFg");


var $l2mTu = parcelRequire("l2mTu");


var $bKFGE = parcelRequire("bKFGE");


var $bL8hA = parcelRequire("bL8hA");


var $1iyef = parcelRequire("1iyef");


var $6AuV3 = parcelRequire("6AuV3");


var $hVF75 = parcelRequire("hVF75");


var $iZ7nC = parcelRequire("iZ7nC");


var $cz4ad = parcelRequire("cz4ad");


var $9B6Ao = parcelRequire("9B6Ao");


var $azkPO = parcelRequire("azkPO");


var $fJC8B = parcelRequire("fJC8B");


var $baKKw = parcelRequire("baKKw");


var $74d4N = parcelRequire("74d4N");


var $f2nvb = parcelRequire("f2nvb");


var $28ZKr = parcelRequire("28ZKr");


var $8tIg4 = parcelRequire("8tIg4");


var $l8E94 = parcelRequire("l8E94");


var $bOvA7 = parcelRequire("bOvA7");




var $gd5kZ = parcelRequire("gd5kZ");

function $9eee334da367dc09$var$isDigit(c) {
    if (c === undefined) return false;
    return c >= '0' && c <= '9';
}
/**
 * Check if cursor is in first segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $9eee334da367dc09$var$isCursorInFirstDateSegment(cursorPos, date) {
    let posCounter = cursorPos - 1;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter >= 0 && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$9eee334da367dc09$var$isDigit(c)) isAdjacent = false;
        posCounter -= 1;
    }
    return isAdjacent;
}
/**
 * Check if cursor is in last segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $9eee334da367dc09$var$isCursorInLastDateSegment(cursorPos, date) {
    let posCounter = cursorPos;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter < strippedDate.length && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$9eee334da367dc09$var$isDigit(c)) isAdjacent = false;
        posCounter += 1;
    }
    return isAdjacent;
}
function $9eee334da367dc09$export$6e7fa6d67147cb9e(date) {
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
}
function $9eee334da367dc09$export$ff5a653e9ab9c0bc(position, date, locale) {
    if (position > date.length) return undefined;
    const placeholder = $9eee334da367dc09$export$a785060aa48542fa(locale);
    if (!placeholder) return undefined;
    // The placeholder without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPlaceholder = placeholder.replace(/[^ymd]+$/g, '');
    const keyToSegment = {
        d: 'day',
        m: 'month',
        y: 'year'
    };
    const firstSegment = keyToSegment[strippedPlaceholder[0]];
    const lastSegment = keyToSegment[strippedPlaceholder[strippedPlaceholder.length - 1]];
    const allPossibleSegments = [
        'day',
        'month',
        'year'
    ];
    const middleSegment = allPossibleSegments.filter((s)=>s !== firstSegment && s !== lastSegment)[0];
    if ($9eee334da367dc09$var$isCursorInFirstDateSegment(position, date)) return firstSegment;
    if ($9eee334da367dc09$var$isCursorInLastDateSegment(position, date)) return lastSegment;
    return middleSegment;
}
function $9eee334da367dc09$export$a785060aa48542fa(locale) {
    const uniqueDateType = {
        day: 7,
        month: 1,
        year: 1992
    };
    const localisedDateString = (0, $gd5kZ.formatDateType)(uniqueDateType, locale);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const shortDateFormat = localisedDateString.replace(/\d+/g, (str)=>{
        if (!str) return '';
        // Ignored via go/ees005
        // eslint-disable-next-line no-var
        var num = parseInt(str);
        switch(num % 100){
            case 92:
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                return str.replace(/.{1}/g, 'y');
            case 1:
                return str.length === 1 ? 'm' : 'mm';
            case 7:
                return str.length === 1 ? 'd' : 'dd';
        }
        return '';
    });
    return shortDateFormat;
}
function $9eee334da367dc09$export$6c4de3b0bb035f06(date, activeSegment, adjustment) {
    const originalDate = (0, $gd5kZ.dateTypeToDate)(date);
    const newDate = activeSegment === 'day' ? (0, $gkHoc.default)(originalDate, adjustment) : activeSegment === 'month' ? (0, $58FyF.default)(originalDate, adjustment) : (0, $fDAOo.default)(originalDate, adjustment);
    return (0, $gd5kZ.dateToDateType)(newDate);
}
function $9eee334da367dc09$export$629b0a497aa65267(date) {
    const today = new Date();
    return date !== undefined && today.getDate() === date.day && date.month === today.getMonth() + 1 && date.year === today.getFullYear();
}
function $9eee334da367dc09$export$1f30ec7fd3ecab15(localeString) {
    let dfLocaleString = localeString;
    const [lang, region] = localeString.split('-');
    if (region) {
        if (lang.toLocaleLowerCase() === region.toLocaleLowerCase()) dfLocaleString = lang;
        else dfLocaleString = `${lang}${region}`;
    }
    return $b28e2808f9377f51$exports[dfLocaleString];
}
module.exports["isDatePossiblyValid"] = $9eee334da367dc09$export$6e7fa6d67147cb9e;
module.exports["findDateSegmentByPosition"] = $9eee334da367dc09$export$ff5a653e9ab9c0bc;
module.exports["adjustDate"] = $9eee334da367dc09$export$6c4de3b0bb035f06;
module.exports["isToday"] = $9eee334da367dc09$export$629b0a497aa65267;
module.exports["getDFLocale"] = $9eee334da367dc09$export$1f30ec7fd3ecab15;

});

parcelRegister("lGPlu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $i2iDg = parcelRequire("i2iDg");


var $fcGXP = parcelRequire("fcGXP");

var $d573e6f470cdb3a4$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d573e6f470cdb3a4$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d573e6f470cdb3a4$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d573e6f470cdb3a4$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d573e6f470cdb3a4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d573e6f470cdb3a4$export$2e2bcd8739ae039 = $d573e6f470cdb3a4$var$formatLong;



var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $fca5596599fc38c5$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $d573e6f470cdb3a4$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $fca5596599fc38c5$export$2e2bcd8739ae039 = $fca5596599fc38c5$var$locale;
module.exports["default"] = $fca5596599fc38c5$export$2e2bcd8739ae039;

});

parcelRegister("czJqG", function(module, exports) {
var $e477044a82bd2f96$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var $e477044a82bd2f96$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $e477044a82bd2f96$var$formatDistanceLocale[token].withPreposition : $e477044a82bd2f96$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
var $e477044a82bd2f96$export$2e2bcd8739ae039 = $e477044a82bd2f96$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e9682331b99adc7a$var$dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $e9682331b99adc7a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e9682331b99adc7a$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $e9682331b99adc7a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e9682331b99adc7a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e9682331b99adc7a$export$2e2bcd8739ae039 = $e9682331b99adc7a$var$formatLong;


var $50c37fe5632e4e2c$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var $50c37fe5632e4e2c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $50c37fe5632e4e2c$var$formatRelativeLocale[token];
};
var $50c37fe5632e4e2c$export$2e2bcd8739ae039 = $50c37fe5632e4e2c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $c2f490467cae760e$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $c2f490467cae760e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $c2f490467cae760e$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $c2f490467cae760e$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $c2f490467cae760e$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $c2f490467cae760e$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $c2f490467cae760e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $c2f490467cae760e$var$localize = {
    ordinalNumber: $c2f490467cae760e$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c2f490467cae760e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c2f490467cae760e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c2f490467cae760e$export$2e2bcd8739ae039 = $c2f490467cae760e$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e53174e3f19300de$var$matchOrdinalNumberPattern = /^\d+\./i;
var $e53174e3f19300de$var$parseOrdinalNumberPattern = /\d+/i;
var $e53174e3f19300de$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $e53174e3f19300de$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $e53174e3f19300de$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $e53174e3f19300de$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e53174e3f19300de$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $e53174e3f19300de$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e53174e3f19300de$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $e53174e3f19300de$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $e53174e3f19300de$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $e53174e3f19300de$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $e53174e3f19300de$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e53174e3f19300de$var$matchOrdinalNumberPattern,
        parsePattern: $e53174e3f19300de$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e53174e3f19300de$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e53174e3f19300de$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e53174e3f19300de$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e53174e3f19300de$export$2e2bcd8739ae039 = $e53174e3f19300de$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $927bfe400ba2cf06$var$locale = {
    code: 'et',
    formatDistance: (0, $e477044a82bd2f96$export$2e2bcd8739ae039),
    formatLong: (0, $e9682331b99adc7a$export$2e2bcd8739ae039),
    formatRelative: (0, $50c37fe5632e4e2c$export$2e2bcd8739ae039),
    localize: (0, $c2f490467cae760e$export$2e2bcd8739ae039),
    match: (0, $e53174e3f19300de$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $927bfe400ba2cf06$export$2e2bcd8739ae039 = $927bfe400ba2cf06$var$locale;
module.exports["default"] = $927bfe400ba2cf06$export$2e2bcd8739ae039;

});

parcelRegister("5OgtV", function(module, exports) {
var $994385883795466b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $994385883795466b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $994385883795466b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $994385883795466b$export$2e2bcd8739ae039 = $994385883795466b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $38d726d96347f28c$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $38d726d96347f28c$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $38d726d96347f28c$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $38d726d96347f28c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $38d726d96347f28c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $38d726d96347f28c$export$2e2bcd8739ae039 = $38d726d96347f28c$var$formatLong;


var $550bfc8a2a2f3ad6$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var $550bfc8a2a2f3ad6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $550bfc8a2a2f3ad6$var$formatRelativeLocale[token];
};
var $550bfc8a2a2f3ad6$export$2e2bcd8739ae039 = $550bfc8a2a2f3ad6$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b48435fc1d309782$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $b48435fc1d309782$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $b48435fc1d309782$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $b48435fc1d309782$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $b48435fc1d309782$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $b48435fc1d309782$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $b48435fc1d309782$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b48435fc1d309782$var$localize = {
    ordinalNumber: $b48435fc1d309782$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b48435fc1d309782$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b48435fc1d309782$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b48435fc1d309782$export$2e2bcd8739ae039 = $b48435fc1d309782$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6ac48a920acd9ffb$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $6ac48a920acd9ffb$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $6ac48a920acd9ffb$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $6ac48a920acd9ffb$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $6ac48a920acd9ffb$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $6ac48a920acd9ffb$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $6ac48a920acd9ffb$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $6ac48a920acd9ffb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $6ac48a920acd9ffb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $6ac48a920acd9ffb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $6ac48a920acd9ffb$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $6ac48a920acd9ffb$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $6ac48a920acd9ffb$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6ac48a920acd9ffb$var$matchOrdinalNumberPattern,
        parsePattern: $6ac48a920acd9ffb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6ac48a920acd9ffb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6ac48a920acd9ffb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6ac48a920acd9ffb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6ac48a920acd9ffb$export$2e2bcd8739ae039 = $6ac48a920acd9ffb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $43ae68338c4c54ac$var$locale = {
    code: 'is',
    formatDistance: (0, $994385883795466b$export$2e2bcd8739ae039),
    formatLong: (0, $38d726d96347f28c$export$2e2bcd8739ae039),
    formatRelative: (0, $550bfc8a2a2f3ad6$export$2e2bcd8739ae039),
    localize: (0, $b48435fc1d309782$export$2e2bcd8739ae039),
    match: (0, $6ac48a920acd9ffb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $43ae68338c4c54ac$export$2e2bcd8739ae039 = $43ae68338c4c54ac$var$locale;
module.exports["default"] = $43ae68338c4c54ac$export$2e2bcd8739ae039;

});

parcelRegister("8a7P0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
var $3ff0692d74bc5277$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $3ff0692d74bc5277$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3ff0692d74bc5277$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $3ff0692d74bc5277$export$2e2bcd8739ae039 = $3ff0692d74bc5277$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $44e6e748316960cd$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $44e6e748316960cd$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $44e6e748316960cd$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $44e6e748316960cd$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $44e6e748316960cd$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $44e6e748316960cd$export$2e2bcd8739ae039 = $44e6e748316960cd$var$formatLong;


var $4cdce5567d10ad59$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $4cdce5567d10ad59$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $4cdce5567d10ad59$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $4cdce5567d10ad59$export$2e2bcd8739ae039 = $4cdce5567d10ad59$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $398d9757f859a3bb$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $398d9757f859a3bb$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $398d9757f859a3bb$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $398d9757f859a3bb$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $398d9757f859a3bb$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $398d9757f859a3bb$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $398d9757f859a3bb$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $398d9757f859a3bb$var$localize = {
    ordinalNumber: $398d9757f859a3bb$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $398d9757f859a3bb$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $398d9757f859a3bb$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $398d9757f859a3bb$export$2e2bcd8739ae039 = $398d9757f859a3bb$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0fb8ee16ab0196f1$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $0fb8ee16ab0196f1$var$parseOrdinalNumberPattern = /\d+/i;
var $0fb8ee16ab0196f1$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $0fb8ee16ab0196f1$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $0fb8ee16ab0196f1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $0fb8ee16ab0196f1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0fb8ee16ab0196f1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $0fb8ee16ab0196f1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0fb8ee16ab0196f1$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $0fb8ee16ab0196f1$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $0fb8ee16ab0196f1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $0fb8ee16ab0196f1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $0fb8ee16ab0196f1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0fb8ee16ab0196f1$var$matchOrdinalNumberPattern,
        parsePattern: $0fb8ee16ab0196f1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0fb8ee16ab0196f1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0fb8ee16ab0196f1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0fb8ee16ab0196f1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0fb8ee16ab0196f1$export$2e2bcd8739ae039 = $0fb8ee16ab0196f1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $5f15531e3796708e$var$locale = {
    code: 'pt',
    formatDistance: (0, $3ff0692d74bc5277$export$2e2bcd8739ae039),
    formatLong: (0, $44e6e748316960cd$export$2e2bcd8739ae039),
    formatRelative: (0, $4cdce5567d10ad59$export$2e2bcd8739ae039),
    localize: (0, $398d9757f859a3bb$export$2e2bcd8739ae039),
    match: (0, $0fb8ee16ab0196f1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5f15531e3796708e$export$2e2bcd8739ae039 = $5f15531e3796708e$var$locale;
module.exports["default"] = $5f15531e3796708e$export$2e2bcd8739ae039;

});

parcelRegister("29kXF", function(module, exports) {
var $4bbd032ac2ace480$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var $4bbd032ac2ace480$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4bbd032ac2ace480$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $4bbd032ac2ace480$export$2e2bcd8739ae039 = $4bbd032ac2ace480$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $aca251c5c37b5e7b$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var $aca251c5c37b5e7b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aca251c5c37b5e7b$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $aca251c5c37b5e7b$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $aca251c5c37b5e7b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aca251c5c37b5e7b$export$2e2bcd8739ae039 = $aca251c5c37b5e7b$var$formatLong;


var $ac1d87a10abd6524$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var $ac1d87a10abd6524$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ac1d87a10abd6524$var$formatRelativeLocale[token];
};
var $ac1d87a10abd6524$export$2e2bcd8739ae039 = $ac1d87a10abd6524$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $d9c1c4a82ab82481$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $d9c1c4a82ab82481$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $d9c1c4a82ab82481$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $d9c1c4a82ab82481$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $d9c1c4a82ab82481$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $d9c1c4a82ab82481$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $d9c1c4a82ab82481$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $d9c1c4a82ab82481$var$localize = {
    ordinalNumber: $d9c1c4a82ab82481$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d9c1c4a82ab82481$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d9c1c4a82ab82481$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d9c1c4a82ab82481$export$2e2bcd8739ae039 = $d9c1c4a82ab82481$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $62e0192087014382$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $62e0192087014382$var$parseOrdinalNumberPattern = /\d+/i;
var $62e0192087014382$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $62e0192087014382$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $62e0192087014382$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $62e0192087014382$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $62e0192087014382$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $62e0192087014382$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $62e0192087014382$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $62e0192087014382$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $62e0192087014382$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $62e0192087014382$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $62e0192087014382$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $62e0192087014382$var$matchOrdinalNumberPattern,
        parsePattern: $62e0192087014382$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62e0192087014382$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $62e0192087014382$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $62e0192087014382$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $62e0192087014382$export$2e2bcd8739ae039 = $62e0192087014382$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $190cae8838e8779e$var$locale = {
    code: 'ro',
    formatDistance: (0, $4bbd032ac2ace480$export$2e2bcd8739ae039),
    formatLong: (0, $aca251c5c37b5e7b$export$2e2bcd8739ae039),
    formatRelative: (0, $ac1d87a10abd6524$export$2e2bcd8739ae039),
    localize: (0, $d9c1c4a82ab82481$export$2e2bcd8739ae039),
    match: (0, $62e0192087014382$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $190cae8838e8779e$export$2e2bcd8739ae039 = $190cae8838e8779e$var$locale;
module.exports["default"] = $190cae8838e8779e$export$2e2bcd8739ae039;

});

parcelRegister("l2mTu", function(module, exports) {
function $818fdfa92abff722$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $818fdfa92abff722$var$declension(scheme, count, time) {
    var group = $818fdfa92abff722$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function $818fdfa92abff722$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $818fdfa92abff722$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $818fdfa92abff722$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $818fdfa92abff722$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $818fdfa92abff722$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var $818fdfa92abff722$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $818fdfa92abff722$var$extractPreposition(token) || '';
    var key = $818fdfa92abff722$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $818fdfa92abff722$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $818fdfa92abff722$var$prefixPreposition(preposition) + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return $818fdfa92abff722$var$prefixPreposition(preposition) + 'o ' + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'future');
    else return $818fdfa92abff722$var$prefixPreposition(preposition) + 'pred ' + $818fdfa92abff722$var$suffixPreposition(preposition) + $818fdfa92abff722$var$declension(scheme, count, 'past');
};
var $818fdfa92abff722$export$2e2bcd8739ae039 = $818fdfa92abff722$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $59460d050055fa70$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $59460d050055fa70$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $59460d050055fa70$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $59460d050055fa70$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $59460d050055fa70$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $59460d050055fa70$export$2e2bcd8739ae039 = $59460d050055fa70$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $3008a450de1e7950$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $3008a450de1e7950$var$_lastWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $3008a450de1e7950$var$thisWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $3008a450de1e7950$var$_nextWeek(day) {
    var weekday = $3008a450de1e7950$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $3008a450de1e7950$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $3008a450de1e7950$var$thisWeek(day);
        else return $3008a450de1e7950$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $3008a450de1e7950$var$thisWeek(day);
        else return $3008a450de1e7950$var$_nextWeek(day);
    },
    other: 'P'
};
var $3008a450de1e7950$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3008a450de1e7950$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $3008a450de1e7950$export$2e2bcd8739ae039 = $3008a450de1e7950$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $95698432c7fba7c7$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $95698432c7fba7c7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $95698432c7fba7c7$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $95698432c7fba7c7$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $95698432c7fba7c7$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $95698432c7fba7c7$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $95698432c7fba7c7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var $95698432c7fba7c7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $95698432c7fba7c7$var$localize = {
    ordinalNumber: $95698432c7fba7c7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $95698432c7fba7c7$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $95698432c7fba7c7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $95698432c7fba7c7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $95698432c7fba7c7$export$2e2bcd8739ae039 = $95698432c7fba7c7$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $677b4734872d1549$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $677b4734872d1549$var$parseOrdinalNumberPattern = /\d+/i;
var $677b4734872d1549$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $677b4734872d1549$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $677b4734872d1549$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $677b4734872d1549$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $677b4734872d1549$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $677b4734872d1549$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $677b4734872d1549$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $677b4734872d1549$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $677b4734872d1549$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $677b4734872d1549$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $677b4734872d1549$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $677b4734872d1549$var$matchOrdinalNumberPattern,
        parsePattern: $677b4734872d1549$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $677b4734872d1549$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $677b4734872d1549$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $677b4734872d1549$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $677b4734872d1549$export$2e2bcd8739ae039 = $677b4734872d1549$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $f50b8b2a828eb3c5$var$locale = {
    code: 'sk',
    formatDistance: (0, $818fdfa92abff722$export$2e2bcd8739ae039),
    formatLong: (0, $59460d050055fa70$export$2e2bcd8739ae039),
    formatRelative: (0, $3008a450de1e7950$export$2e2bcd8739ae039),
    localize: (0, $95698432c7fba7c7$export$2e2bcd8739ae039),
    match: (0, $677b4734872d1549$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f50b8b2a828eb3c5$export$2e2bcd8739ae039 = $f50b8b2a828eb3c5$var$locale;
module.exports["default"] = $f50b8b2a828eb3c5$export$2e2bcd8739ae039;

});

parcelRegister("gd5kZ", function(module, exports) {

var $3vMGL = parcelRequire("3vMGL");

function $1b0e5ffb828996fc$export$9f54bd296c9b15c8(dateString, locale) {
    try {
        const l10n = (0, $3vMGL.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
}
function $1b0e5ffb828996fc$export$c1b0befbc45d5daf(date, locale) {
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $3vMGL.createLocalizationProvider)(locale);
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
}
function $1b0e5ffb828996fc$export$2071e1c033c380c7(date) {
    const { day: day, month: month, year: year } = date;
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return dateObj;
}
function $1b0e5ffb828996fc$export$e657ff381fe1e42a(date) {
    const dateObj = {
        day: date.getDate(),
        // The JS Date api represents month as a number between 0-11 :)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return dateObj;
}
module.exports["parseDateType"] = $1b0e5ffb828996fc$export$9f54bd296c9b15c8;
module.exports["formatDateType"] = $1b0e5ffb828996fc$export$c1b0befbc45d5daf;
module.exports["dateTypeToDate"] = $1b0e5ffb828996fc$export$2071e1c033c380c7;
module.exports["dateToDateType"] = $1b0e5ffb828996fc$export$e657ff381fe1e42a;

});

parcelRegister("kLNHA", function(module, exports) {

let $f1eec034b3d451e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1eec034b3d451e7$var$load("aJLFD"),
    $f1eec034b3d451e7$var$load("43ghN")
]).then(()=>parcelRequire('gu9AW'));

});

parcelRegister("dfEnC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5ce8c589b62bcf6c$export$6a802fb2263552f1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(()=>{});
module.exports["PlainOutsideClickTargetRefContext"] = $5ce8c589b62bcf6c$export$6a802fb2263552f1;

});

parcelRegister("1nt6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $aed463146dbcbf20$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $dfEnC = parcelRequire("dfEnC");

function $aed463146dbcbf20$export$2e2bcd8739ae039(Component) {
    return class WithOutsideClick extends (0, $cozmU.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfEnC.PlainOutsideClickTargetRefContext).Provider, {
                value: this.setOutsideClickTargetRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, this.props));
        }
        constructor(...args){
            super(...args);
            this.outsideClickTargetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
            this.handleClick = (evt)=>{
                const domNode = this.outsideClickTargetRef.current?.deref();
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) this.props.handleClickOutside?.(evt);
            };
            this.handleKeydown = (evt)=>{
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) this.props.handleEscapeKeydown(evt);
            };
            this.setOutsideClickTargetRef = (el)=>{
                this.outsideClickTargetRef.current = el && new WeakRef(el);
            };
        }
    };
}

});

parcelRegister("k8SUN", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $cozmU = parcelRequire("cozmU");


var $chuMh = parcelRequire("chuMh");

var $7RQ8H = parcelRequire("7RQ8H");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $dX4zl = parcelRequire("dX4zl");





var $fqVYq = parcelRequire("fqVYq");


var $8QOo3 = parcelRequire("8QOo3");

const $8fae9b809547d771$export$657fbcd00719af4b = 'toggleExpandRange';
const $8fae9b809547d771$export$de35616b4bcd2077 = (from, to, open = true)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        const fromClamped = from && from >= 0 ? from : 0;
        const toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
        const positions = [];
        tr.doc.nodesBetween(fromClamped, toClamped, (node, pos)=>{
            if ([
                expand,
                nestedExpand
            ].includes(node.type)) {
                (0, $8QOo3.expandedState).set(node, open);
                positions.push(pos);
            }
        });
        if (positions.length === 0) // No expand nodes found in the range — nothing to dispatch.
        return null;
        // Set meta so the expand PM plugin can add node decorations.
        // This ensures ExpandNodeView.update() receives the decoration and visually
        // opens or closes the expand.
        tr.setMeta($8fae9b809547d771$export$657fbcd00719af4b, {
            positions: positions,
            open: open
        });
        return tr;
    };






var $kSwu1 = parcelRequire("kSwu1");








var $dVKvM = parcelRequire("dVKvM");


var $26gmS = parcelRequire("26gmS");

const $2b7ab0141b432875$var$NODE_NAME = 'expand';
const $2b7ab0141b432875$var$ExpandBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.expand, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $2b7ab0141b432875$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26gmS))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand));
};
const $2b7ab0141b432875$export$43e1eed033b6f3d3 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ab0141b432875$var$ExpandBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};



var $1A89X = parcelRequire("1A89X");




var $iLcY8 = parcelRequire("iLcY8");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $6DhDg = parcelRequire("6DhDg");


var $bjg0G = parcelRequire("bjg0G");

const $2edcbf582ab2a883$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $bjg0G.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};






var $kCECX = parcelRequire("kCECX");





var $cycWk = parcelRequire("cycWk");


var $ixfCV = parcelRequire("ixfCV");







const $54fefa0e11c7e40c$export$62b7afc61dbab067 = (state)=>(0, $bjg0G.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);



var $cI8RZ = parcelRequire("cI8RZ");




var $4a6536f156a9e236$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};


const $e948c98b413f4071$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('expandPlugin');
const $e948c98b413f4071$var$dest = (0, $cI8RZ.pluginFactory)($e948c98b413f4071$export$18d4026d1ea86bb1, (0, $4a6536f156a9e236$export$2e2bcd8739ae039));
const $e948c98b413f4071$export$656c7661095efe2e = $e948c98b413f4071$var$dest.createPluginState;
const $e948c98b413f4071$export$8d4021544bdece00 = $e948c98b413f4071$var$dest.createCommand;
const $e948c98b413f4071$export$f05434c51e3762e = $e948c98b413f4071$var$dest.getPluginState;


const $a8a297951f644d31$export$491ffa7e89016e5c = (ref)=>(0, $e948c98b413f4071$export$8d4021544bdece00)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $a8a297951f644d31$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $kCECX.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $a8a297951f644d31$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) return false;
        return $a8a297951f644d31$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $a8a297951f644d31$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage) tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $a8a297951f644d31$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage) tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage ? isExpandedNext === true : isExpandedNext === false && (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state)) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $eaLat.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $iLcY8.PLATFORMS).WEB,
                    mode: (0, $iLcY8.MODE).EDITOR,
                    expanded: __livePage ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $a8a297951f644d31$export$b7c6a6a1365fc215 = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $cycWk.findTable)(state.selection);
    const isSelectionInExpand = (0, $54fefa0e11c7e40c$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $a8a297951f644d31$export$4782944d4b10fd76 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $a8a297951f644d31$export$b7c6a6a1365fc215(state);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $bjg0G.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $dX4zl.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const resolvedInputMethod = (0, $ixfCV.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $krYZG.INPUT_METHOD).QUICK_INSERT;
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT_ID).EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: resolvedInputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $a8a297951f644d31$export$982de01464f3ba33 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        return $a8a297951f644d31$export$4782944d4b10fd76(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $a8a297951f644d31$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $a8a297951f644d31$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $a8a297951f644d31$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_vc90_transition_expand_icon cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true) ? expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $a8a297951f644d31$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kCECX.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $a8a297951f644d31$export$6f1dc7179cebfcb1 = (_selection)=>({ tr: _tr })=>{
        // this action exists so that we can keep the plugin types consistent across the
        // the legacy expand plugin and the single player expand plugin until
        // we will remove the legacy expand plugin
        return null;
    };






var $ldqjS = parcelRequire("ldqjS");




var $1JP3v = parcelRequire("1JP3v");





var $2w79Z = parcelRequire("2w79Z");

var $9gS7U = parcelRequire("9gS7U");


var $44cyU = parcelRequire("44cyU");





var $kWLy1 = parcelRequire("kWLy1");





const $1c0cfc448d4795e0$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $1c0cfc448d4795e0$var$isExpandSelected = (selection)=>selection instanceof (0, $kCECX.NodeSelection) && $1c0cfc448d4795e0$var$isExpandNode(selection.node);
function $1c0cfc448d4795e0$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($1c0cfc448d4795e0$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($1c0cfc448d4795e0$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($1c0cfc448d4795e0$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $a8a297951f644d31$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kCECX.TextSelection) && !(0, $kWLy1.isInTable)(state)) {
                const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $a8a297951f644d31$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9gS7U.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $a8a297951f644d31$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $8QOo3.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded)) return (0, $a8a297951f644d31$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$1c0cfc448d4795e0$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kCECX.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $a8a297951f644d31$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}



var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");





var $aPdNQ = parcelRequire("aPdNQ");


var $fud2r = parcelRequire("fud2r");

const $8d532e37d2ea1d00$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $fud2r.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};


var $jPUdw = parcelRequire("jPUdw");









var $iwjSV = parcelRequire("iwjSV");


var $iqS60 = parcelRequire("iqS60");












var $cSuwJ = parcelRequire("cSuwJ");


var $btvbC = parcelRequire("btvbC");













var $di3bZ = parcelRequire("di3bZ");










function $030e3f5a1671f728$export$dde15965bbee9f3e(container, buttonProps) {
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = buttonProps;
    // Update existing button attributes
    const label = intl.formatMessage(expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode);
    const existingButton = container.querySelector(`.${(0, $6DhDg.expandClassNames).iconButton}`);
    if (existingButton) {
        existingButton.setAttribute('aria-label', label);
        existingButton.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) {
            existingButton.setAttribute('title', label);
            existingButton.removeAttribute('disabled');
        } else {
            existingButton.removeAttribute('title');
            existingButton.setAttribute('disabled', 'true');
        }
    } else {
        const doc = container.ownerDocument;
        if (!doc) return;
        const button = doc.createElement('button');
        button.className = (0, $6DhDg.expandClassNames).iconButton;
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-expanded', String(expanded));
        if (allowInteractiveExpand) button.setAttribute('title', label);
        else button.setAttribute('disabled', 'true');
        container.appendChild(button);
        const svgIcon = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svgIcon.setAttribute('class', (0, $6DhDg.expandClassNames).iconSvg);
        svgIcon.setAttribute('width', '12');
        svgIcon.setAttribute('height', '12');
        svgIcon.setAttribute('viewBox', '0 0 16 16');
        svgIcon.setAttribute('role', 'presentation');
        const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentcolor');
        path.setAttribute('d', 'm6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z');
        svgIcon.appendChild(path);
        button.appendChild(svgIcon);
    }
}



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $5SGpQ = parcelRequire("5SGpQ");








var $7Y8M5 = parcelRequire("7Y8M5");


var $aDSIl = parcelRequire("aDSIl");


var $lpNn5 = parcelRequire("lpNn5");

const $ed3672d169ecbf92$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { label: label } = this.props;
            return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                content: label,
                position: "top",
                tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)(WrapperComponent, this.props)));
        }
        constructor(props){
            super(props);
        }
    };
};
const $ed3672d169ecbf92$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = props;
    const useTheme = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $7Y8M5.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const label = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6DhDg.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $ed3672d169ecbf92$var$ButtonWithTooltip = $ed3672d169ecbf92$export$9a7250d72c34c156($ed3672d169ecbf92$export$aa86be27b687b166);
const $ed3672d169ecbf92$var$ButtonWithoutTooltip = $ed3672d169ecbf92$export$aa86be27b687b166;
const $ed3672d169ecbf92$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($ed3672d169ecbf92$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $cSuwJ.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($ed3672d169ecbf92$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};


function $c178cc331d60d3f0$var$buildExpandClassName(type, expanded) {
    return `${(0, $6DhDg.expandClassNames).prefix} ${(0, $6DhDg.expandClassNames).type(type)} ${expanded ? (0, $6DhDg.expandClassNames).expanded : ''}`;
}
const $c178cc331d60d3f0$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $c178cc331d60d3f0$var$buildExpandClassName(node.type.name, __livePage ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $6DhDg.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $6DhDg.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $6DhDg.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $6DhDg.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandArialabel) || (0, $cSuwJ.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $cSuwJ.messages).expandPlaceholderText) || (0, $cSuwJ.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: `${(0, $6DhDg.expandClassNames).content} ${(__livePage ? !node.attrs.__expanded : node.attrs.__expanded) ? '' : (0, $6DhDg.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...(0, $ieeJu.expValEquals)('platform_editor_expand_content_a11y', 'isEnabled', true) && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabel) || (0, $cSuwJ.messages).expandBodyAriaLabel.defaultMessage
                }
            },
            0
        ]
    ];
class $c178cc331d60d3f0$export$e6a0ba759c3724b0 {
    initHandlers() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            this.updateDisplayStyle(this.node);
        });
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node.attrs;
        (0, $030e3f5a1671f728$export$dde15965bbee9f3e)(this.icon, {
            expanded: this.__livePage ? !__expanded : __expanded,
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed3672d169ecbf92$export$e20de71cd82a9fe9), {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            }), this.icon, this.renderKey);
    }
    updateDisplayStyle(node) {
        if (this.content) {
            const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
            if (isCollapsed) this.content.classList.add((0, $6DhDg.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $6DhDg.expandClassNames).contentCollapsed);
        }
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $6DhDg.expandClassNames).expanded);
                    if ((0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true)) this.renderNativeIcon(node);
                    else this.renderIcon(this && this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
                this.updateDisplayStyle(node);
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            this.nodeViewPortalProviderAPI.remove(this.renderKey);
        }
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $a8a297951f644d31$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $iqS60.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $a8a297951f644d31$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a8a297951f644d31$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in legacyExpand, please also update the implementation in singlePlayerExpand
            if ((0, $ieeJu.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        const { state: state } = this.view;
                        this.view.focus();
                        this.api?.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, pos));
                            // Show the drag handle on the selected expand node
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                // Find the anchor name from the DOM
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = dom.getAttribute('data-node-anchor');
                                    // Only proceed if we found a valid anchor name
                                    if (anchorName) {
                                        const command = this.api?.blockControls?.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            const keyName_result = (0, $iqS60.keyName)(event);
            switch(keyName_result){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteExpand = (_event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode)) (0, $a8a297951f644d31$export$ea222cb41be5bea0)(this.api?.analytics?.actions)(pos, expandNode)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $a8a297951f644d31$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $eaLat.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $kCECX.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).End,
                    selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start,
                        selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $di3bZ.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $di3bZ.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.intl = getIntl();
        const { dom: _dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $c178cc331d60d3f0$var$toDOM(_node, this.__livePage, this.intl, api?.editorDisabled?.sharedState.currentState()?.editorDisabled));
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = _dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).content}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        if ((0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.intl);
        this.initHandlers();
    }
}
function $c178cc331d60d3f0$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $c178cc331d60d3f0$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}



function $5f72d7874b639371$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $5f72d7874b639371$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $e948c98b413f4071$export$656c7661095efe2e)(dispatch, {});
    const isMobile = false;
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        key: (0, $e948c98b413f4071$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                expand: (0, $c178cc331d60d3f0$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $c178cc331d60d3f0$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $5f72d7874b639371$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $5f72d7874b639371$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $5f72d7874b639371$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput);
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $6DhDg.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $5f72d7874b639371$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($5f72d7874b639371$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                    if (node) {
                        const expandRef = (0, $bjg0G.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $e948c98b413f4071$export$f05434c51e3762e)(state).expandRef !== expandRef) (0, $a8a297951f644d31$export$491ffa7e89016e5c)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $5f72d7874b639371$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $8d532e37d2ea1d00$export$447e90e618548243)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $jPUdw.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}



var $2xhuI = parcelRequire("2xhuI");


var $iDfTs = parcelRequire("iDfTs");



const $407719543fd209a1$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        // JST-1060364: We are observing this crashing the editor where the `expandPlugin` doesn't exist
        // in the editor (resulting in `Cannot destructure property 'expandRef' of ...`).
        // For now let's add a null check to ensure we don't crash while we investigate further.
        const { expandRef: expandRef } = (0, $e948c98b413f4071$export$f05434c51e3762e)(state) ?? {};
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                        onClick: (0, $a8a297951f644d31$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $2xhuI.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $f981a0fe8af5b8e6$var$EXPAND_NODE_NAME = 'expand';
let $f981a0fe8af5b8e6$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $2b7ab0141b432875$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($f981a0fe8af5b8e6$var$EXPAND_NODE_NAME))
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $chuMh.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $7RQ8H.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $a8a297951f644d31$export$982de01464f3ba33)(api?.analytics?.actions),
            insertExpandWithInputMethod: (0, $a8a297951f644d31$export$4782944d4b10fd76)(api?.analytics?.actions)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $a8a297951f644d31$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $8fae9b809547d771$export$de35616b4bcd2077
        },
        getSharedState () {
            return (0, $ieeJu.expValEquals)('platform_editor_expand_paste_in_comment_editor', 'isEnabled', true) ? {
                allowInsertion: options?.allowInsertion ?? true
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $5f72d7874b639371$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $1c0cfc448d4795e0$export$e4ebafd8ecd98be0)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $407719543fd209a1$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconExpand), null),
                        action (insert, state) {
                            const node = (0, $a8a297951f644d31$export$b7c6a6a1365fc215)(state);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $dX4zl.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};






































// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead










































const $0c982aa6ebb943ef$export$b7c6a6a1365fc215 = (state, setExpandedState = true, addLocalId)=>{
    const { expand: expand, nestedExpand: nestedExpand, paragraph: paragraph } = state.schema.nodes;
    const isSelectionInTable = !!(0, $cycWk.findTable)(state.selection);
    const isSelectionInExpand = (0, $54fefa0e11c7e40c$export$62b7afc61dbab067)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? expandType.createAndFill(addLocalId ? {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()
    } : {}, // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    paragraph.createAndFill(addLocalId ? {
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()
    } : {})) : expandType.createAndFill({});
    if (setExpandedState) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $8QOo3.expandedState).set(expandNode, true);
    return expandNode;
};
const $0c982aa6ebb943ef$export$b07fdfa9172394f4 = (state, node)=>{
    const tr = (0, $dX4zl.createWrapSelectionTransaction)({
        state: state,
        type: node.type,
        nodeAttributes: node.attrs
    });
    const wrapperNode = (0, $bjg0G.findParentNodeOfType)(node.type)(tr.selection);
    if (wrapperNode) (0, $8QOo3.expandedState).set(wrapperNode.node, true);
    return tr;
};
const $0c982aa6ebb943ef$export$4782944d4b10fd76 = (api)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $0c982aa6ebb943ef$export$b7c6a6a1365fc215(state, false, !!api?.localId);
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $bjg0G.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $8QOo3.expandedState).set(expandNode, true);
            } else {
                tr = (0, $dX4zl.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type,
                    ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') && {
                        nodeAttributes: expandNode.attrs
                    }
                });
                const wrapperNode = (0, $bjg0G.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $8QOo3.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: expandNode?.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT_ID).EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (dispatch) {
                api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $0c982aa6ebb943ef$export$982de01464f3ba33 = (api)=>(state, dispatch)=>{
        return $0c982aa6ebb943ef$export$4782944d4b10fd76(api)((0, $krYZG.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $0c982aa6ebb943ef$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) return false;
        return $0c982aa6ebb943ef$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $0c982aa6ebb943ef$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $kCECX.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $0c982aa6ebb943ef$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $kCECX.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $0c982aa6ebb943ef$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $8QOo3.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $8QOo3.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $eaLat.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $krYZG.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $krYZG.ACTION_SUBJECT).EXPAND : (0, $krYZG.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $iLcY8.PLATFORMS).WEB,
                    mode: (0, $iLcY8.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            tr.setMeta('scrollIntoView', false);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $0c982aa6ebb943ef$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $0c982aa6ebb943ef$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const dom = editorView.domAtPos(pos);
            const expandWrapper = dom.node.parentElement;
            if (expandWrapper) {
                $0c982aa6ebb943ef$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $0c982aa6ebb943ef$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        // TODO: ED-29205 - During platform_editor_vc90_transition_expand_icon cleanup, rename `iconContainer` to `iconButton`.
        const iconContainer = (0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true) ? expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconButton}`) : expand.querySelector(`.${(0, $6DhDg.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView?.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $0c982aa6ebb943ef$export$6f1dc7179cebfcb1 = (selection)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        // if match is inside a nested expand, open the nested expand
        const nestedExpandNode = (0, $bjg0G.findParentNodeOfType)(nestedExpand)(selection);
        if (nestedExpandNode) {
            const expanded = (0, $8QOo3.expandedState).get(nestedExpandNode.node) ?? false;
            if (!expanded) (0, $8QOo3.expandedState).set(nestedExpandNode.node, true);
        }
        // if match is (also) inside an expand, open the expand
        const expandNode = (0, $bjg0G.findParentNodeOfType)(expand)(selection);
        if (expandNode) {
            const expanded = (0, $8QOo3.expandedState).get(expandNode.node) ?? false;
            if (!expanded) (0, $8QOo3.expandedState).set(expandNode.node, true);
        }
        return tr;
    };


































const $93876d773a1ca2f9$var$isExpandNode = (node)=>{
    return node?.type.name === 'expand' || node?.type.name === 'nestedExpand';
};
const $93876d773a1ca2f9$var$isExpandSelected = (selection)=>selection instanceof (0, $kCECX.NodeSelection) && $93876d773a1ca2f9$var$isExpandNode(selection.node);
function $93876d773a1ca2f9$export$e4ebafd8ecd98be0(api) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($93876d773a1ca2f9$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = api?.selection?.sharedState.currentState() || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($93876d773a1ca2f9$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($93876d773a1ca2f9$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $0c982aa6ebb943ef$export$2837c3a55abaa285)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $kCECX.TextSelection) && !(0, $kWLy1.isInTable)(state)) {
                const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $0c982aa6ebb943ef$export$2837c3a55abaa285)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $8QOo3.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $9gS7U.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expand.start)(state, dispatch, editorView);
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $8QOo3.isExpandCollapsed)(expandBefore.node)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === (0, $eaLat.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $8QOo3.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $8QOo3.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $kCECX.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $2edcbf582ab2a883$export$fd7bf9c73fdd6f30)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $8QOo3.isExpandCollapsed)(expandBefore.node)) return (0, $0c982aa6ebb943ef$export$ec60d41a1ae79321)(expandBefore.start)(state, dispatch, editorView);
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$93876d773a1ca2f9$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $kCECX.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode.node) && dispatch) return (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(api?.analytics?.actions)(state, dispatch);
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}


















var $8nvEM = parcelRequire("8nvEM");












var $iAEsk = parcelRequire("iAEsk");




































/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 























function $d87386a2132b5ed7$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: props.label,
            position: "top",
            tag: (0, $cSuwJ.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)(Component, props)));
    };
}
const $d87386a2132b5ed7$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $7Y8M5.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const { intl: intl, expanded: expanded } = props;
    const label = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6DhDg.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $d87386a2132b5ed7$var$ButtonWithTooltip = $d87386a2132b5ed7$var$withTooltip($d87386a2132b5ed7$export$aca20190620a52ea);
const $d87386a2132b5ed7$var$ButtonWithoutTooltip = $d87386a2132b5ed7$export$aca20190620a52ea;
const $d87386a2132b5ed7$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $cSuwJ.messages).collapseNode : (0, $cSuwJ.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($d87386a2132b5ed7$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $cSuwJ.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($d87386a2132b5ed7$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

















const $6441cef4343e79ca$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $6DhDg.expandClassNames).prefix} ${(0, $6DhDg.expandClassNames).type(type)} ${expanded ? (0, $6DhDg.expandClassNames).expanded : ''}`;
};
const $6441cef4343e79ca$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $6441cef4343e79ca$export$f7373e0b2eb22549(node.type.name, (0, $8QOo3.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $6DhDg.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $6DhDg.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $6DhDg.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $6DhDg.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandArialabel) || (0, $cSuwJ.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $cSuwJ.messages).expandPlaceholderText) || (0, $cSuwJ.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            'div',
            {
                // prettier-ignore
                class: `${(0, $6DhDg.expandClassNames).content} ${(0, $8QOo3.expandedState).get(node) ? '' : (0, $6DhDg.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...(0, $ieeJu.expValEquals)('platform_editor_expand_content_a11y', 'isEnabled', true) && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $cSuwJ.messages).expandBodyAriaLabel) || (0, $cSuwJ.messages).expandBodyAriaLabel.defaultMessage
                }
            },
            0
        ]
    ];








// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
const $b87e4c2ed4bd3870$var$darkModeSearchMatchClass = 'search-match-dark';
const $b87e4c2ed4bd3870$var$searchMatchExpandTitleClass = 'search-match-expand-title';
const $b87e4c2ed4bd3870$var$selectedSearchMatchClass = 'selected-search-match';
const $b87e4c2ed4bd3870$export$60784e18d5db1cae = (state)=>{
    const nestedOrParentExpand = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
    // If it's nested expand, we should check if its parent expand is collapsed.
    // If the parent expand is collapsed, the nested expand is not visible,
    // so it could not be selected.
    // In this case, we return the parent expand node instead of the nested expand node.
    if (nestedOrParentExpand?.node.type === state.schema.nodes.nestedExpand) {
        const parentExpand = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
        if (parentExpand && (0, $8QOo3.isExpandCollapsed)(parentExpand.node)) return parentExpand;
    }
    return nestedOrParentExpand;
};
const $b87e4c2ed4bd3870$export$ce3a0b3822605e07 = [
    $b87e4c2ed4bd3870$var$darkModeSearchMatchClass,
    $b87e4c2ed4bd3870$var$searchMatchExpandTitleClass,
    $b87e4c2ed4bd3870$var$selectedSearchMatchClass
];


class $6a4fe46449c2f369$export$e6a0ba759c3724b0 {
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $8QOo3.expandedState).get(this.node);
                if (wasExpanded) (0, $8QOo3.expandedState).set(node, wasExpanded);
            }
            this.node = node;
            const currentExpanded = (0, $8QOo3.expandedState).get(node) ?? false;
            const hasChanged = (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            }) ? this.isExpanded.expanded !== currentExpanded && this.isExpanded.localId === node.attrs.localId : this.isExpanded.expanded !== currentExpanded;
            if (hasChanged) {
                this.updateExpandToggleIcon(node);
                this.updateDisplayStyle(node);
            }
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $8QOo3.expandedState).get(node) ? (0, $8QOo3.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            if ((0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                const classes = this.dom.className.split(' ');
                // find & replace styles might be applied to the expand title and we need to keep them
                const findReplaceDecorationsApplied = classes.filter((className)=>(0, $b87e4c2ed4bd3870$export$ce3a0b3822605e07).includes(className)).join(' ');
                this.dom.className = findReplaceDecorationsApplied ? (0, $6441cef4343e79ca$export$f7373e0b2eb22549)(node.type.name, expanded) + ` ${findReplaceDecorationsApplied}` : (0, $6441cef4343e79ca$export$f7373e0b2eb22549)(node.type.name, expanded);
            } else this.dom.className = (0, $6441cef4343e79ca$export$f7373e0b2eb22549)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            if ((0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true)) this.renderNativeIcon(node);
            else this.renderIcon(this.icon ? this.icon : null, (0, $8QOo3.expandedState).get(node) ?? false);
        }
        this.updateExpandBodyContentEditable();
        this.isExpanded = (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        }) ? {
            expanded: expanded ?? false,
            localId: node.attrs.localId
        } : {
            expanded: expanded ?? false
        };
    }
    updateDisplayStyle(node) {
        if (this.content) {
            if ((0, $8QOo3.isExpandCollapsed)(node)) this.content.classList.add((0, $6DhDg.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $6DhDg.expandClassNames).contentCollapsed);
        }
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    renderNativeIcon(node) {
        if (!this.icon) return;
        (0, $030e3f5a1671f728$export$dde15965bbee9f3e)(this.icon, {
            expanded: !(0, $8QOo3.isExpandCollapsed)(node),
            allowInteractiveExpand: this.allowInteractiveExpand,
            intl: this.intl
        });
    }
    destroy() {
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        this.decorationCleanup?.();
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        this.nodeViewPortalProviderAPI.remove(this.renderKey);
    }
    constructor(_node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange, isExpanded = {
        expanded: false
    }){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.isExpanded = isExpanded;
        this.node = void 0;
        this.view = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.input = void 0;
        this.titleContainer = void 0;
        this.content = void 0;
        this.getPos = void 0;
        this.intl = void 0;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.api = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.decorationCleanup = void 0;
        this.renderKey = void 0;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $0c982aa6ebb943ef$export$289c5ebc50d962d9)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $iqS60.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if ((0, $btvbC.closestElement)(target, `.${(0, $6DhDg.expandClassNames).icon}`)) {
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $0c982aa6ebb943ef$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0c982aa6ebb943ef$export$87b459c5dfcbe773)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            this.decorationCleanup = this.api?.selectionMarker?.actions?.hideDecoration();
        };
        this.handleBlur = ()=>{
            this.decorationCleanup?.();
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in singlePlayer expand, please also update the implementation in legacyExpand
            if ((0, $ieeJu.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        const { state: state } = this.view;
                        this.view.focus();
                        this.api?.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, pos));
                            // Show the drag handle on the selected expand node
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                // Find the anchor name from the DOM
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? dom.getAttribute('data-node-anchor') : dom.getAttribute('data-drag-handler-anchor-name');
                                    // Only proceed if we found a valid anchor name
                                    if (anchorName) {
                                        const command = this.api?.blockControls?.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            switch((0, $iqS60.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $ieeJu.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) {
                if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    metaKey: event.metaKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey
                }));
            }
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $2w79Z.isEmptyNode)(state.schema)(expandNode)) (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(this.api?.analytics?.actions)(state, this.view.dispatch);
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                const { state: state, dispatch: dispatch } = this.view;
                (0, $0c982aa6ebb943ef$export$d94025373e8029d4)({
                    editorAnalyticsAPI: this.api?.analytics?.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $8QOo3.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $eaLat.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $kCECX.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).End,
                    selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = this.api?.selection?.sharedState.currentState() || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if (selectionSharedState?.selectionRelativeToNode === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(pos), (0, $eaLat.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $1JP3v.RelativeSelectionPos).Start,
                        selection: (0, $kCECX.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $di3bZ.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $di3bZ.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $8QOo3.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) return !this.api.editorDisabled.sharedState.currentState()?.editorDisabled && contentEditable;
            return contentEditable;
        };
        this.renderIcon = (icon, expanded)=>{
            if (!icon) return;
            this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d87386a2132b5ed7$export$5663c8f5aeb8c1c4), {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                }), icon, this.renderKey);
        };
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) {
            this.isExpanded.expanded = (0, $8QOo3.expandedState).get(_node) ?? false;
            this.isExpanded.localId = _node.attrs.localId;
        }
        const editorDisabled = api?.editorDisabled?.sharedState.currentState()?.editorDisabled;
        const { dom: _dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $6441cef4343e79ca$export$289411c5a7970646)(_node, this.__livePage, this.intl, editorDisabled, (0, $iAEsk.isSSRStreaming)() ? !editorDisabled && !(0, $8QOo3.isExpandCollapsed)(_node) : undefined));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = _dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).titleContainer}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        this.content = this.dom.querySelector(`.${(0, $6DhDg.expandClassNames).content}`);
        if (!(0, $8QOo3.expandedState).has(this.node)) (0, $8QOo3.expandedState).set(this.node, false);
        if ((0, $ieeJu.expValEquals)('platform_editor_vc90_transition_expand_icon', 'isEnabled', true)) this.renderNativeIcon(this.node);
        else this.renderIcon(this.icon, !(0, $8QOo3.isExpandCollapsed)(this.node));
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if (this.api?.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
        });
    }
}
function $6a4fe46449c2f369$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>new $6a4fe46449c2f369$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api?.selection?.actions?.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
}


const $f72d3c01a1d68f80$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('expandPlugin');
function $f72d3c01a1d68f80$export$366b6d00a7e2683b(element, className) {
    return Boolean(element?.classList?.contains(className));
}
const $f72d3c01a1d68f80$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $kpCD8.SafePlugin)({
        key: $f72d3c01a1d68f80$export$18d4026d1ea86bb1,
        state: {
            init () {
                return (0, $8nvEM.DecorationSet).empty;
            },
            apply (tr, decorationSet) {
                const meta = tr.getMeta((0, $8fae9b809547d771$export$657fbcd00719af4b));
                if (meta && meta.positions.length > 0) {
                    // Add node decorations for each expand node that was toggled.
                    // ExpandNodeView.update() uses these decorations to detect it needs to
                    // visually open or close, even when expandedState was set before the
                    // transaction replaced the node objects.
                    // We do NOT map or carry forward existing decorations — we start fresh
                    // each time the meta is present.
                    const decorations = meta.positions.map((pos)=>(0, $8nvEM.Decoration).node(pos, pos + (tr.doc.nodeAt(pos)?.nodeSize ?? 0), {}, {
                            forceExpandOpen: meta.open
                        }));
                    return (0, $8nvEM.DecorationSet).create(tr.doc, decorations);
                }
                // Map existing decorations through document changes.
                // They will be naturally cleared when they no longer match any node
                // (e.g. if the expand is deleted), or on the next toggleExpandRange call.
                return decorationSet.map(tr.mapping, tr.doc);
            }
        },
        props: {
            decorations (state) {
                return $f72d3c01a1d68f80$export$18d4026d1ea86bb1.getState(state);
            },
            nodeViews: {
                expand: (0, $6a4fe46449c2f369$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $6a4fe46449c2f369$export$2e2bcd8739ae039)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(event.target, (0, $6DhDg.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $f72d3c01a1d68f80$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput);
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $6DhDg.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $f72d3c01a1d68f80$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            if ($f72d3c01a1d68f80$export$366b6d00a7e2683b(document.activeElement, (0, $6DhDg.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric)) return false;
            return true;
        }
    });
};
function $f72d3c01a1d68f80$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $8d532e37d2ea1d00$export$447e90e618548243)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $jPUdw.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}













const $52f36ed40f63035d$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const selectedExpandNode = (0, $b87e4c2ed4bd3870$export$60784e18d5db1cae)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>// Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $bjg0G.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                        onClick: (0, $0c982aa6ebb943ef$export$20123cb2952020ea)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration?.([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $2xhuI.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };


const $5073fc174b6771a9$var$EXPAND_NODE_NAME = 'expand';
let $5073fc174b6771a9$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $2b7ab0141b432875$export$43e1eed033b6f3d3)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($5073fc174b6771a9$var$EXPAND_NODE_NAME))
        }
    ]);
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $chuMh.expandWithNestedExpandLocalId) : (0, $chuMh.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $7RQ8H.nestedExpandWithLocalId) : (0, $7RQ8H.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $0c982aa6ebb943ef$export$982de01464f3ba33)(api),
            insertExpandWithInputMethod: (0, $0c982aa6ebb943ef$export$4782944d4b10fd76)(api)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $0c982aa6ebb943ef$export$6f1dc7179cebfcb1)(selection),
            toggleExpandRange: $8fae9b809547d771$export$de35616b4bcd2077
        },
        getSharedState () {
            return (0, $ieeJu.expValEquals)('platform_editor_expand_paste_in_comment_editor', 'isEnabled', true) ? {
                allowInsertion: options?.allowInsertion ?? true
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $f72d3c01a1d68f80$export$ae829ec7b2625219)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $93876d773a1ca2f9$export$e4ebafd8ecd98be0)(api)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $52f36ed40f63035d$export$86ce8f8241c20a3)(api),
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options && options.allowInsertion !== true) return [];
                return [
                    {
                        id: 'expand',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expand),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).expandDescription),
                        keywords: [
                            'accordion',
                            'collapse'
                        ],
                        priority: 600,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconExpand), null),
                        action (insert, state, source) {
                            const node = (0, $0c982aa6ebb943ef$export$b7c6a6a1365fc215)(state, undefined, !!api?.localId);
                            if (!node) return false;
                            const tr = state.selection.empty ? insert(node) : (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $0c982aa6ebb943ef$export$b07fdfa9172394f4)(state, node) : (0, $dX4zl.createWrapSelectionTransaction)({
                                state: state,
                                type: node.type
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $krYZG.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $krYZG.ACTION_SUBJECT_ID).EXPAND,
                                attributes: {
                                    inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};


let $20d6b4b6e3117d77$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options?.__livePage) return (0, $5073fc174b6771a9$export$a4a90f0c2a6f7a01)({
        config: options,
        api: api
    });
    else {
        if ((0, $ieeJu.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) return (0, $5073fc174b6771a9$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
        else return (0, $f981a0fe8af5b8e6$export$a4a90f0c2a6f7a01)({
            config: options,
            api: api
        });
    }
};
module.exports["expandPlugin"] = $20d6b4b6e3117d77$export$a4a90f0c2a6f7a01;

});

parcelRegister("3gmKQ", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $iwjSV = parcelRequire("iwjSV");


var $hVgcP = parcelRequire("hVgcP");

var $ixHGM = parcelRequire("ixHGM");

var $20WsY = parcelRequire("20WsY");


var $kpCD8 = parcelRequire("kpCD8");


var $ixfCV = parcelRequire("ixfCV");


var $krYZG = parcelRequire("krYZG");
var $b9b39f75b7ac85cf$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $b9b39f75b7ac85cf$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});



var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $3ztIq = parcelRequire("3ztIq");





var $gWBVp = parcelRequire("gWBVp");


var $3xuv0 = parcelRequire("3xuv0");


var $aPdNQ = parcelRequire("aPdNQ");








var $ieeJu = parcelRequire("ieeJu");





var $dpfrn = parcelRequire("dpfrn");








var $cI8RZ = parcelRequire("cI8RZ");




const $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('extensionPlugin');


function $004bdf518602b49b$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}


const $7d5ef977555345d3$var$factory = (0, $cI8RZ.pluginFactory)((0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1), (0, $004bdf518602b49b$export$2e2bcd8739ae039), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $7d5ef977555345d3$export$656c7661095efe2e = $7d5ef977555345d3$var$factory.createPluginState;
const $7d5ef977555345d3$export$8d4021544bdece00 = $7d5ef977555345d3$var$factory.createCommand;
const $7d5ef977555345d3$export$f05434c51e3762e = $7d5ef977555345d3$var$factory.getPluginState;






var $jfFbl = parcelRequire("jfFbl");


var $btvbC = parcelRequire("btvbC");

var $2l49p = parcelRequire("2l49p");








var $bijHC = parcelRequire("bijHC");

const $167f96829d9c9919$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $bjg0G.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $bjg0G.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $167f96829d9c9919$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $167f96829d9c9919$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $bjg0G.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $btvbC.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $167f96829d9c9919$export$cd9967958db163fc = (newNode)=>newNode.marks?.find((mark)=>mark.type.name === 'dataConsumer');
const $167f96829d9c9919$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $2l49p.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $167f96829d9c9919$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $2l49p.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
/**
 * Converts a ProseMirror node to its text representation.
 * Handles text nodes with marks (links) and inline nodes (status, mention, emoji).
 * Returns the content for this node, with a trailing separator for text blocks.
 */ const $167f96829d9c9919$var$convertNodeToText = (node, mentionSet, parent, locale)=>{
    if (node.isInline) {
        const schema = node.type.schema;
        let finalText = '';
        if (node.isText) {
            finalText = node.text || '';
            if (node.marks.length > 0) {
                for (const mark of node.marks)// if it's link, include the href in the text
                if (mark.type === schema.marks.link) {
                    const href = mark.attrs.href;
                    const text = node.text || '';
                    // If the text differs from the href, include both
                    if (text && text !== href) finalText = `${text} ${href}`;
                    else finalText = href;
                }
            }
        } else switch(node.type){
            case schema.nodes.status:
                finalText = node.attrs.text || '';
                break;
            case schema.nodes.mention:
                mentionSet.add(node.attrs.id);
                finalText = `@${node.attrs.id}`;
                break;
            case schema.nodes.emoji:
                finalText = node.attrs.shortName || '';
                break;
            case schema.nodes.date:
                const timestamp = new Date(Number(node.attrs.timestamp));
                finalText = !isNaN(timestamp.getTime()) ? timestamp.toLocaleDateString(locale ?? 'en-US') : String(node.attrs.timestamp);
                break;
            default:
                finalText = node.textContent;
                break;
        }
        if (parent && parent.isTextblock && node === parent.lastChild && parent.childCount > 0) finalText += '\n\n';
        return finalText;
    }
    return '';
};
/**
 * Resolves mention IDs to their display names and replaces them in the text.
 * Returns the text with resolved mentions, or the original text if the provider is unavailable.
 */ const $167f96829d9c9919$var$resolveMentionsInText = async (text, mentionSet, api)=>{
    const mentionProvider = api?.mention?.sharedState?.currentState()?.mentionProvider;
    if (!mentionProvider || !(0, $bijHC.isResolvingMentionProvider)(mentionProvider)) return text;
    let resolvedText = text;
    for (const id of mentionSet){
        const mention = await mentionProvider.resolveMentionName(id);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        resolvedText = resolvedText.replace(`@${id}`, `@${mention.name}` || "@\u2026");
    }
    return resolvedText;
};
const $167f96829d9c9919$export$9defe25170de6263 = async ({ locale: locale, schema: schema, unsupportedContent: unsupportedContent, api: api })=>{
    try {
        if (!unsupportedContent) throw new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $3xuv0.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        let text = '';
        const mentionSet = new Set();
        pmNode.nodesBetween(0, pmNode.content.size, (node, _pos, parent)=>{
            text += $167f96829d9c9919$var$convertNodeToText(node, mentionSet, parent, locale);
        });
        // Trim leading/trailing whitespace from the collected text
        text = text.trim();
        text = await $167f96829d9c9919$var$resolveMentionsInText(text, mentionSet, api);
        (0, $jfFbl.copyToClipboard)(text);
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $167f96829d9c9919$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    const nodeWithPos = $167f96829d9c9919$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi?.analytics?.actions.fireAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        action: (0, $krYZG.ACTION).COPY_FAILED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};


function $3d915853de2ecd5c$export$4971331372cec95a(state) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $3d915853de2ecd5c$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $3d915853de2ecd5c$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $3d915853de2ecd5c$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $3d915853de2ecd5c$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state)) return $3d915853de2ecd5c$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $3d915853de2ecd5c$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $3d915853de2ecd5c$export$fa79c3ccfdddfece = (sourceNode)=>(0, $7d5ef977555345d3$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $dpfrn.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $3d915853de2ecd5c$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeSelectedNode)(tr);
};
const $3d915853de2ecd5c$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $bjg0G.removeParentNodeOfType)(nodeType)(tr);
};



var $9Rq82 = parcelRequire("9Rq82");





var $8tXCb = parcelRequire("8tXCb");


var $YvadP = parcelRequire("YvadP");











const $61358629666c9a4d$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('macroPlugin');


const $783fd49d73f6388e$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $783fd49d73f6388e$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $bjg0G.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $bjg0G.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $bjg0G.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $bjg0G.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).UPDATED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $krYZG.INPUT_METHOD).MACRO_BROWSER : (0, $krYZG.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $783fd49d73f6388e$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $YvadP.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $8tXCb.normaliseNestedLayout)(state, node);
};
const $783fd49d73f6388e$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $783fd49d73f6388e$export$87074dfcaea41da3(macroAttributes, state);
};
const $783fd49d73f6388e$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($9Rq82)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1), {
            macroProvider: resolvedProvider
        }));
        return true;
    };




const $92573c06ef675309$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $92573c06ef675309$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $krYZG.ACTION).INVOKED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
const $92573c06ef675309$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $3ztIq.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    /**
	 * Finds the node and its position by `localId`. Throws if the node could not be found.
	 *
	 * @returns {NodeWithPos}
	 */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $167f96829d9c9919$export$bb057d1dfc5c8b1b)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $aPdNQ.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $aPdNQ.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType?.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $167f96829d9c9919$export$cd9967958db163fc)(node);
                const stringIds = dataConsumerMark?.attrs.sources.map((sourceId)=>sourceId) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $167f96829d9c9919$export$1004a88e790d2d21)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $krYZG.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $bjg0G.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                content: (0, $gWBVp.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? changedValues.marks?.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $aPdNQ.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') newAttrs = {
                ...node.attrs,
                ...changedValues.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    ...changedValues.attrs?.parameters,
                    macroParams: {
                        ...node.attrs.parameters?.macroParams,
                        ...changedValues.attrs?.parameters?.macroParams
                    }
                }
            };
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = node.type.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $3xuv0.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                tr.replaceWith(pos, pos + node.nodeSize, newNode);
                // Keep selection if content does not change
                if (newContent === node.content) tr.setSelection((0, $kCECX.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $92573c06ef675309$var$extensionAPICallPayload('update');
            editorAnalyticsAPI?.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof opts?.addToHistory === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof opts?.scrollIntoView === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $3d915853de2ecd5c$export$845f8c516a847983)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(editorView.state);
                editInLegacy = $92573c06ef675309$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: macroState?.macroProvider || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};




const $5313dd79acf665fc$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $5313dd79acf665fc$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $5313dd79acf665fc$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $bjg0G.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $bjg0G.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).CURRENT_SELECTION;
            let action = (0, $krYZG.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $bjg0G.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $bjg0G.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $b9b39f75b7ac85cf$export$b9401faa25e39d87).HTML_ELEMENT;
                } else action = (0, $krYZG.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $krYZG.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $5313dd79acf665fc$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters?.macroParams
                    };
                    return $5313dd79acf665fc$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $5313dd79acf665fc$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        const nodeWithPos = (0, $167f96829d9c9919$export$b003700b6d25caa7)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $92573c06ef675309$export$5c24840493a9fa44)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $5313dd79acf665fc$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $5313dd79acf665fc$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(view.state);
        return $5313dd79acf665fc$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $5313dd79acf665fc$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $5313dd79acf665fc$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};





var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");



function $d40259b0c24668cb$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.escape).common, (state, dispatch)=>{
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
    }, list);
    return (0, $44cyU.keymap)(list);
}








const $bf6f7e4036588680$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $61358629666c9a4d$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $61358629666c9a4d$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $61358629666c9a4d$export$18d4026d1ea86bb1),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $783fd49d73f6388e$export$e45aff648def0591)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });



var $iAEsk = parcelRequire("iAEsk");





var $lp7sw = parcelRequire("lp7sw");

var $4EksL = parcelRequire("4EksL");

var $1tdnq = parcelRequire("1tdnq");

var $iscRo = parcelRequire("iscRo");









var $1sE44 = parcelRequire("1sE44");


var $hMfrQ = parcelRequire("hMfrQ");


var $fqVYq = parcelRequire("fqVYq");


function $f377b4b9753beb6d$export$18f6e24b34cb523d(nodeName, ...params) {
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $1sE44.default)(...params);
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: nodeName,
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("idCC2")).then(({ ExtensionNodeView: ExtensionNodeView })=>{
                return ExtensionNodeView(...params);
            });
            return result;
        }
    });
}





var $cd8tA = parcelRequire("cd8tA");



const $e273459f17684478$var$maybeGetUpdateMethodFromExtensionProvider = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $cd8tA.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode.update;
};
const $e273459f17684478$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const updateMethod = await $e273459f17684478$var$maybeGetUpdateMethodFromExtensionProvider(view, extensionProvider);
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            showEditButton: !!updateMethod,
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};



const $584598053f9859f0$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $584598053f9859f0$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $584598053f9859f0$export$21b8c38408ff6d69 = (view)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $e273459f17684478$export$1e25f457f2ade11e)(view, extensionProvider);
        } catch  {
            (0, $3d915853de2ecd5c$export$4971331372cec95a)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $584598053f9859f0$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $167f96829d9c9919$export$f1c79f28529bfc9a)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $167f96829d9c9919$export$cdb701fa2b3c99df)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // This is the current assumption and it's wrong but we are keeping it
    // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $584598053f9859f0$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $584598053f9859f0$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $3d915853de2ecd5c$export$4971331372cec95a)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $584598053f9859f0$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions, intl)=>{
    const state = (0, $7d5ef977555345d3$export$656c7661095efe2e)(dispatch, {
        showEditButton: false,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: featureFlags?.macroInteractionUpdates ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $584598053f9859f0$export$21b8c38408ff6d69(editorView);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    $584598053f9859f0$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi?.contextPanel?.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1),
        props: {
            handleDOMEvents: {
                /**
         * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
         * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
         * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
         */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $kCECX.TextSelection) || selection instanceof (0, $kCECX.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $kCECX.TextSelection) ? (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $bjg0G.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $iscRo.isSelectionAtStartOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $1tdnq.isSelectionAtEndOfNode)($head, maybeBodiedExtension?.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $4EksL.GapCursorSelection) || selection instanceof (0, $kCECX.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
                 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
                 */ const previousPositionDecrement = selection instanceof (0, $4EksL.GapCursorSelection) ? 1 : 2;
                                if (tr.doc.nodeAt($head.pos - previousPositionDecrement)?.type === extensionFrame) {
                                    const newSelection = (0, $kCECX.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $f377b4b9753beb6d$export$18f6e24b34cb523d)('extension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $iAEsk.isSSRStreaming)() ? intl : undefined),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $f377b4b9753beb6d$export$18f6e24b34cb523d)('bodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers, (0, $iAEsk.isSSRStreaming)() ? intl : undefined),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $f377b4b9753beb6d$export$18f6e24b34cb523d)('inlineExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $iAEsk.isSSRStreaming)() ? intl : undefined),
                multiBodiedExtension: (0, $f377b4b9753beb6d$export$18f6e24b34cb523d)('multiBodiedExtension', portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, // isAnchorInMBE.pos < head.pos represents downwards selection
                    head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $kCECX.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize // isHeadInMBE.pos < anchor.pos represents upwards selection
                    );
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), // It's to enable nested extensions selection
            {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};




var $04Oo7 = parcelRequire("04Oo7");


var $8Dx7s = parcelRequire("8Dx7s");

const $b098027f4699dcb1$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $b098027f4699dcb1$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $04Oo7.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $8Dx7s.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $b098027f4699dcb1$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $8Dx7s.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};



var $cozmU = parcelRequire("cozmU");





var $2sp5n = parcelRequire("2sp5n");

var $3nm9z = parcelRequire("3nm9z");


var $2xhuI = parcelRequire("2xhuI");


var $2aFJ8 = parcelRequire("2aFJ8");


var $g6uqx = parcelRequire("g6uqx");




var $eQeCt = parcelRequire("eQeCt");


var $6Ixg8 = parcelRequire("6Ixg8");





var $6RqDx = parcelRequire("6RqDx");


var $4mxZP = parcelRequire("4mxZP");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $9V98o = parcelRequire("9V98o");












// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $7d58a2ee0cc4b964$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: nodes }, selection: selection } = state;
    const { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem, panel_c1: panel_c1 } = nodes;
    if (!selectedExtNode) return false;
    const parentNodeTypes = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        blockquote,
        listItem
    ] : [
        panel,
        blockquote,
        listItem
    ];
    return selectedExtNode.node.type === extension && (0, $bjg0G.hasParentNodeOfType)(parentNodeTypes.filter(Boolean))(selection);
};
const $7d58a2ee0cc4b964$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    // Skip agent-managed-block extension until it supports the layout controls in its custom node
    const extensionKey = selectedExtNode.node.attrs.extensionKey;
    if ((0, $2sp5n.AGENT_MANAGED_EXTENSION_KEY) === extensionKey) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $bjg0G.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $bjg0G.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $bjg0G.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $7d58a2ee0cc4b964$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) && !$7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                        label: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                        label: formatMessage((0, $2xhuI.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $2xhuI.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                        label: formatMessage((0, $2xhuI.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o))),
                onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $2xhuI.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $7d58a2ee0cc4b964$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$7d58a2ee0cc4b964$var$isLayoutSupported(state, nodeWithPos) || $7d58a2ee0cc4b964$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $2xhuI.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)));
            break;
        case 'full-width':
            title = formatMessage((0, $2xhuI.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $2xhuI.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($6RqDx)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $2xhuI.default).layoutFixedWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6RqDx))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $2xhuI.default).layoutWide),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4mxZP))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $2xhuI.default).layoutFullWidth),
            onClick: (0, $3d915853de2ecd5c$export$612be0ec35a64e3b)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9V98o))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2xhuI.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $7d58a2ee0cc4b964$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? $7d58a2ee0cc4b964$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $7d58a2ee0cc4b964$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $7d58a2ee0cc4b964$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $61358629666c9a4d$export$18d4026d1ea86bb1).getState(state);
                const { updateExtension: updateExtension } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
                (0, $5313dd79acf665fc$export$f45ebaf24963f4bb)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $3nm9z.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: (0, $ieeJu.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? false : undefined
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $7d58a2ee0cc4b964$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $bjg0G.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && extensionNode?.node.type.name === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement?.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $2aFJ8.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $7d58a2ee0cc4b964$export$7652656d91146fb9 = ({ formatMessage: formatMessage, extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state, locale: locale })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent?.(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        extensionApi?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).COPY_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionDynamicType: node.type.name,
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey
            }
        });
        (0, $167f96829d9c9919$export$9defe25170de6263)({
            locale: locale,
            unsupportedContent: adf,
            schema: state.schema,
            api: extensionApi
        }).then(()=>{
            extensionApi?.copyButton?.actions.afterCopy(formatMessage((0, $2xhuI.default).copiedToClipboard));
        }).catch((error)=>{
            (0, $167f96829d9c9919$export$67e8f2a5d4f25de0)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
        });
        return true;
    };
};
const $7d58a2ee0cc4b964$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        const { formatMessage: formatMessage, locale: locale } = intl;
        const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi?.decorations?.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi?.contextPanel?.actions.applyChange;
        const editorAnalyticsAPI = extensionApi?.analytics?.actions;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $7d58a2ee0cc4b964$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $6Ixg8.isOfflineMode)(extensionApi?.connectivity?.sharedState?.currentState()?.mode), extensionApi);
        const breakoutItems = $7d58a2ee0cc4b964$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if (extensionObj?.node.attrs.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && extensionObj?.node.attrs.extensionKey.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $dpfrn.isReferencedSource)(state, extensionObj?.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $3nm9z.messages).unnamedSource);
            return {
                title: formatMessage((0, $3nm9z.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $3nm9z.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $eQeCt.getNodeName)(state, extensionObj?.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $dpfrn.getChildrenInfo)(state, extensionObj?.node),
                checkboxLabel: formatMessage((0, $3nm9z.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$7d58a2ee0cc4b964$var$clickWithCheckboxHandler(isChecked, extensionObj?.node)
            };
        };
        // disable copy button for legacy content macro
        const shouldHideCopyButton = extensionObj?.node.attrs.extensionType === 'com.atlassian.confluence.migration' && extensionObj?.node.attrs.extensionKey === 'legacy-content';
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$7d58a2ee0cc4b964$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: $7d58a2ee0cc4b964$export$7652656d91146fb9({
                                formatMessage: formatMessage,
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state,
                                locale: locale
                            })
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                {
                    type: 'separator'
                },
                {
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    appearance: 'danger',
                    onClick: (0, $3d915853de2ecd5c$export$366c74c25333cf63)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $2xhuI.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $7d58a2ee0cc4b964$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $3d915853de2ecd5c$export$366c74c25333cf63)()(state, dispatch);
        else (0, $3d915853de2ecd5c$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };



var $2nOF5 = parcelRequire("2nOF5");


var $1A89X = parcelRequire("1A89X");





var $6MtNT = parcelRequire("6MtNT");




const $f28c64404a6658d7$var$pluginKey = new (0, $kCECX.PluginKey)('extensionUniqueIdPlugin');
const $f28c64404a6658d7$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>(0, $6MtNT.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $1A89X.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    step.attrs?.localId === null);
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $2nOF5.uuid).generate()
                            });
                        }
                        /**
							 * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
							 * since we can have more extension nodes within the contents of that
							 */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
						 * Otherwise continue traversing, we can encounter extensions nested in
						 * expands/bodiedExtensions
						 */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $f28c64404a6658d7$var$pluginKey
    });



var $fJUEv = parcelRequire("fJUEv");














var $8HW7o = parcelRequire("8HW7o");






var $4wH3g = parcelRequire("4wH3g");


var $fjZlw = parcelRequire("fjZlw");


const $6a7a68fea06620b8$var$_default_1 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "qCkVP",
    name: "_default_1",
    loader: ()=>(parcelRequire("cnZ3W")).then((module)=>module.default),
    loading: (0, $fjZlw.default)
});
var $6a7a68fea06620b8$export$2e2bcd8739ae039 = $6a7a68fea06620b8$var$_default_1;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");





var $chu6R = parcelRequire("chu6R");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");

function $4d99bbf49073cd12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d99bbf49073cd12$var$noop = ()=>{};
const $4d99bbf49073cd12$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $4d99bbf49073cd12$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    /* E300 */ boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $4d99bbf49073cd12$var$saveIndicatorTextStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.075'
});
const $4d99bbf49073cd12$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $cozmU.useState)(false);
    const shown = (0, $cozmU.useRef)(false);
    const onSaveStarted = (0, $cozmU.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $4d99bbf49073cd12$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $4d99bbf49073cd12$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: "Saving",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $4d99bbf49073cd12$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $3nm9z.messages).saveIndicator))))));
};


const $fc213d5917462889$var$areParametersEqual = (firstParameters, secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $fc213d5917462889$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $kCECX.NodeSelection)) return (0, $kCECX.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $kCECX.TextSelection)) return (0, $kCECX.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $4EksL.GapCursorSelection)) return new (0, $4EksL.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $8HW7o.CellSelection)) return new (0, $8HW7o.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $fc213d5917462889$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(state, true);
            const applyChange = api?.contextPanel?.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
                    duration: 5000,
                    visible: true
                }, ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    const editorView = getEditorView?.();
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: async (updatedParameters)=>{
                            await $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onCancel: async ()=>{
                            try {
                                await new Promise((resolve, reject)=>{
                                    (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                });
                            } catch (e) {
                                // Even if the save failed, we should proceed with closing the panel
                                // eslint-disable-next-line no-console
                                console.error(`Autosave failed with error`, e);
                            }
                            (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
                        },
                        featureFlags: featureFlags
                    });
                });
            }
        };
async function $fc213d5917462889$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($fc213d5917462889$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $5313dd79acf665fc$export$5e06148a47ef53c2)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $fc213d5917462889$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $3d915853de2ecd5c$export$4971331372cec95a)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}









var $3k5Tv = parcelRequire("3k5Tv");


var $iMnC5 = parcelRequire("iMnC5");














var $kA6Zo = parcelRequire("kA6Zo");







var $jND0n = parcelRequire("jND0n");

function $76989ca55049fc51$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $jND0n.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}


const $923147737bfc3fc6$var$itemBodyStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $923147737bfc3fc6$var$itemTextStyles = (0, $buxP3.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $923147737bfc3fc6$var$summaryStyles = (0, $buxP3.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $923147737bfc3fc6$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $923147737bfc3fc6$var$itemBodyStyles
    }, summary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $923147737bfc3fc6$var$itemTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "context-panel-title",
        "data-testid": "context-panel-title"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $923147737bfc3fc6$var$summaryStyles
    }, summary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        alignItems: "center",
        testId: "context-panel-title"
    }, title));
}
const $923147737bfc3fc6$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($923147737bfc3fc6$var$HeaderAfterIconElement);
var $923147737bfc3fc6$export$2e2bcd8739ae039 = $923147737bfc3fc6$var$_default_1;











const $1ae0de3813cee7fd$var$iconWidth = '40px';
const $1ae0de3813cee7fd$var$itemIconStyles = (0, $buxP3.xcss)({
    width: $1ae0de3813cee7fd$var$iconWidth,
    height: $1ae0de3813cee7fd$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $1ae0de3813cee7fd$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $cozmU.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1ae0de3813cee7fd$var$itemIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedIcon, {
        label: title
    })));
}
const $1ae0de3813cee7fd$var$_default_1 = (0, $76989ca55049fc51$export$7dd73e517d9d8a3)($1ae0de3813cee7fd$var$HeaderIcon);
var $1ae0de3813cee7fd$export$2e2bcd8739ae039 = $1ae0de3813cee7fd$var$_default_1;




const $32d059b94ccba6f8$var$selector = (states)=>{
    return {
        showContextPanel: states.extensionState?.showContextPanel,
        extensionProvider: states.extensionState?.extensionProvider,
        processParametersAfter: states.extensionState?.processParametersAfter
    };
};
function $32d059b94ccba6f8$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $32d059b94ccba6f8$var$selector);
    (0, $cozmU.useEffect)(()=>{
        const nodeWithPos = (0, $167f96829d9c9919$export$cdb701fa2b3c99df)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $32d059b94ccba6f8$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $32d059b94ccba6f8$export$2a2eb89a1c258b39(configPanelId, api) {
    const closePanelById = api?.contextPanel?.actions?.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $32d059b94ccba6f8$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos?.node.attrs;
        const extensionType = nodeAttrs?.extensionType;
        const extensionKey = nodeAttrs?.extensionKey;
        /**
     * Loading extension manifest fails when using
     * 	extensionKey directly from nodeAttrs.
     * Always get extensionKey from getExtensionKeyAndNodeKey to load
     * 	extension manifest successfully.
     */ const [extKey, _] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ae0de3813cee7fd$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $923147737bfc3fc6$export$2e2bcd8739ae039), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $32d059b94ccba6f8$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorView.state);
                    /**
           * 	If context panel is open, then first update extension plugin state.
           * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
           * 		which will call hideConfigPanel.
           */ if (extensionState?.showContextPanel) {
                        await $32d059b94ccba6f8$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $fJUEv.CONFIG_PANEL_WIDTH));
    }
}
async function $32d059b94ccba6f8$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    const applyChange = api?.contextPanel?.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $3d915853de2ecd5c$export$81748740fe20ba64)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $3d915853de2ecd5c$export$265d048971b3d878)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $32d059b94ccba6f8$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorState = editorView.state;
    const extensionState = (0, $7d5ef977555345d3$export$f05434c51e3762e)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            padding: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d99bbf49073cd12$export$7ceebdb305e167df), {
            duration: 5000,
            visible: true
        }, ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a7a68fea06620b8$export$2e2bcd8739ae039), {
                api: api,
                showHeader: true,
                closeOnEsc: true,
                extensionType: extensionType,
                extensionKey: extKey,
                nodeKey: nodeKey,
                extensionParameters: parameters,
                parameters: configParams,
                extensionProvider: extensionProvider,
                autoSaveTrigger: autoSaveResolve,
                autoSaveReject: autoSaveReject,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onChange: async (updatedParameters)=>{
                    await (0, $fc213d5917462889$export$2f221d4ebb46923c)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                    onSaveEnded();
                    if (autoSaveResolve) autoSaveResolve();
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCancel: ()=>$32d059b94ccba6f8$export$237eef05f48e1226({
                        api: api,
                        editorView: editorView
                    }),
                featureFlags: featureFlags,
                // Remove below prop when cleaning platform_editor_ai_object_sidebar_injection FG
                // Becuase it will always be true
                usingObjectSidebarPanel: true
            });
        }));
};


const $bd6dbeefb66a82f7$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $fJUEv.CONFIG_PANEL_ID)}-${(0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()}`;
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const extensionLoadingHandlers = {};
    const showContextPanel = api?.contextPanel?.actions?.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $hVgcP.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $b098027f4699dcb1$export$1a85854d3d541a64)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $20WsY.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $ixHGM.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $ixHGM.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $dcc3a1c170ab4a0c$export$18d4026d1ea86bb1).getState(state);
            return {
                showContextPanel: pluginState?.showContextPanel,
                extensionProvider: pluginState?.extensionProvider,
                processParametersAfter: pluginState?.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $584598053f9859f0$export$ae829ec7b2625219)(dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight
                        }, featureFlags, options?.__rendererExtensionOptions, getIntl());
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>(0, $d40259b0c24668cb$export$2e2bcd8739ae039)(api?.contextPanel?.actions.applyChange)
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $f28c64404a6658d7$export$ae829ec7b2625219)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $bf6f7e4036588680$export$ae829ec7b2625219)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                return (0, $92573c06ef675309$export$5c70dcf0377b6800)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api?.contextPanel?.actions.applyChange,
                    editorAnalyticsAPI: api?.analytics?.actions
                });
            },
            getExtensionLoadingHandlers: ()=>extensionLoadingHandlers,
            insertMacroFromMacroBrowser: (0, $783fd49d73f6388e$export$4ec44b2939e261e2)(api?.analytics?.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$f151d046c10e64b5)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $5313dd79acf665fc$export$8ee156b55126996c)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $5313dd79acf665fc$export$1efb7858e16078f5)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api?.analytics?.actions,
                applyChangeToContextPanel: api?.contextPanel?.actions.applyChange
            }),
            registerExtensionLoadingHandler: ({ extensionType: extensionType, handler: handler })=>{
                extensionLoadingHandlers[extensionType] = handler;
                return ()=>{
                    if (extensionLoadingHandlers[extensionType] === handler) delete extensionLoadingHandlers[extensionType];
                };
            },
            runMacroAutoConvert: $783fd49d73f6388e$export$774dc72aee79b8eb,
            forceAutoSave: $3d915853de2ecd5c$export$265d048971b3d878
        },
        pluginsOptions: {
            floatingToolbar: (0, $7d58a2ee0cc4b964$export$86ce8f8241c20a3)({
                breakoutEnabled: options.breakoutEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: // if showContextPanel action is not available, or platform_editor_ai_object_sidebar_injection feature flag is off
            // 	then keep using old context panel.
            !showContextPanel || !(0, $ixfCV.fg)('platform_editor_ai_object_sidebar_injection') ? (0, $fc213d5917462889$export$7c8c60c0acb92731)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel && (0, $ixfCV.fg)('platform_editor_ai_object_sidebar_injection') ? ({ editorView: editorView })=>{
            (0, $32d059b94ccba6f8$export$781dfcd068e3a2e0)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};
module.exports["extensionPlugin"] = $bd6dbeefb66a82f7$export$feb99ebbc74a9193;

});

parcelRegister("idCC2", function(module, exports) {

let $d437648629ceb230$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d437648629ceb230$var$load("25r41").then(()=>parcelRequire('7WyBJ'));

});

parcelRegister("fJUEv", function(module, exports) {
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $2549d8cb406fc6f5$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $2549d8cb406fc6f5$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5 = 320;
const $2549d8cb406fc6f5$export$cb69418acbe13bc2 = 'extensions-panel';
module.exports["ALLOWED_LOGGED_MACRO_PARAMS"] = $2549d8cb406fc6f5$export$2a99ab8c82908148;
module.exports["ALLOWED_PARAM_TYPES"] = $2549d8cb406fc6f5$export$d17c9f402b8c93c8;
module.exports["CONFIG_PANEL_WIDTH"] = $2549d8cb406fc6f5$export$57e7dbe0bbfe09b5;
module.exports["CONFIG_PANEL_ID"] = $2549d8cb406fc6f5$export$cb69418acbe13bc2;

});

parcelRegister("fjZlw", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3nm9z = parcelRequire("3nm9z");


var $1VhsF = parcelRequire("1VhsF");


var $lfoFx = parcelRequire("lfoFx");


var $fqVYq = parcelRequire("fqVYq");

function $1b8a019e594923bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b8a019e594923bc$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $1b8a019e594923bc$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $1b8a019e594923bc$var$LoadingStateWithErrorHandling = (0, $kSwu1.injectIntl)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1VhsF.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $3nm9z.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $1b8a019e594923bc$var$LoadingStateWithoutErrorHandling = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $1b8a019e594923bc$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lfoFx.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
const $1b8a019e594923bc$var$LoadingState = (props)=>(0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) ? $1b8a019e594923bc$var$LoadingStateWithErrorHandling(props) : $1b8a019e594923bc$var$LoadingStateWithoutErrorHandling();
var $1b8a019e594923bc$export$2e2bcd8739ae039 = $1b8a019e594923bc$var$LoadingState;
module.exports["default"] = $1b8a019e594923bc$export$2e2bcd8739ae039;

});

parcelRegister("cnZ3W", function(module, exports) {

let $9046ffc82fa3fa07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9046ffc82fa3fa07$var$load("6wr18"),
    $9046ffc82fa3fa07$var$load("aJLFD"),
    $9046ffc82fa3fa07$var$load("hhss7"),
    $9046ffc82fa3fa07$var$load("ffEVr"),
    $9046ffc82fa3fa07$var$load("Wowvf"),
    $9046ffc82fa3fa07$var$load("7EorR"),
    $9046ffc82fa3fa07$var$load("gbejv"),
    $9046ffc82fa3fa07$var$load("GD9EA"),
    $9046ffc82fa3fa07$var$load("8GyM5")
]).then(()=>parcelRequire('jqjhk'));

});

parcelRegister("jND0n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




const $aef92eb44b339a57$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $aef92eb44b339a57$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $aef92eb44b339a57$var$safeError('Missing AbortController');
    return new AbortController();
};
function $aef92eb44b339a57$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $cozmU.useMemo)(()=>$aef92eb44b339a57$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $cozmU.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    (0, $cozmU.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}


function $b16dcb6878bf018c$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $cozmU.useCallback)(callback, deps);
    const [value, setValue] = (0, $cozmU.useState)(initialValue);
    (0, $aef92eb44b339a57$export$daf4e774a28efe06)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}
module.exports["useStateFromPromise"] = $b16dcb6878bf018c$export$4960a9d54b2095bb;

});

parcelRegister("dGnqc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $6OREF = parcelRequire("6OREF");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $ieeJu = parcelRequire("ieeJu");

var $24df8e09ab5ab032$export$29dff82773c5f10f = /*#__PURE__*/ function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
    return FindReplaceActionTypes;
}({});



var $cI8RZ = parcelRequire("cI8RZ");

var $gLqwM = parcelRequire("gLqwM");

















const $84528c133539f16c$export$e7697da71e34f0a6 = new (0, $kCECX.PluginKey)('findReplace');


const $1165d80eb39a2324$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $8nvEM.DecorationSet).empty,
    shouldMatchCase: false
};
const $1165d80eb39a2324$export$ae829ec7b2625219 = (dispatch, getIntl, api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $84528c133539f16c$export$e7697da71e34f0a6),
        state: (0, $4981acfba9bf358a$export$656c7661095efe2e)(dispatch, ()=>({
                ...$1165d80eb39a2324$export$d4c72bab9d6cc13a,
                getIntl: getIntl,
                api: api
            })),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });
};







const $a28db421455a435a$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE:
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE:
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).CANCEL:
                const { getIntl: getIntl, api: api } = state;
                return (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? {
                    ...getInitialState(),
                    getIntl: getIntl,
                    api: api
                } : getInitialState();
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $24df8e09ab5ab032$export$29dff82773c5f10f).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $a28db421455a435a$export$2e2bcd8739ae039 = $a28db421455a435a$var$reducer;



var $5X6fy = parcelRequire("5X6fy");


var $efgwK = parcelRequire("efgwK");








var $bijHC = parcelRequire("bijHC");


var $caelp = parcelRequire("caelp");








var $gqUuL = parcelRequire("gqUuL");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $517b5dd498d7c267$export$cec6db4af40340f0 = 'search-match';
const $517b5dd498d7c267$export$a19ecadc9ecc39b1 = 'search-match-text';
const $517b5dd498d7c267$export$bf208a338b2a2f1f = 'selected-search-match';
const $517b5dd498d7c267$export$bb09fa712812841f = 'search-match-block';
const $517b5dd498d7c267$export$99146b4c1ad5837a = 'search-match-block-selected';
const $517b5dd498d7c267$export$6cc90c491f952538 = 'search-match-dark';
const $517b5dd498d7c267$export$2414358ab66f419a = 'search-match-expand-title';


function $445be20723a3c870$export$4391514644a718d(nodes) {
    let result = '';
    for (const node of nodes){
        if ((node.type === 'expand' || node.type === 'nestedExpand') && node.attrs?.title) result += node.attrs.title;
        if (node.text != null) // Inline text node — concatenate directly (text already carries its own whitespace)
        result += node.text;
        else if (node.content) {
            // Block-level node — add a space separator to prevent false matches across block boundaries
            if (result.length > 0) result += ' ';
            result += $445be20723a3c870$export$4391514644a718d(node.content);
        }
    }
    return result;
}
function $445be20723a3c870$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $445be20723a3c870$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end, canReplace: canReplace, nodeType: nodeType }, i)=>$445be20723a3c870$export$83df86cadabd260({
            start: start,
            end: end,
            canReplace: canReplace,
            nodeType: nodeType
        }, i === selectedIndex));
const $445be20723a3c870$var$isElement = (nodeType)=>[
        'blockCard',
        'embedCard',
        'inlineCard',
        'status',
        'mention',
        'date'
    ].includes(nodeType || '') || nodeType === 'syncBlock' && (0, $fqVYq.editorExperiment)('platform_synced_block', true);
const $445be20723a3c870$var$isExpandTitle = (match)=>[
        'expand',
        'nestedExpand'
    ].includes(match.nodeType || '') && !match.canReplace;
const $445be20723a3c870$export$83df86cadabd260 = (match, isSelected)=>{
    const { start: start, end: end, nodeType: nodeType } = match;
    if ((0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
        const { colorMode: colorMode } = (0, $gqUuL.default)();
        if ($445be20723a3c870$var$isElement(nodeType)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$bb09fa712812841f), {
                [(0, $517b5dd498d7c267$export$99146b4c1ad5837a)]: isSelected,
                [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $8nvEM.Decoration).node(start, end, {
                class: className
            });
        } else if ($445be20723a3c870$var$isExpandTitle(match)) {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$2414358ab66f419a), {
                [(0, $517b5dd498d7c267$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $8nvEM.Decoration).node(start, end, {
                class: className
            });
        } else {
            const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $517b5dd498d7c267$export$a19ecadc9ecc39b1), {
                [(0, $517b5dd498d7c267$export$bf208a338b2a2f1f)]: isSelected,
                [(0, $517b5dd498d7c267$export$6cc90c491f952538)]: colorMode === 'dark'
            });
            return (0, $8nvEM.Decoration).inline(start, end, {
                class: className
            });
        }
    } else {
        let className = (0, $517b5dd498d7c267$export$cec6db4af40340f0);
        if (isSelected) className += ` ${0, $517b5dd498d7c267$export$bf208a338b2a2f1f}`;
        return (0, $8nvEM.Decoration).inline(start, end, {
            class: className
        });
    }
};
function $445be20723a3c870$export$f4585c00f32d9257({ content: content, searchText: searchText, shouldMatchCase: shouldMatchCase, contentIndex: contentIndex = 0, getIntl: getIntl, api: api }) {
    const matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectTextMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text } = textGrouping;
        const { pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end,
                canReplace: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? true : undefined,
                nodeType: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 'text' : undefined
            });
            index = text.indexOf(searchText, end);
        }
    };
    const collectNodeMatch = (textGrouping, node)=>{
        if (!textGrouping) return;
        const { pos: pos } = textGrouping;
        let { text: text } = textGrouping;
        if (node.type.name === 'status' && shouldMatchCase) text = text.toUpperCase();
        else if (!shouldMatchCase) {
            text = text.toLowerCase();
            searchText = searchText.toLowerCase();
        }
        const index = text.indexOf(searchText);
        if (index !== -1) matches.push({
            start: pos,
            end: pos + node.nodeSize,
            canReplace: false,
            nodeType: node.type.name
        });
    };
    const collectCardTitleMatch = (node, pos)=>{
        const cards = api?.card?.sharedState.currentState()?.cards;
        if (cards) {
            const relevantCard = cards.find((card)=>card.url === node.attrs.url);
            const title = relevantCard?.title;
            if (relevantCard) {
                if (title) collectNodeMatch({
                    text: title,
                    pos: pos
                }, node);
                else // when there is no title, e.g. in an error case like unauthorized
                // the link card just shows the entire url as the title in inline card
                if (node.type.name === 'inlineCard') collectNodeMatch({
                    text: node.attrs.url,
                    pos: pos
                }, node);
            }
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text = textGrouping.text + node.text;
            } else {
                collectTextMatch(textGrouping);
                textGrouping = null;
                if ((0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) switch(node.type.name){
                    case 'status':
                        collectNodeMatch({
                            text: node.attrs.text,
                            pos: pos
                        }, node);
                        break;
                    case 'date':
                        collectNodeMatch({
                            text: (0, $efgwK.timestampToString)(node.attrs.timestamp, getIntl ? getIntl() : null),
                            pos: pos
                        }, node);
                        break;
                    case 'expand':
                    case 'nestedExpand':
                        collectNodeMatch({
                            text: node.attrs.title,
                            pos: pos
                        }, node);
                        break;
                    case 'mention':
                        let text;
                        if (node.attrs.text) text = node.attrs.text;
                        else {
                            // the text may be sanitised from the node for privacy reasons
                            // so we need to use the mentionProvider to resolve it
                            const mentionProvider = api?.mention?.sharedState.currentState()?.mentionProvider;
                            if ((0, $bijHC.isResolvingMentionProvider)(mentionProvider)) {
                                const nameDetail = mentionProvider.resolveMentionName(node.attrs.id);
                                if ((0, $caelp.isPromise)(nameDetail)) text = '@...';
                                else if (nameDetail.status === (0, $caelp.MentionNameStatus).OK) text = `@${nameDetail.name || ''}`;
                                else text = '@_|unknown|_';
                            }
                        }
                        if (text) collectNodeMatch({
                            text: text,
                            pos: pos
                        }, node);
                        break;
                    case 'inlineCard':
                    case 'blockCard':
                    case 'embedCard':
                        collectCardTitleMatch(node, pos);
                        break;
                    case 'syncBlock':
                        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
                            const syncBlockStore = api?.syncedBlock?.sharedState.currentState()?.syncBlockStore;
                            const instance = syncBlockStore?.referenceManager.getFromCache(node.attrs.resourceId);
                            const adfContent = instance?.data?.content;
                            if (adfContent && adfContent.length > 0) {
                                const text = $445be20723a3c870$export$4391514644a718d(adfContent);
                                if (text) collectNodeMatch({
                                    text: text,
                                    pos: pos
                                }, node);
                            }
                        }
                        break;
                    default:
                        break;
                }
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectTextMatch, manually collectTextMatch
        if (textGrouping) collectTextMatch(textGrouping);
    }
    return matches;
}
function $445be20723a3c870$export$6df7393992287695(selectionPos, matches) {
    const forwardMatchIndex = matches.findIndex((match)=>match.start >= selectionPos);
    if (forwardMatchIndex === -1) // if there are no forward matches, it must be the last match
    return matches.length > 0 ? matches.length - 1 : 0;
    else if (forwardMatchIndex === 0) return forwardMatchIndex;
    const backwardMatchIndex = forwardMatchIndex - 1;
    const forwardMatchPos = matches[forwardMatchIndex].start;
    const backwardMatchPos = matches[backwardMatchIndex].start;
    if (forwardMatchPos - selectionPos < selectionPos - backwardMatchPos) return forwardMatchIndex;
    else return backwardMatchIndex;
}
function $445be20723a3c870$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $445be20723a3c870$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $445be20723a3c870$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $445be20723a3c870$var$isSyncBlock = (match)=>match.nodeType === 'syncBlock';
const $445be20723a3c870$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) {
        if ($445be20723a3c870$var$isExpandTitle(matches[index]) || $445be20723a3c870$var$isSyncBlock(matches[index])) return (0, $kCECX.NodeSelection).create(doc, matches[index].start);
        return (0, $kCECX.TextSelection).create(doc, matches[index].start + offset);
    }
    return selection;
};
const $445be20723a3c870$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $445be20723a3c870$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    const lostDecorations = $445be20723a3c870$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $445be20723a3c870$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$445be20723a3c870$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $445be20723a3c870$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $445be20723a3c870$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $445be20723a3c870$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $445be20723a3c870$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $445be20723a3c870$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $445be20723a3c870$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};
function $445be20723a3c870$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}


const $4981acfba9bf358a$var$handleDocChanged = (tr, pluginState)=>{
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $gLqwM.stepHasSlice))) return pluginState;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, decorationSet: decorationSet, matches: matches, shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = pluginState;
    const newMatches = (0, $445be20723a3c870$export$f4585c00f32d9257)({
        content: tr.doc,
        searchText: findText,
        shouldMatchCase: shouldMatchCase,
        getIntl: getIntl,
        api: api
    });
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end),
            canReplace: match.canReplace,
            nodeType: match.nodeType
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $8nvEM.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $gLqwM.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $445be20723a3c870$export$7d11bfeb87290a13)(match, step, tr) && !(0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $445be20723a3c870$export$bb98a54aeaa7e0c0)(mappedMatches.filter((match)=>(0, $445be20723a3c870$export$7d11bfeb87290a13)(match, step, tr) && !!(0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $445be20723a3c870$export$2393fad6cd7faeee)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $445be20723a3c870$export$6df7393992287695)(tr.selection.from, newMatches) : (0, $445be20723a3c870$export$1b7f6169b65103e3)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $445be20723a3c870$export$b5b5304233807f24)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $445be20723a3c870$export$2393fad6cd7faeee)(0, [
        newSelectedMatch
    ]));
    const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, newMatches);
    api?.expand?.commands.toggleExpandWithMatch(newSelection)({
        tr: tr
    });
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const $4981acfba9bf358a$var$dest = (0, $cI8RZ.pluginFactory)((0, $84528c133539f16c$export$e7697da71e34f0a6), (0, $a28db421455a435a$export$2e2bcd8739ae039)(()=>(0, $1165d80eb39a2324$export$d4c72bab9d6cc13a)), {
    onDocChanged: $4981acfba9bf358a$var$handleDocChanged
});
const $4981acfba9bf358a$export$8d4021544bdece00 = $4981acfba9bf358a$var$dest.createCommand;
const $4981acfba9bf358a$export$f05434c51e3762e = $4981acfba9bf358a$var$dest.getPluginState;
const $4981acfba9bf358a$export$656c7661095efe2e = $4981acfba9bf358a$var$dest.createPluginState;








// max number of decorations to apply at once
const $741d4c9951586a77$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $741d4c9951586a77$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $741d4c9951586a77$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
   * Applies the decorations needed for the current search results
   * It does so async, splitting them up into batches to help with performance
   */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $741d4c9951586a77$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $741d4c9951586a77$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $741d4c9951586a77$var$posIncrement));
        } else {
            after = Math.min(after + $741d4c9951586a77$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $741d4c9951586a77$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            const matchesToDecorate = matchesBetween.slice(counter, counter + $741d4c9951586a77$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $741d4c9951586a77$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $741d4c9951586a77$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $445be20723a3c870$export$2393fad6cd7faeee)(useSelectionIndex ? selectionIndex % $741d4c9951586a77$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $741d4c9951586a77$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $741d4c9951586a77$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $741d4c9951586a77$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
   * Calculates Prosemirror start and end positions we want to apply the decorations
   * between
   * Also calculates the positions the are the start and end of the user's viewport
   * so we can apply decorations there first and work outwards
   */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? 0 : 1,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        if ((0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return startPos ? startPos.pos : 0;
        else return startPos ? startPos.pos : 1;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
   * Util to batch function calls by animation frames
   * A counter will start at 0 and increment by provided value until reaches limit
   * Passed in fn receives the counter as a param, return false to skip waiting
   * for the animation frame for the next call
   */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
    constructor(){
        this.rafId = void 0;
        this.addDecorations = void 0;
        this.removeDecorations = void 0;
    }
}
const $741d4c9951586a77$var$batchDecorations = new $741d4c9951586a77$var$BatchDecorations();
var $741d4c9951586a77$export$2e2bcd8739ae039 = $741d4c9951586a77$var$batchDecorations;





const $4a0f603b6c72d7f3$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_editor_centre_content_on_find', 'isEnabled', true) && view) {
                let targetPos = tr.selection.anchor;
                let coords = view.coordsAtPos(targetPos);
                // If element is not visible (coords are invalid), try parent nodes
                if (coords.top === coords.bottom || coords.top === 0) {
                    const $pos = tr.selection.$anchor;
                    let depth = $pos.depth;
                    while(depth > 0 && (coords.top === coords.bottom || coords.top === 0)){
                        targetPos = $pos.before(depth);
                        coords = view.coordsAtPos(targetPos);
                        depth--;
                    }
                }
                // Find the closest scrollable parent element
                let scrollParent = view.dom;
                while(scrollParent && scrollParent !== document.documentElement){
                    const style = window.getComputedStyle(scrollParent);
                    const overflowY = style.overflowY;
                    const overflowX = style.overflowX;
                    const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowX === 'auto' || overflowX === 'scroll') && (scrollParent.scrollHeight > scrollParent.clientHeight || scrollParent.scrollWidth > scrollParent.clientWidth);
                    if (isScrollable) break;
                    scrollParent = scrollParent.parentElement;
                }
                // Scroll to center the content
                if (scrollParent && scrollParent !== document.documentElement) {
                    const parentRect = scrollParent.getBoundingClientRect();
                    const scrollTop = scrollParent.scrollTop + coords.top - parentRect.top - parentRect.height / 2 + (coords.bottom - coords.top) / 2;
                    scrollParent.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth'
                    });
                }
            } else tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);


const $598aa076e480bbc7$export$234c45b355edd85b = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $kCECX.TextSelection) && !selection.empty) {
            findText = (0, $445be20723a3c870$export$93850515e4be65a3)(selection);
            const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
            matches = (0, $445be20723a3c870$export$f4585c00f32d9257)({
                content: state.doc,
                searchText: findText,
                shouldMatchCase: shouldMatchCase,
                getIntl: getIntl,
                api: api
            });
            index = (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches) : (0, $445be20723a3c870$export$1b7f6169b65103e3)(selection.from, matches);
        }
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $598aa076e480bbc7$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $445be20723a3c870$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        const index = (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches) : (0, $445be20723a3c870$export$1b7f6169b65103e3)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $741d4c9951586a77$export$2e2bcd8739ae039).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$598aa076e480bbc7$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$598aa076e480bbc7$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const matches = keyword !== undefined ? (0, $445be20723a3c870$export$f4585c00f32d9257)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        if (matches.length > 0) {
            const index = (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $445be20723a3c870$export$6df7393992287695)(selection.from, matches) : (0, $445be20723a3c870$export$1b7f6169b65103e3)(selection.from, matches);
            const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, index, matches);
            api?.expand?.commands.toggleExpandWithMatch(newSelection)({
                tr: tr
            });
            return tr.setSelection(newSelection);
        }
        return tr;
    }));
const $598aa076e480bbc7$export$ebdf538520f8717 = (editorView)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>$598aa076e480bbc7$var$findInDirection(state, 'next'), (tr, state)=>{
        const { matches: matches, index: index, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $445be20723a3c870$export$7db462fe6be63e0)(searchIndex, matches.length);
        const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $598aa076e480bbc7$export$eef4841c27f82c55 = (editorView)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>$598aa076e480bbc7$var$findInDirection(state, 'previous'), (tr, state)=>{
        const { matches: matches, api: api } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches, true);
        const newSelection = (0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, searchIndex, matches);
        api?.expand?.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        return tr.setSelection(newSelection);
    }));
const $598aa076e480bbc7$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $445be20723a3c870$export$1b7f6169b65103e3)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length) : (0, $445be20723a3c870$export$9041fedbf960fcef)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $598aa076e480bbc7$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_NEXT : (0, $24df8e09ab5ab032$export$29dff82773c5f10f).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $598aa076e480bbc7$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $4a0f603b6c72d7f3$export$b252ecff1878cab7)((0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        const { findText: findText, matches: matches } = pluginState;
        let { decorationSet: decorationSet, index: index } = pluginState;
        decorationSet = $598aa076e480bbc7$var$updateSelectedHighlight(state, (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $445be20723a3c870$export$b5b5304233807f24)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        if (matches[index]) {
            if (!matches[index].canReplace && (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $445be20723a3c870$export$7db462fe6be63e0)(index, matches.length);
            tr.insertText(replaceText, start, end).setSelection((0, $445be20723a3c870$export$91f639c3a212feb2)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length));
        }
        return tr;
    }));
const $598aa076e480bbc7$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        pluginState.matches.forEach((match)=>{
            if (!match.canReplace && (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) return tr;
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $598aa076e480bbc7$export$e17d1d1acde229e1 = (decorations)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $598aa076e480bbc7$export$f9e1c8eeab9872dc = (decorations)=>(0, $4981acfba9bf358a$export$8d4021544bdece00)((state)=>{
        const { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).UPDATE_DECORATIONS,
            decorationSet: (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorations, state.doc)
        };
    });
const $598aa076e480bbc7$export$58f3f9b95b84be3c = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)(()=>{
        (0, $741d4c9951586a77$export$2e2bcd8739ae039).stop();
        return {
            type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).CANCEL
        };
    });
const $598aa076e480bbc7$export$2cc7ff91bcacba5e = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).BLUR
    });
const $598aa076e480bbc7$export$4e987d48fa8a04d7 = ()=>(0, $4981acfba9bf358a$export$8d4021544bdece00)({
        type: (0, $24df8e09ab5ab032$export$29dff82773c5f10f).TOGGLE_MATCH_CASE
    });
const $598aa076e480bbc7$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    const { index: index, matches: matches } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    let { decorationSet: decorationSet } = (0, $4981acfba9bf358a$export$f05434c51e3762e)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $445be20723a3c870$export$e2521c2c8f72064b)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $445be20723a3c870$export$ede9cf72df9a3d38)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $445be20723a3c870$export$83df86cadabd260)(currentSelectedMatch)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $445be20723a3c870$export$83df86cadabd260)(nextSelectedMatch, true)
    ]);
    return decorationSet;
};






var $eEdSM = parcelRequire("eEdSM");





const $af555752df8e1a48$export$f4a2dfcbc300db1a = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, (state)=>({
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                action: (0, $krYZG.ACTION).ACTIVATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $kCECX.TextSelection) && !state.selection.empty ? (0, $krYZG.INPUT_METHOD).PREFILL : (0, $krYZG.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod
                }
            }))((0, $598aa076e480bbc7$export$234c45b355edd85b)());
const $af555752df8e1a48$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT
        })((0, $598aa076e480bbc7$export$71aa6c912b956294)(editorView, containerElement, keyword));
const $af555752df8e1a48$export$da0da8f66917d4cd = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$ebdf538520f8717)(editorView));
    };
const $af555752df8e1a48$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$eef4841c27f82c55)(editorView));
const $af555752df8e1a48$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).REPLACED_ONE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$77ad94ebf1c2b9ed)(replaceText));
const $af555752df8e1a48$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).REPLACED_ALL,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT
        })((0, $598aa076e480bbc7$export$b8b3234b4edfc4c2)(replaceText));
const $af555752df8e1a48$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            action: (0, $krYZG.ACTION).DEACTIVATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $598aa076e480bbc7$export$58f3f9b95b84be3c)());






var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


const $37f4965a84915678$var$activateFindReplace = (editorAnalyticsAPI)=>(state, dispatch)=>{
        (0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $37f4965a84915678$var$keymapPlugin = (editorAnalyticsAPI)=>{
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.find).common, $37f4965a84915678$var$activateFindReplace(editorAnalyticsAPI), list);
    return (0, $44cyU.keymap)(list);
};
var $37f4965a84915678$export$2e2bcd8739ae039 = $37f4965a84915678$var$keymapPlugin;



















var $kSwu1 = parcelRequire("kSwu1");





var $9RT19 = parcelRequire("9RT19");

var $fPv5h = parcelRequire("fPv5h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $dN8GG = parcelRequire("dN8GG");




/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $55fM8 = parcelRequire("55fM8");


var $LQnOI = parcelRequire("LQnOI");











var $kB5K2 = parcelRequire("kB5K2");


var $bRHnZ = parcelRequire("bRHnZ");


var $9FyRG = parcelRequire("9FyRG");


var $4yg9g = parcelRequire("4yg9g");








var $1sCHt = parcelRequire("1sCHt");





var $lpNn5 = parcelRequire("lpNn5");

class $b1d94a1a5a6440d3$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                description: title,
                keymap: (0, $ldqjS.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            id: "afterInputSection",
            label: title,
            appearance: appearance,
            testId: title,
            ref: this.buttonRef,
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    size: iconSize
                }),
            isDisabled: disabled,
            onClick: this.handleClick,
            isSelected: isPressed,
            ...pressedProps
        }));
    }
    constructor(...args){
        super(...args);
        this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}
$b1d94a1a5a6440d3$export$d7a26608845e3a06.defaultProps = {
    keymapDescription: 'no-keymap',
    appearance: 'subtle'
};


/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






function $232a1fdaa735ceb2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $232a1fdaa735ceb2$var$fontSize = 14;
const $232a1fdaa735ceb2$export$2413e968422424ec = /*#__PURE__*/ (0, $lOiVq.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${"var(--ds-border, #0B120E24)"}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: "var(--ds-border-width, 1px)"
});
const $232a1fdaa735ceb2$export$491e6397d7c1480b = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $232a1fdaa735ceb2$export$263284dac1af2f8a = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $232a1fdaa735ceb2$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $232a1fdaa735ceb2$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $232a1fdaa735ceb2$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $lOiVq.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14)
});
const $232a1fdaa735ceb2$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $lOiVq.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${36 / $232a1fdaa735ceb2$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px'
    }
});
const $232a1fdaa735ceb2$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $232a1fdaa735ceb2$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $232a1fdaa735ceb2$export$df58af0590d04217 = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $232a1fdaa735ceb2$export$1e2581329286cf31 = /*#__PURE__*/ (0, $lOiVq.css)({
    color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    fontSize: `${(0, $7Y8M5.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $232a1fdaa735ceb2$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $232a1fdaa735ceb2$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $232a1fdaa735ceb2$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $lOiVq.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $232a1fdaa735ceb2$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};


const $124ea01dd37cfcb5$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $124ea01dd37cfcb5$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) // Wait for findTextfieldRef to become available then focus
        setTimeout(()=>{
            this.focusFindTextfield();
        }, 100);
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        // focus on update if find text did not change
        if (this.props.findText === this.state?.localFindText) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $dN8GG.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$d449744ea6979b42)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $232a1fdaa735ceb2$export$1e2581329286cf31),
                (0, $232a1fdaa735ceb2$export$3fc34436808d2893)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$24f07703e9463557)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
            title: this.matchCase,
            appearance: "default",
            icon: this.matchCaseIconEle,
            iconLabel: this.matchCase,
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                (0, $232a1fdaa735ceb2$export$4fcc6c669daa3229),
                (0, $232a1fdaa735ceb2$export$1c21208bb1fdf473)
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $232a1fdaa735ceb2$export$7910eaff0a3df2fc)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kB5K2.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
    constructor(props){
        super(props);
        this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.isComposing = false;
        this.find = void 0;
        this.noResultsFound = void 0;
        this.matchCase = void 0;
        this.syncFindText = (onSynced)=>{
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== this.state?.localFindText) this.updateFindValue(this.props.findText || '', onSynced);
        };
        this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        };
        this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        };
        // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((value)=>{
            this.props.onFind(value);
        }, $124ea01dd37cfcb5$export$c7a15a679416091a);
        this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        };
        // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $LQnOI.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        });
        this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        };
        this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        };
        this.handleFindNextClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleFindPrevClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleCompositionStart = ()=>{
            this.isComposing = true;
            if ((0, $ieeJu.expValEquals)('platform_editor_korean_characters_split', 'isEnabled', true)) this.debouncedFind.cancel();
        };
        this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        };
        this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
            });
        };
        this.handleMatchCaseClick = ()=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        };
        this.matchCaseIconEle = (iconProps)=>{
            return (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bRHnZ))), {
                label: iconProps.label,
                size: "small"
            }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
                label: this.matchCase
            });
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $dN8GG.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $dN8GG.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $dN8GG.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $124ea01dd37cfcb5$var$_default_1 = (0, $kSwu1.injectIntl)($124ea01dd37cfcb5$var$Find);
var $124ea01dd37cfcb5$export$2e2bcd8739ae039 = $124ea01dd37cfcb5$var$_default_1;









var $ad7Ou = parcelRequire("ad7Ou");








var $5ZC7N = parcelRequire("5ZC7N");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");




var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");










// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $fe33dd93a90a0b71$var$SPACE_REGEX = / /u;
const $fe33dd93a90a0b71$var$replaceContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100'
});
const $fe33dd93a90a0b71$var$replaceWithLabelStyle = (0, $buxP3.xcss)({
    paddingBottom: 'space.050'
});
const $fe33dd93a90a0b71$var$actionButtonContainerStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.200'
});
const $fe33dd93a90a0b71$var$actionButtonParentInlineStyles = (0, $buxP3.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $fe33dd93a90a0b71$var$actionButtonParentInlineStylesNew = (0, $buxP3.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap'
});
const $fe33dd93a90a0b71$var$actionButtonInlineStyles = (0, $buxP3.xcss)({
    gap: 'space.075'
});
const $fe33dd93a90a0b71$var$closeButtonInlineStyles = (0, $buxP3.xcss)({
    marginRight: 'auto'
});
const $fe33dd93a90a0b71$var$Replace = ({ canReplace: canReplace, replaceText: initialReplaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, onReplaceTextfieldRefSet: onReplaceTextfieldRefSet, onArrowUp: onArrowUp, onCancel: onCancel, count: count, onFindNext: onFindNext, onFindPrev: onFindPrev, dispatchAnalyticsEvent: dispatchAnalyticsEvent, setFindTyped: setFindTyped, findTyped: findTyped, focusToolbarButton: focusToolbarButton, intl: { formatMessage: formatMessage } })=>{
    const [replaceText, setReplaceText] = (0, $cozmU.useState)(initialReplaceText || '');
    const [isComposing, setIsComposing] = (0, $cozmU.useState)(false);
    const [isHelperMessageVisible, setIsHelperMessageVisible] = (0, $cozmU.useState)(false);
    const [fakeSuccessReplacementMessageUpdate, setFakeSuccessReplacementMessageUpdate] = (0, $cozmU.useState)(false);
    const [replaceCount, setReplaceCount] = (0, $cozmU.useState)(0);
    const replaceTextfieldRef = (0, $cozmU.useRef)(null);
    const successReplacementMessageRef = (0, $cozmU.useRef)(null);
    const replaceWith = formatMessage((0, $dN8GG.findReplaceMessages).replaceWith);
    const replaceAll = formatMessage((0, $dN8GG.findReplaceMessages).replaceAll);
    const findPrevious = formatMessage((0, $dN8GG.findReplaceMessages).findPrevious);
    const closeFindReplaceDialog = formatMessage((0, $dN8GG.findReplaceMessages).closeFindReplaceDialog);
    (0, $cozmU.useEffect)(()=>{
        onReplaceTextfieldRefSet(replaceTextfieldRef);
    }, [
        onReplaceTextfieldRefSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        setReplaceText(initialReplaceText || '');
    }, [
        initialReplaceText
    ]);
    const skipWhileComposing = (fn)=>{
        if (!isComposing) fn();
    };
    const triggerSuccessReplacementMessageUpdate = (currentReplaceCount)=>{
        if (replaceCount === currentReplaceCount) setFakeSuccessReplacementMessageUpdate(!fakeSuccessReplacementMessageUpdate);
        if (successReplacementMessageRef.current) {
            const ariaLiveRegion = successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion?.removeAttribute('aria-live');
            ariaLiveRegion?.setAttribute('aria-live', 'polite');
        }
    };
    const handleReplaceClick = ()=>skipWhileComposing(()=>{
            onReplace({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON,
                replaceText: replaceText
            });
            triggerSuccessReplacementMessageUpdate(1);
            setIsHelperMessageVisible(true);
            setReplaceCount(1);
            setFindTyped(false);
        });
    const handleReplaceChange = (event)=>skipWhileComposing(()=>{
            updateReplaceValue(event.target.value);
        });
    const updateReplaceValue = (text)=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).CHANGED_REPLACEMENT_TEXT,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).FIND_REPLACE_DIALOG
        });
        setReplaceText(text);
    };
    const handleReplaceKeyDown = (event)=>skipWhileComposing(()=>{
            if (event.key === 'Enter') onReplace({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD,
                replaceText: replaceText
            });
            else if (event.key === 'ArrowUp') onArrowUp();
        });
    const handleReplaceAllClick = ()=>skipWhileComposing(()=>{
            onReplaceAll({
                replaceText: replaceText
            });
            setIsHelperMessageVisible(true);
            if (count.totalReplaceable && (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true)) {
                triggerSuccessReplacementMessageUpdate(count.totalReplaceable);
                setReplaceCount(count.totalReplaceable);
            } else {
                triggerSuccessReplacementMessageUpdate(count.total);
                setReplaceCount(count.total);
            }
            setFindTyped(false);
        });
    const handleCompositionStart = ()=>{
        setIsComposing(true);
    };
    const handleCompositionEnd = (event)=>{
        setIsComposing(false);
        // type for React.CompositionEvent doesn't set type for target correctly
        updateReplaceValue(event.target.value);
    };
    const clearSearch = ()=>{
        onCancel({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
        focusToolbarButton();
    };
    const handleFindNextClick = ()=>{
        if (!isComposing) onFindNext({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
    };
    const handleFindPrevClick = ()=>{
        if (!isComposing) onFindPrev({
            triggerMethod: (0, $krYZG.TRIGGER_METHOD).BUTTON
        });
    };
    const resultsReplace = formatMessage((0, $dN8GG.findReplaceMessages).replaceSuccess, {
        numberOfMatches: replaceCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $fe33dd93a90a0b71$var$replaceContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $fe33dd93a90a0b71$var$replaceWithLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        id: "replace-text-field-label",
        size: "medium",
        weight: "bold",
        color: "color.text.subtle"
    }, replaceWith)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        name: "replace",
        "aria-labelledby": "replace-text-field-label",
        testId: "replace-field",
        appearance: "standard",
        defaultValue: replaceText,
        ref: replaceTextfieldRef,
        autoComplete: "off",
        onChange: handleReplaceChange,
        onKeyDown: handleReplaceKeyDown,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd
    }), isHelperMessageVisible && !findTyped && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: successReplacementMessageRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZC7N.ValidMessage), {
        testId: "message-success-replacement"
    }, fakeSuccessReplacementMessageUpdate ? // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    resultsReplace.replace($fe33dd93a90a0b71$var$SPACE_REGEX, '\u00a0') : resultsReplace)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $fe33dd93a90a0b71$var$actionButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? [
            $fe33dd93a90a0b71$var$actionButtonInlineStyles,
            $fe33dd93a90a0b71$var$actionButtonParentInlineStylesNew
        ] : [
            $fe33dd93a90a0b71$var$actionButtonInlineStyles,
            $fe33dd93a90a0b71$var$actionButtonParentInlineStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $fe33dd93a90a0b71$var$actionButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
        title: formatMessage((0, $dN8GG.findReplaceMessages).findNext),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: iconProps.label,
                size: "small"
            }),
        iconLabel: formatMessage((0, $dN8GG.findReplaceMessages).findNext),
        keymapDescription: 'Enter',
        onClick: handleFindNextClick,
        disabled: count.total <= 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1d94a1a5a6440d3$export$d7a26608845e3a06), {
        title: findPrevious,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: iconProps.label,
                size: "small"
            }),
        iconLabel: findPrevious,
        keymapDescription: 'Shift Enter',
        onClick: handleFindPrevClick,
        disabled: count.total <= 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: 'Replace',
        id: "replace-button",
        onClick: handleReplaceClick,
        isDisabled: !canReplace
    }, formatMessage((0, $dN8GG.findReplaceMessages).replace)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        testId: replaceAll,
        id: "replaceAll-button",
        onClick: handleReplaceAllClick,
        isDisabled: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? count.totalReplaceable === 0 : !canReplace
    }, replaceAll)), (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $fe33dd93a90a0b71$var$closeButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        testId: closeFindReplaceDialog,
        onClick: clearSearch
    }, closeFindReplaceDialog)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        testId: closeFindReplaceDialog,
        onClick: clearSearch
    }, closeFindReplaceDialog))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $fe33dd93a90a0b71$var$_default_1 = (0, $kSwu1.injectIntl)($fe33dd93a90a0b71$var$Replace);
var $fe33dd93a90a0b71$export$2e2bcd8739ae039 = $fe33dd93a90a0b71$var$_default_1;



// eslint-disable-next-line @repo/internal/react/no-class-components
class $b4ec49486aa4f539$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { findText: findText, count: count, isReplaceable: isReplaceable, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase, intl: intl } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            role: 'dialog',
            "aria-label": intl?.formatMessage((0, $dN8GG.findReplaceMessages).findReplaceDialogAriaLabel),
            "aria-modal": false,
            ref: this.modalRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $232a1fdaa735ceb2$export$491e6397d7c1480b),
                (0, $232a1fdaa735ceb2$export$263284dac1af2f8a)
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $124ea01dd37cfcb5$export$2e2bcd8739ae039), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), /*#__PURE__*/ (0, $lOiVq.jsx)("hr", {
            role: "presentation",
            css: (0, $232a1fdaa735ceb2$export$2413e968422424ec),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fe33dd93a90a0b71$export$2e2bcd8739ae039), {
            canReplace: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? !!isReplaceable : count.total > 0,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        }));
    }
    constructor(props){
        super(props);
        this.findTextfield = null;
        this.replaceTextfield = null;
        this.modalRef = void 0;
        this.state = {
            findTyped: false
        };
        this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        };
        this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        };
        this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        };
        this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        };
        this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
var $b4ec49486aa4f539$export$2e2bcd8739ae039 = $b4ec49486aa4f539$var$FindReplace;


const $42f82f57d853bd28$var$findReplaceWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
// Magic number taken from ../FindReplaceToolbarButton.tsx
const $42f82f57d853bd28$var$dropdownWidthNewDesign = 382;
const $42f82f57d853bd28$var$FindReplaceDropdown = (props)=>{
    const { findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, popupsMountPoint: popupsMountPoint, numReplaceable: numReplaceable, onCancel: onCancel } = props;
    if (!popupsMountPoint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fPv5h.default), {
        target: popupsMountPoint,
        mountTo: popupsMountPoint,
        forcePlacement: true,
        alignX: 'right',
        alignY: 'start',
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            4,
            0
        ],
        isOpen: isActive,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        handleEscapeKeydown: ()=>{
            if (isActive) onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
            });
        },
        fitWidth: $42f82f57d853bd28$var$dropdownWidthNewDesign,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $42f82f57d853bd28$var$findReplaceWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4ec49486aa4f539$export$2e2bcd8739ae039), {
        findText: findText,
        replaceText: replaceText,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        count: {
            index: index,
            total: numMatches,
            totalReplaceable: numReplaceable
        },
        ...props
    })));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $42f82f57d853bd28$var$_default_1 = (0, $kSwu1.injectIntl)($42f82f57d853bd28$var$FindReplaceDropdown);
var $42f82f57d853bd28$export$2e2bcd8739ae039 = $42f82f57d853bd28$var$_default_1;


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






















var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");





var $hAgam = parcelRequire("hAgam");





function $a7db1f69e2740b4a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $a7db1f69e2740b4a$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $lOiVq.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $7Y8M5.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $a7db1f69e2740b4a$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $lOiVq.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $a7db1f69e2740b4a$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $a7db1f69e2740b4a$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $a7db1f69e2740b4a$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $a7db1f69e2740b4a$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a7db1f69e2740b4a$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, numReplaceable: numReplaceable, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $dN8GG.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $7Y8M5.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $ldqjS.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $a7db1f69e2740b4a$var$toolbarButtonWrapper,
                takeFullWidth && $a7db1f69e2740b4a$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && (0, $ixfCV.fg)('platform_editor_toolbar_responsive_fixes') && $a7db1f69e2740b4a$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fPv5h.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $krYZG.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $a7db1f69e2740b4a$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: (0, $ixfCV.fg)('platform_editor_toolbar_responsive_fixes') ? /*#__PURE__*/ (0, $lOiVq.jsx)($a7db1f69e2740b4a$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $ldqjS.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
                buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $ldqjS.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $a7db1f69e2740b4a$var$wrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b4ec49486aa4f539$export$2e2bcd8739ae039), {
            findText: findText,
            replaceText: replaceText,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            count: {
                index: index,
                total: numMatches,
                totalReplaceable: numReplaceable
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            openedByClick: false
        };
        this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        };
        this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        };
        this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $a7db1f69e2740b4a$var$_default_1 = (0, $kSwu1.injectIntl)($a7db1f69e2740b4a$var$FindReplaceToolbarButton);
var $a7db1f69e2740b4a$export$2e2bcd8739ae039 = $a7db1f69e2740b4a$var$_default_1;


// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $1a2838ce98d682a4$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $cozmU.useState)(api?.findReplace?.sharedState.currentState());
    (0, $cozmU.useLayoutEffect)(()=>{
        const unsub = api?.findReplace?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $1a2838ce98d682a4$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden, doesNotHaveButton: doesNotHaveButton })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { findReplaceState: findReplaceState } = $1a2838ce98d682a4$var$useSharedPluginStateNoDebounce(api);
    const shouldMatchCase = findReplaceState?.shouldMatchCase;
    const isActive = findReplaceState?.isActive;
    const findText = findReplaceState?.findText;
    const replaceText = findReplaceState?.replaceText;
    const index = findReplaceState?.index;
    const matches = findReplaceState?.matches;
    const shouldFocus = findReplaceState?.shouldFocus;
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement?.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch, editorView);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(editorAnalyticsAPI)({
                triggerMethod: (0, $krYZG.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$a1f845c5f9c28dec)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$da0da8f66917d4cd)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$67b10f9d7f5c44e1)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$95c81501036a7f64)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $af555752df8e1a48$export$99b6462294b19fcd)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $598aa076e480bbc7$export$2cc7ff91bcacba5e)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $af555752df8e1a48$export$330be886194dc3c6)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $598aa076e480bbc7$export$4e987d48fa8a04d7)());
    };
    if (shouldMatchCase === undefined || isActive === undefined || findText === undefined || replaceText === undefined || index === undefined || matches === undefined || shouldFocus === undefined) return null;
    const DropDownComponent = doesNotHaveButton ? (0, $42f82f57d853bd28$export$2e2bcd8739ae039) : (0, $a7db1f69e2740b4a$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DropDownComponent, {
        shouldMatchCase: shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: isActive,
        findText: findText,
        index: index,
        numMatches: matches.length,
        isReplaceable: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? matches[index]?.canReplace : undefined,
        numReplaceable: (0, $ieeJu.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        matches.filter((match)=>match.canReplace === true).length : undefined,
        replaceText: replaceText,
        shouldFocus: shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden
    });
};
const $1a2838ce98d682a4$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($1a2838ce98d682a4$var$FindReplaceToolbarButtonWithState);
var $1a2838ce98d682a4$export$2e2bcd8739ae039 = $1a2838ce98d682a4$var$_default_1;


const $9494488bedef6698$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const toolbarButtonRegisteredExternally = {
        current: false
    };
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        const isButtonHidden = (0, $ixfCV.fg)('platform_editor_toolbar_responsive_fixes') ? toolbarSize < (0, $6OREF.ToolbarSize).XL : false;
        if (props?.twoLineEditorToolbar) return null;
        else if (toolbarButtonRegisteredExternally.current && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return null;
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props?.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            const plugins = [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $1165d80eb39a2324$export$ae829ec7b2625219)(dispatch, getIntl, api)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>(0, $37f4965a84915678$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'findReplaceEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $kpCD8.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $84528c133539f16c$export$e7697da71e34f0a6).getState(editorState) || undefined;
        },
        actions: {
            registerToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                toolbarButtonRegisteredExternally.current = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            },
            activateFindReplace: (triggerMethod)=>{
                if (!editorViewRef.current) return false;
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                if (api?.analytics?.actions) (0, $af555752df8e1a48$export$f4a2dfcbc300db1a)(api?.analytics?.actions)({
                    triggerMethod: triggerMethod || (0, $krYZG.TRIGGER_METHOD).EXTERNAL
                })(state, dispatch);
                else (0, $598aa076e480bbc7$export$234c45b355edd85b)()(state, dispatch);
                return true;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        contentComponent: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
            if (toolbarButtonRegisteredExternally.current || !editorView) return null;
            const popupsMountPointEl = popupsMountPoint || // eslint-disable-next-line @atlaskit/editor/no-as-casting
            wrapperElement?.querySelector("[data-editor-container='true']");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a2838ce98d682a4$export$2e2bcd8739ae039), {
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPointEl,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined,
                isToolbarReducedSpacing: false,
                editorView: editorView,
                containerElement: containerElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                takeFullWidth: props?.takeFullWidth,
                api: api,
                doesNotHaveButton: true
            });
        } : undefined
    };
};
module.exports["findReplacePlugin"] = $9494488bedef6698$export$e5ceda4aabe9bb08;

});

parcelRegister("7iL2d", function(module, exports) {

var $hwsSH = parcelRequire("hwsSH");

/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $2nOF5 = parcelRequire("2nOF5");


var $kpCD8 = parcelRequire("kpCD8");


var $6SJ6d = parcelRequire("6SJ6d");


var $kCECX = parcelRequire("kCECX");

const $7520d54e0c00d1c9$var$pluginKey = new (0, $kCECX.PluginKey)('fragmentMarkConsistencyPlugin');
const $7520d54e0c00d1c9$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $7520d54e0c00d1c9$export$ae829ec7b2625219 = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        key: $7520d54e0c00d1c9$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $7520d54e0c00d1c9$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $6SJ6d.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $2nOF5.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });


const $83d7c6d60a9cd975$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $hwsSH.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $7520d54e0c00d1c9$export$ae829ec7b2625219)(dispatch)
                }
            ];
        }
    });
module.exports["fragmentPlugin"] = $83d7c6d60a9cd975$export$36fc1707093eff41;

});

parcelRegister("iVGec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $60EJg = parcelRequire("60EJg");


var $5X6fy = parcelRequire("5X6fy");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");

const $bfb9b1580f9516c1$export$bc90872e265d166e = 12;
// Matches the existing `.gridParent` 12px left + 12px right gutter expansion.
const $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH = 24;
const $bfb9b1580f9516c1$var$key = new (0, $kCECX.PluginKey)('gridPlugin');
const $bfb9b1580f9516c1$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($bfb9b1580f9516c1$var$key, props);
        dispatch(tr);
        return true;
    };
const $bfb9b1580f9516c1$var$sides = [
    'left',
    'right'
];
const $bfb9b1580f9516c1$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $bfb9b1580f9516c1$export$bc90872e265d166e && maxHighlight >= $bfb9b1580f9516c1$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $bfb9b1580f9516c1$export$bc90872e265d166e + size : true);
};
const $bfb9b1580f9516c1$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $7Y8M5.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $bfb9b1580f9516c1$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: side,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', $bfb9b1580f9516c1$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }));
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: side + '-bk',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $7Y8M5.akEditorBreakoutPadding)) / 2}px`
            }
        }));
    });
    return gridLines;
};
const $bfb9b1580f9516c1$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $bfb9b1580f9516c1$export$bc90872e265d166e;
    for(let i = 0; i <= $bfb9b1580f9516c1$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: i,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $bfb9b1580f9516c1$export$bc90872e265d166e ? style : undefined
        }));
    }
    return gridLines;
};
const $bfb9b1580f9516c1$var$GridLegacy = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "gridParent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
        style: {
            height: `${containerElement.scrollHeight}px`,
            display: visible ? 'block' : 'none',
            width: overlayWidth === undefined ? undefined : `${overlayWidth}px`
        },
        "data-testid": "gridContainer"
    }, gridLines)));
};
const $bfb9b1580f9516c1$var$GridNext = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth);
    const gridLines = [
        ...$bfb9b1580f9516c1$var$lineLengthGridLines(highlight),
        ...$bfb9b1580f9516c1$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "gridParent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('gridContainer', gridType),
        style: {
            height: `${containerElement.scrollHeight}px`,
            display: visible ? 'block' : 'none',
            width: overlayWidth === undefined ? undefined : `${overlayWidth}px`
        },
        "data-testid": "gridContainer"
    }, gridLines)));
};
const $bfb9b1580f9516c1$var$ThemedGridLegacy = (0, $60EJg.b)($bfb9b1580f9516c1$var$GridLegacy);
const $bfb9b1580f9516c1$var$ThemedGrid = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_core_non_ecc_static_css', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_core_static_css', 'isEnabled', true), $bfb9b1580f9516c1$var$GridNext, $bfb9b1580f9516c1$var$ThemedGridLegacy);
const $bfb9b1580f9516c1$var$selector = (states)=>{
    return {
        lineLength: states.widthState?.lineLength,
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $bfb9b1580f9516c1$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { lineLength: lineLength, width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $bfb9b1580f9516c1$var$selector);
    const overlayWidth = (0, $ieeJu.expValEquals)('platform_editor_external_embed_grid_fix', 'isEnabled', true) ? (lineLength || width || (0, $7Y8M5.akEditorFullPageMaxWidth)) + $bfb9b1580f9516c1$var$GRID_GUTTER_WIDTH : undefined;
    if (!visible || !highlight) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfb9b1580f9516c1$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $7Y8M5.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight,
        overlayWidth: overlayWidth
    });
};
const $bfb9b1580f9516c1$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $bfb9b1580f9516c1$var$gridPMPlugin = new (0, $kpCD8.SafePlugin)({
    key: $bfb9b1580f9516c1$var$key,
    state: {
        init () {
            return $bfb9b1580f9516c1$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($bfb9b1580f9516c1$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $bfb9b1580f9516c1$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $bfb9b1580f9516c1$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $bfb9b1580f9516c1$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$bfb9b1580f9516c1$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfb9b1580f9516c1$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};
module.exports["gridPlugin"] = $bfb9b1580f9516c1$export$c090e341e8f725a9;

});

parcelRegister("eHllO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");







const $eb5db962d31ab635$export$a18117c61b4f3090 = '--guideline-offset-x';
const $eb5db962d31ab635$export$343adffee41775d9 = '--guideline-offset-y';


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports




var $11HKG = parcelRequire("11HKG");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



const $dd37751fa808002e$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $dd37751fa808002e$var$getXPosition = (pixel)=>$dd37751fa808002e$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $eb5db962d31ab635$export$a18117c61b4f3090}, '0px'))` : 'unset';
const $dd37751fa808002e$var$getYPosition = (pixel)=>$dd37751fa808002e$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $eb5db962d31ab635$export$343adffee41775d9}, '0px'))` : 'unset';
const $dd37751fa808002e$export$a5b21f38d58b1de0 = (pos)=>{
    return (0, $11HKG.isVerticalPosition)(pos) ? {
        left: $dd37751fa808002e$var$getXPosition(pos.x),
        top: $dd37751fa808002e$var$getYPosition(pos.y?.start),
        height: pos.y ? `${pos.y.end - pos.y.start}px` : '100%'
    } : {
        top: $dd37751fa808002e$var$getYPosition(pos.y),
        left: $dd37751fa808002e$var$getXPosition(pos.x?.start),
        width: pos.x ? `${pos.x.end - pos.x.start}px` : '100%'
    };
};


function $4b69c2b3133f681e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b69c2b3133f681e$var$basicGuidelineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    zIndex: 0,
    opacity: 1,
    transition: 'border-color 0.15s linear, opacity 0.15s linear',
    borderColor: `${"var(--ds-border-disabled, #0515240F)"}`,
    borderStyle: 'solid'
});
const $4b69c2b3133f681e$var$verticalStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: `0 0 0 ${"var(--ds-border-width, 1px)"}`,
    width: '1px',
    height: '100%'
});
const $4b69c2b3133f681e$var$horizontalStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    borderWidth: `${"var(--ds-border-width, 1px)"} 0 0 0`,
    width: '100%',
    height: '1px'
});
const $4b69c2b3133f681e$var$activeGuidelineStyles = {
    name: "uh8fzh",
    styles: "border-color:var(--ds-border-focused, #4688EC);&:before, &:after{background-color:var(--ds-border-focused, #4688EC);}"
};
const $4b69c2b3133f681e$var$hiddenGuidelineStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $4b69c2b3133f681e$var$dashedGuidelineStyles = {
    name: "10ikx64",
    styles: "border-style:dashed"
};
const $4b69c2b3133f681e$var$verticalCapStyles = {
    name: "4o8hyx",
    styles: "&:before, &:after{background-color:var(--ds-border-disabled, #0515240F);content:\"\";position:absolute;height:5px;width:1px;transform:translateY(-50%);}&:after{right:0;}"
};
const $4b69c2b3133f681e$var$horizontalCapStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `${"var(--ds-border-disabled, #0515240F)"}`,
        content: '""',
        position: 'absolute',
        height: '1px',
        width: '5px',
        transform: 'translateX(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        bottom: 0
    }
});
const $4b69c2b3133f681e$export$1f92f20006072ef = (props)=>{
    const { position: position, active: active, show: show = true, styles: styles = {} } = props;
    const isVerticalPos = (0, $11HKG.isVerticalPosition)(position);
    const { lineStyle: lineStyle, color: color, capStyle: capStyle } = styles;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $4b69c2b3133f681e$var$basicGuidelineStyles,
            isVerticalPos ? $4b69c2b3133f681e$var$verticalStyles : $4b69c2b3133f681e$var$horizontalStyles,
            capStyle === 'line' && (isVerticalPos ? $4b69c2b3133f681e$var$horizontalCapStyles : $4b69c2b3133f681e$var$verticalCapStyles),
            active && $4b69c2b3133f681e$var$activeGuidelineStyles,
            !show && $4b69c2b3133f681e$var$hiddenGuidelineStyles,
            lineStyle === 'dashed' && $4b69c2b3133f681e$var$dashedGuidelineStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...color && {
                borderColor: `${color}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $dd37751fa808002e$export$a5b21f38d58b1de0)(position)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "guideline"
    });
};


const $f1525283be4414dc$var$guidelineContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'fixed',
    height: '100vh',
    width: '100%',
    display: 'grid',
    pointerEvents: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px`
});
const $f1525283be4414dc$export$e0b9e5fb6186afa = (props)=>{
    const { guidelines: guidelines, height: height, updateRect: updateRect } = props;
    const [offset, setOffset] = (0, $cozmU.useState)(0);
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        const rect = ref?.current?.getBoundingClientRect();
        if (rect) {
            const centerOffset = rect.width / 2 - 0.5;
            // X pixels from guideline container left to editor center.
            if (offset !== centerOffset) setOffset(centerOffset);
            updateRect({
                top: rect.top,
                left: rect.left
            });
        }
    }, [
        updateRect,
        offset
    ]);
    const style = {
        [(0, $eb5db962d31ab635$export$a18117c61b4f3090)]: `${offset}px`,
        [(0, $eb5db962d31ab635$export$343adffee41775d9)]: `0px`,
        height: height
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        css: $f1525283be4414dc$var$guidelineContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "guidelineContainer"
    }, guidelines.map((guideline)=>{
        const { key: key, ...guidelineProps } = guideline;
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4b69c2b3133f681e$export$1f92f20006072ef), {
            key: key,
            ...guidelineProps
        });
    }));
};


const $43a0cb3d15cb661f$var$guidelineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    transform: `scale(1)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: `${(0, $7Y8M5.akEditorGridLineZIndex)};`,
    display: 'flex',
    justifyContent: 'center'
});
const $43a0cb3d15cb661f$var$key = new (0, $kCECX.PluginKey)('guidelinePlugin');
const $43a0cb3d15cb661f$var$displayGuideline = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($43a0cb3d15cb661f$var$key, props);
        dispatch(tr);
        return true;
    };
const $43a0cb3d15cb661f$export$f040258c471d4154 = {
    guidelines: []
};
const $43a0cb3d15cb661f$var$guidelinePMPlugin = new (0, $kpCD8.SafePlugin)({
    key: $43a0cb3d15cb661f$var$key,
    state: {
        init () {
            return $43a0cb3d15cb661f$export$f040258c471d4154;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($43a0cb3d15cb661f$var$key);
            if (nextPluginState) return {
                ...currentPluginState,
                ...nextPluginState
            };
            return currentPluginState;
        }
    }
});
const $43a0cb3d15cb661f$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        lineLength: states.widthState?.lineLength,
        guidelines: states.guidelineState?.guidelines,
        rect: states.guidelineState?.rect
    };
};
const $43a0cb3d15cb661f$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, lineLength: lineLength, guidelines: guidelines, rect: rect } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width',
        'guideline'
    ], $43a0cb3d15cb661f$var$selector);
    if (!width || !lineLength || !guidelines || guidelines.length === 0) return null;
    const updateRect = ({ top: top, left: left })=>{
        const { dispatch: dispatch, state: state } = editorView;
        const { top: prevTop, left: prevLeft } = rect || {};
        if (prevTop !== top || prevLeft !== left) {
            const tr = state.tr.setMeta($43a0cb3d15cb661f$var$key, {
                rect: {
                    top: top,
                    left: left
                }
            });
            dispatch(tr);
            return true;
        }
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $43a0cb3d15cb661f$var$guidelineStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1525283be4414dc$export$e0b9e5fb6186afa), {
        guidelines: guidelines,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        height: editorView.dom.scrollHeight,
        width: width,
        editorWidth: lineLength,
        updateRect: updateRect
    }));
};
const $43a0cb3d15cb661f$export$63925ade01f824c4 = ({ config: options, api: api })=>({
        name: 'guideline',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $43a0cb3d15cb661f$var$key.getState(editorState) || null;
        },
        actions: {
            displayGuideline: $43a0cb3d15cb661f$var$displayGuideline
        },
        pmPlugins () {
            return [
                {
                    name: 'guideline',
                    plugin: ()=>$43a0cb3d15cb661f$var$guidelinePMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $lOiVq.jsx)($43a0cb3d15cb661f$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    });
module.exports["guidelinePlugin"] = $43a0cb3d15cb661f$export$63925ade01f824c4;

});

parcelRegister("laiso", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $ldqjS = parcelRequire("ldqjS");


var $gx3UZ = parcelRequire("gx3UZ");


var $kyJuy = parcelRequire("kyJuy");


var $doGhB = parcelRequire("doGhB");

const $0e12e5ac318d5e6c$export$2dac2f8389fd3a8c = (tr)=>{
    return tr.setMeta((0, $doGhB.pluginKey), true);
};
const $0e12e5ac318d5e6c$export$c54ba5c26d7768da = (tr)=>{
    return tr.setMeta((0, $doGhB.pluginKey), false);
};



var $8WPM6 = parcelRequire("8WPM6");








var $44cyU = parcelRequire("44cyU");







const $6f4c7a169db14fa2$export$e832373cff8dec22 = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.openHelp).common, (state, dispatch)=>{
        const { tr: tr } = state;
        const isVisible = tr.getMeta((0, $doGhB.pluginKey));
        if (!isVisible) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BUTTON_HELP,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            })(tr);
            (0, $8WPM6.openHelpCommand)(tr, dispatch);
        }
        return true;
    }, list);
    return (0, $44cyU.keymap)(list);
};



var $kpCD8 = parcelRequire("kpCD8");




function $7bb274d36fcc30fd$export$ae829ec7b2625219(dispatch, imageEnabled, aiEnabled) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $doGhB.pluginKey),
        state: {
            init () {
                return {
                    isVisible: false,
                    imageEnabled: imageEnabled,
                    aiEnabled: aiEnabled
                };
            },
            apply (tr, _value, state) {
                const isVisible = tr.getMeta((0, $doGhB.pluginKey));
                const currentState = (0, $doGhB.pluginKey).getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    const newState = {
                        ...currentState,
                        isVisible: isVisible
                    };
                    dispatch((0, $doGhB.pluginKey), newState);
                    return newState;
                }
                return currentState;
            }
        }
    });
}






var $4wH3g = parcelRequire("4wH3g");


const $8ed70e0b13fb68fb$export$e97fc21b7bb6adc7 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f2Q5_",
    name: "HelpDialogLoader",
    loader: ()=>(parcelRequire("9PAwP")).then((mod)=>mod.default),
    loading: ()=>null
});


/**
 * Normalise the caller-supplied config into a single, predictable shape.
 * – Boolean → "image uploads on/off", AI always off
 * – Object  → pick the two feature flags with sane defaults (both false)
 */ function $58d137eaf76fe45b$var$parseFeatureConfig(config) {
    if (typeof config === 'boolean') return {
        imageUploadProviderExists: config,
        aiEnabled: false
    };
    // Object path – ensure we never return undefined
    const { imageUploadProviderExists: imageUploadProviderExists = false, aiEnabled: aiEnabled = false } = config ?? {};
    return {
        imageUploadProviderExists: imageUploadProviderExists,
        aiEnabled: aiEnabled
    };
}
const $58d137eaf76fe45b$export$b3faa25d392107e4 = ({ config: config, api: api })=>{
    const { imageUploadProviderExists: imageUploadProviderExists, aiEnabled: aiEnabled } = $58d137eaf76fe45b$var$parseFeatureConfig(config);
    return {
        name: 'helpDialog',
        pmPlugins () {
            return [
                {
                    name: 'helpDialog',
                    plugin: ({ dispatch: dispatch })=>(0, $7bb274d36fcc30fd$export$ae829ec7b2625219)(dispatch, imageUploadProviderExists, aiEnabled)
                },
                {
                    name: 'helpDialogKeymap',
                    plugin: ()=>(0, $6f4c7a169db14fa2$export$e832373cff8dec22)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'helpdialog',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).help),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).helpDescription),
                        keywords: [
                            '?'
                        ],
                        priority: 4000,
                        keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.openHelp)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
                                label: "",
                                color: "currentColor",
                                spacing: "spacious"
                            }),
                        action (insert) {
                            const tr = insert('');
                            (0, $8WPM6.openHelpCommand)(tr);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).HELP_OPENED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).HELP,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HELP_QUICK_INSERT,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView || (0, $4iudd.isSSR)()) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ed70e0b13fb68fb$export$e97fc21b7bb6adc7), {
                pluginInjectionApi: api,
                editorView: editorView,
                quickInsertEnabled: !!api?.quickInsert
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $doGhB.pluginKey).getState(editorState) || null;
        },
        actions: {
            openHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $0e12e5ac318d5e6c$export$2dac2f8389fd3a8c)(tr));
            },
            closeHelp: ()=>{
                return api?.core.actions.execute(({ tr: tr })=>(0, $0e12e5ac318d5e6c$export$c54ba5c26d7768da)(tr));
            }
        }
    };
};
module.exports["helpDialogPlugin"] = $58d137eaf76fe45b$export$b3faa25d392107e4;

});

parcelRegister("8WPM6", function(module, exports) {

var $doGhB = parcelRequire("doGhB");

const $f953e0d84362cf43$export$e7832c5f11de3579 = (tr, dispatch)=>{
    tr = tr.setMeta((0, $doGhB.pluginKey), true);
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
const $f953e0d84362cf43$export$fd5f4180482ea9ed = (tr, dispatch)=>{
    tr = tr.setMeta((0, $doGhB.pluginKey), false);
    dispatch(tr);
};
module.exports["openHelpCommand"] = $f953e0d84362cf43$export$e7832c5f11de3579;
module.exports["closeHelpCommand"] = $f953e0d84362cf43$export$fd5f4180482ea9ed;

});

parcelRegister("9PAwP", function(module, exports) {

let $728536472a23e9d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728536472a23e9d4$var$load("hIr7E").then(()=>parcelRequire('3vA6q'));

});

parcelRegister("4exuQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UUJT = parcelRequire("6UUJT");

var $6OV8L = parcelRequire("6OV8L");





var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $72OpT = parcelRequire("72OpT");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");




var $gjFO5 = parcelRequire("gjFO5");


var $eEdSM = parcelRequire("eEdSM");


var $fud2r = parcelRequire("fud2r");

var $7SvWS = parcelRequire("7SvWS");

var $iLrhi = parcelRequire("iLrhi");


var $aPdNQ = parcelRequire("aPdNQ");





var $eOaGc = parcelRequire("eOaGc");













const $bbeac3462dd7561c$export$2583e740deddd6d = 3;
const $bbeac3462dd7561c$export$92f9af977c85ea46 = 5;
const $bbeac3462dd7561c$export$a9683f74b118e94b = 5;
const $bbeac3462dd7561c$export$f501538bec3afd75 = 'top';
const $bbeac3462dd7561c$export$faa6744ce57d263b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};





const $4b9fd8b3928d914b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('layout');


const $c44623e798e01dfd$var$roundLayoutColumnWidth = (width)=>Number(width.toFixed(2));
const $c44623e798e01dfd$var$sumWidths = (widths)=>widths.reduce((sum, width)=>sum + width, 0);
const $c44623e798e01dfd$var$normaliseWidthsTotal = (widths, totalWidth, minWidth)=>{
    const roundedWidths = widths.map($c44623e798e01dfd$var$roundLayoutColumnWidth);
    const remainder = $c44623e798e01dfd$var$roundLayoutColumnWidth(totalWidth - $c44623e798e01dfd$var$sumWidths(roundedWidths));
    if (remainder === 0 || roundedWidths.length === 0) return roundedWidths;
    let adjustmentIndex = 0;
    roundedWidths.forEach((width, index)=>{
        if (width > roundedWidths[adjustmentIndex]) adjustmentIndex = index;
    });
    const adjustedWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(roundedWidths[adjustmentIndex] + remainder);
    if (adjustedWidth < minWidth) return roundedWidths;
    return roundedWidths.map((width, index)=>index === adjustmentIndex ? adjustedWidth : width);
};
const $c44623e798e01dfd$var$isValidWidth = (width)=>Number.isFinite(width) && width > 0;
const $c44623e798e01dfd$var$redistributeWithMinimumWidth = ({ minWidth: minWidth, totalWidth: totalWidth, weights: weights })=>{
    if (weights.length * minWidth > totalWidth) return;
    const widths = Array(weights.length).fill(0);
    const clampedIndexes = new Set();
    let remainingWidth = totalWidth;
    let remainingWeight = $c44623e798e01dfd$var$sumWidths(weights);
    while(clampedIndexes.size < weights.length){
        const remainingWidthForPass = remainingWidth;
        const remainingWeightForPass = remainingWeight;
        const indexesToClamp = [];
        weights.forEach((weight, index)=>{
            if (clampedIndexes.has(index)) return;
            const proportionalWidth = remainingWeightForPass > 0 ? weight / remainingWeightForPass * remainingWidthForPass : 0;
            if (proportionalWidth < minWidth) indexesToClamp.push(index);
        });
        if (indexesToClamp.length === 0) break;
        indexesToClamp.forEach((index)=>{
            widths[index] = minWidth;
            clampedIndexes.add(index);
            remainingWidth -= minWidth;
            remainingWeight -= weights[index];
        });
    }
    weights.forEach((weight, index)=>{
        if (!clampedIndexes.has(index)) widths[index] = remainingWeight > 0 ? weight / remainingWeight * remainingWidth : minWidth;
    });
    return widths;
};
const $c44623e798e01dfd$export$e260f2e2ca90998a = (selectedWidths)=>{
    const count = selectedWidths.length;
    if (count < 2) return undefined;
    const selectedTotal = $c44623e798e01dfd$var$sumWidths(selectedWidths);
    const equalWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(selectedTotal / count);
    return {
        selectedTotal: selectedTotal,
        equalWidth: equalWidth
    };
};
function $c44623e798e01dfd$export$3cbb23b573ffb2e9(selectedWidths, distribution = $c44623e798e01dfd$export$e260f2e2ca90998a(selectedWidths)) {
    if (!distribution || selectedWidths.length < 2) return false;
    const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
    const lastColWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(selectedTotal - equalWidth * (selectedWidths.length - 1));
    return selectedWidths.slice(0, -1).every((width)=>width === equalWidth) && selectedWidths[selectedWidths.length - 1] === lastColWidth;
}
const $c44623e798e01dfd$export$7a23b11013fe122c = (currentWidths, removeIndex, minWidth)=>{
    if (currentWidths.length === 0 || removeIndex < 0 || removeIndex >= currentWidths.length || !$c44623e798e01dfd$var$isValidWidth(minWidth)) return currentWidths;
    if (currentWidths.some((width)=>!$c44623e798e01dfd$var$isValidWidth(width))) return currentWidths.filter((_, i)=>i !== removeIndex);
    const remainingWidths = currentWidths.filter((_, i)=>i !== removeIndex);
    if (remainingWidths.length === 0) return remainingWidths;
    const currentTotalWidth = $c44623e798e01dfd$var$sumWidths(currentWidths);
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const redistributed = $c44623e798e01dfd$var$redistributeWithMinimumWidth({
        weights: remainingWidths,
        totalWidth: targetTotalWidth,
        minWidth: minWidth
    });
    if (!redistributed) {
        const equalWidth = $c44623e798e01dfd$var$roundLayoutColumnWidth(targetTotalWidth / remainingWidths.length);
        return $c44623e798e01dfd$var$normaliseWidthsTotal(Array(remainingWidths.length).fill(equalWidth), targetTotalWidth, minWidth);
    }
    return $c44623e798e01dfd$var$normaliseWidthsTotal(redistributed, targetTotalWidth, minWidth);
};
const $c44623e798e01dfd$export$3d07e1109dd4c8ac = (currentWidths, insertIndex, maxColumns, minWidth)=>{
    if (currentWidths.length === 0 || !Number.isInteger(maxColumns) || maxColumns <= 0 || currentWidths.length >= maxColumns || insertIndex < 0 || insertIndex > currentWidths.length || !$c44623e798e01dfd$var$isValidWidth(minWidth) || currentWidths.some((width)=>!$c44623e798e01dfd$var$isValidWidth(width))) return currentWidths;
    const currentTotalWidth = $c44623e798e01dfd$var$sumWidths(currentWidths);
    if (!$c44623e798e01dfd$var$isValidWidth(currentTotalWidth)) return currentWidths;
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const newColumnWidth = Math.max(minWidth, $c44623e798e01dfd$var$roundLayoutColumnWidth(targetTotalWidth / (currentWidths.length + 1)));
    const existingColumnsTotalWidth = targetTotalWidth - newColumnWidth;
    if (existingColumnsTotalWidth < currentWidths.length * minWidth) return currentWidths;
    const redistributedExistingWidths = $c44623e798e01dfd$var$redistributeWithMinimumWidth({
        weights: currentWidths,
        totalWidth: existingColumnsTotalWidth,
        minWidth: minWidth
    });
    if (!redistributedExistingWidths) return currentWidths;
    const nextWidths = [
        ...redistributedExistingWidths
    ];
    nextWidths.splice(insertIndex, 0, newColumnWidth);
    return $c44623e798e01dfd$var$normaliseWidthsTotal(nextWidths, targetTotalWidth, minWidth);
};









const $165a594884c31a30$var$findLayoutSectionFromSelection = (selection)=>{
    const { layoutSection: layoutSection } = selection.$from.doc.type.schema.nodes;
    // NodeSelection on the layoutSection node itself
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type === layoutSection) return {
        node: selection.node,
        pos: selection.from
    };
    return (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection);
};
const $165a594884c31a30$var$findLayoutColumnsFromLayoutSection = (layoutSectionNode, layoutSectionPos = 0)=>{
    return (0, $bjg0G.findChildrenByType)(layoutSectionNode, layoutSectionNode.type.schema.nodes.layoutColumn).map(({ node: node, pos: pos })=>({
            node: node,
            pos: pos + layoutSectionPos + 1
        }));
};
const $165a594884c31a30$var$getSelectedLayoutColumns = (selection, isColumnSelected)=>{
    const layoutSection = $165a594884c31a30$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const { node: layoutSectionNode, pos: layoutSectionPos } = layoutSection;
    const allLayoutColumns = $165a594884c31a30$var$findLayoutColumnsFromLayoutSection(layoutSectionNode, layoutSectionPos);
    if (!allLayoutColumns.length) return undefined;
    let startIndex = -1;
    let endIndex = -1;
    const selectedLayoutColumns = allLayoutColumns.filter((column, index)=>{
        if (isColumnSelected(column, index)) {
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            return true;
        }
        return false;
    });
    return {
        layoutSectionNode: layoutSectionNode,
        layoutSectionPos: layoutSectionPos,
        selectedLayoutColumns: selectedLayoutColumns,
        startIndex: startIndex,
        endIndex: endIndex
    };
};
const $165a594884c31a30$export$d9c5d9ac81e1479b = (selection)=>{
    return $165a594884c31a30$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        // NodeSelection on a layout column is clearly selected.
        if (selection instanceof (0, $kCECX.NodeSelection) && selection.node === node) return true;
        // For TextSelection, only count columns that are fully contained within the selection
        // (not partial text selections inside a column).
        const nodeEndPos = pos + node.nodeSize;
        return !selection.empty && selection.from <= pos && selection.to >= nodeEndPos;
    });
};
const $165a594884c31a30$export$1ba40f8dfd76f1b5 = (selection)=>{
    return $165a594884c31a30$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        if (selection instanceof (0, $kCECX.NodeSelection) && selection.node === node) return true;
        const nodeEndPos = pos + node.nodeSize;
        return selection.empty ? selection.from > pos && selection.from < nodeEndPos : selection.from < nodeEndPos && selection.to > pos;
    });
};
const $165a594884c31a30$export$1f0e4d47b1eb0108 = (selection)=>{
    const layoutSection = $165a594884c31a30$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const layoutColumns = $165a594884c31a30$var$findLayoutColumnsFromLayoutSection(layoutSection.node, layoutSection.pos);
    if (!layoutColumns?.length) return undefined;
    return {
        layoutSectionNode: layoutSection.node,
        layoutSectionPos: layoutSection.pos,
        selectedLayoutColumns: layoutColumns,
        startIndex: 0,
        endIndex: layoutColumns.length - 1
    };
};
const $165a594884c31a30$export$3645821254ad9933 = (layoutColumn)=>layoutColumn ? layoutColumn.attrs.valign ?? (0, $bbeac3462dd7561c$export$f501538bec3afd75) : undefined;
const $165a594884c31a30$export$22b40f2459c71fe8 = (selection, anchorPosFromHandle)=>{
    const selectedLayoutColumns = $165a594884c31a30$export$d9c5d9ac81e1479b(selection);
    if (!selectedLayoutColumns) return undefined;
    const clickedSelectedColumn = selectedLayoutColumns.selectedLayoutColumns.find(({ pos: pos })=>pos === anchorPosFromHandle);
    return clickedSelectedColumn?.pos ?? selectedLayoutColumns.selectedLayoutColumns[0]?.pos;
};


const $20de433b9f6c9d19$export$6ff908759d68cbdd = [
    'single'
];
const $20de433b9f6c9d19$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $20de433b9f6c9d19$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $20de433b9f6c9d19$var$getWidthsForPreset = (presetLayout)=>{
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
        case 'three_left_sidebars':
            return [
                25,
                25,
                50
            ];
        case 'three_right_sidebars':
            return [
                50,
                25,
                25
            ];
        case 'four_equal':
            return [
                25,
                25,
                25,
                25
            ];
        case 'five_equal':
            return [
                20,
                20,
                20,
                20,
                20
            ];
    }
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
    return [];
};
const $20de433b9f6c9d19$var$isValidLayoutWidthDistributions = (layoutSection)=>{
    let totalWidth = 0;
    let hasInvalidWidth = false;
    (0, $fud2r.mapChildren)(layoutSection, (column)=>column.attrs.width).forEach((width)=>{
        if (typeof width === 'number' && isFinite(width) && width > 0 && width <= 100) totalWidth += width;
        else hasInvalidWidth = true;
    });
    return !hasInvalidWidth && Math.round(totalWidth) === 100;
};
const $20de433b9f6c9d19$export$e406155610be725b = (section)=>{
    const widths = (0, $fud2r.mapChildren)(section, (column)=>column.attrs.width).join(',');
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
        switch(widths){
            case '100':
                return 'single';
            case '33.33,33.33,33.33':
                return 'three_equal';
            case '25,50,25':
                return 'three_with_sidebars';
            case '50,25,25':
                return 'three_right_sidebars';
            case '25,25,50':
                return 'three_left_sidebars';
            case '50,50':
                return 'two_equal';
            case '33.33,66.66':
                return 'two_left_sidebar';
            case '66.66,33.33':
                return 'two_right_sidebar';
            case '25,25,25,25':
                return 'four_equal';
            case '20,20,20,20,20':
                return 'five_equal';
        }
        return;
    }
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $20de433b9f6c9d19$var$isLayoutOutOfSync = (node, presetLayout)=>{
    return node.childCount !== $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout).length;
};
const $20de433b9f6c9d19$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $20de433b9f6c9d19$var$isLayoutOutOfSync(maybeLayoutSection, current) && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) return $20de433b9f6c9d19$var$getDefaultPresetLayout(maybeLayoutSection);
    if (maybeLayoutSection && $20de433b9f6c9d19$export$e406155610be725b(maybeLayoutSection)) return $20de433b9f6c9d19$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $20de433b9f6c9d19$export$af0aef1ee58dfcf = (state, numberOfColumns = 2)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    const columns = (0, $aPdNQ.Fragment).fromArray(Array.from({
        length: numberOfColumns
    }, ()=>layoutColumn.createAndFill({
            width: (0, $bbeac3462dd7561c$export$faa6744ce57d263b)[numberOfColumns]
        })));
    return layoutSection.createAndFill(undefined, columns);
};
const $20de433b9f6c9d19$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $aPdNQ.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $20de433b9f6c9d19$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $bjg0G.safeInsert)($20de433b9f6c9d19$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $20de433b9f6c9d19$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: (0, $ixfCV.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                columnCount: (0, $ixfCV.fg)('platform_editor_column_count_analytics') ? 2 : undefined
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })((state, dispatch)=>{
            if (dispatch) dispatch((0, $bjg0G.safeInsert)($20de433b9f6c9d19$export$24df8f7ba30643b8(state))(state.tr));
            return true;
        });
/**
 * Add a column to the right of existing layout
 */ function $20de433b9f6c9d19$var$addColumn(schema, pos) {
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', false)) return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill(undefined));
    };
}
function $20de433b9f6c9d19$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        // check if the column only contains a paragraph with a placeholder text
        // if so, remove the whole column, otherwise just remove the paragraph
        if ((0, $iLrhi.isEmptyDocument)(column)) {
            const fromPos = (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? columnPos : columnPos - 1;
            tr.replaceRange(tr.mapping.map(fromPos), tr.mapping.map(insideRightEdgePos), (0, $aPdNQ.Slice).empty);
        } else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $aPdNQ.Slice).empty);
    };
}
const $20de433b9f6c9d19$var$fromTwoColsToThree = $20de433b9f6c9d19$var$addColumn;
const $20de433b9f6c9d19$var$fromOneColToTwo = $20de433b9f6c9d19$var$addColumn;
const $20de433b9f6c9d19$var$fromTwoColsToOne = $20de433b9f6c9d19$var$removeLastColumnInLayout;
const $20de433b9f6c9d19$var$fromThreeColsToTwo = $20de433b9f6c9d19$var$removeLastColumnInLayout;
const $20de433b9f6c9d19$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
        $20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
    };
};
const $20de433b9f6c9d19$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $20de433b9f6c9d19$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $20de433b9f6c9d19$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
const $20de433b9f6c9d19$var$increaseColumns = (schema, pos, newColumnsNumber = 1)=>{
    return (tr)=>{
        for(let i = 0; i < newColumnsNumber; i++)$20de433b9f6c9d19$var$addColumn(schema, pos)(tr);
    };
};
const $20de433b9f6c9d19$var$decreaseColumns = (node, insideRightEdgePos, columnsNumberToRemove = 1)=>{
    return (tr)=>{
        let endPos = insideRightEdgePos;
        let lastColumn = node.content.lastChild;
        for(let i = 0; i < columnsNumberToRemove; i++){
            lastColumn && $20de433b9f6c9d19$var$removeLastColumnInLayout(lastColumn, endPos - lastColumn.nodeSize, endPos)(tr);
            endPos -= lastColumn?.nodeSize || 0;
            lastColumn = node.content.child(node.childCount - i - 2);
        }
    };
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $20de433b9f6c9d19$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($20de433b9f6c9d19$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $20de433b9f6c9d19$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($20de433b9f6c9d19$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $20de433b9f6c9d19$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($20de433b9f6c9d19$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $20de433b9f6c9d19$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($20de433b9f6c9d19$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $20de433b9f6c9d19$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($20de433b9f6c9d19$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $20de433b9f6c9d19$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($20de433b9f6c9d19$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $20de433b9f6c9d19$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $20de433b9f6c9d19$var$forceColumnStructureNew(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    const columnChange = $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout).length - numCols;
    if (columnChange > 0) $20de433b9f6c9d19$var$increaseColumns(state.schema, insideRightEdgeOfLayoutSection, columnChange)(tr);
    else if (columnChange < 0) $20de433b9f6c9d19$var$decreaseColumns(node, insideRightEdgeOfLayoutSection, -columnChange)(tr);
    return tr;
}
function $20de433b9f6c9d19$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $fud2r.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $20de433b9f6c9d19$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(node, state.schema, $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout)));
}
function $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    const forceColumnStructureFn = (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? $20de433b9f6c9d19$var$forceColumnStructureNew : $20de433b9f6c9d19$var$forceColumnStructure;
    let tr = forceColumnStructureFn(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $20de433b9f6c9d19$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $kCECX.NodeSelection) ? new (0, $kCECX.NodeSelection)(selectionPos$) : new (0, $kCECX.TextSelection)(selectionPos$));
}
const $20de433b9f6c9d19$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
            if (pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            if (selectedLayout === layout && node.childCount > 1) return false;
            const tr = $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $20de433b9f6c9d19$var$formatLayoutName(selectedLayout),
                        newLayout: $20de433b9f6c9d19$var$formatLayoutName(layout)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $20de433b9f6c9d19$var$layoutNeedChanges(node) {
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
        if ((0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true)) {
            // Custom widths that sum to 100% are valid and should not be forced back to presets
            if ($20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node)) return false;
            return true;
        }
        return !$20de433b9f6c9d19$export$e406155610be725b(node) || !$20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node);
    }
    return !$20de433b9f6c9d19$export$e406155610be725b(node);
}
const $20de433b9f6c9d19$var$getDefaultPresetLayout = (layoutNode)=>{
    const layoutColumnCount = layoutNode.childCount;
    if (layoutColumnCount <= 1) return 'single';
    switch(layoutColumnCount){
        case 1:
            return 'single';
        case 2:
            return 'two_equal';
        case 3:
            return 'three_equal';
        case 4:
            return 'four_equal';
        case 5:
            return 'five_equal';
        default:
            return 'five_equal';
    }
};
function $20de433b9f6c9d19$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$20de433b9f6c9d19$var$layoutNeedChanges(node)) return;
        const presetLayout = (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? $20de433b9f6c9d19$var$getDefaultPresetLayout(node) : node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $20de433b9f6c9d19$var$columnWidth(node, schema, $20de433b9f6c9d19$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $aPdNQ.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $20de433b9f6c9d19$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $7SvWS.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($20de433b9f6c9d19$var$layoutNeedChanges(node)) change = $20de433b9f6c9d19$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $20de433b9f6c9d19$var$layoutNeedChanges(node)) change = $20de433b9f6c9d19$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $20de433b9f6c9d19$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node) {
            if (node.childCount !== $20de433b9f6c9d19$var$getWidthsForPreset(selectedLayout).length) {
                // If the resize handle experiment is on and widths are valid, don't force preset
                // (column count mismatch might be from a different preset being selected)
                if ((0, $fqVYq.editorExperiment)('advanced_layouts', true) && (0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true) && $20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node)) return;
                return $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
            }
            if (!$20de433b9f6c9d19$var$isValidLayoutWidthDistributions(node) && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) return $20de433b9f6c9d19$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
        }
    }
    return;
};
const $20de433b9f6c9d19$export$7472487719e2c16f = (editorAnalyticsAPI, inputMethod)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                const tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).DELETED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $20de433b9f6c9d19$var$formatLayoutName(selectedLayout),
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $20de433b9f6c9d19$var$formatLayoutName = (layout)=>{
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) switch(layout){
        case 'single':
            return (0, $gjFO5.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $gjFO5.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
        case 'four_equal':
            return (0, $gjFO5.LAYOUT_TYPE).FOUR_COLS_EQUAL;
        case 'five_equal':
            return (0, $gjFO5.LAYOUT_TYPE).FIVE_COLS_EQUAL;
    }
    switch(layout){
        case 'single':
            return (0, $gjFO5.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $gjFO5.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $gjFO5.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $gjFO5.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};
const $20de433b9f6c9d19$export$7304947c445e7dbb = 'layoutColumnInsert';
const $20de433b9f6c9d19$var$getPreviousLayoutColumnValign = (selectedLayoutColumns)=>{
    const firstValign = (0, $165a594884c31a30$export$3645821254ad9933)(selectedLayoutColumns[0]?.node);
    const hasMixedValign = selectedLayoutColumns.some(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) !== firstValign);
    return hasMixedValign ? 'mixed' : firstValign ?? (0, $bbeac3462dd7561c$export$f501538bec3afd75);
};
const $20de433b9f6c9d19$var$hasLayoutColumnContent = (node)=>!(0, $iLrhi.isEmptyDocument)(node);
/**
 * Remaps a selection through a position mapping, preserving its type. Used after replacing a
 * layout section's contents so the selection stays in its column instead of being mapped out
 * of the layout. Returns `undefined` if no valid selection can be derived (NodeSelection
 * whose node is no longer selectable falls back to a nearby caret).
 */ const $20de433b9f6c9d19$var$remapSelectionThroughMapping = (selection, mapping, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const mappedPos = clamp(mapping.map(selection.from));
        const nodeAtPos = doc.nodeAt(mappedPos);
        if (nodeAtPos && (0, $kCECX.NodeSelection).isSelectable(nodeAtPos)) return (0, $kCECX.NodeSelection).create(doc, mappedPos);
        return (0, $kCECX.TextSelection).findFrom(doc.resolve(mappedPos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $kCECX.TextSelection)) {
        const mappedFrom = clamp(mapping.map(selection.from));
        const mappedTo = clamp(mapping.map(selection.to));
        try {
            return (0, $kCECX.TextSelection).create(doc, mappedFrom, mappedTo);
        } catch  {
            return undefined;
        }
    }
    return undefined;
};
const $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection = (tr, api)=>{
    const insertMeta = tr.getMeta($20de433b9f6c9d19$export$7304947c445e7dbb);
    if (insertMeta) {
        const mapping = insertMeta.side === 'left' ? new (0, $eOaGc.Mapping)([
            new (0, $eOaGc.StepMap)([
                insertMeta.insertedColumnPos,
                0,
                insertMeta.insertedColumnNodeSize
            ])
        ]) : new (0, $eOaGc.Mapping)();
        api?.blockControls?.commands.mapPreservedSelection(mapping)({
            tr: tr
        });
        return;
    }
    // Width and alignment updates should keep original layout column selection unchanged.
    if (tr.getMeta('scrollIntoView') === false && tr.docChanged) api?.blockControls?.commands.mapPreservedSelection(new (0, $eOaGc.Mapping)())({
        tr: tr
    });
};
function $20de433b9f6c9d19$export$1e9b718436507bc8() {
    return (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? (0, $bbeac3462dd7561c$export$92f9af977c85ea46) : (0, $bbeac3462dd7561c$export$2583e740deddd6d);
}
const $20de433b9f6c9d19$var$insertLayoutColumnAt = (side, editorAnalyticsAPI, inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU)=>({ tr: tr })=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) return null;
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$1ba40f8dfd76f1b5)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const selectedColumnIndex = side === 'left' ? startIndex : endIndex;
        const selectedColumnCount = selectedLayoutColumns.length;
        if (layoutSectionNode.childCount >= $20de433b9f6c9d19$export$1e9b718436507bc8()) return null;
        const insertIndex = side === 'left' ? selectedColumnIndex : selectedColumnIndex + 1;
        const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributedWidths = (0, $c44623e798e01dfd$export$3d07e1109dd4c8ac)(existingWidths, insertIndex, $20de433b9f6c9d19$export$1e9b718436507bc8(), (0, $bbeac3462dd7561c$export$a9683f74b118e94b));
        if (redistributedWidths === existingWidths) return null;
        const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes;
        const newColumn = layoutColumn.createAndFill({
            width: redistributedWidths[insertIndex]
        });
        if (!newColumn) return null;
        const updatedColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index === insertIndex) updatedColumns.push(newColumn);
            updatedColumns.push(column);
        });
        if (insertIndex === layoutSectionNode.childCount) updatedColumns.push(newColumn);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $aPdNQ.Fragment).fromArray(updatedColumns));
        let insertedColumnOffset = 0;
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < insertIndex) insertedColumnOffset += column.nodeSize;
        });
        const insertedColumnPos = layoutSectionPos + 1 + insertedColumnOffset;
        tr.setMeta($20de433b9f6c9d19$export$7304947c445e7dbb, {
            insertedColumnNodeSize: newColumn.nodeSize,
            insertedColumnPos: insertedColumnPos,
            side: side
        });
        // Capture the selection before the section content is replaced (the replace below maps
        // it out of the layout by default). The menu path restores its own preserved selection
        // afterwards, so this restoration only matters for the cursor-in-column case.
        const originalSelection = tr.selection;
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributedWidths));
        // Inserting left shifts positions at/after the new column right by its size; inserting
        // right leaves them unchanged. Remap the original selection through that mapping.
        if (!(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1')) {
            const insertMapping = side === 'left' ? new (0, $eOaGc.Mapping)([
                new (0, $eOaGc.StepMap)([
                    insertedColumnPos,
                    0,
                    newColumn.nodeSize
                ])
            ]) : new (0, $eOaGc.Mapping)();
            const restoredSelection = $20de433b9f6c9d19$var$remapSelectionThroughMapping(originalSelection, insertMapping, tr.doc);
            if (restoredSelection) tr.setSelection(restoredSelection);
        }
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                endIndex: endIndex,
                inputMethod: inputMethod,
                newColumnCount: redistributedWidths.length,
                previousColumnCount: layoutSectionNode.childCount,
                selectedCount: selectedColumnCount,
                side: side,
                startIndex: startIndex
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$7dcaf37842fa555e = ({ side: side, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        const result = $20de433b9f6c9d19$var$insertLayoutColumnAt(side, editorAnalyticsAPI, inputMethod)({
            tr: tr
        });
        if (result) $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
        return result;
    };
const $20de433b9f6c9d19$export$4bf533320bf88c4 = ({ valign: valign, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) return null;
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
        if (!selectedLayoutColumnsResult) return null;
        const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const previousValign = $20de433b9f6c9d19$var$getPreviousLayoutColumnValign(selectedLayoutColumns);
        const columnsToUpdate = selectedLayoutColumns.filter(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) !== valign);
        if (columnsToUpdate.length === 0) return null;
        const updatedColumnCount = columnsToUpdate.length;
        columnsToUpdate.forEach(({ node: node, pos: pos })=>{
            tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                valign: valign
            });
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).UPDATED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                columnCount: layoutSectionNode.childCount,
                endIndex: endIndex,
                inputMethod: inputMethod,
                previousValign: previousValign,
                selectedCount: selectedLayoutColumns.length,
                startIndex: startIndex,
                updatedCount: updatedColumnCount,
                valign: valign
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
        return tr;
    };
const $20de433b9f6c9d19$export$3155fb5f705eeef0 = (editorAnalyticsAPI, api)=>({ inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU, target: target = 'selectedColumns' } = {})=>({ tr: tr })=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) return null;
            const selectedLayoutColumnsResult = target === 'allColumns' ? (0, $165a594884c31a30$export$1f0e4d47b1eb0108)(tr.selection) : (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
            if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length < 2) return null;
            const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
            const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
            const selectedWidths = selectedLayoutColumns.map(({ node: node })=>node.attrs.width);
            const distribution = (0, $c44623e798e01dfd$export$e260f2e2ca90998a)(selectedWidths);
            if (!distribution) return null;
            const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
            if ((0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)(selectedWidths, distribution)) return null;
            // Build new widths array: selected columns get equal share, unselected unchanged.
            // Assign rounded (2dp) equal widths to all selected cols except the last, which absorbs
            // the rounding remainder so the sum of selected widths equals selectedTotal exactly.
            let assignedToSelected = 0;
            let selectedAssignedCount = 0;
            const newWidths = existingWidths.map((w, idx)=>{
                if (idx < startIndex || idx > endIndex) return w;
                selectedAssignedCount += 1;
                if (selectedAssignedCount < selectedLayoutColumns.length) {
                    assignedToSelected += equalWidth;
                    return equalWidth;
                }
                // Last selected column: absorb the remainder to avoid drift
                return Number((selectedTotal - assignedToSelected).toFixed(2));
            });
            // Apply widths via setNodeMarkup per selected column — keeps nodes in place (preserves identity, marks, decorations)
            selectedLayoutColumns.forEach(({ node: node, pos: pos }, i)=>{
                const colIdx = startIndex + i;
                tr.setNodeMarkup(pos, node.type, {
                    ...node.attrs,
                    width: newWidths[colIdx]
                });
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    columnCount: layoutSectionNode.childCount,
                    endIndex: endIndex,
                    inputMethod: inputMethod,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex,
                    target: target
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            tr.setMeta('scrollIntoView', false);
            $20de433b9f6c9d19$var$mapLayoutColumnPreservedSelection(tr, api);
            return tr;
        };
const $20de433b9f6c9d19$export$f9a5c2c84987525d = (options)=>({ tr: tr })=>{
        tr.setMeta('toggleLayoutColumnMenu', options);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$21f559cd4fbd479 = (show)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(tr.selection);
        const positions = show ? selectedLayoutColumnsResult?.selectedLayoutColumns.map(({ pos: pos })=>pos) ?? [] : null;
        tr.setMeta('layoutColumnDangerPreview', positions);
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $20de433b9f6c9d19$export$b3b830a5fba26889 = ({ inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU } = {}, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) return null;
        const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$1ba40f8dfd76f1b5)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
        const hadContent = selectedLayoutColumns.some(({ node: node })=>$20de433b9f6c9d19$var$hasLayoutColumnContent(node));
        const emitDeleteColumnAnalytics = (newColumnCount)=>{
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    endIndex: endIndex,
                    hadContent: hadContent,
                    inputMethod: inputMethod,
                    newColumnCount: newColumnCount,
                    previousColumnCount: layoutSectionNode.childCount,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
        };
        // If all columns are selected, remove the entire layoutSection
        if (selectedLayoutColumns.length === layoutSectionNode.childCount) {
            tr.delete(layoutSectionPos, layoutSectionPos + layoutSectionNode.nodeSize);
            emitDeleteColumnAnalytics(0);
            tr.setMeta('scrollIntoView', false);
            api?.blockControls?.commands.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        }
        // Build new column list without the selected columns
        const remainingColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < startIndex || index > endIndex) remainingColumns.push(column);
        });
        // Redistribute widths proportionally among remaining columns using shared utility
        const existingWidths = (0, $fud2r.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributed = selectedLayoutColumns.map((_, i)=>startIndex + i)// Delete highest indices first so lower original indices still point at the same columns
        // as each redistribution step shrinks the widths array.
        .reverse().reduce((widths, selectedIndex)=>(0, $c44623e798e01dfd$export$7a23b11013fe122c)(widths, selectedIndex, (0, $bbeac3462dd7561c$export$a9683f74b118e94b)), existingWidths);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $aPdNQ.Fragment).fromArray(remainingColumns));
        // The cursor-in-column (keyboard) path has a plain text selection; the menu path has a
        // column NodeSelection whose post-delete landing is owned by the block-controls
        // preserved-selection plugin, so we only restore the caret for the former.
        const hadTextSelection = tr.selection instanceof (0, $kCECX.TextSelection);
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $20de433b9f6c9d19$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributed));
        // Land the caret in a remaining column — the one now occupying the deleted slot, or the
        // last column when the deleted slot no longer exists. Otherwise the replace above maps
        // the caret out of the layout to the following paragraph.
        const remainingColumnCount = remainingColumns.length;
        if (hadTextSelection && !(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1') && remainingColumnCount > 0) {
            const targetColumnIndex = Math.min(startIndex, remainingColumnCount - 1);
            const updatedSectionNode = tr.doc.nodeAt(layoutSectionPos);
            if (updatedSectionNode) {
                let columnOffset = 1;
                for(let columnIndex = 0; columnIndex < targetColumnIndex; columnIndex++)columnOffset += updatedSectionNode.child(columnIndex).nodeSize;
                // +1 to land inside the column's first child rather than on the column boundary.
                const caretPos = layoutSectionPos + columnOffset + 1;
                if (caretPos >= 0 && caretPos <= tr.doc.content.size) {
                    const caretSelection = (0, $kCECX.TextSelection).findFrom(tr.doc.resolve(caretPos), 1, true);
                    if (caretSelection) tr.setSelection(caretSelection);
                }
            }
        }
        emitDeleteColumnAnalytics(redistributed.length);
        tr.setMeta('scrollIntoView', false);
        api?.blockControls?.commands.stopPreservingSelection()({
            tr: tr
        });
        return tr;
    };






var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


const $85a43829160bedc9$var$bindLayoutColumnShortcut = (shortcut, command, list)=>{
    if (!shortcut) return;
    (0, $ldqjS.bindKeymapWithEditorCommand)(shortcut, command, list);
};
/**
 * Creates shortcut handlers for layout column actions.
 */ function $85a43829160bedc9$var$keymapPlugin({ api: api }) {
    const list = {};
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnBefore).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'left',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnBeforeVO).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'left',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnAfter).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'right',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.addColumnAfterVO).common, (0, $20de433b9f6c9d19$export$7dcaf37842fa555e)({
        side: 'right',
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    $85a43829160bedc9$var$bindLayoutColumnShortcut((0, $ldqjS.deleteColumn).common, (0, $20de433b9f6c9d19$export$b3b830a5fba26889)({
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }, api?.analytics?.actions, api), list);
    return (0, $eBSR7.keymap)(list);
}
var $85a43829160bedc9$export$2e2bcd8739ae039 = $85a43829160bedc9$var$keymapPlugin;






var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");

var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $dTPhv = parcelRequire("dTPhv");


var $44cyU = parcelRequire("44cyU");











var $8nvEM = parcelRequire("8nvEM");









var $cbY7C = parcelRequire("cbY7C");

















/**
 * Re-creates a selection at the same positions against the resized document. A resize only
 * changes width attrs (not node count, order, or size), so the original positions are still
 * valid. Returns `undefined` if no valid selection can be made.
 */ const $0ab5832e42b8afea$var$remapResizeSelection = (selection, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const pos = clamp(selection.from);
        const nodeAtPos = doc.nodeAt(pos);
        if (nodeAtPos && (0, $kCECX.NodeSelection).isSelectable(nodeAtPos)) return (0, $kCECX.NodeSelection).create(doc, pos);
        return (0, $kCECX.TextSelection).findFrom(doc.resolve(pos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $kCECX.TextSelection)) try {
        return (0, $kCECX.TextSelection).create(doc, clamp(selection.from), clamp(selection.to));
    } catch  {
        return undefined;
    }
    return undefined;
};
// Class names for the column resize divider widget — must stay in sync with layout.ts in editor-core
const $0ab5832e42b8afea$var$layoutColumnDividerClassName = 'layout-column-divider';
const $0ab5832e42b8afea$var$layoutColumnDividerRailClassName = 'layout-column-divider-rail';
const $0ab5832e42b8afea$var$layoutColumnDividerThumbClassName = 'layout-column-divider-thumb';
// Module-level drag state so it survives widget DOM recreation during transactions.
let $0ab5832e42b8afea$var$dragState = null;
/**
 * Dispatches a single undoable ProseMirror transaction to commit the final
 * column widths after a drag completes.
 */ const $0ab5832e42b8afea$var$dispatchColumnWidths = (view, sectionPos, leftColIndex, leftWidth, rightWidth, editorAnalyticsAPI)=>{
    const { state: state } = view;
    const sectionNode = state.doc.nodeAt(sectionPos);
    if (!sectionNode) return;
    const { layoutColumn: layoutColumn } = state.schema.nodes;
    const tr = state.tr;
    const newColumns = [];
    sectionNode.forEach((child, _offset, index)=>{
        if (child.type === layoutColumn) {
            let newWidth = child.attrs.width;
            if (index === leftColIndex) newWidth = Number(leftWidth.toFixed(2));
            else if (index === leftColIndex + 1) newWidth = Number(rightWidth.toFixed(2));
            newColumns.push(layoutColumn.create({
                ...child.attrs,
                width: newWidth
            }, child.content, child.marks));
        } else newColumns.push(child);
    });
    // Capture the selection before the replace below, which otherwise maps the caret out of
    // the layout to the following paragraph. Restored at the same positions afterwards.
    const shouldPreserveSelection = !(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1');
    const selectionBeforeResize = shouldPreserveSelection ? state.selection : null;
    tr.replaceWith(sectionPos + 1, sectionPos + sectionNode.nodeSize - 1, (0, $aPdNQ.Fragment).from(newColumns));
    tr.setMeta('layoutColumnResize', true);
    tr.setMeta('scrollIntoView', false);
    if (selectionBeforeResize) {
        const restoredSelection = $0ab5832e42b8afea$var$remapResizeSelection(selectionBeforeResize, tr.doc);
        if (restoredSelection) tr.setSelection(restoredSelection);
    }
    if ((0, $ixfCV.fg)('platform_editor_layout_resize_analytics')) editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).DRAGGED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
        attributes: {
            columnCount: sectionNode.childCount,
            leftColumnIndex: leftColIndex,
            leftColumnWidth: Number(leftWidth.toFixed(2)),
            rightColumnWidth: Number(rightWidth.toFixed(2)),
            inputMethod: (0, $krYZG.INPUT_METHOD).DRAG
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    view.dispatch(tr);
};
/**
 * Calculates new column widths from the current mouse X position during drag.
 * Uses the columns-only width cached at mousedown — no layout reflow.
 *
 * The denominator is `columnsWidth` (the total flex container width minus
 * divider widgets and flex gaps) so that a 1 px mouse movement corresponds
 * to the exact same visual shift in the column boundary, eliminating the
 * few-pixel drift that occurred when using the full section width.
 */ const $0ab5832e42b8afea$var$calcDragWidths = (clientX)=>{
    if (!$0ab5832e42b8afea$var$dragState) return null;
    const { columnsWidth: columnsWidth } = $0ab5832e42b8afea$var$dragState;
    if (columnsWidth === 0) return null;
    const deltaX = clientX - $0ab5832e42b8afea$var$dragState.startX;
    const combinedWidth = $0ab5832e42b8afea$var$dragState.startLeftWidth + $0ab5832e42b8afea$var$dragState.startRightWidth;
    const deltaPercent = deltaX / columnsWidth * 100;
    let leftWidth = $0ab5832e42b8afea$var$dragState.startLeftWidth + deltaPercent;
    let rightWidth = $0ab5832e42b8afea$var$dragState.startRightWidth - deltaPercent;
    if (leftWidth < (0, $bbeac3462dd7561c$export$a9683f74b118e94b)) {
        leftWidth = (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
        rightWidth = combinedWidth - (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
    } else if (rightWidth < (0, $bbeac3462dd7561c$export$a9683f74b118e94b)) {
        rightWidth = (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
        leftWidth = combinedWidth - (0, $bbeac3462dd7561c$export$a9683f74b118e94b);
    }
    return {
        leftWidth: leftWidth,
        rightWidth: rightWidth
    };
};
const $0ab5832e42b8afea$var$onDragMouseMove = (e)=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    // If the mouse button was released outside the window (e.g. over browser chrome
    // or an iframe), we won't receive a mouseup on ownerDoc. Detect this by checking
    // whether any button is still held — if not, treat it as a drag end.
    if (e.buttons === 0) {
        $0ab5832e42b8afea$var$onDragEnd(e.clientX);
        return;
    }
    // Always capture the latest clientX so the rAF callback uses the most recent
    // mouse position. Previously, intermediate positions were dropped when an rAF
    // was already scheduled, causing the column boundary to lag behind the cursor.
    $0ab5832e42b8afea$var$dragState.lastClientX = e.clientX;
    // If a paint frame is already scheduled it will pick up lastClientX — no need
    // to schedule another one.
    if ($0ab5832e42b8afea$var$dragState.rafId !== null) return;
    $0ab5832e42b8afea$var$dragState.rafId = requestAnimationFrame(()=>{
        if (!$0ab5832e42b8afea$var$dragState) return;
        $0ab5832e42b8afea$var$dragState.rafId = null;
        const widths = $0ab5832e42b8afea$var$calcDragWidths($0ab5832e42b8afea$var$dragState.lastClientX);
        if (!widths) return;
        // Write flex-basis directly onto the column elements' inline styles for immediate
        // visual feedback. This beats PM's own inline flex-basis value without dispatching
        // any PM transaction — keeping drag completely off the ProseMirror render path.
        // The LayoutColumnView.ignoreMutation implementation ensures PM's MutationObserver
        // does not revert these style changes mid-drag.
        $0ab5832e42b8afea$var$dragState.hasDragged = true;
        $0ab5832e42b8afea$var$dragState.leftColEl.style.flexBasis = `${widths.leftWidth}%`;
        $0ab5832e42b8afea$var$dragState.rightColEl.style.flexBasis = `${widths.rightWidth}%`;
    });
};
/**
 * Shared teardown for all drag-end paths (mouseup, missed mouseup detected via
 * e.buttons===0 on mousemove, window blur, and visibilitychange). Commits the
 * final column widths if a real drag occurred.
 */ const $0ab5832e42b8afea$var$onDragEnd = (clientX)=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    const { view: view, sectionPos: sectionPos, leftColIndex: leftColIndex, leftColEl: leftColEl, rightColEl: rightColEl, hasDragged: hasDragged, rafId: rafId, startLeftWidth: startLeftWidth, startRightWidth: startRightWidth, unbindListeners: unbindListeners, editorAnalyticsAPI: editorAnalyticsAPI } = $0ab5832e42b8afea$var$dragState;
    unbindListeners();
    // Cancel any pending rAF so a stale frame doesn't write styles after teardown.
    if (rafId !== null) cancelAnimationFrame(rafId);
    const ownerDoc = view.dom.ownerDocument;
    ownerDoc.body.style.userSelect = '';
    ownerDoc.body.style.cursor = '';
    const widths = $0ab5832e42b8afea$var$calcDragWidths(clientX);
    $0ab5832e42b8afea$var$dragState = null;
    if (!hasDragged) // The user clicked without dragging — no flex-basis overrides were written,
    // so there is nothing to clean up and no transaction to dispatch.
    return;
    // Clear the drag-time flex-basis overrides. The PM transaction below will
    // write the committed widths back into the node attrs and re-render the DOM.
    leftColEl.style.flexBasis = '';
    rightColEl.style.flexBasis = '';
    if (widths && (widths.leftWidth !== startLeftWidth || widths.rightWidth !== startRightWidth)) $0ab5832e42b8afea$var$dispatchColumnWidths(view, sectionPos, leftColIndex, widths.leftWidth, widths.rightWidth, editorAnalyticsAPI);
};
const $0ab5832e42b8afea$var$onDragMouseUp = (e)=>{
    $0ab5832e42b8afea$var$onDragEnd(e.clientX);
};
/**
 * Called when the window loses focus (blur) or the tab becomes hidden
 * (visibilitychange). In either case the user can't be dragging anymore,
 * so we commit the drag at the last known mouse position.
 */ const $0ab5832e42b8afea$var$onDragCancel = ()=>{
    if (!$0ab5832e42b8afea$var$dragState) return;
    // Commit at the last captured mouse position rather than startX, so the
    // columns stay where the user last saw them.
    $0ab5832e42b8afea$var$onDragEnd($0ab5832e42b8afea$var$dragState.lastClientX);
};
/**
 * Creates a column divider widget DOM element with drag-to-resize interaction for
 * the adjacent layout columns. During drag, flex-basis is mutated directly on the
 * column DOM elements for zero-overhead visual feedback (no PM transactions).
 * A single undoable PM transaction is dispatched on mouseup to commit the final widths.
 */ const $0ab5832e42b8afea$var$createColumnDividerWidget = (view, sectionPos, columnIndex, editorAnalyticsAPI)=>{
    const ownerDoc = view.dom.ownerDocument;
    // Outer container: wide transparent hit area for easy grabbing, zero flex footprint
    const divider = ownerDoc.createElement('div');
    divider.classList.add($0ab5832e42b8afea$var$layoutColumnDividerClassName);
    divider.contentEditable = 'false';
    // Rail: styled via layoutColumnDividerStyles in layout.ts
    const rail = ownerDoc.createElement('div');
    rail.classList.add($0ab5832e42b8afea$var$layoutColumnDividerRailClassName);
    divider.appendChild(rail);
    // Thumb: styled via layoutColumnDividerStyles in layout.ts
    const thumb = ownerDoc.createElement('div');
    thumb.classList.add($0ab5832e42b8afea$var$layoutColumnDividerThumbClassName);
    rail.appendChild(thumb);
    const leftColIndex = columnIndex - 1;
    (0, $cbY7C.bind)(divider, {
        type: 'mousedown',
        listener: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const sectionNode = view.state.doc.nodeAt(sectionPos);
            if (!sectionNode) return;
            // Get the initial widths of the two adjacent columns
            let leftCol = null;
            let rightCol = null;
            sectionNode.forEach((child, _offset, index)=>{
                if (index === leftColIndex) leftCol = child;
                if (index === leftColIndex + 1) rightCol = child;
            });
            if (!leftCol || !rightCol) return;
            const sectionElement = divider.closest('[data-layout-section]');
            if (!(sectionElement instanceof HTMLElement)) return;
            // Capture the two adjacent column DOM elements upfront so mousemove can
            // mutate their flex-basis directly without any PM transaction overhead.
            // Query by data-layout-column-index (stamped by LayoutColumnView) rather than
            // relying on positional order of [data-layout-column] elements, which would
            // break if the DOM structure or ordering ever changes.
            const leftColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex}"]`);
            const rightColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex + 1}"]`);
            if (!leftColEl || !rightColEl) return;
            const unbindMove = (0, $cbY7C.bind)(ownerDoc, {
                type: 'mousemove',
                listener: $0ab5832e42b8afea$var$onDragMouseMove
            });
            const unbindUp = (0, $cbY7C.bind)(ownerDoc, {
                type: 'mouseup',
                listener: $0ab5832e42b8afea$var$onDragMouseUp
            });
            // If the user releases the mouse outside the browser window (e.g. over the
            // OS desktop) and then brings the cursor back, we won't get a mouseup on
            // ownerDoc. Listening on window for blur and on the document for
            // visibilitychange catches tab switches and window focus loss respectively.
            const unbindBlur = (0, $cbY7C.bind)(ownerDoc.defaultView ?? window, {
                type: 'blur',
                listener: $0ab5832e42b8afea$var$onDragCancel
            });
            const unbindVisibility = (0, $cbY7C.bind)(ownerDoc, {
                type: 'visibilitychange',
                listener: $0ab5832e42b8afea$var$onDragCancel
            });
            // Compute the width available to columns only (excluding divider widgets and
            // flex gaps). Using this as the denominator ensures that a 1 px mouse delta
            // translates to the exact pixel shift on the column boundary.
            const sectionRect = sectionElement.getBoundingClientRect();
            const dividers = sectionElement.querySelectorAll(`.${$0ab5832e42b8afea$var$layoutColumnDividerClassName}`);
            let dividersWidth = 0;
            dividers.forEach((d)=>{
                dividersWidth += d.getBoundingClientRect().width;
            });
            // Account for CSS gap between flex children. The gap is applied between
            // every pair of direct children (columns + divider widgets).
            const computedGap = parseFloat(getComputedStyle(sectionElement).gap || '0');
            const childCount = sectionElement.children.length;
            const totalGap = childCount > 1 ? computedGap * (childCount - 1) : 0;
            const columnsWidth = sectionRect.width - dividersWidth - totalGap;
            $0ab5832e42b8afea$var$dragState = {
                editorAnalyticsAPI: editorAnalyticsAPI,
                hasDragged: false,
                lastClientX: e.clientX,
                rafId: null,
                view: view,
                sectionPos: sectionPos,
                leftColIndex: leftColIndex,
                leftColEl: leftColEl,
                rightColEl: rightColEl,
                startX: e.clientX,
                startLeftWidth: leftCol.attrs.width,
                startRightWidth: rightCol.attrs.width,
                columnsWidth: columnsWidth,
                sectionElement: sectionElement,
                unbindListeners: ()=>{
                    unbindMove();
                    unbindUp();
                    unbindBlur();
                    unbindVisibility();
                }
            };
            ownerDoc.body.style.userSelect = 'none';
            ownerDoc.body.style.cursor = 'col-resize';
        }
    });
    return divider;
};
const $0ab5832e42b8afea$export$b54a43c7f9b448fd = (state, view, editorAnalyticsAPI)=>{
    const decorations = [];
    if (!view) return decorations;
    const { layoutSection: layoutSection } = state.schema.nodes;
    state.doc.descendants((node, pos)=>{
        if (node.type === layoutSection) {
            // Walk through layout column children and add dividers between them
            node.forEach((child, offset, index)=>{
                // Add a divider widget BEFORE every column except the first
                if (index > 0) {
                    const sectionPos = pos;
                    const colIndex = index;
                    const widgetPos = pos + offset + 1; // position at the start of this column
                    decorations.push((0, $8nvEM.Decoration).widget(widgetPos, ()=>$0ab5832e42b8afea$var$createColumnDividerWidget(view, sectionPos, colIndex, editorAnalyticsAPI), {
                        side: -1,
                        // place before the position
                        key: `layout-col-divider-${pos}-${index}`,
                        ignoreSelection: true
                    }));
                }
            });
            return false; // don't descend into children
        }
        return true; // continue descending
    });
    return decorations;
};





var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");






















var $3k5Tv = parcelRequire("3k5Tv");


var $Igylv = parcelRequire("Igylv");

var $g9sVl = parcelRequire("g9sVl");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $7Y8M5 = parcelRequire("7Y8M5");














var $cBSrP = parcelRequire("cBSrP");


var $8dxef = parcelRequire("8dxef");


var $aWssQ = parcelRequire("aWssQ");


var $aiyg1 = parcelRequire("aiyg1");
















const $b84766e5f44e23e9$export$6cdb476c834bc60 = 8;
const $b84766e5f44e23e9$var$GUIDELINE_KEYS = {
    lineLength: 'grid',
    wide: 'wide',
    fullWidth: 'full_width'
};
const $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS = {
    lineLength: 'center',
    wide: 'wide',
    fullWidth: 'full-width'
};
const $b84766e5f44e23e9$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $b84766e5f44e23e9$export$54a1e15ba45852e2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreakoutGuidelines(getEditorWidth, isResizing, t0) {
    const $ = (0, $bDgLe.c)(38);
    const dynamicFullWidthGuidelineOffset = t0 === undefined ? 0 : t0;
    let t1;
    if ($[0] !== getEditorWidth) {
        t1 = getEditorWidth();
        $[0] = getEditorWidth;
        $[1] = t1;
    } else t1 = $[1];
    const widthState = t1;
    let t2;
    bb0: {
        if (!isResizing) {
            let t3;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t3 = {};
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        let t3;
        if ($[3] !== widthState) {
            t3 = widthState || {};
            $[3] = widthState;
            $[4] = t3;
        } else t3 = $[4];
        const { width: width, lineLength: lineLength } = t3;
        let t4;
        if ($[5] !== lineLength) {
            t4 = lineLength ? Math.round(lineLength * (0, $7Y8M5.breakoutWideScaleRatio)) : undefined;
            $[5] = lineLength;
            $[6] = t4;
        } else t4 = $[6];
        const wideCalWithRatio = t4;
        let t5;
        if ($[7] !== wideCalWithRatio) {
            t5 = (0, $fqVYq.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
            $[7] = wideCalWithRatio;
            $[8] = t5;
        } else t5 = $[8];
        const wide = t5;
        let t6;
        if ($[9] !== width) {
            t6 = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                exposure: true
            }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
            $[9] = width;
            $[10] = t6;
        } else t6 = $[10];
        const padding = t6;
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : undefined;
        let t7;
        if ($[11] !== lineLength) {
            t7 = (0, $fqVYq.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength;
            $[11] = lineLength;
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== fullWidth || $[14] !== t7 || $[15] !== wide) {
            t8 = {
                wide: wide,
                fullWidth: fullWidth,
                lineLength: t7
            };
            $[13] = fullWidth;
            $[14] = t7;
            $[15] = wide;
            $[16] = t8;
        } else t8 = $[16];
        t2 = t8;
    }
    const { lineLength: lineLength_0, wide: wide_0, fullWidth: fullWidth_0 } = t2;
    let t3;
    bb1: {
        if (!fullWidth_0 || !wide_0 || !lineLength_0 || fullWidth_0 <= ((0, $fqVYq.editorExperiment)("single_column_layouts", true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength_0)) {
            t3 = null;
            break bb1;
        }
        if (fullWidth_0 - wide_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) {
            let t4;
            if ($[17] !== fullWidth_0 || $[18] !== lineLength_0 || $[19] !== wide_0) {
                t4 = {
                    lineLength: lineLength_0,
                    wide: wide_0,
                    fullWidth: fullWidth_0
                };
                $[17] = fullWidth_0;
                $[18] = lineLength_0;
                $[19] = wide_0;
                $[20] = t4;
            } else t4 = $[20];
            t3 = t4;
            break bb1;
        }
        if (fullWidth_0 <= wide_0 && fullWidth_0 - lineLength_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) {
            let t4;
            if ($[21] !== fullWidth_0 || $[22] !== lineLength_0) {
                t4 = {
                    lineLength: lineLength_0,
                    fullWidth: fullWidth_0
                };
                $[21] = fullWidth_0;
                $[22] = lineLength_0;
                $[23] = t4;
            } else t4 = $[23];
            t3 = t4;
            break bb1;
        }
        t3 = null;
    }
    const defaultSnappingWidths = t3;
    let t4;
    bb2: {
        if (!isResizing || !defaultSnappingWidths) {
            t4 = null;
            break bb2;
        }
        let t5;
        if ($[24] !== defaultSnappingWidths) {
            t5 = {
                x: Object.values(defaultSnappingWidths)
            };
            $[24] = defaultSnappingWidths;
            $[25] = t5;
        } else t5 = $[25];
        t4 = t5;
    }
    const snaps = t4;
    const [currentLayout, setCurrentLayout] = (0, $cozmU.useState)(null);
    let t5;
    if ($[26] !== currentLayout || $[27] !== defaultSnappingWidths) {
        bb3: {
            const guidelines = [];
            if (!defaultSnappingWidths) {
                t5 = guidelines;
                break bb3;
            }
            Object.entries(defaultSnappingWidths).map((t6)=>{
                const [key, value] = t6;
                if (value) {
                    guidelines.push({
                        key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_left`,
                        position: {
                            x: -$b84766e5f44e23e9$var$roundToNearest(value / 2)
                        },
                        active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                    });
                    guidelines.push({
                        key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_right`,
                        position: {
                            x: $b84766e5f44e23e9$var$roundToNearest(value / 2)
                        },
                        active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                    });
                }
            });
            t5 = guidelines;
        }
        $[26] = currentLayout;
        $[27] = defaultSnappingWidths;
        $[28] = t5;
    } else t5 = $[28];
    const guidelines_0 = t5;
    let t6;
    if ($[29] !== fullWidth_0 || $[30] !== lineLength_0 || $[31] !== wide_0) {
        t6 = (newWidth)=>{
            if (typeof newWidth !== "number") {
                setCurrentLayout(null);
                return;
            }
            if (lineLength_0 && Math.abs(newWidth - lineLength_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout("center");
            else {
                if (wide_0 && Math.abs(newWidth - wide_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout("wide");
                else if (fullWidth_0 && (fullWidth_0 + (0, $7Y8M5.akEditorGutterPadding) - newWidth < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth_0)) setCurrentLayout("full-width");
                else setCurrentLayout(null);
            }
        };
        $[29] = fullWidth_0;
        $[30] = lineLength_0;
        $[31] = wide_0;
        $[32] = t6;
    } else t6 = $[32];
    const setCurrentWidth = t6;
    let t7;
    if ($[33] !== currentLayout || $[34] !== guidelines_0 || $[35] !== setCurrentWidth || $[36] !== snaps) {
        t7 = {
            snaps: snaps,
            currentLayout: currentLayout,
            guidelines: guidelines_0,
            setCurrentWidth: setCurrentWidth
        };
        $[33] = currentLayout;
        $[34] = guidelines_0;
        $[35] = setCurrentWidth;
        $[36] = snaps;
        $[37] = t7;
    } else t7 = $[37];
    return t7;
} : function useBreakoutGuidelines(getEditorWidth, isResizing, dynamicFullWidthGuidelineOffset = 0) {
    const widthState = getEditorWidth();
    const { lineLength: lineLength_0, wide: wide_0, fullWidth: fullWidth_0 } = (0, $cozmU.useMemo)(()=>{
        if (!isResizing) return {};
        const { width: width, lineLength: lineLength } = widthState || {};
        const wideCalWithRatio = lineLength ? Math.round(lineLength * (0, $7Y8M5.breakoutWideScaleRatio)) : undefined;
        // When page is full width, lineLength from widthState can be much wider than 760.
        // But the lineLength variable here is being used like a const 760.
        // when the page is full width, the calculation of wide is wrong.
        // Actuall the wide is the wide breakout point, which is
        const wide = (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
        const padding = width && width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : undefined;
        return {
            wide: wide,
            fullWidth: fullWidth,
            // When page is full width, lineLength from widthState can be much wider than 760.
            // But the lineLength variable here is being used like a const 760.
            lineLength: (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength
        };
    }, [
        widthState,
        isResizing,
        dynamicFullWidthGuidelineOffset
    ]);
    // calculate snapping width
    const defaultSnappingWidths = (0, $cozmU.useMemo)(()=>{
        if (!fullWidth_0 || !wide_0 || !lineLength_0 || fullWidth_0 <= ((0, $fqVYq.editorExperiment)('single_column_layouts', true) ? (0, $7Y8M5.akEditorDefaultLayoutWidth) : lineLength_0)) return null;
        if (fullWidth_0 - wide_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) return {
            lineLength: lineLength_0,
            wide: wide_0,
            fullWidth: fullWidth_0
        };
        if (fullWidth_0 <= wide_0 && fullWidth_0 - lineLength_0 > $b84766e5f44e23e9$export$6cdb476c834bc60) return {
            lineLength: lineLength_0,
            fullWidth: fullWidth_0
        };
        return null;
    }, [
        fullWidth_0,
        lineLength_0,
        wide_0
    ]);
    const snaps = (0, $cozmU.useMemo)(()=>{
        if (!isResizing || !defaultSnappingWidths) return null;
        return {
            x: Object.values(defaultSnappingWidths)
        };
    }, [
        defaultSnappingWidths,
        isResizing
    ]);
    // calculate guidelines, and calculate which lines are active
    const [currentLayout, setCurrentLayout] = (0, $cozmU.useState)(null);
    const guidelines_0 = (0, $cozmU.useMemo)(()=>{
        const guidelines = [];
        if (!defaultSnappingWidths) return guidelines;
        Object.entries(defaultSnappingWidths).map(([key, value])=>{
            if (value) {
                guidelines.push({
                    key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_left`,
                    position: {
                        x: -$b84766e5f44e23e9$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                });
                guidelines.push({
                    key: `${$b84766e5f44e23e9$var$GUIDELINE_KEYS[key]}_right`,
                    position: {
                        x: $b84766e5f44e23e9$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $b84766e5f44e23e9$var$CURRENT_LAYOUT_KEYS[key]
                });
            }
        });
        return guidelines;
    }, [
        defaultSnappingWidths,
        currentLayout
    ]);
    const setCurrentWidth = (0, $cozmU.useCallback)((newWidth)=>{
        if (typeof newWidth !== 'number') {
            setCurrentLayout(null);
            return;
        }
        if (lineLength_0 && Math.abs(newWidth - lineLength_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout('center');
        else if (wide_0 && Math.abs(newWidth - wide_0) < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2) setCurrentLayout('wide');
        else if (fullWidth_0 && // we only allow snap from one side, so we don't use Math.abs here
        (fullWidth_0 + (0, $7Y8M5.akEditorGutterPadding) - newWidth < $b84766e5f44e23e9$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth_0)) setCurrentLayout('full-width');
        else setCurrentLayout(null);
    }, [
        lineLength_0,
        wide_0,
        fullWidth_0
    ]);
    return {
        snaps: snaps,
        currentLayout: currentLayout,
        guidelines: guidelines_0,
        setCurrentWidth: setCurrentWidth
    };
};


const $e61d807cbad078b7$var$breakoutSupportedNodes = [
    'layoutSection',
    'expand',
    'codeBlock'
];
const $e61d807cbad078b7$var$getHandleStyle = (node, hidden)=>{
    const layoutMarginOffset = 12;
    if (hidden) return {
        left: {
            display: 'none'
        },
        right: {
            display: 'none'
        }
    };
    switch(node){
        case 'codeBlock':
            return {
                left: {
                    left: '-12px'
                },
                right: {
                    right: '-12px'
                }
            };
        // expand and layout section elements have a negative margin applied
        default:
            const handleOffset = (0, $ixfCV.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $cBSrP.LAYOUT_SECTION_MARGIN) * 2 + layoutMarginOffset : (0, $cBSrP.LAYOUT_COLUMN_PADDING) * 2;
            return {
                left: {
                    left: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                },
                right: {
                    right: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                }
            };
    }
};
const $e61d807cbad078b7$export$256eed97177e990e = (mutation)=>{
    if (mutation.target instanceof Element) return mutation.target.classList.contains('resizer-item') || mutation.type === 'attributes' && mutation.attributeName === 'style';
    return mutation.type === 'attributes' && mutation.attributeName === 'style';
};
const $e61d807cbad078b7$var$resizingStyles = {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'grid'
};
// Apply grid to stop drag handles rendering inside .resizer-item affecting its height
const $e61d807cbad078b7$var$defaultStyles = {
    display: 'grid'
};
const $e61d807cbad078b7$var$RESIZE_STEP_VALUE = 10;
const $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES = {
    left: true,
    right: true
};
/**
 * BreakoutResizer is a common component used to resize nodes that support the 'Breakout' mark, so it requires
 * correct ADF support.
 *
 * use experiment platform_editor_advanced_layouts
 * @param root0
 * @param root0.editorView
 * @param root0.nodeType
 * @param root0.getPos
 * @param root0.getRef
 * @param root0.disabled
 * @param root0.getEditorWidth
 * @param root0.parentRef
 * @param root0.displayGuidelines
 * @param root0.editorAnalyticsApi
 * @param root0.displayGapCursor
 * @param root0.onResizeStart
 * @param root0.dynamicFullWidthGuidelineOffset
 * @param root0.hidden Hide the resizer handles without outright unrendering them
 * @returns BreakoutResizer component
 * @example
 */ const $e61d807cbad078b7$export$d6c278682f48fbc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: t1 } = t0;
    const hidden = t1 === undefined ? false : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            minWidth: undefined,
            maxWidth: undefined,
            isResizing: false
        };
        $[0] = t2;
    } else t2 = $[0];
    const [t3, setResizingState] = (0, $cozmU.useState)(t2);
    const { minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing } = t3;
    const areResizeMetaKeysPressed = (0, $cozmU.useRef)(false);
    const resizerRef = (0, $cozmU.useRef)(null);
    let t4;
    if ($[1] !== isResizing) {
        t4 = isResizing && (0, $fqVYq.editorExperiment)("single_column_layouts", true);
        $[1] = isResizing;
        $[2] = t4;
    } else t4 = $[2];
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $b84766e5f44e23e9$export$54a1e15ba45852e2)(getEditorWidth, t4, dynamicFullWidthGuidelineOffset);
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $8dxef.getBrowserInfo)();
        $[3] = t5;
    } else t5 = $[3];
    const browser = t5;
    let t6;
    let t7;
    if ($[4] !== displayGuidelines || $[5] !== guidelines) {
        t6 = ()=>{
            if (displayGuidelines) displayGuidelines(guidelines || []);
        };
        t7 = [
            displayGuidelines,
            guidelines
        ];
        $[4] = displayGuidelines;
        $[5] = guidelines;
        $[6] = t6;
        $[7] = t7;
    } else {
        t6 = $[6];
        t7 = $[7];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[8] !== editorView.state.doc || $[9] !== editorView.state.selection || $[10] !== getPos) {
        bb0: {
            const pos = getPos();
            if (pos === undefined) {
                t8 = false;
                break bb0;
            }
            const node = editorView.state.doc.nodeAt(pos);
            if (node === null) {
                t8 = false;
                break bb0;
            }
            const endPos = pos + node.nodeSize;
            const startPos = pos;
            const { $from: $from, $to: $to } = editorView.state.selection;
            t8 = $from.pos >= startPos && endPos >= $to.pos;
        }
        $[8] = editorView.state.doc;
        $[9] = editorView.state.selection;
        $[10] = getPos;
        $[11] = t8;
    } else t8 = $[11];
    const isSelectionInNode = t8;
    let t9;
    if ($[12] !== displayGapCursor || $[13] !== editorView || $[14] !== getEditorWidth || $[15] !== onResizeStart) {
        t9 = ()=>{
            onResizeStart?.();
            let newMinWidth;
            let newMaxWidth;
            const widthState = getEditorWidth();
            const { dispatch: dispatch, state: state } = editorView;
            displayGapCursor(false);
            if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
                const padding = widthState.width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)("platform_editor_preview_panel_responsiveness", true, {
                    exposure: true
                }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
                newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $7Y8M5.akEditorGutterPadding), (0, $7Y8M5.akEditorFullWidthLayoutWidth));
                newMinWidth = Math.min(widthState.lineLength, (0, $7Y8M5.akEditorDefaultLayoutWidth), newMaxWidth);
            }
            setResizingState({
                isResizing: true,
                minWidth: newMinWidth,
                maxWidth: newMaxWidth
            });
            dispatch(state.tr.setMeta("is-resizer-resizing", true));
        };
        $[12] = displayGapCursor;
        $[13] = editorView;
        $[14] = getEditorWidth;
        $[15] = onResizeStart;
        $[16] = t9;
    } else t9 = $[16];
    const handleResizeStart = t9;
    let t10;
    if ($[17] !== setCurrentWidth) {
        t10 = (originalState, delta)=>{
            if ((0, $fqVYq.editorExperiment)("single_column_layouts", true)) {
                const newWidth = originalState.width + delta.width;
                setCurrentWidth(newWidth);
            }
        };
        $[17] = setCurrentWidth;
        $[18] = t10;
    } else t10 = $[18];
    const handleResize = t10;
    let t11;
    if ($[19] !== currentLayout || $[20] !== displayGapCursor || $[21] !== editorAnalyticsApi || $[22] !== editorView || $[23] !== getPos || $[24] !== setCurrentWidth) {
        t11 = (originalState_0, delta_0)=>{
            const newWidth_0 = originalState_0.width + delta_0.width;
            const pos_0 = getPos();
            if (pos_0 === undefined) return;
            const { state: state_0, dispatch: dispatch_0 } = editorView;
            const { breakout: breakout } = state_0.schema.marks;
            const node_0 = state_0.doc.nodeAt(pos_0);
            const newTr = state_0.tr;
            if (node_0 && $e61d807cbad078b7$var$breakoutSupportedNodes.includes(node_0.type.name)) {
                if (currentLayout && [
                    "wide",
                    "full-width"
                ].includes(currentLayout) && (0, $fqVYq.editorExperiment)("single_column_layouts", true)) newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                    breakout.create({
                        mode: currentLayout,
                        width: null
                    })
                ]);
                else {
                    const newBreakoutWidth = Math.max(newWidth_0, (0, $7Y8M5.akEditorDefaultLayoutWidth));
                    newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                        breakout.create({
                            width: newBreakoutWidth
                        })
                    ]);
                    const breakoutResizePayload = {
                        action: (0, $krYZG.ACTION).RESIZED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            nodeType: node_0.type.name,
                            prevWidth: originalState_0.width,
                            newWidth: newBreakoutWidth
                        }
                    };
                    editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
                }
            }
            newTr.setMeta("is-resizer-resizing", false).setMeta("scrollIntoView", false);
            displayGapCursor(true);
            dispatch_0(newTr);
            setResizingState({
                isResizing: false,
                minWidth: undefined,
                maxWidth: undefined
            });
            setCurrentWidth(null);
        };
        $[19] = currentLayout;
        $[20] = displayGapCursor;
        $[21] = editorAnalyticsApi;
        $[22] = editorView;
        $[23] = getPos;
        $[24] = setCurrentWidth;
        $[25] = t11;
    } else t11 = $[25];
    const handleResizeStop = t11;
    let t12;
    if ($[26] !== editorView) {
        t12 = ()=>{
            editorView?.focus();
        };
        $[26] = editorView;
        $[27] = t12;
    } else t12 = $[27];
    const handleEscape = t12;
    let t13;
    if ($[28] !== handleResizeStop || $[29] !== maxWidth || $[30] !== minWidth || $[31] !== parentRef) {
        t13 = (step)=>{
            if (!parentRef) return;
            const resizerItem = parentRef.closest(".resizer-item");
            if (!(resizerItem instanceof HTMLElement)) return;
            const newWidth_1 = resizerItem.offsetWidth + step;
            if (maxWidth && newWidth_1 > maxWidth || minWidth && newWidth_1 < minWidth) return;
            handleResizeStop({
                width: resizerItem.offsetWidth,
                x: 0,
                y: 0,
                height: 0
            }, {
                width: step,
                height: 0
            });
        };
        $[28] = handleResizeStop;
        $[29] = maxWidth;
        $[30] = minWidth;
        $[31] = parentRef;
        $[32] = t13;
    } else t13 = $[32];
    const handleLayoutSizeChangeOnKeypress = t13;
    let t14;
    if ($[33] !== handleEscape || $[34] !== handleLayoutSizeChangeOnKeypress) {
        t14 = (event)=>{
            const isBracketKey = event.code === "BracketRight" || event.code === "BracketLeft";
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
            if (event.altKey && metaKey) {
                if (isBracketKey) {
                    event.preventDefault();
                    handleLayoutSizeChangeOnKeypress(event.code === "BracketRight" ? $e61d807cbad078b7$var$RESIZE_STEP_VALUE : -$e61d807cbad078b7$var$RESIZE_STEP_VALUE);
                }
            } else if (!areResizeMetaKeysPressed.current) handleEscape();
        };
        $[33] = handleEscape;
        $[34] = handleLayoutSizeChangeOnKeypress;
        $[35] = t14;
    } else t14 = $[35];
    const resizeHandleKeyDownHandler = t14;
    let t15;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (event_0)=>{
            if (event_0.altKey || event_0.metaKey) areResizeMetaKeysPressed.current = false;
        };
        $[36] = t15;
    } else t15 = $[36];
    const resizeHandleKeyUpHandler = t15;
    let t16;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (event_1)=>{
            if (!resizerRef.current) return;
            const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
            const metaKey_0 = browser.mac ? event_1.metaKey : event_1.ctrlKey;
            const isTargetResizeHandle = event_1.target instanceof HTMLElement && event_1.target.classList.contains("resizer-handle-thumb");
            if (event_1.altKey && event_1.shiftKey && metaKey_0 && event_1.code === "KeyR" || isTargetResizeHandle && (event_1.altKey || metaKey_0 || event_1.shiftKey)) {
                event_1.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        };
        $[37] = t16;
    } else t16 = $[37];
    const resizerGlobalKeyDownHandler = t16;
    let t17;
    let t18;
    if ($[38] !== editorView || $[39] !== resizeHandleKeyDownHandler) {
        t17 = ()=>{
            if (!resizerRef.current || !editorView) return;
            const resizeHandleThumbEl_0 = resizerRef.current.getResizerThumbEl();
            if (!resizeHandleThumbEl_0) return;
            const editorViewDom = editorView.dom;
            const unbindEditorViewDom = (0, $cbY7C.bind)(editorViewDom, {
                type: "keydown",
                listener: resizerGlobalKeyDownHandler
            });
            const unbindResizeHandle = (0, $cbY7C.bindAll)(resizeHandleThumbEl_0, [
                {
                    type: "keydown",
                    listener: resizeHandleKeyDownHandler
                },
                {
                    type: "keyup",
                    listener: resizeHandleKeyUpHandler
                }
            ]);
            return ()=>{
                unbindEditorViewDom();
                unbindResizeHandle();
            };
        };
        t18 = [
            editorView,
            resizerGlobalKeyDownHandler,
            resizeHandleKeyDownHandler,
            resizeHandleKeyUpHandler
        ];
        $[38] = editorView;
        $[39] = resizeHandleKeyDownHandler;
        $[40] = t17;
        $[41] = t18;
    } else {
        t17 = $[40];
        t18 = $[41];
    }
    (0, $cozmU.useLayoutEffect)(t17, t18);
    if (disabled) {
        let t19;
        if ($[42] !== getRef) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "breakout-resizer-editor-view-wrapper",
                ref: (ref)=>getRef && getRef(ref)
            });
            $[42] = getRef;
            $[43] = t19;
        } else t19 = $[43];
        return t19;
    }
    let t19;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES : {
            left: true,
            right: true
        };
        $[44] = t19;
    } else t19 = $[44];
    const t20 = snaps || undefined;
    let t21;
    if ($[45] !== hidden || $[46] !== nodeType) {
        t21 = $e61d807cbad078b7$var$getHandleStyle(nodeType, hidden);
        $[45] = hidden;
        $[46] = nodeType;
        $[47] = t21;
    } else t21 = $[47];
    const t22 = isResizing ? $e61d807cbad078b7$var$resizingStyles : $e61d807cbad078b7$var$defaultStyles;
    let t23;
    if ($[48] !== currentLayout) {
        t23 = currentLayout && (0, $fqVYq.editorExperiment)("single_column_layouts", true) && [
            "full-width",
            "wide"
        ].includes(currentLayout || "") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: currentLayout
        });
        $[48] = currentLayout;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== getRef || $[51] !== handleResize || $[52] !== handleResizeStart || $[53] !== handleResizeStop || $[54] !== isSelectionInNode || $[55] !== maxWidth || $[56] !== minWidth || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aWssQ.default), {
            ref: resizerRef,
            enable: t19,
            snap: t20,
            snapGap: (0, $b84766e5f44e23e9$export$6cdb476c834bc60),
            handleStyles: t21,
            minWidth: minWidth,
            maxWidth: maxWidth,
            style: t22,
            handleResizeStart: handleResizeStart,
            handleResizeStop: handleResizeStop,
            handleResize: handleResize,
            childrenDOMRef: getRef,
            resizeRatio: 2,
            isHandleVisible: isSelectionInNode,
            handleSize: "clamped",
            handleHighlight: "full-height",
            handlePositioning: "adjacent",
            handleAlignmentMethod: "sticky",
            labelComponent: t23
        });
        $[50] = getRef;
        $[51] = handleResize;
        $[52] = handleResizeStart;
        $[53] = handleResizeStop;
        $[54] = isSelectionInNode;
        $[55] = maxWidth;
        $[56] = minWidth;
        $[57] = t20;
        $[58] = t21;
        $[59] = t22;
        $[60] = t23;
        $[61] = t24;
    } else t24 = $[61];
    return t24;
} : ({ editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: hidden = false })=>{
    const [{ minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing }, setResizingState] = (0, $cozmU.useState)({
        minWidth: undefined,
        maxWidth: undefined,
        isResizing: false
    });
    const areResizeMetaKeysPressed = (0, $cozmU.useRef)(false);
    const resizerRef = (0, $cozmU.useRef)(null);
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $b84766e5f44e23e9$export$54a1e15ba45852e2)(getEditorWidth, isResizing && (0, $fqVYq.editorExperiment)('single_column_layouts', true), dynamicFullWidthGuidelineOffset);
    const browser = (0, $8dxef.getBrowserInfo)();
    (0, $cozmU.useEffect)(()=>{
        if (displayGuidelines) displayGuidelines(guidelines || []);
    }, [
        displayGuidelines,
        guidelines
    ]);
    // Relying on re-renders caused by selection changes inside/around node
    const isSelectionInNode = (0, $cozmU.useMemo)(()=>{
        const pos = getPos();
        if (pos === undefined) return false;
        const node = editorView.state.doc.nodeAt(pos);
        if (node === null) return false;
        const endPos = pos + node.nodeSize;
        const startPos = pos;
        const { $from: $from, $to: $to } = editorView.state.selection;
        return $from.pos >= startPos && endPos >= $to.pos;
    }, [
        editorView.state.doc,
        editorView.state.selection,
        getPos
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        onResizeStart?.();
        let newMinWidth;
        let newMaxWidth;
        const widthState = getEditorWidth();
        const { dispatch: dispatch, state: state } = editorView;
        displayGapCursor(false);
        if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
            const padding = widthState.width <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
            newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $7Y8M5.akEditorGutterPadding), (0, $7Y8M5.akEditorFullWidthLayoutWidth));
            newMinWidth = Math.min(widthState.lineLength, (0, $7Y8M5.akEditorDefaultLayoutWidth), newMaxWidth);
        }
        setResizingState({
            isResizing: true,
            minWidth: newMinWidth,
            maxWidth: newMaxWidth
        });
        dispatch(state.tr.setMeta('is-resizer-resizing', true));
    }, [
        onResizeStart,
        getEditorWidth,
        editorView,
        displayGapCursor
    ]);
    const handleResize = (0, $cozmU.useCallback)((originalState, delta)=>{
        if ((0, $fqVYq.editorExperiment)('single_column_layouts', true)) {
            const newWidth = originalState.width + delta.width;
            setCurrentWidth(newWidth);
        }
    }, [
        setCurrentWidth
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((originalState_0, delta_0)=>{
        const newWidth_0 = originalState_0.width + delta_0.width;
        const pos_0 = getPos();
        if (pos_0 === undefined) return;
        const { state: state_0, dispatch: dispatch_0 } = editorView;
        const { breakout: breakout } = state_0.schema.marks;
        const node_0 = state_0.doc.nodeAt(pos_0);
        const newTr = state_0.tr;
        if (node_0 && $e61d807cbad078b7$var$breakoutSupportedNodes.includes(node_0.type.name)) {
            if (currentLayout && [
                'wide',
                'full-width'
            ].includes(currentLayout) && (0, $fqVYq.editorExperiment)('single_column_layouts', true)) newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                breakout.create({
                    mode: currentLayout,
                    width: null
                })
            ]);
            else {
                const newBreakoutWidth = Math.max(newWidth_0, (0, $7Y8M5.akEditorDefaultLayoutWidth));
                newTr.setNodeMarkup(pos_0, node_0.type, node_0.attrs, [
                    breakout.create({
                        width: newBreakoutWidth
                    })
                ]);
                const breakoutResizePayload = {
                    action: (0, $krYZG.ACTION).RESIZED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: node_0.type.name,
                        prevWidth: originalState_0.width,
                        newWidth: newBreakoutWidth
                    }
                };
                editorAnalyticsApi?.attachAnalyticsEvent(breakoutResizePayload)(newTr);
            }
        }
        newTr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
        displayGapCursor(true);
        dispatch_0(newTr);
        setResizingState({
            isResizing: false,
            minWidth: undefined,
            maxWidth: undefined
        });
        setCurrentWidth(null);
    }, [
        getPos,
        editorView,
        displayGapCursor,
        setCurrentWidth,
        currentLayout,
        editorAnalyticsApi
    ]);
    const handleEscape = (0, $cozmU.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleLayoutSizeChangeOnKeypress = (0, $cozmU.useCallback)((step)=>{
        if (!parentRef) return;
        const resizerItem = parentRef.closest('.resizer-item');
        if (!(resizerItem instanceof HTMLElement)) return;
        const newWidth_1 = resizerItem.offsetWidth + step;
        if (maxWidth && newWidth_1 > maxWidth || minWidth && newWidth_1 < minWidth) return;
        handleResizeStop({
            width: resizerItem.offsetWidth,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        handleResizeStop,
        maxWidth,
        minWidth,
        parentRef
    ]);
    const resizeHandleKeyDownHandler = (0, $cozmU.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleLayoutSizeChangeOnKeypress(event.code === 'BracketRight' ? $e61d807cbad078b7$var$RESIZE_STEP_VALUE : -$e61d807cbad078b7$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleLayoutSizeChangeOnKeypress,
        browser
    ]);
    const resizeHandleKeyUpHandler = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.altKey || event_0.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    const resizerGlobalKeyDownHandler = (0, $cozmU.useCallback)((event_1)=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const metaKey_0 = browser.mac ? event_1.metaKey : event_1.ctrlKey;
        const isTargetResizeHandle = event_1.target instanceof HTMLElement && event_1.target.classList.contains('resizer-handle-thumb');
        if (event_1.altKey && event_1.shiftKey && metaKey_0 && event_1.code === 'KeyR' || isTargetResizeHandle && (event_1.altKey || metaKey_0 || event_1.shiftKey)) {
            event_1.preventDefault();
            if (!resizeHandleThumbEl) return;
            resizeHandleThumbEl.focus();
            resizeHandleThumbEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, [
        resizerRef,
        browser
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resizerRef.current || !editorView) return;
        const resizeHandleThumbEl_0 = resizerRef.current.getResizerThumbEl();
        if (!resizeHandleThumbEl_0) return;
        const editorViewDom = editorView.dom;
        const unbindEditorViewDom = (0, $cbY7C.bind)(editorViewDom, {
            type: 'keydown',
            listener: resizerGlobalKeyDownHandler
        });
        const unbindResizeHandle = (0, $cbY7C.bindAll)(resizeHandleThumbEl_0, [
            {
                type: 'keydown',
                listener: resizeHandleKeyDownHandler
            },
            {
                type: 'keyup',
                listener: resizeHandleKeyUpHandler
            }
        ]);
        return ()=>{
            unbindEditorViewDom();
            unbindResizeHandle();
        };
    }, [
        editorView,
        resizerGlobalKeyDownHandler,
        resizeHandleKeyDownHandler,
        resizeHandleKeyUpHandler
    ]);
    if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breakout-resizer-editor-view-wrapper",
        ref: (ref)=>getRef && getRef(ref)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aWssQ.default), {
        ref: resizerRef,
        enable: (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $e61d807cbad078b7$var$RESIZER_ENABLE_HANDLES : {
            left: true,
            right: true
        },
        snap: snaps || undefined,
        snapGap: (0, $b84766e5f44e23e9$export$6cdb476c834bc60),
        handleStyles: $e61d807cbad078b7$var$getHandleStyle(nodeType, hidden),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: isResizing ? $e61d807cbad078b7$var$resizingStyles : $e61d807cbad078b7$var$defaultStyles,
        handleResizeStart: handleResizeStart,
        handleResizeStop: handleResizeStop,
        handleResize: handleResize,
        childrenDOMRef: getRef,
        resizeRatio: 2,
        isHandleVisible: isSelectionInNode,
        handleSize: "clamped",
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleAlignmentMethod: "sticky",
        labelComponent: currentLayout && (0, $fqVYq.editorExperiment)('single_column_layouts', true) && [
            'full-width',
            'wide'
        ].includes(currentLayout || '') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: currentLayout
        })
    });
};



var $4Qu9h = parcelRequire("4Qu9h");




























const $85a81c71b94ef05b$export$9adba9ade368b431 = (state)=>{
    const { schema: { nodes: { layoutSection: layoutSection, layoutColumn: layoutColumn } }, selection: selection } = state;
    const isLayoutColumn = (0, $fqVYq.editorExperiment)('advanced_layouts', true) && (0, $bjg0G.findSelectedNodeOfType)([
        layoutColumn
    ])(selection);
    // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
    return isLayoutColumn ? undefined : (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection) || (0, $bjg0G.findSelectedNodeOfType)([
        layoutSection
    ])(selection);
};
/**
 * The depth of the layout column inside the layout section.
 * As per the current implementation, the layout column ALWAYS has a depth of 1.
 */ const $85a81c71b94ef05b$var$LAYOUT_COLUMN_DEPTH = 1;
const $85a81c71b94ef05b$export$c13dbc07830c6c42 = (view, posOfLayout, childIndex = 0)=>{
    const $maybeLayoutSection = view.state.doc.resolve(posOfLayout);
    if ($maybeLayoutSection.nodeAfter?.type.name === 'layoutSection') {
        const layoutSectionNode = $maybeLayoutSection.nodeAfter;
        // check if the childIndex is valid
        if (childIndex < 0 || childIndex >= layoutSectionNode.childCount) return;
        const childPos = $maybeLayoutSection.posAtIndex(childIndex, $85a81c71b94ef05b$var$LAYOUT_COLUMN_DEPTH);
        const tr = view.state.tr;
        const $selectionPos = tr.doc.resolve(childPos);
        if (layoutSectionNode.firstChild?.type.name === 'paragraph') view.dispatch(tr.setSelection((0, $kCECX.TextSelection).near($selectionPos)));
        else view.dispatch(tr.setSelection((0, $4EksL.GapCursorSelection).near($selectionPos)));
        return tr;
    }
};
const $85a81c71b94ef05b$export$a03ac666480b47d9 = (view, event)=>{
    if ((0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1')) return undefined;
    // Resolve the column from the DOM target so it works even when posAtCoords returns null
    // (nothing rendered at the clicked Y).
    const target = event.target;
    const columnEl = target?.closest('[data-layout-column]');
    if (!columnEl) return undefined;
    let columnStartPos;
    try {
        columnStartPos = view.posAtDOM(columnEl, 0);
    } catch  {
        return undefined;
    }
    // posAtDOM resolves at varying depths, so walk up to find the layoutColumn.
    const $columnStart = view.state.doc.resolve(columnStartPos);
    let depth = -1;
    for(let d = $columnStart.depth; d >= 0; d--)if ($columnStart.node(d).type.name === 'layoutColumn') {
        depth = d;
        break;
    }
    if (depth < 0) return undefined;
    const columnNode = $columnStart.node(depth);
    if (columnNode.childCount === 0) return undefined;
    const columnContentStart = $columnStart.start(depth);
    const columnEndPos = $columnStart.end(depth);
    const getChildDom = (nodePos)=>{
        try {
            const dom = view.nodeDOM(nodePos);
            return dom instanceof Element ? dom : null;
        } catch  {
            return null;
        }
    };
    const valign = columnNode.attrs?.valign;
    const isNonTopAligned = valign && valign !== 'top';
    // Use the column rect (not child rects) for above/below detection: it stays stable as
    // gap-cursor widgets shift child DOM positions between repeated clicks.
    const columnRect = columnEl.getBoundingClientRect();
    // Click ABOVE the first child (only for middle/bottom-aligned columns).
    const firstChildPos = columnContentStart;
    const firstChildDom = getChildDom(firstChildPos);
    if (isNonTopAligned && firstChildDom) {
        const rect = firstChildDom.getBoundingClientRect();
        if (event.clientY < rect.top && event.clientY >= columnRect.top) return {
            pos: firstChildPos,
            side: 'left'
        };
    }
    // Click BELOW the last child (for any column alignment).
    const lastChild = columnNode.lastChild;
    const lastChildEndPos = columnEndPos;
    const lastChildStartPos = lastChild ? lastChildEndPos - lastChild.nodeSize : columnContentStart;
    const lastChildDom = lastChild ? getChildDom(lastChildStartPos) : null;
    if (lastChild && lastChildDom) {
        const rect = lastChildDom.getBoundingClientRect();
        if (event.clientY > rect.bottom && event.clientY <= columnRect.bottom) return {
            pos: lastChildEndPos,
            side: 'right'
        };
    }
    // Fallback: click lands ON a single atomic child that fills the column (mediaSingle/expand),
    // so the above/below checks never fired.
    if (columnNode.childCount === 1) {
        const onlyChild = columnNode.firstChild;
        // Exclude `panel`: its wrapper makes `view.nodeDOM` non-null and intercepts clicks, so the
        // guard below would wrongly fire for in-panel blank-space clicks (which have their own
        // native gap cursor).
        if (onlyChild && onlyChild.type.name !== 'paragraph' && onlyChild.type.name !== 'panel') {
            // Bail when the click is on the child's own content. For media the wrapper is full-width
            // so test against the <img> rect; resolve it only for a direct mediaSingle child (else
            // getContentRect could grab an image nested in an expand and break its toggle).
            const contentRect = onlyChild.type.name === 'mediaSingle' ? $85a81c71b94ef05b$var$getContentRect(firstChildDom) : null;
            if (contentRect) {
                const insideImage = event.clientX >= contentRect.left && event.clientX <= contentRect.right && event.clientY >= contentRect.top && event.clientY <= contentRect.bottom;
                if (insideImage) return undefined;
            } else {
                // Other atomics: bail when posAtCoords resolves strictly inside the node range.
                let coordPos = null;
                try {
                    coordPos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                } catch  {
                    coordPos = null;
                }
                if (coordPos && coordPos.pos > firstChildPos && coordPos.pos < lastChildEndPos) return undefined;
            }
            // Fire when the child DOM is resolvable, or when it's null (media not yet loaded) but
            // the click target is the column itself (no node view intercepted it).
            const targetEl = event.target;
            const targetIsColumn = targetEl === columnEl;
            const shouldUseFallback = firstChildDom !== null || targetIsColumn;
            if (shouldUseFallback) {
                const side = $85a81c71b94ef05b$var$getGapCursorSideForBlankSpaceClick(firstChildDom, columnRect, event.clientX, event.clientY);
                return side === 'left' ? {
                    pos: firstChildPos,
                    side: 'left'
                } : {
                    pos: lastChildEndPos,
                    side: 'right'
                };
            }
        }
    }
    return undefined;
};
/**
 * The tight `<img>` content rect (or `null`). The outer wrapper often fills the whole column
 * width, so the `<img>` rect is needed to tell "beside the image" from "on the image".
 */ const $85a81c71b94ef05b$var$getContentRect = (firstChildDom)=>{
    const img = firstChildDom?.querySelector('img');
    return img ? img.getBoundingClientRect() : null;
};
/**
 * Which side of an atomic child a blank-space click belongs to. Prefers the tight content (image)
 * rect when available — using its midpoint so it's direction-agnostic (handles RTL right-aligned
 * images) — otherwise falls back to the column's vertical midpoint.
 */ const $85a81c71b94ef05b$var$getGapCursorSideForBlankSpaceClick = (firstChildDom, columnRect, clientX, clientY)=>{
    const contentRect = $85a81c71b94ef05b$var$getContentRect(firstChildDom);
    if (contentRect) {
        if (clientY < contentRect.top) return 'left';
        if (clientY > contentRect.bottom) return 'right';
        if (clientX < (contentRect.left + contentRect.right) / 2) return 'left';
        return 'right';
    }
    const columnMidY = columnRect.top + columnRect.height / 2;
    return clientY < columnMidY ? 'left' : 'right';
};
const $85a81c71b94ef05b$export$8c1438c11cd047f3 = (view, gapTarget)=>{
    const { pos: pos, side: side } = gapTarget;
    const { doc: doc } = view.state;
    try {
        const $pos = doc.resolve(pos);
        const childNode = side === 'left' ? $pos.nodeAfter : $pos.nodeBefore;
        return childNode?.type.name === 'paragraph';
    } catch  {
        return false;
    }
};






var $kSwu1 = parcelRequire("kSwu1");






function $6eaaa6e4602fe34a$export$f101bb1d69aeca23({ children: children, intl: intl }) {
    if (!(0, $iAEsk.isSSRStreaming)() || !(0, $4iudd.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
        value: intl
    }, children);
}


const $c3f861a49670d256$var$layoutDynamicFullWidthGuidelineOffset = 16;
const $c3f861a49670d256$var$isEmptyParagraph = (node)=>{
    return !!node && node.type.name === 'paragraph' && !node.childCount;
};
const $c3f861a49670d256$var$isBreakoutAvailable = (schema)=>{
    return Boolean(schema.marks.breakout);
};
const $c3f861a49670d256$var$isEmptyLayout = (node)=>{
    if (!node) return false;
    // fast check
    // each column should have size 2 from layoutcolumn and 2 from empty paragraph
    if (node.content.size / node.childCount !== 4) return false;
    let isEmpty = true;
    node.content.forEach((maybelayoutColumn)=>{
        if (maybelayoutColumn.type.name !== 'layoutColumn' || maybelayoutColumn.childCount > 1 || !$c3f861a49670d256$var$isEmptyParagraph(maybelayoutColumn.firstChild)) {
            isEmpty = false;
            return;
        }
    });
    return isEmpty;
};
const $c3f861a49670d256$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $c3f861a49670d256$var$LayoutBreakoutResizer = ({ pluginInjectionApi: pluginInjectionApi, forwardRef: forwardRef, getPos: getPos, view: view, parentRef: parentRef })=>{
    const { editorDisabled: editorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled'
    ], $c3f861a49670d256$var$selector);
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const getEditorWidth = ()=>{
        return pluginInjectionApi?.width?.sharedState.currentState();
    };
    const displayGapCursor = (0, $cozmU.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const displayGuidelines = (0, $cozmU.useCallback)((guidelines)=>{
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: guidelines
        });
    }, [
        pluginInjectionApi,
        view
    ]);
    // we want to hide the floating toolbar for other nodes.
    // e.g. info panel inside the current layout section
    const selectIntoCurrentLayout = (0, $cozmU.useCallback)(()=>{
        const pos = getPos();
        if (pos === undefined) return;
        // put the selection into the first column of the layout
        (0, $85a81c71b94ef05b$export$c13dbc07830c6c42)(view, pos, 0);
    }, [
        getPos,
        view
    ]);
    if (interactionState === 'hasNotHadInteraction' && !(0, $ieeJu.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e61d807cbad078b7$export$d6c278682f48fbc4), {
        getRef: forwardRef,
        getPos: getPos,
        editorView: view,
        nodeType: "layoutSection",
        getEditorWidth: getEditorWidth,
        disabled: (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) ? true : editorDisabled === true || !$c3f861a49670d256$var$isBreakoutAvailable(view.state.schema),
        hidden: interactionState === 'hasNotHadInteraction' && (0, $ieeJu.expValEquals)('platform_editor_breakout_interaction_rerender', 'isEnabled', true),
        parentRef: parentRef,
        editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
        displayGuidelines: (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? displayGuidelines : undefined,
        displayGapCursor: displayGapCursor,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onResizeStart: ()=>{
            selectIntoCurrentLayout();
        },
        dynamicFullWidthGuidelineOffset: $c3f861a49670d256$var$layoutDynamicFullWidthGuidelineOffset
    });
};
const $c3f861a49670d256$var$toDOM = (node)=>[
        'div',
        {
            class: 'layout-section-container'
        },
        [
            'div',
            {
                'data-layout-section': true,
                ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') && {
                    'data-local-id': node.attrs.localId
                }
            },
            0
        ]
    ];
class $c3f861a49670d256$export$8bfc7bdc15be731c extends (0, $Igylv.default) {
    /**
   * getContentDOM
   * @example
   * @returns
   */ getContentDOM() {
        // Build the layout DOM via the schema's toDOM spec. This is the same
        // path used in both CSR and SSR — the only SSR-specific concern is
        // re-attaching `contentDOM` (= the `[data-layout-section]` element)
        // after the portal's renderToStaticMarkup + innerHTML write detaches
        // it. We handle that by stamping `data-ssr-content-dom-ref` on the
        // outer container so `ReactNodeView.init()` can find a re-attach
        // target inside `domRef` after the portal write.
        const { dom: container, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $c3f861a49670d256$var$toDOM(this.node));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.layoutDOM = container.querySelector('[data-layout-section]');
        this.layoutDOM.setAttribute('data-column-rule-style', this.node.attrs.columnRuleStyle);
        this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) this.layoutDOM.setAttribute('data-local-id', this.node.attrs.localId);
        // SSR streaming re-attach note:
        // In SSR, `init()` appends `container` into `domRef`; the portal's
        // renderToStaticMarkup + innerHTML write then wipes `domRef`,
        // detaching the entire subtree (with PM-serialized children inside
        // `[data-layout-section]`). React's `render()` emits a
        // `<NodeViewContentHole/>` placeholder inside `domRef`; the SSR
        // re-attach logic in `init()` finds it via `[data-ssr-content-dom-ref]`
        // and calls `_handleRef`, which appends `contentDOMWrapper` (the
        // detached `container`) back inside the placeholder. The end result
        // is `domRef > NodeViewContentHole > layout-section-container >
        // [data-layout-section] > [data-layout-column] children` — the
        // layout DOM contract is preserved.
        return {
            dom: container,
            contentDOM: contentDOM
        };
    }
    /**
   * setDomAttrs
   * @param node
   * @param element
   * @example
   */ setDomAttrs(node, _element) {
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle);
    }
    /**
   * render
   * @param props
   * @param forwardRef
   * @example
   * @returns
   */ render(props, forwardRef) {
        this.isEmpty = $c3f861a49670d256$var$isEmptyLayout(this.node);
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        // SSR streaming path: render only a `<NodeViewContentHole/>` placeholder
        // so ReactNodeView.init()'s SSR re-attach logic can find the marker
        // (`data-ssr-content-dom-ref`) and re-append the detached
        // contentDOMWrapper — which is the FULL layout structure
        // (`layout-section-container > [data-layout-section] > children`) built
        // in `getContentDOM` via DOMSerializer.renderSpec. This avoids
        // duplicating layout structure between getContentDOM and render(), which
        // previously caused an extra wrapping div between `[data-layout-section]`
        // and the `[data-layout-column]` children and broke the flex layout.
        //
        // The BreakoutResizer is intentionally omitted in SSR — it relies on
        // browser-only APIs and contributes no useful static markup. The
        // LayoutSSRReactContextsProvider wraps the placeholder to inject the
        // editor's IntlShape, defending against any descendants that call
        // `useIntl()` during renderToStaticMarkup.
        if ((0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eaaa6e4602fe34a$export$f101bb1d69aeca23), {
            intl: this.intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9sVl.NodeViewContentHole), {
            ref: forwardRef
        }));
        if ((0, $ieeJu.expValEquals)('platform_editor_breakout_resizing', 'isEnabled', true)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f861a49670d256$var$LayoutBreakoutResizer, {
            pluginInjectionApi: props.pluginInjectionApi,
            forwardRef: forwardRef,
            getPos: props.getPos,
            view: props.view,
            parentRef: this.layoutDOM
        });
    }
    /**
   * ignoreMutation
   * @param mutation
   * @example
   * @returns
   */ ignoreMutation(mutation) {
        return (0, $e61d807cbad078b7$export$256eed97177e990e)(mutation);
    }
    /**
   * constructor
   * @param props
   * @param props.node
   * @param props.view
   * @param props.getPos
   * @param props.portalProviderAPI
   * @param props.eventDispatcher
   * @param props.pluginInjectionApi
   * @param props.options
   * @param props.intl
   * @example
   */ constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.options = void 0;
        this.layoutDOM = void 0;
        this.isEmpty = void 0;
        this.intl = void 0;
        this.isEmpty = $c3f861a49670d256$var$isEmptyLayout(this.node);
        this.options = props.options;
        this.intl = props.intl;
    }
}


const $263e2eabc1c558a4$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('layoutResizingPlugin');
/**
 * Minimal node view for layoutColumn that delegates all DOM serialization to the
 * NodeSpec's own toDOM, but overrides ignoreMutation to suppress style attribute
 * mutations from ProseMirror's MutationObserver.
 *
 * This is necessary so that direct inline style mutations during column drag
 * (e.g. setting flex-basis to give real-time visual feedback without dispatching
 * PM transactions) are not "corrected" back by ProseMirror's DOM reconciliation.
 */ const $263e2eabc1c558a4$var$isLayoutElementLike = (element)=>{
    if ((0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)()) {
        // In SSR environments, `HTMLElement` is undefined globally so a plain
        // `instanceof HTMLElement` check is always `false`. That makes the
        // `DOMSerializer.renderSpec(...)` result get rejected by the guard below and
        // the NodeView falls back to a bare `<div>`, losing every schema-defined
        // attribute (`data-layout-column`, `style="flex-basis:..."`,
        // `data-column-width`, plus the inner `<div data-layout-content="true">`
        // wrapper) and breaking the layout's flex sizing in SSR output.
        //
        // To unblock SSR streaming without changing CSR semantics, we gate the check:
        // - In SSR (and only when `platform_editor_editor_ssr_streaming` is enabled),
        //   use a duck-typed check that mirrors `safe-plugin`'s `isHTMLElement`.
        // - Everywhere else, keep the original `instanceof HTMLElement` check exactly
        //   as it was so we don't accidentally widen acceptance in CSR.
        if (element === null || element === undefined) return false;
        return typeof element === 'object' && 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    return element instanceof HTMLElement;
};
class $263e2eabc1c558a4$var$LayoutColumnView {
    ignoreMutation(mutation) {
        // Ignore style attribute mutations — these are direct DOM writes during column drag
        // (setting flex-basis for real-time resize feedback). Without this, PM's
        // MutationObserver would immediately revert our style changes.
        return mutation.type === 'attributes' && mutation.attributeName === 'style';
    }
    constructor(node, view, getPos){
        this.dom = void 0;
        this.contentDOM = void 0;
        // Use the NodeSpec's own toDOM to produce the correct DOM structure and attributes.
        const nodeType = view.state.schema.nodes[node.type.name];
        // Fallback: create a plain div so PM always has a valid DOM node to work with.
        // This path should never be reached in practice — layoutColumn always has a toDOM.
        if (!nodeType.spec.toDOM) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, nodeType.spec.toDOM(node));
        if (!$263e2eabc1c558a4$var$isLayoutElementLike(dom) || !$263e2eabc1c558a4$var$isLayoutElementLike(contentDOM)) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        this.dom = dom;
        this.contentDOM = contentDOM;
        // Stamp the column's index within its parent section onto the DOM element so that
        // column-resize-divider can query columns by index rather than relying on positional
        // order of [data-layout-column] elements (which could break if the DOM structure changes).
        const pos = getPos();
        if (pos !== undefined) {
            const $pos = view.state.doc.resolve(pos);
            this.dom.setAttribute('data-layout-column-index', String($pos.index()));
        }
    }
}
var $263e2eabc1c558a4$export$2e2bcd8739ae039 = (options, pluginInjectionApi, portalProviderAPI, eventDispatcher, intl)=>new (0, $kpCD8.SafePlugin)({
        key: $263e2eabc1c558a4$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                layoutSection: (node, view, getPos)=>{
                    return new (0, $c3f861a49670d256$export$8bfc7bdc15be731c)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        options: options,
                        intl: intl
                    }).init();
                },
                // Register the column node view when EITHER:
                // 1. The resize handle experiment is on (its original purpose:
                //    suppress style-attribute MutationObserver callbacks during
                //    drag, allowing direct flex-basis writes without PM
                //    interference).
                // 2. SSR streaming is enabled — the column node view stamps
                //    `container-type: inline-size` inline on each column dom so
                //    that the SSR-rendered table inside the column constrains
                //    its width to the column (see comment in the constructor).
                ...(0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true) || (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? {
                    layoutColumn: (node, view, getPos)=>new $263e2eabc1c558a4$var$LayoutColumnView(node, view, getPos)
                } : {}
            }
        }
    });




const $d12416bdd3b8a88f$export$cfaf3f619f4fde4d = 'two_equal';
/**
 * Shared blank-space gap cursor placement, used by both `handleClick` and `handleClickOn`
 * (the latter catches clicks on atomic node views that stop propagation before `handleClick`).
 * Returns `true` when it placed a selection and consumed the click, else `false`.
 */ const $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor = (view, event)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true) || !(0, $fqVYq.editorExperiment)('advanced_layouts', true)) return false;
    const gapTarget = (0, $85a81c71b94ef05b$export$a03ac666480b47d9)(view, event);
    if (gapTarget === undefined) return false;
    const $pos = view.state.doc.resolve(gapTarget.pos);
    // A paragraph child takes a TextSelection (caret at the edge) rather than a gap cursor.
    const isParagraphTarget = (0, $85a81c71b94ef05b$export$8c1438c11cd047f3)(view, gapTarget);
    const nextSelection = isParagraphTarget ? (0, $kCECX.TextSelection).near($pos, gapTarget.side === 'left' ? 1 : -1) : new (0, $4EksL.GapCursorSelection)($pos, gapTarget.side === 'left' ? (0, $eaLat.Side).LEFT : (0, $eaLat.Side).RIGHT);
    // Idempotency guard: `mousedown` already placed this selection, but the browser still
    // fires `mouseup`, so `handleClick`/`handleClickOn` re-run for the same click. Consume it
    // without re-dispatching (which would add a redundant undo entry).
    if (view.state.selection.eq(nextSelection)) return true;
    view.dispatch(view.state.tr.setSelection(nextSelection).scrollIntoView());
    return true;
};
const $d12416bdd3b8a88f$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $d12416bdd3b8a88f$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const section = (0, $bjg0G.findParentNodeOfType)(layoutSection)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const column = (0, $bjg0G.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $kCECX.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
const $d12416bdd3b8a88f$var$getNodeDecoration = (pos, node)=>[
        (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
const $d12416bdd3b8a88f$var$getDangerPreviewDecorations = (state, positions)=>positions?.flatMap((pos)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return [];
        return [
            (0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
                class: 'layout-column-danger-preview'
            })
        ];
    }) ?? [];
const $d12416bdd3b8a88f$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $85a81c71b94ef05b$export$9adba9ade368b431)(state);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $20de433b9f6c9d19$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, $d12416bdd3b8a88f$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout,
        isResizing: false,
        isLayoutColumnMenuOpen: false,
        layoutColumnMenuOpenedViaKeyboard: false,
        layoutColumnMenuAnchorPos: undefined,
        dangerPreviewLayoutColumnPositions: undefined
    };
};
const $d12416bdd3b8a88f$var$fireLayoutColumnMenuOpenedAnalytics = (editorAnalyticsAPI, state, openedViaKeyboard)=>{
    const selectedLayoutColumnsResult = (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(state.selection);
    if (!selectedLayoutColumnsResult) return;
    const { layoutSectionNode: layoutSectionNode, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
    editorAnalyticsAPI?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).OPENED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LAYOUT_COLUMN_MENU,
        attributes: {
            columnCount: layoutSectionNode.childCount,
            endIndex: endIndex,
            inputMethod: openedViaKeyboard ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE,
            selectedCount: selectedLayoutColumns.length,
            startIndex: startIndex
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    });
};
const $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState = (pluginState, action)=>{
    switch(action.type){
        case 'toggleLayoutColumnMenu':
            {
                const { anchorPos: anchorPos, isOpen: isOpen, openedViaKeyboard: openedViaKeyboard } = action.meta;
                // `isOpen` provided: use directly (legacy). Omitted: toggle off only when re-clicking
                // the already-open column; otherwise open for the clicked column.
                const isSameColumnAsOpenMenu = pluginState.isLayoutColumnMenuOpen && anchorPos !== undefined && anchorPos === pluginState.layoutColumnMenuAnchorPos;
                const nextIsOpen = isOpen ?? !isSameColumnAsOpenMenu;
                return {
                    ...pluginState,
                    isLayoutColumnMenuOpen: nextIsOpen,
                    layoutColumnMenuOpenedViaKeyboard: nextIsOpen ? openedViaKeyboard ?? false : false,
                    layoutColumnMenuAnchorPos: nextIsOpen ? anchorPos : undefined,
                    dangerPreviewLayoutColumnPositions: nextIsOpen ? pluginState.dangerPreviewLayoutColumnPositions : undefined
                };
            }
        case 'setDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: action.positions
            };
        case 'clearDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: undefined
            };
        case 'setResizeState':
            return {
                ...pluginState,
                isResizing: action.isResizing
            };
        case 'syncSelectionState':
            {
                const maybeLayoutSection = (0, $85a81c71b94ef05b$export$9adba9ade368b431)(action.state);
                return {
                    ...pluginState,
                    pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                    selectedLayout: (0, $20de433b9f6c9d19$export$4cb9903a94908763)(maybeLayoutSection && maybeLayoutSection.node, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    pluginState.selectedLayout)
                };
            }
    }
};
// To prevent a single-column layout,
// if a user attempts to delete a layout column and
// we will force remove the content instead.
// There are some edge cases where user can delete a layout column
// see packages/editor/editor-plugin-layout-tests/src/__tests__/unit/delete.ts
const $d12416bdd3b8a88f$var$handleDeleteLayoutColumn = (state, dispatch)=>{
    const sel = state.selection;
    if (sel instanceof (0, $kCECX.NodeSelection) && sel.node.type.name === 'layoutColumn' && sel.$from.parent.type.name === 'layoutSection' && sel.$from.parent.childCount === 2 && dispatch && (0, $fqVYq.editorExperiment)('advanced_layouts', true) && !(0, $fqVYq.editorExperiment)('single_column_layouts', true)) {
        const tr = state.tr;
        const layoutContentFragment = sel.$from.parentOffset === 0 ? (0, $aPdNQ.Fragment).from(sel.$from.parent.lastChild?.content) : (0, $aPdNQ.Fragment).from(sel.$from.parent.firstChild?.content);
        const parent = (0, $bjg0G.findParentNodeClosestToPos)(sel.$from, (node)=>{
            return node.type.name === 'layoutSection';
        });
        if (parent) {
            const layoutSectionPos = tr.mapping.map(parent.pos);
            const layoutSectionNodeSize = parent.node.nodeSize;
            dispatch(state.tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment));
            return true;
        }
        return false;
    }
    return false;
};
var $d12416bdd3b8a88f$export$2e2bcd8739ae039 = (options, editorAnalyticsAPI)=>{
    // Store a reference to the EditorView so widget decorations can dispatch transactions
    let editorViewRef;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1),
        view (view) {
            editorViewRef = view;
            return {
                update (updatedView) {
                    editorViewRef = updatedView;
                },
                destroy () {
                    editorViewRef = undefined;
                }
            };
        },
        state: {
            init: (_, state)=>$d12416bdd3b8a88f$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, oldState, newState)=>{
                let nextPluginState = pluginState;
                const columnMenuMeta = tr.getMeta('toggleLayoutColumnMenu');
                const dangerPreviewMeta = tr.getMeta('layoutColumnDangerPreview');
                if (columnMenuMeta) {
                    const wasLayoutColumnMenuOpen = nextPluginState.isLayoutColumnMenuOpen;
                    nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                        meta: columnMenuMeta,
                        type: 'toggleLayoutColumnMenu'
                    });
                    if (!wasLayoutColumnMenuOpen && nextPluginState.isLayoutColumnMenuOpen) $d12416bdd3b8a88f$var$fireLayoutColumnMenuOpenedAnalytics(editorAnalyticsAPI, newState, columnMenuMeta.openedViaKeyboard);
                }
                if (tr.getMeta('layoutColumnDangerPreview') !== undefined) nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    positions: dangerPreviewMeta ?? undefined,
                    type: 'setDangerPreview'
                });
                if (tr.docChanged) nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    type: 'clearDangerPreview'
                });
                const isResizing = (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? tr.getMeta('is-resizer-resizing') ?? (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(oldState)?.isResizing : false;
                nextPluginState = $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    isResizing: isResizing,
                    type: 'setResizeState'
                });
                if (tr.docChanged || tr.selectionSet) return $d12416bdd3b8a88f$var$reduceLayoutColumnMenuState(nextPluginState, {
                    state: newState,
                    type: 'syncSelectionState'
                });
                return nextPluginState;
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
                const isLayoutResizingPluginAvailable = (0, $263e2eabc1c558a4$export$18d4026d1ea86bb1).get(state) !== undefined;
                if ((0, $fqVYq.editorExperiment)('advanced_layouts', true) && (0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true) && isLayoutResizingPluginAvailable) {
                    const dividerDecorations = (0, $0ab5832e42b8afea$export$b54a43c7f9b448fd)(state, editorViewRef, editorAnalyticsAPI);
                    const selectedDecorations = layoutState.pos !== null ? $d12416bdd3b8a88f$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    const dangerPreviewDecorations = $d12416bdd3b8a88f$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                    const allDecorations = [
                        ...selectedDecorations,
                        ...dividerDecorations,
                        ...dangerPreviewDecorations
                    ];
                    if (allDecorations.length > 0) return (0, $8nvEM.DecorationSet).create(state.doc, allDecorations);
                    return undefined;
                }
                const dangerPreviewDecorations = $d12416bdd3b8a88f$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                if (layoutState.pos !== null || dangerPreviewDecorations.length > 0) {
                    const selectedDecorations = layoutState.pos !== null ? $d12416bdd3b8a88f$var$getNodeDecoration(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    return (0, $8nvEM.DecorationSet).create(state.doc, [
                        ...selectedDecorations,
                        ...dangerPreviewDecorations
                    ]);
                }
                return undefined;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Tab: (0, $dTPhv.filter)($d12416bdd3b8a88f$var$isWholeSelectionInsideLayoutColumn, $d12416bdd3b8a88f$var$moveCursorToNextColumn),
                'Mod-Backspace': $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                'Mod-Delete': $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                Backspace: $d12416bdd3b8a88f$var$handleDeleteLayoutColumn,
                Delete: $d12416bdd3b8a88f$var$handleDeleteLayoutColumn
            }),
            handleDOMEvents: {
                // Place the gap cursor on `mousedown` (not `mouseup`) so the caret never flashes
                // inside a nested editable child first.
                mousedown (view, event) {
                    const target = event.target;
                    if (target?.hasAttribute('data-layout-section')) return false;
                    if ($d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event)) {
                        event.preventDefault();
                        // `preventDefault()` blocks the editor focus that makes the gap cursor blink,
                        // so restore it here. The `handleClick`/`handleClickOn` paths don't need this.
                        if (!view.hasFocus()) view.focus();
                        return true;
                    }
                    return false;
                }
            },
            handleClickOn: (()=>{
                const selectionClickHandler = (0, $lp7sw.createSelectionClickHandler)([
                    'layoutColumn'
                ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                    useLongPressSelection: options.useLongPressSelection || false,
                    getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
                });
                return (view, pos, node, nodePos, event, direct)=>{
                    // Fallback for clicks on an atomic node view that the mousedown hook missed.
                    const target = event.target;
                    if (!target?.hasAttribute('data-layout-section') && $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event)) return true;
                    return selectionClickHandler(view, pos, node, nodePos, event, direct);
                };
            })(),
            handleClick (view, _pos, event) {
                // Fallback for clicks the mousedown interceptor missed.
                const target = event.target;
                if (target?.hasAttribute('data-layout-section')) return false;
                return $d12416bdd3b8a88f$var$applyBlankSpaceGapCursor(view, event);
            }
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            const changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                // Skip fixing column sizes for column resize drag transactions
                if ((0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true) && prevTr.getMeta('layoutColumnResize')) return;
                // Layout column insert actions already recalculate column widths and need their own
                // selection mapping; avoid a follow-up normalisation transaction that can remap it.
                if (prevTr.getMeta((0, $20de433b9f6c9d19$export$7304947c445e7dbb))) return;
                const change = (0, $20de433b9f6c9d19$export$ea5c48c44d467c6)(prevTr, newState);
                if (change) changes.push(change);
            });
            if ((0, $fqVYq.editorExperiment)('advanced_layouts', true) && changes.length === 1) {
                const change = changes[0];
                // When editorExperiment('single_column_layouts', true) is on
                // delete can create a single column layout
                // otherwise we replace the single column layout with its content
                if (!(0, $fqVYq.editorExperiment)('single_column_layouts', true) && change.slice.content.childCount === 1 && change.slice.content.firstChild?.type.name === 'layoutColumn' && change.slice.content.firstChild?.attrs.width === (0, $bbeac3462dd7561c$export$faa6744ce57d263b)[1]) {
                    const tr = newState.tr;
                    const { content: content } = change.slice.content.firstChild;
                    tr.replaceWith(change.from - 1, change.to, content);
                    return tr;
                }
            }
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $20de433b9f6c9d19$export$35e1f731e4a1d52)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $kCECX.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });
};




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");










const $46d3039b880758a7$var$PLACEHOLDER_SELECTOR = '.ProseMirror-focused .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)';
const $46d3039b880758a7$var$layoutColumnDangerPreviewStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-column].layout-column-danger-preview': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
        boxShadow: `inset 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::before': {
            visibility: 'hidden'
        }
    }
});
const $46d3039b880758a7$var$getPlaceholderStyle = (message)=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $lOiVq.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`${$46d3039b880758a7$var$PLACEHOLDER_SELECTOR}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-subtlest, #6B6E76)",
                pointerEvents: 'none'
            }
        }
    });
    return /*#__PURE__*/ (0, $lOiVq.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '.ProseMirror .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-disabled, #080F214A)",
                font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                marginTop: "var(--ds-space-050, 4px)",
                pointerEvents: 'none'
            }
        }
    });
};
const $46d3039b880758a7$export$cc5403d58ddfa812 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderStyle = (0, $cozmU.useMemo)(()=>{
        const placeholderText = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $72OpT.toolbarMessages).controlslayoutPlaceholder : (0, $72OpT.toolbarMessages).layoutPlaceholder;
        return $46d3039b880758a7$var$getPlaceholderStyle(formatMessage(placeholderText));
    }, [
        formatMessage
    ]);
    const globalStyles = (0, $cozmU.useMemo)(()=>[
            placeholderStyle,
            $46d3039b880758a7$var$layoutColumnDangerPreviewStyle
        ], [
        placeholderStyle
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: globalStyles
    });
};


/* LayoutBlockMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");











var $3FYPH = parcelRequire("3FYPH");


var $dVKvM = parcelRequire("dVKvM");


var $eQpqk = parcelRequire("eQpqk");

const $d682813aeb2e73a4$var$styles = {
    svgOverflow: "_1wrmewfl _172sewfl"
};
const $d682813aeb2e73a4$var$NODE_NAME = 'layoutSection';
const $d682813aeb2e73a4$var$LayoutBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.layoutSection, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $d682813aeb2e73a4$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $d682813aeb2e73a4$var$styles.svgOverflow
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
            label: "",
            size: "small"
        }))
    }, formatMessage((0, $3FYPH.messages).layout));
};
const $d682813aeb2e73a4$export$83047c2fe2258f8 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d682813aeb2e73a4$var$LayoutBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};












var $kAPZe = parcelRequire("kAPZe");


var $7XIuB = parcelRequire("7XIuB");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");


var $9Muxb = parcelRequire("9Muxb");


var $3v5aK = parcelRequire("3v5aK");





var $kwf4Z = parcelRequire("kwf4Z");


var $dQMlg = parcelRequire("dQMlg");









var $uyXFl = parcelRequire("uyXFl");


var $jgJIe = parcelRequire("jgJIe");


var $dQrHJ = parcelRequire("dQrHJ");

















var $iDfTs = parcelRequire("iDfTs");



var $i9j2V = parcelRequire("i9j2V");





const $f7560e5d01f47387$export$b5775257132e9ca7 = (api)=>(0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], ({ selectionState: selectionState })=>{
        const selectedLayoutColumns = selectionState?.selection && (0, $165a594884c31a30$export$d9c5d9ac81e1479b)(selectionState.selection);
        return selectedLayoutColumns?.selectedLayoutColumns.length ? selectedLayoutColumns : undefined;
    });


const $228ccbfff683bd0e$export$5829d448eda3ac0f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const setDangerPreview = (0, $cozmU.useCallback)((show)=>{
        api?.core?.actions.execute(api?.layout?.commands.setLayoutColumnDangerPreview(show));
    }, [
        api
    ]);
    const showDangerPreview = (0, $cozmU.useCallback)(()=>{
        setDangerPreview(true);
    }, [
        setDangerPreview
    ]);
    const hideDangerPreview = (0, $cozmU.useCallback)(()=>{
        setDangerPreview(false);
    }, [
        setDangerPreview
    ]);
    const onClick = (0, $cozmU.useCallback)(()=>{
        const deleteCommand = api?.layout?.commands.deleteLayoutColumn({
            inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api?.core?.actions.execute((props)=>{
            const tr = deleteCommand?.(props);
            if (!tr) return tr ?? null;
            api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    if (selectedLayoutColumns === undefined) return null;
    const selectedColumnCount = selectedLayoutColumns.selectedLayoutColumns.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.deleteColumn)),
        onClick: onClick,
        onFocus: showDangerPreview,
        onMouseEnter: showDangerPreview,
        onBlur: hideDangerPreview,
        onMouseLeave: hideDangerPreview,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.deleteColumn)) ?? ''
        })
    }, formatMessage((0, $72OpT.toolbarMessages).deleteColumn, {
        count: selectedColumnCount
    }));
};















var $eh9HJ = parcelRequire("eh9HJ");





const $9befd911426fdde2$export$38f325b1b0b6a59f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumnsResult = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const { selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult ?? {};
    const handleClick = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute((props)=>{
            const tr = api?.layout?.commands.distributeLayoutColumns({
                inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
            })(props);
            if (!tr) return null;
            const closedTr = api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return closedTr ?? tr;
        });
    }, [
        api
    ]);
    const isAlreadyUniform = (0, $cozmU.useMemo)(()=>{
        if (!selectedLayoutColumns || selectedLayoutColumns.length < 2) return false;
        const selectedWidths = selectedLayoutColumns.map((col)=>col.node.attrs.width);
        return (0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)(selectedWidths);
    }, [
        selectedLayoutColumns
    ]);
    if (selectedLayoutColumns === undefined || selectedLayoutColumns.length < 2) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isDisabled: isAlreadyUniform,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    }, formatMessage((0, $72OpT.toolbarMessages).distributeColumns));
};


















var $jWZGH = parcelRequire("jWZGH");

var $eehur = parcelRequire("eehur");







const $778bf6704af08265$var$INSERT_COLUMN_OPTIONS = {
    left: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWZGH))),
        label: (0, $72OpT.toolbarMessages).addColumnLeft,
        side: 'left'
    },
    right: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eehur))),
        label: (0, $72OpT.toolbarMessages).addColumnRight,
        side: 'right'
    }
};
const $778bf6704af08265$export$81334f287bddf48 = ({ api: api, side: side })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Icon: Icon, label: label } = $778bf6704af08265$var$INSERT_COLUMN_OPTIONS[side];
    const shortcut = side === 'left' ? (0, $ldqjS.addColumnBefore) : (0, $ldqjS.addColumnAfter);
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const columnCount = selectedLayoutColumns?.layoutSectionNode?.childCount ?? 0;
    const maxColumnCount = (0, $20de433b9f6c9d19$export$1e9b718436507bc8)();
    const canInsertColumn = selectedLayoutColumns !== undefined && columnCount < maxColumnCount;
    const onClick = (0, $cozmU.useCallback)(()=>{
        const insertCommand = api?.layout?.commands.insertLayoutColumn({
            side: side,
            inputMethod: (0, $krYZG.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api?.core?.actions.execute((props)=>{
            const tr = insertCommand?.(props);
            if (!tr) return tr ?? null;
            api?.layout?.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        side
    ]);
    if (!canInsertColumn) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $ldqjS.getAriaKeyshortcuts)(shortcut),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)(shortcut) ?? ''
        }),
        onClick: onClick
    }, formatMessage(label));
};


const $28d0336eb9b11f85$export$9d94e89ca7612d27 = {
    type: 'menu',
    key: 'layout-column-menu'
};
const $28d0336eb9b11f85$export$eb99a60802d2824d = {
    type: 'menu-section',
    key: 'layout-column-menu-section'
};
const $28d0336eb9b11f85$export$75dfb738e6f28040 = {
    type: 'menu-section',
    key: 'layout-column-vertical-align-menu-section'
};
const $28d0336eb9b11f85$export$4586103d528537d = {
    type: 'menu-section',
    key: 'layout-column-danger-section'
};
const $28d0336eb9b11f85$export$5a7b98ab4e990db4 = {
    [$28d0336eb9b11f85$export$eb99a60802d2824d.key]: 100,
    [$28d0336eb9b11f85$export$4586103d528537d.key]: 200
};
const $28d0336eb9b11f85$export$b015955eb6c647e8 = {
    type: 'nested-menu',
    key: 'layout-column-menu-vertical-align-menu'
};
const $28d0336eb9b11f85$export$3e4da34ad142735a = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-left-item'
};
const $28d0336eb9b11f85$export$167d9b289da7ec90 = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-right-item'
};
const $28d0336eb9b11f85$export$3497442ae78aae72 = {
    type: 'menu-item',
    key: 'layout-column-menu-distribute-columns-item'
};
const $28d0336eb9b11f85$export$e9b3f7442c87b29e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-top-item'
};
const $28d0336eb9b11f85$export$1031423c8b45d874 = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-middle-item'
};
const $28d0336eb9b11f85$export$afcf8724bfd1844e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-bottom-item'
};
const $28d0336eb9b11f85$export$d75dc9d2c2174014 = {
    type: 'menu-item',
    key: 'layout-column-menu-delete-item'
};
const $28d0336eb9b11f85$export$c1497fcad4589239 = {
    [$28d0336eb9b11f85$export$b015955eb6c647e8.key]: 100,
    [$28d0336eb9b11f85$export$3e4da34ad142735a.key]: 200,
    [$28d0336eb9b11f85$export$167d9b289da7ec90.key]: 300,
    [$28d0336eb9b11f85$export$3497442ae78aae72.key]: 400
};
const $28d0336eb9b11f85$export$179c00b952ce20ad = {
    [$28d0336eb9b11f85$export$d75dc9d2c2174014.key]: 100
};
const $28d0336eb9b11f85$export$3094a3221df5ea5d = {
    [$28d0336eb9b11f85$export$75dfb738e6f28040.key]: 100
};
const $28d0336eb9b11f85$export$9767915495221593 = {
    [$28d0336eb9b11f85$export$e9b3f7442c87b29e.key]: 100,
    [$28d0336eb9b11f85$export$1031423c8b45d874.key]: 200,
    [$28d0336eb9b11f85$export$afcf8724bfd1844e.key]: 300
};













// Disable no-re-export here, this is a useful mapping file for icon lookup used in multiple places
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $372k4 = parcelRequire("372k4");


var $2v0Un = parcelRequire("2v0Un");


var $j0Bn2 = parcelRequire("j0Bn2");

const $997a4dc2b55c47ef$export$ca3f839074508470 = {
    top: (0, (/*@__PURE__*/$parcel$interopDefault($j0Bn2))),
    middle: (0, (/*@__PURE__*/$parcel$interopDefault($2v0Un))),
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($372k4)))
};


const $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c = ({ api: api, label: label, value: value })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const isSelected = selectedLayoutColumns?.selectedLayoutColumns.every(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) === value) ?? false;
    const Icon = (0, $997a4dc2b55c47ef$export$ca3f839074508470)[value];
    const onClick = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(api?.layout?.commands.setLayoutColumnValign({
            valign: value
        }));
    }, [
        api,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            size: "small"
        }),
        isSelected: isSelected,
        onClick: onClick,
        role: "menuitemradio"
    }, formatMessage(label));
};












var $97uS1 = parcelRequire("97uS1");

var $gk3KR = parcelRequire("gk3KR");




const $c1b8ce3f8bcd5031$export$711d24ebe8961c4c = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedLayoutColumns = (0, $f7560e5d01f47387$export$b5775257132e9ca7)(api);
    const currentValign = (0, $cozmU.useMemo)(()=>{
        const selectedColumns = selectedLayoutColumns?.selectedLayoutColumns;
        const firstColumn = selectedColumns?.[0];
        const firstValign = (0, $165a594884c31a30$export$3645821254ad9933)(firstColumn?.node);
        if (!firstValign || !selectedColumns?.every(({ node: node })=>(0, $165a594884c31a30$export$3645821254ad9933)(node) === firstValign)) return undefined;
        return firstValign;
    }, [
        selectedLayoutColumns
    ]);
    const TriggerIcon = currentValign ? (0, $997a4dc2b55c47ef$export$ca3f839074508470)[currentValign] : (0, $997a4dc2b55c47ef$export$ca3f839074508470).middle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerIcon, {
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97uS1.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $72OpT.toolbarMessages).alignColumn)
    }, children);
};


const $ebaa5b0b8f496848$var$LayoutColumnMenuContainer = ({ children: children })=>{
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQrHJ.ToolbarMenuContainer), {
        ref: setOutsideClickTargetRef
    }, children);
};
const $ebaa5b0b8f496848$export$ebf2330b4a9986ef = {
    'menu-section': ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, children)
};
const $ebaa5b0b8f496848$export$dd3a9dfb7a54acb6 = ({ api: api })=>{
    return [
        {
            ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
            component: $ebaa5b0b8f496848$var$LayoutColumnMenuContainer
        },
        {
            ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
                    rank: (0, $28d0336eb9b11f85$export$5a7b98ab4e990db4)[(0, $28d0336eb9b11f85$export$eb99a60802d2824d).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$3e4da34ad142735a),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $778bf6704af08265$export$81334f287bddf48), {
                    api: api,
                    side: "left"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$3e4da34ad142735a).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$167d9b289da7ec90),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $778bf6704af08265$export$81334f287bddf48), {
                    api: api,
                    side: "right"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$167d9b289da7ec90).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$3497442ae78aae72),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9befd911426fdde2$export$38f325b1b0b6a59f), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$3497442ae78aae72).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$b015955eb6c647e8),
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1b8ce3f8bcd5031$export$711d24ebe8961c4c), {
                    api: api
                }, children),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$eb99a60802d2824d),
                    rank: (0, $28d0336eb9b11f85$export$c1497fcad4589239)[(0, $28d0336eb9b11f85$export$b015955eb6c647e8).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$b015955eb6c647e8),
                    rank: (0, $28d0336eb9b11f85$export$3094a3221df5ea5d)[(0, $28d0336eb9b11f85$export$75dfb738e6f28040).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$e9b3f7442c87b29e),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnTop,
                    value: "top"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$e9b3f7442c87b29e).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$1031423c8b45d874),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnMiddle,
                    value: "middle"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$1031423c8b45d874).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$afcf8724bfd1844e),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bfd6a382df5ccef$export$d49b4cfa8d7eb46c), {
                    api: api,
                    label: (0, $72OpT.toolbarMessages).alignColumnBottom,
                    value: "bottom"
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$75dfb738e6f28040),
                    rank: (0, $28d0336eb9b11f85$export$9767915495221593)[(0, $28d0336eb9b11f85$export$afcf8724bfd1844e).key]
                }
            ]
        },
        // --- Danger section (Delete column) ---
        {
            ...(0, $28d0336eb9b11f85$export$4586103d528537d),
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, children),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$9d94e89ca7612d27),
                    rank: (0, $28d0336eb9b11f85$export$5a7b98ab4e990db4)[(0, $28d0336eb9b11f85$export$4586103d528537d).key]
                }
            ]
        },
        {
            ...(0, $28d0336eb9b11f85$export$d75dc9d2c2174014),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $228ccbfff683bd0e$export$5829d448eda3ac0f), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $28d0336eb9b11f85$export$4586103d528537d),
                    rank: (0, $28d0336eb9b11f85$export$179c00b952ce20ad)[(0, $28d0336eb9b11f85$export$d75dc9d2c2174014).key]
                }
            ]
        }
    ];
};




var $1jz5K = parcelRequire("1jz5K");




const $85dec3f17311051f$export$77b285c1046f5dc3 = [
    0,
    4
];
const $85dec3f17311051f$export$a85161024ee45645 = [
    0,
    2
];
const $85dec3f17311051f$export$3013a80cece37d81 = ()=>{
    if (!(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1')) return {
        alignX: undefined,
        alignY: undefined,
        offset: $85dec3f17311051f$export$a85161024ee45645,
        useManualBelowFlip: false
    };
    return {
        alignX: 'center',
        alignY: 'top',
        offset: $85dec3f17311051f$export$77b285c1046f5dc3,
        useManualBelowFlip: true
    };
};
const $85dec3f17311051f$var$getVisibleEditorAreaTop = (editorView, scrollableElement)=>{
    const visibleEditorArea = scrollableElement || (0, $1jz5K.findOverflowScrollParent)(editorView.dom);
    return Math.max(visibleEditorArea ? visibleEditorArea.getBoundingClientRect().top : 0, 0);
};
const $85dec3f17311051f$export$9a58f676ae761743 = ({ editorView: editorView, popup: popup, scrollableElement: scrollableElement, target: target })=>{
    const [, offsetY] = $85dec3f17311051f$export$77b285c1046f5dc3;
    const spaceAbove = target.getBoundingClientRect().top - $85dec3f17311051f$var$getVisibleEditorAreaTop(editorView, scrollableElement);
    const popupHeight = popup.getBoundingClientRect().height || popup.clientHeight;
    return spaceAbove <= popupHeight + offsetY;
};
const $85dec3f17311051f$export$653c6b7fb0f7ffcd = (position, target, popup)=>{
    if (!(popup.offsetParent instanceof HTMLElement)) return position;
    const offsetParent = popup.offsetParent;
    const borderBottomWidth = parseInt(window.getComputedStyle(offsetParent).borderBottomWidth, 10) || 0;
    const { top: offsetParentTop } = offsetParent.getBoundingClientRect();
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const [, offsetY] = $85dec3f17311051f$export$77b285c1046f5dc3;
    const top = Math.ceil(targetTop - offsetParentTop + targetHeight + (offsetParent === offsetParent.ownerDocument.body ? 0 : offsetParent.scrollTop) - borderBottomWidth + offsetY);
    const positionWithoutBottom = {
        ...position
    };
    delete positionWithoutBottom.bottom;
    return {
        ...positionWithoutBottom,
        top: top
    };
};


const $ddefb01754ec395f$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $ddefb01754ec395f$var$TOOLBAR_MENU_SELECTOR = '[data-toolbar-component="menu"]';
const $ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
/**
 * Returns the drag handle button for the selected layout column.
 */ const $ddefb01754ec395f$var$getLayoutColumnMenuTarget = (editorView, selection, anchorPosFromHandle)=>{
    const anchorPos = selection && (0, $165a594884c31a30$export$22b40f2459c71fe8)(selection, anchorPosFromHandle);
    if (anchorPos === undefined) return null;
    const columnDomRef = editorView.nodeDOM(anchorPos);
    if (!(columnDomRef instanceof HTMLElement)) return null;
    const dragHandleContainer = columnDomRef.parentElement?.querySelector(':scope > [data-blocks-drag-handle-container]');
    return dragHandleContainer?.querySelector((0, $kAPZe.DRAG_HANDLE_SELECTOR));
};
const $ddefb01754ec395f$var$focusTrap = {
    initialFocus: undefined
};
const $ddefb01754ec395f$export$7050b81bb37a7c70 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function LayoutColumnMenu({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement }) {
    const { isLayoutColumnMenuOpen: isLayoutColumnMenuOpen, layoutColumnMenuAnchorPos: layoutColumnMenuAnchorPos, openedViaKeyboard: openedViaKeyboard, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'layout',
        'selection'
    ], (states)=>({
            isLayoutColumnMenuOpen: states.layoutState?.isLayoutColumnMenuOpen ?? false,
            layoutColumnMenuAnchorPos: states.layoutState?.layoutColumnMenuAnchorPos,
            openedViaKeyboard: states.layoutState?.layoutColumnMenuOpenedViaKeyboard ?? false,
            selection: states.selectionState?.selection
        }));
    const closeLayoutColumnMenu = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute(api?.layout?.commands.toggleLayoutColumnMenu({
            isOpen: false
        }));
    }, [
        api
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        if (event.target instanceof Element && (event.target.closest($ddefb01754ec395f$var$TOOLBAR_MENU_SELECTOR) || event.target.closest($ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR))) return;
        // Clicking a drag handle should let the drag handle's own click handler
        // update selection/menu state. Treating it as a generic outside click
        // races that transaction and can immediately close the layout column menu.
        if (event.target instanceof Element && event.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR))) return;
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleArrowKeyNavigationClose = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const shouldDisableArrowKeyNavigation = (0, $cozmU.useCallback)((event)=>{
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.closest($ddefb01754ec395f$var$NESTED_DROPDOWN_MENU_SELECTOR) !== null;
    }, []);
    const menuWrapperRef = (0, $cozmU.useRef)(null);
    const handleMenuKeyDown = (0, $cozmU.useCallback)((event)=>{
        // Keep menu keyboard events scoped to the menu while preserving Escape and
        // ArrowUp/ArrowDown handling from Popup and ArrowKeyNavigationProvider.
        if (event.key !== 'Escape' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') event.stopPropagation();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const menuWrapper = menuWrapperRef.current;
        if (!isLayoutColumnMenuOpen || !menuWrapper) return;
        return (0, $cbY7C.bind)(menuWrapper, {
            type: 'keydown',
            listener: handleMenuKeyDown
        });
    }, [
        handleMenuKeyDown,
        isLayoutColumnMenuOpen
    ]);
    const components = api?.uiControlRegistry?.actions.getComponents((0, $28d0336eb9b11f85$export$9d94e89ca7612d27).key) ?? [];
    const target = (0, $cozmU.useMemo)(()=>isLayoutColumnMenuOpen ? $ddefb01754ec395f$var$getLayoutColumnMenuTarget(editorView, selection, layoutColumnMenuAnchorPos) : null, [
        editorView,
        isLayoutColumnMenuOpen,
        layoutColumnMenuAnchorPos,
        selection
    ]);
    const hasValidTarget = target instanceof HTMLElement;
    const positionLayoutColumnMenu = (0, $cozmU.useCallback)((position)=>{
        const popup = menuWrapperRef.current?.parentElement;
        if (!(target instanceof HTMLElement) || !(popup instanceof HTMLElement)) return position;
        if ((0, $85dec3f17311051f$export$9a58f676ae761743)({
            editorView: editorView,
            popup: popup,
            scrollableElement: scrollableElement,
            target: target
        })) return (0, $85dec3f17311051f$export$653c6b7fb0f7ffcd)(position, target, popup);
        return position;
    }, [
        editorView,
        scrollableElement,
        target
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLayoutColumnMenuOpen && (!hasValidTarget || components.length === 0)) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu,
        components.length,
        hasValidTarget,
        isLayoutColumnMenuOpen
    ]);
    const { alignX: alignX, alignY: alignY, offset: offset, useManualBelowFlip: useManualBelowFlip } = (0, $cozmU.useMemo)(()=>(0, $85dec3f17311051f$export$3013a80cece37d81)(), []);
    if (!isLayoutColumnMenuOpen || components.length === 0 || !hasValidTarget) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ddefb01754ec395f$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        alignX: alignX,
        alignY: alignY,
        forcePlacement: true,
        preventOverflow: true,
        stick: true,
        offset: offset,
        onPositionCalculated: useManualBelowFlip ? positionLayoutColumnMenu : undefined,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: closeLayoutColumnMenu,
        focusTrap: openedViaKeyboard ? $ddefb01754ec395f$var$focusTrap : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: menuWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3v5aK.UserIntentPopupWrapper), {
        api: api,
        userIntent: "layoutColumnMenuPopupOpen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwf4Z.ToolbarDropdownMenuProvider), {
        isOpen: isLayoutColumnMenuOpen,
        setIsOpen: handleSetIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
        type: (0, $9RT19.ArrowKeyNavigationType).MENU,
        handleClose: handleArrowKeyNavigationClose,
        disableArrowKeyNavigation: shouldDisableArrowKeyNavigation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQMlg.SurfaceRenderer), {
        components: components,
        fallbacks: (0, $ebaa5b0b8f496848$export$ebf2330b4a9986ef),
        surface: (0, $28d0336eb9b11f85$export$9d94e89ca7612d27)
    }))))));
});










var $2xhuI = parcelRequire("2xhuI");




var $g6uqx = parcelRequire("g6uqx");








var $fHs3z = parcelRequire("fHs3z");





var $8p5GO = parcelRequire("8p5GO");


var $fHdH6 = parcelRequire("fHdH6");


var $5skpJ = parcelRequire("5skpJ");





var $fWx9I = parcelRequire("fWx9I");


var $8AMT2 = parcelRequire("8AMT2");





var $anBbz = parcelRequire("anBbz");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $3ymEf = parcelRequire("3ymEf");


var $bhIPc = parcelRequire("bhIPc");

function $17a886394e2f3375$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $17a886394e2f3375$var$wrapperStyle = {
    name: "dzd8y1",
    styles: "padding:0 4px"
};
const $17a886394e2f3375$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $17a886394e2f3375$var$wrapperStyle
    }, children);
};
const $17a886394e2f3375$export$3cfd1ab6a9856e7e = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($17a886394e2f3375$var$Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ymEf))), {
        label: ""
    }));
};
const $17a886394e2f3375$export$38b01bd15f6a5487 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($17a886394e2f3375$var$Wrapper, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bhIPc))), {
        label: ""
    }));
};






var $ctpKQ = parcelRequire("ctpKQ");

const $edfa58548f6e7d13$export$4518caee70c71b2e = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctpKQ))), props);
};






var $4dPfL = parcelRequire("4dPfL");

const $77daa6a3fae9f080$export$36efe6f2091df089 = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4dPfL))), props);
};


const $34cb090319fea2f7$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $72OpT.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eQpqk)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $72OpT.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHdH6)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $72OpT.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8p5GO)))
    },
    ...$34cb090319fea2f7$var$LAYOUT_TYPES
];
const $34cb090319fea2f7$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $72OpT.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8AMT2)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $72OpT.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fWx9I)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5skpJ)))
    }
];
// These are used for advanced layout options
const $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION_OLD = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $72OpT.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eQpqk)))
    },
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $72OpT.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8AMT2)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $72OpT.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fWx9I)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION_OLD = [
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $72OpT.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHdH6)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5skpJ)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $77daa6a3fae9f080$export$36efe6f2091df089),
        iconFallback: (0, $77daa6a3fae9f080$export$36efe6f2091df089)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $edfa58548f6e7d13$export$4518caee70c71b2e),
        iconFallback: (0, $edfa58548f6e7d13$export$4518caee70c71b2e)
    }
];
const $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $72OpT.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8AMT2)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $72OpT.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fWx9I)))
    }
];
const $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5skpJ)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $77daa6a3fae9f080$export$36efe6f2091df089),
        iconFallback: (0, $77daa6a3fae9f080$export$36efe6f2091df089)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $72OpT.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $edfa58548f6e7d13$export$4518caee70c71b2e),
        iconFallback: (0, $edfa58548f6e7d13$export$4518caee70c71b2e)
    }
];
const $34cb090319fea2f7$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        iconFallback: item.iconFallback,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $34cb090319fea2f7$export$cbec87ad92a1069a = 'Layout floating controls';
const $34cb090319fea2f7$var$iconPlaceholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
    label: ""
}); // TODO: ED-25466 - Replace with proper icon
const $34cb090319fea2f7$var$getLayoutColumnsIcons = (colCount)=>{
    if (!(0, $fqVYq.editorExperiment)('single_column_layouts', true) && !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return undefined;
    switch(colCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8p5GO))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQpqk))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHdH6))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17a886394e2f3375$export$38b01bd15f6a5487), null);
        case 5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17a886394e2f3375$export$3cfd1ab6a9856e7e), null);
        default:
            return undefined;
    }
};
const $34cb090319fea2f7$var$getLayoutColumnWidths = (node)=>{
    return node.children.map((child)=>child.attrs.width);
};
const $34cb090319fea2f7$var$getAdvancedLayoutItems = ({ addSidebarLayouts: addSidebarLayouts, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, node: node, nodeType: nodeType, separator: separator, deleteButton: deleteButton, currentLayout: currentLayout, allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout })=>{
    const numberOfColumns = node.content.childCount || 2;
    const isLayoutColumnMenuEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true);
    const distributionOptions = isLayoutColumnMenuEnabled ? numberOfColumns === 2 ? $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION : numberOfColumns === 3 ? $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION : [] : numberOfColumns === 2 ? $34cb090319fea2f7$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION_OLD : numberOfColumns === 3 ? $34cb090319fea2f7$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION_OLD : [];
    const columnOptions = [
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 2
            }),
            //'2-columns',
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(2) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('two_equal'),
            selected: numberOfColumns === 2
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 3
            }),
            //'3-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(3) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('three_equal'),
            selected: numberOfColumns === 3
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 4
            }),
            //'4-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(4) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('four_equal'),
            selected: numberOfColumns === 4
        },
        {
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: 5
            }),
            //'5-columns'
            icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(5) || $34cb090319fea2f7$var$iconPlaceholder,
            onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('five_equal'),
            selected: numberOfColumns === 5
        }
    ];
    const dropdownOptions = [
        ...allowAdvancedSingleColumnLayout ? [
            {
                title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                    count: 1
                }),
                //'1-columns',
                icon: $34cb090319fea2f7$var$getLayoutColumnsIcons(1) || $34cb090319fea2f7$var$iconPlaceholder,
                onClick: (0, $20de433b9f6c9d19$export$6bb7269b95fae539)(editorAnalyticsAPI)('single'),
                selected: numberOfColumns === 1
            }
        ] : [],
        ...columnOptions
    ];
    const distributeColumnsButton = isLayoutColumnMenuEnabled && numberOfColumns > 1 ? {
        disabled: (0, $c44623e798e01dfd$export$3cbb23b573ffb2e9)($34cb090319fea2f7$var$getLayoutColumnWidths(node)),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))),
        onClick: (editorState, dispatch)=>{
            const tr = (0, $20de433b9f6c9d19$export$3155fb5f705eeef0)(editorAnalyticsAPI)({
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                target: 'allColumns'
            })({
                tr: editorState.tr
            });
            if (!tr) return false;
            dispatch?.(tr);
            return true;
        },
        testId: 'layout-distribute-columns',
        title: intl.formatMessage((0, $72OpT.toolbarMessages).distributeColumns),
        type: 'button'
    } : undefined;
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage((0, $72OpT.toolbarMessages).columnOption, {
                count: numberOfColumns
            }),
            //`${numberOfColumns}-columns`,
            options: dropdownOptions,
            showSelected: true,
            testId: 'column-options-button'
        },
        ...distributionOptions.length > 0 || distributeColumnsButton ? [
            separator
        ] : [],
        ...addSidebarLayouts ? distributionOptions.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : [],
        ...distributeColumnsButton ? [
            distributeColumnsButton
        ] : []
    ];
};
const $34cb090319fea2f7$var$fullHeightSeparator = {
    type: 'separator',
    fullHeight: true
};
const $34cb090319fea2f7$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api)=>{
    const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    const node = state.doc.nodeAt(pos);
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    if (node) {
        const currentLayout = (0, $20de433b9f6c9d19$export$e406155610be725b)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            testId: (0, $2xhuI.default).remove.id,
            title: intl.formatMessage((0, $2xhuI.default).remove),
            onClick: (0, $20de433b9f6c9d19$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
            onMouseEnter: hoverDecoration?.(nodeType, true),
            onMouseLeave: hoverDecoration?.(nodeType, false),
            onFocus: hoverDecoration?.(nodeType, true),
            onBlur: hoverDecoration?.(nodeType, false),
            tabIndex: null
        };
        const copyButton = {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: nodeType
                }
            ]
        };
        const layoutTypes = allowSingleColumnLayout ? $34cb090319fea2f7$var$LAYOUT_TYPES_WITH_SINGLE_COL : $34cb090319fea2f7$var$LAYOUT_TYPES;
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'layout-overflow-dropdown-trigger';
        const overflowMenu = {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                    onClick: ()=>{
                        api?.core?.actions.execute(// @ts-ignore
                        api?.floatingToolbar?.commands.copyNode(nodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
                },
                {
                    title: intl.formatMessage((0, $2xhuI.default).delete),
                    onClick: (0, $20de433b9f6c9d19$export$7472487719e2c16f)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        };
        return {
            title: $34cb090319fea2f7$export$cbec87ad92a1069a,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $bjg0G.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $72OpT.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...(0, $fqVYq.editorExperiment)('advanced_layouts', true) ? $34cb090319fea2f7$var$getAdvancedLayoutItems({
                    addSidebarLayouts: addSidebarLayouts,
                    intl: intl,
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    nodeType: nodeType,
                    node: node,
                    separator: separator,
                    deleteButton: deleteButton,
                    currentLayout: currentLayout,
                    allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout
                }) : [
                    ...layoutTypes.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                    ...addSidebarLayouts ? $34cb090319fea2f7$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$34cb090319fea2f7$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
                ],
                ...toolbarFlagsEnabled ? [
                    $34cb090319fea2f7$var$fullHeightSeparator,
                    overflowMenu
                ] : [
                    separator,
                    copyButton,
                    separator,
                    deleteButton
                ]
            ],
            scrollable: true
        };
    }
    return;
};


const $da7a0fed9b537896$var$LAYOUT_SECTION_NODE_NAME = 'layoutSection';
const $da7a0fed9b537896$export$abf76f127fb6937c = (tr)=>{
    if (!(0, $fqVYq.editorExperiment)('single_column_layouts', true)) return tr;
    const { layoutSection: layoutSection, paragraph: paragraph } = tr.doc.type.schema.nodes;
    const nodeWithPos = (0, $bjg0G.findParentNode)((node)=>node.type === layoutSection)(tr.selection);
    if (!nodeWithPos || !nodeWithPos.node || nodeWithPos.node.type.name !== 'layoutSection' || nodeWithPos.node.firstChild?.firstChild?.type !== paragraph) return tr;
    // set text selection at the beginning of the layout section
    // will set the selection to the first column
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, nodeWithPos.pos));
    return tr;
};
const $da7a0fed9b537896$export$2229806460c545ea = ({ config: options = {}, api: api })=>{
    const allowAdvancedSingleColumnLayout = (0, $fqVYq.editorExperiment)('advanced_layouts', true) && (0, $fqVYq.editorExperiment)('single_column_layouts', true, {
        exposure: true
    });
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]
            },
            component: (0, $d682813aeb2e73a4$export$83047c2fe2258f8)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($da7a0fed9b537896$var$LAYOUT_SECTION_NODE_NAME))
        }
    ]);
    if ((0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) api?.uiControlRegistry?.actions.register((0, $ebaa5b0b8f496848$export$dd3a9dfb7a54acb6)({
        api: api
    }));
    return {
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $6OV8L.layoutSectionWithSingleColumnLocalId) : (0, $6OV8L.layoutSectionWithSingleColumn) : (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $6OV8L.layoutSectionWithLocalId) : (0, $6OV8L.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $6UUJT.layoutColumnWithLocalId) : (0, $6UUJT.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'layout',
                    plugin: ()=>(0, $d12416bdd3b8a88f$export$2e2bcd8739ae039)(options, api?.analytics?.actions)
                }
            ];
            if ((0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) plugins.push({
                name: 'layoutKeymap',
                plugin: ()=>(0, $85a43829160bedc9$export$2e2bcd8739ae039)({
                        api: api
                    })
            });
            if ((options.editorAppearance === 'full-page' || options.editorAppearance === 'full-width' || options.editorAppearance === 'max' && (0, $fqVYq.editorExperiment)('platform_editor_layout_column_resize_handle', true)) && api && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) plugins.push({
                name: 'layoutResizing',
                plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>(0, $263e2eabc1c558a4$export$2e2bcd8739ae039)(options, api, portalProviderAPI, eventDispatcher, getIntl())
            });
            return plugins;
        },
        actions: {
            insertLayoutColumns: (0, $20de433b9f6c9d19$export$3517c001098bb0a9)(api?.analytics?.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const layoutState = (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(state);
                if (!layoutState) return undefined;
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout, isResizing: isResizing } = layoutState;
                const shouldHideToolbar = isResizing && (0, $fqVYq.editorExperiment)('single_column_layouts', true);
                if (pos !== null && !shouldHideToolbar) return (0, $34cb090319fea2f7$export$6dd6ab35df8f7f86)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: ({ formatMessage: formatMessage })=>{
                const withInsertLayoutAnalytics = (tr, columnCount)=>{
                    api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).INSERTED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
                        attributes: {
                            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                            columnCount: columnCount
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK
                    })(tr);
                    return tr;
                };
                if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
                    const advancedSingleColumnOption = allowAdvancedSingleColumnLayout ? [
                        {
                            id: 'onecolumnlayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).singleColumnAdvancedLayout),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).singleColumnsDescriptionAdvancedLayout),
                            keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'single column'
                            ] : [
                                'layout',
                                'column',
                                'section',
                                'single column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconOneColumnLayout), null),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 1));
                                if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 1);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        }
                    ] : [];
                    if ((0, $ieeJu.expValEquals)('platform_editor_layout_typeahead_reorder', 'isEnabled', true)) {
                        const createAdvancedColumnLayoutOption = ({ columnCount: columnCount, descriptionColumnCount: descriptionColumnCount, icon: Icon, id: id, keyword: keyword, title: title })=>({
                                id: id,
                                title: title,
                                description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                    numberOfColumns: descriptionColumnCount
                                }),
                                keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                    'layout',
                                    'column',
                                    'section',
                                    'col',
                                    keyword
                                ] : [
                                    'layout',
                                    'column',
                                    'section',
                                    keyword
                                ],
                                priority: 1100,
                                icon: Icon,
                                action (insert, state) {
                                    const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, columnCount));
                                    if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, columnCount);
                                    else withInsertLayoutAnalytics(tr);
                                    $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                    return tr;
                                }
                            });
                        return [
                            createAdvancedColumnLayoutOption({
                                columnCount: 2,
                                descriptionColumnCount: 'two',
                                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconTwoColumnLayout), null),
                                id: 'twocolumnslayout',
                                keyword: 'two column',
                                title: formatMessage((0, $72OpT.toolbarMessages).twoColumnsAdvancedLayout)
                            }),
                            ...advancedSingleColumnOption,
                            createAdvancedColumnLayoutOption({
                                columnCount: 3,
                                descriptionColumnCount: 'three',
                                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconThreeColumnLayout), null),
                                id: 'threecolumnslayout',
                                keyword: 'three column',
                                title: formatMessage((0, $72OpT.toolbarMessages).threeColumnsAdvancedLayout)
                            }),
                            createAdvancedColumnLayoutOption({
                                columnCount: 4,
                                descriptionColumnCount: 'four',
                                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconFourColumnLayout), null),
                                id: 'fourcolumnslayout',
                                keyword: 'four column',
                                title: formatMessage((0, $72OpT.toolbarMessages).fourColumns)
                            }),
                            createAdvancedColumnLayoutOption({
                                columnCount: 5,
                                descriptionColumnCount: 'five',
                                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconFiveColumnLayout), null),
                                id: 'fivecolumnslayout',
                                keyword: 'five column',
                                title: formatMessage((0, $72OpT.toolbarMessages).fiveColumns)
                            })
                        ];
                    }
                    return [
                        ...advancedSingleColumnOption,
                        {
                            id: 'twocolumnslayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).twoColumnsAdvancedLayout),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: 'two'
                            }),
                            keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'two column'
                            ] : [
                                'layout',
                                'column',
                                'section',
                                'two column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconTwoColumnLayout), null),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 2));
                                if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 2);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        },
                        {
                            id: 'threecolumnslayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).threeColumnsAdvancedLayout),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: 'three'
                            }),
                            keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'three column'
                            ] : [
                                'layout',
                                'column',
                                'section',
                                'three column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconThreeColumnLayout), null),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 3));
                                if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 3);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        },
                        {
                            id: 'fourcolumnslayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).fourColumns),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: 'four'
                            }),
                            keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'four column'
                            ] : [
                                'layout',
                                'column',
                                'section',
                                'four column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconFourColumnLayout), null),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 4));
                                if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 4);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        },
                        {
                            id: 'fivecolumnslayout',
                            title: formatMessage((0, $72OpT.toolbarMessages).fiveColumns),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: 'five'
                            }),
                            keywords: (0, $ieeJu.expValEquals)('platform_editor_layout_keywords', 'isEnabled', true) ? [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'five column'
                            ] : [
                                'layout',
                                'column',
                                'section',
                                'five column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconFiveColumnLayout), null),
                            action (insert, state) {
                                const tr = insert((0, $20de433b9f6c9d19$export$af0aef1ee58dfcf)(state, 5));
                                if ((0, $ixfCV.fg)('platform_editor_column_count_analytics')) withInsertLayoutAnalytics(tr, 5);
                                else withInsertLayoutAnalytics(tr);
                                $da7a0fed9b537896$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        }
                    ];
                } else return [
                    {
                        id: 'layout',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconLayout), null),
                        action (insert, state) {
                            const tr = insert((0, $20de433b9f6c9d19$export$24df8f7ba30643b8)(state));
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46d3039b880758a7$export$cc5403d58ddfa812), null) : null, (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true) && editorView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ddefb01754ec395f$export$7050b81bb37a7c70), {
                api: api,
                editorView: editorView,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            }) : null);
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $4b9fd8b3928d914b$export$18d4026d1ea86bb1).getState(editorState);
        },
        commands: {
            deleteLayoutColumn: (options)=>(0, $20de433b9f6c9d19$export$b3b830a5fba26889)(options, api?.analytics?.actions, api),
            distributeLayoutColumns: (options)=>(0, $20de433b9f6c9d19$export$3155fb5f705eeef0)(api?.analytics?.actions, api)(options),
            insertLayoutColumn: (options)=>(0, $20de433b9f6c9d19$export$7dcaf37842fa555e)(options, api?.analytics?.actions, api),
            setLayoutColumnDangerPreview: $20de433b9f6c9d19$export$21f559cd4fbd479,
            setLayoutColumnValign: (options)=>(0, $20de433b9f6c9d19$export$4bf533320bf88c4)(options, api?.analytics?.actions, api),
            toggleLayoutColumnMenu: $20de433b9f6c9d19$export$f9a5c2c84987525d
        }
    };
};
module.exports["layoutPlugin"] = $da7a0fed9b537896$export$2229806460c545ea;

});

parcelRegister("97uS1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aDSIl = parcelRequire("aDSIl");

const $f07401c5213df202$export$e350497c7f50f900 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing } = t0;
    let t1;
    if ($[0] !== color || $[1] !== label || $[2] !== shouldRecommendSmallIcon || $[3] !== spacing || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: label,
            testId: testId,
            color: color,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: "small"
        });
        $[0] = color;
        $[1] = label;
        $[2] = shouldRecommendSmallIcon;
        $[3] = spacing;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });
module.exports["NestedDropdownRightIcon"] = $f07401c5213df202$export$e350497c7f50f900;

});

parcelRegister("5bzSg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kpCD8 = parcelRequire("kpCD8");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $c2smn = parcelRequire("c2smn");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");








var $794I6 = parcelRequire("794I6");


var $Igylv = parcelRequire("Igylv");







const $d677bd9d75b85608$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider
    };
};
const $d677bd9d75b85608$export$669acb2735f045dd = (pluginInjectionApi)=>{
    const { mediaProvider: mediaProvider } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $d677bd9d75b85608$var$selector);
    const provider = (0, $cozmU.useMemo)(()=>{
        return mediaProvider;
    }, [
        mediaProvider
    ]);
    return provider;
};



var $b7Tum = parcelRequire("b7Tum");





var $kSwu1 = parcelRequire("kSwu1");


var $2InGJ = parcelRequire("2InGJ");




const $4b1307226cea6929$export$788459419c7c9712 = (0, $kSwu1.defineMessages)({
    mediaGroupDeleteLabel: {
        id: "fabric.editor.mediaGroupDeleteLabel",
        defaultMessage: "delete"
    }
});



var $gWBVp = parcelRequire("gWBVp");

var $1HOhD = parcelRequire("1HOhD");

var $eS0D9 = parcelRequire("eS0D9");


var $l3wuH = parcelRequire("l3wuH");








var $17wiG = parcelRequire("17wiG");

var $3lbOc = parcelRequire("3lbOc");

var $gjPL4 = parcelRequire("gjPL4");


var $8TTbR = parcelRequire("8TTbR");

let $7bc5defc72c4131c$var$lastKey = 1;
const $7bc5defc72c4131c$var$identifiersMap = new Map();
const $7bc5defc72c4131c$export$5d5de19b6d92a058 = (identifier)=>{
    switch(identifier.mediaItemType){
        case 'external-image':
            return identifier.dataURI;
        case 'file':
            if (typeof identifier.id === 'string') return identifier.id;
            else {
                const currentKey = $7bc5defc72c4131c$var$identifiersMap.get(identifier.id);
                if (currentKey) return currentKey;
                // We want to increment the key before using it
                $7bc5defc72c4131c$var$lastKey++;
                const newKey = `${$7bc5defc72c4131c$var$lastKey}`;
                $7bc5defc72c4131c$var$identifiersMap.set(identifier.id, newKey);
                return newKey;
            }
    }
};



var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $gIMcb = parcelRequire("gIMcb");

var $3Uz4b = parcelRequire("3Uz4b");













var $PGUCj = parcelRequire("PGUCj");

function $dfca5b518d576f73$export$5cae361ad82dce8b(value) {
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
const $dfca5b518d576f73$var$DeduplicatedFilmStripInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, testId: t1, isLazy: isLazy, fallbackMediaNameFetcher: fallbackMediaNameFetcher } = t0;
    const testId = t1 === undefined ? "media-filmstrip" : t1;
    const [animate, setAnimate] = (0, $cozmU.useState)(false);
    const [offset, setOffset] = (0, $cozmU.useState)(0);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (t3)=>{
            const { offset: offset_0 } = t3;
            setOffset(offset_0);
        };
        $[0] = t2;
    } else t2 = $[0];
    const handleSize = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (t4)=>{
            const { animate: animate_0, offset: offset_1 } = t4;
            setAnimate(animate_0);
            setOffset(offset_1);
        };
        $[1] = t3;
    } else t3 = $[1];
    const handleScroll = t3;
    let t4;
    if ($[2] !== items) {
        t4 = items.map($dfca5b518d576f73$var$_temp).filter((0, $PGUCj.isFileIdentifier));
        $[2] = items;
        $[3] = t4;
    } else t4 = $[3];
    const ids = t4;
    const fileHashes = (0, $3Uz4b.useFileHashes)(ids);
    let t5;
    if ($[4] !== fallbackMediaNameFetcher || $[5] !== featureFlags || $[6] !== fileHashes || $[7] !== isLazy || $[8] !== items || $[9] !== mediaClientConfig || $[10] !== shouldOpenMediaViewer || $[11] !== viewerOptions) {
        let t6;
        if ($[13] !== fileHashes || $[14] !== items) {
            t6 = (t7, i)=>{
                const { identifier: identifier_0 } = t7;
                return identifier_0.mediaItemType !== "file" || !fileHashes[identifier_0.id] || !items.some((currentItem, currI)=>currentItem.identifier.mediaItemType === "file" && currI < i && fileHashes[identifier_0.id] === fileHashes[currentItem.identifier.id]);
            };
            $[13] = fileHashes;
            $[14] = items;
            $[15] = t6;
        } else t6 = $[15];
        const uniqueItems = items.filter(t6);
        t5 = uniqueItems.map((item)=>{
            const key = (0, $7bc5defc72c4131c$export$5d5de19b6d92a058)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
                key: key,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? uniqueItems.map($dfca5b518d576f73$var$_temp2) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17wiG.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                includeHashForDuplicateFiles: true,
                isLazy: isLazy,
                fallbackMediaNameFetcher: fallbackMediaNameFetcher,
                ...item
            });
        });
        $[4] = fallbackMediaNameFetcher;
        $[5] = featureFlags;
        $[6] = fileHashes;
        $[7] = isLazy;
        $[8] = items;
        $[9] = mediaClientConfig;
        $[10] = shouldOpenMediaViewer;
        $[11] = viewerOptions;
        $[12] = t5;
    } else t5 = $[12];
    const cards = t5;
    let t6;
    if ($[16] !== animate || $[17] !== cards || $[18] !== offset || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8TTbR.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: handleSize,
            onScroll: handleScroll,
            testId: testId
        }, cards);
        $[16] = animate;
        $[17] = cards;
        $[18] = offset;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
} : ({ items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, testId: testId = 'media-filmstrip', isLazy: isLazy, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const [animate, setAnimate] = (0, $cozmU.useState)(false);
    const [offset, setOffset] = (0, $cozmU.useState)(0);
    const handleSize = ({ offset: offset_0 })=>{
        setOffset(offset_0);
    };
    const handleScroll = ({ animate: animate_0, offset: offset_1 })=>{
        setAnimate(animate_0);
        setOffset(offset_1);
    };
    const ids = (0, $cozmU.useMemo)(()=>items.map(({ identifier: identifier })=>identifier).filter((0, $PGUCj.isFileIdentifier)), [
        items
    ]);
    const fileHashes = (0, $3Uz4b.useFileHashes)(ids);
    const cards = (0, $cozmU.useMemo)(()=>{
        // filters only the first item when encountering duplicated hashes
        const uniqueItems = items.filter(({ identifier: identifier_0 }, i)=>identifier_0.mediaItemType !== 'file' || !fileHashes[identifier_0.id] || !items.some((currentItem, currI)=>currentItem.identifier.mediaItemType === 'file' && currI < i && fileHashes[identifier_0.id] === fileHashes[currentItem.identifier.id]));
        return uniqueItems.map((item)=>{
            const key = (0, $7bc5defc72c4131c$export$5d5de19b6d92a058)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
                key: key,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? uniqueItems.map((item_0)=>item_0.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17wiG.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                includeHashForDuplicateFiles: true,
                isLazy: isLazy,
                fallbackMediaNameFetcher: fallbackMediaNameFetcher,
                ...item
            });
        });
    }, [
        items,
        fileHashes,
        mediaClientConfig,
        shouldOpenMediaViewer,
        featureFlags,
        viewerOptions,
        isLazy,
        fallbackMediaNameFetcher
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8TTbR.FilmstripView), {
        animate: animate,
        offset: offset,
        onSize: handleSize,
        onScroll: handleScroll,
        testId: testId
    }, cards);
};
const $dfca5b518d576f73$var$EmptyFilmstripView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { items: items, testId: testId } = t0;
    let t1;
    if ($[0] !== items) {
        t1 = items.map($dfca5b518d576f73$var$_temp5);
        $[0] = items;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8TTbR.FilmstripView), {
            animate: false,
            offset: 0,
            onSize: $dfca5b518d576f73$var$_temp3,
            onScroll: $dfca5b518d576f73$var$_temp4,
            testId: testId
        }, t1);
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ items: items, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8TTbR.FilmstripView), {
        animate: false,
        offset: 0,
        onSize: ()=>{},
        onScroll: ()=>{},
        testId: testId
    }, items.map((item, _i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            key: (0, $7bc5defc72c4131c$export$5d5de19b6d92a058)(item.identifier),
            dimensions: (0, $gjPL4.defaultImageCardDimensions),
            interactionName: "media-filmstrip-card-loading"
        })));
};
const $dfca5b518d576f73$export$f2e48bfda187171f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$DeduplicatedFilmStripInternal, props) : !props.mediaClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$EmptyFilmstripView, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
                clientConfig: props.mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$DeduplicatedFilmStripInternal, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$DeduplicatedFilmStripInternal, props) : !props.mediaClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$EmptyFilmstripView, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientProvider), {
            clientConfig: props.mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dfca5b518d576f73$var$DeduplicatedFilmStripInternal, props)));
function $dfca5b518d576f73$var$_temp(t0) {
    const { identifier: identifier } = t0;
    return identifier;
}
function $dfca5b518d576f73$var$_temp2(item_0) {
    return item_0.identifier;
}
function $dfca5b518d576f73$var$_temp3() {}
function $dfca5b518d576f73$var$_temp4() {}
function $dfca5b518d576f73$var$_temp5(item, _i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        key: (0, $7bc5defc72c4131c$export$5d5de19b6d92a058)(item.identifier),
        dimensions: (0, $gjPL4.defaultImageCardDimensions),
        interactionName: "media-filmstrip-card-loading"
    });
}


class $97b84b045a0d4579$export$8be30a51dc0802a7 extends (0, $cozmU.Component) {
    renderCards() {
        const { items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, isLazy: isLazy } = this.props;
        return items.map((item)=>{
            const key = (0, $7bc5defc72c4131c$export$5d5de19b6d92a058)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
                key: key,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? items.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17wiG.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $gjPL4.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                isLazy: isLazy,
                fallbackMediaNameFetcher: this.props.fallbackMediaNameFetcher,
                ...item
            });
        });
    }
    render() {
        const { testId: testId = 'media-filmstrip', includeHashForDuplicateFiles: includeHashForDuplicateFiles } = this.props;
        if (includeHashForDuplicateFiles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfca5b518d576f73$export$f2e48bfda187171f), this.props);
        const { animate: animate, offset: offset } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8TTbR.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            testId: testId
        }, this.renderCards());
    }
    constructor(...args){
        super(...args);
        this.state = {
            animate: false,
            offset: 0
        };
        this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            });
        this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
    }
}









var $2mgqy = parcelRequire("2mgqy");


var $1wNII = parcelRequire("1wNII");

const $5820d7825c1fe8a2$var$getIdentifier = (item)=>{
    if (item.attrs.type === 'external') return {
        mediaItemType: 'external-image',
        dataURI: item.attrs.url
    };
    return {
        id: item.attrs.id,
        mediaItemType: 'file',
        collectionName: item.attrs.collection
    };
};
const $5820d7825c1fe8a2$var$isNodeSelected = (props)=>(mediaItemPos, mediaGroupPos)=>{
        const selected = (0, $gWBVp.isNodeSelectedOrInRange)(props.anchorPos, props.headPos, mediaGroupPos, props.nodeSize);
        if (selected === (0, $1HOhD.SelectedState).selectedInRange) return true;
        if (selected === (0, $1HOhD.SelectedState).selectedInside && props.anchorPos === mediaItemPos) return true;
        return false;
    };
const $5820d7825c1fe8a2$var$prepareFilmstripItem = ({ allowLazyLoading: allowLazyLoading, allowMediaInlineImages: allowMediaInlineImages, enableDownloadButton: enableDownloadButton, handleMediaNodeRemoval: handleMediaNodeRemoval, getPos: getPos, intl: intl, isMediaItemSelected: isMediaItemSelected, setMediaGroupNodeSelection: setMediaGroupNodeSelection, featureFlags: featureFlags })=>(item, idx)=>{
        // We declared this to get a fresh position every time
        const getNodePos = ()=>{
            const pos = getPos();
            if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
            // Because the original code would return NaN on runtime
            // We are just make it explict now.
            // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
            // TODO: ED-13910 - prosemirror-bump leftovers
            return NaN;
            return pos + idx + 1;
        };
        // Media Inline creates a floating toolbar with the same options, excludes these options if enabled
        const mediaInlineOptions = (allowMediaInline = false)=>{
            if (!allowMediaInline) return {
                shouldEnableDownloadButton: enableDownloadButton,
                actions: [
                    {
                        handler: handleMediaNodeRemoval.bind(null, undefined, getNodePos),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                            label: intl.formatMessage((0, $4b1307226cea6929$export$788459419c7c9712).mediaGroupDeleteLabel)
                        })
                    }
                ]
            };
        };
        const mediaGroupPos = getPos();
        return {
            identifier: $5820d7825c1fe8a2$var$getIdentifier(item),
            isLazy: allowLazyLoading,
            selected: isMediaItemSelected(getNodePos(), typeof mediaGroupPos === 'number' ? mediaGroupPos : NaN),
            onClick: ()=>{
                setMediaGroupNodeSelection(getNodePos());
            },
            ...mediaInlineOptions((0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : (0, $c2smn.getMediaFeatureFlag)('mediaInline', featureFlags))
        };
    };
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $5820d7825c1fe8a2$var$useLatestMediaGroupNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $2InGJ.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!previousMediaNode) return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $5820d7825c1fe8a2$var$runMediaNodeUpdate = async ({ mediaNodeUpdater: mediaNodeUpdater, getPos: getPos, node: node, updateAttrs: updateAttrs })=>{
    if (updateAttrs) await mediaNodeUpdater.updateNodeAttrs(getPos);
    const contextId = mediaNodeUpdater.getNodeContextId();
    if (!contextId) await mediaNodeUpdater.updateNodeContextId(getPos);
    const shouldNodeBeDeepCopied = await mediaNodeUpdater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) await mediaNodeUpdater.copyNodeFromPos(getPos, {
        traceId: node.attrs.__mediaTraceId
    });
};
const $5820d7825c1fe8a2$var$noop = ()=>{};
const $5820d7825c1fe8a2$export$7fbb084971a34492 = (0, $kSwu1.injectIntl)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { mediaOptions: { allowLazyLoading: allowLazyLoading, allowMediaInlineImages: allowMediaInlineImages, enableDownloadButton: enableDownloadButton, featureFlags: featureFlags, fallbackMediaNameFetcher: fallbackMediaNameFetcher }, intl: intl, getPos: getPos, anchorPos: anchorPos, headPos: headPos, view: view, disabled: disabled, editorViewMode: editorViewMode, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider, isCopyPasteEnabled: isCopyPasteEnabled } = props;
    const mediaGroupNode = $5820d7825c1fe8a2$var$useLatestMediaGroupNode(props.node);
    const mediaPluginState = (0, $cozmU.useMemo)(()=>{
        return (0, $2mgqy.stateKey).getState(view.state);
    }, [
        view.state
    ]);
    const mediaClientConfig = mediaPluginState?.mediaClientConfig;
    const handleMediaGroupUpdate = mediaPluginState?.handleMediaGroupUpdate;
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, $cozmU.useState)(undefined);
    const nodeSize = mediaGroupNode.nodeSize;
    const mediaNodesWithOffsets = (0, $cozmU.useMemo)(()=>{
        const result = [];
        mediaGroupNode.forEach((item, childOffset)=>{
            result.push({
                node: item,
                offset: childOffset
            });
        });
        return result;
    }, [
        mediaGroupNode
    ]);
    const previousMediaNodesWithOffsets = (0, $2InGJ.default)(mediaNodesWithOffsets);
    const handleMediaNodeRemoval = (0, $cozmU.useMemo)(()=>{
        return disabled || !mediaPluginState ? $5820d7825c1fe8a2$var$noop : mediaPluginState.handleMediaNodeRemoval;
    }, [
        disabled,
        mediaPluginState
    ]);
    const setMediaGroupNodeSelection = (0, $cozmU.useCallback)((pos)=>{
        (0, $eS0D9.setNodeSelection)(view, pos);
    }, [
        view
    ]);
    const isMediaItemSelected = (0, $cozmU.useMemo)(()=>{
        return $5820d7825c1fe8a2$var$isNodeSelected({
            anchorPos: anchorPos,
            headPos: headPos,
            nodeSize: nodeSize
        });
    }, [
        anchorPos,
        headPos,
        nodeSize
    ]);
    const filmstripItem = (0, $cozmU.useMemo)(()=>{
        return $5820d7825c1fe8a2$var$prepareFilmstripItem({
            allowLazyLoading: allowLazyLoading,
            allowMediaInlineImages: allowMediaInlineImages,
            enableDownloadButton: enableDownloadButton,
            handleMediaNodeRemoval: handleMediaNodeRemoval,
            getPos: getPos,
            intl: intl,
            isMediaItemSelected: isMediaItemSelected,
            setMediaGroupNodeSelection: setMediaGroupNodeSelection,
            featureFlags: featureFlags
        });
    }, [
        allowLazyLoading,
        allowMediaInlineImages,
        enableDownloadButton,
        handleMediaNodeRemoval,
        getPos,
        intl,
        isMediaItemSelected,
        setMediaGroupNodeSelection,
        featureFlags
    ]);
    const items = (0, $cozmU.useMemo)(()=>{
        return mediaNodesWithOffsets.map(({ node: node, offset: offset })=>{
            return filmstripItem(node, offset);
        });
    }, [
        mediaNodesWithOffsets,
        filmstripItem
    ]);
    (0, $cozmU.useEffect)(()=>{
        setViewMediaClientConfig(mediaClientConfig);
    }, [
        mediaClientConfig
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        mediaNodesWithOffsets.forEach(({ node: node, offset: offset })=>{
            const mediaNodeUpdater = (0, $1wNII.createMediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                isMediaSingle: false
            });
            const updateAttrs = isCopyPasteEnabled || isCopyPasteEnabled === undefined;
            $5820d7825c1fe8a2$var$runMediaNodeUpdate({
                mediaNodeUpdater: mediaNodeUpdater,
                node: node,
                updateAttrs: updateAttrs,
                getPos: ()=>{
                    const pos = getPos();
                    if (typeof pos !== 'number') return undefined;
                    return pos + offset + 1;
                }
            });
        });
    }, [
        view,
        contextIdentifierProvider,
        getPos,
        mediaProvider,
        mediaNodesWithOffsets,
        isCopyPasteEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!handleMediaGroupUpdate || !previousMediaNodesWithOffsets) return;
        const old = previousMediaNodesWithOffsets.map(({ node: node })=>node);
        const next = mediaNodesWithOffsets.map(({ node: node })=>node);
        handleMediaGroupUpdate(old, next);
        return ()=>{
            handleMediaGroupUpdate(next, []);
        };
    }, [
        handleMediaGroupUpdate,
        mediaNodesWithOffsets,
        previousMediaNodesWithOffsets
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97b84b045a0d4579$export$8be30a51dc0802a7), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        featureFlags: featureFlags,
        shouldOpenMediaViewer: editorViewMode && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control'),
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    });
}));
$5820d7825c1fe8a2$export$7fbb084971a34492.displayName = 'MediaGroup';


const $1bf209640f05747f$var$selector = (states)=>{
    return {
        editorDisabled: states.editorDisabledState?.editorDisabled,
        editorViewMode: states.editorViewModeState?.mode
    };
};
function $1bf209640f05747f$var$MediaGroupNodeViewInternal({ renderFn: renderFn, pluginInjectionApi: pluginInjectionApi }) {
    const { editorDisabled: editorDisabled, editorViewMode: editorViewMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled',
        'editorViewMode'
    ], $1bf209640f05747f$var$selector);
    const mediaProvider = (0, $d677bd9d75b85608$export$669acb2735f045dd)(pluginInjectionApi);
    return renderFn({
        editorDisabled: editorDisabled,
        editorViewMode: editorViewMode,
        mediaProvider: mediaProvider
    });
}
class $1bf209640f05747f$var$MediaGroupNodeView extends (0, $Igylv.default) {
    render(props, forwardRef) {
        const { providerFactory: providerFactory, mediaOptions: mediaOptions, pluginInjectionApi: pluginInjectionApi, intl: intl } = props;
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7Tum.MediaSSRReactContextsProvider), {
            intl: intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                const renderFn = ({ mediaProvider: mediaProviderFromState, editorDisabled: editorDisabled, editorViewMode: editorViewMode })=>{
                    const mediaProvider = mediaProviderFromState ? Promise.resolve(mediaProviderFromState) : undefined;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5820d7825c1fe8a2$export$7fbb084971a34492), {
                        node: this.node,
                        getPos: getPos,
                        view: this.view,
                        forwardRef: forwardRef,
                        disabled: editorDisabled,
                        allowLazyLoading: mediaOptions.allowLazyLoading,
                        mediaProvider: mediaProvider,
                        contextIdentifierProvider: contextIdentifierProvider,
                        isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
                        anchorPos: this.view.state.selection.$anchor.pos,
                        headPos: this.view.state.selection.$head.pos,
                        mediaOptions: mediaOptions,
                        editorViewMode: editorViewMode === 'view'
                    });
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1bf209640f05747f$var$MediaGroupNodeViewInternal, {
                    renderFn: renderFn,
                    pluginInjectionApi: pluginInjectionApi
                });
            }
        }));
    }
}
const $1bf209640f05747f$export$dc2dedbaab4b1587 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi, intl)=>(node, view, getPos)=>{
        return new $1bf209640f05747f$var$MediaGroupNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi,
            intl: intl
        }).init();
    };


const $0a5322ec23ab9ad7$export$a1a01149851636f0 = (portalProviderAPI, eventDispatcher, providerFactory, options = {}, api, intl)=>{
    return (0, $1bf209640f05747f$export$dc2dedbaab4b1587)(portalProviderAPI, eventDispatcher, providerFactory, options, api, intl);
};



var $hMfrQ = parcelRequire("hMfrQ");


const $4a9be827e310c90b$export$c4ddfa4daf804695 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, fallbackMediaNameFetcher, intl)=>{
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'mediaInline',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("h9F7A")).then(({ ReactMediaInlineNode: ReactMediaInlineNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, fallbackMediaNameFetcher, intl)(node, view, getPos);
                };
            });
            return result;
        }
    });
};






var $cbY7C = parcelRequire("cbY7C");





var $4G6PK = parcelRequire("4G6PK");





var $4aRaM = parcelRequire("4aRaM");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $6wYuL = parcelRequire("6wYuL");








var $8nvEM = parcelRequire("8nvEM");







const $1a7aa8d16b1384d6$export$aef4e943472be416 = new (0, $kCECX.PluginKey)('aiGeneratingDecoration');
const $1a7aa8d16b1384d6$var$AI_GENERATING_DECORATION_TYPE = 'ai-generating';
// ── Helpers ─────────────────────────────────────────────────────────────────
/**
 * Build a DecorationSet containing a Decoration.node for every media node
 * targeted by the given set.
 *
 * Targets are matched by `localId` first (the mediaSingle wrapper's or the media
 * node's own) so that duplicate copies of the same image — which share a media
 * file `id` — don't all get decorated; only the node the user acted on lights
 * up. Falls back to the media file `id` for the CWR flow and for any node that
 * has no localId yet.
 */ function $1a7aa8d16b1384d6$var$buildDecorationSet(doc, targetIds) {
    if (targetIds.size === 0) return (0, $8nvEM.DecorationSet).empty;
    const decorations = [];
    doc.descendants((node, pos, parent)=>{
        if (node.type.name !== 'media') return;
        const wrapperLocalId = parent?.attrs?.localId;
        const matches = wrapperLocalId && targetIds.has(wrapperLocalId) || node.attrs.localId && targetIds.has(node.attrs.localId) || targetIds.has(node.attrs.id);
        if (matches) decorations.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {}, {
            type: $1a7aa8d16b1384d6$var$AI_GENERATING_DECORATION_TYPE,
            mediaId: node.attrs.id
        }));
    });
    return (0, $8nvEM.DecorationSet).create(doc, decorations);
}
function $1a7aa8d16b1384d6$export$9bb374347eefe943(decorations) {
    return decorations.some((d)=>d.spec.type === $1a7aa8d16b1384d6$var$AI_GENERATING_DECORATION_TYPE);
}
function $1a7aa8d16b1384d6$export$dacdbc7b94b414ee(tr, mediaId, source) {
    return tr.setMeta($1a7aa8d16b1384d6$export$aef4e943472be416, {
        type: 'SET_GENERATING',
        mediaId: mediaId,
        source: source
    }).setMeta('addToHistory', false);
}
function $1a7aa8d16b1384d6$export$d9968a0fb720c8d8(tr, mediaId) {
    return tr.setMeta($1a7aa8d16b1384d6$export$aef4e943472be416, {
        type: 'CLEAR_GENERATING',
        mediaId: mediaId
    }).setMeta('addToHistory', false);
}
function $1a7aa8d16b1384d6$export$4872b17b77321d10() {
    return new (0, $kpCD8.SafePlugin)({
        key: $1a7aa8d16b1384d6$export$aef4e943472be416,
        state: {
            init () {
                return {
                    generatingMediaIds: new Map(),
                    decorationSet: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                // Disabled when gate/experiment off — drop decorations.
                if (!(0, $ixfCV.fg)('cc-maui-phase-2') || !(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
                    if (pluginState.generatingMediaIds.size > 0) return {
                        generatingMediaIds: new Map(),
                        decorationSet: (0, $8nvEM.DecorationSet).empty
                    };
                    return pluginState;
                }
                const meta = tr.getMeta($1a7aa8d16b1384d6$export$aef4e943472be416);
                if (meta) switch(meta.type){
                    case 'SET_GENERATING':
                        {
                            const ids = new Map(pluginState.generatingMediaIds);
                            ids.set(meta.mediaId, meta.source ?? 'maui');
                            const hasCwrIds = (0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true) && [
                                ...ids.values()
                            ].some((s)=>s === 'cwr');
                            const newDecoSet = $1a7aa8d16b1384d6$var$buildDecorationSet(newState.doc, ids);
                            if (hasCwrIds && newDecoSet.find().length === 0 && ids.size > 0) // CWR fallback — keep existing decorations during transient doc absence
                            return {
                                generatingMediaIds: ids,
                                decorationSet: pluginState.decorationSet
                            };
                            return {
                                generatingMediaIds: ids,
                                decorationSet: newDecoSet
                            };
                        }
                    case 'CLEAR_GENERATING':
                        {
                            const ids = new Map(pluginState.generatingMediaIds);
                            ids.delete(meta.mediaId);
                            const hasCwrIds = (0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true) && [
                                ...ids.values()
                            ].some((s)=>s === 'cwr');
                            const newDecoSet = $1a7aa8d16b1384d6$var$buildDecorationSet(newState.doc, ids);
                            if (hasCwrIds && newDecoSet.find().length === 0) // CWR fallback — keep existing decorations during transient doc absence
                            return {
                                generatingMediaIds: ids,
                                decorationSet: pluginState.decorationSet
                            };
                            return {
                                generatingMediaIds: ids,
                                decorationSet: newDecoSet
                            };
                        }
                    case 'CLEAR_ALL':
                        return {
                            generatingMediaIds: new Map(),
                            decorationSet: (0, $8nvEM.DecorationSet).empty
                        };
                }
                // CWR path
                // Rebuild decorations from scratch because CWR streaming replaces the
                // entire document on every chunk and map() drops decorations whose
                // positions can't be mapped.
                const hasCwrIds = (0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true) && [
                    ...pluginState.generatingMediaIds.values()
                ].some((s)=>s === 'cwr');
                if (tr.docChanged && hasCwrIds) {
                    const rebuilt = $1a7aa8d16b1384d6$var$buildDecorationSet(newState.doc, pluginState.generatingMediaIds);
                    const prevCount = pluginState.decorationSet.find().length;
                    const newCount = rebuilt.find().length;
                    // Prevents flickering that results from updating during transient
                    // doc replacements (when nodes are briefly absent)
                    if (newCount !== prevCount && newCount >= pluginState.generatingMediaIds.size) return {
                        ...pluginState,
                        decorationSet: rebuilt
                    };
                    return pluginState;
                }
                // Remix path
                // Map decorations through document changes so positions stay in sync
                if (tr.docChanged && pluginState.decorationSet !== (0, $8nvEM.DecorationSet).empty) try {
                    return {
                        ...pluginState,
                        decorationSet: pluginState.decorationSet.map(tr.mapping, newState.doc)
                    };
                } catch  {
                    return {
                        generatingMediaIds: new Map(),
                        decorationSet: (0, $8nvEM.DecorationSet).empty
                    };
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return $1a7aa8d16b1384d6$export$aef4e943472be416.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
}



var $7TpAR = parcelRequire("7TpAR");


var $geUVX = parcelRequire("geUVX");





var $7SGh9 = parcelRequire("7SGh9");

const $deae7fa047e4af09$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider
    };
};
const $deae7fa047e4af09$var$MediaNodeWithProviders = ({ pluginInjectionApi: pluginInjectionApi, innerComponent: innerComponent })=>{
    const { mediaProvider: mediaProvider } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $deae7fa047e4af09$var$selector);
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    return innerComponent({
        mediaProvider: mediaProvider ? Promise.resolve(mediaProvider) : undefined,
        interactionState: interactionState
    });
};
function $deae7fa047e4af09$var$isMediaDecorationSpec(decoration) {
    return decoration.spec.type !== undefined && decoration.spec.selected !== undefined;
}
class $deae7fa047e4af09$var$MediaNodeView extends (0, $4aRaM.SelectionBasedNodeView) {
    getMediaSingleNode(getPos) {
        const pos = getPos();
        if (typeof pos !== 'number') return null;
        const $pos = this.view.state.doc.resolve(pos);
        // The parent of the media node should be mediaSingle
        if ($pos.parent && $pos.parent.type.name === 'mediaSingle') return $pos.parent;
        return null;
    }
    getMaxWidthFromMediaSingleNode(mediaSingleNode) {
        const { width: widthAttr, widthType: widthTypeAttr, layout: layoutAttr } = mediaSingleNode.attrs;
        // for extended mediaSingle nodes with width and widthType attributes ( default behaviour )
        if (widthAttr && widthTypeAttr === 'pixel') return widthAttr;
        // for legacy mediaSingle nodes without widthType attribute
        switch(layoutAttr){
            case 'full-width':
                return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, $7Y8M5.akEditorCalculatedWideLayoutWidth;
            default:
                return 0, $7Y8M5.akEditorDefaultLayoutWidth;
        }
    }
    hasPxWidthType(mediaSingleNode) {
        const { width: widthAttr, widthType: widthTypeAttr } = mediaSingleNode.attrs;
        // for extended mediaSingle nodes with width and widthType attributes ( default behaviour )
        if (widthAttr && widthTypeAttr === 'pixel') return true;
        return false;
    }
    createDomRef() {
        const domRef = document.createElement('div');
        if (this.reactComponentProps.mediaOptions && this.reactComponentProps.mediaOptions.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
        this.resizeListenerBinding = (0, $cbY7C.bind)(domRef, {
            type: 'resized',
            listener: this.hasResizedListener
        });
        return domRef;
    }
    viewShouldUpdate(nextNode, decorations) {
        const hasMediaNodeSelectedDecoration = decorations.some((decoration)=>$deae7fa047e4af09$var$isMediaDecorationSpec(decoration) && decoration.spec.type === 'media' && decoration.spec.selected);
        if (this.isSelected !== hasMediaNodeSelectedDecoration) {
            this.isSelected = hasMediaNodeSelectedDecoration;
            return true;
        }
        const aiGenerating = (0, $1a7aa8d16b1384d6$export$9bb374347eefe943)(decorations);
        if (this.isAIGenerating !== aiGenerating) {
            this.isAIGenerating = aiGenerating;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode, decorations);
    }
    stopEvent(event) {
        // Don't trap right click events on media node
        if ([
            'mousedown',
            'contextmenu'
        ].indexOf(event.type) !== -1) {
            const mouseEvent = event;
            if (mouseEvent.button === 2) return true;
        }
        return false;
    }
    getAttrs() {
        const { attrs: attrs } = this.node;
        return attrs;
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return (0, $geUVX.isMediaBlobUrlFromAttrs)(attrs);
    }
    render() {
        const { providerFactory: providerFactory, intl: intl } = this.reactComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7Tum.MediaSSRReactContextsProvider), {
            intl: intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            renderNode: this.renderMediaNodeWithProviders
        }));
    }
    destroy() {
        if (this.resizeListenerBinding) this.resizeListenerBinding();
        super.destroy();
    }
    constructor(...args){
        super(...args);
        this.isSelected = false;
        this.isAIGenerating = false;
        this.hasBeenResized = false;
        this.resizeListenerBinding = void 0;
        this.hasResizedListener = ()=>{
            if (!this.hasBeenResized) {
                this.hasBeenResized = true;
                this.update(this.node, this.decorations);
            }
        };
        this.onExternalImageLoaded = (dimensions)=>{
            const getPos = this.getPos;
            const { width: width, height: height, ...rest } = this.getAttrs();
            if (!width || !height) (0, $7TpAR.updateCurrentMediaNodeAttrs)({
                ...rest,
                width: width || dimensions.width,
                height: height || dimensions.height
            }, {
                node: this.node,
                getPos: getPos
            }, true)(this.view.state, this.view.dispatch);
        };
        this.getMaxCardDimensions = ()=>{
            const flexibleDimensions = {
                width: '100%',
                height: '100%'
            };
            const pos = this.getPos();
            if (typeof pos !== 'number') return flexibleDimensions;
            if (this.hasBeenResized) return flexibleDimensions;
            const mediaSingleNodeParent = this.getMediaSingleNode(this.getPos);
            // If media parent not found, return default
            if (!mediaSingleNodeParent) return flexibleDimensions;
            if (this.hasPxWidthType(mediaSingleNodeParent)) return {
                width: `${mediaSingleNodeParent.attrs.width}px`,
                height: '100%'
            };
            return flexibleDimensions;
        };
        this.getMediaProviderToUse = (mediaOptions, mediaProvider)=>{
            if (mediaProvider) return mediaProvider;
            return mediaOptions.provider;
        };
        this.renderMediaNodeWithState = (contextIdentifierProvider)=>{
            return ({ mediaProvider: mediaProvider, interactionState: interactionState })=>{
                const getPos = this.getPos;
                const { mediaOptions: mediaOptions } = this.reactComponentProps;
                const attrs = this.getAttrs();
                const url = attrs.type === 'external' ? attrs.url : '';
                let { width: width, height: height } = attrs;
                if (this.isMediaBlobUrl()) {
                    const urlAttrs = (0, $6wYuL.getAttrsFromUrl)(url);
                    if (urlAttrs) {
                        const { width: urlWidth, height: urlHeight } = urlAttrs;
                        width = width || urlWidth;
                        height = height || urlHeight;
                    }
                }
                width = width || (0, $4G6PK.DEFAULT_IMAGE_WIDTH);
                height = height || (0, $4G6PK.DEFAULT_IMAGE_HEIGHT);
                const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
                // mediaSingle defines the max dimensions, so we don't need to constrain twice.
                const maxDimensions = this.getMaxCardDimensions();
                const originalDimensions = {
                    width: width,
                    height: height
                };
                const isSelectedAndInteracted = this.nodeInsideSelection() && interactionState !== 'hasNotHadInteraction';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7SGh9.default), {
                    api: pluginInjectionApi,
                    view: this.view,
                    node: this.node,
                    getPos: getPos,
                    selected: isSelectedAndInteracted,
                    originalDimensions: originalDimensions,
                    maxDimensions: maxDimensions,
                    url: url,
                    mediaProvider: this.getMediaProviderToUse(mediaOptions, mediaProvider),
                    syncProvider: mediaOptions.syncProvider,
                    contextIdentifierProvider: contextIdentifierProvider,
                    mediaOptions: mediaOptions,
                    onExternalImageLoaded: this.onExternalImageLoaded,
                    isViewOnly: this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view',
                    pluginInjectionApi: this.reactComponentProps.pluginInjectionApi,
                    isAIGenerating: this.isAIGenerating
                });
            };
        };
        this.renderMediaNodeWithProviders = ({ contextIdentifierProvider: contextIdentifierProvider })=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($deae7fa047e4af09$var$MediaNodeWithProviders, {
                pluginInjectionApi: pluginInjectionApi,
                innerComponent: this.renderMediaNodeWithState(contextIdentifierProvider)
            });
        };
    }
}
const $deae7fa047e4af09$export$a8df8d02db5c2be0 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi, intl)=>(node, view, getPos)=>{
        return new $deae7fa047e4af09$var$MediaNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi,
            intl: intl
        }).init();
    };


/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 



var $lOiVq = parcelRequire("lOiVq");

















var $9k4mh = parcelRequire("9k4mh");




/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 






var $8dxef = parcelRequire("8dxef");







const $d6e06a80e45c94b0$export$6a0665148042092b = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    },
    placeholderWithDoubleClickPrompt: {
        id: "fabric.editor.captionPlaceholderWithDoubleClickPrompt",
        defaultMessage: "Add a caption - double-click to preview"
    }
});



var $p7uR0 = parcelRequire("p7uR0");



var $2G2MI = parcelRequire("2G2MI");

var $7ZFkz = parcelRequire("7ZFkz");

var $7UxJ0 = parcelRequire("7UxJ0");


var $g9sVl = parcelRequire("g9sVl");


var $aHoC6 = parcelRequire("aHoC6");





var $bjg0G = parcelRequire("bjg0G");













const $0f25f56fce6e0168$export$994ea9c3fa8e0b0c = (mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
        // node should have two children, media and caption
        if (mediaSingleNode.childCount !== 2) return false;
        if (dispatch) {
            const media = mediaSingleNode.child(0);
            const caption = mediaSingleNode.child(1);
            let tr = state.tr;
            tr = $0f25f56fce6e0168$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
const $0f25f56fce6e0168$export$a34e35a63d969ea1 = (editorAnalyticsAPI)=>(mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
            if (typeof mediaSingleNodePos !== 'number') return false;
            let tr = state.tr;
            // node should have one child, media
            if (mediaSingleNode.childCount !== 1) return false;
            if (dispatch) {
                const schema = state.schema;
                const media = mediaSingleNode.child(0);
                const caption = schema.nodes.caption.create();
                tr = state.tr.insert(mediaSingleNodePos + media.nodeSize + 1, caption);
                tr = $0f25f56fce6e0168$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
                tr.setMeta('scrollIntoView', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).ADDED,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CAPTION
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $0f25f56fce6e0168$var$setSelectionAtEndOfCaption = (tr, mediaSingleNodePos, mediaNodeSize, captionNodeSize)=>{
    return (0, $bjg0G.setTextSelection)(mediaSingleNodePos + mediaNodeSize + captionNodeSize)(tr);
};





/* eslint-disable @atlaskit/design-system/use-primitives-text */ // This had to be disabled to add an id and styles to a component that could not be replaced with Text
// This was added in a experiment cleanup and should be removed if possible
// Be sure to use primitives in this file as needed
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 













var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");

function $4a13f440c16c504b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $4a13f440c16c504b$var$placeholder = {
    name: "1vjw201",
    styles: "color:var(--ds-text-subtlest, #6B6E76);width:100%;text-align:center;margin-top:var(--ds-space-100, 8px)!important;display:block"
};
const $4a13f440c16c504b$var$placeholderText = {
    name: "o2x9s",
    styles: "color:var(--ds-text-subtlest, #6B6E76)"
};
const $4a13f440c16c504b$var$placeholderButton = (0, $buxP3.xcss)({
    width: '100%',
    marginTop: 'space.100'
});
const $4a13f440c16c504b$export$283943db773aa526 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ onClick: onClick, placeholderMessage: placeholderMessage }, ref)=>{
    const handlePointerDown = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        onClick();
    }, [
        onClick
    ]);
    const computedPlaceholderMessage = placeholderMessage ? placeholderMessage : (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholder;
    // This issue is a temporary fix for users being able to edit captions on edge browsers. This will be removed
    // replaced with CaptionPlaceholderButton in the near future and this code can be removed.
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        css: $4a13f440c16c504b$var$placeholder,
        onPointerDown: handlePointerDown,
        // This id is just used for setting styles at the moment, if it's needed for anything more specific
        // It may need to be generated to avoid overlap
        id: (0, $4G6PK.CAPTION_PLACEHOLDER_ID),
        "data-id": (0, $4G6PK.CAPTION_PLACEHOLDER_ID),
        "data-testid": "caption-placeholder"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), computedPlaceholderMessage)));
});
const $4a13f440c16c504b$export$dfb3d25b53c36a0a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ onClick: onClick, placeholderMessage: placeholderMessage }, ref)=>{
    const handleMouseDown = (0, $cozmU.useCallback)((e)=>{
        // In firefox, button is focused when mouse down, which make editor lose focus
        // Hence we want to disabled it so that user can type in caption directly after click
        e.preventDefault();
    }, []);
    const computedPlaceholderMessage = placeholderMessage ? placeholderMessage : (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholder;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kh0hi.default), {
        ref: ref,
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onMouseDown: handleMouseDown,
        "data-id": (0, $4G6PK.CAPTION_PLACEHOLDER_ID),
        testId: "caption-placeholder",
        padding: "space.0",
        xcss: $4a13f440c16c504b$var$placeholderButton
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $4a13f440c16c504b$var$placeholderText,
        id: (0, $4G6PK.CAPTION_PLACEHOLDER_ID)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), computedPlaceholderMessage)));
});






var $1SZMn = parcelRequire("1SZMn");





var $294Sp = parcelRequire("294Sp");

const $29c776a460b1e43a$var$selector = (states)=>{
    return {
        selectedAnnotations: states.annotationState?.selectedAnnotations,
        isInlineCommentViewClosed: states.annotationState?.isInlineCommentViewClosed,
        annotations: states.annotationState?.annotations
    };
};
const $29c776a460b1e43a$export$28b46719ed075ab4 = ({ api: api, mediaNode: mediaNode, view: view, getPos: getPos, isDrafting: isDrafting })=>{
    const [entered, setEntered] = (0, $cozmU.useState)(false);
    const { selectedAnnotations: selectedAnnotations, isInlineCommentViewClosed: isInlineCommentViewClosed, annotations: annotations } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $29c776a460b1e43a$var$selector);
    const { state: { schema: { nodes: { media: media }, marks: { annotation: annotation } } }, state: state, dispatch: dispatch } = view;
    const status = (0, $cozmU.useMemo)(()=>{
        if (!selectedAnnotations || !mediaNode) return 'default';
        return selectedAnnotations.some((annotation)=>!!mediaNode.marks.find((mark)=>mark.attrs.id === annotation.id)) && !isInlineCommentViewClosed ? 'active' : 'default';
    }, [
        selectedAnnotations,
        isInlineCommentViewClosed,
        mediaNode
    ]);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (api?.annotation && mediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode } = api.annotation.actions;
            showCommentForBlockNode(mediaNode, (0, $1SZMn.VIEW_METHOD).BADGE)(state, dispatch);
        }
    }, [
        api?.annotation,
        dispatch,
        mediaNode,
        state
    ]);
    const pos = getPos();
    const hasNoComments = !Number.isFinite(pos) || !annotations || !mediaNode || mediaNode.type !== media || mediaNode.marks.every((maybeAnnotation)=>maybeAnnotation.type !== annotation || !(maybeAnnotation.attrs.id in annotations) || annotations[maybeAnnotation.attrs.id]);
    if (!isDrafting && hasNoComments || !mediaNode) return null;
    const maybeMediaSingleElement = view.domAtPos(pos + 1).node;
    const mediaSingleElement = maybeMediaSingleElement instanceof HTMLElement ? maybeMediaSingleElement : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $294Sp.CommentBadgeNext), {
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        status: entered ? 'entered' : status,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseEnter: ()=>setEntered(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseLeave: ()=>setEntered(false)
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $gdCrd = parcelRequire("gdCrd");


var $89gPK = parcelRequire("89gPK");

var $b8ZJI = parcelRequire("b8ZJI");

var $76kDm = parcelRequire("76kDm");

var $bfl0n = parcelRequire("bfl0n");

var $fb9eF = parcelRequire("fb9eF");

var $3GQSw = parcelRequire("3GQSw");

var $h5qPS = parcelRequire("h5qPS");

var $34CLe = parcelRequire("34CLe");


var $djukY = parcelRequire("djukY");











var $g9ZnD = parcelRequire("g9ZnD");

const $4bb1e35ad772cb66$export$9573295345282b3b = async (mediaNode, mediaClientConfig)=>{
    if (mediaNode.attrs.type === 'external') return 'external';
    if (!mediaNode.attrs.id) return;
    try {
        const fileState = await (0, $g9ZnD.getMediaClient)(mediaClientConfig).file.getCurrentState(mediaNode.attrs.id, {
            collectionName: mediaNode.attrs.collection
        });
        if (fileState && fileState.status !== 'error') return fileState.mediaType;
    } catch (err) {
    // return undefined in case of media client error
    }
};


const $5cacb7fc658ec2d9$export$edbc9d69329c7c7a = [
    'wrap-right',
    'align-end'
];


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $hNvnn = parcelRequire("hNvnn");

const $1e1c552ca1110b89$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("&>div{", (0, $hNvnn.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;}");


class $5ba1c3c7eefea430$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = (0, $gdCrd.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, this.wrapper);
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        // Handle undo, when the actual pctWidth changed,
        // we sync up with the internal state.
        if (prevProps.pctWidth !== this.props.pctWidth) this.setState({
            resizedPctWidth: this.props.pctWidth
        });
        return true;
    }
    get wrappedLayout() {
        return (0, $34CLe.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    async componentDidMount() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.props;
        if (viewMediaClientConfig) await this.checkVideoFile(viewMediaClientConfig);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.viewMediaClientConfig !== nextProps.viewMediaClientConfig) this.checkVideoFile(nextProps.viewMediaClientConfig);
        if (this.props.layout !== nextProps.layout) this.checkLayout(this.props.layout, nextProps.layout);
    }
    async checkVideoFile(viewMediaClientConfig) {
        const $pos = this.$pos;
        if (!$pos || !viewMediaClientConfig) return;
        const mediaNode = this.props.view.state.doc.nodeAt($pos.pos + 1);
        const mediaType = mediaNode ? await (0, $4bb1e35ad772cb66$export$9573295345282b3b)(mediaNode, viewMediaClientConfig) : undefined;
        const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
        if (this.state.isVideoFile !== isVideoFile) this.setState({
            isVideoFile: isVideoFile
        });
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $34CLe.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    get insideLayout() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { layoutColumn: layoutColumn } = this.props.view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            layoutColumn
        ]);
    }
    render() {
        const { width: origWidth, height: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, selected: selected, children: children } = this.props;
        const initialWidth = this.calcPxWidth(); // width with padding
        let ratio;
        if (origWidth) ratio = (origHeight / origWidth * 100).toFixed(3);
        const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        const enable = {};
        (0, $bfl0n.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            if (this.props.disableHandles) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && (0, $5cacb7fc658ec2d9$export$edbc9d69329c7c7a).indexOf(layout) === -1) {
                enable[side] = false;
                return;
            }
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $fb9eF.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const snapPointsProps = {
            $pos: this.$pos,
            akEditorWideLayoutWidth: (0, $7Y8M5.akEditorWideLayoutWidth),
            allowBreakoutSnapPoints: this.props.allowBreakoutSnapPoints,
            containerWidth: this.props.containerWidth,
            gridSize: this.props.gridSize,
            gridWidth: this.gridWidth,
            insideInlineLike: this.insideInlineLike,
            insideLayout: this.insideLayout,
            isVideoFile: this.state.isVideoFile,
            lineLength: this.props.lineLength,
            offsetLeft: this.state.offsetLeft,
            wrappedLayout: this.wrappedLayout
        };
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-025, 2px)"} * -0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-025, 2px)"} * -0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: this.saveWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $1e1c552ca1110b89$export$c4d4f06a25de97f)({
                layout: layout,
                isResized: !!pctWidth,
                containerWidth: containerWidth || origWidth,
                fullWidthMode: fullWidthMode,
                width: origWidth
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3GQSw.default), {
            ...this.props,
            displayGrid: this.displayGrid,
            ratio: ratio,
            width: initialWidth,
            selected: selected,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: (0, $djukY.calculateSnapPoints)(snapPointsProps),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "media",
            dispatchAnalyticsEvent: this.props.dispatchAnalyticsEvent,
            // when cursor is located below a media with caption,
            // press “Up“ key will result cursor focus on an invalid position, (on the resize handler)
            // This workaround adds an empty div inside the resize handler to prevent the issue.
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleComponentFunc: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    contentEditable: false
                }),
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable())
        }, children));
    }
    constructor(...args){
        super(...args);
        this.hasResized = false;
        this.state = {
            offsetLeft: (0, $gdCrd.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, undefined),
            isVideoFile: false
        };
        this.displayGrid = (visible, gridType, highlight)=>{
            const { pluginInjectionApi: pluginInjectionApi, view: view } = this.props;
            pluginInjectionApi?.grid?.actions?.displayGrid(view)({
                visible: visible,
                gridType: gridType,
                highlight: highlight
            });
        };
        this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            if (!this.hasResized) {
                const mediaDomEl = this.wrapper?.querySelector('div[data-prosemirror-node-name="media"]');
                if (mediaDomEl) {
                    const event = new CustomEvent('resized');
                    mediaDomEl?.dispatchEvent(event);
                }
                this.hasResized = true;
            }
            const newPct = (0, $76kDm.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        };
        this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= (0, $7Y8M5.akEditorWideLayoutWidth)) return 'wide';
            return 'full-width';
        };
        this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $89gPK.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        };
        this.wrapper = void 0;
        this.calcPxWidth = (useLayout)=>{
            const { width: origWidth = 0, height: origHeight, layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $b8ZJI.calcMediaPxWidth)({
                origWidth: origWidth,
                origHeight: origHeight,
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        };
        this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, panel: panel, panel_c1: panel_c1 } = this.props.view.state.schema.nodes;
            const parentsToHideGridLines = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel,
                panel_c1
            ].filter(Boolean) : [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel
            ].filter(Boolean);
            if (this.$pos && !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)(this.$pos, parentsToHideGridLines)) return [];
            if (snapWidth > (0, $7Y8M5.akEditorWideLayoutWidth)) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $89gPK.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
        this.saveWrapper = (wrapper)=>this.wrapper = wrapper;
    }
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $5X6fy = parcelRequire("5X6fy");


var $kmQhR = parcelRequire("kmQhR");


var $ktOsK = parcelRequire("ktOsK");

var $b8q5K = parcelRequire("b8q5K");







var $9jn2Q = parcelRequire("9jn2Q");


var $4MxIv = parcelRequire("4MxIv");


var $adoix = parcelRequire("adoix");

const $4d6e8212dc0ff136$export$54d414ee882d8753 = (state, editorWidth, styles = {})=>{
    const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
    const offset = editorWidth / 2;
    return (0, $bjg0G.findChildren)(state.tr.doc, (node)=>node.type === state.schema.nodes.mediaSingle).reduce((acc, nodeWithPos, index)=>{
        const { node: node, pos: pos } = nodeWithPos;
        // if the current node the selected node
        // or the node is not using pixel width,
        // We will skip the node.
        if (selectedNode === node || node.attrs.widthType !== 'pixel') return acc;
        const $pos = state.tr.doc.resolve(pos);
        if ($pos.parent.type !== state.schema.nodes.doc) return acc;
        const dimensions = (0, $adoix.getMediaSingleDimensions)(node, editorWidth);
        if (!dimensions) return acc;
        const { width: width, height: height } = dimensions;
        const dynamicGuides = [
            ...acc.dynamicGuides,
            ...$4d6e8212dc0ff136$var$getDynamicGuides(node.attrs.layout, width, offset, `${(0, $4MxIv.MEDIA_DYNAMIC_GUIDELINE_PREFIX)}${index}`, styles)
        ];
        const accRelativeGuidesWidth = acc.relativeGuides?.width || {};
        const accRelativeGuidesHeight = acc.relativeGuides?.height || {};
        const relativeGuidesWidth = {
            ...accRelativeGuidesWidth,
            [width]: [
                ...accRelativeGuidesWidth[width] || [],
                nodeWithPos
            ]
        };
        const relativeGuidesWidthHeight = {
            ...accRelativeGuidesHeight,
            [Math.round(height)]: [
                ...accRelativeGuidesHeight[height] || [],
                nodeWithPos
            ]
        };
        return {
            dynamicGuides: dynamicGuides,
            relativeGuides: {
                width: relativeGuidesWidth,
                height: relativeGuidesWidthHeight
            }
        };
    }, {
        relativeGuides: {
            width: {},
            height: {}
        },
        dynamicGuides: []
    });
};
const $4d6e8212dc0ff136$var$getDynamicGuides = (layout, width, offset, key, styles)=>{
    switch(layout){
        case 'align-start':
        case 'wrap-left':
            return [
                {
                    position: {
                        x: (0, $9jn2Q.roundToNearest)(width - offset)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'align-end':
        case 'wrap-right':
            return [
                {
                    position: {
                        x: (0, $9jn2Q.roundToNearest)(offset - width)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'center':
            return [
                {
                    position: {
                        x: (0, $9jn2Q.roundToNearest)(width / 2)
                    },
                    key: `${key}_right`,
                    ...styles
                },
                {
                    position: {
                        x: -(0, $9jn2Q.roundToNearest)(width / 2)
                    },
                    key: `${key}_left`,
                    ...styles
                }
            ];
        default:
            return [];
    }
};


var $lPlPa = parcelRequire("lPlPa");

var $78UMD = parcelRequire("78UMD");

var $82NHW = parcelRequire("82NHW");




const $7a42a7ffc56410cd$var$RELATIVE_GUIDES_GAP = 6;
const $7a42a7ffc56410cd$var$getWidthRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $adoix.getMediaSingleDimensions)(node, editorWidth) || {};
    const y = top - topOffset - $7a42a7ffc56410cd$var$RELATIVE_GUIDES_GAP;
    if (!width || !height || y < 0 || y > viewHeight) return null;
    let start = 0;
    let end = 0;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            start = -editorWidth / 2;
            end = start + width;
            break;
        case 'align-end':
        case 'wrap-right':
            end = editorWidth / 2;
            start = end - width;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            end = width / 2;
            start = -end;
            break;
        default:
    }
    return {
        key: key,
        position: {
            y: y,
            x: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $7a42a7ffc56410cd$var$getHeightRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $adoix.getMediaSingleDimensions)(node, editorWidth) || {};
    if (!width || !height) return null;
    const start = top - topOffset;
    const end = start + height;
    if (end < 0 || start > viewHeight) return null;
    let x = 0;
    const halfWidth = editorWidth / 2;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            x = width - halfWidth;
            break;
        case 'align-end':
        case 'wrap-right':
            x = halfWidth;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            x = width / 2;
            break;
        default:
            x = 0;
    }
    return {
        key: key,
        position: {
            x: x + $7a42a7ffc56410cd$var$RELATIVE_GUIDES_GAP,
            y: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $7a42a7ffc56410cd$export$73b4064129fc756b = (relativeGuides, nodeWithPos, view, editorWidth, topOffset, size)=>{
    const matchWidth = relativeGuides.width ? relativeGuides.width[Math.round(size.width)] : [];
    const matchHeight = relativeGuides.height ? relativeGuides.height[Math.round(size.height)] : [];
    const matches = matchWidth || matchHeight;
    const getRelativeGuideline = matchWidth && $7a42a7ffc56410cd$var$getWidthRelativeGuideline || matchHeight && $7a42a7ffc56410cd$var$getHeightRelativeGuideline || null;
    if (matches && getRelativeGuideline) return [
        getRelativeGuideline('relative_guide_current', view, nodeWithPos, editorWidth, topOffset, size),
        ...matches.map((nodeWithPos, index)=>{
            return getRelativeGuideline(`relative_guide_${index}`, view, nodeWithPos, editorWidth, topOffset);
        })
    ].filter((config)=>!!config);
    return [];
};




const $442707acb01b6232$export$ec77024f2efeedc5 = (relativeGuides, aspectRatio)=>{
    const snapsWidthFromMatchingHeight = Object.keys(relativeGuides.height || {}).map((heightKey)=>{
        const height = Number.parseInt(heightKey);
        return (0, $9jn2Q.roundToNearest)(height * aspectRatio);
    });
    const snapsWidthFromMatchingWidth = Object.keys(relativeGuides.width || {}).map((widthKey)=>{
        return Number.parseInt(widthKey);
    });
    return [
        ...snapsWidthFromMatchingWidth,
        ...snapsWidthFromMatchingHeight
    ];
};



var $hS5Am = parcelRequire("hS5Am");




var $aWssQ = parcelRequire("aWssQ");


var $2INqe = parcelRequire("2INqe");

var $l3s1y = parcelRequire("l3s1y");











var $8qft0 = parcelRequire("8qft0");




















var $hLkNo = parcelRequire("hLkNo");



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports



// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $bb3ae0fe3ca6e859$var$NOTIFICATION_SIZE = 8;
const $bb3ae0fe3ca6e859$var$SPACE_FROM_EDGE = "var(--ds-space-100, 8px)";
const $bb3ae0fe3ca6e859$export$210d1a6e59f1b30e = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    top: $bb3ae0fe3ca6e859$var$SPACE_FROM_EDGE,
    right: `calc(${"var(--ds-space-150, 12px)"} + ${$bb3ae0fe3ca6e859$var$SPACE_FROM_EDGE})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-background-warning-bold, #FBC828)",
    borderRadius: "var(--ds-radius-full, 50%)",
    width: `${$bb3ae0fe3ca6e859$var$NOTIFICATION_SIZE}px`,
    height: `${$bb3ae0fe3ca6e859$var$NOTIFICATION_SIZE}px`,
    pointerEvents: 'none'
});


const $2470dcd7a609eddd$export$239acce4d7b54ab1 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "resizable-media-migration-notification",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $bb3ae0fe3ca6e859$export$210d1a6e59f1b30e)
        ]
    });
};



const $6ba326387cf7a246$export$fe623d3106c02058 = 'mediaSingle.resizerNext.testid';
const $6ba326387cf7a246$var$getNodePosition = (getPos)=>{
    if (typeof getPos !== 'function') return null;
    const pos = getPos();
    if (Number.isNaN(pos) || typeof pos !== 'number') return null;
    return pos;
};
const $6ba326387cf7a246$var$calcPxHeight = (props)=>{
    const { newWidth: newWidth, previousWidth: previousWidth, previousHeight: previousHeight } = props;
    return Math.round(previousHeight / previousWidth * newWidth);
};
const $6ba326387cf7a246$var$calcMinWidth = ({ isVideoFile: isVideoFile, contentWidth: contentWidth })=>{
    return Math.min(contentWidth || (0, $7Y8M5.akEditorDefaultLayoutWidth), isVideoFile ? (0, $4G6PK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $6ba326387cf7a246$var$calcMaxWidth = ({ containerWidth: containerWidth, editorAppearance: editorAppearance })=>{
    return (0, $hS5Am.calcMediaSingleMaxWidth)(containerWidth, editorAppearance);
};
const $6ba326387cf7a246$var$setIsResizingPluginState = ({ isResizing: isResizing, nodePosition: nodePosition, initialWidth: initialWidth })=>(state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $9k4mh.MEDIA_PLUGIN_IS_RESIZING_KEY), isResizing);
        tr.setMeta('is-resizer-resizing', isResizing);
        if (isResizing && typeof nodePosition === 'number') tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, nodePosition));
        if (isResizing && typeof initialWidth === 'number') tr.setMeta((0, $9k4mh.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), initialWidth);
        if (dispatch) dispatch(tr);
        return true;
    };
const $6ba326387cf7a246$var$calcUnwrappedLayout = (width, containerWidth, contentWidth, fullWidthMode, isNestedNode)=>{
    if (isNestedNode) return 'center';
    if (fullWidthMode) {
        if (width < contentWidth) return 'center';
        return 'full-width';
    }
    // handle top-level node in fixed-width editor
    if (width <= contentWidth) return 'center';
    const padding = containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    if (width < Math.min(containerWidth - padding * 2, (0, $7Y8M5.akEditorFullWidthLayoutWidth))) return 'wide';
    // set full width to be containerWidth - padding * 2
    // instead of containerWidth - akEditorBreakoutPadding,
    // so that we have image aligned with text
    return 'full-width';
};
const $6ba326387cf7a246$var$calcNewLayout = ({ layout: layout, containerWidth: containerWidth, lineLength: lineLength, fullWidthMode: fullWidthMode, isNestedNode: isNestedNode })=>(newWidth, stop)=>{
        const newPct = (0, $76kDm.calcPctFromPx)(newWidth, lineLength) * 100;
        const wrappedLayout = (0, $34CLe.wrappedLayouts).indexOf(layout) > -1;
        if (newPct <= 100 && wrappedLayout) {
            if (!stop || newPct !== 100) return layout;
        }
        return $6ba326387cf7a246$var$calcUnwrappedLayout(newWidth, containerWidth, lineLength, fullWidthMode, isNestedNode);
    };
const $6ba326387cf7a246$var$calculateSizeState = (props)=>(size, delta, onResizeStop = false, aspectRatio)=>{
        const calculatedWidth = Math.round(size.width + delta.width);
        const calculatedWidthWithLayout = $6ba326387cf7a246$var$calcNewLayout(props)(calculatedWidth, onResizeStop);
        return {
            width: calculatedWidth,
            height: calculatedWidth / aspectRatio,
            layout: calculatedWidthWithLayout
        };
    };
const $6ba326387cf7a246$var$getAspectRatio = ({ width: width, height: height })=>{
    if (width && height > 0) return width / height;
    // TODO: ED-26962 - handle this case
    return 1;
};
const $6ba326387cf7a246$var$updateSizeInPluginState = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(({ width: width, view: view })=>{
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    tr.setMeta((0, $9k4mh.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), width);
    return dispatch(tr);
}, (0, $4G6PK.MEDIA_SINGLE_RESIZE_THROTTLE_TIME));
const $6ba326387cf7a246$export$4198575e34ea4b65 = (props)=>{
    const { width: origWidth, children: children, containerWidth: containerWidth, fullWidthMode: fullWidthMode, layout: layout, selected: selected, showLegacyNotification: showLegacyNotification, className: className, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, getPos: getPos, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, height: height, nodeType: nodeType, pluginInjectionApi: pluginInjectionApi, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, forceHandlePositioning: forceHandlePositioning, disableHandles: disableHandles } = props;
    const initialWidth = (0, $cozmU.useMemo)(()=>{
        return mediaSingleWidth || (0, $4G6PK.DEFAULT_IMAGE_WIDTH);
    }, [
        mediaSingleWidth
    ]);
    const [dimensions, setDimensions] = (0, $cozmU.useState)({
        width: initialWidth,
        height: $6ba326387cf7a246$var$calcPxHeight({
            newWidth: initialWidth,
            previousWidth: initialWidth,
            previousHeight: height
        })
    });
    const dimensionsRef = (0, $cozmU.useRef)(dimensions);
    const lastSnappedGuidelineKeysRef = (0, $cozmU.useRef)([]);
    const [snaps, setSnaps] = (0, $cozmU.useState)({});
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const [isVideoFile, setIsVideoFile] = (0, $cozmU.useState)(false);
    const [hasResized, setHasResized] = (0, $cozmU.useState)(false);
    const nodePosition = $6ba326387cf7a246$var$getNodePosition(getPos);
    const isNestedNode = (0, $cozmU.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        return !!($pos && $pos.depth !== 0);
    }, [
        nodePosition,
        view
    ]);
    const isAdjacentMode = (0, $cozmU.useMemo)(()=>{
        if (forceHandlePositioning === 'adjacent') return true;
        return isNestedNode;
    }, [
        isNestedNode,
        forceHandlePositioning
    ]);
    const maybeContainerWidth = containerWidth || origWidth;
    const memoizedCss = (0, $cozmU.useMemo)(()=>{
        return (0, $1e1c552ca1110b89$export$c4d4f06a25de97f)({
            layout: layout,
            containerWidth: maybeContainerWidth,
            fullWidthMode: fullWidthMode,
            mediaSingleWidth: dimensions.width,
            isNestedNode: isAdjacentMode,
            isExtendedResizeExperienceOn: true
        });
    }, [
        layout,
        maybeContainerWidth,
        fullWidthMode,
        dimensions.width,
        isAdjacentMode
    ]);
    const maxWidth = (0, $cozmU.useMemo)(()=>{
        if (editorAppearance === 'chromeless' && forceHandlePositioning === 'adjacent') return containerWidth - (0, $4G6PK.MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN) * 2;
        if (!isResizing && isAdjacentMode) return undefined;
        if (isAdjacentMode || fullWidthMode) return lineLength;
        if (!isResizing) return `var(--ak-editor-max-container-width)`;
        return $6ba326387cf7a246$var$calcMaxWidth({
            containerWidth: containerWidth,
            editorAppearance: editorAppearance
        });
    }, [
        isAdjacentMode,
        fullWidthMode,
        lineLength,
        editorAppearance,
        containerWidth,
        isResizing,
        forceHandlePositioning
    ]);
    const minWidth = $6ba326387cf7a246$var$calcMinWidth({
        isVideoFile: isVideoFile,
        contentWidth: lineLength
    });
    // while is not resizing, we take 100% as min-width if the container width is less than the min-width
    const minViewWidth = isResizing ? minWidth : `min(${minWidth}px, 100%)`;
    const resizerNextClassName = (0, $cozmU.useMemo)(()=>{
        const classNameNext = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $l3s1y.richMediaClassName), `image-${layout}`, isResizing ? 'is-resizing' : 'not-resizing', className, (0, $2INqe.resizerItemClassName), {
            'display-handle': selected && !disableHandles,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        return classNameNext;
    }, [
        className,
        disableHandles,
        isResizing,
        layout,
        selected
    ]);
    const isInsideInlineLike = (0, $cozmU.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        const { listItem: listItem } = view.state.schema.nodes;
        return !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }, [
        nodePosition,
        view
    ]);
    const enable = (0, $cozmU.useMemo)(()=>{
        if (disableHandles) return {
            left: false,
            right: false
        };
        const isLeftResizeHandleDisabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        return (0, $bfl0n.handleSides).reduce((acc, side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && (0, $5cacb7fc658ec2d9$export$edbc9d69329c7c7a).indexOf(layout) === -1) {
                acc[side] = false;
                return acc;
            }
            acc[side] = (0, $8qft0.nonWrappedLayouts).concat(`wrap-${oppositeSide}`).concat(`align-${(0, $fb9eF.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && isInsideInlineLike) acc[side] = false;
            return acc;
        }, {});
    }, [
        disableHandles,
        layout,
        isInsideInlineLike
    ]);
    const defaultGuidelines = (0, $cozmU.useMemo)(()=>{
        if (isAdjacentMode) return [];
        return (0, $b8q5K.generateDefaultGuidelines)(lineLength, containerWidth, fullWidthMode);
    }, [
        isAdjacentMode,
        lineLength,
        containerWidth,
        fullWidthMode
    ]);
    const relativeGuidesRef = (0, $cozmU.useRef)({});
    const guidelinesRef = (0, $cozmU.useRef)([]);
    const updateGuidelines = (0, $cozmU.useCallback)(()=>{
        const { relativeGuides: relativeGuides, dynamicGuides: dynamicGuides } = (0, $4d6e8212dc0ff136$export$54d414ee882d8753)(view.state, lineLength, {
            styles: {
                lineStyle: 'dashed'
            },
            show: false
        });
        // disable guidelines for nested media single node
        const dynamicGuidelines = isAdjacentMode ? [] : dynamicGuides;
        relativeGuidesRef.current = relativeGuides;
        guidelinesRef.current = [
            ...defaultGuidelines,
            ...dynamicGuidelines
        ];
    }, [
        view,
        lineLength,
        defaultGuidelines,
        isAdjacentMode
    ]);
    const isGuidelineEnabled = (0, $cozmU.useMemo)(()=>{
        return !!pluginInjectionApi?.guideline;
    }, [
        pluginInjectionApi
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        setIsResizing(true);
        $6ba326387cf7a246$var$setIsResizingPluginState({
            isResizing: true,
            nodePosition: nodePosition,
            initialWidth: dimensionsRef.current.width
        })(view.state, view.dispatch);
        if (isGuidelineEnabled) updateGuidelines();
    }, [
        view,
        nodePosition,
        updateGuidelines,
        isGuidelineEnabled
    ]);
    const getRelativeGuides = (0, $cozmU.useCallback)(()=>{
        if (typeof nodePosition !== 'number') return [];
        const guidelinePluginState = pluginInjectionApi?.guideline?.sharedState?.currentState();
        const { top: topOffset } = guidelinePluginState?.rect || {
            top: 0,
            left: 0
        };
        const $pos = view.state.doc.resolve(nodePosition);
        const relativeGuides = $pos && $pos.nodeAfter && dimensionsRef.current.width ? (0, $7a42a7ffc56410cd$export$73b4064129fc756b)(relativeGuidesRef.current, {
            node: $pos.nodeAfter,
            pos: $pos.pos
        }, view, lineLength, topOffset, dimensionsRef.current) : [];
        return relativeGuides;
    }, [
        pluginInjectionApi,
        nodePosition,
        view,
        lineLength
    ]);
    const updateActiveGuidelines = (0, $cozmU.useCallback)((width = 0, guidelines, guidelineSnapsReference)=>{
        if (!guidelineSnapsReference.snaps.x) return;
        const { gap: gap, keys: activeGuidelineKeys } = (0, $ktOsK.findClosestSnap)(width, guidelineSnapsReference.snaps.x, guidelineSnapsReference.guidelineReference, (0, $4G6PK.MEDIA_SINGLE_SNAP_GAP));
        const relativeGuidelines = activeGuidelineKeys.length ? [] : getRelativeGuides();
        lastSnappedGuidelineKeysRef.current = activeGuidelineKeys.length ? activeGuidelineKeys : relativeGuidelines.map((rg)=>rg.key);
        const nextGuideLines = [
            ...(0, $78UMD.getGuidelinesWithHighlights)(gap, (0, $4G6PK.MEDIA_SINGLE_SNAP_GAP), activeGuidelineKeys, guidelines),
            ...relativeGuidelines
        ];
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: nextGuideLines
        });
    }, [
        getRelativeGuides,
        pluginInjectionApi,
        view
    ]);
    const aspectRatioRef = (0, $cozmU.useRef)($6ba326387cf7a246$var$getAspectRatio({
        width: props.width,
        height: props.height
    }));
    const resizerContainerRef = (0, $cozmU.useRef)(null);
    const handleResize = (0, $cozmU.useCallback)((size, delta)=>{
        const { width: width, height: height, layout: newLayout } = $6ba326387cf7a246$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        const resizerDomEl = resizerContainerRef.current;
        if (resizerDomEl && !hasResized) {
            // dispatch resize event to media node DOM element inside resizerDom
            const mediaDomEl = resizerDomEl.querySelector('div[data-prosemirror-node-name="media"]');
            const event = new CustomEvent('resized');
            mediaDomEl?.dispatchEvent(event);
            setHasResized(true);
        }
        if (isGuidelineEnabled) {
            const guidelineSnaps = (0, $lPlPa.getGuidelineSnaps)(guidelinesRef.current, lineLength, layout);
            updateActiveGuidelines(width, guidelinesRef.current, guidelineSnaps);
            const relativeSnaps = (0, $442707acb01b6232$export$ec77024f2efeedc5)(relativeGuidesRef.current, aspectRatioRef.current);
            setSnaps({
                x: [
                    ...guidelineSnaps.snaps.x || [],
                    ...relativeSnaps
                ]
            });
        }
        setDimensions({
            width: width,
            height: height
        });
        $6ba326387cf7a246$var$updateSizeInPluginState({
            width: width,
            view: view
        });
        if (newLayout !== layout) updateSize(width, newLayout);
    }, [
        layout,
        containerWidth,
        lineLength,
        fullWidthMode,
        isAdjacentMode,
        hasResized,
        isGuidelineEnabled,
        view,
        updateActiveGuidelines,
        updateSize
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((size, delta)=>{
        if (typeof nodePosition !== 'number') return;
        const { width: width, height: height, layout: newLayout } = $6ba326387cf7a246$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        if (dispatchAnalyticsEvent) {
            const $pos = view.state.doc.resolve(nodePosition);
            const event = (0, $hLkNo.getMediaResizeAnalyticsEvent)(nodeType || 'mediaSingle', {
                width: width,
                layout: newLayout,
                widthType: 'pixel',
                snapType: (0, $82NHW.getGuidelineTypeFromKey)(lastSnappedGuidelineKeysRef.current, guidelinesRef.current),
                parentNode: $pos ? $pos.parent.type.name : undefined,
                inputMethod: 'mouse'
            });
            if (event) dispatchAnalyticsEvent(event);
        }
        setIsResizing(false);
        $6ba326387cf7a246$var$setIsResizingPluginState({
            isResizing: false
        })(view.state, view.dispatch);
        pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: []
        });
        let newWidth = width;
        if (newLayout === 'full-width') // When a node reaches full width in current viewport,
        // update its width with 1800 to align with pixel entry
        newWidth = (0, $7Y8M5.akEditorFullWidthLayoutWidth);
        setDimensions({
            width: newWidth,
            height: height
        });
        updateSize(newWidth, newLayout);
    }, [
        nodeType,
        dispatchAnalyticsEvent,
        containerWidth,
        fullWidthMode,
        isAdjacentMode,
        layout,
        lineLength,
        view,
        nodePosition,
        pluginInjectionApi,
        updateSize
    ]);
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        setDimensions({
            width: initialWidth,
            height: $6ba326387cf7a246$var$calcPxHeight({
                newWidth: initialWidth,
                previousWidth: initialWidth,
                previousHeight: height
            })
        });
    }, [
        initialWidth,
        height
    ]);
    (0, $cozmU.useEffect)(()=>{
        dimensionsRef.current = dimensions;
    }, [
        dimensions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!viewMediaClientConfig || typeof nodePosition !== 'number') return;
        const mediaNode = view.state.doc.nodeAt(nodePosition + 1);
        if (!mediaNode) return;
        (0, $4bb1e35ad772cb66$export$9573295345282b3b)(mediaNode, viewMediaClientConfig).then((mediaType)=>{
            if (mountedRef.current) {
                const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
                setIsVideoFile(isVideoFile);
            }
        });
    }, [
        view,
        viewMediaClientConfig,
        nodePosition
    ]);
    const handlePositioning = (0, $cozmU.useMemo)(()=>{
        if (forceHandlePositioning) return forceHandlePositioning;
        return isAdjacentMode ? 'adjacent' : undefined;
    }, [
        forceHandlePositioning,
        isAdjacentMode
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: memoizedCss,
        ref: resizerContainerRef
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aWssQ.default), {
        minWidth: minViewWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerNextClassName,
        snapGap: (0, $4G6PK.MEDIA_SINGLE_SNAP_GAP),
        enable: enable,
        width: dimensions.width,
        handleResizeStart: handleResizeStart,
        handleResize: handleResize,
        handleResizeStop: handleResizeStop,
        snap: snaps,
        resizeRatio: (0, $8qft0.nonWrappedLayouts).includes(layout) ? 2 : 1,
        "data-testid": $6ba326387cf7a246$export$fe623d3106c02058,
        isHandleVisible: selected && !disableHandles,
        handlePositioning: handlePositioning,
        handleHighlight: "full-height"
    }, children, showLegacyNotification && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2470dcd7a609eddd$export$239acce4d7b54ab1), null)));
};
const $6ba326387cf7a246$var$ResizableMediaSingleToggle = ({ allowBreakoutSnapPoints: allowBreakoutSnapPoints, children: children, className: className, containerWidth: containerWidth, dataAttributes: dataAttributes, disableHandles: disableHandles, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, fullWidthMode: fullWidthMode, getPos: getPos, gridSize: gridSize, handleMediaSingleRef: handleMediaSingleRef, hasFallbackContainer: hasFallbackContainer, height: height, isInsideOfInlineExtension: isInsideOfInlineExtension, isLoading: isLoading, layout: layout, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, nodeType: nodeType, pctWidth: pctWidth, pluginInjectionApi: pluginInjectionApi, selected: selected, showLegacyNotification: showLegacyNotification, size: size, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, width: width, forceHandlePositioning: forceHandlePositioning })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)($6ba326387cf7a246$export$4198575e34ea4b65, {
        allowBreakoutSnapPoints: allowBreakoutSnapPoints,
        // eslint-disable-next-line react/no-children-prop
        children: children,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        containerWidth: containerWidth,
        dataAttributes: dataAttributes,
        disableHandles: disableHandles,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAppearance: editorAppearance,
        fullWidthMode: fullWidthMode,
        getPos: getPos,
        gridSize: gridSize,
        handleMediaSingleRef: handleMediaSingleRef,
        hasFallbackContainer: hasFallbackContainer,
        height: height,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        isLoading: isLoading,
        layout: layout,
        lineLength: lineLength,
        mediaSingleWidth: mediaSingleWidth,
        nodeType: nodeType,
        pctWidth: pctWidth,
        pluginInjectionApi: pluginInjectionApi,
        selected: selected,
        showLegacyNotification: showLegacyNotification,
        size: size,
        updateSize: updateSize,
        view: view,
        viewMediaClientConfig: viewMediaClientConfig,
        width: width,
        forceHandlePositioning: forceHandlePositioning
    });
};
var $6ba326387cf7a246$export$2e2bcd8739ae039 = $6ba326387cf7a246$var$ResizableMediaSingleToggle;


const $5e1ec743380ace56$export$56340c4ef3ba9375 = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId || // A changed id means the media source was replaced — always re-initialise
    // the updater so getRemoteDimensions fetches dimensions for the new file.
    // Only check when id is explicitly present on the new attrs (it's Partial).
    'id' in newAttrs && currentAttrs.id !== newAttrs.id;
};






var $5arVd = parcelRequire("5arVd");

function $09f4c8054239e05a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $09f4c8054239e05a$var$figureWrapperStyles = {
    name: "ti75j2",
    styles: "margin:0"
};
const $09f4c8054239e05a$var$useMediaNodeUpdater = ({ mediaProvider: mediaProvider, mediaNode: mediaNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, mediaSingleNodeProps: mediaSingleNodeProps })=>{
    const previousMediaProvider = (0, $2InGJ.default)(mediaProvider);
    const previousMediaNode = (0, $2InGJ.default)(mediaNode);
    const mediaNodeUpdaterRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const createOrUpdateMediaNodeUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((props)=>{
        const mediaChildNode = mediaNode.firstChild;
        const updaterProps = {
            ...props,
            isMediaSingle: true,
            node: mediaChildNode ? mediaChildNode : mediaNode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        };
        if (!mediaNodeUpdaterRef.current) mediaNodeUpdaterRef.current = (0, $1wNII.createMediaNodeUpdater)(updaterProps);
        else mediaNodeUpdaterRef.current.setProps(updaterProps);
    }, [
        mediaNode,
        dispatchAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Forced updates not required on mobile
        if (mediaSingleNodeProps.isCopyPasteEnabled === false) return;
        if (!mediaNodeUpdaterRef.current || previousMediaProvider !== mediaProvider) {
            createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
            mediaNodeUpdaterRef.current?.updateMediaSingleFileAttrs();
        } else if (mediaNode.firstChild && previousMediaNode?.firstChild && mediaNode.firstChild !== previousMediaNode?.firstChild) {
            const attrsChanged = (0, $5e1ec743380ace56$export$56340c4ef3ba9375)(previousMediaNode.firstChild.attrs, mediaNode.firstChild.attrs);
            if (attrsChanged) {
                createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
                // We need to call this method on any prop change since attrs can get removed with collab editing
                mediaNodeUpdaterRef.current?.updateMediaSingleFileAttrs();
            }
        }
    }, [
        createOrUpdateMediaNodeUpdater,
        mediaNode,
        mediaProvider,
        mediaSingleNodeProps,
        previousMediaNode,
        previousMediaProvider
    ]);
    return mediaNodeUpdaterRef.current;
};
const $09f4c8054239e05a$var$mediaAsyncOperations = async (props)=>{
    const updatedDimensions = await props.updater.getRemoteDimensions();
    const currentAttrs = props.mediaChildNode.attrs;
    if (updatedDimensions && (currentAttrs?.width !== updatedDimensions.width || currentAttrs?.height !== updatedDimensions.height)) props.updater.updateDimensions(updatedDimensions);
    if (props.mediaChildNode.attrs.type === 'external' && props.mediaChildNode.attrs.__external) {
        const updatingNode = props.updater.handleExternalMedia(props.getPos);
        props.addPendingTask(updatingNode);
        await updatingNode;
        return;
    }
    const contextId = props.updater.getNodeContextId();
    if (!contextId) await props.updater.updateContextId();
    const shouldNodeBeDeepCopied = await props.updater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) try {
        const copyNode = props.updater.copyNode({
            traceId: props.mediaNode.attrs.__mediaTraceId
        });
        props.addPendingTask(copyNode);
        await copyNode;
    } catch  {}
};
const $09f4c8054239e05a$var$useMediaAsyncOperations = ({ mediaNode: mediaNode, mediaNodeUpdater: mediaNodeUpdater, addPendingTask: addPendingTask, getPos: getPos, mediaChildNodeId: mediaChildNodeId })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!mediaNodeUpdater) return;
        // we want the first child of MediaSingle (type "media")
        const childNode = mediaNode.firstChild;
        if (!childNode) return;
        $09f4c8054239e05a$var$mediaAsyncOperations({
            mediaChildNode: childNode,
            updater: mediaNodeUpdater,
            getPos: getPos,
            mediaNode: mediaNode,
            addPendingTask: addPendingTask
        });
    // mediaChildNodeId is included so this effect re-runs when the media source
    // is replaced (id changes), ensuring getRemoteDimensions fires for the new file
    // with up-to-date updater props after setProps has been called.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mediaNode,
        addPendingTask,
        mediaNodeUpdater,
        getPos,
        mediaChildNodeId
    ]);
};
const $09f4c8054239e05a$var$noop = ()=>{};
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $09f4c8054239e05a$var$useLatestMediaNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $2InGJ.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!previousMediaNode || typeof previousMediaNode.eq !== 'function') return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $09f4c8054239e05a$var$useMediaDimensionsLogic = ({ childMediaNodeAttrs: childMediaNodeAttrs })=>{
    const { width: originalWidth, height: originalHeight } = childMediaNodeAttrs;
    const isExternalMedia = childMediaNodeAttrs.type === 'external';
    const hasMediaUrlBlob = isExternalMedia && typeof childMediaNodeAttrs.url === 'string' && (0, $geUVX.isMediaBlobUrlFromAttrs)(childMediaNodeAttrs);
    const urlBlobAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!hasMediaUrlBlob) return null;
        return (0, $6wYuL.getAttrsFromUrl)(childMediaNodeAttrs.url);
    }, [
        hasMediaUrlBlob,
        childMediaNodeAttrs
    ]);
    const { width: width, height: height } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        // original width and height of child media node (scaled)
        let width = originalWidth;
        let height = originalHeight;
        if (isExternalMedia) {
            if (urlBlobAttrs) {
                if (urlBlobAttrs) {
                    const { width: urlWidth, height: urlHeight } = urlBlobAttrs;
                    width = width || urlWidth;
                    height = height || urlHeight;
                }
            }
            if (width === null) width = (0, $4G6PK.DEFAULT_IMAGE_WIDTH);
            if (height === null) height = (0, $4G6PK.DEFAULT_IMAGE_HEIGHT);
        }
        if (!width || !height) {
            width = (0, $4G6PK.DEFAULT_IMAGE_WIDTH);
            height = (0, $4G6PK.DEFAULT_IMAGE_HEIGHT);
        }
        return {
            width: width,
            height: height
        };
    }, [
        originalWidth,
        originalHeight,
        isExternalMedia,
        urlBlobAttrs
    ]);
    return {
        width: width,
        height: height
    };
};
const $09f4c8054239e05a$var$useUpdateSizeCallback = ({ mediaNode: mediaNode, view: view, getPos: getPos })=>{
    const updateSize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((width, layout)=>{
        const { state: state, dispatch: dispatch } = view;
        const pos = getPos();
        if (typeof pos === 'undefined') return;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...mediaNode.attrs,
            layout: layout,
            width: width,
            widthType: 'pixel'
        });
        tr.setMeta('scrollIntoView', false);
        /**
     * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
     * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
     * The recommended fix is to reset the selection.[2]
     *
     * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
     * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
     */ tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, pos));
        return dispatch(tr);
    }, [
        view,
        getPos,
        mediaNode
    ]);
    return updateSize;
};
/**
 * This value is used to fallback when widthState is undefined.
 *
 * Previously, the old MediaSingle was ignoring the undefined situation:
 *
 * <MediaSingleNode
 *	  width={widthState!.width}
 *	  lineLength={widthState!.lineLength}
 */ const $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH = 760;
const $09f4c8054239e05a$export$4a00cdcfd685a172 = (mediaSingleNodeNextProps)=>{
    const { selected: selected, getPos: getPos, node: nextMediaNode, mediaOptions: mediaOptions, fullWidthMode: fullWidthMode, view: view, pluginInjectionApi: pluginInjectionApi, width: containerWidth, lineLength: lineLength, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorViewMode: editorViewMode, editorDisabled: editorDisabled, isDrafting: isDrafting, targetNodeId: targetNodeId, editorAppearance: editorAppearance, mediaProvider: mediaProviderPromise, forwardRef: forwardRef, contextIdentifierProvider: contextIdentifierProviderPromise, addPendingTask: addPendingTask } = mediaSingleNodeNextProps;
    const [mediaProvider, setMediaProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    const [_contextIdentifierProvider, setContextIdentifierProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    const pos = getPos();
    const isSelected = selected();
    const contentWidthForLegacyExperience = (0, $7ZFkz.getMaxWidthForNestedNode)(view, getPos()) || lineLength;
    const mediaNode = $09f4c8054239e05a$var$useLatestMediaNode(nextMediaNode);
    const mediaNodeUpdater = $09f4c8054239e05a$var$useMediaNodeUpdater({
        mediaNode: mediaNode,
        mediaSingleNodeProps: mediaSingleNodeNextProps,
        mediaProvider: mediaProvider,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent
    });
    $09f4c8054239e05a$var$useMediaAsyncOperations({
        mediaNodeUpdater: mediaNodeUpdater,
        getPos: getPos,
        mediaNode: mediaNode,
        addPendingTask: addPendingTask || $09f4c8054239e05a$var$noop,
        mediaChildNodeId: mediaNode.firstChild?.attrs.id
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        if (!mediaProviderPromise) return;
        mediaProviderPromise.then((resolvedProvider)=>{
            const { viewMediaClientConfig: viewMediaClientConfig } = resolvedProvider;
            if (mountedRef.current) {
                setViewMediaClientConfig(viewMediaClientConfig);
                setMediaProvider(resolvedProvider);
            }
        });
    }, [
        mediaProviderPromise
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!contextIdentifierProviderPromise) return;
        contextIdentifierProviderPromise.then((provider)=>{
            if (mountedRef.current) setContextIdentifierProvider(provider);
        });
    }, [
        contextIdentifierProviderPromise
    ]);
    const { layout: layout, widthType: widthType, width: mediaSingleWidthAttribute } = mediaNode.attrs;
    const childNode = mediaNode.firstChild;
    const childMediaNodeAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return childNode?.attrs || {};
    }, [
        childNode
    ]);
    const { width: width, height: height } = $09f4c8054239e05a$var$useMediaDimensionsLogic({
        childMediaNodeAttrs: childMediaNodeAttrs
    });
    const updateSize = $09f4c8054239e05a$var$useUpdateSizeCallback({
        view: view,
        getPos: getPos,
        mediaNode: mediaNode
    });
    const canResize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        const result = Boolean(!!mediaOptions.allowResizing && !editorDisabled && !editorViewMode);
        if (mediaOptions.allowResizingInTables) return result;
        // If resizing not allowed in tables, check parents for tables
        const $pos = view.state.doc.resolve(pos);
        const { table: table } = view.state.schema.nodes;
        const disabledNode = !!(0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
            table
        ]);
        return Boolean(result && !disabledNode);
    }, [
        mediaOptions,
        pos,
        view,
        editorDisabled,
        editorViewMode
    ]);
    const shouldShowPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const result = mediaOptions.allowCaptions && mediaNode.childCount !== 2 && isSelected && view.state.selection instanceof (0, $kCECX.NodeSelection);
        return !editorDisabled && result;
    }, [
        editorDisabled,
        mediaOptions.allowCaptions,
        mediaNode,
        view,
        isSelected
    ]);
    const isInsideTable = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        return (0, $bjg0G.findParentNodeOfTypeClosestToPos)(view.state.doc.resolve(pos), [
            view.state.schema.nodes.table
        ]);
    }, [
        pos,
        view
    ]);
    const currentMediaElement = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (typeof pos !== 'number') return null;
        const mediaNode = view.domAtPos(pos + 1).node;
        return mediaNode instanceof HTMLElement ? mediaNode : null;
    }, [
        view,
        pos
    ]);
    const mediaSingleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return (0, $p7uR0.calcMediaSinglePixelWidth)({
            width: mediaSingleWidthAttribute,
            widthType: widthType,
            origWidth: width,
            layout: layout,
            // This will only be used when calculating legacy media single width
            // thus we use the legacy value (exclude table as container node)
            contentWidth: contentWidthForLegacyExperience,
            containerWidth: containerWidth,
            gutterOffset: (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)
        });
    }, [
        mediaSingleWidthAttribute,
        widthType,
        width,
        layout,
        contentWidthForLegacyExperience,
        containerWidth
    ]);
    const currentMaxWidth = isSelected ? pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth : undefined;
    const contentWidth = currentMaxWidth || lineLength;
    const isCurrentNodeDrafting = Boolean(isDrafting && targetNodeId === mediaNode?.firstChild?.attrs.id);
    const mediaSingleWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    const captionPlaceHolderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    const browser = (0, $8dxef.getBrowserInfo)();
    const notIos = !browser.ios;
    const onMediaSingleClicked = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        const browser = (0, $8dxef.getBrowserInfo)();
        // Workaround for iOS 16 Caption selection issue
        // @see https://product-fabric.atlassian.net/browse/MEX-2012
        if (!browser.ios) return;
        if (mediaSingleWrapperRef.current !== event.target) return;
        captionPlaceHolderRef.current?.click();
    }, [
        mediaSingleWrapperRef,
        captionPlaceHolderRef
    ]);
    const onMediaSingleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (mediaSingleWrapperRef.current !== event.target) return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            captionPlaceHolderRef.current?.click();
        }
    }, [
        mediaSingleWrapperRef,
        captionPlaceHolderRef
    ]);
    const clickPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (typeof getPos === 'boolean') return;
        (0, $0f25f56fce6e0168$export$a34e35a63d969ea1)(pluginInjectionApi?.analytics?.actions)(getPos(), mediaNode)(view.state, view.dispatch);
    }, [
        view,
        getPos,
        mediaNode,
        pluginInjectionApi
    ]);
    const legacySize = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            width: mediaSingleWidthAttribute,
            widthType: widthType
        };
    }, [
        widthType,
        mediaSingleWidthAttribute
    ]);
    const MediaChildren = /*#__PURE__*/ (0, $lOiVq.jsx)("figure", {
        ref: mediaSingleWrapperRef,
        css: $09f4c8054239e05a$var$figureWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5arVd.MediaSingleNodeSelector),
        onClick: notIos ? undefined : onMediaSingleClicked,
        onKeyDown: notIos ? undefined : onMediaSingleKeyDown
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7UxJ0.MediaBadges), {
        mediaElement: currentMediaElement(),
        mediaHeight: height,
        mediaWidth: width,
        extendedResizeOffset: mediaOptions.allowPixelResizing && !isInsideTable
    }, ({ visible: visible })=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, visible && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2G2MI.ExternalImageBadge), {
            type: childMediaNodeAttrs.type,
            url: childMediaNodeAttrs.type === 'external' ? childMediaNodeAttrs.url : undefined
        }), mediaOptions.allowCommentsOnMedia && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $29c776a460b1e43a$export$28b46719ed075ab4), {
            view: view,
            api: pluginInjectionApi,
            mediaNode: mediaNode?.firstChild,
            getPos: getPos,
            isDrafting: isCurrentNodeDrafting
        }))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9sVl.NodeViewContentHole), {
        ref: forwardRef
    }), shouldShowPlaceholder && ((0, $ixfCV.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4a13f440c16c504b$export$dfb3d25b53c36a0a), {
        // platform_editor_typography_ugc clean up
        // remove typecasting
        ref: captionPlaceHolderRef,
        onClick: clickPlaceholder,
        placeholderMessage: mediaOptions.allowImagePreview ? (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholderWithDoubleClickPrompt : (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholder
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4a13f440c16c504b$export$283943db773aa526), {
        ref: captionPlaceHolderRef,
        onClick: clickPlaceholder,
        placeholderMessage: mediaOptions.allowImagePreview ? (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholderWithDoubleClickPrompt : (0, $d6e06a80e45c94b0$export$6a0665148042092b).placeholder
    })));
    if (widthType !== 'pixel') return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, canResize ? mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6ba326387cf7a246$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: true,
        forceHandlePositioning: mediaOptions?.forceHandlePositioning
    }, MediaChildren) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5ba1c3c7eefea430$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute
    }, MediaChildren) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aHoC6.default), {
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        editorAppearance: editorAppearance,
        pctWidth: mediaSingleWidthAttribute,
        lineLength: lineLength || $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH,
        size: legacySize
    }, MediaChildren));
    return mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6ba326387cf7a246$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: widthType !== 'pixel',
        forceHandlePositioning: mediaOptions?.forceHandlePositioning,
        disableHandles: !canResize
    }, MediaChildren) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5ba1c3c7eefea430$export$2e2bcd8739ae039), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $09f4c8054239e05a$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute,
        disableHandles: !canResize
    }, MediaChildren);
};


const $dc3343e483b8f408$var$selector = (states)=>{
    return {
        mediaProviderPromise: states.mediaState?.mediaProvider,
        addPendingTask: states.mediaState?.addPendingTask,
        isDrafting: states.annotationState?.isDrafting,
        targetNodeId: states.annotationState?.targetNodeId,
        width: states.widthState?.width,
        lineLength: states.widthState?.lineLength,
        editorDisabled: states.editorDisabledState?.editorDisabled,
        viewMode: states.editorViewModeState?.mode
    };
};
const $dc3343e483b8f408$var$MediaSingleNodeWrapper = ({ pluginInjectionApi: pluginInjectionApi, contextIdentifierProvider: contextIdentifierProvider, node: node, getPos: getPos, mediaOptions: mediaOptions, view: view, fullWidthMode: fullWidthMode, selected: selected, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, forwardRef: forwardRef, editorAppearance: editorAppearance })=>{
    const { mediaProviderPromise: mediaProviderPromise, addPendingTask: addPendingTask, isDrafting: isDrafting, targetNodeId: targetNodeId, width: width, lineLength: lineLength, editorDisabled: editorDisabled, viewMode: viewMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'media',
        'annotation',
        'editorDisabled',
        'editorViewMode'
    ], $dc3343e483b8f408$var$selector);
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const mediaProvider = (0, $cozmU.useMemo)(()=>mediaProviderPromise ? Promise.resolve(mediaProviderPromise) : undefined, [
        mediaProviderPromise
    ]);
    const isSelectedAndInteracted = (0, $cozmU.useCallback)(()=>Boolean(selected() && interactionState !== 'hasNotHadInteraction'), [
        interactionState,
        selected
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $09f4c8054239e05a$export$4a00cdcfd685a172), {
        width: width || 0,
        lineLength: lineLength || 0,
        node: node,
        getPos: getPos,
        mediaProvider: mediaProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        mediaOptions: mediaOptions,
        view: view,
        fullWidthMode: fullWidthMode,
        selected: isSelectedAndInteracted,
        eventDispatcher: eventDispatcher,
        addPendingTask: addPendingTask,
        isDrafting: isDrafting,
        targetNodeId: targetNodeId,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        forwardRef: forwardRef,
        pluginInjectionApi: pluginInjectionApi,
        editorDisabled: editorDisabled,
        editorViewMode: viewMode === 'view',
        editorAppearance: editorAppearance
    });
};
class $dc3343e483b8f408$var$MediaSingleNodeView extends (0, $Igylv.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // control the domRef contentEditable attribute based on the editor view mode
        this.unsubscribeToViewModeChange = this.subscribeToViewModeChange(domRef);
        const initialViewMode = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
        this.updateDomRefContentEditable(domRef, initialViewMode);
        if (this.reactComponentProps.mediaOptions?.allowPixelResizing) domRef.classList.add('media-extended-resize-experience');
        domRef.setAttribute('data-media-vc-wrapper', 'true');
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        dom.classList.add((0, $9k4mh.MEDIA_CONTENT_WRAP_CLASS_NAME));
        return {
            dom: dom
        };
    }
    viewShouldUpdate(nextNode) {
        if (this.forceViewUpdate) {
            this.forceViewUpdate = false;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        if (this.selectionType !== this.checkAndUpdateSelectionType()) return true;
        if (this.node.childCount !== nextNode.childCount) return true;
        return super.viewShouldUpdate(nextNode);
    }
    subscribeToViewModeChange(domRef) {
        return this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange((viewModeState)=>{
            this.updateDomRefContentEditable(domRef, viewModeState.nextSharedState?.mode);
        });
    }
    updateDomRefContentEditable(domRef, editorViewMode) {
        // if the editor is in view mode, we should not allow editing
        if (editorViewMode === 'view') {
            domRef.contentEditable = 'false';
            return;
        }
        // if the editor is in edit mode, we should allow editing if the media options allow it
        if (this.reactComponentProps.mediaOptions?.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
    }
    getNodeMediaId(node) {
        if (node.firstChild) return node.firstChild.attrs.id;
        return undefined;
    }
    stopEvent(event) {
        if (this.isNodeSelected() && event instanceof KeyboardEvent && event?.target instanceof HTMLElement) {
            const targetType = event.target.type;
            if (event.key === 'Enter' && targetType === 'button') return true;
        }
        return false;
    }
    update(node, decorations, _innerDecorations, isValidUpdate) {
        if (!isValidUpdate) isValidUpdate = (currentNode, newNode)=>this.getNodeMediaId(currentNode) === this.getNodeMediaId(newNode);
        // Detect mediaSingle width attribute changes and signal child media node to update
        if (!this.hasResized && this.node.attrs.width !== node.attrs.width) {
            const target = this.dom.querySelector('div[data-prosemirror-node-name="media"]');
            target?.dispatchEvent(new CustomEvent('resized'));
        }
        return super.update(node, decorations, _innerDecorations, isValidUpdate);
    }
    render(props, forwardRef) {
        const { eventDispatcher: eventDispatcher, fullWidthMode: fullWidthMode, providerFactory: providerFactory, mediaOptions: mediaOptions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, editorAppearance: editorAppearance, intl: intl } = this.reactComponentProps;
        // getPos is a boolean for marks, since this is a node we know it must be a function
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b7Tum.MediaSSRReactContextsProvider), {
            intl: intl
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                return /*#__PURE__*/ (0, $lOiVq.jsx)($dc3343e483b8f408$var$MediaSingleNodeWrapper, {
                    pluginInjectionApi: pluginInjectionApi,
                    contextIdentifierProvider: contextIdentifierProvider,
                    node: this.node,
                    getPos: getPos,
                    mediaOptions: mediaOptions,
                    view: this.view,
                    fullWidthMode: fullWidthMode,
                    selected: this.isNodeSelected,
                    eventDispatcher: eventDispatcher,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    forwardRef: forwardRef,
                    editorAppearance: editorAppearance
                });
            }
        }));
    }
    ignoreMutation() {
        // DOM has changed; recalculate if we need to re-render
        if (this.dom) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const offsetLeft = this.dom.offsetLeft;
            if (offsetLeft !== this.lastOffsetLeft) {
                this.lastOffsetLeft = offsetLeft;
                this.forceViewUpdate = true;
                this.update(this.node, [], undefined, ()=>true);
            }
        }
        return true;
    }
    destroy() {
        this.unsubscribeToViewModeChange?.();
    }
    constructor(...args){
        super(...args);
        this.lastOffsetLeft = 0;
        this.forceViewUpdate = false;
        this.selectionType = null;
        this.unsubscribeToViewModeChange = void 0;
        this.hasResized = false;
        this.checkAndUpdateSelectionType = ()=>{
            const getPos = this.getPos;
            const { selection: selection } = this.view.state;
            /**
       *  ED-19831
       *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
       *  directly to confluence since this bug is now in production.
       */ let pos;
            try {
                pos = getPos ? getPos() : undefined;
            } catch  {
                pos = undefined;
            }
            const isNodeSelected = (0, $gWBVp.isNodeSelectedOrInRange)(selection.$anchor.pos, selection.$head.pos, pos, this.node.nodeSize);
            this.selectionType = isNodeSelected;
            return isNodeSelected;
        };
        this.isNodeSelected = ()=>{
            this.checkAndUpdateSelectionType();
            return this.selectionType !== null;
        };
    }
}
const $dc3343e483b8f408$export$fd09b1a92f5ce9f7 = (portalProviderAPI, eventDispatcher, providerFactory, pluginInjectionApi, dispatchAnalyticsEvent, mediaOptions = {}, intl)=>(node, view, getPos)=>{
        return new $dc3343e483b8f408$var$MediaSingleNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            fullWidthMode: mediaOptions.fullWidthEnabled,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
            pluginInjectionApi: pluginInjectionApi,
            editorAppearance: mediaOptions.editorAppearance,
            intl: intl
        }).init();
    };



var $2fsTz = parcelRequire("2fsTz");


var $8Dx7s = parcelRequire("8Dx7s");




const $05167d1bf7527f26$export$daf6081925f8454b = (nodeName, node)=>{
    const copyPrivateAttributes = (// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    from, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    to, map)=>{
        if (node.attrs) Object.keys(node.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const attrs = {
        'data-id': node.attrs.id,
        'data-node-type': `${nodeName}`,
        'data-type': node.attrs.type,
        'data-collection': node.attrs.collection,
        'data-occurrence-key': node.attrs.occurrenceKey,
        'data-width': node.attrs.width,
        'data-height': node.attrs.height,
        'data-url': node.attrs.url,
        'data-alt': node.attrs.alt,
        // toDOM is used for static rendering as well as editor rendering. This comes into play for
        // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
        // node view being used for editing).
        title: 'Attachment',
        // Manually kept in sync with the style of media cards. The goal is to render a plain gray
        // rectangle that provides an affordance for media.
        style: `display: inline-block; border-radius: 3px; background: #EBECF0; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
    };
    copyPrivateAttributes(node.attrs, attrs, (key)=>`data-${$05167d1bf7527f26$export$f84fdfb973c05bd8(key.slice(2))}`);
    return attrs;
};
const $05167d1bf7527f26$export$f84fdfb973c05bd8 = (str)=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $05167d1bf7527f26$export$6efdb466dbe90a4b = (withExtendedWidthTypes, node)=>{
    const { layout: layout, width: width } = node.attrs;
    const attrs = {
        'data-node-type': 'mediaSingle',
        'data-layout': layout
    };
    if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
    const { widthType: widthType } = node.attrs;
    return {
        ...attrs,
        'data-width-type': widthType || 'percentage',
        'data-media-vc-wrapper': 'true'
    };
};


const $c84764e57e50c687$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $c84764e57e50c687$export$9f8a4f04eb482f68 = ()=>{
    return {
        ...(0, $2fsTz.media),
        toDOM: (node)=>{
            const attrs = (0, $05167d1bf7527f26$export$daf6081925f8454b)('media', node);
            if (node.attrs.type === 'external') return [
                'img',
                {
                    ...attrs,
                    src: node.attrs.url,
                    style: (0, $8Dx7s.convertToInlineCss)({
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
                        outline: 'none',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 100%)`
                    })
                }
            ];
            if (node.attrs.type === 'file') {
                const dataUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                const width = $c84764e57e50c687$export$d87a47989c00f322.width;
                const height = $c84764e57e50c687$export$d87a47989c00f322.height;
                const sharedAttrs = {
                    width: width,
                    height: height,
                    ...attrs,
                    // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                    // rectangle that provides an affordance for media.
                    style: (0, $8Dx7s.convertToInlineCss)({
                        display: 'var(--ak-editor-media-card-display, inline-block)',
                        backgroundImage: `url("${dataUrl}")`,
                        marginLeft: '0',
                        marginRight: 'var(--ak-editor-media-margin-right, 4px)',
                        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
                        borderRadius: "var(--ds-radius-small, 3px)",
                        outline: 'none',
                        flexBasis: `${$c84764e57e50c687$export$d87a47989c00f322.width}px`,
                        backgroundColor: 'var(--ak-editor-media-card-background-color)',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 0)`,
                        paddingBottom: `var(--ak-editor-media-padding-bottom, 0)`
                    })
                };
                // Safari is stripping the dom if a child does not exist for the media nodes on safari.
                // Creating an empty child allows safari to pick up the media node within the clipboard.
                // https://product-fabric.atlassian.net/browse/ED-25841
                return (0, $ixfCV.fg)('platform_editor_safari_media_clipboard_fix') ? [
                    'div',
                    sharedAttrs,
                    [
                        'div',
                        {}
                    ]
                ] : [
                    'div',
                    sharedAttrs
                ];
            }
            return [
                'div',
                {
                    ...attrs,
                    styles: (0, $8Dx7s.convertToInlineCss)({
                        backgroundColor: `var(--ak-editor-media-card-background-color, ${"var(--ds-background-neutral, #0515240F)"})`,
                        outline: 'none'
                    })
                }
            ];
        }
    };
};



var $l73oM = parcelRequire("l73oM");

const $2f91ab31b5f56f89$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2f91ab31b5f56f89$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2f91ab31b5f56f89$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2f91ab31b5f56f89$export$ed7b8a4728e9c63 = (appearance = 'auto')=>{
    if (appearance === 'image') return $2f91ab31b5f56f89$export$d87a47989c00f322;
    if (appearance === 'square') return $2f91ab31b5f56f89$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2f91ab31b5f56f89$export$aeb48196afcd236a;
    return $2f91ab31b5f56f89$export$d87a47989c00f322;
};
const $2f91ab31b5f56f89$export$927453cb1fcf720e = ()=>{
    return {
        ...(0, $l73oM.mediaGroup),
        toDOM: ()=>{
            // Margin margin that consolidates the margin in the
            return [
                'div',
                {
                    style: `
						margin: 3px 5px;
						display: flex;
						gap: 8px;
						--ak-editor-media-card-background-color: #EBECF0;
						--ak-editor-media-card-width: ${$2f91ab31b5f56f89$export$d87a47989c00f322.width}px;
						--ak-editor-media-card-height: ${$2f91ab31b5f56f89$export$d87a47989c00f322.height}px;
					`,
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    };
};



var $9biYD = parcelRequire("9biYD");


const $cab0e5f2f63f8407$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #0515240F)"};`;
// Matches media
const $cab0e5f2f63f8407$var$fallbackAspectRatio = 1.25;
const $cab0e5f2f63f8407$export$e71594f26ef09ec1 = ()=>{
    return {
        ...(0, $9biYD.mediaInline),
        toDOM: (node)=>{
            const dataAttrs = (0, $05167d1bf7527f26$export$daf6081925f8454b)('mediaInline', node);
            if (node.attrs.type === 'image') {
                const aspectRatio = node.attrs.width && node.attrs.height ? node.attrs.width / node.attrs.height : $cab0e5f2f63f8407$var$fallbackAspectRatio;
                return [
                    'span',
                    {
                        ...dataAttrs,
                        style: 'display: inline-block; transform: translateY(6px)',
                        class: 'media-inline-image-wrapper'
                    },
                    [
                        'span',
                        {
                            height: '100%',
                            width: '100%',
                            // Transparent image workaround to control styling
                            src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                            style: `display: inline-block; aspect-ratio: ${aspectRatio}; height: 100%; width: 100%; border-radius: ${"var(--ds-radius-small, 3px)"}; ${$cab0e5f2f63f8407$var$skeletonStyling}`
                        }
                    ]
                ];
            } else return [
                'span',
                {
                    ...dataAttrs,
                    style: `display: inline-block; transform: translateY(6px); ${$cab0e5f2f63f8407$var$skeletonStyling}`,
                    class: 'media-inline-image-wrapper'
                },
                [
                    'span',
                    {
                        style: `display: inline-block; height: 100%; width: 100%; aspect-ratio: ${$cab0e5f2f63f8407$var$fallbackAspectRatio};`
                    }
                ]
            ];
        }
    };
};



var $f3bB0 = parcelRequire("f3bB0");





const $15153c82cbcfc2b5$var$WRAPPED_LAYOUTS = [
    'wrap-left',
    'wrap-right'
];
const $15153c82cbcfc2b5$var$ALIGNED_LAYOUTS = [
    'align-end',
    'align-start'
];
const $15153c82cbcfc2b5$var$LEGACY_LAYOUTS = [
    'full-width',
    'wide'
];
const $15153c82cbcfc2b5$var$DEFAULT_IMAGE_WIDTH = 250;
const $15153c82cbcfc2b5$var$DEFAULT_IMAGE_HEIGHT = 200;
const $15153c82cbcfc2b5$var$GUTTER_SIZE = '24px';
const $15153c82cbcfc2b5$var$HALF_GUTTER_SIZE = '12px';
const $15153c82cbcfc2b5$export$7d83792003901332 = ({ mediaSingleDimensionWidth: mediaSingleDimensionWidth, layout: layout, baseWidth: baseWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    const isMediaWrapped = $15153c82cbcfc2b5$var$WRAPPED_LAYOUTS.includes(layout);
    const isMediaAligned = $15153c82cbcfc2b5$var$ALIGNED_LAYOUTS.includes(layout);
    const isMediaLegacyLayout = $15153c82cbcfc2b5$var$LEGACY_LAYOUTS.includes(layout);
    const shouldUseAlignedLayoutCalc = isMediaAligned && !hasMediaDimensionWidth;
    const shouldUseWrappedLayoutCalc = isMediaWrapped && !hasMediaDimensionWidth;
    const shouldUseBreakoutWideLogic = layout === 'wide';
    const shouldUseBreakoutFullWidthLogic = layout === 'full-width';
    const shouldUseProportionalCalc = !isExtendedResizeExperience && !isPixelWidth && hasMediaDimensionWidth && !isMediaLegacyLayout && !isMediaWrapped;
    const shouldUseHalfContainerCalc = shouldUseProportionalCalc && isMediaAligned && mediaSingleDimensionWidth >= 100;
    const shouldHardCodePixelWidth = isExtendedResizeExperience && isPixelWidth && hasMediaDimensionWidth;
    const containerWidthPlusGutter = `(min(100cqw, 100%) + ${$15153c82cbcfc2b5$var$GUTTER_SIZE})`;
    const fullContainerWidth = 'var(--ak-editor-max-container-width, 100cqw)';
    const applyContainerWidthBoundaries = (calc)=>{
        // Safe measure to avoid bleeding
        return `min(${calc}, ${fullContainerWidth})`;
    };
    let cssCalc = '';
    if (shouldUseAlignedLayoutCalc) cssCalc = `min(calc(${containerWidthPlusGutter} * 0.5 - ${$15153c82cbcfc2b5$var$GUTTER_SIZE}), ${baseWidth}px)`;
    else if (shouldUseWrappedLayoutCalc) cssCalc = `100%`;
    else if (shouldUseHalfContainerCalc) cssCalc = `min(min(${baseWidth}px, calc(50cqw - ${$15153c82cbcfc2b5$var$HALF_GUTTER_SIZE})), 100%)`;
    else if (shouldUseProportionalCalc) cssCalc = `calc(${containerWidthPlusGutter} * var(--ak-editor-media-single--proportion, 1px) - ${$15153c82cbcfc2b5$var$GUTTER_SIZE})`;
    else if (shouldHardCodePixelWidth) cssCalc = `min(${mediaSingleDimensionWidth}px, ${fullContainerWidth})`;
    else if (shouldUseBreakoutWideLogic) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width)))`;
    else if (shouldUseBreakoutFullWidthLogic) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width)))`;
    else cssCalc = `max(min(${baseWidth}px, min(100cqw, 100%)), ${$15153c82cbcfc2b5$var$GUTTER_SIZE})`;
    return applyContainerWidthBoundaries(cssCalc);
};
const $15153c82cbcfc2b5$export$f236e46eb0ba66bc = ({ isMediaWrapped: isMediaWrapped, isExternalMedia: isExternalMedia, isPixelWidth: isPixelWidth, childMediaWidth: childMediaWidth, mediaSingleDimensionWidth: mediaSingleDimensionWidth })=>{
    if (isExternalMedia || !isMediaWrapped) return 'unset';
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    if (!hasMediaDimensionWidth) return `calc((100% / 2) - ${$15153c82cbcfc2b5$var$HALF_GUTTER_SIZE})`;
    if (isPixelWidth) return `min(calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$15153c82cbcfc2b5$var$HALF_GUTTER_SIZE}), ${mediaSingleDimensionWidth}px)`;
    const hasChildMediaWidth = typeof childMediaWidth === 'number';
    if (hasChildMediaWidth) return `min(calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$15153c82cbcfc2b5$var$HALF_GUTTER_SIZE}), ${childMediaWidth}px)`;
    return `calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$15153c82cbcfc2b5$var$HALF_GUTTER_SIZE})`;
};
const $15153c82cbcfc2b5$export$e6a8bed31e6b00e2 = ({ isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isMediaWrapped: isMediaWrapped })=>{
    const hasMediaWidth = typeof mediaSingleDimensionWidth === 'number';
    if (isPixelWidth || isExtendedResizeExperience || !hasMediaWidth) return 'unset';
    if (isMediaWrapped) return mediaSingleDimensionWidth >= 50 ? '1' : `${1 - mediaSingleDimensionWidth / 100}`;
    return `${mediaSingleDimensionWidth / 100}`;
};
const $15153c82cbcfc2b5$export$899bc2e8a274123a = ({ layout: layout })=>{
    switch(layout){
        case 'align-end':
        case 'wrap-right':
            return 'end';
        case 'align-start':
        case 'wrap-left':
            return 'start';
        default:
            return 'center';
    }
};
const $15153c82cbcfc2b5$export$e03be381a0c66cf5 = ({ layout: layout, dataAttrs: dataAttrs, childMediaWidth: childMediaWidth, childMediaHeight: childMediaHeight, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const layoutStyleJustifyContent = $15153c82cbcfc2b5$export$899bc2e8a274123a({
        layout: layout
    });
    const mediaWidthCalc = $15153c82cbcfc2b5$export$7d83792003901332({
        layout: layout,
        mediaSingleDimensionWidth: mediaSingleDimensionWidth,
        baseWidth: childMediaWidth,
        isPixelWidth: isPixelWidth,
        isExtendedResizeExperience: isExtendedResizeExperience
    });
    const paddingBottom = `calc((${childMediaHeight} / ${childMediaWidth}) * 100%)`;
    return [
        'div',
        {
            class: `rich-media-item mediaSingleView-content-wrap image-${layout}`,
            style: (0, $8Dx7s.convertToInlineCss)({
                display: 'flex',
                justifyContent: layoutStyleJustifyContent,
                transform: 'unset',
                marginLeft: '0'
            }),
            ...dataAttrs
        },
        [
            'div',
            {
                style: (0, $8Dx7s.convertToInlineCss)({
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: mediaWidthCalc,
                    minWidth: mediaWidthCalc,
                    color: "var(--ds-icon, #292A2E)"
                })
            },
            [
                'figure',
                {
                    class: 'media-single-node',
                    style: (0, $8Dx7s.convertToInlineCss)({
                        '--ak-editor-media-padding-bottom': paddingBottom,
                        margin: '0px'
                    })
                },
                [
                    'div',
                    {},
                    [
                        'div',
                        {
                            class: 'media-content-wrap'
                        },
                        0
                    ]
                ]
            ]
        ]
    ];
};
const $15153c82cbcfc2b5$export$e23517a19eb0e861 = (allowPixelResizing)=>(node)=>{
        const mediaSingleAttrs = node.attrs;
        const isPixelWidth = mediaSingleAttrs?.widthType === 'pixel';
        const layout = mediaSingleAttrs?.layout ?? 'center';
        const childNode = node.firstChild;
        const isExternalMedia = childNode?.attrs.type === 'external';
        const childMediaWidth = childNode?.attrs.width || $15153c82cbcfc2b5$var$DEFAULT_IMAGE_WIDTH;
        const childMediaHeight = childNode?.attrs.height || $15153c82cbcfc2b5$var$DEFAULT_IMAGE_HEIGHT;
        const dataAttrs = (0, $05167d1bf7527f26$export$6efdb466dbe90a4b)(true, node);
        const content = $15153c82cbcfc2b5$export$e03be381a0c66cf5({
            layout: layout,
            dataAttrs: dataAttrs,
            childMediaWidth: childMediaWidth,
            childMediaHeight: childMediaHeight,
            mediaSingleDimensionWidth: mediaSingleAttrs.width,
            isPixelWidth: isPixelWidth,
            isExtendedResizeExperience: allowPixelResizing
        });
        const isMediaWrapped = $15153c82cbcfc2b5$var$WRAPPED_LAYOUTS.includes(layout);
        const proportionCalc = $15153c82cbcfc2b5$export$e6a8bed31e6b00e2({
            isPixelWidth: isPixelWidth,
            isMediaWrapped: isMediaWrapped,
            mediaSingleDimensionWidth: mediaSingleAttrs?.width,
            isExtendedResizeExperience: allowPixelResizing
        });
        const contentWrapperWidth = $15153c82cbcfc2b5$export$f236e46eb0ba66bc({
            isMediaWrapped: isMediaWrapped,
            isExternalMedia: isExternalMedia,
            isPixelWidth: isPixelWidth,
            childMediaWidth: childMediaWidth,
            mediaSingleDimensionWidth: mediaSingleAttrs?.width
        });
        return [
            'div',
            {
                class: 'mediaSingleView-content-wrap',
                layout: layout,
                'data-media-vc-wrapper': 'true',
                style: (0, $8Dx7s.convertToInlineCss)({
                    '--ak-editor-media-single--proportion': proportionCalc,
                    '--ak-editor-media-card-display': 'block',
                    '--ak-editor-media-single--gutter-size': $15153c82cbcfc2b5$var$GUTTER_SIZE,
                    '--ak-editor-media-margin-right': '0',
                    '--ak-editor-media-card-background-color': "var(--ds-background-neutral, #0515240F)",
                    marginTop: isMediaWrapped ? $15153c82cbcfc2b5$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginBottom: isMediaWrapped ? $15153c82cbcfc2b5$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginRight: isMediaWrapped ? layout === 'wrap-right' ? 'auto' : $15153c82cbcfc2b5$var$HALF_GUTTER_SIZE : 0,
                    marginLeft: isMediaWrapped ? layout === 'wrap-left' ? 'auto' : $15153c82cbcfc2b5$var$HALF_GUTTER_SIZE : 0,
                    width: contentWrapperWidth
                })
            },
            content
        ];
    };
const $15153c82cbcfc2b5$export$7540e2ccc4187dcf = (mediaSingleOption)=>{
    const mediaSingleNode = (0, $f3bB0.mediaSingleSpec)(mediaSingleOption);
    const toDOM = $15153c82cbcfc2b5$export$e23517a19eb0e861(mediaSingleOption.withExtendedWidthTypes);
    return {
        ...mediaSingleNode,
        toDOM: toDOM
    };
};







var $cI8RZ = parcelRequire("cI8RZ");

var $2w79Z = parcelRequire("2w79Z");




var $e8618caed4fa750e$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'updateAltText':
            return {
                ...state
            };
        case 'openMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: true
            };
        case 'closeMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: false
            };
        default:
            return state;
    }
};


const $cf420da73fb250ce$var$pluginKey = new (0, $kCECX.PluginKey)('mediaAltTextPlugin');
const $cf420da73fb250ce$var$dest = (0, $cI8RZ.pluginFactory)($cf420da73fb250ce$var$pluginKey, (0, $e8618caed4fa750e$export$2e2bcd8739ae039), {
    onSelectionChanged: (tr, newState)=>{
        // dont close alt text for undo/redo transactions (if it comes from prosemirror-history)
        if (tr.getMeta((0, $2w79Z.pmHistoryPluginKey))) return newState;
        return {
            isAltTextEditorOpen: false
        };
    }
});
const $cf420da73fb250ce$var$createPluginState = $cf420da73fb250ce$var$dest.createPluginState;
const $cf420da73fb250ce$export$8d4021544bdece00 = $cf420da73fb250ce$var$dest.createCommand;
const $cf420da73fb250ce$export$f05434c51e3762e = $cf420da73fb250ce$var$dest.getPluginState;
const $cf420da73fb250ce$export$ae829ec7b2625219 = ({ dispatch: dispatch, providerFactory: providerFactory })=>{
    return new (0, $kpCD8.SafePlugin)({
        state: $cf420da73fb250ce$var$createPluginState(dispatch, {
            isAltTextEditorOpen: false
        }),
        key: $cf420da73fb250ce$var$pluginKey
    });
};



var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");





var $eEdSM = parcelRequire("eEdSM");








var $7mc9A = parcelRequire("7mc9A");


const $89c53bb0b7f851eb$var$createCommandWithAnalytics = (actionType, action, transform)=>{
    return (editorAnalyticsAPI)=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, (state)=>{
            const mediaNode = (0, $geUVX.getMediaSingleOrInlineNodeFromSelection)(state);
            const type = (0, $7mc9A.getNodeType)(state);
            return {
                action: actionType,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    mediaType: mediaNode.attrs.type
                }
            };
        })((0, $cf420da73fb250ce$export$8d4021544bdece00)(action, transform));
    };
};
const $89c53bb0b7f851eb$export$e494ea08c5b8d2cd = (altText)=>{
    const commandTransform = typeof altText === 'string' ? $89c53bb0b7f851eb$var$updateAltTextTransform(altText) : undefined;
    return (0, $cf420da73fb250ce$export$8d4021544bdece00)((state)=>{
        if ((0, $geUVX.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'closeMediaAltTextMenu'
        };
        return false;
    }, commandTransform);
};
const $89c53bb0b7f851eb$export$56a9d6e428ac89c9 = $89c53bb0b7f851eb$export$e494ea08c5b8d2cd();
const $89c53bb0b7f851eb$export$e5f8c6baa484e73d = $89c53bb0b7f851eb$var$createCommandWithAnalytics((0, $krYZG.ACTION).OPENED, (state)=>{
    if ((0, $geUVX.isMediaSingleOrInlineNodeSelected)(state)) return {
        type: 'openMediaAltTextMenu'
    };
    return false;
}, (tr)=>tr.setMeta('scrollIntoView', false));
const $89c53bb0b7f851eb$var$updateAltTextTransform = (newAltText)=>(tr, state)=>{
        const mediaNode = (0, $geUVX.getMediaSingleOrInlineNodeFromSelection)(state);
        if (mediaNode) {
            // mediaSingle or mediaInline
            const originalSelectionPos = tr.selection.from;
            const mediaPos = mediaNode.type === state.schema.nodes.media ? originalSelectionPos + 1 // media inside mediaSingle
             : originalSelectionPos; // mediaInline
            /**
			 * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
			 * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
			 * The recommended fix is to reset the selection.[2]
			 *
			 * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
			 * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
			 */ tr.setMeta('scrollIntoView', false).setNodeMarkup(mediaPos, undefined, {
                ...mediaNode.attrs,
                alt: newAltText
            }).setSelection((0, $kCECX.NodeSelection).create(tr.doc, originalSelectionPos));
        }
        return tr;
    };
const $89c53bb0b7f851eb$export$d4d994ee16c78b4b = (newAltText)=>(0, $cf420da73fb250ce$export$8d4021544bdece00)((state)=>{
        if ((0, $geUVX.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'updateAltText'
        };
        return false;
    }, $89c53bb0b7f851eb$var$updateAltTextTransform(newAltText));


function $18fbf82b74023294$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.addAltText).common, (0, $89c53bb0b7f851eb$export$e5f8c6baa484e73d)(editorAnalyticsAPI), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.escape).common, (0, $89c53bb0b7f851eb$export$56a9d6e428ac89c9), list);
    return (0, $44cyU.keymap)(list);
}



var $fw4RS = parcelRequire("fw4RS");









var $d55P7 = parcelRequire("d55P7");

const $596922be77b060f5$export$9f7495958f6fc412 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $2mgqy.stateKey), {
            type: (0, $fw4RS.ACTIONS).SHOW_MEDIA_VIEWER,
            mediaViewerSelectedMedia: media,
            isMediaViewerVisible: true
        });
        return tr;
    };
const $596922be77b060f5$export$4e934779424102f3 = ({ tr: tr })=>{
    tr.setMeta((0, $2mgqy.stateKey), {
        type: (0, $fw4RS.ACTIONS).HIDE_MEDIA_VIEWER,
        mediaViewerSelectedMedia: null,
        isMediaViewerVisible: false
    });
    return tr;
};
const $596922be77b060f5$export$3d560bf5e623346d = (attrs)=>({ tr: tr })=>{
        const identifier = (0, $geUVX.getIdentifier)(attrs);
        tr.setMeta((0, $2mgqy.stateKey), {
            type: (0, $fw4RS.ACTIONS).TRACK_MEDIA_PASTE,
            identifier: identifier
        });
        return tr;
    };
const $596922be77b060f5$export$b4a04e6655f9ee09 = (mediaId, source)=>({ tr: tr })=>(0, $1a7aa8d16b1384d6$export$dacdbc7b94b414ee)(tr, mediaId, source);
const $596922be77b060f5$export$573182394cb8259c = (mediaId)=>({ tr: tr })=>(0, $1a7aa8d16b1384d6$export$d9968a0fb720c8d8)(tr, mediaId);
const $596922be77b060f5$export$483fbd616c5570ae = (editorAnalyticsAPI, allowPixelResizing)=>(mediaAttrs, inputMethod, insertMediaVia, positions, dataConsumerSource)=>(0, $d55P7.createInsertMediaAsMediaSingleCommand)(mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, positions, dataConsumerSource);








const $ce057ab641682293$export$1a764a38ffc131af = (0, $kSwu1.defineMessages)({
    MediaWidthIsMax: {
        id: "fabric.editor.media.pixelEntry.MediaWidthIsMax",
        defaultMessage: "Media increased to the maximum size"
    },
    MediaWidthIsMin: {
        id: "fabric.editor.media.MediaWidthIsMin",
        defaultMessage: "Media decreased to the minimum size"
    },
    DefaultMediaWidthIncreased: {
        id: "fabric.editor.media.DefaultMediaWidthIncreased",
        defaultMessage: "{newMediaWidth, plural, one {Media width increased to # pixel.} other {Media width increased to # pixels.}}"
    },
    DefaultMediaWidthDecreased: {
        id: "fabric.editor.media.DefaultMediaWidthDecreased",
        defaultMessage: "{newMediaWidth, plural, one {Media width decreased to # pixel.} other {Media width decreased to # pixels.}}"
    }
});








var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


















var $2ETaj = parcelRequire("2ETaj");

function $558d9096a667e962$var$keymapPlugin(options, editorAnalyticsAPI, editorSelectionAPI, widthPlugin, getIntl) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.undo).common, $558d9096a667e962$var$ignoreLinksInSteps, list);
    if (options?.allowCaptions) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveDown).common, $558d9096a667e962$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.tab).common, $558d9096a667e962$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveLeft).common, $558d9096a667e962$var$arrowLeftFromMediaSingle(editorSelectionAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveRight).common, $558d9096a667e962$var$arrowRightFromMediaSingle(editorSelectionAPI), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.insertNewLine).common, $558d9096a667e962$var$splitMediaGroup, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $558d9096a667e962$var$splitMediaGroup, list);
    if (options?.allowPixelResizing) {
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.increaseMediaSize).common, $558d9096a667e962$var$handleMediaIncrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.decreaseMediaSize).common, $558d9096a667e962$var$handleMediaDecrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.activateVideoControls).common, $558d9096a667e962$var$focusPlayButton, list);
    return (0, $44cyU.keymap)(list);
}
const $558d9096a667e962$var$ignoreLinksInSteps = (state)=>{
    const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
    mediaPluginState.ignoreLinks = true;
    return false;
};
const $558d9096a667e962$var$splitMediaGroup = (state)=>{
    const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
    return mediaPluginState.splitMediaGroup();
};
const $558d9096a667e962$var$focusPlayButton = (state)=>{
    const videoControlsWrapperRef = (0, $2mgqy.stateKey).getState(state)?.element;
    if (videoControlsWrapperRef) {
        const firstButton = videoControlsWrapperRef?.querySelector('button, [tabindex]:not([tabindex="-1"])');
        firstButton?.focus();
    }
    return true;
};
const $558d9096a667e962$var$validationMaxMin = (newWidth, maxWidth, minWidth, validation)=>{
    let newWidthValidated;
    if (newWidth > maxWidth) {
        newWidthValidated = maxWidth;
        validation = 'greater-than-max';
    } else if (newWidth < minWidth) {
        newWidthValidated = minWidth;
        validation = 'less-than-min';
    } else {
        newWidthValidated = newWidth;
        validation = 'valid';
    }
    return {
        newWidthValidated: newWidthValidated,
        validation: validation
    };
};
const $558d9096a667e962$var$createAnnouncer = (action, mediaWidth, changeAmount, validation, getIntl)=>{
    const announcerContainer = document.getElementById('media-announcer') || document.createElement('div');
    const intl = getIntl();
    if (!announcerContainer.id) {
        announcerContainer.id = 'media-announcer';
        announcerContainer.setAttribute('role', 'status');
        announcerContainer.setAttribute('aria-live', 'polite');
        announcerContainer.setAttribute('aria-atomic', 'true');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style = announcerContainer.style;
        style.position = 'absolute';
        style.width = '1px';
        style.height = '1px';
        style.marginTop = '-1px';
        style.opacity = '0';
        style.overflow = 'hidden';
        document.body.appendChild(announcerContainer);
    } else {
        const newMediaWidth = mediaWidth + changeAmount;
        if (validation === 'greater-than-max') announcerContainer.textContent = intl.formatMessage((0, $ce057ab641682293$export$1a764a38ffc131af).MediaWidthIsMax);
        else if (validation === 'less-than-min') announcerContainer.textContent = intl.formatMessage((0, $ce057ab641682293$export$1a764a38ffc131af).MediaWidthIsMin);
        else announcerContainer.textContent = intl.formatMessage(action === 'increased' ? (0, $ce057ab641682293$export$1a764a38ffc131af).DefaultMediaWidthIncreased : (0, $ce057ab641682293$export$1a764a38ffc131af).DefaultMediaWidthDecreased, {
            newMediaWidth: newMediaWidth
        });
    }
};
const $558d9096a667e962$var$handleMediaSizeChange = (editorAnalyticsAPI, widthPlugin, options, changeAmount, action, getIntl)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (!(selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'mediaSingle')) return false;
        const mediaWidth = (0, $2ETaj.getSelectedMediaSingle)(state)?.node?.attrs?.width;
        const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth);
        const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
        const maxWidthForNestedNode = mediaPluginState.currentMaxWidth;
        const minWidth = (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let maxWidth = maxWidthForNestedNode;
        const currentMaxWidth = widthPlugin?.sharedState.currentState()?.width || maxWidth;
        if (maxWidth === undefined && maxWidthForNestedNode === undefined) maxWidth = options?.fullWidthEnabled ? widthPlugin?.sharedState.currentState()?.lineLength : (0, $hS5Am.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        const validation = 'valid';
        const newWidth = mediaWidth + changeAmount;
        if (options?.fullWidthEnabled) maxWidth = widthPlugin?.sharedState.currentState()?.lineLength;
        else if (maxWidthForNestedNode === undefined) maxWidth = (0, $hS5Am.calcMediaSingleMaxWidth)(currentMaxWidth, options?.editorAppearance);
        const { newWidthValidated: newWidthValidated, validation: validationResult } = $558d9096a667e962$var$validationMaxMin(newWidth, maxWidth, minWidth, validation);
        const newLayout = (0, $2ETaj.calcNewLayout)(newWidthValidated, (0, $2ETaj.getSelectedMediaSingle)(state)?.node?.attrs?.layout, contentWidth, options?.fullWidthEnabled);
        (0, $7mc9A.updateMediaSingleWidth)(editorAnalyticsAPI)(newWidthValidated, validationResult, 'keyboard', newLayout)(state, dispatch);
        $558d9096a667e962$var$createAnnouncer(action, mediaWidth, changeAmount, validationResult, getIntl);
        return true;
    };
const $558d9096a667e962$var$handleMediaIncrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$558d9096a667e962$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, 1, 'increased', getIntl);
const $558d9096a667e962$var$handleMediaDecrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$558d9096a667e962$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, -1, 'decreased', getIntl);
const $558d9096a667e962$var$insertAndSelectCaption = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type === schema.nodes.mediaSingle && schema.nodes.caption) {
            if (dispatch) {
                const { from: from, node: node } = selection;
                if (!(0, $0f25f56fce6e0168$export$a34e35a63d969ea1)(editorAnalyticsAPI)(from, node)(state, dispatch)) (0, $0f25f56fce6e0168$export$994ea9c3fa8e0b0c)(from, node)(state, dispatch);
            }
            return true;
        }
        return false;
    };
const $558d9096a667e962$var$arrowLeftFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(selection.from), (0, $eaLat.Side).LEFT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $558d9096a667e962$var$arrowRightFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $4EksL.GapCursorSelection)(state.doc.resolve(selection.to), (0, $eaLat.Side).RIGHT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
var $558d9096a667e962$export$2e2bcd8739ae039 = $558d9096a667e962$var$keymapPlugin;






var $jzePg = parcelRequire("jzePg");





var $iUNgd = parcelRequire("iUNgd");










/**
 * Check if is an empty selection at the start of the node
 */ function $d72bc7f44fb21c4f$var$isEmptySelectionAtStart(selection) {
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    return $from.parentOffset <= 0;
}
/**
 * Check if the current selection is inside a node type
 */ function $d72bc7f44fb21c4f$var$isSelectionInsideOf(selection, nodeType) {
    const { $from: $from } = selection;
    const parent = $from.parent;
    return parent.type === nodeType;
}
/**
 * Return the sibling of the current selection
 */ function $d72bc7f44fb21c4f$var$getSibling(selection, sibling) {
    const { $from: $from } = selection;
    const index = $from.index($from.depth - 1);
    const grandParent = $from.node($from.depth - 1); // Get GrandParent
    return grandParent ? grandParent.maybeChild(index + sibling) : null;
}
/**
 * Check if respective sibling (negative number previous, positive number next)
 * is from the specified node
 */ function $d72bc7f44fb21c4f$var$isSiblingOfType(selection, node, sibling) {
    const maybeSiblingNode = $d72bc7f44fb21c4f$var$getSibling(selection, sibling);
    return !!maybeSiblingNode && maybeSiblingNode.type === node;
}
/**
 * When there's any empty block before another paragraph with wrap-right
 * mediaSingle. Pressing backspace at the start of the paragraph will select
 * the media but visually it makes more sense to remove the empty paragraph.
 *
 * Structure of the document: doc(block(), mediaSingle(media()), paragraph('{<>}hello!'))
 * But, visually it looks like the following:
 *
 *    [empty block] <- Remove this block
 * or [paragraph block] <- Move text inside this paragraph
 * or [any other block] <- Move paragraph node after this node
 * [Cursor] x x x x x x x x  +---------------+
 * x x x x x x x x x x       |  mediaSingle  |
 * x x x x x.                +---------------+
 */ function $d72bc7f44fb21c4f$var$handleSelectionAfterWrapRight(isEmptyNode) {
    function isEmptyWithoutThrow(node) {
        let isEmpty = false;
        try {
            // We dont have isEmptyNode definition for table for example.
            // In this case it will throw we need to catch it
            isEmpty = isEmptyNode(node);
        } catch (e) {}
        return isEmpty;
    }
    return (state, dispatch)=>{
        const { $from: $from } = state.selection;
        const { paragraph: paragraph } = state.schema.nodes;
        const previousMediaSingleSibling = -2;
        const maybeSibling = $d72bc7f44fb21c4f$var$getSibling(state.selection, previousMediaSingleSibling);
        if (!maybeSibling) // the last is the image so should let the default behaviour delete the image
        return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const mediaSingle = $d72bc7f44fb21c4f$var$getSibling(state.selection, -1); // Sibling is a media single already checked in main code
        const mediaSinglePos = $from.pos - mediaSingle.nodeSize;
        // Should find the position
        // Should move the current paragraph to the last line
        const maybeAnyBlockPos = mediaSinglePos - maybeSibling.nodeSize;
        let tr = state.tr;
        if (isEmptyWithoutThrow(maybeSibling)) // Should remove the empty sibling
        tr = tr.replace(maybeAnyBlockPos - 1, maybeAnyBlockPos + maybeSibling.nodeSize);
        else {
            // We move the current node, to the new position
            // 1. Remove current node, only if I am not removing the last node.
            if (!(0, $2w79Z.isSelectionInsideLastNodeInDocument)(state.selection)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
            else // Remove node content, if is the last node, let a empty paragraph
            tr.replace($from.pos, $from.pos + $from.parent.nodeSize - 1);
            // 2. Add it in the new position
            // If the sibling is a paragraph lets copy the text inside the paragraph
            // Like a normal backspace from paragraph to paragraph
            if (maybeSibling.type === paragraph) {
                const insideParagraphPos = maybeAnyBlockPos + maybeSibling.nodeSize - 2;
                (0, $bjg0G.safeInsert)($from.parent.content, insideParagraphPos)(tr);
            } else {
                // If is any other kind of block just add the paragraph after it
                const endOfBlockPos = maybeAnyBlockPos + maybeSibling.nodeSize - 1;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (0, $bjg0G.safeInsert)($from.parent.copy($from.parent.content), endOfBlockPos)(tr);
            }
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $d72bc7f44fb21c4f$var$backspaceAfterMediaNode = (schema)=>{
    const isEmptyNodeInSchema = (0, $2w79Z.isEmptyNode)(schema);
    return (state, dispatch)=>{
        const { selection: selection, schema: schema, tr: tr } = state;
        const { $from: $from } = selection;
        if (!$d72bc7f44fb21c4f$var$isEmptySelectionAtStart(state.selection)) return false;
        if (!$d72bc7f44fb21c4f$var$isSelectionInsideOf(state.selection, schema.nodes.paragraph)) return false;
        const previousSibling = -1;
        // no media single or media group
        if (!$d72bc7f44fb21c4f$var$isSiblingOfType(state.selection, schema.nodes.mediaSingle, previousSibling) && !$d72bc7f44fb21c4f$var$isSiblingOfType(state.selection, schema.nodes.mediaGroup, previousSibling)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const media = $d72bc7f44fb21c4f$var$getSibling(state.selection, previousSibling);
        // if media single
        if (media.type === schema.nodes.mediaSingle) {
            if (media.attrs.layout === 'wrap-right') return $d72bc7f44fb21c4f$var$handleSelectionAfterWrapRight(isEmptyNodeInSchema)(state, dispatch);
            if (dispatch) // Select media single, and remove paragraph if it's empty.
            (0, $iUNgd.selectNodeBackward)(state, (tr)=>{
                if (isEmptyNodeInSchema($from.parent) && !(0, $jzePg.atTheEndOfDoc)(state)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
                dispatch(tr);
            });
            return true;
        }
        // if media group
        if (dispatch) {
            // select media group, and remove paragraph if it's empty.
            if (isEmptyNodeInSchema($from.parent)) {
                tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // remove node
                tr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve($from.pos - media.nodeSize))).scrollIntoView(); // select media
            }
            dispatch(tr);
        }
        return true;
    };
};
function $d72bc7f44fb21c4f$export$2e2bcd8739ae039(schema) {
    const list = {};
    const backspaceAfterMediaCommand = $d72bc7f44fb21c4f$var$backspaceAfterMediaNode(schema);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.backspace).common, backspaceAfterMediaCommand, list);
    return (0, $44cyU.keymap)(list);
}











var $d29601216ac29824$export$6eb9cfa224a48678 = /*#__PURE__*/ function(MediaLinkingActionsTypes) {
    MediaLinkingActionsTypes["showToolbar"] = "MEDIA_SHOW_TOOLBAR";
    MediaLinkingActionsTypes["hideToolbar"] = "MEDIA_HIDE_TOOLBAR";
    MediaLinkingActionsTypes["setUrl"] = "MEDIA_SET_LINK_TO";
    MediaLinkingActionsTypes["unlink"] = "MEDIA_LINKING_UNLINK";
    return MediaLinkingActionsTypes;
}({});


var $cd8643c48b68acfd$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $d29601216ac29824$export$6eb9cfa224a48678).showToolbar:
            return {
                ...state,
                visible: true
            };
        case (0, $d29601216ac29824$export$6eb9cfa224a48678).setUrl:
            return {
                ...state,
                editable: true,
                link: action.payload
            };
        case (0, $d29601216ac29824$export$6eb9cfa224a48678).hideToolbar:
            return {
                ...state,
                visible: false
            };
        case (0, $d29601216ac29824$export$6eb9cfa224a48678).unlink:
            return {
                ...state,
                link: '',
                visible: false,
                editable: false
            };
    }
    return state;
};


const $0f87f7842b3d8002$export$e8ef6001d0045a33 = new (0, $kCECX.PluginKey)('mediaLinking');
const $0f87f7842b3d8002$var$initialState = {
    visible: false,
    editable: false,
    mediaPos: null,
    link: ''
};
function $0f87f7842b3d8002$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.mediaPos !== null) return {
        ...pluginState,
        mediaPos: tr.mapping.map(pluginState.mediaPos)
    };
    return pluginState;
}
function $0f87f7842b3d8002$var$onSelectionChanged(tr) {
    const isNodeSelection = tr.selection instanceof (0, $kCECX.NodeSelection);
    if (!isNodeSelection) return $0f87f7842b3d8002$var$initialState;
    const pos = tr.selection.$from.pos;
    const mediaPos = tr.selection.node.type.name === 'mediaInline' ? pos : pos + 1;
    const node = tr.doc.nodeAt(mediaPos);
    if (!node || ![
        'media',
        'mediaInline'
    ].includes(node.type.name)) return $0f87f7842b3d8002$var$initialState;
    const mark = node.marks.find((mark)=>mark.type.name === 'link');
    if (mark) return {
        ...$0f87f7842b3d8002$var$initialState,
        mediaPos: mediaPos,
        editable: true,
        link: mark.attrs.href
    };
    return {
        ...$0f87f7842b3d8002$var$initialState,
        mediaPos: mediaPos
    };
}
const $0f87f7842b3d8002$var$mediaLinkingPluginFactory = (0, $cI8RZ.pluginFactory)($0f87f7842b3d8002$export$e8ef6001d0045a33, (0, $cd8643c48b68acfd$export$2e2bcd8739ae039), {
    mapping: $0f87f7842b3d8002$var$mapping,
    onSelectionChanged: $0f87f7842b3d8002$var$onSelectionChanged
});
const $0f87f7842b3d8002$export$2c81aa6d281594cd = $0f87f7842b3d8002$var$mediaLinkingPluginFactory.createCommand;
const $0f87f7842b3d8002$export$a27ff1704d423d4e = $0f87f7842b3d8002$var$mediaLinkingPluginFactory.getPluginState;
var $0f87f7842b3d8002$export$2e2bcd8739ae039 = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        key: $0f87f7842b3d8002$export$e8ef6001d0045a33,
        state: $0f87f7842b3d8002$var$mediaLinkingPluginFactory.createPluginState(dispatch, $0f87f7842b3d8002$var$initialState)
    });












var $9WBFV = parcelRequire("9WBFV");


var $hZrGN = parcelRequire("hZrGN");








var $4JRVn = parcelRequire("4JRVn");

const $2dad6518a4381baf$export$e0eb18fceec368c4 = (0, $0f87f7842b3d8002$export$2c81aa6d281594cd)((state)=>{
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    if (mediaLinkingState && mediaLinkingState.mediaPos !== null) {
        const node = state.doc.nodeAt(mediaLinkingState.mediaPos);
        if (node) return {
            type: (0, $d29601216ac29824$export$6eb9cfa224a48678).showToolbar
        };
    }
    return false;
});
const $2dad6518a4381baf$export$f0b12e75a8c0baf5 = (editorState, dispatch, editorView)=>{
    if (dispatch && editorView) {
        const mediaNode = (0, $4JRVn.currentMediaNode)(editorState);
        const mediaInlineNode = (0, $4JRVn.currentMediaInlineNode)(editorState);
        const nodeSelection = editorState.selection;
        const currentSelectedNode = nodeSelection.node;
        if (!mediaNode && !mediaInlineNode) return false;
        const { mediaClientConfig: mediaClientConfig } = (0, $9k4mh.getMediaPluginState)(editorState);
        if (!mediaClientConfig) return false;
        if (mediaNode && currentSelectedNode !== mediaInlineNode) (0, $4bb1e35ad772cb66$export$9573295345282b3b)(mediaNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $4JRVn.currentMediaNode)(editorView.state) === mediaNode) dispatch(editorView.state.tr.setMeta((0, $0f87f7842b3d8002$export$e8ef6001d0045a33), {
                type: (0, $d29601216ac29824$export$6eb9cfa224a48678).showToolbar
            }));
        });
        if (mediaInlineNode) (0, $4bb1e35ad772cb66$export$9573295345282b3b)(mediaInlineNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $4JRVn.currentMediaInlineNode)(editorView.state) === mediaInlineNode) dispatch(editorView.state.tr.setMeta((0, $0f87f7842b3d8002$export$e8ef6001d0045a33), {
                type: (0, $d29601216ac29824$export$6eb9cfa224a48678).showToolbar
            }));
        });
    }
    return true;
};
const $2dad6518a4381baf$var$hideLinkingToolbarCommand = (0, $0f87f7842b3d8002$export$2c81aa6d281594cd)({
    type: (0, $d29601216ac29824$export$6eb9cfa224a48678).hideToolbar
});
const $2dad6518a4381baf$export$3b74d2c3073f13a9 = (state, dispatch, view, focusFloatingToolbar)=>{
    $2dad6518a4381baf$var$hideLinkingToolbarCommand(state, dispatch, view);
    // restore focus on the editor so keyboard shortcuts aren't lost to the browser
    if (view && !focusFloatingToolbar) view.focus();
};
function $2dad6518a4381baf$var$getCurrentUrl(state) {
    const { link: linkType } = state.schema.marks;
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return;
    const hasLink = linkType.isInSet(node.marks);
    if (!hasLink) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const link = node.marks.find((mark)=>mark.type === linkType); // Already check exist
    const url = link.attrs.href;
    return url;
}
function $2dad6518a4381baf$var$toggleLinkMark(tr, state, { forceRemove: forceRemove = false, url: url }) {
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return tr;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return tr;
    const linkMark = state.schema.marks.link;
    const { media: media, mediaInline: mediaInline } = state.schema.nodes;
    if (node.type !== mediaInline) {
        const toggleBlockLinkMark = (0, $9WBFV.createToggleBlockMarkOnRange)(linkMark, (prevAttrs, node)=>{
            // Only add mark to media
            if (!node || node.type !== media) return; //No op
            if (forceRemove) return false;
            const href = (0, $hZrGN.normalizeUrl)(url);
            if (prevAttrs && prevAttrs.href === href) return; //No op
            if (href.trim() === '') return false; // remove
            return {
                ...prevAttrs,
                href: href
            };
        }, [
            media
        ]);
        toggleBlockLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    }
    const toggleInlineLinkMark = (0, $9WBFV.createToggleInlineMarkOnRange)(linkMark, (prevAttrs, node)=>{
        // Only add mark to mediaInline
        if (!node || node.type !== mediaInline) return; //No op
        if (forceRemove) return false;
        const href = (0, $hZrGN.normalizeUrl)(url);
        if (prevAttrs && prevAttrs.href === href) return; //No op
        if (href.trim() === '') return false; // remove
        return {
            ...prevAttrs,
            href: href
        };
    });
    toggleInlineLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    return tr;
}
const $2dad6518a4381baf$var$fireAnalyticForMediaLink = (tr, action, attributes, editorAnalyticsAPI)=>{
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: action,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LINK,
        attributes: attributes
    })(tr);
    return tr;
};
const $2dad6518a4381baf$export$5e0808041271ce04 = (editorAnalyticsAPI)=>(0, $0f87f7842b3d8002$export$2c81aa6d281594cd)({
        type: (0, $d29601216ac29824$export$6eb9cfa224a48678).unlink
    }, (tr, state)=>{
        const transaction = $2dad6518a4381baf$var$toggleLinkMark(tr, state, {
            forceRemove: true
        });
        return $2dad6518a4381baf$var$fireAnalyticForMediaLink(transaction, (0, $krYZG.ACTION).DELETED, {
            ...$2dad6518a4381baf$var$getNodeTypeAndMediaTypeAttributes(state)
        }, editorAnalyticsAPI);
    });
const $2dad6518a4381baf$var$getAction = (newUrl, state)=>{
    const currentUrl = $2dad6518a4381baf$var$getCurrentUrl(state);
    if (!currentUrl) return (0, $krYZG.ACTION).ADDED;
    else if (newUrl !== currentUrl) return (0, $krYZG.ACTION).EDITED;
    return undefined;
};
const $2dad6518a4381baf$var$getNodeTypeAndMediaTypeAttributes = (state)=>{
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    const { allowInlineImages: allowInlineImages } = (0, $9k4mh.getMediaPluginState)(state);
    const { mediaInline: mediaInline, mediaSingle: mediaSingle } = state.schema.nodes;
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return {};
    if (allowInlineImages && node.type === mediaInline) return {
        type: mediaInline.name,
        mediaType: node.attrs.type
    };
    return {
        type: mediaSingle.name,
        mediaType: node.attrs.type
    };
};
const $2dad6518a4381baf$export$b195a1839eae3673 = (url, inputMethod, editorAnalyticsAPI)=>(0, $0f87f7842b3d8002$export$2c81aa6d281594cd)({
        type: (0, $d29601216ac29824$export$6eb9cfa224a48678).setUrl,
        payload: (0, $hZrGN.normalizeUrl)(url)
    }, (tr, state)=>{
        const action = $2dad6518a4381baf$var$getAction(url, state);
        if (!action) return tr;
        const nodeTypeAndMediaTypeAttrs = $2dad6518a4381baf$var$getNodeTypeAndMediaTypeAttributes(state);
        try {
            const toggleLinkMarkResult = $2dad6518a4381baf$var$toggleLinkMark(tr, state, {
                url: url
            });
            $2dad6518a4381baf$var$fireAnalyticForMediaLink(tr, action, action === (0, $krYZG.ACTION).ADDED ? {
                inputMethod: inputMethod,
                ...nodeTypeAndMediaTypeAttrs
            } : nodeTypeAndMediaTypeAttrs, editorAnalyticsAPI);
            return toggleLinkMarkResult;
        } catch (e) {
            $2dad6518a4381baf$var$fireAnalyticForMediaLink(tr, (0, $krYZG.ACTION).ERRORED, {
                action: action,
                ...nodeTypeAndMediaTypeAttrs
            }, editorAnalyticsAPI);
            throw e;
        }
    });


function $3c5aeafd362db864$export$2e2bcd8739ae039(schema) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.addLink).common, (0, $2dad6518a4381baf$export$f0b12e75a8c0baf5), list);
    return (0, $44cyU.keymap)(list);
}














var $c9fcfa5d8d10fb07$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'openPixelEditor':
            return {
                ...state,
                isPixelEditorOpen: true
            };
        case 'closePixelEditor':
            return {
                ...state,
                isPixelEditorOpen: false
            };
        default:
            return state;
    }
};


const $b65a57bd9857f1c9$var$pluginKey = new (0, $kCECX.PluginKey)('mediaPixelResizingPlugin');
const $b65a57bd9857f1c9$var$dest = (0, $cI8RZ.pluginFactory)($b65a57bd9857f1c9$var$pluginKey, (0, $c9fcfa5d8d10fb07$export$2e2bcd8739ae039), {
    onSelectionChanged () {
        return {
            isPixelEditorOpen: false
        };
    }
});
const $b65a57bd9857f1c9$var$createPluginState = $b65a57bd9857f1c9$var$dest.createPluginState;
const $b65a57bd9857f1c9$export$8d4021544bdece00 = $b65a57bd9857f1c9$var$dest.createCommand;
const $b65a57bd9857f1c9$export$f05434c51e3762e = $b65a57bd9857f1c9$var$dest.getPluginState;
const $b65a57bd9857f1c9$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $kpCD8.SafePlugin)({
        state: $b65a57bd9857f1c9$var$createPluginState(dispatch, {
            isPixelEditorOpen: false
        }),
        key: $b65a57bd9857f1c9$var$pluginKey
    });
};





















var $5ZJRm = parcelRequire("5ZJRm");





var $9kbTQ = parcelRequire("9kbTQ");





var $dldpg = parcelRequire("dldpg");


var $IRDCg = parcelRequire("IRDCg");

const $6ad161d3628df7d8$var$dummyMediaPickerObject = {
    on: ()=>{},
    removeAllListeners: ()=>{},
    emit: ()=>{},
    destroy: ()=>{},
    setUploadParams: ()=>{}
};
const $6ad161d3628df7d8$var$selector = (states)=>{
    return {
        mediaProvider: states.mediaState?.mediaProvider,
        mediaOptions: states.mediaState?.mediaOptions,
        insertFile: states.mediaState?.insertFile,
        options: states.mediaState?.options
    };
};
function $6ad161d3628df7d8$export$2e2bcd8739ae039({ api: api, analyticsName: analyticsName, children: children }) {
    const [state, setState] = (0, $cozmU.useState)({
        pickerFacadeInstance: undefined,
        config: undefined,
        mediaClientConfig: undefined
    });
    const { mediaProvider: mediaProvider, mediaOptions: mediaOptions, insertFile: insertFile, options: options } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $6ad161d3628df7d8$var$selector);
    const handleMediaProvider = (0, $cozmU.useCallback)(async (_name, provider)=>{
        const mediaProvider = await provider;
        if (!mediaProvider || !mediaProvider.uploadParams || !insertFile) return;
        const resolvedMediaClientConfig = await mediaProvider.uploadMediaClientConfig || await mediaProvider.viewMediaClientConfig;
        if (!resolvedMediaClientConfig) return;
        const pickerFacadeConfig = {
            mediaClientConfig: resolvedMediaClientConfig,
            errorReporter: options?.errorReporter || new (0, $dldpg.ErrorReporter)(),
            featureFlags: mediaOptions && mediaOptions.featureFlags
        };
        const pickerFacadeInstance = await new (0, $IRDCg.default)('customMediaPicker', pickerFacadeConfig, $6ad161d3628df7d8$var$dummyMediaPickerObject, analyticsName).init();
        pickerFacadeInstance.onNewMedia(insertFile);
        pickerFacadeInstance.setUploadParams(mediaProvider.uploadParams);
        const config = {
            uploadParams: mediaProvider.uploadParams
        };
        (0, $9kbTQ.flushSync)(()=>{
            setState({
                pickerFacadeInstance: pickerFacadeInstance,
                config: config,
                mediaClientConfig: resolvedMediaClientConfig
            });
        });
    }, [
        analyticsName,
        insertFile,
        mediaOptions,
        options?.errorReporter
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mediaProvider) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        handleMediaProvider('mediaProvider', Promise.resolve(mediaProvider));
    }, [
        mediaProvider,
        handleMediaProvider
    ]);
    const { mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance } = state;
    if (!mediaClientConfig || !config || !pickerFacadeInstance) return null;
    return children({
        mediaClientConfig: mediaClientConfig,
        config: config,
        pickerFacadeInstance: pickerFacadeInstance
    });
}


const $ff844a800db6cb4a$export$78e63feb3bcb89b0 = ({ api: api, isOpen: isOpen, onBrowseFn: onBrowseFn, featureFlags: featureFlags })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ad161d3628df7d8$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "browser"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
        const browserConfig = {
            ...config,
            multiple: true
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
            onBrowseFn: onBrowseFn,
            isOpen: isOpen,
            config: browserConfig,
            mediaClientConfig: mediaClientConfig,
            onEnd: pickerFacadeInstance.handleReady,
            onError: pickerFacadeInstance.handleUploadError,
            onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
            featureFlags: featureFlags
        });
    });










class $6ba447d347261701$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        if (!this.state.Clipboard) Promise.all([
            (parcelRequire("gi32l")),
            (parcelRequire("g4HVK"))
        ]).then(([mediaClient, clipboardModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $6ba447d347261701$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $6ba447d347261701$export$d7936799bf32b554.Clipboard
            });
        });
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            Clipboard: $6ba447d347261701$export$d7936799bf32b554.Clipboard
        };
    }
}
$6ba447d347261701$export$d7936799bf32b554.displayName = 'AsyncClipboard';
$6ba447d347261701$export$d7936799bf32b554.Clipboard = void 0;



const $f56a80a475bb0e2d$export$b7fcd7f87db4d1ee = ({ api: api, container: container, featureFlags: featureFlags })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ad161d3628df7d8$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "clipboard"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
        const clipboardConfig = Object.assign({}, config);
        clipboardConfig.container = container;
        clipboardConfig.onPaste = (event)=>{
            event.stopPropagation();
            return false;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ba447d347261701$export$d7936799bf32b554), {
            mediaClientConfig: mediaClientConfig,
            config: clipboardConfig,
            onError: pickerFacadeInstance.handleUploadError,
            onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
            onEnd: pickerFacadeInstance.handleReady,
            featureFlags: featureFlags
        });
    });









var $1jz5K = parcelRequire("1jz5K");


var $bXbVP = parcelRequire("bXbVP");


const $5ec40e1a3453e899$var$selector = (states)=>{
    return {
        options: states.mediaState?.options,
        handleDrag: states.mediaState?.handleDrag
    };
};
const $5ec40e1a3453e899$var$DropzoneWrapperInternal = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance, mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
    const { options: options, handleDrag: handleDrag } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $5ec40e1a3453e899$var$selector);
    const { customDropzoneContainer: customDropzoneContainer } = options || {};
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorHtmlElement = editorDomElement;
    const scrollParent = appearance === 'full-page' && (0, $1jz5K.findOverflowScrollParent)(editorHtmlElement);
    const container = customDropzoneContainer || (scrollParent ? scrollParent : editorHtmlElement);
    const dropzoneConfig = {
        ...config,
        container: container
    };
    return isActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bXbVP.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onError: pickerFacadeInstance.handleUploadError,
        onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
        onEnd: pickerFacadeInstance.handleReady,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>handleDrag?.('enter'),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>handleDrag?.('leave'),
        featureFlags: featureFlags
    }) : null;
};
const $5ec40e1a3453e899$export$1364cc2f4ae811f4 = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ad161d3628df7d8$export$2e2bcd8739ae039), {
        api: api,
        analyticsName: "dropzone"
    }, ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ec40e1a3453e899$var$DropzoneWrapperInternal, {
            api: api,
            isActive: isActive,
            featureFlags: featureFlags,
            editorDomElement: editorDomElement,
            appearance: appearance,
            mediaClientConfig: mediaClientConfig,
            config: config,
            pickerFacadeInstance: pickerFacadeInstance
        }));


const $bd2a2620618dfd4a$var$selector = (states)=>{
    return {
        hasFocus: states.focusState?.hasFocus,
        connectivityMode: states.connectivityState?.mode,
        mediaOptions: states.mediaState?.mediaOptions
    };
};
const $bd2a2620618dfd4a$var$MediaPicker = ({ api: api, isPopupOpened: isPopupOpened, appearance: appearance, onBrowseFn: onBrowseFn, editorDomElement: editorDomElement })=>{
    const { hasFocus: hasFocus, connectivityMode: connectivityMode, mediaOptions: mediaOptions } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'focus',
        'connectivity',
        'media'
    ], $bd2a2620618dfd4a$var$selector);
    const featureFlags = mediaOptions && mediaOptions.featureFlags;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorDom = editorDomElement;
    const editorParent = editorDom.parentElement ?? undefined;
    /**
   * https://product-fabric.atlassian.net/browse/ED-21993
   * Avoid attach paste event to same dom element,
   * so editor-paste-plugin can use stopPropagation,
   * as stopImmediatePropagation could cause race condition issues
   */ const container = editorParent;
    const clipboard = hasFocus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f56a80a475bb0e2d$export$b7fcd7f87db4d1ee), {
        api: api,
        featureFlags: featureFlags,
        container: container
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, clipboard, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ec40e1a3453e899$export$1364cc2f4ae811f4), {
        api: api,
        isActive: !isPopupOpened && // If we're offline don't show the dropzone
        connectivityMode !== 'offline',
        featureFlags: featureFlags,
        editorDomElement: editorDomElement,
        appearance: appearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff844a800db6cb4a$export$78e63feb3bcb89b0), {
        api: api,
        onBrowseFn: onBrowseFn,
        featureFlags: featureFlags
    }));
};
class $bd2a2620618dfd4a$export$b8a89db960d45391 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        const { onPopupToggle: onPopupToggle } = this.props;
        onPopupToggle((isPopupOpened)=>{
            this.setState({
                isPopupOpened: isPopupOpened
            });
        });
    }
    render() {
        const { api: api, editorDomElement: editorDomElement, appearance: appearance } = this.props;
        const { isPopupOpened: isPopupOpened } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd2a2620618dfd4a$var$MediaPicker, {
            editorDomElement: editorDomElement,
            appearance: appearance,
            isPopupOpened: isPopupOpened,
            onBrowseFn: this.onBrowseFn,
            api: api
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPopupOpened: false
        };
        this.onBrowseFn = (nativeBrowseFn)=>{
            const { setBrowseFn: setBrowseFn } = this.props;
            setBrowseFn(nativeBrowseFn);
        };
    }
}
$bd2a2620618dfd4a$export$b8a89db960d45391.displayName = 'MediaPickerComponents';



var $j5Sek = parcelRequire("j5Sek");








var $jU5kz = parcelRequire("jU5kz");





var $nnUSM = parcelRequire("nnUSM");


var $bI2nS = parcelRequire("bI2nS");

var $2xhuI = parcelRequire("2xhuI");

var $2BvhC = parcelRequire("2BvhC");





var $6Ixg8 = parcelRequire("6Ixg8");











var $4w6dd = parcelRequire("4w6dd");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $6Fmj3 = parcelRequire("6Fmj3");


var $8VfSP = parcelRequire("8VfSP");


var $i7DLA = parcelRequire("i7DLA");


var $bVwWU = parcelRequire("bVwWU");


var $kTw4V = parcelRequire("kTw4V");


var $kvJb4 = parcelRequire("kvJb4");


var $bh4C9 = parcelRequire("bh4C9");




const $1ce50a9b28304653$export$ddc30058b32b7b60 = (offset)=>{
    return `.${0, $8TTbR.MediaFilmStripListItemSelector}:nth-child(${offset})`;
};



var $fA65V = parcelRequire("fA65V");














/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 








const $57fcdb3d1b6673ad$export$41750bfa58c03af2 = (0, $kSwu1.defineMessages)({
    validationFailedMessage: {
        id: "fabric.editor.media.pixelEntry.validationFailedMessage",
        defaultMessage: "Validation for width failed"
    },
    inputWidthTooltip: {
        id: "fabric.editor.media.pixelEntry.inputWidthTooltip",
        defaultMessage: "Max width {maxWidth}px"
    },
    inputWidthAriaLabel: {
        id: "fabric.editor.media.pixelEntry.inputWidthAriaLabel",
        defaultMessage: "Max width {maxWidth}px"
    },
    inputWidthLabel: {
        id: "fabric.editor.media.pixelEntry.inputWidthLabel",
        defaultMessage: "Width"
    },
    inputHeightTooltip: {
        id: "fabric.editor.media.pixelEntry.inputHeightTooltip",
        defaultMessage: "Height"
    },
    inputHeightAriaLabel: {
        id: "fabric.editor.media.pixelEntry.inputHeightAriaLabel",
        defaultMessage: "height input"
    },
    submitButtonText: {
        id: "fabric.editor.media.pixelEntry.submitButtonText",
        defaultMessage: "Submit"
    },
    fullWidthLabel: {
        id: "fabric.editor.image.fullWidthLabel",
        defaultMessage: "Full-width"
    },
    migrationButtonText: {
        id: "fabric.editor.media.pixelEntry.migrationButtonText",
        defaultMessage: "Convert to pixels"
    },
    migrationButtonTooltip: {
        id: "fabric.editor.media.pixelEntry.migrationButtonTooltip",
        defaultMessage: "Migrate from percentage to fixed pixel sizing"
    },
    closePixelEntry: {
        id: "fabric.editor.media.pixelEntry.closePixelEntry",
        defaultMessage: "Close"
    },
    resizeOption: {
        id: "fabric.editor.media.pixelEntry.ResizeOption",
        defaultMessage: "Resize"
    }
});



var $cRsJ5 = parcelRequire("cRsJ5");
















var $4aRua = parcelRequire("4aRua");











const $c77199520c777221$export$3f611b75d530f269 = ()=>{
    return (0, $b65a57bd9857f1c9$export$8d4021544bdece00)({
        type: 'openPixelEditor'
    });
};
const $c77199520c777221$export$6113a2660dc189b8 = ()=>{
    return (0, $b65a57bd9857f1c9$export$8d4021544bdece00)({
        type: 'closePixelEditor'
    });
};
const $c77199520c777221$export$b46ccfbc4dc863e = (saveTransform)=>{
    return (0, $b65a57bd9857f1c9$export$8d4021544bdece00)({
        type: 'closePixelEditor'
    }, saveTransform);
};


/* eslint-disable jsdoc/check-tag-names */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $7ZB0A = parcelRequire("7ZB0A");


var $1sCHt = parcelRequire("1sCHt");



var $dTHYM = parcelRequire("dTHYM");

var $dUI0h = parcelRequire("dUI0h");





var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $6Pqow = parcelRequire("6Pqow");




var $4yg9g = parcelRequire("4yg9g");


var $lpNn5 = parcelRequire("lpNn5");

const $e5d2f0341666dfa6$export$92acff719f79f188 = 'pixel-entry-convert-pixels-btn';
const $e5d2f0341666dfa6$export$e879bf3f9286d0ca = 240;
const $e5d2f0341666dfa6$export$82086c41f042e8aa = 204;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



function $999d37ffb2c8ee64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $999d37ffb2c8ee64$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH = 120;
const $999d37ffb2c8ee64$export$7adff2da6cbda45a = /*#__PURE__*/ (0, $lOiVq.css)("display:grid;grid-template-columns:1fr 1em 1fr 0;grid-template-rows:auto;grid-template-areas:'widthinput label heightinput submit';width:", $999d37ffb2c8ee64$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH, "px;text-align:center;height:var(--ds-space-300, 24px);&>*{margin-top:0!important;}");
const $999d37ffb2c8ee64$export$a087928e226af252 = {
    name: "jf7je1",
    styles: "form{width:100%;}"
};
const $999d37ffb2c8ee64$export$8eb4fadc3d78e5b8 = {
    name: "kleeuo",
    styles: "width:100%;height:var(--ds-space-300, 24px);& input{text-align:center;}"
};
const $999d37ffb2c8ee64$export$24de6e5e0b062da4 = {
    name: "6o3mvm",
    styles: "grid-area:widthinput"
};
const $999d37ffb2c8ee64$export$239e009fce8340c = {
    name: "10wktdx",
    styles: "grid-area:heightinput"
};
const $999d37ffb2c8ee64$export$2eb599df69546ffe = {
    name: "1555zxw",
    styles: "grid-area:submit;visibility:hidden;width:0;height:0;padding:0"
};
const $999d37ffb2c8ee64$export$e7603c3ecd81d479 = /*#__PURE__*/ (0, $lOiVq.css)({
    minWidth: `${$999d37ffb2c8ee64$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH}px`,
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});


function $5d1e335abfc18e86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5d1e335abfc18e86$var$pixelSizingLabel = (0, $buxP3.xcss)({
    gridArea: 'label',
    lineHeight: "var(--ds-space-300, 24px)"
});
const $5d1e335abfc18e86$export$87ba3d82a3f32422 = ({ width: width, mediaWidth: mediaWidth, mediaHeight: mediaHeight, onSubmit: onSubmit, minWidth: minWidth, maxWidth: maxWidth, onChange: onChange, intl: { formatMessage: formatMessage }, showMigration: showMigration, onMigrate: onMigrate, onCloseAndSave: onCloseAndSave, isViewMode: isViewMode, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const ratioWidth = (0, $cozmU.useMemo)(()=>{
        return mediaHeight / mediaWidth;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const ratioHeight = (0, $cozmU.useMemo)(()=>{
        return mediaWidth / mediaHeight;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const [computedWidth, setComputedWidth] = (0, $cozmU.useState)(width);
    const [computedHeight, setComputedHeight] = (0, $cozmU.useState)(Math.round(ratioWidth * width));
    // Handle update to width from outside component
    (0, $cozmU.useEffect)(()=>{
        setComputedWidth(width);
        setComputedHeight(Math.round(ratioWidth * width));
    }, [
        width,
        ratioWidth
    ]);
    // Handle submit when user presses enter in form
    const handleOnSubmit = (data)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onSubmit) {
            let widthToBeSumitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSumitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSumitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSumitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSumitted));
            }
            onSubmit({
                width: widthToBeSumitted,
                validation: validation
            });
        }
    };
    // Handle submit when user presses enter or click close button in PixelEntryComponentNext
    const handleCloseAndSave = (0, $cozmU.useCallback)((data, setFocus)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onCloseAndSave) {
            let widthToBeSubmitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSubmitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSubmitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSubmitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSubmitted));
            }
            onCloseAndSave({
                width: widthToBeSubmitted,
                validation: validation
            }, setFocus);
        }
    }, [
        maxWidth,
        minWidth,
        onCloseAndSave,
        ratioWidth
    ]);
    // Handle updating computed fields based on
    const handleOnChange = (0, $cozmU.useCallback)((type)=>(event)=>{
            const value = parseInt(event.currentTarget.value);
            const newInputValue = isNaN(value) ? '' : value;
            let newWidth = '';
            switch(type){
                case 'inputWidth':
                    {
                        newWidth = newInputValue;
                        setComputedWidth(newInputValue);
                        const newHeight = newInputValue !== '' ? Math.round(ratioWidth * newInputValue) : '';
                        setComputedHeight(newHeight);
                        break;
                    }
                case 'inputHeight':
                    setComputedHeight(newInputValue);
                    newWidth = newInputValue !== '' ? Math.round(ratioHeight * newInputValue) : '';
                    setComputedWidth(newWidth);
                    break;
            }
            const isInvalidInputValid = newWidth !== '' && (newWidth < minWidth || newWidth > maxWidth);
            onChange && onChange(isInvalidInputValid);
        }, [
        minWidth,
        maxWidth,
        onChange,
        ratioWidth,
        ratioHeight
    ]);
    if (showMigration) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).migrationButtonTooltip)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ZB0A.default), {
        appearance: "warning",
        spacing: "compact",
        onClick: onMigrate,
        testId: (0, $e5d2f0341666dfa6$export$92acff719f79f188)
    }, formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).migrationButtonText)));
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $lOiVq.jsx)($5d1e335abfc18e86$export$94fe217aa650da08, {
        maxWidth: maxWidth,
        formatMessage: formatMessage,
        handleFieldChange: handleOnChange,
        computedWidth: computedWidth,
        computedHeight: computedHeight,
        handleCloseAndSave: handleCloseAndSave,
        isViewMode: isViewMode
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $999d37ffb2c8ee64$export$a087928e226af252)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dTHYM.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps })=>{
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $lOiVq.jsx)("form", formProps, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $999d37ffb2c8ee64$export$7adff2da6cbda45a)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUI0h.default), {
            key: "inputWidth",
            name: "inputWidth",
            defaultValue: computedWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputWidthTooltip, {
                    maxWidth: maxWidth
                }),
                position: "top"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                css: [
                    (0, $999d37ffb2c8ee64$export$24de6e5e0b062da4),
                    (0, $999d37ffb2c8ee64$export$8eb4fadc3d78e5b8)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputWidth'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputWidthAriaLabel, {
                    maxWidth: maxWidth
                })
            }))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
            as: "span",
            xcss: $5d1e335abfc18e86$var$pixelSizingLabel
        }, "\xd7"), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUI0h.default), {
            key: "inputHeight",
            name: "inputHeight",
            defaultValue: computedHeight
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputHeightTooltip),
                position: "top"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                css: [
                    (0, $999d37ffb2c8ee64$export$239e009fce8340c),
                    (0, $999d37ffb2c8ee64$export$8eb4fadc3d78e5b8)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputHeight'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputHeightAriaLabel)
            }))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7ZB0A.default), {
            css: (0, $999d37ffb2c8ee64$export$2eb599df69546ffe),
            type: "submit"
        }, formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).submitButtonText)))));
    })));
};
const $5d1e335abfc18e86$var$pixelEntryWrapperStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $e5d2f0341666dfa6$export$e879bf3f9286d0ca)}px`
});
const $5d1e335abfc18e86$var$pixelEntryWrapperViewModeStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $e5d2f0341666dfa6$export$82086c41f042e8aa)}px`
});
const $5d1e335abfc18e86$var$fieldStyles = {
    name: "1we2h56",
    styles: "[data-ds--text-field--input]{padding-block:var(--ds-space-0, 0px);padding-inline:var(--ds-space-100, 8px);}flex:1"
};
const $5d1e335abfc18e86$var$dividerStyles = (0, $buxP3.xcss)({
    width: '1px',
    height: "var(--ds-space-500, 40px)",
    background: "var(--ds-border, #0B120E24)",
    marginInlineEnd: 'space.050'
});
const $5d1e335abfc18e86$export$94fe217aa650da08 = ({ maxWidth: maxWidth, formatMessage: formatMessage, handleFieldChange: handleFieldChange, computedWidth: computedWidth, computedHeight: computedHeight, handleCloseAndSave: handleCloseAndSave, isViewMode: isViewMode })=>{
    const widthInputRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (widthInputRef.current) {
            if (isViewMode) widthInputRef.current.blur();
            else widthInputRef.current.focus();
        }
    }, [
        isViewMode,
        widthInputRef
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter') {
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    const handleCloseButtonKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: [
            $5d1e335abfc18e86$var$pixelEntryWrapperStyles,
            isViewMode && $5d1e335abfc18e86$var$pixelEntryWrapperViewModeStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kz1Yj.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputWidthLabel))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5d1e335abfc18e86$var$fieldStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        position: "top",
        content: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputWidthTooltip, {
            maxWidth: maxWidth
        })
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
        name: "inputWidth",
        value: computedWidth,
        ref: widthInputRef,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputWidthAriaLabel, {
            maxWidth: maxWidth
        }),
        onChange: handleFieldChange('inputWidth'),
        onKeyDown: handleKeyDown
    }))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputHeightTooltip))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5d1e335abfc18e86$var$fieldStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        content: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputHeightTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4yg9g.default), {
        name: "inputHeight",
        value: computedHeight,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).inputHeightAriaLabel),
        onChange: handleFieldChange('inputHeight'),
        onKeyDown: handleKeyDown
    }))), !isViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $5d1e335abfc18e86$var$dividerStyles
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1sCHt.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).closePixelEntry),
        appearance: "subtle",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            });
        },
        onKeyDown: handleCloseButtonKeyDown
    })))));
};



const $4c6ef1df365261e2$export$4c9bbfa83ba6e1fa = ({ editorView: editorView, selectedMediaSingleNode: selectedMediaSingleNode, pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const contentWidth = pluginInjectionApi?.width.sharedState.currentState()?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth);
    const { width: mediaSingleWidth, widthType: widthType, layout: layout } = selectedMediaSingleNode.node.attrs;
    // hasParentNode will return falsey value if selection depth === 0
    const isNested = (0, $bjg0G.hasParentNode)((n)=>n.type !== state.schema.nodes.doc)(state.selection);
    const updateNodeWithTr = (0, $cozmU.useCallback)((width, validation)=>{
        const newLayout = (0, $2ETaj.calcNewLayout)(width, layout, contentWidth, isEditorFullWidthEnabled, isNested);
        return (0, $7mc9A.updateMediaSingleWidthTr)(pluginInjectionApi?.analytics?.actions, state, width, validation, 'floatingToolBar', newLayout);
    }, [
        layout,
        contentWidth,
        isEditorFullWidthEnabled,
        isNested,
        state,
        pluginInjectionApi
    ]);
    const selectedMediaNode = selectedMediaSingleNode.node.content.firstChild;
    if (!selectedMediaNode) return null;
    const { width: mediaWidth, height: mediaHeight } = selectedMediaNode.attrs;
    const maxWidthForNestedNode = pluginInjectionApi?.media?.sharedState.currentState()?.currentMaxWidth;
    const maxWidth = maxWidthForNestedNode || (0, $7Y8M5.akEditorFullWidthLayoutWidth);
    const isVideoFile = (0, $d55P7.isVideo)(selectedMediaNode.attrs.__fileMimeType);
    const minWidth = (0, $cRsJ5.calcMinWidth)(isVideoFile, maxWidthForNestedNode || contentWidth);
    const hasPixelType = widthType === 'pixel';
    const pixelWidthFromElement = (0, $2ETaj.getPixelWidthOfElement)(editorView, selectedMediaSingleNode.pos + 1, // get pos of media node
    mediaWidth || (0, $4G6PK.DEFAULT_IMAGE_WIDTH));
    const pixelWidth = hasPixelType ? mediaSingleWidth : pixelWidthFromElement;
    const forceFocusSelector = pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector;
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5d1e335abfc18e86$export$87ba3d82a3f32422), {
        intl: intl,
        width: pluginState.isResizing ? pluginState.resizingWidth : pixelWidth,
        showMigration: !pluginState.isResizing && !hasPixelType,
        mediaWidth: mediaWidth || (0, $4G6PK.DEFAULT_IMAGE_WIDTH),
        mediaHeight: mediaHeight || (0, $4G6PK.DEFAULT_IMAGE_HEIGHT),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onChange: (valid)=>{
            if (valid) hoverDecoration?.(mediaSingle, true, 'warning')(editorView.state, dispatch, editorView);
            else hoverDecoration?.(mediaSingle, false)(editorView.state, dispatch, editorView);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSubmit: ({ width: width, validation: validation })=>{
            const tr = updateNodeWithTr(width, validation);
            if (tr) dispatch(tr);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMigrate: ()=>{
            let tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
                ...selectedMediaSingleNode.node.attrs,
                width: pixelWidthFromElement,
                widthType: 'pixel'
            });
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
            if (triggerButtonSelector) {
                const newTr = forceFocusSelector && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            dispatch(tr);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCloseAndSave: ({ width: width, validation: validation }, setFocus)=>{
            let tr = updateNodeWithTr(width, validation);
            if (setFocus && triggerButtonSelector) {
                const newTr = forceFocusSelector && tr && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            if (tr) return (0, $c77199520c777221$export$b46ccfbc4dc863e)(()=>tr)(state, dispatch);
        },
        isViewMode: pluginState.isResizing,
        triggerButtonSelector: triggerButtonSelector,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $4c6ef1df365261e2$export$8bde7db5b2aba7d = ({ intl: { formatMessage: formatMessage } })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $999d37ffb2c8ee64$export$e7603c3ecd81d479)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.default), null, formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).fullWidthLabel))));
};











/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $ixa4K = parcelRequire("ixa4K");


var $feeMI = parcelRequire("feeMI");


var $7XIuB = parcelRequire("7XIuB");


var $3aDYK = parcelRequire("3aDYK");

var $8VCvx = parcelRequire("8VCvx");

var $7xQNd = parcelRequire("7xQNd");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");


var $czp8P = parcelRequire("czp8P");


var $lRXxm = parcelRequire("lRXxm");


var $7sJoX = parcelRequire("7sJoX");


var $fxA94 = parcelRequire("fxA94");


var $fRmp0 = parcelRequire("fRmp0");


var $jdueN = parcelRequire("jdueN");










/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $kQOs5 = parcelRequire("kQOs5");

function $a01946851ab4024a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a01946851ab4024a$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $a01946851ab4024a$export$e14354b446b68c1f = 4;
const $a01946851ab4024a$export$b102432b1d401cd6 = {
    name: "bkadrv",
    styles: "display:flex;&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:var(--ds-icon, #292A2E);}"
};
const $a01946851ab4024a$export$3c6c744e4fb4ffeb = (color)=>/*#__PURE__*/ (0, $lOiVq.css)($a01946851ab4024a$export$b102432b1d401cd6, " &::before{content:'';display:block;border:var(--ds-border-width, 1px) solid ", (0, $kQOs5.DEFAULT_BORDER_COLOR), ";border-radius:var(--ds-radius-small, 3px);width:20px;height:20px;", color && `background: ${color}`, ";}");
const $a01946851ab4024a$export$22186258d84a0d25 = (index)=>/*#__PURE__*/ (0, $lOiVq.css)("border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:flex;position:absolute;top:", index * ($a01946851ab4024a$export$1a7f12094b137d20.height + $a01946851ab4024a$export$e14354b446b68c1f * 2), "px;left:", $a01946851ab4024a$export$1a7f12094b137d20.width, "px;padding:var(--ds-space-100, 8px);>div{padding:0;}");
const $a01946851ab4024a$export$fd4d27a26b4854f3 = (selected)=>/*#__PURE__*/ (0, $lOiVq.css)("height:26px;width:26px;padding:0;border-radius:var(--ds-radius-small, 4px);background-color:", selected ? "var(--ds-text, #292A2E)" : "var(--ds-background-neutral, #0515240F)", ";border:1px solid ", (0, $kQOs5.DEFAULT_BORDER_COLOR), ";cursor:pointer;display:block;");
const $a01946851ab4024a$export$7afe8f4b3442c19d = {
    name: "1bac8cc",
    styles: "border:1px solid transparent;margin:var(--ds-space-025, 2px);font-size:0;display:flex;align-items:center;padding:var(--ds-space-025, 2px);border-radius:var(--ds-radius-medium, 6px);&:focus-within,&:focus,&:hover{border-color:var(--ds-border, #0B120E24)!important;}"
};
const $a01946851ab4024a$export$53f1d5ea8de3d7c = (size, selected)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;&:before{content:'';display:block;position:absolute;top:50%;left:50%;width:12px;height:", size, "px;background-color:", selected ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)", ";border-radius:90px;transform:translate(-50%, -50%) rotate(135deg);}");
const $a01946851ab4024a$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${"var(--ds-background-neutral-subtle-hovered, #0515240F)"};

    &:hover {
      background: ${"var(--ds-background-neutral-hovered, #0B120E24)"};
    }
  }`;
const $a01946851ab4024a$export$6d722733f5366928 = ({ enabled: enabled, isOpen: isOpen })=>/*#__PURE__*/ (0, $lOiVq.css)("display:flex;.image-border-toolbar-btn{border-top-right-radius:0;border-bottom-right-radius:0;padding:0;&>span{margin:0;}&:not([disabled])::after{border:none;}}.image-border-toolbar-dropdown{padding:0;width:16px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;margin-left:var(--ds-space-025, 2px);&>span{margin:0;}&:not([disabled])::after{border:none;}}", !enabled && $a01946851ab4024a$var$getHoverStyles('.image-border-toolbar-btn'), " ", !isOpen && !enabled && $a01946851ab4024a$var$getHoverStyles('.image-border-toolbar-dropdown'), ";");
const $a01946851ab4024a$export$8918fcb9aa07f104 = {
    name: "1eim0z6",
    styles: "background:transparent;border:var(--ds-border-width-focused, 2px) solid transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:8px 16px;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);border:var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #4688EC);}"
};
const $a01946851ab4024a$export$89634948c2be5ede = {
    name: "3linml",
    styles: "span[role='menuitem']{padding:0;}"
};


function $daa586f49fdcc793$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New padding for border options drop down
const $daa586f49fdcc793$var$dropdownOptionButtonNew = {
    name: "9wwuwq",
    styles: "background:transparent;border-width:var(--ds-border-width-selected, 2px);border-style:solid;border-color:transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:0;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);border-color:var(--ds-border-focused, #4688EC);}"
};
const $daa586f49fdcc793$var$ImageBorder = ({ intl: { formatMessage: formatMessage }, toggleBorder: toggleBorder, borderMark: borderMark, setBorder: setBorder })=>{
    const popupTarget = (0, $cozmU.useRef)(null);
    const dropDownColorOptionButton = (0, $cozmU.useRef)(null);
    const dropDownSizeOptionButton = (0, $cozmU.useRef)(null);
    const colorSubmenuRef = (0, $cozmU.useRef)(null);
    const sizeSubmenuRef = (0, $cozmU.useRef)(null);
    const openDropdownButtonRef = (0, $cozmU.useRef)(null);
    const enabled = !!borderMark;
    const color = borderMark?.color;
    const size = borderMark?.size;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $cozmU.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $cozmU.useState)(false);
    const handleColorSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton?.current?.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton?.current?.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, allowedKeys, callback)=>{
        if (!allowedKeys.includes(event.key)) return;
        event.preventDefault();
        callback();
        setIsOpenedByKeyboard(true);
    };
    const handleTriggerToolbarByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            ' '
        ], callback);
    };
    const handleTriggerSubmenuByKeyboard = (event, callback)=>{
        const keys = (0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? [
            'Enter',
            'ArrowRight'
        ] : [
            'Enter',
            ' '
        ];
        handleTriggerByKeyboard(event, keys, callback);
    };
    (0, $cozmU.useEffect)(()=>{
        const focusFirstOption = (submenuRef, isOpen)=>{
            if (!isOpenByKeyboard) return;
            if (isOpen && submenuRef.current) {
                const firstOption = submenuRef.current.querySelector('button');
                if (!firstOption) return;
                firstOption.focus();
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                firstOption.dispatchEvent(keyboardEvent);
            }
        };
        focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
        focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeSubtle),
            value: 1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdueN)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeMedium),
            value: 2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fRmp0)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeBold),
            value: 3,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxA94)))
        }
    ];
    const items = [
        {
            content: /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                ref: dropDownColorOptionButton,
                type: "button",
                "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderColorDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-color",
                css: (0, $ieeJu.expValEquals)('platform_editor_fix_media_toolbar_border_dropdown', 'isEnabled', true, false) ? $daa586f49fdcc793$var$dropdownOptionButtonNew : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                (0, $a01946851ab4024a$export$8918fcb9aa07f104),
                "aria-expanded": isColorSubmenuOpen,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsColorSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsSizeSubmenuOpen(false);
                            return next;
                        });
                        else setIsColorSubmenuOpen(!isColorSubmenuOpen);
                    })
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.default), null, formatMessage((0, $ixa4K.imageBorderMessages).borderColor)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $a01946851ab4024a$export$b102432b1d401cd6)
            })), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                ref: colorSubmenuRef
            }, isColorSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $a01946851ab4024a$export$22186258d84a0d25)(0),
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    handleColorSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7xQNd.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (color)=>{
                    setBorder({
                        color: color
                    });
                    setIsOpen(!isOpen);
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (color, _, event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        setBorder({
                            color: color
                        });
                        setIsOpen(!isOpen);
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                        openDropdownButtonRef.current?.focus();
                    }
                },
                selectedColor: color ?? null,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: (0, $3aDYK.default),
                    paletteColorTooltipMessages: (0, $8VCvx.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $czp8P.hexToEditorBorderPaletteColor)
                }
            }))))),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-image-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                type: "button",
                "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderSizeDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-size",
                css: (0, $ieeJu.expValEquals)('platform_editor_fix_media_toolbar_border_dropdown', 'isEnabled', true, false) ? $daa586f49fdcc793$var$dropdownOptionButtonNew : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                (0, $a01946851ab4024a$export$8918fcb9aa07f104),
                "aria-expanded": isSizeSubmenuOpen,
                ref: dropDownSizeOptionButton,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsSizeSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsColorSubmenuOpen(false);
                            return next;
                        });
                        else setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
                    })
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4aRua.default), null, formatMessage((0, $ixa4K.imageBorderMessages).borderSize)), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $a01946851ab4024a$export$b102432b1d401cd6)
            })), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                //eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                ref: sizeSubmenuRef
            }, isSizeSubmenuOpen && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: (e)=>{
                    e.preventDefault();
                    handleSizeSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $a01946851ab4024a$export$22186258d84a0d25)(1),
                ref: handleSubMenuRef
            }, borderSizeOptions.map(({ name: name, value: value, icon: icon }, idx)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = icon;
                return(// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                    key: idx,
                    content: name
                }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    css: (0, $a01946851ab4024a$export$7afe8f4b3442c19d)
                }, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                    type: "button",
                    /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $a01946851ab4024a$export$fd4d27a26b4854f3)(value === size),
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === size,
                    onClick: ()=>{
                        setBorder({
                            size: value
                        });
                        setIsOpen(false);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            setBorder({
                                size: value
                            });
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            openDropdownButtonRef.current?.focus();
                        }
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                    color: value === size ? "var(--ds-icon-inverse, #FFFFFF)" : 'currentColor',
                    spacing: "spacious",
                    label: ""
                })))));
            }))))),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-image-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ];
    /**
   * We want to change direction of our dropdowns a bit early,
   * not exactly when it hits the boundary.
   */ const fitTolerance = 10;
    const fitWidth = (0, $a01946851ab4024a$export$1a7f12094b137d20).width;
    const fitHeight = items.length * ((0, $a01946851ab4024a$export$1a7f12094b137d20).height + (0, $a01946851ab4024a$export$e14354b446b68c1f));
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $a01946851ab4024a$export$6d722733f5366928)({
            enabled: enabled,
            isOpen: isOpen
        })
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-btn",
        selected: enabled,
        onClick: toggleBorder,
        spacing: "compact",
        "aria-label": enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder),
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lRXxm))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        title: enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder)
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: popupTarget
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-dropdown",
        ref: openDropdownButtonRef,
        selected: enabled || isOpen,
        "aria-expanded": isOpen,
        "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
        title: formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            setIsOpen(!isOpen);
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onKeyDown: (e)=>handleTriggerToolbarByKeyboard(e, ()=>setIsOpen(!isOpen))
    }))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        target: popupTarget.current ? popupTarget.current : undefined,
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance,
        forcePlacement: true,
        stick: true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        onMouseLeave: (0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? undefined : ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $a01946851ab4024a$export$89634948c2be5ede)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gLi18.default), {
        //This needs be removed when the a11y is completely handled
        //Disabling key navigation now as it works only partially
        //Same with packages/editor/editor-plugin-table/src/plugins/table/ui/FloatingContextualMenu/ContextualMenu.tsx
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: isAnySubMenuOpen
        },
        allowEnterDefaultBehavior: isAnySubMenuOpen,
        handleEscapeKeydown: isAnySubMenuOpen ? ()=>{
            return;
        } : ()=>{
            openDropdownButtonRef.current?.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        shouldFocusFirstItem: ()=>isOpenByKeyboard,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onOpenChange: ()=>{
            setIsOpen(false);
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onItemActivated: ({ item: item })=>{
            if (item.value.name === 'color') {
                if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsColorSubmenuOpen((prev)=>{
                    const next = !prev;
                    if (next) setIsSizeSubmenuOpen(false);
                    return next;
                });
                else setIsColorSubmenuOpen(!isColorSubmenuOpen);
            }
            if (item.value.name === 'size') {
                if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsSizeSubmenuOpen((prev)=>{
                    const next = !prev;
                    if (next) setIsColorSubmenuOpen(false);
                    return next;
                });
                else setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
            }
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseEnter: ({ item: item })=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'color') {
                    setIsColorSubmenuOpen(true);
                    setIsOpenedByKeyboard(false);
                }
                if (item.value.name === 'size') {
                    setIsSizeSubmenuOpen(true);
                    setIsOpenedByKeyboard(false);
                }
            }
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseLeave: ({ item: item })=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'color') setIsColorSubmenuOpen(false);
                if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
            }
        },
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance
    }))));
};
var $daa586f49fdcc793$export$2e2bcd8739ae039 = $daa586f49fdcc793$var$ImageBorder;











const $87d3ca72fad96c66$export$63563c8e4d4e5bae = (0, $kSwu1.defineMessages)({
    altText: {
        id: "fabric.editor.addAltText",
        defaultMessage: "Alt text"
    },
    addAltText: {
        id: "fabric.editor.addUpdatedAltText",
        defaultMessage: "Add alt text"
    },
    editAltText: {
        id: "fabric.editor.editAltText",
        defaultMessage: "Edit alt text"
    },
    back: {
        id: "fabric.editor.closeAltTextEdit",
        defaultMessage: "Back"
    },
    clear: {
        id: "fabric.editor.clearAltTextEdit",
        defaultMessage: "Clear alt text"
    },
    placeholder: {
        id: "fabric.editor.placeholderAltText",
        defaultMessage: "Describe this image with alt text"
    },
    supportText: {
        id: "fabric.editor.supportAltText",
        defaultMessage: "Alt text is useful for people using screen readers because of visual limitations."
    },
    validationMessage: {
        id: "fabric.editor.alttext.validation",
        defaultMessage: "Please remove any special characters in alt text."
    }
});



var $l0zDh = parcelRequire("l0zDh");


var $2VYYv = parcelRequire("2VYYv");





var $dsePF = parcelRequire("dsePF");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $lzgC6 = parcelRequire("lzgC6");




var $fdQKX = parcelRequire("fdQKX");








/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $24dy7 = parcelRequire("24dy7");


var $chu6R = parcelRequire("chu6R");




function $c0fe317632e75495$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c0fe317632e75495$var$errorColor = {
    name: "hwd2ye",
    styles: "color:var(--ds-text-danger, #AE2E24)"
};
const $c0fe317632e75495$var$validColor = {
    name: "88plqi",
    styles: "color:var(--ds-text-success, #4C6B1F)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $c0fe317632e75495$var$messageStyle = ()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        marginTop: "var(--ds-space-050, 4px)",
        display: 'flex',
        justifyContent: 'baseline'
    });
const $c0fe317632e75495$var$iconWrapperStyle = {
    name: "15quk7w",
    styles: "display:flex;margin-right:var(--ds-space-050, 4px)"
};
const $c0fe317632e75495$export$8fbe3c7d0ed2c683 = ({ children: children })=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $c0fe317632e75495$var$messageStyle
    }, children);
const $c0fe317632e75495$export$915e9e7bd4f0f96d = ({ children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>{
            return [
                $c0fe317632e75495$var$messageStyle(),
                $c0fe317632e75495$var$errorColor
            ];
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $c0fe317632e75495$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: intl.formatMessage((0, $2xhuI.default).error)
    })), children);
};
const $c0fe317632e75495$export$5505afb209a532c8 = ({ children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>{
            return [
                $c0fe317632e75495$var$messageStyle(),
                $c0fe317632e75495$var$validColor
            ];
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $c0fe317632e75495$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: intl.formatMessage((0, $2xhuI.default).success)
    })), children);
};


var $4hfky = parcelRequire("4hfky");

var $6BleA = parcelRequire("6BleA");







var $iW7aI = parcelRequire("iW7aI");


var $5avUB = parcelRequire("5avUB");


function $d70ca2cb1b180d17$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d70ca2cb1b180d17$export$17c2363f220b4958 = 510; // double tweet length
const $d70ca2cb1b180d17$var$supportTextStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(12),
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-500, 40px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    margin: 0
});
const $d70ca2cb1b180d17$var$containerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX)}px`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 2
});
const $d70ca2cb1b180d17$var$inputWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $d70ca2cb1b180d17$var$validationWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
    alignItems: 'start',
    flexDirection: 'column'
});
const $d70ca2cb1b180d17$var$buttonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
});
const $d70ca2cb1b180d17$var$clearTextStyles = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
class $d70ca2cb1b180d17$export$c3eac9b61d42d8a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.prevValue = this.props.value;
    }
    componentWillUnmount() {
        this.fireAnalytics((0, $krYZG.ACTION).CLOSED);
        if (!this.prevValue && this.state.lastValue) this.fireAnalytics((0, $krYZG.ACTION).ADDED);
        if (this.prevValue && !this.state.lastValue) this.fireAnalytics((0, $krYZG.ACTION).CLEARED);
        if (this.prevValue && this.prevValue !== this.state.lastValue) this.fireAnalytics((0, $krYZG.ACTION).EDITED);
    }
    getValidationErrors(value) {
        const { altTextValidator: altTextValidator } = this.props;
        if (value && typeof altTextValidator === 'function') return altTextValidator(value) || [];
        return [];
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { showClearTextButton: showClearTextButton } = this.state;
        const backButtonMessage = formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).back);
        const backButtonMessageComponent = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: backButtonMessage,
            keymap: (0, $ldqjS.escape),
            shortcutOverride: "Esc"
        });
        const errorsList = (this.state.validationErrors || []).map(function(error, index) {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0fe317632e75495$export$915e9e7bd4f0f96d), {
                key: index
            }, error);
        });
        const hasErrors = !!errorsList.length;
        const onSubmit = this.props.areAnyNewToolbarFlagsEnabled ?? (0, $g6uqx.areToolbarFlagsEnabled)() ? this.closeMediaAltTextMenuAndSetFocus : this.closeMediaAltTextMenu;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $d70ca2cb1b180d17$var$containerStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("section", {
            css: $d70ca2cb1b180d17$var$inputWrapperStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $d70ca2cb1b180d17$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            title: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).back),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                label: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).back),
                size: "small"
            }),
            tooltipContent: backButtonMessageComponent,
            onClick: this.closeMediaAltTextMenu,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $g6uqx.areToolbarFlagsEnabled)()
        })), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6BleA.default), {
            testId: "alt-text-input",
            ariaLabel: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).placeholder),
            describedById: `${hasErrors ? 'errors-list' : ''} support-text`,
            placeholder: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).placeholder),
            defaultValue: this.state.lastValue,
            onCancel: this.dispatchCancelEvent,
            onChange: this.handleOnChange,
            onBlur: this.handleOnBlur,
            onSubmit: onSubmit,
            maxLength: $d70ca2cb1b180d17$export$17c2363f220b4958,
            ariaRequired: true,
            ariaInvalid: hasErrors,
            autoFocus: true
        }), showClearTextButton && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $d70ca2cb1b180d17$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            testId: "alt-text-clear-button",
            title: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).clear),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: $d70ca2cb1b180d17$var$clearTextStyles
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).clear)
            })),
            tooltipContent: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).clear),
            onClick: this.handleClearText,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $g6uqx.areToolbarFlagsEnabled)()
        }))), hasErrors && /*#__PURE__*/ (0, $lOiVq.jsx)("section", {
            id: "errors-list",
            ref: this.errorsListRef,
            "aria-live": "assertive",
            css: $d70ca2cb1b180d17$var$validationWrapperStyles
        }, errorsList), /*#__PURE__*/ (0, $lOiVq.jsx)("p", {
            css: $d70ca2cb1b180d17$var$supportTextStyles,
            id: "support-text"
        }, formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).supportText)));
    }
    fireAnalytics(actionType) {
        const { createAnalyticsEvent: createAnalyticsEvent, nodeType: nodeType, mediaType: mediaType } = this.props;
        if (createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: {
                action: actionType,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    type: nodeType,
                    mediaType: mediaType
                }
            }
        });
    }
    constructor(props){
        super(props);
        this.fireCustomAnalytics = void 0;
        this.errorsListRef = void 0;
        this.state = {
            showClearTextButton: Boolean(this.props.value),
            validationErrors: this.props.value ? this.getValidationErrors(this.props.value) : [],
            lastValue: this.props.value
        };
        this.prevValue = void 0;
        this.closeMediaAltTextMenu = ()=>{
            const { view: view } = this.props;
            if (this.state.validationErrors.length === 0) (0, $89c53bb0b7f851eb$export$e494ea08c5b8d2cd)(this.state.lastValue || '')(view.state, view.dispatch);
            else (0, $89c53bb0b7f851eb$export$56a9d6e428ac89c9)(view.state, view.dispatch);
        };
        this.closeMediaAltTextMenuAndSetFocus = ()=>{
            this.closeMediaAltTextMenu();
            this.props.onEnter?.();
        };
        this.dispatchCancelEvent = (event)=>{
            const { view: view, onEscape: onEscape } = this.props;
            // We need to pass down the ESCAPE keymap
            // because when we focus on the Toolbar, Prosemirror blur,
            // making all keyboard shortcuts not working
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            view.someProp('handleKeyDown', (fn)=>fn(view, event));
            onEscape?.();
        };
        this.handleOnChange = (newAltText)=>{
            const validationErrors = this.getValidationErrors(newAltText);
            if (this.state?.validationErrors?.length !== validationErrors?.length) // If number of errors was changed we need to reset attribute to get new SR announcement
            {
                if (this.errorsListRef) {
                    const errorsArea = this.errorsListRef?.current;
                    errorsArea?.removeAttribute('aria-live');
                    errorsArea?.setAttribute('aria-live', 'assertive');
                }
            }
            this.setState({
                showClearTextButton: Boolean(newAltText),
                validationErrors: validationErrors,
                lastValue: newAltText
            });
        };
        this.handleOnBlur = (e)=>{
            // prevent other selection transaction gets triggered
            e.stopPropagation();
            if (this.props.areAnyNewToolbarFlagsEnabled ?? (0, $g6uqx.areToolbarFlagsEnabled)()) this.closeMediaAltTextMenuAndSetFocus();
            else this.closeMediaAltTextMenu();
        };
        this.handleClearText = ()=>{
            this.handleOnChange('');
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        this.fireCustomAnalytics = (0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent);
        this.errorsListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
const $d70ca2cb1b180d17$var$_default_1 = (0, $lzgC6.default)()((0, $kSwu1.injectIntl)($d70ca2cb1b180d17$export$c3eac9b61d42d8a9));
var $d70ca2cb1b180d17$export$2e2bcd8739ae039 = $d70ca2cb1b180d17$var$_default_1;



var $8f29X = parcelRequire("8f29X");







const $45de47491c72a957$var$testId = 'alt-text-edit-button';
const $45de47491c72a957$export$ee5eb653e9c77c53 = (intl, state, editorAnalyticsAPI)=>{
    const mediaNode = (0, $geUVX.getMediaSingleOrInlineNodeFromSelection)(state);
    const message = mediaNode && mediaNode.attrs.alt ? (0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).editAltText : (0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).altText;
    const title = intl.formatMessage(message);
    return {
        title: title,
        id: 'editor.media.altText',
        type: 'button',
        onClick: (0, $89c53bb0b7f851eb$export$e5f8c6baa484e73d)(editorAnalyticsAPI),
        showTitle: true,
        testId: $45de47491c72a957$var$testId,
        tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: title,
            keymap: (0, $ldqjS.addAltText)
        })
    };
};
const $45de47491c72a957$var$altTextEditComponent = (options)=>{
    return {
        type: 'custom',
        fallback: [],
        disableArrowNavigation: true,
        render: (view, idx)=>{
            if (!view) return null;
            const state = view.state;
            const mediaNode = (0, $geUVX.getMediaSingleOrInlineNodeFromSelection)(state);
            if (!mediaNode) return null;
            /** Focus should move to the 'Alt text' button when the toolbar closes
       * and not close the floating toolbar.
       */ const setFocus = ()=>{
                const { state: { tr: tr }, dispatch: dispatch } = view;
                const elementSelector = options?.triggerButtonSelector && options?.areAnyNewToolbarFlagsEnabled ? options.triggerButtonSelector : `[data-testid="${$45de47491c72a957$var$testId}"]`;
                const newTr = options?.forceFocusSelector?.(elementSelector)(tr);
                if (newTr) dispatch(newTr);
            };
            const type = (0, $7mc9A.getNodeType)(state);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d70ca2cb1b180d17$export$2e2bcd8739ae039), {
                view: view,
                key: idx,
                nodeType: type,
                mediaType: mediaNode.attrs.type,
                value: mediaNode.attrs.alt,
                altTextValidator: options && options.altTextValidator,
                onEscape: setFocus,
                onEnter: setFocus,
                areAnyNewToolbarFlagsEnabled: options?.areAnyNewToolbarFlagsEnabled
            });
        }
    };
};
const $45de47491c72a957$export$626712166441e24f = (toolbarBaseConfig, options)=>{
    return {
        ...toolbarBaseConfig,
        width: (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        className: (0, $l0zDh.ClassNames).FLOATING_TOOLBAR_COMPONENT,
        items: [
            $45de47491c72a957$var$altTextEditComponent(options)
        ]
    };
};
const $45de47491c72a957$export$cf32f28463a52655 = (state, formatMessage, allowAltTextOnImages, selectedNodeType, editorAnalyticsAPI)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.attrs.type;
    if (allowAltTextOnImages && (selectedNodeType === mediaSingle || selectedNodeType === mediaInline && (0, $8f29X.isImage)(mediaType))) return [
        {
            title: formatMessage((0, $87d3ca72fad96c66$export$63563c8e4d4e5bae).addAltText),
            onClick: (0, $89c53bb0b7f851eb$export$e5f8c6baa484e73d)(editorAnalyticsAPI),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsePF))), {
                label: ""
            }),
            testId: 'media-alt-text-dropdown-option'
        }
    ];
    return [];
};

















var $ImNkk = parcelRequire("ImNkk");


var $83k8i = parcelRequire("83k8i");





var $eDtFr = parcelRequire("eDtFr");










const $dbb3c762a028e37f$export$c936f67f30fa5fde = (intl, state, api, onCommentButtonMount, createCommentExperience)=>{
    const selectMediaNode = (0, $2ETaj.getSelectedMediaSingle)(state)?.node.firstChild;
    let hasActiveComments = false;
    const annotations = api?.annotation?.sharedState.currentState()?.annotations;
    if (selectMediaNode && annotations) hasActiveComments = selectMediaNode.marks.some((mark)=>mark.type.name === 'annotation' && !annotations[mark.attrs.id]);
    const title = intl.formatMessage(hasActiveComments ? (0, $ImNkk.commentMessages).viewCommentsOnMedia : (0, $ImNkk.commentMessages).addCommentOnMedia);
    const buttonLabel = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
    const onClickHandler = (state, dispatch)=>{
        if (api?.annotation && selectMediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode, setInlineCommentDraftState: setInlineCommentDraftState } = api.annotation.actions;
            const isOpeningMediaCommentFromToolbar = (0, $ixfCV.fg)('confluence_frontend_media_scroll_fix') ? true : false;
            if (!showCommentForBlockNode(selectMediaNode, (0, $1SZMn.VIEW_METHOD).COMMENT_BUTTON, isOpeningMediaCommentFromToolbar)(state, dispatch)) {
                if ((0, $ixfCV.fg)('confluence_fe_create_inline_comment_exp_coverage_2')) {
                    createCommentExperience?.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'block',
                            blockType: 'media',
                            entryPoint: 'highlightActionsSimple'
                        }
                    });
                    createCommentExperience?.initExperience.start();
                }
                setInlineCommentDraftState(true, // TODO: ED-26962 - might need to update to reflect it's from media floating toolbar
                (0, $krYZG.INPUT_METHOD).FLOATING_TB, 'block', selectMediaNode.attrs?.id, isOpeningMediaCommentFromToolbar)(state, dispatch);
            }
        }
        return true;
    };
    return {
        type: 'button',
        testId: 'add-comment-media-button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
        title: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') ? title : buttonLabel,
        showTitle: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
        onClick: onClickHandler,
        tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: title
        }),
        supportsViewMode: true,
        disabled: (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode),
        onMount: ()=>{
            onCommentButtonMount && onCommentButtonMount();
        }
    };
};



var $3mJu6 = parcelRequire("3mJu6");




function $2f71e8fa67fa1d22$export$5c7a39f9b065f644(editorState) {
    const border = editorState.schema.marks.border;
    if (!border) return false;
    const nodeWithPos = (0, $3mJu6.currentMediaNodeWithPos)(editorState) || (0, $4JRVn.currentMediaInlineNodeWithPos)(editorState);
    if (!nodeWithPos) return false;
    const { parent: parent } = editorState.doc.resolve(nodeWithPos.pos);
    return parent && parent.type.allowsMarkType(border);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports




var $7joZr = parcelRequire("7joZr");




var $huoxr = parcelRequire("huoxr");






const $451012731f6a91e2$var$containerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100'
});
const $451012731f6a91e2$export$7fe0cbe305f29bb4 = ({ layoutButtons: layoutButtons, dispatchCommand: dispatchCommand, hide: hide, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $451012731f6a91e2$var$containerStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, layoutButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                        hide();
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};






var $9p0BY = parcelRequire("9p0BY");





var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");








var $kTb7m = parcelRequire("kTb7m");


var $V3JOP = parcelRequire("V3JOP");






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $clVvI = parcelRequire("clVvI");










var $kerfx = parcelRequire("kerfx");







function $8ccb0d7c00c56cd6$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithActivityProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { providerFactory: providerFactory } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
                // Memoising this array causes the component fail tests in platform/packages/editor/editor-plugin-media-tests/src/__tests__/playwright/media-link.spec.ts because the WithProviders component doesn't update when the parent rerenders - this is a bug with the underlying WithProviders component
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'activityProvider'
                ],
                providerFactory: providerFactory,
                renderNode: this.renderNode
            });
        }
        constructor(...args){
            super(...args);
            this.renderNode = (providers)=>{
                const { providerFactory: _providerFactory, ...props } = this.props;
                const { activityProvider: activityProvider } = providers;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    activityProvider: activityProvider,
                    ...props
                });
            };
        }
    };
}


const $d7548a805a172e40$var$DEFAULT_ITEMS_LIMIT = 5;
const $d7548a805a172e40$var$limit = (items, max)=>{
    return items.slice(0, max);
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d7548a805a172e40$var$RecentLink extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.defaultUrl !== this.props.defaultUrl) this.setState((state)=>{
            if (state.url !== this.props.defaultUrl) return {
                items: [],
                selectedIndex: -1,
                url: this.props.defaultUrl || ''
            };
            return null;
        });
    }
    async componentDidMount() {
        if (this.props.activityProvider) {
            this.activityProvider = await this.props.activityProvider;
            await this.loadRecentItems(this.activityProvider);
        }
    }
    async loadRecentItems(activityProvider) {
        try {
            if (!this.state.url) this.setState({
                isLoading: true,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                items: $d7548a805a172e40$var$limit(await activityProvider.getRecentItems(), this.props.limit) // defaultProps assure that limit always contains a value
            });
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    getCurrentInputMethod() {
        const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
        if (items && items.length > 0 && selectedIndex > -1) return (0, $krYZG.INPUT_METHOD).TYPEAHEAD;
        else if (url && url.length > 0) return (0, $krYZG.INPUT_METHOD).MANUAL;
        return;
    }
    render() {
        const { render: render } = this.props;
        const { url: url } = this.state;
        return render({
            activityProvider: this.activityProvider,
            inputProps: {
                onChange: this.handleChange,
                onKeyDown: this.handleKeyDown,
                onSubmit: this.handleSubmit,
                value: url
            },
            clearValue: this.clearValue,
            currentInputMethod: this.getCurrentInputMethod(),
            renderRecentList: this.renderRecentList
        });
    }
    constructor(props){
        super(props);
        this.activityProvider = null;
        this.handleSubmit = ()=>{
            const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
            const inputMethod = this.getCurrentInputMethod();
            if (!inputMethod) return; // No call submit, if there is nothing to submit
            switch(inputMethod){
                case (0, $krYZG.INPUT_METHOD).MANUAL:
                    this.props.onSubmit({
                        url: url,
                        text: url,
                        inputMethod: (0, $krYZG.INPUT_METHOD).MANUAL
                    });
                    break;
                case (0, $krYZG.INPUT_METHOD).TYPEAHEAD:
                    {
                        const item = items[selectedIndex];
                        this.setState(()=>({
                                url: item.url
                            }));
                        if (this.props.onSubmit) this.props.onSubmit({
                            url: item.url,
                            text: item.name,
                            inputMethod: (0, $krYZG.INPUT_METHOD).TYPEAHEAD
                        });
                        break;
                    }
            }
        };
        this.handleSelected = (href, text)=>{
            if (this.props.onSubmit) {
                this.setState(()=>({
                        url: href
                    }));
                this.props.onSubmit({
                    text: text,
                    url: href,
                    inputMethod: (0, $krYZG.INPUT_METHOD).TYPEAHEAD
                });
            }
        };
        this.handleChange = async (input)=>{
            this.setState({
                url: input
            });
            if (this.activityProvider) {
                if (input.length === 0) this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $d7548a805a172e40$var$limit(await this.activityProvider.getRecentItems(), this.props.limit),
                    selectedIndex: -1
                });
                else this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $d7548a805a172e40$var$limit(await this.activityProvider.searchRecent(input), this.props.limit),
                    selectedIndex: 0
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (e)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (!items || !items.length) return;
            if (e.key === 'ArrowDown') {
                // down
                e.preventDefault();
                this.setState({
                    selectedIndex: (selectedIndex + 1) % items.length
                });
            } else if (e.key === 'ArrowUp') {
                // up
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : items.length - 1
                });
            }
        };
        this.handleMouseMove = (objectId)=>{
            const { items: items } = this.state;
            if (items) {
                const index = items.findIndex((item)=>item.objectId === objectId);
                this.setState({
                    selectedIndex: index
                });
            }
        };
        this.renderRecentList = ()=>{
            const { items: items, isLoading: isLoading, selectedIndex: selectedIndex } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kerfx.default), {
                items: items,
                isLoading: isLoading,
                selectedIndex: selectedIndex,
                onSelect: this.handleSelected,
                onMouseMove: this.handleMouseMove
            });
        };
        this.clearValue = ()=>{
            this.setState({
                url: ''
            });
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            items: [],
            url: props.defaultUrl || ''
        };
    }
}
$d7548a805a172e40$var$RecentLink.defaultProps = {
    limit: $d7548a805a172e40$var$DEFAULT_ITEMS_LIMIT
};
const $d7548a805a172e40$var$_default_1 = (0, $8ccb0d7c00c56cd6$export$2e2bcd8739ae039)((0, $kSwu1.injectIntl)($d7548a805a172e40$var$RecentLink));
var $d7548a805a172e40$export$2e2bcd8739ae039 = $d7548a805a172e40$var$_default_1;





const $267e93d70ef36cd8$export$8fc7ee45d6c4fad2 = (0, $kSwu1.defineMessages)({
    backLink: {
        id: "fabric.editor.backLink",
        defaultMessage: "Go back"
    }
});



















var $8y86q = parcelRequire("8y86q");

const $a6a4683edc4edd6d$var$validationWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-400, 32px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column'
});
const $a6a4683edc4edd6d$var$buttonWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} 0px`
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a6a4683edc4edd6d$var$LinkAddToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    getValidationErrors(value, inputMethod) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // dont show validation errors if input method is typeahed, which means user selects from search list
        if (inputMethod === (0, $krYZG.INPUT_METHOD).TYPEAHEAD) return [];
        if (!value) return [
            formatMessage((0, $iEFx5.linkToolbarMessages).emptyLink)
        ];
        // if url can be normalized - we consider it is a valid url
        // also don't show validaition errors for empty values
        if ((0, $hZrGN.normalizeUrl)(value)) return [];
        else return [
            formatMessage((0, $iEFx5.linkToolbarMessages).invalidLink)
        ];
    }
    render() {
        const { providerFactory: providerFactory, displayUrl: displayUrl } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $d7548a805a172e40$export$2e2bcd8739ae039), {
            defaultUrl: (0, $hZrGN.normalizeUrl)(displayUrl),
            providerFactory: providerFactory,
            onSubmit: this.handleSubmit,
            onBlur: this.handleOnBlur,
            render: this.renderContainer
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            validationErrors: []
        };
        this.handleSubmit = ({ url: url, inputMethod: inputMethod })=>{
            this.props.onSubmit(url, {
                inputMethod: inputMethod
            });
        };
        this.handleOnBack = ({ url: url, inputMethod: inputMethod }, setFocus)=>{
            const { onBack: onBack } = this.props;
            if (onBack) onBack(url, {
                inputMethod: inputMethod
            }, setFocus);
        };
        this.handleCancel = ()=>{
            const { onCancel: onCancel } = this.props;
            if (onCancel) onCancel();
        };
        this.handleUnlink = (setFocus)=>{
            const { onUnlink: onUnlink } = this.props;
            if (onUnlink) onUnlink(setFocus);
        };
        this.handleOnBlur = (options)=>{
            this.props.onBlur(options.url);
        };
        this.renderContainer = ({ activityProvider: activityProvider, inputProps: { onChange: onChange, onKeyDown: onKeyDown, onSubmit: onSubmit, value: value }, currentInputMethod: currentInputMethod, renderRecentList: renderRecentList })=>{
            const { intl: { formatMessage: formatMessage }, displayUrl: displayUrl } = this.props;
            const getPlaceholder = (hasActivityProvider)=>formatMessage(hasActivityProvider ? (0, $iEFx5.linkToolbarMessages).placeholder : (0, $iEFx5.linkToolbarMessages).linkPlaceholder);
            const formatLinkAddressText = formatMessage((0, $267e93d70ef36cd8$export$8fc7ee45d6c4fad2).backLink);
            const formatUnlinkText = formatMessage((0, $iEFx5.linkToolbarMessages).unlink);
            const errorsList = this.state.validationErrors.map(function(error, index) {
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0fe317632e75495$export$915e9e7bd4f0f96d), {
                    key: index
                }, error);
            });
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                className: "recent-list"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: [
                    (0, $clVvI.container),
                    !!activityProvider && (0, $clVvI.containerWithProvider)
                ]
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $clVvI.inputWrapper)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: $a6a4683edc4edd6d$var$buttonWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                title: formatLinkAddressText,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                    label: formatLinkAddressText,
                    size: "small"
                }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>this.handleOnBack({
                        url: value,
                        inputMethod: currentInputMethod
                    }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleOnBack({
                            url: value,
                            inputMethod: currentInputMethod
                        }, true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            })), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6BleA.default), {
                inputId: "media-link-search-input",
                testId: "media-link-input",
                placeholder: getPlaceholder(!!activityProvider),
                autoFocus: true,
                onCancel: this.handleCancel,
                defaultValue: value,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (inputValue)=>{
                    const validationErrors = this.getValidationErrors(inputValue, currentInputMethod);
                    this.setState({
                        validationErrors: validationErrors
                    });
                    if (!validationErrors.length) onSubmit();
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onChange: (value)=>{
                    this.setState({
                        validationErrors: []
                    });
                    onChange(value);
                },
                onKeyDown: onKeyDown
            }), /*#__PURE__*/ (0, $lOiVq.jsx)("label", {
                className: "assistive",
                htmlFor: "media-link-search-input"
            }, formatMessage((0, $iEFx5.linkToolbarMessages).searchInput)), (0, $hZrGN.normalizeUrl)(displayUrl) && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                title: formatUnlinkText,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8y86q))), {
                    label: formatUnlinkText
                }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>this.handleUnlink(),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleUnlink(true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }))), !!errorsList.length && /*#__PURE__*/ (0, $lOiVq.jsx)("section", {
                css: $a6a4683edc4edd6d$var$validationWrapper
            }, errorsList), renderRecentList())));
        };
    }
}
var $a6a4683edc4edd6d$export$2e2bcd8739ae039 = $a6a4683edc4edd6d$var$LinkAddToolbar;


const $18e21504ef0614dc$var$FORCE_FOCUS_SELECTOR = '[data-testid="add-link-button"],[data-testid="edit-link-button"]';
const $18e21504ef0614dc$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS = '[data-testid="media-overflow-dropdown-trigger"]';
function $18e21504ef0614dc$export$383c20208186148e(editorState) {
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(editorState);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return false;
    const { nodes: { media: media, mediaInline: mediaInline }, marks: { link: link } } = editorState.schema;
    const node = editorState.doc.nodeAt(mediaLinkingState.mediaPos);
    if (!node || ![
        media,
        mediaInline
    ].includes(node.type)) return false;
    const { parent: parent } = editorState.doc.resolve(mediaLinkingState.mediaPos);
    return parent && parent.type.allowsMarkType(link);
}
const $18e21504ef0614dc$export$894ccf55bf35e0cb = (toolbarBaseConfig, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory)=>{
    const { link: link, visible: visible, editable: editing, mediaPos: mediaPos } = mediaLinkingState;
    if (visible && mediaPos !== null) {
        const node = state.doc.nodeAt(mediaPos);
        if (node) return {
            ...toolbarBaseConfig,
            height: (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX),
            width: (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
            forcePlacement: true,
            items: [
                {
                    type: 'custom',
                    fallback: [],
                    disableArrowNavigation: true,
                    render: (view, idx)=>{
                        if (!view || !providerFactory) return null;
                        const setFocusOnFloatingToolbar = (setFocus)=>{
                            if (setFocus && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
                                const { state: { tr: tr }, dispatch: dispatch } = view;
                                pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector($18e21504ef0614dc$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS)(tr);
                                dispatch(tr);
                            }
                        };
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6a4683edc4edd6d$export$2e2bcd8739ae039), {
                            key: idx,
                            displayUrl: link,
                            providerFactory: providerFactory,
                            intl: intl,
                            editing: editing,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onUnlink: (setFocus)=>{
                                (0, $2dad6518a4381baf$export$5e0808041271ce04)(pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onBack: (href, meta, setFocus)=>{
                                if (href.trim() && meta.inputMethod) (0, $2dad6518a4381baf$export$b195a1839eae3673)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $2dad6518a4381baf$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: ()=>{
                                (0, $2dad6518a4381baf$export$3b74d2c3073f13a9)(view.state, view.dispatch, view, true);
                                /** Focus should move to the 'Add link' button when the toolbar closes
               * and not close the floating toolbar.
               */ const { state: { tr: tr }, dispatch: dispatch } = view;
                                const selector = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar)) ? $18e21504ef0614dc$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS : $18e21504ef0614dc$var$FORCE_FOCUS_SELECTOR;
                                pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector(selector)(tr);
                                dispatch(tr);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onSubmit: (href, meta)=>{
                                (0, $2dad6518a4381baf$export$b195a1839eae3673)(href, meta.inputMethod, pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch, view);
                                (0, $2dad6518a4381baf$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(true);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onBlur: ()=>{
                                (0, $2dad6518a4381baf$export$3b74d2c3073f13a9)(view.state, view.dispatch, view);
                            },
                            areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
                        });
                    }
                }
            ]
        };
    }
};
const $18e21504ef0614dc$var$mediaTypes = [
    'image',
    'video',
    'audio',
    'doc',
    'archive',
    'unknown'
];
const $18e21504ef0614dc$var$getMediaType = (selectedNodeTypeSingle)=>{
    return $18e21504ef0614dc$var$mediaTypes.find((type)=>selectedNodeTypeSingle?.includes(type));
};
const $18e21504ef0614dc$export$ed96f06ad293a0a8 = (editorState, intl, mediaLinkingState, isInlineNode, allowLinking, isViewOnly)=>{
    if (isViewOnly || !allowLinking || !$18e21504ef0614dc$export$383c20208186148e(editorState)) return [];
    let mediaType;
    const mediaNode = isInlineNode ? (0, $4JRVn.currentMediaInlineNode)(editorState) : (0, $4JRVn.currentMediaNode)(editorState);
    if (mediaNode) {
        const selectedNodeTypeSingle = mediaNode?.attrs.__fileMimeType;
        mediaType = $18e21504ef0614dc$var$getMediaType(selectedNodeTypeSingle);
    }
    // Only show link dropdown option for images and external media (shown as images)
    if (mediaType !== 'image' && mediaNode?.attrs.type !== 'external') return [];
    if (mediaLinkingState && mediaLinkingState.editable) {
        const title = intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $2dad6518a4381baf$export$e0eb18fceec368c4)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    label: ""
                })
            }
        ];
    } else {
        const title = intl.formatMessage((0, $iEFx5.linkToolbarMessages).addLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $2dad6518a4381baf$export$e0eb18fceec368c4)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    label: ""
                })
            }
        ];
    }
};
const $18e21504ef0614dc$export$23a4fa4e099d05b4 = (intl, mediaLinkingState, pluginInjectionApi)=>{
    const isValidUrl = (0, $9p0BY.isSafeUrl)(mediaLinkingState.link);
    const linkTitle = intl.formatMessage(isValidUrl ? (0, $91WyP.linkMessages).openLink : (0, $iEFx5.linkToolbarMessages).unableToOpenLink);
    return {
        id: 'editor.media.open-link',
        testId: 'open-link-toolbar-button',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        title: linkTitle,
        target: '_blank',
        href: isValidUrl ? mediaLinkingState.link : undefined,
        disabled: !isValidUrl,
        onClick: (state, dispatch, editorView)=>{
            if (editorView) {
                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    action: (0, $krYZG.ACTION).VISITED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LINK
                })(tr);
                dispatch(tr);
            }
            return true;
        },
        supportsViewMode: true
    };
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


































function $18d939fed2cf6844$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $18d939fed2cf6844$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $18d939fed2cf6844$export$2a8c6fb42753b13e = ({ editorState: editorState, mediaLinkingState: mediaLinkingState, intl: intl, onAddLink: onAddLink, onEditLink: onEditLink, onOpenLink: onOpenLink, isInlineNode: isInlineNode, isViewOnly: isViewOnly, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [showLinkingControls, setShowLinkingControls] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        const mediaNode = isInlineNode ? (0, $4JRVn.currentMediaInlineNode)(editorState) : (0, $4JRVn.currentMediaNode)(editorState);
        if (!mediaNode) {
            setShowLinkingControls(false);
            return;
        }
        const mediaClientConfig = (0, $2mgqy.stateKey).getState(editorState)?.mediaClientConfig;
        if (!mediaClientConfig) {
            setShowLinkingControls(false);
            return;
        }
        (0, $4bb1e35ad772cb66$export$9573295345282b3b)(mediaNode, mediaClientConfig).then((mediaType)=>{
            setShowLinkingControls(mediaType === 'external' || mediaType === 'image');
        });
    }, [
        editorState,
        isInlineNode
    ]);
    if (!showLinkingControls) return null;
    if (mediaLinkingState && mediaLinkingState.editable) {
        const isValidUrl = (0, $9p0BY.isSafeUrl)(mediaLinkingState.link);
        const title = intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink);
        const linkTitle = intl.formatMessage(isValidUrl ? (0, $91WyP.linkMessages).openLink : (0, $iEFx5.linkToolbarMessages).unableToOpenLink);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, !isViewOnly && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $18d939fed2cf6844$var$wrapperStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            onClick: onEditLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                description: title,
                keymap: (0, $ldqjS.addLink)
            }),
            testId: "edit-link-button",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            target: "_blank",
            href: isValidUrl ? mediaLinkingState.link : undefined,
            disabled: !isValidUrl,
            onClick: onOpenLink,
            title: linkTitle,
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                color: "currentColor",
                spacing: "spacious",
                label: linkTitle
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "hyperlink-open-link",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    } else {
        const title = intl.formatMessage((0, $iEFx5.linkToolbarMessages).addLink);
        return !isViewOnly ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            testId: "add-link-button",
            onClick: onAddLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                description: title,
                keymap: (0, $ldqjS.addLink)
            }),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                color: "currentColor",
                label: title,
                spacing: "spacious"
            }),
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        })) : null;
    }
};




































































const $955bd5f9baa18c85$export$55564240c0c61582 = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options = {})=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const forceFocusSelector = pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector;
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.attrs.type;
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    if (mediaPluginState.allowInlineImages && (0, $8f29X.isImage)(mediaType)) return $955bd5f9baa18c85$var$getMediaInlineImageToolbar(state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options);
    const items = [];
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const mauiToolbarSeparatorsUpdateEnabled = (0, $ixfCV.fg)('cc-maui-toolbar-separators-update') && areAnyNewToolbarFlagsEnabled;
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))) : (0, (/*@__PURE__*/$parcel$interopDefault($kTw4V))),
        title: intl.formatMessage((0, $fA65V.messages).expand),
        onClick: ()=>{
            return (0, $255acfdd816952f8$export$19271a18f1ddc766)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    const disableDownloadButton = (0, $2ETaj.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
        onClick: ()=>{
            (0, $2ETaj.downloadMedia)(mediaPluginState);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $fA65V.messages).download),
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $bI2nS.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        selected: false,
        disabled: false,
        focusEditoronEnter: true,
        onClick: (0, $7mc9A.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $bI2nS.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onMouseEnter: hoverDecoration?.(mediaInline, true),
        onMouseLeave: hoverDecoration?.(mediaInline, false),
        onFocus: hoverDecoration?.(mediaInline, true),
        onBlur: hoverDecoration?.(mediaInline, false),
        title: intl.formatMessage((0, $2xhuI.default).remove),
        onClick: (0, $7mc9A.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $bI2nS.messages).inlineTitle),
                onClick: ()=>true,
                selected: true,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $bI2nS.messages).blockTitle),
                onClick: (0, $7mc9A.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $fA65V.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ], download, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ], preview, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ]);
    }
    return items;
};
const $955bd5f9baa18c85$var$getMediaInlineImageToolbar = (state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options = {})=>{
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaInlineImageTitle = intl.formatMessage((0, $2BvhC.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $2BvhC.toolbarMessages).changeToMediaSingle);
    const widthPluginState = pluginInjectionApi?.width?.sharedState.currentState();
    const inlineImageItems = [];
    const isEditorControlsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const { isViewOnly: isViewOnly, allowAltTextOnImages: allowAltTextOnImages, allowLinking: allowLinking, allowImagePreview: allowImagePreview } = options;
    const mauiToolbarSeparatorsUpdateEnabled = (0, $ixfCV.fg)('cc-maui-toolbar-separators-update') && isEditorControlsEnabled;
    if ((0, $2f71e8fa67fa1d22$export$5c7a39f9b065f644)(state)) {
        inlineImageItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $4JRVn.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $daa586f49fdcc793$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    toggleBorder: ()=>{
                        (0, $7mc9A.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    setBorder: (attrs)=>{
                        (0, $7mc9A.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!isEditorControlsEnabled) inlineImageItems.push({
            type: 'separator'
        });
    }
    const download = {
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
        onClick: ()=>{
            (0, $2ETaj.downloadMedia)(mediaPluginState, options.isViewOnly);
            return true;
        },
        title: intl.formatMessage((0, $fA65V.messages).download),
        supportsViewMode: true
    };
    // For Editor Controls: show options to convert from 'Inline' to 'Original size' via dropdown
    if (!isEditorControlsEnabled) inlineImageItems.push({
        id: 'editor.media.convert.mediainline',
        type: 'button',
        title: mediaInlineImageTitle,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaInlineImageTitle
            }),
        onClick: ()=>{
            return true;
        },
        selected: true
    }, {
        id: 'editor.media.convert.mediasingle',
        type: 'button',
        title: mediaSingleTitle,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i7DLA))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaSingleTitle
            }),
        onClick: (0, $7mc9A.changeMediaInlineToMediaSingle)(editorAnalyticsAPI, widthPluginState, options?.allowPixelResizing)
    }, {
        type: 'separator'
    }, {
        type: 'custom',
        fallback: [],
        render: (editorView, idx)=>{
            if (editorView?.state) {
                const editLink = ()=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $2dad6518a4381baf$export$e0eb18fceec368c4)(state, dispatch);
                    }
                };
                const openLink = ()=>{
                    if (editorView) {
                        const { state: { tr: tr }, dispatch: dispatch } = editorView;
                        pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            action: (0, $krYZG.ACTION).VISITED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LINK
                        })(tr);
                        dispatch(tr);
                        return true;
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18d939fed2cf6844$export$2a8c6fb42753b13e), {
                    key: idx,
                    editorState: editorView.state,
                    intl: intl,
                    mediaLinkingState: mediaLinkingState,
                    onAddLink: editLink,
                    onEditLink: editLink,
                    onOpenLink: openLink,
                    isInlineNode: true,
                    isViewOnly: options.isViewOnly,
                    areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
                });
            }
            return null;
        },
        supportsViewMode: true
    });
    else {
        const switchFromInlineToBlock = (0, $2ETaj.getMediaSingleAndMediaInlineSwitcherDropdown)('inline', intl, pluginInjectionApi);
        inlineImageItems.push(switchFromInlineToBlock, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ]);
        if (isViewOnly) inlineImageItems.push(download, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
    }
    //Image Preview
    if (allowImagePreview) inlineImageItems.push({
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: isEditorControlsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))) : (0, (/*@__PURE__*/$parcel$interopDefault($kTw4V))),
        title: intl.formatMessage((0, $fA65V.messages).expand),
        onClick: ()=>{
            return (0, $255acfdd816952f8$export$19271a18f1ddc766)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        supportsViewMode: true
    }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    // open link
    if (allowLinking && (0, $18e21504ef0614dc$export$383c20208186148e)(state) && mediaLinkingState && mediaLinkingState.editable && isEditorControlsEnabled) inlineImageItems.push((0, $18e21504ef0614dc$export$23a4fa4e099d05b4)(intl, mediaLinkingState, pluginInjectionApi), ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    if (isViewOnly && !isEditorControlsEnabled) inlineImageItems.push(download, {
        type: 'separator',
        supportsViewMode: true
    });
    if (allowAltTextOnImages && !isEditorControlsEnabled) inlineImageItems.push((0, $45de47491c72a957$export$ee5eb653e9c77c53)(intl, state, pluginInjectionApi?.analytics?.actions), {
        type: 'separator'
    });
    if (isViewOnly || !isEditorControlsEnabled) inlineImageItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    });
    if (!isEditorControlsEnabled) {
        inlineImageItems.push({
            type: 'separator'
        });
        inlineImageItems.push({
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            onMouseEnter: hoverDecoration?.(mediaInline, true),
            onMouseLeave: hoverDecoration?.(mediaInline, false),
            onFocus: hoverDecoration?.(mediaInline, true),
            onBlur: hoverDecoration?.(mediaInline, false),
            title: intl.formatMessage((0, $2xhuI.default).remove),
            onClick: (0, $7mc9A.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
            testId: 'media-toolbar-remove-button'
        });
    }
    return inlineImageItems;
};


















const $da1ba0eb5b878795$export$bee6402990837b71 = (toolbarBaseConfig, { pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>({
        ...toolbarBaseConfig,
        width: (0, $e5d2f0341666dfa6$export$e879bf3f9286d0ca),
        scrollable: true,
        items: [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(editorView.state);
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c6ef1df365261e2$export$4c9bbfa83ba6e1fa), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: isEditorFullWidthEnabled,
                        triggerButtonSelector: triggerButtonSelector
                    });
                }
            }
        ]
    });
const $da1ba0eb5b878795$export$162f6210a4cda095 = (mediaOptions, state, formatMessage, selectedNodeType)=>{
    if (selectedNodeType?.name !== 'mediaSingle') return [];
    const { allowResizing: allowResizing, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = mediaOptions;
    const isWithinTable = (0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) return [
        {
            title: formatMessage((0, $57fcdb3d1b6673ad$export$41750bfa58c03af2).resizeOption),
            onClick: (0, $c77199520c777221$export$3f611b75d530f269)(),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i7DLA))), {
                label: ""
            }),
            testId: 'media-pixel-resizing-dropdown-option'
        }
    ];
    return [];
};





const $255acfdd816952f8$var$mediaTypeMessages = {
    image: (0, $fA65V.messages).file_image_is_selected,
    video: (0, $fA65V.messages).file_video_is_selected,
    audio: (0, $fA65V.messages).file_audio_is_selected,
    doc: (0, $fA65V.messages).file_doc_is_selected,
    archive: (0, $fA65V.messages).file_archive_is_selected,
    unknown: (0, $fA65V.messages).file_unknown_is_selected
};
const $255acfdd816952f8$var$getMediaActionSubject = (nodeType)=>{
    switch(nodeType.name){
        case 'mediaSingle':
            return (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
        case 'mediaInline':
            return (0, $krYZG.ACTION_SUBJECT).MEDIA_INLINE;
        case 'mediaGroup':
            return (0, $krYZG.ACTION_SUBJECT).MEDIA_GROUP;
        default:
            return (0, $krYZG.ACTION_SUBJECT).MEDIA;
    }
};
const $255acfdd816952f8$var$removeWithAnalytics = (editorAnalyticsApi, nodeType)=>{
    if (!nodeType) return $255acfdd816952f8$var$remove;
    const mediaType = $255acfdd816952f8$var$getMediaActionSubject(nodeType);
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: mediaType,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })($255acfdd816952f8$var$remove);
};
const $255acfdd816952f8$var$remove = (state, dispatch)=>{
    if (dispatch) dispatch((0, $bjg0G.removeSelectedNode)(state.tr));
    return true;
};
const $255acfdd816952f8$var$handleRemoveMediaGroupWithAnalytics = (editorAnalyticsApi)=>{
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_GROUP,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })($255acfdd816952f8$var$handleRemoveMediaGroup);
};
const $255acfdd816952f8$var$handleRemoveMediaGroup = (state, dispatch)=>{
    const tr = (0, $2ETaj.removeMediaGroupNode)(state);
    if (dispatch) dispatch(tr);
    return true;
};
const $255acfdd816952f8$export$19271a18f1ddc766 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    const selectedNodeAttrs = (0, $2ETaj.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api?.core.actions.execute(api?.media.commands.showMediaViewer(selectedNodeAttrs));
};
const $255acfdd816952f8$export$909b58dbf0af33b8 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    const selectedNodeAttrs = (0, $2ETaj.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api?.core.actions.execute(api?.mediaEditing?.commands.showImageEditor(selectedNodeAttrs));
};
const $255acfdd816952f8$var$generateMediaCardFloatingToolbar = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, editorAnalyticsAPI, forceFocusSelector, isViewOnly)=>{
    const disableDownloadButton = (0, $2ETaj.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))) : (0, (/*@__PURE__*/$parcel$interopDefault($kTw4V))),
        title: intl.formatMessage((0, $fA65V.messages).expand),
        onClick: ()=>{
            return $255acfdd816952f8$export$19271a18f1ddc766({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        disabled: (0, $6Ixg8.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
        supportsViewMode: true
    };
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
        onClick: ()=>{
            (0, $2ETaj.downloadMedia)(mediaPluginState);
            return true;
        },
        title: intl.formatMessage((0, $fA65V.messages).download),
        disabled: disableDownloadButton,
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (isViewOnly && !areAnyNewToolbarFlagsEnabled) return [];
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const items = [];
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))),
        selected: false,
        focusEditoronEnter: true,
        disabled: false,
        onClick: (0, $7mc9A.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $bI2nS.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $bI2nS.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaGroup
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onMouseEnter: hoverDecoration?.(mediaGroup, true),
        onMouseLeave: hoverDecoration?.(mediaGroup, false),
        onFocus: hoverDecoration?.(mediaGroup, true),
        onBlur: hoverDecoration?.(mediaGroup, false),
        title: intl.formatMessage((0, $2xhuI.default).remove),
        onClick: $255acfdd816952f8$var$handleRemoveMediaGroupWithAnalytics(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $bI2nS.messages).inlineTitle),
                onClick: (0, $7mc9A.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $bI2nS.messages).blockTitle),
                selected: true,
                onClick: ()=>true,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $fA65V.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, {
            type: 'separator',
            fullHeight: true
        }, download, {
            type: 'separator',
            supportsViewMode: true
        }, preview, {
            type: 'separator',
            fullHeight: true
        });
    }
    return items;
};
const $255acfdd816952f8$var$generateMediaSingleFloatingToolbar = (state, intl, options, pluginState, mediaLinkingState, pluginInjectionApi)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { allowResizing: allowResizing, allowLinking: allowLinking, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowCommentsOnMedia: allowCommentsOnMedia, allowResizingInTables: allowResizingInTables, allowAltTextOnImages: allowAltTextOnImages, allowMediaInline: allowMediaInline, allowMediaInlineImages: allowMediaInlineImages, allowImageEditing: allowImageEditing, allowImagePreview: allowImagePreview, isViewOnly: isViewOnly, allowPixelResizing: allowPixelResizing, onCommentButtonMount: onCommentButtonMount, createCommentExperience: createCommentExperience } = options;
    let toolbarButtons = [];
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const disableDownloadButton = (0, $2ETaj.getIsDownloadDisabledByDataSecurityPolicy)(pluginState);
    const mauiToolbarSeparatorsUpdateEnabled = (0, $ixfCV.fg)('cc-maui-toolbar-separators-update') && areAnyNewToolbarFlagsEnabled;
    if ((0, $2f71e8fa67fa1d22$export$5c7a39f9b065f644)(state)) {
        toolbarButtons.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $4JRVn.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $daa586f49fdcc793$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    toggleBorder: ()=>{
                        (0, $7mc9A.toggleBorderMark)(pluginInjectionApi?.analytics?.actions)(state, dispatch);
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    setBorder: (attrs)=>{
                        (0, $7mc9A.setBorderMark)(pluginInjectionApi?.analytics?.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
            type: 'separator'
        });
    }
    if (allowAdvancedToolBarOptions) {
        const widthPlugin = pluginInjectionApi?.width;
        let isChangingLayoutDisabled = false;
        const selectedNode = (0, $2ETaj.getSelectedMediaSingle)(state);
        if (allowPixelResizing) {
            const contentWidth = widthPlugin?.sharedState.currentState()?.lineLength;
            const selectedNodeMaxWidth = pluginState.currentMaxWidth || contentWidth;
            if (selectedNode && selectedNodeMaxWidth && selectedNode.node.attrs.width >= selectedNodeMaxWidth) isChangingLayoutDisabled = true;
        }
        const layoutButtons = (0, $jU5kz.default)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi?.analytics?.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
        const addLayoutDropdownToToolbar = ()=>{
            if (areAnyNewToolbarFlagsEnabled) {
                const layoutDropdown = (0, $jU5kz.buildLayoutDropdown)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi?.analytics?.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
                toolbarButtons = [
                    ...toolbarButtons,
                    ...layoutDropdown
                ];
            } else {
                const selectedLayoutIcon = (0, $2ETaj.getSelectedLayoutIcon)([
                    ...(0, $jU5kz.alignmentIcons),
                    ...(0, $jU5kz.wrappingIcons)
                ], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectedNode.node);
                if (selectedLayoutIcon && layoutButtons.length) {
                    const options = {
                        render: (props)=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $451012731f6a91e2$export$7fe0cbe305f29bb4), {
                                layoutButtons: layoutButtons,
                                ...props,
                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                            });
                        },
                        width: 188,
                        height: 32
                    };
                    const trigger = {
                        id: 'media-single-layout',
                        testId: 'media-single-layout-dropdown-trigger',
                        type: 'dropdown',
                        options: options,
                        title: intl.formatMessage((0, $jU5kz.layoutToMessages)[selectedLayoutIcon.value]),
                        icon: selectedLayoutIcon.icon
                    };
                    toolbarButtons = [
                        ...toolbarButtons,
                        trigger,
                        ...areAnyNewToolbarFlagsEnabled ? [] : [
                            {
                                type: 'separator'
                            }
                        ]
                    ];
                }
            }
        };
        if ((0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag')) {
            if (allowMediaInlineImages && selectedNode) addLayoutDropdownToToolbar();
            else {
                toolbarButtons = [
                    ...toolbarButtons,
                    ...layoutButtons
                ];
                if (layoutButtons.length && !mauiToolbarSeparatorsUpdateEnabled) toolbarButtons.push({
                    type: 'separator'
                });
            }
        } else if ((0, $nnUSM.mediaInlineImagesEnabled)(allowMediaInline, allowMediaInlineImages) && selectedNode) addLayoutDropdownToToolbar();
        else {
            toolbarButtons = [
                ...toolbarButtons,
                ...layoutButtons
            ];
            if (layoutButtons.length && !areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
                type: 'separator'
            });
        }
        // floating and inline switcher
        if (pluginState.allowInlineImages && selectedNode && (0, $2ETaj.canShowSwitchButtons)(selectedNode.node)) // mediaInlne doesn't suppprt external images, so hiding buttons to prevent conversion from mediaSingle to mediaInline
        {
            if (selectedNode.node.firstChild?.attrs.type !== 'external') {
                const hasCaption = (0, $bjg0G.contains)(selectedNode.node, state.schema.nodes.caption);
                const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $2BvhC.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $2BvhC.toolbarMessages).changeToMediaInlineImage);
                const floatingSwitcherTitle = intl.formatMessage((0, $2BvhC.toolbarMessages).changeToMediaSingle);
                if (!areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
                    type: 'button',
                    id: 'editor.media.image.view.switcher.inline',
                    title: inlineSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: inlineSwitcherTitle
                        }),
                    onClick: (0, $7mc9A.changeMediaSingleToMediaInline)(pluginInjectionApi?.analytics?.actions),
                    testId: 'image-inline-appearance',
                    selected: false
                }, {
                    type: 'button',
                    id: 'editor.media.image.view.switcher.floating',
                    title: floatingSwitcherTitle,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i7DLA))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: floatingSwitcherTitle
                        }),
                    onClick: ()=>{
                        return true;
                    },
                    testId: 'image-floating-appearance',
                    selected: true
                }, {
                    type: 'separator'
                });
                else {
                    const switchFromBlockToInline = (0, $2ETaj.getMediaSingleAndMediaInlineSwitcherDropdown)('block', intl, pluginInjectionApi, hasCaption);
                    toolbarButtons.push(switchFromBlockToInline, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                        {
                            type: 'separator',
                            fullHeight: true
                        }
                    ]);
                }
            }
        }
        // A separator is needed regardless switcher is enabled or not
        if (Boolean(pluginInjectionApi?.toolbar) && !mauiToolbarSeparatorsUpdateEnabled) toolbarButtons.push({
            type: 'separator',
            fullHeight: true
        });
        // Pixel Entry Toolbar Support
        const { selection: selection } = state;
        const isWithinTable = (0, $bjg0G.hasParentNodeOfType)([
            state.schema.nodes.table
        ])(selection);
        if (allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) {
            const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
            const sizeInput = {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c6ef1df365261e2$export$4c9bbfa83ba6e1fa), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: options.fullWidthEnabled
                    });
                }
            };
            if (pluginState.isResizing) {
                // If the image is resizing
                // then return pixel entry component or full width label as the only toolbar item
                if (!selectedMediaSingleNode) return [];
                const { layout: layout } = selectedMediaSingleNode.node.attrs;
                if (layout === 'full-width') {
                    const fullWidthLabel = {
                        type: 'custom',
                        fallback: [],
                        render: ()=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4c6ef1df365261e2$export$8bde7db5b2aba7d), {
                                intl: intl
                            });
                        }
                    };
                    return [
                        fullWidthLabel
                    ];
                }
                return [
                    sizeInput
                ];
            }
            if (!areAnyNewToolbarFlagsEnabled) {
                toolbarButtons.push(sizeInput);
                toolbarButtons.push({
                    type: 'separator'
                });
            }
        }
        if (!areAnyNewToolbarFlagsEnabled) {
            if (allowCommentsOnMedia) toolbarButtons.push((0, $dbb3c762a028e37f$export$c936f67f30fa5fde)(intl, state, pluginInjectionApi, onCommentButtonMount, createCommentExperience), {
                type: 'separator',
                supportsViewMode: true
            });
            if (allowLinking && (0, $18e21504ef0614dc$export$383c20208186148e)(state)) toolbarButtons.push({
                type: 'custom',
                fallback: [],
                render: (editorView, idx)=>{
                    if (editorView?.state) {
                        const editLink = ()=>{
                            if (editorView) {
                                const { state: state, dispatch: dispatch } = editorView;
                                (0, $2dad6518a4381baf$export$e0eb18fceec368c4)(state, dispatch);
                            }
                        };
                        const openLink = ()=>{
                            if (editorView) {
                                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                                pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent({
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                                    action: (0, $krYZG.ACTION).VISITED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LINK
                                })(tr);
                                dispatch(tr);
                                return true;
                            }
                        };
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18d939fed2cf6844$export$2a8c6fb42753b13e), {
                            key: idx,
                            editorState: editorView.state,
                            intl: intl,
                            mediaLinkingState: mediaLinkingState,
                            onAddLink: editLink,
                            onEditLink: editLink,
                            onOpenLink: openLink,
                            isViewOnly: isViewOnly,
                            areAnyNewToolbarFlagsEnabled: false
                        });
                    }
                    return null;
                },
                supportsViewMode: true
            });
            // Image Editing Support
            if (!!pluginInjectionApi?.mediaEditing && allowImageEditing && (0, $ieeJu.expValEquals)('platform_editor_add_image_editing', 'isEnabled', true)) {
                const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
                // Disable image editing for external media, as we cannot save changes to external images per CORS policy
                const isExternal = mediaNode?.attrs?.type === 'external';
                // Disable image editing for gifs as CropperJS does not support gif editing
                const isGif = mediaNode?.attrs?.__fileMimeType === 'image/gif';
                if (!(0, $d55P7.isVideo)(mediaNode?.attrs?.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                    id: 'editor.media.edit',
                    testId: 'image-edit-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w6dd))),
                    title: intl.formatMessage((0, $2xhuI.default).imageEdit),
                    onClick: ()=>{
                        return $255acfdd816952f8$export$909b58dbf0af33b8({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    // Making the button more accessible
                    supportsViewMode: false,
                    isRadioButton: true,
                    selected: false
                });
            }
            // Preview Support
            if (allowImagePreview) {
                const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
                if (!(0, $d55P7.isVideo)(mediaNode?.attrs?.__fileMimeType)) toolbarButtons.push({
                    id: 'editor.media.viewer',
                    testId: 'file-preview-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTw4V))),
                    title: intl.formatMessage((0, $fA65V.messages).expand),
                    onClick: ()=>{
                        return $255acfdd816952f8$export$19271a18f1ddc766({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    disabled: (0, $6Ixg8.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
                    supportsViewMode: true
                }, {
                    type: 'separator',
                    supportsViewMode: true
                });
            }
        }
    }
    if (isViewOnly) toolbarButtons.push({
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Fmj3))),
        onClick: ()=>{
            (0, $2ETaj.downloadMedia)(pluginState, isViewOnly);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $fA65V.messages).download),
        supportsViewMode: true
    }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    if (!areAnyNewToolbarFlagsEnabled) {
        if (allowAltTextOnImages) toolbarButtons.push((0, $45de47491c72a957$export$ee5eb653e9c77c53)(intl, state, pluginInjectionApi?.analytics?.actions), {
            type: 'separator'
        });
        const removeButton = {
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            onMouseEnter: hoverDecoration?.(mediaSingle, true),
            onMouseLeave: hoverDecoration?.(mediaSingle, false),
            onFocus: hoverDecoration?.(mediaSingle, true),
            onBlur: hoverDecoration?.(mediaSingle, false),
            title: intl.formatMessage((0, $2xhuI.default).remove),
            onClick: $255acfdd816952f8$var$removeWithAnalytics(pluginInjectionApi?.analytics?.actions),
            testId: 'media-toolbar-remove-button',
            supportsViewMode: false
        };
        const items = [
            ...toolbarButtons,
            {
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: intl.formatMessage,
                        nodeType: mediaSingle
                    }
                ],
                supportsViewMode: true
            }
        ];
        items.push({
            type: 'separator',
            supportsViewMode: false
        });
        items.push(removeButton);
        return items;
    } else {
        // Preview Support
        if (allowAdvancedToolBarOptions && allowImagePreview) {
            const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
            if (!(0, $d55P7.isVideo)(mediaNode?.attrs?.__fileMimeType)) toolbarButtons.push({
                id: 'editor.media.viewer',
                testId: 'file-preview-toolbar-button',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
                title: intl.formatMessage((0, $fA65V.messages).expand),
                onClick: ()=>{
                    return $255acfdd816952f8$export$19271a18f1ddc766({
                        api: pluginInjectionApi,
                        mediaPluginState: pluginState
                    }) ?? false;
                },
                disabled: (0, $6Ixg8.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode),
                supportsViewMode: true
            }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                {
                    type: 'separator',
                    supportsViewMode: true
                }
            ]);
        }
        if (allowAdvancedToolBarOptions && allowImageEditing && (0, $ieeJu.expValEquals)('platform_editor_add_image_editing', 'isEnabled', true)) {
            const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode?.node.content.firstChild;
            // Disable image editing for external media, as we cannot save changes to external images per CORS policy
            const isExternal = mediaNode?.attrs?.type === 'external';
            // Disable image editing for gifs as CropperJS does not support gif editing
            const isGif = mediaNode?.attrs?.__fileMimeType === 'image/gif';
            if (!(0, $d55P7.isVideo)(mediaNode?.attrs?.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                id: 'editor.media.edit',
                testId: 'image-edit-toolbar-button',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w6dd))),
                title: intl.formatMessage((0, $2xhuI.default).imageEdit),
                onClick: ()=>{
                    return $255acfdd816952f8$export$909b58dbf0af33b8({
                        api: pluginInjectionApi,
                        mediaPluginState: pluginState
                    }) ?? false;
                },
                supportsViewMode: false
            }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                {
                    type: 'separator',
                    supportsViewMode: false
                }
            ]);
        }
        // open link
        if (allowLinking && (0, $18e21504ef0614dc$export$383c20208186148e)(state) && mediaLinkingState && mediaLinkingState.editable) toolbarButtons.push((0, $18e21504ef0614dc$export$23a4fa4e099d05b4)(intl, mediaLinkingState, pluginInjectionApi), ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
        isViewOnly && toolbarButtons.push({
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaSingle
                }
            ],
            supportsViewMode: true
        }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
        if (allowAdvancedToolBarOptions && allowCommentsOnMedia) {
            if (!mauiToolbarSeparatorsUpdateEnabled) (0, $2ETaj.updateToFullHeightSeparator)(toolbarButtons);
            toolbarButtons.push((0, $dbb3c762a028e37f$export$c936f67f30fa5fde)(intl, state, pluginInjectionApi, onCommentButtonMount, createCommentExperience));
        }
        return toolbarButtons;
    }
};
const $255acfdd816952f8$var$getMediaTypeMessage = (selectedNodeTypeSingle)=>{
    const mediaType = Object.keys($255acfdd816952f8$var$mediaTypeMessages).find((key)=>selectedNodeTypeSingle?.includes(key));
    return mediaType ? $255acfdd816952f8$var$mediaTypeMessages[mediaType] : (0, $fA65V.messages).file_unknown_is_selected;
};
const $255acfdd816952f8$export$893b800ba7bfda6d = 'media-overflow-dropdown-trigger';
const $255acfdd816952f8$var$isMediaSelection = (selection, nodeType)=>{
    if (selection instanceof (0, $kCECX.NodeSelection)) return nodeType.includes(selection.node.type);
    return false;
};
const $255acfdd816952f8$export$4850df084251d287 = (state, intl, options = {}, pluginInjectionApi)=>{
    const { media: media, mediaInline: mediaInline, mediaSingle: mediaSingle, mediaGroup: mediaGroup } = state.schema.nodes;
    const { altTextValidator: altTextValidator, allowLinking: allowLinking, allowAltTextOnImages: allowAltTextOnImages, providerFactory: providerFactory, allowMediaInlineImages: allowMediaInlineImages, allowResizing: allowResizing, isViewOnly: isViewOnly, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = options;
    let { allowMediaInline: allowMediaInline } = options;
    allowMediaInline = (0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : allowMediaInline;
    const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
    const mediaLinkingState = (0, $0f87f7842b3d8002$export$a27ff1704d423d4e)(state);
    const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
    if (!mediaPluginState) return;
    const nodeType = allowMediaInline ? [
        mediaInline,
        mediaSingle,
        media
    ] : [
        mediaSingle
    ];
    const isSelectedNodeMediaSingle = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === mediaSingle;
    if (!$255acfdd816952f8$var$isMediaSelection(state.selection, nodeType)) return;
    const baseToolbar = {
        title: 'Media floating controls',
        nodeType: nodeType,
        getDomRef: ()=>{
            const element = isSelectedNodeMediaSingle ? mediaPluginState.element?.querySelector(`.${(0, $5arVd.MediaSingleNodeSelector)}`) || mediaPluginState.element : mediaPluginState.element;
            return element;
        }
    };
    if (allowLinking && mediaLinkingState && mediaLinkingState.visible && (0, $18e21504ef0614dc$export$383c20208186148e)(state)) {
        const linkingToolbar = (0, $18e21504ef0614dc$export$894ccf55bf35e0cb)(baseToolbar, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory);
        if (linkingToolbar) return linkingToolbar;
    }
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const overflowButtonSelector = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar)) ? `[data-testid="${$255acfdd816952f8$export$893b800ba7bfda6d}"]` : undefined;
    if (allowAltTextOnImages) {
        const mediaAltTextPluginState = (0, $cf420da73fb250ce$export$f05434c51e3762e)(state);
        if (mediaAltTextPluginState.isAltTextEditorOpen) return (0, $45de47491c72a957$export$626712166441e24f)(baseToolbar, {
            altTextValidator: altTextValidator,
            forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
            triggerButtonSelector: overflowButtonSelector,
            areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))
        });
    }
    const { selection: selection } = state;
    const isWithinTable = (0, $bjg0G.hasParentNodeOfType)([
        state.schema.nodes.table
    ])(selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        const mediaPixelResizingPluginState = (0, $b65a57bd9857f1c9$export$f05434c51e3762e)(state);
        if (mediaPixelResizingPluginState?.isPixelEditorOpen) return (0, $da1ba0eb5b878795$export$bee6402990837b71)(baseToolbar, {
            intl: intl,
            pluginInjectionApi: pluginInjectionApi,
            pluginState: mediaPluginState,
            hoverDecoration: hoverDecoration,
            isEditorFullWidthEnabled: options.fullWidthEnabled,
            triggerButtonSelector: overflowButtonSelector
        });
    }
    let items = [];
    const parentMediaGroupNode = (0, $bjg0G.findParentNodeOfType)(mediaGroup)(state.selection);
    let selectedNodeType;
    if (state.selection instanceof (0, $kCECX.NodeSelection)) selectedNodeType = state.selection.node.type;
    if (allowMediaInline && parentMediaGroupNode?.node.type === mediaGroup) {
        const mediaOffset = state.selection.$from.parentOffset + 1;
        baseToolbar.getDomRef = ()=>{
            const selector = (0, $1ce50a9b28304653$export$ddc30058b32b7b60)(mediaOffset);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            return mediaPluginState.element?.querySelector(selector);
        };
        items = $255acfdd816952f8$var$generateMediaCardFloatingToolbar(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector, isViewOnly);
    } else if (allowMediaInline && selectedNodeType && selectedNodeType === mediaInline) items = (0, $955bd5f9baa18c85$export$55564240c0c61582)(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options);
    else {
        baseToolbar.getDomRef = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const element = mediaPluginState.element?.querySelector(`.${(0, $5arVd.MediaSingleNodeSelector)}`);
            return element || mediaPluginState.element;
        };
        items = $255acfdd816952f8$var$generateMediaSingleFloatingToolbar(state, intl, options, mediaPluginState, mediaLinkingState, pluginInjectionApi);
    }
    if (!mediaPluginState.isResizing && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        if (!(0, $ixfCV.fg)('cc-maui-toolbar-separators-update')) (0, $2ETaj.updateToFullHeightSeparator)(items);
        const showReplaceOption = !isViewOnly && mediaPluginState.allowsUploads && (0, $ieeJu.expValEquals)('platform_editor_inline_media_replacement', 'isEnabled', true) && selectedNodeType === mediaSingle;
        const customOptions = [
            ...(0, $18e21504ef0614dc$export$ed96f06ad293a0a8)(state, intl, mediaLinkingState, allowMediaInline && selectedNodeType && selectedNodeType === mediaInline, allowLinking, isViewOnly),
            ...(0, $45de47491c72a957$export$cf32f28463a52655)(state, intl.formatMessage, allowAltTextOnImages, selectedNodeType, pluginInjectionApi?.analytics?.actions),
            ...(0, $da1ba0eb5b878795$export$162f6210a4cda095)(options, state, intl.formatMessage, selectedNodeType)
        ];
        if (customOptions.length) customOptions.push({
            type: 'separator'
        });
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        items.push({
            type: 'overflow-dropdown',
            id: 'media',
            testId: $255acfdd816952f8$export$893b800ba7bfda6d,
            options: [
                ...customOptions,
                ...showReplaceOption ? [
                    {
                        title: intl.formatMessage((0, $2BvhC.toolbarMessages).replaceMedia),
                        onClick: ()=>{
                            mediaPluginState.showMediaPickerForReplace();
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
                            label: ""
                        }),
                        testId: 'media-replace-toolbar-button'
                    }
                ] : [],
                {
                    title: intl?.formatMessage((0, $2xhuI.default).copyToClipboard),
                    onClick: ()=>{
                        pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                        pluginInjectionApi?.floatingToolbar?.commands.copyNode(nodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
                },
                {
                    title: intl?.formatMessage((0, $2xhuI.default).delete),
                    onClick: parentMediaGroupNode?.node.type === mediaGroup ? $255acfdd816952f8$var$handleRemoveMediaGroupWithAnalytics(pluginInjectionApi?.analytics?.actions) : $255acfdd816952f8$var$removeWithAnalytics(pluginInjectionApi?.analytics?.actions, selectedNodeType),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    var assistiveMessage = '';
    const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
    if (selectedMediaSingleNode) {
        const selectedMediaNodeView = selectedMediaSingleNode?.node.content;
        if (selectedMediaNodeView) {
            const selectedMediaNode = selectedMediaNodeView.firstChild;
            const selectedNodeTypeSingle = selectedMediaNode?.attrs.__fileMimeType;
            const selectedMediaAlt = selectedMediaNode?.attrs.alt;
            assistiveMessage = intl?.formatMessage($255acfdd816952f8$var$getMediaTypeMessage(selectedNodeTypeSingle), {
                name: selectedMediaAlt
            });
        }
    }
    const toolbarConfig = {
        ...baseToolbar,
        items: items,
        scrollable: true,
        mediaAssistiveMessage: assistiveMessage
    };
    if (allowResizing && allowPixelResizing) return {
        ...toolbarConfig,
        width: mediaPluginState.isResizing ? undefined : (0, $2ETaj.getMaxToolbarWidth)()
    };
    return toolbarConfig;
};














const $0a76b42c126ae725$export$1e0626fa34762ce3 = (0, $kSwu1.defineMessages)({
    toolbarMediaTitle: {
        id: "fabric.editor.toolbarMediaTitle",
        defaultMessage: "Add image, video, or file"
    }
});



var $aiL0G = parcelRequire("aiL0G");




var $gxI48 = parcelRequire("gxI48");

const $3758eb561e33fde8$var$onClickMediaButton = (showMediaPicker)=>()=>{
        showMediaPicker();
        return true;
    };
const $3758eb561e33fde8$var$selector = (states)=>{
    return {
        allowsUploads: states.mediaState?.allowsUploads,
        showMediaPicker: states.mediaState?.showMediaPicker
    };
};
const $3758eb561e33fde8$var$ToolbarMedia = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: intl, api: api })=>{
    const { allowsUploads: allowsUploads, showMediaPicker: showMediaPicker } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $3758eb561e33fde8$var$selector);
    if (!allowsUploads || !showMediaPicker) return null;
    const { toolbarMediaTitle: toolbarMediaTitle } = (0, $0a76b42c126ae725$export$1e0626fa34762ce3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).MEDIA,
        onClick: $3758eb561e33fde8$var$onClickMediaButton(showMediaPicker),
        disabled: isDisabled,
        title: intl.formatMessage(toolbarMediaTitle),
        spacing: isReducedSpacing ? 'none' : 'default',
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
            label: intl.formatMessage(toolbarMediaTitle)
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $3758eb561e33fde8$var$_default_1 = (0, $kSwu1.injectIntl)($3758eb561e33fde8$var$ToolbarMedia);
var $3758eb561e33fde8$export$2e2bcd8739ae039 = $3758eb561e33fde8$var$_default_1;


const $2a3ae420c48a4de9$var$selector = (states)=>{
    return {
        onPopupToggle: states.mediaState?.onPopupToggle,
        setBrowseFn: states.mediaState?.setBrowseFn
    };
};
const $2a3ae420c48a4de9$var$MediaPickerFunctionalComponent = ({ api: api, editorDomElement: editorDomElement, appearance: appearance })=>{
    const { onPopupToggle: onPopupToggle, setBrowseFn: setBrowseFn } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $2a3ae420c48a4de9$var$selector);
    if (!onPopupToggle || !setBrowseFn) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd2a2620618dfd4a$export$b8a89db960d45391), {
        onPopupToggle: onPopupToggle,
        setBrowseFn: setBrowseFn,
        editorDomElement: editorDomElement,
        appearance: appearance,
        api: api
    });
};
const $2a3ae420c48a4de9$var$mediaViewerStateSelector = (states)=>{
    return {
        isMediaViewerVisible: states.mediaState?.isMediaViewerVisible,
        mediaViewerSelectedMedia: states.mediaState?.mediaViewerSelectedMedia,
        mediaClientConfig: states.mediaState?.mediaClientConfig
    };
};
const $2a3ae420c48a4de9$var$MediaViewerFunctionalComponent = ({ api: api, editorView: editorView, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    // Only traverse document once when media viewer is visible, media viewer items will not update
    // when document changes are made while media viewer is open
    const { isMediaViewerVisible: isMediaViewerVisible, mediaViewerSelectedMedia: mediaViewerSelectedMedia, mediaClientConfig: mediaClientConfig } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $2a3ae420c48a4de9$var$mediaViewerStateSelector);
    const mediaItems = (0, $cozmU.useMemo)(()=>{
        if (isMediaViewerVisible) {
            const mediaNodes = (0, $geUVX.extractMediaNodes)(editorView.state.doc);
            return (0, $geUVX.createMediaIdentifierArray)(mediaNodes);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only update mediaItems once when media viewer is visible
    }, [
        isMediaViewerVisible
    ]);
    // Viewer does not have required attributes to render the media viewer
    if (!isMediaViewerVisible || !mediaViewerSelectedMedia || !mediaClientConfig) return null;
    const handleOnClose = ()=>{
        // Run Command to hide the media viewer
        api?.core.actions.execute(api?.media.commands.hideMediaViewer);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j5Sek.RenderMediaViewer), {
        mediaClientConfig: mediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: mediaViewerSelectedMedia,
        items: mediaItems,
        extensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    });
};
const $2a3ae420c48a4de9$export$a4dd0667e1feabbd = ({ config: options = {}, api: api })=>{
    let previousMediaProvider;
    const mediaErrorLocalIds = new Set();
    return {
        name: 'media',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $2mgqy.stateKey).getState(editorState) || null;
        },
        actions: {
            handleMediaNodeRenderError: (node, reason, nestedUnder)=>{
                let isDuplicateError = false;
                if ((0, $ieeJu.expValEquals)('platform_editor_media_reliability_observability', 'isEnabled', true)) {
                    if (mediaErrorLocalIds.has(node.attrs.localId)) // we mark duplicate errors in the case of nested media nodes
                    // renderering to avoid firing multiple errored events for the same underlying issue,
                    // which can happen more often with nested media nodes
                    isDuplicateError = true;
                    else mediaErrorLocalIds.add(node.attrs.localId);
                }
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).ERRORED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        reason: reason,
                        external: node.attrs.__external,
                        ...nestedUnder && (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? {
                            nestedUnder: nestedUnder
                        } : {},
                        ...(0, $fqVYq.editorExperiment)('platform_synced_block', true) ? {
                            isDuplicateError: isDuplicateError
                        } : {}
                    }
                });
            },
            insertMediaAsMediaSingle: (view, node, inputMethod, insertMediaVia)=>(0, $d55P7.insertMediaAsMediaSingle)(view, node, inputMethod, api?.analytics?.actions, insertMediaVia, options?.allowPixelResizing),
            setProvider: (provider)=>{
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $2mgqy.stateKey), {
                        mediaProvider: provider
                    })) ?? false;
            }
        },
        commands: {
            showMediaViewer: $596922be77b060f5$export$9f7495958f6fc412,
            hideMediaViewer: $596922be77b060f5$export$4e934779424102f3,
            trackMediaPaste: $596922be77b060f5$export$3d560bf5e623346d,
            setAIGenerating: $596922be77b060f5$export$b4a04e6655f9ee09,
            clearAIGenerating: $596922be77b060f5$export$573182394cb8259c,
            insertMediaSingle: (0, $596922be77b060f5$export$483fbd616c5570ae)(api?.analytics?.actions, options.allowPixelResizing)
        },
        nodes () {
            const { allowMediaGroup: allowMediaGroup = true, allowMediaSingle: allowMediaSingle = false, allowPixelResizing: allowPixelResizing = false, allowCaptions: allowCaptions, allowMediaInlineImages: allowMediaInlineImages, featureFlags: mediaFeatureFlags } = options || {};
            const allowMediaInline = (0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag') ? allowMediaInlineImages : (0, $c2smn.getMediaFeatureFlag)('mediaInline', mediaFeatureFlags);
            const mediaSingleOption = {
                withCaption: allowCaptions,
                withExtendedWidthTypes: allowPixelResizing
            };
            return [
                {
                    name: 'mediaGroup',
                    node: (0, $2f91ab31b5f56f89$export$927453cb1fcf720e)()
                },
                {
                    name: 'mediaSingle',
                    node: (0, $15153c82cbcfc2b5$export$7540e2ccc4187dcf)(mediaSingleOption)
                },
                {
                    name: 'media',
                    node: (0, $c84764e57e50c687$export$9f8a4f04eb482f68)()
                },
                {
                    name: 'mediaInline',
                    node: (0, $cab0e5f2f63f8407$export$e71594f26ef09ec1)()
                }
            ].filter((node)=>{
                if (node.name === 'mediaGroup') return allowMediaGroup;
                if (node.name === 'mediaSingle') return allowMediaSingle;
                if (node.name === 'mediaInline') return allowMediaInline;
                return true;
            });
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'media',
                    plugin: ({ schema: schema, dispatch: dispatch, getIntl: getIntl, eventDispatcher: eventDispatcher, providerFactory: providerFactory, errorReporter: errorReporter, portalProviderAPI: portalProviderAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $9k4mh.createPlugin)(schema, {
                            providerFactory: providerFactory,
                            nodeViews: {
                                mediaGroup: (0, $0a5322ec23ab9ad7$export$a1a01149851636f0)(portalProviderAPI, eventDispatcher, providerFactory, options, api, getIntl()),
                                mediaSingle: (0, $dc3343e483b8f408$export$fd09b1a92f5ce9f7)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options, getIntl()),
                                media: (0, $deae7fa047e4af09$export$a8df8d02db5c2be0)(portalProviderAPI, eventDispatcher, providerFactory, options, api, getIntl()),
                                mediaInline: (0, $4a9be827e310c90b$export$c4ddfa4daf804695)(portalProviderAPI, eventDispatcher, providerFactory, api, undefined, options?.fallbackMediaNameFetcher, getIntl())
                            },
                            errorReporter: errorReporter,
                            uploadErrorHandler: options && options.uploadErrorHandler,
                            waitForMediaUpload: options && options.waitForMediaUpload,
                            customDropzoneContainer: options && options.customDropzoneContainer,
                            customMediaPicker: options && options.customMediaPicker,
                            allowResizing: !!(options && options.allowResizing),
                            fallbackMediaNameFetcher: options && options.fallbackMediaNameFetcher
                        }, getIntl, api, nodeViewPortalProviderAPI, dispatch, options);
                    }
                },
                {
                    name: 'mediaKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $558d9096a667e962$export$2e2bcd8739ae039)(options, api?.analytics?.actions, api?.selection?.actions, api?.width, getIntl)
                }
            ];
            if (options && options.allowMediaSingle) pmPlugins.push({
                name: 'mediaSingleKeymap',
                plugin: ({ schema: schema })=>(0, $d72bc7f44fb21c4f$export$2e2bcd8739ae039)(schema)
            });
            if (options && options.allowAltTextOnImages) {
                pmPlugins.push({
                    name: 'mediaAltText',
                    plugin: (0, $cf420da73fb250ce$export$ae829ec7b2625219)
                });
                pmPlugins.push({
                    name: 'mediaAltTextKeymap',
                    plugin: ({ schema: schema })=>(0, $18fbf82b74023294$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                });
            }
            if (options && options.allowLinking) {
                pmPlugins.push({
                    name: 'mediaLinking',
                    plugin: ({ dispatch: dispatch })=>(0, $0f87f7842b3d8002$export$2e2bcd8739ae039)(dispatch)
                });
                pmPlugins.push({
                    name: 'mediaLinkingKeymap',
                    plugin: ({ schema: schema })=>(0, $3c5aeafd362db864$export$2e2bcd8739ae039)(schema)
                });
            }
            if (options && options.allowAdvancedToolBarOptions && options.allowResizing && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) && options.allowPixelResizing) pmPlugins.push({
                name: 'mediaPixelResizing',
                plugin: (0, $b65a57bd9857f1c9$export$ae829ec7b2625219)
            });
            pmPlugins.push({
                name: 'mediaAIGeneratingDecoration',
                plugin: ()=>(0, $1a7aa8d16b1384d6$export$4872b17b77321d10)()
            });
            pmPlugins.push({
                name: 'mediaSelectionHandler',
                plugin: ()=>{
                    const mediaSelectionHandlerPlugin = new (0, $kpCD8.SafePlugin)({
                        key: new (0, $kCECX.PluginKey)('mediaSelectionHandlerPlugin'),
                        props: {
                            handleScrollToSelection: (view)=>{
                                const { state: { selection: selection } } = view;
                                if (!(selection instanceof (0, $kCECX.NodeSelection)) || selection.node.type.name !== 'media') return false;
                                const { node: node, offset: offset } = view.domAtPos(selection.from);
                                if (// Is the media element mounted already?
                                offset === node.childNodes.length) // Media is not ready, so stop the scroll request
                                return true;
                                // Media is ready, keep the scrolling request
                                return false;
                            }
                        }
                    });
                    return mediaSelectionHandlerPlugin;
                }
            });
            return pmPlugins;
        },
        contentComponent ({ editorView: editorView, appearance: appearance }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3ae420c48a4de9$var$MediaViewerFunctionalComponent, {
                api: api,
                editorView: editorView,
                mediaViewerExtensions: options?.mediaViewerExtensions,
                fallbackMediaNameFetcher: options?.fallbackMediaNameFetcher
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3ae420c48a4de9$var$MediaPickerFunctionalComponent, {
                editorDomElement: editorView.dom,
                appearance: appearance,
                api: api
            }));
        },
        secondaryToolbarComponent ({ disabled: disabled }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3758eb561e33fde8$export$2e2bcd8739ae039), {
                isDisabled: disabled,
                isReducedSpacing: true,
                api: api
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>!api?.mediaInsert ? [
                    {
                        id: 'media',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconImages), null),
                        isDisabledOffline: true,
                        action (insert, state) {
                            const pluginState = (0, $2mgqy.stateKey).getState(state);
                            pluginState?.showMediaPicker();
                            const tr = insert('');
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).OPENED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_CLOUD,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ] : [],
            floatingToolbar: (state, intl, providerFactory)=>(0, $255acfdd816952f8$export$4850df084251d287)(state, intl, {
                    providerFactory: providerFactory,
                    allowMediaInline: options && (0, $c2smn.getMediaFeatureFlag)('mediaInline', options.featureFlags),
                    allowResizing: options && options.allowResizing,
                    allowResizingInTables: options && options.allowResizingInTables,
                    allowCommentsOnMedia: options && options.allowCommentsOnMedia,
                    allowLinking: options && options.allowLinking,
                    allowAdvancedToolBarOptions: options && options.allowAdvancedToolBarOptions,
                    allowAltTextOnImages: options && options.allowAltTextOnImages,
                    allowImageEditing: !!api?.mediaEditing && options && options.allowImageEditing,
                    allowImagePreview: options && options.allowImagePreview,
                    altTextValidator: options && options.altTextValidator,
                    fullWidthEnabled: options && options.fullWidthEnabled,
                    allowMediaInlineImages: options && options.allowMediaInlineImages,
                    isViewOnly: api?.editorViewMode?.sharedState.currentState()?.mode === 'view',
                    allowPixelResizing: options?.allowPixelResizing,
                    onCommentButtonMount: options?.onCommentButtonMount,
                    createCommentExperience: options?.createCommentExperience
                }, api)
        }
    };
};
module.exports["mediaPlugin"] = $2a3ae420c48a4de9$export$a4dd0667e1feabbd;

});

parcelRegister("b7Tum", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");

function $aca05cfca1cadad7$export$6542fd0697d9003d({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
        value: intl
    }, children);
}
module.exports["MediaSSRReactContextsProvider"] = $aca05cfca1cadad7$export$6542fd0697d9003d;

});

parcelRegister("1wNII", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $iwjSV = parcelRequire("iwjSV");


var $1A89X = parcelRequire("1A89X");


var $krYZG = parcelRequire("krYZG");


var $4G6PK = parcelRequire("4G6PK");


var $kCECX = parcelRequire("kCECX");


var $6wYuL = parcelRequire("6wYuL");

var $gOi68 = parcelRequire("gOi68");


var $g9ZnD = parcelRequire("g9ZnD");


var $bGrTZ = parcelRequire("bGrTZ");


var $ixfCV = parcelRequire("ixfCV");


var $7TpAR = parcelRequire("7TpAR");


var $2mgqy = parcelRequire("2mgqy");


var $55fM8 = parcelRequire("55fM8");


var $1UWNP = parcelRequire("1UWNP");


var $hdvEd = parcelRequire("hdvEd");


var $jbOus = parcelRequire("jbOus");

const $f7171ea9179f4e0d$export$4dd32806a37c505b = (editorView, steps)=>{
    const { state: state, dispatch: dispatch } = editorView;
    const tr = state.tr;
    if (steps.length === 0) return false;
    tr.step(new (0, $hdvEd.BatchAttrsStep)(steps));
    if (tr.steps.length > 0 && tr.doc.eq(state.doc)) return false;
    (0, $jbOus.tintDirtyTransaction)(tr);
    dispatch(tr);
};


/**
 * 🧱 Internal: Editor FE Platform
 * Based on https://github.com/lodash/lodash/issues/2403#issuecomment-1706130395
 *
 * Creates a debounced function that delays invoking the provided function until after a specified
 * wait time has elapsed since the last time the debounced function was invoked. Additionally, the
 * debounced function is memoized so that the same function instance is used for each unique set
 * of arguments based on the resolver.
 *
 * This is particularly useful in scenarios where you want to debounce function calls while ensuring
 * that each unique input combination receives its own debounced function instance. It's a combination
 * of lodash's `debounce` and `memoize`.
 *
 * @template T
 * @param {T} func - The function to debounce.
 * @param {number} [wait=0] - The number of milliseconds to delay.
 * @param {object} [options] - The options object to pass to `debounce`.
 * @param {Function} [resolver] - The function to resolve the cache key for memoization.
 * @returns {Function} A new debounced and memoized function.
 *
 * @example
 * const debouncedFunction = memoizeDebounce(myFunction, 300, { leading: true }, myResolver);
 * debouncedFunction(arg1, arg2);
 */ function $15be3869eb7f080a$var$memoizeDebounce(func, wait = 0, options, resolver) {
    const mem = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(func, wait, options);
    }, resolver);
    return function(...args) {
        return mem(...args)(...args);
    };
}
const $15be3869eb7f080a$var$mediaAttributesCache = new WeakMap();
const $15be3869eb7f080a$var$debouncedTime = 500;
const $15be3869eb7f080a$export$e13de86a39dc2884 = (a, b)=>{
    // a contains b, and want to check if attributes in b are same in a
    return Object.entries(b).every(([bkey, bValue])=>{
        if (bkey in a) {
            const aValue = a[bkey];
            // Check if types match before comparing values
            return typeof aValue === typeof bValue && aValue === bValue;
        }
        return false;
    });
};
const $15be3869eb7f080a$export$36f3e00b05c9935d = (editorView, cache)=>{
    const toUpdateValues = cache.get(editorView) || {};
    // clear the media attributes cache per editor view
    cache.delete(editorView);
    const ids = Object.keys(toUpdateValues);
    const { state: state } = editorView;
    const mediaSteps = [];
    // search node positions by id
    state.doc.descendants((node, position)=>{
        if (![
            node.type.schema.nodes.media,
            node.type.schema.nodes.mediaInline
        ].includes(node.type)) return true;
        if (!ids.includes(node.attrs.id)) return false;
        const attrs = toUpdateValues[node.attrs.id];
        if ($15be3869eb7f080a$export$e13de86a39dc2884(node.attrs, attrs)) return false;
        mediaSteps.push({
            position: position,
            nodeType: node.type.name,
            attrs: attrs
        });
    });
    if (mediaSteps.length > 0) (0, $f7171ea9179f4e0d$export$4dd32806a37c505b)(editorView, mediaSteps);
};
const $15be3869eb7f080a$export$8ad1cb8a3a0ac36b = $15be3869eb7f080a$var$memoizeDebounce($15be3869eb7f080a$export$36f3e00b05c9935d, $15be3869eb7f080a$var$debouncedTime, /**
	 * Use the default debounce options:
	 * {leading: false, trailing: true}
	 */ undefined, (view)=>{
    /**
		 * EditorView is a singleton.
		 * There is only one instance per Editor.
		 */ return view;
});
const $15be3869eb7f080a$export$298f04086ed0efe2 = (editorView, props)=>{
    let cachePerView = $15be3869eb7f080a$var$mediaAttributesCache.get(editorView);
    if (!cachePerView) cachePerView = {
        records: {}
    };
    cachePerView[props.id] = {
        ...cachePerView[props.id] || {},
        ...props.nextAttributes
    };
    $15be3869eb7f080a$var$mediaAttributesCache.set(editorView, cachePerView);
    $15be3869eb7f080a$export$8ad1cb8a3a0ac36b(editorView, $15be3869eb7f080a$var$mediaAttributesCache);
};



var $geUVX = parcelRequire("geUVX");


var $7Y8M5 = parcelRequire("7Y8M5");

const $2d86ba6229e0fd27$var$MIN_MEDIA_DISPLAY_WIDTH = 24;
const $2d86ba6229e0fd27$export$e41d0c834cb917d8 = (targetDisplayHeight, newIntrinsicWidth, newIntrinsicHeight, layout, lineLength)=>{
    if (newIntrinsicHeight <= 0) return $2d86ba6229e0fd27$var$MIN_MEDIA_DISPLAY_WIDTH;
    const unclamped = targetDisplayHeight * (newIntrinsicWidth / newIntrinsicHeight);
    const maxWidth = layout === 'full-width' ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : layout === 'wide' ? (0, $7Y8M5.akEditorWideLayoutWidth) : lineLength;
    return Math.max($2d86ba6229e0fd27$var$MIN_MEDIA_DISPLAY_WIDTH, Math.min(unclamped, maxWidth));
};


const $fa4955302491851b$var$isMediaTypeSupported = (type)=>{
    if (type) return [
        'image',
        'file'
    ].includes(type);
    return false;
};
class $fa4955302491851b$export$e115d1293528d541 {
    setProps(newComponentProps) {
        this.props = {
            ...this.props,
            ...newComponentProps
        };
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return !!(attrs && attrs.type === 'external' && (0, $6wYuL.isMediaBlobUrl)(attrs.url));
    }
    async getRemoteDimensions() {
        const mediaProvider = await this.props.mediaProvider;
        const { mediaOptions: mediaOptions } = this.props;
        const attrs = this.getAttrs();
        if (!mediaProvider || !attrs) return false;
        const { height: height, width: width } = attrs;
        if (attrs.type === 'external' || !attrs.id) return false;
        const { id: id, collection: collection } = attrs;
        if (height && width) return false;
        // can't fetch remote dimensions on mobile, so we'll default them
        if (mediaOptions && !mediaOptions.allowRemoteDimensionsFetch) return {
            id: id,
            height: (0, $4G6PK.DEFAULT_IMAGE_HEIGHT),
            width: (0, $4G6PK.DEFAULT_IMAGE_WIDTH)
        };
        const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
        const mediaClient = (0, $g9ZnD.getMediaClient)(viewMediaClientConfig);
        const currentState = await mediaClient.file.getCurrentState(id, {
            collectionName: collection
        });
        if (!(0, $gOi68.isImageRepresentationReady)(currentState)) return false;
        const imageMetadata = await mediaClient.getImageMetadata(id, {
            collection: collection
        });
        if (!imageMetadata || !imageMetadata.original) return false;
        return {
            id: id,
            height: imageMetadata.original.height || (0, $4G6PK.DEFAULT_IMAGE_HEIGHT),
            width: imageMetadata.original.width || (0, $4G6PK.DEFAULT_IMAGE_WIDTH)
        };
    }
    async handleExternalMedia(getPos) {
        if (this.isMediaBlobUrl()) try {
            await this.copyNodeFromBlobUrl(getPos);
        } catch  {
            await this.uploadExternalMedia(getPos);
        }
        else await this.uploadExternalMedia(getPos);
    }
    constructor(props){
        this.props = void 0;
        this.mediaPluginState = void 0;
        // Updates the node with contextId if it doesn't have one already
        this.updateContextId = async ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return;
            const { id: id } = attrs;
            const objectId = await this.getObjectId();
            (0, $15be3869eb7f080a$export$298f04086ed0efe2)(this.props.view, {
                id: id,
                nextAttributes: {
                    __contextId: objectId
                }
            });
        };
        this.updateNodeContextId = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return;
            const objectId = await this.getObjectId();
            (0, $7TpAR.updateCurrentMediaNodeAttrs)({
                __contextId: objectId
            }, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.hasFileAttributesDefined = (attrs)=>{
            return attrs && attrs.type === 'file' && attrs.__fileName && attrs.__fileMimeType && attrs.__fileSize && attrs.__contextId;
        };
        this.getNewFileAttrsForNode = async ()=>{
            const attrs = this.getAttrs();
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams || !attrs || !$fa4955302491851b$var$isMediaTypeSupported(attrs.type) || this.hasFileAttributesDefined(attrs)) return;
            const mediaClientConfig = mediaProvider.viewMediaClientConfig;
            const mediaClient = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
            let fileState;
            const { id: id, collection: collectionName } = attrs;
            try {
                fileState = await mediaClient.file.getCurrentState(id, {
                    collectionName: collectionName
                });
                if (fileState.status === 'error') return;
            } catch  {
                return;
            }
            const contextId = this.getNodeContextId() || await this.getObjectId();
            const { name: name, mimeType: mimeType, size: size } = fileState;
            const newAttrs = {
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size,
                __contextId: contextId
            };
            if (!$fa4955302491851b$var$hasPrivateAttrsChanged(attrs, newAttrs)) return;
            return newAttrs;
        };
        this.updateMediaSingleFileAttrs = async ()=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            const { id: id } = this.getAttrs();
            if (id && newAttrs) (0, $15be3869eb7f080a$export$298f04086ed0efe2)(this.props.view, {
                id: id,
                nextAttributes: newAttrs
            });
        };
        this.updateNodeAttrs = async (getPos)=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            if (newAttrs) (0, $7TpAR.updateCurrentMediaNodeAttrs)(newAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.getAttrs = ()=>{
            const { attrs: attrs } = this.props.node;
            if (attrs) return attrs;
            return undefined;
        };
        this.getObjectId = async ()=>{
            const contextIdentifierProvider = await this.props.contextIdentifierProvider;
            return contextIdentifierProvider?.objectId || null;
        };
        this.uploadExternalMedia = async (getPos)=>{
            const { node: node, mediaOptions: mediaOptions } = this.props;
            if (mediaOptions?.isExternalMediaUploadDisabled) return;
            const mediaProvider = await this.props.mediaProvider;
            if (node && mediaProvider) {
                const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
                if (!uploadMediaClientConfig || !node.attrs.url) return;
                const mediaClient = (0, $g9ZnD.getMediaClient)(uploadMediaClientConfig);
                const collection = mediaProvider.uploadParams && mediaProvider.uploadParams.collection;
                try {
                    const uploader = await mediaClient.file.uploadExternal(node.attrs.url, collection);
                    const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions } = uploader;
                    const pos = getPos();
                    if (typeof pos !== 'number') return;
                    (0, $7TpAR.replaceExternalMedia)(pos + 1, {
                        id: uploadableFileUpfrontIds.id,
                        collection: collection,
                        height: dimensions.height,
                        width: dimensions.width,
                        occurrenceKey: uploadableFileUpfrontIds.occurrenceKey
                    })(this.props.view.state, this.props.view.dispatch);
                } catch  {
                    //keep it as external media
                    if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                        action: (0, $krYZG.ACTION).UPLOAD_EXTERNAL_FAIL,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        };
        this.getNodeContextId = ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return null;
            return attrs.__contextId || null;
        };
        this.updateDimensions = (dimensions)=>{
            const { view: view } = this.props;
            const mediaPluginState = (0, $2mgqy.stateKey).getState(view.state);
            const targetDisplayHeight = mediaPluginState?.replaceMediaTargetDisplayHeight;
            if (targetDisplayHeight !== null && targetDisplayHeight !== undefined && dimensions.width > 0) {
                // Replace mode: combine intrinsic dimension update on the media node AND
                // display width update on the mediaSingle into a single transaction so they
                // are never out of sync and don't cause two separate renders/layout shifts.
                // Clear the stored target height — this is a one-shot adjustment
                if (mediaPluginState) mediaPluginState.replaceMediaTargetDisplayHeight = null;
                // Clamp to the layout's maximum width so the image never overflows its container.
                const lineLength = this.props.lineLength ?? 760;
                const { state: state } = view;
                const { mediaSingle: mediaSingle } = state.schema.nodes;
                // Typed explicitly because TypeScript can't track mutations inside
                // the descendants callback closure and would narrow these to `never`.
                let mediaSinglePos = null;
                let mediaSingleNode = null;
                let mediaPos = null;
                state.doc.descendants((node, pos)=>{
                    if (mediaSinglePos !== null) return false;
                    if (node.type === mediaSingle) {
                        const mediaChild = node.firstChild;
                        if (mediaChild && mediaChild.attrs.id === dimensions.id) {
                            mediaSinglePos = pos;
                            mediaSingleNode = node;
                            mediaPos = pos + 1;
                        }
                    }
                    return true;
                });
                const layout = mediaSingleNode?.attrs?.layout ?? 'center';
                const newDisplayWidth = (0, $2d86ba6229e0fd27$export$e41d0c834cb917d8)(targetDisplayHeight, dimensions.width, dimensions.height, layout, lineLength);
                if (mediaSinglePos !== null && mediaSingleNode !== null && mediaPos !== null) {
                    const tr = state.tr;
                    // Update intrinsic dimensions on the media child node
                    tr.step(new (0, $1A89X.SetAttrsStep)(mediaPos, {
                        height: dimensions.height,
                        width: dimensions.width
                    }));
                    // Update display width on the mediaSingle parent
                    tr.setNodeMarkup(mediaSinglePos, undefined, {
                        ...mediaSingleNode.attrs,
                        width: Math.round(newDisplayWidth),
                        widthType: 'pixel'
                    });
                    // Re-create the NodeSelection so the floating toolbar picks up
                    // the updated node and renders the full set of controls.
                    if (state.selection instanceof (0, $kCECX.NodeSelection)) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, mediaSinglePos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                    return;
                }
            }
            // Normal (non-replace) path: use the existing batched update mechanism
            (0, $15be3869eb7f080a$export$298f04086ed0efe2)(view, {
                id: dimensions.id,
                nextAttributes: {
                    height: dimensions.height,
                    width: dimensions.width
                }
            });
        };
        this.shouldNodeBeDeepCopied = async ()=>{
            const scope = this.props.mediaOptions?.mediaShallowCopyScope ?? this.mediaPluginState?.mediaOptions?.mediaShallowCopyScope ?? 'context';
            if (scope === 'context') return await this.hasDifferentContextId();
            else {
                const attrs = this.getAttrs();
                if (!attrs || !this.mediaPluginState) return false;
                const id = (0, $geUVX.getIdentifier)(attrs);
                const isIdentifierOutsideEditorScope = !this.mediaPluginState.isIdentifierInEditorScope(id);
                return isIdentifierOutsideEditorScope;
            }
        };
        this.hasDifferentContextId = async ()=>{
            const nodeContextId = this.getNodeContextId();
            const currentContextId = await this.getObjectId();
            if (nodeContextId && currentContextId && nodeContextId !== currentContextId) return true;
            return false;
        };
        this.isNodeFromDifferentCollection = async ()=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return false;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return false;
            const { collection: nodeCollection, __contextId: __contextId } = attrs;
            const contextId = __contextId || await this.getObjectId();
            if (contextId && currentCollectionName !== nodeCollection) return true;
            return false;
        };
        this.handleCopyFileSwitcher = async (attrs)=>{
            const { mediaClient: mediaClient, source: source, destination: destination, traceContext: traceContext } = attrs;
            try {
                // calling copyWithToken by passing the auth providers
                const { id: id } = await mediaClient.file.copyFile(source, destination, undefined, traceContext);
                return id;
            } catch (err) {
                if ((0, $ixfCV.fg)('platform_media_cross_client_copy')) {
                    // calling /v2/file/copy by removing the auth tokens to make cross product copy and pastes
                    const { authProvider: _sourceAP, ...copyV2Source } = source;
                    const { authProvider: _destAP, ...copyV2Destination } = destination;
                    const { id: id } = await mediaClient.file.copyFile(copyV2Source, copyV2Destination, undefined, traceContext);
                    return id;
                } else throw err;
            }
        };
        this.copyNodeFromBlobUrl = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs.type !== 'external') return;
            const { url: url } = attrs;
            const mediaAttrs = (0, $6wYuL.getAttrsFromUrl)(url);
            if (!mediaAttrs) return;
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const { contextId: contextId, clientId: clientId, id: id, collection: collection, height: height, width: width, mimeType: mimeType, name: name, size: size } = mediaAttrs;
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig || !uploadMediaClientConfig.getAuthFromContext) return;
            const mediaClient = (0, $g9ZnD.getMediaClient)(uploadMediaClientConfig);
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(contextId),
                    clientId: (0, $ixfCV.fg)('platform_media_cross_client_copy_with_auth') ? clientId : undefined
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()
                }
            });
            const pos = getPos();
            if (typeof pos !== 'number') return;
            (0, $7TpAR.replaceExternalMedia)(pos + 1, {
                id: mediaFileId,
                collection: currentCollectionName,
                height: height,
                width: width,
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection using a getPos handler
        this.copyNodeFromPos = async (getPos, traceContext)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $7TpAR.updateCurrentMediaNodeAttrs)(copiedAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection
        this.copyNode = async (traceContext)=>{
            const attrs = this.getAttrs();
            const { view: view } = this.props;
            if (!attrs || attrs && !$fa4955302491851b$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $7TpAR.updateMediaNodeAttrs)(attrs.id, copiedAttrs)(view.state, view.dispatch);
        };
        this.copyFile = async (id, collection, traceContext)=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider?.uploadParams) return;
            const nodeContextId = this.getNodeContextId();
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig?.getAuthFromContext || !nodeContextId) return;
            const mediaClient = (0, $g9ZnD.getMediaClient)(uploadMediaClientConfig);
            const clientId = (0, $ixfCV.fg)('platform_media_cross_client_copy_with_auth') ? (0, $bGrTZ.getClientIdForFile)(id) : undefined;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const objectId = await this.getObjectId();
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(nodeContextId),
                    clientId: clientId
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()
                },
                traceContext: traceContext
            });
            return {
                id: mediaFileId,
                collection: currentCollectionName,
                __contextId: objectId
            };
        };
        this.props = props;
        this.mediaPluginState = (0, $2mgqy.stateKey).getState(props.view.state);
    }
}
const $fa4955302491851b$var$hasPrivateAttrsChanged = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};
const $fa4955302491851b$export$5acae1477d0bf3d = (props)=>{
    const updaterProps = {
        ...props
    };
    return new $fa4955302491851b$export$e115d1293528d541(updaterProps);
};
module.exports["MediaNodeUpdater"] = $fa4955302491851b$export$e115d1293528d541;
module.exports["createMediaNodeUpdater"] = $fa4955302491851b$export$5acae1477d0bf3d;

});

parcelRegister("2ETaj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $4G6PK = parcelRequire("4G6PK");


var $2BvhC = parcelRequire("2BvhC");


var $8qft0 = parcelRequire("8qft0");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $bVwWU = parcelRequire("bVwWU");


var $kTw4V = parcelRequire("kTw4V");


var $g9ZnD = parcelRequire("g9ZnD");


var $fA65V = parcelRequire("fA65V");


var $ieeJu = parcelRequire("ieeJu");


var $d55P7 = parcelRequire("d55P7");


var $7mc9A = parcelRequire("7mc9A");

const $6c4bd01af5568a18$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};
const $6c4bd01af5568a18$var$getSelectedMediaContainerNodeAttrs = (mediaPluginState)=>{
    const selectedNode = mediaPluginState.selectedMediaContainerNode?.();
    if (selectedNode && selectedNode.attrs) return selectedNode.attrs;
    return null;
};
const $6c4bd01af5568a18$export$a5d2856f3da2ba87 = (selectedMediaContainerNode)=>{
    const selectedNode = selectedMediaContainerNode?.();
    if (selectedNode) switch(selectedNode.type.name){
        case 'mediaSingle':
            {
                const childNode = selectedNode.firstChild;
                return childNode?.attrs;
            }
        default:
            return selectedNode.attrs;
    }
    return null;
};
const $6c4bd01af5568a18$export$33674170711ec257 = (mediaPluginState)=>{
    return $6c4bd01af5568a18$export$a5d2856f3da2ba87(mediaPluginState.selectedMediaContainerNode);
};
const $6c4bd01af5568a18$export$de36002be6360c60 = (mediaPluginState)=>{
    const enforceMediaDataSecurityPolicy = mediaPluginState?.mediaClientConfig?.enforceDataSecurityPolicy;
    return typeof enforceMediaDataSecurityPolicy === 'boolean' ? enforceMediaDataSecurityPolicy : false;
};
const $6c4bd01af5568a18$export$e8f97a24a74eb5e0 = async (mediaPluginState, isViewMode)=>{
    try {
        const selectedNodeAttrs = isViewMode ? $6c4bd01af5568a18$export$33674170711ec257(mediaPluginState) : $6c4bd01af5568a18$var$getSelectedMediaContainerNodeAttrs(mediaPluginState);
        if (selectedNodeAttrs && mediaPluginState.mediaClientConfig && !$6c4bd01af5568a18$export$c8d0f9dbb5a183eb(selectedNodeAttrs)) {
            const { id: id, collection: collection = '' } = selectedNodeAttrs;
            const mediaClient = (0, $g9ZnD.getMediaClient)(mediaPluginState.mediaClientConfig);
            const fileState = await mediaClient.file.getCurrentState(id, {
                collectionName: collection
            });
            let fileName = fileState.status === 'error' ? undefined : fileState.name;
            if (!fileName && (0, $ieeJu.expValEquals)('platform_editor_media_download_fallback_name', 'isEnabled', true) && mediaPluginState.mediaOptions?.fallbackMediaNameFetcher) {
                const fetched = await mediaPluginState.mediaOptions.fallbackMediaNameFetcher(id).catch(()=>undefined);
                fileName = fetched ?? undefined;
            }
            mediaClient.file.downloadBinary(id, fileName, collection);
        }
        return true;
    } catch (err) {
        return false;
    }
};
const $6c4bd01af5568a18$export$83833694bbefe84a = (state)=>{
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const mediaGroupParent = (0, $bjg0G.findParentNodeOfType)(mediaGroup)(state.selection);
    let tr = state.tr;
    // If it is the last media group in filmstrip, remove the entire filmstrip
    if (mediaGroupParent && mediaGroupParent.node.childCount === 1) tr = (0, $bjg0G.removeParentNodeOfType)(mediaGroup)(tr);
    else tr = (0, $bjg0G.removeSelectedNode)(tr);
    return tr;
};
const $6c4bd01af5568a18$export$3b6a8a992fa2a6d6 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return (0, $bjg0G.findSelectedNodeOfType)(mediaSingle)(state.selection) || (0, $bjg0G.findParentNodeOfType)(mediaSingle)(state.selection);
};
const $6c4bd01af5568a18$export$5b609aa7c383235 = (0, $dOBRD.default)((editorView, pos, mediaWidth)=>{
    const domNode = editorView.nodeDOM(pos);
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return mediaWidth;
});
const $6c4bd01af5568a18$export$62003b26b3b70d62 = (width, layout, contentWidth, fullWidthMode = false, isNested = false)=>{
    const isWrappedLayout = (0, $4G6PK.wrappedLayouts).indexOf(layout) > -1;
    //See flowchart for layout logic: https://hello.atlassian.net/wiki/spaces/TWPCP/whiteboard/2969594044
    if (width >= (0, $7Y8M5.akEditorFullWidthLayoutWidth)) // If width is greater than or equal to full editor width
    return 'full-width';
    if (fullWidthMode) // If under editor full width mode
    return isWrappedLayout ? layout : 'center';
    if (width > contentWidth && !isNested) // If width is greater than content length and not nested
    return 'wide';
    return isNested || isWrappedLayout && width !== contentWidth ? layout : 'center';
};
let $6c4bd01af5568a18$var$maxToolbarFitWidth = 0;
const $6c4bd01af5568a18$export$6bd6107b1c4a8338 = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="Media floating controls"]`);
    const toolbarWidth = toolbar?.getBoundingClientRect().width;
    if (!toolbar) $6c4bd01af5568a18$var$maxToolbarFitWidth = 0;
    if (toolbarWidth && toolbarWidth > $6c4bd01af5568a18$var$maxToolbarFitWidth) $6c4bd01af5568a18$var$maxToolbarFitWidth = toolbarWidth;
    return $6c4bd01af5568a18$var$maxToolbarFitWidth;
};
const $6c4bd01af5568a18$export$247dbed7311e99c7 = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $8qft0.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $6c4bd01af5568a18$export$e9cd793e76f25514 = (mediaSingleNode)=>{
    if (mediaSingleNode) {
        const mediaNode = mediaSingleNode.content.firstChild;
        return mediaNode && !(0, $d55P7.isVideo)(mediaNode.attrs.__fileMimeType);
    }
    return false;
};
const $6c4bd01af5568a18$export$e13ccac5f0484027 = (items)=>{
    const lastItem = items.at(-1);
    if (lastItem?.type === 'separator') lastItem.fullHeight = true;
    else if (items.length) items.push({
        type: 'separator',
        fullHeight: true
    });
};
const $6c4bd01af5568a18$export$cf30b16cfb070b4a = (nodeType, intl, pluginInjectionApi, hasCaption = false)=>{
    const mediaInlineImageTitle = intl.formatMessage((0, $2BvhC.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $2BvhC.toolbarMessages).changeToMediaSingle);
    const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $2BvhC.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $2BvhC.toolbarMessages).changeToMediaInlineImage);
    const InlineIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVwWU))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const BlockIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTw4V))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const dropdownConfig = {
        inline: {
            handleInlineButtonClick: ()=>{
                return true;
            },
            handleBlockButtonClick: (0, $7mc9A.changeMediaInlineToMediaSingle)(pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.width.sharedState.currentState()),
            id: 'media-inline-to-block-toolbar-item',
            icon: InlineIcon
        },
        block: {
            handleInlineButtonClick: (0, $7mc9A.changeMediaSingleToMediaInline)(pluginInjectionApi?.analytics?.actions),
            handleBlockButtonClick: ()=>{
                return true;
            },
            id: 'media-block-to-inline-toolbar-item',
            icon: BlockIcon
        }
    };
    const options = [
        {
            id: 'editor.media.convert.mediainline',
            title: mediaInlineImageTitle,
            onClick: dropdownConfig[nodeType].handleInlineButtonClick,
            selected: nodeType === 'inline',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InlineIcon, null),
            tooltip: hasCaption ? inlineSwitcherTitle : undefined
        },
        {
            id: 'editor.media.convert.mediasingle',
            title: mediaSingleTitle,
            onClick: dropdownConfig[nodeType].handleBlockButtonClick,
            selected: nodeType === 'block',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlockIcon, null)
        }
    ];
    return {
        id: dropdownConfig[nodeType].id,
        testId: 'media-inline-to-block-dropdown',
        title: intl.formatMessage((0, $fA65V.messages).sizeOptions),
        type: 'dropdown',
        options: options,
        icon: dropdownConfig[nodeType].icon
    };
};
module.exports["isExternalMedia"] = $6c4bd01af5568a18$export$c8d0f9dbb5a183eb;
module.exports["getSelectedNearestMediaContainerNodeAttrsFunction"] = $6c4bd01af5568a18$export$a5d2856f3da2ba87;
module.exports["getSelectedNearestMediaContainerNodeAttrs"] = $6c4bd01af5568a18$export$33674170711ec257;
module.exports["getIsDownloadDisabledByDataSecurityPolicy"] = $6c4bd01af5568a18$export$de36002be6360c60;
module.exports["downloadMedia"] = $6c4bd01af5568a18$export$e8f97a24a74eb5e0;
module.exports["removeMediaGroupNode"] = $6c4bd01af5568a18$export$83833694bbefe84a;
module.exports["getSelectedMediaSingle"] = $6c4bd01af5568a18$export$3b6a8a992fa2a6d6;
module.exports["getPixelWidthOfElement"] = $6c4bd01af5568a18$export$5b609aa7c383235;
module.exports["calcNewLayout"] = $6c4bd01af5568a18$export$62003b26b3b70d62;
module.exports["getMaxToolbarWidth"] = $6c4bd01af5568a18$export$6bd6107b1c4a8338;
module.exports["getSelectedLayoutIcon"] = $6c4bd01af5568a18$export$247dbed7311e99c7;
module.exports["canShowSwitchButtons"] = $6c4bd01af5568a18$export$e9cd793e76f25514;
module.exports["updateToFullHeightSeparator"] = $6c4bd01af5568a18$export$e13ccac5f0484027;
module.exports["getMediaSingleAndMediaInlineSwitcherDropdown"] = $6c4bd01af5568a18$export$cf30b16cfb070b4a;

});

parcelRegister("8f29X", function(module, exports) {
const $4ccccea36326664d$export$fb85bc5d6d9ef19b = (type)=>{
    return !!type && (type.indexOf('image/') > -1 || type.indexOf('video/') > -1 || type === 'image');
};
const $4ccccea36326664d$export$ac5608bbe92d6fdc = (fileType)=>{
    return !!fileType && fileType.includes('video/');
};
module.exports["isImage"] = $4ccccea36326664d$export$fb85bc5d6d9ef19b;
module.exports["isVideo"] = $4ccccea36326664d$export$ac5608bbe92d6fdc;

});

parcelRegister("h9F7A", function(module, exports) {

let $c7d32ccdb1202e26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c7d32ccdb1202e26$var$load("fV46K"),
    $c7d32ccdb1202e26$var$load("6OMo6"),
    $c7d32ccdb1202e26$var$load("aaRXj"),
    $c7d32ccdb1202e26$var$load("fHlIz"),
    $c7d32ccdb1202e26$var$load("4QwAJ"),
    $c7d32ccdb1202e26$var$load("3i44s"),
    $c7d32ccdb1202e26$var$load("5kI0b"),
    $c7d32ccdb1202e26$var$load("kYkz1"),
    $c7d32ccdb1202e26$var$load("jfYeU"),
    $c7d32ccdb1202e26$var$load("b4nm1"),
    $c7d32ccdb1202e26$var$load("geXPZ"),
    $c7d32ccdb1202e26$var$load("aQ5uu"),
    $c7d32ccdb1202e26$var$load("5K1Mf"),
    $c7d32ccdb1202e26$var$load("lVz4k"),
    $c7d32ccdb1202e26$var$load("jOE2W"),
    $c7d32ccdb1202e26$var$load("jTOhL"),
    $c7d32ccdb1202e26$var$load("gERRA")
]).then(()=>parcelRequire('bTvo5'));

});

parcelRegister("adoix", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $95Vjg = parcelRequire("95Vjg");

var $9jn2Q = parcelRequire("9jn2Q");

const $81c3bc6e8cdda1ad$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = mediaNode?.attrs || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $9jn2Q.roundToNearest)(pixelWidth),
        height: (0, $9jn2Q.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};
module.exports["getMediaSingleDimensions"] = $81c3bc6e8cdda1ad$export$c7bf42817f6e4244;

});

parcelRegister("82NHW", function(module, exports) {
const $c2899ffa94a5826a$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};
module.exports["getGuidelineTypeFromKey"] = $c2899ffa94a5826a$export$3fa50479f031580;

});

parcelRegister("gi32l", function(module, exports) {

let $bdc0aeda9447fe84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bdc0aeda9447fe84$var$load("hJE7W"),
    $bdc0aeda9447fe84$var$load("hZ2FX"),
    $bdc0aeda9447fe84$var$load("fV46K"),
    $bdc0aeda9447fe84$var$load("kruxh")
]).then(()=>parcelRequire('gB7FN'));

});

parcelRegister("g4HVK", function(module, exports) {

let $bb3f18bd85145bd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb3f18bd85145bd2$var$load("fV46K"),
    $bb3f18bd85145bd2$var$load("6OMo6"),
    $bb3f18bd85145bd2$var$load("aaRXj"),
    $bb3f18bd85145bd2$var$load("fHlIz"),
    $bb3f18bd85145bd2$var$load("4QwAJ"),
    $bb3f18bd85145bd2$var$load("3i44s"),
    $bb3f18bd85145bd2$var$load("5kI0b"),
    $bb3f18bd85145bd2$var$load("kYkz1"),
    $bb3f18bd85145bd2$var$load("jfYeU"),
    $bb3f18bd85145bd2$var$load("b4nm1"),
    $bb3f18bd85145bd2$var$load("geXPZ"),
    $bb3f18bd85145bd2$var$load("aQ5uu"),
    $bb3f18bd85145bd2$var$load("flY2n"),
    $bb3f18bd85145bd2$var$load("jOE2W"),
    $bb3f18bd85145bd2$var$load("jTOhL"),
    $bb3f18bd85145bd2$var$load("kKrH1")
]).then(()=>parcelRequire('bQyry'));

});

parcelRegister("j5Sek", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $1tBud = parcelRequire("1tBud");


var $2ETaj = parcelRequire("2ETaj");

const $e20d61555d2cb082$var$getIdentifier = (attrs)=>{
    if ((0, $2ETaj.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $e20d61555d2cb082$export$d852d5f849a8df8d = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, items: items = [], extensions: extensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const identifier = $e20d61555d2cb082$var$getIdentifier(selectedNodeAttrs);
    const collectionName = (0, $2ETaj.isExternalMedia)(selectedNodeAttrs) ? '' : selectedNodeAttrs.collection;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1tBud.default), {
        collectionName: collectionName,
        items: items,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        mediaClientConfig: mediaClientConfig,
        selectedItem: identifier,
        onClose: onClose,
        extensions: extensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    }), document.body);
};
module.exports["RenderMediaViewer"] = $e20d61555d2cb082$export$d852d5f849a8df8d;

});

parcelRegister("ixa4K", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $cab0f05c1e2a9a00$export$cb37ac89e145f1d = (0, $kSwu1.defineMessages)({
    borderColor: {
        id: "fabric.editor.imageBorderColor",
        defaultMessage: "Color"
    },
    borderColorDropdownAriaLabel: {
        id: "fabric.editor.imageBorderColor.dropdownAriaLabel",
        defaultMessage: "Image border options Color dropdown"
    },
    borderSize: {
        id: "fabric.editor.imageBorderSize",
        defaultMessage: "Size"
    },
    borderSizeDropdownAriaLabel: {
        id: "fabric.editor.imageBorderSize.dropdownAriaLabel",
        defaultMessage: "Image border options Size dropdown"
    },
    addBorder: {
        id: "fabric.editor.addImageBorder",
        defaultMessage: "Add border"
    },
    removeBorder: {
        id: "fabric.editor.removeImageBorder",
        defaultMessage: "Remove border"
    },
    borderOptions: {
        id: "fabric.editor.imageBorderOptions",
        defaultMessage: "Border options"
    },
    borderSizeSubtle: {
        id: "fabric.editor.imageBorderSubtle",
        defaultMessage: "Subtle"
    },
    borderSizeMedium: {
        id: "fabric.editor.imageBorderMedium",
        defaultMessage: "Medium"
    },
    borderSizeBold: {
        id: "fabric.editor.imageBorderBold",
        defaultMessage: "Bold"
    }
});
module.exports["imageBorderMessages"] = $cab0f05c1e2a9a00$export$cb37ac89e145f1d;

});

parcelRegister("3aDYK", function(module, exports) {

var $dWeA1 = parcelRequire("dWeA1");


var $kQOs5 = parcelRequire("kQOs5");


var $xx2Zf = parcelRequire("xx2Zf");


var $j1hRT = parcelRequire("j1hRT");

const $8a3ff46c144d7246$var$borderColorPalette = [];
(0, $dWeA1.borderColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $xx2Zf.default)((0, $j1hRT.default), key);
    $8a3ff46c144d7246$var$borderColorPalette.push({
        value: color,
        label: label,
        border: (0, $kQOs5.DEFAULT_BORDER_COLOR),
        message: message
    });
});
var $8a3ff46c144d7246$export$2e2bcd8739ae039 = $8a3ff46c144d7246$var$borderColorPalette;
module.exports["default"] = $8a3ff46c144d7246$export$2e2bcd8739ae039;

});

parcelRegister("7gEjc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kCECX = parcelRequire("kCECX");

const $2c12eef5bfcd4017$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('mediaInsertPlugin');


const $f4981ec9ce58fcc3$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $f4981ec9ce58fcc3$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $f4981ec9ce58fcc3$var$setPopupMeta = ({ type: type, tr: tr, mountInfo: mountInfo })=>tr.setMeta((0, $2c12eef5bfcd4017$export$18d4026d1ea86bb1), {
        type: type,
        mountInfo: mountInfo
    });
const $f4981ec9ce58fcc3$export$3e81af3e1bf8bdd1 = (tr, mountInfo)=>{
    return $f4981ec9ce58fcc3$var$setPopupMeta({
        type: $f4981ec9ce58fcc3$export$f766031ad28e12e3,
        mountInfo: mountInfo,
        tr: tr
    });
};
const $f4981ec9ce58fcc3$export$e89adf8af9d31a9f = (tr)=>{
    return $f4981ec9ce58fcc3$var$setPopupMeta({
        type: $f4981ec9ce58fcc3$export$1be3e111c71a5c61,
        tr: tr
    });
};



var $kpCD8 = parcelRequire("kpCD8");



const $deecd87553932f9f$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    mountInfo: undefined
                };
            },
            apply (tr, mediaInsertPluginState) {
                const meta = tr.getMeta((0, $2c12eef5bfcd4017$export$18d4026d1ea86bb1));
                switch(meta?.type){
                    case 0, $f4981ec9ce58fcc3$export$f766031ad28e12e3:
                        return {
                            isOpen: true,
                            mountInfo: meta.mountInfo
                        };
                    case 0, $f4981ec9ce58fcc3$export$1be3e111c71a5c61:
                        return {
                            isOpen: false
                        };
                    default:
                        return mediaInsertPluginState;
                }
            }
        },
        key: (0, $2c12eef5bfcd4017$export$18d4026d1ea86bb1)
    });
};







var $kSwu1 = parcelRequire("kSwu1");





var $ajK0g = parcelRequire("ajK0g");


var $3k5Tv = parcelRequire("3k5Tv");


var $4OhxS = parcelRequire("4OhxS");


var $dfEnC = parcelRequire("dfEnC");

var $7XIuB = parcelRequire("7XIuB");

var $1nt6a = parcelRequire("1nt6a");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iMnC5 = parcelRequire("iMnC5");

var $8cnlb = parcelRequire("8cnlb");

var $4aRua = parcelRequire("4aRua");


var $hMjUh = parcelRequire("hMjUh");

var $dkVNA = parcelRequire("dkVNA");

var $eq2ng = parcelRequire("eq2ng");

var $22LbG = parcelRequire("22LbG");


var $anBbz = parcelRequire("anBbz");




const $c7f1a105d6d1f755$export$97a7acd021cf4e6b = ({ editorView: editorView })=>{
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use setTimeout to run this async after the call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    return focusEditor;
};





const $b36d626792e9eb0b$export$51343998e6e270fe = ()=>{
    const autofocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const positionRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((position)=>{
        if (positionRef.current === null) // Initial position is _always incorrect, so the first time this is set
        // we're going to ignore it.
        positionRef.current = position;
        else if (positionRef.current !== position) {
            // If it isn't the first position and it has changed, we're likely in
            // the actual position we want. We'll call focus and update the position.
            autofocusRef.current?.focus();
            positionRef.current = position;
        }
        // Important to return this as the popup uses the returned position
        return position;
    }, [
        autofocusRef
    ]);
    /**
	 * If we don't clear the ref, then reopening the media picker will
	 * not correctly focus the button.
	 *
	 * WARNING: If the component re-renders the ref will be cleared and
	 * the button will be focused again.
	 *
	 * This is a trade-off, we prefer that the button is correctly focused
	 * if the media picker is re-opened, rather than re-focusing the button
	 * if the component re-renders/ the browser window is resized.
	 *
	 * This is a temporary solution until we can find a better way to do it.
	 */ (0, $cozmU.useEffect)(()=>{
        return ()=>{
            positionRef.current = null;
        };
    });
    return {
        autofocusRef: autofocusRef,
        onPositionCalculated: onPositionCalculated
    };
};









var $ad7Ou = parcelRequire("ad7Ou");








var $bh4C9 = parcelRequire("bh4C9");


var $5ZJRm = parcelRequire("5ZJRm");


var $dinVW = parcelRequire("dinVW");


var $1VhsF = parcelRequire("1VhsF");










function $8cd77795f5f69d04$export$5bf35293e545f20c(dispatchAnalyticsEvent) {
    const onUploadButtonClickedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadCommencedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).UPLOAD_COMMENCED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadSuccessAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).UPLOAD_SUCCEEDED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadFailureAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((reason, mediaUploadSource)=>{
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).UPLOAD_FAILED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                reason: reason,
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics,
            onUploadCommencedAnalytics: onUploadCommencedAnalytics,
            onUploadSuccessAnalytics: onUploadSuccessAnalytics,
            onUploadFailureAnalytics: onUploadFailureAnalytics
        }), [
        onUploadButtonClickedAnalytics,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
}


const $e83af2b2d77afa83$var$INITIAL_UPLOAD_STATE = Object.freeze({
    isOpen: false,
    error: null
});
const $e83af2b2d77afa83$var$uploadReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...$e83af2b2d77afa83$var$INITIAL_UPLOAD_STATE,
                isOpen: true
            };
        case 'close':
            // This is the only case where we don't reset state. This is because
            // onClose gets called for cancel _and_ upload, so we don't want to
            // reset any loading or error states that may have occured
            return {
                ...state,
                isOpen: false
            };
        case 'error':
            return {
                ...$e83af2b2d77afa83$var$INITIAL_UPLOAD_STATE,
                error: action.error
            };
        case 'reset':
            return $e83af2b2d77afa83$var$INITIAL_UPLOAD_STATE;
    }
};
const $e83af2b2d77afa83$var$isImagePreview = (preview)=>{
    return 'dimensions' in preview;
};
const $e83af2b2d77afa83$export$72542eb1d24a31e0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertFile: insertFile }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    const strings = {
        upload: intl.formatMessage((0, $4OhxS.mediaInsertMessages).upload),
        chooseFile: intl.formatMessage((0, $4OhxS.mediaInsertMessages).chooseFile),
        networkError: intl.formatMessage((0, $4OhxS.mediaInsertMessages).localFileNetworkErrorMessage),
        genericError: intl.formatMessage((0, $4OhxS.mediaInsertMessages).localFileErrorMessage)
    };
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $8cd77795f5f69d04$export$5bf35293e545f20c)(dispatchAnalyticsEvent);
    const [uploadState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useReducer($e83af2b2d77afa83$var$uploadReducer, $e83af2b2d77afa83$var$INITIAL_UPLOAD_STATE);
    const erroredFileIds = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(new Set())[0];
    // This is a bit horrendous. Fundementally though, `insertFile` takes a
    // callback that can ask for us to add listeners to any and all of the
    // `Browser` events for each file uplaoded. We add a track those in a
    // ref, call the CBs so the media-plugin can do it's thing, and then
    // remove all listeners `onEnd`.
    const eventSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    const onStateChanged = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((fileId)=>(cb)=>{
            eventSubscribers.current = {
                ...eventSubscribers.current,
                [fileId]: [
                    ...eventSubscribers.current?.[fileId] ?? [],
                    cb
                ]
            };
        }, []);
    const onPreviewUpdate = ({ file: file, preview: preview })=>{
        onUploadSuccessAnalytics('local');
        const isErroredFile = erroredFileIds.has(file.id);
        const { dimensions: dimensions, scaleFactor: scaleFactor } = $e83af2b2d77afa83$var$isImagePreview(preview) ? preview : {
            dimensions: undefined,
            scaleFactor: undefined
        };
        const mediaState = {
            id: file.id,
            collection: mediaProvider.uploadParams?.collection,
            fileMimeType: file.type,
            fileSize: file.size,
            fileName: file.name,
            dimensions: dimensions,
            scaleFactor: scaleFactor,
            status: isErroredFile ? 'error' : undefined
        };
        insertFile({
            mediaState: mediaState,
            inputMethod: (0, $krYZG.INPUT_METHOD).MEDIA_PICKER,
            onMediaStateChanged: onStateChanged(file.id)
        });
        closeMediaInsertPicker();
        // Probably not needed but I guess it _could_ fail to close for some reason
        dispatch({
            type: 'reset'
        });
    };
    const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = mediaProvider;
    const onEnd = (0, $cozmU.useCallback)((payload)=>{
        eventSubscribers.current?.[payload.file.id]?.forEach((cb)=>cb({
                id: payload.file.id,
                status: 'ready'
            }));
        delete eventSubscribers.current?.[payload.file.id];
    }, []);
    const onError = (0, $cozmU.useCallback)(({ error: error, fileId: fileId })=>{
        // Dispatch the error events
        onUploadFailureAnalytics(error.name, 'local');
        dispatch({
            type: 'error',
            error: error.name
        });
        // Update the status of the errored file
        erroredFileIds.add(fileId);
        // Update and remove listeners
        eventSubscribers.current?.[fileId]?.forEach((cb)=>cb({
                id: fileId,
                status: 'error',
                error: error
            }));
        delete eventSubscribers.current?.[fileId];
    }, [
        erroredFileIds,
        onUploadFailureAnalytics
    ]);
    const buttonText = (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? strings.chooseFile : strings.upload;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        grow: "fill",
        space: "space.200"
    }, uploadState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "error"
    }, uploadState.error === 'upload_fail' ? strings.networkError : strings.genericError), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        id: "local-media-upload-button",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
                label: ""
            }),
        ref: ref,
        shouldFitContainer: true,
        isDisabled: !uploadMediaClientConfig || !uploadParams,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            onUploadButtonClickedAnalytics();
            dispatch({
                type: 'open'
            });
        }
    }, buttonText), uploadMediaClientConfig && uploadParams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZJRm.BrowserLoader), {
        isOpen: uploadState.isOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        config: {
            uploadParams: uploadParams,
            multiple: true
        },
        mediaClientConfig: uploadMediaClientConfig,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onUploadsStart: ()=>onUploadCommencedAnalytics('local'),
        onPreviewUpdate: onPreviewUpdate,
        onEnd: onEnd,
        // NOTE: this will fire for some errors like network failures, but not
        // for others like empty files. Those have their own feedback toast
        // owned by media.
        onError: onError,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClose: ()=>{
            erroredFileIds.clear();
            dispatch({
                type: 'close'
            });
        }
    }));
});









var $9p0BY = parcelRequire("9p0BY");


var $7joZr = parcelRequire("7joZr");











var $dTHYM = parcelRequire("dTHYM");

var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $j7cLK = parcelRequire("j7cLK");

var $9DzWa = parcelRequire("9DzWa");

var $dQLwo = parcelRequire("dQLwo");


var $8VfSP = parcelRequire("8VfSP");


var $g9ZnD = parcelRequire("g9ZnD");


var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $kz1Yj = parcelRequire("kz1Yj");

var $2wCqQ = parcelRequire("2wCqQ");

var $buxP3 = parcelRequire("buxP3");





var $4yg9g = parcelRequire("4yg9g");











var $17wiG = parcelRequire("17wiG");

var $3lbOc = parcelRequire("3lbOc");

const $f2b2f16ad8c66db0$var$maxDimensions = {
    width: '100%',
    height: '100%'
};
const $f2b2f16ad8c66db0$export$a6543a2e3828db2c = ({ attrs: attrs, mediaProvider: mediaProvider })=>{
    const intl = (0, $kSwu1.useIntl)();
    const mediaAlt = intl.formatMessage((0, $4OhxS.mediaInsertMessages).mediaAlt);
    const dimensions = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            width: attrs.dimensions.width,
            height: attrs.dimensions.height
        };
    }, [
        attrs.dimensions.width,
        attrs.dimensions.height
    ]);
    const identifier = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            id: attrs.id,
            mediaItemType: 'file',
            collectionName: attrs.collection
        }), [
        attrs.collection,
        attrs.id
    ]);
    if (!mediaProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        dimensions: dimensions,
        interactionName: "editor-media-insert-card-loading"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17wiG.default), {
        mediaClientConfig: mediaProvider.viewMediaClientConfig,
        resizeMode: "stretchy-fit",
        dimensions: $f2b2f16ad8c66db0$var$maxDimensions,
        originalDimensions: dimensions,
        identifier: identifier,
        alt: mediaAlt,
        disableOverlay: true
    });
};



// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ea0197fe1d985d2f$var$WHITESPACE_REGEX = /\s/;
const $ea0197fe1d985d2f$var$PreviewBoxStyles = (0, $buxP3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'dashed',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    height: '200px'
});
const $ea0197fe1d985d2f$var$PreviewImageStyles = (0, $buxP3.xcss)({
    height: '200px'
});
const $ea0197fe1d985d2f$var$FormStyles = (0, $buxP3.xcss)({
    flexGrow: 1
});
const $ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE = Object.freeze({
    isLoading: false,
    error: null,
    warning: null,
    previewInfo: null
});
const $ea0197fe1d985d2f$var$isValidInput = (value, customizedUrlValidation)=>{
    if (customizedUrlValidation) return customizedUrlValidation(value);
    return $ea0197fe1d985d2f$export$bef94a5618bf18bf(value);
};
const $ea0197fe1d985d2f$var$MAX_URL_LENGTH = 2048;
const $ea0197fe1d985d2f$export$bef94a5618bf18bf = (value)=>{
    try {
        // Check for spaces and length first to avoid the expensive URL parsing
        if ($ea0197fe1d985d2f$var$WHITESPACE_REGEX.test(value) || value.length > $ea0197fe1d985d2f$var$MAX_URL_LENGTH) return false;
        new URL(value);
    } catch  {
        return false;
    }
    return (0, $9p0BY.isSafeUrl)(value);
};
const $ea0197fe1d985d2f$var$previewStateReducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                ...$ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE,
                isLoading: true
            };
        case 'error':
            return {
                ...$ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE,
                error: action.error
            };
        case 'warning':
            return {
                ...$ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE,
                warning: action.warning
            };
        case 'success':
            return {
                ...$ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE,
                previewInfo: action.payload
            };
        case 'reset':
            return $ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE;
        default:
            return state;
    }
};
function $ea0197fe1d985d2f$export$903b9b47fa175337({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, isOnlyExternalLinks: isOnlyExternalLinks, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage }) {
    const intl = (0, $kSwu1.useIntl)();
    const strings = {
        loadPreview: intl.formatMessage((0, $4OhxS.mediaInsertMessages).loadPreview),
        insert: intl.formatMessage((0, $4OhxS.mediaInsertMessages).insert),
        pasteLinkToUpload: intl.formatMessage((0, $4OhxS.mediaInsertMessages).pasteLinkToUpload),
        cancel: intl.formatMessage((0, $4OhxS.mediaInsertMessages).cancel),
        errorMessage: intl.formatMessage((0, $4OhxS.mediaInsertMessages).fromUrlErrorMessage),
        warning: intl.formatMessage((0, $4OhxS.mediaInsertMessages).fromUrlWarning),
        invalidUrl: intl.formatMessage((0, $4OhxS.mediaInsertMessages).invalidUrlErrorMessage)
    };
    const [previewState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useReducer($ea0197fe1d985d2f$var$previewStateReducer, $ea0197fe1d985d2f$var$INITIAL_PREVIEW_STATE);
    const [input, setInput] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('');
    const pasteFlag = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $8cd77795f5f69d04$export$5bf35293e545f20c)(dispatchAnalyticsEvent);
    const uploadExternalMedia = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (url)=>{
        onUploadButtonClickedAnalytics();
        dispatch({
            type: 'loading'
        });
        const { uploadMediaClientConfig: uploadMediaClientConfig, uploadParams: uploadParams } = mediaProvider;
        if (!uploadMediaClientConfig) return;
        const mediaClient = (0, $g9ZnD.getMediaClient)(uploadMediaClientConfig);
        const collection = uploadParams?.collection;
        onUploadCommencedAnalytics('url');
        try {
            const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions, mimeType: mimeType } = await mediaClient.file.uploadExternal(url, collection);
            onUploadSuccessAnalytics('url');
            dispatch({
                type: 'success',
                payload: {
                    id: uploadableFileUpfrontIds.id,
                    collection: collection,
                    dimensions: dimensions,
                    occurrenceKey: uploadableFileUpfrontIds.occurrenceKey,
                    fileMimeType: mimeType
                }
            });
        } catch (e) {
            // eslint-disable-line no-unused-vars
            if (typeof e === 'string' && e === 'Could not download remote file') {
                // TODO: ED-26962 - Make sure this gets good unit test coverage with the actual media plugin.
                // This hard coded error message could be changed at any
                // point and we need a unit test to break to stop people changing it.
                onUploadFailureAnalytics(e, 'url');
                dispatch({
                    type: 'warning',
                    warning: e,
                    url: url
                });
            } else if (e instanceof Error) {
                const message = 'Image preview fetch failed';
                onUploadFailureAnalytics(message, 'url');
                dispatch({
                    type: 'error',
                    error: message
                });
            } else {
                onUploadFailureAnalytics('Unknown error', 'url');
                dispatch({
                    type: 'error',
                    error: 'Unknown error'
                });
            }
        }
    }, [
        onUploadButtonClickedAnalytics,
        mediaProvider,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
    const onURLChange = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        const url = e.currentTarget.value;
        dispatch({
            type: 'reset'
        });
        setInput(url);
        if (!$ea0197fe1d985d2f$var$isValidInput(url, customizedUrlValidation)) return;
        if (pasteFlag.current) {
            pasteFlag.current = false;
            if (!isOnlyExternalLinks) uploadExternalMedia(url);
        }
    }, [
        uploadExternalMedia,
        isOnlyExternalLinks,
        customizedUrlValidation
    ]);
    const onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e, inputUrl)=>{
        // Note: this is a little weird, but the paste event will always be
        // fired before the change event when pasting. We don't really want to
        // duplicate logic by handling pastes separately to changes, so we're
        // just noting paste occurred to then be handled in the onURLChange fn
        // above. The one exception to this is where paste inputs exactly what was
        // already in the input, in which case we want to ignore it.
        if (e.clipboardData.getData('text') !== inputUrl) pasteFlag.current = true;
    }, []);
    const onInsert = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (previewState.previewInfo) insertMediaSingle({
            mediaState: previewState.previewInfo,
            inputMethod: (0, $krYZG.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertMediaSingle,
        previewState.previewInfo
    ]);
    const onExternalInsert = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((url)=>{
        if (previewState.warning || isOnlyExternalLinks) insertExternalMediaSingle({
            url: url,
            alt: '',
            inputMethod: (0, $krYZG.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertExternalMediaSingle,
        previewState.warning,
        isOnlyExternalLinks
    ]);
    const onInputKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (event && event.key === 'Esc') {
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $krYZG.ACTION).CLOSED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
        }
    }, [
        dispatchAnalyticsEvent,
        closeMediaInsertPicker
    ]);
    const onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).CANCELLED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            dispatchAnalyticsEvent(payload);
        }
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSubmit: ({ inputUrl: inputUrl }, form)=>{
            // This can be triggered from an enter key event on the input even when
            // the button is disabled, so we explicitly do nothing when in loading
            // state.
            if (previewState.isLoading || form.getState().invalid) return;
            if (previewState.previewInfo) return onInsert();
            if (previewState.warning || isOnlyExternalLinks) return onExternalInsert(inputUrl);
            return uploadExternalMedia(inputUrl);
        }
    }, ({ formProps: formProps })=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ea0197fe1d985d2f$var$FormStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.150",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            isRequired: true,
            name: "inputUrl",
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            validate: (value)=>value && $ea0197fe1d985d2f$var$isValidInput(value, customizedUrlValidation) ? undefined : strings.invalidUrl
        }, ({ fieldProps: { value: value, onChange: onChange, ...rest }, error: error, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.150",
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                ...rest,
                value: value,
                "aria-label": strings.pasteLinkToUpload,
                placeholder: strings.pasteLinkToUpload,
                maxLength: $ea0197fe1d985d2f$var$MAX_URL_LENGTH,
                onKeyPress: onInputKeyPress,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onPaste: (event)=>onPaste(event, value),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onChange: (value)=>{
                    onURLChange(value);
                    onChange(value);
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (e)=>{
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        formProps.onSubmit();
                    }
                }
            }), customizedHelperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, customizedHelperMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                as: "span"
            }, error)))), !previewState.previewInfo && !previewState.error && !previewState.warning && !isOnlyExternalLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                xcss: $ea0197fe1d985d2f$var$PreviewBoxStyles,
                alignItems: "center",
                justifyContent: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                type: "button",
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>formProps.onSubmit(),
                isLoading: previewState.isLoading,
                isDisabled: !!error || !meta.dirty,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
                        label: ""
                    })
            }, strings.loadPreview)))), previewState.previewInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignInline: "center",
            alignBlock: "center",
            xcss: $ea0197fe1d985d2f$var$PreviewImageStyles,
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b2f16ad8c66db0$export$a6543a2e3828db2c), {
            attrs: previewState.previewInfo,
            mediaProvider: mediaProvider
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, previewState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "error"
        }, strings.errorMessage), previewState.warning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, strings.warning)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j7cLK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onCancel
        }, strings.cancel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "button",
            appearance: "primary",
            isDisabled: isOnlyExternalLinks ? !input || !$ea0197fe1d985d2f$var$isValidInput(input, customizedUrlValidation) : !previewState.previewInfo && !previewState.warning,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>formProps.onSubmit()
        }, strings.insert))))));
}










const $2682fe5f206f3410$var$styles = (0, $buxP3.xcss)({
    /* Reset inherited styles from toolbar */ whiteSpace: 'initial',
    textAlign: 'initial',
    boxShadow: 'elevation.shadow.overflow',
    width: '340px',
    padding: 'space.200',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay'
});
const $2682fe5f206f3410$export$d01f0fa2ebc904b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: ref,
        xcss: $2682fe5f206f3410$var$styles
    }, children);
});


const $e599553e0a965740$var$PopupWithListeners = (0, $1nt6a.default)((0, $7XIuB.default));
const $e599553e0a965740$var$MEDIA_INSERT_PICKER_ANALYTICS_SOURCE = 'MediaInsertPicker';
const $e599553e0a965740$var$EMPTY_REGISTERED_TABS = [];
const $e599553e0a965740$var$getMediaInsertPickerTabSource = (selectedTab)=>`${$e599553e0a965740$var$MEDIA_INSERT_PICKER_ANALYTICS_SOURCE} - ${selectedTab}`;
const $e599553e0a965740$var$getNextTabIndexForKey = (currentTabIndex, tabCount, key)=>{
    if (key === 'Home') return 0;
    if (key === 'End') return tabCount - 1;
    if (key === 'ArrowRight') return currentTabIndex === tabCount - 1 ? 0 : currentTabIndex + 1;
    if (key === 'ArrowLeft') return currentTabIndex === 0 ? tabCount - 1 : currentTabIndex - 1;
    return undefined;
};
const $e599553e0a965740$var$getLinkTabIndex = (registeredTabCount, isOnlyExternalLinks)=>registeredTabCount + (isOnlyExternalLinks ? 0 : 1);
const $e599553e0a965740$var$TabWithAnalytics = ({ children: children, onSelectTabForAnalytics: onSelectTabForAnalytics, selectedTabIndex: selectedTabIndex, tabCount: tabCount })=>{
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eq2ng.default)();
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        onSelectTabForAnalytics(selectedTabIndex);
        onClick();
    }, [
        onClick,
        onSelectTabForAnalytics,
        selectedTabIndex
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        const nextTabIndex = $e599553e0a965740$var$getNextTabIndexForKey(selectedTabIndex, tabCount, event.key);
        if (nextTabIndex !== undefined) onSelectTabForAnalytics(nextTabIndex);
        onKeyDown(event);
    }, [
        onKeyDown,
        onSelectTabForAnalytics,
        selectedTabIndex,
        tabCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8cnlb.default), {
        as: "div",
        isInset: true,
        onClick: handleClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: handleKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children));
};
/**
 * A custom TabPanel that is non-focusable.
 */ const $e599553e0a965740$var$CustomTabPanel = ({ children: children, disablePaddingBlockEnd: disablePaddingBlockEnd = false })=>{
    const tabPanelAttributes = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockEnd: disablePaddingBlockEnd ? 'space.0' : 'space.150',
        ...tabPanelAttributes,
        tabIndex: -1
    }, children);
};
const $e599553e0a965740$export$6a978a6c0eb24e84 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, insertFile: insertFile, isOnlyExternalLinks: isOnlyExternalLinks = false, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage })=>{
    // Tabs registered by other plugins via `api.mediaInsert.actions.registerInsertTab(...)`.
    // Read once per render; the registry is mutated only at plugin setup time so this is stable
    // for the lifetime of an editor instance.
    const registeredTabs = api?.mediaInsert?.actions?.getInsertTabs?.() ?? $e599553e0a965740$var$EMPTY_REGISTERED_TABS;
    const { mediaProvider: mediaProvider, isOpen: isOpen, mountInfo: mountInfo } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'media',
        'mediaInsert'
    ], (states)=>({
            mediaProvider: states.mediaState?.mediaProvider,
            isOpen: states.mediaInsertState?.isOpen,
            mountInfo: states.mediaInsertState?.mountInfo
        }));
    let targetRef;
    let mountPoint;
    if (mountInfo) {
        targetRef = mountInfo.ref;
        mountPoint = mountInfo.mountPoint;
    } else {
        // If targetRef is undefined, target the selection in the editor
        targetRef = (0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA, api?.analytics?.actions);
        mountPoint = popupsMountPoint;
    }
    const intl = (0, $kSwu1.useIntl)();
    const focusEditor = (0, $c7f1a105d6d1f755$export$97a7acd021cf4e6b)({
        editorView: editorView
    });
    const { autofocusRef: autofocusRef, onPositionCalculated: onPositionCalculated } = (0, $b36d626792e9eb0b$export$51343998e6e270fe)();
    const tabCount = registeredTabs.length + (isOnlyExternalLinks ? 1 : 2);
    const linkTabIndex = $e599553e0a965740$var$getLinkTabIndex(registeredTabs.length, isOnlyExternalLinks);
    const getTabAnalyticsMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((selectedTabIndex)=>{
        const registeredTab = registeredTabs[selectedTabIndex];
        if (registeredTab) return {
            selectedTab: registeredTab.key,
            selectedTabIndex: selectedTabIndex
        };
        const uploadTabIndex = registeredTabs.length;
        if (!isOnlyExternalLinks && selectedTabIndex === uploadTabIndex) return {
            selectedTab: (0, $krYZG.MEDIA_INSERT_TAB).UPLOAD,
            selectedTabIndex: selectedTabIndex
        };
        if (selectedTabIndex === linkTabIndex) return {
            selectedTab: (0, $krYZG.MEDIA_INSERT_TAB).LINK,
            selectedTabIndex: selectedTabIndex
        };
        return {
            selectedTab: 'unknown',
            selectedTabIndex: selectedTabIndex
        };
    }, [
        isOnlyExternalLinks,
        linkTabIndex,
        registeredTabs
    ]);
    const selectedTabAnalyticsMetadataRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(getTabAnalyticsMetadata(0));
    const tabsAnalyticsContext = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            get source () {
                return $e599553e0a965740$var$getMediaInsertPickerTabSource(selectedTabAnalyticsMetadataRef.current.selectedTab);
            }
        }), []);
    const setSelectedTabAnalyticsMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((selectedTabIndex)=>{
        selectedTabAnalyticsMetadataRef.current = getTabAnalyticsMetadata(selectedTabIndex);
    }, [
        getTabAnalyticsMetadata
    ]);
    const hasDispatchedInitialTabViewedEventRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    // Atlaskit Tabs only calls `onChange` after the user changes tabs, so the
    // initially opened tab needs its viewed analytics event dispatched from an
    // effect. The ref keeps this to once per picker open without setting state.
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!isOpen) {
            hasDispatchedInitialTabViewedEventRef.current = false;
            return;
        }
        if (!mediaProvider || !dispatchAnalyticsEvent || hasDispatchedInitialTabViewedEventRef.current) return;
        const selectedTabMetadata = getTabAnalyticsMetadata(0);
        selectedTabAnalyticsMetadataRef.current = selectedTabMetadata;
        const payload = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                selectedTab: selectedTabMetadata.selectedTab,
                selectedTabIndex: selectedTabMetadata.selectedTabIndex
            }
        };
        dispatchAnalyticsEvent(payload);
        hasDispatchedInitialTabViewedEventRef.current = true;
    }, [
        dispatchAnalyticsEvent,
        getTabAnalyticsMetadata,
        isOpen,
        mediaProvider
    ]);
    const handleTabChange = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((selectedTabIndex, analyticsEvent)=>{
        const selectedTabMetadata = getTabAnalyticsMetadata(selectedTabIndex);
        selectedTabAnalyticsMetadataRef.current = selectedTabMetadata;
        analyticsEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    selectedTab: selectedTabMetadata.selectedTab,
                    selectedTabIndex: selectedTabIndex
                }
            })).fire();
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    selectedTab: selectedTabMetadata.selectedTab,
                    selectedTabIndex: selectedTabIndex
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }, [
        dispatchAnalyticsEvent,
        getTabAnalyticsMetadata
    ]);
    if (!isOpen || !mediaProvider) return null;
    const handleClose = (exitMethod)=>(event)=>{
            // Same as AIImageGenerationPopup: react-select can detach the option
            // before `click` fires, so withOuterListeners treats it as outside.
            if (exitMethod === (0, $krYZG.INPUT_METHOD).MOUSE && event.target instanceof Node && !event.target.isConnected) return;
            event.preventDefault();
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $krYZG.ACTION).CLOSED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: exitMethod
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeMediaInsertPicker();
            focusEditor();
        };
    const fileTabTitle = (0, $anBbz.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? intl.formatMessage((0, $4OhxS.mediaInsertMessages).uploadTabTitle) : intl.formatMessage((0, $4OhxS.mediaInsertMessages).fileTabTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage((0, $4OhxS.mediaInsertMessages).mediaPickerPopupAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: mountPoint,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClose((0, $krYZG.INPUT_METHOD).MOUSE),
        handleEscapeKeydown: handleClose((0, $krYZG.INPUT_METHOD).KEYBOARD),
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        onPositionCalculated: onPositionCalculated,
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dfEnC.PlainOutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2682fe5f206f3410$export$d01f0fa2ebc904b8), {
            ref: setOutsideClickTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
            id: "media-insert-tab-navigation",
            analyticsContext: tabsAnalyticsContext,
            onChange: handleTabChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingBlockEnd: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, registeredTabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$TabWithAnalytics, {
                key: tab.key,
                onSelectTabForAnalytics: setSelectedTabAnalyticsMetadata,
                selectedTabIndex: index,
                tabCount: tabCount
            }, tab.label)), !isOnlyExternalLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$TabWithAnalytics, {
            onSelectTabForAnalytics: setSelectedTabAnalyticsMetadata,
            selectedTabIndex: registeredTabs.length,
            tabCount: tabCount
        }, fileTabTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$TabWithAnalytics, {
            onSelectTabForAnalytics: setSelectedTabAnalyticsMetadata,
            selectedTabIndex: linkTabIndex,
            tabCount: tabCount
        }, intl.formatMessage((0, $4OhxS.mediaInsertMessages).linkTabTitle)))), registeredTabs.map(({ key: key, component: TabComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$CustomTabPanel, {
                key: key,
                disablePaddingBlockEnd: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TabComponent, {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                closeMediaInsertPicker: ()=>{
                    closeMediaInsertPicker();
                    focusEditor();
                },
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                insertMediaSingle: insertMediaSingle,
                mediaProvider: mediaProvider
            }))), !isOnlyExternalLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$CustomTabPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e83af2b2d77afa83$export$72542eb1d24a31e0), {
            ref: autofocusRef,
            mediaProvider: mediaProvider,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            closeMediaInsertPicker: ()=>{
                closeMediaInsertPicker();
                focusEditor();
            },
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            insertFile: insertFile
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e599553e0a965740$var$CustomTabPanel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea0197fe1d985d2f$export$903b9b47fa175337), {
            mediaProvider: mediaProvider,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            closeMediaInsertPicker: ()=>{
                closeMediaInsertPicker();
                focusEditor();
            },
            insertMediaSingle: insertMediaSingle,
            insertExternalMediaSingle: insertExternalMediaSingle,
            isOnlyExternalLinks: isOnlyExternalLinks,
            customizedUrlValidation: customizedUrlValidation,
            customizedHelperMessage: customizedHelperMessage
        }))))));
};


const $199f24a87788c875$var$getInitialMediaInsertTab = (registeredTabs, isOnlyExternalLinks)=>{
    const registeredTab = registeredTabs[0];
    if (registeredTab) return registeredTab.key;
    return isOnlyExternalLinks ? (0, $krYZG.MEDIA_INSERT_TAB).LINK : (0, $krYZG.MEDIA_INSERT_TAB).UPLOAD;
};
/**
 * Per-editor-instance registry of insert tabs registered via
 * `actions.registerInsertTab(...)`. Idempotent on `key` so that re-registering
 * the same tab (e.g. on plugin re-init in dev / StrictMode) replaces rather
 * than duplicates.
 */ const $199f24a87788c875$var$createInsertTabRegistry = ()=>{
    const tabs = [];
    return {
        register: (tab)=>{
            const existingIndex = tabs.findIndex((t)=>t.key === tab.key);
            if (existingIndex >= 0) tabs[existingIndex] = tab;
            else tabs.push(tab);
        },
        getAll: ()=>tabs
    };
};
const $199f24a87788c875$export$922c51f87f6fe974 = ({ api: api, config: config })=>{
    const insertTabRegistry = $199f24a87788c875$var$createInsertTabRegistry();
    return {
        name: 'mediaInsert',
        pmPlugins () {
            return [
                {
                    name: 'mediaInsert',
                    plugin: ()=>(0, $deecd87553932f9f$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const { isOpen: isOpen, mountInfo: mountInfo } = (0, $2c12eef5bfcd4017$export$18d4026d1ea86bb1).getState(editorState) || {};
            return {
                isOpen: isOpen,
                mountInfo: mountInfo
            };
        },
        commands: {
            showMediaInsertPopup: (mountInfo)=>({ tr: tr })=>(0, $f4981ec9ce58fcc3$export$3e81af3e1bf8bdd1)(tr, mountInfo)
        },
        actions: {
            registerInsertTab: (tab)=>insertTabRegistry.register(tab),
            getInsertTabs: ()=>insertTabRegistry.getAll()
        },
        contentComponent: ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            const insertMediaSingle = ({ mediaState: mediaState, inputMethod: inputMethod })=>{
                const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName, collection: collection } = mediaState;
                const { width: width, height: height } = dimensions || {
                    height: undefined,
                    width: undefined
                };
                const scaledWidth = width && Math.round(width / scaleFactor);
                const node = editorView.state.schema.nodes.media.create({
                    id: id,
                    type: 'file',
                    collection: collection,
                    contextId: contextId,
                    width: scaledWidth,
                    height: height && Math.round(height / scaleFactor),
                    alt: fileName,
                    __fileMimeType: mediaState.fileMimeType
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $krYZG.INSERT_MEDIA_VIA).EXTERNAL_UPLOAD) ?? false;
            };
            const insertExternalMediaSingle = ({ url: url, alt: alt, inputMethod: inputMethod })=>{
                const node = editorView.state.schema.nodes.media.create({
                    type: 'external',
                    url: url,
                    alt: alt,
                    __external: true
                });
                return api?.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $krYZG.INSERT_MEDIA_VIA).EXTERNAL_URL) ?? false;
            };
            const insertFile = ({ mediaState: mediaState, inputMethod: inputMethod, onMediaStateChanged: onMediaStateChanged })=>{
                const collection = mediaState.collection;
                return collection !== undefined ? api?.media.sharedState.currentState()?.insertFile(mediaState, onMediaStateChanged, inputMethod, (0, $krYZG.INSERT_MEDIA_VIA).LOCAL_UPLOAD) ?? false : false;
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e599553e0a965740$export$6a978a6c0eb24e84), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                closeMediaInsertPicker: ()=>editorView.dispatch((0, $f4981ec9ce58fcc3$export$e89adf8af9d31a9f)(editorView.state.tr)),
                insertMediaSingle: insertMediaSingle,
                insertExternalMediaSingle: insertExternalMediaSingle,
                insertFile: insertFile,
                isOnlyExternalLinks: config?.isOnlyExternalLinks,
                customizedUrlValidation: config?.customizedUrlValidation,
                customizedHelperMessage: config?.customizedHelperMessage
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'media-insert',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconImages), null),
                        isDisabledOffline: true,
                        action (insert) {
                            // Insert empty string to remove the typeahead raw text
                            // close the quick insert immediately
                            const tr = insert('');
                            api?.mediaInsert.commands.showMediaInsertPopup()({
                                tr: tr
                            });
                            api?.analytics?.actions?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).OPENED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PICKER_MEDIA,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                                    openedTab: $199f24a87788c875$var$getInitialMediaInsertTab(insertTabRegistry.getAll(), config?.isOnlyExternalLinks)
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["mediaInsertPlugin"] = $199f24a87788c875$export$922c51f87f6fe974;

});

parcelRegister("jeuMk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jVdlG = parcelRequire("jVdlG");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $8tXCb = parcelRequire("8tXCb");


var $5HBT9 = parcelRequire("5HBT9");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $lhCmf = parcelRequire("lhCmf");

const $0bd0a15a02ed16c1$var$IconCustomPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconCustomPanel() {
    const $ = (0, $bDgLe.c)(48);
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    let t0;
    if ($[0] !== iconThemed) {
        t0 = iconThemed({
            light: "#fff",
            dark: "#161A1D"
        });
        $[0] = iconThemed;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: t0
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== iconThemed) {
        t2 = iconThemed({
            light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
        });
        $[4] = iconThemed;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
            fill: t2
        });
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== iconThemed) {
        t4 = iconThemed({
            light: "#6E5DC6",
            dark: "#9F8FEF"
        });
        $[8] = iconThemed;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
            fill: t4
        });
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== iconThemed) {
        t6 = iconThemed({
            light: "#E34935",
            dark: "#EF5C48"
        });
        $[12] = iconThemed;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
            fill: t6
        });
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== iconThemed) {
        t8 = iconThemed({
            light: "#D97008",
            dark: "#F18D13"
        });
        $[16] = iconThemed;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
            fill: t8
        });
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== iconThemed) {
        t10 = iconThemed({
            light: "#E2B203",
            dark: "#E2B203"
        });
        $[20] = iconThemed;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
            fill: t10
        });
        $[22] = t10;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== iconThemed) {
        t12 = iconThemed({
            light: "#6A9A23",
            dark: "#82B536"
        });
        $[24] = iconThemed;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
            fill: t12
        });
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== iconThemed) {
        t14 = iconThemed({
            light: "#0055CC",
            dark: "#579DFF"
        });
        $[28] = iconThemed;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
            fill: t14
        });
        $[30] = t14;
        $[31] = t15;
    } else t15 = $[31];
    let t16;
    if ($[32] !== t11 || $[33] !== t13 || $[34] !== t15 || $[35] !== t5 || $[36] !== t7 || $[37] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0)"
        }, t5, t7, t9, t11, t13, t15);
        $[32] = t11;
        $[33] = t13;
        $[34] = t15;
        $[35] = t5;
        $[36] = t7;
        $[37] = t9;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== iconThemed) {
        t17 = iconThemed({
            light: "#fff",
            dark: "#fff"
        });
        $[39] = iconThemed;
        $[40] = t17;
    } else t17 = $[40];
    let t18;
    if ($[41] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "8",
            height: "8",
            fill: t17,
            transform: "translate(12 16)"
        })));
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    let t19;
    if ($[43] !== t1 || $[44] !== t16 || $[45] !== t18 || $[46] !== t3) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            focusable: "false",
            "aria-hidden": true
        }, t1, t3, t16, t18);
        $[43] = t1;
        $[44] = t16;
        $[45] = t18;
        $[46] = t3;
        $[47] = t19;
    } else t19 = $[47];
    return t19;
} : function IconCustomPanel() {
    const { iconThemed: iconThemed } = (0, $lhCmf.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: iconThemed({
            light: '#fff',
            dark: '#161A1D'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
        fill: iconThemed({
            light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
        fill: iconThemed({
            light: '#6E5DC6',
            dark: '#9F8FEF'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
        fill: iconThemed({
            light: '#E34935',
            dark: '#EF5C48'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
        fill: iconThemed({
            light: '#D97008',
            dark: '#F18D13'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
        fill: iconThemed({
            light: '#E2B203',
            dark: '#E2B203'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
        fill: iconThemed({
            light: '#6A9A23',
            dark: '#82B536'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
        fill: iconThemed({
            light: '#0055CC',
            dark: '#579DFF'
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8",
        height: "8",
        fill: iconThemed({
            light: '#fff',
            dark: '#fff'
        }),
        transform: "translate(12 16)"
    }))));
};
var $0bd0a15a02ed16c1$export$2e2bcd8739ae039 = $0bd0a15a02ed16c1$var$IconCustomPanel;


var $jGK9e = parcelRequire("jGK9e");


var $dX4zl = parcelRequire("dX4zl");


var $57Rmq = parcelRequire("57Rmq");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $2w79Z = parcelRequire("2w79Z");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");





var $45O09 = parcelRequire("45O09");


var $lqPdm = parcelRequire("lqPdm");


var $kCECX = parcelRequire("kCECX");





var $7Y8M5 = parcelRequire("7Y8M5");







const $53df13cea42d9a29$export$e58edb186cf54d62 = (nodeName)=>{
    return (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        'panel',
        'panel_c1'
    ].includes(nodeName) : nodeName === 'panel';
};
const $53df13cea42d9a29$export$24b1da61c87aac35 = (nodes)=>{
    const { panel: panel, panel_c1: panel_c1 } = nodes;
    return (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1
    ] : [
        panel
    ];
};
const $53df13cea42d9a29$export$ddbd7c123a514b96 = (state, selection)=>{
    return (0, $bjg0G.findSelectedNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection) || (0, $bjg0G.findParentNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection);
};
const $53df13cea42d9a29$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $jVdlG.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = (0, $ieeJu.expValEquals)('platform_editor_stricter_panelcolor_typecheck', 'isEnabled', true) ? typeof panelColor === 'string' && (0, $lqPdm.hexToEditorBackgroundPaletteColor)(panelColor) : panelColor && (0, $lqPdm.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const isCustomPanelWithColor = (0, $ieeJu.expValEquals)('platform_editor_stricter_panelcolor_typecheck', 'isEnabled', true) ? typeof panelColor === 'string' && isCustomPanel : panelColor && isCustomPanel;
    const style = [
        `${isCustomPanelWithColor ? `background-color: ${panelBackgroundColor};` : ''}`,
        // When table-in-panel is enabled, set --table-container-bg so that table
        // masking elements (sticky-header mask, column-controls wrapper) blend with
        // the custom panel background instead of showing opaque white.
        `${isCustomPanelWithColor && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `${0, $7Y8M5.akEditorTableContainerBg}: ${panelBackgroundColor};` : ''}`,
        `${!hasIcon && !(0, $ixfCV.fg)('platform_editor_nested_dnd_styles_changes') ? `padding-left: 12px;padding-right: 12px;` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $45O09.PanelSharedCssClassName).prefix}${!hasIcon && (0, $ixfCV.fg)('platform_editor_nested_dnd_styles_changes') ? ` ${(0, $45O09.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $jVdlG.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    // Required for parseDOM to correctly parse custom panel when NodeView DOM is copied directly
    // Schema's parseDOM expects data-panel-icon on all custom panels, not just ones with color
    if (isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-icon': panelIcon
    };
    if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) panelAttrs = {
        ...panelAttrs,
        'data-local-id': attrs.localId
    };
    const iconDiv = [
        'div',
        // EDITOR-266 This fixes an issue in LCM where if you have nested panels
        // The icon colour will be overridden by the parent panel style, this is used to create a more specific css selector
        {
            class: (0, $45O09.PanelSharedCssClassName).icon,
            'data-panel-type': panelType || (0, $jVdlG.PanelType).INFO
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $45O09.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $53df13cea42d9a29$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($53df13cea42d9a29$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $bjg0G.findParentNode)((node)=>$53df13cea42d9a29$export$e58edb186cf54d62(node.type.name))(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode?.node.copy();
        const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? oldPanelNode?.node.type ?? schema.nodes.panel : schema.nodes.panel;
        const newPanelNode = panelNodeType.create({
            ...clonedPanelNode?.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $kCECX.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $53df13cea42d9a29$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $kCECX.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $bjg0G.findParentNodeOfType)($53df13cea42d9a29$export$24b1da61c87aac35(newState.schema.nodes))(oldState.tr.selection);
    const isparentTypeDecision = (0, $bjg0G.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && isParentTypePanel?.node.childCount === 1 && (isparentTypeDecision?.node.childCount === 1 || isNodeTypeRuleOrCodeBlock));
};


function $0653049125c911cf$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $bjg0G.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $0653049125c911cf$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $0653049125c911cf$var$findParentNode(selection, nodeType);
    return parentNode && (0, $2w79Z.isEmptyNode)(schema)(parentNode);
}
function $0653049125c911cf$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup, extension: extension } = nodes;
            const panelNodeTypes = (0, $53df13cea42d9a29$export$24b1da61c87aac35)(nodes);
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType && (0, $53df13cea42d9a29$export$e58edb186cf54d62)(previousNodeType.name);
            const isParentNodeAPanel = (0, $53df13cea42d9a29$export$e58edb186cf54d62)(parentNodeType.name);
            const nodeBeforePanel = $previousPos?.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // identifies if new position after backspace is at the start of a non-bodied extension node
            const isPreviousPosAtExtension = $previousPos.nodeAfter?.type === extension;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel && !isPreviousPosAtExtension || panelNodeTypes.some((type)=>$0653049125c911cf$var$isInsideAnEmptyNode(selection, type, state.schema)) || (0, $bjg0G.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia && !isPreviousPosAtExtension || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel?.type?.spec?.isolating && (0, $bjg0G.hasParentNodeOfType)(panelNodeTypes)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $bjg0G.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (!(0, $53df13cea42d9a29$export$e58edb186cf54d62)(nodeType.name)) return false;
            return true;
        }
    };
    return (0, $44cyU.keymap)(keymaps);
}
var $0653049125c911cf$export$2e2bcd8739ae039 = $0653049125c911cf$export$e832373cff8dec22;






var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");








var $iwjSV = parcelRequire("iwjSV");














var $6OpMl = parcelRequire("6OpMl");

const $a6e94e2cea024cb0$var$EmojiNodeFunctional = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(22);
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    let t0;
    if ($[0] !== fallback || $[1] !== id || $[2] !== shortName) {
        t0 = {
            shortName: shortName,
            id: id,
            fallback: fallback
        };
        $[0] = fallback;
        $[1] = id;
        $[2] = shortName;
        $[3] = t0;
    } else t0 = $[3];
    const emojiId = t0;
    let t1;
    if ($[4] !== emojiProvider) {
        t1 = Promise.resolve(emojiProvider);
        $[4] = emojiProvider;
        $[5] = t1;
    } else t1 = $[5];
    const emojiProviderResolver = t1;
    if (allowTextFallback && !emojiProvider) {
        const t2 = fallback || shortName;
        const t3 = fallback || shortName;
        let t4;
        if ($[6] !== id || $[7] !== shortName || $[8] !== t2 || $[9] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": t2
            }, t3);
            $[6] = id;
            $[7] = shortName;
            $[8] = t2;
            $[9] = t3;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
    if (!emojiProvider) return null;
    const t2 = emojiProviderResolver;
    let t3;
    if ($[11] !== fallback || $[12] !== id || $[13] !== resourceConfig?.optimisticImageApi || $[14] !== shortName) {
        t3 = resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        });
        $[11] = fallback;
        $[12] = id;
        $[13] = resourceConfig?.optimisticImageApi;
        $[14] = shortName;
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== emojiId || $[17] !== fitToHeight || $[18] !== showTooltip || $[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: emojiId,
            emojiProvider: t2,
            showTooltip: showTooltip,
            fitToHeight: fitToHeight,
            optimistic: true,
            optimisticImageURL: t3,
            editorEmoji: true,
            renderUnicodeEmojiAsImage: false
        });
        $[16] = emojiId;
        $[17] = fitToHeight;
        $[18] = showTooltip;
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : (props)=>{
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $cozmU.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $cozmU.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName
    }, fallback || shortName);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true,
        renderUnicodeEmojiAsImage: false
    });
};
const $a6e94e2cea024cb0$var$EmojiNode = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers } = t0;
    let t1;
    if ($[0] !== allowTextFallback || $[1] !== emojiProvider || $[2] !== fallback || $[3] !== fitToHeight || $[4] !== id || $[5] !== providers || $[6] !== resourceConfig || $[7] !== shortName || $[8] !== showTooltip) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6e94e2cea024cb0$var$EmojiNodeFunctional, {
            allowTextFallback: allowTextFallback,
            shortName: shortName,
            id: id,
            fallback: fallback,
            fitToHeight: fitToHeight,
            showTooltip: showTooltip,
            resourceConfig: resourceConfig,
            emojiProvider: emojiProvider,
            providers: providers
        });
        $[0] = allowTextFallback;
        $[1] = emojiProvider;
        $[2] = fallback;
        $[3] = fitToHeight;
        $[4] = id;
        $[5] = providers;
        $[6] = resourceConfig;
        $[7] = shortName;
        $[8] = showTooltip;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6e94e2cea024cb0$var$EmojiNodeFunctional, {
        allowTextFallback: allowTextFallback,
        shortName: shortName,
        id: id,
        fallback: fallback,
        fitToHeight: fitToHeight,
        showTooltip: showTooltip,
        resourceConfig: resourceConfig,
        emojiProvider: emojiProvider,
        providers: providers
    });
};
const $a6e94e2cea024cb0$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($a6e94e2cea024cb0$var$EmojiNode);
var $a6e94e2cea024cb0$export$2e2bcd8739ae039 = $a6e94e2cea024cb0$var$_default_1;



var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");





var $aPdNQ = parcelRequire("aPdNQ");





var $dVbiN = parcelRequire("dVbiN");








// SVG path data extracted from panel icon components
const $2fed7b38d07e9fc1$var$PANEL_ICON_PATHS = {
    [(0, $jVdlG.PanelType).INFO]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z',
    [(0, $jVdlG.PanelType).NOTE]: 'M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z',
    [(0, $jVdlG.PanelType).SUCCESS]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z',
    [(0, $jVdlG.PanelType).WARNING]: 'M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z',
    [(0, $jVdlG.PanelType).ERROR]: 'M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z'
};
function $2fed7b38d07e9fc1$export$b4e58f62136fde82(panelType, container) {
    if (!panelType || !$2fed7b38d07e9fc1$var$PANEL_ICON_PATHS[panelType]) return null;
    const doc = container.ownerDocument;
    const svgNS = 'http://www.w3.org/2000/svg';
    // Create wrapper span (mimics PanelInfoIcon structure see editor-common/src/icons/shared/PanelInfoIcon.tsx)
    const span = doc.createElement('span');
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', `${panelType} panel`);
    // Create SVG element
    const svg = doc.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', svgNS);
    svg.setAttribute('role', 'presentation');
    svg.style.pointerEvents = 'none';
    // Create path element
    const path = doc.createElementNS(svgNS, 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute('d', $2fed7b38d07e9fc1$var$PANEL_ICON_PATHS[panelType]);
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    span.appendChild(svg);
    container.appendChild(span);
    return svg;
}


const $a2d4b5a427286cae$export$4641b622f6c36f58 = {
    info: (0, $f1UXy.PanelInfoIcon),
    success: (0, $f1UXy.PanelSuccessIcon),
    note: (0, $f1UXy.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))),
    warning: (0, $f1UXy.PanelWarningIcon),
    error: (0, $f1UXy.PanelErrorIcon),
    custom: (0, $f1UXy.PanelInfoIcon)
};
const $a2d4b5a427286cae$var$selector = (states)=>{
    return {
        emojiState: states.emojiState
    };
};
const $a2d4b5a427286cae$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const { emojiState: emojiState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'emoji'
    ], $a2d4b5a427286cae$var$selector);
    const emojiProvider = emojiState?.emojiProvider;
    if (allowCustomPanel && panelIcon && panelType === (0, $jVdlG.PanelType).CUSTOM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6e94e2cea024cb0$export$2e2bcd8739ae039), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $7Y8M5.akEditorCustomIconSize)
    });
    const Icon = $a2d4b5a427286cae$export$4641b622f6c36f58[panelType];
    return Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: `${panelType} panel`
    }) : null;
};
class $a2d4b5a427286cae$var$PanelNodeView {
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
    destroy() {
        const panelAttrs = this.node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $jVdlG.PanelType).INFO,
            (0, $jVdlG.PanelType).NOTE,
            (0, $jVdlG.PanelType).SUCCESS,
            (0, $jVdlG.PanelType).WARNING,
            (0, $jVdlG.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // Only remove Portal if it was used (for custom emoji panels)
        if (!(isStandardPanel && (0, $ieeJu.expValEquals)('platform_editor_vc90_transition_panel_icon', 'isEnabled', true))) this.nodeViewPortalProviderAPI.remove(this.key);
    }
    constructor(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory){
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.providerFactory = void 0;
        this.nodeViewPortalProviderAPI = void 0;
        this.pluginOptions = void 0;
        this.key = void 0;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.key = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $53df13cea42d9a29$export$4dbd81d91bb3604b)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.icon = this.dom.querySelector(`.${(0, $45O09.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        const panelAttrs = node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $jVdlG.PanelType).INFO,
            (0, $jVdlG.PanelType).NOTE,
            (0, $jVdlG.PanelType).SUCCESS,
            (0, $jVdlG.PanelType).WARNING,
            (0, $jVdlG.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // For standard panels (info, note, success, warning, error), render icon directly as native DOM
        // This avoids Portal rendering delays that cause flickering on SSR and page transitions
        if (isStandardPanel && (0, $ieeJu.expValEquals)('platform_editor_vc90_transition_panel_icon', 'isEnabled', true)) (0, $2fed7b38d07e9fc1$export$b4e58f62136fde82)(panelAttrs.panelType, this.icon);
        else this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a2d4b5a427286cae$export$2ba98455e5e9d756, {
                pluginInjectionApi: api,
                allowCustomPanel: pluginOptions.allowCustomPanel,
                panelAttributes: panelAttrs,
                providerFactory: this.providerFactory
            }), this.icon, this.key);
    }
}
const $a2d4b5a427286cae$export$544c25cc15cdca2 = (pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)=>(node, view, getPos)=>{
        return new $a2d4b5a427286cae$var$PanelNodeView(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory);
    };





const $9ca011f9b0d77a22$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('panelPlugin');



const $fcdfc49b894c1d9d$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api, nodeViewPortalProviderAPI)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $9ca011f9b0d77a22$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $53df13cea42d9a29$export$1c3f791fb2a5168)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $a2d4b5a427286cae$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory),
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                    panel_c1: (0, $a2d4b5a427286cae$export$544c25cc15cdca2)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)
                } : {}
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                'panel',
                'panel_c1'
            ] : [
                'panel'
            ], (target)=>!!target.closest(`.${(0, $45O09.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};






var $kSwu1 = parcelRequire("kSwu1");











var $dVKvM = parcelRequire("dVKvM");


var $a1ZzW = parcelRequire("a1ZzW");




const $b14b76f6df90ebf6$var$NODE_NAME = 'panel';
const $b14b76f6df90ebf6$var$PanelBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(tr.selection.$from) : tr.doc.type.schema.nodes.panel;
            const command = api?.blockMenu?.commands.transformNode(panelNodeType, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $b14b76f6df90ebf6$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $5HBT9.messages).panel));
};
const $b14b76f6df90ebf6$export$33a19cd537147781 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b14b76f6df90ebf6$var$PanelBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};












var $eEdSM = parcelRequire("eEdSM");


var $2xhuI = parcelRequire("2xhuI");

var $2DRge = parcelRequire("2DRge");





var $g6uqx = parcelRequire("g6uqx");


var $kQOs5 = parcelRequire("kQOs5");
const $ada50ba998f74379$export$4c05e6c3475702fb = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: "var(--ds-border, #0B120E24)"
    }));









var $fHs3z = parcelRequire("fHs3z");


var $5avUB = parcelRequire("5avUB");


var $iDfTs = parcelRequire("iDfTs");


var $bAlk9 = parcelRequire("bAlk9");


var $iDtkd = parcelRequire("iDtkd");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");




















const $1167f0e0875411c4$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        const panelNodeTypes = (0, $53df13cea42d9a29$export$24b1da61c87aac35)(nodes);
        let deleteTr = tr;
        if ((0, $bjg0G.findSelectedNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $bjg0G.removeSelectedNode)(tr);
        else if ((0, $bjg0G.findParentNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $bjg0G.removeParentNodeOfType)(panelNodeTypes)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $1167f0e0875411c4$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
            if (panelNode === undefined) return false;
            const newType = panelType;
            const previousType = panelNode.node.attrs.panelType;
            let newTr;
            const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelNode.node.type : nodes.panel;
            if (allowCustomPanel) {
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $45O09.getPanelTypeBackgroundNoTokens)(previousType);
                const previousIcon = panelNode.node.attrs.panelIcon;
                const previousIconId = panelNode.node.attrs.panelIconId;
                const previousIconText = panelNode.node.attrs.panelIconText;
                const newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                panelType: panelType
            });
            const payload = {
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $kCECX.NodeSelection) && (0, $53df13cea42d9a29$export$e58edb186cf54d62)(state.selection.node.type.name) ? newTr.setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };













var $dPtk6 = parcelRequire("dPtk6");














const $42ac95b32e1cc263$var$panelTitleAndIcon = {
    [(0, $jVdlG.PanelType).INFO]: {
        title: (0, $2DRge.panelMessages).info,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz)))({
            label: 'info-icon',
            color: "var(--ds-icon-information, #357DE8)"
        })
    },
    [(0, $jVdlG.PanelType).NOTE]: {
        title: (0, $2DRge.panelMessages).note,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDtkd)))({
            label: 'note-icon',
            color: "var(--ds-icon-discovery, #AF59E1)"
        })
    },
    [(0, $jVdlG.PanelType).SUCCESS]: {
        title: (0, $2DRge.panelMessages).success,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R)))({
            label: 'success-icon',
            color: "var(--ds-icon-success, #6A9A23)"
        })
    },
    [(0, $jVdlG.PanelType).WARNING]: {
        title: (0, $2DRge.panelMessages).warning,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1)))({
            label: 'warning-icon',
            color: "var(--ds-icon-warning, #E06C00)"
        })
    },
    [(0, $jVdlG.PanelType).ERROR]: {
        title: (0, $2DRge.panelMessages).error,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5avUB)))({
            label: 'error-icon',
            color: "var(--ds-icon-danger, #C9372C)"
        })
    },
    [(0, $jVdlG.PanelType).CUSTOM]: {
        title: (0, $2DRge.panelMessages).custom,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6)))({
            label: 'custom-icon'
        })
    }
};
const $42ac95b32e1cc263$export$b79ba0272604ac1c = ({ activePanelType: activePanelType, editorAnalyticsAPI: editorAnalyticsAPI, formatMessage: formatMessage })=>{
    const dropdownOptions = [
        {
            id: 'editor.panel.info',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).INFO].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).INFO),
            selected: activePanelType === (0, $jVdlG.PanelType).INFO,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).INFO].title)
        },
        {
            id: 'editor.panel.note',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).NOTE].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).NOTE),
            selected: activePanelType === (0, $jVdlG.PanelType).NOTE,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).NOTE].title)
        },
        {
            id: 'editor.panel.success',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).SUCCESS].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).SUCCESS),
            selected: activePanelType === (0, $jVdlG.PanelType).SUCCESS,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).SUCCESS].title)
        },
        {
            id: 'editor.panel.warning',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).WARNING].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).WARNING),
            selected: activePanelType === (0, $jVdlG.PanelType).WARNING,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).WARNING].title)
        },
        {
            id: 'editor.panel.error',
            icon: $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).ERROR].icon,
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).ERROR),
            selected: activePanelType === (0, $jVdlG.PanelType).ERROR,
            title: formatMessage($42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).ERROR].title)
        }
    ];
    const selectedPanelType = activePanelType || (0, $jVdlG.PanelType).INFO;
    const selectedTitleAndIcon = $42ac95b32e1cc263$var$panelTitleAndIcon[selectedPanelType] || $42ac95b32e1cc263$var$panelTitleAndIcon[(0, $jVdlG.PanelType).CUSTOM];
    return {
        id: 'panel-type-dropdown',
        testId: 'panel-type-dropdown-trigger',
        type: 'dropdown',
        options: dropdownOptions,
        showSelected: true,
        iconBefore: ()=>selectedTitleAndIcon.icon,
        title: formatMessage(selectedTitleAndIcon.title)
    };
};


const $9daf5d2579659285$export$f17692e562e3afad = {
    [(0, $jVdlG.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $jVdlG.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $jVdlG.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $jVdlG.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $jVdlG.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $jVdlG.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $9daf5d2579659285$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state, api)=>{
    const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // TODO: ED-14403 - investigate why these titles are not getting translated for the tooltips
    const items = areAllNewToolbarFlagsDisabled ? [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).INFO),
            selected: activePanelType === (0, $jVdlG.PanelType).INFO,
            title: formatMessage((0, $2DRge.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDtkd))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).NOTE),
            selected: activePanelType === (0, $jVdlG.PanelType).NOTE,
            title: formatMessage((0, $2DRge.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).SUCCESS),
            selected: activePanelType === (0, $jVdlG.PanelType).SUCCESS,
            title: formatMessage((0, $2DRge.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).WARNING),
            selected: activePanelType === (0, $jVdlG.PanelType).WARNING,
            title: formatMessage((0, $2DRge.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5avUB))),
            onClick: (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).ERROR),
            selected: activePanelType === (0, $jVdlG.PanelType).ERROR,
            title: formatMessage((0, $2DRge.panelMessages).error),
            tabIndex: null
        }
    ] : [
        (0, $42ac95b32e1cc263$export$b79ba0272604ac1c)({
            activePanelType: activePanelType,
            editorAnalyticsAPI: editorAnalyticsAPI,
            formatMessage: formatMessage
        }),
        ...Boolean(api?.toolbar) ? [] : [
            {
                type: 'separator'
            }
        ]
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $45O09.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $9daf5d2579659285$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $krYZG.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (panelNode === undefined) return false;
                const previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $krYZG.ACTION).CHANGED_ICON,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
                if (activePanelType === (0, $jVdlG.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $krYZG.ACTION).REMOVE_ICON,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payload)((0, $1167f0e0875411c4$export$1e9f13c739b39e00)(editorAnalyticsAPI)((0, $jVdlG.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $jVdlG.PanelType).CUSTOM ? activePanelColor || (0, $45O09.getPanelTypeBackgroundNoTokens)((0, $jVdlG.PanelType).INFO) : (0, $45O09.getPanelTypeBackgroundNoTokens)(activePanelType);
        const defaultPalette = (0, $ada50ba998f74379$export$4c05e6c3475702fb).find((item)=>item.value === panelColor) || {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Custom',
            value: panelColor,
            border: (0, $kQOs5.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $2DRge.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: (0, $ada50ba998f74379$export$4c05e6c3475702fb),
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $2DRge.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $jVdlG.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAlk9))), {
                        spacing: 'spacious',
                        label: ''
                    }),
                onClick: removeEmoji(),
                title: formatMessage((0, $2xhuI.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (areAllNewToolbarFlagsDisabled) {
        if (state) {
            items.push({
                type: 'separator'
            });
            items.push({
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: formatMessage,
                        nodeType: panelNodeType
                    }
                ]
            });
        }
        items.push({
            type: 'separator'
        }, {
            id: 'editor.panel.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    spacing: 'spacious',
                    label: ''
                }),
            onClick: (0, $1167f0e0875411c4$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration?.(panelNodeType, true),
            onMouseLeave: hoverDecoration?.(panelNodeType, false),
            onFocus: hoverDecoration?.(panelNodeType, true),
            onBlur: hoverDecoration?.(panelNodeType, false),
            title: formatMessage((0, $2xhuI.default).remove),
            tabIndex: null
        });
    } else {
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration?.(nodeType, true, className),
                onMouseLeave: hoverDecoration?.(nodeType, false, className),
                onFocus: hoverDecoration?.(nodeType, true, className),
                onBlur: hoverDecoration?.(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'panel-overflow-dropdown-trigger';
        const overflowMenuConfig = [
            {
                type: 'separator',
                fullHeight: true
            },
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: formatMessage((0, $2xhuI.default).copyToClipboard),
                        onClick: ()=>{
                            api?.core?.actions.execute(// @ts-ignore
                            api?.floatingToolbar?.commands.copyNode(panelNodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType, (0, $7Y8M5.akEditorSelectedNodeClassName))
                    },
                    {
                        title: formatMessage((0, $2xhuI.default).delete),
                        onClick: (0, $1167f0e0875411c4$export$8784bcc8bfa6de8d)(editorAnalyticsAPI),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    return items;
};
const $9daf5d2579659285$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $53df13cea42d9a29$export$ddbd7c123a514b96)(state);
    if (panelObject) {
        const nodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelObject.node.type : state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $jVdlG.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $9daf5d2579659285$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api?.decorations?.actions.hoverDecoration, api?.analytics?.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state, (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) ? api : undefined);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $bjg0G.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $2DRge.panelMessages).panelsGroup)
        };
    }
    return;
};


const $de4ab4eb6d060862$var$PANEL_NODE_NAME = 'panel';
const $de4ab4eb6d060862$var$panelPlugin = ({ config: { allowCustomPanel: allowCustomPanel = false, allowCustomPanelEdit: allowCustomPanelEdit = false } = {}, api: api })=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]
            },
            component: (0, $b14b76f6df90ebf6$export$33a19cd537147781)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($de4ab4eb6d060862$var$PANEL_NODE_NAME))
        }
    ]);
    return {
        name: 'panel',
        nodes () {
            if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) return [
                {
                    name: 'panel',
                    node: {
                        ...(0, $jVdlG.extendedPanelWithLocalId)(!!allowCustomPanel),
                        definingAsContext: true
                    }
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: {
                            ...(0, $jVdlG.extendedPanelC1WithLocalId)(!!allowCustomPanel),
                            definingAsContext: true
                        }
                    }
                ] : []
            ];
            return [
                {
                    name: 'panel',
                    node: (0, $jVdlG.extendedPanel)(!!allowCustomPanel)
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: (0, $jVdlG.extendedPanelC1)(!!allowCustomPanel)
                    }
                ] : []
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $fcdfc49b894c1d9d$export$ae829ec7b2625219)(dispatch, providerFactory, {
                            allowCustomPanel: allowCustomPanel,
                            allowCustomPanelEdit: allowCustomPanelEdit
                        }, api, nodeViewPortalProviderAPI)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $0653049125c911cf$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                return function(state, dispatch) {
                    const tr = $de4ab4eb6d060862$var$createPanelAction({
                        state: state,
                        attributes: {
                            panelType: (0, $jVdlG.PanelType).INFO
                        },
                        api: api,
                        inputMethod: inputMethod
                    });
                    if (!tr) return false;
                    if (dispatch) dispatch(tr);
                    return true;
                };
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertOptions = [
                    {
                        id: 'infopanel',
                        title: formatMessage((0, $5HBT9.messages).infoPanel),
                        keywords: [
                            'panel'
                        ],
                        description: formatMessage((0, $5HBT9.messages).infoPanelDescription),
                        priority: 800,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconPanel), null),
                        action (typeAheadInsert, state) {
                            return $de4ab4eb6d060862$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).INFO
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'notepanel',
                        title: formatMessage((0, $5HBT9.messages).notePanel),
                        description: formatMessage((0, $5HBT9.messages).notePanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconPanelNote), null),
                        action (typeAheadInsert, state) {
                            return $de4ab4eb6d060862$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).NOTE
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'successpanel',
                        title: formatMessage((0, $5HBT9.messages).successPanel),
                        description: formatMessage((0, $5HBT9.messages).successPanelDescription),
                        keywords: [
                            'tip'
                        ],
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconPanelSuccess), null),
                        action (typeAheadInsert, state) {
                            return $de4ab4eb6d060862$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).SUCCESS
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'warningpanel',
                        title: formatMessage((0, $5HBT9.messages).warningPanel),
                        description: formatMessage((0, $5HBT9.messages).warningPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconPanelWarning), null),
                        action (typeAheadInsert, state) {
                            return $de4ab4eb6d060862$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).WARNING
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    },
                    {
                        id: 'errorpanel',
                        title: formatMessage((0, $5HBT9.messages).errorPanel),
                        description: formatMessage((0, $5HBT9.messages).errorPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconPanelError), null),
                        action (typeAheadInsert, state) {
                            return $de4ab4eb6d060862$var$createPanelAction({
                                state: state,
                                attributes: {
                                    panelType: (0, $jVdlG.PanelType).ERROR
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    }
                ];
                if (allowCustomPanel && allowCustomPanelEdit) quickInsertOptions.push({
                    id: 'custompanel',
                    title: formatMessage((0, $5HBT9.messages).customPanel),
                    description: formatMessage((0, $5HBT9.messages).customPanelDescription),
                    priority: 1000,
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0bd0a15a02ed16c1$export$2e2bcd8739ae039), null),
                    action (typeAheadInsert, state) {
                        return $de4ab4eb6d060862$var$createPanelAction({
                            state: state,
                            attributes: {
                                panelType: (0, $jVdlG.PanelType).CUSTOM,
                                panelIcon: ':rainbow:',
                                panelIconId: '1f308',
                                panelIconText: "\uD83C\uDF08",
                                // Ignored via go/ees007
                                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                                // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                panelColor: '#E6FCFF'
                            },
                            api: api,
                            typeAheadInsert: typeAheadInsert
                        });
                    }
                });
                return quickInsertOptions;
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $9daf5d2579659285$export$86ce8f8241c20a3)(state, intl, {
                    allowCustomPanel: allowCustomPanel,
                    allowCustomPanelEdit: allowCustomPanelEdit
                }, providerFactory, api)
        }
    };
};
/**
 * Creates panel action and wrap selection transaction with analytics for the panel insertion.
 *
 * @example
 * const tr = createPanelAction({
 *   state: editorState,
 *   attributes: { panelType: 'info' },
 * });
 * if (tr) {
 *   applyTransaction(tr);
 * }
 */ function $de4ab4eb6d060862$var$createPanelAction({ state: state, attributes: attributes, api: api, typeAheadInsert: typeAheadInsert, inputMethod: inputMethod = (0, $krYZG.INPUT_METHOD).QUICK_INSERT }) {
    const panelNodeType = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.pickPanelTypeForInsertion)(state.selection.$from) : state.schema.nodes.panel;
    let tr;
    // If the selection is empty, we want to insert the panel on a new line
    if (state.selection.empty) {
        const node = panelNodeType.createAndFill({
            ...attributes
        });
        if (!node) return false;
        if (typeAheadInsert !== undefined) // If the type-ahead insert is provided, we should use that to insert the node
        tr = typeAheadInsert(node);
        else // Otherwise we can use insertSelectedItem to insert the node
        tr = (0, $8tXCb.insertSelectedItem)(node)(state, state.tr, state.selection.head)?.scrollIntoView();
    } else tr = (0, $dX4zl.createWrapSelectionTransaction)({
        state: state,
        type: panelNodeType,
        nodeAttributes: {
            ...attributes
        }
    });
    if (tr) api?.analytics?.actions.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PANEL,
        attributes: {
            inputMethod: inputMethod,
            panelType: attributes.panelType
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    return tr ?? false;
}
var $de4ab4eb6d060862$export$2e2bcd8739ae039 = $de4ab4eb6d060862$var$panelPlugin;
module.exports["default"] = $de4ab4eb6d060862$export$2e2bcd8739ae039;

});

parcelRegister("4Bdub", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $ixfCV = parcelRequire("ixfCV");


var $anBbz = parcelRequire("anBbz");


var $mW7G5 = parcelRequire("mW7G5");


var $krYZG = parcelRequire("krYZG");

var $fAWGo = parcelRequire("fAWGo");


var $eEdSM = parcelRequire("eEdSM");

var $a576dcc6a24ebd21$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
    return PastePluginActionTypes;
}({});



var $cI8RZ = parcelRequire("cI8RZ");



var $kCECX = parcelRequire("kCECX");

const $fda2da217123fc9d$export$2b71482310d8c520 = new (0, $kCECX.PluginKey)('paste-options');
var $fda2da217123fc9d$export$ec4e67a10e59fca = /*#__PURE__*/ function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
    return ToolbarDropdownOption;
}({});


const $feee454b9de5f38d$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $feee454b9de5f38d$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $feee454b9de5f38d$export$78dda1ebb9a1ea84 = 'text-highlight';
const $feee454b9de5f38d$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $feee454b9de5f38d$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $feee454b9de5f38d$export$220f0307408bc0c = 'akEditor';
const $feee454b9de5f38d$export$299d35c5583816ad = 'paste-options-testid';
const $feee454b9de5f38d$export$d1234a98f427930 = 'paste-options$';
const $feee454b9de5f38d$export$b7100f42dfe6c945 = 8;
const $feee454b9de5f38d$export$6b0e62d36c2a26b4 = 24;



const $63429698745499e9$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                showLegacyOptions: action.data.showLegacyOptions,
                pasteAncestorNodeNames: action.data.pasteAncestorNodeNames,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};


const $4f5b30d8bf5b9b95$var$dest = (0, $cI8RZ.pluginFactory)((0, $fda2da217123fc9d$export$2b71482310d8c520), (0, $63429698745499e9$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($4f5b30d8bf5b9b95$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $4f5b30d8bf5b9b95$export$656c7661095efe2e = $4f5b30d8bf5b9b95$var$dest.createPluginState;
const $4f5b30d8bf5b9b95$export$8d4021544bdece00 = $4f5b30d8bf5b9b95$var$dest.createCommand;
const $4f5b30d8bf5b9b95$export$f05434c51e3762e = $4f5b30d8bf5b9b95$var$dest.getPluginState;
const $4f5b30d8bf5b9b95$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $feee454b9de5f38d$export$d1234a98f427930));
    if (meta && meta.type === (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT) return true;
    return false;
};



var $6gBg9 = parcelRequire("6gBg9");


var $jv11C = parcelRequire("jv11C");


var $h6b2D = parcelRequire("h6b2D");


var $c9zHD = parcelRequire("c9zHD");


var $aPdNQ = parcelRequire("aPdNQ");





var $eOaGc = parcelRequire("eOaGc");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3c979cd9cda14083$var$ESCAPE_LINKS_URL_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/;
function $3c979cd9cda14083$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $3c979cd9cda14083$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        return str.match($3c979cd9cda14083$var$ESCAPE_LINKS_URL_REGEX) ? `<${str}>` : str;
    });
}
const $3c979cd9cda14083$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $3c979cd9cda14083$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $3c979cd9cda14083$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        const marks = node.marks?.map((mark)=>mark.type.name);
        hasLinkMark = marks?.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1ec7a1cc42b08d91$var$CODE_BLOCK_FENCE_REGEX = /```/;
const $1ec7a1cc42b08d91$export$f9baf8679201c53f = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $1ec7a1cc42b08d91$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection);
    if (!markdownSlice) return tr;
    $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $1ec7a1cc42b08d91$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $1ec7a1cc42b08d91$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $1ec7a1cc42b08d91$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $aPdNQ.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $aPdNQ.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $1ec7a1cc42b08d91$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eOaGc.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode?.type.createAndFill();
    const isLastNodeEmpty = emptyNodeReference?.nodeSize === lastInsertNode?.nodeSize;
    const isStepSplitingTarget = !lastInsertNode?.isLeaf && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kCECX.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1ec7a1cc42b08d91$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $eOaGc.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $kCECX.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $1ec7a1cc42b08d91$export$3f1f93abf0f3a57(text, schema, selection) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        let textInput = text;
        const textSplitByCodeBlock = textInput.split($1ec7a1cc42b08d91$var$CODE_BLOCK_FENCE_REGEX);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const atlassianMarkDownParser = new (0, $c9zHD.MarkdownTransformer)(schema, (0, $h6b2D.md));
        const doc = atlassianMarkDownParser.parse((0, $3c979cd9cda14083$export$8acd10161c5f8b07)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === doc.content.firstChild?.type;
        const canMergeOpenEnd = targetOpenEndNode.type === doc.content.lastChild?.type;
        const $start = (0, $kCECX.Selection).atStart(doc).$from;
        const $end = (0, $kCECX.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return (0, $6gBg9.normalizeMarkdownCodeBlockAttrsInSlice)(new (0, $aPdNQ.Slice)(doc.content, openStart, openEnd), schema);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}



const $d4c269fd41087652$export$1ad95a504fba561e = (lastContentPasted, selectedOption, showLegacyOptions = true, pasteAncestorNodeNames = [])=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text ?? '',
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos,
                showLegacyOptions: showLegacyOptions,
                pasteAncestorNodeNames: pasteAncestorNodeNames
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText) return tr;
        return (0, $1ec7a1cc42b08d91$export$60ca0c8603a51ef1)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, plaintextTransformer);
};
const $d4c269fd41087652$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize, invokedFrom)=>()=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).PASTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                type: (0, $fAWGo.PasteTypes).plain,
                content: (0, $fAWGo.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($d4c269fd41087652$export$ff80cd8c68a7a6ad());
    };
const $d4c269fd41087652$export$405f0689dadde83d = ()=>{
    return $d4c269fd41087652$export$3367fb592cb1ac64();
};
const $d4c269fd41087652$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText) return tr;
        return (0, $1ec7a1cc42b08d91$export$da9c2ff7c79a9eab)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, transformer);
};
const $d4c269fd41087652$export$849d50d444ed50f8 = (editorAnalyticsAPI, invokedFrom)=>()=>{
        const payloadCallback = (state)=>{
            const pastePluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
            return {
                action: (0, $krYZG.ACTION).PASTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                    type: (0, $fAWGo.PasteTypes).richText,
                    content: (0, $fAWGo.PasteContents).text,
                    pasteSize: pastePluginState.richTextSlice?.size || 0,
                    invokedFrom: invokedFrom
                }
            };
        };
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, payloadCallback)($d4c269fd41087652$export$50a682c7628ffa4e());
    };
const $d4c269fd41087652$export$f22e171f994ad9d1 = ()=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
        if (pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown) return tr;
        return (0, $1ec7a1cc42b08d91$export$f9baf8679201c53f)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown
            }
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction, markdownTransformer);
};
const $d4c269fd41087652$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize, invokedFrom)=>()=>{
        return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).PASTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
                type: (0, $fAWGo.PasteTypes).markdown,
                content: (0, $fAWGo.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($d4c269fd41087652$export$f22e171f994ad9d1());
    };
const $d4c269fd41087652$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIGHLIGHT_CONTENT
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$70777665aad0464c = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $a576dcc6a24ebd21$export$ad3c0356f902fd97).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $4f5b30d8bf5b9b95$export$8d4021544bdece00)(commandAction);
};
const $d4c269fd41087652$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(view.state);
    if (pluginState.showToolbar) $d4c269fd41087652$export$70777665aad0464c()(view.state, view.dispatch);
};



var $kpCD8 = parcelRequire("kpCD8");





var $8nvEM = parcelRequire("8nvEM");





const $7e1bf35df5b7b5d8$var$MODIFIER_KEYS = new Set([
    'Shift',
    'Control',
    'Alt',
    'Meta',
    // Cmd on Mac, Win on Windows
    'CapsLock',
    'NumLock',
    'ScrollLock',
    'Fn',
    'FnLock'
]);
function $7e1bf35df5b7b5d8$var$isModifierKey(event) {
    return $7e1bf35df5b7b5d8$var$MODIFIER_KEYS.has(event.key);
}
function $7e1bf35df5b7b5d8$export$ae829ec7b2625219(dispatch, options) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $fda2da217123fc9d$export$2b71482310d8c520),
        state: (0, $4f5b30d8bf5b9b95$export$656c7661095efe2e)(dispatch, {
            showToolbar: false,
            showLegacyOptions: false,
            pasteAncestorNodeNames: [],
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $8nvEM.DecorationSet).empty,
            richTextSlice: (0, $aPdNQ.Slice).empty,
            selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None
        }),
        view (_editorView) {
            return {
                update (_view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                blur: (view)=>{
                    if (options?.useNewPasteMenu) return false;
                    (0, $d4c269fd41087652$export$8b65e7aad6163588)(view);
                    return false;
                },
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $d4c269fd41087652$export$8b65e7aad6163588)
            },
            handleKeyDown: (view, event)=>{
                // Don't hide toolbar when pressing modifier keys alone (Ctrl, Shift, Alt, Meta/Cmd)
                if ($7e1bf35df5b7b5d8$var$isModifierKey(event)) return false;
                (0, $d4c269fd41087652$export$8b65e7aad6163588)(view);
                return false;
            },
            decorations: (state)=>{
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state) || {};
                const decorationSet = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state)?.highlightDecorationSet ?? (0, $8nvEM.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $8nvEM.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $feee454b9de5f38d$export$78dda1ebb9a1ea84)
                }, {
                    key: (0, $feee454b9de5f38d$export$d829547aa567b0f1)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}






const $29282488bd260ae9$var$hasTableNode = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};
const $29282488bd260ae9$var$isNotProse = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};
const $29282488bd260ae9$export$899f54ccaa7b18cb = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ($29282488bd260ae9$var$isNotProse(pastedText)) return;
    if ($29282488bd260ae9$var$hasTableNode(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $mW7G5.expVal)('platform_editor_paste_actions_menu', 'isEnabled', false);
    } catch  {
        // pasteStartPos may be out of bounds if the document changed between
        // when the paste was recorded and when this effect fires.
        return;
    }
};


// Remove this file when experiment 'platform_editor_paste_actions_menu_v2' is cleaned up.



const $ccabb917a6ff0a8f$export$44b7f57aaef7c0af = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};


const $6b89ac4b3810071f$export$71535a792a9ee562 = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};


const $471bf21fb11fd74a$export$3bc247e6ff3a4c32 = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ((0, $6b89ac4b3810071f$export$71535a792a9ee562)(pastedText)) return;
    if ((0, $ccabb917a6ff0a8f$export$44b7f57aaef7c0af)(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $mW7G5.expVal)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    } catch  {
        return;
    }
};












var $3nacY = parcelRequire("3nacY");

var $bFSJa = parcelRequire("bFSJa");


var $1jz5K = parcelRequire("1jz5K");

var $7XIuB = parcelRequire("7XIuB");


var $9Muxb = parcelRequire("9Muxb");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kwf4Z = parcelRequire("kwf4Z");








var $3IBFJ = parcelRequire("3IBFJ");





var $GErjr = parcelRequire("GErjr");





const $80d2dc5ef3c83ccc$export$208ad7410c805534 = (state, lastContentPasted)=>{
    /**
   * Conditions for not showing the toolbar:
   * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
   * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
   *    (grandParent node should be root doc for showing up the toolbar)
   * 3. Cursor is inside the codeblock.
   */ const $from = state.selection.$from;
    if ((0, $3c979cd9cda14083$export$ec154944314bb7c)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = $from.parent?.type;
    const grandParentNodeType = $from.node($from.depth - 1)?.type;
    if (grandParentNodeType && grandParentNodeType.name === state.schema.nodes.doc.name && parentNodeType.name !== state.schema.nodes.codeBlock?.name && !(0, $3c979cd9cda14083$export$6c3620a9f018c4e)(lastContentPasted.pasteSource) && !(0, $3c979cd9cda14083$export$2d7feffd198c797d)(lastContentPasted.pastedSlice) && !(0, $3c979cd9cda14083$export$e7b0e22080760bf0)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $80d2dc5ef3c83ccc$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $d4c269fd41087652$export$849d50d444ed50f8)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown,
            onClick: (0, $d4c269fd41087652$export$a1a13c805bf0cea1)(editorAnalyticsAPI, pluginState.plaintext.length)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText,
            onClick: (0, $d4c269fd41087652$export$c833704cd36ac295)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $feee454b9de5f38d$export$af443436fa5992cb),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($GErjr))),
        type: 'dropdown',
        testId: (0, $feee454b9de5f38d$export$299d35c5583816ad),
        title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $80d2dc5ef3c83ccc$var$onToggleHandler
    };
};
const $80d2dc5ef3c83ccc$var$onToggleHandler = (state, dispatch)=>{
    return (0, $d4c269fd41087652$export$405f0689dadde83d)()(state, dispatch);
};
const $80d2dc5ef3c83ccc$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
    const menu = $80d2dc5ef3c83ccc$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI);
    return {
        title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        className: (0, $feee454b9de5f38d$export$164821e1c3d789fd),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $80d2dc5ef3c83ccc$var$onPositionCalculated
    };
};
const $80d2dc5ef3c83ccc$var$onPositionCalculated = (editorView, _nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="${(0, $3IBFJ.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = toolbar?.offsetParent || editorView.dom;
    const offsetParentRect = offsetParent?.getBoundingClientRect();
    const offsetTop = offsetParentRect?.top || 0;
    const offsetLeft = offsetParentRect?.left || 0;
    const offsetScrollTop = offsetParent?.scrollTop || 0;
    const cursorHeight = $80d2dc5ef3c83ccc$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $80d2dc5ef3c83ccc$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = nodeAtFrom?.nodeType === Node.TEXT_NODE ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom.parentNode : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};



var $aKpkp = parcelRequire("aKpkp");

const $af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden = (component, componentsByKey)=>{
    if (component.isHidden?.()) return true;
    return (component.parents ?? []).some((parent)=>{
        const parentComponent = componentsByKey.get(parent.key);
        return parentComponent ? $af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden(parentComponent, componentsByKey) : false;
    });
};
const $af7ce99f0a6e1d0c$export$99cddee748d62c45 = (components, types = [
    'menu-item'
])=>{
    const componentsByKey = new Map(components.map((c)=>[
            c.key,
            c
        ]));
    return components.filter((c)=>types.includes(c.type)).filter((c)=>!$af7ce99f0a6e1d0c$var$isComponentOrAncestorHidden(c, componentsByKey)).map((c)=>c.key);
};
const $af7ce99f0a6e1d0c$export$159affd63ddd230e = (components)=>{
    return $af7ce99f0a6e1d0c$export$99cddee748d62c45(components).length > 0;
};


/* PasteActionsMenuContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $uyXFl = parcelRequire("uyXFl");


var $dQrHJ = parcelRequire("dQrHJ");


var $dQMlg = parcelRequire("dQMlg");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $cVdVi = parcelRequire("cVdVi");

const $f6633e8b9d56106e$export$d62a1f704dc41529 = 3000;
const $f6633e8b9d56106e$var$hasAsyncHidden = (component)=>typeof component.isAsyncHidden === 'function';
const $f6633e8b9d56106e$var$rejectOnTimeout = (promise, timeoutMs)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new Error('isAsyncHidden timeout')), timeoutMs);
    });
    return Promise.race([
        promise.finally(()=>{
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }),
        timeoutPromise
    ]);
};
const $f6633e8b9d56106e$var$evaluateComponentAsyncHidden = async (component, context)=>{
    try {
        const hidden = await $f6633e8b9d56106e$var$rejectOnTimeout(component.isAsyncHidden(context), $f6633e8b9d56106e$export$d62a1f704dc41529);
        return {
            key: component.key,
            hidden: hidden
        };
    } catch  {
        return {
            key: component.key,
            hidden: true
        };
    }
};
async function $f6633e8b9d56106e$export$1e23d15f3989d9b2(components, context) {
    const results = await Promise.all(components.filter($f6633e8b9d56106e$var$hasAsyncHidden).map((component)=>$f6633e8b9d56106e$var$evaluateComponentAsyncHidden(component, context)));
    return Object.fromEntries(results.map(({ key: key, hidden: hidden })=>[
            key,
            hidden
        ]));
}


const $a2f1cb9d719e236e$var$styles = {
    container: "_2rko12b0 _bfhk1bhr _16qs130s"
};
const $a2f1cb9d719e236e$var$pasteMenuSurface = {
    type: (0, $3nacY.PASTE_MENU).type,
    key: (0, $3nacY.PASTE_MENU).key
};
const $a2f1cb9d719e236e$export$41585964872b7c = ({ onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, components: components, contentRef: contentRef, pastedSlice: pastedSlice })=>{
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext)); // Extract the pasted URL (if the pasted content was a single smart link).
    // Uses the reactive pasted slice from the paste plugin state so pastedUrl
    // updates when paste state changes.
    const pastedUrl = (0, $cVdVi.getSingleSmartLinkUrlFromSlice)(pastedSlice); // Components with isAsyncHidden are hidden until the async check resolves.
    // This prevents flash-of-visible content for items that
    // should ultimately be hidden. A generation counter discards stale results.
    const [asyncHiddenResults, setAsyncHiddenResults] = (0, $cozmU.useState)(()=>{
        return Object.fromEntries(components.map((component)=>[
                component.key,
                true
            ]));
    });
    const generationRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const asyncComponents = [];
        for (const component of components)if (typeof component.isAsyncHidden === 'function') asyncComponents.push(component);
        if (asyncComponents.length === 0) {
            setAsyncHiddenResults({});
            return;
        } // Reset: mark all async components as hidden until this round resolves.
        const pending = {};
        for (const c of asyncComponents)pending[c.key] = true;
        setAsyncHiddenResults(pending);
        const generation = ++generationRef.current;
        const context = {
            pastedUrl: pastedUrl
        };
        (0, $f6633e8b9d56106e$export$1e23d15f3989d9b2)(asyncComponents, context).then((results)=>{
            // Discard if a newer effect has already started.
            if (generation === generationRef.current) setAsyncHiddenResults(results);
        });
    }, [
        components,
        pastedUrl
    ]);
    // SurfaceRenderer evaluates isHidden() itself on each component. Override
    // isHidden on async components so SurfaceRenderer sees the resolved value.
    const visibleComponents = components.map((component)=>{
        if (typeof component.isAsyncHidden !== 'function') // No async check — pass through unchanged.
        return component;
        const asyncResult = asyncHiddenResults[component.key];
        return {
            ...component,
            isHidden: ()=>{
                return asyncResult === true || Boolean(component.isHidden?.());
            }
        };
    });
    const mergedRef = (0, $cozmU.useCallback)((node)=>{
        setOutsideClickTargetRef?.(node);
        if (contentRef) contentRef.current = node;
    }, [
        setOutsideClickTargetRef,
        contentRef
    ]);
    if ((0, $ieeJu.expValEquals)('platform_editor_menu_radius_update', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQrHJ.ToolbarMenuContainer), {
        ref: mergedRef,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQMlg.SurfaceRenderer), {
        surface: $a2f1cb9d719e236e$var$pasteMenuSurface,
        components: visibleComponents
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        ref: mergedRef,
        xcss: $a2f1cb9d719e236e$var$styles.container,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQMlg.SurfaceRenderer), {
        surface: $a2f1cb9d719e236e$var$pasteMenuSurface,
        components: visibleComponents
    }));
};


const $af9b39dbd0229b2c$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $af9b39dbd0229b2c$var$isAgentMentionUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $af9b39dbd0229b2c$export$3d56f604f007aa63 = (slice)=>{
    if (!slice) return false;
    let hasAgentMention = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'mention' && $af9b39dbd0229b2c$var$isAgentMentionUserType(node.attrs.userType)) hasAgentMention = true;
    });
    return hasAgentMention;
};
const $af9b39dbd0229b2c$export$fa38ccb7191f761d = (slice)=>(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $af9b39dbd0229b2c$export$3d56f604f007aa63(slice);
const $af9b39dbd0229b2c$export$6b1ad80f8062f971 = (slice)=>(0, $mW7G5.expVal)('platform_editor_fix_link_paste_menu', 'isEnabled', false) && !(0, $aKpkp.isNotSingleLink)(slice ?? undefined);
function $af9b39dbd0229b2c$export$2562999169740ceb(editorView, pos) {
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(pos, editorView.domAtPos.bind(editorView));
        if (domRef instanceof HTMLElement) {
            // Empty blocks render a <br> placeholder whose bounding rect has no
            // meaningful dimensions (height ≈ 0). Using it as the Popup anchor
            // causes the menu to appear at an unexpected position. Walk up to the
            // parent block element so the Popup anchors correctly.
            if (domRef.nodeName === 'BR' && domRef.parentElement) return domRef.parentElement;
            return domRef;
        }
        return null;
    } catch  {
        return null;
    }
}
function $af9b39dbd0229b2c$export$203646a3dfbc94aa(editorView, pos) {
    const $pos = editorView.state.doc.resolve(pos);
    for(let depth = $pos.depth; depth > 0; depth--){
        if ($pos.node(depth).type.name === 'table') return $pos.after(depth);
    }
    return undefined;
}
function $af9b39dbd0229b2c$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos) {
    const endCoords = editorView.coordsAtPos(pasteEndPos);
    let bottom = endCoords.bottom;
    if (tableAfterPos !== undefined) {
        const afterCoords = editorView.coordsAtPos(tableAfterPos);
        bottom = Math.max(bottom, afterCoords.bottom);
    }
    return bottom;
}
function $af9b39dbd0229b2c$export$69f2182d2b29f39f(editorView, pos) {
    try {
        const $pos = editorView.state.doc.resolve(pos);
        // Walk up the document tree from the resolved position's innermost
        // node towards the root. $pos.node(depth) gives the ancestor at each
        // depth; $pos.start(depth) gives the position just inside that ancestor,
        // so `$pos.start(depth) - 1` is the position of the ancestor node itself
        // (which is what nodeDOM expects).
        for(let depth = $pos.depth; depth >= 0; depth--){
            const node = $pos.node(depth);
            if (node.isBlock) {
                const domNode = editorView.nodeDOM($pos.start(depth) - 1);
                if (domNode instanceof HTMLElement) return domNode;
                // depth 0 is the doc node — nodeDOM(–1) won't work, so try
                // the editor's own DOM element as a fallback.
                if (depth === 0 && editorView.dom instanceof HTMLElement) return editorView.dom;
            }
        }
    } catch  {
    // Position may be out of range after a concurrent edit — fall through.
    }
    return null;
}
function $af9b39dbd0229b2c$export$725e0e72f273d89c(editorView, pasteEndPos, targetElement, popupContentRef) {
    return (position)=>{
        const endCoords = editorView.coordsAtPos(pasteEndPos);
        const targetRect = targetElement.getBoundingClientRect();
        // Vertical: center the menu with the line at the paste end position.
        const lineHeight = endCoords.bottom - endCoords.top;
        const lineMidpoint = endCoords.top + lineHeight / 2;
        const menuHeight = popupContentRef.current?.getBoundingClientRect().height ?? lineHeight;
        const menuTop = lineMidpoint - menuHeight / 2;
        const topDelta = menuTop - (targetRect.top + targetRect.height);
        const adjustedTop = (position.top ?? 0) + topDelta;
        // Horizontal: position to the right of the cursor
        const leftDelta = endCoords.right - targetRect.right;
        const adjustedLeft = (position.left ?? 0) + leftDelta;
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
function $af9b39dbd0229b2c$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, targetElement, scrollableElement) {
    // Pre-compute once per render to avoid doc.resolve() on every scroll frame.
    const tableAfterPos = $af9b39dbd0229b2c$export$203646a3dfbc94aa(editorView, pasteEndPos);
    const blockAncestorDOM = $af9b39dbd0229b2c$export$69f2182d2b29f39f(editorView, pasteStartPos);
    return (position)=>{
        const startCoords = editorView.coordsAtPos(pasteStartPos);
        const endBottom = $af9b39dbd0229b2c$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos);
        const targetRect = targetElement.getBoundingClientRect();
        // ── Vertical adjustment ──────────────────────────────────────────
        // The Popup places the menu at the target's bottom edge by default.
        // We shift it up so it aligns with the paste start position.
        // Both coordinates are in viewport space, so the delta is offset-parent agnostic.
        const topDelta = startCoords.top - (targetRect.top + targetRect.height);
        let adjustedTop = (position.top ?? 0) + topDelta;
        // Sticky-top: clamp to the scroll container's top edge when the paste
        // start has scrolled above the visible area, but only while some pasted
        // content is still visible.
        if (scrollableElement) {
            const scrollContainerTop = scrollableElement.getBoundingClientRect().top;
            if (startCoords.top < scrollContainerTop && endBottom > scrollContainerTop) adjustedTop += scrollContainerTop - startCoords.top + (0, $feee454b9de5f38d$export$6b0e62d36c2a26b4);
        }
        // ── Horizontal adjustment ────────────────────────────────────────
        // When pasted content starts with a mark (bold, italic, link …) or
        // an inline node (emoji, smart link, inline image …),
        // findDomRefAtPos returns the narrow inline wrapper element. The
        // Popup's alignX="end" then places the menu at that element's right
        // edge instead of the content area's right edge. We correct this by
        // resolving the nearest block-level ProseMirror ancestor and
        // re-anchoring to its right edge.
        let adjustedLeft = position.left;
        if (blockAncestorDOM && blockAncestorDOM !== targetElement) {
            const blockRect = blockAncestorDOM.getBoundingClientRect();
            // Shift left by the difference between the block's right edge and
            // the inline target's right edge. This mirrors what alignX="end"
            // would have computed if the target were the block element.
            const leftDelta = blockRect.right - targetRect.right;
            adjustedLeft = (position.left ?? 0) + leftDelta;
        }
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
const $af9b39dbd0229b2c$export$8c1ff721ebf4b048 = ({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { lastContentPasted: lastContentPasted } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>({
            lastContentPasted: states.pasteState?.lastContentPasted
        }));
    const sliceForAgentMentionSuppression = lastContentPasted?.sourcePastedSlice;
    const shouldSuppressPasteActions = (0, $cozmU.useMemo)(()=>$af9b39dbd0229b2c$export$fa38ccb7191f761d(sliceForAgentMentionSuppression) || $af9b39dbd0229b2c$export$6b1ad80f8062f971(sliceForAgentMentionSuppression), [
        sliceForAgentMentionSuppression
    ]);
    const prevShowToolbarRef = (0, $cozmU.useRef)(false);
    const popupContentRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!lastContentPasted) {
            (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
            return;
        }
        if (shouldSuppressPasteActions) {
            (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
            return;
        }
        let selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None;
        if (!lastContentPasted.isPlainText) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
        else if (lastContentPasted.isShiftPressed) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
        else selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
        const $pos = editorView.state.doc.resolve(lastContentPasted.pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (lastContentPasted.pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const legacyVisible = (0, $80d2dc5ef3c83ccc$export$208ad7410c805534)(editorView.state, lastContentPasted);
        (0, $d4c269fd41087652$export$1ad95a504fba561e)(lastContentPasted, selectedOption, legacyVisible, pasteAncestorNodeNames)(editorView.state, editorView.dispatch);
    }, [
        lastContentPasted,
        shouldSuppressPasteActions,
        editorView
    ]);
    const { showToolbar: isToolbarShown, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            showToolbar: pluginState?.showToolbar ?? false,
            pasteStartPos: pluginState?.pasteStartPos ?? 0,
            pasteEndPos: pluginState?.pasteEndPos ?? 0
        };
    });
    const preventEditorFocusLoss = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        (0, $d4c269fd41087652$export$3367fb592cb1ac64)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((evt)=>{
        if (evt.target instanceof Element) {
            const isInsideNestedDropdown = evt.target.closest('[data-toolbar-nested-dropdown-menu]');
            if (isInsideNestedDropdown) return;
        }
        handleDismiss();
    }, [
        handleDismiss
    ]);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) handleDismiss();
    }, [
        handleDismiss
    ]);
    const shouldRenderToolbar = isToolbarShown && !shouldSuppressPasteActions;
    // Find the actual scroll container using the same utility the Popup's
    // stick prop uses internally. We pass this as the scrollableElement prop
    // so the Popup attaches its built-in scroll listener, which calls
    // scheduledUpdatePosition (RAF-throttled) on each scroll event — triggering
    // onPositionCalculated with fresh viewport coordinates.
    const overflowScrollParent = shouldRenderToolbar ? (0, $1jz5K.findOverflowScrollParent)(editorView.dom) : false;
    const effectiveScrollableElement = overflowScrollParent || scrollableElement;
    const pasteMenuComponents = api?.uiControlRegistry?.actions.getComponents((0, $3nacY.PASTE_MENU).key) ?? [];
    const anyComponentVisible = (0, $af7ce99f0a6e1d0c$export$159affd63ddd230e)(pasteMenuComponents);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- pasteMenuComponents changes by reference each render; filter is small (< 10 items)
    const aiMenuItems = pasteMenuComponents.filter((c)=>c.type === 'menu-item' && c.parents?.some((p)=>p.key === (0, $3nacY.AI_PASTE_MENU_SECTION).key));
    const visibleAiActionKeys = (0, $af7ce99f0a6e1d0c$export$99cddee748d62c45)(aiMenuItems, [
        'menu-item'
    ]);
    // Two positioning modes:
    // 1. Inline: no AI actions visible — menu appears to the right of the cursor,
    //    vertically centered with the text line.
    // 2. Block-anchored: AI actions are visible — menu appears at the right edge
    //    of the content block, aligned with paste start.
    const hasVisibleAiActions = visibleAiActionKeys.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (!prevShowToolbarRef.current && shouldRenderToolbar) editorAnalyticsAPI?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).OPENED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).PASTE_ACTIONS_MENU,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                visibleAiActions: visibleAiActionKeys
            }
        });
        prevShowToolbarRef.current = shouldRenderToolbar;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRenderToolbar,
        editorAnalyticsAPI
    ]);
    const useInlinePosition = !hasVisibleAiActions;
    if (!shouldRenderToolbar) return null;
    if (!anyComponentVisible) return null;
    const target = $af9b39dbd0229b2c$export$2562999169740ceb(editorView, useInlinePosition ? pasteEndPos : pasteStartPos);
    if (!target) return null;
    // Choose positioning strategy based on whether the menu appears inline
    // (right of cursor for short pastes) or anchored to the block ancestor
    // (right side of content area for longer pastes / AI actions).
    let positionCalculator;
    try {
        positionCalculator = useInlinePosition ? $af9b39dbd0229b2c$export$725e0e72f273d89c(editorView, pasteEndPos, target, popupContentRef) : $af9b39dbd0229b2c$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, target, effectiveScrollableElement);
    } catch (error) {
        positionCalculator = (position)=>({
                ...position,
                top: position.top ?? 0
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af9b39dbd0229b2c$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: effectiveScrollableElement,
        minPopupMargin: (0, $feee454b9de5f38d$export$b7100f42dfe6c945),
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        alignX: "end",
        alignY: useInlinePosition ? 'top' : 'bottom',
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ offset: [
            (0, $feee454b9de5f38d$export$b7100f42dfe6c945),
            0
        ],
        onPositionCalculated: positionCalculator,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFSJa.EditorToolbarProvider), {
        editorView: editorView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwf4Z.ToolbarDropdownMenuProvider), {
        isOpen: isToolbarShown,
        setIsOpen: handleSetIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2f1cb9d719e236e$export$41585964872b7c), {
        onMouseDown: preventEditorFocusLoss,
        onMouseEnter: handleMouseEnter,
        components: pasteMenuComponents,
        contentRef: popupContentRef,
        pastedSlice: lastContentPasted?.pastedSlice
    }))));
};


/* PasteMenuComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");










var $hVLmg = parcelRequire("hVLmg");




var $dVKvM = parcelRequire("dVKvM");

var $jgJIe = parcelRequire("jgJIe");

var $gk3KR = parcelRequire("gk3KR");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");










/* PasteOptionsDropdownButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $3vgx3 = parcelRequire("3vgx3");


var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $9eb8f6ded88088d3$export$fb556e4963c45caa = ({ children: children, elemBefore: elemBefore, elemAfter: elemAfter, label: label, testId: testId, tooltipContent: tooltipContent })=>{
    const trigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            ref: triggerProps.triggerRef,
            isSelected: triggerProps.isSelected,
            "aria-expanded": triggerProps['aria-expanded'],
            "aria-haspopup": triggerProps['aria-haspopup'],
            onClick: triggerProps.onClick,
            testId: testId,
            iconBefore: elemBefore,
            label: label
        }, elemAfter);
        if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent,
            position: "top"
        }, button);
        return button;
    }, [
        testId,
        elemBefore,
        elemAfter,
        label,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        trigger: trigger
    }, children);
};


const $9d04b982b9359ef2$var$nestedMenuStyles = {
    narrowSection: "_10gv1lit"
};
const $9d04b982b9359ef2$export$ca4999b34e9ed55a = (pasteType, selectedOption)=>{
    switch(pasteType){
        case 'rich-text':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
        case 'markdown':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
        case 'plain-text':
            return selectedOption === (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
        default:
            return false;
    }
};
const $9d04b982b9359ef2$var$PasteMenuItem = ({ api: api, pasteType: pasteType })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const editorAnalyticsAPI = api?.analytics?.actions;
    const { selectedOption: selectedOption, plaintextLength: plaintextLength, isPlainText: isPlainText } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            selectedOption: pluginState?.selectedOption ?? (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
            plaintextLength: pluginState?.plaintextLength ?? 0,
            isPlainText: pluginState?.isPlainText ?? false
        };
    });
    const getDefaultLabel = (0, $cozmU.useCallback)((type)=>{
        switch(type){
            case 'rich-text':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).richTextAction);
            case 'markdown':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).markdownAction);
            case 'plain-text':
                return intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).plainTextAction);
            default:
                return type;
        }
    }, [
        intl
    ]);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (!editorView) return;
        switch(pasteType){
            case 'rich-text':
                (0, $d4c269fd41087652$export$849d50d444ed50f8)(editorAnalyticsAPI, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
            case 'markdown':
                (0, $d4c269fd41087652$export$a1a13c805bf0cea1)(editorAnalyticsAPI, plaintextLength, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
            case 'plain-text':
                (0, $d4c269fd41087652$export$c833704cd36ac295)(editorAnalyticsAPI, plaintextLength, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
        }
    }, [
        editorView,
        editorAnalyticsAPI,
        plaintextLength,
        pasteType
    ]);
    if (pasteType === 'rich-text' && isPlainText) return null;
    const displayLabel = getDefaultLabel(pasteType);
    const isSelected = $9d04b982b9359ef2$export$ca4999b34e9ed55a(pasteType, selectedOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        testId: `paste-${pasteType}-menu-item`,
        hasNestedDropdownMenu: true
    }, displayLabel);
};
const $9d04b982b9359ef2$var$PasteOptionsNestedMenu = ({ children: children, hasVisibleAiActions: hasVisibleAiActions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteMenuActionsPasteAs);
    if (!hasVisibleAiActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9eb8f6ded88088d3$export$fb556e4963c45caa), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            size: "small",
            label: ""
        }),
        label: label,
        testId: "paste-options-nested-menu",
        tooltipContent: label
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($GErjr))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            size: "small",
            label: ""
        }),
        testId: "paste-options-nested-menu",
        text: label
    }, children);
};
const $9d04b982b9359ef2$var$getHasVisibleAiActions = (api)=>{
    const allComponents = api?.uiControlRegistry?.actions.getComponents((0, $3nacY.PASTE_MENU).key) ?? [];
    const aiMenuItems = allComponents.filter((c)=>c.type === 'menu-item' && c.parents?.some((p)=>p.key === (0, $3nacY.AI_PASTE_MENU_SECTION).key));
    return (0, $af7ce99f0a6e1d0c$export$99cddee748d62c45)(aiMenuItems, [
        'menu-item'
    ]).length > 0;
};
const $9d04b982b9359ef2$export$fc33052900084a9d = ({ api: api })=>[
        {
            type: (0, $3nacY.PASTE_MENU).type,
            key: (0, $3nacY.PASTE_MENU).key
        },
        {
            type: (0, $3nacY.PASTE_MENU_SECTION).type,
            key: (0, $3nacY.PASTE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: (0, $hVLmg.PASTE_MENU_RANK)[(0, $3nacY.PASTE_MENU_SECTION).key]
                }
            ],
            isHidden: ()=>{
                const pluginState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                return !(pluginState?.showLegacyOptions ?? false);
            },
            component: (props)=>{
                const hasVisibleAiActions = $9d04b982b9359ef2$var$getHasVisibleAiActions(api);
                if (!hasVisibleAiActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    padding: "space.100"
                }, props.children);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children);
            }
        },
        {
            type: (0, $3nacY.PASTE_NESTED_MENU).type,
            key: (0, $3nacY.PASTE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU_SECTION).type,
                    key: (0, $3nacY.PASTE_MENU_SECTION).key,
                    rank: (0, $hVLmg.PASTE_MENU_SECTION_RANK)[(0, $3nacY.PASTE_NESTED_MENU).key]
                }
            ],
            component: (props)=>{
                const hasVisibleAiActions = $9d04b982b9359ef2$var$getHasVisibleAiActions(api);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04b982b9359ef2$var$PasteOptionsNestedMenu, {
                    hasVisibleAiActions: hasVisibleAiActions
                }, props.children);
            }
        },
        {
            type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
            key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.PASTE_NESTED_MENU).type,
                    key: (0, $3nacY.PASTE_NESTED_MENU).key,
                    rank: (0, $hVLmg.PASTE_NESTED_MENU_RANK)[(0, $3nacY.PASTE_MENU_NESTED_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    xcss: (0, $k12R1.cx)($9d04b982b9359ef2$var$nestedMenuStyles.narrowSection)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children))
        },
        {
            key: (0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    pasteType: "rich-text"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_RICH_TEXT_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    pasteType: "markdown"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_MARKDOWN_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).key,
            type: (0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04b982b9359ef2$var$PasteMenuItem, {
                    api: api,
                    pasteType: "plain-text"
                }),
            parents: [
                {
                    key: (0, $3nacY.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $3nacY.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $hVLmg.PASTE_MENU_NESTED_SECTION_RANK)[(0, $3nacY.PASTE_PLAIN_TEXT_MENU_ITEM).key]
                }
            ]
        }
    ];






/**
 * Structural container nodes are nodes whose children are determined by
 * document structure (e.g. list items inside a list, rows inside a table)
 * rather than by content choice. Having different child types inside these
 * nodes does NOT indicate mixed content.
 *
 * All other container nodes (blockTaskItem, blockquote, panel,
 * expand, layoutColumn, tableCell, tableHeader, bodiedExtension, etc.) hold
 * rich block content, so mixed block children inside them IS mixing.
 */ const $fb56a651e80e808e$var$STRUCTURAL_CONTAINERS = new Set([
    'bulletList',
    'orderedList',
    'listItem',
    'taskList',
    'decisionList',
    'table',
    'tableRow'
]);
/**
 * Returns true if a node's direct block-level children include more than one
 * distinct node type — i.e. the children are "mixed".
 */ const $fb56a651e80e808e$var$hasBlockSiblings = (node)=>{
    const types = new Set();
    node.forEach((child)=>{
        if (child.isBlock) types.add(child.type.name);
    });
    return types.size > 1;
};
const $fb56a651e80e808e$export$a88d571ef2c6a298 = (slice)=>{
    if (!slice?.content?.size) return false;
    // Check the top-level children of the slice (Fragment has no parent Node,
    // so we construct a synthetic check by iterating slice.content directly).
    const topLevelTypes = new Set();
    slice.content.forEach((node)=>{
        if (node.isBlock) topLevelTypes.add(node.type.name);
    });
    if (topLevelTypes.size > 1) return true;
    // Walk every descendant node and check its direct block children for mixing,
    // skipping structural containers (their children are structural, not content).
    let mixed = false;
    slice.content.descendants((node)=>{
        if (mixed) return false; // short-circuit once found
        if ($fb56a651e80e808e$var$STRUCTURAL_CONTAINERS.has(node.type.name)) return true; // recurse into but don't check children for mixing
        if ($fb56a651e80e808e$var$hasBlockSiblings(node)) {
            mixed = true;
            return false;
        }
        return true;
    });
    return mixed;
};







/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is shorter than `minChars` characters.
 */ const $0154d77ff4d1c8aa$var$minCharsRule = (minChars)=>(context)=>context.getPlaintextLength() < minChars;
/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is longer than `maxChars` characters.
 */ const $0154d77ff4d1c8aa$var$maxCharsRule = (maxChars)=>(context)=>context.getPlaintextLength() > maxChars;
/**
 * A rule that hides the paste-menu button when the pasted content is plain
 * text (i.e. not rich-text / prose).
 */ const $0154d77ff4d1c8aa$var$notProseRule = (context)=>{
    // The pasted slice being empty or missing indicates plain-text paste.
    const slice = context.getPastedSlice();
    const pastedText = context.getPastedText();
    return slice === undefined && (0, $6b89ac4b3810071f$export$71535a792a9ee562)(pastedText);
};
/**
 * A rule that hides the paste-menu button when the pasted content contains a
 * table node as an ancestor at the insertion point.
 */ const $0154d77ff4d1c8aa$var$containsTableRule = (context)=>(0, $ccabb917a6ff0a8f$export$44b7f57aaef7c0af)(context.getPastedSlice());
/**
 * Returns a rule that hides the paste-menu button when any of the provided
 * node names appear in the ancestor list at the insertion point.
 */ const $0154d77ff4d1c8aa$var$excludedAncestorRule = (excludedNames)=>(context)=>context.getAncestorNodeNames().some((name)=>excludedNames.includes(name));
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * more than one node type (e.g. a mix of paragraphs and headings, or a table
 * with multiple cell types).
 */ const $0154d77ff4d1c8aa$var$hideIfMixedNodesRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return (0, $fb56a651e80e808e$export$a88d571ef2c6a298)(slice);
};
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * only a single node type (e.g. a single paragraph, or a table with only one cell type).
 * This is the inverse of `hideIfMixedNodesRule` and can be used in combination with it
 * to target pastes that contain either exactly one node type or more than one node type.
 */ const $0154d77ff4d1c8aa$var$hideIfSingleNodeRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return !(0, $fb56a651e80e808e$export$a88d571ef2c6a298)(slice);
};
/**
 * A rule that hides the paste-menu button when the paste source is NOT an
 * external application (i.e. the content was pasted from within the Fabric
 * editor or renderer rather than from a third-party source).
 */ const $0154d77ff4d1c8aa$var$notExternalPasteRule = (context)=>{
    const source = context.getPasteSource();
    return source === 'fabric-editor' || source === 'fabric-renderer';
};
/**
 * A rule that hides the paste-menu button when the pasted content is a single
 * standalone link — i.e. a bare URL link (text equals href) alone in a
 * paragraph, or a single inline card (smartlink) alone in a paragraph.
 *
 * Returns `true` (hidden) when the paste is NOT a single link — e.g. a link
 * with a custom label, a link accompanied by other text or sibling nodes, or
 * multiple paragraphs.
 */ const $0154d77ff4d1c8aa$var$notSingleLinkRule = (context)=>(0, $aKpkp.isNotSingleLink)(context.getPastedSlice());
/**
 * A rule that hides the paste-menu button when the pasted content IS a single
 * standalone link (the inverse of `notSingleLinkRule`).
 *
 * Use this to suppress buttons (e.g. Improve Writing, Fix Spelling) that
 * should not appear for single-link pastes.
 */ const $0154d77ff4d1c8aa$var$isSingleLinkRule = (context)=>!(0, $aKpkp.isNotSingleLink)(context.getPastedSlice());
/**
 * Combines multiple context-aware rules with short-circuit evaluation.
 * Returns `true` (hidden) as soon as the first rule returns `true`; returns
 * `false` only when all rules return `false`.
 * Context is injected by `createPasteMenuRuleFactories` — callers never
 * construct or pass a context object.
 */ const $0154d77ff4d1c8aa$var$allRules = (...rules)=>(context)=>{
        for (const rule of rules){
            if (rule(context)) return true;
        }
        return false;
    };
/**
 * Binds a `PasteMenuRuleWithContext` to a context supplier, returning a
 * no-argument `PasteMenuRule` that re-reads the context on every invocation.
 */ const $0154d77ff4d1c8aa$var$bind = (getContext, rule)=>()=>rule(getContext());
const $0154d77ff4d1c8aa$export$aa0980ac1f3ab236 = (getContext)=>({
        allRules: (...rules)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$allRules(...rules)),
        containsTableRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$containsTableRule),
        excludedAncestorRule: (excludedNames)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$excludedAncestorRule(excludedNames)),
        hideIfMixedNodesRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$hideIfMixedNodesRule),
        hideIfSingleNodeRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$hideIfSingleNodeRule),
        isSingleLinkRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$isSingleLinkRule),
        maxCharsRule: (maxChars)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$maxCharsRule(maxChars)),
        minCharsRule: (minChars)=>$0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$minCharsRule(minChars)),
        notExternalPasteRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notExternalPasteRule),
        notProseRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notProseRule),
        notSingleLinkRule: $0154d77ff4d1c8aa$var$bind(getContext, $0154d77ff4d1c8aa$var$notSingleLinkRule)
    });


const $d958b60311dd0d3f$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const getPasteMenuContext = ()=>({
            getCurrentPasteRange: ()=>{
                const state = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                if (!state) return undefined;
                return {
                    pasteEndPos: state.pasteEndPos,
                    pasteStartPos: state.pasteStartPos
                };
            },
            getCurrentPastedUrl: ()=>(0, $cVdVi.getSingleSmartLinkUrlFromSlice)(api?.paste?.sharedState.currentState()?.lastContentPasted?.pastedSlice)
        });
    if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) api?.uiControlRegistry?.actions.register((0, $9d04b982b9359ef2$export$fc33052900084a9d)({
        api: api
    }));
    if (config?.pasteMenuButtonsFactory && config?.usePopupBasedPasteActionsMenu) {
        const rules = (()=>{
            const getContext = ()=>{
                const pasteOptsState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                const pasteState = api?.paste?.sharedState.currentState();
                return {
                    getPlaintextLength: ()=>pasteOptsState?.plaintextLength ?? 0,
                    getAncestorNodeNames: ()=>pasteOptsState?.pasteAncestorNodeNames ?? [],
                    getPastedText: ()=>pasteState?.lastContentPasted?.text ?? '',
                    getPastedSlice: ()=>pasteState?.lastContentPasted?.pastedSlice,
                    getNodeTypes: ()=>[],
                    getPasteSource: ()=>pasteState?.lastContentPasted?.pasteSource
                };
            };
            return (0, $0154d77ff4d1c8aa$export$aa0980ac1f3ab236)(getContext);
        })();
        const productButtons = config.pasteMenuButtonsFactory(rules, getPasteMenuContext());
        api?.uiControlRegistry?.actions.register(productButtons);
    }
    return {
        name: 'pasteOptionsToolbarPlugin',
        actions: {
            getPasteMenuRules: ()=>{
                const getContext = ()=>{
                    const pasteOptsState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
                    const pasteState = api?.paste?.sharedState.currentState();
                    return {
                        getPlaintextLength: ()=>pasteOptsState?.plaintextLength ?? 0,
                        getAncestorNodeNames: ()=>pasteOptsState?.pasteAncestorNodeNames ?? [],
                        getPastedText: ()=>pasteState?.lastContentPasted?.text ?? '',
                        getPastedSlice: ()=>pasteState?.lastContentPasted?.pastedSlice,
                        getNodeTypes: ()=>[],
                        getPasteSource: ()=>pasteState?.lastContentPasted?.pasteSource
                    };
                };
                return (0, $0154d77ff4d1c8aa$export$aa0980ac1f3ab236)(getContext);
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $7e1bf35df5b7b5d8$export$ae829ec7b2625219)(dispatch, {
                            useNewPasteMenu: config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)
                        })
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isPlainText: false,
                pasteAncestorNodeNames: [],
                pasteEndPos: 0,
                pasteStartPos: 0,
                plaintextLength: 0,
                selectedOption: (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
                showLegacyOptions: false,
                showToolbar: false
            };
            const pluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(editorState);
            return {
                isPlainText: pluginState?.isPlainText ?? false,
                pasteAncestorNodeNames: pluginState?.pasteAncestorNodeNames ?? [],
                pasteEndPos: pluginState?.pasteEndPos ?? 0,
                pasteStartPos: pluginState?.pasteStartPos ?? 0,
                plaintextLength: pluginState?.plaintext.length ?? 0,
                selectedOption: pluginState?.selectedOption ?? (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None,
                showLegacyOptions: pluginState?.showLegacyOptions ?? false,
                showToolbar: pluginState?.showToolbar ?? false
            };
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                const pastePluginState = (0, $fda2da217123fc9d$export$2b71482310d8c520).getState(state);
                if (pastePluginState.showToolbar) return (0, $80d2dc5ef3c83ccc$export$6dd6ab35df8f7f86)(state, intl, editorAnalyticsAPI);
                return;
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!(config?.usePopupBasedPasteActionsMenu && ((0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) || [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control')))) || !editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af9b39dbd0229b2c$export$8c1ff721ebf4b048), {
                api: api,
                editorView: editorView,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        },
        usePluginHook ({ editorView: editorView }) {
            const { lastContentPasted: lastContentPasted } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
                'paste'
            ], (states)=>({
                    lastContentPasted: states.pasteState?.lastContentPasted
                }));
            (0, $cozmU.useEffect)(()=>{
                if (config?.usePopupBasedPasteActionsMenu && (0, $ixfCV.fg)('platform_editor_paste_actions_menu_exposure')) (0, $29282488bd260ae9$export$899f54ccaa7b18cb)(lastContentPasted?.text?.length ?? 0, editorView.state, lastContentPasted?.pasteStartPos, lastContentPasted?.pasteEndPos, lastContentPasted?.text, lastContentPasted?.pastedSlice);
                // These two need to be seperate to prevent them being dependant on each other
                if (config?.usePopupBasedPasteActionsMenu && (0, $ixfCV.fg)('platform_editor_paste_actions_menu_v2_exposure')) (0, $471bf21fb11fd74a$export$3bc247e6ff3a4c32)(lastContentPasted?.text?.length ?? 0, editorView.state, lastContentPasted?.pasteStartPos, lastContentPasted?.pasteEndPos, lastContentPasted?.text, lastContentPasted?.pastedSlice);
                if (config?.usePopupBasedPasteActionsMenu && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                if (!lastContentPasted) {
                    (0, $d4c269fd41087652$export$70777665aad0464c)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).PlainText;
                else selectedOption = (0, $fda2da217123fc9d$export$ec4e67a10e59fca).Markdown;
                if (!(0, $80d2dc5ef3c83ccc$export$208ad7410c805534)(editorView.state, lastContentPasted)) return;
                (0, $d4c269fd41087652$export$1ad95a504fba561e)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};
module.exports["pasteOptionsToolbarPlugin"] = $d958b60311dd0d3f$export$2eabbda136e01363;

});

parcelRegister("cVdVi", function(module, exports) {

var $aKpkp = parcelRequire("aKpkp");

const $0bb2adc6cbf32902$var$getUrlFromTextLinkNode = (node)=>{
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = node.marks[0].attrs?.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $0bb2adc6cbf32902$var$getUrlFromInlineCardNode = (node)=>{
    if (node.type.name !== 'inlineCard') return undefined;
    const url = node.attrs?.url;
    return typeof url === 'string' ? url : undefined;
};
const $0bb2adc6cbf32902$var$significantChildren = (node)=>{
    const children = [];
    node.content.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
const $0bb2adc6cbf32902$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || (0, $aKpkp.isNotSingleLink)(slice)) return undefined;
    if (slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $0bb2adc6cbf32902$var$getUrlFromTextLinkNode(topNode) ?? $0bb2adc6cbf32902$var$getUrlFromInlineCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $0bb2adc6cbf32902$var$significantChildren(topNode);
    if (children.length !== 1) return undefined;
    return $0bb2adc6cbf32902$var$getUrlFromTextLinkNode(children[0]) ?? $0bb2adc6cbf32902$var$getUrlFromInlineCardNode(children[0]);
};
module.exports["getSingleSmartLinkUrlFromSlice"] = $0bb2adc6cbf32902$export$6f4c320e305ef7dc;

});

parcelRegister("1K7sQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $59uj0 = parcelRequire("59uj0");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $kpCD8 = parcelRequire("kpCD8");


var $2w79Z = parcelRequire("2w79Z");


var $kCECX = parcelRequire("kCECX");


var $UL6rM = parcelRequire("UL6rM");




const $802e6d041f58903b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('placeholderTextPlugin');


const $0681165d98d72b2c$export$cf72668e5bda227e = (state, dispatch)=>{
    const tr = state.tr;
    if (!state.selection.empty) tr.deleteSelection();
    tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
        showInsertPanelAt: tr.selection.anchor
    });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
const $0681165d98d72b2c$export$478f9b36a44ad411 = (value)=>(state, dispatch)=>{
        dispatch(state.tr.replaceSelectionWith(state.schema.nodes.placeholder.createChecked({
            text: value
        })).setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
            showInsertPanelAt: null
        }).scrollIntoView());
        return true;
    };
const $0681165d98d72b2c$export$722fce80225bc19b = (state, dispatch)=>{
    dispatch(state.tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
        showInsertPanelAt: null
    }));
    return true;
};



var $aPdNQ = parcelRequire("aPdNQ");





var $8nvEM = parcelRequire("8nvEM");

class $74c182ba2c8524ee$export$9f5092f54ccc15c6 {
    map(mapping) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return new $74c182ba2c8524ee$export$9f5092f54ccc15c6(mapping.map(this.pos));
    }
    resolve(doc) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const $pos = doc.resolve(this.pos);
        return (0, $kCECX.Selection).near($pos);
    }
    constructor(pos){
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
}
class $74c182ba2c8524ee$export$37936ceed0f40761 extends (0, $kCECX.Selection) {
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.$head.pos));
        return new $74c182ba2c8524ee$export$37936ceed0f40761($pos);
    }
    static content() {
        return (0, $aPdNQ.Slice).empty;
    }
    eq(other) {
        return other instanceof $74c182ba2c8524ee$export$37936ceed0f40761 && other.head === this.head;
    }
    toJSON() {
        return {
            type: 'Cursor',
            pos: this.head
        };
    }
    static fromJSON(doc, json) {
        return new $74c182ba2c8524ee$export$37936ceed0f40761(doc.resolve(json.pos));
    }
    getBookmark() {
        return new $74c182ba2c8524ee$export$9f5092f54ccc15c6(this.anchor);
    }
    constructor($pos){
        super($pos, $pos);
    }
}
(0, $kCECX.Selection).jsonID('fake-text-cursor', $74c182ba2c8524ee$export$37936ceed0f40761);
const $74c182ba2c8524ee$export$b8cf92335d1aa4be = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection.empty) {
        const { selection: { $from: $from } } = state;
        dispatch(state.tr.setSelection(new $74c182ba2c8524ee$export$37936ceed0f40761($from)));
    }
};
const $74c182ba2c8524ee$export$b0a69583d8930ac5 = (state, dispatch)=>{
    if (state.selection instanceof $74c182ba2c8524ee$export$37936ceed0f40761) {
        const { $from: $from } = state.selection;
        dispatch(state.tr.setSelection(new (0, $kCECX.TextSelection)($from)));
    }
};
const $74c182ba2c8524ee$export$e3d497d0280bbada = (state)=>{
    if (!(state.selection instanceof $74c182ba2c8524ee$export$37936ceed0f40761)) return null;
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        (0, $8nvEM.Decoration).widget(state.selection.head, node, {
            key: 'Cursor'
        })
    ]);
};



var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");




const $9043b85d85dae09c$var$serializePlaceholderNode = (node)=>{
    const element = document.createElement('span');
    const browser = (0, $8dxef.getBrowserInfo)();
    element.classList.add('pm-placeholder');
    // the inline node api test suite requires the following class name
    element.classList.add('placeholderView-content-wrap');
    element.innerText = (0, $fngNp.ZERO_WIDTH_SPACE);
    const elementChildren = document.createElement('span');
    elementChildren.classList.add('pm-placeholder__text');
    elementChildren.dataset.placeholder = node.attrs.text;
    elementChildren.setAttribute('contenteditable', 'false');
    element.appendChild(elementChildren);
    if (browser.safari) element.appendChild(document.createTextNode((0, $fngNp.ZERO_WIDTH_SPACE)));
    else element.appendChild(document.createElement('wbr'));
    return element;
};
class $9043b85d85dae09c$export$442d0baedc2512a6 {
    stopEvent(e) {
        if (e.type === 'mousedown' && typeof this.getPos === 'function') {
            e.preventDefault();
            const { view: view } = this;
            const startNodePosition = this.getPos();
            if (typeof startNodePosition !== 'number') return false;
            const tr = view.state.tr;
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(startNodePosition)));
            view.dispatch(tr);
            if (!view.hasFocus()) window.requestAnimationFrame(()=>{
                view.focus();
            });
            return true;
        }
        return false;
    }
    ignoreMutation(record) {
        if (typeof this.getPos !== 'function' || record.type !== 'selection') return true;
        const { view: view, node: node } = this;
        const placeholderStartPosition = this.getPos();
        if (typeof placeholderStartPosition !== 'number') return false;
        const placeholderEndPosition = placeholderStartPosition + node.nodeSize;
        const selection = view.state.selection;
        // when the selection is set right after the placeholder.
        // we should let ProseMirror deal with this edge-case
        if (selection.from === placeholderEndPosition) return false;
        const isSelectionAtPlaceholder = selection.from === placeholderStartPosition;
        const isSelectionAfterlaceholder = selection.from > placeholderEndPosition;
        if (isSelectionAtPlaceholder || isSelectionAfterlaceholder) {
            const tr = view.state.tr;
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(placeholderEndPosition)));
            view.dispatch(tr);
            return true;
        }
        return true;
    }
    constructor(node, view, getPos){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = void 0;
        this.dom = $9043b85d85dae09c$var$serializePlaceholderNode(this.node);
        this.getPos = getPos;
    }
}






const $e608286830e672c2$export$fcfa1d7f51efd169 = (selection)=>{
    if (!(selection instanceof (0, $kCECX.TextSelection)) || !selection.$cursor) return false;
    const node = selection.$cursor.doc.nodeAt(selection.$cursor.pos);
    return node?.type.name === 'placeholder';
};






var $kSwu1 = parcelRequire("kSwu1");


var $WnqKg = parcelRequire("WnqKg");


var $6BleA = parcelRequire("6BleA");

/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7XIuB = parcelRequire("7XIuB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $0d8c43a0d52ffea3$export$34e0f9847d4c02dd = (height)=>/*#__PURE__*/ (0, $lOiVq.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? `${height}px` : undefined
    });


function $3a915050eccdd184$export$2e2bcd8739ae039({ children: children, target: target, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight = 40, onPositionCalculated: onPositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, className: className, absoluteOffset: absoluteOffset, alignX: alignX, alignY: alignY, zIndex: zIndex }) {
    if (!target) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        absoluteOffset: absoluteOffset,
        alignX: alignX,
        alignY: alignY,
        target: target,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        offset: offset,
        fitWidth: fitWidth,
        fitHeight: fitHeight,
        onPositionCalculated: onPositionCalculated
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $0d8c43a0d52ffea3$export$34e0f9847d4c02dd)(fitHeight),
        "data-testid": "popup-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children));
}


const $b441e757b9165293$var$getCursorHeightFrom = (node)=>parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
const $b441e757b9165293$export$5055c4a13011779 = (editorViewDom, popupsMountPoint)=>popupsMountPoint ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
    popupsMountPoint.offsetParent : // eslint-disable-next-line @atlaskit/editor/no-as-casting
    editorViewDom.offsetParent;
const $b441e757b9165293$export$dcb2d1671e2c93d4 = (node)=>// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    node.nodeType === Node.TEXT_NODE ? node.parentNode : node;
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */ const $b441e757b9165293$var$convertFixedCoordinatesToAbsolutePositioning = (coordinates, offsetParent, cursorHeight)=>{
    const { left: offsetParentLeft, top: offsetParentTop, height: offsetParentHeight } = offsetParent.getBoundingClientRect();
    return {
        left: (coordinates.left ?? 0) - offsetParentLeft,
        right: (coordinates.right ?? 0) - offsetParentLeft,
        top: (coordinates.top ?? 0) - (offsetParentTop - cursorHeight) + offsetParent.scrollTop,
        bottom: offsetParentHeight - ((coordinates.top ?? 0) - (offsetParentTop - cursorHeight) - offsetParent.scrollTop)
    };
};
const $b441e757b9165293$export$499dde0ed160b17d = (offsetParent, node, getCurrentFixedCoordinates)=>(position)=>{
        if (!offsetParent) return position;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = $b441e757b9165293$export$dcb2d1671e2c93d4(node);
        const cursorHeight = $b441e757b9165293$var$getCursorHeightFrom(target);
        const fixedCoordinates = getCurrentFixedCoordinates();
        const absoluteCoordinates = $b441e757b9165293$var$convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
        return {
            left: position.left ? absoluteCoordinates.left : undefined,
            right: position.right ? absoluteCoordinates.right : undefined,
            top: position.top ? absoluteCoordinates.top : undefined,
            bottom: position.bottom ? absoluteCoordinates.bottom : undefined
        };
    };


// eslint-disable-next-line @repo/internal/react/no-class-components
class $4d46e11f337bfddf$var$PlaceholderFloatingToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { getNodeFromPos: getNodeFromPos, showInsertPanelAt: showInsertPanelAt, editorViewDOM: editorViewDOM, popupsMountPoint: popupsMountPoint, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, popupsBoundariesElement: popupsBoundariesElement, intl: { formatMessage: formatMessage } } = this.props;
        const target = getNodeFromPos(showInsertPanelAt);
        const offsetParent = (0, $b441e757b9165293$export$5055c4a13011779)(editorViewDOM, popupsMountPoint);
        const getFixedCoordinates = ()=>getFixedCoordinatesFromPos(showInsertPanelAt);
        const handlePositionCalculated = (0, $b441e757b9165293$export$499dde0ed160b17d)(offsetParent, target, getFixedCoordinates);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a915050eccdd184$export$2e2bcd8739ae039), {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            target: (0, $b441e757b9165293$export$dcb2d1671e2c93d4)(target),
            onPositionCalculated: handlePositionCalculated,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            fitHeight: 32,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                12
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BleA.default), {
            placeholder: formatMessage((0, $WnqKg.placeholderTextMessages).placeholderTextPlaceholder),
            onSubmit: this.handleSubmit,
            onBlur: this.handleBlur,
            autoFocus: true,
            width: 300
        }));
    }
    constructor(...args){
        super(...args);
        this.handleSubmit = (value)=>{
            if (value) {
                this.props.insertPlaceholder(value);
                this.props.setFocusInEditor();
            } else this.props.hidePlaceholderFloatingToolbar();
        };
        this.handleBlur = ()=>{
            this.props.hidePlaceholderFloatingToolbar();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $4d46e11f337bfddf$var$_default_1 = (0, $kSwu1.injectIntl)($4d46e11f337bfddf$var$PlaceholderFloatingToolbar);
var $4d46e11f337bfddf$export$2e2bcd8739ae039 = $4d46e11f337bfddf$var$_default_1;


const $54cd7fd764d9ffe7$var$getOpenTypeAhead = (trigger, api)=>{
    const typeAheadHandler = api?.typeAhead?.actions?.findHandlerByTrigger(trigger);
    if (!typeAheadHandler || !typeAheadHandler.id) return null;
    return api?.typeAhead?.actions?.openAtTransaction({
        triggerHandler: typeAheadHandler,
        inputMethod: (0, $krYZG.INPUT_METHOD).KEYBOARD
    });
};
function $54cd7fd764d9ffe7$export$ae829ec7b2625219(dispatch, options, api) {
    const allowInserting = !!options.allowInserting;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $802e6d041f58903b$export$18d4026d1ea86bb1),
        state: {
            init: ()=>({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting
                }),
            apply: (tr, state)=>{
                const meta = tr.getMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1));
                if (meta && meta.showInsertPanelAt !== undefined) {
                    const newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting
                    };
                    dispatch((0, $802e6d041f58903b$export$18d4026d1ea86bb1), newState);
                    return newState;
                } else if (state.showInsertPanelAt) {
                    const newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting
                    };
                    dispatch((0, $802e6d041f58903b$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                return state;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            if (transactions.some((txn)=>txn.docChanged)) {
                const didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter === newState.selection.$head.nodeAfter;
                const adjacentNode = newState.selection.$head.nodeAfter;
                const adjacentNodePos = newState.selection.$head.pos;
                const placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode && adjacentNode.type === placeholderNodeType && didPlaceholderExistBeforeTxn) {
                    const { $head: $newHead } = newState.selection;
                    const { $head: $oldHead } = oldState.selection;
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    const cursorMoved = $oldHead.pos < $newHead.pos;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const nodeBeforeHasContent = !(0, $2w79Z.isNodeEmpty)($newHead.nodeBefore);
                    const nodeBeforeIsInline = $newHead.nodeBefore?.type.isInline;
                    if (cursorMoved && (nodeBeforeHasContent || nodeBeforeIsInline)) {
                        const { $from: $from, $to: $to } = (0, $kCECX.NodeSelection).create(newState.doc, adjacentNodePos);
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!(0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && (0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) return newState.tr.setSelection(new (0, $74c182ba2c8524ee$export$37936ceed0f40761)(newState.selection.$from));
            if ((0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(oldState).showInsertPanelAt && !(0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof (0, $74c182ba2c8524ee$export$37936ceed0f40761)) return newState.tr.setSelection(new (0, $kCECX.TextSelection)(newState.selection.$from));
            }
            return;
        },
        props: {
            decorations: (0, $74c182ba2c8524ee$export$e3d497d0280bbada),
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    const { state: state } = view;
                    if (event instanceof InputEvent && !event.isComposing && event.inputType === 'insertText' && (0, $e608286830e672c2$export$fcfa1d7f51efd169)(view.state.selection)) {
                        event.stopPropagation();
                        event.preventDefault();
                        const startNodePosition = state.selection.from;
                        const content = event.data || '';
                        const tr = view.state.tr;
                        tr.delete(startNodePosition, startNodePosition + 1);
                        const openTypeAhead = $54cd7fd764d9ffe7$var$getOpenTypeAhead(content, api);
                        if (openTypeAhead) openTypeAhead(tr);
                        else tr.insertText(content);
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            nodeViews: {
                placeholder: (node, view, getPos)=>new (0, $9043b85d85dae09c$export$442d0baedc2512a6)(node, view, getPos)
            }
        }
    });
}
function $54cd7fd764d9ffe7$var$ContentComponent({ editorView: editorView, dependencyApi: dependencyApi, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
    const { showInsertPanelAt: showInsertPanelAt } = (0, $3k5Tv.useSharedPluginStateWithSelector)(dependencyApi, [
        'placeholderText'
    ], (states)=>({
            showInsertPanelAt: states.placeholderTextState?.showInsertPanelAt
        }));
    const insertPlaceholderText = (value)=>(0, $0681165d98d72b2c$export$478f9b36a44ad411)(value)(editorView.state, editorView.dispatch);
    const hidePlaceholderToolbar = ()=>(0, $0681165d98d72b2c$export$722fce80225bc19b)(editorView.state, editorView.dispatch);
    const getNodeFromPos = (pos)=>editorView.domAtPos(pos).node;
    const getFixedCoordinatesFromPos = (pos)=>editorView.coordsAtPos(pos);
    const setFocusInEditor = ()=>editorView.focus();
    if (showInsertPanelAt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d46e11f337bfddf$export$2e2bcd8739ae039), {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorViewDOM: editorView.dom,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        getFixedCoordinatesFromPos: getFixedCoordinatesFromPos,
        getNodeFromPos: getNodeFromPos,
        hidePlaceholderFloatingToolbar: hidePlaceholderToolbar,
        showInsertPanelAt: showInsertPanelAt,
        insertPlaceholder: insertPlaceholderText,
        setFocusInEditor: setFocusInEditor
    });
    return null;
}
const $54cd7fd764d9ffe7$var$basePlaceholderTextPlugin = ({ api: api, config: options })=>({
        name: 'placeholderText',
        nodes () {
            return [
                {
                    name: 'placeholder',
                    node: (0, $59uj0.placeholder)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholderText',
                    plugin: ({ dispatch: dispatch })=>$54cd7fd764d9ffe7$export$ae829ec7b2625219(dispatch, options, api)
                }
            ];
        },
        actions: {
            showPlaceholderFloatingToolbar: $0681165d98d72b2c$export$cf72668e5bda227e
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { showInsertPanelAt: showInsertPanelAt, allowInserting: allowInserting } = (0, $802e6d041f58903b$export$18d4026d1ea86bb1).getState(editorState) || {
                showInsertPanelAt: null
            };
            return {
                showInsertPanelAt: showInsertPanelAt,
                allowInserting: !!allowInserting
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($54cd7fd764d9ffe7$var$ContentComponent, {
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                dependencyApi: api
            });
        }
    });
const $54cd7fd764d9ffe7$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (!options.allowInserting) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'placeholderText',
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderText),
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).placeholderTextDescription),
                    priority: 1400,
                    keywords: [
                        'placeholder'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
                            label: ""
                        }),
                    action (insert, state) {
                        const tr = state.tr;
                        tr.setMeta((0, $802e6d041f58903b$export$18d4026d1ea86bb1), {
                            showInsertPanelAt: tr.selection.anchor
                        });
                        const resolvedInputMethod = (0, $krYZG.INPUT_METHOD).QUICK_INSERT;
                        api?.analytics?.actions.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).INSERTED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
                            attributes: {
                                inputMethod: resolvedInputMethod
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK
                        })(tr);
                        return tr;
                    }
                }
            ]
    };
    return plugin;
};
const $54cd7fd764d9ffe7$var$placeholderTextPlugin = ({ config: options = {}, api: api })=>$54cd7fd764d9ffe7$var$decorateWithPluginOptions($54cd7fd764d9ffe7$var$basePlaceholderTextPlugin({
        config: options,
        api: api
    }), options, api);
var $54cd7fd764d9ffe7$export$2e2bcd8739ae039 = $54cd7fd764d9ffe7$var$placeholderTextPlugin;
module.exports["default"] = $54cd7fd764d9ffe7$export$2e2bcd8739ae039;

});

parcelRegister("2hEu6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2kGqi = parcelRequire("2kGqi");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $ixfCV = parcelRequire("ixfCV");





var $8tXCb = parcelRequire("8tXCb");


var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");





var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");

const $05985544cd07af13$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
	 * This is a workaround to get rid of the typeahead text when using quick insert
	 * Once we insert *nothing*, we get a new transaction, so we can use the new selection
	 * without considering the extra text after the `/` command.
	 **/ tr = state.tr.replaceWith(start, end, (0, $aPdNQ.Fragment).empty);
    tr = (0, $8tXCb.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    const resolvedInputMethod = (0, $ixfCV.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $krYZG.INPUT_METHOD).QUICK_INSERT;
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: resolvedInputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $05985544cd07af13$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $bjg0G.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $05985544cd07af13$export$718ed5cb714e84ae(state, start, end, (0, $krYZG.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
// eslint-disable-next-line require-unicode-regexp
const $05985544cd07af13$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX = /^(\-\-\-|\*\*\*)$/;
function $05985544cd07af13$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push((0, $d8RhQ.createRule)($05985544cd07af13$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX, (state, _match, start, end)=>$05985544cd07af13$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $d8RhQ.createRule)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`${(0, $3brWT.leafNodeReplacementCharacter)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $05985544cd07af13$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $05985544cd07af13$export$2e2bcd8739ae039 = $05985544cd07af13$export$568a7ed6897c4817;


const $5deaa86b10dd8648$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $05985544cd07af13$export$718ed5cb714e84ae)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };







var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


function $c2d8440543aebfe9$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.insertRule).common, (0, $5deaa86b10dd8648$export$439dcefd29ca03b3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.escape).common, ()=>true, list);
    return (0, $44cyU.keymap)(list);
}
var $c2d8440543aebfe9$export$2e2bcd8739ae039 = $c2d8440543aebfe9$export$e832373cff8dec22;


const $c741bb398d7047e7$export$7cc71f8da095a98d = ({ api: api })=>{
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $2kGqi.ruleWithLocalId) : (0, $2kGqi.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $5deaa86b10dd8648$export$439dcefd29ca03b3)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>(0, $05985544cd07af13$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>(0, $c2d8440543aebfe9$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconDivider), null),
                        action (insert, state, source) {
                            const tr = insert(state.schema.nodes.rule.createChecked());
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["rulePlugin"] = $c741bb398d7047e7$export$7cc71f8da095a98d;

});

parcelRegister("3VDvd", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $3brWT = parcelRequire("3brWT");

const $5897a92d13a27703$export$a86035451b36e0f9 = new (0, $kCECX.PluginKey)('scrollIntoViewPlugin');
/**
 * Determines if a transaction contains changes that should trigger scrolling into view.
 * This includes:
 * - Specific step types (Replace, ReplaceAround)
 */ const $5897a92d13a27703$var$hasRelevantChanges = (tr)=>{
    // Check if there are any steps that modified the document
    if (!tr.docChanged) return false;
    // Look for specific types of steps that should trigger scrolling
    const hasRelevantStep = tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    return hasRelevantStep;
};
const $5897a92d13a27703$var$createPlugin = ()=>new (0, $kpCD8.SafePlugin)({
        key: $5897a92d13a27703$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if (($5897a92d13a27703$var$hasRelevantChanges(tr) || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $3brWT.TEXT_INPUT_RULE_TRANSACTION_KEY)) && // ignore appended transactions as they should be treated as side effects
            tr.getMeta('appendedTransaction') === undefined) return newState.tr.scrollIntoView();
        }
    });
const $5897a92d13a27703$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$5897a92d13a27703$var$createPlugin()
                }
            ];
        }
    });
module.exports["scrollIntoViewPlugin"] = $5897a92d13a27703$export$750392944713b1a5;

});

parcelRegister("drevR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $PYwg9 = parcelRequire("PYwg9");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $gZpSA = parcelRequire("gZpSA");


var $eDtFr = parcelRequire("eDtFr");


var $2nOF5 = parcelRequire("2nOF5");





var $eEdSM = parcelRequire("eEdSM");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $ixfCV = parcelRequire("ixfCV");




const $b900a37c29c42ee1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('statusPlugin');


const $35c8ece4f44259bc$export$ac80046fa87f5a7a = {
    text: '',
    color: 'neutral'
};
const $35c8ece4f44259bc$export$42634a38572cebab = {
    text: '',
    color: 'neutral',
    style: 'mixedCase'
};
const $35c8ece4f44259bc$export$83bafcce64b36a62 = (statusNode, tr, annotationMarks)=>{
    const fragment = (0, $aPdNQ.Fragment).fromArray([
        statusNode,
        tr.doc.type.schema.text(' ', annotationMarks)
    ]);
    const insertable = (0, $bjg0G.canInsert)(tr.selection.$from, fragment);
    if (!insertable) {
        const parentSelection = (0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
        tr.insert(parentSelection.to, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, parentSelection.to + 1));
    } else tr.insert(tr.selection.from, fragment).setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
    return tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
        showStatusPickerAt: tr.selection.from,
        isNew: true
    }).scrollIntoView();
};
const $35c8ece4f44259bc$export$1cefe804e0e75f6d = (tr)=>{
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
    const statusNode = tr.doc.type.schema.nodes.status.createChecked({
        ...(0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $35c8ece4f44259bc$export$42634a38572cebab : $35c8ece4f44259bc$export$ac80046fa87f5a7a,
        localId: (0, $2nOF5.uuid).generate()
    }, null, annotationMarksForPos);
    return $35c8ece4f44259bc$export$83bafcce64b36a62(statusNode, tr, annotationMarksForPos);
};
const $35c8ece4f44259bc$export$84e57993298e69f2 = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR)=>({ tr: tr })=>{
            const statusTr = $35c8ece4f44259bc$export$1cefe804e0e75f6d(tr);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(statusTr);
            return statusTr;
        };
const $35c8ece4f44259bc$export$dd127eb7207846ef = (status)=>(state, dispatch)=>{
        const { schema: schema } = state;
        const selectedStatus = status ? Object.assign(status, {
            text: status.text.trim(),
            localId: status.localId || (0, $2nOF5.uuid).generate()
        }) : status;
        const statusProps = {
            ...(0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $35c8ece4f44259bc$export$42634a38572cebab : $35c8ece4f44259bc$export$ac80046fa87f5a7a,
            ...selectedStatus
        };
        let tr = state.tr;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
        if (!showStatusPickerAt) {
            // Same behaviour as quick insert (used in createStatus)
            const statusNode = schema.nodes.status.createChecked(statusProps);
            tr = $35c8ece4f44259bc$export$83bafcce64b36a62(statusNode, state.tr);
            if (dispatch) dispatch(tr);
            return true;
        }
        if (state.doc.nodeAt(showStatusPickerAt)) {
            tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps).setSelection((0, $kCECX.NodeSelection).create(tr.doc, showStatusPickerAt)).setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
                showStatusPickerAt: showStatusPickerAt
            }).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $35c8ece4f44259bc$export$2d82855a8f0dcacb = (editorAnalyticsAPI)=>(inputMethod, status)=>(0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).STATUS,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })($35c8ece4f44259bc$export$dd127eb7207846ef(status));
const $35c8ece4f44259bc$export$9bef27b5339b1a7a = (showStatusPickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            showStatusPickerAt: showStatusPickerAt,
            isNew: false
        }));
        return true;
    };
const $35c8ece4f44259bc$export$38345b9b03bc4599 = (showStatusPickerAt)=>({ tr: tr })=>{
        tr.replace(showStatusPickerAt, showStatusPickerAt + 1);
        return tr;
    };
const $35c8ece4f44259bc$export$89aebd528a1fddb6 = ()=>(state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            focusStatusInput: true
        });
        dispatch(tr);
        return true;
    };
const $35c8ece4f44259bc$var$handleClosingByArrows = (closingMethod, state, showStatusPickerAt, tr)=>{
    if (closingMethod === 'arrowLeft') // put cursor right before status Lozenge
    tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt), -1));
    else if (closingMethod === 'arrowRight') // put cursor right after status Lozenge
    tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 1)));
};
const $35c8ece4f44259bc$export$cdfbbd5b38df803 = (closingPayload)=>(editorView)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
        const { closingMethod: closingMethod } = closingPayload || {};
        if (!showStatusPickerAt) return;
        const statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
        if (!statusNode) return;
        let tr = state.tr;
        tr = tr.setMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), {
            showStatusPickerAt: null,
            focusStatusInput: false,
            isNew: false
        });
        if (closingMethod) $35c8ece4f44259bc$var$handleClosingByArrows(closingMethod, state, showStatusPickerAt, tr);
        else if (statusNode.attrs.text) // still has content - keep content
        // move selection after status if selection did not change
        {
            if (tr.selection.from === showStatusPickerAt) tr = tr.setSelection((0, $kCECX.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 2)));
        } else // no content - remove node
        tr = tr.delete(showStatusPickerAt, showStatusPickerAt + 1);
        dispatch(tr);
        editorView.focus();
    };






var $44cyU = parcelRequire("44cyU");









const $e5fba860dcc119fa$export$ae039c0c89d3061 = (selection)=>{
    if (selection && selection instanceof (0, $kCECX.NodeSelection)) {
        const nodeSelection = selection;
        if (nodeSelection.node.type.name === 'status') return selection.node.attrs || null;
    }
    return null;
};
const $e5fba860dcc119fa$export$4e209830f320e9a = (node)=>node && (node.text && node.text.trim().length === 0 || node.text === '');
const $e5fba860dcc119fa$export$9a35f63e5088c6ab = (tr, pos)=>tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, tr.mapping.map(pos)));


function $52f20a93e5d9fb1b$export$e832373cff8dec22() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.enter).common, $52f20a93e5d9fb1b$var$consumeKeyEvent, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.tab).common, (state, dispatch)=>{
        const statusPluginState = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state);
        const isStatusNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node.type === state.schema.nodes.status : false;
        if (!isStatusNode) return false;
        if (statusPluginState?.showStatusPickerAt) {
            (0, $35c8ece4f44259bc$export$89aebd528a1fddb6)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
// consume event to prevent status node problems with positioning and selection
const $52f20a93e5d9fb1b$var$consumeKeyEvent = (state, _dispatch)=>!!(0, $e5fba860dcc119fa$export$ae039c0c89d3061)(state.tr.selection);
var $52f20a93e5d9fb1b$export$2e2bcd8739ae039 = $52f20a93e5d9fb1b$export$e832373cff8dec22;



var $kpCD8 = parcelRequire("kpCD8");


var $2w79Z = parcelRequire("2w79Z");





var $4rQbz = parcelRequire("4rQbz");








var $8dxef = parcelRequire("8dxef");


var $8Dx7s = parcelRequire("8Dx7s");


var $fngNp = parcelRequire("fngNp");




// eg. Version/4.0 Chrome/95.0.4638.50
const $32a8240ea4dc6188$var$isAndroidChromium = // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
typeof window !== 'undefined' && /Version\/.* Chrome\/.*/u.test(window.navigator.userAgent);
const $32a8240ea4dc6188$export$5318aa2f7ab92c01 = (node)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    const { text: text, color: color, style: style, localId: localId } = node.attrs;
    const editorNodeWrapperAttrs = {
        class: 'statusView-content-wrap inlineNodeView',
        'data-testid': 'statusContainerView',
        'data-prosemirror-node-name': 'status',
        localid: localId,
        // Required for parseDOM to correctly parse status when NodeView DOM is copied directly
        'data-node-type': 'status',
        'data-color': color,
        'data-text': text // Text stored as attribute for parseDOM extraction
    };
    const statusElementAttrs = {
        style: (0, $8Dx7s.convertToInlineCss)($32a8240ea4dc6188$var$isAndroidChromium ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'inline-block !important',
            verticalAlign: 'middle'
        } : {}),
        class: 'status-lozenge-span',
        'data-node-type': 'status',
        'data-color': color,
        'data-style': style
    };
    const lozengeWrapperAttrs = {
        class: 'lozenge-wrapper'
    };
    const lozengeTextAttrs = {
        class: 'lozenge-text',
        style: (0, $8Dx7s.convertToInlineCss)({
            ...(0, $ixfCV.fg)('platform-lozenge-custom-letterspacing') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                letterSpacing: '0.165px'
            } : {},
            ...style !== 'mixedCase' && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                textTransform: 'uppercase'
            } : {}
        })
    };
    return [
        'span',
        editorNodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            statusElementAttrs,
            [
                'span',
                lozengeWrapperAttrs,
                [
                    'span',
                    lozengeTextAttrs,
                    text
                ]
            ]
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};


class $3062ceff56f48f4a$export$54e825089e34a876 {
    setPlaceholder() {
        if (this.textContainer && this.domElement) {
            this.textContainer.textContent = this.intl.formatMessage((0, $4rQbz.messages).placeholder);
            this.domElement.style.setProperty('opacity', '0.83');
        }
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        if (node.type !== this.node.type) return false;
        if (this.textContainer && node.attrs.text !== this.node.attrs.text) {
            this.textContainer.textContent = node.attrs.text;
            // Also update data-text on outer wrapper for parseDOM extraction when copying
            this.domElement?.setAttribute('data-text', node.attrs.text);
        }
        if (this.textContainer && node.attrs.style !== this.node.attrs.style && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) this.textContainer.style.textTransform = node.attrs.style !== 'mixedCase' ? 'uppercase' : '';
        if (node.attrs.color !== this.node.attrs.color) {
            this.box?.setAttribute('data-color', node.attrs.color);
            // Also update data-color on outer wrapper for parseDOM extraction when copying
            this.domElement?.setAttribute('data-color', node.attrs.color);
        }
        if (!node.attrs.text) this.setPlaceholder();
        if (node.attrs.text && this.domElement) this.domElement.style.setProperty('opacity', '1');
        this.node = node;
        return true;
    }
    /**
   *
   * @param node
   * @param intl
   * @example
   */ constructor(node, intl){
        this.dom = void 0;
        this.domElement = void 0;
        this.box = null;
        this.textContainer = null;
        this.node = void 0;
        this.intl = void 0;
        this.node = node;
        this.intl = intl;
        const spec = (0, $32a8240ea4dc6188$export$5318aa2f7ab92c01)(node);
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if (this.domElement) {
            this.box = this.domElement.querySelector('.status-lozenge-span');
            this.textContainer = this.domElement.querySelector('.lozenge-text');
        }
        if (!node.attrs.text) this.setPlaceholder();
    }
}




const $0d68e47196c4702b$var$createPlugin = (pmPluginFactoryParams, options)=>new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    isNew: false,
                    showStatusPickerAt: null,
                    focusStatusInput: false
                }),
            apply (tr, state, oldEditorState) {
                const meta = tr.getMeta((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.showStatusPickerAt);
                    const showStatusPickerAt = deleted ? null : pos;
                    const newState = {
                        ...state,
                        showStatusPickerAt: showStatusPickerAt
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                if (tr.selectionSet) {
                    // Change in selection, while status picker was open, update state, if required.
                    const selectionFrom = tr.selection.from;
                    const nodeAtSelection = tr.doc.nodeAt(selectionFrom);
                    let showStatusPickerAt = null;
                    if (nodeAtSelection && nodeAtSelection.type === oldEditorState.schema.nodes.status && tr.selection instanceof (0, $kCECX.NodeSelection)) showStatusPickerAt = selectionFrom;
                    if (showStatusPickerAt !== state.showStatusPickerAt) {
                        const newState = {
                            ...state,
                            isNew: false,
                            showStatusPickerAt: showStatusPickerAt,
                            focusStatusInput: false
                        };
                        pmPluginFactoryParams.dispatch((0, $b900a37c29c42ee1$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                return state;
            }
        },
        filterTransaction: (tr, state)=>{
            // if it is a selection change transaction, and selection changes from node to text
            if (tr.selectionSet && !tr.steps.length && tr.isGeneric && tr.selection instanceof (0, $kCECX.TextSelection) && state.selection instanceof (0, $kCECX.NodeSelection)) {
                const { isNew: isNew, showStatusPickerAt: showStatusPickerAt } = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state) || {};
                const nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                // prevent changing node selection to text selection on dom change right after inserting status
                // if newly selected status is selected with status picker opened
                if (isNew && showStatusPickerAt && nodeAtSelection && nodeAtSelection.type === state.schema.nodes.status) return false;
            }
            return true;
        },
        appendTransaction: (transactions, oldEditorState, newEditorState)=>{
            let changed = false;
            const tr = newEditorState.tr;
            /**
			 * When user start creating status, and, when users navigates away
			 *  while empty, then we want to remove empty ("set a status") status.
			 * But when transaction to add empty status happens from undo/redo
			 *  we don't want to remove it.
			 */ if (transactions.find((tr)=>tr.selectionSet && !tr.getMeta((0, $2w79Z.pmHistoryPluginKey)))) {
                const oldStatus = (0, $e5fba860dcc119fa$export$ae039c0c89d3061)(oldEditorState.selection);
                const newStatus = (0, $e5fba860dcc119fa$export$ae039c0c89d3061)(newEditorState.selection);
                if (oldStatus && (newStatus && oldStatus.localId !== newStatus.localId || !newStatus)) {
                    if ((0, $e5fba860dcc119fa$export$4e209830f320e9a)(oldStatus)) {
                        const pos = oldEditorState.selection.from;
                        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + 1));
                        changed = true;
                    }
                }
            }
            return changed ? tr : undefined;
        },
        key: (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1),
        props: {
            nodeViews: {
                status: (node)=>{
                    return new (0, $3062ceff56f48f4a$export$54e825089e34a876)(node, pmPluginFactoryParams.getIntl());
                }
            }
        }
    });
var $0d68e47196c4702b$export$2e2bcd8739ae039 = $0d68e47196c4702b$var$createPlugin;







var $4y8CY = parcelRequire("4y8CY");








/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $lzgC6 = parcelRequire("lzgC6");


var $haNN4 = parcelRequire("haNN4");





var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $3v5aK = parcelRequire("3v5aK");


var $7Y8M5 = parcelRequire("7Y8M5");




/* StatusPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $4yg9g = parcelRequire("4yg9g");







/* color-palette.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $IQ4Dz = parcelRequire("IQ4Dz");




/* color.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eh6Ml = parcelRequire("eh6Ml");


var $hBYtq = parcelRequire("hBYtq");





var $jDboD = parcelRequire("jDboD");




const $65a3acb62cce22b1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    neutralColor: {
        id: "fabric.status.color.grey",
        defaultMessage: "Grey"
    },
    purpleColor: {
        id: "fabric.status.color.purple",
        defaultMessage: "Purple"
    },
    blueColor: {
        id: "fabric.status.color.blue",
        defaultMessage: "Blue"
    },
    redColor: {
        id: "fabric.status.color.red",
        defaultMessage: "Red"
    },
    yellowColor: {
        id: "fabric.status.color.yellow",
        defaultMessage: "Yellow"
    },
    greenColor: {
        id: "fabric.status.color.green",
        defaultMessage: "Green"
    },
    statusInputLabel: {
        id: "fabric.status.input.label",
        defaultMessage: "Set a status"
    }
});


function $a08a82db344faf50$var$_defineProperty(e, r, t) {
    return (r = $a08a82db344faf50$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a08a82db344faf50$var$_toPropertyKey(t) {
    var i = $a08a82db344faf50$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a08a82db344faf50$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $a08a82db344faf50$var$styles = {
    button: "_2rko12b0 _19itia51 _1reo15vq _18m915vq _4t3i1tcg _1bsb1tcg _bfhki8nm _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1ule"
};
const $a08a82db344faf50$var$buttonWrapperStyles = null;
class $a08a82db344faf50$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { tabIndex: tabIndex, backgroundColor: backgroundColor, isSelected: isSelected, borderColor: borderColor, iconColor: iconColor, value: value, setRef: setRef, onKeyDown: onKeyDown } = this.props;
        return /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_2rko12x7 _189ee4h9 _1dqonqa1 _1h6d1j28 _19pkze3t _2hwxv77o _otyrze3t _18u0v77o _1e0c1txw _4cvr1h6o _ca0qe4h9 _u5f3e4h9 _n3tde4h9 _19bve4h9 _bfw7ia51"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $65a3acb62cce22b1$export$defe85febe8b728c)[`${value}Color`], (labels)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
                xcss: $a08a82db344faf50$var$styles.button,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                onKeyDown: onKeyDown,
                tabIndex: tabIndex,
                title: labels[0],
                // For button selected (to be precise pressed) or not
                //  use aria-pressed as per
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
                "aria-pressed": isSelected,
                style: {
                    backgroundColor: backgroundColor || 'transparent',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    color: iconColor,
                    borderColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderColor
                },
                ref: setRef
            }, isSelected && /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                color: "currentColor",
                label: labels[0]
            }))));
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    constructor(...args){
        super(...args);
        $a08a82db344faf50$var$_defineProperty(this, "hoverStartTime", 0);
        $a08a82db344faf50$var$_defineProperty(this, "onMouseEnter", ()=>{
            this.hoverStartTime = Date.now();
        });
        $a08a82db344faf50$var$_defineProperty(this, "onMouseLeave", ()=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover(this.props.value);
            this.hoverStartTime = 0;
        });
        $a08a82db344faf50$var$_defineProperty(this, "onMouseDown", (e)=>{
            e.preventDefault();
        });
        $a08a82db344faf50$var$_defineProperty(this, "onClick", (e)=>{
            const { onClick: onClick, value: value } = this.props;
            e.preventDefault();
            onClick(value);
        });
    }
}





const $96a1f0b2ea65eaba$var$paletteLegacy = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery, #F8EEFE)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon-discovery, #AF59E1)"
    ],
    [
        'blue',
        "var(--ds-background-information, #E9F2FE)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon-information, #357DE8)"
    ],
    [
        'red',
        "var(--ds-background-danger, #FFECEB)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon-danger, #C9372C)"
    ],
    [
        'yellow',
        "var(--ds-background-warning, #FFF5DB)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon-warning, #E06C00)"
    ],
    [
        'green',
        "var(--ds-background-success, #EFFFD6)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon-success, #6A9A23)"
    ]
];
const $96a1f0b2ea65eaba$var$paletteRefreshed = [
    [
        'neutral',
        "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-pressed, #ADCBFB)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-pressed, #BDE97C)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-pressed, #FBD779)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-pressed, #FFB8B2)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-pressed, #E3BDFA)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon, #292A2E)"
    ]
];
const $96a1f0b2ea65eaba$var$paletteTeam26 = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        '#CACBCF',
        '#63666B',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-subtler, #CFE1FD)",
        '#8FB8F6',
        '#1558BC',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-subtler, #D3F1A7)",
        '#B3DF72',
        '#4C6B1F',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-subtler, #FCE4A6)",
        '#FBC828',
        '#9E4C00',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-subtler, #FFD5D2)",
        '#FD9891',
        '#AE2E24',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-subtler, #EED7FC)",
        '#D8A0F7',
        '#803FA5',
        "var(--ds-icon, #292A2E)"
    ]
];
const $96a1f0b2ea65eaba$var$getPalette = (colorMode)=>{
    if ((0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const isDark = colorMode === 'dark';
        return $96a1f0b2ea65eaba$var$paletteTeam26.map(([colorValue, backgroundColor, lightBorderColor, darkBorderColor, iconColor])=>[
                colorValue,
                backgroundColor,
                isDark ? darkBorderColor : lightBorderColor,
                iconColor
            ]);
    }
    return (0, $ixfCV.fg)('platform-component-visual-refresh') ? $96a1f0b2ea65eaba$var$paletteRefreshed : $96a1f0b2ea65eaba$var$paletteLegacy;
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $96a1f0b2ea65eaba$var$colorPaletteWrapperStyles = null;
var $96a1f0b2ea65eaba$export$2e2bcd8739ae039 = ({ cols: cols = 7, onClick: onClick, selectedColor: selectedColor, className: className, onHover: onHover })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const palette = $96a1f0b2ea65eaba$var$getPalette(colorMode);
    const colorRefs = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        colorRefs.current = colorRefs.current.slice(0, palette.length);
    }, [
        palette.length
    ]);
    const createKeyDownHandler = (0, $cozmU.useCallback)((index)=>(e)=>{
            let newColorIndex = null;
            const nextColor = ()=>index + 1 > palette.length - 1 ? 0 : index + 1;
            const previousColor = ()=>index - 1 < 0 ? palette.length - 1 : index - 1;
            switch(e.key){
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    newColorIndex = nextColor();
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    newColorIndex = previousColor();
                    break;
            }
            if (newColorIndex === null) return;
            colorRefs.current[newColorIndex]?.focus();
        }, [
        colorRefs,
        palette.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_19bvidpf _19pku2gc _2hwxu2gc _otyridpf _18u0u2gc _1e0c1txw _1n261g80",
            className
        ]),
        style: {
            maxWidth: cols * 32
        }
    }, palette.map(([colorValue, backgroundColor, borderColor, iconColor], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a08a82db344faf50$export$2e2bcd8739ae039), {
            key: colorValue,
            value: colorValue,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            iconColor: iconColor,
            onClick: onClick,
            onHover: onHover,
            isSelected: colorValue === selectedColor,
            tabIndex: i === 0 ? 0 : -1,
            setRef: (el)=>colorRefs.current[i] = el,
            onKeyDown: createKeyDownHandler(i)
        })));
};



function $5a1082336b950663$var$_defineProperty(e, r, t) {
    return (r = $5a1082336b950663$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5a1082336b950663$var$_toPropertyKey(t) {
    var i = $5a1082336b950663$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5a1082336b950663$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $5a1082336b950663$var$fieldTextWrapperStyles = null;
class $5a1082336b950663$var$Picker extends (0, $cozmU.PureComponent) {
    render() {
        const { text: text, selectedColor: selectedColor, onColorClick: onColorClick, onColorHover: onColorHover, intl: intl } = this.props;
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: this.fieldTextWrapperKey,
            className: (0, $hekY6.default)([
                "_19pkidpf _otyridpf _2hwxu2gc _18u0u2gc _n6341ihb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            value: text,
            isCompact: true,
            ref: this.handleInputRef,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            spellCheck: false,
            autoComplete: "off",
            "aria-label": intl.formatMessage((0, $65a3acb62cce22b1$export$defe85febe8b728c).statusInputLabel)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96a1f0b2ea65eaba$export$2e2bcd8739ae039), {
            key: this.colorPaletteKey,
            onClick: onColorClick,
            onHover: onColorHover,
            selectedColor: selectedColor
        }));
    }
    componentDidUpdate() {
        if (this.inputRef && this.props.autoFocus) this.focusInput();
    }
    componentWillUnmount() {
        if (this.autofocusTimeout !== undefined) clearTimeout(this.autofocusTimeout);
    }
    constructor(...args){
        super(...args);
        $5a1082336b950663$var$_defineProperty(this, "inputRef", void 0);
        $5a1082336b950663$var$_defineProperty(this, "autofocusTimeout", void 0);
        $5a1082336b950663$var$_defineProperty(this, "fieldTextWrapperKey", Math.random().toString());
        $5a1082336b950663$var$_defineProperty(this, "colorPaletteKey", Math.random().toString());
        $5a1082336b950663$var$_defineProperty(this, "onChange", (evt)=>{
            // @ts-ignore
            this.props.onTextChanged(evt.target.value);
        });
        $5a1082336b950663$var$_defineProperty(this, "onKeyPress", (event)=>{
            if (event.key === 'Enter') this.props.onEnter();
        });
        $5a1082336b950663$var$_defineProperty(this, "handleInputRef", (ref)=>{
            this.inputRef = ref;
            if (ref && this.props.autoFocus) this.focusInput();
        });
        $5a1082336b950663$var$_defineProperty(this, "focusInput", ()=>{
            if (!this.inputRef) return;
             // Defer to prevent editor scrolling to top
            this.autofocusTimeout = setTimeout(()=>{
                this.inputRef?.focus();
            });
        });
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$5a1082336b950663$var$_defineProperty($5a1082336b950663$var$Picker, "defaultProps", {
    autoFocus: true
});
const $5a1082336b950663$export$39975ce689bf0105 = (0, $kSwu1.injectIntl)($5a1082336b950663$var$Picker);



var $9GVkD = parcelRequire("9GVkD");


const $03737233c2d85182$export$7787c7adba71b8c3 = 'fabric-elements';
const $03737233c2d85182$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent && payload) {
            const statusPayload = {
                ...payload,
                eventType: 'ui'
            };
            if (!statusPayload.attributes) statusPayload.attributes = {};
            statusPayload.attributes.componentName = 'status';
            createAnalyticsEvent(statusPayload).fire($03737233c2d85182$export$7787c7adba71b8c3);
        }
    };
const $03737233c2d85182$export$69e00be7c24e6455 = (isNew)=>isNew ? 'new' : 'update';


const $7d3151e91594125f$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
var $7d3151e91594125f$export$4182489224ea9c47 = /*#__PURE__*/ function(InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
    return InputMethod;
}({});
var $7d3151e91594125f$export$cc742728d048210b = /*#__PURE__*/ function(closingMethods) {
    closingMethods["ArrowLeft"] = "arrowLeft";
    closingMethods["ArrowRight"] = "arrowRight";
    return closingMethods;
}({});
const $7d3151e91594125f$var$pickerContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase'
    }
});
const $7d3151e91594125f$var$pickerContainerStylesTeam26 = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':focus': {
        outline: 'none'
    }
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7d3151e91594125f$var$StatusPickerWithIntl extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    fireStatusPopupOpenedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.startTime = Date.now();
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $03737233c2d85182$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    fireStatusPopupClosedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: this.inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $03737233c2d85182$export$69e00be7c24e6455)(isNew)
            }
        });
    }
    reset() {
        this.startTime = Date.now();
        this.inputMethod = "blur";
    }
    componentDidMount() {
        this.reset();
        this.fireStatusPopupOpenedAnalytics(this.state);
    }
    componentWillUnmount() {
        this.focusTimeout && cancelAnimationFrame(this.focusTimeout);
        this.fireStatusPopupClosedAnalytics(this.state);
        this.startTime = 0;
    }
    componentDidUpdate(prevProps, prevState) {
        const element = this.props.target;
        if (prevProps.target !== element) {
            const newState = this.extractStateFromProps(this.props);
            this.setState(newState);
            this.fireStatusPopupClosedAnalytics(prevState);
            this.reset();
            this.fireStatusPopupOpenedAnalytics(newState);
        }
    }
    extractStateFromProps(props) {
        const { defaultColor: defaultColor, defaultText: defaultText, defaultLocalId: defaultLocalId, isNew: isNew } = props;
        return {
            color: defaultColor || (0, $35c8ece4f44259bc$export$ac80046fa87f5a7a).color,
            text: defaultText || (0, $35c8ece4f44259bc$export$ac80046fa87f5a7a).text,
            localId: defaultLocalId,
            isNew: isNew
        };
    }
    setRef(setOutsideClickTargetRef) {
        return (ref)=>{
            setOutsideClickTargetRef(ref);
            this.popupBodyWrapper.current = ref;
        };
    }
    renderWithSetOutsideClickTargetRef(setOutsideClickTargetRef) {
        const { isNew: isNew, focusStatusInput: focusStatusInput, api: api } = this.props;
        const { color: color, text: text } = this.state;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
            api: api,
            userIntent: "statusPickerOpen"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $7d3151e91594125f$var$pickerContainerStylesTeam26 : $7d3151e91594125f$var$pickerContainerStyles,
            role: "none",
            ref: this.setRef(setOutsideClickTargetRef),
            onClick: this.handlePopupClick,
            onKeyDown: this.onKeyDown
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5a1082336b950663$export$39975ce689bf0105), {
            autoFocus: isNew || focusStatusInput,
            selectedColor: color,
            text: text,
            onColorClick: this.onColorClick,
            onColorHover: this.onColorHover,
            onTextChanged: this.onTextChanged,
            onEnter: this.onEnter
        })));
    }
    render() {
        const { target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, intl: intl } = this.props;
        if (!editorView?.editable) return null;
        return target && /*#__PURE__*/ (0, $lOiVq.jsx)($7d3151e91594125f$var$PopupWithListeners, {
            ariaLabel: intl.formatMessage((0, $4rQbz.messages).statusEditorLabel),
            target: target,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                8
            ],
            handleClickOutside: this.handleClickOutside,
            handleEscapeKeydown: this.handleEscapeKeydown,
            zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
            fitHeight: 40,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            closeOnTab: false
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GVkD.default), {
            "aria-atomic": true,
            role: "alert"
        }, intl.formatMessage((0, $4rQbz.messages).statusPickerOpenedAlert)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, this.renderWithSetOutsideClickTargetRef.bind(this)));
    }
    constructor(props){
        super(props);
        this.startTime = void 0;
        this.inputMethod = void 0;
        this.createStatusAnalyticsAndFireFunc = void 0;
        this.popupBodyWrapper = void 0;
        this.focusTimeout = void 0;
        this.handleClickOutside = (event)=>{
            event.preventDefault();
            this.inputMethod = "blur";
            const selectedText = window.getSelection();
            if (!selectedText) this.props.closeStatusPicker();
        };
        this.handleEscapeKeydown = (event)=>{
            event.preventDefault();
            this.inputMethod = "escKey";
            this.props.onEnter(this.state);
        };
        this.handleTabPress = (event)=>{
            const colorButtons = event.currentTarget.querySelectorAll('button');
            const inputField = event.currentTarget.querySelector('input');
            const activeElement = (0, $haNN4.getDocument)()?.activeElement;
            const isInputFocussed = activeElement === inputField;
            const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            if (event?.shiftKey) {
                /* shift + tab */ if (isInputFocussed) {
                    colorButtons[0].focus();
                    event.preventDefault();
                }
                /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
               To correctly set focus to the input field instead of the first color button we need to set focus manually
               */ if (isButtonFocussed) {
                    inputField?.focus();
                    event.preventDefault();
                }
            } else /* tab */ if (isButtonFocussed) {
                inputField?.focus();
                event.preventDefault();
            }
        };
        this.handleArrow = (event, closingMethod)=>{
            const activeElement = (0, $haNN4.getDocument)()?.activeElement;
            if (activeElement === this.popupBodyWrapper.current) {
                event.preventDefault();
                this.popupBodyWrapper?.current?.blur();
                this.props.closeStatusPicker({
                    closingMethod: closingMethod
                });
            }
        };
        this.onKeyDown = (event)=>{
            const isTabPressed = event.key === 'Tab';
            if (isTabPressed) return this.handleTabPress(event);
            if (event.key in $7d3151e91594125f$export$cc742728d048210b) return this.handleArrow(event, $7d3151e91594125f$export$cc742728d048210b[event.key]);
        };
        this.onColorHover = (color)=>{
            this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: this.state.localId,
                    state: (0, $03737233c2d85182$export$69e00be7c24e6455)(this.props.isNew)
                }
            });
        };
        this.onColorClick = (color)=>{
            const { text: text, localId: localId } = this.state;
            if (color === this.state.color) {
                this.createStatusAnalyticsAndFireFunc({
                    action: 'clicked',
                    actionSubject: 'statusColorPicker',
                    attributes: {
                        color: color,
                        localId: localId,
                        state: (0, $03737233c2d85182$export$69e00be7c24e6455)(this.props.isNew)
                    }
                });
                // closes status box and commits colour
                this.onEnter();
            } else {
                this.setState({
                    color: color
                });
                this.props.onSelect({
                    text: text,
                    color: color,
                    localId: localId
                });
            }
        };
        this.onTextChanged = (text)=>{
            const { color: color, localId: localId } = this.state;
            this.setState({
                text: text
            });
            this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId
            }, !!this.props.isNew);
        };
        this.onEnter = ()=>{
            this.inputMethod = "enterKey";
            this.props.onEnter(this.state);
        };
        // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        this.handlePopupClick = (event)=>event.nativeEvent.stopImmediatePropagation();
        this.state = this.extractStateFromProps(props);
        this.createStatusAnalyticsAndFireFunc = (0, $03737233c2d85182$export$aa98853957f9f5aa)(props.createAnalyticsEvent);
        this.popupBodyWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
const $7d3151e91594125f$export$bcfa9a4744e42b68 = (0, $kSwu1.injectIntl)($7d3151e91594125f$var$StatusPickerWithIntl);
const $7d3151e91594125f$var$_default_1 = (0, $lzgC6.default)()($7d3151e91594125f$export$bcfa9a4744e42b68);
var $7d3151e91594125f$export$2e2bcd8739ae039 = $7d3151e91594125f$var$_default_1;


function $02a272aa3edde94b$export$2dda1e4a1d1f6a81({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, domAtPos: domAtPos }) {
    const { statusState: statusState } = (0, $4y8CY.useSharedPluginState)(api, [
        'status'
    ]);
    const { showStatusPickerAt: showStatusPickerAt } = statusState ?? {};
    const target = (0, $cozmU.useMemo)(()=>// Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        showStatusPickerAt ? (0, $bjg0G.findDomRefAtPos)(showStatusPickerAt, domAtPos) : null, [
        showStatusPickerAt,
        domAtPos
    ]);
    const statusNode = (0, $cozmU.useMemo)(()=>showStatusPickerAt ? editorView.state.doc.nodeAt(showStatusPickerAt) : undefined, [
        showStatusPickerAt,
        editorView
    ]);
    const onSelect = (0, $cozmU.useCallback)((status)=>{
        (0, $35c8ece4f44259bc$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onTextChanged = (0, $cozmU.useCallback)((status)=>{
        (0, $35c8ece4f44259bc$export$dd127eb7207846ef)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const closeStatusPicker = (0, $cozmU.useCallback)((closingPayload)=>{
        (0, $35c8ece4f44259bc$export$cdfbbd5b38df803)(closingPayload)(editorView);
    }, [
        editorView
    ]);
    const onEnter = (0, $cozmU.useCallback)(()=>{
        (0, $35c8ece4f44259bc$export$cdfbbd5b38df803)()(editorView);
    }, [
        editorView
    ]);
    if (typeof showStatusPickerAt !== 'number') return null;
    if (!statusNode || statusNode.type.name !== 'status') return null;
    const { text: text, color: color, localId: localId, style: style } = statusNode.attrs;
    const displayText = style !== 'mixedCase' && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? text.toUpperCase() : text;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7d3151e91594125f$export$2e2bcd8739ae039), {
        isNew: statusState?.isNew,
        focusStatusInput: statusState?.focusStatusInput,
        target: target,
        defaultText: displayText,
        defaultColor: color,
        defaultLocalId: localId,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onSelect: onSelect,
        onTextChanged: onTextChanged,
        closeStatusPicker: closeStatusPicker,
        onEnter: onEnter,
        editorView: editorView,
        api: api
    });
}


const $673fe1fcd0c9f1e1$export$4c24fc5ab73049c9 = ({ config: options, api: api })=>({
        name: 'status',
        nodes () {
            return [
                {
                    name: 'status',
                    node: (0, $PYwg9.status)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'status',
                    plugin: (pmPluginFactoryParams)=>(0, $0d68e47196c4702b$export$2e2bcd8739ae039)(pmPluginFactoryParams, options)
                },
                {
                    name: 'statusKeymap',
                    plugin: (0, $52f20a93e5d9fb1b$export$e832373cff8dec22)
                }
            ];
        },
        actions: {
            commitStatusPicker: $35c8ece4f44259bc$export$cdfbbd5b38df803,
            updateStatus: (0, $35c8ece4f44259bc$export$2d82855a8f0dcacb)(api?.analytics?.actions)
        },
        commands: {
            removeStatus: $35c8ece4f44259bc$export$38345b9b03bc4599,
            insertStatus: (0, $35c8ece4f44259bc$export$84e57993298e69f2)(api?.analytics?.actions)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $b900a37c29c42ee1$export$18d4026d1ea86bb1).getState(state);
            return pluginState ? {
                isNew: pluginState.isNew,
                showStatusPickerAt: pluginState.showStatusPickerAt,
                focusStatusInput: pluginState.focusStatusInput
            } : undefined;
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>{
                if (options?.menuDisabled === true) return [];
                return [
                    {
                        id: 'status',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).status),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).statusDescription),
                        priority: 700,
                        keywords: [
                            'lozenge'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconStatus), null),
                        action (_insert, state) {
                            return (0, $35c8ece4f44259bc$export$84e57993298e69f2)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).QUICK_INSERT)({
                                tr: state.tr
                            }) ?? state.tr;
                        }
                    }
                ];
            },
            floatingToolbar (state, intl) {
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                return {
                    title: 'Status floating toolbar',
                    nodeType: state.schema.nodes.status,
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Status floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const hasActiveMark = node.marks.some((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && isViewMode() && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !hasActiveMark;
                        const onCommentClick = (stateFromClickEvent, dispatch)=>{
                            if (!api?.annotation) return true;
                            const command = api.annotation.actions.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                            api?.analytics?.actions?.fireAnalyticsEvent({
                                action: (0, $krYZG.ACTION).CLICKED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                                eventType: (0, $krYZG.EVENT_TYPE).UI,
                                attributes: {
                                    source: 'highlightActionsMenu',
                                    pageMode: 'edit',
                                    sourceNode: 'status'
                                }
                            });
                            return command(stateFromClickEvent, dispatch);
                        };
                        const createCommentMessage = intl.formatMessage((0, $83k8i.annotationMessages).createComment);
                        const commentItems = showAnnotation ? [
                            {
                                type: 'button',
                                title: createCommentMessage,
                                onClick: onCommentClick,
                                showTitle: true,
                                tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                                    description: createCommentMessage,
                                    keymap: (0, $ldqjS.addInlineComment)
                                }),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                supportsViewMode: true
                            }
                        ] : [];
                        return [
                            ...commentItems
                        ];
                    }
                };
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            const domAtPos = editorView.domAtPos.bind(editorView);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02a272aa3edde94b$export$2dda1e4a1d1f6a81), {
                domAtPos: domAtPos,
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        }
    });
module.exports["statusPlugin"] = $673fe1fcd0c9f1e1$export$4c24fc5ab73049c9;

});

parcelRegister("gUZEQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $39Puj = parcelRequire("39Puj");


var $krYZG = parcelRequire("krYZG");

var $jzpoq = parcelRequire("jzpoq");


var $8dxef = parcelRequire("8dxef");


var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");


var $ldqjS = parcelRequire("ldqjS");


var $gx3UZ = parcelRequire("gx3UZ");


var $euISL = parcelRequire("euISL");

var $is9bZ = parcelRequire("is9bZ");


var $aC6bW = parcelRequire("aC6bW");


var $kpCD8 = parcelRequire("kpCD8");


var $bjg0G = parcelRequire("bjg0G");


var $kCECX = parcelRequire("kCECX");


var $h9YGx = parcelRequire("h9YGx");


var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");

function $e3602a9ce7363b58$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $8HW7o.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $8nvEM.DecorationSet).create(state.doc, cells);
}





const $da948d59b46f583d$export$8dc63188bf2e0962 = new (0, $kCECX.PluginKey)('selectingCells');
const $da948d59b46f583d$export$9731ba46aee163cb = new (0, $kCECX.PluginKey)('fix-tables');



var $8Z43Z = parcelRequire("8Z43Z");


var $ksfbF = parcelRequire("ksfbF");


var $f719K = parcelRequire("f719K");

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function $970ca4dfedc3167e$var$changedDescendants(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    // eslint-disable-next-line no-labels
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $970ca4dfedc3167e$var$changedDescendants(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}
function $970ca4dfedc3167e$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = $970ca4dfedc3167e$export$26dfac117c7732d8(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) $970ca4dfedc3167e$var$changedDescendants(oldState.doc, state.doc, 0, check);
    return tr;
}
function $970ca4dfedc3167e$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $8Z43Z.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $8Z43Z.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $ksfbF.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $8Z43Z.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $8Z43Z.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $8Z43Z.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nodes.push((0, $f719K.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $da948d59b46f583d$export$9731ba46aee163cb), {
        fixTables: true
    });
}











// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5f3a941ec59fce60$var$ROW_OR_TABLE_ROLE_REGEX = /row|table/;
function $5f3a941ec59fce60$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $kCECX.NodeSelection)) role = sel.node.type.spec.tableRole;
    if (sel instanceof (0, $kCECX.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $8HW7o.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $8HW7o.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $8Z43Z.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $8HW7o.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $kCECX.TextSelection) && $5f3a941ec59fce60$var$isCellBoundarySelection(sel)) normalize = (0, $kCECX.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $kCECX.TextSelection) && $5f3a941ec59fce60$var$isTextSelectionAcrossSameTableCells(sel)) normalize = (0, $kCECX.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $5f3a941ec59fce60$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    return afterFrom === beforeTo && $5f3a941ec59fce60$var$ROW_OR_TABLE_ROLE_REGEX.test($from.node(depth).type.spec.tableRole);
}
function $5f3a941ec59fce60$var$isTextSelectionAcrossSameTableCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    let fromCellTableNode;
    let toCellTableNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') fromCellBoundaryNode = node;
        if (node.type.name === 'table') {
            fromCellTableNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') toCellBoundaryNode = node;
        if (node.type.name === 'table') {
            toCellTableNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== undefined && toCellBoundaryNode !== undefined && fromCellBoundaryNode !== toCellBoundaryNode && toCellTableNode === fromCellTableNode && $to.parentOffset === 0;
}


// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $44cyU = parcelRequire("44cyU");


var $aPdNQ = parcelRequire("aPdNQ");








var $cycWk = parcelRequire("cycWk");




var $7zMjs = parcelRequire("7zMjs");


var $kWLy1 = parcelRequire("kWLy1");


const $4c3013647a4ff392$export$bab59f27a7347e45 = (0, $44cyU.keydownHandler)({
    ArrowLeft: $4c3013647a4ff392$var$arrow('horiz', -1),
    ArrowRight: $4c3013647a4ff392$var$arrow('horiz', 1),
    ArrowUp: $4c3013647a4ff392$var$arrow('vert', -1),
    ArrowDown: $4c3013647a4ff392$var$arrow('vert', 1),
    'Shift-ArrowLeft': $4c3013647a4ff392$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $4c3013647a4ff392$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $4c3013647a4ff392$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $4c3013647a4ff392$var$shiftArrow('vert', 1),
    Backspace: $4c3013647a4ff392$var$deleteCellSelection,
    'Mod-Backspace': $4c3013647a4ff392$var$deleteCellSelection,
    Delete: $4c3013647a4ff392$var$deleteCellSelection,
    'Mod-Delete': $4c3013647a4ff392$var$deleteCellSelection
});
function $4c3013647a4ff392$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $4c3013647a4ff392$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $8HW7o.CellSelection)) return $4c3013647a4ff392$var$maybeSetSelection(state, dispatch, (0, $kCECX.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $4c3013647a4ff392$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $4c3013647a4ff392$var$maybeSetSelection(state, dispatch, (0, $kCECX.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $7zMjs.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $kCECX.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $kCECX.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $kCECX.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $4c3013647a4ff392$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $4c3013647a4ff392$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $8HW7o.CellSelection))) {
            const end = view ? $4c3013647a4ff392$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes(maybeTableCell?.parent?.type.name || '');
            if (!sameCell) return false;
            sel = new (0, $8HW7o.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $7zMjs.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $4c3013647a4ff392$var$maybeSetSelection(state, dispatch, new (0, $8HW7o.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $4c3013647a4ff392$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $8HW7o.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const baseContent = (0, $f719K.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $aPdNQ.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
function $4c3013647a4ff392$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $7zMjs.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $8HW7o.CellSelection)($cell)));
    return true;
}
function $4c3013647a4ff392$export$b4a93e0b711d8f7(view, event) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const startDOMCell = $4c3013647a4ff392$var$domInCell(view, startEvent.target);
    const $anchor = (0, $7zMjs.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $8HW7o.CellSelection)) {
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        const isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $4c3013647a4ff392$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $4c3013647a4ff392$var$cellUnderMouse(view, event);
        const starting = (0, $da948d59b46f583d$export$8dc63188bf2e0962).getState(view.state) == null;
        if (!$head || !(0, $kWLy1.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $8HW7o.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $da948d59b46f583d$export$8dc63188bf2e0962), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mouseup', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('dragstart', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mousemove', move);
        if ((0, $da948d59b46f583d$export$8dc63188bf2e0962).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $da948d59b46f583d$export$8dc63188bf2e0962), -1));
    }
    function move(event) {
        const anchor = (0, $da948d59b46f583d$export$8dc63188bf2e0962).getState(view.state);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const currDOMCell = $4c3013647a4ff392$var$domInCell(view, event.target);
        const isCurrCellInsideNestedTable = $4c3013647a4ff392$var$isInsideNestedTable(view, event);
        const isStartCellInsideNestedTable = $4c3013647a4ff392$var$isInsideNestedTable(view, startEvent);
        const isBothCellsInSameTable = isCurrCellInsideNestedTable === isStartCellInsideNestedTable;
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if (currDOMCell !== startDOMCell && isBothCellsInSameTable) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $4c3013647a4ff392$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('dragstart', stop);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mousemove', move);
    return false;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $4c3013647a4ff392$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $kCECX.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}
function $4c3013647a4ff392$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $4c3013647a4ff392$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $7zMjs.cellAround)(view.state.doc.resolve(mousePos.pos));
}
function $4c3013647a4ff392$var$isInsideNestedTable(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return false;
    const pos = view.state.doc.resolve(mousePos.pos);
    const table = (0, $cycWk.findTableClosestToPos)(pos);
    if (!table) return false;
    const parent = view.state.doc.resolve(table.pos).parent;
    const nodeTypes = view.state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
}



function $853d31c23059c8f6$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $kCECX.Plugin)({
        key: (0, $da948d59b46f583d$export$8dc63188bf2e0962),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $da948d59b46f583d$export$8dc63188bf2e0962));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $e3602a9ce7363b58$export$938a078fa3e1d420),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $4c3013647a4ff392$export$b4a93e0b711d8f7)(view, event);
                }
            },
            createSelectionBetween (view) {
                if ((0, $da948d59b46f583d$export$8dc63188bf2e0962).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $4c3013647a4ff392$export$f17e34274dd6fcf5,
            handleKeyDown: $4c3013647a4ff392$export$bab59f27a7347e45,
            handlePaste: $h9YGx.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $5f3a941ec59fce60$export$64b8795b15903d8d)(state, (0, $970ca4dfedc3167e$export$d6d48849d9121a1)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}



var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $5X6fy = parcelRequire("5X6fy");


var $hQhZW = parcelRequire("hQhZW");





var $iAEsk = parcelRequire("iAEsk");


var $8Dx7s = parcelRequire("8Dx7s");


var $cdX2q = parcelRequire("cdX2q");








var $k8PFz = parcelRequire("k8PFz");


var $hac25 = parcelRequire("hac25");

var $j8zA9 = parcelRequire("j8zA9");





var $7Y8M5 = parcelRequire("7Y8M5");




const $26c6284b781fc82b$export$dd66abdcfb4bb2cf = 48;
const $26c6284b781fc82b$export$bffd6819c009a916 = 1800;
const $26c6284b781fc82b$export$8a91b25da594a758 = 4000;
const $26c6284b781fc82b$export$b5e6eff3efdc4860 = 1800;
const $26c6284b781fc82b$export$e8dbf55270553cd3 = 0.3;
const $26c6284b781fc82b$export$2e7c88a39ad490e6 = 0.4;
const $26c6284b781fc82b$export$7c8bcfa1d3f9af23 = 76;
const $26c6284b781fc82b$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $26c6284b781fc82b$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $26c6284b781fc82b$export$c332ba2dd5aa2199 = 2 * ($26c6284b781fc82b$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $26c6284b781fc82b$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);
const $26c6284b781fc82b$export$a823f6a7493b3d06 = 12;



var $9ppjA = parcelRequire("9ppjA");


var $8y0c9 = parcelRequire("8y0c9");















function $a2b54432792761eb$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) {
        let padding = (0, $7Y8M5.akEditorGutterPaddingDynamic)();
        if (containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        })) padding = (0, $7Y8M5.akEditorGutterPaddingReduced);
        return containerWidth ? Math.min(containerWidth - padding * 2, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : (0, $7Y8M5.akEditorFullWidthLayoutWidth);
    }
    const calculatedTableWidth = (0, $8y0c9.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $9ppjA.layoutToWidth)[tableLayout] || containerWidth;
}
function $a2b54432792761eb$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $a2b54432792761eb$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    const width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $a2b54432792761eb$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $9ppjA.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $a2b54432792761eb$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $7Y8M5.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $a2b54432792761eb$export$44361276769f7eff = (table)=>{
    if ((0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(table)) // TODO: ED-26961 - is there a scenario where ADF columns are SMALLER than container width?
    return (0, $hac25.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $a2b54432792761eb$export$a34136fcfaec1907(table);
};
const $a2b54432792761eb$export$a34136fcfaec1907 = (table)=>{
    return (0, $9ppjA.getTableContainerWidth)(table);
};
const $a2b54432792761eb$export$817f7cd897b65634 = (isCommentEditor, isChromelessEditor, isTableScalingEnabled)=>{
    const maxResizerWidthForNonCommentEditor = isTableScalingEnabled ? `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${(0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916)}px)` : `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${(0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916)}px)`;
    return isCommentEditor || isChromelessEditor ? '100%' : maxResizerWidthForNonCommentEditor;
};
const $a2b54432792761eb$export$708cde710ed0df70 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = (0, $9ppjA.getTableContainerWidth)(node);
    if (!node.attrs.width && (isCommentEditor || isChromelessEditor)) // width undefined would make .resizer-item width to be `auto`
    return undefined;
    return tableWidthAttribute;
};
const $a2b54432792761eb$export$7d968ec824de6aa6 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = $a2b54432792761eb$export$708cde710ed0df70(node, isCommentEditor, isChromelessEditor);
    return tableWidthAttribute ? `${tableWidthAttribute}px` : 'auto';
};
const $a2b54432792761eb$export$30421da09613cb3d = (node, isTableScalingEnabled)=>{
    const tableWidth = $a2b54432792761eb$export$a34136fcfaec1907(node);
    // for full page appearance
    if (isTableScalingEnabled) return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${tableWidth}px)`;
    return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${tableWidth}px)`;
};
const $a2b54432792761eb$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $26c6284b781fc82b$export$2e7c88a39ad490e6) : (0, $26c6284b781fc82b$export$e8dbf55270553cd3);
    const tableWidth = $a2b54432792761eb$export$a34136fcfaec1907(table);
    const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $a2b54432792761eb$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $cec18a6f3d8c1f93$export$b44a013e4f554514)(table)) {
        const tableWidth = (0, $hac25.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $a2b54432792761eb$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $26c6284b781fc82b$export$2e7c88a39ad490e6) : (0, $26c6284b781fc82b$export$e8dbf55270553cd3);
    const tableWidth = $a2b54432792761eb$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};


const $cec18a6f3d8c1f93$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $cec18a6f3d8c1f93$var$generateColStyle = (fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, hasTableBeenResized)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $26c6284b781fc82b$export$2e7c88a39ad490e6) : (0, $26c6284b781fc82b$export$e8dbf55270553cd3);
    const maxScaledRatio = 1 - maxScalingPercent;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // for nested tables, or chromeless editor, which used non resizable table container
    if (isNested || isChromelessEditor) {
        if (hasTableBeenResized) return `width: max(${fixedColWidth}px, ${0, $k8PFz.tableCellMinWidth}px)`;
        return (0, $iAEsk.isSSRStreaming)() ? `width: ${0, $k8PFz.tableCellMinWidth}px` : `width: ${0, $k8PFz.tableCellMinWidth}px)`;
    }
    if (isFullPageEditor || !isFullPageEditor && isTableHasWidth) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $7Y8M5.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth}px * ${maxScaledRatio}), calc(${fixedColWidth} * ${scaledPercent}), ${0, $k8PFz.tableCellMinWidth}px)`;
    }
    // table resized to full-width in comment editor
    // it doesn't have a width attribute, and cols has been resized
    if (hasTableBeenResized) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $7Y8M5.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth} * ${scaledPercent}), ${0, $k8PFz.tableCellMinWidth}px)`;
    }
    return `width: ${0, $k8PFz.tableCellMinWidth}px`;
};
const $cec18a6f3d8c1f93$export$465034143db788da = (table, isCommentEditor, isChromelessEditor, isNested, isTableScalingEnabled, shouldUseIncreasedScalingPercent)=>{
    const cols = [];
    const map = (0, $8Z43Z.TableMap).get(table);
    const isTableHasWidth = !!table.attrs.width;
    const isNumberColumnEnabled = table.attrs.isNumberColumnEnabled || false;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        // if the table has been resized
        if (Array.isArray(cell.attrs.colwidth)) cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
            // existing logic for calculating the width of the column
            const fixedColWidth = $cec18a6f3d8c1f93$export$66302252070a658d(width, map.width);
            const tableWidth = isFullPageEditor || !isFullPageEditor && isTableHasWidth ? (0, $a2b54432792761eb$export$a34136fcfaec1907)(table) : (0, $hac25.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
            if (isTableScalingEnabled) cols.push([
                'col',
                {
                    style: $cec18a6f3d8c1f93$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, true)
                }
            ]);
            else cols.push([
                'col',
                {
                    style: `width: max(${fixedColWidth}px, ${(0, $k8PFz.tableCellMinWidth)}px)`
                }
            ]);
        });
        else if (!isTableScalingEnabled) cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $k8PFz.tableCellMinWidth)}px;`
                }
            ]));
        else // columns has not been resized, so distribute the width evenly
        cols.push(...Array.from({
            length: colspan
        }, (_)=>{
            const tableWidth = (0, $a2b54432792761eb$export$a34136fcfaec1907)(table);
            const columnWidth = tableWidth / map.width || 0;
            const fixedColWidth = $cec18a6f3d8c1f93$export$66302252070a658d(columnWidth, map.width || 0);
            return [
                'col',
                {
                    style: $cec18a6f3d8c1f93$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth)
                }
            ];
        }));
    });
    return cols;
};
const $cec18a6f3d8c1f93$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)=>{
    const cols = [];
    const map = (0, $8Z43Z.TableMap).get(table);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentOrChromelessEditor && !table.attrs?.width) scalePercent = (0, $a2b54432792761eb$export$4e884677f8e54bba)(table, tableRef);
                else scalePercent = (0, $a2b54432792761eb$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    // existing logic for calculating the width of the column
                    const fixedColWidth = $cec18a6f3d8c1f93$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $k8PFz.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$cec18a6f3d8c1f93$export$66302252070a658d(width ? Math.max(width, (0, $k8PFz.tableCellMinWidth)) : (0, $k8PFz.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $k8PFz.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $cec18a6f3d8c1f93$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let colgroup = tableRef?.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef?.removeChild(colgroup);
    colgroup = $cec18a6f3d8c1f93$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
    if (shouldRemove) tableRef?.insertBefore(colgroup, tableRef?.firstChild);
    return colgroup.children;
};
const $cec18a6f3d8c1f93$export$8c07f44cea64e3c7 = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return !!(0, $j8zA9.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $cec18a6f3d8c1f93$export$b44a013e4f554514 = $cec18a6f3d8c1f93$export$8c07f44cea64e3c7;
const $cec18a6f3d8c1f93$export$2878318085bf6dbf = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cellArray = (0, $j8zA9.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $k8PFz.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $cec18a6f3d8c1f93$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor) {
    const rendered = (0, $aPdNQ.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$cec18a6f3d8c1f93$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return rendered.dom;
}
const $cec18a6f3d8c1f93$export$dc24345db4290451 = (table)=>{
    const map = (0, $8Z43Z.TableMap).get(table);
    return map.width;
};
const $cec18a6f3d8c1f93$export$e7ee55be67771d90 = (node)=>{
    const currentColumnCount = $cec18a6f3d8c1f93$export$dc24345db4290451(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $26c6284b781fc82b$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};




const $f683956911721579$export$e217d2a535d6ae45 = ({ allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isFullPageEditor: isFullPageEditor })=>{
    return allowColumnResizing && allowTableResizing && isFullPageEditor;
};


/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




var $bYPHE = parcelRequire("bYPHE");

const $93ebfcf1771919c4$export$1a38c7157d718094 = 30;
var $93ebfcf1771919c4$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    return TableDecorations;
}({});
const $93ebfcf1771919c4$export$19a8a7a6488b1b9f = {
    ...(0, $bYPHE.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $39Puj.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $39Puj.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $39Puj.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $39Puj.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $39Puj.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $39Puj.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $39Puj.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $39Puj.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $39Puj.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $39Puj.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $39Puj.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $39Puj.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $39Puj.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_ROW_FLOATING_DRAG_HANDLE: `${(0, $39Puj.tablePrefixSelector)}-drag-row-floating-drag-handle`,
    DRAG_COLUMN_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $39Puj.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $39Puj.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $39Puj.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $39Puj.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $39Puj.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $39Puj.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $39Puj.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $39Puj.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $39Puj.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $39Puj.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $39Puj.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $39Puj.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $39Puj.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $39Puj.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $39Puj.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $39Puj.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $39Puj.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $39Puj.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $39Puj.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $39Puj.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $39Puj.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $39Puj.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $39Puj.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $39Puj.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $39Puj.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $39Puj.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $39Puj.tableCellSelector),
    TABLE_CORNER_MASK: `${(0, $39Puj.tablePrefixSelector)}-corner-mask`,
    TABLE_HEADER_CELL: (0, $39Puj.tableHeaderSelector),
    TABLE_STICKY: `${(0, $39Puj.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $39Puj.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    WITH_COLUMN_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $39Puj.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $39Puj.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $39Puj.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $39Puj.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $39Puj.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $39Puj.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $39Puj.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $39Puj.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $39Puj.tablePrefixSelector)}-last-row-insert-line__inactive`,
    NATIVE_STICKY: `${(0, $39Puj.tablePrefixSelector)}-row-native-sticky`,
    NATIVE_STICKY_ACTIVE: `${(0, $39Puj.tablePrefixSelector)}-row-native-sticky-active`,
    NO_OVERFLOW: `${(0, $39Puj.tablePrefixSelector)}-no-overflow`,
    ACTIVE_CURSOR_CELL: `${(0, $39Puj.tablePrefixSelector)}-active-cursor-cell`
};
var $93ebfcf1771919c4$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});



const $cac57eed68474c1f$export$2cbc54593c64b1f2 = 'align-start';
const $cac57eed68474c1f$export$3ea9e188ab01c845 = 'center';
const $cac57eed68474c1f$export$2e10df95acfe6933 = (layout)=>layout === $cac57eed68474c1f$export$3ea9e188ab01c845 || layout === $cac57eed68474c1f$export$2cbc54593c64b1f2 ? layout : $cac57eed68474c1f$export$3ea9e188ab01c845;
const $cac57eed68474c1f$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $cac57eed68474c1f$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $26c6284b781fc82b$export$b5e6eff3efdc4860));


const $fd8f31229a524c35$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $fd8f31229a524c35$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $fd8f31229a524c35$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $cac57eed68474c1f$export$2cbc54593c64b1f2) ? $fd8f31229a524c35$var$leftAlignStyle : $fd8f31229a524c35$var$centerAlignStyle;


const $65506e9a5bee1a79$export$477bb32cbededd65 = (config)=>{
    const tableNode = config.isNestingSupported ? (0, $39Puj.tableWithNestedTable) : (0, $39Puj.table);
    return {
        ...tableNode,
        toDOM: (node)=>{
            const isFullPageEditor = !config.isChromelessEditor && !config.isCommentEditor;
            const isInContentMode = (0, $cdX2q.isTableInContentMode)({
                tableNode: node,
                isSupported: (0, $f683956911721579$export$e217d2a535d6ae45)({
                    allowColumnResizing: config.allowColumnResizing,
                    allowTableResizing: config.tableResizingEnabled,
                    isFullPageEditor: isFullPageEditor
                }),
                isTableNested: config.isNested
            }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
            const alignmentStyle = Object.entries((0, $fd8f31229a524c35$export$b4e2cb644a5e9e7e)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(v)}`).join(';');
            const tableMinWidth = (0, $cec18a6f3d8c1f93$export$e7ee55be67771d90)(node);
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-ssr-placeholder': `table-${node.attrs.localId}`,
                'data-ssr-placeholder-replace': `table-${node.attrs.localId}`
            };
            if (isInContentMode) attrs['data-initial-width-mode'] = 'content';
            if ((0, $ieeJu.expValEquals)('platform_editor_table_display_mode_in_to_dom', 'isEnabled', true)) attrs['data-table-display-mode'] = node.attrs.displayMode;
            // This would be used for table scaling in colgroup CSS
            // cqw, or px is well supported
            const resizableTableWidth = isFullPageEditor ? (0, $a2b54432792761eb$export$30421da09613cb3d)(node, config.isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $cec18a6f3d8c1f93$export$465034143db788da)(node, config.isCommentEditor, config.isChromelessEditor, config.isNested, config.isTableScalingEnabled, config.shouldUseIncreasedScalingPercent)
            ];
            const roundedTableCornerMasks = (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? [
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        class: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK,
                        'data-corner': 'left'
                    }
                ],
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        class: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK,
                        'data-corner': 'right'
                    }
                ]
            ] : [];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-wrapper'
                    },
                    ...roundedTableCornerMasks,
                    [
                        'table',
                        attrs,
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ],
                ...(0, $iAEsk.isSSRStreaming)() ? [
                    [
                        'div',
                        {
                            contenteditable: 'false',
                            class: 'pm-table-left-border',
                            'data-with-numbered-table': node.attrs.isNumberColumnEnabled,
                            'data-testid': 'table-left-border'
                        }
                    ],
                    [
                        'div',
                        {
                            contenteditable: 'false',
                            class: 'pm-table-right-border',
                            'data-testid': 'table-right-border'
                        }
                    ]
                ] : []
            ];
            if (!config.tableResizingEnabled || config.isNested) return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true',
                    style: (0, $8Dx7s.convertToInlineCss)({
                        '--ak-editor-table-width': resizableTableWidth
                    })
                },
                tableContainerDiv
            ];
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: (0, $8Dx7s.convertToInlineCss)({
                            '--ak-editor-table-gutter-padding': config.isTableScalingEnabled ? 'calc(var(--ak-editor--large-gutter-padding) * 2)' : 'calc(var(--ak-editor--large-gutter-padding) * 2 - var(--ak-editor-resizer-handle-spacing))',
                            '--ak-editor-table-width': isInContentMode ? 'max-content' : resizableTableWidth,
                            width: `var(--ak-editor-table-width)`
                        })
                    },
                    [
                        'div',
                        {
                            class: (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) ? 'resizer-item display-handle' : (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('resizer-item', {
                                'display-handle': !isInContentMode
                            }),
                            style: (0, $8Dx7s.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-max-width': `${(0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916)}px`,
                                '--ak-editor-table-min-width': `${tableMinWidth}px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: (0, $a2b54432792761eb$export$817f7cd897b65634)(config.isCommentEditor, config.isChromelessEditor, config.isTableScalingEnabled),
                                width: isInContentMode ? 'auto' : (0, $a2b54432792761eb$export$7d968ec824de6aa6)(node, config.isCommentEditor, config.isChromelessEditor)
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableResizingDiv
            ];
        }
    };
};


















const $bec9b600a021f606$var$EMPTY_STATE = {
    cellPos: -1,
    decorationSet: (0, $8nvEM.DecorationSet).empty
};
const $bec9b600a021f606$export$88e8c90fa17a6a30 = new (0, $kCECX.PluginKey)('tableActiveCellHighlight');
/**
 * Returns the position of the cell containing the cursor, or -1 if the cursor
 * is not in a table cell or the selection is a CellSelection.
 */ const $bec9b600a021f606$var$getActiveCellPos = (state)=>{
    if (state.selection instanceof (0, $8HW7o.CellSelection)) return -1;
    try {
        const cell = (0, $cycWk.findCellClosestToPos)(state.selection.$from);
        return cell ? cell.pos : -1;
    } catch  {
        return -1;
    }
};
const $bec9b600a021f606$var$buildState = (cellPos, state)=>{
    if (cellPos === -1) return $bec9b600a021f606$var$EMPTY_STATE;
    try {
        const cell = state.doc.nodeAt(cellPos);
        if (!cell) return $bec9b600a021f606$var$EMPTY_STATE;
        const decoration = (0, $8nvEM.Decoration).node(cellPos, cellPos + cell.nodeSize, {
            class: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL
        });
        return {
            cellPos: cellPos,
            decorationSet: (0, $8nvEM.DecorationSet).create(state.doc, [
                decoration
            ])
        };
    } catch  {
        return $bec9b600a021f606$var$EMPTY_STATE;
    }
};
const $bec9b600a021f606$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $bec9b600a021f606$export$88e8c90fa17a6a30,
        state: {
            init: (_, state)=>{
                return $bec9b600a021f606$var$buildState($bec9b600a021f606$var$getActiveCellPos(state), state);
            },
            apply: (tr, prev, _oldState, newState)=>{
                if (tr.docChanged) // Doc changed — always rebuild since positions may have shifted
                return $bec9b600a021f606$var$buildState($bec9b600a021f606$var$getActiveCellPos(newState), newState);
                if (!tr.selectionSet) // Neither doc nor selection changed — nothing to do
                return prev;
                // Selection changed — only rebuild if cursor moved to a different cell
                const nextCellPos = $bec9b600a021f606$var$getActiveCellPos(newState);
                if (nextCellPos === prev.cellPos) return prev;
                return $bec9b600a021f606$var$buildState(nextCellPos, newState);
            }
        },
        props: {
            decorations: (state)=>{
                return $bec9b600a021f606$export$88e8c90fa17a6a30.getState(state)?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
};











var $3u5lg = parcelRequire("3u5lg");





var $btvbC = parcelRequire("btvbC");

var $gWBVp = parcelRequire("gWBVp");

var $b9BvQ = parcelRequire("b9BvQ");

var $fud2r = parcelRequire("fud2r");


















const $20fa832ab1c7e819$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };







const $54d06cc8ab559031$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };


var $hC0Ga = parcelRequire("hC0Ga");

var $bc8rR = parcelRequire("bc8rR");

var $8imfU = parcelRequire("8imfU");

var $2xHHU = parcelRequire("2xHHU");

const $b730fae248040f82$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $2xHHU.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};


var $WABbQ = parcelRequire("WABbQ");

var $b3vr9 = parcelRequire("b3vr9");



const $f60381991620365d$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $2xHHU.cloneTr)(tr);
        }
        return tr;
    };




var $5I4Vo = parcelRequire("5I4Vo");
















/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json



const $a10022ebdc03afe1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tablePlugin');


/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $1A89X = parcelRequire("1A89X");








var $6SJ6d = parcelRequire("6SJ6d");













const $0a5cb7a587a71a47$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableWidthPlugin');
const $0a5cb7a587a71a47$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, maxWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $0a5cb7a587a71a47$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($0a5cb7a587a71a47$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($0a5cb7a587a71a47$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = (0, $6SJ6d.isReplaceDocOperation)(transactions, oldState);
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if ((0, $cdX2q.isTableInContentMode)({
                    tableNode: node,
                    isSupported: (0, $f683956911721579$export$e217d2a535d6ae45)({
                        allowColumnResizing: true,
                        allowTableResizing: true,
                        isFullPageEditor: true
                    }),
                    isTableNested: false
                })) return;
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (maxWidthEnabled) tableWidthCal = (0, $7Y8M5.akEditorMaxWidthLayoutWidth);
                        else if (fullWidthEnabled) tableWidthCal = (0, $7Y8M5.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $7Y8M5.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $7Y8M5.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $7Y8M5.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: _width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $1A89X.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916))) tr.setNodeAttribute(pos, 'width', (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $cac57eed68474c1f$export$2cbc54593c64b1f2));
                        }
                    });
                });
            });
            return tr;
        }
    });
};


// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck








var $kSwu1 = parcelRequire("kSwu1");


var $iwjSV = parcelRequire("iwjSV");


var $k4g0R = parcelRequire("k4g0R");













/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");








var $fKJ7J = parcelRequire("fKJ7J");


var $lpNn5 = parcelRequire("lpNn5");


const $977973bf2fc837bd$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
            description: formatMessage((0, $fKJ7J.messages).adjustColumns),
            keymap: (0, $ldqjS.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};


const $cfea602767863767$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $cfea602767863767$export$8042b574593bd713 = (decorationSet)=>$cfea602767863767$var$filterDecorationByKey((0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_SELECTED, decorationSet);
const $cfea602767863767$export$6577d2f7fe84e45c = (decorationSet)=>$cfea602767863767$var$filterDecorationByKey((0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER, decorationSet);
const $cfea602767863767$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $8nvEM.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING
        }, {
            key: (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER
        }));
const $cfea602767863767$export$ecf836094c108a0 = (cells, type, tr, hoveredIndexes, danger, selected)=>{
    const table = (0, $cycWk.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $cycWk.findTable)(selection);
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL
        ];
        if (danger) classes.push((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL);
        if (type === 'column' || type === 'row') {
            classes.pop();
            classes.push((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT);
        }
        let key;
        switch(type){
            case 'row':
                key = (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $8nvEM.Decoration).node(pos, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $cfea602767863767$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $cycWk.findTable)(selection);
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $8nvEM.Decoration).node(pos + table.start, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + table.start + cell.nodeSize, {
            class: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_SELECTED}_${index}`
        });
    });
};
const $cfea602767863767$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $8nvEM.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $cfea602767863767$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $cfea602767863767$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $cfea602767863767$var$makeArray = (n)=>Array.from(Array(n).keys());
const $cfea602767863767$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl, nodeViewPortalProviderAPI)=>{
    const table = (0, $cycWk.findTable)(tr.selection);
    if (!table || !table.node) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    if (!map.width) return [];
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $8nvEM.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $kSwu1.RawIntlProvider), {
                    value: getIntl()
                }, (0, $cozmU.createElement)((0, $977973bf2fc837bd$export$e84bed3a1e3da852), {
                    startIndex: cellColumnPositioning.left,
                    endIndex: cellColumnPositioning.right,
                    includeTooltip: includeTooltip
                })), element, decorationRenderKey);
            return element;
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (_node)=>{
                nodeViewPortalProviderAPI.remove(decorationRenderKey);
            }
        });
    };
    const resizeHandleCellDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
        }
    }
    return resizeHandleCellDecorations;
};
const $cfea602767863767$export$c1faae7fcf0653ce = (selection, cellColumnPositioning)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isLastColumn ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE;
    const cellPositions = $cfea602767863767$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $8nvEM.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $k4g0R.nonNullable));
};
const $cfea602767863767$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $cfea602767863767$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $8nvEM.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $k4g0R.nonNullable));
};
const $cfea602767863767$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $8nvEM.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $k4g0R.nonNullable));
};


const $d10972e8b512aa41$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);


const $8b7a319ed8b36e3a$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $8HW7o.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $8b7a319ed8b36e3a$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $cfea602767863767$export$6577d2f7fe84e45c)(decorationSet));
const $8b7a319ed8b36e3a$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$8b7a319ed8b36e3a$var$isColumnSelected(tr)) return decorationSet;
    return (0, $cfea602767863767$export$77a59c867f92cbc7)(tr.doc, decorationSet, (0, $cfea602767863767$export$9bd7e7efc13bb839)(tr), (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_SELECTED);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $8b7a319ed8b36e3a$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $cfea602767863767$export$8042b574593bd713)(decorationSet));
const $8b7a319ed8b36e3a$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $cfea602767863767$export$8042b574593bd713)(decorationSet).length;
const $8b7a319ed8b36e3a$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$8b7a319ed8b36e3a$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $8b7a319ed8b36e3a$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $8b7a319ed8b36e3a$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr })=>{
    return (0, $d10972e8b512aa41$export$c3909dd6d9555879)([
        $8b7a319ed8b36e3a$var$removeColumnControlsSelectedDecoration,
        $8b7a319ed8b36e3a$var$removeControlsHoverDecoration,
        $8b7a319ed8b36e3a$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};


const $f9ba8a550809a188$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableDecorationsPlugin');
const $f9ba8a550809a188$export$968abecb43309c32 = (state)=>$f9ba8a550809a188$export$18d4026d1ea86bb1.getState(state);
const $f9ba8a550809a188$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    const isResizing = (0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1).getState(newState)?.resizing;
    const wasResizing = (0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1).getState(oldState)?.resizing;
    const { isInDanger: isInDanger, isTableHovered: isTableHovered } = (0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $8nvEM.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $8HW7o.CellSelection) || changedResizing) return (0, $8b7a319ed8b36e3a$export$967c329e5e466f2)({
        decorationSet: decorationSet,
        tr: tr
    });
    else if (tr.selectionSet) {
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $8HW7o.CellSelection)) return (0, $8b7a319ed8b36e3a$export$cbb3730335eda2fb)({
            decorationSet: decorationSet,
            tr: tr
        });
        // We're exiting a table with an existing decorations so we should clean it up
        if ((isInDanger || isTableHovered) && (!(0, $5I4Vo.insideTable)(newState) || (0, $cycWk.findTable)(newState.selection)?.node !== (0, $cycWk.findTable)(oldState.selection)?.node)) return (0, $8b7a319ed8b36e3a$export$967c329e5e466f2)({
            decorationSet: decorationSet,
            tr: tr
        });
    }
    return decorationSet;
};
const $f9ba8a550809a188$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>(0, $8nvEM.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $f9ba8a550809a188$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $f9ba8a550809a188$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$f9ba8a550809a188$export$968abecb43309c32(state)
        }
    });
};





const $928f94d8311fbe27$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $cfea602767863767$export$77a59c867f92cbc7)(tr.doc, decorationSet, columnResizesDecorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET);
const $928f94d8311fbe27$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)=>({ tr: tr, decorationSet: decorationSet })=>{
        const columnResizesDecorations = columnEndIndex < 0 ? [] : (0, $cfea602767863767$export$dab489ad285db87)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl, nodeViewPortalProviderAPI);
        return (0, $d10972e8b512aa41$export$c3909dd6d9555879)([
            $928f94d8311fbe27$var$updateColumnResizeHandle(columnResizesDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $928f94d8311fbe27$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        return (0, $d10972e8b512aa41$export$c3909dd6d9555879)([
            $928f94d8311fbe27$var$updateColumnResizeHandle([])
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };



var $cI8RZ = parcelRequire("cI8RZ");

// #region Imports

var $kVd8s = parcelRequire("kVd8s");


var $3tKiV = parcelRequire("3tKiV");













const $a004efca12670bed$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $a004efca12670bed$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};





const $c3bb9070ade8eb63$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableFlexiColumnResizing');






var $eOaGc = parcelRequire("eOaGc");




const $9a55b3e43b8a3cae$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $9a55b3e43b8a3cae$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $cycWk.findTable)(selection);
    if (!nodePos) return $9a55b3e43b8a3cae$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $aPdNQ.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $9a55b3e43b8a3cae$var$bail();
    const canWrap = (0, $eOaGc.findWrapping)(range, expand);
    if (canWrap === null) return $9a55b3e43b8a3cae$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
		 * Do we ever want to deal with the result of `findWrapping`? Probably not,
		 * but we have it anyway.
		 */ findWrappingRes: canWrap
    };
};
const $9a55b3e43b8a3cae$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $9a55b3e43b8a3cae$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
	 * TODO: add attrs: { __expanded: false } when
	 * - it is working with new collab (CEMS-1204)
	 * - synchrony is no longer used
	 *
	 *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
	 *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
	 */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};














const $8e70e8c6596c6b3f$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $8e70e8c6596c6b3f$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $8Z43Z.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch  {
        return false;
    }
    return true;
};
const $8e70e8c6596c6b3f$export$86a810659e2d575 = (table)=>{
    const map = (0, $8Z43Z.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $8e70e8c6596c6b3f$export$653b4f383b39a1d0 = (selection)=>$8e70e8c6596c6b3f$var$filterNearSelection(selection, (0, $cycWk.findTable), $8e70e8c6596c6b3f$export$a21ded6c12f16fdf, false);
const $8e70e8c6596c6b3f$export$b8efdc0183f04d59 = (selection)=>$8e70e8c6596c6b3f$var$filterNearSelection(selection, (0, $cycWk.findTable), $8e70e8c6596c6b3f$export$86a810659e2d575, false);
const $8e70e8c6596c6b3f$export$101f2696d8127fe0 = (selection)=>$8e70e8c6596c6b3f$var$filterNearSelection(selection, (0, $cycWk.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $8e70e8c6596c6b3f$export$4910020ffe58186f = (node)=>{
    return $8e70e8c6596c6b3f$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $8e70e8c6596c6b3f$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    const currentTableWidths = $8e70e8c6596c6b3f$var$getTableWidths(currentTable);
    const previousTableWidths = $8e70e8c6596c6b3f$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $8e70e8c6596c6b3f$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $8Z43Z.TableMap).get(previousTable);
    const currentMap = (0, $8Z43Z.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $8e70e8c6596c6b3f$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $8Z43Z.TableMap).get(previousTable);
    const currentMap = (0, $8Z43Z.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $8e70e8c6596c6b3f$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $8e70e8c6596c6b3f$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    const tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $8e70e8c6596c6b3f$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const $tablePos = state.doc.resolve(tablePos);
    return $tablePos.depth > 0;
};
const $8e70e8c6596c6b3f$export$e31912a493829c23 = (state, tablePos = 0)=>{
    return state.doc.resolve(tablePos).depth > 2;
};
const $8e70e8c6596c6b3f$export$ffa7c963c6f2f204 = (state, tablePos)=>{
    const bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
    if (!bodiedSyncBlock) return false;
    const $pos = state.doc.resolve(tablePos);
    for(let d = $pos.depth; d > 0; d--){
        if ($pos.node(d).type === bodiedSyncBlock) return true;
    }
    return false;
};
const $8e70e8c6596c6b3f$var$anyChildCellMergedAcrossRow = (node)=>(0, $fud2r.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $8e70e8c6596c6b3f$var$anyChildCellMergedAcrossColumn = (node)=>(0, $fud2r.mapChildren)(node, (child)=>child.attrs.colspan || 0).some((colspan)=>colspan > 1);
const $8e70e8c6596c6b3f$export$4af45fdaadf67b18 = (node)=>{
    const allHeaders = (0, $fud2r.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    if ((0, $ieeJu.expValEquals)('platform_editor_fix_sticky_header_malfunction', 'isEnabled', true)) {
        const someMergedAcrossRow = $8e70e8c6596c6b3f$var$anyChildCellMergedAcrossRow(node);
        const someMergedAcrossColumn = $8e70e8c6596c6b3f$var$anyChildCellMergedAcrossColumn(node);
        return allHeaders && !someMergedAcrossRow && !someMergedAcrossColumn;
    }
    const someMerged = $8e70e8c6596c6b3f$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};


const $8af6f9c8a5774031$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $kVd8s.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $8af6f9c8a5774031$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $c3bb9070ade8eb63$export$18d4026d1ea86bb1))) return undefined;
    return resizeHandleColumnIndex;
};
const $8af6f9c8a5774031$var$shouldCloseLegacyContextualMenu = ({ pluginState: pluginState, targetCellPositionChanged: targetCellPositionChanged, tr: tr })=>Boolean(pluginState.isContextualMenuOpen && (targetCellPositionChanged || tr.selectionSet && !(tr.selection instanceof (0, $8HW7o.CellSelection))));
const $8af6f9c8a5774031$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            let targetCellPosition;
            if (tableNode) {
                const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
                const cell = (0, $bjg0G.findParentNodeOfType)([
                    tableCell,
                    tableHeader
                ])(tr.selection);
                targetCellPosition = cell ? cell.pos : undefined;
            }
            const hasTargetCellChanged = pluginState.targetCellPosition !== targetCellPosition;
            const hasActiveTableMenu = pluginState.activeTableMenu != null && pluginState.activeTableMenu.type !== 'none';
            const shouldCloseMenu = hasActiveTableMenu && tr.selectionSet && (!tableNode || hasTargetCellChanged || !(tr.selection instanceof (0, $8HW7o.CellSelection)));
            if (!hasTargetCellChanged && !shouldCloseMenu) return pluginState;
            // The updated table menu is anchored to a table selection. When selection moves
            // to another cell, leaves the table, or changes from a CellSelection to a text cursor,
            // close the active menu so render state cannot point at a stale anchor.
            return {
                ...pluginState,
                targetCellPosition: targetCellPosition,
                activeTableMenu: shouldCloseMenu ? {
                    type: 'none'
                } : pluginState.activeTableMenu
            };
        }
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $bjg0G.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_close_cell_menu_on_move_exp', 'isEnabled', true)) {
            const targetCellPositionChanged = pluginState.targetCellPosition !== targetCellPosition;
            const closeContextualMenu = $8af6f9c8a5774031$var$shouldCloseLegacyContextualMenu({
                pluginState: pluginState,
                targetCellPositionChanged: targetCellPositionChanged,
                tr: tr
            });
            if (!targetCellPositionChanged && !closeContextualMenu) return pluginState;
            // Close the legacy contextual menu when moving cells because the cell background
            // color submenu can otherwise remain open against the previous cell selection.
            return {
                ...pluginState,
                ...closeContextualMenu ? {
                    isContextualMenuOpen: false
                } : {},
                targetCellPosition: targetCellPosition
            };
        }
        if (pluginState.targetCellPosition === targetCellPosition) return pluginState;
        return {
            ...pluginState,
            targetCellPosition: targetCellPosition
        };
    };
const $8af6f9c8a5774031$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $3tKiV.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $a004efca12670bed$export$af473ce758096273),
            tableNode: tableNode,
            ordering: $8af6f9c8a5774031$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $8af6f9c8a5774031$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $8e70e8c6596c6b3f$export$101f2696d8127fe0)(tr.selection),
            isHeaderColumnEnabled: (0, $8e70e8c6596c6b3f$export$653b4f383b39a1d0)(tr.selection),
            isHeaderRowEnabled: (0, $8e70e8c6596c6b3f$export$b8efdc0183f04d59)(tr.selection)
        };
    };
const $8af6f9c8a5774031$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
		 * If we don't have focus, or collapse isn't allowed, or a table node doesn't
		 * exist, we don't need to waste extra checks below
		 */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $bjg0G.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $9a55b3e43b8a3cae$export$34840b5e3787a37c)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $8af6f9c8a5774031$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) {
                if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                    const shouldClearTargetCellPosition = pluginState.targetCellPosition !== undefined;
                    const hasActiveTableMenu = pluginState.activeTableMenu != null && pluginState.activeTableMenu.type !== 'none';
                    if (!shouldClearTargetCellPosition && !hasActiveTableMenu) return pluginState;
                    return {
                        ...pluginState,
                        targetCellPosition: undefined,
                        activeTableMenu: hasActiveTableMenu ? {
                            type: 'none'
                        } : pluginState.activeTableMenu
                    };
                }
                return pluginState.targetCellPosition ? {
                    ...pluginState,
                    targetCellPosition: undefined
                } : pluginState;
            }
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $8af6f9c8a5774031$export$a9962e3214ca2ff7 = (tr, pluginState)=>$8af6f9c8a5774031$var$buildPluginState([
        $8af6f9c8a5774031$var$updateTargetCellPosition,
        $8af6f9c8a5774031$var$updateTableNodePluginState,
        $8af6f9c8a5774031$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $cycWk.findTable)(tr.selection)
    })(pluginState);




var $1d1f9f8d1c6d5c7d$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $a004efca12670bed$export$af473ce758096273)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SET_ACTIVE_TABLE_MENU':
            return {
                ...pluginState,
                ...action.data
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};


const $8fc50ac4440f7aa5$var$dest = (0, $cI8RZ.pluginFactory)((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), (0, $1d1f9f8d1c6d5c7d$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $8af6f9c8a5774031$export$a9962e3214ca2ff7),
    onSelectionChanged: (0, $8af6f9c8a5774031$export$a9962e3214ca2ff7)
});
const $8fc50ac4440f7aa5$export$656c7661095efe2e = $8fc50ac4440f7aa5$var$dest.createPluginState;
const $8fc50ac4440f7aa5$export$8d4021544bdece00 = $8fc50ac4440f7aa5$var$dest.createCommand;
const $8fc50ac4440f7aa5$export$f05434c51e3762e = $8fc50ac4440f7aa5$var$dest.getPluginState;

















const $ca53c3bdaf050947$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;


function $c436026b333ec16f$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $c436026b333ec16f$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $c436026b333ec16f$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $c436026b333ec16f$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $c436026b333ec16f$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO: ED-26961 - There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // TODO: ED-26961 - doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $ca53c3bdaf050947$export$d486eb5767febcd9)(style.minWidth));
            const { width: width } = $c436026b333ec16f$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $c436026b333ec16f$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $c436026b333ec16f$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlaskit/editor/no-as-casting
    parent = node.parentNode;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($c436026b333ec16f$var$measureText(canvas, current, font), acc), 0);
    return $c436026b333ec16f$var$measureText(canvas, textContent, font);
}



const $57e3eace369fe9f7$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $57e3eace369fe9f7$export$8c54458430be6d1d(cells, $57e3eace369fe9f7$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? (0, $k8PFz.tableNewColumnMinWidth) : $57e3eace369fe9f7$export$8c54458430be6d1d(cells, $57e3eace369fe9f7$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $k8PFz.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $57e3eace369fe9f7$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $57e3eace369fe9f7$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $8Z43Z.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const col = (0, $bjg0G.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $57e3eace369fe9f7$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $57e3eace369fe9f7$export$8a19622c99267fdf = (amount, css)=>amount + (0, $ca53c3bdaf050947$export$d486eb5767febcd9)(css.paddingLeft) + (0, $ca53c3bdaf050947$export$d486eb5767febcd9)(css.paddingRight);
function $57e3eace369fe9f7$var$calculateColumnWidthCallback(css) {
    return (0, $ca53c3bdaf050947$export$d486eb5767febcd9)(css.width);
}
function $57e3eace369fe9f7$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $ca53c3bdaf050947$export$d486eb5767febcd9)(css.width);
        const { minWidth: minContentWidth } = (0, $c436026b333ec16f$export$698d25a635a3873a)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($57e3eace369fe9f7$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}




const $6a88bd18c82ff0af$export$ce28ec4a9ddaeb6d = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // TODO: ED-26961 - The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};
const $6a88bd18c82ff0af$export$97482f1a2b86c59e = (tr, table, tablePos, modifyCell)=>{
    let rowOffset = tablePos + 1;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        let cellOffset = rowOffset + 1;
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            const modified = modifyCell(cell, rowIndex, colIndex);
            if (!modified.sameMarkup(cell)) tr.setNodeMarkup(cellOffset, modified.type, modified.attrs, modified.marks);
            cellOffset += cell.nodeSize;
        }
        rowOffset += row.nodeSize;
    }
    return tr;
};


const $294a9e2ffe698c99$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $294a9e2ffe698c99$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = (0, $6a88bd18c82ff0af$export$ce28ec4a9ddaeb6d)(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $294a9e2ffe698c99$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $294a9e2ffe698c99$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $294a9e2ffe698c99$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $294a9e2ffe698c99$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $294a9e2ffe698c99$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $294a9e2ffe698c99$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $a2b54432792761eb$export$7bde9ac1d5d663fc)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = (0, $6a88bd18c82ff0af$export$ce28ec4a9ddaeb6d)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $294a9e2ffe698c99$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $7Y8M5.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $7Y8M5.akEditorDefaultLayoutWidth) && totalWidth < (0, $7Y8M5.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $294a9e2ffe698c99$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    const cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $57e3eace369fe9f7$export$43e8ce817a8e5c42)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $57e3eace369fe9f7$export$8c54458430be6d1d)(cells, (_, col)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return (0, $c436026b333ec16f$export$698d25a635a3873a)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $k8PFz.tableCellMinWidth));
        }
    }
    return cols;
}






const $60645b3cbef54bbb$export$884c674a282996e7 = (state, decorations, key)=>(0, $cfea602767863767$export$77a59c867f92cbc7)(state.doc, (0, $f9ba8a550809a188$export$968abecb43309c32)(state), decorations, key);


const $9b2eea537bbdfc67$var$DARK_MODE_CELL_COLOR = '#1f1f21';
const $9b2eea537bbdfc67$var$DARK_MODE_HEADER_COLOR = '#303134';
const $9b2eea537bbdfc67$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
        type: 'SET_EDITOR_FOCUS',
        data: {
            editorHasFocus: editorHasFocus
        }
    });
const $9b2eea537bbdfc67$export$79b661cbf50c3490 = (ref)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $cycWk.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $btvbC.closestElement)(tableRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $8e70e8c6596c6b3f$export$101f2696d8127fe0)(state.selection),
                isHeaderRowEnabled: (0, $8e70e8c6596c6b3f$export$b8efdc0183f04d59)(state.selection),
                isHeaderColumnEnabled: (0, $8e70e8c6596c6b3f$export$653b4f383b39a1d0)(state.selection),
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$c8d277469ceb354b = (name, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $8HW7o.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $b3vr9.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter?.type, {
                    ...cell.nodeAfter?.attrs,
                    [name]: value
                }));
                return true;
            }
        }
        return false;
    };
const $9b2eea537bbdfc67$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $kCECX.TextSelection)) {
            const cell = (0, $cycWk.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $8HW7o.CellSelection)) {
            const rect = (0, $hC0Ga.getSelectionRect)(selection);
            if (!(0, $8e70e8c6596c6b3f$export$b8efdc0183f04d59)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $9b2eea537bbdfc67$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $9b2eea537bbdfc67$export$80a571fa7de8754d = (slice, schema)=>{
    // the background attr in adf should always store the light mode value of the background color
    // and tables which have been created without a background color set will have background as undefined
    // in the undefined case, when pasting from renderer, we get a background color which is the dark mode color
    // we need to convert it back to undefined, otherwise it will be interpreted as a light mode value and be inverted
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            if (maybeCell.type === tableCell && cellAttrs.background === $9b2eea537bbdfc67$var$DARK_MODE_CELL_COLOR || maybeCell.type === tableHeader && cellAttrs.background === $9b2eea537bbdfc67$var$DARK_MODE_HEADER_COLOR) cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $9b2eea537bbdfc67$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $9b2eea537bbdfc67$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $9b2eea537bbdfc67$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $9b2eea537bbdfc67$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $8HW7o.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $9b2eea537bbdfc67$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $cycWk.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $8Z43Z.TableMap).get(currentTable.node);
        const slicedMap = (0, $8Z43Z.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch  {
        return undefined;
    }
};
const $9b2eea537bbdfc67$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table || !type) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const cell = (0, $cycWk.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $9b2eea537bbdfc67$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $b730fae248040f82$export$5b4a0d6329b35552)(state.tr));
    return true;
};
const $9b2eea537bbdfc67$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $8imfU.isTableSelected)(state.selection)) return $9b2eea537bbdfc67$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $9b2eea537bbdfc67$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $cycWk.findTable)(tr.selection);
        const map = (0, $8Z43Z.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $9b2eea537bbdfc67$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $8e70e8c6596c6b3f$export$b75dc620676872cc)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $8e70e8c6596c6b3f$export$b75dc620676872cc)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
    ensure we're just at a top level paragraph
    otherwise, perform regular backspace behaviour
   */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $kCECX.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $kCECX.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $9b2eea537bbdfc67$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if ((0, $bc8rR.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $f60381991620365d$export$aa21d3b96c1c378c)((0, $cycWk.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $cycWk.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $f60381991620365d$export$aa21d3b96c1c378c)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                editorView?.focus();
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $9b2eea537bbdfc67$export$95deba1419fe5dbe = (attrs, targetCellPosition)=>({ tr: tr })=>{
        let cursorPos;
        if ((0, $bc8rR.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (0, $f60381991620365d$export$aa21d3b96c1c378c)((0, $cycWk.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (typeof targetCellPosition === 'number') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $cycWk.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            (0, $f60381991620365d$export$aa21d3b96c1c378c)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) return tr;
        return null;
    };
const $9b2eea537bbdfc67$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const cells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const decorations = (0, $cfea602767863767$export$9bd7e7efc13bb839)((0, $WABbQ.selectColumn)(column, expand)(state.tr));
        const decorationSet = (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>(0, $WABbQ.selectColumn)(column, expand)(tr).setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard));
const $9b2eea537bbdfc67$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $20fa832ab1c7e819$export$c14b77638b178c5d)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $cfea602767863767$export$9bd7e7efc13bb839)((0, $WABbQ.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $WABbQ.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $9b2eea537bbdfc67$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        let targetCellPosition;
        const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $WABbQ.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $9b2eea537bbdfc67$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $WABbQ.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$72433e6f15f8aeaa = (columnIndex)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$27d9631a056c3f39 = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, nodeViewPortalProviderAPI, isKeyboardResize)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $cycWk.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $928f94d8311fbe27$export$aa1fe977609f5606)(rowIndex, columnIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $f9ba8a550809a188$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$31eed8673ceee613 = (nodeViewPortalProviderAPI, rowIndex, columnIndex, includeTooltip)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $cycWk.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $928f94d8311fbe27$export$aa1fe977609f5606)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $f9ba8a550809a188$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$99c5230572e6696d = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $928f94d8311fbe27$export$a590d16867e1babd)()({
                    tr: state.tr,
                    decorationSet: (0, $f9ba8a550809a188$export$968abecb43309c32)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $9b2eea537bbdfc67$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $294a9e2ffe698c99$export$8d491ebb055c561d)(view, node, table, basePos, opts));
    return true;
};
const $9b2eea537bbdfc67$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $b9BvQ.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $gWBVp.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong?.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $9b2eea537bbdfc67$export$833849b68219cbcc = (widthToWidest)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const { widthToWidest: prevWidthToWidest } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $9b2eea537bbdfc67$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $cycWk.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $9ppjA.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $9b2eea537bbdfc67$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $9ppjA.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $9b2eea537bbdfc67$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));


var $daffbf7d97cd68e0$export$4e6e4e454d4dbb37 = /*#__PURE__*/ function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
    return AnalyticPluginTypes;
}({});








const $3ec45f70f752e6b4$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableAnalyticPlugin');



const $427fb8e6065c9b4f$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};


const $c2b99cb3c2146547$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $daffbf7d97cd68e0$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $daffbf7d97cd68e0$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $427fb8e6065c9b4f$export$49d5fc8cba920a0).rowOrColumnMoved
            };
        default:
            return state;
    }
};


const $7f9af87869911ca3$var$dest = (0, $cI8RZ.pluginFactory)((0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1), (0, $c2b99cb3c2146547$export$1650419e431d3ba3));
const $7f9af87869911ca3$export$656c7661095efe2e = $7f9af87869911ca3$var$dest.createPluginState;
const $7f9af87869911ca3$export$8d4021544bdece00 = $7f9af87869911ca3$var$dest.createCommand;
const $7f9af87869911ca3$export$f05434c51e3762e = $7f9af87869911ca3$var$dest.getPluginState;




const $7d6ed378f4570360$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $7d6ed378f4570360$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $7d6ed378f4570360$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $427fb8e6065c9b4f$export$49d5fc8cba920a0).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells || prevState.numberOfCells,
        type: nextState?.type
    };
};


const $5dabf810bb68e726$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $7f9af87869911ca3$export$8d4021544bdece00)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $7f9af87869911ca3$export$f05434c51e3762e)(state);
        const data = (0, $7d6ed378f4570360$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $daffbf7d97cd68e0$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5dabf810bb68e726$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $daffbf7d97cd68e0$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1), payload);
    };
const $5dabf810bb68e726$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $7f9af87869911ca3$export$f05434c51e3762e)(state);
        const data = (0, $7d6ed378f4570360$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $daffbf7d97cd68e0$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1), payload);
    };





const $5398dae1191b57c8$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $kpCD8.SafePlugin)({
        key: (0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1),
        state: (0, $7f9af87869911ca3$export$656c7661095efe2e)(dispatch, (0, $427fb8e6065c9b4f$export$49d5fc8cba920a0)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta((0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1))?.data?.currentActions?.includes('pasted'));
            if (tr) {
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        type: tr.getMeta((0, $3ec45f70f752e6b4$export$18d4026d1ea86bb1))?.data?.type
                    }
                });
                return (0, $5dabf810bb68e726$export$39ebe85f9f5fbe7e)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $9b2eea537bbdfc67$export$1798097ddb0b05de)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $9b2eea537bbdfc67$export$950c7c2913136ae5)(state.selection, type)) return;
                const count = (0, $9b2eea537bbdfc67$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $5dabf810bb68e726$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $9b2eea537bbdfc67$export$e5b37491e59cd9d)(state.selection);
                const count = (0, $9b2eea537bbdfc67$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $5dabf810bb68e726$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });


// #region Imports

var $cTqvh = parcelRequire("cTqvh");











var $hZ5o2 = parcelRequire("hZ5o2");














var $6i2ZP = parcelRequire("6i2ZP");







const $0f04fd8275596ede$export$93d48be6ee61745 = (columnIndex)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (table) {
            const map = (0, $8Z43Z.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $2xHHU.cloneTr)((0, $6i2ZP.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex));
        }
        return tr;
    };








var $bAYhP = parcelRequire("bAYhP");












const $73553921a0bcae47$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        const foundCells = [];
        const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $73553921a0bcae47$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (table) {
            const map = (0, $8Z43Z.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $f719K.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                const cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    const rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        const foundCells = $73553921a0bcae47$var$filterCellsInRow(i, (cell, _tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $f60381991620365d$export$aa21d3b96c1c378c)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $bjg0G.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };
const $73553921a0bcae47$export$643f25d380b0167d = (rowIndex, clonePreviousRow)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (table) {
            const map = (0, $8Z43Z.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $2xHHU.cloneTr)($73553921a0bcae47$export$46bec710cf196d80(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $2xHHU.cloneTr)((0, $bAYhP.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex));
        }
        return tr;
    };




var $91iSj = parcelRequire("91iSj");











/**
 * A plugin is created for collecting payload data for tableOverflowChanged analytics event
 */ 










const $a734f122c6a2cd61$var$pluginKey = new (0, $kCECX.PluginKey)('tableOverflowAnalyticsPlugin');
const $a734f122c6a2cd61$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $a734f122c6a2cd61$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $kpCD8.SafePlugin)({
        key: $a734f122c6a2cd61$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($a734f122c6a2cd61$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($a734f122c6a2cd61$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const newPluginState = $a734f122c6a2cd61$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            const lastTriggerName = newPluginState?.lastTrigger?.name || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($a734f122c6a2cd61$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $jzpoq.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($a734f122c6a2cd61$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });































var $6pnwK = parcelRequire("6pnwK");











function $8d0629bb8e812232$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $cycWk.findTable)(selection);
    if (table) {
        map = (0, $8Z43Z.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $8d0629bb8e812232$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $8d0629bb8e812232$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $8d0629bb8e812232$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI?.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $8d0629bb8e812232$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $8Z43Z.TableMap).get(props.resizedNode);
    return {
        action: (0, $jzpoq.TABLE_ACTION).RESIZED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(props.resizedNode) ? (0, $8e70e8c6596c6b3f$export$4910020ffe58186f)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $8d0629bb8e812232$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $8d0629bb8e812232$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $8d0629bb8e812232$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $jzpoq.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $8d0629bb8e812232$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    const frameCount = (0, $cozmU.useRef)(0);
    const lastTime = (0, $cozmU.useRef)(0);
    const timeoutId = (0, $cozmU.useRef)();
    const frameRateSamples = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};
const $8d0629bb8e812232$var$tableContainerNodes = new Set([
    'layoutSection',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'extensionFrame',
    'table',
    'tableCell',
    'tableHeader',
    'tableRow'
]);
const $8d0629bb8e812232$export$208d2421b73f3f86 = (editorView, editorWidth)=>{
    const tablesInfo = [];
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$8d0629bb8e812232$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                tableWidth: table.scrollWidth,
                isNestedTable: isNestedTable,
                hasScrollbar: table.parentElement ? table?.parentElement.clientWidth < table.scrollWidth : false
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    return {
        action: (0, $jzpoq.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $6pnwK.getBreakpointKey)(editorWidth),
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            maxTableWidthBreakpoint: (0, $6pnwK.getBreakpointKey)(maxTableWidth),
            tableWidthInfo: tablesInfo,
            mode: 'editor'
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
};
const $8d0629bb8e812232$export$34e5b28c67455a81 = (editorView)=>{
    const tablesInfo = [];
    const editorPopupScrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
    // don't send the event if the editor scroll parent is not available
    if (!editorPopupScrollParent) return undefined;
    const editorScrollParentClientHeight = editorPopupScrollParent.clientHeight;
    const isEditorScrollable = editorPopupScrollParent.scrollHeight > editorScrollParentClientHeight;
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$8d0629bb8e812232$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                isNestedTable: isNestedTable,
                tableHeight: table.scrollHeight
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    return {
        action: (0, $jzpoq.TABLE_ACTION).TABLE_EDITOR_HEIGHT_INFO,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        attributes: {
            editorScrollParentClientHeight: editorScrollParentClientHeight,
            isEditorScrollable: isEditorScrollable,
            maxTableToEditorHeightRatio: maxTableHeight / editorScrollParentClientHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
};










var $2vkhA = parcelRequire("2vkhA");

var $3IK8A = parcelRequire("3IK8A");




















/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json







const $deb80ec534adbdde$export$3efa753685336605 = "var(--ds-surface, #FFFFFF)";
const $deb80ec534adbdde$export$95883e661e73a1d1 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $deb80ec534adbdde$export$1b578d7ab4fc0385 = "var(--ds-background-neutral-subtle, #00000000)";
const $deb80ec534adbdde$export$14da8da34a807702 = "var(--ds-text-subtlest, #6B6E76)";
const $deb80ec534adbdde$export$60473ec4f7c2b794 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $deb80ec534adbdde$export$5aac4cb73ae3f2da = "var(--ds-background-neutral, #0515240F)";
const $deb80ec534adbdde$export$f26d047169b4195d = "var(--ds-blanket-selected, #388BFF14)";
const $deb80ec534adbdde$export$7c0a2e8110d12a28 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $deb80ec534adbdde$export$8c5dd0fc35774ae1 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $deb80ec534adbdde$export$9bf0891aaaf2fecb = "var(--ds-border-focused, #4688EC)";
const $deb80ec534adbdde$export$a699493d7d7580c3 = "var(--ds-icon-subtle, #505258)";
const $deb80ec534adbdde$export$cd5e5900c9fa42dc = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $deb80ec534adbdde$export$3c2a828febe9d506 = "var(--ds-blanket-danger, #EF5C4814)";
const $deb80ec534adbdde$export$870d72a5700e711d = "var(--ds-border-danger, #E2483D)";
const $deb80ec534adbdde$export$e7bba7ffd7bf3c50 = "var(--ds-background-danger-pressed, #FFB8B2)";
const $deb80ec534adbdde$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, #FFFFFF)";
const $deb80ec534adbdde$export$9907ca2ad437ddcc = "var(--ds-background-danger-bold, #C9372C)";
const $deb80ec534adbdde$export$371da7842ff35a5b = 3;
const $deb80ec534adbdde$export$e5ff276883773ffd = 8;
const $deb80ec534adbdde$export$92421f8864c287b1 = 15;
const $deb80ec534adbdde$export$cbcfa4314b903419 = 2;
const $deb80ec534adbdde$export$6d23b13c5fcb846c = 20;
const $deb80ec534adbdde$export$cb376ed67c7ae37e = 16;
const $deb80ec534adbdde$export$52b432855099b8bd = 6;
const $deb80ec534adbdde$export$a4d60e31f4f6188b = (0, $7Y8M5.akEditorTableToolbarSize);
const $deb80ec534adbdde$export$880976487022eb5 = (0, $k8PFz.tableMarginTop) + $deb80ec534adbdde$export$e5ff276883773ffd - (0, $k8PFz.tableCellBorderWidth);
const $deb80ec534adbdde$export$73b1242ebdcc73be = 3;
const $deb80ec534adbdde$export$86dfc955b6099b88 = 32;
const $deb80ec534adbdde$export$893fc0cfd2a0c40e = 13;
const $deb80ec534adbdde$export$a3e71c692f2c2213 = 4;
const $deb80ec534adbdde$export$62374dd2f63076b0 = 25;
const $deb80ec534adbdde$export$da0ccd381b1a80f = (0, $7Y8M5.akEditorUnitZIndex) * 10;
const $deb80ec534adbdde$export$83da30a15600a83e = $deb80ec534adbdde$export$da0ccd381b1a80f + 1;
const $deb80ec534adbdde$export$45aeeddcedd441ab = (0, $7Y8M5.akEditorUnitZIndex) * 10;
const $deb80ec534adbdde$export$5b53cc051bf05434 = $deb80ec534adbdde$export$83da30a15600a83e + 1;
const $deb80ec534adbdde$export$cc7ed656b7dcf729 = 3;
const $deb80ec534adbdde$export$72409f838e9c33c7 = (0, $93ebfcf1771919c4$export$1a38c7157d718094) / 3;
const $deb80ec534adbdde$export$45d9825f76985b4e = 2;
const $deb80ec534adbdde$export$887c1388be90c08e = $deb80ec534adbdde$export$da0ccd381b1a80f + (0, $7Y8M5.akRichMediaResizeZIndex);
const $deb80ec534adbdde$export$3969371f057ce1e5 = 16;
const $deb80ec534adbdde$export$42d9040c5091b076 = 250;
const $deb80ec534adbdde$export$1279af870a198fea = $deb80ec534adbdde$export$887c1388be90c08e + 2;
const $deb80ec534adbdde$export$83c60dd0aac17107 = 8;
const $deb80ec534adbdde$export$13b0e72269a9a3aa = 1;
const $deb80ec534adbdde$export$40311377f05dbfc4 = 8;
const $deb80ec534adbdde$export$1680d391e1ce7b96 = 32;
const $deb80ec534adbdde$export$3cdde837cf189e96 = 188;
const $deb80ec534adbdde$export$9c3151841258b6f0 = 24;
const $deb80ec534adbdde$export$a13fb25a398e2fab = (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex) - 5;
const $deb80ec534adbdde$export$471fb2a0b2f2f936 = $deb80ec534adbdde$export$a13fb25a398e2fab + 1;
const $deb80ec534adbdde$export$7b64f35449327c05 = $deb80ec534adbdde$export$a13fb25a398e2fab - 1;
const $deb80ec534adbdde$export$b2015400488f9243 = 14;
const $deb80ec534adbdde$export$8f6133b6e2b4291 = 9;
const $deb80ec534adbdde$export$edb1b9caf8ff5b32 = 10;
const $deb80ec534adbdde$export$7af5c65e392a647 = 2;
const $deb80ec534adbdde$export$11cf30061861ec4a = 5;
const $deb80ec534adbdde$export$858d012f03ae70a5 = -68;
const $deb80ec534adbdde$export$a13bd817a2eda041 = 92;
const $deb80ec534adbdde$export$e0140c2b978caac5 = 4;
const $deb80ec534adbdde$export$c6a9e7014cf7aedc = 6;
const $deb80ec534adbdde$export$963fb187132ee7cf = 250;
const $deb80ec534adbdde$export$d18320cc8ee69115 = 16;
const $deb80ec534adbdde$export$6bec1f8a2aa82be8 = 150;
const $deb80ec534adbdde$export$c2ef52861254b274 = 14;
const $deb80ec534adbdde$export$2c18704a8d793cdb = 7;
const $deb80ec534adbdde$export$150cd2564fec30b7 = 8;


const $51948cb73f37d26f$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $cycWk.findTable)(selection);
    if (table) {
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const cellRef = (0, $bjg0G.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $51948cb73f37d26f$export$e4820f63cd163896 = (totalWidth, columnCount, ratios)=>{
    const evenSplit = ()=>new Array(columnCount).fill(totalWidth / columnCount);
    if (!ratios || ratios.length !== columnCount) return evenSplit();
    const total = ratios.reduce((sum, ratio)=>sum + (ratio > 0 ? ratio : 0), 0);
    if (total <= 0) return evenSplit();
    return ratios.map((ratio)=>totalWidth * ((ratio > 0 ? ratio : 0) / total));
};
const $51948cb73f37d26f$export$cf5a0e252f1598f1 = (view)=>{
    const { selection: selection } = view.state;
    const table = (0, $cycWk.findTable)(selection);
    if (!table) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const domAtPos = view.domAtPos.bind(view);
    const widths = Array.from({
        length: map.width
    });
    for(let i = 0; i < map.width; i++){
        if (map.isCellMergedTopLeft(0, i)) continue;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(map.map[i]);
        const pos = map.map[i] + table.start;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const cellRef = (0, $bjg0G.findDomRefAtPos)(pos, domAtPos);
        const rect = cellRef.getBoundingClientRect();
        const measuredWidth = (rect ? rect.width : cellRef.offsetWidth) + 1;
        const colspan = node.attrs.colspan ?? 1;
        if (colspan <= 1) {
            widths[i] = measuredWidth;
            continue;
        }
        const colwidth = Array.isArray(node.attrs.colwidth) ? node.attrs.colwidth : undefined;
        const perColumnWidths = $51948cb73f37d26f$export$e4820f63cd163896(measuredWidth, colspan, colwidth);
        for(let span = 0; span < colspan && i + span < map.width; span++)widths[i + span] = perColumnWidths[span];
        i += colspan - 1;
    }
    return widths;
};
const $51948cb73f37d26f$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $deb80ec534adbdde$export$cb376ed67c7ae37e) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $51948cb73f37d26f$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $51948cb73f37d26f$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $51948cb73f37d26f$export$d231dfb66a75f6c1 = (tr, { useColwidthRatios: useColwidthRatios = false } = {})=>{
    // get the colspans
    const rowColSpans = (0, $btvbC.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $btvbC.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        const domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...useColwidthRatios ? $51948cb73f37d26f$var$getRelativeDomCellWidths(cell) : new Array(cell.colspan).fill(cell.width / cell.colspan));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $51948cb73f37d26f$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $51948cb73f37d26f$export$b8d525853cd49bde = (cellElement, mouseEvent, columnIndexRange)=>{
    const { startIndex: startIndex, endIndex: endIndex } = columnIndexRange;
    const columnCount = endIndex - startIndex;
    if (columnCount <= 0) return undefined;
    const cellRect = cellElement.getBoundingClientRect();
    if (mouseEvent.clientX < cellRect.left || mouseEvent.clientX >= cellRect.right) return undefined;
    // Read DOM ratios here to avoid resolving the ProseMirror node on this mouse-move path.
    const ratios = cellElement.dataset.colwidth?.split(',').map(Number).filter((value)=>!Number.isNaN(value));
    const perColumnWidths = $51948cb73f37d26f$export$e4820f63cd163896(cellRect.width, columnCount, ratios);
    const offsetFromLeft = mouseEvent.clientX - cellRect.left;
    let cumulativeWidth = 0;
    for(let column = 0; column < columnCount; column++){
        cumulativeWidth += perColumnWidths[column];
        if (offsetFromLeft < cumulativeWidth) return startIndex + column;
    }
    return endIndex - 1;
};
const $51948cb73f37d26f$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $51948cb73f37d26f$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};




















const $d44e2b3965cf0527$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        const rows = tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $3IK8A.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $d44e2b3965cf0527$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $deb80ec534adbdde$export$cb376ed67c7ae37e) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $d44e2b3965cf0527$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $d44e2b3965cf0527$export$6fa6c264fb9023fb = (tableRef, mouseEvent, rowIndexRange)=>{
    const tableBody = tableRef.querySelector('tbody');
    if (!tableBody) return undefined;
    const rows = tableBody.children;
    const startIndex = rowIndexRange?.startIndex ?? 0;
    const endIndex = Math.min(rowIndexRange?.endIndex ?? rows.length, rows.length);
    if (startIndex >= endIndex) return undefined;
    const firstRowRect = rows[startIndex].getBoundingClientRect();
    if (mouseEvent.clientY < firstRowRect.top) return undefined;
    let rowBottom = firstRowRect.bottom;
    if (mouseEvent.clientY < rowBottom) return startIndex;
    for(let rowIndex = startIndex + 1; rowIndex < endIndex; rowIndex++){
        const rowRect = rows[rowIndex].getBoundingClientRect();
        rowBottom = rowRect.bottom;
        if (mouseEvent.clientY < rowBottom) return rowIndex;
    }
    return undefined;
};
const $d44e2b3965cf0527$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $8imfU.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $d44e2b3965cf0527$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $cycWk.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $8Z43Z.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            const cells = [];
            const fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $bjg0G.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };


const $629d677dec0f3c2a$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
        $629d677dec0f3c2a$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $d44e2b3965cf0527$export$3e5149a60ac7416b)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $629d677dec0f3c2a$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $629d677dec0f3c2a$export$3658aa65e79e3104 = (view, event)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    if (!(0, $2vkhA.containsClassName)(target, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $btvbC.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $629d677dec0f3c2a$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $3IK8A.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $k8PFz.tableCellBorderWidth);
    table.style.marginTop = `${(0, $k8PFz.tableMarginTop) + firstRowHeight}px`;
};
const $629d677dec0f3c2a$var$applyColWidthsToStickyRow = (colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $51948cb73f37d26f$export$d231dfb66a75f6c1)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $629d677dec0f3c2a$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $629d677dec0f3c2a$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $629d677dec0f3c2a$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $629d677dec0f3c2a$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) $629d677dec0f3c2a$var$syncCornerMasksToStickyRow(tableRef, headerRow, wrapper);
    }
};
const $629d677dec0f3c2a$export$324b8139ca20d6a6 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    const wrapper = tableRef.parentElement;
    if (!headerRow || !wrapper) return;
    $629d677dec0f3c2a$var$syncCornerMasksToStickyRow(tableRef, headerRow, wrapper);
};
const $629d677dec0f3c2a$export$b6a476e1427b061 = (tableRef)=>{
    const wrapper = tableRef?.parentElement;
    if (!wrapper) return;
    wrapper.querySelectorAll(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK}`).forEach((mask)=>{
        mask.style.removeProperty('left');
    });
};
const $629d677dec0f3c2a$var$syncCornerMasksToStickyRow = (tableRef, headerRow, wrapper)=>{
    const cornerMasks = wrapper.querySelectorAll(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK}`);
    if (!cornerMasks.length) return;
    const isLegacySticky = tableRef.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY) && headerRow.classList.contains('sticky');
    if (!isLegacySticky) {
        $629d677dec0f3c2a$export$b6a476e1427b061(tableRef);
        return;
    }
    const stickyRowRect = headerRow.getBoundingClientRect();
    cornerMasks.forEach((mask)=>{
        const corner = mask.dataset.corner;
        const left = corner === 'right' ? stickyRowRect.right - 11 : stickyRowRect.left - 1;
        mask.style.left = `${left}px`;
    });
};



const $da3a78eceffe80bd$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && table.attrs?.width) {
        const scalePercent = (0, $a2b54432792761eb$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $hac25.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $k8PFz.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $k8PFz.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $cec18a6f3d8c1f93$export$ae5d9647f2a0891c)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !table.attrs?.width ? maxSize : (0, $9ppjA.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $57e3eace369fe9f7$export$43e8ce817a8e5c42)(index, table, start, domAtPos);
        return (0, $57e3eace369fe9f7$export$5c09bfb77c404ce)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $da3a78eceffe80bd$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef?.querySelectorAll(':scope > colgroup > col');
    const columnsCount = cols?.length;
    /**
     updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
     We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
     We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
     * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $cec18a6f3d8c1f93$export$66302252070a658d)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $k8PFz.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols?.[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols?.[i]) cols[i].style.width = `${(0, $cec18a6f3d8c1f93$export$66302252070a658d)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tableRef);
};
const $da3a78eceffe80bd$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $da3a78eceffe80bd$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $da3a78eceffe80bd$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $k8PFz.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $da3a78eceffe80bd$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $da3a78eceffe80bd$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $da3a78eceffe80bd$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $da3a78eceffe80bd$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $da3a78eceffe80bd$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $da3a78eceffe80bd$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $da3a78eceffe80bd$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $da3a78eceffe80bd$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $da3a78eceffe80bd$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $da3a78eceffe80bd$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fixes total table widths by adding missing pixels to columns widths here and there
    return $da3a78eceffe80bd$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $da3a78eceffe80bd$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $da3a78eceffe80bd$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement?.closest('table');
    if (!tableRef) return;
    const layout = $da3a78eceffe80bd$var$normaliseTableLayout(tableRef?.dataset.layout);
    const maxSize = (0, $a2b54432792761eb$export$8bfbafe1083a527d)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = $da3a78eceffe80bd$export$38f73cf370cfaafc({
        minWidth: (0, $k8PFz.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $da3a78eceffe80bd$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};









var $95bQO = parcelRequire("95bQO");









const $da07a0ba1e0d1d07$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $da07a0ba1e0d1d07$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $da07a0ba1e0d1d07$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $da3a78eceffe80bd$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
const $da07a0ba1e0d1d07$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $da07a0ba1e0d1d07$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $da3a78eceffe80bd$export$fbc5c7e5991c30a8)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $da07a0ba1e0d1d07$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $da3a78eceffe80bd$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
function $da07a0ba1e0d1d07$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $57e3eace369fe9f7$export$529a1befd331574)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $da07a0ba1e0d1d07$var$ColType = /*#__PURE__*/ function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
    return ColType;
}($da07a0ba1e0d1d07$var$ColType || {});
// TODO: ED-26961 - should handle when destIdx:
// - is beyond the range, and then not give it back
function $da07a0ba1e0d1d07$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $57e3eace369fe9f7$export$529a1befd331574)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($da07a0ba1e0d1d07$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($da07a0ba1e0d1d07$var$amountFor("src")(amount) < 0 && $da07a0ba1e0d1d07$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $da07a0ba1e0d1d07$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $da07a0ba1e0d1d07$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $da3a78eceffe80bd$export$fbc5c7e5991c30a8)(state);
        if (totalWidth - srcCol.width + $da07a0ba1e0d1d07$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $da07a0ba1e0d1d07$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $da07a0ba1e0d1d07$var$stackSpace(state, destIdx, amount) {
    let candidates = $da07a0ba1e0d1d07$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        const candidateIdx = $da07a0ba1e0d1d07$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $57e3eace369fe9f7$export$529a1befd331574)(column) <= 0) break;
        const res = $da07a0ba1e0d1d07$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $da07a0ba1e0d1d07$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $57e3eace369fe9f7$export$529a1befd331574)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $da07a0ba1e0d1d07$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $da07a0ba1e0d1d07$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $da07a0ba1e0d1d07$var$amountFor(colType)(amount);
}
function $da07a0ba1e0d1d07$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $da07a0ba1e0d1d07$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}





// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $094ae3eb1cbee718$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $9ppjA.getTableContainerWidth)(node) : (0, $a2b54432792761eb$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $8e70e8c6596c6b3f$export$4910020ffe58186f)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $9ppjA.getTableContainerWidth)(node) : (0, $a2b54432792761eb$export$7bde9ac1d5d663fc)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $7Y8M5.akEditorTableNumberColumnWidth);
    const resizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
        minWidth: (0, $k8PFz.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $094ae3eb1cbee718$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $094ae3eb1cbee718$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
        minWidth: (0, $k8PFz.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $7Y8M5.akEditorTableNumberColumnWidth);
    return $094ae3eb1cbee718$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $094ae3eb1cbee718$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $da3a78eceffe80bd$export$fbc5c7e5991c30a8)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    const newTotalWidth = (0, $da3a78eceffe80bd$export$fbc5c7e5991c30a8)(newState);
    if (newTotalWidth > maxSize) newState = (0, $da07a0ba1e0d1d07$export$827dd2d6fa38543e)(newState, newTotalWidth - maxSize);
    return (0, $da3a78eceffe80bd$export$b07f5f5f9c98720a)(newState, maxSize);
}
const $094ae3eb1cbee718$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, allowFixedColumnWidthOption = false, isCommentOrChromelessEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && allowFixedColumnWidthOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentOrChromelessEditor;
    const resizeState = parentWidth ? $094ae3eb1cbee718$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, shouldUseIncreasedScalingPercent) : $094ae3eb1cbee718$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $da3a78eceffe80bd$export$23e0010f5fd8981)(resizeState, tableRef, node, false, 1);
};
const $094ae3eb1cbee718$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $cec18a6f3d8c1f93$export$ae5d9647f2a0891c)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) {
            // When the table is nested inside a bodiedSyncBlock, the table's outer transparent
            // left/right borders (1px total under `border-collapse: collapse`) cause the
            // table's outer width to exceed the colgroup width by 1px. Subtract 1px from the
            // parentWidth here so that the scaled colgroup fits within the sync-block
            // container without overflowing.
            const isNestedInBodiedSyncBlock = !!tableRef.closest?.(`.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).content}`);
            const BORDER_COLLAPSE_WIDTH_PX = 1;
            const adjustedParentWidth = isNestedInBodiedSyncBlock ? parentWidth - BORDER_COLLAPSE_WIDTH_PX : parentWidth;
            resizeState = $094ae3eb1cbee718$var$scaleWithParent(tableRef, adjustedParentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        } else resizeState = $094ae3eb1cbee718$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $3785adcc5f70ea76$export$6688b13ec132acdf)(resizeState, node, start, api)(tr);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
           scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
           Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
         */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };


const $3785adcc5f70ea76$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $8Z43Z.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $eOaGc.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth === undefined ? null : updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api?.batchAttributeUpdates) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $3785adcc5f70ea76$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement?.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $a2b54432792761eb$export$44361276769f7eff)(table.node),
                possibleMaxWidth: (0, $a2b54432792761eb$export$a34136fcfaec1907)(table.node),
                isResized: isResized
            };
            else previousTableInfo = {
                // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                /** the is the width the table can reach before overflowing */ possibleMaxWidth: tableRef?.parentElement?.clientWidth || 0,
                isResized: isResized
            };
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $8Z43Z.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $k8PFz.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $k8PFz.tableCellMinWidth) || previousTableInfo.isResized && (0, $cec18a6f3d8c1f93$export$2878318085bf6dbf)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $k8PFz.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $k8PFz.tableCellMinWidth),
                        minWidth: (0, $k8PFz.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $3785adcc5f70ea76$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
                minWidth: (0, $k8PFz.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $094ae3eb1cbee718$export$5de2ae9923ce5a0)(resizeState, previousTableInfo.possibleMaxWidth);
            return $3785adcc5f70ea76$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };





/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $fbc6377033140eb5$export$1c3aefb711c3a4cc = ()=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $fbc6377033140eb5$var$staticValue = false;
const $fbc6377033140eb5$export$31b40729666a4ae0 = {
    setStatic (value) {
        $fbc6377033140eb5$var$staticValue = value;
    },
    generate () {
        return $fbc6377033140eb5$var$staticValue || $fbc6377033140eb5$export$1c3aefb711c3a4cc();
    }
};


const $0bd99c63caf0cceb$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $0bd99c63caf0cceb$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $f719K.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $0bd99c63caf0cceb$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $0bd99c63caf0cceb$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $fbc6377033140eb5$export$31b40729666a4ae0).generate(),
        width: width,
        layout: layout
    }, rows);
};






const $94c5e3c97a03aca7$var$NESTED_TABLE_DEFAULT_ROWS = 2;
const $94c5e3c97a03aca7$var$NESTED_TABLE_DEFAULT_COLS = 2;
const $94c5e3c97a03aca7$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isMaxWidthModeEnabled: isMaxWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, isNestedTable: isNestedTable, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isNestedTable) {
            attrsOverrides.rowsCount = createTableProps?.rowsCount ? createTableProps?.rowsCount : $94c5e3c97a03aca7$var$NESTED_TABLE_DEFAULT_ROWS;
            attrsOverrides.colsCount = createTableProps?.colsCount ? createTableProps?.colsCount : $94c5e3c97a03aca7$var$NESTED_TABLE_DEFAULT_COLS;
        }
        if (isTableScalingEnabled && !isCommentEditor) {
            if (((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled) attrsOverrides.tableWidth = (0, $26c6284b781fc82b$export$8a91b25da594a758);
            else if (isFullWidthModeEnabled) attrsOverrides.tableWidth = (0, $26c6284b781fc82b$export$bffd6819c009a916);
        }
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $0bd99c63caf0cceb$export$33bbb3ec7652e187)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };



function $90f868070281c7fb$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}




function $1eaa45a3d80bffa1$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (table) return tr.step((0, $cTqvh.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $1eaa45a3d80bffa1$export$93d48be6ee61745(api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $1eaa45a3d80bffa1$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $0f04fd8275596ede$export$93d48be6ee61745)(column)(updatedTr);
            const table = (0, $cycWk.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $3785adcc5f70ea76$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $5dabf810bb68e726$export$800a77929fdae774)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $1eaa45a3d80bffa1$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $cycWk.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $91iSj.selectedRect)(state);
            dispatch($1eaa45a3d80bffa1$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $90f868070281c7fb$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $1eaa45a3d80bffa1$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $cycWk.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $91iSj.selectedRect)(state);
            dispatch($1eaa45a3d80bffa1$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $90f868070281c7fb$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $1eaa45a3d80bffa1$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            const tr = $1eaa45a3d80bffa1$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $90f868070281c7fb$export$f8ddfdc64e14a808)(state), view)(state.tr);
            const table = (0, $cycWk.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $8Z43Z.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $1eaa45a3d80bffa1$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $8e70e8c6596c6b3f$export$b8efdc0183f04d59)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $d44e2b3965cf0527$export$173c92a3a1ff68a7)(state.schema)(row)(state.tr) : (0, $73553921a0bcae47$export$643f25d380b0167d)(row, undefined)(state.tr);
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $8Z43Z.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $5dabf810bb68e726$export$800a77929fdae774)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $1eaa45a3d80bffa1$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, isMaxWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $bjg0G.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT,
                    ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                        parentNode: state.selection.$from.node(-1)?.type.name
                    } : {}
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $1eaa45a3d80bffa1$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isMaxWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isMaxWidthModeEnabled: isMaxWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $bjg0G.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: rowsCount,
                    totalColumnCount: colsCount,
                    ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                        parentNode: tr.selection.$from.node(-1)?.type.name
                    } : {}
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(newTr);
            return newTr;
        };
    };
const $1eaa45a3d80bffa1$export$b57b177fe1ab7f1f = ({ isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, isFullWidthModeEnabled: isFullWidthModeEnabled = false, isMaxWidthModeEnabled: isMaxWidthModeEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, isTableResizingEnabled: isTableResizingEnabled = false, createTableProps: createTableProps = {} }, api, analyticsPayload)=>({ tr: tr })=>{
        // Delegate to the markdown plugin to insert a markdown table string at the CM cursor position.
        const markdownState = api?.markdownMode?.sharedState.currentState();
        if (markdownState?.isMarkdownMode && markdownState?.view === 'syntax' && (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $ixfCV.fg)('platform_editor_markdown_compatible_toolbar')) {
            api?.markdownMode?.actions.insertSourceTable(createTableProps.rowsCount, createTableProps.colsCount);
            return tr;
        }
        const { schema: schema } = tr.doc.type;
        // If the cursor is inside a table
        let insertAt;
        let isNestedTable = false;
        if ((0, $bjg0G.hasParentNodeOfType)(schema.nodes.table)(tr.selection) && (0, $hZ5o2.isNestedTablesSupported)(schema)) {
            // If trying to nest deeper than one level, we insert the table after the top table
            if ((0, $euISL.getParentOfTypeCount)(schema.nodes.table)(tr.selection.$from) > 1) {
                const positionAfterTopTable = (0, $is9bZ.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(tr.selection.$from);
                if (!positionAfterTopTable) return tr;
                insertAt = (0, $kCECX.TextSelection).create(tr.doc, positionAfterTopTable);
            } else // Table can be nested in parent table
            isNestedTable = true;
        }
        const node = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled,
            isNestedTable: isNestedTable,
            createTableProps: createTableProps
        })(schema);
        api?.contentInsertion?.commands?.insert({
            node: node,
            options: {
                selectNodeInserted: false,
                analyticsPayload: analyticsPayload ? {
                    ...analyticsPayload,
                    attributes: {
                        ...analyticsPayload.attributes,
                        localId: node.attrs.localId,
                        ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                            parentNode: tr.selection.$from.node(-1)?.type.name
                        } : {}
                    }
                } : undefined,
                insertAt: insertAt
            }
        })({
            tr: tr
        });
        return tr;
    };


const $9424facaeaa63c09$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};


















var $fEPSi = parcelRequire("fEPSi");


var $eFgM7 = parcelRequire("eFgM7");


var $38vK5 = parcelRequire("38vK5");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");
















const $61cf1c01aee4adc2$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $61cf1c01aee4adc2$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};
const $61cf1c01aee4adc2$export$dcbd781e48a8c658 = (selection)=>{
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!rect) return false;
    const table = (0, $cycWk.findTableClosestToPos)(selection.$anchorCell);
    if (!table) return false;
    const map = (0, $8Z43Z.TableMap).get(table.node);
    if (rect.bottom !== map.height || rect.top === 0) return false;
    for(let col = rect.left; col < rect.right; col++){
        const topCellRect = map.findCell(map.map[col]);
        const isHorizontallyMerged = topCellRect.right - topCellRect.left > 1;
        const bridgesGapAboveSelection = topCellRect.bottom >= rect.top;
        if (!isHorizontallyMerged || !bridgesGapAboveSelection) return false;
    }
    return true;
};
const $61cf1c01aee4adc2$export$8e35aa0e81c25478 = (selection)=>{
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!rect) return false;
    const table = (0, $cycWk.findTableClosestToPos)(selection.$anchorCell);
    if (!table) return false;
    const map = (0, $8Z43Z.TableMap).get(table.node);
    if (rect.right !== map.width || rect.left === 0) return false;
    for(let row = rect.top; row < rect.bottom; row++){
        const leftCellRect = map.findCell(map.map[row * map.width]);
        const isVerticallyMerged = leftCellRect.bottom - leftCellRect.top > 1;
        const bridgesGapLeftOfSelection = leftCellRect.right >= rect.left;
        if (!isVerticallyMerged || !bridgesGapLeftOfSelection) return false;
    }
    return true;
};
const $61cf1c01aee4adc2$export$3a10391c7abbe1c8 = (selection)=>{
    if (!(selection instanceof (0, $8HW7o.CellSelection))) return false;
    return selection.isRowSelection() || selection.isColSelection() || $61cf1c01aee4adc2$export$8e35aa0e81c25478(selection) || $61cf1c01aee4adc2$export$dcbd781e48a8c658(selection);
};


const $4c617ebfadab8027$var$applyMenuUserIntent = (tr, api, nextActiveTableMenu)=>{
    if (nextActiveTableMenu.type === 'row' || nextActiveTableMenu.type === 'column') {
        api?.userIntent?.commands.setCurrentUserIntent('tableDragMenuPopupOpen')({
            tr: tr
        });
        return;
    }
    api?.userIntent?.commands.setCurrentUserIntent((0, $61cf1c01aee4adc2$export$3a10391c7abbe1c8)(tr.selection) ? 'dragHandleSelected' : 'default')({
        tr: tr
    });
};
const $4c617ebfadab8027$export$68481d8823bb24fb = (api, options)=>({ tr: tr })=>{
        const nextActiveTableMenu = {
            type: 'none'
        };
        tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), {
            type: 'SET_ACTIVE_TABLE_MENU',
            data: {
                activeTableMenu: nextActiveTableMenu
            }
        });
        if (!options?.skipUserIntent) $4c617ebfadab8027$var$applyMenuUserIntent(tr, api, nextActiveTableMenu);
        if (!tr.docChanged) tr.setMeta('addToHistory', false);
        return tr;
    };
const $4c617ebfadab8027$var$isSameActiveTableMenu = (current, next)=>{
    if (!current || current.type !== next.type) return false;
    if (current.type === 'row' || current.type === 'column') return next.type === current.type && current.index === next.index;
    return true;
};
const $4c617ebfadab8027$export$5744ca63af11af1a = (activeTableMenu, currentActiveTableMenu, api)=>({ tr: tr })=>{
        const nextActiveTableMenu = $4c617ebfadab8027$var$isSameActiveTableMenu(currentActiveTableMenu, activeTableMenu) ? {
            type: 'none'
        } : activeTableMenu;
        tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), {
            type: 'SET_ACTIVE_TABLE_MENU',
            data: {
                activeTableMenu: nextActiveTableMenu
            }
        });
        $4c617ebfadab8027$var$applyMenuUserIntent(tr, api, nextActiveTableMenu);
        tr.setMeta('addToHistory', false);
        return tr;
    };











const $42b76cc10c347878$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $btvbC.closestElement)(node, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}`) || !!(0, $btvbC.closestElement)(node, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL}`)));
};
const $42b76cc10c347878$export$94cf9243187b20f0 = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON);
const $42b76cc10c347878$export$7a8d111d40fb198c = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW) || (0, $btvbC.closestElement)(node, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`) || (0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY) && (0, $btvbC.closestElement)(node, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS}`);
const $42b76cc10c347878$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $42b76cc10c347878$export$a1261fc41ec5bc0f = (target)=>{
    if (target.hasAttribute('data-start-index')) return target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const closestWithIndex = target.closest('[data-start-index]');
    return closestWithIndex ?? target;
};
const $42b76cc10c347878$export$14eb53395cc0cf57 = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
const $42b76cc10c347878$export$edad492f0c70264f = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON) || (0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
const $42b76cc10c347878$export$4cf9002f70d2d324 = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION);
const $42b76cc10c347878$export$b4f0758743701ac9 = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || (0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP);
const $42b76cc10c347878$export$2b59104f44ee317b = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER) || (0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER);
const $42b76cc10c347878$export$b2ae534578c0ae33 = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $42b76cc10c347878$export$666ae3fd07127e7f = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $42b76cc10c347878$export$571c943db7bc729c = (node)=>(0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON) || (0, $2vkhA.containsClassName)(node, (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER);
const $42b76cc10c347878$export$75641d19d3ee2fef = (target)=>target instanceof HTMLElement && Boolean(target.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER}`));
const $42b76cc10c347878$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $42b76cc10c347878$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $42b76cc10c347878$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $btvbC.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $42b76cc10c347878$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $42b76cc10c347878$export$449115d164fc37c3 = (element)=>{
    if (!element || element instanceof Window) return 0;
    return element?.getBoundingClientRect?.()?.top ?? 0;
};
const $42b76cc10c347878$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = cell?.parentElement ?? undefined;
    if (!Number.isFinite(row?.rowIndex) || !Number.isFinite(cell?.cellIndex)) return undefined;
    return {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        row: row.rowIndex,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        col: cell.cellIndex
    };
};
const $42b76cc10c347878$export$732358707dcc2511 = (entry)=>{
    const rects = [
        entry.boundingClientRect,
        entry.rootBounds,
        entry.intersectionRect
    ];
    return rects.every((rect)=>rect && rect.width === 0 && rect.height === 0 && rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0);
};







const $a5103e1f191e6e99$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $a5103e1f191e6e99$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return false;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $a5103e1f191e6e99$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $a5103e1f191e6e99$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $8Z43Z.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $a5103e1f191e6e99$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $cycWk.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $8Z43Z.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $a5103e1f191e6e99$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return false;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $a5103e1f191e6e99$export$9af117e01db30223(indexes, map, type);
    };
const $a5103e1f191e6e99$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    const minIndex = Math.min(...indexes);
    const maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
   * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
   TODO: ED-22335 this should better called only when hover over the drag handle.
  */ const isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    const isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $a5103e1f191e6e99$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};


const $74fcba9734962ef8$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};











function $cd8622176ff49d46$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the nth (last) cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the nth (last) cell is also a header then the entire row/col is a header.
    // Be careful though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we won't be able to reliably identify header state on tables smaller than 2x2, however we can make a best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, n) is a header cell or not
    // bit: 2 = Identifies if the cell at (n, 0) is a header cell or not
    let mask = 0;
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width - 1]);
        // If the cell at (0, n) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width * (tableMap.height - 1)]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}










const $dc111febbca139e1$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(startIndex)(tr.selection);
        const firstRowCells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };





const $03a0ad15414f3c6d$export$9cb09a71b7d66923 = (array)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array[0].map((_, i)=>{
        return array.map((column)=>column[i]);
    });
};
const $03a0ad15414f3c6d$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $8Z43Z.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};
const $03a0ad15414f3c6d$var$moveRowInArrayOfRows = (arrayOfNodes, indexesOrigin, indexesTarget, directionOverride)=>{
    const direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;
    const rowsExtracted = arrayOfNodes.splice(indexesOrigin[0], indexesOrigin.length);
    const positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
    let target;
    if (directionOverride === -1 && direction === 1) target = indexesTarget[0] - 1;
    else if (directionOverride === 1 && direction === -1) target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
    else target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
    // @ts-ignore no idea what this line does
    arrayOfNodes.splice.apply(arrayOfNodes, [
        target,
        0
    ].concat(rowsExtracted));
    return arrayOfNodes;
};
const $03a0ad15414f3c6d$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $8Z43Z.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};
const $03a0ad15414f3c6d$export$8eeacd95914015c2 = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $03a0ad15414f3c6d$export$63019a088e9d8f5f(table.node);
    rows = $03a0ad15414f3c6d$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    return $03a0ad15414f3c6d$export$5c8f3870f9ad667(table.node, rows);
};
const $03a0ad15414f3c6d$export$18d467ff157d6daa = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $03a0ad15414f3c6d$export$9cb09a71b7d66923($03a0ad15414f3c6d$export$63019a088e9d8f5f(table.node));
    rows = $03a0ad15414f3c6d$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    rows = $03a0ad15414f3c6d$export$9cb09a71b7d66923(rows);
    return $03a0ad15414f3c6d$export$5c8f3870f9ad667(table.node, rows);
};
const $03a0ad15414f3c6d$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};





function $d704d12ea36e8328$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $d704d12ea36e8328$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $8Z43Z.TableMap).get(table.node);
        const originalColumnRanges = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $03a0ad15414f3c6d$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $f719K.tableNodeTypes)(state.schema);
        const direction = $d704d12ea36e8328$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $cd8622176ff49d46$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $d704d12ea36e8328$var$createContentNodeFactory(table);
        const newTr = (0, $2xHHU.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $d704d12ea36e8328$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$d704d12ea36e8328$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $8HW7o.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $d704d12ea36e8328$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $d704d12ea36e8328$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $d704d12ea36e8328$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}
















const $f47473adc66224ff$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(startIndex)(tr.selection);
        const firstColumnCells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };






function $786fcfa51c3f2fd3$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $786fcfa51c3f2fd3$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $8Z43Z.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $f47473adc66224ff$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $f47473adc66224ff$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $03a0ad15414f3c6d$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $f719K.tableNodeTypes)(state.schema);
        const direction = $786fcfa51c3f2fd3$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $2xHHU.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $cd8622176ff49d46$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$786fcfa51c3f2fd3$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $f47473adc66224ff$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $8HW7o.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $786fcfa51c3f2fd3$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}















function $7d11a11b7b597792$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : dir;
}






const $75071edeee7d70da$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $8Z43Z.TableMap).get(table.node);
        const originalColumnRanges = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $03a0ad15414f3c6d$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $f719K.tableNodeTypes)(state.schema);
        const direction = (0, $7d11a11b7b597792$export$3d9c15b8c24b72f5)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $cd8622176ff49d46$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $75071edeee7d70da$var$createContentNodeFactory(table);
        const newTr = (0, $2xHHU.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $75071edeee7d70da$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' || tableMap.isCellMergedTopLeft(y, actualTargetIndex) ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$75071edeee7d70da$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $dc111febbca139e1$export$7032a6f0de5ecc29)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $8HW7o.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $75071edeee7d70da$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $75071edeee7d70da$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $75071edeee7d70da$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}




















const $bf83f2cf4d61ca8d$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $8Z43Z.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $f47473adc66224ff$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $f47473adc66224ff$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $03a0ad15414f3c6d$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $f719K.tableNodeTypes)(state.schema);
        const direction = (0, $7d11a11b7b597792$export$3d9c15b8c24b72f5)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $2xHHU.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $cd8622176ff49d46$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$bf83f2cf4d61ca8d$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $f47473adc66224ff$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $8HW7o.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $bf83f2cf4d61ca8d$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}





const $77ff0896ebca4b84$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};









const $c13762150e3ca207$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('dragAndDropPlugin');




var $91e5ba46c2b0124f$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $77ff0896ebca4b84$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};


const $9c44a2089c87f26f$var$dest = (0, $cI8RZ.pluginFactory)((0, $c13762150e3ca207$export$18d4026d1ea86bb1), (0, $91e5ba46c2b0124f$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});
const $9c44a2089c87f26f$export$656c7661095efe2e = $9c44a2089c87f26f$var$dest.createPluginState;
const $9c44a2089c87f26f$export$8d4021544bdece00 = $9c44a2089c87f26f$var$dest.createCommand;
const $9c44a2089c87f26f$export$f05434c51e3762e = $9c44a2089c87f26f$var$dest.getPluginState;



// TODO: ED-26961 - This command is a placeholder example. Please replace this if required.
const $a709990a5e57b471$var$getDecorations = (state)=>{
    return (0, $c13762150e3ca207$export$18d4026d1ea86bb1).getState(state)?.decorationSet || (0, $8nvEM.DecorationSet).empty;
};
const $a709990a5e57b471$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $cfea602767863767$export$77a59c867f92cbc7)(state.doc, $a709990a5e57b471$var$getDecorations(state), decorations, key);
const $a709990a5e57b471$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $9c44a2089c87f26f$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $8nvEM.DecorationSet).empty;
        if (type === 'column') decorationSet = $a709990a5e57b471$var$updatePluginStateDecorations(state, (0, $cfea602767863767$export$6012cbb334f87faa)(index, state.selection, hasMergedCells), (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $a709990a5e57b471$var$updatePluginStateDecorations(state, (0, $cfea602767863767$export$c47f6da2c2a0ebc8)(index, state.selection, hasMergedCells), (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ROW_INSERT_LINE);
        return {
            type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $a709990a5e57b471$export$e74dec9e818a8c0b = (tr)=>(0, $9c44a2089c87f26f$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
        if (dropTargetType === (0, $77ff0896ebca4b84$export$9377432e002bc2da).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $8nvEM.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $a709990a5e57b471$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $9c44a2089c87f26f$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $8nvEM.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $bf83f2cf4d61ca8d$export$fbe24096ca2da576) : (0, $75071edeee7d70da$export$d1fbe0eb3fc9219);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $a709990a5e57b471$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $9c44a2089c87f26f$export$8d4021544bdece00)((state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $a709990a5e57b471$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $9c44a2089c87f26f$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $8nvEM.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $786fcfa51c3f2fd3$export$94fc9bbbd60f961f) : (0, $d704d12ea36e8328$export$799175205f855ccd);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });























var $6faDz = parcelRequire("6faDz");








var $63qYG = parcelRequire("63qYG");


var $4R9Nm = parcelRequire("4R9Nm");


var $bWjzw = parcelRequire("bWjzw");


var $jWZGH = parcelRequire("jWZGH");


var $eehur = parcelRequire("eehur");


var $haA5t = parcelRequire("haA5t");


var $iMVfw = parcelRequire("iMVfw");


var $iRp8L = parcelRequire("iRp8L");


var $eh9HJ = parcelRequire("eh9HJ");


var $jJItz = parcelRequire("jJItz");


var $i8vym = parcelRequire("i8vym");


var $81DSz = parcelRequire("81DSz");


var $1isWY = parcelRequire("1isWY");


var $kSpvN = parcelRequire("kSpvN");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $dOBRD = parcelRequire("dOBRD");










var $b4bEA = parcelRequire("b4bEA");





var $2xhuI = parcelRequire("2xhuI");






var $9GCRb = parcelRequire("9GCRb");





var $g6uqx = parcelRequire("g6uqx");





var $xx2Zf = parcelRequire("xx2Zf");


var $j1hRT = parcelRequire("j1hRT");

const $b37f1c99fe49c1e2$var$cellBackgroundColorPalette = [];
(0, $39Puj.tableBackgroundColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $xx2Zf.default)((0, $j1hRT.default), key);
    $b37f1c99fe49c1e2$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $39Puj.tableBackgroundBorderColor),
        message: message
    });
});
var $b37f1c99fe49c1e2$export$2e2bcd8739ae039 = $b37f1c99fe49c1e2$var$cellBackgroundColorPalette;


var $kQOs5 = parcelRequire("kQOs5");




var $dpfrn = parcelRequire("dpfrn");

var $eQeCt = parcelRequire("eQeCt");








var $lrTDq = parcelRequire("lrTDq");






















function $8a3f02cf94899256$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}
function $8a3f02cf94899256$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        const sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $8HW7o.CellSelection))) {
            cellNode = $8a3f02cf94899256$export$603245c099db0b11(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $7zMjs.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            const rect = (0, $91iSj.selectedRect)(state);
            const tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $8HW7o.CellSelection) && $lastCellPosition instanceof (0, $aPdNQ.ResolvedPos)) {
                const cellSelection = new (0, $8HW7o.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}





const $53f42aed97ade489$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $f719K.tableNodeTypes)(state.schema);
    return (0, $8a3f02cf94899256$export$8c441a625fd4d770)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};



var $hZR9z = parcelRequire("hZR9z");


var $6aEgq = parcelRequire("6aEgq");


var $fHs3z = parcelRequire("fHs3z");


var $dPtk6 = parcelRequire("dPtk6");


var $iDfTs = parcelRequire("iDfTs");


var $99F21 = parcelRequire("99F21");










// #region Imports


















const $d3dc0fe24d69f2ab$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $cycWk.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $d3dc0fe24d69f2ab$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $8Z43Z.TableMap).get(prevTableNode);
    const currentTableMap = (0, $8Z43Z.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $fKJ7J.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $fKJ7J.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $fKJ7J.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $fKJ7J.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};



const $47589dd3b7f399b2$var$makeArray = (n)=>Array.from(Array(n).keys());
const $47589dd3b7f399b2$export$59dcdc44819c7e7c = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const mergedCellsPositions = (0, $d3dc0fe24d69f2ab$export$ffded79ba5549697)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $cycWk.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $cfea602767863767$export$e1f7dd2d4ed6c778)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $47589dd3b7f399b2$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const cells = (0, $20fa832ab1c7e819$export$c14b77638b178c5d)(hoveredColumns)(state.tr.selection);
        if (!cells) return false;
        const decorations = (0, $cfea602767863767$export$ecf836094c108a0)(cells, 'column', state.tr, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $47589dd3b7f399b2$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $cfea602767863767$export$ecf836094c108a0)(cells, 'row', state.tr, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $47589dd3b7f399b2$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const table = (0, $cycWk.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const hoveredColumns = $47589dd3b7f399b2$var$makeArray(map.width);
        const hoveredRows = $47589dd3b7f399b2$var$makeArray(map.height);
        const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $cfea602767863767$export$ecf836094c108a0)(cells, 'table', state.tr, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, decorations, (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $47589dd3b7f399b2$export$d4bebf197f3770e4 = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, [], (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $47589dd3b7f399b2$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        return {
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, (0, $cfea602767863767$export$c1faae7fcf0653ce)(state.selection, cellColumnPositioning), (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        };
    });
const $47589dd3b7f399b2$export$5ad4eed96dbaffaf = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $60645b3cbef54bbb$export$884c674a282996e7)(state, [], (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $47589dd3b7f399b2$export$f217071b524cec4f = (hovered)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $47589dd3b7f399b2$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));





const $aab88375fd1dd187$export$fa79c3ccfdddfece = (sourceNode)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $dpfrn.removeConnectedNodes)(state, sourceNode) : tr;
    });

































// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck




var $f8b7c3d9e0c8c2c7$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};


function $78429e61a3e1fdf5$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $78429e61a3e1fdf5$var$factory = (0, $cI8RZ.pluginFactory)((0, $c3bb9070ade8eb63$export$18d4026d1ea86bb1), (0, $f8b7c3d9e0c8c2c7$export$2e2bcd8739ae039), {
    mapping: $78429e61a3e1fdf5$var$mapping
});
const $78429e61a3e1fdf5$export$8d4021544bdece00 = $78429e61a3e1fdf5$var$factory.createCommand;
const $78429e61a3e1fdf5$export$656c7661095efe2e = $78429e61a3e1fdf5$var$factory.createPluginState;
const $78429e61a3e1fdf5$export$f05434c51e3762e = $78429e61a3e1fdf5$var$factory.getPluginState;




const $cb90c04d75301fb4$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $8imfU.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $629d677dec0f3c2a$export$f76d638a91295d45)(event, lastClick)) {
            const newState = (0, $da3a78eceffe80bd$export$aa593d179f012fe1)(resizeState);
            $cb90c04d75301fb4$var$setLastClick(null, (tr)=>(0, $3785adcc5f70ea76$export$6688b13ec132acdf)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $cb90c04d75301fb4$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $cb90c04d75301fb4$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $3785adcc5f70ea76$export$6688b13ec132acdf)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $cb90c04d75301fb4$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $cb90c04d75301fb4$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $cb90c04d75301fb4$export$d1301521f1f26547 = (tr)=>(0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $cb90c04d75301fb4$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $cb90c04d75301fb4$var$setLastClick = (lastClick, transform)=>(0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);





























function $a80eeaee4326e361$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $8HW7o.CellSelection)) || !$a80eeaee4326e361$export$9df87bad3fce982f(tr)) return tr;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $cycWk.findTable)(selection);
    const map = (0, $8Z43Z.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $a80eeaee4326e361$var$isEmptyCell(cell) ? (0, $aPdNQ.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$a80eeaee4326e361$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $a80eeaee4326e361$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $aPdNQ.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $a80eeaee4326e361$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $kCECX.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $a80eeaee4326e361$export$61c1a939609d5bfa(selection) {
    if (!(selection instanceof (0, $8HW7o.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $hC0Ga.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $8Z43Z.TableMap).get(table);
    if ($a80eeaee4326e361$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $a80eeaee4326e361$export$9df87bad3fce982f(tr) {
    return $a80eeaee4326e361$export$61c1a939609d5bfa(tr.selection);
}
function $a80eeaee4326e361$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $a80eeaee4326e361$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $a80eeaee4326e361$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $a80eeaee4326e361$var$getEmptyColumnIndexes(table) {
    const map = (0, $8Z43Z.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $a80eeaee4326e361$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $8Z43Z.TableMap).get(table);
    const emptyColumnIndexes = $a80eeaee4326e361$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}


const $4633e594230ce0eb$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $8Z43Z.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $a80eeaee4326e361$export$84575ef2cffee22a)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $4633e594230ce0eb$var$getNextCursorPos(newTable, rowsToDelete);
        // If we delete a row we should also clean up the hover selection
        tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $4633e594230ce0eb$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $8Z43Z.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}














const $2216df10537483ae$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $f719K.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $2xHHU.cloneTr)(tr);
            }
        }
        return tr;
    };






const $a3f9a14de9b89349$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $bc8rR.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $2216df10537483ae$export$1a1df84fec87e1b5)((0, $cycWk.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $cycWk.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $2216df10537483ae$export$1a1df84fec87e1b5)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $kCECX.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };



const $96985d8b1bf9679d$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $9a55b3e43b8a3cae$export$436c9f28d887a0c3)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};




























// Resize a given column by an amount from the current state


const $29b3570c8ef9d78d$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $da07a0ba1e0d1d07$export$276e2d0f37ca319a)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $da07a0ba1e0d1d07$export$99e30963fc7d1a1e)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $da3a78eceffe80bd$export$23e0010f5fd8981)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};






const $83f03c9ff5611334$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $8fc50ac4440f7aa5$export$8d4021544bdece00)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $83f03c9ff5611334$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos, nodeViewPortalProviderAPI)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $928f94d8311fbe27$export$aa1fe977609f5606)(rowIndex, columnIndex, true, getIntl, nodeViewPortalProviderAPI)({
            tr: customTr,
            decorationSet: (0, $f9ba8a550809a188$export$968abecb43309c32)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $cfea602767863767$export$77a59c867f92cbc7)(customTr.doc, decorationsWithWidget, (0, $cfea602767863767$export$c1faae7fcf0653ce)(state.selection, {
            right: columnIndex
        }), (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $83f03c9ff5611334$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $c3bb9070ade8eb63$export$18d4026d1ea86bb1), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $83f03c9ff5611334$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $bc8rR.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $cycWk.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $83f03c9ff5611334$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos, nodeViewPortalProviderAPI)(state, dispatch);
        return false;
    };
const $83f03c9ff5611334$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $cycWk.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $cycWk.findTableClosestToPos)($currentCell);
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $7zMjs.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $83f03c9ff5611334$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $83f03c9ff5611334$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $83f03c9ff5611334$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch);
            }
        }
        return false;
    };
const $83f03c9ff5611334$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
        const cell = (0, $cycWk.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $8Z43Z.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell?.node.attrs;
        const width = (0, $a2b54432792761eb$export$8f862fd911e06936)(view, cell?.pos, cellAttrs);
        (0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $a2b54432792761eb$export$8bfbafe1083a527d)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
            minWidth: (0, $k8PFz.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $629d677dec0f3c2a$export$13c259c17cfd51f5)()(state);
        const selectionRect = (0, $hC0Ga.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width ? (0, $a2b54432792761eb$export$4e884677f8e54bba)(originalTable, dom) : (0, $a2b54432792761eb$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        const newResizeState = (0, $29b3570c8ef9d78d$export$7f7e69ee7fe25ed6)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $3785adcc5f70ea76$export$6688b13ec132acdf)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $83f03c9ff5611334$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $928f94d8311fbe27$export$a590d16867e1babd)()({
            tr: customTr,
            decorationSet: (0, $f9ba8a550809a188$export$968abecb43309c32)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $cfea602767863767$export$77a59c867f92cbc7)(customTr.doc, decorationWithoutWidget, [], (0, $93ebfcf1771919c4$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $83f03c9ff5611334$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $78429e61a3e1fdf5$export$8d4021544bdece00)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };























function $df09db816a132914$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    const mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $8Z43Z.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                const mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}


const $83bf9e50d594393b$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: ED-26961 - After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $df09db816a132914$export$e526e68a5eecfb66)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        const mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $cTqvh.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $83bf9e50d594393b$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $83bf9e50d594393b$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $83bf9e50d594393b$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $83bf9e50d594393b$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $83bf9e50d594393b$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $8Z43Z.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $83bf9e50d594393b$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $83bf9e50d594393b$var$fixRowSpans(table) {
    const map = (0, $8Z43Z.TableMap).get(table);
    const minRowSpans = $83bf9e50d594393b$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $83bf9e50d594393b$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $83bf9e50d594393b$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $83bf9e50d594393b$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $cycWk.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $3785adcc5f70ea76$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };



const $49fc188cd54a2dd6$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $83bf9e50d594393b$export$9dbd3595d5638a0b)(rect, (0, $90f868070281c7fb$export$f8ddfdc64e14a808)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        // If we delete a column we should also clean up the hover selection
        tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };





const $ff3fa6b291292a64$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $cycWk.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};










var $f9Emz = parcelRequire("f9Emz");















const $afaee1b2f3cac989$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (data && (data.name || data.title)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $afaee1b2f3cac989$export$53e8d4c581cfe158 = (columnIndex, order = (0, $6faDz.SortOrder).DESC)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $cycWk.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $bc8rR.isSelectionType)(tr.selection, 'cell') ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hC0Ga.getSelectionRect)(tr.selection) : (0, $cycWk.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        const tableArray = (0, $03a0ad15414f3c6d$export$63019a088e9d8f5f)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $f9Emz.createCompareNodes)({
            getInlineCardTextFromStore: $afaee1b2f3cac989$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $03a0ad15414f3c6d$export$5c8f3870f9ad667)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $8Z43Z.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $kVd8s.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(table.start + pos)));
    });







const $889db17e17b8e31a$export$3983d6b165b9fd4d = (selection)=>{
    let cellNode;
    if (!(selection instanceof (0, $8HW7o.CellSelection))) {
        cellNode = (0, $8a3f02cf94899256$export$603245c099db0b11)(selection.$from);
        if (!cellNode) return false;
    } else {
        if (selection.$anchorCell.pos !== selection.$headCell.pos) return false;
        cellNode = selection.$anchorCell.nodeAfter;
    }
    return Boolean(cellNode && (cellNode.attrs.colspan !== 1 || cellNode.attrs.rowspan !== 1));
};
const $889db17e17b8e31a$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $8a3f02cf94899256$export$8c441a625fd4d770)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};


//#region Imports






var $gVdWX = parcelRequire("gVdWX");



const $55616d8330b777b9$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $55616d8330b777b9$export$2155c86bec6ad614 = (state, dispatch)=>(0, $gVdWX.toggleHeader)('row')(state, (tr)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $55616d8330b777b9$export$cb41f2462444ad87 = (state, dispatch)=>(0, $gVdWX.toggleHeader)('column')(state, (tr)=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $55616d8330b777b9$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { node: node, pos: pos } = (0, $cycWk.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $55616d8330b777b9$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $cycWk.findTable)(state.selection);
    if (!table) return false;
    const layout = $55616d8330b777b9$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $55616d8330b777b9$export$458dbe7d48b81d0a = ()=>(0, $8fc50ac4440f7aa5$export$8d4021544bdece00)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion


const $70029e39e0a22c66$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).CLEARED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $a3f9a14de9b89349$export$5d68db27bfdddb78)(targetCellPosition));
const $70029e39e0a22c66$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).MERGED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $a80eeaee4326e361$export$124b0cee26577176)(state.tr));
            return true;
        });
const $70029e39e0a22c66$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(selection);
            const cell = (0, $cycWk.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $jzpoq.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $889db17e17b8e31a$export$74933b5979945879));
const $70029e39e0a22c66$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).COLORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $39Puj.tableBackgroundColorPalette).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $9b2eea537bbdfc67$export$91116982335533cf)({
            background: cellColor
        }, editorView));
const $70029e39e0a22c66$var$getNormalizedCellValign = (valign)=>valign ?? 'top';
const $70029e39e0a22c66$var$getCellVerticalAlignmentAnalyticsInfo = (selection, valign, targetCellPosition)=>{
    const selectedValigns = [];
    if (selection instanceof (0, $8HW7o.CellSelection)) selection.forEachCell((cell)=>{
        selectedValigns.push($70029e39e0a22c66$var$getNormalizedCellValign(cell.attrs.valign));
    });
    else if (typeof targetCellPosition === 'number') {
        const cell = selection.$from.doc.nodeAt(targetCellPosition);
        if (cell) selectedValigns.push($70029e39e0a22c66$var$getNormalizedCellValign(cell.attrs.valign));
    }
    if (selectedValigns.length === 0) return undefined;
    const [firstValign] = selectedValigns;
    const previousValign = selectedValigns.every((selectedValign)=>selectedValign === firstValign) ? firstValign : 'mixed';
    const updatedCount = selectedValigns.filter((selectedValign)=>selectedValign !== valign).length;
    return {
        previousValign: previousValign,
        updatedCount: updatedCount
    };
};
const $70029e39e0a22c66$export$816bc15c63933c5f = (editorAnalyticsAPI)=>(inputMethod, valign, targetCellPosition)=>({ tr: tr })=>{
            const analyticsInfo = $70029e39e0a22c66$var$getCellVerticalAlignmentAnalyticsInfo(tr.selection, valign, targetCellPosition);
            const result = (0, $9b2eea537bbdfc67$export$95deba1419fe5dbe)({
                valign: valign
            }, targetCellPosition)({
                tr: tr
            });
            if (result && analyticsInfo) {
                const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(tr.selection);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).CHANGED_CELL_VERTICAL_ALIGNMENT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        previousValign: analyticsInfo.previousValign,
                        valign: valign,
                        updatedCount: analyticsInfo.updatedCount,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
            }
            return result;
        };
const $70029e39e0a22c66$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
            const rect = isCellSelection ? (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $70029e39e0a22c66$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $70029e39e0a22c66$export$e45f3a1f9c021052 = (editorAnalyticsAPI)=>(inputMethod, options)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $1eaa45a3d80bffa1$export$5a4e94bbc04b5f2)(options.index, options.moveCursorToInsertedRow));
const $70029e39e0a22c66$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            return {
                action: (0, $jzpoq.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table?.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $83f03c9ff5611334$export$4627714f08bcfd8)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $70029e39e0a22c66$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $1eaa45a3d80bffa1$export$35ae1d3df4b27cf0)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $70029e39e0a22c66$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $4633e594230ce0eb$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $70029e39e0a22c66$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $49fc188cd54a2dd6$export$136e266e21963ad8)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $70029e39e0a22c66$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $9b2eea537bbdfc67$export$e5b37491e59cd9d)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $70029e39e0a22c66$export$ad9854279980efbe(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $70029e39e0a22c66$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $krYZG.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $70029e39e0a22c66$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
    return {
        action: (0, $jzpoq.TABLE_ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
const $70029e39e0a22c66$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>$70029e39e0a22c66$var$getTableDeletedAnalytics(selection, (0, $krYZG.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $9b2eea537bbdfc67$export$4882f04e79ed0a80));
const $70029e39e0a22c66$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>$70029e39e0a22c66$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $9b2eea537bbdfc67$export$a853c8f1dbe33b1f));
const $70029e39e0a22c66$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        return {
            action: (0, $jzpoq.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $55616d8330b777b9$export$2155c86bec6ad614));
const $70029e39e0a22c66$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        return {
            action: (0, $jzpoq.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $55616d8330b777b9$export$cb41f2462444ad87));
const $70029e39e0a22c66$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $jzpoq.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $8e70e8c6596c6b3f$export$101f2696d8127fe0)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $55616d8330b777b9$export$67d4f89bd3067fa2));
const $70029e39e0a22c66$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $afaee1b2f3cac989$export$53e8d4c581cfe158)(columnIndex, sortOrder));
const $70029e39e0a22c66$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $8d0629bb8e812232$export$c27221be174b6703)(()=>{
            return {
                action: (0, $jzpoq.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $cb90c04d75301fb4$export$e8f15c4883bd4cb9)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $70029e39e0a22c66$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $jzpoq.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $96985d8b1bf9679d$export$8afb7fb379a7ebd1));
const $70029e39e0a22c66$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table?.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $jzpoq.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $jzpoq.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table?.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $aC6bW.editorCommandToPMCommand)((0, $ff3fa6b291292a64$export$6ed6a850e47b73cc)));
const $70029e39e0a22c66$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, previousAlignment, inputMethod, reason)=>(0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $jzpoq.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table?.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $aC6bW.editorCommandToPMCommand)((0, $9b2eea537bbdfc67$export$e0cd4746386d78b5)(newAlignment, isCommentEditor)));
const $70029e39e0a22c66$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $8d0629bb8e812232$export$c27221be174b6703)(()=>{
            const map = (0, $8Z43Z.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $jzpoq.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $aC6bW.editorCommandToPMCommand)((0, $9b2eea537bbdfc67$export$2880e63de92f5116)(newAlignment, tableNodeWithPos)));































const $2c61af3d1532943d$export$558c1c356b7f2033 = (contentWidth)=>{
    const maxEditorWidth = (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $7Y8M5.akEditorMaxLayoutWidth) : (0, $7Y8M5.akEditorFullWidthLayoutWidth);
    return Math.min(maxEditorWidth, contentWidth);
};
const $2c61af3d1532943d$var$tableWidth = $2c61af3d1532943d$export$558c1c356b7f2033;
const $2c61af3d1532943d$export$d87d6ab7a18b29eb = (tableRef)=>{
    const colWidths = $2c61af3d1532943d$var$getRenderedColgroupColumnWidths(tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    return {
        colWidths: colWidths,
        tableWidth: $2c61af3d1532943d$var$tableWidth(totalContentWidth)
    };
};
const $2c61af3d1532943d$export$e55d81380f623ba1 = (tr, tableNode, { colWidths: colWidths, tableWidth: tableWidth }, tablePos)=>{
    tr = (0, $6a88bd18c82ff0af$export$97482f1a2b86c59e)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = colWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        width: tableWidth
    });
};
function $2c61af3d1532943d$var$getRenderedColgroupColumnWidths(tableRef) {
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    return cols.map((col)=>{
        const width = col.getBoundingClientRect().width;
        return Math.max(Math.round(width), (0, $k8PFz.tableCellMinWidth));
    });
}












/** Each column's max width is `MAX × (usableWidth / numCols)`. */ const $79ed3928a5d606e4$export$3b36a7fc0215f73d = {
    MAX: 2
};


const $8bd8a1048ece21c4$export$71ab12c987afd8bc = (widths)=>widths.reduce((sum, width)=>sum + width, 0);
// 2px absorbs sub-pixel rounding in `getRenderedColgroupColumnWidths`.
const $8bd8a1048ece21c4$var$SUB_PIXEL_ROUNDING_ALLOWANCE = 2;
const $8bd8a1048ece21c4$export$30e7a6d6466e87d1 = (desiredWidths, editorContainerWidth)=>{
    if (desiredWidths.length === 0 || !isFinite(editorContainerWidth) || editorContainerWidth <= 0) return desiredWidths;
    const usableWidth = Math.max(editorContainerWidth - (0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2, (0, $k8PFz.tableCellMinWidth) * desiredWidths.length);
    const evenShare = usableWidth / desiredWidths.length;
    const ceiling = (0, $79ed3928a5d606e4$export$3b36a7fc0215f73d).MAX * evenShare;
    const isCompactColumn = (width)=>width <= ceiling;
    const desiredCeil = desiredWidths.map((desired)=>Math.max((0, $k8PFz.tableCellMinWidth), Math.ceil(desired) + $8bd8a1048ece21c4$var$SUB_PIXEL_ROUNDING_ALLOWANCE));
    const capped = desiredCeil.map((desired)=>isCompactColumn(desired) ? desired : Math.min(ceiling, desired));
    const sum = $8bd8a1048ece21c4$export$71ab12c987afd8bc(capped);
    // Underflow: grow non-protected ceiling-hitters into the leftover, up to their desired.
    if (sum < usableWidth) {
        const leftover = usableWidth - sum;
        const growthHeadroom = capped.map((width, index)=>!isCompactColumn(desiredCeil[index]) && width >= ceiling ? Math.max(desiredCeil[index] - width, 0) : 0);
        const totalHeadroom = $8bd8a1048ece21c4$export$71ab12c987afd8bc(growthHeadroom);
        if (totalHeadroom > 0) {
            const totalGrowth = Math.min(leftover, totalHeadroom);
            return capped.map((width, index)=>{
                const headroom = growthHeadroom[index];
                if (headroom <= 0) return width;
                return width + headroom / totalHeadroom * totalGrowth;
            });
        }
        return capped;
    }
    if (sum === usableWidth) return capped;
    // Overflow: reclaim from non-protected ceiling-hitters only.
    const overage = sum - usableWidth;
    const slacks = capped.map((width, index)=>!isCompactColumn(desiredCeil[index]) && width >= ceiling ? Math.max(width - (0, $k8PFz.tableCellMinWidth), 0) : 0);
    const totalSlack = $8bd8a1048ece21c4$export$71ab12c987afd8bc(slacks);
    if (totalSlack <= 0) return capped;
    return capped.map((width, index)=>{
        const slack = slacks[index];
        if (slack <= 0) return width;
        const share = slack / totalSlack * Math.min(overage, totalSlack);
        return Math.max(width - share, (0, $k8PFz.tableCellMinWidth));
    });
};


const $2151023ba99f1af6$var$measureWithIntrinsicWidth = (tableRef, resizerContainer, resizerItem)=>{
    if (resizerContainer) {
        resizerContainer.style.width = 'var(--ak-editor-table-width)';
        resizerContainer.style.setProperty('--ak-editor-table-width', 'max-content');
    }
    if (resizerItem) resizerItem.style.width = 'max-content';
    const prevTableWidth = tableRef.style.width;
    const prevTableMaxWidth = tableRef.style.maxWidth;
    const prevTableMinWidth = tableRef.style.minWidth;
    tableRef.style.setProperty('width', 'max-content', 'important');
    tableRef.style.setProperty('max-width', 'none', 'important');
    tableRef.style.setProperty('min-width', '0', 'important');
    try {
        return (0, $2c61af3d1532943d$export$d87d6ab7a18b29eb)(tableRef);
    } finally{
        tableRef.style.width = prevTableWidth;
        tableRef.style.maxWidth = prevTableMaxWidth;
        tableRef.style.minWidth = prevTableMinWidth;
    }
};
const $2151023ba99f1af6$export$a3fd5033d86b5b8b = (resizerContainer)=>{
    if (!resizerContainer) return;
    resizerContainer.style.width = 'var(--ak-editor-table-width)';
    resizerContainer.style.removeProperty('--ak-editor-table-width');
};
const $2151023ba99f1af6$export$426be2b82c7d51bf = (tableRef, resizerContainer, resizerItem, editorContainerWidthFromApi)=>{
    const preferredMeasurement = $2151023ba99f1af6$var$measureWithIntrinsicWidth(tableRef, resizerContainer, resizerItem);
    const desiredWidths = preferredMeasurement.colWidths;
    const editorContainerWidth = editorContainerWidthFromApi ?? (0, $8bd8a1048ece21c4$export$71ab12c987afd8bc)(desiredWidths);
    const colWidths = (0, $8bd8a1048ece21c4$export$30e7a6d6466e87d1)(desiredWidths, editorContainerWidth);
    return {
        ...preferredMeasurement,
        colWidths: colWidths,
        tableWidth: (0, $8bd8a1048ece21c4$export$71ab12c987afd8bc)(colWidths)
    };
};


const $eb7bbd51f1335e02$export$b4d02699ba1d276b = (tableRef, editorContainerWidth)=>{
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    const contentWrap = tableRef.closest(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`);
    const resizerContainer = contentWrap?.querySelector(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
    const resizerItem = resizerContainer?.querySelector('.resizer-item.display-handle');
    const prevTableWidth = tableRef.style.width;
    const prevTableLayout = tableRef.style.tableLayout;
    const prevColWidths = cols.map((col)=>col.style.width);
    const prevResizerItemWidth = resizerItem?.style.width;
    tableRef.style.width = '';
    tableRef.style.tableLayout = 'auto';
    cols.forEach((col)=>col.style.width = '');
    const hadTableSticky = tableRef.classList.contains((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY);
    const prevTableMarginTop = tableRef.style.marginTop;
    if (hadTableSticky) tableRef.classList.remove((0, $bYPHE.TableSharedCssClassName).TABLE_NATIVE_STICKY);
    if (prevTableMarginTop) tableRef.style.marginTop = '';
    const stickyRows = Array.from(tableRef.querySelectorAll(`tr.sticky, tr.${(0, $bYPHE.TableSharedCssClassName).TABLE_NATIVE_STICKY}`));
    const prevStickyRowState = stickyRows.map((row)=>({
            row: row,
            hadSticky: row.classList.contains('sticky'),
            hadNative: row.classList.contains((0, $bYPHE.TableSharedCssClassName).TABLE_NATIVE_STICKY),
            width: row.style.width,
            top: row.style.top,
            position: row.style.position,
            gridTemplateColumns: row.style.gridTemplateColumns
        }));
    stickyRows.forEach((row)=>{
        row.classList.remove('sticky');
        row.classList.remove((0, $bYPHE.TableSharedCssClassName).TABLE_NATIVE_STICKY);
        row.style.width = '';
        row.style.top = '';
        row.style.position = '';
        row.style.gridTemplateColumns = '';
    });
    try {
        return (0, $2151023ba99f1af6$export$426be2b82c7d51bf)(tableRef, resizerContainer, resizerItem, editorContainerWidth);
    } finally{
        tableRef.style.width = prevTableWidth;
        tableRef.style.tableLayout = prevTableLayout;
        cols.forEach((col, i)=>col.style.width = prevColWidths[i]);
        if (hadTableSticky) tableRef.classList.add((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY);
        if (prevTableMarginTop) tableRef.style.marginTop = prevTableMarginTop;
        prevStickyRowState.forEach((state)=>{
            if (state.hadSticky) state.row.classList.add('sticky');
            if (state.hadNative) state.row.classList.add((0, $bYPHE.TableSharedCssClassName).TABLE_NATIVE_STICKY);
            if (state.width) state.row.style.width = state.width;
            if (state.top) state.row.style.top = state.top;
            if (state.position) state.row.style.position = state.position;
            if (state.gridTemplateColumns) state.row.style.gridTemplateColumns = state.gridTemplateColumns;
        });
        (0, $2151023ba99f1af6$export$a3fd5033d86b5b8b)(resizerContainer);
        if (resizerItem) resizerItem.style.width = prevResizerItemWidth ?? '';
    }
};


const $9617b8bba70a740b$export$b4b4c38f004e5aad = (view, api)=>{
    const tableObject = (0, $cycWk.findTable)(view.state.selection);
    if (!tableObject) return;
    const { node: node, pos: pos } = tableObject;
    const tableState = api?.table.sharedState.currentState();
    if (!tableState?.tableRef) return;
    const editorContainerWidth = api?.width?.sharedState.currentState()?.width;
    const measurement = (0, $eb7bbd51f1335e02$export$b4d02699ba1d276b)(tableState.tableRef, editorContainerWidth);
    const tr = (0, $2c61af3d1532943d$export$e55d81380f623ba1)(view.state.tr, node, measurement, pos);
    api?.analytics?.actions?.attachAnalyticsEvent({
        action: (0, $jzpoq.TABLE_ACTION).FIT_TO_CONTENT_ON_DEMAND,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        actionSubjectId: null,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            editorContainerWidth: api?.width?.sharedState.currentState()?.width ?? 0,
            tableWidth: measurement.tableWidth,
            totalColumnCount: measurement.colWidths.length
        }
    })(tr);
    view.dispatch(tr);
};




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 



var $7joZr = parcelRequire("7joZr");


var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $61e35656de93c3ad$var$containerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100'
});
const $61e35656de93c3ad$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $61e35656de93c3ad$var$containerStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};


const $0271a85e586658fd$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $fKJ7J.messages).lockColumnWidths),
            onClick: (0, $70029e39e0a22c66$export$ebf85a007abbf908)(editorAnalyticsAPI, (0, $krYZG.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $fKJ7J.messages).headerRow),
            onClick: (0, $70029e39e0a22c66$export$2e66edaa488e7a1d)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $fKJ7J.messages).headerColumn),
            onClick: (0, $70029e39e0a22c66$export$9fd5a66fcada8ad2)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $fKJ7J.messages).numberedRows),
            onClick: (0, $70029e39e0a22c66$export$9e4b8d27ecc9c55)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $fKJ7J.messages).collapseTable),
            onClick: (0, $70029e39e0a22c66$export$70cd1c3ffea1a5d0)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))),
        title: formatMessage((0, $fKJ7J.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $0271a85e586658fd$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $fKJ7J.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
                const index = selectionRect?.right;
                if (index) (0, $70029e39e0a22c66$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $lrTDq.shortcutStyle)
            }, (0, $ldqjS.tooltip)((0, $ldqjS.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $fKJ7J.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
                const index = selectionRect?.bottom;
                if (index) (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $lrTDq.shortcutStyle)
            }, (0, $ldqjS.tooltip)((0, $ldqjS.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $fKJ7J.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $70029e39e0a22c66$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $0271a85e586658fd$var$highlightColumnsHandler,
            onBlur: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
            onMouseOver: $0271a85e586658fd$var$highlightColumnsHandler,
            onMouseLeave: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $fKJ7J.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $70029e39e0a22c66$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $0271a85e586658fd$var$highlightRowsHandler,
            onBlur: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
            onMouseOver: $0271a85e586658fd$var$highlightRowsHandler,
            onMouseLeave: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $fKJ7J.messages).mergeCells),
        onClick: (0, $70029e39e0a22c66$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $a80eeaee4326e361$export$9df87bad3fce982f)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $fKJ7J.messages).splitCell),
        onClick: (0, $70029e39e0a22c66$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $53f42aed97ade489$export$74933b5979945879)(editorState)
    });
    if (pluginState?.pluginConfig?.allowDistributeColumns) {
        let wouldChange = true; // Default to enabled - show the button.
        let newResizeStateWithAnalytics;
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled && !(0, $ieeJu.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
            newResizeStateWithAnalytics = editorView ? (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(initialSelectionRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor) : undefined;
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
        const distributeColumnWidths = (state, dispatch, view)=>{
            // When optimization is enabled, calculate on-demand when clicked
            if (isLimitedModeEnabled || (0, $ieeJu.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
                if (view) {
                    const resizeState = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(initialSelectionRect, state, view.domAtPos.bind(view), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (resizeState) {
                        (0, $70029e39e0a22c66$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $krYZG.INPUT_METHOD).FLOATING_TB, resizeState)(state, dispatch);
                        return true;
                    }
                }
                return false;
            } else {
                // Original behavior: use pre-calculated state
                if (newResizeStateWithAnalytics) {
                    (0, $70029e39e0a22c66$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $krYZG.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
                    return true;
                }
                return false;
            }
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $fKJ7J.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: !wouldChange
        });
    }
    if (pluginState?.pluginConfig?.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $d3dc0fe24d69f2ab$export$ffded79ba5549697)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $fKJ7J.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $fKJ7J.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $d3dc0fe24d69f2ab$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $47589dd3b7f399b2$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $6faDz.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $fKJ7J.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $d3dc0fe24d69f2ab$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $47589dd3b7f399b2$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $6faDz.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $fKJ7J.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            (0, $70029e39e0a22c66$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $lrTDq.shortcutStyle)
        }, (0, $ldqjS.tooltip)((0, $ldqjS.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $fKJ7J.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $0271a85e586658fd$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $bc8rR.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
};
const $0271a85e586658fd$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $cycWk.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $8Z43Z.TableMap).get(tableObject.node);
    const tableRect = new (0, $8Z43Z.Rect)(0, 0, map.width, map.height);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, $bc8rR.isSelectionType)(selection, 'cell') ? (0, $hC0Ga.getSelectionRect)(selection) : tableRect;
};
// Memoize the expensive DOM queries (querySelector, closestElement) separately
// Cache key is the parent DOM node reference - stays same when typing in same cell
const $0271a85e586658fd$var$getTableWrapperFromParentImpl = (parent)=>{
    if (!parent) return undefined;
    // These are the expensive DOM operations
    const tableRef = // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    parent.querySelector('table') || undefined;
    if (!tableRef) return undefined;
    return (0, $btvbC.closestElement)(tableRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
};
// Create memoized version ONCE - reused across all calls
const $0271a85e586658fd$var$getMemoizedTableWrapperFromParent = (0, $dOBRD.default)($0271a85e586658fd$var$getTableWrapperFromParentImpl);
const $0271a85e586658fd$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $cycWk.findTable)(state.selection);
            const pluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            const resizeState = (0, $c3bb9070ade8eb63$export$18d4026d1ea86bb1).getState(state);
            const tableWidthState = (0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1).getState(state);
            const isTableScalingEnabled = options?.isTableScalingEnabled || false;
            const nodeType = state.schema.nodes.table;
            const toolbarTitle = 'Table floating controls';
            const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                const { isDragMenuOpen: isDragHandleMenuOpened = false, isDragging: isTableRowOrColumnDragged = false } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
                const isTableOrColumnResizing = !!(resizeState?.dragging || tableWidthState?.resizing);
                const isTableMenuOpened = pluginState.isContextualMenuOpen || isDragHandleMenuOpened;
                const isTableState = isTableRowOrColumnDragged || isTableOrColumnResizing || isTableMenuOpened;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Note: when focus is in codeblocks, pluginState.editorHasFocus is false, so the codeblocks toolbar
                // won't be suppressed.
                const shouldSuppressAllToolbars = isTableState && pluginState.editorHasFocus && !isViewMode;
                if (shouldSuppressAllToolbars) return {
                    title: toolbarTitle,
                    items: [],
                    nodeType: nodeType
                };
            }
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState?.resizing;
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing) {
                const isNested = pluginState.tablePos && (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (0, $ieeJu.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? (editorView)=>{
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $bjg0G.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    return $0271a85e586658fd$var$getMemoizedTableWrapperFromParent(parent);
                } : (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $bjg0G.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) {
                        const tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                        if (tableRef) element = (0, $btvbC.closestElement)(tableRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
                    }
                    return element;
                };
                const menu = $0271a85e586658fd$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = config.allowTableAlignment && !isNested ? $0271a85e586658fd$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, options?.fullWidthEnabled, options?.isCommentEditor) : [];
                const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                const columnSettingsItems = $0271a85e586658fd$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options?.isCommentEditor, isLimitedModeEnabled);
                const colorPicker = !areAnyNewToolbarFlagsEnabled ? $0271a85e586658fd$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView) : [];
                const fitToContentButton = (0, $f683956911721579$export$e217d2a535d6ae45)({
                    allowColumnResizing: !!pluginState.pluginConfig.allowColumnResizing,
                    allowTableResizing: !!pluginState.pluginConfig.allowTableResizing,
                    isFullPageEditor: !pluginState.isChromelessEditor && !pluginState.isCommentEditor
                }) && !isNested && api?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_on_demand', 'isEnabled', true) ? [
                    {
                        id: 'editor.table.fitToContent',
                        type: 'button',
                        title: intl.formatMessage((0, $fKJ7J.messages).fitToContent),
                        icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
                                spacing: 'spacious',
                                label: ''
                            }),
                        onClick: (_state, _dispatch, view)=>{
                            if (view) (0, $9617b8bba70a740b$export$b4b4c38f004e5aad)(view, api ?? undefined);
                            return true;
                        }
                    }
                ] : [];
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $dpfrn.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $fKJ7J.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $fKJ7J.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $fKJ7J.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $fKJ7J.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $eQeCt.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $fKJ7J.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $dpfrn.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $fKJ7J.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$0271a85e586658fd$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                const deleteButton = {
                    id: 'editor.table.delete',
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    onClick: (0, $70029e39e0a22c66$export$3e2fb93914330b82)(editorAnalyticsAPI),
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(true),
                    onFocus: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(true),
                    onBlur: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
                    onMouseLeave: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
                    title: intl.formatMessage((0, $2xhuI.default).remove),
                    focusEditoronEnter: true,
                    confirmDialog: confirmDialog
                };
                const copyButton = {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onMouseEnter: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(false, true),
                            onMouseLeave: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
                            onFocus: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(false, true),
                            onBlur: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()
                        }
                    ]
                };
                const isNestedTable = (0, $hZ5o2.isNestedTablesSupported)(state.schema) && (0, $9GCRb.isSelectionTableNestedInTable)(state);
                const hoverTableProps = (isInDanger, isSelected)=>({
                        onMouseEnter: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(isInDanger, isSelected),
                        onMouseLeave: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)(),
                        onFocus: (0, $47589dd3b7f399b2$export$41c571b711ba06e)(isInDanger, isSelected),
                        onBlur: (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const overflowDropdownTestId = 'table-overflow-dropdown-trigger';
                const extensionState = api?.extension?.sharedState?.currentState();
                const extensionApi = api?.extension?.actions.api();
                return {
                    title: toolbarTitle,
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $0271a85e586658fd$var$separator(menu.hidden)
                        ] : [],
                        ...alignmentMenu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $0271a85e586658fd$var$separator(alignmentMenu.length === 0)
                        ] : [],
                        ...columnSettingsItems,
                        ...fitToContentButton,
                        ...colorPicker,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            {
                                type: 'extensions-placeholder',
                                separator: 'end'
                            },
                            copyButton,
                            {
                                type: 'separator'
                            },
                            deleteButton
                        ] : [
                            areAnyNewToolbarFlagsEnabled && {
                                type: 'separator',
                                fullHeight: true
                            },
                            {
                                type: 'overflow-dropdown',
                                testId: overflowDropdownTestId,
                                dropdownWidth: 220,
                                options: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        render: (editorView, dropdownOptions)=>{
                                            if (!editorView) return null;
                                            if (!extensionApi || !extensionState?.extensionProvider) return null;
                                            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b4bEA.DropdownMenuExtensionItems), {
                                                node: tableObject.node,
                                                editorView: editorView,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                extension: {
                                                    extensionProvider: extensionState?.extensionProvider ? Promise.resolve(extensionState.extensionProvider) : undefined,
                                                    extensionApi: extensionApi
                                                },
                                                dropdownOptions: dropdownOptions,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                disabled: (key)=>{
                                                    return isNestedTable && [
                                                        'referentiality:connections',
                                                        'chart:insert-chart'
                                                    ].includes(key);
                                                },
                                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                                            });
                                        }
                                    },
                                    ...extensionApi && extensionState?.extensionProvider && !areAnyNewToolbarFlagsEnabled ? [
                                        {
                                            type: 'separator'
                                        }
                                    ] : [],
                                    {
                                        title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                                        onClick: ()=>{
                                            api?.core?.actions.execute(// @ts-ignore
                                            api?.floatingToolbar?.commands.copyNode(nodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                                            return true;
                                        },
                                        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                                            label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                                        }),
                                        ...hoverTableProps(false, true)
                                    },
                                    {
                                        title: intl.formatMessage((0, $2xhuI.default).delete),
                                        onClick: (0, $70029e39e0a22c66$export$3e2fb93914330b82)(editorAnalyticsAPI),
                                        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                            label: intl.formatMessage((0, $2xhuI.default).delete)
                                        }),
                                        ...hoverTableProps(true),
                                        confirmDialog: confirmDialog
                                    }
                                ]
                            }
                        ]
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $0271a85e586658fd$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $0271a85e586658fd$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $0271a85e586658fd$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $70029e39e0a22c66$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $krYZG.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $0271a85e586658fd$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const pluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorState);
    const items = [];
    let wouldChange = true; // Default to enabled - show the button.
    let newResizeStateWithAnalytics;
    if ((0, $ieeJu.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
        if (!editorView) return [];
    } else {
        const selectionOrTableRect = $0271a85e586658fd$var$getClosestSelectionOrTableRect(editorState);
        if (!selectionOrTableRect || !editorView) return [];
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled) {
            newResizeStateWithAnalytics = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionOrTableRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
    }
    if (pluginState?.pluginConfig?.allowDistributeColumns) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $fKJ7J.messages).distributeColumns),
        icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
                spacing: 'spacious',
                label: ''
            }),
        onClick: (state, dispatch, view)=>$0271a85e586658fd$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: !wouldChange
    });
    if (items.length !== 0 && !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) items.push({
        type: 'separator'
    });
    return items;
};
const $0271a85e586658fd$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = node?.attrs?.background || '#ffffff';
    const defaultPalette = (0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039).find((item)=>item.value === currentBackground) || {
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'Custom',
        value: currentBackground,
        border: (0, $kQOs5.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $fKJ7J.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            defaultValue: defaultPalette,
            options: (0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039),
            returnEscToButton: true,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: (option)=>(0, $70029e39e0a22c66$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $0271a85e586658fd$var$separator(menu.hidden)
    ];
};
const $0271a85e586658fd$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $70029e39e0a22c66$export$3e2fb93914330b82)(editorAnalyticsAPI)(state, dispatch);
        else (0, $aab88375fd1dd187$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };
const $0271a85e586658fd$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $47589dd3b7f399b2$export$ab63d99b591b89)((0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $0271a85e586658fd$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $0271a85e586658fd$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)((0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $0271a85e586658fd$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $cycWk.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6aEgq))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-start-icon"
                })
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hZR9z))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-center-icon"
                })
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $fKJ7J.messages).alignTableCenter,
        'align-start': (0, $fKJ7J.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        const shouldDisableLayoutOption = (0, $ieeJu.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? $0271a85e586658fd$var$getMemoizedIsLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView !== null, shouldUseIncreasedScalingPercent, isFullWidthEditor) : $0271a85e586658fd$var$isLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor);
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $cac57eed68474c1f$export$2e10df95acfe6933)(currentLayout) === value,
            onClick: (0, $70029e39e0a22c66$export$5d8dfbdf832abbae)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $krYZG.INPUT_METHOD).FLOATING_TB, (0, $jzpoq.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...shouldDisableLayoutOption && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $61e35656de93c3ad$export$a6e8f537af71668f), {
                alignmentButtons: alignmentButtons,
                ...props,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 74,
        height: 32
    };
    const selectedAlignmentIcon = $0271a85e586658fd$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $fKJ7J.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon?.icon
        }
    ];
    return alignmentToolbarItem;
};
const $0271a85e586658fd$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $cac57eed68474c1f$export$2e10df95acfe6933)(selectedAlignment));
};
const $0271a85e586658fd$var$isLayoutOptionDisabledImpl = (selectedNode, getEditorContainerWidth, hasEditorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (hasEditorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $a2b54432792761eb$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};
const $0271a85e586658fd$var$getMemoizedIsLayoutOptionDisabled = (0, $dOBRD.default)($0271a85e586658fd$var$isLayoutOptionDisabledImpl, ([prevNode, ...prevRest], [nextNode, ...nextRest])=>{
    // Only node needs special comparison (attrs only), rest use reference equality
    const nodeEqual = (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevNode.attrs, nextNode.attrs);
    const restEqual = prevRest.every((val, idx)=>val === nextRest[idx]);
    return nodeEqual && restEqual;
});
const $0271a85e586658fd$var$isLayoutOptionDisabled = (selectedNode, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (editorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $a2b54432792761eb$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};








const $bd58fdd834784798$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $bd58fdd834784798$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect) : (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect);
    const targetIndex = $bd58fdd834784798$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $a5103e1f191e6e99$export$7ef37f297601e698)(targetIndex, selection) : (0, $a5103e1f191e6e99$export$834c4ba4fe64e8f2)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $a5103e1f191e6e99$export$e4c313e419348ae7)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $bd58fdd834784798$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $0271a85e586658fd$export$e3ff63a8559e7571)(state);
    if (rect) {
        const selectedColIndexes = (0, $61cf1c01aee4adc2$export$915a77877be361e9)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $bd58fdd834784798$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $bd58fdd834784798$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, ariaNotifyPlugin, isCommentEditor = false, isColumnSortingEnabled = true)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jJItz))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $ldqjS.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i8vym))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $ldqjS.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWZGH))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $ldqjS.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eehur))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $ldqjS.addColumnAfter)
        }
    ];
    const isNewKeymapExperiment = (0, $ieeJu.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kSpvN))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $ldqjS.moveRowUp) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $ldqjS.moveRowUpOld),
            canMove: $bd58fdd834784798$export$a4ef2b0c3fa55ad2('table-row', -1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $61cf1c01aee4adc2$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1isWY))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $ldqjS.moveRowDown) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $ldqjS.moveRowDownOld),
            canMove: $bd58fdd834784798$export$a4ef2b0c3fa55ad2('table-row', 1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $61cf1c01aee4adc2$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iMVfw))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $ldqjS.moveColumnLeft) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $ldqjS.moveColumnLeftOld),
            canMove: $bd58fdd834784798$export$a4ef2b0c3fa55ad2('table-column', -1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $61cf1c01aee4adc2$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRp8L))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $ldqjS.moveColumnRight) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $ldqjS.moveColumnRightOld),
            canMove: $bd58fdd834784798$export$a4ef2b0c3fa55ad2('table-column', 1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $61cf1c01aee4adc2$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $6faDz.SortOrder).ASC,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63qYG))), {
                    spacing: 'spacious',
                    label: ''
                })
        },
        {
            label: 'decreasing',
            order: (0, $6faDz.SortOrder).DESC,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
                    spacing: 'spacious',
                    label: ''
                })
        }
    ] : [];
    const sortConfigs = sortOptions.map(({ label: label, order: order, icon: icon })=>({
            id: `sort_column_${order}`,
            title: `Sort ${label}`,
            disabled: hasMergedCellsInTable,
            icon: icon,
            onClick: (state, dispatch)=>{
                (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                return true;
            }
        }));
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $70029e39e0a22c66$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $ldqjS.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$bd58fdd834784798$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $0271a85e586658fd$export$e3ff63a8559e7571)(state);
                if (selectionRect) {
                    const newResizeState = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $70029e39e0a22c66$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
                    spacing: 'spacious',
                    label: ''
                })
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $70029e39e0a22c66$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bWjzw))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $ldqjS.tooltip)((0, $ldqjS.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $70029e39e0a22c66$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $bd58fdd834784798$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $70029e39e0a22c66$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $bd58fdd834784798$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: direction === 'row' ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81DSz))), {
                    spacing: 'spacious',
                    label: ''
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($haA5t))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: direction === 'row' ? (0, $ldqjS.tooltip)((0, $ldqjS.deleteRow)) : (0, $ldqjS.tooltip)((0, $ldqjS.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (_state, _dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getOriginIndexes(selectionRect), // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $ldqjS.tooltip)(keymap)
            }))
    ];
    const allConfigs = [
        ...restConfigs
    ];
    if (isColumnSortingEnabled) allConfigs.unshift(...sortConfigs);
    return allConfigs.filter(Boolean);
};





const $b1a4a1bc8826a6a3$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $jzpoq.TABLE_ACTION).MOVED_ROW : (0, $jzpoq.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes?.length ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $a709990a5e57b471$export$e74dec9e818a8c0b)(tr)(state, dispatch);
            return true;
        });
    };
const $b1a4a1bc8826a6a3$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $jzpoq.TABLE_ACTION).MOVED_ROW : (0, $jzpoq.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $jzpoq.TABLE_STATUS).CANCELLED : (0, $jzpoq.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $a709990a5e57b471$export$1326c72b3102f66d)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $krYZG.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $fKJ7J.messages).rowMovedDown : (0, $fKJ7J.messages).rowMovedUp : direction > 0 ? (0, $fKJ7J.messages).columnMovedRight : (0, $fKJ7J.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $b1a4a1bc8826a6a3$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
            const selectionRect = isCellSelection ? (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect) : (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            if (!(0, $bd58fdd834784798$export$a4ef2b0c3fa55ad2)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $bd58fdd834784798$export$79db8995cf046b43)(selectedIndexes, direction);
            return $b1a4a1bc8826a6a3$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $krYZG.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $b1a4a1bc8826a6a3$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $8d0629bb8e812232$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $jzpoq.TABLE_ACTION).CLONED_ROW : (0, $jzpoq.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $jzpoq.TABLE_STATUS).CANCELLED : (0, $jzpoq.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $a709990a5e57b471$export$88277f1015e99c8a)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };
const $b1a4a1bc8826a6a3$export$ade80ff7f1fbb779 = (editorAnalyticsAPI)=>(isDragMenuOpen, direction, index, trigger = 'mouse')=>{
        return (0, $8d0629bb8e812232$export$c27221be174b6703)((state)=>{
            const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
            if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return undefined;
            let updatedMenuOpenState;
            if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
            else // menu open but menu direction changed, means user clicked on drag handle of different row/column
            // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
            // 2 scenarios above , menu should remain open.
            if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
            else updatedMenuOpenState = !previousOpenState;
            if (updatedMenuOpenState) // We only want to fire analytics when the menu is opened
            return {
                action: (0, $jzpoq.TABLE_ACTION).DRAG_MENU_OPENED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: trigger === 'keyboard' ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE,
                    direction: direction ?? previousDragMenuDirection ?? 'column'
                }
            };
            return undefined;
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $a709990a5e57b471$export$8a902a12acc69924)(isDragMenuOpen, direction, index, trigger)(state, dispatch);
            return true;
        });
    };






var $aqP4n = parcelRequire("aqP4n");




const $bf50c846deda0729$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    const isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};


const $df0b300f526f2b64$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $aqP4n.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $bf50c846deda0729$export$b95259a1f587c41)(location.current.input)
    };
};


const $7d82e6bf8d8a7f69$var$destroyFn = (editorView, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                (0, $eFgM7.insm).session?.startFeature('tableDragAndDrop');
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                (0, $eFgM7.insm).session?.endFeature('tableDragAndDrop');
                // 'null' will remove the inline style
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $38vK5.autoScrollForElements)({
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $aDtKq.combine)(...rowAutoScrollers, (0, $iSrRp.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === tableNode?.attrs.localId;
        },
        onDragStart: ()=>{
            (0, $eFgM7.insm).session?.startFeature('tableDragAndDrop');
            if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) api?.core.actions.execute(({ tr: tr })=>{
                (0, $4c617ebfadab8027$export$68481d8823bb24fb)(api, {
                    skipUserIntent: true
                })({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                return tr;
            });
            else {
                (0, $a709990a5e57b471$export$8a902a12acc69924)(false)(editorView.state, editorView.dispatch);
                api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
            }
        },
        onDrag (event) {
            const data = (0, $df0b300f526f2b64$export$6d440138302b6316)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $a709990a5e57b471$export$e74dec9e818a8c0b)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: ED-26961 - as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $77ff0896ebca4b84$export$9377432e002bc2da).ROW : (0, $77ff0896ebca4b84$export$9377432e002bc2da).COLUMN;
            const hasMergedCells = (0, $a5103e1f191e6e99$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $a709990a5e57b471$export$a54c991ec4a21b4a)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
        },
        onDrop (event) {
            const data = (0, $df0b300f526f2b64$export$6d440138302b6316)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
            const cell = (0, $42b76cc10c347878$export$fe489db90f7f492a)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: cell?.row ?? hoveredCell.rowIndex,
                        colIndex: cell?.col ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), action);
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging') api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                (0, $eFgM7.insm).session?.endFeature('tableDragAndDrop');
                if (event?.source?.data?.type === 'table-row' || event?.source?.data?.type === 'table-column') return (0, $b1a4a1bc8826a6a3$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, event.source.data?.indexes, (0, $jzpoq.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                return (0, $a709990a5e57b471$export$e74dec9e818a8c0b)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $a5103e1f191e6e99$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $77ff0896ebca4b84$export$9377432e002bc2da).ROW : (0, $77ff0896ebca4b84$export$9377432e002bc2da).COLUMN)(editorView.state.selection)) {
                (0, $b1a4a1bc8826a6a3$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $jzpoq.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                (0, $eFgM7.insm).session?.endFeature('tableDragAndDrop');
                return;
            }
            requestAnimationFrame(()=>{
                if (behaviour === 'clone') (0, $b1a4a1bc8826a6a3$export$e432b518ff8f345a)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $cec18a6f3d8c1f93$export$ae5d9647f2a0891c)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
                (0, $eFgM7.insm).session?.endFeature('tableDragAndDrop');
            });
        }
    }));
};
const $7d82e6bf8d8a7f69$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, api)=>{
    return new (0, $kpCD8.SafePlugin)({
        state: (0, $9c44a2089c87f26f$export$656c7661095efe2e)(dispatch, ()=>({
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                dropTargetType: (0, $77ff0896ebca4b84$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $c13762150e3ca207$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $74fcba9734962ef8$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $54d06cc8ab559031$export$a804b6b4ce22aa92)(dragMenuIndex)(tr.selection);
                        // TODO: ED-20673 - check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $8HW7o.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $c13762150e3ca207$export$18d4026d1ea86bb1), action);
                         // else NOP
                    } else return tr.setMeta((0, $c13762150e3ca207$export$18d4026d1ea86bb1), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $7d82e6bf8d8a7f69$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
				 * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
				 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
				 */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $fEPSi.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((event.target || null)?.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};









const $b82f27ffc9765a71$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('editorContentAreaHeightPlugin');
const $b82f27ffc9765a71$export$4d09e1a8cc78d53 = 1200;
const $b82f27ffc9765a71$export$e591924e2463f32f = '.ak-editor-content-area-region';
const $b82f27ffc9765a71$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        key: $b82f27ffc9765a71$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    height: $b82f27ffc9765a71$export$4d09e1a8cc78d53
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($b82f27ffc9765a71$export$18d4026d1ea86bb1);
                if (meta) return {
                    ...pluginState,
                    ...meta
                };
                return pluginState;
            }
        },
        view: (view)=>{
            const editorContentAreaEl = view.dom.closest($b82f27ffc9765a71$export$e591924e2463f32f);
            let resizeObserver;
            if (editorContentAreaEl) {
                resizeObserver = new ResizeObserver((entries)=>{
                    for (const entry of entries){
                        const height = entry.contentRect.height;
                        const tr = view.state.tr.setMeta($b82f27ffc9765a71$export$18d4026d1ea86bb1, {
                            height: height,
                            isObserved: true
                        });
                        view.dispatch(tr);
                    }
                });
                resizeObserver.observe(editorContentAreaEl);
            }
            return {
                destroy () {
                    resizeObserver?.disconnect();
                }
            };
        }
    });












var $iUNgd = parcelRequire("iUNgd");


































function $ba2691c84311992e$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $ba2691c84311992e$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $kWLy1.isInTable)(state)) return false;
        const cellSelection = (0, $b3vr9.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $ba2691c84311992e$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $kCECX.TextSelection).between($cell, $ba2691c84311992e$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $ba2691c84311992e$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        let table = $cell.node(-1);
        // table is the parent table, not the nested table
        if ($cell.node(-4) && $cell.node(-4).type.name === 'table') table = $cell.node(-4);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}







const $448f4b5fb0491bfb$var$TAB_FORWARD_DIRECTION = 1;
const $448f4b5fb0491bfb$var$TAB_BACKWARD_DIRECTION = -1;
const $448f4b5fb0491bfb$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            const table = (0, $cycWk.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state)?.isKeyboardResize;
            if (isColumnResizing) {
                (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $8Z43Z.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $bjg0G.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // When tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $448f4b5fb0491bfb$var$TAB_BACKWARD_DIRECTION) {
                (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // When tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $448f4b5fb0491bfb$var$TAB_FORWARD_DIRECTION) {
                (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $ba2691c84311992e$export$78a7cb7971e0752d)(direction)(state, dispatch);
            return true;
        };
const $448f4b5fb0491bfb$export$24bf4ae22c7b6454 = (direction)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const nestedTableSelection = (0, $9GCRb.isSelectionTableNestedInTable)(state);
        if (!(selection instanceof (0, $kCECX.NodeSelection)) && !nestedTableSelection) return false; // Let ProseMirror handle other selection types
        let table = (0, $cycWk.findTable)(selection);
        let cell = (0, $cycWk.findCellClosestToPos)(state.doc.resolve(selection.from));
        let selectionPos = selection.from;
        // Handle when we have nested table fully selected
        if (table && nestedTableSelection && (0, $8imfU.isTableSelected)(selection)) {
            const parentTablePos = table.pos;
            table = (0, $cycWk.findTableClosestToPos)(state.doc.resolve(parentTablePos));
            cell = (0, $cycWk.findCellClosestToPos)(state.doc.resolve(parentTablePos));
            selectionPos = parentTablePos;
        }
        if (!table || !cell || !cell.pos) return false;
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        // Let ProseMirror handle movement within the cell if content exists above/below
        if ($448f4b5fb0491bfb$var$cellHasContentInDirection(cell.node, cell.pos, selectionPos, direction)) return false;
        // Move to the next cell vertically
        const map = (0, $8Z43Z.TableMap).get(table.node);
        const nextCellPos = map.nextCell(cell.pos - table.start, 'vert', direction);
        if (dispatch && nextCellPos) {
            const nextCellStart = table.start + nextCellPos;
            const $nextCell = state.doc.resolve(nextCellStart);
            if ($nextCell.nodeAfter?.type && [
                tableCell,
                tableHeader
            ].includes($nextCell.nodeAfter?.type)) {
                const contentPos = $448f4b5fb0491bfb$var$getTargetPositionInNextCell($nextCell.nodeAfter, nextCellStart, direction);
                dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, contentPos)));
                return true;
            }
            return false;
        }
        return false; // No next cell found
    };
function $448f4b5fb0491bfb$var$cellHasContentInDirection(cellNode, cellPos, selectionPos, direction) {
    let hasContent = false;
    cellNode.content.forEach((node, offset)=>{
        const nodeStart = cellPos + 1 + offset;
        const nodeEnd = nodeStart + node.nodeSize;
        if (direction === 1 && nodeStart > selectionPos && node.isBlock) hasContent = true; // Content below
        else if (direction === -1 && nodeEnd <= selectionPos && node.isBlock) hasContent = true; // Content above
    });
    return hasContent;
}
function $448f4b5fb0491bfb$var$getTargetPositionInNextCell(cellNode, nextCellStart, direction) {
    let contentPos = nextCellStart + 1; // Default: just inside the cell
    if (cellNode.content.size > 0) {
        if (direction === 1) {
            const firstChild = cellNode.firstChild;
            if (firstChild && firstChild.isBlock) contentPos = nextCellStart + 1 + (firstChild.isLeaf ? 0 : 1); // Down: Start of first block
        } else if (direction === -1) {
            let lastBlock;
            let lastOffset = 0;
            cellNode.content.forEach((node, offset)=>{
                if (node.isBlock) {
                    lastBlock = node;
                    lastOffset = offset;
                }
            });
            if (lastBlock) contentPos = nextCellStart + 1 + lastOffset + (lastBlock.isLeaf ? 0 : lastBlock.nodeSize - 1);
        }
    }
    return contentPos;
}






function $ad4bf9b41fec365c$export$e832373cff8dec22(getEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.nextCell).common, (0, $448f4b5fb0491bfb$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.previousCell).common, (0, $448f4b5fb0491bfb$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.toggleTable).common, (0, $aC6bW.editorCommandToPMCommand)((0, $1eaa45a3d80bffa1$export$b57b177fe1ab7f1f)({
        isTableScalingEnabled: isTableScalingEnabled,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: !!isFullWidthEnabled,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableResizingEnabled: isTableResizingEnabled
    }, api, {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.backspace).common, (0, $iUNgd.chainCommands)((0, $70029e39e0a22c66$export$253ebd9c41cefd54)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), (0, $70029e39e0a22c66$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.backspace).common, (0, $9b2eea537bbdfc67$export$f49961c90342f4db), list);
    // Add row/column shortcuts
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addRowBefore).common, (0, $70029e39e0a22c66$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addRowAfter).common, (0, $70029e39e0a22c66$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addColumnBefore).common, (0, $1eaa45a3d80bffa1$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addColumnAfter).common, (0, $1eaa45a3d80bffa1$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addRowBeforeVO).common, (0, $70029e39e0a22c66$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addRowAfterVO).common, (0, $70029e39e0a22c66$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addColumnBeforeVO).common, (0, $1eaa45a3d80bffa1$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.addColumnAfterVO).common, (0, $1eaa45a3d80bffa1$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if ((0, $ldqjS.moveRowDown).common && (0, $ldqjS.moveRowUp).common && (0, $ldqjS.moveColumnLeft).common && (0, $ldqjS.moveColumnRight).common) {
        const isNewKeyMapExperiment = (0, $ieeJu.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
        // Move row/column shortcuts
        /**
     * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
     * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
     * to make sure the logic for holding the shortcut keys is valid
     * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
     */ (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $ldqjS.moveRowDown).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.moveRowDownOld).common, (0, $b1a4a1bc8826a6a3$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $ldqjS.moveRowUp).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.moveRowUpOld).common, (0, $b1a4a1bc8826a6a3$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $ldqjS.moveColumnLeft).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.moveColumnLeftOld).common, (0, $b1a4a1bc8826a6a3$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $ldqjS.moveColumnRight).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.moveColumnRightOld).common, (0, $b1a4a1bc8826a6a3$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.deleteColumn).common, (0, $70029e39e0a22c66$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.deleteRow).common, (0, $70029e39e0a22c66$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.startColumnResizing).common, (0, $83f03c9ff5611334$export$833f46f974daec36)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveRight).common, (0, $83f03c9ff5611334$export$44cde2b92e1bbc4a)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveLeft).common, (0, $83f03c9ff5611334$export$44cde2b92e1bbc4a)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveDown).common, (0, $448f4b5fb0491bfb$export$24bf4ae22c7b6454)(1), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.moveUp).common, (0, $448f4b5fb0491bfb$export$24bf4ae22c7b6454)(-1), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.decreaseMediaSize).common, (0, $70029e39e0a22c66$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $krYZG.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.increaseMediaSize).common, (0, $70029e39e0a22c66$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $krYZG.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.escape).common, (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.focusToContextMenuTrigger).common, (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(), list);
    return (0, $44cyU.keymap)(list);
}
var $ad4bf9b41fec365c$export$2e2bcd8739ae039 = $ad4bf9b41fec365c$export$e832373cff8dec22;



var $cbY7C = parcelRequire("cbY7C");



















var $jlFP9 = parcelRequire("jlFP9");



const $f77decf2d75a41ec$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $aPdNQ.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};








const $93b96d5caf93ce93$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $93b96d5caf93ce93$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $fud2r.mapFragment)((0, $aPdNQ.Fragment).from(maybeLayoutSection), (node)=>{
        return $93b96d5caf93ce93$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $93b96d5caf93ce93$export$238984649a055433(node, i) {
    return i === 0 ? $93b96d5caf93ce93$export$5fc4db161d3fef1f(node) : node;
}
function $93b96d5caf93ce93$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $93b96d5caf93ce93$export$5fc4db161d3fef1f(node) : node;
}
function $93b96d5caf93ce93$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $aPdNQ.Slice)((0, $fud2r.flatmap)(slice.content, $93b96d5caf93ce93$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $aPdNQ.Slice)((0, $fud2r.flatmap)(slice.content, $93b96d5caf93ce93$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $aPdNQ.Slice)((0, $fud2r.flatmap)(slice.content, $93b96d5caf93ce93$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}




const $85f912d052ddf140$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $aPdNQ.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};





























const $742cd3b7e186e5d1$export$2073a24f9367a16f = (0, $dOBRD.default)(()=>{
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --anchor');
    return false;
});
const $742cd3b7e186e5d1$export$2ee7329d46115d8f = ()=>{
    const safariVersion = (0, $8dxef.getBrowserInfo)().safari_version;
    const isBrowserSafari = !Number.isNaN(safariVersion);
    return(// Safari has a bug with position: sticky and content editable, so we don't support it
    !isBrowserSafari && $742cd3b7e186e5d1$export$2073a24f9367a16f());
};












var $Igylv = parcelRequire("Igylv");






























const $e7003ff463061818$var$setDataAttr = (cell, attr, value)=>{
    const hasAttr = cell.hasAttribute(attr);
    if (value && !hasAttr) cell.setAttribute(attr, 'true');
    else if (!value && hasAttr) cell.removeAttribute(attr);
};
/**
 * Refreshes the `data-reaches-{top,bottom,left,right}` attributes used by CSS to round
 * the table's corner cells (including merged cells that span to an edge).
 *
 * Edge membership is derived directly from the table map's border rows/columns: a cell
 * reaches an edge iff its offset appears in the corresponding border slice (this naturally
 * accounts for rowspan/colspan cells, whose offset is repeated across every grid slot they
 * cover). This is O(cells) overall, versus O(cells^2) when calling findCell per cell.
 */ const $e7003ff463061818$var$refreshRoundedTableEdgeAttrs = (table, tableNode)=>{
    try {
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        const { width: width, height: height, map: map } = tableMap;
        const cells = Array.from(table.rows).flatMap((row)=>Array.from(row.cells));
        const cellOffsets = Array.from(new Set(map));
        const topOffsets = new Set();
        const bottomOffsets = new Set();
        const leftOffsets = new Set();
        const rightOffsets = new Set();
        for(let col = 0; col < width; col++){
            topOffsets.add(map[col]);
            bottomOffsets.add(map[(height - 1) * width + col]);
        }
        for(let row = 0; row < height; row++){
            leftOffsets.add(map[row * width]);
            rightOffsets.add(map[row * width + width - 1]);
        }
        cellOffsets.forEach((cellOffset, cellIndex)=>{
            const cell = cells[cellIndex];
            if (!cell) return;
            $e7003ff463061818$var$setDataAttr(cell, 'data-reaches-top', topOffsets.has(cellOffset));
            $e7003ff463061818$var$setDataAttr(cell, 'data-reaches-bottom', bottomOffsets.has(cellOffset));
            $e7003ff463061818$var$setDataAttr(cell, 'data-reaches-left', leftOffsets.has(cellOffset));
            $e7003ff463061818$var$setDataAttr(cell, 'data-reaches-right', rightOffsets.has(cellOffset));
        });
    } catch  {
    // Table structure can be transient while ProseMirror normalises transactions.
    // Keep existing edge attrs if the current shape cannot be mapped safely.
    }
};
/**
 * Builds a lightweight signature of the cells sitting on the table's four borders, using
 * their (immutable) ProseMirror node references. The signature changes whenever a border
 * cell is added, removed, merged, or moved (row/column reorder via drag-and-drop) but stays
 * stable across pure text edits in non-edge cells. This lets the controller decide cheaply
 * (O(rows + cols)) whether the rounded-edge attrs need a full refresh, instead of only
 * reacting to width/height changes.
 */ const $e7003ff463061818$var$getTableEdgeSignature = (tableNode)=>{
    const edgeCells = [];
    const lastRowIndex = tableNode.childCount - 1;
    tableNode.forEach((row, _rowOffset, rowIndex)=>{
        const isEdgeRow = rowIndex === 0 || rowIndex === lastRowIndex;
        const lastCellIndex = row.childCount - 1;
        row.forEach((cell, _cellOffset, cellIndex)=>{
            if (isEdgeRow || cellIndex === 0 || cellIndex === lastCellIndex) edgeCells.push(cell);
        });
    });
    return edgeCells;
};
const $e7003ff463061818$var$tableEdgeSignaturesDiffer = (prev, next)=>{
    if (!prev || prev.length !== next.length) return true;
    for(let i = 0; i < prev.length; i++){
        if (prev[i] !== next[i]) return true;
    }
    return false;
};
class $e7003ff463061818$export$45ddc54457529def {
    /**
   * Call from the node view's `update()` after `super.update()`. When the border signature
   * changes it schedules a refresh of the edge attrs on the next animation frame.
   */ handleUpdate(node) {
        const nextSignature = $e7003ff463061818$var$getTableEdgeSignature(node);
        const edgesChanged = $e7003ff463061818$var$tableEdgeSignaturesDiffer(this.prevSignature, nextSignature);
        this.prevSignature = nextSignature;
        if (edgesChanged) this.scheduleRefresh(node);
    }
    /** Call from the node view's `destroy()` to cancel any pending refresh. */ destroy() {
        if (this.refreshHandle !== undefined) {
            cancelAnimationFrame(this.refreshHandle);
            this.refreshHandle = undefined;
        }
    }
    // The refresh runs on the next animation frame because ReactNodeView.update() schedules the
    // table's React render via the portal provider. If we read `table.rows` synchronously, we'd
    // still see the previous DOM.
    scheduleRefresh(node) {
        if (this.refreshHandle !== undefined) cancelAnimationFrame(this.refreshHandle);
        this.refreshHandle = requestAnimationFrame(()=>{
            this.refreshHandle = undefined;
            const table = this.getTableElement();
            if (table instanceof HTMLTableElement) $e7003ff463061818$var$refreshRoundedTableEdgeAttrs(table, node);
        });
    }
    constructor(getTableElement, node){
        this.getTableElement = void 0;
        this.refreshHandle = void 0;
        // References to the previous render's border cells (O(rows + cols), perimeter-sized, not all cells).
        this.prevSignature = void 0;
        this.getTableElement = getTableElement;
        // Baseline the edge signature so the first content edit doesn't trigger a spurious
        // refresh — the cells set their own edge attrs on construction.
        this.prevSignature = $e7003ff463061818$var$getTableEdgeSignature(node);
    }
}


















var $LQnOI = parcelRequire("LQnOI");








var $jbOus = parcelRequire("jbOus");





var $fvMxa = parcelRequire("fvMxa");





var $g9sVl = parcelRequire("g9sVl");





var $e11am = parcelRequire("e11am");
























var $bTXWf = parcelRequire("bTXWf");


var $9r8oV = parcelRequire("9r8oV");


var $4PtQA = parcelRequire("4PtQA");


var $iqmUH = parcelRequire("iqmUH");


var $5Mj3f = parcelRequire("5Mj3f");


var $drwMb = parcelRequire("drwMb");


var $75xM4 = parcelRequire("75xM4");


var $jNg3h = parcelRequire("jNg3h");


var $eU390 = parcelRequire("eU390");


var $lIDh1 = parcelRequire("lIDh1");

function $329d3e829575e5e0$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eU390.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $lIDh1.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $329d3e829575e5e0$export$b220adcde0a1c5fd = {
    top: $329d3e829575e5e0$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $329d3e829575e5e0$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $329d3e829575e5e0$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $329d3e829575e5e0$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};


// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $fa112c50d6efcf4c$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $fa112c50d6efcf4c$var$getSpacingFromProvided(value) {
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
function $fa112c50d6efcf4c$var$getHitboxSpacing(provided) {
    return {
        top: $fa112c50d6efcf4c$var$getSpacingFromProvided(provided.forTopEdge),
        right: $fa112c50d6efcf4c$var$getSpacingFromProvided(provided.forRightEdge),
        bottom: $fa112c50d6efcf4c$var$getSpacingFromProvided(provided.forBottomEdge),
        left: $fa112c50d6efcf4c$var$getSpacingFromProvided(provided.forLeftEdge)
    };
}
function $fa112c50d6efcf4c$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $fa112c50d6efcf4c$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $iqmUH.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $329d3e829575e5e0$export$b220adcde0a1c5fd)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
			 * Intentionally _not_ doing an explicit check to
			 * see if `client` is with within the `overElementHitbox`.
			 *
			 * **Why?**
			 *
			 * 1. 🥱 Redundant
			 * This check is already achieved by `element.contains(underUsersPointer)`
			 *
			 * 2. 📐 Overlap on boundaries
			 * Two elements can share the same `{x,y}` points on shared edges.
			 * It's not clear which of the two will be picked by
			 * `const underUsersPointer = document.elementFromPoint(x,y)`
			 * The edge of an "outside" element, can have shared `{x,y}`
			 * values along the edge of an "inside element".
			 * So when `underUsersPointer` is the "outer" element, the `client`
			 * point might actually be also within the "inner" element.
			 * We are exclusively relying on `underUsersPointer` make the decision
			 * on what we are "over" so we should not be doing "over element" hitbox
			 * testing here.
			 * https://twitter.com/alexandereardon/status/1721758766507638996
			 *
			 *
			 * 3. 🐞 Chrome bug
			 * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
			 * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
			 * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
			 */ if ((0, $jNg3h.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $jNg3h.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $5Mj3f.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $75xM4.isAxisAllowed)((0, $iqmUH.edgeAxisLookup)[value.edge], allowedAxis) && (0, $4PtQA.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $fa112c50d6efcf4c$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $fa112c50d6efcf4c$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $fa112c50d6efcf4c$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $fa112c50d6efcf4c$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}


function $e350452427b9ca04$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $9r8oV.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $fa112c50d6efcf4c$export$6cfa6dfe6898b98f)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}


function $005f65aa8030e89e$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $e350452427b9ca04$export$10dd8807a40dbd8b)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $bTXWf.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}


const $c98b9d00711428e3$var$api = (0, $005f65aa8030e89e$export$b8fa21320a811083)({
    monitor: (0, $iSrRp.monitorForElements)
});
const $c98b9d00711428e3$export$b6fc2123c6c7faac = $c98b9d00711428e3$var$api.unsafeOverflowAutoScroll;



const $9e4bbf318fa6c019$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $38vK5.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            }
        }),
        (0, $c98b9d00711428e3$export$b6fc2123c6c7faac)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            },
            getOverflow: ()=>({
                    forTopEdge: {
                        top: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        right: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        left: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8)
                    },
                    forRightEdge: {
                        right: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        top: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        bottom: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8)
                    },
                    forLeftEdge: {
                        top: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        left: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
                        bottom: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8)
                    }
                })
        })
    ];
};





const $24d7f01a57cdc1f1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('stickyHeadersPlugin');


const $04640e18ab019d4a$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};





























var $2Vrax = parcelRequire("2Vrax");

var $1JGpb = parcelRequire("1JGpb");

var $eS0D9 = parcelRequire("eS0D9");



































const $b012a0a8cdd0c09d$export$f8597a393fbbbffb = 280;
const $b012a0a8cdd0c09d$export$2e13b7512b2d6fe8 = '[data-testid="column-handle-menu"], [data-testid="row-handle-menu"], [data-toolbar-component="menu"], [data-toolbar-nested-dropdown-menu]';
const $b012a0a8cdd0c09d$export$1aad44a7533f8ad8 = 'table-row';
const $b012a0a8cdd0c09d$export$2f97b0848614fec9 = 'table-column';


const $c6627e327b6f56a8$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $c6627e327b6f56a8$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $c6627e327b6f56a8$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $c6627e327b6f56a8$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $c6627e327b6f56a8$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $c6627e327b6f56a8$var$isFocusingTableMenu = (event)=>(0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && Boolean(event.relatedTarget.closest((0, $b012a0a8cdd0c09d$export$2e13b7512b2d6fe8)));
const $c6627e327b6f56a8$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $8dxef.getBrowserInfo)().ie_version !== 11 && !$c6627e327b6f56a8$var$isFocusingCalendar(event) && !$c6627e327b6f56a8$var$isFocusingModal(event) && !$c6627e327b6f56a8$var$isFocusingFloatingToolbar(event) && !$c6627e327b6f56a8$var$isFocusingDragHandles(event) && !$c6627e327b6f56a8$var$isFocusingDragHandlesClickableZone(event) && !$c6627e327b6f56a8$var$isFocusingTableMenu(event)) (0, $9b2eea537bbdfc67$export$f516ed9c5f43abfc)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $c6627e327b6f56a8$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $9b2eea537bbdfc67$export$f516ed9c5f43abfc)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $c6627e327b6f56a8$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $cycWk.findTable)(view.state.selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    if (event instanceof MouseEvent && (0, $42b76cc10c347878$export$14eb53395cc0cf57)(element)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const [startIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $9b2eea537bbdfc67$export$c2e8772deb1607ea)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    !(0, $2Vrax.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $8Z43Z.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const colElement = (0, $btvbC.closestElement)(element, 'td') || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $btvbC.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $btvbC.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $1JGpb.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $eS0D9.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $c6627e327b6f56a8$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    if ((0, $42b76cc10c347878$export$7a8d111d40fb198c)(target)) {
        const [startIndex, endIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(target);
        const positionRow = (0, $42b76cc10c347878$export$3bf5911758d564a4)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $9b2eea537bbdfc67$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
    }
    if ((0, $42b76cc10c347878$export$14eb53395cc0cf57)(target)) {
        const [startIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)([
            startIndex
        ], false)(state, dispatch);
    }
    const isNestedTable = (0, $euISL.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1;
    if (isNestedTable) {
        // if the table is nested inside a table, we only call hideInsertColumnOrRowButton if the table nearest to the mouse target is NOT the parent table
        const nearestTable = (0, $btvbC.closestElement)(target, 'table');
        const nestedTable = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(state.doc.resolve(state.selection.from), [
            state.schema.nodes.table
        ]);
        const parentTable = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(state.doc.resolve(nestedTable?.pos || 0), [
            state.schema.nodes.table
        ]);
        if (nearestTable?.dataset.tableLocalId !== parentTable?.node.attrs.localId && ((0, $42b76cc10c347878$export$835df158d20ae2f0)(target) || (0, $42b76cc10c347878$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $9b2eea537bbdfc67$export$27d9631a056c3f39)()(state, dispatch);
    } else if (((0, $42b76cc10c347878$export$835df158d20ae2f0)(target) || (0, $42b76cc10c347878$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $9b2eea537bbdfc67$export$27d9631a056c3f39)()(state, dispatch);
    if ((0, $42b76cc10c347878$export$4cf9002f70d2d324)(target)) {
        const [startIndex, endIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(target);
        return (0, $47589dd3b7f399b2$export$9b72d13d82d16e72)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $47589dd3b7f399b2$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $c6627e327b6f56a8$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $8Z43Z.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $9b2eea537bbdfc67$export$72433e6f15f8aeaa)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $c6627e327b6f56a8$var$resetDragHandleSelectedIntentOnMouseDown = (event, api)=>{
    if ((0, $42b76cc10c347878$export$75641d19d3ee2fef)(event.target)) return;
    if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragHandleSelected') api?.core?.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
};
const $c6627e327b6f56a8$export$b4a93e0b711d8f7 = (_view, event, api)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $42b76cc10c347878$export$2b59104f44ee317b)(event.target) || (0, $42b76cc10c347878$export$14eb53395cc0cf57)(event.target) || (0, $42b76cc10c347878$export$edad492f0c70264f)(event.target) || (0, $42b76cc10c347878$export$571c943db7bc729c)(event.target)));
    if (isControl) event.preventDefault();
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) $c6627e327b6f56a8$var$resetDragHandleSelectedIntentOnMouseDown(event, api);
    return isControl;
};
const $c6627e327b6f56a8$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $42b76cc10c347878$export$14eb53395cc0cf57)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $42b76cc10c347878$export$4cf9002f70d2d324)(target) && !(0, $42b76cc10c347878$export$4cf9002f70d2d324)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $47589dd3b7f399b2$export$5ad4eed96dbaffaf)()(state, dispatch);
    }
    return false;
};
const $c6627e327b6f56a8$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    if (!isTableHovered) return (0, $47589dd3b7f399b2$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $c6627e327b6f56a8$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    if (isTableHovered) {
        const { isDragMenuOpen: isDragMenuOpen = false } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
        !isDragMenuOpen && (0, $47589dd3b7f399b2$export$f217071b524cec4f)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$c6627e327b6f56a8$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $42b76cc10c347878$export$b4f0758743701ac9)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $9b2eea537bbdfc67$export$27d9631a056c3f39)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $c6627e327b6f56a8$var$handleMouseMoveDebounce = (nodeViewPortalProviderAPI)=>(0, $LQnOI.default)((view, event, offsetX)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        const element = event.target;
        const isTableMenuUpdatesEnabled = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true);
        // Spanned cells need mouse-position-based hover indexes; normal cells already report them.
        if (isTableMenuUpdatesEnabled) {
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const tableCell = (0, $2Vrax.isElementInTableCell)(element);
            if (tableCell && (tableCell.rowSpan > 1 || tableCell.colSpan > 1)) {
                const dragDropState = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(view.state);
                if (dragDropState && !dragDropState.isDragging) $c6627e327b6f56a8$var$trackCellLocation(view, event);
            }
        }
        if ((0, $42b76cc10c347878$export$14eb53395cc0cf57)(element) || (0, $42b76cc10c347878$export$666ae3fd07127e7f)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            const indexSourceElement = isTableMenuUpdatesEnabled ? (0, $42b76cc10c347878$export$a1261fc41ec5bc0f)(element) : element;
            const [startIndex, endIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(indexSourceElement);
            const positionColumn = (0, $42b76cc10c347878$export$3dde6150a2e2df0a)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
            if (positionColumn !== insertColumnButtonIndex) return (0, $9b2eea537bbdfc67$export$72433e6f15f8aeaa)(positionColumn)(state, dispatch);
        }
        if ((0, $42b76cc10c347878$export$edad492f0c70264f)(element) || (0, $42b76cc10c347878$export$b2ae534578c0ae33)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertRowButtonIndex: insertRowButtonIndex } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            const indexSourceElement = isTableMenuUpdatesEnabled ? (0, $42b76cc10c347878$export$a1261fc41ec5bc0f)(element) : element;
            const [startIndex, endIndex] = (0, $42b76cc10c347878$export$e5e82c478fd9ea3)(indexSourceElement);
            const positionRow = (0, $42b76cc10c347878$export$3bf5911758d564a4)(event) === 'bottom' ? endIndex : startIndex;
            if (positionRow !== insertRowButtonIndex) return (0, $9b2eea537bbdfc67$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
        }
        if (!(0, $42b76cc10c347878$export$4cf9002f70d2d324)(element) && (0, $42b76cc10c347878$export$835df158d20ae2f0)(element)) {
            const positionColumn = (0, $42b76cc10c347878$export$3dde6150a2e2df0a)(event, offsetX, (0, $93ebfcf1771919c4$export$1a38c7157d718094));
            if (positionColumn !== null) {
                const { state: state, dispatch: dispatch } = view;
                const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                const isKeyboardResize = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state).isKeyboardResize;
                const tableCell = (0, $btvbC.closestElement)(element, 'td, th');
                const cellStartPosition = view.posAtDOM(tableCell, 0);
                const rect = (0, $cycWk.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
                if (rect) {
                    const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                    const rowIndexTarget = rect.top;
                    if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $42b76cc10c347878$export$80e4fcc9d7220616)({
                        target: element,
                        columnEndIndexTarget: columnEndIndexTarget
                    })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                    ) return (0, $9b2eea537bbdfc67$export$cc6f44d67305c400)(rowIndexTarget, columnEndIndexTarget, true, nodeViewPortalProviderAPI)(state, dispatch);
                }
            }
        }
        return false;
    });
const $c6627e327b6f56a8$export$3248c033e90a4ba0 = (nodeViewPortalProviderAPI)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
        // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
        // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
        // in the deferred callback handler.
        // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
        $c6627e327b6f56a8$var$handleMouseMoveDebounce(nodeViewPortalProviderAPI)(view, event, (0, $8dxef.getBrowserInfo)().gecko ? event.offsetX : NaN);
        return false;
    };
function $c6627e327b6f56a8$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $7zMjs.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $kCECX.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $kCECX.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $kCECX.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $c6627e327b6f56a8$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $8HW7o.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $8HW7o.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $8HW7o.CellSelection)) {
            const rect = (0, $hC0Ga.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$277d5394a2608229)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).CUT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $8HW7o.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $b730fae248040f82$export$5b4a0d6329b35552)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(newState);
                        tr = (0, $4633e594230ce0eb$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $83bf9e50d594393b$export$9dbd3595d5638a0b)(rect, (0, $90f868070281c7fb$export$f8ddfdc64e14a808)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $c6627e327b6f56a8$export$42d5d9cc7457d81e = (view)=>{
    return !!(0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(view.state)?.tableNode && !(0, $78429e61a3e1fdf5$export$f05434c51e3762e)(view.state)?.dragging;
};
const $c6627e327b6f56a8$export$82a75cb550f27e28 = (eventHandler, pluginInjectionApi)=>(view, mouseEvent)=>{
        if (!$c6627e327b6f56a8$export$42d5d9cc7457d81e(view)) return false;
        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        /**
   * Table cannot be in focus if we are in view mode.
   * This will prevent an infinite flow of adding and removing
   * resize handle decorations in view mode that causes unpredictable
   * selections.
   */ if (isViewMode) return false;
        return eventHandler(view, mouseEvent);
    };
const $c6627e327b6f56a8$var$trackCellLocation = (view, mouseEvent)=>{
    const isTableMenuUpdatesEnabled = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true);
    const target = mouseEvent.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const maybeTableCell = (0, $2Vrax.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(view.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const tableElement = (0, $btvbC.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement?.dataset?.tableLocalId && tableElement.dataset.tableLocalId !== tableNode?.attrs.localId) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $btvbC.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const rowIndex = maybeTableCell.rowSpan > 1 && mouseEvent instanceof MouseEvent && isTableMenuUpdatesEnabled ? (0, $d44e2b3965cf0527$export$6fa6c264fb9023fb)(tableRef, mouseEvent, {
        startIndex: htmlRowIndex,
        endIndex: htmlRowIndex + maybeTableCell.rowSpan
    }) ?? htmlRowIndex : htmlRowIndex;
    const tableMap = tableNode && (0, $8Z43Z.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $51948cb73f37d26f$export$b53a50910add7502)(htmlColIndex, htmlRowIndex, tableMap);
        if (isTableMenuUpdatesEnabled) {
            // New behaviour: the column controls grid renders one track per visual column
            // (`getColumnsWidthsWithMergedCells`), so the hover index must be the visual column
            // index — not the first-row-cell index. Mapping to the first-row cell would collapse
            // every column under a merged first-row cell to the same index, leaving the drag handle
            // stuck when hovering cells in other rows. For a colspanned cell, refine the converted
            // (left-most) visual column to the exact visual column under the pointer.
            colIndex = convertedColIndex;
            if (maybeTableCell.colSpan > 1 && mouseEvent instanceof MouseEvent) colIndex = (0, $51948cb73f37d26f$export$b8d525853cd49bde)(maybeTableCell, mouseEvent, {
                startIndex: convertedColIndex,
                endIndex: convertedColIndex + maybeTableCell.colSpan
            }) ?? convertedColIndex;
        } else // Old behaviour: the legacy grid renders one track per first-row cell, so snap to the
        // first-row column index (a merged first-row cell collapses to a single column track).
        colIndex = (0, $51948cb73f37d26f$export$ffa56ed053ef832e)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $47589dd3b7f399b2$export$1d614a0f0fe37c44)(rowIndex, colIndex)(view.state, view.dispatch);
};
const $c6627e327b6f56a8$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $9c44a2089c87f26f$export$f05434c51e3762e)(view.state) && !(0, $9c44a2089c87f26f$export$f05434c51e3762e)(view.state).isDragging) $c6627e327b6f56a8$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };
















/* eslint-disable @atlaskit/design-system/prefer-primitives */ 































/* eslint-disable @atlaskit/design-system/no-html-button */ 






var $9kbTQ = parcelRequire("9kbTQ");






















var $cDMxg = parcelRequire("cDMxg");




















const $477a4d8b388db835$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "1",
        y: "1",
        width: "26",
        height: "18",
        rx: "5",
        fill: "var(--ds-background-accent-blue-subtle, #669DF1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "9",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "13",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "17",
        y: "6",
        width: "2",
        height: "8",
        rx: "1",
        fill: "var(--ds-border-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "1",
        y: "1",
        width: "26",
        height: "18",
        rx: "5",
        stroke: "var(--ds-border-inverse, #FFFFFF)",
        strokeWidth: "2"
    }));


const $c59ec903c7e4c2fe$var$boxStyles = (0, $buxP3.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    backgroundColor: 'color.blanket.selected'
});
const $c59ec903c7e4c2fe$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    const marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    const marginTop = direction === 'row' ? height / 2 - 14 : -10;
    const transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c59ec903c7e4c2fe$var$boxStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            width: `${width}px`,
            height: `${height}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $477a4d8b388db835$export$227151c7eab30def), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: `${marginLeft}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transform: transform
        }
    }));
};








const $28e6a072c6f25d36$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "16",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "7",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "11",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "15",
        y: "4",
        width: "2",
        height: "8",
        rx: "1"
    })));





const $dd60897bfec247b3$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "16",
        rx: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
    })));






const $0fcd08413da1e55e$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED,
        width: "24",
        height: "5",
        rx: "3"
    }));


const $ceb69f370583a51f$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28e6a072c6f25d36$export$b005cb3a0f2a5647), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd60897bfec247b3$export$7d3bc85820ac4455), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fcd08413da1e55e$export$e32dc8bb64018ca1), null);
};


const $fe3937c19310030c$var$DragHandleComponent = ({ api: api, isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage } })=>{
    const dragHandleDivRef = (0, $cozmU.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $cozmU.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    const hasMergedCells = (0, $cozmU.useMemo)(()=>{
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return false;
        const map = (0, $8Z43Z.TableMap).get(table?.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $kCECX.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $a5103e1f191e6e99$export$1d4a5608e72f1096)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $a5103e1f191e6e99$export$1d4a5608e72f1096)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $a5103e1f191e6e99$export$e4c313e419348ae7)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $a5103e1f191e6e99$export$e4c313e419348ae7)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $cozmU.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        const browser = (0, $8dxef.getBrowserInfo)();
        if (dragHandleDivRefCurrent) return (0, $iSrRp.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $cDMxg.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if (browser.safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    const browser = (0, $8dxef.getBrowserInfo)();
    // Clicking the drag handle's clickable zone is a plain row/column selection (not the menu
    // trigger), so the selection toolbar should appear. The floating menu defers closing for clicks
    // inside the drag controls, so we close it here and reset the user intent to 'default' (in the
    // same transaction) so the toolbar is shown.
    const closeActiveDragMenuAndShowToolbar = (0, $cozmU.useCallback)(()=>{
        if (!api) return;
        const activeTableMenu = api.table?.sharedState.currentState()?.activeTableMenu;
        const isActiveTableMenuOpen = activeTableMenu?.type === 'row' || activeTableMenu?.type === 'column';
        if (!isActiveTableMenuOpen) return;
        api.core?.actions.execute(({ tr: tr })=>{
            (0, $4c617ebfadab8027$export$68481d8823bb24fb)(api, {
                skipUserIntent: true
            })({
                tr: tr
            });
            api.userIntent?.commands.setCurrentUserIntent('default')({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
        "data-testid": "table-drag-handle-clickable-zone-button",
        style: {
            height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${0, $deb80ec534adbdde$export$d18320cc8ee69115}px)` : `${"var(--ds-space-200, 16px)"}`,
            // 16px here because it's the size of drag handle button's large side
            width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
             : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${0, $deb80ec534adbdde$export$d18320cc8ee69115}px)`,
            left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
            bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
            alignSelf: isColumn ? 'none' : 'center',
            zIndex: isColumn ? '-1' : 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            pointerEvents: 'auto'
        },
        onMouseUp: (e)=>{
            // should toggle menu if current drag menu open.
            // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
            // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
            editorView.focus();
            if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) // New menu: close the open row/column menu (and show the selection toolbar).
            closeActiveDragMenuAndShowToolbar();
            else if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
        },
        onClick: onClick,
        "aria-label": formatMessage((0, $fKJ7J.messages).dragHandleZone)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
            [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED]: hasMergedCells
        }),
        ref: dragHandleDivRef,
        style: {
            transform: isColumn ? 'none' : 'rotate(90deg)',
            alignSelf: isColumn ? 'none' : 'center'
        },
        "data-testid": "table-drag-handle-button",
        "aria-label": formatMessage(isRow ? (0, $fKJ7J.messages).rowDragHandle : (0, $fKJ7J.messages).columnDragHandle),
        "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
        "aria-haspopup": "menu",
        onMouseOver: (e)=>{
            setIsHovered(true);
            onMouseOver && onMouseOver(e);
        },
        onMouseOut: (e)=>{
            setIsHovered(false);
            onMouseOut && onMouseOut(e);
        },
        onFocus: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? (e)=>{
            onFocus && onFocus(e);
        } : undefined,
        onBlur: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? (e)=>{
            onBlur && onBlur(e);
        } : undefined,
        onMouseUp: (e)=>{
            // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
            // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
            editorView.focus();
            if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) toggleDragMenu && toggleDragMenu('mouse', e, indexes[0]);
            else toggleDragMenu && toggleDragMenu('mouse', e);
        },
        onClick: onClick,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) toggleDragMenu && toggleDragMenu('keyboard', undefined, indexes[0]);
                else toggleDragMenu && toggleDragMenu('keyboard');
            }
        }
    }, appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
    browser.gecko ? // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceb69f370583a51f$export$8749e1cb5c52435f), handleIconProps) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceb69f370583a51f$export$8749e1cb5c52435f), handleIconProps)) : null), previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c59ec903c7e4c2fe$export$905ab40ac2179daa), {
        direction: direction,
        width: previewWidth,
        height: previewHeight
    }), previewContainer));
};
const $fe3937c19310030c$export$a0c24614540b0efb = (0, $kSwu1.injectIntl)($fe3937c19310030c$var$DragHandleComponent);


const $d486eb7a1912664f$var$getSelectedColumns = (selection)=>{
    if (!(selection instanceof (0, $8HW7o.CellSelection))) return [];
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        // New behaviour: also treat a column selection that sits below a merged first-row cell as a
        // full column selection.
        if (!selection.isColSelection() && !(0, $61cf1c01aee4adc2$export$dcbd781e48a8c658)(selection)) return [];
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        return rect ? (0, $61cf1c01aee4adc2$export$915a77877be361e9)(rect) : [];
    }
    // Old behaviour: only standard column selections are recognised.
    if (selection.isColSelection()) {
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $61cf1c01aee4adc2$export$915a77877be361e9)(rect);
    }
    return [];
};
const $d486eb7a1912664f$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $cozmU.useRef)(null);
    const { selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const widths = colWidths?.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ') ?? '0px';
    // TODO: ED-26961 - reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $d44e2b3965cf0527$export$b8127ab1acaa6d46)(colWidths ?? []);
    const colIndex = hoveredCell?.colIndex;
    const selectedColIndexes = $d486eb7a1912664f$var$getSelectedColumns(selection || editorView.state.selection);
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = 45;
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $9b2eea537bbdfc67$export$c2e8772deb1607ea)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $9b2eea537bbdfc67$export$41a42e79fbe56d35)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $cozmU.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $cozmU.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $47589dd3b7f399b2$export$1d614a0f0fe37c44)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $cozmU.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $cozmU.useCallback)((trigger, event, handleIndex)=>{
        if (event?.shiftKey) return;
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            // Use the clicked handle index because `hoveredCell` can point at a merged cell's first column.
            const targetColIndex = handleIndex ?? colIndex;
            if (targetColIndex !== undefined && api) {
                const { activeTableMenu: currentActiveTableMenu } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                const isSameActiveMenu = currentActiveTableMenu?.type === 'column' && currentActiveTableMenu.index === targetColIndex;
                api.core.actions.execute(({ tr: tr })=>{
                    if (!isSameActiveMenu) api.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $jzpoq.TABLE_ACTION).DRAG_MENU_OPENED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: trigger === 'keyboard' ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE,
                            direction: 'column'
                        }
                    })(tr);
                    (0, $4c617ebfadab8027$export$5744ca63af11af1a)({
                        type: 'column',
                        index: targetColIndex,
                        openedBy: trigger
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
            }
            return;
        }
        (0, $b1a4a1bc8826a6a3$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex,
        api
    ]);
    const colIndexes = (0, $cozmU.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = getScrollOffset?.() ?? 0;
    // EDITOR-6790 - render a dot on the left edge of the first column so users have a visible
    // affordance to insert a column to the left of the first column.
    const isFirstColumnInsertEnabled = (0, $ieeJu.expValEquals)('platform_editor_table_col_insert', 'isEnabled', true);
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = rowHeights?.reduce((sum, cur)=>sum + cur, 0) ?? 0;
        const previewWidth = colWidths?.reduce((sum, v, i)=>sum + (v ?? (0, $k8PFz.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0) ?? (0, $k8PFz.tableCellMinWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            contentEditable: false,
            key: type,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                pointerEvents: isPlaceholder && isFirstColumnInsertEnabled ? 'none' : undefined
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : selectedColIndexes[0]}-drag-handle`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3937c19310030c$export$a0c24614540b0efb), {
            api: api,
            isDragMenuTarget: !isHover,
            direction: "column",
            tableLocalId: localId || '',
            indexes: indexes,
            hoveredCell: hoveredCell,
            previewWidth: previewWidth,
            forceDefaultHandle: !isHover,
            previewHeight: previewHeight,
            appearance: appearance,
            onClick: handleClick,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            onBlur: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
            onFocus: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOver : undefined,
            toggleDragMenu: toggleDragMenuHandler,
            editorView: editorView
        }));
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = selectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > selectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedColIndexes[0] + 1} / span ${selectedColIndexes.length}`, selectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !selectedColIndexes.includes(colIndex)) handles.push(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: columnControlsRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
        "data-testid": "table-floating-column-controls",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gridTemplateColumns: widths,
            marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginTop,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: stickyTop ? containerWidth : undefined,
            overflowX: stickyTop ? 'hidden' : 'visible',
            pointerEvents: isDragging ? 'none' : undefined
        }
    }, columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                gridColumn: `${startIndex + 1} / span 1`
            },
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
            contentEditable: false,
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index
        }, isFirstColumnInsertEnabled && index === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                left: '0',
                right: 'auto'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: columnParams.length - 1 === index ? {
                right: '0'
            } : {}
        }))), columnHandles()));
};
















const $5b3ec32adc1ef23d$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $iSrRp.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $bf50c846deda0729$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $bf50c846deda0729$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $bf50c846deda0729$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $aqP4n.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};


const $e42634b329870faf$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $cozmU.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${getScrollOffset?.() ?? 0}px`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
        "data-testid": "table-floating-column-controls-drop-targets"
    }, colWidths?.map((width, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b3ec32adc1ef23d$export$e8a325e09c5453d5), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            index: index,
            localId: localId,
            width: width,
            height: tableHeight,
            marginTop: 0
        });
    })));
};


const $cb4f8d58cffbb2d9$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor })=>{
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node?.attrs.localId;
    const hasHeaderColumn = (0, $8e70e8c6596c6b3f$export$a21ded6c12f16fdf)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $cozmU.useEffect)(()=>{
        return (0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $cozmU.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $d44e2b3965cf0527$export$3e5149a60ac7416b)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? (0, $51948cb73f37d26f$export$cf5a0e252f1598f1)(editorView) : (0, $51948cb73f37d26f$export$79aef9e007571c)(editorView);
    if (stickyTop) {
        const columnControlTopOffsetFromParent = '-12px';
        containerRef?.current?.style.setProperty('top', columnControlTopOffsetFromParent);
    } else containerRef?.current?.style.removeProperty('top');
    let anchorStyles = {};
    if ((0, $742cd3b7e186e5d1$export$2ee7329d46115d8f)() && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        const rowAnchorName = tableRef.querySelector('tr')?.style.getPropertyValue('anchor-name');
        // cast here is due to CSSProperties missing valid positionAnchor property
        anchorStyles = {
            /* We need to default to checking the anchor style because there may be a conflict with the block controls
       plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
       */ positionAnchor: rowAnchorName === '' ? tableRef.querySelector('tr')?.dataset.nodeAnchor : rowAnchorName
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper",
        // anchor name is determined dynamically so can't use static styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: anchorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d486eb7a1912664f$export$a71b12ee0b179860), {
        editorView: editorView,
        hoveredCell: hoveredCell,
        tableRef: tableRef,
        tableActive: tableActive,
        isTableHovered: isTableHovered,
        stickyTop: tableActive ? stickyTop : undefined,
        localId: currentNodeLocalId,
        isInDanger: isInDanger,
        rowHeights: rowHeights,
        colWidths: colWidths,
        hasHeaderColumn: hasHeaderColumn,
        tableContainerWidth: tableContainerWidth,
        isNumberColumnEnabled: isNumberColumnEnabled,
        isDragging: isDragging,
        getScrollOffset: getScrollOffset,
        api: api
    }), isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e42634b329870faf$export$9878f6beafc50edd), {
        tableRef: tableRef,
        isHeaderSticky: stickyHeader?.sticky && hasHeaderRow,
        tableHeight: tableWrapperHeight,
        localId: currentNodeLocalId,
        colWidths: colWidths,
        getScrollOffset: getScrollOffset
    }));
};
var $cb4f8d58cffbb2d9$export$2e2bcd8739ae039 = $cb4f8d58cffbb2d9$var$TableFloatingColumnControls;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















































const $dce53d03e7fabcb8$var$DragCornerControlsComponent = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage } })=>{
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $WABbQ.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $cozmU.useMemo)(()=>{
        const { selection: selection } = editorView.state;
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return false;
        return (0, $8imfU.isTableSelected)(selection);
    }, [
        editorView.state
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $fKJ7J.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        onBlur: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
    }));
};
const $dce53d03e7fabcb8$var$DragCornerControlsComponentWithSelection = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, api: api })=>{
    const { selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $WABbQ.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $cozmU.useMemo)(()=>{
        if (!selection) return;
        const table = (0, $cycWk.findTable)(selection);
        if (!table) return false;
        return (0, $8imfU.isTableSelected)(selection);
    }, [
        selection
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $fKJ7J.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        onBlur: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
        contentEditable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
    }));
};
const $dce53d03e7fabcb8$export$2e06061cfdb64df2 = (0, $kSwu1.injectIntl)($dce53d03e7fabcb8$var$DragCornerControlsComponentWithSelection);
const $dce53d03e7fabcb8$export$2beb96b6455e9966 = (0, $kSwu1.injectIntl)($dce53d03e7fabcb8$var$DragCornerControlsComponent);









var $4iudd = parcelRequire("4iudd");










class $9006b2650fecb3a2$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $d44e2b3965cf0527$export$3e5149a60ac7416b)(tableRef);
        const getMarginTop = ()=>{
            if (!hasHeaderRow || this.props.stickyTop === undefined) return undefined;
            // with platform_editor_table_q4_loveability enabled, table controls have margin-top of 1px applied. Offset this here.
            return rowHeights[0] + 1;
        };
        if ((0, $4iudd.isSSR)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? getMarginTop() : hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: isDragAndDropEnabled && tableActive && !(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'hidden' // Ensure the column is not visible during SSR
            },
            contentEditable: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? getMarginTop() : hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: isDragAndDropEnabled && tableActive && !(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'visible'
            },
            contentEditable: false
        }, rowHeights.map((rowHeight, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: `wrapper-${index}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: this.getClassNames(index, true),
                "data-index": index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: this.getCellStyles(index, rowHeight),
                onFocus: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? ()=>updateCellHoverLocation(index) : undefined,
                onMouseOver: ()=>updateCellHoverLocation(index)
            }, hasHeaderRow ? index > 0 ? index : null : index + 1)));
    }
    constructor(...args){
        super(...args);
        this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = 0;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        };
        this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, tableActive: tableActive } = this.props;
            const isActive = (0, $8imfU.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, {
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER]: tableActive && isActive && isInDanger,
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE]: tableActive && isActive
            });
        };
    }
}


/* eslint-disable @atlaskit/design-system/prefer-primitives */ 








































const $048e5e8ef7bb619d$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $iSrRp.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $bf50c846deda0729$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $bf50c846deda0729$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $bf50c846deda0729$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $aqP4n.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $048e5e8ef7bb619d$export$2e2bcd8739ae039 = $048e5e8ef7bb619d$var$RowDropTarget;


const $1146ebd0a0d95ff4$var$getSelectedRows = (selection)=>{
    if (!(selection instanceof (0, $8HW7o.CellSelection))) return [];
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        // New behaviour: also treat a row selection that sits to the right of a merged first-column
        // cell as a full row selection.
        if (!selection.isRowSelection() && !(0, $61cf1c01aee4adc2$export$8e35aa0e81c25478)(selection)) return [];
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        return rect ? (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(rect) : [];
    }
    // Old behaviour: only standard row selections are recognised.
    if (selection.isRowSelection()) {
        const rect = (0, $hC0Ga.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(rect);
    }
    return [];
};
const $1146ebd0a0d95ff4$export$350d0cf1f91b53f4 = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api, selection: selection })=>{
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const rowHeights = (0, $d44e2b3965cf0527$export$3e5149a60ac7416b)(tableRef);
    const rowsParams = (0, $d44e2b3965cf0527$export$b8127ab1acaa6d46)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $1146ebd0a0d95ff4$var$getSelectedRows(selection ?? editorView.state.selection);
    const currentNodeLocalId = tableNode?.attrs?.localId ?? '';
    (0, $cozmU.useEffect)(()=>{
        return (0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === tableNode?.attrs.localId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $cozmU.useCallback)((trigger, event, handleIndex)=>{
        if (event?.shiftKey) return;
        // Use the clicked handle index because `hoveredCell` can point at a merged cell's first row.
        const rowIndex = handleIndex ?? hoveredCell?.rowIndex;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if (rowIndex !== undefined && api) {
                const { activeTableMenu: currentActiveTableMenu } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
                const isSameActiveMenu = currentActiveTableMenu?.type === 'row' && currentActiveTableMenu.index === rowIndex;
                api.core.actions.execute(({ tr: tr })=>{
                    if (!isSameActiveMenu) api.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $jzpoq.TABLE_ACTION).DRAG_MENU_OPENED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: trigger === 'keyboard' ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE,
                            direction: 'row'
                        }
                    })(tr);
                    (0, $4c617ebfadab8027$export$5744ca63af11af1a)({
                        type: 'row',
                        index: rowIndex,
                        openedBy: trigger
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
            }
            return;
        }
        (0, $b1a4a1bc8826a6a3$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'row', rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell?.rowIndex,
        api
    ]);
    const rowIndex = hoveredCell?.rowIndex;
    const handleMouseOut = (0, $cozmU.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $cozmU.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target?.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS}`);
        const rowIndex = target?.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $cozmU.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $cozmU.useCallback)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        const isClickOutsideSelectedRows = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectRow(rowIndex, e.shiftKey);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: type,
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE : undefined,
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`,
            "data-row-index": rowIndex,
            "data-selected-row-index": selectedRowIndexes[0],
            "data-handle-appearance": appearance
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe3937c19310030c$export$a0c24614540b0efb), {
            api: api,
            isDragMenuTarget: !isHover,
            direction: "row",
            tableLocalId: currentNodeLocalId,
            indexes: indexes,
            forceDefaultHandle: !isHover,
            previewWidth: tableWidth,
            previewHeight: previewHeight,
            appearance: appearance,
            hoveredCell: hoveredCell,
            onClick: handleClick,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            onBlur: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
            onFocus: (0, $ieeJu.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOver : undefined,
            toggleDragMenu: toggleDragMenuHandler,
            editorView: editorView
        }));
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        const selectedGridRow = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? // New behaviour: always position the placeholder in the first row to avoid an invalid
        // `NaN / span 0` grid placement (which makes the handle disappear) when no rows are selected.
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}` : // Old behaviour.
        `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`;
        handles.push(generateHandleByType('selected', selectedAppearance, selectedGridRow, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $deb80ec534adbdde$export$6bec1f8a2aa82be8}px ${0, $deb80ec534adbdde$export$c2ef52861254b274}px ${tableWidth}px` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0px ${0, $deb80ec534adbdde$export$c2ef52861254b274}px 0px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $deb80ec534adbdde$export$6bec1f8a2aa82be8) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false
    }, rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                gridRow: `${index + 1} / span 1`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2'
            },
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
            contentEditable: false,
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: `insert-dot-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT
        })), isDragging && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $048e5e8ef7bb619d$export$2e2bcd8739ae039), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: `drop-target-${index}`,
            index: index,
            localId: currentNodeLocalId,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '1 / span 3',
                gridRow: `${index + 1} / span 1`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                pointerEvents: 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: "var(--ds-space-negative-100, -8px)"
            }
        }))), rowHandles());
};
const $1146ebd0a0d95ff4$export$8bade456cc132de4 = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, tableActive: tableActive, hoveredCell: hoveredCell, isInDanger: isInDanger, isTableHovered: isTableHovered, isResizing: isResizing, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api })=>{
    const { selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1146ebd0a0d95ff4$export$350d0cf1f91b53f4, {
        editorView: editorView,
        tableRef: tableRef,
        tableNode: tableNode,
        tableWidth: tableWidth,
        tableActive: tableActive,
        hoveredCell: hoveredCell,
        isInDanger: isInDanger,
        isTableHovered: isTableHovered,
        isResizing: isResizing,
        hoverRows: hoverRows,
        selectRow: selectRow,
        selectRows: selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api,
        selection: selection
    });
};


function $2fc4d25daa4b2ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2fc4d25daa4b2ed4$var$styles = {
    name: "lr2r3w",
    styles: "&:has(~ .pm-table-wrapper-no-overflow){margin-top:0;}"
};
const $2fc4d25daa4b2ed4$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $cozmU.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $8dxef.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $9b2eea537bbdfc67$export$e247ed8cec4832f4)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $cozmU.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $8dxef.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $9b2eea537bbdfc67$export$b5ba3b60192c7a8d)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $cozmU.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $47589dd3b7f399b2$export$ab63d99b591b89)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $cozmU.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $47589dd3b7f399b2$export$1d614a0f0fe37c44)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER;
    const tablePos = (0, $cycWk.findTable)(editorView.state.selection)?.pos;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const isNested = tablePos !== undefined && (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(editorView.state, tablePos);
    const shouldShowCornerControls = isNested && !(0, $ixfCV.fg)('platform_editor_nested_dnd_styles_changes');
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassName,
        css: [
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && !(0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_7') && $2fc4d25daa4b2ed4$var$styles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        role: "none",
        onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault()
    }, isNumberColumnEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9006b2650fecb3a2$export$2e2bcd8739ae039), {
        editorView: editorView,
        hoverRows: _hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        updateCellHoverLocation: updateCellHoverLocation,
        stickyTop: stickyTop,
        isDragAndDropEnabled: isDragAndDropEnabled
    }) : null, tableActive && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, shouldShowCornerControls && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dce53d03e7fabcb8$export$2e06061cfdb64df2), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        api: api
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1146ebd0a0d95ff4$export$8bade456cc132de4), {
        tableRef: tableRef,
        tableNode: tableNode,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        editorView: editorView,
        tableActive: tableActive,
        isInDanger: isInDanger,
        isResizing: isResizing,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tableWidth: tableWrapperWidth,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        selectRows: _selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api
    }))));
};
var $2fc4d25daa4b2ed4$export$2e2bcd8739ae039 = $2fc4d25daa4b2ed4$export$1e425115e5c75aac;














const $cf73522296cb0654$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $cozmU.useState)(false);
    const currentNodeLocalId = node?.attrs.localId;
    (0, $cozmU.useEffect)(()=>{
        return (0, $iSrRp.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $51948cb73f37d26f$export$79aef9e007571c)(editorView);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $deb80ec534adbdde$export$6bec1f8a2aa82be8) - (0, $k8PFz.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $deb80ec534adbdde$export$b2015400488f9243)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // move drop targets based on table wrapper scroll
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: `-${getScrollOffset()}px`
        }
    }, colWidths?.map((width, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b3ec32adc1ef23d$export$e8a325e09c5453d5), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            index: index,
            localId: currentNodeLocalId,
            width: width,
            height: (0, $deb80ec534adbdde$export$6bec1f8a2aa82be8),
            marginTop: 0
        });
    })));
};























































var $78UMD = parcelRequire("78UMD");











var $jv11C = parcelRequire("jv11C");


var $aWssQ = parcelRequire("aWssQ");


var $4Qu9h = parcelRequire("4Qu9h");





























var $6PhB4 = parcelRequire("6PhB4");

const $dd997a1d3eaa42b0$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return (0, $6PhB4.createGuidesFromLengths)(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};



var $11HKG = parcelRequire("11HKG");










const $d66ebc188fbae6c9$var$numberOfLanesInDefaultLayoutWidth = 12;
const $d66ebc188fbae6c9$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $d66ebc188fbae6c9$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$d66ebc188fbae6c9$var$calculateSubSnappingWidths($d66ebc188fbae6c9$var$numberOfLanesInDefaultLayoutWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $7Y8M5.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $7Y8M5.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $d66ebc188fbae6c9$var$getPadding = (editorContainerWidth)=>{
    return editorContainerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
};
const $d66ebc188fbae6c9$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWidth = (0, $7Y8M5.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $d66ebc188fbae6c9$var$getPadding(editorContainerWidth);
    const dynamicFullWidthLine = editorContainerWidth - padding * 2 >= (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const dynamicMaxWidthLine = editorContainerWidth - padding * 2 >= (0, $7Y8M5.akEditorMaxWidthLayoutWidth) ? (0, $7Y8M5.akEditorMaxWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    if ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) guides.push(dynamicMaxWidthLine - lengthOffset);
    if (!exclude.breakoutPoints) guides.unshift((0, $7Y8M5.akEditorDefaultLayoutWidth) + lengthOffset, (0, $7Y8M5.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$d66ebc188fbae6c9$var$calculateSubSnappingWidths($d66ebc188fbae6c9$var$numberOfLanesInDefaultLayoutWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $d66ebc188fbae6c9$export$c5e672719c546336 = $d66ebc188fbae6c9$export$c4ddb11be0806484();
const $d66ebc188fbae6c9$export$b2f61428a1609695 = 0;
const $d66ebc188fbae6c9$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $d66ebc188fbae6c9$var$getPadding(editorContainerWidth);
    return editorContainerWidth - padding * 2 > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? $d66ebc188fbae6c9$export$c4ddb11be0806484() : $d66ebc188fbae6c9$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $d66ebc188fbae6c9$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $11HKG.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};


const $46ad12f11f94bf79$export$71ea7e0a71c6d202 = (0, $dd997a1d3eaa42b0$export$24448ad8894709b4)([
    0,
    ...(0, $d66ebc188fbae6c9$export$c4ddb11be0806484)(-1)
]);
const $46ad12f11f94bf79$export$d25f7f8989bf9598 = -1;
const $46ad12f11f94bf79$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $d66ebc188fbae6c9$export$7542cd96381664c2)(lengthOffset, editorContainerWidth, exclude);
    return (0, $dd997a1d3eaa42b0$export$24448ad8894709b4)(lengths, undefined, true);
};




const $51f1e6c8a600d549$var$RESIZE_STEP_VALUE = 10;
const $51f1e6c8a600d549$var$handles = {
    right: true
};
const $51f1e6c8a600d549$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $51f1e6c8a600d549$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = tableRef?.clientHeight ?? 0;
    /*
  - One row table height (minimum possible table height) ~ 45px
  - Two row table height ~ 90px
  - Three row table height ~ 134px
  	In the if below we need to use:
  - > 46 because the height of the table can be a float number like 45.44.
  - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $51f1e6c8a600d549$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $cec18a6f3d8c1f93$export$dc24345db4290451)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $26c6284b781fc82b$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
const $51f1e6c8a600d549$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
};
const $51f1e6c8a600d549$var$getTableMaxWidth = (containerWidth, lineLength, isCommentEditor, isChromelessEditor)=>{
    if (isCommentEditor) return Math.floor(containerWidth - (0, $26c6284b781fc82b$export$c332ba2dd5aa2199));
    else if (isChromelessEditor) return Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : Math.floor(containerWidth - (0, $26c6284b781fc82b$export$a823f6a7493b3d06));
    else return (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916);
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $51f1e6c8a600d549$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $deb80ec534adbdde$export$858d012f03ae70a5);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $46ad12f11f94bf79$export$d25f7f8989bf9598) + 1;
        const padding = $51f1e6c8a600d549$var$getPadding(containerWidth);
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * padding + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $51f1e6c8a600d549$var$selector = (states)=>({
        widthToWidest: states.tableState?.widthToWidest
    });
const $51f1e6c8a600d549$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, disabled: disabled })=>{
    const currentGap = (0, $cozmU.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $cozmU.useRef)(false);
    const areResizeMetaKeysPressed = (0, $cozmU.useRef)(false);
    const resizerRef = (0, $cozmU.useRef)(null);
    const interactionState = (0, $4Qu9h.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const { widthToWidest: widthToWidest } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], $51f1e6c8a600d549$var$selector);
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const currentSelection = editorView.state?.selection;
    const tableFromSelection = (0, $cozmU.useMemo)(()=>{
        return (0, $cycWk.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection?.pos;
    const isTableSelected = (0, $cozmU.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        if (interactionState === 'hasNotHadInteraction') return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $jv11C.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        interactionState,
        getPos
    ]);
    const resizerMinWidth = $51f1e6c8a600d549$var$getResizerMinWidth(node);
    const handleSize = $51f1e6c8a600d549$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $8d0629bb8e812232$export$9642a56c1e8805cc)();
    const excludeGuidelineConfig = (0, $cozmU.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && isFullWidthModeEnabled)
        }), [
        isFullWidthModeEnabled,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $cozmU.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $51f1e6c8a600d549$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $46ad12f11f94bf79$export$be2db36e9da53e09)((0, $46ad12f11f94bf79$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $51f1e6c8a600d549$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $46ad12f11f94bf79$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $78UMD.getGuidelinesWithHighlights)(gap, (0, $deb80ec534adbdde$export$8f6133b6e2b4291), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $cozmU.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $d66ebc188fbae6c9$export$461c50a158de0369)((0, $d66ebc188fbae6c9$export$b2f61428a1609695), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * $51f1e6c8a600d549$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $d66ebc188fbae6c9$export$c5e672719c546336)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $cozmU.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $cac57eed68474c1f$export$8dcb9bda5f25db3a)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $70029e39e0a22c66$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $cac57eed68474c1f$export$3ea9e188ab01c845), (0, $cac57eed68474c1f$export$2cbc54593c64b1f2), tableNodeWithPos, (0, $krYZG.INPUT_METHOD).AUTO, (0, $jzpoq.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi?.analytics?.actions
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        (0, $eFgM7.insm).session?.startFeature('tableResize');
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('resizing')({
            tr: tr
        });
        dispatch(tr);
        const visibleGuidelines = $51f1e6c8a600d549$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $46ad12f11f94bf79$export$be2db36e9da53e09)((0, $46ad12f11f94bf79$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $51f1e6c8a600d549$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $46ad12f11f94bf79$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        isFullWidthModeEnabled,
        lineLength,
        containerWidth,
        excludeGuidelineConfig,
        displayGuideline,
        onResizeStart,
        pluginInjectionApi?.userIntent?.commands
    ]);
    const handleResize = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (originalState, delta)=>{
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch  {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * $51f1e6c8a600d549$var$getPadding(containerWidth) : containerWidth;
        const closestSnap = isFullPageAppearance && (0, $d66ebc188fbae6c9$export$5ea7b9558ea477a)(newWidth, isTableScalingEnabled ? (0, $d66ebc188fbae6c9$export$461c50a158de0369)((0, $d66ebc188fbae6c9$export$b2f61428a1609695), editorContainerWidth, excludeGuidelineConfig) : (0, $d66ebc188fbae6c9$export$c5e672719c546336), isTableScalingEnabled ? (0, $46ad12f11f94bf79$export$be2db36e9da53e09)((0, $46ad12f11f94bf79$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig) : (0, $46ad12f11f94bf79$export$71ea7e0a71c6d202), (0, $deb80ec534adbdde$export$edb1b9caf8ff5b32), (0, $deb80ec534adbdde$export$7af5c65e392a647));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const fullWidthGuideline = (0, $46ad12f11f94bf79$export$be2db36e9da53e09)((0, $46ad12f11f94bf79$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? closestSnap && fullWidthGuideline && closestSnap.keys.includes(fullWidthGuideline.key) : closestSnap && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = $51f1e6c8a600d549$var$getTableMaxWidth(containerWidth, lineLength, isCommentEditor, isChromelessEditor);
        const shouldUpdateWidthToWidest = !isFullPageAppearance ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = !isFullPageAppearance && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $094ae3eb1cbee718$export$2d57109fc9066ba2)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, allowFixedColumnWidthOption, !isFullPageAppearance);
        (0, $iUNgd.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $9b2eea537bbdfc67$export$833849b68219cbcc)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isChromelessEditor,
        isFullPageAppearance,
        isTableScalingEnabled,
        allowFixedColumnWidthOption,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $cozmU.useMemo)(()=>(0, $LQnOI.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((originalState, delta)=>{
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const tableMaxWidth = !isFullPageAppearance ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('default')({
            tr: tr
        });
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $8d0629bb8e812232$export$29574a7e6ffc8eb4)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                attachAnalyticsEvent(payload)?.(tr);
            });
        }
        if (typeof pos === 'number') {
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth,
                layout: node.attrs.layout !== (0, $cac57eed68474c1f$export$2cbc54593c64b1f2) && node.attrs.layout !== (0, $cac57eed68474c1f$export$3ea9e188ab01c845) ? (0, $cac57eed68474c1f$export$3ea9e188ab01c845) : node.attrs.layout
            });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $094ae3eb1cbee718$export$edcf1a404e75ce35)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment and chromeless editors, because
                // newWidth can be undefined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                parentWidth: !isFullPageAppearance ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, !isFullPageAppearance)(tr);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const scaledNode = tr.doc.nodeAt(pos);
            attachAnalyticsEvent((0, $8d0629bb8e812232$export$a12b1eaff522a2d1)({
                originalNode: node,
                resizedNode: scaledNode
            }))?.(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $fKJ7J.messages).tableSizeDecreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        else if (delta.width > 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $fKJ7J.messages).tableSizeIncreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        (0, $eFgM7.insm).session?.endFeature('tableResize');
        return newWidth;
    }, [
        editorView,
        getPos,
        node,
        widthToWidest,
        endMeasure,
        displayGapCursor,
        displayGuideline,
        updateWidth,
        scheduleResize,
        onResizeStop,
        pluginInjectionApi,
        attachAnalyticsEvent,
        tableRef,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        formatMessage,
        isFullPageAppearance
    ]);
    const handleTableSizeChangeOnKeypress = (0, $cozmU.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        resizerMinWidth
    ]);
    const handleEscape = (0, $cozmU.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const browser = (0, $8dxef.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $51f1e6c8a600d549$var$RESIZE_STEP_VALUE : -$51f1e6c8a600d549$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $cozmU.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const browser = (0, $8dxef.getBrowserInfo)();
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView?.dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keydown', handleKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keyup', handleKeyUp);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keydown', handleKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $cac57eed68474c1f$export$2e10df95acfe6933)(node.attrs.layout) === (0, $cac57eed68474c1f$export$3ea9e188ab01c845) ? 2 : 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aWssQ.default), {
        ref: resizerRef,
        enable: disabled ? {} : $51f1e6c8a600d549$var$handles,
        width: width,
        handleAlignmentMethod: "sticky",
        handleSize: handleSize,
        handleStyles: $51f1e6c8a600d549$var$handleStyles,
        handleResizeStart: handleResizeStart,
        handleResize: scheduleResize,
        handleResizeStop: handleResizeStop,
        resizeRatio: resizeRatio,
        minWidth: resizerMinWidth,
        maxWidth: maxWidth,
        snapGap: (0, $deb80ec534adbdde$export$8f6133b6e2b4291),
        snap: guidelineSnaps,
        handlePositioning: "adjacent",
        isHandleVisible: isTableSelected,
        needExtendedResizeZone: true,
        appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
        handleHighlight: "shadow",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        handleTooltipContent: ({ update: update })=>{
            updateTooltip.current = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                description: formatMessage((0, $fKJ7J.messages).resizeTable),
                keymap: (0, $ldqjS.focusTableResizer)
            });
        },
        "data-vc-nvs": "true"
    }, children));
};


const $35fcf350376de7bb$var$InnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, style: style, node: node, children: children }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-testid": "table-container"
    }, children);
});
const $35fcf350376de7bb$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $cac57eed68474c1f$export$2cbc54593c64b1f2) ? (0, $cac57eed68474c1f$export$3ea9e188ab01c845) : (0, $cac57eed68474c1f$export$2cbc54593c64b1f2);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], (states)=>({
            isFullWidthModeEnabled: states.tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: states.tableState?.wasFullWidthModeEnabled
        }));
    (0, $cozmU.useEffect)(()=>{
        if (editorView && getPos) {
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $cac57eed68474c1f$export$3ea9e188ab01c845) && node.attrs.width > (0, $7Y8M5.akEditorDefaultLayoutWidth)) {
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $70029e39e0a22c66$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $cac57eed68474c1f$export$3ea9e188ab01c845), alignment, {
                    pos: pos,
                    node: node
                }, (0, $krYZG.INPUT_METHOD).AUTO, (0, $jzpoq.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        isFullWidthModeEnabled,
        wasFullWidthModeEnabled,
        node
    ]);
    const style = (0, $cozmU.useMemo)(()=>{
        return (0, $fd8f31229a524c35$export$b4e2cb644a5e9e7e)(alignment);
    }, [
        alignment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
};
const $35fcf350376de7bb$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35fcf350376de7bb$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView
    }, children);
};
const $35fcf350376de7bb$var$selector = (states)=>({
        tableState: states.tableState,
        editorViewModeState: states.editorViewModeState
    });
const $35fcf350376de7bb$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
};
const $35fcf350376de7bb$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const tableWidthRef = (0, $cozmU.useRef)((0, $7Y8M5.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $cozmU.useState)(false);
    const { tableState: tableState, editorViewModeState: editorViewModeState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table',
        'editorViewMode'
    ], $35fcf350376de7bb$var$selector);
    const isFullWidthModeEnabled = tableState?.isFullWidthModeEnabled;
    const isMaxWidthModeEnabled = tableState?.isMaxWidthModeEnabled;
    const mode = editorViewModeState?.mode;
    // If the editor is in max width mode and the table has no width, use the max width value rather than the default table value
    const tableWidth = isMaxWidthModeEnabled && !node.attrs.width && (0, $ixfCV.fg)('platform_editor_max_width_default_width') ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $9ppjA.getTableContainerWidth)(node);
    const updateContainerHeight = (0, $cozmU.useCallback)((height)=>{
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = containerRef.current?.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            const stickyHeaderHeight = containerRef.current?.getElementsByTagName('th')[0].getBoundingClientRect().height || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $cozmU.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $cozmU.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $cozmU.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $cozmU.useCallback)((guidelines)=>{
        return pluginInjectionApi?.guideline?.actions?.displayGuideline(editorView)({
            guidelines: guidelines
        }) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        return pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $cozmU.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const { width: width, maxResizerWidth: maxResizerWidth } = (0, $cozmU.useMemo)(()=>{
        let responsiveContainerWidth = 0;
        const padding = $35fcf350376de7bb$var$getPadding(containerWidth);
        // When Full width or Max width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
        // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
        // issues when viwport width is less than full/max width Editor's width. To detect avoid them
        // we need to use lineLength to defined responsiveWidth instead of containerWidth
        // (which does not get updated when Mac setting changes) in Full-width/Max-width editor.
        if (isFullWidthModeEnabled || isMaxWidthModeEnabled && (0, $ixfCV.fg)('platform_editor_max_width_default_width')) {
            // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
            // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
            // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
            // lineLength is undefined on first paint → width: NaN → wrapper expands to page
            // width. rAF col-sizing then runs before the number-column padding and
            // the final shrink, so column widths are locked in wrong.
            // If the value isn't finite we fall back to gutterWidth for that first frame.
            if (isTableScalingEnabled && Number.isFinite(lineLength) && lineLength !== undefined) responsiveContainerWidth = lineLength;
            else responsiveContainerWidth = containerWidth - padding * 2 - (0, $26c6284b781fc82b$export$a823f6a7493b3d06);
        } else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $26c6284b781fc82b$export$c332ba2dd5aa2199);
        else if (isChromelessEditor) // there's no padding included in chromeless appearance, so we need to reduce table
        // width to ensure all controls are visible.
        // use lineLength as the value is updated by scrollbar visibility changes
        responsiveContainerWidth = Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : containerWidth - (0, $26c6284b781fc82b$export$a823f6a7493b3d06);
        else // 76 is currently an accepted padding value considering the spacing for resizer handle
        // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
        // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
        // padding left = padding right = akEditorGutterPadding = 32
        responsiveContainerWidth = isTableScalingEnabled ? containerWidth - padding * 2 : containerWidth - padding * 2 - (0, $26c6284b781fc82b$export$a823f6a7493b3d06);
        // Fix for HOT-119925: Ensure table width is properly constrained and responsive
        // For wide tables, ensure they don't exceed container width and can be scrolled
        const calculatedWidth = !node.attrs.width && !isFullPageAppearance ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
        // Ensure minimum width for usability while respecting container constraints
        const width = Math.max(calculatedWidth, Math.min(responsiveContainerWidth * 0.5, 300));
        const maxResizerWidth = !isFullPageAppearance ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $26c6284b781fc82b$export$8a91b25da594a758) : (0, $26c6284b781fc82b$export$bffd6819c009a916));
        return {
            width: width,
            maxResizerWidth: maxResizerWidth
        };
    }, [
        containerWidth,
        isCommentEditor,
        isChromelessEditor,
        isFullWidthModeEnabled,
        isMaxWidthModeEnabled,
        isFullPageAppearance,
        isTableScalingEnabled,
        lineLength,
        node.attrs.width,
        tableWidth
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isResizing) tableWidthRef.current = width;
    }, [
        width,
        isResizing
    ]);
    // CSS Solution for table resizer container width
    const tableResizerContainerWidth = (0, $cozmU.useMemo)(()=>{
        return (0, $a2b54432792761eb$export$30421da09613cb3d)(node, isTableScalingEnabled);
    }, [
        node,
        isTableScalingEnabled
    ]);
    // CSS Solution for table resizer max width
    const tableResizerMaxWidth = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
        const nonResizingMaxWidth = isFullPageAppearance ? (0, $a2b54432792761eb$export$817f7cd897b65634)(isCommentEditor, isChromelessEditor, isTableScalingEnabled) : maxResizerWidth;
        // isResizing is needed, otherwise we can't resize table.
        // when not resizing, maxWidth is calculated based on the container width via CSS
        return !isResizing ? nonResizingMaxWidth : maxResizerWidth;
    }, [
        isCommentEditor,
        isChromelessEditor,
        isTableScalingEnabled,
        isResizing,
        maxResizerWidth
    ]);
    // TODO: EDITOR-1679 - Add support for lineLength being undefined at runtime.
    const tableResizerProps = {
        width: // The `width` is used for .resizer-item in <TableResizer>, and it has to be a number
        // So we can't use min(var(--ak-editor-table-width), ${tableWidth}px) here
        // We still have to use JS to calculate width
        width,
        maxWidth: tableResizerMaxWidth,
        containerWidth: containerWidth,
        // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- To be fixed in EDITOR-1679
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor
    };
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35fcf350376de7bb$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--ak-editor-table-gutter-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2)',
            '--ak-editor-table-width': isFullPageAppearance ? tableResizerContainerWidth : `${tableWidthRef.current}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            width: 'var(--ak-editor-table-width)',
            height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
            position: isLivePageViewMode ? 'relative' : 'unset'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RESIZER_CONTAINER,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51f1e6c8a600d549$export$65233f8d64070eeb), {
        ...tableResizerProps,
        disabled: isLivePageViewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35fcf350376de7bb$var$InnerContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node
    }, children))));
});
const $35fcf350376de7bb$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35fcf350376de7bb$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerWidth: editorWidth,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor
    }, children);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const resizableTableWidth = isFullPageAppearance ? (0, $a2b54432792761eb$export$30421da09613cb3d)(node, isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($35fcf350376de7bb$var$InnerContainer, {
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(className, {
            'less-padding': editorWidth < (0, $7Y8M5.akEditorMobileBreakoutPoint) && !isNested && !isChromelessEditor
        }),
        style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--ak-editor-table-width': resizableTableWidth
        }
    }, children);
};



var $1jz5K = parcelRequire("1jz5K");





class $d6272af98b04baff$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.editorScrollableElement = // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $1jz5K.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (entry.rootBounds?.height === 0) return;
                if (target.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        // Multiple bottom sentinels may be found if there are nested tables. We need to make sure we get the last one which will belong to the parent table.
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = bottomSentinels?.item(bottomSentinels.length - 1);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>{
            if (el !== null && this.intersectionObserver) this.intersectionObserver.observe(el);
        });
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0) || // When editorScrollableElement is the root document or inside modal,
        // so the boundingClientRect.top will never be less than the rootBounds.top,
        // so we need to check if the boundingClientRect.top is less than 20% of the rootBounds.height
        // to determine if the bottom sentinel is above the scroll area
        entry.boundingClientRect.top < (entry.rootBounds?.height || 0) * 0.2;
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
    constructor(wrapper, view){
        this.wrapper = void 0;
        this.view = void 0;
        this.editorScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.view = view;
        if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', true)) requestAnimationFrame(()=>{
            this.init();
        });
        else this.init();
    }
}


// Prevent unnecessary parentWidth updates when table is nested inside of a node that is nested itself.
const $c0dbf892e73ac158$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD = 2;
const $c0dbf892e73ac158$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD = 20;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c0dbf892e73ac158$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        const { observe: observe } = (0, $fvMxa.nodeVisibilityManager)(this.props.view.dom);
        if (this.table) {
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.table,
                onFirstVisible: ()=>{
                    this.initialiseEventListenersAfterMount();
                    // force width calculation - missed resize event under firefox when
                    // table is nested within bodied extension
                    if (this.wrapper) this.wrapperWidth = this.wrapper?.clientWidth;
                }
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeNewDebounced);
        }
        this.dispatchTableRefUpdate();
    }
    initialiseEventListenersAfterMount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode } = this.props;
        const browser = (0, $8dxef.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseover', this.handleMouseOver);
        if (this.wrapper) {
            this.wrapperReisizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries)this.wrapperWidth = entry.contentRect?.width;
            });
            this.wrapperReisizeObserver.observe(this.wrapper);
        }
        if (allowColumnResizing && this.wrapper && !isIE11) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if (this.table && !this.isNestedInTable) this.stickyScrollbar = new (0, $d6272af98b04baff$export$8c072780619cfc83)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $aDtKq.combine)(...(0, $9e4bbf318fa6c019$export$aed4bc7b473fc217)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.on((0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1).key, this.onStickyState);
    }
    componentWillUnmount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, view: view, isInDanger: isInDanger, isDragAndDropEnabled: isDragAndDropEnabled } = this.props;
        const browser = (0, $8dxef.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        if (this.wrapper && !isIE11) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        if (this.nodeVisibilityObserverCleanupFn) this.nodeVisibilityObserverCleanupFn();
        this.resizeObserver?.disconnect();
        this.wrapperReisizeObserver?.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!allowTableResizing) this.handleWindowResizeDebounced.cancel();
        this.handleWindowResizeNewDebounced.cancel();
        if (isInDanger) (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(view.state, view.dispatch);
        if (!allowTableResizing && allowColumnResizing) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeDebounced);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeNewDebounced);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseover', this.handleMouseOver);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.off((0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, getEditorFeatureFlags: getEditorFeatureFlags, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $9ppjA.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options?.isCommentEditor ? containerWidth.width - ((0, $26c6284b781fc82b$export$c332ba2dd5aa2199) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $26c6284b781fc82b$export$7c8bcfa1d3f9af23);
        tableNodeWidth = options?.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $8e70e8c6596c6b3f$export$bc84d95d2dfa63bf)(tableNode, this.node);
        const { width: containerWidthValue, lineLength: containerLineLength } = containerWidth;
        const isLineLengthChanged = this.containerWidth?.lineLength !== containerLineLength;
        const isFullWidthModeAndLineLengthChanged = this.updateColGroupFromFullWidthChange && isLineLengthChanged;
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !options?.isCommentEditor || isNumberColumnChanged || isNumberOfColumnsChanged || this.state.windowResized;
        if (force || maybeScale || isFullWidthModeAndLineLengthChanged) {
            const isWidthChanged = this.containerWidth?.width !== containerWidthValue;
            const wasTableResized = (0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(this.node);
            const isTableResized = (0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = this.shouldUpdateColgroup({
                isWindowResized: this.state.windowResized,
                isWidthChanged: isWidthChanged,
                isTableWidthChanged: isTableWidthChanged,
                isColumnsDistributed: isColumnsDistributed,
                isTableResizedFullWidth: isTableResizedFullWidth,
                isTableDisplayModeChanged: isTableDisplayModeChanged,
                isNumberColumnChanged: isNumberColumnChanged,
                isNumberOfColumnsChanged: isNumberOfColumnsChanged,
                isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged,
                isTableResized: isTableResized
            });
            const tableWithFixedColumnWidthsOption = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? this.props?.allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!this.props.options?.isTableScalingEnabled && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!this.props.options?.isTableScalingEnabled && !!this.props.options?.isCommentEditor;
            if (force || !isResizing && shouldUpdateColgroup) {
                const resizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
                    minWidth: (0, $26c6284b781fc82b$export$dd66abdcfb4bb2cf),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!this.props.options?.isCommentEditor
                });
                let shouldScaleOnColgroupUpdate = false;
                if (this.props.options?.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if (this.props.options?.isTableScalingEnabled && this.props.options?.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!this.props.options?.isCommentEditor || this.props.options?.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $a2b54432792761eb$export$b2c142721a99201b)(tableNode, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, shouldUseIncreasedScalingPercent);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    scalePercent = (0, $a2b54432792761eb$export$4e884677f8e54bba)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $da3a78eceffe80bd$export$23e0010f5fd8981)(resizeState, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        if (isFullWidthModeAndLineLengthChanged) this.updateColGroupFromFullWidthChange = false;
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    componentDidUpdate(_, prevState) {
        const { getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, getEditorFeatureFlags: getEditorFeatureFlags, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const tableWithFixedColumnWidthsOption = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!this.props.options?.isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if (this.props.options?.isCommentEditor && allowTableResizing && !options?.isTableScalingEnabled) this.removeInlineTableWidth();
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $8e70e8c6596c6b3f$export$bc84d95d2dfa63bf)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $8e70e8c6596c6b3f$export$8fe872ff9fc9b477)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) this.props.pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify((0, $d3dc0fe24d69f2ab$export$cea95ea93d5f9224)(previousTable, currentTable, this.props.intl), {
            priority: 'important'
        });
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $8e70e8c6596c6b3f$export$8f2a10e9b102ac33)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !allowTableResizing || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $cec18a6f3d8c1f93$export$ae5d9647f2a0891c)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                    // Deferred from setDomAttrs — remove only once colgroup is updated and table has left content mode.
                    if (this.table?.hasAttribute('data-initial-width-mode') && !(0, $cdX2q.isTableInContentMode)({
                        tableNode: currentTable,
                        isSupported: (0, $f683956911721579$export$e217d2a535d6ae45)({
                            allowColumnResizing: !!allowColumnResizing,
                            allowTableResizing: !!allowTableResizing,
                            isFullPageEditor: !this.props.options?.isCommentEditor && !this.props.options?.isChromelessEditor
                        }),
                        isTableNested: (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(view.state, getPos())
                    })) this.table.removeAttribute('data-initial-width-mode');
                }
                (0, $629d677dec0f3c2a$export$13c259c17cfd51f5)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
        this.dispatchTableRefUpdate();
    }
    dispatchTableRefUpdate() {
        if (this.table && this.table !== this.lastSetTableRef && (!(0, $ieeJu.expValEquals)('platform_editor_table_ref_optimisation', 'isEnabled', true) || this.props.tableActive) && this.props.view) {
            this.lastSetTableRef = this.table;
            (0, $9b2eea537bbdfc67$export$79b661cbf50c3490)(this.table)(this.props.view.state, this.props.view.dispatch);
        }
    }
    observeTable(table) {
        if (table) this.resizeObserver?.observe(table);
    }
    render() {
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, allowTableResizing: // here we can use options.isTableScalingEnabled
        allowTableResizing, allowTableAlignment: allowTableAlignment, selection: selection, isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const node = getNode();
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $8e70e8c6596c6b3f$export$86a810659e2d575)(node);
        const rowControls = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fc4d25daa4b2ed4$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        });
        const tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb4f8d58cffbb2d9$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            getScrollOffset: ()=>this.wrapper?.scrollLeft || 0,
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        }) : null;
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(view.state, tablePos);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!this.props.options?.isCommentEditor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35fcf350376de7bb$export$f2c3aea42b2a048f), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, {
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY]: !this.props.limitedMode && this.state.stickyHeader && hasHeaderRow,
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED]: (0, $8imfU.isTableSelected)(selection ?? view.state.selection),
                [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS]: tableActive && allowControls && this.isNestedInTable
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: allowTableResizing,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            allowFixedColumnWidthOption: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: allowTableAlignment,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options?.isCommentEditor,
            isChromelessEditor: options?.isChromelessEditor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP,
            "data-testid": "sticky-sentinel-top"
        }), !this.isNestedInTable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), allowControls && rowControls, isDragAndDropEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf73522296cb0654$export$1041cb8214100cd2), {
            editorView: view,
            node: node,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            getScrollOffset: ()=>{
                return this.wrapper?.scrollLeft || 0;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            getTableWrapperWidth: ()=>{
                return this.wrapper?.clientWidth || 760;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9sVl.NodeViewContentHole), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- existing table wrapper class required for legacy styling hooks
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER),
            ref: this.setWrapperRef
        }, (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            contentEditable: false,
            "aria-hidden": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK,
            "data-corner": "left"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            contentEditable: false,
            "aria-hidden": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK,
            "data-corner": "right"
        })), allowControls && colControls), !this.isNestedInTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER,
            "data-vc-nvs": "true",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none',
                // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: tableRef?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            },
            "data-vc-nvs": "true"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: tableRef?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            },
            "data-vc-nvs": "true"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM,
            "data-testid": "sticky-sentinel-bottom"
        }), !this.isNestedInTable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            contentEditable: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_BORDER,
            "data-with-numbered-table": node.attrs.isNumberColumnEnabled,
            "data-testid": "table-left-border"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            contentEditable: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_BORDER,
            "data-testid": "table-right-border"
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            parentWidth: undefined,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined,
            windowResized: false
        };
        this.wrapper = void 0;
        this.table = void 0;
        this.node = void 0;
        this.containerWidth = void 0;
        this.wasResizing = void 0;
        this.tableNodeWidth = void 0;
        this.layoutSize = void 0;
        this.stickyScrollbar = void 0;
        this.isNestedInTable = void 0;
        this.initialOverflowCaptureTimerId = void 0;
        this.resizeObserver = void 0;
        this.wrapperWidth = void 0;
        this.wrapperReisizeObserver = void 0;
        this.updateColGroupFromFullWidthChange = void 0;
        this.dragAndDropCleanupFn = void 0;
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.handleMouseOut = (event)=>{
            if (!(0, $c6627e327b6f56a8$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $c6627e327b6f56a8$export$72517da01e0ce829)(this.props.view, event);
        };
        this.handleMouseOver = (event)=>{
            if (!(0, $c6627e327b6f56a8$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $c6627e327b6f56a8$export$87e6a6bf8341824f)((0, $c6627e327b6f56a8$export$321c2da35903b013))(this.props.view, event);
        };
        this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        };
        this.lastSetTableRef = null;
        this.setWrapperRef = (elem)=>{
            this.wrapper = elem;
            if (!elem) return;
            this.props.contentDOM(elem);
            const tableElement = elem.querySelector('table');
            if (tableElement !== this.table) {
                this.table = tableElement;
                this.observeTable(this.table);
            }
        };
        this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $e11am.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $04640e18ab019d4a$export$91d61a242b14c7fb)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) this.setState({
                stickyHeader: stickyHeader
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.prevTableState = null;
        this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
                if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $629d677dec0f3c2a$export$324b8139ca20d6a6)(this.table);
            }
            // force update to for table controls to re-align
            this.forceUpdate();
        };
        this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options, allowTableResizing: allowTableResizing } = this.props;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const tablePos = this.props.getPos();
            const isNested = (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(this.props.view.state, tablePos);
            let parentWidth = this.getParentNodeWidth();
            const useMeasuredWidthForBodiedSyncBlock = isNested && typeof tablePos === 'number' && (0, $8e70e8c6596c6b3f$export$ffa7c963c6f2f204)(this.props.view.state, tablePos);
            if (useMeasuredWidthForBodiedSyncBlock) {
                // Prefer the live DOM measurement (`clientWidth`) over the ResizeObserver-cached
                // value (`wrapperWidth`) because clientWidth is synchronous and more up-to-date
                // at the time this handler runs. Fall back to `wrapperWidth` if the wrapper ref
                // is not yet available.
                // The clientWidth > 0 since DOM clientWidth is 0 before layout
                // The > 1 guard for wrapperWidth was intentional to filter out the degenerate value of 1 that ResizeObserver reports during element unmounting.
                let measuredWrapperWidth;
                if (this.wrapper && this.wrapper.clientWidth > 0) measuredWrapperWidth = this.wrapper.clientWidth;
                else if (this.wrapperWidth && this.wrapperWidth > 1) measuredWrapperWidth = this.wrapperWidth;
                if (measuredWrapperWidth !== undefined) // Override the default parentWidth so that scaleTable uses the real
                // available width inside the sync-block rather than the full editor width.
                parentWidth = measuredWrapperWidth;
            }
            if (!useMeasuredWidthForBodiedSyncBlock && isNested && (0, $8e70e8c6596c6b3f$export$e31912a493829c23)(this.props.view.state, tablePos)) {
                const resizeObsWrapperWidth = this.wrapperWidth || 0;
                const wrapperWidthDiffBetweenRerenders = Math.abs(resizeObsWrapperWidth - (this.state.parentWidth || 0));
                const isOusideOfThreshold = wrapperWidthDiffBetweenRerenders <= $c0dbf892e73ac158$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD || wrapperWidthDiffBetweenRerenders > $c0dbf892e73ac158$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD;
                // 1. Check isOusideOfThreshold is added to prevent undersired state update.
                // When table is nested in the extenstion and the table column is being resized,
                // space available within extension can change and cause undesirable state update.
                // MIN_THRESNESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLDHOLD value is required
                // as the resizeObsWrapperWidth can differ between page reloads by 2px.
                // 2. Check resizeObsWrapperWidth > 1 is added to prevent parentWidth update when table unmounts.
                // When a is nested table in a nested expand and the expand collabses, the table unmounts and
                // resizeObsWrapperWidth becomes 1.
                parentWidth = isOusideOfThreshold && resizeObsWrapperWidth > 1 ? resizeObsWrapperWidth : this.state.parentWidth;
            }
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $8e70e8c6596c6b3f$export$bc84d95d2dfa63bf)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!allowTableResizing || allowTableResizing && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (allowTableResizing && hasNumberedColumnChanged) {
                    if (!(0, $cec18a6f3d8c1f93$export$8c07f44cea64e3c7)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        };
        // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $e11am.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $094ae3eb1cbee718$export$edcf1a404e75ce35)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) {
                (0, $jbOus.tintDirtyTransaction)(tr);
                // Avoid adding this transaction separately to the history as these are automatic updates
                // as a consequence of another action
                tr.setMeta('addToHistory', false);
            }
            dispatch(tr);
        };
        this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $e11am.isValidPosition)(pos, view.state)) return;
                (0, $9b2eea537bbdfc67$export$d6e5d8afaa172954)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        };
        this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        };
        // This is a new handler for window resize events that sets the windowResized state immediately
        // This is needed to update colgroup on window resize, to enforce the table scaling
        this.handleWindowResizeNew = ()=>{
            // Set resizing to true immediately
            if (!this.state.windowResized) this.setState({
                windowResized: true
            });
        };
        this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $e11am.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $9ppjA.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        };
        this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        };
        this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $a2b54432792761eb$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {});
        this.shouldUpdateColgroup = (params)=>{
            const { isWindowResized: isWindowResized, isWidthChanged: isWidthChanged, isTableWidthChanged: isTableWidthChanged, isColumnsDistributed: isColumnsDistributed, isTableResizedFullWidth: isTableResizedFullWidth, isTableDisplayModeChanged: isTableDisplayModeChanged, isNumberColumnChanged: isNumberColumnChanged, isNumberOfColumnsChanged: isNumberOfColumnsChanged, isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged } = params;
            const isFullPageEditor = !this.props.options?.isCommentEditor && !this.props.options?.isChromelessEditor;
            if (isFullPageEditor) return !!isWindowResized || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
            return isWidthChanged || isTableWidthChanged || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
        };
        this.scaleTableDebounced = (0, $LQnOI.default)(this.scaleTable);
        this.handleTableResizingDebounced = (0, $LQnOI.default)(this.handleTableResizing);
        this.handleScrollDebounced = (0, $LQnOI.default)(this.handleScroll);
        this.handleAutoSizeDebounced = (0, $LQnOI.default)(this.handleAutoSize);
        this.handleWindowResizeDebounced = (0, $LQnOI.default)(this.handleWindowResize);
        this.handleWindowResizeNewDebounced = (0, $LQnOI.default)(this.handleWindowResizeNew);
        const { options: _options, containerWidth: _containerWidth, getNode: _getNode } = props;
        this.node = _getNode();
        this.containerWidth = _containerWidth;
        const _tablePos = props.getPos();
        this.isNestedInTable = _tablePos ? (0, $euISL.getParentOfTypeCount)(props.view.state.schema.nodes.table)(props.view.state.doc.resolve(_tablePos)) > 0 : false;
        if (!this.updateColGroupFromFullWidthChange) this.updateColGroupFromFullWidthChange = _options?.isFullWidthModeEnabled && !_options?.wasFullWidthModeEnabled;
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = _options ? _options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, _containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)this.setState((prev)=>{
                return prev?.tableWrapperWidth === entry.contentRect?.width && prev?.tableWrapperHeight === entry.contentRect?.height ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$c0dbf892e73ac158$var$TableComponent.displayName = 'TableComponent';
const $c0dbf892e73ac158$var$_default_1 = (0, $kSwu1.injectIntl)($c0dbf892e73ac158$var$TableComponent);
var $c0dbf892e73ac158$export$2e2bcd8739ae039 = $c0dbf892e73ac158$var$_default_1;


const $ee8e446e73059e6b$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    const { isTableResizing: isTableResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isResizing: isResizing, isInDanger: isInDanger, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger, interaction: interaction, isFullscreen: isFullscreen, lineLength: lineLength, mode: mode, selection: selection, width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'table',
        'width',
        'media',
        'selection',
        'editorViewMode',
        'interaction'
    ], (states)=>({
            // tableState
            isTableResizing: states.tableState?.isTableResizing,
            isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
            isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
            ordering: states.tableState?.ordering,
            isResizing: states.tableState?.isResizing,
            isInDanger: states.tableState?.isInDanger,
            hoveredCell: states.tableState?.hoveredCell,
            hoveredRows: states.tableState?.hoveredRows,
            isTableHovered: states.tableState?.isTableHovered,
            isWholeTableInDanger: states.tableState?.isWholeTableInDanger,
            // Required so that table control re-renders
            targetCellPosition: states.tableState?.targetCellPosition,
            // mediaState
            isFullscreen: states.mediaState?.isFullscreen,
            // selectionState
            selection: states.selectionState?.selection,
            // editorViewModeState
            mode: states.editorViewModeState?.mode,
            // widthState
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength,
            // interactionState
            interaction: states.interactionState?.interactionState
        }));
    const isLivePageViewMode = mode === 'view';
    /**
   *  ED-19810
   *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
   *  directly to confluence since this bug is now in production.
   */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        currentTablePos = undefined;
    }
    const selectedTable = (0, $cycWk.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0dbf892e73ac158$export$2e2bcd8739ae039), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: isFullscreen,
        options: options,
        allowControls: allowControls,
        isDragAndDropEnabled: !isLivePageViewMode,
        isHeaderRowEnabled: isHeaderRowEnabled ?? false,
        isHeaderColumnEnabled: isHeaderColumnEnabled ?? false,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        allowTableAlignment: allowTableAlignment,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        tableActive: tableActive && !isLivePageViewMode && interaction !== 'hasNotHadInteraction',
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        containerWidth: {
            width: width ?? 0,
            lineLength: lineLength
        },
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        selection: selection
    });
};













function $ffcb9098e9e07a15$export$6fd84272d0edd48f({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
        value: intl
    }, children);
}



const $17d71a987b23526f$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $17d71a987b23526f$var$getInlineWidth = (node, options, state, pos, allowTableResizing)=>{
    if (!node.attrs.width && options?.isChromelessEditor || !node.attrs.width && options?.isCommentEditor && allowTableResizing) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = allowTableResizing && !(0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(state, pos);
    let widthValue = (0, $9ppjA.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $7Y8M5.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $17d71a987b23526f$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
class $17d71a987b23526f$export$2e2bcd8739ae039 extends (0, $Igylv.default) {
    getContentDOM() {
        const isNested = (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(this.view.state, this.getPos());
        const tableDOMStructure = (0, $65506e9a5bee1a79$export$477bb32cbededd65)({
            allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
            tableResizingEnabled: !!this.reactComponentProps.allowTableResizing,
            getEditorContainerWidth: this.reactComponentProps.getEditorContainerWidth,
            isTableScalingEnabled: this.reactComponentProps.options?.isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: this.reactComponentProps.options?.shouldUseIncreasedScalingPercent,
            isCommentEditor: this.reactComponentProps.options?.isCommentEditor,
            isChromelessEditor: this.reactComponentProps.options?.isChromelessEditor,
            isNested: isNested
        }).toDOM(this.node);
        const rendered = (0, $aPdNQ.DOMSerializer).renderSpec(document, tableDOMStructure);
        if (rendered.dom) {
            const tableElement = rendered.dom.querySelector('table');
            this.table = tableElement ? tableElement : rendered.dom;
            this.renderedDOM = rendered.dom;
            const allowFixedColumnWidthOption = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && allowFixedColumnWidthOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $17d71a987b23526f$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos(), this.reactComponentProps.allowTableResizing);
                if (tableInlineWidth) $17d71a987b23526f$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    /**
   * Handles moving the table from ProseMirror's DOM structure into a React-rendered table node.
   * Temporarily disables mutation observers (except for selection changes) during the move,
   * preserves selection state, and restores it afterwards if mutations occurred and cursor
   * wasn't at start of node. This prevents duplicate tables and maintains editor state during
   * the DOM manipulation.
   */ _handleTableRef(node) {
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // Only proceed if we have both a node and table, and the table isn't already inside the node
        if (node && this.table && !node.contains(this.table)) {
            // Store the current ignoreMutation handler so we can restore it later
            oldIgnoreMutation = this.ignoreMutation;
            // Set up a temporary mutation handler that:
            // - Ignores all DOM mutations except selection changes
            // - Tracks when mutations have been ignored via mutationsIgnored flag
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // Store the current selection state if there is a visible selection
            // This lets us restore it after DOM changes
            const { selection: selection } = this.view.state;
            const tablePos = this.getPos();
            if (selection.empty && tablePos && (0, $kCECX.TextSelection).near(this.view.state.doc.resolve(tablePos)).from === selection.from) selectionBookmark = this.view.state.selection.getBookmark();
            if (this.dom) {
                this.dom.setAttribute('data-ssr-placeholder', `table-nodeview-${this.node.attrs.localId}`);
                this.dom.setAttribute('data-ssr-placeholder-replace', `table-nodeview-${this.node.attrs.localId}`);
            }
            // Remove the ProseMirror table DOM structure to avoid duplication, as it's replaced with the React table node.
            // In SSR streaming the portal renders via `container.innerHTML = html` (portal/common.tsx), which detaches
            // `renderedDOM` from `dom` before this runs; require it to still be a child so `removeChild` doesn't throw
            // `NotFoundError` (which would make EditorSSRRenderer fall back to the position-blind schema toDOM and lose
            // nested detection). CSR keeps the original condition unchanged.
            if (this.dom && this.renderedDOM && (!(0, $iAEsk.isSSRStreaming)() || this.renderedDOM.parentNode === this.dom)) this.dom.removeChild(this.renderedDOM);
            // Move the table from the ProseMirror table structure into the React rendered table node.
            node.appendChild(this.table);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    /**
           * This handles a very specific case only -> insertion by the user of a new
           * table
           * Since it's behind a RAF it's possible the user has clicked elsewhere or
           * it affects collaborative users (which selection changes shouldn't ever)
           *
           * This ensures that the selectionBookmark *before* is inside the first
           * position in the table and that after it is the text position directly
           * before the table
           * Ideally we want to remove this RAF entirely but that would require removing
           * the DOM manipulation and is a more complex effort
           */ if (!resolvedSelection.eq(this.view.state.selection) && resolvedSelection.empty && // Ensure that the *next* valid text position matches the first position
                    // in the table
                    (0, $kCECX.TextSelection).findFrom(this.view.state.doc.resolve(this.view.state.selection.from + 1), 1, true)?.eq(resolvedSelection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    setDomAttrs(node) {
        if (!this.table) return; // width / attribute application to actual table will happen later when table is set
        const attrs = $17d71a987b23526f$var$tableAttributes(node);
        // render table with content-mode attribute which removes all width constraints from the table
        // fire exposure here
        if ((0, $cdX2q.isTableInContentMode)({
            tableNode: node,
            isSupported: (0, $f683956911721579$export$e217d2a535d6ae45)({
                allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
                allowTableResizing: !!this.reactComponentProps.allowTableResizing,
                isFullPageEditor: !this.reactComponentProps.options?.isCommentEditor && !this.reactComponentProps.options?.isChromelessEditor
            }),
            isTableNested: (0, $8e70e8c6596c6b3f$export$d4302a800316ebd6)(this.view.state, this.getPos())
        }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) attrs['data-initial-width-mode'] = 'content';
        Object.keys(attrs).forEach((attr)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.table.setAttribute(attr, attrs[attr]);
        });
        const isTableFixedColumnWidthsOptionEnabled = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
        // Preserve Table Width cannot have inline width set on the table
        if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && node.attrs.displayMode === 'fixed') {
            // handle inline style when table been resized
            const tableInlineWidth = $17d71a987b23526f$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos(), this.reactComponentProps.allowTableResizing);
            const isTableResizing = (0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1).getState(this.view.state)?.resizing;
            if (!isTableResizing && tableInlineWidth) $17d71a987b23526f$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    update(node, decorations, innerDecorations, validUpdate) {
        const didUpdate = super.update(node, decorations, innerDecorations, validUpdate);
        // Keep the rounded-corner edge attrs in sync with structural changes (rows/columns
        // added, removed, merged, or reordered via drag-and-drop) that the cells themselves
        // can miss.
        if (didUpdate && (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.roundedTableEdges?.handleUpdate(node);
        return didUpdate;
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffcb9098e9e07a15$export$6fd84272d0edd48f), {
            intl: this.intl
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee8e446e73059e6b$export$b6d58ec6836e4dcf), {
            forwardRef: forwardRef,
            getNode: this.getNode,
            view: props.view,
            options: props.options,
            eventDispatcher: props.eventDispatcher,
            api: props.pluginInjectionApi,
            allowColumnResizing: props.allowColumnResizing,
            allowTableAlignment: props.allowTableAlignment,
            allowTableResizing: props.allowTableResizing,
            allowControls: props.allowControls,
            getPos: props.getPos,
            getEditorFeatureFlags: props.getEditorFeatureFlags,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption
        }));
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(this.view.state);
        const hoveredRowsChanged = !!hoveredRows?.length !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!hoveredRows?.length;
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        if ((0, $8e70e8c6596c6b3f$export$8f2a10e9b102ac33)(node, nextNode)) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $8Z43Z.TableMap).get(node);
        const nextTableMap = (0, $8Z43Z.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && nodeName?.toUpperCase() === 'DIV' && firstChild?.nodeName.toUpperCase() === 'TABLE') return false;
        // ED-16668
        // Do not remove this fixes an issue with windows firefox that relates to
        // the addition of the shadow sentinels
        if (type === 'selection' && nodeName?.toUpperCase() === 'TABLE' && (firstChild?.nodeName.toUpperCase() === 'COLGROUP' || firstChild?.nodeName.toUpperCase() === 'SPAN')) return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.roundedTableEdges?.destroy();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher?.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props, undefined, undefined, // @portal-render-immediately
        true);
        this.table = void 0;
        this.renderedDOM = void 0;
        this.resizeObserver = void 0;
        this.roundedTableEdges = void 0;
        this.intl = void 0;
        this.eventDispatcher = void 0;
        this.getPos = void 0;
        this.options = void 0;
        this.getEditorFeatureFlags = void 0;
        this.getNode = ()=>{
            return this.node;
        };
        this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
        this.intl = props.intl;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.roundedTableEdges = new (0, $e7003ff463061818$export$45ddc54457529def)(()=>this.table, props.node);
        this.handleRef = (node)=>this._handleTableRef(node);
    }
}
const $17d71a987b23526f$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption, intl)=>{
    const { pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled // same as options.isTableScalingEnabled
     } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(view.state);
    // Use shared state for isFullWidthModeEnabled and wasFullWidthModeEnabled for most up-to-date values
    const tableState = pluginInjectionApi?.table?.sharedState.currentState();
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls, allowTableResizing: allowTableResizing, allowTableAlignment: allowTableAlignment } = (0, $9424facaeaa63c09$export$c23fbabe48bd9130)(pluginConfig);
    const isTableFixedColumnWidthsOptionEnabled = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
    return new $17d71a987b23526f$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowTableResizing: allowTableResizing,
        allowTableAlignment: allowTableAlignment,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: tableState?.wasFullWidthModeEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isCommentEditor: // same as options.isTableScalingEnabled
            isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        intl: intl
    }).init();
};



















class $5be24141f24686be$export$2e2bcd8739ae039 {
    /**
   * @constructor
   */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        /**
     * Variables
     */ this.dom = void 0;
        this.contentDOM = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}


const $3bfcec40514e79cf$var$DEFAULT_COL_SPAN = 1;
const $3bfcec40514e79cf$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $3bfcec40514e79cf$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3bfcec40514e79cf$var$cssVariablePattern = /^VAR\(--.*\)$/;
const $3bfcec40514e79cf$var$getCellDomAttrsForTableMenuUpdates = (node)=>{
    const attrs = (0, $39Puj.getCellDomAttrs)(node);
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
class $3bfcec40514e79cf$export$2e2bcd8739ae039 extends (0, $5be24141f24686be$export$2e2bcd8739ae039) {
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    /**
   * Detects whether this cell visually reaches the bottom or right edge of the table
   * (accounting for rowspan/colspan) and sets data attributes so CSS can apply
   * rounded corners and transparent borders to merged cells that span to the table edges.
   */ updateTableEdgeAttrs() {
        const pos = this.getPos();
        if (pos === undefined) return;
        try {
            const resolvedPos = this.view.state.doc.resolve(pos);
            // Cell → row → table: depth-1 is the table, depth is the row
            const tableDepth = resolvedPos.depth - 1;
            const rowDepth = resolvedPos.depth;
            if (tableDepth < 0 || rowDepth < 0) return;
            const tableNode = resolvedPos.node(tableDepth);
            if (tableNode.type.name !== 'table') return;
            const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
            const cellStartInTable = pos - resolvedPos.start(tableDepth);
            const cellRect = tableMap.findCell(cellStartInTable);
            this.setDataAttr('data-reaches-top', cellRect.top === 0);
            this.setDataAttr('data-reaches-bottom', cellRect.bottom >= tableMap.height);
            this.setDataAttr('data-reaches-left', cellRect.left === 0);
            this.setDataAttr('data-reaches-right', cellRect.right >= tableMap.width);
        } catch  {
        // Position may be stale during document mutations; silently ignore.
        }
    }
    setDataAttr(attr, value) {
        if (value) this.dom.setAttribute(attr, 'true');
        else this.dom.removeAttribute(attr);
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = $3bfcec40514e79cf$var$getCellDomAttrsForTableMenuUpdates(this.node);
        const nextAttrs = $3bfcec40514e79cf$var$getCellDomAttrsForTableMenuUpdates(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $39Puj.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $3bfcec40514e79cf$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $3bfcec40514e79cf$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher);
        this.delayHandle = void 0;
        this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                // eslint-disable-next-line compat/compat
                window?.cancelIdleCallback?.(this.delayHandle);
                window?.cancelAnimationFrame?.(this.delayHandle);
            }
        };
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.updateTableEdgeAttrs();
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        if ($3bfcec40514e79cf$var$cssVariablePattern.test(node.attrs.background)) this.delayHandle = $3bfcec40514e79cf$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
}



var $55fM8 = parcelRequire("55fM8");


var $kmQhR = parcelRequire("kmQhR");





















// eslint-disable-next-line import/order




const $b0bfd2c9e917ced5$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const $b0bfd2c9e917ced5$var$dest = (0, $cI8RZ.pluginFactory)((0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1), $b0bfd2c9e917ced5$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});
const $b0bfd2c9e917ced5$export$656c7661095efe2e = $b0bfd2c9e917ced5$var$dest.createPluginState;
const $b0bfd2c9e917ced5$export$8d4021544bdece00 = $b0bfd2c9e917ced5$var$dest.createCommand;


const $81c125624ae400c1$export$dd348cf8bfd51272 = (rowState)=>(0, $b0bfd2c9e917ced5$export$8d4021544bdece00)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $81c125624ae400c1$export$98af81c5504c750e = (pos)=>(0, $b0bfd2c9e917ced5$export$8d4021544bdece00)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));








// limit scroll event calls
const $e4b429826013b5cd$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $e4b429826013b5cd$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $e4b429826013b5cd$export$2e2bcd8739ae039 extends (0, $5be24141f24686be$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $8e70e8c6596c6b3f$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $1jz5K.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $42b76cc10c347878$export$449115d164fc37c3)(this.editorScrollableElement);
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $deb80ec534adbdde$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $deb80ec534adbdde$export$92421f8864c287b1) + (0, $deb80ec534adbdde$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $629d677dec0f3c2a$export$ec6da316e37a54bf)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.shouldSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                if ((0, $ixfCV.fg)('platform_editor_ai_table_ai_streaming_pos_fix')) try {
                    // getPos can return stale positions during AI streaming which cannot be resolved
                    const $tableRowPos = this.view.state.doc.resolve(pos);
                    // layout -> layout column -> table -> table row
                    if ($tableRowPos.depth >= 3) {
                        const isInsideLayout = (0, $bjg0G.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                            return node.type.name === 'layoutColumn';
                        })?.node;
                        if (isInsideLayout) return false;
                    }
                } catch  {
                    // getPos can return stale positions during AI streaming — fall back to non-sticky
                    return false;
                }
                else {
                    const $tableRowPos = this.view.state.doc.resolve(pos);
                    // layout -> layout column -> table -> table row
                    if ($tableRowPos.depth >= 3) {
                        const isInsideLayout = (0, $bjg0G.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                            return node.type.name === 'layoutColumn';
                        })?.node;
                        if (isInsideLayout) return false;
                    }
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
      # Overview
        I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
        The format of the states are;    {top|bottom}:{in|above|below}
        ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
         For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
        above and out of the viewport
         This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
       # States
        top:in / bottom:in - NOT sticky
        top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:in / bottom:below - NOT sticky
        top:above / bottom:in - STICKY
        top:above / bottom:above - NOT sticky
        top:above / bottom:below - STICKY
        top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:below - NOT sticky
       # Summary
        The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
        is in or below it.
      */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $deb80ec534adbdde$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $42b76cc10c347878$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isSticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $629d677dec0f3c2a$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $629d677dec0f3c2a$export$b6a476e1427b061)(table);
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $deb80ec534adbdde$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $42b76cc10c347878$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $81c125624ae400c1$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $81c125624ae400c1$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotSticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isSticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $e4b429826013b5cd$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $e4b429826013b5cd$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.isHeaderRow = (0, $8e70e8c6596c6b3f$export$4af45fdaadf67b18)(node);
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) this.isInNestedTable = (0, $euISL.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        } catch  {
        // Intentionally swallowed — getPos can return stale positions during AI streaming
        }
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $fvMxa.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
    }
}












































// limit scroll event calls
const $3f44a41cbd3d901c$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $3f44a41cbd3d901c$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $3f44a41cbd3d901c$export$2e2bcd8739ae039 extends (0, $5be24141f24686be$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $8e70e8c6596c6b3f$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) {
            if (!newNodeIsHeaderRow && this.isHeaderRow) this.dom.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`)?.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
            return false; // re-create nodeview
        }
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.overflowObserver && this.overflowObserver.disconnect();
            this.overflowObserverEntries = undefined;
            this.stickyStateObserver && this.stickyStateObserver.disconnect();
            this.nodeVisibilityObserver?.disconnect();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $1jz5K.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $42b76cc10c347878$export$449115d164fc37c3)(this.editorScrollableElement);
            if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_5')) {
                this.scrollListener = ()=>{
                    if (this.hasScrolledSinceLoad) return;
                    this.hasScrolledSinceLoad = true;
                    if (!this.overflowObserver) return;
                    // Re-check intersection state now that scrolling has occurred
                    const entries = this.overflowObserverEntries ?? this.overflowObserver.takeRecords();
                    this.overflowObserverEntries = undefined;
                    /** NOTE: This logic is duplicated in the overflowObserver callback
           *  to avoid conflicting with a follow up refactor where this will
           *  be cleaned up.
           */ entries.forEach((entry)=>{
                        const tableWrapper = this.dom.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
                        if (tableWrapper && tableWrapper instanceof HTMLElement && (!(0, $42b76cc10c347878$export$732358707dcc2511)(entry) && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true) || !(0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true))) {
                            if (entry.isIntersecting) {
                                tableWrapper.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = true;
                            } else {
                                tableWrapper.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = false;
                            }
                            this.refreshLegacyStickyState();
                        }
                    });
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.editorScrollableElement.addEventListener('scroll', this.scrollListener, {
                    passive: true,
                    once: true
                });
            }
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.scrollListener && this.editorScrollableElement) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = undefined;
        }
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    initOverflowObserver() {
        const tableWrapper = this.dom.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        if (!tableWrapper) return;
        const options = {
            root: tableWrapper,
            threshold: 1
        };
        this.overflowObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (!(observer.root instanceof HTMLElement)) return;
                // Only apply classes if page has scrolled since load
                if (!this.hasScrolledSinceLoad && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_5')) {
                    this.overflowObserverEntries = entries;
                    return;
                }
                if (entry.isIntersecting) {
                    if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        if (!this.disableNativeSticky) this.dom.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = true;
                } else {
                    if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = false;
                }
                this.refreshLegacyStickyState();
                if ((0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) this.api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).STICKY_HEADER_METHOD_TOGGLED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE_STICKY_HEADER,
                    eventType: (0, $krYZG.EVENT_TYPE).UI,
                    attributes: {
                        nativeStickyHeaderEnabled: entry.isIntersecting
                    }
                });
            });
        }, options);
    }
    /**
   * This observer is used to track the 'stuck' state of the header row.
   * This roughly mimics `(at)container scroll-state(stuck: top)` in CSS,
   * but with full browser support.
   */ initStickyStateObserver() {
        if (!this.editorScrollableElement || !(this.editorScrollableElement instanceof Element)) return;
        const options = {
            root: this.editorScrollableElement,
            rootMargin: `-${(0, $k8PFz.tableMarginTop) + 1}px 0px 0px 0px`,
            threshold: 1
        };
        this.stickyStateObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const tableContainer = this.dom.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
                if (entry.intersectionRect.top === entry.rootBounds?.top && (!this.disableNativeSticky || !(0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4'))) {
                    this.dom.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) tableContainer.dataset.tableHeaderIsStuck = 'true';
                } else {
                    this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) {
                        if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_3')) delete tableContainer.dataset.tableHeaderIsStuck;
                        else tableContainer.dataset.tableHeaderIsStuck = 'false';
                    }
                }
            });
        }, options);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        if (this.isHeaderRow && !this.isInNestedTable) {
            if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) this.dom.style.setProperty('anchor-name', this.dom.getAttribute('data-node-anchor') ?? '');
            this.initOverflowObserver();
            if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) this.initNodeVisibilityObserver();
            const closestTable = this.dom.closest('table');
            if (closestTable) {
                this.overflowObserver?.observe(closestTable);
                if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) this.nodeVisibilityObserver?.observe(closestTable);
            }
            this.initStickyStateObserver();
            this.stickyStateObserver?.observe(this.dom);
        }
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // initialise intersection observer to track whether table is in scroll area
    initNodeVisibilityObserver() {
        this.nodeVisibilityObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!this.isNativeSticky) return;
                if (entry.intersectionRatio !== 0 && entry.intersectionRatio !== 1) return;
                if (this.disableNativeSticky === true) this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                if (this.disableNativeSticky === false) this.dom.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            });
        }, {
            threshold: [
                0,
                0.05,
                0.95,
                1
            ]
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $deb80ec534adbdde$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $deb80ec534adbdde$export$92421f8864c287b1) + (0, $deb80ec534adbdde$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $629d677dec0f3c2a$export$ec6da316e37a54bf)(table);
                    }
                    if ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) {
                        const viewportHeight = this.editorContentAreaHeight ?? (0, $b82f27ffc9765a71$export$4d09e1a8cc78d53);
                        this.toggleDisableNativeSticky(newHeight, viewportHeight);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshLegacyStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshLegacyStickyState() {
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        if (this.isNativeSticky) {
            this.makeRowHeaderNotLegacySticky(table);
            return;
        }
        const shouldStick = this.shouldSticky();
        if (this.isLegacySticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowLegacySticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotLegacySticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                if ((0, $ixfCV.fg)('platform_editor_ai_table_ai_streaming_pos_fix')) try {
                    // getPos can return stale positions during AI streaming which cannot be resolved
                    const $tableRowPos = this.view.state.doc.resolve(pos);
                    // layout -> layout column -> table -> table row
                    if ($tableRowPos.depth >= 3) {
                        const isInsideLayout = (0, $bjg0G.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                            return node.type.name === 'layoutColumn';
                        })?.node;
                        if (isInsideLayout) return false;
                    }
                } catch  {
                    // getPos can return stale positions during AI streaming — fall back to non-sticky
                    return false;
                }
                else {
                    const $tableRowPos = this.view.state.doc.resolve(pos);
                    // layout -> layout column -> table -> table row
                    if ($tableRowPos.depth >= 3) {
                        const isInsideLayout = (0, $bjg0G.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                            return node.type.name === 'layoutColumn';
                        })?.node;
                        if (isInsideLayout) return false;
                    }
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
    # Overview
     I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
     The format of the states are;    {top|bottom}:{in|above|below}
     ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
     above and out of the viewport
      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
    # States
     top:in / bottom:in - NOT sticky
     top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:in / bottom:below - NOT sticky
     top:above / bottom:in - STICKY
     top:above / bottom:above - NOT sticky
     top:above / bottom:below - STICKY
     top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:below - NOT sticky
    # Summary
     The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
     is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotLegacySticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $deb80ec534adbdde$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $629d677dec0f3c2a$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isLegacySticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowLegacySticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isLegacySticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $42b76cc10c347878$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isLegacySticky) {
            (0, $629d677dec0f3c2a$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isLegacySticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $629d677dec0f3c2a$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotLegacySticky(table, isEditorDestroyed = false) {
        if (!this.isLegacySticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $629d677dec0f3c2a$export$b6a476e1427b061)(table);
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isLegacySticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $deb80ec534adbdde$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $42b76cc10c347878$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $81c125624ae400c1$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $81c125624ae400c1$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $42b76cc10c347878$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
            this.onEditorContentAreaHeightChange?.();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isLegacySticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        this.api = void 0;
        /** Native sticky header variables */ this.overflowObserver = void 0;
        this.stickyStateObserver = void 0;
        this.hasScrolledSinceLoad = false;
        this.scrollListener = void 0;
        this.overflowObserverEntries = void 0;
        this.isNativeSticky = void 0;
        this.disableNativeSticky = false;
        this.onEditorContentAreaHeightChange = void 0;
        this.editorContentAreaHeight = void 0;
        this.nodeVisibilityObserver = void 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $3f44a41cbd3d901c$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(()=>{
            if (this.isLegacySticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $3f44a41cbd3d901c$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.toggleDisableNativeSticky = (headerHeight, viewportHeight)=>{
            if (!this.disableNativeSticky && headerHeight > viewportHeight * 0.5) {
                this.disableNativeSticky = true;
                if (this.isNativeSticky === undefined) this.dom.classList.remove((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            }
            if (this.disableNativeSticky && headerHeight <= viewportHeight * 0.5) this.disableNativeSticky = false;
        };
        this.isHeaderRow = (0, $8e70e8c6596c6b3f$export$4af45fdaadf67b18)(node);
        this.isLegacySticky = false;
        const { pluginConfig: pluginConfig } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        this.api = api;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        if ((0, $ixfCV.fg)('platform_editor_ai_table_ai_streaming_pos_fix')) try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) this.isInNestedTable = (0, $euISL.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        } catch  {
        // Intentionally swallowed — getPos can return stale positions during AI streaming
        }
        else if (pos) this.isInNestedTable = (0, $euISL.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $fvMxa.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
        if (this.isHeaderRow && this.isStickyHeaderEnabled && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4')) this.onEditorContentAreaHeightChange = api?.table?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.editorContentAreaHeight && nextSharedState?.editorContentAreaHeight !== this.editorContentAreaHeight) {
                this.editorContentAreaHeight = nextSharedState.editorContentAreaHeight;
                this.toggleDisableNativeSticky(this.stickyRowHeight ?? 0, nextSharedState.editorContentAreaHeight);
            }
        });
    }
}


const $18cf2a7e47a34c30$export$58b58f8ab97e94ed = (options)=>{
    return (node, view, getPos)=>{
        return (0, $17d71a987b23526f$export$f0e1dd383a612bf9)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor, options?.allowFixedColumnWidthOption, options.intl);
    };
};
const $18cf2a7e47a34c30$export$cb505927d54cfbe6 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $3bfcec40514e79cf$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $18cf2a7e47a34c30$export$182d82ed34901998 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $3bfcec40514e79cf$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $18cf2a7e47a34c30$export$2b8a69d954e9d30 = (options)=>{
    return (node, view, getPos)=>{
        if ((0, $742cd3b7e186e5d1$export$2ee7329d46115d8f)() && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) return new (0, $3f44a41cbd3d901c$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
        else return new (0, $e4b429826013b5cd$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    };
};





























const $c0f83bbab9b5ecee$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $8imfU.isTableSelected)(state.selection)) {
        const table = (0, $cycWk.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $8d0629bb8e812232$export$d2cf64960b17e12e)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $jzpoq.TABLE_ACTION).REPLACED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};






















const $6e62cb30035a7a87$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
                content.push(...(0, $bjg0G.flatten)(maybeCell, false).map((child)=>child.node));
                return false;
            }
            return true;
        });
        return content;
    }
    return maybeTable;
};
// Flattens nested tables after a given nesting depth
// If this looks familiar, it's a heavily modified version of `mapFragment` which has been
// adjusted to support tracking nesting depth. This wasn't possible by using `mapFragment` directly
const $6e62cb30035a7a87$var$unwrapNestedTables = (content, schema, unwrapNestDepth, currentNestDepth = 0)=>{
    const flattenNested = (node, tableDepth)=>{
        if (node.type === schema.nodes.table) {
            if (tableDepth >= unwrapNestDepth) return $6e62cb30035a7a87$export$c2e425c24c996f14(node);
            return node;
        }
        return node;
    };
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? flattenNested(node, currentNestDepth) : flattenNested(node.copy((0, $aPdNQ.Fragment).fromArray($6e62cb30035a7a87$var$unwrapNestedTables(node.content, schema, unwrapNestDepth, node.type === schema.nodes.table ? currentNestDepth + 1 : currentNestDepth))), currentNestDepth);
        if (transformed) {
            if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return children;
};
const $6e62cb30035a7a87$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $6e62cb30035a7a87$export$c2e425c24c996f14(node) : node;
};
const $6e62cb30035a7a87$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $6e62cb30035a7a87$export$c2e425c24c996f14(node) : node;
};
const $6e62cb30035a7a87$export$8bc9a7cde47c4f8e = (slice, schema, selection)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let openEnd = slice.openEnd;
    const newFragment = (0, $fud2r.flatmap)(slice.content, (node, i, fragment)=>{
        // We allow default nesting of 2 to support
        // two levels of nesting in nodes that support table nesting already such as layoutSection and expands
        let allowedTableNesting = 2;
        const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
        const isPasteInTable = (0, $bjg0G.hasParentNodeOfType)([
            table,
            tableCell,
            tableHeader
        ])(selection);
        const isPasteInNestedTable = (0, $euISL.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1;
        const isPasteFullTableInsideEmptyCellEnabled = (0, $ixfCV.fg)('platform_editor_paste_full_table_inside_empty_cell');
        // Pasted content only contains a table and no other content
        const isCellPaste = isPasteInTable && slice.content.childCount === 1 && slice.content.firstChild?.type === table && (!isPasteFullTableInsideEmptyCellEnabled || slice.openStart !== 0 && slice.openEnd !== 0);
        // however if pasted content is a table, allow just one level
        if (node.type === schema.nodes.table) {
            allowedTableNesting = 1;
            // if paste is inside a table, allow no further nesting
            if (isPasteInTable) allowedTableNesting = 0;
            // unless we are pasting inside a nested table, then bounce back to 1 level
            // because editor-plugin-paste will lift the table to the parent table (just below it)
            if (isPasteInNestedTable) allowedTableNesting = 1;
            // paste of table cells into a table cell - content is spread across multiple cells
            // by editor-tables so needs to be treated a little differently
            if (isCellPaste || isCellSelection) {
                allowedTableNesting = 1;
                if (isPasteInNestedTable) allowedTableNesting = 0;
            }
        }
        // Prevent invalid openEnd after pasting tables with a selection that ends inside a nested table cell.
        // If the slice ends with a selection that ends inside a nested table, and we paste inside a table we
        // need to adjust the openEnd because it is no longer correct. If we don't, Prosemirror fires an exception
        // because it iterates to a non-existent depth and the transform will not be applied
        if (slice.openEnd >= 7 && // depth of a nested table cell
        slice.content.childCount > 1 && slice.content.lastChild?.type === table && isPasteInTable) // re-point the slice's openEnd to non-nested table cell depth
        openEnd = 4;
        if (isCellSelection && !isCellPaste) // if pasting into a cell selection, we need to flatten the parent table as well
        return $6e62cb30035a7a87$var$unwrapNestedTables((0, $aPdNQ.Fragment).fromArray([
            node
        ]), schema, allowedTableNesting);
        else {
            // after we've worked out what the allowed nesting depth is, unwrap nested tables
            const newChildren = $6e62cb30035a7a87$var$unwrapNestedTables(node.content, schema, allowedTableNesting);
            return node.copy((0, $aPdNQ.Fragment).fromArray(newChildren));
        }
    });
    return new (0, $aPdNQ.Slice)(newFragment, slice.openStart, openEnd);
};
const $6e62cb30035a7a87$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak?.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $6e62cb30035a7a87$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $6e62cb30035a7a87$var$isNodeSingleCellTable = (node, schema)=>{
    return node.childCount === 1 && node.firstChild?.type === schema.nodes.tableRow && node.firstChild.childCount === 1 && (node.firstChild.firstChild?.type === schema.nodes.tableCell || node.firstChild.firstChild?.type === schema.nodes.tableHeader);
};
const $6e62cb30035a7a87$var$isFragmentSingleCellTable = (fragment, schema)=>{
    return fragment.childCount === 1 && fragment.firstChild !== null && $6e62cb30035a7a87$var$isNodeSingleCellTable(fragment.firstChild, schema);
};
const $6e62cb30035a7a87$var$containsNonTableBlockChildren = (fragment, schema)=>{
    let containsNonTableBlock = false;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    fragment.forEach((node)=>{
        if (node.isBlock && ![
            table,
            tableCell,
            tableHeader
        ].includes(node.type)) containsNonTableBlock = true;
    });
    return containsNonTableBlock;
};
const $6e62cb30035a7a87$export$7932630df6a9b5d9 = (slice, schema)=>{
    // Case 1: A slice of a block selection inside a nested table
    // Prosemirror wraps nested block selections in their respective tables
    // We are using `safeInsert` to paste nested tables, so we do not want to preserve this wrapping
    // slice starts and ends inside a nested table at the same depth
    if (slice.openStart >= 7 && slice.openEnd >= 7) {
        let cleaned = slice;
        let descendedDepth = 0;
        const tableDepthDecrement = 2;
        // if the slice is a single cell table and contains cells with single cell tables, descend into it until we find textblock children
        if ($6e62cb30035a7a87$var$isFragmentSingleCellTable(slice.content, schema)) slice.content.firstChild?.descendants((node)=>{
            if ($6e62cb30035a7a87$var$isNodeSingleCellTable(node, schema)) descendedDepth += tableDepthDecrement;
            else if (node.type === schema.nodes.table) return false;
            else if ($6e62cb30035a7a87$var$containsNonTableBlockChildren(node.content, schema)) {
                descendedDepth += tableDepthDecrement;
                // create a new slice with the content of non-table block children and the depth of the nested tables subtracted
                cleaned = new (0, $aPdNQ.Slice)(node.content, slice.openStart - descendedDepth - tableDepthDecrement, slice.openEnd - descendedDepth - tableDepthDecrement);
                return false;
            }
        });
        if (!cleaned.eq(slice)) return cleaned;
    }
    // Case 2: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    slice.content.firstChild.type === schema.nodes.table) {
        // we're removing the table, tableRow and tableCell reducing the open depth by 3
        const depthDecrement = 3;
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (slice.content.firstChild?.content?.firstChild?.content?.firstChild?.type === schema.nodes.table) cleaned = new (0, $aPdNQ.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $aPdNQ.Slice)((0, $fud2r.flatmap)(cleaned.content, $6e62cb30035a7a87$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 3: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && slice.content.firstChild?.type === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $aPdNQ.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $6e62cb30035a7a87$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $6e62cb30035a7a87$export$cbabf4b236642ebb(state) {
    const tableState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $6e62cb30035a7a87$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $fud2r.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

















const $e1a9fc99cb56666d$export$a6fbfadef1c3fa2e = (view, pluginInjectionApi)=>{
    const { state: { doc: doc, schema: schema } } = view;
    let tr = view.state.tr;
    const { table: table } = schema.nodes;
    let modified = false;
    const measuredTables = [];
    // modify only top-level tables
    doc.forEach((node, offset)=>{
        if ((0, $ixfCV.fg)('platform_editor_table_auto_convert_fix')) {
            if (node.type !== table || !(0, $cdX2q.isTableInContentMode)({
                tableNode: node,
                isSupported: true,
                isTableNested: false
            })) return;
        } else {
            if (node.type !== table || (0, $cdX2q.hasTableBeenResized)(node) && node.attrs.layout !== 'align-start') return;
        }
        const domNode = view.domAtPos(offset + 1).node;
        const tableWrapper = domNode instanceof HTMLElement ? domNode.closest(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`) : null;
        const tableRef = tableWrapper?.querySelector('table');
        if (!tableRef) return;
        measuredTables.push({
            node: node,
            offset: offset,
            measurement: (0, $2c61af3d1532943d$export$d87d6ab7a18b29eb)(tableRef)
        });
    });
    measuredTables.forEach(({ node: node, offset: offset, measurement: measurement })=>{
        tr = (0, $2c61af3d1532943d$export$e55d81380f623ba1)(tr, node, measurement, offset);
        modified = true;
    });
    if (modified) {
        pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
            action: (0, $jzpoq.TABLE_ACTION).FIT_TO_CONTENT_AUTO_CONVERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                editorContainerWidth: pluginInjectionApi?.width?.sharedState.currentState()?.width ?? 0,
                totalTablesResized: measuredTables.length,
                measurements: measuredTables.map(({ measurement: measurement })=>({
                        tableWidth: measurement.tableWidth,
                        totalColumnCount: measurement.colWidths.length
                    }))
            }
        })(tr);
        view.dispatch(tr.setMeta('addToHistory', false));
    }
};



const $b69ebba757e1f13b$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, fullWidthModeEnabled, previousFullWidthModeEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption, __livePage)=>{
    const state = (0, $8fc50ac4440f7aa5$export$656c7661095efe2e)(dispatch, {
        pluginConfig: pluginConfig,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isTableScalingEnabled: isTableScalingEnabled,
        activeTableMenu: {
            type: 'none'
        },
        ...(0, $a004efca12670bed$export$4c0699e9a8272521),
        ...(0, $a004efca12670bed$export$af473ce758096273),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    const intl = (0, $iAEsk.isSSRStreaming)() ? getIntl() : undefined;
    const getNodeView = ()=>{
        return {
            table: (0, $18cf2a7e47a34c30$export$58b58f8ab97e94ed)({
                portalProviderAPI: portalProviderAPI,
                eventDispatcher: eventDispatcher,
                getEditorContainerWidth: getEditorContainerWidth,
                getEditorFeatureFlags: getEditorFeatureFlags,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                intl: intl
            }),
            tableRow: (0, $18cf2a7e47a34c30$export$2b8a69d954e9d30)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableCell: (0, $18cf2a7e47a34c30$export$cb505927d54cfbe6)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableHeader: (0, $18cf2a7e47a34c30$export$182d82ed34901998)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            })
        };
    };
    const nodeViews = getNodeView();
    return new (0, $kpCD8.SafePlugin)({
        state: state,
        key: (0, $a10022ebdc03afe1$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $c6627e327b6f56a8$export$1c3f791fb2a5168)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $294a9e2ffe698c99$export$d6d48849d9121a1)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $294a9e2ffe698c99$export$d6d48849d9121a1)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            let contentModeSizeTableId = null;
            let hasMeasuredContentModeTables = false;
            let focusListenerBinding = null;
            if ((!(0, $ixfCV.fg)('platform_editor_table_auto_convert_fix') || !__livePage) && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && (0, $f683956911721579$export$e217d2a535d6ae45)({
                allowColumnResizing: !!pluginConfig.allowColumnResizing,
                allowTableResizing: !!pluginConfig.allowTableResizing,
                isFullPageEditor: !isChromelessEditor && !isCommentEditor
            }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) focusListenerBinding = (0, $cbY7C.bind)(editorView.dom, {
                type: 'focus',
                listener: ()=>{
                    if ((0, $ixfCV.fg)('platform_editor_table_nested_renderer_fix')) {
                        if (hasMeasuredContentModeTables || contentModeSizeTableId) return;
                        hasMeasuredContentModeTables = true;
                        (0, $e1a9fc99cb56666d$export$a6fbfadef1c3fa2e)(editorView, pluginInjectionApi);
                        return;
                    }
                    if (contentModeSizeTableId) return;
                    contentModeSizeTableId = requestAnimationFrame(()=>{
                        if (!editorViewRef) return;
                        (0, $e1a9fc99cb56666d$export$a6fbfadef1c3fa2e)(editorViewRef, pluginInjectionApi);
                    });
                },
                options: {
                    once: true
                }
            });
            return {
                update: (view, prevState)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                    let tableRef;
                    const parent = (0, $bjg0G.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                    const shouldSetTableRef = parent && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && pluginInjectionApi?.interaction?.sharedState.currentState()?.interactionState !== 'hasNotHadInteraction';
                    if (shouldSetTableRef) tableRef = // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    parent.querySelector('table') || undefined;
                    if (pluginState.editorHasFocus) {
                        const tableNode = (0, $cycWk.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = pluginPrevState?.tableNode !== tableNode?.node;
                            if (pluginPrevState?.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $8Z43Z.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $8Z43Z.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $9b2eea537bbdfc67$export$79b661cbf50c3490)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $9b2eea537bbdfc67$export$bf5ab08a5036bda8)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $9b2eea537bbdfc67$export$99c5230572e6696d)()(state, dispatch);
                },
                destroy: ()=>{
                    contentModeSizeTableId && cancelAnimationFrame(contentModeSizeTableId);
                    focusListenerBinding && focusListenerBinding();
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $5I4Vo.insideTable)(editorState) && (0, $6e62cb30035a7a87$export$cbabf4b236642ebb)(editorState)) slice = (0, $9b2eea537bbdfc67$export$bb3294affcb5059f)(slice, schema);
                // This fixes pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $5I4Vo.insideTable)(editorState) && isCommentEditor && pluginConfig.allowTableAlignment && isTableScalingEnabled) slice = (0, $6e62cb30035a7a87$export$4e98c990eb0fdba6)(slice, schema);
                slice = (0, $6e62cb30035a7a87$export$fc3230cbfe498044)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $93b96d5caf93ce93$export$82cc8566682e5cf4)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $f77decf2d75a41ec$export$6d57e15bdf5e650f)(slice, schema);
                // transformSliceToRemoveOpenTable() transforms based on the depth of the root node, assuming that the tables will be at the root
                // Bodied extensions will contribute to the depth of the table selection so we need to remove them first
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $jlFP9.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $6e62cb30035a7a87$export$7932630df6a9b5d9)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $jlFP9.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $6e62cb30035a7a87$export$5354b8e5d3b01769)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $9b2eea537bbdfc67$export$8fcd87e05a98248e)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $9b2eea537bbdfc67$export$f4e57bcfd514085d)(slice, schema);
                else slice = (0, $9b2eea537bbdfc67$export$80a571fa7de8754d)(slice, schema);
                slice = (0, $85f912d052ddf140$export$74dbe7cb6b933cde)(slice, schema);
                if ((0, $hZ5o2.isNestedTablesSupported)(schema)) slice = (0, $6e62cb30035a7a87$export$8bc9a7cde47c4f8e)(slice, schema, editorState.selection);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $f9ba8a550809a188$export$18d4026d1ea86bb1).getState(state);
                const browser = (0, $8dxef.getBrowserInfo)();
                if ((0, $cfea602767863767$export$6577d2f7fe84e45c)(decorationSet).length) (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if (browser.chrome && event.target) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || targetClassList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE) || targetClassList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER)) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $bjg0G.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $btvbC.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                if (isKeyboardResize) {
                    (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $c0f83bbab9b5ecee$export$ea73b328547c6ad5)(state, text, (0, $krYZG.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: nodeViews,
            handleDOMEvents: {
                focus: (0, $c6627e327b6f56a8$export$185584c64f36588),
                blur: (0, $c6627e327b6f56a8$export$27d5d91e7417534c),
                mousedown: (0, $c6627e327b6f56a8$export$87e6a6bf8341824f)((view, event)=>(0, $c6627e327b6f56a8$export$b4a93e0b711d8f7)(view, event, pluginInjectionApi)),
                mouseleave: (0, $c6627e327b6f56a8$export$fcff8e67f71577c3),
                mousemove: (0, $c6627e327b6f56a8$export$82a75cb550f27e28)((0, $c6627e327b6f56a8$export$3248c033e90a4ba0)(nodeViewPortalProviderAPI), pluginInjectionApi),
                mouseenter: (0, $c6627e327b6f56a8$export$2560ef85393729a7),
                mouseup: (0, $c6627e327b6f56a8$export$82a75cb550f27e28)((0, $c6627e327b6f56a8$export$88f4dbb0cd0ffc84)),
                click: (0, $c6627e327b6f56a8$export$87e6a6bf8341824f)((0, $c6627e327b6f56a8$export$82a75cb550f27e28)((0, $c6627e327b6f56a8$export$b981489921ee18cd)))
            },
            handleTripleClick: $c6627e327b6f56a8$export$f17e34274dd6fcf5
        }
    });
};



/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 








const $dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $kCECX.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $dd1b5de40ba01c0a$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $8nvEM.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $8nvEM.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $8nvEM.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $8nvEM.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>$dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)?.decorations,
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
						 * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
						 * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
						 * The condition here checks to see if the entire text node is about to be swapped inside of an element
						 */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($dd1b5de40ba01c0a$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};







const $76a73165c8f7caeb$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $kpCD8.SafePlugin)({
        state: (0, $b0bfd2c9e917ced5$export$656c7661095efe2e)(dispatch, initialState),
        key: (0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1)
    });
};





// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid

var $kHija = parcelRequire("kHija");





var $2XHKU = parcelRequire("2XHKU");













class $afb92dfdaf83fcd8$var$ObjHash {
    static getForNode(node) {
        if (this.cache.has(node)) return this.cache.get(node) || '';
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid
        const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
        this.cache.set(node, uniqueId);
        return uniqueId;
    }
}
$afb92dfdaf83fcd8$var$ObjHash.cache = new WeakMap();
const $afb92dfdaf83fcd8$var$getNodeAnchor = (node)=>{
    const handleId = $afb92dfdaf83fcd8$var$ObjHash.getForNode(node);
    return `--table-${node.type.name}-${handleId}`;
};
const $afb92dfdaf83fcd8$var$createTableAnchorDecorations = (state)=>{
    const decs = [];
    let headerRowId;
    state.doc.nodesBetween(0, state.doc.content.size, (node, pos, parent, index)=>{
        const isTableHeader = node.type.name === 'tableHeader';
        const isTableRow = node.type.name === 'tableRow';
        const isParentTableRow = parent?.type.name === 'tableRow';
        const isParentTableHeaderRow = parent?.type.name === 'tableRow' && headerRowId && parent?.attrs?.localId === headerRowId;
        const shouldAddDecorationToHeader = (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? isParentTableHeaderRow && isTableHeader : isTableHeader;
        const isFirstRow = isTableRow && index === 0;
        if (isFirstRow) headerRowId = node.attrs.localId;
        // only apply to header cells and the first row of a table, for performance reasons
        if (isFirstRow || shouldAddDecorationToHeader) {
            const anchorName = $afb92dfdaf83fcd8$var$getNodeAnchor(node);
            const shouldAddAnchorNameInDecoration = !(0, $2XHKU.isCSSAttrAnchorSupported)() && (0, $2XHKU.isCSSAnchorSupported)() && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_8');
            const attributes = {
                'data-node-anchor': anchorName,
                style: `anchor-name: ${anchorName};`
            };
            decs.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, shouldAddAnchorNameInDecoration ? attributes : {
                'data-node-anchor': anchorName
            }));
        }
        // only decend if there is a possible table row or table header node after the current node, for performance reasons
        return (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? !(isTableHeader || isParentTableHeaderRow) : !(isTableHeader || isParentTableRow);
    });
    return (0, $8nvEM.DecorationSet).create(state.doc, decs);
};
const $afb92dfdaf83fcd8$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableAnchorNamesPlugin');
const $afb92dfdaf83fcd8$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init: (_config, state)=>{
                return $afb92dfdaf83fcd8$var$createTableAnchorDecorations(state);
            },
            apply: (tr, decorationSet, _, newState)=>{
                if (tr.docChanged) return $afb92dfdaf83fcd8$var$createTableAnchorDecorations(newState);
                return decorationSet;
            }
        },
        key: $afb92dfdaf83fcd8$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$afb92dfdaf83fcd8$export$18d4026d1ea86bb1.getState(state) || (0, $8nvEM.DecorationSet).empty
        }
    });
};


/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 



var $2nOF5 = parcelRequire("2nOF5");





var $gLqwM = parcelRequire("gLqwM");




const $9ae90c5b5e91c4fc$var$pluginKey = new (0, $kCECX.PluginKey)('tableLocalIdPlugin');
const $9ae90c5b5e91c4fc$var$getPluginState = (state)=>state && $9ae90c5b5e91c4fc$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $9ae90c5b5e91c4fc$export$ae829ec7b2625219 = (dispatch)=>new (0, $kpCD8.SafePlugin)({
        key: $9ae90c5b5e91c4fc$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($9ae90c5b5e91c4fc$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($9ae90c5b5e91c4fc$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
				 * Utilise the update cycle for _one_ scan through an initial doc
				 * to ensure existing tables without IDs get them when this plugin is
				 * enabled.
				 *
				 * This entire block can be skipped if we simply remove the `checkIsAddingTable`
				 * check in appendTransaction, but that comes with 2 cons:
				 *
				 * 1. require a transaction before we actually add the local IDs
				 * 2. ever slightly more unncessary checks
				 *
				 * Finally, this never happens in practice when utilising this in
				 * confluence, as the collab/synchrony initialisation process will
				 * trigger a transaction which adds tables, and thus this plugin will
				 * add/dedupe the necessary IDs. But general usage of the editor
				 * without collab should still solve for IDs.
				 */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $9ae90c5b5e91c4fc$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $LQnOI.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $2nOF5.uuid).generate()
                                });
                                return false;
                            }
                            /**
							 * Otherwise continue traversing, we can encounter tables nested in
							 * expands/bodiedExtensions
							 */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($9ae90c5b5e91c4fc$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $gLqwM.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $2nOF5.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });










































const $6cc993879715a3d7$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)=>{
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $a2b54432792761eb$export$3c89e45c7dff9619)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    event.preventDefault();
    (0, $eFgM7.insm).session?.startFeature('tableColumnResize');
    const tr = view.state.tr;
    tr.setMeta((0, $a734f122c6a2cd61$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: (0, $jzpoq.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width) maxSize = editorWidth - (0, $26c6284b781fc82b$export$c332ba2dd5aa2199);
    else maxSize = (0, $a2b54432792761eb$export$8bfbafe1083a527d)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = (0, $da3a78eceffe80bd$export$38f73cf370cfaafc)({
        minWidth: (0, $k8PFz.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $cb90c04d75301fb4$export$c955b9a736441250)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const width = (0, $a2b54432792761eb$export$8f862fd911e06936)(view, localResizeHandlePos, cell.attrs);
    (0, $cb90c04d75301fb4$export$e747fb9908ce65b7)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $9b2eea537bbdfc67$export$31eed8673ceee613)(nodeViewPortalProviderAPI, undefined, undefined, false)(state, dispatch);
    function finish(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mouseup', finish);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        if (resizeHandlePos === null) {
            (0, $eFgM7.insm).session?.endFeature('tableColumnResize');
            return (0, $cb90c04d75301fb4$export$d1301521f1f26547)()(state, dispatch);
        }
        if (!(0, $a2b54432792761eb$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos))) {
            (0, $eFgM7.insm).session?.endFeature('tableColumnResize');
            return;
        }
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            (0, $eFgM7.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $83f03c9ff5611334$export$b77825ff607efdbb)({})(state, dispatch, view);
            else return (0, $cb90c04d75301fb4$export$d1301521f1f26547)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            const { startX: startX } = dragging;
            // If the dimensions of the table have changed through a remote modification by another
            // person for example don't persist the new column widths as we couldn't reliably remap them
            // For example, if a table col is deleted
            // There may be a more elegant solution to this, to avoid a jarring experience. This used to
            // be an equality check but that caused issues when a nested table would change (eg. when it
            // dynamically updates its width on resize)
            if (!(0, $8e70e8c6596c6b3f$export$bc84d95d2dfa63bf)(originalTable, table)) {
                const map = (0, $8Z43Z.TableMap).get(table);
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $hC0Ga.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $a2b54432792761eb$export$4e884677f8e54bba)(originalTable, dom) : (0, $a2b54432792761eb$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
                const newResizeState = (0, $29b3570c8ef9d78d$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                tr = (0, $3785adcc5f70ea76$export$6688b13ec132acdf)(newResizeState, table, start, api)(tr);
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $jzpoq.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $jzpoq.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $krYZG.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            (0, $eFgM7.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $83f03c9ff5611334$export$b77825ff607efdbb)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $cb90c04d75301fb4$export$d1301521f1f26547)(tr)(state, dispatch);
        }
    }
    function move(event) {
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $a2b54432792761eb$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos)) || !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $8Z43Z.TableMap).get(table);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $a2b54432792761eb$export$4e884677f8e54bba)(table, dom) : (0, $a2b54432792761eb$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        (0, $29b3570c8ef9d78d$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        (0, $629d677dec0f3c2a$export$13c259c17cfd51f5)()(state);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mouseup', finish);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mousemove', move);
    return true;
};





function $e611c0bfba215a68$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, isCommentEditor) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $c3bb9070ade8eb63$export$18d4026d1ea86bb1),
        state: (0, $78429e61a3e1fdf5$export$656c7661095efe2e)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
                        [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state).resizeHandlePos || (0, $629d677dec0f3c2a$export$3658aa65e79e3104)(view, event);
                    const { dragging: dragging } = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
          	We need to start listening mouse events if column resize started from keyboard.
          	This will allow continue resizing via mouse
          */ const { isKeyboardResize: isKeyboardResize } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $6cc993879715a3d7$export$b4a93e0b711d8f7)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $cb90c04d75301fb4$export$4d14ce8b526952e5)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}













var $4EksL = parcelRequire("4EksL");

var $1tdnq = parcelRequire("1tdnq");

var $iscRo = parcelRequire("iscRo");

var $1JP3v = parcelRequire("1JP3v");

var $eaLat = parcelRequire("eaLat");






















var $05c5afa32cb500f1$var$TableSelectionDirection = /*#__PURE__*/ function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
    return TableSelectionDirection;
}($05c5afa32cb500f1$var$TableSelectionDirection || {});
const $05c5afa32cb500f1$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $8HW7o.CellSelection)) return $05c5afa32cb500f1$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $4EksL.GapCursorSelection)) return $05c5afa32cb500f1$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $kCECX.TextSelection)) return $05c5afa32cb500f1$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $05c5afa32cb500f1$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $8HW7o.CellSelection)) return $05c5afa32cb500f1$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $4EksL.GapCursorSelection)) return $05c5afa32cb500f1$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $kCECX.TextSelection)) return $05c5afa32cb500f1$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $05c5afa32cb500f1$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $8imfU.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionState?.selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $05c5afa32cb500f1$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $05c5afa32cb500f1$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $05c5afa32cb500f1$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $1JP3v.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $05c5afa32cb500f1$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $8imfU.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $05c5afa32cb500f1$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $05c5afa32cb500f1$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $05c5afa32cb500f1$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $cycWk.findTable)(selection);
            const rect = (0, $91iSj.selectedRect)(state);
            if (table && (0, $8imfU.isRowSelected)(rect.top)(selection)) return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $9b2eea537bbdfc67$export$c2e8772deb1607ea)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $8Z43Z.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $05c5afa32cb500f1$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $cycWk.findTable)(selection);
            const rect = (0, $91iSj.selectedRect)(state);
            if (table && (0, $8imfU.isColumnSelected)(rect.left)(selection)) return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $9b2eea537bbdfc67$export$e247ed8cec4832f4)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $8Z43Z.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $fKJ7J.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $05c5afa32cb500f1$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $eaLat.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $eaLat.Side).LEFT) {
                const table = (0, $cycWk.findTable)(selection);
                if (table && $05c5afa32cb500f1$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $05c5afa32cb500f1$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $eaLat.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $eaLat.Side).RIGHT) {
                const table = (0, $cycWk.findTable)(selection);
                if (table && $05c5afa32cb500f1$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $05c5afa32cb500f1$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $cycWk.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($05c5afa32cb500f1$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $1JP3v.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $05c5afa32cb500f1$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $cycWk.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($05c5afa32cb500f1$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * sets a cell selection over the table cell in which the selection is inside of
 */ const $05c5afa32cb500f1$var$selectTableCell = (state, dispatch)=>{
    const $cell = (0, $7zMjs.cellAround)(state.selection.$from);
    if (!$cell) return false;
    if (dispatch) {
        dispatch(state.tr.setSelection(new (0, $8HW7o.CellSelection)($cell)));
        return true;
    }
    return false;
};
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $05c5afa32cb500f1$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $8Z43Z.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $8HW7o.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $1JP3v.RelativeSelectionPos).End;
            } else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $8HW7o.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $1JP3v.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $4EksL.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $4EksL.GapCursorSelection)($firstPosInsideCell, (0, $eaLat.Side).LEFT) : (0, $kCECX.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $4EksL.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $4EksL.GapCursorSelection)($lastPosInsideCell, (0, $eaLat.Side).RIGHT) : (0, $kCECX.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $cycWk.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $4EksL.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $4EksL.GapCursorSelection)($beforeTablePos, (0, $eaLat.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $cycWk.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $4EksL.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $4EksL.GapCursorSelection)($afterTablePos, (0, $eaLat.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $05c5afa32cb500f1$var$isSelectionAtStartOfTable = ($pos, selection)=>(0, $iscRo.isSelectionAtStartOfNode)($pos, (0, $cycWk.findTable)(selection)?.node);
const $05c5afa32cb500f1$var$isSelectionAtEndOfTable = ($pos, selection)=>(0, $1tdnq.isSelectionAtEndOfNode)($pos, (0, $cycWk.findTable)(selection)?.node);
const $05c5afa32cb500f1$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $cycWk.findTable)(selection);
            const selectionRect = (0, $0271a85e586658fd$export$e3ff63a8559e7571)(state);
            const index = selectionRect?.top;
            if (table && index === 0) return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $05c5afa32cb500f1$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $cycWk.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $8imfU.isTableSelected)(selection);
            const isCellSelection = selection instanceof (0, $8HW7o.CellSelection);
            // if no cells are selected
            if (!isCellSelection) return $05c5afa32cb500f1$var$selectTableCell(state, dispatch);
            else if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $05c5afa32cb500f1$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };


function $879cd4d4e153591c$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    const list = {};
    const editorSelectionAPI = pluginInjectionApi?.selection;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveRight).common, (0, $05c5afa32cb500f1$export$2e5835b1a25e33b)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.moveLeft).common, (0, $05c5afa32cb500f1$export$2c7e1bbc14ebf0ec)(editorSelectionAPI)(), list);
    (0, $ldqjS.bindKeymapArrayWithCommand)((0, $ldqjS.selectColumn), (0, $05c5afa32cb500f1$export$41a42e79fbe56d35)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $ldqjS.bindKeymapArrayWithCommand)((0, $ldqjS.selectRow), (0, $05c5afa32cb500f1$export$b5ba3b60192c7a8d)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.shiftArrowUp).common, (0, $05c5afa32cb500f1$export$ef446fa0355915f)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.selectTable).common, (0, $05c5afa32cb500f1$export$1de5b4cd2a72d822)(editorSelectionAPI)(), list);
    return (0, $44cyU.keymap)(list);
}








const $285f4eda3a20b494$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableSizeSelectorPlugin');
const $285f4eda3a20b494$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $285f4eda3a20b494$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({
                    isSelectorOpen: false
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($285f4eda3a20b494$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return currentPluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...currentPluginState,
                            ...meta
                        };
                        dispatch($285f4eda3a20b494$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return currentPluginState;
            }
        }
    });
};



/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 












const $8bb90754565162d1$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('tableWidthInCommentFixPlugin');
const $8bb90754565162d1$var$getPluginState = (state)=>state && $8bb90754565162d1$export$18d4026d1ea86bb1.getState(state);
const $8bb90754565162d1$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $8bb90754565162d1$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($8bb90754565162d1$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($8bb90754565162d1$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $8bb90754565162d1$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $LQnOI.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $7Y8M5.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $cac57eed68474c1f$export$2cbc54593c64b1f2) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($8bb90754565162d1$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};




/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 












var $7Meja = parcelRequire("7Meja");














var $5TMHS = parcelRequire("5TMHS");

const $de4cf649ee0f73d1$export$25fb1502cf13990c = (props)=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    if (mode === 'edit') return null;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TMHS.default), props);
};



const $741bb5eed103c4d2$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $741bb5eed103c4d2$export$fb5c0ba8f0806db1 = 'is-disabled';
const $741bb5eed103c4d2$export$665a01df2c44393a = 'data-sort-index';





const $d923efcd4eacd9e3$export$994e077cfffa9ab4 = new (0, $kCECX.PluginKey)('tableViewModeSortPlugin');






var $5fU8Q = parcelRequire("5fU8Q");




const $e8e39496c5f47790$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const tbody = tableElement.querySelector(`:scope > tbody`);
    const rows = tableElement.querySelectorAll(`:scope > tbody > tr`);
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody?.appendChild(rows[item.index + 1]);
    });
};
const $e8e39496c5f47790$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $5fU8Q.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $f9Emz.createCompareNodes)({
        // TODO: ED-26961 - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $e8e39496c5f47790$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $741bb5eed103c4d2$export$b61cb5d3425147f)}`);
    if (widget?.classList.contains((0, $741bb5eed103c4d2$export$fb5c0ba8f0806db1)) || !widget) return;
    const dataSortIndex = target?.closest('.ProseMirror-widget')?.getAttribute((0, $741bb5eed103c4d2$export$665a01df2c44393a));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode?.attrs.localId;
    if (!tableId || !tableNode || tableNode?.type?.name !== 'table') return;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, direction: direction, order: oldOrder } = pluginState?.[tableId] || {};
    // Unsort if there was already a sort
    if (direction !== (0, $7Meja.SortOrder).NO_ORDER && oldOrder !== undefined) $e8e39496c5f47790$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $7Meja.SortOrder).NO_ORDER:
            direction = (0, $7Meja.SortOrder).ASC;
            break;
        case (0, $7Meja.SortOrder).ASC:
            direction = (0, $7Meja.SortOrder).DESC;
            break;
        case (0, $7Meja.SortOrder).DESC:
            direction = (0, $7Meja.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $7Meja.SortOrder).ASC; // default direction when a new index is clicked
    const order = $e8e39496c5f47790$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $7Meja.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $e8e39496c5f47790$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = tableElement?.querySelector(':scope > tbody');
    const rows = tableElement?.querySelectorAll(':scope > tbody > tr');
    return {
        tbody: tbody,
        rows: rows
    };
};


const $a4e477e00a1dc89a$export$ae829ec7b2625219 = (api, nodeViewPortalProviderAPI)=>{
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $8nvEM.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                // TODO: ED-26961 - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = api.editorViewMode?.sharedState.currentState() || {};
                if (mode !== 'view') {
                    const sortingDecorations = pluginState?.decorations?.find(undefined, undefined, (s)=>s?.type === 'sorting-decoration');
                    return {
                        ...pluginState,
                        decorations: pluginState?.decorations?.remove(sortingDecorations)
                    };
                }
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                const removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta?.[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
         * Create decorations for the sorting icons
         */ const decs = [];
                const sortingDecorations = pluginState.decorations.find(undefined, undefined, (spec)=>spec.tableId === tableId && spec.type === 'sorting-decoration');
                // TODO: ED-26961 - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta || isTableInState && !sortingDecorations.length) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $8Z43Z.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                            const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
                            decs.push((0, $8nvEM.Decoration).widget(cell + pos + 2, ()=>{
                                const element = document.createElement('div');
                                element.setAttribute((0, $741bb5eed103c4d2$export$665a01df2c44393a), `${index}`);
                                element.classList.add((0, $741bb5eed103c4d2$export$b61cb5d3425147f));
                                if (hasMergedCells) element.classList.add((0, $741bb5eed103c4d2$export$fb5c0ba8f0806db1));
                                let sortOrdered;
                                if (index === sort[tableId]?.index) sortOrdered = sort[tableId]?.direction;
                                else sortOrdered = (0, $7Meja.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(oldState);
                                nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $kSwu1.RawIntlProvider), {
                                        value: getIntl()
                                    }, (0, $cozmU.createElement)((0, $de4cf649ee0f73d1$export$25fb1502cf13990c), {
                                        isSortingAllowed: !hasMergedCells,
                                        sortOrdered: sortOrdered,
                                        onClick: ()=>{},
                                        onKeyDown: ()=>{},
                                        api: api
                                    })), element, decorationRenderKey);
                                return element;
                            }, {
                                destroy: (node)=>{
                                    nodeViewPortalProviderAPI.remove(decorationRenderKey);
                                },
                                type: 'sorting-decoration',
                                tableId: tableId
                            }));
                        });
                    });
                    decorations = (0, $8nvEM.DecorationSet).create(tr.doc, decs);
                }
                /**
         * Map the decorations to the new document if there are changes
         */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $d923efcd4eacd9e3$export$994e077cfffa9ab4,
        appendTransaction: (trs, oldState, newState)=>{
            // return newState.tr;
            const { mode: mode } = api?.editorViewMode?.sharedState.currentState() || {};
            if (mode !== 'view') return newState.tr;
            let allTables = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(newState)?.allTables || [];
            /**
       * If incoming changes have affected a table node, remove the sorting. This prevents the
       * table from breaking if changes like merged cells are incoming.
       */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(oldState);
                const newPluginState = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(newState);
                for (const table of allTables){
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = oldPluginState?.sort?.[tableId] || {};
                    if (isChangesIncoming) {
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = maybeTableNode?.attrs?.localId !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $e8e39496c5f47790$export$8bb6f5de29aeee1e)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
           * Sort the table if the sort order has changed
           */ const { order: newOrder, direction: newDirection, index: newIndex } = newPluginState?.sort?.[tableId] || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $7Meja.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $e8e39496c5f47790$export$8bb6f5de29aeee1e)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody?.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO: ED-26961 - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        const pluginState = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                        (0, $e8e39496c5f47790$export$e9466f5bf01e21a7)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    const pluginState = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                    (0, $e8e39496c5f47790$export$e9466f5bf01e21a7)(view, event, pluginState);
                }
            },
            decorations (state) {
                const decs = (0, $d923efcd4eacd9e3$export$994e077cfffa9ab4).getState(state)?.decorations || (0, $8nvEM.DecorationSet).empty;
                return decs;
            }
        }
    });
};









var $h75sz = parcelRequire("h75sz");


var $ajK0g = parcelRequire("ajK0g");





var $aiyg1 = parcelRequire("aiyg1");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
























var $7XIuB = parcelRequire("7XIuB");


var $ldbHR = parcelRequire("ldbHR");








var $7sJoX = parcelRequire("7sJoX");
























/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766









var $kAPZe = parcelRequire("kAPZe");






var $fmXA0 = parcelRequire("fmXA0");




var $jyNaC = parcelRequire("jyNaC");

var $6hOaa = parcelRequire("6hOaa");




/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $cc560653dbfeebda$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #292A2E)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #3B3D42)"};
  }
`;

















/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766














const $9745b7caeebc31f4$var$roundedTableCellCornerStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{>tbody>tr>td[data-reaches-top][data-reaches-left],>tbody>tr>th[data-reaches-top][data-reaches-left]{border-top-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-top][data-reaches-right],>tbody>tr>th[data-reaches-top][data-reaches-right]{border-top-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-left],>tbody>tr>th[data-reaches-bottom][data-reaches-left]{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-right],>tbody>tr>th[data-reaches-bottom][data-reaches-right]{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);}}}");
/**
 * Interaction-overlay corner rounding only styles (the `::after` / `::before` / hover-danger
 * pseudo-elements), split out of {@link roundedTableCellCornerStyles}.
 *
 * The base cell `border-*-radius` rules are emitted from the SSR-rendered
 * `EditorContentContainer` (see `tableRoundedCornerStyles` in editor-core) so corners are
 * rounded server-side. These overlay rules only apply during interaction (node selection
 * wash, hover-to-delete danger highlight), which require a live editorView and therefore
 * never render during SSR — so they intentionally stay in the client-only `<Global>` styles
 * to avoid shipping dead CSS in the SSR payload.
 */ const $9745b7caeebc31f4$var$roundedTableCellCornerInteractionOverlayStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{>tbody>tr>td[data-reaches-top][data-reaches-left],>tbody>tr>th[data-reaches-top][data-reaches-left]{&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-top][data-reaches-right],>tbody>tr>th[data-reaches-top][data-reaches-right]{&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-left],>tbody>tr>th[data-reaches-bottom][data-reaches-left]{&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-right],>tbody>tr>th[data-reaches-bottom][data-reaches-right]{&::after,&::before,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);}}}");
const $9745b7caeebc31f4$var$roundedTableInteractionOverlayStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "::after,th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "::after{border:1px solid var(--ds-border-selected, #1868DB);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f);content:'';position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;width:auto;height:auto;z-index:", (0, $7Y8M5.akEditorSmallZIndex), ";pointer-events:none;}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, "::after,td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after,th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after,th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, "::after,th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;}>tbody>tr>td:is(\n\t\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ", .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ", .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "\n\t\t\t),>tbody>tr>th:is(\n\t\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ", .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ", .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "\n\t\t\t){&[data-reaches-top]{border-top-color:transparent;&::after{top:-1px;bottom:-1px;border-top-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}}&[data-reaches-left]{border-left-color:transparent;&::after{border-left-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}}&[data-reaches-right]{border-right-color:transparent;&::after{border-right-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}}&[data-reaches-bottom]{border-bottom-color:transparent;&::after{border-bottom-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}}}>tbody>tr>td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",>tbody>tr>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{&[data-reaches-top]{border-top-color:transparent;&::after{top:-1px;bottom:-1px;border-top-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}}&[data-reaches-left]{border-left-color:transparent;&::after{border-left-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}}&[data-reaches-right]{border-right-color:transparent;&::after{border-right-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}}&[data-reaches-bottom]{border-bottom-color:transparent;&::after{border-bottom-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}}}}");
const $9745b7caeebc31f4$var$roundedTableSelectedNodeStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), ">[data-testid='table-alignment-container']>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RESIZER_CONTAINER, ">.resizer-item>.resizer-hover-zone>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{&::after{border-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}>tbody>tr>td,>tbody>tr>th{position:relative;border-color:transparent;&::after{content:'';position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;border:1px solid ", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";background:", (0, $deb80ec534adbdde$export$f26d047169b4195d), ";z-index:", (0, $7Y8M5.akEditorSmallZIndex), ";pointer-events:none;}}}");
const $9745b7caeebc31f4$var$roundedTableNumberedColumnStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{position:relative;border-left:0;&::before{content:'';position:absolute;top:0;left:0;bottom:0;width:100%;border-left:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";border-top-left-radius:var(--ds-radius-xlarge, 12px);border-bottom-left-radius:var(--ds-radius-xlarge, 12px);pointer-events:none;z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left-color:transparent;}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE, ",>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active,>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active{border-left-color:transparent;}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr>th[data-reaches-top][data-reaches-left],>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr>td[data-reaches-top][data-reaches-left]{border-top-left-radius:0;&::after{border-top-left-radius:0;}}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr>th[data-reaches-bottom][data-reaches-left],>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr>td[data-reaches-bottom][data-reaches-left]{border-bottom-left-radius:0;&::after,&::before{border-bottom-left-radius:0;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ":first-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE, ":first-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active:first-of-type{border-top-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":last-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ":last-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE, ":last-of-type,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active:last-of-type{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ":first-of-type::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ":last-of-type::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr th[data-reaches-top][data-reaches-left]::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}");
const $9745b7caeebc31f4$var$roundedTableStickyHeaderCellCornerStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky{>th[data-reaches-left],>td[data-reaches-left]{border-top-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>td[data-reaches-right],>th[data-reaches-right]{border-top-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{border-left-color:transparent;}");
const $9745b7caeebc31f4$var$roundedTableStickyHeaderNumberColumnStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr th[data-reaches-top][data-reaches-left]::before,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, " th[data-reaches-left]::before,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, " th[data-reaches-left]::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);border-bottom:none;}");
const $9745b7caeebc31f4$var$roundedTableStickyHeaderCornerMaskStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, "{display:none;position:sticky;top:calc(", (0, $k8PFz.tableMarginTop), "px - 1px);width:12px;height:12px;margin-bottom:-12px;background:var(--ds-surface, #FFFFFF);pointer-events:none;z-index:", (0, $deb80ec534adbdde$export$a13fb25a398e2fab), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, "[data-corner='left']{margin-left:-", (0, $7Y8M5.akEditorTableNumberColumnWidth), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, "[data-corner='right']{left:calc(100% - 11px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(> table > tbody > tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ")>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(> table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " > tbody > tr.sticky)>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, "{display:block;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(> table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " > tbody > tr.sticky)>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CORNER_MASK, "{position:fixed;top:30px;z-index:1;}");
const $9745b7caeebc31f4$var$roundedTableStickyHeaderOverlayStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top]::after,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top]::after{content:'';position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;pointer-events:none;border-top-width:1px;border-top-style:solid;border-top-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top]:is(\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ",\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "\n\t\t)::after,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top]:is(\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ",\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ACTIVE_CURSOR_CELL, "\n\t\t)::after{border-top-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top].", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top].", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{border-top-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}:where(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, " > table > tbody > tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-left]::after{border-left-color:transparent;}", (0, $ixfCV.fg)('platform_editor_table_q4_patch_1') ? /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top]::after,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top]::after{border-top-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}") : '', ";");
const $9745b7caeebc31f4$var$roundedTableStickyHeaderShadowStyles = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky{box-shadow:inset 0 -1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), "!important;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, "{box-shadow:inset 0 -1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f)!important;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top],.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ">td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top],.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-top],.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-top]{border-top-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-left],.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-left]{border-left-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "[data-reaches-right],.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "[data-reaches-right]{border-right:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "{border-bottom:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, ":has(tr.sticky) .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type{box-shadow:none!important;}", (0, $ixfCV.fg)('platform_editor_table_q4_patch_1') ? /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody>tr.sticky{box-shadow:inset 0 -1px ", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), "!important;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, ".", (0, $7Y8M5.akEditorSelectedNodeClassName), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, "{box-shadow:inset 0 -1px ", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f)!important;}") : '', ";");
const $9745b7caeebc31f4$export$c72b32764860aa67 = ()=>/*#__PURE__*/ (0, $lOiVq.css)((0, $ixfCV.fg)('platform_editor_table_q4_patch_1') ? // Base corner radius is emitted from the SSR-rendered EditorContentContainer
    // (tableRoundedCornerStyles in editor-core); only the interaction overlays remain here.
    $9745b7caeebc31f4$var$roundedTableCellCornerInteractionOverlayStyles() : $9745b7caeebc31f4$var$roundedTableCellCornerStyles(), " ", $9745b7caeebc31f4$var$roundedTableInteractionOverlayStyles(), " ", (0, $ixfCV.fg)('platform_editor_table_q4_patch_1') ? $9745b7caeebc31f4$var$roundedTableSelectedNodeStyles() : '', " ", $9745b7caeebc31f4$var$roundedTableNumberedColumnStyles(), " ", $9745b7caeebc31f4$var$roundedTableStickyHeaderCellCornerStyles(), " ", $9745b7caeebc31f4$var$roundedTableStickyHeaderNumberColumnStyles(), " ", $9745b7caeebc31f4$var$roundedTableStickyHeaderCornerMaskStyles(), " ", $9745b7caeebc31f4$var$roundedTableStickyHeaderOverlayStyles(), " ", $9745b7caeebc31f4$var$roundedTableStickyHeaderShadowStyles(), ";");


/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766














function $4349cb0621f20c58$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4349cb0621f20c58$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{background:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";display:none;position:absolute;z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";", cssString, ";}");
const $4349cb0621f20c58$var$Marker = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $deb80ec534adbdde$export$60473ec4f7c2b794),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $deb80ec534adbdde$export$a3e71c692f2c2213)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $deb80ec534adbdde$export$a3e71c692f2c2213)}px`,
        borderRadius: "var(--ds-radius-full, 9999px)",
        pointerEvents: 'none'
    });
const $4349cb0621f20c58$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER, "{", $4349cb0621f20c58$var$Marker(), ";", cssString, ";}");
const $4349cb0621f20c58$var$Button = (cssString)=>/*#__PURE__*/ (0, $lOiVq.css)("border-radius:var(--ds-radius-small, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $4349cb0621f20c58$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background:", (0, $deb80ec534adbdde$export$95883e661e73a1d1), ";border:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $deb80ec534adbdde$export$8c5dd0fc35774ae1), ";border-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";}");
const $4349cb0621f20c58$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $deb80ec534adbdde$export$8c5dd0fc35774ae1), ";border-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";cursor:pointer;}");
const $4349cb0621f20c58$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background-color:", (0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50), ";border-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";position:relative;z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}");
const $4349cb0621f20c58$var$InsertButton = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $7Y8M5.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{height:", (0, $deb80ec534adbdde$export$6d23b13c5fcb846c), "px;width:", (0, $deb80ec534adbdde$export$6d23b13c5fcb846c), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{", $4349cb0621f20c58$var$Button(`
      background: ${"var(--ds-surface-overlay, #FFFFFF)"};
      box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
      color: ${"var(--ds-icon, #292A2E)"};
    `), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:flex;}");
const $4349cb0621f20c58$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $4349cb0621f20c58$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $7Y8M5.akEditorUnitZIndex) + 10, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, "{", $4349cb0621f20c58$var$Button(`
    background: ${"var(--ds-surface-overlay, #FFFFFF)"};
    color: ${"var(--ds-icon, #292A2E)"};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
    border-radius: 50%;
    height: ${(0, $deb80ec534adbdde$export$d18320cc8ee69115)}px;
    width: ${(0, $deb80ec534adbdde$export$d18320cc8ee69115)}px;
  `), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);border:1px solid var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $4349cb0621f20c58$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 99, ";&.active .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #1868DB);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFFFFF);background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);border-radius:2px;width:5px;height:5px;position:relative;}");
const $4349cb0621f20c58$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $4349cb0621f20c58$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $4349cb0621f20c58$var$InsertLine(`
    height: 2px;
    top: -11px;
	${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    left: ${(0, $deb80ec534adbdde$export$6d23b13c5fcb846c) - 1}px;
  `));
const $4349cb0621f20c58$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $4349cb0621f20c58$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{height:", (0, $deb80ec534adbdde$export$cb376ed67c7ae37e), "px;width:", (0, $deb80ec534adbdde$export$cb376ed67c7ae37e), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{", $4349cb0621f20c58$var$Button(`
        background: ${(0, $deb80ec534adbdde$export$cd5e5900c9fa42dc)};
        color: ${(0, $deb80ec534adbdde$export$a699493d7d7580c3)};
      `), ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $deb80ec534adbdde$export$9907ca2ad437ddcc), ";color:", (0, $deb80ec534adbdde$export$6cc2aa96833a5989), ";cursor:pointer;}");
const $4349cb0621f20c58$export$f802e22253ad2b2c = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $k8PFz.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $k8PFz.tableMarginTop), "px;z-index:", (0, $7Y8M5.akEditorShadowZIndex), ";width:", (0, $deb80ec534adbdde$export$1680d391e1ce7b96), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{background:linear-gradient(to left, transparent 0, var(--ds-shadow-overflow-spread, #1E1F2129) 140%),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, #1E1F211f) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, ").", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:", (0, $7Y8M5.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{background:linear-gradient(to right, transparent 0, var(--ds-shadow-overflow-spread, #1E1F2129) 140%),linear-gradient(to left, var(--ds-shadow-overflow-perimeter, #1E1F211f) 0px, transparent 1px);left:calc(100% - ", (0, $deb80ec534adbdde$export$1680d391e1ce7b96), "px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}}");
const $4349cb0621f20c58$export$b9641ea8858d4b62 = (tableOverflowShadowWidth)=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", tableOverflowShadowWidth, "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}");
const $4349cb0621f20c58$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $deb80ec534adbdde$export$95883e661e73a1d1),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $4349cb0621f20c58$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        color: "var(--ds-text-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $deb80ec534adbdde$export$8c5dd0fc35774ae1),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $deb80ec534adbdde$export$83da30a15600a83e)
    });
const $4349cb0621f20c58$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)("tr th:last-child .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;width:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $4349cb0621f20c58$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $4349cb0621f20c58$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)("div.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;width:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px;right:-1px;}");
};
const $4349cb0621f20c58$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $deb80ec534adbdde$export$62374dd2f63076b0) + (0, $k8PFz.tableCellBorderWidth), "px;height:", (0, $deb80ec534adbdde$export$62374dd2f63076b0), "px;&::before{content:' ';background-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;width:", (0, $deb80ec534adbdde$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $4349cb0621f20c58$var$columnHeaderButton(`
        border-right: ${(0, $k8PFz.tableCellBorderWidth)}px solid ${(0, $deb80ec534adbdde$export$60473ec4f7c2b794)};
        border-top: ${(0, $k8PFz.tableCellBorderWidth)}px solid ${(0, $deb80ec534adbdde$export$60473ec4f7c2b794)};
        border-bottom: ${(0, $k8PFz.tableCellBorderWidth)}px solid ${(0, $deb80ec534adbdde$export$60473ec4f7c2b794)};
        box-sizing: content-box;
        height: ${(0, $deb80ec534adbdde$export$a4d60e31f4f6188b) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $deb80ec534adbdde$export$62374dd2f63076b0) - (0, $deb80ec534adbdde$export$a4d60e31f4f6188b)}px;
        left: 0px;
        z-index: ${(0, $deb80ec534adbdde$export$da0ccd381b1a80f)};
      `), ";}}", $4349cb0621f20c58$var$getFloatingDotOverrides(), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_TABLE, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $4349cb0621f20c58$var$columnHeaderButtonSelected(), ";}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50), ";border-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $4349cb0621f20c58$var$columnHeaderButtonSelected(), ";border-left:", (0, $k8PFz.tableCellBorderWidth), "px solid ", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";left:-", (0, $k8PFz.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $4349cb0621f20c58$var$columnHeaderButtonSelected(), ";}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50), ";border-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";border-left:", (0, $k8PFz.tableCellBorderWidth), "px solid ", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";left:-", (0, $k8PFz.tableCellBorderWidth), "px;z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 100, ";}}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $4349cb0621f20c58$var$columnHeaderButtonSelected(), ";}}");
};
const $4349cb0621f20c58$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, "{", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};`, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";border:1px solid ", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";border:1px solid ", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";}}}");
const $4349cb0621f20c58$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, "{position:relative;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};`, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{position:relative;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};`, ";}}");
const $4349cb0621f20c58$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $lOiVq.css)(":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING, "{background-color:var(--ds-background-warning, #FFF5DB)!important;border:1px solid var(--ds-border-warning, #E06C00);}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $4349cb0621f20c58$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)("th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";top:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px;}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $deb80ec534adbdde$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px);background-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";z-index:", (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2, ";top:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px;}");
};
const $4349cb0621f20c58$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $deb80ec534adbdde$export$72409f838e9c33c7), "px;height:100%;top:0;right:-", (0, $deb80ec534adbdde$export$72409f838e9c33c7) / 2, "px;cursor:col-resize;z-index:", (0, $deb80ec534adbdde$export$887c1388be90c08e), ";}tr th:last-child .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $deb80ec534adbdde$export$72409f838e9c33c7) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $deb80ec534adbdde$export$887c1388be90c08e), ";}", $4349cb0621f20c58$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px;height:calc(100% + ", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + (0, $k8PFz.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $4349cb0621f20c58$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $k8PFz.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $deb80ec534adbdde$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2
});
const $4349cb0621f20c58$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $deb80ec534adbdde$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $k8PFz.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $deb80ec534adbdde$export$da0ccd381b1a80f) * 2
});
const $4349cb0621f20c58$var$insertLineActiveColor = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb)
});
const $4349cb0621f20c58$var$insertLineInactiveColor = {
    name: "5t20g5",
    styles: "background-color:var(--ds-background-accent-gray-subtler, #DDDEE1)"
};
const $4349cb0621f20c58$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $k8PFz.tableCellBorderWidth), "px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " top:-1px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " top:-1px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " top:-1px;", $4349cb0621f20c58$var$insertLineActiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " top:-1px;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " bottom:0;", $4349cb0621f20c58$var$insertLineActiveColor, ";}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " bottom:0;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " bottom:0;", $4349cb0621f20c58$var$insertLineActiveColor, ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $4349cb0621f20c58$var$tableCellRowInsertLineStyles, " bottom:0;", $4349cb0621f20c58$var$insertLineInactiveColor, ";}}");


const $0935dfe4dac9e048$var$cornerControlHeight = (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1;
const $0935dfe4dac9e048$export$af45328890cf2a82 = (0, $deb80ec534adbdde$export$6d23b13c5fcb846c) / 2;
const $0935dfe4dac9e048$export$cc4d06b9af7cea87 = 44;
// Shared styling for numbered column buttons in selected state
const $0935dfe4dac9e048$var$numberedColumnButtonSelectedStyles = `
	border-bottom: 1px solid ${(0, $deb80ec534adbdde$export$9bf0891aaaf2fecb)};
	border-color: ${(0, $deb80ec534adbdde$export$9bf0891aaaf2fecb)};
	background-color: ${(0, $deb80ec534adbdde$export$8c5dd0fc35774ae1)};
	position: relative;
	z-index: ${(0, $7Y8M5.akEditorUnitZIndex)};
	color: ${"var(--ds-text-selected, #1868DB)"};
`;
const $0935dfe4dac9e048$var$rangeSelectionStyles = `
.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $7Y8M5.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $jyNaC.getSelectionStyles)([
    (0, $6hOaa.SelectionStyle).Blanket,
    (0, $6hOaa.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
// Q4 path: node selection is painted by roundedTableSelectedNodeStyles() (the .selectedCell model),
// so getSelectionStyles is omitted here and only native text-selection hiding is kept.
const $0935dfe4dac9e048$var$rangeSelectionStylesForRoundedTable = `
.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $7Y8M5.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $jyNaC.hideNativeBrowserTextSelectionStyles)}
  }
}
`;
const $0935dfe4dac9e048$var$rangeSelectionStylesForFakeBorders = `
.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $7Y8M5.akEditorSelectedNodeClassName)} .${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER},
.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $7Y8M5.akEditorSelectedNodeClassName)} .${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
	  background: ${(0, $7Y8M5.akEditorSelectedBorderColor)};
}
`;
const $0935dfe4dac9e048$var$sentinelStyles = `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $deb80ec534adbdde$export$62374dd2f63076b0)}px;
  }
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $deb80ec534adbdde$export$92421f8864c287b1) + (0, $deb80ec534adbdde$export$83c60dd0aac17107) + (0, $deb80ec534adbdde$export$e5ff276883773ffd) * 2 + 23}px;
  }
  &.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
    > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $deb80ec534adbdde$export$62374dd2f63076b0)}px;
    }
  }
}`;
const $0935dfe4dac9e048$var$stickyScrollbarSentinelStyles = `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
 > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $deb80ec534adbdde$export$62374dd2f63076b0) + $0935dfe4dac9e048$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $7Y8M5.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $0935dfe4dac9e048$var$stickyScrollbarContainerStyles = `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $0935dfe4dac9e048$var$stickyScrollbarStyles = `${$0935dfe4dac9e048$var$stickyScrollbarContainerStyles} ${$0935dfe4dac9e048$var$stickyScrollbarSentinelStyles}`;
const $0935dfe4dac9e048$var$shadowSentinelStyles = `
  .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $0935dfe4dac9e048$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(">*:not([data-mark-type='fragment']) .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $0935dfe4dac9e048$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)("th{.", (0, $741bb5eed103c4d2$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $741bb5eed103c4d2$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}>.", (0, $741bb5eed103c4d2$export$b61cb5d3425147f), "{.", (0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":hover)){>.", (0, $741bb5eed103c4d2$export$b61cb5d3425147f), "{.", (0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}}");
};
const $0935dfe4dac9e048$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $0935dfe4dac9e048$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $0935dfe4dac9e048$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    /*
  This is MAGIC!
  This fixes a bug which occurs in firefox when the first row becomes sticky.
  see https://product-fabric.atlassian.net/browse/ED-19177
   */ if (browser.gecko) return /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $0935dfe4dac9e048$var$baseTableStylesWithoutSharedStyle = (props)=>/*#__PURE__*/ (0, $lOiVq.css)((0, $4349cb0621f20c58$export$6114ba9f95ca48dc)(), ";", (0, $4349cb0621f20c58$export$4d63bf225990ad34)(), ";", (0, $4349cb0621f20c58$export$1c46f5412a5a3ae0)(), ";", (0, $4349cb0621f20c58$export$40edb32b62e4fb85), ";", (0, $4349cb0621f20c58$export$b9932a52fb1c7aad)(), ";", (0, $4349cb0621f20c58$export$8e36b812ea421d73)(), ";", // Only block getSelectionStyles when our replacement (gated by q4 + q4_patch_1) owns the
    // decoration, so node selection is never left unstyled.
    (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $ixfCV.fg)('platform_editor_table_q4_patch_1') ? $0935dfe4dac9e048$var$rangeSelectionStylesForRoundedTable : $0935dfe4dac9e048$var$rangeSelectionStyles, ";", $0935dfe4dac9e048$var$rangeSelectionStylesForFakeBorders, ";", $0935dfe4dac9e048$var$viewModeSortStyles(), ";", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `
		.ak-editor-panel:not([data-panel-type="custom"]) .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"};
		}
		.ak-editor-panel[data-panel-type="note"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"};
		}
		.ak-editor-panel[data-panel-type="tip"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"};
		}
		.ak-editor-panel[data-panel-type="warning"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"};
		}
		.ak-editor-panel[data-panel-type="error"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-red-subtlest, #FFECEB)"};
		}
		.ak-editor-panel[data-panel-type="success"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
			${0, $7Y8M5.akEditorTableContainerBg}: ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"};
		}
	` : '', " ", (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $0935dfe4dac9e048$var$tableAnchorStyles, ";.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ",th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, "{background-color:", (0, $deb80ec534adbdde$export$3efa753685336605), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";border-bottom:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $4349cb0621f20c58$export$d9daf73b486785b9)(), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $4349cb0621f20c58$export$595c9c01d7c39885)(), ";}", (0, $4349cb0621f20c58$export$cfa9a9cdd25b9d6e)(), " ", (0, $4349cb0621f20c58$export$6134f9ac8c9f161f)(), (0, $4349cb0621f20c58$export$d6f68d0fe29f8050)(), ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $deb80ec534adbdde$export$83c60dd0aac17107), "px;width:", (0, $7Y8M5.akEditorTableNumberColumnWidth), "px;position:fixed!important;z-index:", (0, $7Y8M5.akEditorStickyHeaderZIndex), "!important;box-shadow:0px -", (0, $deb80ec534adbdde$export$83c60dd0aac17107), "px ", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";border-right:0 none;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `
			width: ${(0, $7Y8M5.akEditorTableNumberColumnWidth) + 1}px;
			border-left: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};

			/* Keep the new fixed left border in sync with the selected/danger states,
			   which would otherwise leave it the default colour (.active recolours the
			   rest of the border) or drop it entirely (delete-hover sets border-left: 0). */
			&.active {
				border-left-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};
			}
			&.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER} {
				border-left: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};
			}
			` : '', ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $7Y8M5.akEditorSmallZIndex), "!important;background:", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";width:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;height:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;width:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;}", $0935dfe4dac9e048$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $0935dfe4dac9e048$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $7Y8M5.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px solid ", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";margin-left:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " col:first-of-type{border-right:1px solid ", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}tr.sticky{padding-top:", (0, $deb80ec534adbdde$export$83c60dd0aac17107), "px;position:fixed;display:grid;z-index:", (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";box-sizing:content-box;box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $deb80ec534adbdde$export$13b0e72269a9a3aa), "px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";margin-right:-1px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $0935dfe4dac9e048$export$af45328890cf2a82 + 1, "px;}", (0, $ieeJu.expValEquals)('platform_editor_table_col_insert', 'isEnabled', true) ? // Mask geometry mirrors the drag-handle wrapper geometry from
    // editor-plugin-block-controls/src/ui/drag-handle.tsx
    // (`buttonWrapperStyles`):
    //   height = paddingTop (=calc(space.400 - 1px)) + paddingBottom (=space.200) + DRAG_HANDLE_HEIGHT
    //   width  = DRAG_HANDLE_WIDTH + paddingRight('space.150')
    `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY}:has(tr.sticky)::before {
			content: ' ';
			position: sticky;
			pointer-events: none;
			top: 0;
			float: left;
			transform: translateX(calc(-1 * (${0, $kAPZe.DRAG_HANDLE_WIDTH}px + ${"var(--ds-space-150, 12px)"})));
			margin-bottom: calc(-1 * (${"var(--ds-space-400, 32px)"} - 1px + ${"var(--ds-space-200, 16px)"} + ${"var(--ds-space-300, 24px)"}));
			height: calc(${"var(--ds-space-400, 32px)"} - 1px + ${"var(--ds-space-200, 16px)"} + ${"var(--ds-space-300, 24px)"});
			width: calc(${0, $kAPZe.DRAG_HANDLE_WIDTH}px + ${"var(--ds-space-150, 12px)"});
			background: linear-gradient(
				to bottom,
				${(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)"} 90%,
				transparent
			);
			z-index: ${(0, $deb80ec534adbdde$export$45aeeddcedd441ab) + 5};
		}
		${(0, $ixfCV.fg)('platform_editor_col_insert_patch_1') ? // Shift the mask left by the numbered column width so it sits to the left of it.
    `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY}[data-number-column='true']:has(tr.sticky)::before {
			transform: translateX(calc(-1 * (${0, $kAPZe.DRAG_HANDLE_WIDTH}px + ${"var(--ds-space-150, 12px)"} + ${0, $7Y8M5.akEditorTableNumberColumnWidth}px)));
		}` : ``}` : ``, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, "{tr.sticky td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $deb80ec534adbdde$export$72409f838e9c33c7) - (0, $deb80ec534adbdde$export$45d9825f76985b4e)) / 2 + 1, "px;}}tr.sticky td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",tr.sticky th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $deb80ec534adbdde$export$72409f838e9c33c7) - (0, $deb80ec534adbdde$export$45d9825f76985b4e)) / 2, "px;}}}tr.sticky .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ",tr.sticky .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "{z-index:1;}tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{position:sticky;top:", (0, $k8PFz.tableMarginTop), "px;z-index:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $7Y8M5.akEditorSmallZIndex) : `calc(${0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex} - 5)`, ";box-shadow:inset -1px 1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}::after {
				height: 100%;
				content: '';
				border-left: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};
				border-bottom: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};
				position: absolute;
				right: 0px;
				top: 0px;
				bottom: 0;
				width: 100%;
				display: inline-block;
				pointer-events: none;
			}` : ``, ";&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, "{", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `z-index: ${0, $deb80ec534adbdde$export$a13fb25a398e2fab};` : '', " box-shadow:inset -1px 1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{content:' ';display:block;top:0;box-sizing:border-box;width:100%;height:0;margin-bottom:-", (0, $k8PFz.tableMarginTop), "px;position:sticky;border-top:", (0, $k8PFz.tableMarginTop), "px solid transparent;z-index:", (0, $deb80ec534adbdde$export$1279af870a198fea), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, ")::before{border-top:", (0, $k8PFz.tableMarginTop), "px solid ", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{top:", (0, $deb80ec534adbdde$export$9c3151841258b6f0), "px;z-index:", (0, $deb80ec534adbdde$export$471fb2a0b2f2f936), ";}", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_7') ? `
		.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER}:has(~ .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW}) {
			margin-top: 0;
		}
	` : ``, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-table-header-is-stuck='true']:has(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{z-index:", (0, $deb80ec534adbdde$export$7b64f35449327c05), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " ", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4') ? `tr.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY}` : '', ")>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{top:", (0, $deb80ec534adbdde$export$9c3151841258b6f0), "px;}.pm-table-wrapper:has([data-number-column='true'] tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{margin-left:-", (0, $7Y8M5.akEditorTableNumberColumnWidth), "px;width:calc(100% + ", (0, $7Y8M5.akEditorTableNumberColumnWidth), "px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, "[data-table-header-is-stuck='true'] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE, ":is([data-row-index='0'], [data-selected-row-index='0']:not([data-handle-appearance='default'])){visibility:hidden;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{top:", (0, $k8PFz.tableMarginTop), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $deb80ec534adbdde$export$880976487022eb5), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $deb80ec534adbdde$export$880976487022eb5), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{border-top:", (0, $deb80ec534adbdde$export$880976487022eb5) - (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px solid ", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}", $0935dfe4dac9e048$var$sentinelStyles, " ", (0, $4349cb0621f20c58$export$f802e22253ad2b2c)(), " ", $0935dfe4dac9e048$var$stickyScrollbarStyles, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $deb80ec534adbdde$export$e5ff276883773ffd), "px;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $deb80ec534adbdde$export$e5ff276883773ffd), "px;&::after{right:6px!important;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-4px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $deb80ec534adbdde$export$e5ff276883773ffd), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $7Y8M5.akEditorTableNumberColumnWidth) + (0, $deb80ec534adbdde$export$e5ff276883773ffd) - 1, "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", (0, $deb80ec534adbdde$export$40311377f05dbfc4), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}.", (0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER, "{left:8px;}.", (0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER, "{right:8px;}}>.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $0935dfe4dac9e048$var$breakoutWidthStyling(), " ", (0, $4349cb0621f20c58$export$8c8180e74f25db6a)(), ";", (0, $4349cb0621f20c58$export$a2258906ae78ec82)(), ";.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, "{width:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1, "px;height:", $0935dfe4dac9e048$var$cornerControlHeight, "px;display:none;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $4349cb0621f20c58$export$22ce45ffbca2b768)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1, "px;height:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1, "px;border:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";border-radius:0;border-top-left-radius:", (0, $deb80ec534adbdde$export$371da7842ff35a5b), "px;background:", (0, $deb80ec534adbdde$export$95883e661e73a1d1), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";background:", (0, $deb80ec534adbdde$export$8c5dd0fc35774ae1), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{width:", (0, $7Y8M5.akEditorTableToolbarSize) + (0, $7Y8M5.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";background:", (0, $deb80ec534adbdde$export$8c5dd0fc35774ae1), ";cursor:pointer;}:not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";background:", (0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{width:", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b), "px;box-sizing:border-box;display:none;position:relative;", (0, $4349cb0621f20c58$export$22ce45ffbca2b768)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $4349cb0621f20c58$export$c7c73467b57835d)(`
        border-bottom: 1px solid ${(0, $deb80ec534adbdde$export$60473ec4f7c2b794)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $deb80ec534adbdde$export$a4d60e31f4f6188b)}px;

        .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $deb80ec534adbdde$export$371da7842ff35a5b), "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $deb80ec534adbdde$export$45aeeddcedd441ab) + 4, ";.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{height:", (0, $deb80ec534adbdde$export$9c3151841258b6f0), "px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $deb80ec534adbdde$export$887c1388be90c08e), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:", (0, $deb80ec534adbdde$export$9c3151841258b6f0), "px;width:100%;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid var(--ds-surface, #FFFFFF);display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F0F1F2);}&>g>rect{fill:var(--ds-icon-disabled, #080F214A);}}}&:not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}g{fill:var(--ds-icon-subtle, #505258);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #4688EC);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #FD9891);}g{fill:var(--ds-border-inverse, #FFFFFF);}}}}}", (0, $4349cb0621f20c58$export$125caa90718a4ea9)(), " :not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{", (0, $4349cb0621f20c58$export$eb5435fbd56e8d4)(), " ", (0, $4349cb0621f20c58$export$7f243984d41e6570)(), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $7Y8M5.akEditorTableToolbarSize), "px;top:", props.isDragAndDropEnabled ? 0 : (0, $7Y8M5.akEditorTableToolbarSize), "px;width:", (0, $7Y8M5.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:", (0, $7Y8M5.relativeSizeToBaseFontSize)(10), " 2px;text-align:center;font-size:", (0, $7Y8M5.relativeSizeToBaseFontSize)(14), ";background-color:", (0, $deb80ec534adbdde$export$95883e661e73a1d1), ";color:", (0, $deb80ec534adbdde$export$14da8da34a807702), ";border-color:", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, ":first-of-type::after{content:'';display:block;height:33px;width:100%;background-color:var(--ds-surface, #FFFFFF);position:absolute;top:-34px;left:-1px;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{display:block;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active{", $0935dfe4dac9e048$var$numberedColumnButtonSelectedStyles, ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $deb80ec534adbdde$export$60473ec4f7c2b794), ";}}}", (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? `/* Apply numbered column styling when table is selected via text selection (e.g., block menu) */
	.${0, $7Y8M5.akEditorSelectedNodeClassName} {
		.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} {
			.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				${$0935dfe4dac9e048$var$numberedColumnButtonSelectedStyles}
				${0, $jyNaC.hideNativeBrowserTextSelectionStyles}
			}
		}
	}` : '', " :not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{", $0935dfe4dac9e048$var$numberedColumnButtonSelectedStyles, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50), ";border:1px solid ", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";border-left:0;color:var(--ds-text-danger, #AE2E24);position:relative;z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}}", (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? `.tableView-content-wrap.danger {
		:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING}) .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
			.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				background-color: ${0, $deb80ec534adbdde$export$e7bba7ffd7bf3c50};
				border: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};
				border-left: 0;
				color: ${"var(--ds-text-danger, #AE2E24)"};
				position: relative;
				z-index: ${0, $7Y8M5.akEditorUnitZIndex};
			}
		}
	}` : '', ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $7Y8M5.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "{", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};`, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $deb80ec534adbdde$export$f26d047169b4195d), ";z-index:", (0, $7Y8M5.akEditorSmallZIndex), ";}th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell border colors are handled by the ::after overlay in rounded mode. */  : `border-left-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d};
			border-top-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d};`, " &::after{height:100%;width:100%;border:1px solid ", (0, $deb80ec534adbdde$export$870d72a5700e711d), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 100, ";display:inline-block;pointer-events:none;background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";}}td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, ",td.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $7Y8M5.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $0935dfe4dac9e048$var$tableBorderStyles(), ";z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 100, ";background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";}&.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $0935dfe4dac9e048$var$tableBorderStyles(), ";z-index:", (0, $7Y8M5.akEditorUnitZIndex) * 100, ";background:", (0, $deb80ec534adbdde$export$3c2a828febe9d506), ";}}}", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $9745b7caeebc31f4$export$c72b32764860aa67)() : '', ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $k8PFz.tableMarginTop), "px;left:-", (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1, "px;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled ? `
			margin-top: ${0, $k8PFz.tableMarginTop}px;
			top: 0;
			left: -${(0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $k8PFz.tableMarginTop) - $0935dfe4dac9e048$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $deb80ec534adbdde$export$a4d60e31f4f6188b}px;
		`, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $k8PFz.tableMarginTop), "px;}", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `
	.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $k8PFz.tableMarginTop}px;
		background: ${(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)"};
		top: unset;
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $deb80ec534adbdde$export$a13fb25a398e2fab) + 1};
		${(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `
		/* Leave a 1px gap so the sticky header row's top border stays visible. */
		translate: 0 -1px;` : ``}
	}` : `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $k8PFz.tableMarginTop}px;
		background: ${(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)"};
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $deb80ec534adbdde$export$a13fb25a398e2fab) + 1};
		${(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `
		/* Leave a 1px gap so the sticky header row's top border stays visible. */
		margin-bottom: 1px;` : ``}
	}`, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ">.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "::before{content:'';position:relative;display:inline-block;margin-left:-", (0, $7Y8M5.akEditorTableNumberColumnWidth) + (0, $deb80ec534adbdde$export$c2ef52861254b274), "px;width:", (0, $7Y8M5.akEditorTableNumberColumnWidth) + (0, $deb80ec534adbdde$export$c2ef52861254b274), "px;height:", (0, $k8PFz.tableMarginTop), "px;background:", (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $7Y8M5.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";z-index:", (0, $deb80ec534adbdde$export$a13fb25a398e2fab) - 1, ";}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type::before{content:'';position:absolute;display:inline-block;box-sizing:border-box;left:0;width:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `${0, $7Y8M5.akEditorTableNumberColumnWidth}px` : `${(0, $7Y8M5.akEditorTableNumberColumnWidth) - 1}px`, ";height:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? 'calc(100% + 2px)' : '100%', ";margin-left:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `-${(0, $7Y8M5.akEditorTableNumberColumnWidth) + 1}px` : `-${0, $7Y8M5.akEditorTableNumberColumnWidth}px`, ";", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $ixfCV.fg)('platform_editor_table_q4_patch_2') ? // Anchor the mask with an explicit `top` so `vertical-align` (data-valign) on the cell
    // doesn't shift it; the calc reproduces the previous top-aligned offset.
    `top: calc(${"var(--ds-space-100, 8px)"} - ${(0, $deb80ec534adbdde$export$83c60dd0aac17107) + 1}px);` : `margin-top: -${(0, $deb80ec534adbdde$export$83c60dd0aac17107) + 1}px;` : `margin-top: -${0, $deb80ec534adbdde$export$83c60dd0aac17107}px;`, " outline:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? 'none' : (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `0.5px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}` : `1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}`, ";border-left:", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}` : (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? 'none' : `1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794}`, ";", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};` : ``, " background:var(--ds-background-accent-gray-subtlest, #F0F1F2);", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};` : ``, " ", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) || (0, $8dxef.getBrowserInfo)().gecko && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `border-top: 1px solid ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};` : `border-top: none;`, ";}", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_7') ? `.ak-editor-selected-node .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"]:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED}) .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type {
			/* Recolour the number-column corner mask to match the selected cells. Keep this identical
			   to the .selectedCell ::before rule below \u{2014} never set margin-top (the base negative
			   margin aligns the mask) or radius (rounded generically by data-reaches-* rules). */
			&::before {
				outline: none;
				border-left-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};
				${(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};` : ''}
				${(0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};` : ''}
				background: ${0, $deb80ec534adbdde$export$7c0a2e8110d12a28};
			}
	}` : '', " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "):first-of-type::before,.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ", .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED, "):first-of-type::before{outline:none;border-left-color:", (0, $deb80ec534adbdde$export$9bf0891aaaf2fecb), ";", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb}` : '', ";", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top-color: ${0, $deb80ec534adbdde$export$9bf0891aaaf2fecb};` : ``, " background:", (0, $deb80ec534adbdde$export$7c0a2e8110d12a28), ";}", (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:first-of-type::before, .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
			outline: none;
			${(0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $ixfCV.fg)('platform_editor_table_q4_patch_2') ? // Recolour the corner edges to the delete border and composite the translucent danger
    // fill over the mask's gray so it matches the adjacent cells instead of reading as transparent.
    `border-left: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};
							border-top: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};
							border-bottom: 1px solid ${0, $deb80ec534adbdde$export$870d72a5700e711d};
							background-color: ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"};
							background-image: linear-gradient(${0, $deb80ec534adbdde$export$3c2a828febe9d506}, ${0, $deb80ec534adbdde$export$3c2a828febe9d506});` : `border-left: unset;
						border-top: unset;
						background: ${0, $deb80ec534adbdde$export$3c2a828febe9d506};`}
		}
		.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_SELECTED}.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type::before, .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
		outline: none;
		border-left-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d};
		border-top-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d};
		background: ${0, $deb80ec534adbdde$export$3c2a828febe9d506};
		}` : `	.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				background: ${0, $deb80ec534adbdde$export$3c2a828febe9d506};
			}
			.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				border-left-color: ${0, $deb80ec534adbdde$export$870d72a5700e711d};
				background: ${0, $deb80ec534adbdde$export$3c2a828febe9d506};
		}`, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, " th:first-of-type::before{box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, ":not(.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, " *){margin-top:", (0, $k8PFz.tableMarginTop), "px!important;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_6') ? `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).WITH_CONTROLS}:has(tr.sticky) .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			box-shadow: 0 -5px 0 1px ${0, $deb80ec534adbdde$export$60473ec4f7c2b794};
		}` : ``, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;z-index:", (0, $7Y8M5.akEditorUnitZIndex), ";}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, "{overflow:visible;}");
const $0935dfe4dac9e048$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $lOiVq.css)((0, $k8PFz.tableSharedStyle)(), ";", $0935dfe4dac9e048$var$baseTableStylesWithoutSharedStyle(props), ";");
const $0935dfe4dac9e048$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $lOiVq.css)(".ProseMirror{", $0935dfe4dac9e048$var$baseTableStylesWithoutSharedStyle(props), ";}.ProseMirror.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).IS_RESIZING, "{.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $cc560653dbfeebda$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).RESIZE_CURSOR, "{cursor:col-resize;}", $0935dfe4dac9e048$var$shadowSentinelStyles, ";");
const $0935dfe4dac9e048$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $lOiVq.css)(".ProseMirror .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $0935dfe4dac9e048$export$61a2da566f69d1df = /*#__PURE__*/ (0, $lOiVq.css)(".ProseMirror .", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $cc560653dbfeebda$export$b2380b18b089518f), ";}");
const $0935dfe4dac9e048$var$tableAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)(".pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableHeader']{anchor-name:var(", (0, $2XHKU.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}.pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableRow']{anchor-name:var(", (0, $2XHKU.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}");


const $e87d4d9dc8a16cab$var$BUTTON_WIDTH = 20;
const $e87d4d9dc8a16cab$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $e87d4d9dc8a16cab$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $e87d4d9dc8a16cab$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $cozmU.useRef)(null);
    const observerTargetRef = (0, $cozmU.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $cozmU.useRef)(0);
    const leftPosDataRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $e87d4d9dc8a16cab$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $0935dfe4dac9e048$export$af45328890cf2a82)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $LQnOI.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = 0;
    const containerLeft = (0, $cozmU.useMemo)(()=>{
        const container = targetCellRef.closest('[data-editor-container="true"]');
        return container?.getBoundingClientRect().left || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $cozmU.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $e87d4d9dc8a16cab$export$ed0fda2c59cbba0f({
            buttonWidth: $e87d4d9dc8a16cab$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: fixedButtonRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            top: fixedButtonTop + stickyHeader.padding + offset * 2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex),
            left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON_FIXED
    }, children)), mountTo);
};
var $e87d4d9dc8a16cab$export$2e2bcd8739ae039 = $e87d4d9dc8a16cab$export$c947181980f67d40;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







function $d7b5475d1a9abb21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d7b5475d1a9abb21$export$554a9cb1559eb2d5 = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: "var(--ds-surface, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-small, 4px)" : "var(--ds-radius-small, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $deb80ec534adbdde$export$3969371f057ce1e5) + 2}px`,
            width: "var(--ds-space-250, 20px)",
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, #0515240F)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${"var(--ds-surface, #FFFFFF)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-xsmall, 2px)" : '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
var $d7b5475d1a9abb21$var$_ref = {
    name: "lb8dok",
    styles: "&& button{background:var(--ds-background-selected, #E9F2FE);}&& button:hover{background:var(--ds-background-selected-hovered, #CFE1FD);}&& button:active{background:var(--ds-background-selected-pressed, #8FB8F6);}"
};
const $d7b5475d1a9abb21$export$cd6af2ca27c1a823 = ()=>$d7b5475d1a9abb21$var$_ref;


const $b2935b967c63bed2$var$BUTTON_OFFSET = 3;
const $b2935b967c63bed2$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX = 2;
const $b2935b967c63bed2$var$anchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    positionVisibility: 'anchors-visible',
    zIndex: $b2935b967c63bed2$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX
});
const $b2935b967c63bed2$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { api: api, editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const { activeTableMenu: activeTableMenu } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>({
            activeTableMenu: states.tableState?.activeTableMenu
        }));
    const isCellMenuOpen = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? activeTableMenu?.type === 'cell' : isContextualMenuOpen;
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if (!api) return;
            const { activeTableMenu: currentActiveTableMenu } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            api.core.actions.execute(({ tr: tr })=>{
                (0, $4c617ebfadab8027$export$5744ca63af11af1a)({
                    type: 'cell',
                    openedBy: 'mouse'
                }, currentActiveTableMenu, api)({
                    tr: tr
                });
                return tr;
            });
            return;
        }
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $bjg0G.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $cozmU.useEffect)(()=>{
        if (isCellMenuOpenByKeyboard && !isCellMenuOpen) {
            const { state: state, dispatch: dispatch } = editorView;
            // open the menu when the keyboard shortcut is pressed
            if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                if (!api) return;
                const { activeTableMenu: currentActiveTableMenu } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                api.core.actions.execute(({ tr: tr })=>{
                    (0, $4c617ebfadab8027$export$5744ca63af11af1a)({
                        type: 'cell',
                        openedBy: 'keyboard'
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
                return;
            }
            (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
        }
    }, [
        isCellMenuOpenByKeyboard,
        isCellMenuOpen,
        editorView,
        api
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $fKJ7J.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $d7b5475d1a9abb21$export$554a9cb1559eb2d5)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isCellMenuOpen && (0, $d7b5475d1a9abb21$export$cd6af2ca27c1a823)()
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON,
        selected: isCellMenuOpen,
        title: labelCellOptions,
        keymap: (0, $ldqjS.focusToContextMenuTrigger),
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": isCellMenuOpen,
        // Stable anchor used by the Post Office changeboarding spotlight
        // (cc-editor-table-cell-menu-changes) to target the cell options button.
        testId: (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? 'pm-table-contextual-menu-button' : undefined
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    const parentStickyNative = targetCellRef.parentElement && ((0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4') ? tableWrapper?.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) : targetCellRef.parentElement.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NATIVE_STICKY));
    if (parentStickyNative && targetCellRef.nodeName === 'TH' && (0, $742cd3b7e186e5d1$export$2ee7329d46115d8f)() && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        /* We need to default to checking the anchor style because there may be a conflict with the block controls
     plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
     */ let rowAnchorName = targetCellRef.parentElement?.style.getPropertyValue('anchor-name');
        let colAnchorName = targetCellRef.style.getPropertyValue('anchor-name');
        if (rowAnchorName === '') rowAnchorName = targetCellRef.parentElement?.dataset.nodeAnchor;
        if (colAnchorName === '') colAnchorName = targetCellRef?.dataset.nodeAnchor;
        if (!(0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $b2935b967c63bed2$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$b2935b967c63bed2$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$b2935b967c63bed2$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
        if (rowAnchorName && colAnchorName) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $b2935b967c63bed2$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$b2935b967c63bed2$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$b2935b967c63bed2$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
    }
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $e87d4d9dc8a16cab$export$2e2bcd8739ae039), {
        offset: $b2935b967c63bed2$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isCellMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            $b2935b967c63bed2$var$BUTTON_OFFSET,
            -$b2935b967c63bed2$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $7Y8M5.akEditorSmallZIndex)
    }, button);
});
const $b2935b967c63bed2$var$FloatingContextualButton = (0, $kSwu1.injectIntl)($b2935b967c63bed2$var$FloatingContextualButtonInner);
function $b2935b967c63bed2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $h75sz.ErrorBoundary), {
        component: (0, $krYZG.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($b2935b967c63bed2$var$FloatingContextualButton, props));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


































var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $3v5aK = parcelRequire("3v5aK");





const $bf9c2f49f53f3f37$export$200ea9e754d6f884 = {
    type: 'menu-item',
    key: 'background-color'
};
const $bf9c2f49f53f3f37$export$7c71e4184715e790 = {
    type: 'menu-item',
    key: 'clear-cells'
};


const $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa = {
    type: 'menu',
    key: 'column-handle-menu'
};
const $495b1900dd6e1ce7$export$868359cdd46b8e96 = {
    type: 'menu-section',
    key: 'column-toggle-section'
};
const $495b1900dd6e1ce7$export$b9f73083561c9b45 = {
    type: 'menu-section',
    key: 'column-background-section'
};
const $495b1900dd6e1ce7$export$d76bf3eb1cb3622e = {
    type: 'menu-section',
    key: 'column-sort-section'
};
const $495b1900dd6e1ce7$export$10cac5e3b97c49c5 = {
    type: 'menu-section',
    key: 'column-add-section'
};
const $495b1900dd6e1ce7$export$139af6cfa83a6c0c = {
    type: 'menu-section',
    key: 'column-danger-section'
};
const $495b1900dd6e1ce7$export$d6f0842ac421fece = {
    [$495b1900dd6e1ce7$export$868359cdd46b8e96.key]: 100,
    [$495b1900dd6e1ce7$export$b9f73083561c9b45.key]: 200,
    [$495b1900dd6e1ce7$export$d76bf3eb1cb3622e.key]: 300,
    [$495b1900dd6e1ce7$export$10cac5e3b97c49c5.key]: 400,
    [$495b1900dd6e1ce7$export$139af6cfa83a6c0c.key]: 500
};
const $495b1900dd6e1ce7$export$70437eab3a41306c = {
    type: 'menu-item',
    key: 'header-column-toggle'
};
const $495b1900dd6e1ce7$export$53f931b253816d5f = {
    type: 'menu-item',
    key: 'sort-increasing'
};
const $495b1900dd6e1ce7$export$bd9506c8b0be373c = {
    type: 'menu-item',
    key: 'sort-decreasing'
};
const $495b1900dd6e1ce7$export$313a331094e8e40 = {
    type: 'menu-item',
    key: 'add-column-left'
};
const $495b1900dd6e1ce7$export$369288a3adc8cde7 = {
    type: 'menu-item',
    key: 'add-column-right'
};
const $495b1900dd6e1ce7$export$e5b0244351372e94 = {
    type: 'menu-item',
    key: 'move-column-left'
};
const $495b1900dd6e1ce7$export$49af2aec08b8ed97 = {
    type: 'menu-item',
    key: 'move-column-right'
};
const $495b1900dd6e1ce7$export$82d2c16b28fc2c87 = {
    type: 'menu-item',
    key: 'distribute-columns'
};
const $495b1900dd6e1ce7$export$4d0f5768433488cd = {
    type: 'menu-item',
    key: 'delete-column'
};
const $495b1900dd6e1ce7$export$55d9aafd67ce68f = {
    [$495b1900dd6e1ce7$export$70437eab3a41306c.key]: 100
};
const $495b1900dd6e1ce7$export$bc1c17ea404e1e65 = {
    [(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]: 100
};
const $495b1900dd6e1ce7$export$dc7b7fa82abf029 = {
    [$495b1900dd6e1ce7$export$53f931b253816d5f.key]: 100,
    [$495b1900dd6e1ce7$export$bd9506c8b0be373c.key]: 200
};
const $495b1900dd6e1ce7$export$16082c766842f755 = {
    [$495b1900dd6e1ce7$export$313a331094e8e40.key]: 100,
    [$495b1900dd6e1ce7$export$369288a3adc8cde7.key]: 200,
    [$495b1900dd6e1ce7$export$e5b0244351372e94.key]: 300,
    [$495b1900dd6e1ce7$export$49af2aec08b8ed97.key]: 400,
    [$495b1900dd6e1ce7$export$82d2c16b28fc2c87.key]: 500
};
const $495b1900dd6e1ce7$export$7549083293c6b325 = {
    [(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]: 100,
    [$495b1900dd6e1ce7$export$4d0f5768433488cd.key]: 200
};



const $d0d78e4f78ab53f8$export$335a830a90e5dc34 = {
    type: 'menu',
    key: 'row-handle-menu'
};
const $d0d78e4f78ab53f8$export$87244e8119d8581c = {
    type: 'menu-section',
    key: 'row-toggle-section'
};
const $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6 = {
    type: 'menu-section',
    key: 'row-background-section'
};
const $d0d78e4f78ab53f8$export$d478a53ed2abe40f = {
    type: 'menu-section',
    key: 'row-add-section'
};
const $d0d78e4f78ab53f8$export$46ec42cba969242b = {
    type: 'menu-section',
    key: 'row-danger-section'
};
const $d0d78e4f78ab53f8$export$9de76c9f0172de51 = {
    [$d0d78e4f78ab53f8$export$87244e8119d8581c.key]: 100,
    [$d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6.key]: 200,
    [$d0d78e4f78ab53f8$export$d478a53ed2abe40f.key]: 300,
    [$d0d78e4f78ab53f8$export$46ec42cba969242b.key]: 400
};
const $d0d78e4f78ab53f8$export$f53435d29f0ad0a1 = {
    type: 'menu-item',
    key: 'header-row-toggle'
};
const $d0d78e4f78ab53f8$export$6b0a072235fdd804 = {
    type: 'menu-item',
    key: 'numbered-rows-toggle'
};
const $d0d78e4f78ab53f8$export$e4528482450d5f2e = {
    type: 'menu-item',
    key: 'add-row-above'
};
const $d0d78e4f78ab53f8$export$c0c87706fa348bc1 = {
    type: 'menu-item',
    key: 'add-row-below'
};
const $d0d78e4f78ab53f8$export$6a0b892b38736f32 = {
    type: 'menu-item',
    key: 'move-row-up'
};
const $d0d78e4f78ab53f8$export$489645ca66afd844 = {
    type: 'menu-item',
    key: 'move-row-down'
};
const $d0d78e4f78ab53f8$export$fd74fd566defa85d = {
    type: 'menu-item',
    key: 'delete-row'
};
const $d0d78e4f78ab53f8$export$d75534200c5cba18 = {
    [$d0d78e4f78ab53f8$export$f53435d29f0ad0a1.key]: 100,
    [$d0d78e4f78ab53f8$export$6b0a072235fdd804.key]: 200
};
const $d0d78e4f78ab53f8$export$2476e690f9168fc5 = {
    [(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]: 100
};
const $d0d78e4f78ab53f8$export$64075ae5fd18cb9c = {
    [$d0d78e4f78ab53f8$export$e4528482450d5f2e.key]: 100,
    [$d0d78e4f78ab53f8$export$c0c87706fa348bc1.key]: 200,
    [$d0d78e4f78ab53f8$export$6a0b892b38736f32.key]: 300,
    [$d0d78e4f78ab53f8$export$489645ca66afd844.key]: 400
};
const $d0d78e4f78ab53f8$export$5cf4383498669284 = {
    [(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]: 100,
    [$d0d78e4f78ab53f8$export$fd74fd566defa85d.key]: 200
};



const $b045de5a05ab28f6$export$190f9a1b925620da = {
    type: 'menu',
    key: 'cell-contextual-menu'
};
const $b045de5a05ab28f6$export$51b56b1bf623d0f = {
    type: 'menu-section',
    key: 'cell-action-section'
};
const $b045de5a05ab28f6$export$263b4b5ce540189d = {
    type: 'menu-section',
    key: 'cell-add-section'
};
const $b045de5a05ab28f6$export$ae771163ae415c91 = {
    type: 'menu-section',
    key: 'cell-danger-section'
};
const $b045de5a05ab28f6$export$8770b59bbf22f751 = {
    [$b045de5a05ab28f6$export$51b56b1bf623d0f.key]: 100,
    [$b045de5a05ab28f6$export$263b4b5ce540189d.key]: 200,
    [$b045de5a05ab28f6$export$ae771163ae415c91.key]: 300
};
const $b045de5a05ab28f6$export$b58e7f7cb85261bb = {
    type: 'menu-item',
    key: 'merge-cells'
};
const $b045de5a05ab28f6$export$4a4b751aa9083b35 = {
    type: 'menu-item',
    key: 'split-cell'
};
const $b045de5a05ab28f6$export$b015955eb6c647e8 = {
    type: 'nested-menu',
    key: 'vertical-align'
};
const $b045de5a05ab28f6$export$2ee0b7de1ba81016 = {
    type: 'menu-section',
    key: 'vertical-align-section'
};
const $b045de5a05ab28f6$export$4aeebd1c4003f0d1 = {
    type: 'menu-item',
    key: 'vertical-align-top'
};
const $b045de5a05ab28f6$export$fdb9421b7fa72aa6 = {
    type: 'menu-item',
    key: 'vertical-align-middle'
};
const $b045de5a05ab28f6$export$3348ad90bdbb18b = {
    type: 'menu-item',
    key: 'vertical-align-bottom'
};
const $b045de5a05ab28f6$export$1d60acb37b4923d4 = {
    [(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]: 100,
    [$b045de5a05ab28f6$export$b015955eb6c647e8.key]: 200,
    [$b045de5a05ab28f6$export$b58e7f7cb85261bb.key]: 300,
    [$b045de5a05ab28f6$export$4a4b751aa9083b35.key]: 400
};
const $b045de5a05ab28f6$export$3094a3221df5ea5d = {
    [$b045de5a05ab28f6$export$2ee0b7de1ba81016.key]: 100
};
const $b045de5a05ab28f6$export$9767915495221593 = {
    [$b045de5a05ab28f6$export$4aeebd1c4003f0d1.key]: 100,
    [$b045de5a05ab28f6$export$fdb9421b7fa72aa6.key]: 200,
    [$b045de5a05ab28f6$export$3348ad90bdbb18b.key]: 300
};
const $b045de5a05ab28f6$export$75f616c8c0c24cae = {
    [$b045de5a05ab28f6$export$b58e7f7cb85261bb.key]: 100,
    [$b045de5a05ab28f6$export$4a4b751aa9083b35.key]: 200,
    [(0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key]: 300,
    [(0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key]: 400,
    [(0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key]: 500
};
const $b045de5a05ab28f6$export$75f3bad3b50a6fc9 = {
    [(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]: 100,
    [(0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key]: 200,
    [(0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key]: 300
};
















var $dQrHJ = parcelRequire("dQrHJ");


var $dQMlg = parcelRequire("dQMlg");






const $9e2d9387cba2bb3b$var$TableMenuContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $9e2d9387cba2bb3b$export$e9137bf957e9632f = $9e2d9387cba2bb3b$var$TableMenuContext.Provider;
const $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($9e2d9387cba2bb3b$var$TableMenuContext);


const $70b713918a73bdfd$export$c337ca08f09b4493 = /*#__PURE__*/ (0, $cozmU.memo)(({ api: api, editorView: editorView, surface: surface })=>{
    const components = (0, $cozmU.useMemo)(()=>api?.uiControlRegistry?.actions.getComponents(surface.key) ?? [], [
        api,
        surface.key
    ]);
    const { tableNode: tableNode, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table',
        'selection'
    ], (states)=>({
            tableNode: states.tableState?.tableNode,
            selection: states.selectionState?.selection
        }));
    const tableMenuContext = (0, $cozmU.useMemo)(()=>{
        // rely on selection plugins state to re-render the row/column menu, but use editorView.selection
        // for cell menu state as the selection plugin won't update when text selection changes within cells
        if (!tableNode || !editorView || !selection) return undefined;
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        const cellOps = {
            editorView: editorView,
            canMergeCells: (0, $a80eeaee4326e361$export$61c1a939609d5bfa)(editorView.state.selection),
            canSplitCell: (0, $889db17e17b8e31a$export$3983d6b165b9fd4d)(editorView.state.selection),
            hasMergedCellsInTable: tableMap.hasMergedCells()
        };
        if (!selectionRect) return cellOps;
        return {
            ...cellOps,
            isFirstRow: selectionRect.top === 0,
            isLastRow: selectionRect.bottom === tableMap.height,
            selectedRowCount: selectionRect.bottom - selectionRect.top,
            isFirstColumn: selectionRect.left === 0,
            isLastColumn: selectionRect.right === tableMap.width,
            selectedColumnCount: selectionRect.right - selectionRect.left
        };
    }, [
        editorView,
        tableNode,
        selection
    ]);
    if (components.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e2d9387cba2bb3b$export$e9137bf957e9632f), {
        value: tableMenuContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQrHJ.ToolbarMenuContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQMlg.SurfaceRenderer), {
        surface: surface,
        components: components
    })));
});
$70b713918a73bdfd$export$c337ca08f09b4493.displayName = 'TableMenu';


const $b9ae0f2150f4cc07$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $b9ae0f2150f4cc07$var$NESTED_DROPDOWN_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
const $b9ae0f2150f4cc07$var$CELL_MENU_TRIGGER_SELECTOR = `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON}`;
const $b9ae0f2150f4cc07$var$CELL_MENU_TRIGGER_CLEARANCE = [
    6,
    0
];
const $b9ae0f2150f4cc07$export$28b7d8193cac27fc = ({ api: api, boundariesElement: boundariesElement, editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, target: target, zIndex: zIndex })=>{
    const popupContentRef = (0, $cozmU.useRef)(null);
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    const handlePopupRef = (0, $cozmU.useCallback)((el)=>{
        popupContentRef.current = el;
        setOutsideClickTargetRef?.(el);
    }, [
        setOutsideClickTargetRef
    ]);
    const closeCellMenu = (0, $cozmU.useCallback)(()=>{
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        if (isCellMenuOpenByKeyboard) (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(false)(editorView.state, editorView.dispatch);
    }, [
        api,
        editorView
    ]);
    const isEventInsideCellMenu = (0, $cozmU.useCallback)((event)=>{
        const target = event.target;
        if (!(target instanceof Node)) return false;
        if (popupContentRef.current?.contains(target)) return true;
        return target instanceof Element && Boolean(target.closest($b9ae0f2150f4cc07$var$NESTED_DROPDOWN_SELECTOR) || target.closest($b9ae0f2150f4cc07$var$CELL_MENU_TRIGGER_SELECTOR));
    }, []);
    const horizontalPlacementRef = (0, $cozmU.useRef)(undefined);
    const handlePlacementChanged = (0, $cozmU.useCallback)(([, horizontalPlacement])=>{
        horizontalPlacementRef.current = horizontalPlacement;
    }, []);
    const handlePositionCalculated = (0, $cozmU.useCallback)((position)=>{
        if (horizontalPlacementRef.current !== 'left' || position.left === undefined) return position;
        return {
            ...position,
            left: position.left + target.getBoundingClientRect().width
        };
    }, [
        target
    ]);
    const handleCellMenuClickOutside = (0, $cozmU.useCallback)((event)=>{
        if (isEventInsideCellMenu(event)) return;
        // Another table menu (e.g. a row/column drag menu) may have just been opened by this same
        // click. Its React handler runs before this document listener, so the active menu is no
        // longer 'cell' — don't clobber the newly opened menu back to 'none'.
        const activeTableMenu = api?.table?.sharedState.currentState()?.activeTableMenu;
        if (activeTableMenu?.type !== 'cell') return;
        closeCellMenu();
    }, [
        api,
        closeCellMenu,
        isEventInsideCellMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b9ae0f2150f4cc07$var$PopupWithListeners, {
        alignX: "end",
        alignY: "start",
        target: target,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $deb80ec534adbdde$export$3cdde837cf189e96),
        fitWidth: (0, $b012a0a8cdd0c09d$export$f8597a393fbbbffb),
        zIndex: zIndex,
        forcePlacement: true,
        preventOverflow: true,
        onPlacementChanged: handlePlacementChanged,
        onPositionCalculated: handlePositionCalculated,
        offset: $b9ae0f2150f4cc07$var$CELL_MENU_TRIGGER_CLEARANCE,
        stick: true,
        handleClickOutside: handleCellMenuClickOutside,
        handleEscapeKeydown: closeCellMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: handlePopupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3v5aK.UserIntentPopupWrapper), {
        api: api,
        userIntent: "tableContextualMenuPopupOpen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70b713918a73bdfd$export$c337ca08f09b4493), {
        api: api,
        editorView: editorView,
        surface: (0, $b045de5a05ab28f6$export$190f9a1b925620da)
    }))));
};


/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
























var $feeMI = parcelRequire("feeMI");


var $8VCvx = parcelRequire("8VCvx");

var $7xQNd = parcelRequire("7xQNd");

var $3gFnx = parcelRequire("3gFnx");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");

var $gLi18 = parcelRequire("gLi18");








var $lqPdm = parcelRequire("lqPdm");






var $b391T = parcelRequire("b391T");





var $5de7B = parcelRequire("5de7B");


var $53Mds = parcelRequire("53Mds");





































// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766








const $600505d29a31ef90$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $lOiVq.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $600505d29a31ef90$export$62225ca66ffe289c = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:0;left:", (0, $deb80ec534adbdde$export$42d9040c5091b076), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $39Puj.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");


const $8fbd4eafa4158203$var$dropdownMenuSection = {
    hasSeparator: true
};
const $8fbd4eafa4158203$var$elementBeforeIconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $8fbd4eafa4158203$var$getArrowsList = (0, $dOBRD.default)(()=>new Set(!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? [
        'ArrowRight',
        'ArrowLeft'
    ] : [
        'ArrowRight'
    ]));
class $8fbd4eafa4158203$export$f55c8e309b1cad66 extends (0, $cozmU.Component) {
    componentDidMount() {
        // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
        // until user pressed ArrowDown.
        // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
        // so here is triggering componentDidUpdate inside dropdown to set focus on first element
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        if (isCellMenuOpenByKeyboard) this.setState({
            ...this.state,
            isOpenAllowed: isCellMenuOpenByKeyboard
        });
    }
    componentDidUpdate() {
        const { isContextualMenuOpen: isContextualMenuOpen } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(this.props.editorView.state);
        if (this.props.isDragMenuOpen && isContextualMenuOpen) (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(this.props.editorView.state, this.props.editorView.dispatch);
    }
    render() {
        const { isOpen: isOpen, offset: offset, boundariesElement: boundariesElement, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, api: api } = this.props;
        const items = this.createContextMenuItems();
        let isOpenAllowed = false;
        isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
            userIntent: "tableContextualMenuPopupOpen",
            api: api
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            onMouseLeave: (0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? undefined : this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gLi18.default), {
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: !isCellMenuOpenByKeyboard || this.state.isSubmenuOpen
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: (0, $deb80ec534adbdde$export$42d9040c5091b076),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            shouldFocusFirstItem: ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            },
            boundariesElement: boundariesElement,
            offset: offset,
            section: $8fbd4eafa4158203$var$dropdownMenuSection,
            allowEnterDefaultBehavior: this.state.isSubmenuOpen
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        };
        this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.handleSubMenuRef = (ref)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const dom = this.props.editorView.dom;
            const parent = (0, $btvbC.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $btvbC.closestElement)(dom, '.ak-editor-content-area');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (!!this.props.mountPoint) return;
            const offsetParent = ref?.offsetParent;
            if (!offsetParent) return;
            const offsetParentRect = offsetParent.getBoundingClientRect();
            const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
            const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
            if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
            // if it overflows regardless of side, let it overlap with the parent menu
            if (leftOverflow > 0 && rightOverflow > 0) {
                if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
                else ref.style.left = `-${rect.width - leftOverflow}px`;
            }
        };
        this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
            if (allowBackgroundColor) {
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $lqPdm.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
                const selectedRowAndColumnFromPalette = (0, $3gFnx.getSelectedRowAndColumnFromPalette)((0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                background, (0, $deb80ec534adbdde$export$2c18704a8d793cdb));
                const selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                const selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                return {
                    content: formatMessage((0, $fKJ7J.messages).backgroundColor),
                    value: {
                        name: 'background'
                    },
                    elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                        xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b391T))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $fKJ7J.messages).backgroundColor)
                    })),
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $600505d29a31ef90$export$bc7b8b99ac8e8073)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL
                    }), isSubmenuOpen && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                        type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7xQNd.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        paletteOptions: {
                            palette: (0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039),
                            paletteColorTooltipMessages: (0, $8VCvx.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $lqPdm.hexToEditorBackgroundPaletteColor)
                        }
                    })))),
                    'aria-expanded': isSubmenuOpen
                };
            }
        };
        // Used in the NewContextMenuItems object
        this.newDistributeColumnsItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.createDistributeColumnsItemInternal({
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).distributeColumns)
                }))
            });
        };
        this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage } } = this.props;
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $fKJ7J.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $a80eeaee4326e361$export$9df87bad3fce982f)(state.tr),
                    elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                        xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5de7B))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $fKJ7J.messages).mergeCells)
                    }))
                },
                {
                    content: formatMessage((0, $fKJ7J.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $53f42aed97ade489$export$74933b5979945879)(state),
                    elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                        xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53Mds))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $fKJ7J.messages).splitCell)
                    }))
                }
            ];
            return [];
        };
        this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const content = formatMessage((0, $fKJ7J.messages).addColumnRight);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: (0, $lrTDq.shortcutStyle)
                }, (0, $ldqjS.tooltip)((0, $ldqjS.addColumnAfter))),
                elemBefore: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eehur))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).addColumnRight)
                })),
                'aria-label': (0, $ldqjS.tooltip)((0, $ldqjS.addColumnAfter), String(content))
            };
        };
        this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const content = formatMessage((0, $fKJ7J.messages).addRowBelow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: (0, $lrTDq.shortcutStyle)
                }, (0, $ldqjS.tooltip)((0, $ldqjS.addRowAfter))),
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i8vym))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).addRowBelow)
                })),
                'aria-label': (0, $ldqjS.tooltip)((0, $ldqjS.addRowAfter), String(content))
            };
        };
        this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $fKJ7J.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: (0, $lrTDq.shortcutStyle)
                }, (0, $ldqjS.tooltip)((0, $ldqjS.backspace))),
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bWjzw))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    })
                })),
                'aria-label': (0, $ldqjS.tooltip)((0, $ldqjS.backspace), String(content))
            };
        };
        this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $fKJ7J.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($haA5t))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).removeColumns, {
                        0: noOfColumns
                    })
                }))
            };
        };
        this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $fKJ7J.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $8fbd4eafa4158203$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($81DSz))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $fKJ7J.messages).removeRows, {
                        0: noOfRows
                    })
                }))
            };
        };
        this.createDistributeColumnsItemInternal = (partialMenuItem)=>{
            const { selectionRect: selectionRect, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, intl: { formatMessage: formatMessage } } = this.props;
            const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const newResizeState = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
            const wouldChange = newResizeState?.changed ?? false;
            return {
                content: formatMessage((0, $fKJ7J.messages).distributeColumns),
                value: {
                    name: 'distribute_columns'
                },
                isDisabled: !wouldChange,
                ...partialMenuItem
            };
        };
        this.createContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            const items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) items[1].items.push(this.newDistributeColumnsItem());
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        };
        this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen)) {
                const { tr: tr } = state;
                tr.setMeta((0, $a10022ebdc03afe1$export$18d4026d1ea86bb1), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $6faDz.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $6faDz.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $70029e39e0a22c66$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $70029e39e0a22c66$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $70029e39e0a22c66$export$9bca7816a0c95373)(editorAnalyticsAPI, this.props.api)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $70029e39e0a22c66$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $70029e39e0a22c66$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $70029e39e0a22c66$export$4c11b948fab97510)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
                    (0, $70029e39e0a22c66$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    {
                        if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen) this.setState({
                            isSubmenuOpen: true
                        });
                    } else this.setState((prevState)=>({
                            isSubmenuOpen: !prevState.isSubmenuOpen
                        }));
                    break;
            }
        };
        this.toggleOpen = ()=>{
            const { isOpen: isOpen, editorView: { state: state, dispatch: dispatch } } = this.props;
            if ((0, $ieeJu.expValEquals)('platform_editor_table_close_cell_menu_on_move_exp', 'isEnabled', true)) {
                if ((0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state).isContextualMenuOpen) (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
                this.closeSubmenu();
                return;
            }
            (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
            if (!isOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (payload) {
                const { event: event } = payload;
                if (event && event instanceof KeyboardEvent) {
                    if (!this.state.isSubmenuOpen) {
                        if ($8fbd4eafa4158203$var$getArrowsList().has(event.key)) {
                            // preventing default behavior for avoiding cursor jump to next/previous table column
                            // when left/right arrow pressed.
                            event.preventDefault();
                            if ((0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                                this.setState({
                                    isSubmenuOpen: true
                                });
                                return;
                            }
                        }
                        (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(false)(state, dispatch);
                        dom.focus();
                    }
                } else {
                    // mouse click outside
                    (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
                    this.setState({
                        isSubmenuOpen: false
                    });
                    if (isCellMenuOpenByKeyboard) (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(false)(state, dispatch);
                }
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') {
                    if (!this.state.isSubmenuOpen) this.setState({
                        isSubmenuOpen: true
                    });
                }
            }
            if (item.value.name === 'delete_column') (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)((0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $47589dd3b7f399b2$export$ab63d99b591b89)((0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $d3dc0fe24d69f2ab$export$ffded79ba5549697)(state.tr).length !== 0) (0, $47589dd3b7f399b2$export$59dcdc44819c7e7c)()(state, dispatch);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') this.closeSubmenu();
            }
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { state: state, dispatch: dispatch, dom: dom } = editorView;
            (0, $70029e39e0a22c66$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            if (!(0, $ieeJu.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) this.toggleOpen();
            else if ((0, $ieeJu.expValEquals)('platform_editor_table_close_cell_menu_on_move_exp', 'isEnabled', true)) {
                this.toggleOpen();
                if (isCellMenuOpenByKeyboard) {
                    (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(false)(editorView.state, dispatch);
                    dom.focus();
                }
            } else {
                (0, $55616d8330b777b9$export$458dbe7d48b81d0a)()(state, dispatch);
                this.setState({
                    isSubmenuOpen: false
                });
                if (isCellMenuOpenByKeyboard) {
                    (0, $9b2eea537bbdfc67$export$a6e5155a1ac72366)(false)(state, dispatch);
                    dom.focus();
                }
            }
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$8fbd4eafa4158203$export$f55c8e309b1cad66.defaultProps = {
    boundariesElement: typeof document !== 'undefined' ? document.body : undefined
};
const $8fbd4eafa4158203$var$_default_1 = (0, $kSwu1.injectIntl)($8fbd4eafa4158203$export$f55c8e309b1cad66);
var $8fbd4eafa4158203$export$2e2bcd8739ae039 = $8fbd4eafa4158203$var$_default_1;



const $183f51f5a5d0efde$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api, isDragMenuOpen: isDragMenuOpen })=>{
    const { activeTableMenu: activeTableMenu } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>({
            activeTableMenu: states.tableState?.activeTableMenu
        }));
    const isCellMenuOpen = (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? activeTableMenu?.type === 'cell' : isOpen;
    if (!editorView) return null;
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
    if (!isCellMenuOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $bc8rR.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $bjg0G.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        if (!(targetCellRef instanceof HTMLElement)) return null;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $b9ae0f2150f4cc07$export$28b7d8193cac27fc), {
            api: api,
            boundariesElement: boundariesElement,
            editorView: editorView,
            mountPoint: mountPoint,
            scrollableElement: scrollableElement,
            target: targetCellRef,
            zIndex: parentSticky ? (0, $7Y8M5.akEditorFloatingDialogZIndex) : (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex)
        });
    }
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7XIuB.default), {
        alignX: "right",
        alignY: "top",
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $deb80ec534adbdde$export$3cdde837cf189e96),
        fitWidth: (0, $deb80ec534adbdde$export$42d9040c5091b076),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $7Y8M5.akEditorFloatingDialogZIndex) : (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $600505d29a31ef90$export$62225ca66ffe289c)()
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $8fbd4eafa4158203$export$2e2bcd8739ae039), {
        editorView: editorView,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            (0, $deb80ec534adbdde$export$3969371f057ce1e5) / 2,
            -(0, $deb80ec534adbdde$export$3969371f057ce1e5)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowMergeCells: pluginConfig.allowMergeCells,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api,
        isDragMenuOpen: isDragMenuOpen
    })));
};
$183f51f5a5d0efde$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $183f51f5a5d0efde$export$2e2bcd8739ae039 = $183f51f5a5d0efde$var$FloatingContextualMenu;



















/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 




























































var $c0A7H = parcelRequire("c0A7H");











/* eslint-disable @atlaskit/design-system/prefer-primitives */ 



var $j9oLZ = parcelRequire("j9oLZ");



















var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


const $f83d5aaf58d66922$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $uyXFl.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9oLZ.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $f83d5aaf58d66922$var$DropListWithOutsideListeners = (0, $9Muxb.default)($f83d5aaf58d66922$var$DropListWithOutsideClickTargetRef);
const $f83d5aaf58d66922$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $cozmU.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $cozmU.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    const offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    const offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f83d5aaf58d66922$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleClickOutside: ()=>handleClose('editor'),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: 0,
                minWidth: (0, $deb80ec534adbdde$export$963fb187132ee7cf)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            role: "menu"
        }, items.map((group, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gLi18.DropdownMenuItem), {
                    shouldUseDefaultRole: false,
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: onItemActivated,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                }))))));
    };
    const onClose = (0, $cozmU.useCallback)(()=>handleClose('handle'), [
        handleClose
    ]);
    const onSelection = (0, $cozmU.useCallback)((index)=>{
        const results = items.flatMap((item)=>'items' in item ? item.items : item);
        // onSelection is called when any focusable element is 'activated'
        // this is an issue as some menu items have toggles, which cause the index value
        // in the callback to be outside of array length.
        // The logic below normalises the index value based on the number
        // of menu items with 2 focusable elements, and adjusts the index to ensure
        // the correct menu item is sent in onItemActivated callback
        const keys = [
            'row_numbers',
            'header_row',
            'header_column'
        ];
        let doubleItemCount = 0;
        const firstIndex = results.findIndex((value)=>{
            const key = value.key;
            return key !== undefined && keys.includes(key);
        });
        if (firstIndex === -1 || index <= firstIndex) {
            onItemActivated && onItemActivated({
                item: results[index]
            });
            return;
        }
        for(let i = firstIndex; i < results.length; i += 1){
            const key = results[i].key;
            if (key !== undefined && keys.includes(key)) doubleItemCount += 1;
            if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
            if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
        }
    }, [
        items,
        onItemActivated
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "drag-dropdown-menu-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "drag-dropdown-menu-popup-ref",
        ref: handleRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetRefDiv,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onPlacementChanged: (placement)=>{
            setPopupPlacement(placement);
        },
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            offsetX,
            offsetY
        ],
        allowOutOfBounds: true // required as this popup is child of a parent popup, should be allowed to be out of bound of the parent popup, otherwise horizontal offset is not right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
        closeOnTab: !disableKeyboardHandling,
        type: (0, $9RT19.ArrowKeyNavigationType).MENU,
        handleClose: onClose,
        onSelection: onSelection,
        // disableKeyboardHandling is linked with isSubmenuOpen in DragMenu
        // When isSubmenuOpen is true, the background color picker palette is open, and the picker is a ColorPaletteArrowKeyNavigationProvider
        // At the same time the MenuArrowKeyNavigationProvider are renderer too, as it is the wrapper for all other DragMenu items
        // In this case we want the ColorPaletteArrowKeyNavigationProvider to handle the keyboard event, not the MenuArrowKeyNavigationProvider
        // Hence set disableArrowKeyNavigation to true when disableKeyboardHandling is true
        disableArrowKeyNavigation: disableKeyboardHandling
    }, innerMenu()))));
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ 







function $36613044f8f331a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $36613044f8f331a3$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $lOiVq.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $36613044f8f331a3$export$2a71c1910478944e = ()=>/*#__PURE__*/ (0, $lOiVq.css)(".", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:", (0, $deb80ec534adbdde$export$e0140c2b978caac5) + (0, $deb80ec534adbdde$export$a13bd817a2eda041) + (0, $deb80ec534adbdde$export$c6a9e7014cf7aedc), "px;left:", (0, $deb80ec534adbdde$export$963fb187132ee7cf), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $39Puj.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");
const $36613044f8f331a3$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};


const $4a13de12a2c746b9$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $fKJ7J.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $fKJ7J.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $fKJ7J.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $fKJ7J.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $fKJ7J.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $fKJ7J.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $fKJ7J.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $fKJ7J.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $fKJ7J.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $fKJ7J.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $fKJ7J.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $fKJ7J.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $fKJ7J.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $fKJ7J.messages).sortColumnDecreasing,
        plural: null
    }
};
const $4a13de12a2c746b9$var$getGroupedDragMenuConfig = ()=>{
    const groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    groupedDragMenuConfig.unshift(sortColumnItems);
    return groupedDragMenuConfig;
};
const $4a13de12a2c746b9$var$elementBeforeIconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $4a13de12a2c746b9$var$convertToDropdownItems = (dragMenuConfig, formatMessage, selectionRect)=>{
    const groupedDragMenuConfig = $4a13de12a2c746b9$var$getGroupedDragMenuConfig();
    const menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    const menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean($4a13de12a2c746b9$var$MapDragMenuOptionIdToMessage[item.id]?.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($4a13de12a2c746b9$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($4a13de12a2c746b9$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                xcss: $4a13de12a2c746b9$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $lOiVq.jsx)(item.icon, {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage($4a13de12a2c746b9$var$MapDragMenuOptionIdToMessage[item.id].message, options)
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $lrTDq.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        curr?.length > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $4a13de12a2c746b9$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $8Z43Z.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $cozmU.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
    const selectionRect = (0, $bc8rR.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = tableMap?.hasMergedCells() ?? false;
    const allowBackgroundColor = pluginConfig?.allowBackgroundColor ?? false;
    const dragMenuConfig = (0, $bd58fdd834784798$export$25f919d23e41e94d)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig?.isHeaderRowRequired, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, ariaNotifyPlugin, isCommentEditor, pluginConfig?.allowColumnSorting ?? true);
    const { menuItems: menuItems, menuCallback: menuCallback } = $4a13de12a2c746b9$var$convertToDropdownItems(dragMenuConfig, formatMessage, selectionRect);
    const handleSubMenuRef = (ref)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = editorView.dom;
        const parent = (0, $btvbC.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $btvbC.closestElement)(dom, '.ak-editor-content-area');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (!!mountPoint) return;
        const offsetParent = ref?.offsetParent;
        if (!offsetParent) return;
        const offsetParentRect = offsetParent.getBoundingClientRect();
        const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
        const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
        if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
        // if it overflows regardless of side, let it overlap with the parent menu
        if (leftOverflow > 0 && rightOverflow > 0) {
            if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
            else ref.style.left = `-${rect.width - leftOverflow}px`;
        }
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $70029e39e0a22c66$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $lqPdm.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)((0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039), background, (0, $deb80ec534adbdde$export$2c18704a8d793cdb));
        return {
            key: 'background',
            content: formatMessage((0, $fKJ7J.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                xcss: $4a13de12a2c746b9$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b391T))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $fKJ7J.messages).backgroundColor)
            })),
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $36613044f8f331a3$export$2a71c1910478944e)()
            }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $36613044f8f331a3$export$bc7b8b99ac8e8073)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9ric.ArrowKeyNavigationProvider), {
                type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    target?.focus();
                    target?.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7xQNd.default), {
                cols: (0, $deb80ec534adbdde$export$2c18704a8d793cdb),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: (0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039),
                    paletteColorTooltipMessages: (0, $8VCvx.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $lqPdm.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $70029e39e0a22c66$export$9fd5a66fcada8ad2)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $70029e39e0a22c66$export$2e66edaa488e7a1d)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $70029e39e0a22c66$export$9e4b8d27ecc9c55)(editorAnalyticsAPI)(state, dispatch);
    };
    const HeaderColumnToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $36613044f8f331a3$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0A7H.default), {
            id: "toggle-header-column",
            label: formatMessage((0, $fKJ7J.messages).headerColumn),
            onChange: toggleHeaderColumn,
            isChecked: (0, $8e70e8c6596c6b3f$export$653b4f383b39a1d0)(selection)
        }));
    const HeaderRowToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: (0, $36613044f8f331a3$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0A7H.default), {
            id: "toggle-header-row",
            label: formatMessage((0, $fKJ7J.messages).headerRow),
            onChange: toggleHeaderRow,
            isChecked: (0, $8e70e8c6596c6b3f$export$b8efdc0183f04d59)(selection)
        }));
    const createHeaderRowColumnMenuItem = (direction)=>{
        if (direction === 'column' && (pluginConfig?.advanced || pluginConfig?.allowHeaderColumn)) return {
            key: 'header_column',
            content: formatMessage((0, $fKJ7J.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)(HeaderColumnToggle, null)
        };
        if (direction === 'row' && (pluginConfig?.advanced || pluginConfig?.allowHeaderRow)) return {
            key: 'header_row',
            content: formatMessage((0, $fKJ7J.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)(HeaderRowToggle, null)
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $fKJ7J.messages).numberedRows),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $36613044f8f331a3$export$4e493e7fd1e47c4d)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0A7H.default), {
                id: "toggle-row-numbers",
                label: formatMessage((0, $fKJ7J.messages).numberedRows),
                onChange: toggleRowNumbers,
                isChecked: (0, $8e70e8c6596c6b3f$export$101f2696d8127fe0)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $9c44a2089c87f26f$export$f05434c51e3762e)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target?.focus();
            else editorView.focus();
            (0, $a709990a5e57b471$export$8a902a12acc69924)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        menuCallback[item.value.name]?.(state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!item.value.name?.startsWith('delete')) return;
        (item.value.name === 'delete_column' ? (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)((0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), true) : (0, $47589dd3b7f399b2$export$ab63d99b591b89)((0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), true))(state, dispatch);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(state, dispatch);
    };
    (0, $cozmU.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) menuItems[1].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) {
        if (pluginConfig?.advanced || pluginConfig?.allowHeaderColumn || pluginConfig?.allowHeaderRow) {
            const headerRowColumnMenuItem = createHeaderRowColumnMenuItem(direction);
            headerRowColumnMenuItem && menuItems.push({
                items: [
                    headerRowColumnMenuItem
                ]
            });
        }
    }
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row' && (pluginConfig?.advanced || pluginConfig?.allowNumberColumn)) index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3v5aK.UserIntentPopupWrapper), {
        api: api,
        userIntent: "tableDragMenuPopupOpen"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f83d5aaf58d66922$export$e44a253a59704894), {
        disableKeyboardHandling: isSubmenuOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    }));
});
// eslint-disable-next-line @typescript-eslint/ban-types
const $4a13de12a2c746b9$var$_default_1 = (0, $kSwu1.injectIntl)($4a13de12a2c746b9$var$DragMenu);
var $4a13de12a2c746b9$export$2e2bcd8739ae039 = $4a13de12a2c746b9$var$_default_1;


const $c1e63e40b546cb71$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor, tableWrapper: tableWrapper })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky || tableWrapper?.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_7');
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $8HW7o.CellSelection))) return null;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags?.() ?? {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $deb80ec534adbdde$export$963fb187132ee7cf),
        fitHeight: (0, $deb80ec534adbdde$export$3cdde837cf189e96),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $7Y8M5.akEditorFloatingDialogZIndex) : (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: direction === 'row' ? [
            -9,
            0
        ] : [
            0,
            -7
        ],
        stick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a13de12a2c746b9$export$2e2bcd8739ae039), {
        editorView: editorView,
        isOpen: isOpen,
        tableNode: tableNode,
        direction: direction,
        index: index,
        target: targetHandleRef || undefined,
        targetCellPosition: targetCellPosition,
        getEditorContainerWidth: getEditorContainerWidth,
        editorAnalyticsAPI: editorAnalyticsAPI,
        pluginConfig: pluginConfig,
        fitWidth: (0, $deb80ec534adbdde$export$963fb187132ee7cf),
        fitHeight: (0, $deb80ec534adbdde$export$3cdde837cf189e96),
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        isTableScalingEnabled: isTableScalingEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
        ariaNotifyPlugin: ariaNotifyPlugin,
        api: api,
        isCommentEditor: isCommentEditor || false
    }));
};
$c1e63e40b546cb71$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $c1e63e40b546cb71$export$2e2bcd8739ae039 = $c1e63e40b546cb71$var$FloatingDragMenu;











































const $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $deb80ec534adbdde$export$6d23b13c5fcb846c) / 2);
const $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $7Y8M5.akEditorTableNumberColumnWidth);
const $c03d146b36cc2fe4$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $deb80ec534adbdde$export$73b1242ebdcc73be);
const $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $c03d146b36cc2fe4$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $deb80ec534adbdde$export$6d23b13c5fcb846c) / 2;
function $c03d146b36cc2fe4$var$getRowOptions(index) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $c03d146b36cc2fe4$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$c03d146b36cc2fe4$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG
            };
        }
    };
}
function $c03d146b36cc2fe4$var$getColumnOptions(index, tableContainer, hasNumberedColumns, // Distance between the target cell top and table top, used when anchoring to a lower-row cell.
verticalOffsetCorrection = 0) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            $c03d146b36cc2fe4$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            // Move the popup upward whether the offset parent provides `top` or `bottom`.
            let verticalCorrection;
            if (verticalOffsetCorrection) {
                if (position.top !== undefined) verticalCorrection = {
                    top: position.top - verticalOffsetCorrection
                };
                else if (position.bottom !== undefined) verticalCorrection = {
                    bottom: position.bottom + verticalOffsetCorrection
                };
            }
            const { left: left } = position;
            if (!left) return {
                ...position,
                ...verticalCorrection
            };
            if (index === 0) return {
                ...position,
                ...verticalCorrection,
                left: hasNumberedColumns ? $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $c03d146b36cc2fe4$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                ...verticalCorrection,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $c03d146b36cc2fe4$var$getPopupOptions(direction, index, hasNumberedColumns, tableContainer, verticalOffsetCorrection = 0) {
    switch(direction){
        case 'column':
            return $c03d146b36cc2fe4$var$getColumnOptions(index, tableContainer, hasNumberedColumns, verticalOffsetCorrection);
        case 'row':
            return $c03d146b36cc2fe4$var$getRowOptions(index);
        default:
            return {};
    }
}
var $c03d146b36cc2fe4$export$2e2bcd8739ae039 = $c03d146b36cc2fe4$var$getPopupOptions;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 




























const $6337f0080f8e87c1$var$getInsertLineHeight = (tableRef, hasStickyHeaders)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $k8PFz.tableMarginTop) * 3 - LINE_OFFSET : (0, $deb80ec534adbdde$export$a4d60e31f4f6188b) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $6337f0080f8e87c1$var$getNumberColumnWidth = (tableRef)=>{
    const parent = (0, $btvbC.closestElement)(tableRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}`) ? (0, $7Y8M5.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $6337f0080f8e87c1$var$getInsertLineWidth = (tableRef, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parentOffsetWidth = parentElement.offsetWidth;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    return Math.min(offsetWidth, parentOffsetWidth - Math.max(scrollLeft - diff, 0)) + DRAG_LINE_OFFSET + $6337f0080f8e87c1$var$getNumberColumnWidth(tableRef);
};
const $6337f0080f8e87c1$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $fKJ7J.messages).insertRow : (0, $fKJ7J.messages).insertColumn;
};
const $6337f0080f8e87c1$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: formatMessage(isRow ? (0, $fKJ7J.messages).insertRowDrag : (0, $fKJ7J.messages).insertColumnDrag),
            keymap: isRow ? (0, $ldqjS.addRowAfter) : (0, $ldqjS.addColumnAfter)
        }),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
            [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
            [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
            [(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
        fill: "currentColor"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: type === 'row' ? {
            width: $6337f0080f8e87c1$var$getInsertLineWidth(tableRef, isChromelessEditor),
            left: "var(--ds-space-150, 12px)"
        } : {
            height: $6337f0080f8e87c1$var$getInsertLineHeight(tableRef, hasStickyHeaders) - 8,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            top: '-3px'
        }
    })));
    const floatingButtonClassName = isRow ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: floatingButtonClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`
    }, content)));
};
const $6337f0080f8e87c1$export$5e513603d391e3de = (0, $kSwu1.injectIntl)($6337f0080f8e87c1$var$InsertButtonForDragAndDrop);
const $6337f0080f8e87c1$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
            description: formatMessage($6337f0080f8e87c1$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $ldqjS.addRowAfter) : (0, $ldqjS.addColumnAfter)
        }),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON,
        onMouseDown: onMouseDown,
        "aria-label": formatMessage($6337f0080f8e87c1$var$tooltipMessageByType(type))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: type === 'row' ? {
            width: $6337f0080f8e87c1$var$getInsertLineWidth(tableRef)
        } : {
            height: $6337f0080f8e87c1$var$getInsertLineHeight(tableRef, hasStickyHeaders)
        }
    })));
    const floatingButtonClassName = type === 'column' ? (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: floatingButtonClassName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`
    }, content)));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $6337f0080f8e87c1$var$_default_1 = (0, $kSwu1.injectIntl)($6337f0080f8e87c1$var$InsertButton);
var $6337f0080f8e87c1$export$2e2bcd8739ae039 = $6337f0080f8e87c1$var$_default_1;


class $b9b64aeebac2ecfb$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // EDITOR-6790 - when platform_editor_table_col_insert is enabled, allow the first column
        // (index 0) insert button so a column can be inserted to the left of the first column.
        const isFirstColumnInsertEnabled = (0, $ieeJu.expValEquals)('platform_editor_table_col_insert', 'isEnabled', true);
        // ED-26961 - disable insert button for first row, and keep first-column behavior
        // disabled until platform_editor_table_col_insert is enabled.
        if (insertColumnButtonIndex === 0 && !isFirstColumnInsertEnabled || insertRowButtonIndex === 0) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can’t display the insert button for row|colum index 0
        // when the header row|colum is enabled, this feature will be change on the future.
        // EDITOR-6790 - when platform_editor_table_col_insert is enabled, still allow the first
        // column (index 0) insert button even when the header column is enabled.
        if (type === 'column' && isHeaderColumnEnabled && insertColumnButtonIndex === 0 && !isFirstColumnInsertEnabled || type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if ((0, $61cf1c01aee4adc2$export$3a10391c7abbe1c8)(tr.selection)) return null;
        } else {
            if (tr.selection instanceof (0, $8HW7o.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        }
        const tablePos = (0, $cycWk.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos?.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $bjg0G.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $krYZG.ACTION).ERRORED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $krYZG.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        error: error?.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $btvbC.closestElement)(target, 'tr') : (0, $btvbC.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $btvbC.closestElement)(targetCellRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
        const tableWrapper = (0, $btvbC.closestElement)(targetCellRef, `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $8e70e8c6596c6b3f$export$101f2696d8127fe0)(editorView.state.selection);
        // If row 0 has a colspan, anchor to a lower row for the real column boundary (X),
        // then move back up to the table top (Y):
        //   row 0: [   colspan=2   ]
        //   row 1: [ col 1 ][ col 2 ]  ← anchor here for X
        //          ↑ button should render at row 0/table top
        let verticalOffsetCorrection = 0;
        if (type === 'column' && (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) verticalOffsetCorrection = Math.max(0, targetCellRef.getBoundingClientRect().top - tableRef.getBoundingClientRect().top);
        // Fixed the 'add column button' not visible issue when sticky header is enabled
        // By setting the Popup z-index higher than the sticky header z-index ( common-styles.ts tr.sticky)
        // Only when inserting a column, otherwise set to undefined
        // Need to set z-index in the Popup, set z-index in the <DragAndDropInsertButton /> will not work
        const zIndex = (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') || type === 'column' ? (0, $7Y8M5.akEditorTableCellOnStickyHeaderZIndex) : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $c03d146b36cc2fe4$export$2e2bcd8739ae039)(type, index, hasNumberedColumns, tableContainerWrapper, verticalOffsetCorrection),
            zIndex: zIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6337f0080f8e87c1$export$5e513603d391e3de), {
            type: type,
            tableRef: tableRef,
            onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
            hasStickyHeaders: this.props.hasStickyHeaders || false,
            isChromelessEditor: isChromelessEditor
        }));
    }
    // Finds a row where `columnIndex` has real left/right cell boundaries.
    findRowWithUnmergedColumn(tableMap, columnIndex) {
        for(let row = 0; row < tableMap.height; row++){
            const pos = tableMap.map[row * tableMap.width + columnIndex];
            const rect = tableMap.findCell(pos);
            if (rect.left === columnIndex && rect.right === columnIndex + 1) return row;
        }
        return null;
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        if (type === 'column') {
            // This condition is to make typescript happy.
            // Previously insertColumnButtonIndex - 1 would produce NaN and return null anyway.
            if (insertColumnButtonIndex === undefined) return null;
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                const rowWithRealColumn = this.findRowWithUnmergedColumn(tableMap, columnIndex);
                return rowWithRealColumn === null ? null : tableMap.positionAt(rowWithRealColumn, columnIndex, tableNode);
            }
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            // This condition is to make typescript happy.
            // Previously insertRowButtonIndex - 1 would produce NaN and return null anyway.
            if (insertRowButtonIndex === undefined) return null;
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $70029e39e0a22c66$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$b9b64aeebac2ecfb$export$e2c2386b8045af89.displayName = 'FloatingInsertButton';
const $b9b64aeebac2ecfb$var$_default_1 = (0, $kSwu1.injectIntl)($b9b64aeebac2ecfb$export$e2c2386b8045af89);
var $b9b64aeebac2ecfb$export$2e2bcd8739ae039 = $b9b64aeebac2ecfb$var$_default_1;























var $jEaFE = parcelRequire("jEaFE");











const $7324773f21ea967f$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
// Defer drag-handle clicks to the drag handle's own toggle/select handlers — those own
// the open/switch/close semantics for moving between rows/columns.
const $7324773f21ea967f$var$DRAG_HANDLE_CONTROLS_SELECTOR = `.${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS}, .${(0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS}`;
const $7324773f21ea967f$var$NESTED_DROPDOWN_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
// Marks the menu subtree that ToolbarKeyboardNavigationProvider scopes its
// keyboard handling to. The provider only reacts to events whose target sits
// inside this selector.
const $7324773f21ea967f$var$TABLE_MENU_NAV_SELECTOR = '[data-table-drag-menu-nav="true"]';
const $7324773f21ea967f$var$TABLE_MENU_OFFSET = (0, $deb80ec534adbdde$export$d18320cc8ee69115) + 4;
const $7324773f21ea967f$var$POPUP_OFFSET = [
    $7324773f21ea967f$var$TABLE_MENU_OFFSET,
    0
];
/**
 * Row and column menu for table.
 */ const $7324773f21ea967f$var$FloatingTableMenu = ({ api: api, boundariesElement: boundariesElement, editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeaders: stickyHeaders, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition })=>{
    const { activeTableMenu: activeTableMenu } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>({
            activeTableMenu: states.tableState?.activeTableMenu
        }));
    const isDragMenuOpen = activeTableMenu?.type === 'row' || activeTableMenu?.type === 'column';
    const dragMenuDirection = isDragMenuOpen ? activeTableMenu.type : undefined;
    const isOpenedByKeyboard = isDragMenuOpen && activeTableMenu.openedBy === 'keyboard';
    const popupContentRef = (0, $cozmU.useRef)(null);
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    const navWrapperRef = (0, $cozmU.useRef)(null);
    const handlePopupRef = (0, $cozmU.useCallback)((el)=>{
        popupContentRef.current = el;
        setOutsideClickTargetRef?.(el);
    }, [
        setOutsideClickTargetRef
    ]);
    const returnFocusToDragHandle = (0, $cozmU.useCallback)(()=>{
        // Match legacy DragMenu's closeMenu('handle') behaviour.
        const handleId = dragMenuDirection === 'row' ? '#drag-handle-button-row' : '#drag-handle-button-column';
        const handle = document.querySelector(handleId);
        handle?.focus();
    }, [
        dragMenuDirection
    ]);
    const focusFirstMenuItem = (0, $cozmU.useCallback)(()=>{
        const root = navWrapperRef.current;
        if (!root) return;
        const firstItem = root.querySelector('[role="menuitem"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled]), [role="menuitemradio"]:not([disabled]), button:not([disabled])');
        firstItem?.focus();
    }, []);
    // Focus the first menu item when the menu opens via keyboard (Enter/Space on
    // the drag handle). Mouse-opened menus leave focus where the user clicked.
    const setNavWrapperRef = (0, $cozmU.useCallback)((el)=>{
        navWrapperRef.current = el;
        if (el && isOpenedByKeyboard) // rAF allows the popup to finish positioning before focusing.
        requestAnimationFrame(()=>{
            focusFirstMenuItem();
        });
    }, [
        focusFirstMenuItem,
        isOpenedByKeyboard
    ]);
    const handleKeyboardFocus = (0, $cozmU.useCallback)((_event)=>{
        focusFirstMenuItem();
    }, [
        focusFirstMenuItem
    ]);
    const handleEscape = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        returnFocusToDragHandle();
    }, [
        api,
        returnFocusToDragHandle
    ]);
    // Memoize the editor DOM reference so the provider doesn't re-bind listeners
    // on every render (the provider depends on `dom` in its effect's deps).
    const editorDom = (0, $cozmU.useMemo)(()=>editorView.dom instanceof HTMLElement ? editorView.dom : undefined, [
        editorView.dom
    ]);
    // The drag menu is opened by interacting with the drag handle directly, not
    // by a global page-level shortcut.
    const isShortcutToFocusToolbar = (0, $cozmU.useCallback)(()=>false, []);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        const target = event.target;
        // Ignore clicks handled by this popup, drag handles, or nested portalled
        // dropdowns so those controls can manage their own open/close behavior.
        if (target instanceof Node && popupContentRef.current?.contains(target) || target instanceof Element && (target.closest($7324773f21ea967f$var$DRAG_HANDLE_CONTROLS_SELECTOR) || target.closest($7324773f21ea967f$var$NESTED_DROPDOWN_SELECTOR))) return;
        // Another table menu (e.g. the cell menu) may have just been opened by this same click.
        // Its React handler runs before this document listener, so the active menu is no longer a
        // row/column menu — don't clobber the newly opened menu back to 'none'.
        const currentActiveTableMenu = api?.table?.sharedState.currentState()?.activeTableMenu;
        if (currentActiveTableMenu?.type !== 'row' && currentActiveTableMenu?.type !== 'column') return;
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
    }, [
        api
    ]);
    if (!isDragMenuOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky || tableWrapper?.classList.contains((0, $93ebfcf1771919c4$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_7');
    const targetHandleRef = dragMenuDirection === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $8HW7o.CellSelection))) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7324773f21ea967f$var$PopupWithListeners, {
        alignX: dragMenuDirection === 'row' ? 'right' : undefined,
        alignY: dragMenuDirection === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $b012a0a8cdd0c09d$export$f8597a393fbbbffb),
        fitHeight: (0, $deb80ec534adbdde$export$3cdde837cf189e96),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $7Y8M5.akEditorFloatingDialogZIndex) : (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        preventOverflow: dragMenuDirection === 'row',
        offset: $7324773f21ea967f$var$POPUP_OFFSET,
        stick: true,
        handleClickOutside: handleClickOutside
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: handlePopupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
        childComponentSelector: $7324773f21ea967f$var$TABLE_MENU_NAV_SELECTOR,
        dom: editorDom,
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleFocus: handleKeyboardFocus,
        handleEscape: handleEscape
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-table-drag-menu-nav": "true",
        ref: setNavWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70b713918a73bdfd$export$c337ca08f09b4493), {
        api: api,
        editorView: editorView,
        surface: dragMenuDirection === 'row' ? (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34) : (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa)
    })))));
};
$7324773f21ea967f$var$FloatingTableMenu.displayName = 'FloatingTableMenu';
var $7324773f21ea967f$export$2e2bcd8739ae039 = $7324773f21ea967f$var$FloatingTableMenu;








const $9fe09278da412093$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset
    }, content);
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 






const $09f920d800d52047$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags, api: api })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: (0, $0935dfe4dac9e048$export$e938d6f191645a3e)({
            featureFlags: featureFlags,
            isDragAndDropEnabled: !isLivePageViewMode
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $2iq8g = parcelRequire("2iq8g");


const $2844c150515f03ae$var$DEFAULT_TABLE_SELECTOR_COLS = 3;
const $2844c150515f03ae$var$DEFAULT_TABLE_SELECTOR_ROWS = 3;
const $2844c150515f03ae$export$800b7d81026538f2 = ({ api: api, target: target, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    const closeSelectorPopup = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $285f4eda3a20b494$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onSelection = (0, $cozmU.useCallback)((rowsCount, colsCount)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.table.commands.insertTableWithSize(rowsCount, colsCount)({
                tr: tr
            });
            tr.setMeta((0, $285f4eda3a20b494$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onUnmount = ()=>{
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2iq8g.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        defaultSize: {
            row: $2844c150515f03ae$var$DEFAULT_TABLE_SELECTOR_ROWS,
            col: $2844c150515f03ae$var$DEFAULT_TABLE_SELECTOR_COLS
        },
        target: target,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        popupsBoundariesElement: popupsBoundariesElement,
        isOpenedByKeyboard: true,
        handleClickOutside: closeSelectorPopup,
        handleEscapeKeydown: closeSelectorPopup
    });
};














var $kz1Yj = parcelRequire("kz1Yj");



const $c87f0a8e4c59981e$var$tableFullWidthLabelWrapperStyles = (0, $buxP3.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $c87f0a8e4c59981e$var$tableFullWidthLabelStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $c87f0a8e4c59981e$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $c87f0a8e4c59981e$var$tableFullWidthLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $c87f0a8e4c59981e$var$tableFullWidthLabelStyles
    }, formatMessage((0, $fKJ7J.messages).fullWidthLabel)));
};


const $d0cd06c03a409ff7$var$selector = (states)=>({
        resizingTableLocalId: states.tableState?.resizingTableLocalId,
        resizingTableRef: states.tableState?.resizingTableRef,
        isTableResizing: states.tableState?.isTableResizing,
        isResizing: states.tableState?.isResizing,
        widthToWidest: states.tableState?.widthToWidest,
        tableNode: states.tableState?.tableNode,
        targetCellPosition: states.tableState?.targetCellPosition,
        isContextualMenuOpen: states.tableState?.isContextualMenuOpen,
        tableRef: states.tableState?.tableRef,
        pluginConfig: states.tableState?.pluginConfig,
        insertColumnButtonIndex: states.tableState?.insertColumnButtonIndex,
        insertRowButtonIndex: states.tableState?.insertRowButtonIndex,
        isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
        isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
        tableWrapperTarget: states.tableState?.tableWrapperTarget,
        isCellMenuOpenByKeyboard: states.tableState?.isCellMenuOpenByKeyboard,
        stickyHeader: states.tableState?.stickyHeader,
        dragMenuDirection: states.tableState?.dragMenuDirection,
        dragMenuIndex: states.tableState?.dragMenuIndex,
        isDragMenuOpen: states.tableState?.isDragMenuOpen,
        isSizeSelectorOpen: states.tableState?.isSizeSelectorOpen,
        sizeSelectorTargetRef: states.tableState?.sizeSelectorTargetRef,
        // IMPORTANT: hovered states are used by FloatingDragMenu component to render popup in the correct location
        hoveredRows: states.tableState?.hoveredRows,
        hoveredColumns: states.tableState?.hoveredColumns,
        hoveredCell: states.tableState?.hoveredCell
    });
const $d0cd06c03a409ff7$var$ContentComponentInternal = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const { resizingTableLocalId: resizingTableLocalId, resizingTableRef: resizingTableRef, isTableResizing: isTableResizing, isResizing: isResizing, widthToWidest: widthToWidest, tableNode: tableNode, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, stickyHeader: stickyHeader, dragMenuDirection: dragMenuDirection, dragMenuIndex: dragMenuIndex, isDragMenuOpen: isDragMenuOpen, isSizeSelectorOpen: isSizeSelectorOpen, sizeSelectorTargetRef: sizeSelectorTargetRef } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'table'
    ], $d0cd06c03a409ff7$var$selector);
    const { allowControls: allowControls } = pluginConfig ?? {};
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b2935b967c63bed2$export$2e2bcd8739ae039), {
        api: api,
        isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
        editorView: editorView,
        tableNode: tableNode,
        mountPoint: popupsMountPoint,
        targetCellPosition: targetCellPosition,
        scrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isContextualMenuOpen: isContextualMenuOpen,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapperTarget,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
    }), allowControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9b64aeebac2ecfb$export$2e2bcd8739ae039), {
        tableNode: tableNode,
        tableRef: tableRef,
        insertColumnButtonIndex: insertColumnButtonIndex,
        insertRowButtonIndex: insertRowButtonIndex,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        editorView: editorView,
        mountPoint: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        hasStickyHeaders: stickyHeader && stickyHeader.sticky,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: defaultGetEditorContainerWidth,
        getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
        isChromelessEditor: options?.isChromelessEditor,
        api: api,
        isCommentEditor: options?.isCommentEditor
    }), options?.allowContextualMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $183f51f5a5d0efde$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        isOpen: Boolean(isContextualMenuOpen) && !isResizing,
        pluginConfig: pluginConfig,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: defaultGetEditorContainerWidth,
        getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: options?.isCommentEditor,
        api: api,
        isDragMenuOpen: isDragMenuOpen
    }), (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7324773f21ea967f$export$2e2bcd8739ae039), {
        api: api,
        boundariesElement: popupsBoundariesElement,
        editorView: editorView,
        mountPoint: popupsMountPoint,
        stickyHeaders: stickyHeader,
        tableWrapper: tableWrapperTarget,
        targetCellPosition: targetCellPosition
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1e63e40b546cb71$export$2e2bcd8739ae039), {
        editorView: editorView,
        mountPoint: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        tableRef: tableRef,
        tableNode: tableNode,
        targetCellPosition: targetCellPosition,
        direction: dragMenuDirection,
        index: dragMenuIndex,
        isOpen: !!isDragMenuOpen && !isResizing,
        getEditorContainerWidth: defaultGetEditorContainerWidth,
        editorAnalyticsAPI: editorAnalyticsAPI,
        stickyHeaders: stickyHeader,
        pluginConfig: pluginConfig,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
        ariaNotifyPlugin: ariaNotifyPlugin,
        api: api,
        isCommentEditor: options?.isCommentEditor,
        tableWrapper: tableWrapperTarget
    }), (options?.isTableScalingEnabled || options?.tableOptions.allowTableResizing && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9fe09278da412093$export$a60e1be3b6001ff3), {
        target: resizingTableRef,
        content: (0, $fqVYq.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiyg1.ResizerBreakoutModeLabel), {
            layout: "full-width"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c87f0a8e4c59981e$export$8bde7db5b2aba7d), null),
        alignX: 'center',
        alignY: 'bottom',
        stick: true,
        forcePlacement: true,
        zIndex: (0, $7Y8M5.akEditorFloatingPanelZIndex),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ]
    }), isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2844c150515f03ae$export$800b7d81026538f2), {
        api: api,
        isOpenedByKeyboard: false,
        popupsMountPoint: popupsMountPoint,
        target: sizeSelectorTargetRef ?? (0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api?.analytics?.actions),
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement
    }));
};
const $d0cd06c03a409ff7$export$2dda1e4a1d1f6a81 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h75sz.ErrorBoundary), {
        component: (0, $krYZG.ACTION_SUBJECT).TABLES_PLUGIN,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $09f920d800d52047$export$cc5403d58ddfa812), {
        featureFlags: api?.featureFlags?.sharedState.currentState(),
        api: api
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d0cd06c03a409ff7$var$ContentComponentInternal, {
        api: api,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        options: options,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isTableSelectorEnabled: isTableSelectorEnabled,
        defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
        defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags
    }));
};









var $jgJIe = parcelRequire("jgJIe");


var $372k4 = parcelRequire("372k4");


var $2v0Un = parcelRequire("2v0Un");


var $j0Bn2 = parcelRequire("j0Bn2");



















var $dVKvM = parcelRequire("dVKvM");




/**
 * Merge cells is only visible when the active selection can actually be merged
 * (multi-cell, non-overlapping).
 */ const $1558a907ff2b7b5e$var$shouldShowMergeCells = (tableMenuContext)=>tableMenuContext?.canMergeCells === true;
const $1558a907ff2b7b5e$export$860c28593c1aa9bb = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$96680f9d22153cab)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!$1558a907ff2b7b5e$var$shouldShowMergeCells(tableMenuContext)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5de7B))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $fKJ7J.messages).mergeCells));
};






















/**
 * Split cell is only visible when the active selection sits in a cell whose
 * `rowspan` or `colspan` is greater than one.
 */ const $c596a099bd2a4c2d$var$shouldShowSplitCell = (tableMenuContext)=>tableMenuContext?.canSplitCell === true;
const $c596a099bd2a4c2d$export$d79dfb0d5c37e690 = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$e30671f873d3125c)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).CONTEXT_MENU)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!$c596a099bd2a4c2d$var$shouldShowSplitCell(tableMenuContext)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($53Mds))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $fKJ7J.messages).splitCell));
};



















const $7de3bf9891917f98$var$getNormalizedValign = (valign)=>valign ?? 'top';
const $7de3bf9891917f98$export$a5cc539f15f26080 = (editorView)=>{
    if (!editorView) return 'top';
    const { state: state } = editorView;
    const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(state);
    const cell = typeof targetCellPosition === 'number' ? state.doc.nodeAt(targetCellPosition) : undefined;
    return $7de3bf9891917f98$var$getNormalizedValign(cell?.attrs.valign);
};


const $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c = ({ api: api, icon: Icon, label: label, value: value })=>{
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedValign = (0, $cozmU.useMemo)(()=>(0, $7de3bf9891917f98$export$a5cc539f15f26080)(editorView), [
        editorView
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!editorView || !api) return;
        const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
        api.core.actions.execute(({ tr: tr })=>{
            (0, $70029e39e0a22c66$export$816bc15c63933c5f)(api.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, value, targetCellPosition)({
                tr: tr
            });
            (0, $4c617ebfadab8027$export$68481d8823bb24fb)(api)({
                tr: tr
            });
            return tr;
        });
        api.core.actions.focus();
    }, [
        api,
        editorView,
        value
    ]);
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isSelected: selectedValign === value,
        onClick: handleClick,
        role: "menuitemradio"
    }, formatMessage(label));
};












var $97uS1 = parcelRequire("97uS1");

var $gk3KR = parcelRequire("gk3KR");












const $4ec8e0d1b546ee6a$var$getTriggerIcon = (valign)=>{
    switch(valign){
        case 'middle':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2v0Un));
        case 'bottom':
            return 0, (/*@__PURE__*/$parcel$interopDefault($372k4));
        case 'top':
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($j0Bn2));
    }
};
const $4ec8e0d1b546ee6a$export$711d24ebe8961c4c = ({ children: children })=>{
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedValign = (0, $cozmU.useMemo)(()=>(0, $7de3bf9891917f98$export$a5cc539f15f26080)(editorView), [
        editorView
    ]);
    const TriggerIcon = $4ec8e0d1b546ee6a$var$getTriggerIcon(selectedValign);
    if (!editorView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerIcon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97uS1.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $fKJ7J.messages).cellAlignment)
    }, children);
};



const $cbd8b8eabc3a7a69$export$2dfd78068db84eff = ({ api: api })=>(0, $ixfCV.fg)('platform_editor_table_cell_menu_update') ? [
        // --- Cell menu update ON ---
        // Merge/Split cells move into the Add section (alongside the shared add/distribute
        // items); the danger section gains the shared Delete column/row items.
        // --- Menu surface ---
        {
            type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
            key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key
        },
        // --- Main action section (Background color, Vertical align) ---
        {
            type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
            key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
                    key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key,
                    rank: (0, $b045de5a05ab28f6$export$8770b59bbf22f751)[(0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).type,
            key: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $b045de5a05ab28f6$export$b015955eb6c647e8).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ec8e0d1b546ee6a$export$711d24ebe8961c4c), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
            key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).type,
                    key: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).key,
                    rank: (0, $b045de5a05ab28f6$export$3094a3221df5ea5d)[(0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).type,
            key: (0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($j0Bn2))),
                    label: (0, $fKJ7J.messages).cellAlignmentTop,
                    value: "top"
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).type,
            key: (0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2v0Un))),
                    label: (0, $fKJ7J.messages).cellAlignmentMiddle,
                    value: "middle"
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$3348ad90bdbb18b).type,
            key: (0, $b045de5a05ab28f6$export$3348ad90bdbb18b).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$3348ad90bdbb18b).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($372k4))),
                    label: (0, $fKJ7J.messages).cellAlignmentBottom,
                    value: "bottom"
                })
        },
        // --- Add / Move section (shared Add column right / Add row below / Distribute
        // columns are registered in `../shared/getSharedItems`; Merge/Split cells below) ---
        {
            type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
            key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
                    key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key,
                    rank: (0, $b045de5a05ab28f6$export$8770b59bbf22f751)[(0, $b045de5a05ab28f6$export$263b4b5ce540189d).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).type,
            key: (0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
                    key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
                    rank: (0, $b045de5a05ab28f6$export$75f616c8c0c24cae)[(0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1558a907ff2b7b5e$export$860c28593c1aa9bb), {
                    api: api
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$4a4b751aa9083b35).type,
            key: (0, $b045de5a05ab28f6$export$4a4b751aa9083b35).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
                    key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
                    rank: (0, $b045de5a05ab28f6$export$75f616c8c0c24cae)[(0, $b045de5a05ab28f6$export$4a4b751aa9083b35).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c596a099bd2a4c2d$export$d79dfb0d5c37e690), {
                    api: api
                })
        },
        // --- Danger section (Clear cell + shared Delete column / Delete row) ---
        {
            type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
            key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
                    key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key,
                    rank: (0, $b045de5a05ab28f6$export$8770b59bbf22f751)[(0, $b045de5a05ab28f6$export$ae771163ae415c91).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        }
    ] : [
        // --- Cell menu update OFF: legacy cell menu (Merge/Split live in the action section) ---
        // --- Menu surface ---
        {
            type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
            key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key
        },
        // --- Main action section (Background color, Merge cells, Split cell) ---
        {
            type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
            key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
                    key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key,
                    rank: (0, $b045de5a05ab28f6$export$8770b59bbf22f751)[(0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).type,
            key: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $b045de5a05ab28f6$export$b015955eb6c647e8).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ec8e0d1b546ee6a$export$711d24ebe8961c4c), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
            key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).type,
                    key: (0, $b045de5a05ab28f6$export$b015955eb6c647e8).key,
                    rank: (0, $b045de5a05ab28f6$export$3094a3221df5ea5d)[(0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).type,
            key: (0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$4aeebd1c4003f0d1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($j0Bn2))),
                    label: (0, $fKJ7J.messages).cellAlignmentTop,
                    value: "top"
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).type,
            key: (0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$fdb9421b7fa72aa6).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2v0Un))),
                    label: (0, $fKJ7J.messages).cellAlignmentMiddle,
                    value: "middle"
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$3348ad90bdbb18b).type,
            key: (0, $b045de5a05ab28f6$export$3348ad90bdbb18b).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).type,
                    key: (0, $b045de5a05ab28f6$export$2ee0b7de1ba81016).key,
                    rank: (0, $b045de5a05ab28f6$export$9767915495221593)[(0, $b045de5a05ab28f6$export$3348ad90bdbb18b).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3d685f1d3cfc59f$export$d49b4cfa8d7eb46c), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($372k4))),
                    label: (0, $fKJ7J.messages).cellAlignmentBottom,
                    value: "bottom"
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).type,
            key: (0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $b045de5a05ab28f6$export$b58e7f7cb85261bb).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1558a907ff2b7b5e$export$860c28593c1aa9bb), {
                    api: api
                })
        },
        {
            type: (0, $b045de5a05ab28f6$export$4a4b751aa9083b35).type,
            key: (0, $b045de5a05ab28f6$export$4a4b751aa9083b35).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $b045de5a05ab28f6$export$4a4b751aa9083b35).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c596a099bd2a4c2d$export$d79dfb0d5c37e690), {
                    api: api
                })
        },
        // --- Danger section (Clear cell) ---
        {
            type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
            key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
            parents: [
                {
                    type: (0, $b045de5a05ab28f6$export$190f9a1b925620da).type,
                    key: (0, $b045de5a05ab28f6$export$190f9a1b925620da).key,
                    rank: (0, $b045de5a05ab28f6$export$8770b59bbf22f751)[(0, $b045de5a05ab28f6$export$ae771163ae415c91).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        }
    ];





































var $i9j2V = parcelRequire("i9j2V");




const $618e4d1c64d77931$export$3d6de3c2da0f12e9 = ({ api: api })=>{
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState?.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState?.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState?.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        const index = selectionRect?.left;
        if (index === undefined) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $70029e39e0a22c66$export$fc693eab55df8b35)(api, api?.analytics?.actions, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, index)(editorView.state, editorView.dispatch, editorView);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWZGH))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addColumnBefore)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).addColumnLeft));
};







































const $f12dba47e5569ed1$export$7b5d5e575078343e = (selection)=>{
    if (!(0, $ixfCV.fg)('platform_editor_table_cell_menu_update')) return (0, $hC0Ga.getSelectionRect)(selection);
    return (0, $bc8rR.isSelectionType)(selection, 'cell') ? (0, $hC0Ga.getSelectionRect)(selection) : (0, $cycWk.findCellRectClosestToPos)(selection.$from);
};



const $45f195252a44263c$export$790a355d691039c9 = ({ api: api })=>{
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState?.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState?.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState?.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        const index = selectionRect?.right;
        if (index === undefined) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $70029e39e0a22c66$export$fc693eab55df8b35)(api, api?.analytics?.actions, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, index)(editorView.state, editorView.dispatch, editorView);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eehur))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addColumnAfter)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).addColumnRight));
};
































const $ef7daf16eef1b1ed$export$dade01215233a7bf = ({ isFirstColumn: isFirstColumn, isHeaderColumnAllowed: isHeaderColumnAllowed, selectedColumnCount: selectedColumnCount })=>isHeaderColumnAllowed === true && isFirstColumn === true && selectedColumnCount === 1;
const $ef7daf16eef1b1ed$export$9d690116d46d85ce = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderColumnAllowed: isHeaderColumnAllowed, isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isHeaderColumnAllowed: states.tableState?.pluginConfig?.allowHeaderColumn,
            isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $fKJ7J.messages).headerColumn);
    const handleClick = ()=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$9fd5a66fcada8ad2)(api?.analytics?.actions)(editorView.state, editorView.dispatch);
    };
    if (!$ef7daf16eef1b1ed$export$dade01215233a7bf({
        isFirstColumn: tableMenuContext?.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext?.selectedColumnCount
    })) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            label: label,
            isChecked: !!isHeaderColumnEnabled,
            onChange: handleClick
        })
    }, label);
};


const $b54c149023964a21$export$5b0d88ff04cc328c = ({ api: api, children: children })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { isHeaderColumnAllowed: isHeaderColumnAllowed } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isHeaderColumnAllowed: states.tableState?.pluginConfig?.allowHeaderColumn
        }));
    const hasSeparator = (0, $ef7daf16eef1b1ed$export$dade01215233a7bf)({
        isFirstColumn: tableMenuContext?.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext?.selectedColumnCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator
    }, children);
};













const $58ca0d77e256ccd4$export$e0bba57c586892e5 = ({ api: api, children: children })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { isHeaderColumnAllowed: isHeaderColumnAllowed } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isHeaderColumnAllowed: states.tableState?.pluginConfig?.allowHeaderColumn
        }));
    if (!(0, $ef7daf16eef1b1ed$export$dade01215233a7bf)({
        isFirstColumn: tableMenuContext?.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext?.selectedColumnCount
    })) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, children);
};
































const $ccaaced34de0e7cf$export$7840ed9912c84130 = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const selectedColumnCount = tableMenuContext?.selectedColumnCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState?.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState?.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState?.isTableScalingEnabled
        };
    });
    const handleMouseEnter = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $47589dd3b7f399b2$export$4cf548f2efac0afe)((0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), true)(editorView.state, editorView.dispatch);
    };
    const handleMouseLeave = ()=>{
        if (!editorView) return;
        (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(editorView.state, editorView.dispatch);
    };
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        if (!selectionRect) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $70029e39e0a22c66$export$4c11b948fab97510)(api?.analytics?.actions, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect)(editorView.state, editorView.dispatch, editorView);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        onBlur: handleMouseLeave,
        onMouseLeave: handleMouseLeave,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.deleteColumn)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).removeColumns, {
        0: selectedColumnCount
    }));
};



























/** Distribute columns is only visible when more than one column is selected. */ const $dbcf14159570fbba$var$shouldShowDistributeColumns = (selectedColumnCount)=>(selectedColumnCount ?? 0) > 1;
const $dbcf14159570fbba$export$b038fb9a55c447ee = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState?.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState?.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState?.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        const editorContainerWidth = api?.width?.sharedState.currentState();
        if (!selectionRect || !editorContainerWidth) return;
        const newResizeState = (0, $da3a78eceffe80bd$export$8490eb29eba3007d)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), ()=>editorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (!newResizeState) return;
        (0, $70029e39e0a22c66$export$9bca7816a0c95373)(api?.analytics?.actions, api)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!$dbcf14159570fbba$var$shouldShowDistributeColumns(tableMenuContext?.selectedColumnCount)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh9HJ))), {
            color: "currentColor",
            label: "",
            size: "small"
        })
    }, formatMessage((0, $fKJ7J.messages).distributeColumns));
};






































const $fcbd7ee969fcd16c$var$shouldShowMoveColumnLeft = (isFirstColumn)=>!isFirstColumn;
const $fcbd7ee969fcd16c$export$dda1f0abce68f555 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            tableNode: states.tableState?.tableNode
        }));
    const selectedColumnCount = tableMenuContext?.selectedColumnCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(api?.analytics?.actions, api?.accessibilityUtils?.actions.ariaNotify, (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state).getIntl)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $b012a0a8cdd0c09d$export$2f97b0848614fec9), (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), selectionRect.left - 1)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!tableNode || !$fcbd7ee969fcd16c$var$shouldShowMoveColumnLeft(tableMenuContext?.isFirstColumn)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iMVfw))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.moveColumnLeft)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).moveColumnLeft, {
        0: selectedColumnCount
    }));
};




































const $0c52e3cdd5eb9b78$var$shouldShowMoveColumnRight = (isLastColumn)=>!isLastColumn;
const $0c52e3cdd5eb9b78$export$6a6c7fe03e6819e3 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            tableNode: states.tableState?.tableNode
        }));
    const selectedColumnCount = tableMenuContext?.selectedColumnCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(api?.analytics?.actions, api?.accessibilityUtils?.actions.ariaNotify, (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state).getIntl)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $b012a0a8cdd0c09d$export$2f97b0848614fec9), (0, $61cf1c01aee4adc2$export$915a77877be361e9)(selectionRect), selectionRect.right)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!tableNode || !$0c52e3cdd5eb9b78$var$shouldShowMoveColumnRight(tableMenuContext?.isLastColumn)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRp8L))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.moveColumnRight)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).moveColumnRight, {
        0: selectedColumnCount
    }));
};


/* SortDecreasingItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $a1ZzW = parcelRequire("a1ZzW");









var $iMnC5 = parcelRequire("iMnC5");







const $b9c50be643e3f4eb$var$styles = {
    disabledLabel: "_syaz1gmx",
    infoIconTrigger: "_1e0c116y _4cvr1h6o"
};
const $b9c50be643e3f4eb$export$d429b5b13299a5d2 = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasMergedCellsInTable = Boolean(tableMenuContext?.hasMergedCellsInTable);
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        const columnIndex = selectionRect?.left;
        if (columnIndex === undefined) return;
        (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, columnIndex, (0, $6faDz.SortOrder).DESC)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    }; // When the table has merged cells, the item remains interactive but is rendered
    // with a disabled-looking label and leading icon, alongside an enabled info icon
    // that surfaces why sorting is unavailable.
    if (hasMergedCellsInTable && (0, $ixfCV.fg)('platform_editor_table_menu_updates_patch_1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
            label: "",
            size: "small",
            color: "var(--ds-text-disabled, #080F214A)"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fKJ7J.messages).canNotSortTableNoIcon),
            position: "top"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                as: "span",
                xcss: $b9c50be643e3f4eb$var$styles.infoIconTrigger,
                ...tooltipProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                label: "",
                size: "small",
                color: "var(--ds-icon, #292A2E)"
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $b9c50be643e3f4eb$var$styles.disabledLabel
    }, formatMessage((0, $fKJ7J.messages).sortColumnDecreasing)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isDisabled: Boolean(tableMenuContext?.hasMergedCellsInTable),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $fKJ7J.messages).sortColumnDecreasing));
};


/* SortIncreasingItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 




































const $021a8bab1cbafcc3$var$styles = {
    disabledLabel: "_syaz1gmx",
    infoIconTrigger: "_1e0c116y _4cvr1h6o"
};
const $021a8bab1cbafcc3$export$dbae1ebe00b36634 = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasMergedCellsInTable = Boolean(tableMenuContext?.hasMergedCellsInTable);
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        const columnIndex = selectionRect?.left;
        if (columnIndex === undefined) return;
        (0, $70029e39e0a22c66$export$1be9cb7a554871e3)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, columnIndex, (0, $6faDz.SortOrder).ASC)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    }; // When the table has merged cells, the item remains interactive but is rendered
    // with a disabled-looking label and leading icon, alongside an enabled info icon
    // that surfaces why sorting is unavailable.
    if (hasMergedCellsInTable && (0, $ixfCV.fg)('platform_editor_table_menu_updates_patch_1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63qYG))), {
            label: "",
            size: "small",
            color: "var(--ds-text-disabled, #080F214A)"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fKJ7J.messages).canNotSortTableNoIcon),
            position: "top"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                as: "span",
                xcss: $021a8bab1cbafcc3$var$styles.infoIconTrigger,
                ...tooltipProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                label: "",
                size: "small",
                color: "var(--ds-icon, #292A2E)"
            })))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $021a8bab1cbafcc3$var$styles.disabledLabel
    }, formatMessage((0, $fKJ7J.messages).sortColumnIncreasing)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        isDisabled: Boolean(tableMenuContext?.hasMergedCellsInTable),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63qYG))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $fKJ7J.messages).sortColumnIncreasing));
};



const $53931d64168b46f1$export$eca8f3a6aa996ce2 = ({ api: api })=>(0, $ixfCV.fg)('platform_editor_table_cell_menu_update') ? [
        // --- Cell menu update ON ---
        // AddColumnRightItem/DistributeColumnsItem/DeleteColumnItem are registered in
        // `../shared/getSharedItems` (shared with the cell menu), so they are omitted here.
        // --- Menu surface ---
        {
            type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
            key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key
        },
        // --- Toggle section (Header column) ---
        {
            type: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).type,
            key: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58ca0d77e256ccd4$export$e0bba57c586892e5), {
                    api: api
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$70437eab3a41306c).type,
            key: (0, $495b1900dd6e1ce7$export$70437eab3a41306c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).type,
                    key: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key,
                    rank: (0, $495b1900dd6e1ce7$export$55d9aafd67ce68f)[(0, $495b1900dd6e1ce7$export$70437eab3a41306c).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef7daf16eef1b1ed$export$9d690116d46d85ce), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).type,
            key: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b54c149023964a21$export$5b0d88ff04cc328c), {
                    api: api
                }, props.children)
        },
        // --- Sort section ---
        {
            type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
            key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$53f931b253816d5f).type,
            key: (0, $495b1900dd6e1ce7$export$53f931b253816d5f).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
                    key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
                    rank: (0, $495b1900dd6e1ce7$export$dc7b7fa82abf029)[(0, $495b1900dd6e1ce7$export$53f931b253816d5f).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $021a8bab1cbafcc3$export$dbae1ebe00b36634), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).type,
            key: (0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
                    key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
                    rank: (0, $495b1900dd6e1ce7$export$dc7b7fa82abf029)[(0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9c50be643e3f4eb$export$d429b5b13299a5d2), {
                    api: api
                })
        },
        // --- Add / Move section ---
        {
            type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
            key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$313a331094e8e40).type,
            key: (0, $495b1900dd6e1ce7$export$313a331094e8e40).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$313a331094e8e40).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $618e4d1c64d77931$export$3d6de3c2da0f12e9), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$e5b0244351372e94).type,
            key: (0, $495b1900dd6e1ce7$export$e5b0244351372e94).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$e5b0244351372e94).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcbd7ee969fcd16c$export$dda1f0abce68f555), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).type,
            key: (0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c52e3cdd5eb9b78$export$6a6c7fe03e6819e3), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete column) ---
        {
            type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
            key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        }
    ] : [
        // --- Cell menu update OFF: legacy column menu (registers its own add/delete items) ---
        // --- Menu surface ---
        {
            type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
            key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key
        },
        // --- Toggle section (Header column) ---
        {
            type: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).type,
            key: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58ca0d77e256ccd4$export$e0bba57c586892e5), {
                    api: api
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$70437eab3a41306c).type,
            key: (0, $495b1900dd6e1ce7$export$70437eab3a41306c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).type,
                    key: (0, $495b1900dd6e1ce7$export$868359cdd46b8e96).key,
                    rank: (0, $495b1900dd6e1ce7$export$55d9aafd67ce68f)[(0, $495b1900dd6e1ce7$export$70437eab3a41306c).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef7daf16eef1b1ed$export$9d690116d46d85ce), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).type,
            key: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b54c149023964a21$export$5b0d88ff04cc328c), {
                    api: api
                }, props.children)
        },
        // --- Sort section ---
        {
            type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
            key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$53f931b253816d5f).type,
            key: (0, $495b1900dd6e1ce7$export$53f931b253816d5f).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
                    key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
                    rank: (0, $495b1900dd6e1ce7$export$dc7b7fa82abf029)[(0, $495b1900dd6e1ce7$export$53f931b253816d5f).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $021a8bab1cbafcc3$export$dbae1ebe00b36634), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).type,
            key: (0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).type,
                    key: (0, $495b1900dd6e1ce7$export$d76bf3eb1cb3622e).key,
                    rank: (0, $495b1900dd6e1ce7$export$dc7b7fa82abf029)[(0, $495b1900dd6e1ce7$export$bd9506c8b0be373c).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9c50be643e3f4eb$export$d429b5b13299a5d2), {
                    api: api
                })
        },
        // --- Add / Move section ---
        {
            type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
            key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$313a331094e8e40).type,
            key: (0, $495b1900dd6e1ce7$export$313a331094e8e40).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$313a331094e8e40).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $618e4d1c64d77931$export$3d6de3c2da0f12e9), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$369288a3adc8cde7).type,
            key: (0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45f195252a44263c$export$790a355d691039c9), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$e5b0244351372e94).type,
            key: (0, $495b1900dd6e1ce7$export$e5b0244351372e94).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$e5b0244351372e94).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcbd7ee969fcd16c$export$dda1f0abce68f555), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).type,
            key: (0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$49af2aec08b8ed97).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c52e3cdd5eb9b78$export$6a6c7fe03e6819e3), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).type,
            key: (0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbcf14159570fbba$export$b038fb9a55c447ee), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete column) ---
        {
            type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
            key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).type,
                    key: (0, $495b1900dd6e1ce7$export$f8a6b1c18fca6bfa).key,
                    rank: (0, $495b1900dd6e1ce7$export$d6f0842ac421fece)[(0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $495b1900dd6e1ce7$export$4d0f5768433488cd).type,
            key: (0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
                    key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
                    rank: (0, $495b1900dd6e1ce7$export$7549083293c6b325)[(0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccaaced34de0e7cf$export$7840ed9912c84130), {
                    api: api
                })
        }
    ];







































const $18b4768cb299a7e2$export$138f9370dd8b98ae = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        const index = selectionRect?.top;
        if (index === undefined) return;
        (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, {
            index: index,
            moveCursorToInsertedRow: true
        })(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jJItz))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addRowBefore)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).addRowAbove));
};




























const $21a8151ddbedb679$export$3fc3a5ba73261067 = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        const index = selectionRect?.bottom;
        if (index === undefined) return;
        (0, $70029e39e0a22c66$export$e45f3a1f9c021052)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, {
            index: index,
            moveCursorToInsertedRow: true
        })(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i8vym))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.addRowAfter)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).addRowBelow));
};
































const $01bf7cd46923e0a4$export$841535b3f254af3a = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderRowRequired: isHeaderRowRequired } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isHeaderRowRequired: states.tableState?.pluginConfig?.isHeaderRowRequired
        }));
    const selectedRowCount = tableMenuContext?.selectedRowCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleMouseEnter = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $47589dd3b7f399b2$export$ab63d99b591b89)((0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), true)(editorView.state, editorView.dispatch);
    };
    const handleMouseLeave = ()=>{
        if (!editorView) return;
        (0, $47589dd3b7f399b2$export$d4bebf197f3770e4)()(editorView.state, editorView.dispatch);
    };
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $f12dba47e5569ed1$export$7b5d5e575078343e)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $70029e39e0a22c66$export$ad9854279980efbe)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        onBlur: handleMouseLeave,
        onMouseLeave: handleMouseLeave,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.deleteRow)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).removeRows, {
        0: selectedRowCount
    }));
};






















/** Header row toggle is only visible when the first row is the entire selection. */ const $95a7c318b3ee673e$var$shouldShowHeaderRowToggle = ({ isFirstRow: isFirstRow, isHeaderRowAllowed: isHeaderRowAllowed, selectedRowCount: selectedRowCount })=>isHeaderRowAllowed === true && isFirstRow && selectedRowCount === 1;
const $95a7c318b3ee673e$export$9dea3bd6b52ecc8f = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderRowAllowed: isHeaderRowAllowed, isHeaderRowEnabled: isHeaderRowEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isHeaderRowAllowed: states.tableState?.pluginConfig?.allowHeaderRow,
            isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled
        }));
    const selectedRowCount = tableMenuContext?.selectedRowCount ?? 0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $fKJ7J.messages).headerRow);
    const handleClick = ()=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$2e66edaa488e7a1d)(api?.analytics?.actions)(editorView.state, editorView.dispatch);
    };
    if (!$95a7c318b3ee673e$var$shouldShowHeaderRowToggle({
        isFirstRow: tableMenuContext?.isFirstRow === true,
        isHeaderRowAllowed: isHeaderRowAllowed,
        selectedRowCount: selectedRowCount
    })) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            label: label,
            isChecked: !!isHeaderRowEnabled,
            onChange: handleClick
        })
    }, label);
};




































const $d14534a5336f80b3$var$shouldShowMoveRowDown = (isLastRow)=>!isLastRow;
const $d14534a5336f80b3$export$59ceb255a30542d3 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            tableNode: states.tableState?.tableNode
        }));
    const selectedRowCount = tableMenuContext?.selectedRowCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(api?.analytics?.actions, api?.accessibilityUtils?.actions.ariaNotify, (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state).getIntl)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $b012a0a8cdd0c09d$export$1aad44a7533f8ad8), (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), selectionRect.bottom)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!tableNode || !$d14534a5336f80b3$var$shouldShowMoveRowDown(tableMenuContext?.isLastRow)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1isWY))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.moveRowDown)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).moveRowDown, {
        0: selectedRowCount
    }));
};




































const $31d62202ebefad67$var$shouldShowMoveRowUp = (isFirstRow)=>!isFirstRow;
const $31d62202ebefad67$export$6cf86f5e7d0cc460 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            tableNode: states.tableState?.tableNode
        }));
    const selectedRowCount = tableMenuContext?.selectedRowCount ?? 1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $hC0Ga.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $b1a4a1bc8826a6a3$export$137f4de350aca2d8)(api?.analytics?.actions, api?.accessibilityUtils?.actions.ariaNotify, (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state).getIntl)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $b012a0a8cdd0c09d$export$1aad44a7533f8ad8), (0, $61cf1c01aee4adc2$export$d023456f91fdf995)(selectionRect), selectionRect.top - 1)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    if (!tableNode || !$31d62202ebefad67$var$shouldShowMoveRowUp(tableMenuContext?.isFirstRow)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kSpvN))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.moveRowUp)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).moveRowUp, {
        0: selectedRowCount
    }));
};






















const $c5469e2d0202d5fb$export$e0ecc089c0583a2d = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { isNumberColumnAllowed: isNumberColumnAllowed, isNumberColumnEnabled: isNumberColumnEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>({
            isNumberColumnAllowed: states.tableState?.pluginConfig?.allowNumberColumn,
            isNumberColumnEnabled: states.tableState?.isNumberColumnEnabled
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $fKJ7J.messages).numberedRows);
    const handleClick = ()=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$9e4b8d27ecc9c55)(api?.analytics?.actions)(editorView.state, editorView.dispatch);
    };
    if (!isNumberColumnAllowed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            label: label,
            isChecked: !!isNumberColumnEnabled,
            onChange: handleClick
        })
    }, label);
};



const $8b9310be296a0141$export$c176756f533b3bad = ({ api: api })=>(0, $ixfCV.fg)('platform_editor_table_cell_menu_update') ? [
        // --- Cell menu update ON ---
        // AddRowBelowItem/DeleteRowItem are registered in `../shared/getSharedItems`
        // (shared with the cell menu), so they are omitted here.
        // --- Menu surface ---
        {
            type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
            key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key
        },
        // --- Toggle section (Header row, Numbered rows) ---
        {
            type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
            key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).type,
            key: (0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
                    key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
                    rank: (0, $d0d78e4f78ab53f8$export$d75534200c5cba18)[(0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95a7c318b3ee673e$export$9dea3bd6b52ecc8f), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).type,
            key: (0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
                    key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
                    rank: (0, $d0d78e4f78ab53f8$export$d75534200c5cba18)[(0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5469e2d0202d5fb$export$e0ecc089c0583a2d), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).type,
            key: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        // --- Add / Move section ---
        {
            type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
            key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).type,
            key: (0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18b4768cb299a7e2$export$138f9370dd8b98ae), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).type,
            key: (0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31d62202ebefad67$export$6cf86f5e7d0cc460), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$489645ca66afd844).type,
            key: (0, $d0d78e4f78ab53f8$export$489645ca66afd844).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$489645ca66afd844).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d14534a5336f80b3$export$59ceb255a30542d3), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete row) ---
        {
            type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
            key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        }
    ] : [
        // --- Cell menu update OFF: legacy row menu (registers its own add/delete items) ---
        // --- Menu surface ---
        {
            type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
            key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key
        },
        // --- Toggle section (Header row, Numbered rows) ---
        {
            type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
            key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, props.children)
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).type,
            key: (0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
                    key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
                    rank: (0, $d0d78e4f78ab53f8$export$d75534200c5cba18)[(0, $d0d78e4f78ab53f8$export$f53435d29f0ad0a1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95a7c318b3ee673e$export$9dea3bd6b52ecc8f), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).type,
            key: (0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).type,
                    key: (0, $d0d78e4f78ab53f8$export$87244e8119d8581c).key,
                    rank: (0, $d0d78e4f78ab53f8$export$d75534200c5cba18)[(0, $d0d78e4f78ab53f8$export$6b0a072235fdd804).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5469e2d0202d5fb$export$e0ecc089c0583a2d), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).type,
            key: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        // --- Add / Move section ---
        {
            type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
            key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).type,
            key: (0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$e4528482450d5f2e).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18b4768cb299a7e2$export$138f9370dd8b98ae), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).type,
            key: (0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21a8151ddbedb679$export$3fc3a5ba73261067), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).type,
            key: (0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$6a0b892b38736f32).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31d62202ebefad67$export$6cf86f5e7d0cc460), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$489645ca66afd844).type,
            key: (0, $d0d78e4f78ab53f8$export$489645ca66afd844).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$489645ca66afd844).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d14534a5336f80b3$export$59ceb255a30542d3), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete row) ---
        {
            type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
            key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).type,
                    key: (0, $d0d78e4f78ab53f8$export$335a830a90e5dc34).key,
                    rank: (0, $d0d78e4f78ab53f8$export$9de76c9f0172de51)[(0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, props.children)
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).type,
            key: (0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
                    key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
                    rank: (0, $d0d78e4f78ab53f8$export$5cf4383498669284)[(0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01bf7cd46923e0a4$export$841535b3f254af3a), {
                    api: api
                })
        }
    ];
















/* BackgroundColorItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");



































const $824fb4b6610864b8$var$colorPaletteColumns = 7;
const $824fb4b6610864b8$var$colorPaletteStyles = {
    container: "_1rjcu2gc",
    elemAfter: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    colorPreview: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsbdlk8 _4t3idlk8 _1o9zidpf"
};
const $824fb4b6610864b8$export$b0a2efdf78e6aed2 = ({ api: api })=>{
    const { editorView: editorView } = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)() ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedColor = (0, $cozmU.useMemo)(()=>{
        if (!editorView) return '#ffffff';
        const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
        const node = targetCellPosition ? editorView.state.doc.nodeAt(targetCellPosition) : null;
        return (0, $lqPdm.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
    }, [
        editorView
    ]);
    const onClick = (0, $cozmU.useCallback)((color)=>{
        if (!editorView) return;
        (0, $70029e39e0a22c66$export$d0cc02883d6bbba)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, color, editorView)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    }, [
        api,
        editorView
    ]); // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const colorPreviewStyle = (0, $cozmU.useMemo)(()=>({
            backgroundColor: selectedColor
        }), [
        selectedColor
    ]);
    const paletteOptions = (0, $cozmU.useMemo)(()=>{
        return {
            palette: (0, $b37f1c99fe49c1e2$export$2e2bcd8739ae039),
            paletteColorTooltipMessages: (0, $8VCvx.backgroundPaletteTooltipMessages),
            hexToPaletteColor: (0, $lqPdm.hexToEditorBackgroundPaletteColor)
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b391T))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $824fb4b6610864b8$var$colorPaletteStyles.elemAfter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: colorPreviewStyle,
            className: (0, $hekY6.default)([
                $824fb4b6610864b8$var$colorPaletteStyles.colorPreview
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97uS1.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        })),
        text: formatMessage((0, $fKJ7J.messages).backgroundColor)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $824fb4b6610864b8$var$colorPaletteStyles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xQNd.default), {
        cols: $824fb4b6610864b8$var$colorPaletteColumns,
        onClick: onClick,
        selectedColor: colorPreviewStyle.backgroundColor,
        paletteOptions: paletteOptions
    })));
};


















var $l3wuH = parcelRequire("l3wuH");









const $4a801d3dad17c06f$export$8b64094e7c2cc90 = ({ api: api })=>{
    const tableMenuContext = (0, $9e2d9387cba2bb3b$export$3ac6ec6862f4c02f)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const selectedCellCount = Math.max(tableMenuContext?.selectedColumnCount ?? 1, tableMenuContext?.selectedRowCount ?? 1);
    const handleClick = ()=>{
        if (!editorView) return;
        const { targetCellPosition: targetCellPosition } = (0, $8fc50ac4440f7aa5$export$f05434c51e3762e)(editorView.state);
        (0, $70029e39e0a22c66$export$67e5a2aa802b5be1)(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(editorView.state, editorView.dispatch);
        api?.core.actions.execute((0, $4c617ebfadab8027$export$68481d8823bb24fb)(api));
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.tooltip)((0, $ldqjS.backspace)) ?? ''
        })
    }, formatMessage((0, $fKJ7J.messages).clearCells, {
        0: selectedCellCount
    }));
};



const $e5cfcd403885e6c2$export$58613b8ba3de644b = ({ api: api })=>(0, $ixfCV.fg)('platform_editor_table_cell_menu_update') ? [
        // --- Cell menu update ON ---
        // The add/delete items move out of the row/column menu files and are registered here
        // once with an additional cell parent, so they render inside the cell menu too.
        {
            type: (0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).type,
            key: (0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).type,
                    key: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key,
                    rank: (0, $d0d78e4f78ab53f8$export$2476e690f9168fc5)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                },
                {
                    type: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).type,
                    key: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key,
                    rank: (0, $495b1900dd6e1ce7$export$bc1c17ea404e1e65)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $824fb4b6610864b8$export$b0a2efdf78e6aed2), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$369288a3adc8cde7).type,
            key: (0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
                    key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
                    rank: (0, $b045de5a05ab28f6$export$75f616c8c0c24cae)[(0, $495b1900dd6e1ce7$export$369288a3adc8cde7).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45f195252a44263c$export$790a355d691039c9), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).type,
            key: (0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).type,
                    key: (0, $d0d78e4f78ab53f8$export$d478a53ed2abe40f).key,
                    rank: (0, $d0d78e4f78ab53f8$export$64075ae5fd18cb9c)[(0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
                    key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
                    rank: (0, $b045de5a05ab28f6$export$75f616c8c0c24cae)[(0, $d0d78e4f78ab53f8$export$c0c87706fa348bc1).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21a8151ddbedb679$export$3fc3a5ba73261067), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).type,
            key: (0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).type,
                    key: (0, $495b1900dd6e1ce7$export$10cac5e3b97c49c5).key,
                    rank: (0, $495b1900dd6e1ce7$export$16082c766842f755)[(0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).type,
                    key: (0, $b045de5a05ab28f6$export$263b4b5ce540189d).key,
                    rank: (0, $b045de5a05ab28f6$export$75f616c8c0c24cae)[(0, $495b1900dd6e1ce7$export$82d2c16b28fc2c87).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbcf14159570fbba$export$b038fb9a55c447ee), {
                    api: api
                })
        },
        {
            type: (0, $bf9c2f49f53f3f37$export$7c71e4184715e790).type,
            key: (0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
                    key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
                    rank: (0, $d0d78e4f78ab53f8$export$5cf4383498669284)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                },
                {
                    type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
                    key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
                    rank: (0, $495b1900dd6e1ce7$export$7549083293c6b325)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
                    key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
                    rank: (0, $b045de5a05ab28f6$export$75f3bad3b50a6fc9)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a801d3dad17c06f$export$8b64094e7c2cc90), {
                    api: api
                })
        },
        {
            type: (0, $495b1900dd6e1ce7$export$4d0f5768433488cd).type,
            key: (0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key,
            parents: [
                {
                    type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
                    key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
                    rank: (0, $495b1900dd6e1ce7$export$7549083293c6b325)[(0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
                    key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
                    rank: (0, $b045de5a05ab28f6$export$75f3bad3b50a6fc9)[(0, $495b1900dd6e1ce7$export$4d0f5768433488cd).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccaaced34de0e7cf$export$7840ed9912c84130), {
                    api: api
                })
        },
        {
            type: (0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).type,
            key: (0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
                    key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
                    rank: (0, $d0d78e4f78ab53f8$export$5cf4383498669284)[(0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
                    key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
                    rank: (0, $b045de5a05ab28f6$export$75f3bad3b50a6fc9)[(0, $d0d78e4f78ab53f8$export$fd74fd566defa85d).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01bf7cd46923e0a4$export$841535b3f254af3a), {
                    api: api
                })
        }
    ] : [
        // --- Cell menu update OFF: legacy shared items (background color + clear cells only).
        // The add/delete items are registered by the row/column menu files in this mode.
        {
            type: (0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).type,
            key: (0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).type,
                    key: (0, $d0d78e4f78ab53f8$export$6f08e5b4d0fb8ff6).key,
                    rank: (0, $d0d78e4f78ab53f8$export$2476e690f9168fc5)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                },
                {
                    type: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).type,
                    key: (0, $495b1900dd6e1ce7$export$b9f73083561c9b45).key,
                    rank: (0, $495b1900dd6e1ce7$export$bc1c17ea404e1e65)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).type,
                    key: (0, $b045de5a05ab28f6$export$51b56b1bf623d0f).key,
                    rank: (0, $b045de5a05ab28f6$export$1d60acb37b4923d4)[(0, $bf9c2f49f53f3f37$export$200ea9e754d6f884).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $824fb4b6610864b8$export$b0a2efdf78e6aed2), {
                    api: api
                })
        },
        {
            type: (0, $bf9c2f49f53f3f37$export$7c71e4184715e790).type,
            key: (0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key,
            parents: [
                {
                    type: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).type,
                    key: (0, $d0d78e4f78ab53f8$export$46ec42cba969242b).key,
                    rank: (0, $d0d78e4f78ab53f8$export$5cf4383498669284)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                },
                {
                    type: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).type,
                    key: (0, $495b1900dd6e1ce7$export$139af6cfa83a6c0c).key,
                    rank: (0, $495b1900dd6e1ce7$export$7549083293c6b325)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                },
                {
                    type: (0, $b045de5a05ab28f6$export$ae771163ae415c91).type,
                    key: (0, $b045de5a05ab28f6$export$ae771163ae415c91).key,
                    rank: (0, $b045de5a05ab28f6$export$75f3bad3b50a6fc9)[(0, $bf9c2f49f53f3f37$export$7c71e4184715e790).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a801d3dad17c06f$export$8b64094e7c2cc90), {
                    api: api
                })
        }
    ];


const $a49ff7c80b10e541$export$efabff7be90ed58a = (params)=>[
        ...(0, $8b9310be296a0141$export$c176756f533b3bad)(params),
        ...(0, $53931d64168b46f1$export$eca8f3a6aa996ce2)(params),
        ...(0, $cbd8b8eabc3a7a69$export$2dfd78068db84eff)(params),
        ...(0, $e5cfcd403885e6c2$export$58613b8ba3de644b)(params)
    ];



const $8aa62fc46bb2e845$var$defaultGetEditorFeatureFlags = ()=>({});
// we want to calculate all the table widths (which causes reflows) after the editor has finished loading to mitigate performance impact
const $8aa62fc46bb2e845$var$TABLE_WIDTH_INFO_TIMEOUT = 10000;
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $8aa62fc46bb2e845$var$tablePlugin = ({ config: config, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const options = {
        ...config,
        tableOptions: config?.tableOptions ?? {},
        isTableScalingEnabled: config?.isTableScalingEnabled || (0, $ixfCV.fg)('platform_editor_enable_table_scaling')
    };
    const defaultGetEditorContainerWidth = ()=>{
        return api?.width?.sharedState.currentState() ?? {
            width: document?.body?.offsetWidth ?? 500
        };
    };
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isTableFixedColumnWidthsOptionEnabled = (0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption || false;
    const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
    options?.isCommentEditor);
    const isTableSelectorEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    !options?.isChromelessEditor && !options?.isCommentEditor && options?.getEditorFeatureFlags?.().tableSelector && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1');
    if ((0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) api?.uiControlRegistry?.actions.register((0, $a49ff7c80b10e541$export$efabff7be90ed58a)({
        api: api
    }));
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const tablePluginState = (0, $a10022ebdc03afe1$export$18d4026d1ea86bb1).getState(editorState);
            const tableResizingPluginState = (0, $78429e61a3e1fdf5$export$f05434c51e3762e)(editorState);
            const tableWidthResizingPluginState = (0, $0a5cb7a587a71a47$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeadersState = (0, $24d7f01a57cdc1f1$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeader = stickyHeadersState ? (0, $04640e18ab019d4a$export$91d61a242b14c7fb)(stickyHeadersState, tablePluginState?.tablePos) : undefined;
            const dragAndDropState = (0, $c13762150e3ca207$export$18d4026d1ea86bb1).getState(editorState);
            const sizeSelectorPluginState = (0, $285f4eda3a20b494$export$18d4026d1ea86bb1).getState(editorState);
            const editorContentAreaHeightPluginState = (0, $b82f27ffc9765a71$export$18d4026d1ea86bb1).getState(editorState);
            const sharedStateInternal = {
                isFullWidthModeEnabled: !!options?.fullWidthEnabled,
                wasFullWidthModeEnabled: !!options?.wasFullWidthEnabled,
                isMaxWidthModeEnabled: !!options?.maxWidthEnabled,
                wasMaxWidthModeEnabled: !!options?.wasMaxWidthEnabled,
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                isNumberColumnEnabled: tablePluginState.isNumberColumnEnabled,
                isCommentEditor: tablePluginState.isCommentEditor,
                isTableScalingEnabled: tablePluginState.isTableScalingEnabled,
                isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState?.dragging || tableWidthResizingPluginState?.resizing),
                isTableResizing: tableWidthResizingPluginState?.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredColumns: tablePluginState.hoveredColumns,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest,
                resizingTableLocalId: tableWidthResizingPluginState?.tableLocalId,
                tableRef: tablePluginState?.tableRef ?? undefined,
                resizingTableRef: tableWidthResizingPluginState?.tableRef ?? undefined,
                tablePos: tablePluginState.tablePos,
                targetCellPosition: tablePluginState.targetCellPosition,
                isContextualMenuOpen: tablePluginState.isContextualMenuOpen,
                pluginConfig: tablePluginState.pluginConfig,
                insertColumnButtonIndex: tablePluginState.insertColumnButtonIndex,
                insertRowButtonIndex: tablePluginState.insertRowButtonIndex,
                tableWrapperTarget: tablePluginState.tableWrapperTarget,
                isCellMenuOpenByKeyboard: tablePluginState.isCellMenuOpenByKeyboard,
                activeTableMenu: tablePluginState.activeTableMenu,
                stickyHeader: stickyHeader,
                dragMenuDirection: dragAndDropState?.dragMenuDirection,
                dragMenuIndex: dragAndDropState?.dragMenuIndex,
                isDragMenuOpen: dragAndDropState?.isDragMenuOpen,
                isSizeSelectorOpen: sizeSelectorPluginState?.isSelectorOpen,
                sizeSelectorTargetRef: sizeSelectorPluginState?.targetRef,
                editorContentAreaHeight: (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_4') ? editorContentAreaHeightPluginState?.height : undefined
            };
            return sharedStateInternal;
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    if (options?.tableOptions?.allowNestedTables) return (0, $aC6bW.editorCommandToPMCommand)((0, $1eaa45a3d80bffa1$export$b57b177fe1ab7f1f)({
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                        isFullWidthModeEnabled: options?.fullWidthEnabled,
                        isMaxWidthModeEnabled: options?.maxWidthEnabled,
                        isCommentEditor: options?.isCommentEditor,
                        isChromelessEditor: options?.isChromelessEditor,
                        isTableResizingEnabled: options?.tableOptions.allowTableResizing
                    }, api, analyticsPayload))(state, dispatch);
                    else {
                        const node = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)({
                            isTableScalingEnabled: options?.isTableScalingEnabled,
                            isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                            isFullWidthModeEnabled: options?.fullWidthEnabled,
                            isMaxWidthModeEnabled: options?.maxWidthEnabled,
                            isCommentEditor: options?.isCommentEditor,
                            isChromelessEditor: options?.isChromelessEditor,
                            isTableResizingEnabled: options?.tableOptions.allowTableResizing
                        })(state.schema);
                        return api?.contentInsertion?.actions?.insert({
                            state: state,
                            dispatch: dispatch,
                            node: node,
                            options: {
                                selectNodeInserted: false,
                                analyticsPayload: {
                                    ...analyticsPayload,
                                    attributes: {
                                        ...analyticsPayload.attributes,
                                        localId: node.attrs.localId
                                    }
                                }
                            }
                        }) ?? false;
                    }
                }
        },
        commands: {
            insertTableWithSize: (rowsCount, colsCount, inputMethod)=>(0, $1eaa45a3d80bffa1$export$b57b177fe1ab7f1f)({
                    isTableScalingEnabled: options?.isTableScalingEnabled,
                    isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                    isFullWidthModeEnabled: options?.fullWidthEnabled,
                    isMaxWidthModeEnabled: options?.maxWidthEnabled,
                    isCommentEditor: options?.isCommentEditor,
                    isChromelessEditor: options?.isChromelessEditor,
                    isTableResizingEnabled: options?.tableOptions.allowTableResizing,
                    createTableProps: {
                        rowsCount: rowsCount,
                        colsCount: colsCount
                    }
                }, api, {
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod ?? (0, $krYZG.INPUT_METHOD).PICKER,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })
        },
        nodes () {
            const { allowColumnResizing: allowColumnResizing } = (0, $9424facaeaa63c09$export$c23fbabe48bd9130)(options?.tableOptions);
            // TODO: ED-25901 - We need to move this into a plugin config option so we don't accidentally enable nested nodes in Jira
            const isNestingSupported = Boolean(options?.tableOptions?.allowNestedTables);
            const isTableFixedColumnWidthsOptionEnabled = ((0, $ixfCV.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            options?.isCommentEditor);
            const isTableScalingEnabled = options?.isTableScalingEnabled;
            const isCommentEditor = options?.isCommentEditor;
            const isChromelessEditor = options?.isChromelessEditor;
            return isNestingSupported ? [
                {
                    name: 'table',
                    node: (0, $65506e9a5bee1a79$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableHeaderWithNestedTableWithLocalId) : (0, $39Puj.tableHeaderWithNestedTable)
                },
                {
                    name: 'tableRow',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableRowWithNestedTableWithLocalId) : (0, $39Puj.tableRowWithNestedTable)
                },
                {
                    name: 'tableCell',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableCellWithNestedTableWithLocalId) : (0, $39Puj.tableCellWithNestedTable)
                }
            ] : [
                {
                    name: 'table',
                    node: (0, $65506e9a5bee1a79$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableHeaderWithLocalId) : (0, $39Puj.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableRowWithLocalId) : (0, $39Puj.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $39Puj.tableCellWithLocalId) : (0, $39Puj.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, __livePage: __livePage } = options || {};
                        return (0, $b69ebba757e1f13b$export$ae829ec7b2625219)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, (0, $9424facaeaa63c09$export$c23fbabe48bd9130)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $8aa62fc46bb2e845$var$defaultGetEditorFeatureFlags, getIntl, fullWidthEnabled, wasFullWidthEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, options?.allowFixedColumnWidthOption, __livePage);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $9424facaeaa63c09$export$c23fbabe48bd9130)(tableOptions);
                        return allowColumnResizing ? (0, $e611c0bfba215a68$export$ae829ec7b2625219)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $8aa62fc46bb2e845$var$defaultGetEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled || false, !!options?.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $f9ba8a550809a188$export$ae829ec7b2625219)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { isTableScalingEnabled: isTableScalingEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableOptions: tableOptions } = options || {};
                        return (0, $ad4bf9b41fec365c$export$e832373cff8dec22)(defaultGetEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, tableOptions?.allowTableAlignment, fullWidthEnabled, api, getIntl, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableOptions?.allowTableResizing);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $879cd4d4e153591c$export$21439b5bf6b9c77f)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        return (0, $853d31c23059c8f6$export$e382fe3f780a6548)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $jzpoq.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                                })(tr);
                            }
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch })=>options && options.tableOptions.stickyHeaders ? (0, $76a73165c8f7caeb$export$ae829ec7b2625219)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $7d82e6bf8d8a7f69$export$ae829ec7b2625219)(dispatch, editorAnalyticsAPI, options?.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor, api);
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return api?.editorViewMode ? (0, $a4e477e00a1dc89a$export$ae829ec7b2625219)(api, nodeViewPortalProviderAPI) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>!(0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $9ae90c5b5e91c4fc$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options?.tableOptions.allowTableResizing ? (0, $0a5cb7a587a71a47$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options.fullWidthEnabled ?? false, options.maxWidthEnabled ?? false, options.isTableScalingEnabled ?? false, options.tableOptions.allowTableResizing ?? false, options.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options?.tableOptions.allowTableResizing && options?.isCommentEditor ? (0, $8bb90754565162d1$export$ae829ec7b2625219)(dispatch, options.tableOptions.allowTableAlignment ?? false) : undefined
                },
                // TODO: ED-26961 - should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $a734f122c6a2cd61$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options?.tableOptions.allowTableResizing ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5398dae1191b57c8$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                let rafID;
                                let ricID;
                                // send statistics about the widths of the tables on the page for alerting
                                // only send this event once, after the editorView is first initialised
                                const setTimeoutID = setTimeout(()=>{
                                    const requestIdleCallbackFn = ()=>{
                                        const editorWidth = api?.width.sharedState.currentState()?.width;
                                        if (editorViewRef.current) {
                                            if (editorWidth) {
                                                const payload = (0, $8d0629bb8e812232$export$208d2421b73f3f86)(editorViewRef.current, editorWidth);
                                                if (payload) dispatchAnalyticsEvent(payload);
                                            }
                                            if ((0, $ixfCV.fg)('platform_editor_table_height_analytics_event')) {
                                                const payloadHeight = (0, $8d0629bb8e812232$export$34e5b28c67455a81)(editorViewRef.current);
                                                if (payloadHeight) dispatchAnalyticsEvent(payloadHeight);
                                            }
                                        }
                                    };
                                    if (window && typeof window.requestIdleCallback === 'function') ricID = window.requestIdleCallback(requestIdleCallbackFn);
                                    else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                                    rafID = window.requestAnimationFrame(requestIdleCallbackFn);
                                }, $8aa62fc46bb2e845$var$TABLE_WIDTH_INFO_TIMEOUT);
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                        if (setTimeoutID) clearTimeout(setTimeoutID);
                                        if (rafID) window.cancelAnimationFrame(rafID);
                                        if (ricID) window.cancelIdleCallback(ricID);
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'tableSizeSelectorPlugin',
                    plugin: ({ dispatch: dispatch })=>isTableSelectorEnabled ? (0, $285f4eda3a20b494$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'editorContentAreaHeightPlugin',
                    plugin: ()=>(0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_1') ? (0, $b82f27ffc9765a71$export$ae829ec7b2625219)() : undefined
                }
            ];
            if (!(0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) plugins.push({
                name: 'tableAnchorNames',
                plugin: ()=>(0, $afb92dfdaf83fcd8$export$ae829ec7b2625219)()
            });
            if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) plugins.push({
                name: 'tableActiveCellHighlight',
                plugin: ()=>(0, $bec9b600a021f606$export$ae829ec7b2625219)()
            });
            const browser = (0, $8dxef.getBrowserInfo)();
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if (browser.safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $dd1b5de40ba01c0a$export$ae829ec7b2625219)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d0cd06c03a409ff7$export$2dda1e4a1d1f6a81), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: $8aa62fc46bb2e845$var$defaultGetEditorFeatureFlags,
                isTableSelectorEnabled: isTableSelectorEnabled
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'table',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).table),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).tableDescription),
                        keywords: [
                            'cell',
                            'table'
                        ],
                        priority: 600,
                        keyshortcut: (0, $ldqjS.tooltip)((0, $ldqjS.toggleTable)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1UXy.IconTable), null),
                        action (insert, state) {
                            if (isTableSelectorEnabled) {
                                const tr = insert('');
                                tr.setMeta((0, $285f4eda3a20b494$export$18d4026d1ea86bb1), {
                                    isSelectorOpen: true
                                });
                                return tr;
                            }
                            // Delegate to the markdown plugin to insert a markdown table string at the CM cursor position.
                            const markdownState = api?.markdownMode?.sharedState.currentState();
                            if (markdownState?.isMarkdownMode && markdownState?.view === 'syntax' && (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $ixfCV.fg)('platform_editor_markdown_compatible_toolbar')) {
                                api?.markdownMode?.actions.insertSourceTable();
                                return state.tr;
                            }
                            // see comment on tablesPlugin.getSharedState on usage
                            const tableState = api?.table?.sharedState.currentState();
                            const tableNodeProps = {
                                isTableScalingEnabled: options?.isTableScalingEnabled,
                                isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                                isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
                                isMaxWidthModeEnabled: tableState?.isMaxWidthModeEnabled,
                                isCommentEditor: options?.isCommentEditor,
                                isChromelessEditor: options?.isChromelessEditor,
                                isTableResizingEnabled: options?.tableOptions.allowTableResizing
                            };
                            let tableNode = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)(tableNodeProps)(state.schema);
                            let { tr: tr } = state;
                            // If the cursor is inside a table
                            if ((0, $bjg0G.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options?.tableOptions?.allowNestedTables) {
                                // If trying to nest deeper than one level, we insert the table after the top table
                                if ((0, $euISL.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
                                    // Nesting is too deep insert table after the top parent table
                                    const positionAfterTopTable = (0, $is9bZ.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
                                    tr = (0, $bjg0G.safeInsert)(tableNode, positionAfterTopTable)(tr);
                                    tr.scrollIntoView();
                                } else {
                                    // Table can be nested in parent table
                                    tableNode = (0, $94c5e3c97a03aca7$export$5003ecb973fc11c2)({
                                        ...tableNodeProps,
                                        isNestedTable: true
                                    })(state.schema);
                                    tr = insert(tableNode);
                                }
                            } else tr = insert(tableNode);
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TABLE,
                                attributes: {
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                                    localId: tableNode.attrs.localId,
                                    ...(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                                        parentNode: tr.selection.$from.node(-1)?.type.name
                                    } : {}
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $0271a85e586658fd$export$86ce8f8241c20a3)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $9424facaeaa63c09$export$c23fbabe48bd9130)(options?.tableOptions))
        },
        usePluginHook ({ editorView: editorView }) {
            const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
                'editorViewMode'
            ], (states)=>({
                    mode: states.editorViewModeState?.mode
                }));
            (0, $cozmU.useEffect)(()=>{
                const { state: state, dispatch: dispatch } = editorView;
                const tr = state.tr;
                tr.setMeta('viewModeState', mode);
                if (dispatch) dispatch(tr);
            }, [
                editorView,
                mode
            ]);
        }
    };
};
var $8aa62fc46bb2e845$export$2e2bcd8739ae039 = $8aa62fc46bb2e845$var$tablePlugin;
module.exports["default"] = $8aa62fc46bb2e845$export$2e2bcd8739ae039;

});

parcelRegister("8y0c9", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

const $8b9f30d52bc7d906$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $7Y8M5.akEditorBreakoutPadding) : 0), (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : (0, $7Y8M5.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $7Y8M5.akEditorBreakoutPadding) : 0), (0, $7Y8M5.akEditorWideLayoutWidth));
            return 0, $7Y8M5.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};
module.exports["calcTableWidth"] = $8b9f30d52bc7d906$export$d7ece4d8beb06815;

});

parcelRegister("bAYhP", function(module, exports) {

var $f719K = parcelRequire("f719K");

function $cbdc7580ef18d660$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $f719K.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $cbdc7580ef18d660$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($cbdc7580ef18d660$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $f719K.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background) attrs = {
                background: cell.attrs.background
            };
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $f719K.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}
module.exports["addRow"] = $cbdc7580ef18d660$export$40ed00dbc18f8b2f;

});

parcelRegister("jIG3b", function(module, exports) {
/* tasksAndDecisionsPlugin.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kAzEy = parcelRequire("kAzEy");

var $7eTEw = parcelRequire("7eTEw");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $fClPf = parcelRequire("fClPf");


var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $4Qu9h = parcelRequire("4Qu9h");


var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $9ehdj = parcelRequire("9ehdj");


var $8Dx7s = parcelRequire("8Dx7s");


var $hdn7b = parcelRequire("hdn7b");


var $HdvOc = parcelRequire("HdvOc");







const $b42172fa2d8646ff$export$c0efac86beb21f01 = (node)=>{
    if (node.content.childCount === 0) return true;
    if (node.type.name === 'blockTaskItem') return node.content.childCount === 1 && node.content.firstChild?.type.name === 'paragraph' && node.content.firstChild?.childCount === 0;
    return false;
};


const $d6761794de1cb5b3$export$aa7ccb8f78e9cbdd = ()=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $9ehdj.taskItem;
    return {
        ...(0, $9ehdj.taskItem),
        toDOM: (node)=>$d6761794de1cb5b3$export$61f6ad164c5ca628(node)
    };
};
const $d6761794de1cb5b3$export$526b6659b16d1721 = ()=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $9ehdj.blockTaskItem;
    return {
        ...(0, $9ehdj.blockTaskItem),
        toDOM: (node)=>$d6761794de1cb5b3$export$61f6ad164c5ca628(node)
    };
};
const $d6761794de1cb5b3$var$getCheckBoxId = (localId)=>`task-checkbox-${localId}`;
function $d6761794de1cb5b3$export$640336359e1ccaeb(node, placeholder, intl) {
    const checked = node.attrs.state === 'DONE';
    const checkboxId = $d6761794de1cb5b3$var$getCheckBoxId(node.attrs.localId);
    const inputAttrs = {
        name: checkboxId,
        id: checkboxId,
        type: 'checkbox',
        'aria-label': intl.formatMessage(checked ? (0, $hdn7b.tasksAndDecisionsMessages).markTaskAsNotCompleted : (0, $hdn7b.tasksAndDecisionsMessages).markTaskAsCompleted)
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        'data-prosemirror-node-name': 'taskItem',
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    let contentDomDataAttrs = node.content.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) contentDomDataAttrs = (0, $b42172fa2d8646ff$export$c0efac86beb21f01)(node) ? {
        'data-empty': 'true'
    } : {};
    const checkboxIcons = [
        'http://www.w3.org/2000/svg svg',
        {
            width: '20',
            height: '20',
            viewBox: '2 2 20 20',
            role: 'presentation',
            'data-component': 'checkbox-icon'
        },
        [
            'http://www.w3.org/2000/svg g',
            {
                'fill-rule': 'evenodd'
            },
            [
                'http://www.w3.org/2000/svg rect',
                {
                    fill: 'currentcolor',
                    x: '5.5',
                    y: '5.5',
                    width: '13',
                    height: '13',
                    rx: '1.5'
                }
            ],
            [
                'http://www.w3.org/2000/svg path',
                {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'm16.326 9.48-1.152-.96-4.424 5.308-1.924-2.308-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z',
                    fill: 'inherit'
                }
            ]
        ]
    ];
    return [
        'div',
        {
            class: `${(0, $HdvOc.TaskDecisionSharedCssClassName).TASK_CONTAINER}`,
            ...dataAttrs,
            state: node.attrs.state
        },
        [
            'div',
            {
                'data-component': 'task-item-main'
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    class: `${(0, $HdvOc.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`,
                    'data-component': 'task-item-input-wrap'
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'task-item',
                        'data-task-input': true,
                        'data-testid': 'task-item-checkbox',
                        'data-component': 'task-item-input',
                        role: 'checkbox'
                    }
                ],
                checkboxIcons
            ],
            [
                'span',
                {
                    class: 'placeholder-node-view',
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contenteditable: 'false'
                },
                placeholder
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $HdvOc.TaskDecisionSharedCssClassName).TASK_ITEM,
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
}
const $d6761794de1cb5b3$export$61f6ad164c5ca628 = (node)=>{
    const checked = node.attrs.state === 'DONE';
    const inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    return [
        'div',
        {
            class: (0, $HdvOc.TaskDecisionSharedCssClassName).TASK_CONTAINER,
            ...dataAttrs,
            style: (0, $8Dx7s.convertToInlineCss)({
                listStyleType: 'none',
                lineHeight: '24px',
                minWidth: '48px',
                position: 'relative'
            })
        },
        [
            'div',
            {
                style: (0, $8Dx7s.convertToInlineCss)({
                    display: 'flex'
                })
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    style: (0, $8Dx7s.convertToInlineCss)({
                        width: '24px',
                        height: '24px',
                        lineHeight: '24px',
                        display: 'grid',
                        placeContent: 'center center'
                    })
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'lazy-task-item',
                        style: (0, $8Dx7s.convertToInlineCss)({
                            width: '13px',
                            height: '13px',
                            margin: '1px 0 0 0',
                            padding: 0,
                            accentColor: "var(--ds-background-selected-bold, #1868DB)"
                        })
                    }
                ]
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $HdvOc.TaskDecisionSharedCssClassName).TASK_ITEM,
                        style: (0, $8Dx7s.convertToInlineCss)({
                            display: 'block',
                            fontSize: '16px',
                            fontFamily: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            color: "var(--ds-text, #292A2E)"
                        })
                    },
                    0
                ]
            ]
        ]
    ];
};



var $98Lj8 = parcelRequire("98Lj8");







const $3a4a47e26a06419c$export$7727308e3d6fe8e9 = ()=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $98Lj8.decisionItem;
    return {
        ...(0, $98Lj8.decisionItem),
        toDOM: (node)=>{
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state,
                class: 'decisionItemView-content-wrap'
            };
            const showPlaceholder = node.content.size === 0;
            return [
                'li',
                attrs,
                [
                    'div',
                    {
                        'data-decision-wrapper': true,
                        'data-testid': 'elements-decision-item',
                        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
                        style: (0, $8Dx7s.convertToInlineCss)({
                            background: "var(--ds-background-neutral, #0515240F)",
                            padding: "var(--ds-space-100, 8px)",
                            paddingLeft: "var(--ds-space-150, 12px)",
                            margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                            display: 'flex',
                            borderRadius: "var(--ds-radius-small, 3px)"
                        })
                    },
                    [
                        'span',
                        {
                            style: (0, $8Dx7s.convertToInlineCss)({
                                width: '16px',
                                height: '16px',
                                margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
                                color: showPlaceholder ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-success, #6A9A23)",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }),
                            contentEditable: 'false',
                            'data-component': 'icon'
                        },
                        [
                            'span',
                            {
                                role: 'img',
                                style: (0, $8Dx7s.convertToInlineCss)({
                                    width: '32px',
                                    height: '32px'
                                })
                            },
                            [
                                'http://www.w3.org/2000/svg svg',
                                {
                                    viewBox: `0 0 24 24`,
                                    role: 'presentation',
                                    width: '24',
                                    height: '24',
                                    'data-icon-source': 'legacy',
                                    style: (0, $8Dx7s.convertToInlineCss)({
                                        width: '32px',
                                        height: '32px'
                                    })
                                },
                                [
                                    'http://www.w3.org/2000/svg path',
                                    {
                                        fill: 'currentcolor',
                                        'fill-rule': 'evenodd',
                                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                                    }
                                ]
                            ]
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: 'decision-item'
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};



var $4EksL = parcelRequire("4EksL");


var $2w79Z = parcelRequire("2w79Z");

var $aXHNB = parcelRequire("aXHNB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");










const $9f04dba1d2252c2c$export$77b371d6becc8882 = new (0, $kCECX.PluginKey)('tasksAndDecisionsPlugin');


var $de4e130d88e972dc$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
    ACTIONS[ACTIONS["OPEN_REQUEST_TO_EDIT_POPUP"] = 2] = "OPEN_REQUEST_TO_EDIT_POPUP";
    return ACTIONS;
}({});





function $e69ff03257131f89$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $e69ff03257131f89$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $e69ff03257131f89$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $kCECX.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $e69ff03257131f89$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $e69ff03257131f89$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $kCECX.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $e69ff03257131f89$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const head = $e69ff03257131f89$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $kCECX.TextSelection)(head, head);
    }
    const head = $e69ff03257131f89$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $e69ff03257131f89$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $kCECX.TextSelection)(anchor, head);
};
const $e69ff03257131f89$export$11f4e85d86397169 = ($from)=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    const firstParent = $from.parent;
    if (firstParent.type === blockTaskItem) return {
        blockTaskItemNode: firstParent,
        hasParagraph: false
    };
    else if (firstParent.type === paragraph) {
        if ($from.depth >= 1) {
            const secondParent = $from.node($from.depth - 1);
            if (secondParent.type === blockTaskItem) return {
                blockTaskItemNode: secondParent,
                hasParagraph: true
            };
            else return false;
        } else return false;
    }
    return false;
};


const $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    if (blockTaskItem) return Boolean((0, $bjg0G.findParentNodeOfTypeClosestToPos)(state.selection.$from, [
        decisionItem,
        taskItem,
        blockTaskItem
    ]));
    return (0, $bjg0G.hasParentNodeOfType)([
        decisionItem,
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $c9ab19b3ef4e46bb$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $c9ab19b3ef4e46bb$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem, blockTaskItem: blockTaskItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem,
        blockTaskItem
    ].indexOf(node.type) > -1;
};
const $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)([
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $c9ab19b3ef4e46bb$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $c9ab19b3ef4e46bb$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $c9ab19b3ef4e46bb$export$f029cbac7e0ab14c = ({ $from: $from, $to: $to })=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    if (blockTaskItem) {
        const result = (0, $e69ff03257131f89$export$11f4e85d86397169)($from);
        if (result) {
            const { hasParagraph: hasParagraph } = result;
            const blockTaskItemDepth = hasParagraph ? $from.depth - 1 : $from.depth;
            let blockRangeDepth = blockTaskItemDepth - 1;
            // Calculate start position of the block range
            let startPos = $from.start(blockTaskItemDepth) - 1;
            // Calculate end position and get node after the current selection
            const endPos = $to.end();
            let $after = $to.doc.resolve(endPos + 1);
            let afterNode = $after.nodeAfter;
            const lastNode = $to.node($to.depth);
            let endRangePos = $to.start() + lastNode.nodeSize;
            // Make adjustments for paragraph nodes
            if (lastNode.type === paragraph) {
                $after = $to.doc.resolve(endPos + 2);
                afterNode = $after.nodeAfter;
            } else {
                blockRangeDepth--;
                endRangePos--;
            }
            // Extend range if there's a sibling taskList
            if (afterNode && afterNode.type === taskList && $after.depth === blockTaskItemDepth - 1) endRangePos += afterNode.nodeSize;
            // Check if preceded by another taskItem/blockTaskItem
            const $prevNode = $from.doc.resolve(startPos - 1);
            const prevNodeSize = $prevNode.nodeBefore?.nodeSize || 0;
            const $prevNodeParent = $from.doc.resolve($prevNode.pos - prevNodeSize - 1);
            const prevNodeParent = $prevNodeParent.nodeAfter;
            if (prevNodeParent && [
                blockTaskItem,
                taskItem
            ].includes(prevNodeParent.type)) {
                blockRangeDepth = blockTaskItemDepth - 1;
                endRangePos -= 2;
                startPos += 1;
            }
            // Create and return the NodeRange
            return new (0, $aPdNQ.NodeRange)($to.doc.resolve(startPos), $to.doc.resolve(endRangePos), blockRangeDepth);
        }
    }
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $c9ab19b3ef4e46bb$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList, blockTaskItem: blockTaskItem } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $2w79Z.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    if ((0, $bjg0G.hasParentNodeOfType)([
        blockTaskItem
    ])(selection)) {
        const blockTaskItemNode = (0, $2w79Z.findFarthestParentNode)((node)=>node.type === blockTaskItem)($from);
        if (blockTaskItemNode) /**
			 * If we are inside a blockTaskItem, calculate the indent level from the
			 * blockTaskItemNode instead of the selection, in case the selection is
			 * nested inside a blockTaskItem.
			 */ return blockTaskItemNode.depth - furthestParent.depth;
    }
    return $from.depth - furthestParent.depth;
};
const $c9ab19b3ef4e46bb$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>node?.type.name === 'taskList';
    const itemAtPos = (0, $bjg0G.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $c9ab19b3ef4e46bb$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $c9ab19b3ef4e46bb$export$59958047ba34fe83 = ($from, $to, types)=>{
    const root = (0, $2w79Z.findFarthestParentNode)((node)=>types.indexOf(node.type) > -1)($from);
    if (!root) return -1;
    // get the height between the root and the current position
    const distToParent = $from.depth - root.depth;
    // include any following taskList since nested lists appear
    // as siblings
    //
    // this is unlike regular bullet lists where the orderedList
    // appears as descendent of listItem
    const blockRange = $c9ab19b3ef4e46bb$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return -1;
    // and get the max height from the current position to the
    // deepest leaf node
    let maxChildDepth = $from.depth;
    $from.doc.nodesBetween(blockRange.start, blockRange.end, (descendent, relPos, _parent)=>{
        maxChildDepth = Math.max($from.doc.resolve(relPos).depth, maxChildDepth);
        // keep descending down the tree if we can
        if (types.indexOf(descendent.type) > -1) return true;
    });
    return distToParent + (maxChildDepth - $from.depth);
};
const $c9ab19b3ef4e46bb$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { paragraph: paragraph, blockTaskItem: blockTaskItem, decisionItem: decisionItem, taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const isEmptyTaskOrDecisionItem = node && (node.type === taskItem || node.type === decisionItem) && node.content.size === 0;
    // Block task items must contain a single empty paragraph to be considered empty
    const isInEmptyBlockTaskItem = // If in an empty paragraph that's not at the doc level
    node.content.size === 0 && node.type === paragraph && $from.depth > 0 && // and it's parent is a blockTaskItem with only this paragraph inside it
    $from.node($from.depth - 1).type === blockTaskItem && $from.node($from.depth - 1).childCount === 1;
    return isEmptyTaskOrDecisionItem || isInEmptyBlockTaskItem;
};
const $c9ab19b3ef4e46bb$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $c9ab19b3ef4e46bb$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $eOaGc.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $c9ab19b3ef4e46bb$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    if ((0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true)) {
        const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const maybeTask = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($from, [
            taskItem,
            blockTaskItem
        ]);
        // current selection has to be inside taskitem
        if (maybeTask) return {
            pos: maybeTask?.pos,
            localId: maybeTask?.node.attrs.localId
        };
    } else {
        const isInTaskItem = $from.node().type === schema.nodes.taskItem;
        // current selection has to be inside taskitem
        if (isInTaskItem) {
            const taskItemPos = $from.before();
            return {
                pos: taskItemPos,
                localId: $from.node().attrs.localId
            };
        }
    }
}
function $c9ab19b3ef4e46bb$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    const isInTaskItem = (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1(state) : $fromPos.node().type === schema.nodes.taskItem;
    // if not inside task item then return undefined;
    if (!isInTaskItem) return;
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const rootTaskListData = (0, $2w79Z.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem || (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && blockTaskItem && node.type === blockTaskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $c9ab19b3ef4e46bb$export$34f429092f5d2a8b(view, allTaskItems) {
    const { state: state } = view;
    const { schema: schema } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $bjg0G.findParentNodeOfTypeClosestToPos)($fromPos, [
        taskItem,
        blockTaskItem
    ])?.node : $fromPos.node($fromPos.depth);
    if (currentTaskItem) {
        const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
        return currentTaskItemIndex;
    } else return -1;
}
function $c9ab19b3ef4e46bb$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $c9ab19b3ef4e46bb$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $c9ab19b3ef4e46bb$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $c9ab19b3ef4e46bb$export$6ddc162ae107856(view, taskItemData) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    if (taskItemData) {
        tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
            action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
            data: taskItemData.localId
        });
        dispatch(tr);
    }
}
function $c9ab19b3ef4e46bb$export$965155ace97a0424(view, taskItemData) {
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc } = state;
    const { schema: schema } = state;
    const { extension: extension } = schema.nodes;
    const tr = state.tr;
    // if there's an extension at this position, we're in a blockTaskItem, set a gapCursor
    if ((0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && extension && doc.resolve(pos + 1).nodeAfter?.type === extension) tr.setSelection(new (0, $4EksL.GapCursorSelection)(doc.resolve(pos + 1)));
    else if ((0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) && doc.resolve(pos + 1).nodeAfter?.isTextblock) tr.setSelection(new (0, $kCECX.TextSelection)(doc.resolve(pos + 2)));
    else tr.setSelection(new (0, $kCECX.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
        action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $c9ab19b3ef4e46bb$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
        action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).FOCUS_BY_LOCALID
    }));
}
function $c9ab19b3ef4e46bb$export$ccb659c518fe26ad(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
        action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: pos
    }));
}
function $c9ab19b3ef4e46bb$export$6e1436cb7b69383b(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
        action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
        data: null
    }));
}
function $c9ab19b3ef4e46bb$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $aXHNB.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $bjg0G.findParentNodeClosestToPos)($pos, (0, $aXHNB.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
const $c9ab19b3ef4e46bb$export$2ca50ccc2f45db88 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    return $from.parent.isTextblock && $from.node($from.depth - 1).type === blockTaskItem && $from.index($from.depth - 1) === 0;
};
const $c9ab19b3ef4e46bb$export$bcd44b9b102ed403 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const parentNode = $from.node($from.depth - 1);
    return $from.parent.isTextblock && parentNode.type === blockTaskItem && $from.index($from.depth - 1) === parentNode.childCount - 1;
};






var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");








var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");


var $2nOF5 = parcelRequire("2nOF5");



var $a18b98bdac6ae9b2$export$f78f4c81bbd3af70 = /*#__PURE__*/ function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
    return USER_CONTEXT;
}({});
var $a18b98bdac6ae9b2$export$5981355d1002ed79 = /*#__PURE__*/ function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
    return LINK_STATUS;
}({});
var $a18b98bdac6ae9b2$export$6c486891427a9a0 = /*#__PURE__*/ function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
    return LINK_REPRESENTATION;
}({});
var $a18b98bdac6ae9b2$export$7c9a0eeb2da3d2de = /*#__PURE__*/ function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
    return LINK_RESOURCE;
}({});






var $liXVw = parcelRequire("liXVw");














var $ixfCV = parcelRequire("ixfCV");



const $d0a518f3dca58926$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $a18b98bdac6ae9b2$export$f78f4c81bbd3af70).EDIT : (0, $a18b98bdac6ae9b2$export$f78f4c81bbd3af70).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $d0a518f3dca58926$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    const resolvedInputMethod = (0, $ixfCV.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $krYZG.INPUT_METHOD).QUICK_INSERT;
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $krYZG.ACTION_SUBJECT_ID).ACTION : (0, $krYZG.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: resolvedInputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $d0a518f3dca58926$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $d0a518f3dca58926$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$d0a518f3dca58926$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $d0a518f3dca58926$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $liXVw.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $d0a518f3dca58926$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $d0a518f3dca58926$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $d0a518f3dca58926$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $d0a518f3dca58926$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $bjg0G.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $d0a518f3dca58926$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $bjg0G.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $2nOF5.uuid).generate();
        itemLocalId = itemLocalId || (0, $2nOF5.uuid).generate();
        if (insertTrCreator) {
            const insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI?.attachAnalyticsEvent($d0a518f3dca58926$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $d0a518f3dca58926$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $bjg0G.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $bjg0G.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $d0a518f3dca58926$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $d0a518f3dca58926$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $2nOF5.uuid).generate(), itemLocalId = (0, $2nOF5.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $4EksL.GapCursorSelection)) return (0, $bjg0G.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($d0a518f3dca58926$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $2nOF5.uuid).generate()
        }, [
            item.create({
                localId: (0, $2nOF5.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $bjg0G.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $aPdNQ.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $eOaGc.liftTarget)(range));
        }
        const listParent = (0, $bjg0G.findParentNodeOfType)(taskList)(selection) || (0, $bjg0G.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $bjg0G.findParentNodeOfType)(taskItem)(selection) || (0, $bjg0G.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $bjg0G.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $bjg0G.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $d0a518f3dca58926$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $bjg0G.safeInsert)(emptyList)(tr);
};
const $d0a518f3dca58926$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
            action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).SET_PROVIDER,
            data: provider
        });
    };


const $f2a3082b82d1c4c7$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $d8RhQ.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $d0a518f3dca58926$export$c8b7fdb74eb8fe5c)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $bjg0G.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $d0a518f3dca58926$export$8c1bb617b1f6f2f1)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $krYZG.INPUT_METHOD).FORMATTING, $f2a3082b82d1c4c7$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $f2a3082b82d1c4c7$var$isCursorInsideList = ($pos)=>{
    return $pos.node($pos.depth - 1)?.type.name === 'listItem';
};
const $f2a3082b82d1c4c7$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $f2a3082b82d1c4c7$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($f2a3082b82d1c4c7$var$isCursorInsideList($from)) {
                $f2a3082b82d1c4c7$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $d0a518f3dca58926$export$eb5c8ff5b17fd36b)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $kCECX.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $f2a3082b82d1c4c7$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($f2a3082b82d1c4c7$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`(^|${(0, $3brWT.leafNodeReplacementCharacter)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($f2a3082b82d1c4c7$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $3brWT.leafNodeReplacementCharacter)})\\[\\]\\s$`), 'taskList'));
            rules.push($f2a3082b82d1c4c7$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $3brWT.leafNodeReplacementCharacter)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $f2a3082b82d1c4c7$export$2e2bcd8739ae039 = $f2a3082b82d1c4c7$export$568a7ed6897c4817;







var $1A89X = parcelRequire("1A89X");




var $iX5Ka = parcelRequire("iX5Ka");


var $eEdSM = parcelRequire("eEdSM");


var $ldqjS = parcelRequire("ldqjS");


var $bVxZJ = parcelRequire("bVxZJ");




var $eaLat = parcelRequire("eaLat");


var $77KCc = parcelRequire("77KCc");

var $dTPhv = parcelRequire("dTPhv");


var $iUNgd = parcelRequire("iUNgd");


var $44cyU = parcelRequire("44cyU");














var $iwBlG = parcelRequire("iwBlG");

var $hJh89 = parcelRequire("hJh89");

var $hnsob = parcelRequire("hnsob");








var $dxhaW = parcelRequire("dxhaW");

function $4eb0705668521e5b$export$f41b6e46f49afc20(options) {
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = options.doc.type.schema.nodes;
    return (0, $dxhaW.flattenList)(options, {
        isContentNode: (node, parent)=>{
            const isTaskItemType = node.type === taskItem || blockTaskItem != null && node.type === blockTaskItem;
            return isTaskItemType && parent != null && parent.type === taskList;
        },
        getSelectionBounds: (node, pos)=>({
                start: pos,
                end: pos + node.nodeSize
            }),
        getDepth: (resolvedDepth, rootDepth)=>resolvedDepth - rootDepth - 1
    });
}
function $4eb0705668521e5b$export$50c9fbf449dfc27(items, schema) {
    const { taskList: taskList } = schema.nodes;
    const contentStartOffsets = new Array(items.length);
    if (items.length === 0) return null;
    // Start with the root level (depth -1 represents the root taskList wrapper)
    const stack = [
        {
            depth: -1,
            children: [],
            hasSelectedItems: false,
            listAttrs: items[0].parentListAttrs,
            sourceParentAttrs: items[0].parentListAttrs
        }
    ];
    for (const item of items){
        const targetDepth = item.depth;
        // Pop stack entries strictly deeper than target, wrapping them into taskLists
        while(stack.length > 1 && stack[stack.length - 1].depth > targetDepth){
            const popped = stack.pop();
            if (!popped) break;
            const attrs = popped.listAttrs ?? {
                localId: (0, $2nOF5.uuid).generate()
            };
            const wrappedList = taskList.create(attrs, popped.children);
            stack[stack.length - 1].children.push(wrappedList);
        }
        // If the stack top is at the same depth as the target, decide whether
        // to merge into the existing entry or close it and start a new one.
        // Unselected items from different original parent taskLists get
        // separate wrappers (preserving original nesting). Selected (moved)
        // items always merge with whatever is already at the target depth,
        // since they're being placed into a new structural context.
        // However, if the current entry already contains selected (moved) items,
        // we do NOT split — the unselected sibling should join the same wrapper
        // because the selected item established the new structural context.
        if (stack.length > 1 && stack[stack.length - 1].depth === targetDepth && !item.isSelected) {
            const top = stack[stack.length - 1];
            if (top.sourceParentAttrs !== item.parentListAttrs && !top.hasSelectedItems) {
                const popped = stack.pop();
                if (!popped) break;
                const attrs = popped.listAttrs ?? {
                    localId: (0, $2nOF5.uuid).generate()
                };
                const wrappedList = taskList.create(attrs, popped.children);
                stack[stack.length - 1].children.push(wrappedList);
            }
        }
        // Push new stack entries to reach the target depth.
        // Skip intermediate entries at depth 0 — depth-0 items belong
        // directly in the root entry (depth -1), so we only need
        // intermediates for depths > 1.
        while(stack[stack.length - 1].depth < targetDepth - 1){
            const nextDepth = Math.max(stack[stack.length - 1].depth + 1, 1);
            stack.push({
                depth: nextDepth,
                children: [],
                hasSelectedItems: false,
                listAttrs: item.isSelected ? null : item.parentListAttrs,
                sourceParentAttrs: item.parentListAttrs
            });
        }
        // Add the item at the target depth
        if (targetDepth === 0) {
            // Depth 0 items go directly into the root taskList
            stack[0].children.push(item.node);
            if (item.isSelected) stack[0].hasSelectedItems = true;
        } else {
            // Ensure there's a stack entry at depth targetDepth to hold this item
            if (stack[stack.length - 1].depth < targetDepth) stack.push({
                depth: targetDepth,
                children: [],
                hasSelectedItems: false,
                listAttrs: item.isSelected ? null : item.parentListAttrs,
                sourceParentAttrs: item.parentListAttrs
            });
            stack[stack.length - 1].children.push(item.node);
            if (item.isSelected) stack[stack.length - 1].hasSelectedItems = true;
        }
    }
    // Close remaining stack entries
    while(stack.length > 1){
        const popped = stack.pop();
        if (!popped) break;
        const attrs = popped.listAttrs ?? {
            localId: (0, $2nOF5.uuid).generate()
        };
        const wrappedList = taskList.create(attrs, popped.children);
        stack[stack.length - 1].children.push(wrappedList);
    }
    // The root entry's children form the root taskList.
    // Preserve the root's original attrs when available.
    const rootChildren = stack[0].children;
    const rootAttrs = stack[0].listAttrs ?? {
        localId: (0, $2nOF5.uuid).generate()
    };
    const rootList = taskList.create(rootAttrs, rootChildren);
    // Compute contentStartOffsets by walking the rebuilt tree.
    // Each taskItem's content starts at (pos_within_root + 1) for the taskItem opening tag.
    // We add +1 for the root taskList's opening tag.
    const isTaskItemType = (node)=>{
        const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        return node.type === taskItem || blockTaskItem != null && node.type === blockTaskItem;
    };
    let itemIdx = 0;
    rootList.descendants((node, pos)=>{
        if (isTaskItemType(node) && itemIdx < items.length) {
            // pos is relative to rootList content start;
            // +1 for rootList's opening tag, +1 for taskItem's opening tag
            contentStartOffsets[itemIdx] = 1 + pos + 1;
            itemIdx++;
        }
        return true;
    });
    return {
        node: rootList,
        contentStartOffsets: contentStartOffsets
    };
}


const $d6ecd2c1a8ddffbd$var$MAX_TASK_LIST_DEPTH = 6;
function $d6ecd2c1a8ddffbd$export$6de6f04870a23f53(tr, indentDelta) {
    const { doc: doc, selection: selection } = tr;
    const { schema: schema } = doc.type;
    const { taskList: taskList } = schema.nodes;
    const { $from: $from, $to: $to } = selection;
    const rootListResult = (0, $2w79Z.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!rootListResult) return null;
    const rootListStart = rootListResult.pos;
    const rootListEnd = rootListStart + rootListResult.node.nodeSize;
    const flattenResult = (0, $4eb0705668521e5b$export$f41b6e46f49afc20)({
        doc: doc,
        rootListStart: rootListStart,
        rootListEnd: rootListEnd,
        selectionFrom: $from.pos,
        selectionTo: $to.pos,
        indentDelta: indentDelta,
        maxDepth: $d6ecd2c1a8ddffbd$var$MAX_TASK_LIST_DEPTH
    });
    if (!flattenResult) return null;
    const { items: flattenedItems, startIndex: startIndex, endIndex: endIndex } = flattenResult;
    const { fragment: fragment, contentStartOffsets: contentStartOffsets } = (0, $iwBlG.buildReplacementFragment)({
        items: flattenedItems,
        schema: schema,
        rebuildFn: (0, $4eb0705668521e5b$export$50c9fbf449dfc27),
        extractContentFn: (item, s)=>{
            // Extract task item content for breakout.
            // taskItem has inline content, so wrap in a paragraph.
            // blockTaskItem already has paragraph children.
            const { blockTaskItem: blockTaskItem } = s.nodes;
            if (!!blockTaskItem && item.node.type === blockTaskItem) {
                // blockTaskItem children are already paragraphs/extensions
                const children = [];
                item.node.forEach((child)=>children.push(child));
                return children;
            }
            // Regular taskItem — wrap inline content in a paragraph
            return [
                s.nodes.paragraph.create(null, item.node.content)
            ];
        }
    });
    if (fragment.size === 0) return null;
    // Narrow the replacement to the minimal changed range for collab-friendly
    // cursor preservation on unaffected list items.
    const narrowed = (0, $hnsob.narrowReplacementRange)(tr.doc, rootListStart, rootListEnd, fragment, contentStartOffsets);
    tr.replaceWith(narrowed.start, narrowed.end, narrowed.fragment);
    const { from: from, to: to } = (0, $hJh89.computeSelectionOffsets)({
        items: flattenedItems,
        startIndex: startIndex,
        endIndex: endIndex,
        originalFrom: $from.pos,
        originalTo: $to.pos,
        contentStartOffsets: narrowed.adjustedContentStartOffsets,
        rootListStart: narrowed.start,
        docSize: tr.doc.content.size
    });
    (0, $hJh89.restoreSelection)({
        tr: tr,
        originalSelection: selection,
        from: from,
        to: to
    });
    tr.scrollIntoView();
    return tr;
}



var $9WBFV = parcelRequire("9WBFV");





var $96Kjp = parcelRequire("96Kjp");
















var $kPKLu = parcelRequire("kPKLu");









/**
 * Transforms a paste slice to handle blockTaskItem nodes when pasting into task items.
 *
 * Initially we do not support user creation of blockTaskItem - it is intended primarily
 * for TinyMCE migration purposes however that may change in the future.
 * This function handles the behavior to work around Prosemirror behaviour which decides
 * that blockTaskItem is the appropriate node to use here.
 *
 * @param slice - The slice being pasted
 * @param view - The editor view where the paste is occurring
 * @returns The transformed slice with blockTaskItems converted to taskItems when appropriate
 *
 * @example
 * ```typescript
 * const transformedSlice = tempTransformSliceToRemoveBlockTaskItem(pasteSlice, editorView);
 * ```
 *
 * @see {@link https://hello.atlassian.net/wiki/spaces/EDITOR/pages/5626622054/Block+elements+in+task+-+Decision+log#Can-users-create-block-task-items%3F} for reasoning
 */ const $1ffd94c702d1e1e5$var$getTaskPasteContext = (view)=>{
    const { schema: schema, selection: selection } = view.state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    const fontSize = schema.marks?.fontSize;
    const { $from: $from } = selection;
    const currentParent = $from.parent;
    const currentNode = typeof $from.node === 'function' ? $from.node() : undefined;
    if (currentParent?.type === taskItem || currentNode?.type === taskItem) return {
        isInTaskContext: true,
        smallTextAttrs: false
    };
    if (!blockTaskItem) return {
        isInTaskContext: false,
        smallTextAttrs: false
    };
    if (currentParent?.type === blockTaskItem || currentNode?.type === blockTaskItem) return {
        isInTaskContext: true,
        smallTextAttrs: fontSize ? (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)(currentParent ?? currentNode, fontSize) : false
    };
    if (currentParent?.type === paragraph && $from.depth > 0 && $from.node($from.depth - 1).type === blockTaskItem) return {
        isInTaskContext: true,
        smallTextAttrs: fontSize ? (0, $bVxZJ.getBlockMarkAttrs)(currentParent, fontSize) : false
    };
    return {
        isInTaskContext: false,
        smallTextAttrs: false
    };
};
const $1ffd94c702d1e1e5$var$convertTaskItemToBlockTaskItem = (node, schema, smallTextAttrs)=>{
    const { fontSize: fontSize } = schema.marks;
    return (0, $kPKLu.createBlockTaskItem)({
        attrs: node.attrs,
        content: node.content,
        marks: [
            fontSize.create(smallTextAttrs)
        ],
        schema: schema
    });
};
const $1ffd94c702d1e1e5$var$addSmallTextToBlockTaskItem = (node, schema, smallTextAttrs)=>{
    const { paragraph: paragraph } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    const newContent = [];
    node.content.forEach((child)=>{
        if (child.type === paragraph) newContent.push(paragraph.createChecked(child.attrs, child.content, child.marks.filter((mark)=>mark.type !== fontSize).concat(fontSize.create(smallTextAttrs))));
        else newContent.push(child);
    });
    return node.type.create(node.attrs, newContent);
};
const $1ffd94c702d1e1e5$var$normalizeBlockTaskItemToTaskItems = (node, schema)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    if (!blockTaskItem || node.type !== blockTaskItem) return [
        node
    ];
    let allChildrenAreParagraphs = true;
    node.content.forEach((child)=>{
        if (child.type !== paragraph) allChildrenAreParagraphs = false;
    });
    if (allChildrenAreParagraphs && node.childCount > 0) {
        const transformedContent = [];
        node.content.forEach((paragraphNode)=>{
            transformedContent.push(taskItem.create({
                localId: (0, $2nOF5.uuid).generate(),
                state: node.attrs.state || 'TODO'
            }, paragraphNode.content));
        });
        return transformedContent;
    }
    return [
        node
    ];
};
const $1ffd94c702d1e1e5$var$transformSliceContent = (slice, transformNode)=>{
    const transformedContent = [];
    slice.content.forEach((node)=>{
        transformedContent.push(...transformNode(node));
    });
    if (transformedContent.length !== slice.content.childCount || transformedContent.some((node, idx)=>node !== slice.content.child(idx))) {
        const newFragment = (0, $aPdNQ.Fragment).from(transformedContent);
        return new (0, $aPdNQ.Slice)(newFragment, slice.openStart, slice.openEnd);
    }
    return slice;
};
const $1ffd94c702d1e1e5$var$transformSliceToRemoveBlockTaskItemLegacy = (slice, view)=>{
    const { schema: schema } = view.state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const isInTaskItem = view.state.selection.$from.node().type === taskItem;
    if (!isInTaskItem || !blockTaskItem) return slice;
    return $1ffd94c702d1e1e5$var$transformSliceContent(slice, (node)=>$1ffd94c702d1e1e5$var$normalizeBlockTaskItemToTaskItems(node, schema));
};
const $1ffd94c702d1e1e5$export$aabf20f2ccae32df = (node, schema, smallTextAttrs)=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    if (!smallTextAttrs) return [
        node
    ];
    if ((0, $96Kjp.isTaskList)(node.type)) {
        const transformedChildren = [];
        node.content.forEach((child)=>{
            transformedChildren.push(...$1ffd94c702d1e1e5$export$aabf20f2ccae32df(child, schema, smallTextAttrs));
        });
        return [
            taskList.create(node.attrs, transformedChildren)
        ];
    }
    if (blockTaskItem && fontSize) {
        if (node.type === taskItem) return [
            $1ffd94c702d1e1e5$var$convertTaskItemToBlockTaskItem(node, schema, smallTextAttrs)
        ];
        if (node.type === blockTaskItem) return [
            $1ffd94c702d1e1e5$var$addSmallTextToBlockTaskItem(node, schema, smallTextAttrs)
        ];
    }
    return [
        node
    ];
};
const $1ffd94c702d1e1e5$var$normalizeNodeForTaskPaste = (node, schema, smallTextAttrs)=>{
    if (smallTextAttrs) return $1ffd94c702d1e1e5$export$aabf20f2ccae32df(node, schema, smallTextAttrs);
    return $1ffd94c702d1e1e5$var$normalizeBlockTaskItemToTaskItems(node, schema);
};
const $1ffd94c702d1e1e5$export$7e04b173e2b79898 = (slice, view)=>{
    const fontSizeExperimentEnabled = (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    if (!fontSizeExperimentEnabled) return $1ffd94c702d1e1e5$var$transformSliceToRemoveBlockTaskItemLegacy(slice, view);
    const { blockTaskItem: blockTaskItem } = view.state.schema.nodes;
    const { isInTaskContext: isInTaskContext, smallTextAttrs: smallTextAttrs } = $1ffd94c702d1e1e5$var$getTaskPasteContext(view);
    if (!isInTaskContext || !blockTaskItem) return slice;
    return $1ffd94c702d1e1e5$var$transformSliceContent(slice, (node)=>$1ffd94c702d1e1e5$var$normalizeNodeForTaskPaste(node, view.state.schema, smallTextAttrs));
};


const $e99562cef88632d9$export$2837bcd4021a2a47 = (state, dispatch)=>{
    const normalizedSelection = (0, $e69ff03257131f89$export$e590f1ae61640432)(state.selection);
    const { $from: $from, $to: $to } = normalizedSelection;
    const tr = (0, $c9ab19b3ef4e46bb$export$b4043a93b6a561c9)(state.tr, $from, $to);
    if (dispatch && tr) dispatch(tr);
    return !!tr;
};
const $e99562cef88632d9$export$b9f50dd5ccd0f20 = (state, dispatch)=>{
    const { $from: $from, $to: $to } = (0, $e69ff03257131f89$export$e590f1ae61640432)(state.selection);
    // limit ui indentation to 6 levels
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    let maxDepth = (0, $c9ab19b3ef4e46bb$export$59958047ba34fe83)($from, $to, [
        taskList,
        taskItem
    ]);
    if (blockTaskItem) {
        const resultOfFindBlockTaskItem = (0, $e69ff03257131f89$export$11f4e85d86397169)($from);
        if (resultOfFindBlockTaskItem) {
            const { hasParagraph: hasParagraph } = resultOfFindBlockTaskItem;
            // If the selection is inside a nested node inside the blockTaskItem
            // Remove the difference in depth between the selection and the blockTaskItemNode
            if (hasParagraph) maxDepth = (0, $c9ab19b3ef4e46bb$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]) - 1;
            else maxDepth = (0, $c9ab19b3ef4e46bb$export$59958047ba34fe83)($from, $to, [
                taskList,
                blockTaskItem
            ]);
        }
    }
    if (maxDepth >= 6) return true;
    const blockRange = (0, $c9ab19b3ef4e46bb$export$f029cbac7e0ab14c)({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return true;
    const wrapping = (0, $eOaGc.findWrapping)(blockRange, state.schema.nodes.taskList);
    if (!wrapping) return true;
    if (dispatch) dispatch(state.tr.wrap(blockRange, wrapping).scrollIntoView());
    return true;
};
const $e99562cef88632d9$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $9WBFV.findCutBefore)($pos);
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        const { fontSize: fontSize } = state.schema.marks;
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $c9ab19b3ef4e46bb$export$6f0e2eafb461f634)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            let slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            let from = $lastNode.pos;
            const to = $cut.pos + $cut.nodeAfter.nodeSize;
            let gapFrom = $cut.pos + 1;
            let gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
            const insert = 0;
            if (blockTaskItem) {
                if ($lastNode.parent.type === blockTaskItem) {
                    const childOfLastNode = state.doc.resolve($lastNode.pos - 1);
                    if (childOfLastNode.parent.type === paragraph) {
                        // Recalculate the slice to include the full blockTaskItem structure
                        slice = state.tr.doc.slice(childOfLastNode.pos, $cut.pos);
                        // Need to move one pos in to get to the text node of the paragraph
                        from = $lastNode.pos - 1;
                    } else {
                        // If the blockTaskItem last node is not a paragraph
                        // Expand the gap to include the paragraph being merged
                        gapFrom = $cut.pos; // To get the actual paragraph node
                        gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
                    }
                }
            }
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            let tr = state.tr.step(new (0, $eOaGc.ReplaceAroundStep)(from, to, gapFrom, gapTo, slice, insert, true));
            if (fontSize && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
                const targetTaskListSmallTextAttrs = (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)($cut.nodeBefore, fontSize);
                const followingListPos = $cut.pos + $cut.nodeAfter.nodeSize;
                const followingListNode = state.doc.resolve(followingListPos).nodeAfter;
                if (followingListNode && (0, $96Kjp.isTaskList)(followingListNode.type)) {
                    const normalizedListNode = (0, $1ffd94c702d1e1e5$export$aabf20f2ccae32df)(followingListNode, state.schema, targetTaskListSmallTextAttrs)[0];
                    if (normalizedListNode && normalizedListNode !== followingListNode) {
                        const mappedFollowingListPos = tr.mapping.map(followingListPos);
                        const currentFollowingListNode = tr.doc.nodeAt(mappedFollowingListPos);
                        if (currentFollowingListNode) tr = tr.replaceWith(mappedFollowingListPos, mappedFollowingListPos + currentFollowingListNode.nodeSize, normalizedListNode);
                    }
                }
            }
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };











var $3TgtB = parcelRequire("3TgtB");


var $cR6yj = parcelRequire("cR6yj");

var $lCuAc = parcelRequire("lCuAc");



var $3pVtP = parcelRequire("3pVtP");

var $7oNan = parcelRequire("7oNan");










const $1e638f9ccb1e4939$export$2e48e3ea1c210731 = (editorAnalyticsAPI)=>(targetType = 'paragraph')=>{
        return ({ tr: tr })=>{
            const inputMethod = (0, $krYZG.INPUT_METHOD).TOOLBAR;
            const { nodes: nodes } = tr.doc.type.schema;
            const { selection: selection } = tr;
            // Handle empty selection: insert a new task item
            const { $from: $from } = selection;
            const isEmpty = $from.parent.content.size === 0;
            if (isEmpty && nodes.taskList && nodes.taskItem) {
                // Create an empty task list with one empty task item
                const listLocalId = (0, $2nOF5.uuid).generate();
                const itemLocalId = (0, $2nOF5.uuid).generate();
                const emptyList = nodes.taskList.create({
                    localId: listLocalId
                }, [
                    nodes.taskItem.create({
                        localId: itemLocalId
                    })
                ]);
                // Insert the empty list at the current selection
                const insertTr = (0, $bjg0G.safeInsert)(emptyList)(tr);
                if (insertTr !== tr) {
                    if ((0, $ixfCV.fg)('platform_editor_toolbar_task_list_analytics')) // Fire INSERT analytics event when creating a new task list
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).INSERTED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ACTION,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: inputMethod,
                            listLocalId: listLocalId,
                            listSize: 1,
                            localId: itemLocalId,
                            position: 0
                        }
                    })(insertTr);
                    // Set cursor inside the new task item
                    const insertPos = insertTr.selection.$from.pos;
                    return insertTr.setSelection((0, $kCECX.TextSelection).near(insertTr.doc.resolve(insertPos)));
                }
            }
            const { node: node, pos: pos } = (0, $cR6yj.getFormattedNode)(tr);
            if (node !== null && pos !== null) {
                if ((0, $lCuAc.isBulletOrOrderedList)(node.type)) {
                    const transformedFrom = node.type.name === 'bulletList' ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes.taskList,
                        tr: tr
                    };
                    const resultTr = (0, $3pVtP.transformBetweenListTypes)(context);
                    if ((0, $ixfCV.fg)('platform_editor_toolbar_task_list_analytics')) // Fire CONVERTED analytics event when transforming a list to task list
                    {
                        if (resultTr && resultTr.docChanged) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CONVERTED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
                                transformedFrom: transformedFrom,
                                inputMethod: inputMethod
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
                if ((0, $96Kjp.isTaskList)(node.type)) {
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes[targetType],
                        tr: tr
                    };
                    const resultTr = targetType === 'paragraph' ? (0, $7oNan.transformTaskListToBlockNodes)(context) : (0, $3pVtP.transformBetweenListTypes)(context);
                    // Fire CONVERTED analytics event when transforming from task list
                    if (resultTr && resultTr.docChanged && targetType !== 'paragraph') {
                        const transformedFrom = (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
                        const targetListType = targetType === 'bulletList' ? (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                        if ((0, $ixfCV.fg)('platform_editor_toolbar_task_list_analytics')) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CONVERTED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).LIST,
                            actionSubjectId: targetListType,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                ...(0, $3TgtB.getCommonListAnalyticsAttributes)(tr),
                                transformedFrom: transformedFrom,
                                inputMethod: inputMethod
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
                const { $from: $from, $to: $to } = selection;
                const range = $from.blockRange($to);
                if (range) {
                    const resultTr = (0, $3pVtP.transformToTaskList)(tr, range, nodes.taskList, undefined, nodes);
                    // Fire INSERT analytics event when creating task list from selection
                    if (resultTr && resultTr.docChanged) {
                        const listNode = resultTr.doc.nodeAt(range.start);
                        const listLocalIdFromNode = listNode?.attrs?.localId ?? (0, $2nOF5.uuid).generate();
                        const listSizeFromNode = listNode?.childCount ?? 0;
                        const localIdFromNode = listNode?.firstChild?.attrs?.localId ?? (0, $2nOF5.uuid).generate();
                        if ((0, $ixfCV.fg)('platform_editor_toolbar_task_list_analytics')) editorAnalyticsAPI?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).INSERTED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ACTION,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                inputMethod: inputMethod,
                                listLocalId: listLocalIdFromNode,
                                listSize: listSizeFromNode,
                                localId: localIdFromNode,
                                position: 0
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
            }
            return tr;
        };
    };



const $7f73bce25198562c$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $iX5Ka.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $iX5Ka.INDENT_TYPE).TASK_LIST
        }
    });
const $7f73bce25198562c$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $7f73bce25198562c$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $7f73bce25198562c$var$nodeAfter($pos);
    return !after || (0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)(after);
};
const $7f73bce25198562c$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $77KCc.isEmptySelectionAtEnd)(state) || !(0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $c9ab19b3ef4e46bb$export$cd30871533411394)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $e99562cef88632d9$export$3553eb36282f092b)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $c9ab19b3ef4e46bb$export$b4043a93b6a561c9)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $iUNgd.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $7f73bce25198562c$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>(0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e69ff03257131f89$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $c9ab19b3ef4e46bb$export$d75a55aec79aaa5)(normalizedSelection);
            if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) {
                if (!curIndentLevel) return true;
                const outdentTr = (0, $d6ecd2c1a8ddffbd$export$6de6f04870a23f53)(state.tr, -1);
                if (outdentTr) {
                    (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, $7f73bce25198562c$var$indentationAnalytics(curIndentLevel, (0, $iX5Ka.INDENT_DIRECTION).OUTDENT, inputMethod))((_state, d)=>{
                        d?.(outdentTr);
                        return true;
                    })(state, dispatch);
                    return true;
                }
                return false;
            }
            if (!curIndentLevel || curIndentLevel === 1) return false;
            return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, $7f73bce25198562c$var$indentationAnalytics(curIndentLevel, (0, $iX5Ka.INDENT_DIRECTION).OUTDENT, inputMethod))((0, $iUNgd.autoJoin)((0, $e99562cef88632d9$export$2837bcd4021a2a47), [
                'taskList'
            ]))(state, dispatch);
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $7f73bce25198562c$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $c9ab19b3ef4e46bb$export$d75a55aec79aaa5)(state.selection);
    const curIndex = (0, $c9ab19b3ef4e46bb$export$af0098af8462419f)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cell = (0, $bjg0G.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $c9ab19b3ef4e46bb$export$cc187e317961fba)(state)) && cell) return true;
    return false;
};
const $7f73bce25198562c$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>(0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1), (state, dispatch)=>{
            const normalizedSelection = (0, $e69ff03257131f89$export$e590f1ae61640432)(state.selection);
            const curIndentLevel = (0, $c9ab19b3ef4e46bb$export$d75a55aec79aaa5)(normalizedSelection);
            if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) {
                if (!curIndentLevel) return true;
                const indentTr = (0, $d6ecd2c1a8ddffbd$export$6de6f04870a23f53)(state.tr, 1);
                if (indentTr) {
                    (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, $7f73bce25198562c$var$indentationAnalytics(curIndentLevel, (0, $iX5Ka.INDENT_DIRECTION).INDENT, inputMethod))((_state, d)=>{
                        d?.(indentTr);
                        return true;
                    })(state, dispatch);
                    return true;
                }
                return false;
            }
            if (!curIndentLevel || curIndentLevel >= 6) return true;
            return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, $7f73bce25198562c$var$indentationAnalytics(curIndentLevel, (0, $iX5Ka.INDENT_DIRECTION).INDENT, inputMethod))((0, $iUNgd.autoJoin)((0, $e99562cef88632d9$export$b9f50dd5ccd0f20), [
                'taskList'
            ]))(state, dispatch);
        });
const $7f73bce25198562c$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            const { taskList: taskList, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
            // Check if selection is inside a blockTaskItem paragraph
            const resultOfFindBlockTaskItem = (0, $e69ff03257131f89$export$11f4e85d86397169)($from);
            const isInBlockTaskItemParagraph = resultOfFindBlockTaskItem && resultOfFindBlockTaskItem?.hasParagraph;
            // Get the node before the current position
            const beforePos = isInBlockTaskItemParagraph ? $from.before() - 1 : $from.before();
            const nodeBefore = $from.doc.resolve(beforePos).nodeBefore;
            // Check if the node before is an empty task item
            const isEmptyActionOrDecisionItem = nodeBefore && (0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)(nodeBefore) && nodeBefore.content.size === 0;
            const isEmptyBlockTaskItem = blockTaskItem && nodeBefore?.type === blockTaskItem && nodeBefore?.firstChild?.type === paragraph && nodeBefore?.firstChild?.content?.size === 0;
            // previous was empty, just delete backwards
            if (isEmptyActionOrDecisionItem || isEmptyBlockTaskItem) return false;
            // If nested in a taskList, unindent
            const depthFromSelectionToBlockTaskItem = isInBlockTaskItemParagraph ? 2 : 1;
            const depthFromSelectionToNestedTaskList = depthFromSelectionToBlockTaskItem + 1;
            const parentDepth = $from.depth - depthFromSelectionToNestedTaskList;
            if ($from.node(parentDepth).type === taskList) return $7f73bce25198562c$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
            // If at the end of an item, unwrap contents into a paragraph
            // we achieve this by slicing the content out, and replacing
            if ($7f73bce25198562c$var$actionDecisionFollowsOrNothing($from)) {
                if (dispatch) {
                    // If we are in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                    // So we reduce the depth by 1 to get to the blockTaskItem node content
                    const taskContent = isInBlockTaskItemParagraph ? state.doc.slice($from.start($from.depth - 1), $from.end($from.depth - 1)).content : state.doc.slice($from.start(), $from.end()).content;
                    let slice;
                    try {
                        slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                        // might be end of document after
                        const tr = $7f73bce25198562c$var$splitListItemWith(state.tr, slice, $from, true);
                        dispatch(tr);
                        return true;
                    } catch  {
                        // If there's an error creating a paragraph, check if we are in a blockTaskItem
                        // Block task item's can have non-text content that cannot be wrapped in a paragraph
                        // So if the selection is in a blockTaskItem, just pass the content as is
                        if (resultOfFindBlockTaskItem && resultOfFindBlockTaskItem.blockTaskItemNode) {
                            // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                            slice = Array.from(taskContent.content);
                            const tr = $7f73bce25198562c$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $7f73bce25198562c$var$backspace = (editorAnalyticsAPI)=>(0, $dTPhv.filter)((0, $77KCc.isEmptySelectionAtStart), (0, $iUNgd.autoJoin)((0, $iUNgd.chainCommands)((state, dispatch)=>(0, $e99562cef88632d9$export$3553eb36282f092b)(state.selection.$from)(state, dispatch), (0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b), (state, dispatch)=>$7f73bce25198562c$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $7f73bce25198562c$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph, blockTaskItem: blockTaskItem, taskItem: taskItem } }, tr: tr } = state;
    // only run if cursor is at the end of the node
    if (!(0, $77KCc.isEmptySelectionAtEnd)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $c9ab19b3ef4e46bb$export$cd30871533411394)($from);
    // this is a top-level node it wont have $next.before()
    if (!$next.parent || $next.parent.type === doc) return false;
    // get resolved position of parent
    const $parentPos = $from.doc.resolve($from.start($from.depth - 1));
    const currentNode = $from.node();
    const parentNode = $parentPos.node();
    // if current position isn't an action or decision item, return false
    if (!(0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)(currentNode) && !(0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)(parentNode)) return false;
    const resultOfCurrentFindBlockTaskItem = (0, $e69ff03257131f89$export$11f4e85d86397169)($next);
    let isCurrentEmptyBlockTaskItem = false;
    if (resultOfCurrentFindBlockTaskItem) {
        const { blockTaskItemNode: blockTaskItemNode } = resultOfCurrentFindBlockTaskItem;
        isCurrentEmptyBlockTaskItem = blockTaskItem && blockTaskItemNode && blockTaskItemNode.childCount === 1 && blockTaskItemNode.firstChild?.type === paragraph && blockTaskItemNode.firstChild.childCount === 0;
    }
    const isEmptyActionOrDecisionItem = currentNode && (0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)(currentNode) && currentNode.childCount === 0;
    // If empty item, use default handler
    if (isEmptyActionOrDecisionItem || isCurrentEmptyBlockTaskItem) return false;
    // Check if next node is a blockTaskItem paragraph
    const resultOfNextFindBlockTaskItem = (0, $e69ff03257131f89$export$11f4e85d86397169)($next);
    const isNextInBlockTaskItemParagraph = resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem?.hasParagraph;
    // if nested, just unindent
    if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
    $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
        (0, $c9ab19b3ef4e46bb$export$b4043a93b6a561c9)(tr, $next, $next);
        dispatch(tr);
        return true;
    }
    const isNextCompatibleWithBlockTaskItem = blockTaskItem && ($next?.node()?.type === taskItem && $from?.node()?.type === blockTaskItem || $next?.node()?.type === blockTaskItem && $from?.node()?.type === taskItem || [
        taskItem,
        blockTaskItem
    ].includes($next?.node()?.type) && resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode);
    // if next node is of same type or compatible type, remove the node wrapping and create paragraph
    if (!(0, $c9ab19b3ef4e46bb$export$567a2801b8f40ab5)($next.nodeAfter) && (0, $c9ab19b3ef4e46bb$export$93c6d1f260b6c095)($from.parent) || resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode && $7f73bce25198562c$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type or compatible
    ($next.node().type.name === $from.node().type.name || isNextCompatibleWithBlockTaskItem)) {
        if (dispatch) {
            // If next node is in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
            // So we reduce the depth by 1 to get to the blockTaskItem node content
            const taskContent = isNextInBlockTaskItemParagraph ? state.doc.slice($next.start($next.depth - 1), $next.end($next.depth - 1)).content : state.doc.slice($next.start(), $next.end()).content;
            let slice;
            try {
                slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                // might be end of document after
                const tr = $7f73bce25198562c$var$splitListItemWith(state.tr, slice, $next, false);
                dispatch(tr);
                return true;
            } catch  {
                // If there's an error creating a paragraph, check if we are in a blockTaskItem
                // Block task item's can have non-text content that cannot be wrapped in a paragraph
                // So if the selection is in a blockTaskItem, just pass the content as is
                if (resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem.blockTaskItemNode) {
                    // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                    slice = Array.from(taskContent.content);
                    let $splitPos = $next;
                    if ($next.node().firstChild?.isTextblock) // set $next to the resolved position of inside the textblock
                    $splitPos = $next.doc.resolve($next.pos + 1);
                    const tr = $7f73bce25198562c$var$splitListItemWith(state.tr, slice, $splitPos, false);
                    dispatch(tr);
                    return true;
                }
            }
        }
    }
    return false;
};
const $7f73bce25198562c$var$deleteForwards = (0, $iUNgd.autoJoin)((0, $iUNgd.chainCommands)((0, $77KCc.deleteEmptyParagraphAndMoveBlockUp)((0, $c9ab19b3ef4e46bb$export$6f0e2eafb461f634)), $7f73bce25198562c$var$joinTaskDecisionFollowing, $7f73bce25198562c$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $7f73bce25198562c$var$deleteExtraListItem = (tr, _$from)=>{
    /*
    After we replace actionItem with empty list item if there's the anomaly of extra empty list item
    the cursor moves inside the first taskItem of splitted taskList
    so the extra list item present above the list item containing taskList & cursor
  */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $7f73bce25198562c$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $c9ab19b3ef4e46bb$export$cd0bf0d386a8d5a7)($from);
    const previousChildCountOfList = parentListNode?.node.childCount;
    const currentParentListNode = (0, $c9ab19b3ef4e46bb$export$cd0bf0d386a8d5a7)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode?.node.childCount;
    /*
    While replacing range with empty list item an extra list item gets created in some of the scenarios
    After splitting only one extra listItem should be created else an extra listItem is created
  */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $7f73bce25198562c$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $7f73bce25198562c$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    const origDoc = tr.doc;
    const { blockTaskItem: blockTaskItem, taskList: taskList } = tr.doc.type.schema.nodes;
    let baseDepth = $from.depth;
    let $oldAfter = origDoc.resolve($from.after());
    let textSelectionModifier = 0;
    let replaceFromModifier = 0;
    let deleteBlockModifier = 0;
    let shouldSplitBlockTaskItem = true;
    let isGapCursorSelection = false;
    let hasBlockTaskItem = false;
    if (blockTaskItem) {
        const result = (0, $e69ff03257131f89$export$11f4e85d86397169)($from);
        if (result) {
            const { blockTaskItemNode: blockTaskItemNode, hasParagraph: hasParagraph } = result;
            hasBlockTaskItem = !!blockTaskItemNode;
            if (blockTaskItemNode) {
                // If the case there is a paragraph in the block task item we need to
                // adjust some calculations
                if (hasParagraph) {
                    baseDepth = $from.depth - 1;
                    $oldAfter = origDoc.resolve($from.after(baseDepth));
                    // When we're removing the extra empty task item we need to reduce the range a bit
                    deleteBlockModifier = 1;
                } else {
                    textSelectionModifier = 1;
                    isGapCursorSelection = true;
                }
                textSelectionModifier = 1;
                const hasSiblingTaskList = $oldAfter.nodeAfter?.type === taskList;
                if (hasSiblingTaskList) // Don't use the split command if there is a sibling taskList
                shouldSplitBlockTaskItem = false;
                const posPreviousSibling = $from.start(hasParagraph ? $from.depth - 1 : $from.depth) - 1;
                const $posPreviousSibling = tr.doc.resolve(posPreviousSibling);
                const hasPreviousTaskItem = $posPreviousSibling.nodeBefore?.type === blockTaskItem;
                if (hasPreviousTaskItem && hasParagraph) replaceFromModifier = 1;
            }
        }
    }
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node(baseDepth - 2);
    const posInList = $from.index(baseDepth - 1);
    const shouldSplit = !(!(0, $c9ab19b3ef4e46bb$export$6f0e2eafb461f634)(container) && posInList === 0) && shouldSplitBlockTaskItem;
    const frag = (0, $aPdNQ.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && frag.firstChild?.type.name === 'listItem';
    /*
	 * We don't split the list item if it's nested inside lists
	 * to have consistent behaviour and their resolution.
	 */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, hasBlockTaskItem ? 0 : 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $2nOF5.uuid).generate()
            }
        }
    ]);
    /*
	 * In case of nested action inside lists we explicitly set the cursor
	 * We need to insert it relatively to previous doc structure
	 * So we calculate the position of previous list item and save that position
	 * (The cursor can be placed easily next to list item)
	 */ const previousListItemPos = isNestedActionInsideLists ? $from.start(baseDepth - 2) : 0;
    tr = tr.replace(tr.mapping.map($from.start(baseDepth) - 2 + replaceFromModifier), tr.mapping.map($from.end(baseDepth) + 2), frag.size ? new (0, $aPdNQ.Slice)(frag, 0, 0) : (0, $aPdNQ.Slice).empty);
    if (setSelection && !isNestedActionInsideLists) {
        const newPos = $from.pos + 1 - ((shouldSplit ? 0 : 2) + textSelectionModifier);
        if (isGapCursorSelection) tr = tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(newPos), (0, $eaLat.Side).LEFT));
        else tr = tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(newPos)));
    }
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === baseDepth - 1) {
        if ($oldAfter.nodeAfter && (0, $c9ab19b3ef4e46bb$export$6f0e2eafb461f634)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $c9ab19b3ef4e46bb$export$f029cbac7e0ab14c)({
                $from: $after,
                $to: tr.doc.resolve($after.after($after.depth - 1) - 1)
            });
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // After replacing the range there is an empty task item that
            // we need to remove.
            // We delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            // If this operation was done on a blockTaskItem we
            // have a modifier for the position
            tr = tr.deleteRange(pos - 3 - deleteBlockModifier, pos - 1 - deleteBlockModifier);
        }
    }
    if (isNestedActionInsideLists) $7f73bce25198562c$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $7f73bce25198562c$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $7f73bce25198562c$var$getCurrentBlockTaskFontSizeAttrs = (state, $from)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return false;
    const { fontSize: fontSize } = state.schema.marks;
    if (!fontSize) return false;
    const result = (0, $e69ff03257131f89$export$11f4e85d86397169)($from);
    if (!result) return false;
    return result.hasParagraph ? (0, $bVxZJ.getBlockMarkAttrs)($from.parent, fontSize) : (0, $bVxZJ.getFirstParagraphBlockMarkAttrs)(result.blockTaskItemNode, fontSize);
};
const $7f73bce25198562c$var$createTaskItemForCurrentTextSize = (state, attrs, fontSizeAttrs)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    if (fontSizeAttrs && blockTaskItem && paragraph && fontSize) return blockTaskItem.createChecked(attrs, paragraph.createChecked({}, undefined, [
        fontSize.create(fontSizeAttrs)
    ]));
    return taskItem.createAndFill(attrs);
};
const $7f73bce25198562c$var$splitListItem = (state, dispatch)=>{
    const { tr: tr, selection: { $from: $from } } = state;
    const { listItem: listItem, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph } = state.schema.nodes;
    const currentBlockTaskFontSizeAttrs = $7f73bce25198562c$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
    if ($7f73bce25198562c$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            // If previous node is a blockTaskItem we just want to delete the existing node and replace it with a paragraph
            const nodeBefore = state.doc.resolve($from.pos - 1).nodeBefore;
            if (blockTaskItem && nodeBefore?.type === blockTaskItem) {
                if ($from.parent.type === taskItem) {
                    const nodeSize = $from.parent.nodeSize;
                    tr.delete($from.pos - Math.floor(nodeSize / 2), $from.pos + Math.ceil(nodeSize / 2));
                    tr.insert($from.pos, paragraph.createChecked());
                    dispatch(tr);
                    return true;
                }
            }
            if ((0, $bjg0G.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($7f73bce25198562c$var$splitListItemWith(tr, $7f73bce25198562c$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            const splitTr = $7f73bce25198562c$var$splitListItemWith(tr, paragraph.createChecked(), $from, true);
            if (currentBlockTaskFontSizeAttrs) (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, state.schema.marks.fontSize, currentBlockTaskFontSizeAttrs);
            dispatch(splitTr);
        }
        return true;
    }
    return false;
};
const $7f73bce25198562c$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b), (0, $iUNgd.chainCommands)((0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$e29ace8e645e5684), (0, $iUNgd.chainCommands)($7f73bce25198562c$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $7f73bce25198562c$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        let nodeType = node && node.type;
        // Get the parent node type if the current node type is not one of the task or decision items
        // This is required to handle blockTaskItem
        if (![
            decisionItem,
            taskItem,
            blockTaskItem
        ].includes(nodeType)) {
            const possibleNodeType = (0, $bjg0G.findParentNodeOfType)([
                decisionItem,
                taskItem,
                blockTaskItem
            ])(selection)?.node?.type;
            if (possibleNodeType) nodeType = possibleNodeType;
        }
        const listType = [
            taskItem,
            blockTaskItem
        ].includes(nodeType) ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0 && (nodeType !== blockTaskItem || !$from.parent.isTextblock || (0, $c9ab19b3ef4e46bb$export$2ca50ccc2f45db88)(state))) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) {
                    if (nodeType === blockTaskItem) {
                        const blockTaskItemNode = (0, $bjg0G.findParentNodeOfType)([
                            blockTaskItem
                        ])(selection);
                        // New task items for blockTaskItem should be taskItem
                        // We want to prevent creating new blockTaskItems as much as possible
                        const newTaskItem = taskItem.createAndFill({
                            localId: itemLocalId
                        });
                        if (!blockTaskItemNode || !newTaskItem) return tr;
                        return tr.insert(blockTaskItemNode.pos, newTaskItem);
                    }
                    // Current position will point to text node, but we want to insert above the taskItem node
                    const insertPos = $from.pos - 1;
                    tr.insert(insertPos, newTask);
                    // Place cursor on the newly inserted empty task item above
                    // when nested inside another taskList.
                    if ((0, $ieeJu.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) {
                        const { taskList: taskListType } = schema.nodes;
                        const parentTaskList = $from.node($from.depth - 1);
                        const grandparent = $from.depth >= 3 ? $from.node($from.depth - 2) : null;
                        if (parentTaskList?.type === taskListType && grandparent?.type === taskListType) tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, insertPos + 1));
                    }
                    return tr;
                }
            }
            /**
					 * For blockTaskItem, must handle it differently because it can have a different depth
					 */ if (nodeType === blockTaskItem) {
                const blockTaskItemNode = (0, $bjg0G.findParentNodeOfType)([
                    blockTaskItem
                ])(selection);
                if (!blockTaskItemNode) return tr;
                // If the selection is a gap cursor at the end of the blockTaskItem,
                // we should insert a new taskItem.
                if ((!$from.parent.isTextblock || (0, $c9ab19b3ef4e46bb$export$bcd44b9b102ed403)(state)) && $from.parentOffset === $from.parent.nodeSize - 2) {
                    const currentBlockTaskFontSizeAttrs = $7f73bce25198562c$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
                    const newTaskNode = $7f73bce25198562c$var$createTaskItemForCurrentTextSize(state, {
                        localId: itemLocalId
                    }, currentBlockTaskFontSizeAttrs);
                    if (newTaskNode) {
                        tr.insert(blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize, newTaskNode);
                        // Move the cursor to the end of the newly inserted blockTaskItem
                        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize + 1));
                        return tr;
                    }
                }
                // Split near the depth of the current selection
                const splitTr = tr.split($from.pos, $from?.parent?.isTextblock ? 2 : 1, [
                    {
                        type: blockTaskItem,
                        attrs: {
                            localId: itemLocalId
                        }
                    }
                ]);
                const currentBlockTaskFontSizeAttrs = $7f73bce25198562c$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
                if (currentBlockTaskFontSizeAttrs) (0, $bVxZJ.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, state.schema.marks.fontSize, currentBlockTaskFontSizeAttrs);
                return splitTr;
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $d0a518f3dca58926$export$14f75d90d7dffdab)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $krYZG.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $7f73bce25198562c$var$cmdOptEnter = (0, $dTPhv.filter)((0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $1A89X.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $7f73bce25198562c$export$e832373cff8dec22(_schema, api, allowNestedTasks, consumeTabs) {
    const getContextIdentifier = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    const indentHandlers = {
        'Shift-Tab': (0, $dTPhv.filter)([
            (0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b),
            (state)=>!$7f73bce25198562c$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$7f73bce25198562c$export$d5d1010fad3453fa(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs),
        Tab: (0, $dTPhv.filter)([
            (0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b),
            (state)=>!$7f73bce25198562c$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$7f73bce25198562c$export$b294289254b8cdac(api?.analytics?.actions)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs)
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b),
        Tab: (0, $c9ab19b3ef4e46bb$export$c4942fd0ddcad0b)
    } : {};
    const toggleTaskListShortcut = (state, dispatch)=>{
        if (!state.schema.nodes.taskItem) return false;
        if (dispatch) {
            const command = (0, $1e638f9ccb1e4939$export$2e48e3ea1c210731)(api?.analytics?.actions)();
            const tr = command({
                tr: state.tr
            });
            if (tr) {
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
    const keymaps = {
        Backspace: $7f73bce25198562c$var$backspace(api?.analytics?.actions),
        Delete: $7f73bce25198562c$var$deleteForwards,
        'Ctrl-d': $7f73bce25198562c$var$deleteForwards,
        Enter: $7f73bce25198562c$var$enter(api?.analytics?.actions, getContextIdentifier),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $ldqjS.toggleTaskItemCheckbox).common]: $7f73bce25198562c$var$cmdOptEnter,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $ldqjS.toggleTaskList).common]: toggleTaskListShortcut,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $44cyU.keymap)(keymaps);
}
var $7f73bce25198562c$export$2e2bcd8739ae039 = $7f73bce25198562c$export$e832373cff8dec22;












var $lp7sw = parcelRequire("lp7sw");




var $7SvWS = parcelRequire("7SvWS");





var $8nvEM = parcelRequire("8nvEM");



















/**
 * Determine if the decision item node is empty
 *
 * @param node The decision item node
 * @returns true if the decision item is empty and false otherwise
 */ const $47fcb5b658a7035e$var$isDecisionItemEmpty = (node)=>node.childCount <= 0;
/**
 * Creates a DOM element for the decision icon with an accessible aria label.
 *
 * Generates a decision icon DOM structure with an aria label that changes based on whether
 * the decision item is empty. An empty decision item receives the "undefined" aria label,
 * while non-empty decision items receive the standard "decision" aria label.
 *
 * @param node - The ProseMirror node representing the decision item
 * @param intl - The intl object used to format internationalized messages for the aria label
 * @returns A DOMOutputSpec array representing the icon element with nested SVG graphics
 */ const $47fcb5b658a7035e$var$createIconDOM = ({ node: node, intl: intl })=>{
    const ariaLabel = $47fcb5b658a7035e$var$isDecisionItemEmpty(node) ? intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).undefinedDecisionAriaLabel) : intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).decisionAriaLabel);
    return [
        'span',
        {
            contentEditable: false,
            'data-component': 'icon'
        },
        [
            'span',
            {
                role: 'img',
                'aria-label': ariaLabel
            },
            [
                'http://www.w3.org/2000/svg svg',
                {
                    viewBox: `0 0 24 24`,
                    role: 'presentation',
                    width: '24',
                    height: '24',
                    'data-icon-source': 'legacy'
                },
                [
                    'http://www.w3.org/2000/svg path',
                    {
                        fill: 'currentcolor',
                        'fill-rule': 'evenodd',
                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                    }
                ]
            ],
            [
                'http://www.w3.org/2000/svg svg',
                {
                    viewBox: `-4 -4 24 24`,
                    fill: 'none',
                    role: 'presentation',
                    width: '24',
                    height: '24',
                    'data-icon-source': 'refreshed'
                },
                [
                    'http://www.w3.org/2000/svg path',
                    {
                        fill: 'currentcolor',
                        'fill-rule': 'evenodd',
                        d: 'm13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z'
                    }
                ]
            ]
        ]
    ];
};
const $47fcb5b658a7035e$export$e9f11508261835be = (node, intl)=>{
    const contentDomDataAttrs = $47fcb5b658a7035e$var$isDecisionItemEmpty(node) ? {
        'data-empty': 'true'
    } : {};
    return [
        'li',
        {
            'data-decision-local-id': node.attrs.localId || 'local-decision',
            'data-decision-state': node.attrs.state,
            'data-prosemirror-node-name': 'decisionItem',
            class: 'decisionItemView-content-wrap'
        },
        [
            'div',
            {
                'data-testid': 'elements-decision-item',
                'data-decision-wrapper': true
            },
            $47fcb5b658a7035e$var$createIconDOM({
                node: node,
                intl: intl
            }),
            // renderPlaceholder
            [
                'span',
                {
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contentEditable: false
                },
                intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).decisionPlaceholder)
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: 'decision-item',
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
};


class $19534721bb1ed20b$export$a190d28468c64715 {
    /**
   * Updates the hasChildren state based on the node's child count by setting the `data-empty` attribute on the contentDOM.
   * @param node - The ProseMirror node to check for children.
   * @private
   */ updateHasChildren(node) {
        const currentlyHasChildren = node.childCount > 0;
        if (currentlyHasChildren !== this.hasChildren) {
            this.hasChildren = currentlyHasChildren;
            this.contentDOM?.toggleAttribute('data-empty', !currentlyHasChildren);
            this.setIconAriaLabel(!currentlyHasChildren);
        }
        return this.hasChildren;
    }
    setIcon(dom) {
        if (!dom || !(dom instanceof HTMLElement)) return;
        const maybeIcon = dom.querySelector('[data-component="icon"] > [role="img"]');
        if (maybeIcon && maybeIcon instanceof HTMLElement) this.icon = maybeIcon;
    }
    setIconAriaLabel(isEmpty) {
        if (!this.icon || !this.intl) return;
        const ariaLabel = isEmpty ? this.intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).undefinedDecisionAriaLabel) : this.intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).decisionAriaLabel);
        this.icon.setAttribute('aria-label', ariaLabel);
    }
    /**
   * Updates the node view when the ProseMirror node changes.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @param {PMNode} node - The ProseMirror node to update the view with.
   * @example
   * decisionItemNodeView.update(node);
   * @returns {boolean} - Returns true if the view was updated successfully.
   */ update(node) {
        this.updateHasChildren(node);
        return true;
    }
    /**
   * Determines whether a mutation should be ignored by ProseMirror.
   * This prevents unnecessary node view destruction during DOM changes that don't affect our content.
   * @param mutation - The DOM mutation record or selection change
   * @returns true if the mutation should be ignored, false if it should be processed
   * @example
   * // Mutation outside contentDOM will be ignored
   * const shouldIgnore = decisionItemNodeView.ignoreMutation(mutationRecord);
   */ ignoreMutation(mutation) {
        // This was discovered while implementing the platform_editor_debounce_portal_provider experiment
        // And there will only be an issue if the experiment is enabled.
        // As such, this fix is behind this experiment.
        if (!(0, $ieeJu.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true, false)) return false; // Let ProseMirror handle all mutations when experiment is disabled
        if (!this.contentDOM) return true;
        // Ignore mutations that don't target our contentDOM and aren't selection changes
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    /**
   * Creates a new DecisionItemNodeView.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @import type {IntlShape} from 'react-intl';
   * @param {PMNode} node - The ProseMirror node representing the decision item.
   * @param {IntlShape} intl - The IntlShape for internationalization, used to format the placeholder text.
   * @example
   * const decisionItemNodeView = new DecisionItemNodeView(node, getIntl());
   */ constructor(node, intl){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.icon = null;
        this.intl = void 0;
        this.hasChildren = undefined;
        const spec = (0, $47fcb5b658a7035e$export$e9f11508261835be)(node, intl);
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.setIcon(this.dom);
        this.intl = intl;
    }
}



var $cbY7C = parcelRequire("cbY7C");
















class $dd1b6ff0b53fd6e4$export$8e651bc5e6600399 {
    getContextIdentifierProvider() {
        return this.api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    getObjectAri() {
        const provider = this.getContextIdentifierProvider();
        if (provider) return provider.objectId;
        return undefined;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    // Update the placeholder visibility based on content
    updatePlaceholder(node) {
        let currentIsContentEmpty = this.isContentEmpty(node);
        if ((0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) currentIsContentEmpty = (0, $b42172fa2d8646ff$export$c0efac86beb21f01)(node);
        if (currentIsContentEmpty !== this.emptyContent) {
            this.emptyContent = currentIsContentEmpty;
            this.contentDOM?.toggleAttribute('data-empty', currentIsContentEmpty);
        }
    }
    update(node) {
        if (!(0, $ieeJu.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            const isValidUpdate = node.type === this.node.type && !!(node.attrs.state === this.node.attrs.state);
            if (!isValidUpdate) return false;
        }
        // Only return false if this is a completely different task
        if (this.node.attrs.localId !== node.attrs.localId) return false;
        if ((0, $ieeJu.expValEquals)('platform_editor_prevent_taskitem_remount', 'isEnabled', true)) {
            if (node.type !== this.node.type) return false;
            const stateChanged = node.type === this.node.type && !!(node.attrs.state !== this.node.attrs.state);
            // Update task checkbox state to match document state.
            // It's possible the state may have changed from a collab edit and not from a checkbox click
            // so we need to update the checkbox to match.
            if (stateChanged && this.input) this.input.checked = node.attrs.state === 'DONE';
        }
        this.updatePlaceholder(node);
        if (this.domElement && !node.sameMarkup(this.node)) {
            this.domElement.setAttribute('data-task-state', node.attrs.state);
            this.domElement.setAttribute('data-task-local-id', node.attrs.localId);
            this.domElement.setAttribute('state', node.attrs.state);
        }
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.unbindInputDom) this.unbindInputDom();
        this.contentDOM = undefined;
        this.input = undefined;
        this.emptyContent = undefined;
        this.api = undefined;
    }
    constructor(node, view, getPos, { api: api, placeholder: placeholder, intl: intl }){
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.unbindInputDom = void 0;
        this.emptyContent = void 0;
        this.input = void 0;
        this.handleOnClick = (event)=>{
            if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                event.stopImmediatePropagation();
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $c9ab19b3ef4e46bb$export$ccb659c518fe26ad)(this.view, pos);
                return;
            }
        };
        this.handleOnChange = ()=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return;
            const { localId: localId, state: state } = this.node.attrs;
            const isDone = state === 'DONE';
            const nextState = isDone ? 'TODO' : 'DONE';
            const currentTaskDecisionState = this.api?.taskDecision.sharedState.currentState();
            // logic is inspired from packages/elements/task-decision/src/components/ResourcedTaskItem.tsx
            const objectAri = this.getObjectAri();
            if (currentTaskDecisionState?.taskDecisionProvider && objectAri) currentTaskDecisionState.taskDecisionProvider.toggleTask({
                localId: localId,
                objectAri: objectAri
            }, nextState);
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $1A89X.SetAttrsStep)(nodePos, {
                state: nextState,
                localId: localId
            }));
            tr.setMeta('scrollIntoView', false);
            const taskItemInfoMeta = {
                checkState: nextState,
                from: nodePos,
                to: nodePos + this.node.nodeSize
            };
            tr.setMeta('taskItemInfo', taskItemInfoMeta);
            this.view.dispatch(tr);
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.intl = intl;
        this.api = api;
        this.view = view;
        const domPlaceholder = placeholder ?? this.intl.formatMessage((0, $hdn7b.tasksAndDecisionsMessages).taskPlaceholder);
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $d6761794de1cb5b3$export$640336359e1ccaeb)(node, domPlaceholder, intl));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.domElement = this.dom instanceof HTMLElement ? this.dom : undefined;
        if (this.domElement) {
            this.input = this.domElement.querySelector('input[type="checkbox"]');
            this.unbindInputDom = (0, $cbY7C.bindAll)(this.input, [
                {
                    type: 'click',
                    listener: this.handleOnClick
                },
                {
                    type: 'change',
                    listener: this.handleOnChange
                }
            ]);
        }
    }
}


const $7d452d90b68b2994$export$da2f2be53bb82f44 = (api, intl, placeholder)=>{
    return (node, view, getPos)=>{
        return new (0, $dd1b6ff0b53fd6e4$export$8e651bc5e6600399)(node, view, getPos, {
            placeholder: placeholder,
            api: api,
            intl: intl
        });
    };
};


const $48648356c7cba438$export$9af39543e75ed75a = (state, action)=>{
    return {
        ...state,
        focusedTaskItemLocalId: action.data
    };
};
const $48648356c7cba438$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        taskDecisionProvider: action.data
    };
};
const $48648356c7cba438$export$571ff0891839feec = (state, action)=>{
    return {
        ...state,
        openRequestToEditPopupAt: action.data
    };
};




function $5f998e19dd0fc3b0$export$4f9e52c150984a8a(view, event) {
    const { target: target } = event;
    if (!target || !(target instanceof HTMLInputElement) || target.type !== 'checkbox' || target.getAttribute('data-input-type') !== 'lazy-task-item') return;
    const pos = view.posAtDOM(target, 0);
    // Resolve the position in the current document
    const resolvedPos = view.state.doc.resolve(pos);
    // Access the parent node
    const parentNode = resolvedPos?.parent;
    if (parentNode?.type?.name !== 'taskItem') return;
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const tr = view.state.tr.setNodeMarkup(parentPos, null, {
        ...parentNode.attrs,
        state: target.checked ? 'DONE' : 'TODO'
    });
    view.dispatch(tr);
}








function $dbd14b236231fa41$var$getAffectedTaskListsFromTransactions(transactions, doc, schema) {
    const { taskList: taskList } = schema.nodes;
    if (!taskList) return new Map();
    const result = new Map();
    for (const tr of transactions)for (const step of tr.steps){
        // ReplaceStep and ReplaceAroundStep both have from/to — other step types are skipped.
        if (!(step instanceof (0, $eOaGc.ReplaceStep)) && !(step instanceof (0, $eOaGc.ReplaceAroundStep))) continue;
        // Check both the start and end of each changed range, mapped to post-transaction positions.
        for (const rawPos of [
            step.from,
            step.to
        ]){
            const mappedPos = Math.min(tr.mapping.map(rawPos), doc.content.size - 1);
            const $pos = doc.resolve(mappedPos);
            // Walk ancestors from inner to outer, recording the outermost taskList node.
            // Once we find a taskList and then exit list structure (hit a non-taskList ancestor),
            // break early — prevents container nodes (e.g. panel) from causing us to
            // return an outer taskList in a different structural context.
            let rootTaskListPos = null;
            let rootTaskListNode = null;
            for(let depth = $pos.depth; depth >= 0; depth--){
                const node = $pos.node(depth);
                if (node.type === taskList) {
                    rootTaskListPos = $pos.before(depth);
                    rootTaskListNode = node;
                } else if (rootTaskListNode !== null && node.type !== schema.nodes.taskItem) break;
            }
            if (rootTaskListPos !== null && rootTaskListNode !== null) result.set(rootTaskListPos, rootTaskListNode);
        }
    }
    return result;
}
function $dbd14b236231fa41$export$5afbcba37ef924e1({ doc: doc, schema: schema, tr: tr, transactions: transactions }) {
    const { taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (!taskList || !taskItem) return tr;
    const affectedTaskLists = $dbd14b236231fa41$var$getAffectedTaskListsFromTransactions(transactions, doc, schema);
    if (affectedTaskLists.size === 0) return tr;
    // Sort by position descending so we process deeper/later positions first,
    // preventing earlier insertions from shifting later positions.
    const sortedEntries = [
        ...affectedTaskLists.entries()
    ].sort(([a], [b])=>b - a);
    for (const [taskListPos] of sortedEntries){
        // Re-resolve the taskList node from the current transaction doc (post-operation state).
        const mappedTaskListPos = tr.mapping.map(taskListPos);
        const currentTaskListNode = tr.doc.nodeAt(mappedTaskListPos);
        if (!currentTaskListNode) continue;
        if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_indentation', 'isEnabled', true)) {
            // Collect positions of all taskList nodes (at any depth) whose direct children
            // include a taskList — this is the invalid structure. The taskList schema requires
            // taskItem as children, not nested taskLists directly.
            // Process in reverse order so higher-position insertions don't shift lower positions.
            const invalidTaskListPositions = [];
            currentTaskListNode.descendants((node, offsetPos)=>{
                if (node.type === taskList) {
                    // A taskList as the FIRST child of another taskList is invalid — it means a
                    // delete or paste removed the leading taskItem, leaving a bare nested list.
                    // A taskList that follows a taskItem is valid (that's normal indentation).
                    const firstChild = node.firstChild;
                    if (firstChild && firstChild.type === taskList) {
                        const pos = mappedTaskListPos + 1 + offsetPos + 1;
                        invalidTaskListPositions.push(pos);
                    }
                }
                return true;
            });
            // Process in reverse (highest positions first).
            for(let i = invalidTaskListPositions.length - 1; i >= 0; i--){
                const remappedPos = tr.mapping.map(invalidTaskListPositions[i]);
                const emptyTaskItem = taskItem.createAndFill();
                if (emptyTaskItem) tr.insert(remappedPos, emptyTaskItem);
            }
        }
    }
    return tr;
}




function $630c351902eebd0c$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $7SvWS.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $630c351902eebd0c$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder) {
    return new (0, $kpCD8.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $7d452d90b68b2994$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder),
                decisionItem: (node)=>{
                    return new (0, $19534721bb1ed20b$export$a190d28468c64715)(node, getIntl());
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) ? {
                    blockTaskItem: (0, $7d452d90b68b2994$export$da2f2be53bb82f44)(api, getIntl(), taskPlaceholder)
                } : {}
            },
            decorations (state) {
                const pluginState = (0, $9f04dba1d2252c2c$export$77b371d6becc8882).getState(state);
                if (pluginState?.decorations) return pluginState.decorations;
                return (0, $8nvEM.DecorationSet).empty;
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $lp7sw.createSelectionClickHandler)([
                'decisionItem',
                'taskItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                // When the page is lazy loaded and task item is not yet available this allows
                // our toDOM implementation to toggle the node state
                change: (0, $5f998e19dd0fc3b0$export$4f9e52c150984a8a)
            },
            handleKeyDown: (view, event)=>{
                const { state: state } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_patch_1', 'isEnabled', true) ? (0, $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1)(state) : $from.node().type === schema.nodes.taskItem;
                const focusedTaskItemLocalId = (0, $9f04dba1d2252c2c$export$77b371d6becc8882).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $c9ab19b3ef4e46bb$export$bb36b9aa75d84160)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === currentTaskItemData?.localId;
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $c9ab19b3ef4e46bb$export$6d348f0593efe546)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $c9ab19b3ef4e46bb$export$6d348f0593efe546)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $c9ab19b3ef4e46bb$export$6d348f0593efe546)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $c9ab19b3ef4e46bb$export$84c7d27d1433771f)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $c9ab19b3ef4e46bb$export$965155ace97a0424)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $c9ab19b3ef4e46bb$export$6d348f0593efe546)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    (0, $c9ab19b3ef4e46bb$export$6ddc162ae107856)(view, currentTaskItemData);
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $4EksL.GapCursorSelection) && selection.side === 'left' && $from.nodeAfter?.type === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $c9ab19b3ef4e46bb$export$965155ace97a0424)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $c9ab19b3ef4e46bb$export$84c7d27d1433771f)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $c9ab19b3ef4e46bb$export$965155ace97a0424)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            },
            transformPasted: (slice, view)=>{
                if (Boolean(view?.state?.schema?.nodes?.blockTaskItem)) slice = (0, $1ffd94c702d1e1e5$export$7e04b173e2b79898)(slice, view);
                return slice;
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent,
                    focusedTaskItemLocalId: null,
                    taskDecisionProvider: undefined,
                    decorations: (0, $8nvEM.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882));
                const { action: action, data: data } = metaData ?? {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $de4e130d88e972dc$export$92a1a3b7554e9387).FOCUS_BY_LOCALID:
                        newPluginState = (0, $48648356c7cba438$export$9af39543e75ed75a)(newPluginState, {
                            action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).FOCUS_BY_LOCALID,
                            data: data
                        });
                        break;
                    case (0, $de4e130d88e972dc$export$92a1a3b7554e9387).SET_PROVIDER:
                        newPluginState = (0, $48648356c7cba438$export$1572b3eade6662f9)(newPluginState, {
                            action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).SET_PROVIDER,
                            data: data
                        });
                        break;
                    case (0, $de4e130d88e972dc$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP:
                        newPluginState = (0, $48648356c7cba438$export$571ff0891839feec)(newPluginState, {
                            action: (0, $de4e130d88e972dc$export$92a1a3b7554e9387).OPEN_REQUEST_TO_EDIT_POPUP,
                            data: data
                        });
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                const taskItemInfo = tr.getMeta('taskItemInfo');
                let decorations = (0, $8nvEM.DecorationSet).empty;
                if (taskItemInfo) decorations = (0, $8nvEM.DecorationSet).create(tr.doc, [
                    (0, $8nvEM.Decoration).inline(taskItemInfo.from, taskItemInfo.to, {}, {
                        dataTaskNodeCheckState: taskItemInfo.checkState
                    })
                ]);
                else decorations = newPluginState.decorations?.map(tr.mapping, tr.doc);
                const newState = {
                    ...newPluginState,
                    decorations: decorations
                };
                dispatch((0, $9f04dba1d2252c2c$export$77b371d6becc8882), newState);
                return newState;
            }
        },
        key: (0, $9f04dba1d2252c2c$export$77b371d6becc8882),
        /*
     * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
     * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
     * Prosemirror capability where node attributes could be generated dynamically.
     * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
     *
     * Note: we currently do not handle the edge case where two nodes may have the same localId
     */ appendTransaction: (transactions, _oldState, newState)=>{
            // Normalise taskList structure first — runs on its own transaction (without addToHistory: false)
            // so it is included in history and correctly undone with the triggering operation.
            if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && transactions.some((t)=>t.docChanged)) {
                const normTr = (0, $dbd14b236231fa41$export$5afbcba37ef924e1)({
                    tr: newState.tr,
                    transactions: transactions,
                    doc: newState.doc,
                    schema: newState.schema
                });
                if (normTr.docChanged) // Return the normalisation transaction — the next appendTransaction call will
                // assign any missing localIds to newly inserted nodes via the localId path below.
                return normTr;
            }
            // Assign unique localIds to any new nodes that don't have one.
            // Runs with addToHistory: false so localId assignment is not part of the undo history.
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $630c351902eebd0c$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem || blockTaskItem && node.type === blockTaskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
                                localId: (0, $2nOF5.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = (0, $9f04dba1d2252c2c$export$77b371d6becc8882).getState(view.state);
                    const prevPluginState = (0, $9f04dba1d2252c2c$export$77b371d6becc8882).getState(prevState);
                    if (pluginState.focusedTaskItemLocalId === prevPluginState.focusedTaskItemLocalId) return;
                    const taskItem = (0, $c9ab19b3ef4e46bb$export$bb36b9aa75d84160)(view);
                    if (!taskItem) return;
                    if (pluginState.focusedTaskItemLocalId === taskItem.localId) {
                        const taskElement = view.nodeDOM(taskItem.pos);
                        if (taskElement instanceof HTMLElement) taskElement?.querySelector('input')?.focus();
                    }
                }
            };
        }
    });
}








var $kSwu1 = parcelRequire("kSwu1");





var $3FYPH = parcelRequire("3FYPH");


var $dVKvM = parcelRequire("dVKvM");


var $dimUV = parcelRequire("dimUV");

const $29807f7d090d58e2$var$NODE_NAME = 'decisionList';
const $29807f7d090d58e2$export$77edd8d99970778c = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.decisionList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $29807f7d090d58e2$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $3FYPH.messages).decisionList));
};


/* RequestToEditPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ // import Popup from '@atlaskit/popup';












var $iLcY8 = parcelRequire("iLcY8");





var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");





var $7Y8M5 = parcelRequire("7Y8M5");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

const $2a39577846935772$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $2a39577846935772$var$TRYING_REQUEST_TIMEOUT = 3000;
const $2a39577846935772$var$popupContentWrapper = null;
const $2a39577846935772$var$wrapperStyles = null;
const $2a39577846935772$var$wrapperBoxStyles = null;
const $2a39577846935772$var$dotStyles = null;
const $2a39577846935772$var$dotStylesUnbounded = null;
const $2a39577846935772$var$pressableStyles = {
    pressable: "_ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1oa5 _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $2a39577846935772$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $iLcY8.PLATFORMS).WEB,
            mode: (0, $iLcY8.MODE).EDITOR
        }
    };
};
const $2a39577846935772$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).requestToEdit), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "requested-to-edit",
        color: "var(--ds-icon-disabled, #080F214A)"
    }));
};
const $2a39577846935772$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        onClick: onClick,
        xcss: $2a39577846935772$var$pressableStyles.pressable,
        testId: "request-to-edit-popup-request-btn"
    }, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).requestToEdit)));
};
const $2a39577846935772$export$2dae066a4c27dc7a = ({ element: element, api: api, editorView: editorView, onClose: onClose, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const hasRequestedEditPermission = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const openRequestToEditPopupAt = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'taskDecision.openRequestToEditPopupAt');
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(!!openRequestToEditPopupAt);
    const [requested, setRequested] = (0, $cozmU.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $2a39577846935772$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const onHandleEdit = (event)=>{
        event.stopPropagation();
        const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
        if (viewMode !== 'view') return;
        const editorAnalyticsAPI = api?.analytics?.actions;
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        tr.setMeta('scrollIntoView', false);
        if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
            const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI?.attachAnalyticsEvent($2a39577846935772$var$anaylyticsEventPayload((0, $krYZG.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($2a39577846935772$var$anaylyticsEventPayload((0, $krYZG.ACTION).DISMISSED));
        setIsOpen(false);
        onClose();
    };
    const onHandleCancel = (event)=>{
        // Check if the click is on task item checkbox, if so, do not close the popup
        const target = event.target;
        if (target && (element.contains(target) || element === target)) return;
        setIsOpen(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ $cozmU.createElement($2a39577846935772$var$PopupWithListeners // Ignored via go/ees005
    , {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        target: element,
        fitHeight: 148,
        handleClickOutside: onHandleCancel,
        handleEscapeKeydown: onHandleCancel,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        ariaLabel: null,
        preventOverflow: true,
        focusTrap: true,
        captureClick: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ $cozmU.createElement("div", {
            ref: setOutsideClickTargetRef,
            className: (0, $hekY6.default)([
                "_2rkofajl _ca0qv77o _n3tdv77o _19bvv77o _u5f3v77o _16qs130s _bfhk1bhr"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
            space: "space.150"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).editAccessTitle)), /*#__PURE__*/ $cozmU.createElement("div", null, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).requestToEditDescription)), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1gmx"
            ])
        }, tryingRequest || requested ? /*#__PURE__*/ $cozmU.createElement($2a39577846935772$var$RequestedMessage, null) : /*#__PURE__*/ $cozmU.createElement($2a39577846935772$var$RequestToEditButton, {
            onClick: onHandleEdit
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhk16e3",
                "_2rko1rr0"
            ])
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), null, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        ), {
            onClick: ()=>onHandleDismiss(api?.analytics?.actions),
            xcss: $2a39577846935772$var$pressableStyles.pressable,
            testId: "request-to-edit-popup-cancel-btn"
        }, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).dismiss)))))))));
};


















var $iAaYd = parcelRequire("iAaYd");

const $12321e460f50275c$var$NODE_NAME = 'taskList';
const $12321e460f50275c$export$de5198967b780ae = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $krYZG.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.taskList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $12321e460f50275c$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).taskList));
};






var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");








var $3k5Tv = parcelRequire("3k5Tv");












var $i9j2V = parcelRequire("i9j2V");







const $5da2bf18e2587411$export$a78d1842153dea18 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isMarkdownToolbarEnabled = (0, $anBbz.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $ixfCV.fg)('platform_editor_markdown_compatible_toolbar');
    const { isInsideTask: isInsideTask, markdownView: markdownView, sourceBlockFormatState: sourceBlockFormatState, sourceListFormatState: sourceListFormatState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'taskDecision',
        'markdownMode'
    ], (states)=>({
            isInsideTask: states.taskDecisionState?.isInsideTask,
            markdownView: isMarkdownToolbarEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceBlockFormatState : null,
            sourceListFormatState: isMarkdownToolbarEnabled ? states.markdownModeState?.sourceListFormatState : null
        }));
    const isInSourceView = isMarkdownToolbarEnabled && markdownView === 'syntax';
    const isSelected = isInSourceView ? sourceListFormatState?.inTaskList : isInsideTask;
    const isDisabled = Boolean(isInSourceView && sourceBlockFormatState?.inCodeBlock);
    const handleClick = ()=>{
        if (isDisabled) return;
        if (isInSourceView) {
            api?.markdownMode?.actions.toggleSourceTaskList();
            return;
        }
        api?.core.actions.execute(api?.taskDecision?.commands.toggleTaskList());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $ldqjS.formatShortcut)((0, $ldqjS.toggleTaskList))
        }),
        isSelected: isSelected,
        isDisabled: isDisabled,
        onClick: handleClick,
        ariaKeyshortcuts: (0, $ldqjS.formatShortcut)((0, $ldqjS.toggleTaskList))
    }, formatMessage((0, $hdn7b.tasksAndDecisionsMessages).taskList));
};


const $fd16cd5f5ac6c8e8$export$f1884d013db554cc = ({ api: api })=>{
    return [
        {
            type: (0, $3nacY.TASK_LIST_MENU_ITEM).type,
            key: (0, $3nacY.TASK_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $3nacY.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $hVLmg.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $3nacY.TASK_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5da2bf18e2587411$export$a78d1842153dea18), {
                    api: api,
                    parents: parents
                })
        }
    ];
};












var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");





const $49a8e01d82c86ae0$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $d0a518f3dca58926$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            label: label
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $49a8e01d82c86ae0$var$_default_1 = (0, $kSwu1.injectIntl)($49a8e01d82c86ae0$var$ToolbarDecision);
var $49a8e01d82c86ae0$export$2e2bcd8739ae039 = $49a8e01d82c86ae0$var$_default_1;

















var $d0CGr = parcelRequire("d0CGr");


const $6783693dc2fc8d95$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $d0a518f3dca58926$export$d1657e7847eaa8d6)(editorAPI?.analytics?.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d0CGr))), {
            label: label
        })
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $6783693dc2fc8d95$var$_default_1 = (0, $kSwu1.injectIntl)($6783693dc2fc8d95$var$ToolbarTask);
var $6783693dc2fc8d95$export$2e2bcd8739ae039 = $6783693dc2fc8d95$var$_default_1;


const $5bbbce939af77ddc$var$taskDecisionToolbarGroupStyles = null;
const $5bbbce939af77ddc$var$TASK_LIST_NODE_NAME = 'taskList';
const $5bbbce939af77ddc$var$DECISION_LIST_NODE_NAME = 'decisionList';
const $5bbbce939af77ddc$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $d0a518f3dca58926$export$c8b7fdb74eb8fe5c)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
function $5bbbce939af77ddc$var$ContentComponent({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi }) {
    const openRequestToEditPopupAt = (0, $4Qu9h.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.openRequestToEditPopupAt');
    const hasEditPermission = (0, $4Qu9h.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.hasEditPermission');
    if (!editorView || hasEditPermission || !openRequestToEditPopupAt) return null;
    const domAtPos = editorView.domAtPos.bind(editorView); // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $bjg0G.findDomRefAtPos)(openRequestToEditPopupAt, domAtPos);
    const handleOnClose = ()=>{
        (0, $c9ab19b3ef4e46bb$export$6e1436cb7b69383b)(editorView);
        editorView.focus();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $2a39577846935772$export$2dae066a4c27dc7a), {
        key: openRequestToEditPopupAt,
        api: dependencyApi,
        editorView: editorView,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: element,
        onClose: handleOnClose
    });
}
const $5bbbce939af77ddc$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission = true, hasRequestedEditPermission: hasRequestedEditPermission, quickInsertActionDescription: quickInsertActionDescription, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, taskPlaceholder: taskPlaceholder, allowBlockTaskItem: allowBlockTaskItem } = {}, api: api })=>{
    const getIdentifierProvider = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    let previousTaskAndDecisionProvider;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $fd16cd5f5ac6c8e8$export$f1884d013db554cc)({
        api: api
    }));
    if (taskDecisionProvider) taskDecisionProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>(0, $d0a518f3dca58926$export$1572b3eade6662f9)(provider)(tr));
    });
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]
            },
            component: ({ isSuggested: isSuggested } = {})=>{
                return /*#__PURE__*/ $cozmU.createElement((0, $12321e460f50275c$export$de5198967b780ae), {
                    api: api,
                    isSuggested: isSuggested
                });
            },
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($5bbbce939af77ddc$var$TASK_LIST_NODE_NAME))
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]
            },
            component: ({ isSuggested: isSuggested } = {})=>{
                return /*#__PURE__*/ $cozmU.createElement((0, $29807f7d090d58e2$export$77edd8d99970778c), {
                    api: api,
                    isSuggested: isSuggested
                });
            },
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($5bbbce939af77ddc$var$DECISION_LIST_NODE_NAME))
        }
    ]);
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $kAzEy.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $3a4a47e26a06419c$export$7727308e3d6fe8e9)()
                },
                {
                    name: 'taskList',
                    node: (0, $7eTEw.taskList)
                },
                {
                    name: 'taskItem',
                    node: (0, $d6761794de1cb5b3$export$aa7ccb8f78e9cbdd)()
                },
                ...(0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true) && allowBlockTaskItem ? [
                    {
                        name: 'blockTaskItem',
                        node: (0, $d6761794de1cb5b3$export$526b6659b16d1721)()
                    }
                ] : []
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $9f04dba1d2252c2c$export$77b371d6becc8882).getState(editorState);
            const indentLevel = (0, $c9ab19b3ef4e46bb$export$d75a55aec79aaa5)(editorState.selection) || 0;
            const itemIndex = (0, $c9ab19b3ef4e46bb$export$af0098af8462419f)(editorState);
            const isFlexibleListIndentationEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_flexible_list_indentation', 'isEnabled', true);
            return {
                focusedTaskItemLocalId: pluginState?.focusedTaskItemLocalId || null,
                isInsideTask: (0, $c9ab19b3ef4e46bb$export$2fad51fb9cb5e2d1)(editorState),
                indentDisabled: !isFlexibleListIndentationEnabled && itemIndex === 0 || indentLevel >= (0, $fClPf.MAX_INDENTATION_LEVEL),
                outdentDisabled: isFlexibleListIndentationEnabled ? indentLevel <= 0 : indentLevel <= 1,
                // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
                // this allows the default plugin state to initialise as true if the extra configuration is not provided
                hasEditPermission: pluginState?.hasEditPermission !== undefined ? pluginState?.hasEditPermission : true,
                requestToEditContent: pluginState?.requestToEditContent,
                hasRequestedEditPermission: pluginState?.hasRequestedEditPermission,
                taskDecisionProvider: pluginState?.taskDecisionProvider,
                openRequestToEditPopupAt: pluginState?.openRequestToEditPopupAt
            };
        },
        commands: {
            toggleTaskList: (targetType)=>(0, $1e638f9ccb1e4939$export$2e48e3ea1c210731)(api?.analytics?.actions)(targetType),
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $9f04dba1d2252c2c$export$77b371d6becc8882), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $d0a518f3dca58926$export$d1657e7847eaa8d6)(api?.analytics?.actions, getIdentifierProvider),
            indentTaskList: (0, $7f73bce25198562c$export$b294289254b8cdac)(api?.analytics?.actions),
            outdentTaskList: (0, $7f73bce25198562c$export$d5d1010fad3453fa)(api?.analytics?.actions),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise; // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise) return false;
                previousTaskAndDecisionProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $d0a518f3dca58926$export$1572b3eade6662f9)(provider)(tr)) ?? false;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $630c351902eebd0c$export$ae829ec7b2625219)(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $f2a3082b82d1c4c7$export$2e2bcd8739ae039)(api?.analytics?.actions, getIdentifierProvider)(schema, featureFlags)
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $7f73bce25198562c$export$2e2bcd8739ae039)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $49a8e01d82c86ae0$export$2e2bcd8739ae039), {
                editorView: editorView,
                isDisabled: disabled,
                isReducedSpacing: true,
                editorAPI: api
            }), /*#__PURE__*/ $cozmU.createElement((0, $6783693dc2fc8d95$export$2e2bcd8739ae039), {
                editorView: editorView,
                isDisabled: disabled,
                isReducedSpacing: true,
                editorAPI: api
            }));
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ $cozmU.createElement($5bbbce939af77ddc$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'action',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).action),
                        description: quickInsertActionDescription ?? formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).actionDescription),
                        priority: 100,
                        keywords: [
                            'checkbox',
                            'task',
                            'todo'
                        ],
                        keyshortcut: '[]',
                        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, $jGK9e.IconAction), null),
                        action (insert, state, source) {
                            return (0, $d0a518f3dca58926$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'taskList', source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT, $5bbbce939af77ddc$var$addItem(insert, 'taskList', state.schema));
                        }
                    },
                    {
                        id: 'decision',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).decision),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).decisionDescription),
                        priority: 900,
                        keyshortcut: '<>',
                        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, $jGK9e.IconDecision), null),
                        action (insert, state, source) {
                            return (0, $d0a518f3dca58926$export$8c1bb617b1f6f2f1)(api?.analytics?.actions, getIdentifierProvider)(state, 'decisionList', source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT, $5bbbce939af77ddc$var$addItem(insert, 'decisionList', state.schema));
                        }
                    }
                ]
        }
    };
};
module.exports["tasksAndDecisionsPlugin"] = $5bbbce939af77ddc$export$582323d9689d93fc;

});

parcelRegister("ctVsO", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");


var $kpCD8 = parcelRequire("kpCD8");


var $c2E4R = parcelRequire("c2E4R");


var $iLrhi = parcelRequire("iLrhi");


var $a33Aa = parcelRequire("a33Aa");

const $5db34782a9e568c4$export$abe7f7e3118e197d = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        view () {
            let aborted = false;
            return {
                update (view, prevState) {
                    if (aborted) // opt out of additional logic if already aborted
                    return;
                    if (!view.state.selection.eq(prevState.selection) && !(0, $c2E4R.atTheBeginningOfDoc)(view.state) && !(0, $iLrhi.isEmptyDocument)(view.state.doc)) {
                        const activeInteraction = (0, $a33Aa.getActiveInteraction)();
                        if (activeInteraction && [
                            'edit-page',
                            'live-edit'
                        ].includes(activeInteraction.ufoName)) (0, $a33Aa.abortAll)('new_interaction', `selection-changed-on-editor-element`);
                        aborted = true;
                    }
                }
            };
        }
    });
};


const $0c2d9c23fee987f5$export$e137bce9a5077ae5 = ()=>({
        name: 'ufo',
        pmPlugins () {
            const isSSR = Boolean(undefined);
            if (isSSR) // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
            return [];
            if ((0, $ieeJu.expValEquals)('platform_editor_abort_ufo_on_user_interaction', 'isEnabled', true)) return [
                {
                    name: 'traceUFOInteractionOnFirstInteraction',
                    plugin: (0, $5db34782a9e568c4$export$abe7f7e3118e197d)
                }
            ];
            return [];
        }
    });
module.exports["ufoPlugin"] = $0c2d9c23fee987f5$export$e137bce9a5077ae5;

});

parcelRegister("cDpdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


const $2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("lPrYD")));
const $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $2a3e0a8082e0a83e$export$5057fa778edd8de9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, config)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== config) {
        t0 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config
            });
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const WrapperComponent = t0;
    let t1;
    if ($[2] !== props) {
        t1 = props ?? {};
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== WrapperComponent || $[5] !== t1) {
        t2 = {
            ...t1,
            plugins: $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
        $[4] = WrapperComponent;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const WrapperComponent = (0, $cozmU.useMemo)(()=>(props_0)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config
            });
        }, [
        config
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return {
            ...props ?? {},
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props
    ]);
};
module.exports["useLinkPickerEditorProps"] = $2a3e0a8082e0a83e$export$5057fa778edd8de9;

});

parcelRegister("lPrYD", function(module, exports) {

let $fe44101023950a27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe44101023950a27$var$load("7TnhR"),
    $fe44101023950a27$var$load("hS8gF"),
    $fe44101023950a27$var$load("6wr18"),
    $fe44101023950a27$var$load("g8A75"),
    $fe44101023950a27$var$load("h5kct"),
    $fe44101023950a27$var$load("4RsKm"),
    $fe44101023950a27$var$load("ffEVr"),
    $fe44101023950a27$var$load("fmCjo")
]).then(()=>parcelRequire('et6nL'));

});

parcelRegister("WABbQ", function(module, exports) {

var $fqVYq = parcelRequire("fqVYq");


var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $2xHHU = parcelRequire("2xHHU");


var $cycWk = parcelRequire("cycWk");

const $93681452653812f0$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $cycWk.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $8Z43Z.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $cycWk.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $93681452653812f0$export$c2e8772deb1607ea = $93681452653812f0$var$select('column');
const $93681452653812f0$export$e247ed8cec4832f4 = $93681452653812f0$var$select('row');
const $93681452653812f0$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $cycWk.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $8Z43Z.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
        };
const $93681452653812f0$export$b5ba3b60192c7a8d = $93681452653812f0$var$selectRowsOrColumns('rows');
const $93681452653812f0$export$41a42e79fbe56d35 = $93681452653812f0$var$selectRowsOrColumns('columns');
const $93681452653812f0$export$625c5b9bf13f01a8 = (tr)=>{
    const table = (0, $cycWk.findTable)(tr.selection);
    if (table) {
        const { map: map } = (0, $8Z43Z.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
const $93681452653812f0$export$cec96519863940d = ($pos)=>{
    const table = (0, $cycWk.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $8Z43Z.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = $pos.doc.resolve(head);
            const $anchor = $pos.doc.resolve(anchor);
            return new (0, $8HW7o.CellSelection)($anchor, $head);
        }
    }
};
const $93681452653812f0$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) {
        const tableSelection = $93681452653812f0$export$cec96519863940d($pos);
        if (tableSelection) return (0, $2xHHU.cloneTr)(tr.setSelection(tableSelection));
        return tr;
    }
    const table = (0, $cycWk.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $8Z43Z.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $2xHHU.cloneTr)(tr.setSelection(new (0, $8HW7o.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
module.exports["selectColumn"] = $93681452653812f0$export$c2e8772deb1607ea;
module.exports["selectRow"] = $93681452653812f0$export$e247ed8cec4832f4;
module.exports["selectRows"] = $93681452653812f0$export$b5ba3b60192c7a8d;
module.exports["selectColumns"] = $93681452653812f0$export$41a42e79fbe56d35;
module.exports["selectTable"] = $93681452653812f0$export$625c5b9bf13f01a8;
module.exports["getTableSelectionClosesToPos"] = $93681452653812f0$export$cec96519863940d;
module.exports["selectTableClosestToPos"] = $93681452653812f0$export$3e7c4d16b1cc1be3;

});

parcelRegister("rOV4B", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $9HWym = parcelRequire("9HWym");

const $854c0c9c837fb0c6$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption',
    'layoutColumn'
];
const $854c0c9c837fb0c6$export$4b59c90449151b37 = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption'
];
const $854c0c9c837fb0c6$var$IGNORE_NODE_DESCENDANTS = [
    'listItem',
    'taskList',
    'decisionList',
    'mediaSingle'
];
const $854c0c9c837fb0c6$export$9cba0273af9f9727 = [
    'listItem',
    'taskList',
    'decisionList'
];
const $854c0c9c837fb0c6$export$d43a1c4953e0600e = (node)=>{
    // Optimisation to avoid drawing node decorations for empty table cells
    if ([
        'tableCell',
        'tableHeader'
    ].includes(node.type.name)) {
        if (node.childCount === 1 && node.firstChild?.type.name === 'paragraph' && node.firstChild.childCount === 0) return false;
    }
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) return !$854c0c9c837fb0c6$export$9cba0273af9f9727.includes(node.type.name);
    return !$854c0c9c837fb0c6$var$IGNORE_NODE_DESCENDANTS.includes(node.type.name);
};
const $854c0c9c837fb0c6$var$shouldIgnoreNode = (node, ignore_nodes, depth, parent)=>{
    const nodeTypes = node.type.schema.nodes;
    const isTable = node.type.name === nodeTypes?.table?.name;
    const parentIsTable = parent && [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
    const isNestedTable = isTable && parentIsTable;
    if (isNestedTable) return true;
    const isFirstTableRow = parent?.type.name === 'table' && depth === 1 && node === parent.firstChild && 'tableRow' === node.type.name && (0, $fqVYq.editorExperiment)('advanced_layouts', true);
    if (isFirstTableRow) return false;
    const isLegacyContentMacroExtension = node.type.name === 'extension' && node.attrs?.extensionType === 'com.atlassian.confluence.migration' && node.attrs?.extensionKey === 'legacy-content';
    if (isLegacyContentMacroExtension) return true;
    return ignore_nodes.includes(node.type.name);
};
const $854c0c9c837fb0c6$export$562fc95beb8a58d3 = (state, decorations, from, to)=>{
    let newFrom = from;
    let newTo = to;
    // make it non-inclusive
    if (newFrom !== undefined) newFrom++;
    // make it non-inclusive
    if (newTo !== undefined) newTo--;
    // return empty array if range reversed
    if (newFrom !== undefined && newTo !== undefined && newFrom > newTo) return [];
    return decorations.find(newFrom, newTo, (spec)=>spec.type === (0, $9HWym.TYPE_NODE_DEC));
};
const $854c0c9c837fb0c6$export$a3bb13b1e97d70c7 = (newState, from, to)=>{
    const decs = [];
    if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return [];
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > newState.doc.nodeSize - 2 ? newState.doc.nodeSize - 2 : to;
    const ignore_nodes = (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? $854c0c9c837fb0c6$export$4b59c90449151b37 : $854c0c9c837fb0c6$var$IGNORE_NODES;
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, _)=>{
        let depth = 0;
        const shouldDescend = $854c0c9c837fb0c6$export$d43a1c4953e0600e(node);
        const anchorName = (0, $9HWym.getNodeAnchor)(node);
        const nodeTypeWithLevel = (0, $9HWym.getNodeTypeWithLevel)(node);
        // Doesn't descend into a node
        if (node.isInline) return false;
        depth = newState.doc.resolve(pos).depth;
        if ($854c0c9c837fb0c6$var$shouldIgnoreNode(node, ignore_nodes, depth, parent)) return shouldDescend; //skip over, don't consider it a valid depth
        const anchorStyles = `anchor-name: ${anchorName};`;
        decs.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {
            style: anchorStyles,
            ['data-drag-handler-anchor-name']: anchorName,
            ['data-drag-handler-node-type']: nodeTypeWithLevel,
            ['data-drag-handler-anchor-depth']: `${depth}`
        }, {
            type: (0, $9HWym.TYPE_NODE_DEC),
            anchorName: anchorName,
            nodeType: node.type.name,
            nodeTypeWithLevel: nodeTypeWithLevel
        }));
        return shouldDescend && depth < (0, $9HWym.NESTED_DEPTH);
    });
    return decs;
};
module.exports["IGNORE_NODES_NEXT"] = $854c0c9c837fb0c6$export$4b59c90449151b37;
module.exports["IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT"] = $854c0c9c837fb0c6$export$9cba0273af9f9727;
module.exports["findNodeDecs"] = $854c0c9c837fb0c6$export$562fc95beb8a58d3;
module.exports["nodeDecorations"] = $854c0c9c837fb0c6$export$a3bb13b1e97d70c7;

});

parcelRegister("3BXSc", function(module, exports) {

var $LQnOI = parcelRequire("LQnOI");


var $haNN4 = parcelRequire("haNN4");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $4RpM6 = parcelRequire("4RpM6");


var $hiQdW = parcelRequire("hiQdW");


var $kpCD8 = parcelRequire("kpCD8");


var $kAPZe = parcelRequire("kAPZe");


var $g6uqx = parcelRequire("g6uqx");


var $bwJyA = parcelRequire("bwJyA");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $ixfCV = parcelRequire("ixfCV");


var $38vK5 = parcelRequire("38vK5");


var $aDtKq = parcelRequire("aDtKq");


var $iSrRp = parcelRequire("iSrRp");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $fKt2m = parcelRequire("fKt2m");


var $rOV4B = parcelRequire("rOV4B");


var $j28nv = parcelRequire("j28nv");


var $djgGr = parcelRequire("djgGr");


var $g8ZIt = parcelRequire("g8ZIt");


var $hYw7t = parcelRequire("hYw7t");


var $9UAss = parcelRequire("9UAss");


var $h7MdN = parcelRequire("h7MdN");


var $jdNrc = parcelRequire("jdNrc");


var $d1Uph = parcelRequire("d1Uph");


var $aHnsS = parcelRequire("aHnsS");


var $a4QVD = parcelRequire("a4QVD");


var $bOZni = parcelRequire("bOZni");


var $i2jOy = parcelRequire("i2jOy");


var $bOCgz = parcelRequire("bOCgz");

const $ae8d0893738a17f4$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('blockControls');
const $ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT = 'Editor Blocks Drag Initialization Time';
const $ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT = 'Editor Blocks Drop Initialization Time';
const $ae8d0893738a17f4$var$scheduleCallback = (cb, options)=>{
    return 'requestIdleCallback' in window ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $ae8d0893738a17f4$var$isHTMLElement = (element)=>{
    return element instanceof HTMLElement;
};
const $ae8d0893738a17f4$var$destroyFn = (api, editorView)=>{
    const scrollable = (0, $haNN4.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent') ?? null;
    const cleanupFn = [];
    if (scrollable) cleanupFn.push((0, $38vK5.autoScrollForElements)({
        element: scrollable
    }));
    let dragInitializationDuration = 0;
    cleanupFn.push((0, $iSrRp.monitorForElements)({
        canMonitor: ({ source: source })=>source.data.type === 'element',
        onDrag: ()=>{
            if ((0, $ixfCV.fg)('platform_editor_drag_and_drop_perf_analytics')) {
                if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT, (duration)=>{
                    dragInitializationDuration = duration;
                });
            } else if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT, (duration, startTime)=>{
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).BLOCKS_DRAG_INIT,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodesCount: editorView?.state.doc.nodeSize
                    }
                });
            });
        },
        onDragStart: ()=>{
            if ($ae8d0893738a17f4$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', 'unset');
        },
        onDrop: ({ location: location, source: source })=>{
            if ($ae8d0893738a17f4$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', null);
            if ((0, $ixfCV.fg)('platform_editor_drag_and_drop_perf_analytics')) (0, $hiQdW.startMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT);
            if (!api) return;
            api.core?.actions.execute(({ tr: tr })=>{
                const { multiSelectDnD: multiSelectDnD } = api.blockControls?.sharedState.currentState() || {};
                // Restore the users initial Editor selection when the drop completes
                if (multiSelectDnD) {
                    // If the TextSelection between the drag start and end has changed, the document has changed, and we should not reapply the last selection
                    const expandedSelectionUnchanged = multiSelectDnD.textAnchor === tr.selection.anchor && multiSelectDnD.textHead === tr.selection.head;
                    if (expandedSelectionUnchanged) {
                        const $anchor = tr.doc.resolve(multiSelectDnD.userAnchor);
                        const $head = tr.doc.resolve(multiSelectDnD.userHead);
                        if ($head.node() === $anchor.node()) {
                            const $from = $anchor.min($head);
                            (0, $bOZni.selectNode)(tr, $from.pos, $from.node().type.name, api);
                        } else tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, multiSelectDnD.userAnchor, multiSelectDnD.userHead));
                    }
                }
                api.selection?.commands.clearManualSelection()({
                    tr: tr
                });
                const { start: start } = source.data;
                // if no drop targets are rendered, assume that drop is invalid
                const lastDragCancelled = location.current.dropTargets.length === 0;
                if (lastDragCancelled) {
                    const position = (0, $i2jOy.getSelectedSlicePosition)(start, tr, api);
                    const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, position.from, position.to);
                    const { nodeTypes: nodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    api.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        action: (0, $krYZG.ACTION).CANCELLED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                }
                if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api.metrics?.commands.startActiveSessionTimer()({
                    tr: tr
                });
                api.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                    ...tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                    isDragging: false,
                    isPMDragging: false,
                    lastDragCancelled: lastDragCancelled
                });
            });
            if ((0, $ixfCV.fg)('platform_editor_drag_and_drop_perf_analytics')) // wait for the idle callback to ensure that the drag operation has completed
            $ae8d0893738a17f4$var$scheduleCallback(()=>{
                if ((0, $hiQdW.isMeasuring)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT)) (0, $hiQdW.stopMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DROP_INIT, (duration)=>{
                    const isCancelled = location.current.dropTargets.length === 0;
                    api?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).ENDED,
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            dragInitializationDuration: dragInitializationDuration,
                            dropProcessingDuration: duration,
                            isCancelled: isCancelled,
                            nodesCount: editorView?.state.doc.nodeSize
                        }
                    });
                });
            });
        }
    }));
    return (0, $aDtKq.combine)(...cleanupFn);
};
const $ae8d0893738a17f4$var$initialState = {
    decorations: (0, $8nvEM.DecorationSet).empty,
    activeNode: undefined,
    isDragging: false,
    isMenuOpen: false,
    editorHeight: 0,
    editorWidthLeft: 0,
    editorWidthRight: 0,
    isResizerResizing: false,
    isDocSizeLimitEnabled: null,
    isPMDragging: false,
    multiSelectDnD: undefined,
    lastDragCancelled: false,
    isSelectedViaDragHandle: false
};
const $ae8d0893738a17f4$export$968abecb43309c32 = (state)=>$ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.decorations;
const $ae8d0893738a17f4$var$getDecorationAtPos = (state, decorations, pos, to)=>{
    // Find the newly minted node decs that touch the active node
    const findNewNodeDecs = (0, $rOV4B.findNodeDecs)(state, decorations, pos - 1, to);
    // Find the specific dec that the active node corresponds to
    const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === pos);
    // If multiple decorations at the active node pos, we want the last one
    const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
    return nodeDecAtActivePos;
};
const $ae8d0893738a17f4$export$5635d7ef4b8fee1c = (api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true, anchorRectCache, resizeObserverWidth, pragmaticCleanup)=>{
    let { activeNode: activeNode, decorations: decorations, isResizerResizing: isResizerResizing, multiSelectDnD: multiSelectDnD } = currentState;
    const { editorHeight: editorHeight, editorWidthLeft: editorWidthLeft, editorWidthRight: editorWidthRight, isDragging: isDragging, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, menuTriggerByNode: menuTriggerByNode, blockMenuOptions: blockMenuOptions, isPMDragging: isPMDragging, isShiftDown: isShiftDown, lastDragCancelled: lastDragCancelled, isSelectedViaDragHandle: isSelectedViaDragHandle } = currentState;
    let isActiveNodeDeleted = false;
    const { from: from, to: to, numReplaceSteps: numReplaceSteps, isAllText: isAllText, isReplacedWithSameSize: isReplacedWithSameSize } = (0, $bOCgz.getTrMetadata)(tr, flags);
    const meta = tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
    const hasDocumentSizeBreachedThreshold = api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(newState)?.documentSizeBreachesThreshold;
    if (hasDocumentSizeBreachedThreshold) {
        /**
     * INFO: This if statement is a duplicate of the logic in destroy(). When the threshold is breached and we enter limited mode, we want to trigger the cleanup logic in destroy().
     */ const editorContentArea = (0, $haNN4.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent') ?? null;
        if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
        pragmaticCleanup?.();
        return currentState;
    }
    // When steps exist, remap existing decorations, activeNode and multi select positions
    if (tr.docChanged) {
        decorations = decorations.map(tr.mapping, tr.doc);
        // platform_editor_controls note: enables quick insert
        // don't remap activeNode if it's being dragged
        if (!flags.toolbarFlagsEnabled) {
            if (activeNode) {
                const mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
                activeNode = {
                    pos: mappedPos.pos,
                    anchorName: activeNode.anchorName,
                    nodeType: activeNode.nodeType
                };
            }
        } else if (activeNode && meta?.isDragging !== true) {
            let mappedPos;
            const browser = (0, $8dxef.getBrowserInfo)();
            // In safari, when platform_editor_controls is on,
            // sometimes the drag handle for the layout disppears after you click on the handle for a few times
            // Which caused the drag handle onClick event not firing, then block menu wouldn't be opened
            // This is caused by the mappedPos.deletedAfter sometimes returning true in webkit browsers even though the active node still exists
            // This is likely a prosemirror and safari integration bug, but to unblock the issue, we are going to use mappedPos.deleted in safari for now
            if (browser.webkit && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
                mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
            } else {
                mappedPos = tr.mapping.mapResult(activeNode.pos, -1);
                isActiveNodeDeleted = mappedPos.deletedAfter;
            }
            // for editor controls, remap the rootPos as well
            let mappedRootPos;
            if (activeNode.rootPos !== undefined) mappedRootPos = tr.mapping.mapResult(activeNode.rootPos, -1);
            activeNode = {
                pos: mappedPos.pos,
                anchorName: activeNode.anchorName,
                nodeType: activeNode.nodeType,
                rootPos: mappedRootPos?.pos ?? activeNode.rootPos,
                rootAnchorName: activeNode.rootAnchorName,
                rootNodeType: activeNode.rootNodeType
            };
        }
        if (multiSelectDnD) {
            multiSelectDnD.anchor = tr.mapping.map(multiSelectDnD.anchor);
            multiSelectDnD.head = tr.mapping.map(multiSelectDnD.head);
        }
    }
    const resizerMeta = tr.getMeta('is-resizer-resizing');
    isResizerResizing = resizerMeta ?? isResizerResizing;
    const hasJustFinishedResizing = resizerMeta === false;
    multiSelectDnD = meta?.multiSelectDnD ?? multiSelectDnD;
    if (multiSelectDnD) {
        if ((meta?.isDragging ?? isDragging) && (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // When dragging, we want to keep the multiSelectDnD object unless both document and selection
            // has changed, in which case we want to reset it.
            const shouldResetMultiSelectDnD = tr.docChanged && tr.selectionSet && tr.selection.empty;
            multiSelectDnD = shouldResetMultiSelectDnD ? undefined : multiSelectDnD;
        } else multiSelectDnD = meta?.isDragging === false || tr.selection.empty ? undefined : multiSelectDnD;
    }
    const maybeNodeCountChanged = !isAllText && numReplaceSteps > 0;
    let latestActiveNode = meta?.activeNode;
    const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
    if (!latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) latestActiveNode = activeNode;
    // Re-create node decorations
    const isDecSetEmpty = decorations === (0, $8nvEM.DecorationSet).empty;
    const isNodeDecsMissing = isDecSetEmpty || maybeNodeCountChanged || (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) && hasJustFinishedResizing;
    const shouldRedrawNodeDecs = !isResizerResizing && (isNodeDecsMissing || meta?.isDragging) && // Skip expensive anchor node decoration recalculations when native anchor support is enabled
    !(0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    let isActiveNodeModified = false;
    if (api && shouldRedrawNodeDecs) {
        const oldNodeDecs = (0, $rOV4B.findNodeDecs)(newState, decorations, from, to);
        decorations = decorations.remove(oldNodeDecs);
        const newNodeDecs = (0, $rOV4B.nodeDecorations)(newState, isDecSetEmpty ? undefined : from, isDecSetEmpty ? undefined : to);
        decorations = decorations.add(newState.doc, newNodeDecs);
        // platform_editor_controls note: enables quick insert
        if (!flags.toolbarFlagsEnabled) {
            if (latestActiveNode && !isActiveNodeDeleted) {
                // Find the newly minted node decs that touch the active node
                const findNewNodeDecs = (0, $rOV4B.findNodeDecs)(newState, decorations, latestActiveNode.pos - 1, to);
                // Find the specific dec that the active node corresponds to
                const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>dec?.from === latestActiveNode.pos);
                // If multiple decorations at the active node pos, we want the last one
                const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
                // Update the active node anchor-name and type for accurate positioning
                if (nodeDecAtActivePos) {
                    isActiveNodeModified = true;
                    latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                    latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
                }
            }
        } else if (latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) {
            const nodeDecAtActivePos = $ae8d0893738a17f4$var$getDecorationAtPos(newState, decorations, latestActiveNode.pos, to);
            const rootNodeDecAtActivePos = latestActiveNode.rootPos !== undefined ? $ae8d0893738a17f4$var$getDecorationAtPos(newState, decorations, latestActiveNode.rootPos, to) : undefined;
            if (nodeDecAtActivePos || rootNodeDecAtActivePos) isActiveNodeModified = true;
            // Update the active node anchor-name and type for accurate positioning
            if (nodeDecAtActivePos) {
                latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
            }
            if (rootNodeDecAtActivePos) {
                latestActiveNode.rootAnchorName = rootNodeDecAtActivePos.spec.anchorName;
                latestActiveNode.rootNodeType = rootNodeDecAtActivePos.spec.nodeType;
            }
        }
    }
    // Check if editor dimensions have changed
    const editorSizeChanged = meta?.editorHeight !== undefined && meta?.editorHeight !== editorHeight || meta?.editorWidthLeft !== undefined && meta?.editorWidthLeft !== editorWidthLeft || meta?.editorWidthRight !== undefined && meta?.editorWidthRight !== editorWidthRight;
    // Check if there's a new active node, and it differs from the last
    const activeNodeChanged = meta?.activeNode && (meta?.activeNode.pos !== activeNode?.pos && meta?.activeNode.anchorName !== activeNode?.anchorName || meta?.activeNode.handleOptions?.isFocused);
    const rootActiveNodeChanged = meta?.activeNode && meta?.activeNode.rootPos !== activeNode?.rootPos && meta?.activeNode.rootAnchorName !== activeNode?.rootAnchorName;
    // Some browsers don't support anchor positioning, meaning we need to replace the handle when nodes change
    const handleNeedsRedraw = shouldRedrawNodeDecs && !(0, $a4QVD.isAnchorSupported)();
    // Create/recreate handle dec when the active node is missing/changes, or the editor viewport has changed (non-anchor pos workaround)
    const shouldRecreateHandle = latestActiveNode && (activeNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    const shouldRecreateQuickInsertButton = latestActiveNode && (rootActiveNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    // If the active node is missing, we need to remove the handle
    let shouldRemoveHandle = latestActiveNode ? isResizerResizing || isActiveNodeDeleted && !isReplacedWithSameSize || meta?.nodeMoved : true;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) // Remove handle dec when editor is blurred
    shouldRemoveHandle = shouldRemoveHandle || meta?.editorBlurred;
    // In view mode with right-side controls, remove any lingering drag handle decorations
    // (they may carry over from edit mode). Only remove drag handles specifically, not
    // the remix button decorations (those are managed separately via showInViewMode).
    if (isViewMode && rightSideControlsEnabled) {
        const allHandleDecs = (0, $j28nv.findHandleDec)(decorations, 0, newState.doc.content.size);
        if (allHandleDecs.length > 0) decorations = decorations.remove(allHandleDecs);
    }
    if (shouldRemoveHandle) {
        const oldHandle = (0, $j28nv.findHandleDec)(decorations, activeNode?.pos, activeNode?.pos);
        decorations = decorations.remove(oldHandle);
        // When removing the handle, also remove the anchor-marker node decorations
        // (data-active-drag-handle / data-active-quick-insert) so the DOM attributes
        // don't linger on nodes that are no longer active.
        // Use full-range search (0..contentSize) rather than a point-range at activeNode.pos/rootPos:
        // after a doc change (e.g. pressing Enter splits a node), DecorationSet.map() can shift the
        // decoration to a different position, so a point-range search would miss it and leave a stale
        // attribute on the wrong DOM node.
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) {
            const oldActiveNodeDec = (0, $j28nv.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveNodeDec);
            const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveQuickInsertDec);
        }
        // platform_editor_controls note: enables quick insert
        if (flags.toolbarFlagsEnabled && quickInsertButtonEnabled) {
            const oldQuickInsertButton = (0, $hYw7t.findQuickInsertInsertButtonDecoration)(decorations, activeNode?.rootPos, activeNode?.rootPos);
            decorations = decorations.remove(oldQuickInsertButton);
            for (const factory of nodeDecorationRegistry){
                const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
            if (rightSideControlsEnabled && isViewMode && (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')) {
                for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                    const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                    decorations = decorations.remove(old);
                }
            }
        }
    } else if (api) {
        if (shouldRecreateHandle && (!rightSideControlsEnabled || !isViewMode)) {
            const oldHandle = (0, $j28nv.findHandleDec)(decorations, activeNode?.pos, activeNode?.pos);
            decorations = decorations.remove(oldHandle);
            const handleDec = (0, $j28nv.dragHandleDecoration)({
                api: api,
                formatMessage: formatMessage,
                pos: latestActiveNode?.pos,
                anchorName: latestActiveNode?.anchorName,
                nodeType: latestActiveNode?.nodeType,
                handleOptions: latestActiveNode?.handleOptions,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                handleDec
            ]);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && latestActiveNode) {
            // Recreate the drag handle node decoration when the active node changed,
            // its content was modified, or the document changed (e.g. Enter splits a node).
            // This runs independently of shouldRecreateHandle so that doc changes (like pressing
            // Enter) correctly refresh the decoration even when the handle widget doesn't move.
            // DecorationSet.map() can misplace the decoration after node splits/inserts.
            const needsNodeDecUpdate = activeNodeChanged || isActiveNodeModified || tr.docChanged;
            if (needsNodeDecUpdate) {
                const nodeSize = newState.doc.nodeAt(latestActiveNode.pos)?.nodeSize;
                if (nodeSize !== undefined) {
                    // Search the full doc range: after DecorationSet.map(), the decoration may have
                    // shifted away from activeNode?.pos (e.g. a node split moves it to the new paragraph).
                    const oldActiveNodeDec = (0, $j28nv.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const dragHandleDecAlreadyCorrect = oldActiveNodeDec.length === 1 && oldActiveNodeDec[0].from === latestActiveNode.pos && oldActiveNodeDec[0].to === latestActiveNode.pos + nodeSize;
                    if (!dragHandleDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveNodeDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $j28nv.createActiveDragHandleNodeDecoration)(latestActiveNode.pos, nodeSize)
                        ]);
                    }
                }
            }
            // The quick-insert decoration lives on the root node (rootPos), which can change
            // independently of the edit-mode node — e.g. when only editorSizeChanged fires but
            // rootActiveNodeChanged is also true. So we use a separate, broader guard that
            // includes rootActiveNodeChanged to avoid leaving the attribute on a stale root node.
            // tr.docChanged is included for the same reason as needsNodeDecUpdate: DecorationSet.map()
            // can misplace the decoration after a node split, so we must refresh it on every doc change.
            const needsQuickInsertDecUpdate = activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged;
            if (needsQuickInsertDecUpdate && latestActiveNode.rootPos !== undefined) {
                const rootNodeSize = newState.doc.nodeAt(latestActiveNode.rootPos)?.nodeSize;
                if (rootNodeSize !== undefined) {
                    const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const quickInsertDecAlreadyCorrect = oldActiveQuickInsertDec.length === 1 && oldActiveQuickInsertDec[0].from === latestActiveNode.rootPos && oldActiveQuickInsertDec[0].to === latestActiveNode.rootPos + rootNodeSize;
                    if (!quickInsertDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveQuickInsertDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $hYw7t.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                        ]);
                    }
                }
            }
        }
        if (shouldRecreateQuickInsertButton && latestActiveNode?.rootPos !== undefined && // platform_editor_controls note: enables quick insert
        flags.toolbarFlagsEnabled && quickInsertButtonEnabled && (!rightSideControlsEnabled || !isViewMode)) {
            const oldQuickInsertButton = (0, $hYw7t.findQuickInsertInsertButtonDecoration)(decorations, activeNode?.rootPos, activeNode?.rootPos);
            decorations = decorations.remove(oldQuickInsertButton);
            const quickInsertButton = (0, $hYw7t.quickInsertButtonDecoration)({
                api: api,
                formatMessage: formatMessage,
                anchorName: latestActiveNode?.anchorName,
                nodeType: latestActiveNode?.nodeType,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                rootPos: latestActiveNode?.rootPos,
                rootAnchorName: latestActiveNode?.rootAnchorName,
                rootNodeType: latestActiveNode?.rootNodeType,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                quickInsertButton
            ]);
            // Update quick insert node decoration when the quick insert button is recreated but
            // the drag handle was NOT recreated (shouldRecreateHandle was false). When
            // shouldRecreateHandle is true, the block above already handles this.
            // Also skip when the needsQuickInsertDecUpdate block above already handled the update
            // (i.e. activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged)
            // — running both would remove and re-add a duplicate decoration.
            if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !shouldRecreateHandle && !(activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged) && latestActiveNode?.rootPos !== undefined) {
                // Use full-range search (0..contentSize) rather than a point-range at activeNode.rootPos:
                // after a doc change, DecorationSet.map() can shift the decoration to a different position,
                // so a point-range search would miss it and leave a stale attribute on the wrong DOM node.
                const oldActiveQuickInsertDec = (0, $hYw7t.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                decorations = decorations.remove(oldActiveQuickInsertDec);
                const rootNodeSize = newState.doc.nodeAt(latestActiveNode.rootPos)?.nodeSize;
                if (rootNodeSize !== undefined) decorations = decorations.add(newState.doc, [
                    (0, $hYw7t.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                ]);
            }
            if (rightSideControlsEnabled) for (const factory of nodeDecorationRegistry){
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                const old = decorations.find(activeNode?.rootPos, activeNode?.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
                // determines whether to show the decorations, see malleableUiPlugin.tsx
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
            else for (const factory of nodeDecorationRegistry){
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
        // In view mode (edit/live pages), show right-side controls on block hover (without drag handle or quick insert)
        const rootPos = latestActiveNode?.rootPos;
        // rootPos is computed using the same logic as the floating insert menu, so it always points to a top-level (doc child) block when defined.
        const isDocLevel = rootPos !== undefined && !isNaN(rootPos);
        if (isViewMode && isDocLevel && flags.toolbarFlagsEnabled && rightSideControlsEnabled) {
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const existingAtPos = decorations.find(rootPos, rootPos, (spec)=>spec.type === factory.type);
                // Skip remove/re-add when decoration already exists at correct position - avoids
                // flickering from widget destroy/recreate on every transaction (e.g. on hover).
                if (existingAtPos.length > 0) continue;
                // Remove any stale decoration at a different position (e.g. after moving to another block)
                const stale = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(stale);
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
        } else if (isViewMode && rightSideControlsEnabled && (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')) {
            // Remove view-mode right-side decorations when no active node
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
    }
    // Drop targets may be missing when the node count is being changed during a drag
    const isDropTargetsMissing = (meta?.isDragging ?? isDragging) && maybeNodeCountChanged && !meta?.nodeMoved;
    // Remove drop target decorations when dragging stops or they need to be redrawn
    if (meta?.isDragging === false || isDropTargetsMissing) {
        const dropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
        decorations = decorations.remove(dropTargetDecs);
    }
    let currentActiveDropTargetNode = isDragging ? currentState.activeDropTargetNode : undefined;
    if (api) {
        if ((0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // If page is updated while dragging (likely by remote updates), we simply remove the drop targets
            // and add them back when the user interacts with the editor again
            if (isDropTargetsMissing) {
                const oldDropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
                decorations = decorations.remove(oldDropTargetDecs);
            }
            if (meta?.activeDropTargetNode) {
                currentActiveDropTargetNode = meta?.activeDropTargetNode;
                const oldDropTargetDecs = (0, $djgGr.findDropTargetDecs)(decorations);
                const { decsToAdd: decsToAdd, decsToRemove: decsToRemove } = (0, $g8ZIt.getActiveDropTargetDecorations)(meta.activeDropTargetNode, newState, api, oldDropTargetDecs, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
                decorations = decorations.remove(decsToRemove);
                if (decsToAdd.length > 0) decorations = decorations.add(newState.doc, decsToAdd);
            }
        } else if (meta?.isDragging || isDropTargetsMissing) {
            // Add drop targets when dragging starts or some are missing
            const decs = (0, $djgGr.dropTargetDecorations)(newState, api, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
            decorations = decorations.add(newState.doc, decs);
        }
    }
    const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(newState.doc);
    if (isEmptyDoc && !(0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
        const hasNodeDecoration = !!(0, $rOV4B.findNodeDecs)(newState, decorations).length;
        if (!hasNodeDecoration) decorations = decorations.add(newState.doc, [
            (0, $j28nv.emptyParagraphNodeDecorations)()
        ]);
    }
    let newActiveNode;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) {
        // remove isEmptyDoc check and let decorations render and determine their own visibility
        // In view mode with right-side controls we render node decorations (right-edge button), not the
        // handle - so findHandleDec is always empty. Don't clear activeNode in that case.
        const hasHandleOrViewModeControls = (0, $j28nv.findHandleDec)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length > 0 || isViewMode && rightSideControlsEnabled;
        newActiveNode = meta?.editorBlurred || !meta?.activeNode && !hasHandleOrViewModeControls ? null : latestActiveNode;
    } else newActiveNode = isEmptyDoc || !meta?.activeNode && (0, $j28nv.findHandleDec)(decorations, latestActiveNode?.pos, latestActiveNode?.pos).length === 0 ? null : latestActiveNode;
    let isMenuOpenNew = isMenuOpen;
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
        if (meta?.closeMenu) isMenuOpenNew = false;
        else if (meta?.toggleMenu) {
            const isSameAnchor = meta?.toggleMenu.anchorName === menuTriggerBy;
            isMenuOpenNew = menuTriggerBy === undefined || isSameAnchor || !isMenuOpen && !isSameAnchor ? !isMenuOpen : isMenuOpen;
        }
    } else if (meta?.toggleMenu) isMenuOpenNew = !isMenuOpen;
    let isSelectedViaDragHandleNew;
    if (flags.toolbarFlagsEnabled) isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined ? meta?.isSelectedViaDragHandle : isSelectedViaDragHandle;
    else isSelectedViaDragHandleNew = meta?.isSelectedViaDragHandle !== undefined && flags.toolbarFlagsEnabled && meta?.isSelectedViaDragHandle;
    return {
        decorations: decorations,
        activeNode: newActiveNode,
        activeDropTargetNode: currentActiveDropTargetNode,
        isDragging: meta?.isDragging ?? isDragging,
        isMenuOpen: isMenuOpenNew,
        menuTriggerBy: flags.toolbarFlagsEnabled || (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? meta?.toggleMenu?.anchorName || menuTriggerBy : undefined,
        menuTriggerByNode: (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? meta?.toggleMenu?.triggerByNode || menuTriggerByNode : undefined,
        blockMenuOptions: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? {
            canMoveUp: meta?.toggleMenu?.moveUp !== undefined ? meta?.toggleMenu?.moveUp : blockMenuOptions?.canMoveUp,
            canMoveDown: meta?.toggleMenu?.moveDown !== undefined ? meta?.toggleMenu?.moveDown : blockMenuOptions?.canMoveDown,
            openedViaKeyboard: meta?.toggleMenu?.openedViaKeyboard !== undefined ? meta?.toggleMenu?.openedViaKeyboard : blockMenuOptions?.openedViaKeyboard
        } : undefined,
        editorHeight: meta?.editorHeight ?? editorHeight,
        editorWidthLeft: meta?.editorWidthLeft ?? editorWidthLeft,
        editorWidthRight: meta?.editorWidthRight ?? editorWidthRight,
        isResizerResizing: isResizerResizing,
        isDocSizeLimitEnabled: $ae8d0893738a17f4$var$initialState.isDocSizeLimitEnabled,
        isPMDragging: meta?.isPMDragging ?? isPMDragging,
        multiSelectDnD: multiSelectDnD,
        isShiftDown: meta?.isShiftDown ?? isShiftDown,
        lastDragCancelled: meta?.lastDragCancelled ?? lastDragCancelled,
        isSelectedViaDragHandle: isSelectedViaDragHandleNew
    };
};
const $ae8d0893738a17f4$export$ae829ec7b2625219 = (api, getIntl, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true)=>{
    const { formatMessage: formatMessage } = getIntl();
    const isAdvancedLayoutEnabled = (0, $fqVYq.editorExperiment)('advanced_layouts', true, {
        exposure: true
    });
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const flags = {
        toolbarFlagsEnabled: toolbarFlagsEnabled
    };
    let anchorRectCache;
    if (!(0, $a4QVD.isAnchorSupported)()) anchorRectCache = new (0, $a4QVD.AnchorRectCache)();
    let resizeObserverWidth;
    let pragmaticCleanup = null;
    return new (0, $kpCD8.SafePlugin)({
        key: $ae8d0893738a17f4$export$df61b30b684217c0,
        state: {
            init () {
                return $ae8d0893738a17f4$var$initialState;
            },
            apply: (tr, currentState, _, newState)=>$ae8d0893738a17f4$export$5635d7ef4b8fee1c(api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled, anchorRectCache, resizeObserverWidth, pragmaticCleanup)
        },
        props: {
            decorations: (state)=>{
                if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                const isDisabled = api?.editorDisabled?.sharedState.currentState()?.editorDisabled;
                if (isDisabled) {
                    const remixRightSideEnabled = rightSideControlsEnabled && (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg');
                    // Hide decorations when disabled, except in view mode when right-side controls are enabled
                    if (!remixRightSideEnabled || api?.editorViewMode?.sharedState.currentState()?.mode !== 'view') return;
                }
                let decorationSet = $ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.decorations;
                // In view mode with right-side controls, remove any lingering drag-handle decorations
                // (created in edit mode) that may not have been cleaned up on mode switch.
                if (decorationSet && rightSideControlsEnabled && api?.editorViewMode?.sharedState.currentState()?.mode === 'view') {
                    const handleDecs = (0, $j28nv.findHandleDec)(decorationSet, 0, state.doc.content.size);
                    if (handleDecs.length > 0) decorationSet = decorationSet.remove(handleDecs);
                }
                return decorationSet;
            },
            handleDOMEvents: {
                drop (view, event) {
                    // Prevent native DnD from triggering if we are in drag
                    const { dispatch: dispatch, dragging: dragging, state: state } = view;
                    const tr = state.tr;
                    let pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(state);
                    const dndDragCancelled = pluginState?.lastDragCancelled;
                    if (pluginState?.isPMDragging || dndDragCancelled) {
                        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            isPMDragging: false,
                            lastDragCancelled: false
                        }));
                    }
                    pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(view.state);
                    if (!(event.target instanceof HTMLElement) || !pluginState?.activeNode) return false;
                    // Currently we can only drag one node at a time
                    // so we only need to check first child
                    const draggable = dragging?.slice.content.firstChild;
                    if (dndDragCancelled || draggable?.type.name === 'layoutColumn') {
                        // we prevent native DnD for layoutColumn to prevent single column layout.
                        event.preventDefault();
                        return false;
                    }
                    const nodeElement = event.target?.closest?.(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
                    if (!nodeElement) return false;
                    // TODO: ED-26959 - Review usage of posAtDOM here
                    const domPos = Math.max(view.posAtDOM(nodeElement, 0) - 1, 0);
                    const nodeTarget = state.doc.nodeAt(domPos);
                    const isSameNode = !!(nodeTarget && draggable?.eq(nodeTarget));
                    if (isSameNode) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                dragenter (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    // Only process dragenter for block control drags.
                    // Other drag types (e.g. table row) should not create
                    // drop target decorations or emit active anchors.
                    if (!$ae8d0893738a17f4$export$df61b30b684217c0.getState(view.state)?.isDragging) return;
                    if ($ae8d0893738a17f4$var$isHTMLElement(event.target) && (0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
                        const targetElement = event.target.closest('[data-prosemirror-node-name]');
                        if (targetElement) {
                            const nodeTypeName = targetElement?.getAttribute('data-prosemirror-node-name');
                            const pos = view.posAtDOM(targetElement, -1);
                            const currentActiveDropTargetNode = api?.blockControls.sharedState.currentState()?.activeDropTargetNode;
                            if (currentActiveDropTargetNode?.pos !== pos || currentActiveDropTargetNode?.nodeTypeName !== nodeTypeName) {
                                const activeDropTargetNode = {
                                    pos: pos,
                                    nodeTypeName: nodeTypeName
                                };
                                view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                                    activeDropTargetNode: activeDropTargetNode
                                }));
                            }
                        }
                    } else if (isAdvancedLayoutEnabled) {
                        if ($ae8d0893738a17f4$var$isHTMLElement(event.target)) {
                            const closestParentElement = event.target.closest('[data-drag-handler-anchor-depth="0"]');
                            if (closestParentElement) {
                                const currentAnchor = closestParentElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
                                if (currentAnchor) (0, $d1Uph.defaultActiveAnchorTracker).emit(currentAnchor);
                            }
                        }
                    }
                },
                dragstart (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    (0, $hiQdW.startMeasure)($ae8d0893738a17f4$var$EDITOR_BLOCKS_DRAG_INIT);
                    if (isAdvancedLayoutEnabled) (0, $d1Uph.defaultActiveAnchorTracker).reset();
                    if ((0, $ieeJu.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) anchorRectCache?.clear();
                    anchorRectCache?.setEditorView(view);
                    view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                        isPMDragging: true
                    }));
                },
                dragend (view) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    const { state: state, dispatch: dispatch } = view;
                    if ($ae8d0893738a17f4$export$df61b30b684217c0.getState(state)?.isPMDragging) {
                        const tr = state.tr;
                        tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            isPMDragging: false
                        });
                        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                        dispatch(tr);
                    }
                },
                mouseover: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    // another layer of protection to prevent handling mouseover
                    // when native anchor with dnd is enabled in limited mode
                    // in case there are descripancies between getNodeIdProvider limited mode state
                    if ((0, $4RpM6.getNodeIdProvider)(view)?.isLimitedMode() && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return;
                    (0, $h7MdN.handleMouseOver)(view, event, api);
                    return false;
                },
                mousedown: (view, event)=>{
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $9UAss.handleMouseDown)(api)(view, event) : undefined;
                },
                keydown (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if (event.shiftKey && event.ctrlKey) //prevent holding down key combo from firing repeatedly
                    {
                        if (!event.repeat && (0, $jdNrc.boundKeydownHandler)(api, formatMessage)(view, event)) {
                            event.preventDefault();
                            return true;
                        }
                    }
                    if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLElement && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isDragHandle = event.target.closest((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? (0, $kAPZe.DRAG_HANDLE_SELECTOR) : '[data-editor-block-ctrl-drag-handle="true"]') !== null;
                        api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle));
                    }
                    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowUp') && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isBlockMenuOpen = api?.blockControls.sharedState.currentState()?.isMenuOpen && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true);
                        // when block menu is just open, and we press arrow keys, we want to use the arrow keys to navigate the block menu
                        // in this scenario, isSelectedViaDragHandle should not be set to false
                        if (api?.blockControls.sharedState.currentState()?.isSelectedViaDragHandle && !isBlockMenuOpen) api?.core.actions.execute(api?.blockControls.commands.setSelectedViaDragHandle(false));
                    }
                    if (!event.repeat && event.shiftKey && (0, $ixfCV.fg)('platform_editor_elements_dnd_shift_click_select')) view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                        isShiftDown: true
                    }));
                    return false;
                },
                keyup (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if (!event.repeat && event.key === 'Shift') view.dispatch(view.state.tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                        isShiftDown: false
                    }));
                },
                blur (view, event) {
                    if (api?.limitedMode?.sharedState.currentState()?.enabled) return;
                    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isChildOfEditor = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest(`#${(0, $bwJyA.EDIT_AREA_ID)}`) !== null;
                        // don't do anything if the event relatedTarget (the element receiving focus) is a child of the editor
                        // or if the editor has focus
                        if (isChildOfEditor || view.hasFocus()) return false;
                        api?.core?.actions.execute(({ tr: tr })=>{
                            const currMeta = tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
                            tr.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                                ...currMeta,
                                editorBlurred: true
                            });
                            return tr;
                        });
                        return false;
                    }
                }
            }
        },
        view: (editorView)=>{
            const dom = editorView.dom;
            const editorContentArea = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
            // Use ResizeObserver to observe resizer (scroll-parent typically grows when resizing) and editor width changes
            resizeObserverWidth = new ResizeObserver((0, $LQnOI.default)((entries)=>{
                const pluginState = $ae8d0893738a17f4$export$df61b30b684217c0.getState(editorView.state);
                if (!pluginState?.isDragging) {
                    const isResizerResizing = !!dom.querySelector('.is-resizing');
                    const transaction = editorView.state.tr;
                    if (pluginState?.isResizerResizing !== isResizerResizing) transaction.setMeta('is-resizer-resizing', isResizerResizing);
                    if (!isResizerResizing) {
                        const editorContentArea = entries[0].target;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthRight = editorContentArea.getBoundingClientRect().right;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthLeft = editorContentArea.getBoundingClientRect().left;
                        transaction.setMeta($ae8d0893738a17f4$export$df61b30b684217c0, {
                            ...transaction.getMeta($ae8d0893738a17f4$export$df61b30b684217c0),
                            editorWidthLeft: editorWidthLeft,
                            editorWidthRight: editorWidthRight
                        });
                    }
                    editorView.dispatch(transaction);
                }
            }));
            const shouldObserve = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? !(0, $a4QVD.isAnchorSupported)() : true;
            if (editorContentArea && shouldObserve) resizeObserverWidth.observe(editorContentArea);
            // Start pragmatic monitors
            pragmaticCleanup = $ae8d0893738a17f4$var$destroyFn(api, editorView);
            return {
                destroy () {
                    if (editorContentArea) resizeObserverWidth.unobserve(editorContentArea);
                    pragmaticCleanup?.();
                }
            };
        }
    });
};
const $ae8d0893738a17f4$export$e75bc9902db1596f = (tr)=>{
    return tr.getMeta($ae8d0893738a17f4$export$df61b30b684217c0);
};
module.exports["key"] = $ae8d0893738a17f4$export$df61b30b684217c0;
module.exports["getDecorations"] = $ae8d0893738a17f4$export$968abecb43309c32;
module.exports["createPlugin"] = $ae8d0893738a17f4$export$ae829ec7b2625219;
module.exports["getBlockControlsMeta"] = $ae8d0893738a17f4$export$e75bc9902db1596f;

});

parcelRegister("gxKDp", function(module, exports) {

var $hade9 = parcelRequire("hade9");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");


var $bI2nS = parcelRequire("bI2nS");

const $ddec03442dd66a9a$export$b5524c7a5a82630a = {
    url: {
        title: (0, $bI2nS.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9)))
    },
    inline: {
        title: (0, $bI2nS.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu)))
    },
    block: {
        title: (0, $bI2nS.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4)))
    },
    embed: {
        title: (0, $bI2nS.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F)))
    }
};
module.exports["appearancePropsMap"] = $ddec03442dd66a9a$export$b5524c7a5a82630a;

});

parcelRegister("cbp6v", function(module, exports) {

var $kcs7l = parcelRequire("kcs7l");

const $28eb8ceae9a9c979$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $kcs7l.pluginKey), action);
};
const $28eb8ceae9a9c979$export$2b7045d36e3e01d4 = (url)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $28eb8ceae9a9c979$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $28eb8ceae9a9c979$export$af5afab36c1f83f6 = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $28eb8ceae9a9c979$export$3301f76e6efaf85e = (info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $28eb8ceae9a9c979$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $28eb8ceae9a9c979$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $28eb8ceae9a9c979$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f = (url, attributes)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_RESOLVED_TOOLBAR_ATTRIBUTES',
            url: url,
            attributes: attributes
        });
const $28eb8ceae9a9c979$export$c9a25858ed46807c = (layout)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $28eb8ceae9a9c979$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $28eb8ceae9a9c979$export$83c364d103479f90 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$bd1cd60a9b31da5e = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $28eb8ceae9a9c979$export$2c79f54b873d04be = (modalType)=>(tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $28eb8ceae9a9c979$export$e545bc176b552938 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $28eb8ceae9a9c979$export$a2922c2e95ff48f7 = (tr)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $28eb8ceae9a9c979$export$53e36aa41bbce673 = (tr, datasourceStash)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $28eb8ceae9a9c979$export$4b1fde77584594b5 = (tr, url)=>$28eb8ceae9a9c979$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });
module.exports["resolveCard"] = $28eb8ceae9a9c979$export$2b7045d36e3e01d4;
module.exports["queueCards"] = $28eb8ceae9a9c979$export$5312e3a17c3f6d3;
module.exports["registerCard"] = $28eb8ceae9a9c979$export$af5afab36c1f83f6;
module.exports["removeCard"] = $28eb8ceae9a9c979$export$3301f76e6efaf85e;
module.exports["registerRemoveOverlay"] = $28eb8ceae9a9c979$export$a3d5a5cb818ce9d9;
module.exports["registerSmartCardEvents"] = $28eb8ceae9a9c979$export$55288255874724a1;
module.exports["setProvider"] = $28eb8ceae9a9c979$export$1572b3eade6662f9;
module.exports["setDatasourceTableRef"] = $28eb8ceae9a9c979$export$f9c5be16586d220a;
module.exports["setResolvedToolbarAttributes"] = $28eb8ceae9a9c979$export$63a1bdeb24c4dd9f;
module.exports["setCardLayout"] = $28eb8ceae9a9c979$export$c9a25858ed46807c;
module.exports["setCardLayoutAndDatasourceTableRef"] = $28eb8ceae9a9c979$export$dd3435a1df9b2a3f;
module.exports["showLinkToolbar"] = $28eb8ceae9a9c979$export$83c364d103479f90;
module.exports["hideLinkToolbar"] = $28eb8ceae9a9c979$export$bd1cd60a9b31da5e;
module.exports["showDatasourceModal"] = $28eb8ceae9a9c979$export$2c79f54b873d04be;
module.exports["hideDatasourceModal"] = $28eb8ceae9a9c979$export$e545bc176b552938;
module.exports["clearOverlayCandidate"] = $28eb8ceae9a9c979$export$a2922c2e95ff48f7;
module.exports["setDatasourceStash"] = $28eb8ceae9a9c979$export$53e36aa41bbce673;
module.exports["removeDatasourceStash"] = $28eb8ceae9a9c979$export$4b1fde77584594b5;

});

parcelRegister("4eqn3", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $k92Y1 = parcelRequire("k92Y1");


var $ao034 = parcelRequire("ao034");

var $2WEO5 = parcelRequire("2WEO5");

var $b1qV0 = parcelRequire("b1qV0");


var $kcs7l = parcelRequire("kcs7l");

const $50d9c959a343ad0a$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $50d9c959a343ad0a$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $kCECX.NodeSelection)) return $50d9c959a343ad0a$export$71376de76fa352d1(state.selection.node.type);
};
const $50d9c959a343ad0a$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $50d9c959a343ad0a$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $50d9c959a343ad0a$export$a6fcef6250c64f76 = (node, info)=>$50d9c959a343ad0a$export$fe497395c317d106($50d9c959a343ad0a$export$15bc29504ff06986(node), info);
const $50d9c959a343ad0a$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $kcs7l.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $50d9c959a343ad0a$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $50d9c959a343ad0a$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$50d9c959a343ad0a$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $50d9c959a343ad0a$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $k92Y1.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $50d9c959a343ad0a$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $ao034.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $2WEO5.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $50d9c959a343ad0a$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $50d9c959a343ad0a$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $50d9c959a343ad0a$export$48ba7bd006cffb5e(node.attrs);
};
const $50d9c959a343ad0a$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $50d9c959a343ad0a$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $50d9c959a343ad0a$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $50d9c959a343ad0a$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $kCECX.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};
module.exports["appearanceForNodeType"] = $50d9c959a343ad0a$export$71376de76fa352d1;
module.exports["selectedCardAppearance"] = $50d9c959a343ad0a$export$a5ff7aecd33e6813;
module.exports["titleUrlPairFromNode"] = $50d9c959a343ad0a$export$15bc29504ff06986;
module.exports["displayInfoForCard"] = $50d9c959a343ad0a$export$a6fcef6250c64f76;
module.exports["findCardInfo"] = $50d9c959a343ad0a$export$f3f2332ef0853029;
module.exports["isEmbedSupportedAtPosition"] = $50d9c959a343ad0a$export$b31d21baab1bb9f;
module.exports["isBlockSupportedAtPosition"] = $50d9c959a343ad0a$export$290208dc31723a19;
module.exports["getResolvedAttributesFromStore"] = $50d9c959a343ad0a$export$a0e5429851d8d8a9;
module.exports["isDatasourceConfigEditable"] = $50d9c959a343ad0a$export$c677d64dd26b7aa2;
module.exports["isDatasourceNode"] = $50d9c959a343ad0a$export$962cfe99b8da8614;
module.exports["focusEditorView"] = $50d9c959a343ad0a$export$bab6ff782a349bd3;
module.exports["getAwarenessProps"] = $50d9c959a343ad0a$export$ea8b03e32bcc0b2d;

});

parcelRegister("brpLB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9p0BY = parcelRequire("9p0BY");


var $krYZG = parcelRequire("krYZG");

var $eaCAt = parcelRequire("eaCAt");


var $jU5kz = parcelRequire("jU5kz");

var $gjTdl = parcelRequire("gjTdl");


var $9bUBT = parcelRequire("9bUBT");


var $83k8i = parcelRequire("83k8i");

var $bI2nS = parcelRequire("bI2nS");

var $2xhuI = parcelRequire("2xhuI");

var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");


var $jWZvv = parcelRequire("jWZvv");

var $l3s1y = parcelRequire("l3s1y");


var $g6uqx = parcelRequire("g6uqx");


var $k3XQC = parcelRequire("k3XQC");


var $6Ixg8 = parcelRequire("6Ixg8");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $eDtFr = parcelRequire("eDtFr");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8y86q = parcelRequire("8y86q");


var $V3JOP = parcelRequire("V3JOP");


var $11OF7 = parcelRequire("11OF7");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $6JWmx = parcelRequire("6JWmx");


var $kcs7l = parcelRequire("kcs7l");


var $4eqn3 = parcelRequire("4eqn3");


var $3o30f = parcelRequire("3o30f");


var $KRqQR = parcelRequire("KRqQR");


var $b161W = parcelRequire("b161W");


var $7IbuD = parcelRequire("7IbuD");


var $bSOGe = parcelRequire("bSOGe");


var $iPc0t = parcelRequire("iPc0t");


var $38tfT = parcelRequire("38tfT");


var $lwOI6 = parcelRequire("lwOI6");


var $1zg27 = parcelRequire("1zg27");


var $dkZll = parcelRequire("dkZll");

const $cc2f82b3700a9ffb$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $gjTdl.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $krYZG.ACTION).DELETED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $bjg0G.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $krYZG.ACTION).DELETED
    });
const $cc2f82b3700a9ffb$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod, resolvedAttributes)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod, resolvedAttributes))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics = (editorAnalyticsApi, inputMethod, resolvedAttributes = {})=>(state, dispatch)=>{
        const linkAnalyticsRecorded = $cc2f82b3700a9ffb$export$7ee76be08aa43a42(editorAnalyticsApi, inputMethod, resolvedAttributes)(state, dispatch);
        if (!linkAnalyticsRecorded) return false;
        editorAnalyticsApi?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).OPEN_LINK,
            attributes: {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
        return true;
    };
const $cc2f82b3700a9ffb$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $cc2f82b3700a9ffb$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $kcs7l.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $4eqn3.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $jWZvv.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $bI2nS.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $l3s1y.richMediaClassName)}`);
                    if (!(0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $cc2f82b3700a9ffb$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $KRqQR.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled, linkPickerOptions)
        };
    };
};
const $cc2f82b3700a9ffb$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $4eqn3.displayInfoForCard)(node, (0, $4eqn3.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $gjTdl.commandWithMetadata)((0, $6JWmx.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $krYZG.ACTION).UNLINK
    });
    return ()=>false;
};
const $cc2f82b3700a9ffb$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $jU5kz.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $jU5kz.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $cc2f82b3700a9ffb$var$withToolbarMetadata = (command)=>(0, $gjTdl.commandWithMetadata)(command, {
        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
    });
const $cc2f82b3700a9ffb$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkZll.ToolbarViewedEvent), {
                    key: "edit.link.menu.viewed",
                    url: url,
                    display: display,
                    editorView: editorView
                })
        }
    ];
};
const $cc2f82b3700a9ffb$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $4eqn3.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $9p0BY.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $4eqn3.displayInfoForCard)(node, (0, $4eqn3.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
        const currentAppearance = (0, $4eqn3.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $4eqn3.isDatasourceNode)(node);
        const pluginState = (0, $kcs7l.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $k3XQC.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $KRqQR.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $cc2f82b3700a9ffb$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b161W.EditToolbarButton), {
                            key: "edit-toolbar-item",
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $KRqQR.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $KRqQR.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                    title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                    showTitle: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $6Ixg8.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b161W.EditToolbarButton), {
                            key: "edit-toolbar-item",
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $KRqQR.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $KRqQR.getEditLinkCallback)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
                exposure: true
            }) ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1zg27.OpenPreviewPanelToolbarButton), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ] : [];
            const resolvedToolbarAttributes = url ? pluginState?.resolvedToolbarAttributesByUrl[url] ?? {} : {};
            const openLinkToolbarItemFallback = {
                id: 'editor.link.openLink',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                metadata: metadata,
                className: 'hyperlink-open-link',
                title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                href: url,
                target: '_blank'
            };
            const openLinkToolbarItem = (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
                type: 'custom',
                fallback: [
                    openLinkToolbarItemFallback
                ],
                render: (editorView)=>editorView && url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwOI6.OpenLinkToolbarButton), {
                        url: url,
                        title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                        editorView: editorView,
                        onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }) : null
            } : openLinkToolbarItemFallback;
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                {
                    type: 'separator'
                },
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $2xhuI.default).remove),
                    onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$cc2f82b3700a9ffb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $cc2f82b3700a9ffb$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPc0t.LinkToolbarAppearance), {
                            key: "link-appearance",
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        })
                } : (0, $38tfT.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o30f.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                                    pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                                    label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $7Y8M5.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $2xhuI.default).delete),
                                onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                                    label: intl.formatMessage((0, $2xhuI.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $cc2f82b3700a9ffb$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8y86q))),
            onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $cc2f82b3700a9ffb$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($11OF7))),
        title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).settingsLink),
        onClick: $cc2f82b3700a9ffb$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $9bUBT.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $cc2f82b3700a9ffb$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    toolbarItems.push(...$cc2f82b3700a9ffb$var$getToolbarViewedItem(node?.attrs?.url, currentAppearance ?? 'url'));
    const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPc0t.LinkToolbarAppearance), {
                    key: "link-appearance",
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                });
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o30f.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $38tfT.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $krYZG.INPUT_METHOD).FLOATING_TB;
    const pluginState = (0, $kcs7l.pluginKey).getState(state);
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b161W.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                key: "edit-toolbar-item",
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $KRqQR.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            })
    });
    if (node?.attrs?.url) {
        const openLinkToolbarItemFallback = {
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
            onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
            href: node.attrs.url,
            target: '_blank'
        };
        toolbarItems.push((0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
            type: 'custom',
            fallback: [
                openLinkToolbarItemFallback
            ],
            render: (editorView)=>editorView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lwOI6.OpenLinkToolbarButton), {
                    url: node.attrs.url,
                    title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
                    editorView: editorView,
                    onClick: $cc2f82b3700a9ffb$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, pluginState?.resolvedToolbarAttributesByUrl[node.attrs.url] ?? {}),
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }) : null
        } : openLinkToolbarItemFallback);
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $2xhuI.default).remove),
        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $cc2f82b3700a9ffb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $2xhuI.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                            pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $7Y8M5.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                            label: intl.formatMessage((0, $2xhuI.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $2xhuI.default).delete),
                        onClick: $cc2f82b3700a9ffb$var$withToolbarMetadata($cc2f82b3700a9ffb$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                            label: intl.formatMessage((0, $2xhuI.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $cc2f82b3700a9ffb$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $cc2f82b3700a9ffb$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b161W.EditToolbarButton), {
                        key: "edit-toolbar-button",
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    });
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
                showTitle: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            const hyperlinkAppearance = [
                (0, $bSOGe.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkZll.ToolbarViewedEvent), {
                            key: "edit.link.menu.viewed",
                            url: link,
                            display: "url",
                            editorView: editorView
                        })
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkZll.ToolbarViewedEvent), {
                        key: "edit.link.menu.viewed",
                        url: link,
                        display: "url",
                        editorView: editorView
                    })
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7IbuD.HyperlinkToolbarAppearance), {
                        key: "link-appearance",
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    });
                }
            },
            ...editLinkItem
        ];
    };
};
const $cc2f82b3700a9ffb$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) return [
            {
                type: 'separator'
            },
            $cc2f82b3700a9ffb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };
module.exports["visitCardLinkAnalytics"] = $cc2f82b3700a9ffb$export$7ee76be08aa43a42;
module.exports["floatingToolbar"] = $cc2f82b3700a9ffb$export$4850df084251d287;
module.exports["shouldRenderToolbarPulse"] = $cc2f82b3700a9ffb$export$ddeab6943680f5be;
module.exports["getStartingToolbarItems"] = $cc2f82b3700a9ffb$export$bb790f15a666b7f0;
module.exports["getEndingToolbarItems"] = $cc2f82b3700a9ffb$export$d5ca70670b9f6b9;

});

parcelRegister("6JWmx", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $9p0BY = parcelRequire("9p0BY");


var $krYZG = parcelRequire("krYZG");

var $gjFO5 = parcelRequire("gjFO5");

var $eaCAt = parcelRequire("eaCAt");


var $2HZqG = parcelRequire("2HZqG");


var $9bUBT = parcelRequire("9bUBT");


var $fRYCB = parcelRequire("fRYCB");

var $4wRTw = parcelRequire("4wRTw");

var $6SJ6d = parcelRequire("6SJ6d");

var $5Qi6J = parcelRequire("5Qi6J");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $di3bZ = parcelRequire("di3bZ");


var $fqVYq = parcelRequire("fqVYq");


var $cbp6v = parcelRequire("cbp6v");


var $kcs7l = parcelRequire("kcs7l");


var $1pvv7 = parcelRequire("1pvv7");


var $4eqn3 = parcelRequire("4eqn3");

/**
 * Attempt to replace the link into the respective card.
 */ function $ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $9p0BY.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $1pvv7.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $ff2860869594b73b$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>(editorState, dispatch)=>{
        const state = (0, $kcs7l.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        let cardAdf = null;
        // If an embed card transformer is provided and the resolved card is an embedCard,
        // attempt to transform it into an alternative node representation first.
        if (cardData.type === 'embedCard' && embedCardNodeTransformer && (0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) {
            const transformResult = embedCardNodeTransformer(schema, cardData.attrs);
            // The transformer may return a Promise for async transformations (e.g. short-link expansion).
            // When async, we snapshot the current requests and positions now (before any dispatch),
            // then insert the resolved node and clean up the queue in one transaction once the
            // Promise settles. This avoids the stale-editorState problem: rather than re-running
            // replaceQueuedUrlWithCard with an outdated state snapshot, we capture what we need
            // immediately and apply a targeted insert when ready.
            if (transformResult instanceof Promise) {
                // Snapshot requests now, while the queue still contains this URL.
                const pendingRequests = [
                    ...requests
                ];
                transformResult.then((resolvedNode)=>{
                    if (!dispatch) return;
                    // Build a fresh transaction (editorState is the snapshot at call-time; positions
                    // are mapped through it). For the async case we fall back to cardData if the
                    // transform returned nothing, mirroring what the sync path would do.
                    const asyncCardAdf = resolvedNode ? resolvedNode : (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
                    const asyncTr = editorState.tr;
                    if (asyncCardAdf) pendingRequests.forEach((request)=>$ff2860869594b73b$var$replaceLinksToCards(asyncTr, asyncCardAdf, schema, request));
                    dispatch((0, $cbp6v.resolveCard)(url)((0, $di3bZ.closeHistory)(asyncTr)));
                });
                return true;
            }
            cardAdf = transformResult ?? null;
        }
        if (!cardAdf) cardAdf = (0, $5Qi6J.processRawValue)(schema, cardData) ?? null;
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$ff2860869594b73b$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $4wRTw.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $2HZqG.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $cbp6v.resolveCard)(url)((0, $di3bZ.closeHistory)(tr)));
        return true;
    };
const $ff2860869594b73b$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $kcs7l.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $krYZG.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $4wRTw.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $cbp6v.resolveCard)(request.url)(tr));
        return true;
    };
/**
 * Per-node walker shared by `queueCardsFromChangedTr` and
 * `queueCardsFromRange`. Pushes a smart-link resolution request for every
 * text node carrying a qualifying `link` mark.
 *
 * Returning `true`/`false` follows the ProseMirror `nodesBetween`/
 * `nodesBetweenChanged` walker contract: `true` to descend into children,
 * `false` to skip subtree.
 */ const $ff2860869594b73b$var$collectLinkRequest = (requests, node, pos, options)=>{
    if (!node.isText) return true;
    const linkMark = node.marks.find((mark)=>mark.type === options.linkMarkType);
    if (linkMark) {
        if (!(0, $1pvv7.shouldReplaceLink)(node, options.normalizeLinkText)) return false;
        requests.push({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: options.appearance,
            compareLinkText: options.normalizeLinkText,
            source: options.source,
            analyticsAction: options.analyticsAction,
            sourceEvent: options.sourceEvent
        });
    }
    return false;
};
const $ff2860869594b73b$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $cbp6v.queueCards)(requests)(tr);
};
const $ff2860869594b73b$export$86b4b08ffadfa0a6 = (state, tr, from, to, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    const clampedFrom = Math.max(0, from);
    const clampedTo = Math.min(tr.doc.content.size, to);
    if (clampedFrom < clampedTo) tr.doc.nodesBetween(clampedFrom, clampedTo, (node, pos)=>$ff2860869594b73b$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $cbp6v.queueCards)(requests)(tr);
};
const $ff2860869594b73b$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $6SJ6d.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $1pvv7.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $cbp6v.queueCards)(requests)(tr);
};
const $ff2860869594b73b$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $krYZG.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $9bUBT.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $2HZqG.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $krYZG.ACTION).CHANGED_TYPE
    });
    return (0, $cbp6v.queueCards)(requests)(state.tr);
};
const $ff2860869594b73b$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $gjFO5.SMART_LINK_TYPE).URL,
                    previousType: (0, $4eqn3.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos !== undefined) tr = $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $ff2860869594b73b$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $4eqn3.selectedCardAppearance)(state);
        const tr = $ff2860869594b73b$var$cardToLinkWithTransaction(state, href, href);
        $ff2860869594b73b$export$717aabd99c4fc685(state, tr, (0, $krYZG.INPUT_METHOD).MANUAL, (0, $krYZG.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $ff2860869594b73b$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $ff2860869594b73b$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $ff2860869594b73b$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                action: (0, $krYZG.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.unlinkPayload)((0, $krYZG.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $ff2860869594b73b$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $ff2860869594b73b$export$c8301558911030d4(state, (0, $krYZG.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
                    action: (0, $krYZG.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $4eqn3.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? $ff2860869594b73b$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock') : $ff2860869594b73b$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $ff2860869594b73b$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        // If switching to embed appearance, attempt to use a registered transform command
        // to create an alternative node representation (e.g. a native embed).
        if (appearance === 'embed' && (selectedNode.attrs.url || selectedNode.attrs.data?.url)) {
            const cardState = (0, $kcs7l.pluginKey).getState(state);
            const createEmbedCardTransformCommand = cardState?.embedCardTransformers?.createEmbedCardTransformCommand;
            if (createEmbedCardTransformCommand) {
                const transformCommand = createEmbedCardTransformCommand({
                    editorAnalyticsApi: editorAnalyticsApi,
                    augmentTransaction: (augmentTr)=>{
                        $ff2860869594b73b$var$updateDatasourceStash(augmentTr, selectedNode);
                        editorAnalyticsApi?.attachAnalyticsEvent({
                            action: (0, $krYZG.ACTION).CHANGED_TYPE,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                newType: appearance,
                                previousType: (0, $4eqn3.appearanceForNodeType)(selectedNode.type)
                            }
                        })(augmentTr);
                        (0, $2HZqG.addLinkMetadata)(state.selection, augmentTr, {
                            action: (0, $krYZG.ACTION).CHANGED_TYPE
                        });
                    }
                });
                if (transformCommand(state, dispatch)) return true;
            }
        }
        $ff2860869594b73b$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).CHANGED_TYPE,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $4eqn3.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
            action: (0, $krYZG.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $ff2860869594b73b$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $ff2860869594b73b$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $cbp6v.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $cbp6v.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $cbp6v.hideDatasourceModal)(tr);
    (0, $2HZqG.addLinkMetadata)(state.selection, tr, {
        action: (0, $krYZG.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $ff2860869594b73b$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $4eqn3.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $ff2860869594b73b$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $4eqn3.isDatasourceNode)(selectedNode) && !(0, $4eqn3.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $cbp6v.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};
module.exports["replaceQueuedUrlWithCard"] = $ff2860869594b73b$export$78f5a0da64579d3e;
module.exports["handleFallbackWithAnalytics"] = $ff2860869594b73b$export$2bb01cc4a12e0b44;
module.exports["queueCardsFromChangedTr"] = $ff2860869594b73b$export$f17c48478174211e;
module.exports["queueCardsFromRange"] = $ff2860869594b73b$export$86b4b08ffadfa0a6;
module.exports["changeSelectedCardToLink"] = $ff2860869594b73b$export$3f14f692ecc2a0d9;
module.exports["changeSelectedCardToLinkFallback"] = $ff2860869594b73b$export$56a04318a610dc7c;
module.exports["updateCard"] = $ff2860869594b73b$export$884fcee347ca969b;
module.exports["changeSelectedCardToText"] = $ff2860869594b73b$export$23c9e012c8c1ce24;
module.exports["setSelectedCardAppearance"] = $ff2860869594b73b$export$a188ef61ddbb94f;
module.exports["updateCardViaDatasource"] = $ff2860869594b73b$export$113cdaf1b279f308;
module.exports["insertDatasource"] = $ff2860869594b73b$export$7f7b236478a618df;

});

parcelRegister("8AEvG", function(module, exports) {

var $kcs7l = parcelRequire("kcs7l");

const $82719199149a05f4$export$f05434c51e3762e = (editorState)=>(0, $kcs7l.pluginKey).getState(editorState);
const $82719199149a05f4$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            })),
        resolvedInlineSmartLinks: pluginState.resolvedInlineSmartLinks?.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $82719199149a05f4$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$82719199149a05f4$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $82719199149a05f4$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;
module.exports["getPluginState"] = $82719199149a05f4$export$f05434c51e3762e;
module.exports["getPluginStateWithUpdatedPos"] = $82719199149a05f4$export$be237c815d2927d4;
module.exports["getNewRequests"] = $82719199149a05f4$export$cd9326e2f6dc42c0;

});

parcelRegister("9PpVE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $83d2b8785968bed7$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $cMyWi.useSmartCardContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(cardContext));
};
module.exports["WithCardContext"] = $83d2b8785968bed7$export$722ea04dd4ef208e;

});

parcelRegister("f21H2", function(module, exports) {

var $1G3WB = parcelRequire("1G3WB");


var $2Q7sv = parcelRequire("2Q7sv");


var $9H66G = parcelRequire("9H66G");


var $dz9dk = parcelRequire("dz9dk");

/**
 * Returns the resolved destination URL for a Smart Link, with cross-product analytics
 * parameters appended when the `platform_smartlink_xpc_url_wrapping` feature gate is enabled.
 *
 * This is the same URL that SmartCard would navigate to when clicked. Use this as an `href`
 * wherever you render a link to a Smart Link URL outside of the SmartCard component itself
 * (e.g. toolbar buttons, overlays).
 *
 * Falls back to the raw `url` when:
 * - The link has not yet resolved
 * - The feature gate is disabled
 * - The link is not a first-party Atlassian link
 *
 * @example
 * const href = useSmartLinkDestinationUrl(url);
 *
 * Use as <a href={href} target="_blank">Open link</a>
 */ const $4f8ab10692e6efbc$var$useDestinationUrlImplementation = (url)=>{
    const state = (0, $9H66G.useSmartCardState)(url);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const resolvedUrl = (0, $2Q7sv.getClickUrl)(url, state.details);
    return appendCrossProductAnalyticsParams(resolvedUrl);
};
const $4f8ab10692e6efbc$export$863256c4c19e0538 = (0, $1G3WB.functionWithFG)('platform_smartlink_xpc_url_wrapping', $4f8ab10692e6efbc$var$useDestinationUrlImplementation, (url)=>url);
module.exports["useDestinationUrl"] = $4f8ab10692e6efbc$export$863256c4c19e0538;

});

parcelRegister("kcs7l", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $ab0973bc4ada0879$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('cardPlugin');
module.exports["pluginKey"] = $ab0973bc4ada0879$export$18d4026d1ea86bb1;

});

parcelRegister("eHuhD", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");

const $215d271c3bef94e8$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $215d271c3bef94e8$export$4521957a9ae858f5 = 'discovered';
const $215d271c3bef94e8$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $215d271c3bef94e8$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $215d271c3bef94e8$export$2cf27d95188f1c13 = 86400000;
const $215d271c3bef94e8$var$storageClient = new (0, $6YrB3.default)($215d271c3bef94e8$export$c0fd7e3ed450d078);
const $215d271c3bef94e8$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $215d271c3bef94e8$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $215d271c3bef94e8$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $215d271c3bef94e8$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $215d271c3bef94e8$var$storageClient.setItemWithExpiry(key, $215d271c3bef94e8$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK"] = $215d271c3bef94e8$export$613f4cbb1d6327d6;
module.exports["LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR"] = $215d271c3bef94e8$export$b1ab83c904a5352e;
module.exports["ONE_DAY_IN_MILLISECONDS"] = $215d271c3bef94e8$export$2cf27d95188f1c13;
module.exports["isLocalStorageKeyDiscovered"] = $215d271c3bef94e8$export$f029a1bf9ca298da;
module.exports["markLocalStorageKeyDiscovered"] = $215d271c3bef94e8$export$6b9d1ae5ec92c88e;

});

parcelRegister("7vzxX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iEnX6 = parcelRequire("iEnX6");


var $eHuhD = parcelRequire("eHuhD");

const $61088fb587c1a22d$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $eHuhD.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $cozmU.useCallback)(()=>{
        if (!discovered) (0, $eHuhD.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iEnX6.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline
    }, children);
};
module.exports["DiscoveryPulse"] = $61088fb587c1a22d$export$1f5748a1623673d7;

});

parcelRegister("jWZvv", function(module, exports) {
const $64861730f5bb867e$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $64861730f5bb867e$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
module.exports["DATASOURCE_INNER_CONTAINER_CLASSNAME"] = $64861730f5bb867e$export$32f80df830e375f6;
module.exports["FLOATING_TOOLBAR_LINKPICKER_CLASSNAME"] = $64861730f5bb867e$export$863ae87a9d233606;

});

parcelRegister("dil4b", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $cozmU = parcelRequire("cozmU");


var $9p0BY = parcelRequire("9p0BY");


var $fbHl6 = parcelRequire("fbHl6");


var $6JWmx = parcelRequire("6JWmx");

class $2a1fa379fa79b714$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $9p0BY.isSafeUrl)(url)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error
            }, (0, $6JWmx.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch));
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UnsupportedComponent, null) : null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fbHl6.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error
                }, unsupportedComponent);
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            isError: false,
            error: null
        };
    }
}
module.exports["DatasourceErrorBoundary"] = $2a1fa379fa79b714$export$76664c71b9b1a689;

});

parcelRegister("byDyt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $6pnwK = parcelRequire("6pnwK");


var $8AEvG = parcelRequire("8AEvG");

const $82bb9aba23fa33e9$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $8AEvG.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: analyticsData
    }, children);
};
module.exports["EditorAnalyticsContext"] = $82bb9aba23fa33e9$export$b49e513cc101a4b6;

});

parcelRegister("cEgRX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");


var $cMyWi = parcelRequire("cMyWi");

function $59ddef7452a84f28$export$d59258481d10b16b({ smartCardContext: smartCardContext, children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl || !smartCardContext) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
        value: intl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        value: smartCardContext
    }, children));
}
module.exports["SmartCardSSRReactContextsProvider"] = $59ddef7452a84f28$export$d59258481d10b16b;

});

parcelRegister("gjNeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9p0BY = parcelRequire("9p0BY");


var $gBjHb = parcelRequire("gBjHb");


var $3k5Tv = parcelRequire("3k5Tv");


var $6pnwK = parcelRequire("6pnwK");


var $i1t43 = parcelRequire("i1t43");


var $6JWmx = parcelRequire("6JWmx");


var $8AEvG = parcelRequire("8AEvG");


var $4eqn3 = parcelRequire("4eqn3");


var $9PpVE = parcelRequire("9PpVE");

const $537b6f07c48b0136$var$fatalErrorPositionMap = new Map();
const $537b6f07c48b0136$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        return {
            mode: states.editorViewModeState?.mode
        };
    });
    const onClick = (0, $cozmU.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        onClick: allowNavigation ? undefined : onClick
    }));
};
function $537b6f07c48b0136$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $4eqn3.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $9p0BY.isSafeUrl)(url)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UnsupportedComponent, null);
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: url,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (e)=>{
                        e.preventDefault();
                    }
                }, url);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UnsupportedComponent, null);
            }
            const editorAppearance = (0, $8AEvG.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $6pnwK.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($537b6f07c48b0136$var$WithClickHandler, {
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                url: url
            }, ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PpVE.WithCardContext), null, (cardContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SmartCardComponent, {
                        key: url,
                        cardContext: cardContext,
                        ...this.props,
                        onClick: onClick
                    }))));
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $4eqn3.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $537b6f07c48b0136$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $6JWmx.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                if (url && pos) $537b6f07c48b0136$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                isError: false
            };
        }
    };
}
module.exports["Card"] = $537b6f07c48b0136$export$60332b2344f7fe41;

});

parcelRegister("89gPK", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $5ad357f2123c826c$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
module.exports["calcColumnsFromPx"] = $5ad357f2123c826c$export$10912f14d8d54640;

});

parcelRegister("yNGEI", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $809138f2c808c2d9$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
}
module.exports["calcPxFromPct"] = $809138f2c808c2d9$export$e70e278a1f662f8d;

});

parcelRegister("jdAIP", function(module, exports) {
var $b2f681feca808083$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var $b2f681feca808083$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b2f681feca808083$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
var $b2f681feca808083$export$2e2bcd8739ae039 = $b2f681feca808083$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $a33e97cd12c23639$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $a33e97cd12c23639$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a33e97cd12c23639$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a33e97cd12c23639$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $a33e97cd12c23639$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a33e97cd12c23639$export$2e2bcd8739ae039 = $a33e97cd12c23639$var$formatLong;


var $e0c19184a1b1e296$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $e0c19184a1b1e296$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e0c19184a1b1e296$var$formatRelativeLocale[token];
};
var $e0c19184a1b1e296$export$2e2bcd8739ae039 = $e0c19184a1b1e296$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $451d43700c5ee845$var$eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $451d43700c5ee845$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var $451d43700c5ee845$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $451d43700c5ee845$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var $451d43700c5ee845$var$dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var $451d43700c5ee845$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var $451d43700c5ee845$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var $451d43700c5ee845$var$localize = {
    ordinalNumber: $451d43700c5ee845$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $451d43700c5ee845$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $451d43700c5ee845$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $451d43700c5ee845$export$2e2bcd8739ae039 = $451d43700c5ee845$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $26278ca5bf5af828$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $26278ca5bf5af828$var$parseOrdinalNumberPattern = /\d+/i;
var $26278ca5bf5af828$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $26278ca5bf5af828$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $26278ca5bf5af828$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $26278ca5bf5af828$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $26278ca5bf5af828$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $26278ca5bf5af828$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $26278ca5bf5af828$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $26278ca5bf5af828$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $26278ca5bf5af828$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $26278ca5bf5af828$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $26278ca5bf5af828$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $26278ca5bf5af828$var$matchOrdinalNumberPattern,
        parsePattern: $26278ca5bf5af828$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26278ca5bf5af828$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $26278ca5bf5af828$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $26278ca5bf5af828$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $26278ca5bf5af828$export$2e2bcd8739ae039 = $26278ca5bf5af828$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $dfdbb7723bf7ba0f$var$locale = {
    code: 'af',
    formatDistance: (0, $b2f681feca808083$export$2e2bcd8739ae039),
    formatLong: (0, $a33e97cd12c23639$export$2e2bcd8739ae039),
    formatRelative: (0, $e0c19184a1b1e296$export$2e2bcd8739ae039),
    localize: (0, $451d43700c5ee845$export$2e2bcd8739ae039),
    match: (0, $26278ca5bf5af828$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $dfdbb7723bf7ba0f$export$2e2bcd8739ae039 = $dfdbb7723bf7ba0f$var$locale;
module.exports["default"] = $dfdbb7723bf7ba0f$export$2e2bcd8739ae039;

});

parcelRegister("lTSBl", function(module, exports) {
var $dd58201294ace246$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var $dd58201294ace246$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $dd58201294ace246$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $dd58201294ace246$export$2e2bcd8739ae039 = $dd58201294ace246$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f67db57f817b58a2$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $f67db57f817b58a2$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f67db57f817b58a2$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f67db57f817b58a2$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f67db57f817b58a2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f67db57f817b58a2$export$2e2bcd8739ae039 = $f67db57f817b58a2$var$formatLong;


var $0159922a1f261318$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $0159922a1f261318$var$formatRelative = function formatRelative(token) {
    return $0159922a1f261318$var$formatRelativeLocale[token];
};
var $0159922a1f261318$export$2e2bcd8739ae039 = $0159922a1f261318$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $cd78d92f6f693dd7$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $cd78d92f6f693dd7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $cd78d92f6f693dd7$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $cd78d92f6f693dd7$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $cd78d92f6f693dd7$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $cd78d92f6f693dd7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $cd78d92f6f693dd7$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $cd78d92f6f693dd7$var$localize = {
    ordinalNumber: $cd78d92f6f693dd7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cd78d92f6f693dd7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cd78d92f6f693dd7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cd78d92f6f693dd7$export$2e2bcd8739ae039 = $cd78d92f6f693dd7$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $fa1411ccf3e27b3c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fa1411ccf3e27b3c$var$parseOrdinalNumberPattern = /\d+/i;
var $fa1411ccf3e27b3c$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $fa1411ccf3e27b3c$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $fa1411ccf3e27b3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $fa1411ccf3e27b3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fa1411ccf3e27b3c$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $fa1411ccf3e27b3c$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $fa1411ccf3e27b3c$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $fa1411ccf3e27b3c$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $fa1411ccf3e27b3c$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $fa1411ccf3e27b3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $fa1411ccf3e27b3c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fa1411ccf3e27b3c$var$matchOrdinalNumberPattern,
        parsePattern: $fa1411ccf3e27b3c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa1411ccf3e27b3c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fa1411ccf3e27b3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fa1411ccf3e27b3c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fa1411ccf3e27b3c$export$2e2bcd8739ae039 = $fa1411ccf3e27b3c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $ff1916bb766f416a$var$locale = {
    code: 'ar',
    formatDistance: (0, $dd58201294ace246$export$2e2bcd8739ae039),
    formatLong: (0, $f67db57f817b58a2$export$2e2bcd8739ae039),
    formatRelative: (0, $0159922a1f261318$export$2e2bcd8739ae039),
    localize: (0, $cd78d92f6f693dd7$export$2e2bcd8739ae039),
    match: (0, $fa1411ccf3e27b3c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $ff1916bb766f416a$export$2e2bcd8739ae039 = $ff1916bb766f416a$var$locale;
module.exports["default"] = $ff1916bb766f416a$export$2e2bcd8739ae039;

});

parcelRegister("b7b2O", function(module, exports) {
var $96bcf62034ace16f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $96bcf62034ace16f$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $96bcf62034ace16f$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $96bcf62034ace16f$export$2e2bcd8739ae039 = $96bcf62034ace16f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f248cca0cfb5e781$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $f248cca0cfb5e781$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f248cca0cfb5e781$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f248cca0cfb5e781$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f248cca0cfb5e781$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f248cca0cfb5e781$export$2e2bcd8739ae039 = $f248cca0cfb5e781$var$formatLong;


var $79643fe3feaa5518$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $79643fe3feaa5518$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $79643fe3feaa5518$var$formatRelativeLocale[token];
};
var $79643fe3feaa5518$export$2e2bcd8739ae039 = $79643fe3feaa5518$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $d9f580f3b1da0e18$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $d9f580f3b1da0e18$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $d9f580f3b1da0e18$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $d9f580f3b1da0e18$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $d9f580f3b1da0e18$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $d9f580f3b1da0e18$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $d9f580f3b1da0e18$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $d9f580f3b1da0e18$var$localize = {
    ordinalNumber: $d9f580f3b1da0e18$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d9f580f3b1da0e18$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d9f580f3b1da0e18$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d9f580f3b1da0e18$export$2e2bcd8739ae039 = $d9f580f3b1da0e18$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $fa10b19db80b2e40$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fa10b19db80b2e40$var$parseOrdinalNumberPattern = /\d+/i;
var $fa10b19db80b2e40$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $fa10b19db80b2e40$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $fa10b19db80b2e40$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $fa10b19db80b2e40$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fa10b19db80b2e40$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $fa10b19db80b2e40$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $fa10b19db80b2e40$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $fa10b19db80b2e40$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $fa10b19db80b2e40$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $fa10b19db80b2e40$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $fa10b19db80b2e40$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fa10b19db80b2e40$var$matchOrdinalNumberPattern,
        parsePattern: $fa10b19db80b2e40$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa10b19db80b2e40$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fa10b19db80b2e40$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fa10b19db80b2e40$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fa10b19db80b2e40$export$2e2bcd8739ae039 = $fa10b19db80b2e40$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $8178ea531aca906f$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $96bcf62034ace16f$export$2e2bcd8739ae039),
    formatLong: (0, $f248cca0cfb5e781$export$2e2bcd8739ae039),
    formatRelative: (0, $79643fe3feaa5518$export$2e2bcd8739ae039),
    localize: (0, $d9f580f3b1da0e18$export$2e2bcd8739ae039),
    match: (0, $fa10b19db80b2e40$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8178ea531aca906f$export$2e2bcd8739ae039 = $8178ea531aca906f$var$locale;
module.exports["default"] = $8178ea531aca906f$export$2e2bcd8739ae039;

});

parcelRegister("aAFll", function(module, exports) {
var $bf93c12030db218f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var $bf93c12030db218f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bf93c12030db218f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
var $bf93c12030db218f$export$2e2bcd8739ae039 = $bf93c12030db218f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e93788a4172ac6df$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var $e93788a4172ac6df$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e93788a4172ac6df$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e93788a4172ac6df$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e93788a4172ac6df$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e93788a4172ac6df$export$2e2bcd8739ae039 = $e93788a4172ac6df$var$formatLong;


var $59bb8255866cfac9$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $59bb8255866cfac9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $59bb8255866cfac9$var$formatRelativeLocale[token];
};
var $59bb8255866cfac9$export$2e2bcd8739ae039 = $59bb8255866cfac9$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b9687b6ae6b3581b$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $b9687b6ae6b3581b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $b9687b6ae6b3581b$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $b9687b6ae6b3581b$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $b9687b6ae6b3581b$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $b9687b6ae6b3581b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9687b6ae6b3581b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $b9687b6ae6b3581b$var$localize = {
    ordinalNumber: $b9687b6ae6b3581b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b9687b6ae6b3581b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b9687b6ae6b3581b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b9687b6ae6b3581b$export$2e2bcd8739ae039 = $b9687b6ae6b3581b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $57a88cc7890775c8$var$matchOrdinalNumberPattern = /^(\d+)/;
var $57a88cc7890775c8$var$parseOrdinalNumberPattern = /\d+/i;
var $57a88cc7890775c8$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $57a88cc7890775c8$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $57a88cc7890775c8$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $57a88cc7890775c8$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $57a88cc7890775c8$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $57a88cc7890775c8$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $57a88cc7890775c8$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $57a88cc7890775c8$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $57a88cc7890775c8$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $57a88cc7890775c8$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $57a88cc7890775c8$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $57a88cc7890775c8$var$matchOrdinalNumberPattern,
        parsePattern: $57a88cc7890775c8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $57a88cc7890775c8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $57a88cc7890775c8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $57a88cc7890775c8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $57a88cc7890775c8$export$2e2bcd8739ae039 = $57a88cc7890775c8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $7b5d56198139aafc$var$locale = {
    code: 'ar-EG',
    formatDistance: (0, $bf93c12030db218f$export$2e2bcd8739ae039),
    formatLong: (0, $e93788a4172ac6df$export$2e2bcd8739ae039),
    formatRelative: (0, $59bb8255866cfac9$export$2e2bcd8739ae039),
    localize: (0, $b9687b6ae6b3581b$export$2e2bcd8739ae039),
    match: (0, $57a88cc7890775c8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7b5d56198139aafc$export$2e2bcd8739ae039 = $7b5d56198139aafc$var$locale;
module.exports["default"] = $7b5d56198139aafc$export$2e2bcd8739ae039;

});

parcelRegister("aDiMe", function(module, exports) {
var $f5b4cf25016bd32b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $f5b4cf25016bd32b$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $f5b4cf25016bd32b$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $f5b4cf25016bd32b$export$2e2bcd8739ae039 = $f5b4cf25016bd32b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $0e807c7d13f46a35$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $0e807c7d13f46a35$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $0e807c7d13f46a35$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0e807c7d13f46a35$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0e807c7d13f46a35$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0e807c7d13f46a35$export$2e2bcd8739ae039 = $0e807c7d13f46a35$var$formatLong;


var $8f47874a1b864904$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $8f47874a1b864904$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8f47874a1b864904$var$formatRelativeLocale[token];
};
var $8f47874a1b864904$export$2e2bcd8739ae039 = $8f47874a1b864904$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $24335f6b72b9bbaa$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $24335f6b72b9bbaa$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $24335f6b72b9bbaa$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var $24335f6b72b9bbaa$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $24335f6b72b9bbaa$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $24335f6b72b9bbaa$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $24335f6b72b9bbaa$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $24335f6b72b9bbaa$var$localize = {
    ordinalNumber: $24335f6b72b9bbaa$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $24335f6b72b9bbaa$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $24335f6b72b9bbaa$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $24335f6b72b9bbaa$export$2e2bcd8739ae039 = $24335f6b72b9bbaa$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $6a06ea1f8e837431$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6a06ea1f8e837431$var$parseOrdinalNumberPattern = /\d+/i;
var $6a06ea1f8e837431$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $6a06ea1f8e837431$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $6a06ea1f8e837431$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $6a06ea1f8e837431$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6a06ea1f8e837431$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $6a06ea1f8e837431$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $6a06ea1f8e837431$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $6a06ea1f8e837431$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $6a06ea1f8e837431$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6a06ea1f8e837431$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6a06ea1f8e837431$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6a06ea1f8e837431$var$matchOrdinalNumberPattern,
        parsePattern: $6a06ea1f8e837431$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a06ea1f8e837431$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6a06ea1f8e837431$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6a06ea1f8e837431$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6a06ea1f8e837431$export$2e2bcd8739ae039 = $6a06ea1f8e837431$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $7bdc1c959e26eae3$var$locale = {
    code: 'ar-MA',
    formatDistance: (0, $f5b4cf25016bd32b$export$2e2bcd8739ae039),
    formatLong: (0, $0e807c7d13f46a35$export$2e2bcd8739ae039),
    formatRelative: (0, $8f47874a1b864904$export$2e2bcd8739ae039),
    localize: (0, $24335f6b72b9bbaa$export$2e2bcd8739ae039),
    match: (0, $6a06ea1f8e837431$export$2e2bcd8739ae039),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $7bdc1c959e26eae3$export$2e2bcd8739ae039 = $7bdc1c959e26eae3$var$locale;
module.exports["default"] = $7bdc1c959e26eae3$export$2e2bcd8739ae039;

});

parcelRegister("cSVQD", function(module, exports) {
var $0f295f83b79d9846$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $0f295f83b79d9846$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0f295f83b79d9846$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $0f295f83b79d9846$export$2e2bcd8739ae039 = $0f295f83b79d9846$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $01852b7175515125$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $01852b7175515125$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $01852b7175515125$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $01852b7175515125$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $01852b7175515125$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $01852b7175515125$export$2e2bcd8739ae039 = $01852b7175515125$var$formatLong;


var $fa2ddb3d63960783$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $fa2ddb3d63960783$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fa2ddb3d63960783$var$formatRelativeLocale[token];
};
var $fa2ddb3d63960783$export$2e2bcd8739ae039 = $fa2ddb3d63960783$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a0ce5da94bce0308$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $a0ce5da94bce0308$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $a0ce5da94bce0308$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $a0ce5da94bce0308$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $a0ce5da94bce0308$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $a0ce5da94bce0308$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $a0ce5da94bce0308$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $a0ce5da94bce0308$var$localize = {
    ordinalNumber: $a0ce5da94bce0308$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a0ce5da94bce0308$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a0ce5da94bce0308$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a0ce5da94bce0308$export$2e2bcd8739ae039 = $a0ce5da94bce0308$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5d376a22169806a1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $5d376a22169806a1$var$parseOrdinalNumberPattern = /\d+/i;
var $5d376a22169806a1$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $5d376a22169806a1$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $5d376a22169806a1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $5d376a22169806a1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5d376a22169806a1$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $5d376a22169806a1$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $5d376a22169806a1$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $5d376a22169806a1$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $5d376a22169806a1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $5d376a22169806a1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $5d376a22169806a1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5d376a22169806a1$var$matchOrdinalNumberPattern,
        parsePattern: $5d376a22169806a1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5d376a22169806a1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5d376a22169806a1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5d376a22169806a1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5d376a22169806a1$export$2e2bcd8739ae039 = $5d376a22169806a1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $961766977fd63b1b$var$locale = {
    code: 'ar-SA',
    formatDistance: (0, $0f295f83b79d9846$export$2e2bcd8739ae039),
    formatLong: (0, $01852b7175515125$export$2e2bcd8739ae039),
    formatRelative: (0, $fa2ddb3d63960783$export$2e2bcd8739ae039),
    localize: (0, $a0ce5da94bce0308$export$2e2bcd8739ae039),
    match: (0, $5d376a22169806a1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $961766977fd63b1b$export$2e2bcd8739ae039 = $961766977fd63b1b$var$locale;
module.exports["default"] = $961766977fd63b1b$export$2e2bcd8739ae039;

});

parcelRegister("c4IgH", function(module, exports) {
var $08ef092b5db007a9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var $08ef092b5db007a9$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $08ef092b5db007a9$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
var $08ef092b5db007a9$export$2e2bcd8739ae039 = $08ef092b5db007a9$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e63ae226639e18cb$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $e63ae226639e18cb$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e63ae226639e18cb$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e63ae226639e18cb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e63ae226639e18cb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e63ae226639e18cb$export$2e2bcd8739ae039 = $e63ae226639e18cb$var$formatLong;


var $c648f06e22d2f537$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var $c648f06e22d2f537$var$formatRelative = function formatRelative(token) {
    return $c648f06e22d2f537$var$formatRelativeLocale[token];
};
var $c648f06e22d2f537$export$2e2bcd8739ae039 = $c648f06e22d2f537$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b9926ebd06f12423$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $b9926ebd06f12423$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $b9926ebd06f12423$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $b9926ebd06f12423$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $b9926ebd06f12423$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9926ebd06f12423$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $b9926ebd06f12423$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $b9926ebd06f12423$var$localize = {
    ordinalNumber: $b9926ebd06f12423$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b9926ebd06f12423$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b9926ebd06f12423$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b9926ebd06f12423$export$2e2bcd8739ae039 = $b9926ebd06f12423$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $bb68f5fe977246c0$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $bb68f5fe977246c0$var$parseOrdinalNumberPattern = /\d+/i;
var $bb68f5fe977246c0$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $bb68f5fe977246c0$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $bb68f5fe977246c0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $bb68f5fe977246c0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bb68f5fe977246c0$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $bb68f5fe977246c0$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $bb68f5fe977246c0$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $bb68f5fe977246c0$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $bb68f5fe977246c0$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $bb68f5fe977246c0$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $bb68f5fe977246c0$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $bb68f5fe977246c0$var$matchOrdinalNumberPattern,
        parsePattern: $bb68f5fe977246c0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $bb68f5fe977246c0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $bb68f5fe977246c0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $bb68f5fe977246c0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $bb68f5fe977246c0$export$2e2bcd8739ae039 = $bb68f5fe977246c0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $0244c70221cbb5ce$var$locale = {
    code: 'ar-TN',
    formatDistance: (0, $08ef092b5db007a9$export$2e2bcd8739ae039),
    formatLong: (0, $e63ae226639e18cb$export$2e2bcd8739ae039),
    formatRelative: (0, $c648f06e22d2f537$export$2e2bcd8739ae039),
    localize: (0, $b9926ebd06f12423$export$2e2bcd8739ae039),
    match: (0, $bb68f5fe977246c0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0244c70221cbb5ce$export$2e2bcd8739ae039 = $0244c70221cbb5ce$var$locale;
module.exports["default"] = $0244c70221cbb5ce$export$2e2bcd8739ae039;

});

parcelRegister("f9xPZ", function(module, exports) {
var $318b0e24ced65955$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var $318b0e24ced65955$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $318b0e24ced65955$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
var $318b0e24ced65955$export$2e2bcd8739ae039 = $318b0e24ced65955$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $91d2297f88c8a881$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var $91d2297f88c8a881$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $91d2297f88c8a881$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $91d2297f88c8a881$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $91d2297f88c8a881$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $91d2297f88c8a881$export$2e2bcd8739ae039 = $91d2297f88c8a881$var$formatLong;


var $6f0e50755c493b9d$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var $6f0e50755c493b9d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6f0e50755c493b9d$var$formatRelativeLocale[token];
};
var $6f0e50755c493b9d$export$2e2bcd8739ae039 = $6f0e50755c493b9d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $2fcb04ac4942286d$var$eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var $2fcb04ac4942286d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $2fcb04ac4942286d$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $2fcb04ac4942286d$var$dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var $2fcb04ac4942286d$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $2fcb04ac4942286d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $2fcb04ac4942286d$var$suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var $2fcb04ac4942286d$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($2fcb04ac4942286d$var$suffixes[a]) return $2fcb04ac4942286d$var$suffixes[a];
    else if ($2fcb04ac4942286d$var$suffixes[b]) return $2fcb04ac4942286d$var$suffixes[b];
    else if (c !== null) return $2fcb04ac4942286d$var$suffixes[c];
    return '';
};
var $2fcb04ac4942286d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $2fcb04ac4942286d$var$getSuffix(number);
    return number + suffix;
};
var $2fcb04ac4942286d$var$localize = {
    ordinalNumber: $2fcb04ac4942286d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $2fcb04ac4942286d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $2fcb04ac4942286d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2fcb04ac4942286d$export$2e2bcd8739ae039 = $2fcb04ac4942286d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $99da96f1160612a6$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $99da96f1160612a6$var$parseOrdinalNumberPattern = /\d+/i;
var $99da96f1160612a6$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $99da96f1160612a6$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $99da96f1160612a6$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $99da96f1160612a6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $99da96f1160612a6$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $99da96f1160612a6$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $99da96f1160612a6$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $99da96f1160612a6$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $99da96f1160612a6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $99da96f1160612a6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $99da96f1160612a6$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $99da96f1160612a6$var$matchOrdinalNumberPattern,
        parsePattern: $99da96f1160612a6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99da96f1160612a6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $99da96f1160612a6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $99da96f1160612a6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $99da96f1160612a6$export$2e2bcd8739ae039 = $99da96f1160612a6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $b081f1b224bd63bf$var$locale = {
    code: 'az',
    formatDistance: (0, $318b0e24ced65955$export$2e2bcd8739ae039),
    formatLong: (0, $91d2297f88c8a881$export$2e2bcd8739ae039),
    formatRelative: (0, $6f0e50755c493b9d$export$2e2bcd8739ae039),
    localize: (0, $2fcb04ac4942286d$export$2e2bcd8739ae039),
    match: (0, $99da96f1160612a6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $b081f1b224bd63bf$export$2e2bcd8739ae039 = $b081f1b224bd63bf$var$locale;
module.exports["default"] = $b081f1b224bd63bf$export$2e2bcd8739ae039;

});

parcelRegister("jmsQ6", function(module, exports) {
function $a3da41d9a584d47f$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $a3da41d9a584d47f$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $a3da41d9a584d47f$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $a3da41d9a584d47f$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $a3da41d9a584d47f$var$declension(scheme.past, count);
                else return $a3da41d9a584d47f$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $a3da41d9a584d47f$var$declension(scheme.regular, count);
    };
}
var $a3da41d9a584d47f$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $a3da41d9a584d47f$var$formatDistanceLocale = {
    lessThanXSeconds: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $a3da41d9a584d47f$var$halfAMinute,
    lessThanXMinutes: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $a3da41d9a584d47f$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $a3da41d9a584d47f$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $a3da41d9a584d47f$var$formatDistanceLocale[token](count, options);
};
var $a3da41d9a584d47f$export$2e2bcd8739ae039 = $a3da41d9a584d47f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $d3ea639f741d83a8$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $d3ea639f741d83a8$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $d3ea639f741d83a8$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $d3ea639f741d83a8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d3ea639f741d83a8$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $d3ea639f741d83a8$export$2e2bcd8739ae039 = $d3ea639f741d83a8$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $38e85d028b9a6b34$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $38e85d028b9a6b34$var$lastWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $38e85d028b9a6b34$var$thisWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $38e85d028b9a6b34$var$nextWeek(day) {
    var weekday = $38e85d028b9a6b34$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $38e85d028b9a6b34$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $38e85d028b9a6b34$var$thisWeek(day);
    else return $38e85d028b9a6b34$var$lastWeek(day);
};
var $38e85d028b9a6b34$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $38e85d028b9a6b34$var$thisWeek(day);
    else return $38e85d028b9a6b34$var$nextWeek(day);
};
var $38e85d028b9a6b34$var$formatRelativeLocale = {
    lastWeek: $38e85d028b9a6b34$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $38e85d028b9a6b34$var$nextWeekFormat,
    other: 'P'
};
var $38e85d028b9a6b34$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $38e85d028b9a6b34$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $38e85d028b9a6b34$export$2e2bcd8739ae039 = $38e85d028b9a6b34$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $1d4adbebaa32311b$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $1d4adbebaa32311b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $1d4adbebaa32311b$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $1d4adbebaa32311b$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $1d4adbebaa32311b$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $1d4adbebaa32311b$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $1d4adbebaa32311b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $1d4adbebaa32311b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $1d4adbebaa32311b$var$localize = {
    ordinalNumber: $1d4adbebaa32311b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $1d4adbebaa32311b$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1d4adbebaa32311b$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $1d4adbebaa32311b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1d4adbebaa32311b$export$2e2bcd8739ae039 = $1d4adbebaa32311b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b0c34d8f35d5e56e$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $b0c34d8f35d5e56e$var$parseOrdinalNumberPattern = /\d+/i;
var $b0c34d8f35d5e56e$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $b0c34d8f35d5e56e$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $b0c34d8f35d5e56e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $b0c34d8f35d5e56e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b0c34d8f35d5e56e$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $b0c34d8f35d5e56e$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $b0c34d8f35d5e56e$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $b0c34d8f35d5e56e$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $b0c34d8f35d5e56e$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $b0c34d8f35d5e56e$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $b0c34d8f35d5e56e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b0c34d8f35d5e56e$var$matchOrdinalNumberPattern,
        parsePattern: $b0c34d8f35d5e56e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b0c34d8f35d5e56e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0c34d8f35d5e56e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b0c34d8f35d5e56e$export$2e2bcd8739ae039 = $b0c34d8f35d5e56e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $e186714dab88b5a6$var$locale = {
    code: 'be',
    formatDistance: (0, $a3da41d9a584d47f$export$2e2bcd8739ae039),
    formatLong: (0, $d3ea639f741d83a8$export$2e2bcd8739ae039),
    formatRelative: (0, $38e85d028b9a6b34$export$2e2bcd8739ae039),
    localize: (0, $1d4adbebaa32311b$export$2e2bcd8739ae039),
    match: (0, $b0c34d8f35d5e56e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e186714dab88b5a6$export$2e2bcd8739ae039 = $e186714dab88b5a6$var$locale;
module.exports["default"] = $e186714dab88b5a6$export$2e2bcd8739ae039;

});

parcelRegister("jhqet", function(module, exports) {
function $11a20ed43c993415$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $11a20ed43c993415$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $11a20ed43c993415$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $11a20ed43c993415$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $11a20ed43c993415$var$declension(scheme.past, count);
                else return $11a20ed43c993415$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $11a20ed43c993415$var$declension(scheme.regular, count);
    };
}
var $11a20ed43c993415$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $11a20ed43c993415$var$formatDistanceLocale = {
    lessThanXSeconds: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $11a20ed43c993415$var$halfAMinute,
    lessThanXMinutes: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $11a20ed43c993415$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $11a20ed43c993415$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $11a20ed43c993415$var$formatDistanceLocale[token](count, options);
};
var $11a20ed43c993415$export$2e2bcd8739ae039 = $11a20ed43c993415$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $147a7f3db432cf11$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $147a7f3db432cf11$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $147a7f3db432cf11$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $147a7f3db432cf11$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $147a7f3db432cf11$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $147a7f3db432cf11$export$2e2bcd8739ae039 = $147a7f3db432cf11$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $85392500641cecfb$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $85392500641cecfb$var$lastWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $85392500641cecfb$var$thisWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $85392500641cecfb$var$nextWeek(day) {
    var weekday = $85392500641cecfb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $85392500641cecfb$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $85392500641cecfb$var$thisWeek(day);
    else return $85392500641cecfb$var$lastWeek(day);
};
var $85392500641cecfb$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $85392500641cecfb$var$thisWeek(day);
    else return $85392500641cecfb$var$nextWeek(day);
};
var $85392500641cecfb$var$formatRelativeLocale = {
    lastWeek: $85392500641cecfb$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $85392500641cecfb$var$nextWeekFormat,
    other: 'P'
};
var $85392500641cecfb$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $85392500641cecfb$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $85392500641cecfb$export$2e2bcd8739ae039 = $85392500641cecfb$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $004f37759f8aeb0e$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $004f37759f8aeb0e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $004f37759f8aeb0e$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $004f37759f8aeb0e$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $004f37759f8aeb0e$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $004f37759f8aeb0e$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $004f37759f8aeb0e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $004f37759f8aeb0e$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $004f37759f8aeb0e$var$localize = {
    ordinalNumber: $004f37759f8aeb0e$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $004f37759f8aeb0e$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $004f37759f8aeb0e$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $004f37759f8aeb0e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $004f37759f8aeb0e$export$2e2bcd8739ae039 = $004f37759f8aeb0e$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $547c4f758a666784$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $547c4f758a666784$var$parseOrdinalNumberPattern = /\d+/i;
var $547c4f758a666784$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $547c4f758a666784$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $547c4f758a666784$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $547c4f758a666784$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $547c4f758a666784$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $547c4f758a666784$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $547c4f758a666784$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $547c4f758a666784$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $547c4f758a666784$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $547c4f758a666784$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $547c4f758a666784$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $547c4f758a666784$var$matchOrdinalNumberPattern,
        parsePattern: $547c4f758a666784$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $547c4f758a666784$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $547c4f758a666784$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $547c4f758a666784$export$2e2bcd8739ae039 = $547c4f758a666784$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $e093f41305dfbce7$var$locale = {
    code: 'be-tarask',
    formatDistance: (0, $11a20ed43c993415$export$2e2bcd8739ae039),
    formatLong: (0, $147a7f3db432cf11$export$2e2bcd8739ae039),
    formatRelative: (0, $85392500641cecfb$export$2e2bcd8739ae039),
    localize: (0, $004f37759f8aeb0e$export$2e2bcd8739ae039),
    match: (0, $547c4f758a666784$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e093f41305dfbce7$export$2e2bcd8739ae039 = $e093f41305dfbce7$var$locale;
module.exports["default"] = $e093f41305dfbce7$export$2e2bcd8739ae039;

});

parcelRegister("gCI9G", function(module, exports) {
var $0d0bb21158d046c2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $0d0bb21158d046c2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0d0bb21158d046c2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
var $0d0bb21158d046c2$export$2e2bcd8739ae039 = $0d0bb21158d046c2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $09f10a7e3f806b5a$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $09f10a7e3f806b5a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $09f10a7e3f806b5a$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $09f10a7e3f806b5a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $09f10a7e3f806b5a$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $09f10a7e3f806b5a$export$2e2bcd8739ae039 = $09f10a7e3f806b5a$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

// Adapted from the `ru` translation
var $82cd260365851412$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $82cd260365851412$var$lastWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $82cd260365851412$var$thisWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $82cd260365851412$var$nextWeek(day) {
    var weekday = $82cd260365851412$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var $82cd260365851412$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $82cd260365851412$var$thisWeek(day);
    else return $82cd260365851412$var$lastWeek(day);
};
var $82cd260365851412$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $82cd260365851412$var$thisWeek(day);
    else return $82cd260365851412$var$nextWeek(day);
};
var $82cd260365851412$var$formatRelativeLocale = {
    lastWeek: $82cd260365851412$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $82cd260365851412$var$nextWeekFormatToken,
    other: 'P'
};
var $82cd260365851412$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $82cd260365851412$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $82cd260365851412$export$2e2bcd8739ae039 = $82cd260365851412$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $350b305b65b802b8$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $350b305b65b802b8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var $350b305b65b802b8$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $350b305b65b802b8$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var $350b305b65b802b8$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $350b305b65b802b8$var$isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function $350b305b65b802b8$var$isNeuter(unit) {
    return unit === 'quarter';
}
function $350b305b65b802b8$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $350b305b65b802b8$var$isNeuter(unit) ? neuter : $350b305b65b802b8$var$isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var $350b305b65b802b8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $350b305b65b802b8$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $350b305b65b802b8$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var $350b305b65b802b8$var$localize = {
    ordinalNumber: $350b305b65b802b8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $350b305b65b802b8$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $350b305b65b802b8$export$2e2bcd8739ae039 = $350b305b65b802b8$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $486b8cbaa152beed$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $486b8cbaa152beed$var$parseOrdinalNumberPattern = /\d+/i;
var $486b8cbaa152beed$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $486b8cbaa152beed$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $486b8cbaa152beed$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $486b8cbaa152beed$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $486b8cbaa152beed$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $486b8cbaa152beed$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $486b8cbaa152beed$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $486b8cbaa152beed$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $486b8cbaa152beed$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $486b8cbaa152beed$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $486b8cbaa152beed$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $486b8cbaa152beed$var$matchOrdinalNumberPattern,
        parsePattern: $486b8cbaa152beed$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $486b8cbaa152beed$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $486b8cbaa152beed$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $486b8cbaa152beed$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $486b8cbaa152beed$export$2e2bcd8739ae039 = $486b8cbaa152beed$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $c1a27242d2d22a09$var$locale = {
    code: 'bg',
    formatDistance: (0, $0d0bb21158d046c2$export$2e2bcd8739ae039),
    formatLong: (0, $09f10a7e3f806b5a$export$2e2bcd8739ae039),
    formatRelative: (0, $82cd260365851412$export$2e2bcd8739ae039),
    localize: (0, $350b305b65b802b8$export$2e2bcd8739ae039),
    match: (0, $486b8cbaa152beed$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c1a27242d2d22a09$export$2e2bcd8739ae039 = $c1a27242d2d22a09$var$locale;
module.exports["default"] = $c1a27242d2d22a09$export$2e2bcd8739ae039;

});

parcelRegister("gbABh", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $0e7126715f6352ff$var$numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var $0e7126715f6352ff$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var $0e7126715f6352ff$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var $0e7126715f6352ff$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var $0e7126715f6352ff$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var $0e7126715f6352ff$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var $0e7126715f6352ff$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $0e7126715f6352ff$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var $0e7126715f6352ff$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $0e7126715f6352ff$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return $0e7126715f6352ff$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function $0e7126715f6352ff$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $0e7126715f6352ff$var$numberValues.locale[match];
    });
}
var $0e7126715f6352ff$var$localize = {
    ordinalNumber: $0e7126715f6352ff$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $0e7126715f6352ff$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0e7126715f6352ff$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0e7126715f6352ff$export$2e2bcd8739ae039 = $0e7126715f6352ff$var$localize;


var $6361aa5f13e18b9f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var $6361aa5f13e18b9f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6361aa5f13e18b9f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $0e7126715f6352ff$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
var $6361aa5f13e18b9f$export$2e2bcd8739ae039 = $6361aa5f13e18b9f$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8b273ede8f784770$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $8b273ede8f784770$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $8b273ede8f784770$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8b273ede8f784770$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8b273ede8f784770$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8b273ede8f784770$export$2e2bcd8739ae039 = $8b273ede8f784770$var$formatLong;


var $479f3bd97d1a907b$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var $479f3bd97d1a907b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $479f3bd97d1a907b$var$formatRelativeLocale[token];
};
var $479f3bd97d1a907b$export$2e2bcd8739ae039 = $479f3bd97d1a907b$var$formatRelative;




var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0f6d35625cff6b71$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $0f6d35625cff6b71$var$parseOrdinalNumberPattern = /\d+/i;
var $0f6d35625cff6b71$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $0f6d35625cff6b71$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $0f6d35625cff6b71$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $0f6d35625cff6b71$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $0f6d35625cff6b71$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $0f6d35625cff6b71$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $0f6d35625cff6b71$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $0f6d35625cff6b71$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $0f6d35625cff6b71$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $0f6d35625cff6b71$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $0f6d35625cff6b71$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0f6d35625cff6b71$var$matchOrdinalNumberPattern,
        parsePattern: $0f6d35625cff6b71$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0f6d35625cff6b71$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f6d35625cff6b71$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0f6d35625cff6b71$export$2e2bcd8739ae039 = $0f6d35625cff6b71$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $bc8a1076b9cb0699$var$locale = {
    code: 'bn',
    formatDistance: (0, $6361aa5f13e18b9f$export$2e2bcd8739ae039),
    formatLong: (0, $8b273ede8f784770$export$2e2bcd8739ae039),
    formatRelative: (0, $479f3bd97d1a907b$export$2e2bcd8739ae039),
    localize: (0, $0e7126715f6352ff$export$2e2bcd8739ae039),
    match: (0, $0f6d35625cff6b71$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bc8a1076b9cb0699$export$2e2bcd8739ae039 = $bc8a1076b9cb0699$var$locale;
module.exports["default"] = $bc8a1076b9cb0699$export$2e2bcd8739ae039;

});

parcelRegister("gBLDk", function(module, exports) {
var $b2d1c943dd63d596$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $b2d1c943dd63d596$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b2d1c943dd63d596$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $b2d1c943dd63d596$export$2e2bcd8739ae039 = $b2d1c943dd63d596$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $7ae381bf48f63a46$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $7ae381bf48f63a46$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7ae381bf48f63a46$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7ae381bf48f63a46$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7ae381bf48f63a46$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7ae381bf48f63a46$export$2e2bcd8739ae039 = $7ae381bf48f63a46$var$formatLong;


var $30874e90035a67c1$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $30874e90035a67c1$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $30874e90035a67c1$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $30874e90035a67c1$export$2e2bcd8739ae039 = $30874e90035a67c1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $505521e49905a82d$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var $505521e49905a82d$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $505521e49905a82d$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $505521e49905a82d$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $505521e49905a82d$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $505521e49905a82d$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $505521e49905a82d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $505521e49905a82d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var $505521e49905a82d$var$localize = {
    ordinalNumber: $505521e49905a82d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $505521e49905a82d$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $505521e49905a82d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $505521e49905a82d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $505521e49905a82d$export$2e2bcd8739ae039 = $505521e49905a82d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $05712f91748e06c3$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $05712f91748e06c3$var$parseOrdinalNumberPattern = /\d+/i;
var $05712f91748e06c3$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $05712f91748e06c3$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $05712f91748e06c3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $05712f91748e06c3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $05712f91748e06c3$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $05712f91748e06c3$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $05712f91748e06c3$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $05712f91748e06c3$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $05712f91748e06c3$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $05712f91748e06c3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $05712f91748e06c3$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $05712f91748e06c3$var$matchOrdinalNumberPattern,
        parsePattern: $05712f91748e06c3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $05712f91748e06c3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $05712f91748e06c3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $05712f91748e06c3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $05712f91748e06c3$export$2e2bcd8739ae039 = $05712f91748e06c3$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $c1750d05a11f40ea$var$locale = {
    code: 'bs',
    formatDistance: (0, $b2d1c943dd63d596$export$2e2bcd8739ae039),
    formatLong: (0, $7ae381bf48f63a46$export$2e2bcd8739ae039),
    formatRelative: (0, $30874e90035a67c1$export$2e2bcd8739ae039),
    localize: (0, $505521e49905a82d$export$2e2bcd8739ae039),
    match: (0, $05712f91748e06c3$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c1750d05a11f40ea$export$2e2bcd8739ae039 = $c1750d05a11f40ea$var$locale;
module.exports["default"] = $c1750d05a11f40ea$export$2e2bcd8739ae039;

});

parcelRegister("dNzyu", function(module, exports) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $59c097a7dfae9738$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $59c097a7dfae9738$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $59c097a7dfae9738$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
var $59c097a7dfae9738$export$2e2bcd8739ae039 = $59c097a7dfae9738$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f1313bdd9c00f010$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $f1313bdd9c00f010$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $f1313bdd9c00f010$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f1313bdd9c00f010$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f1313bdd9c00f010$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f1313bdd9c00f010$export$2e2bcd8739ae039 = $f1313bdd9c00f010$var$formatLong;


var $bcb7cbecaf482a8f$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $bcb7cbecaf482a8f$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var $bcb7cbecaf482a8f$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $bcb7cbecaf482a8f$var$formatRelativeLocalePlural[token];
    return $bcb7cbecaf482a8f$var$formatRelativeLocale[token];
};
var $bcb7cbecaf482a8f$export$2e2bcd8739ae039 = $bcb7cbecaf482a8f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var $1ce4572d936c96c9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $1ce4572d936c96c9$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $1ce4572d936c96c9$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var $1ce4572d936c96c9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $1ce4572d936c96c9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var $1ce4572d936c96c9$var$localize = {
    ordinalNumber: $1ce4572d936c96c9$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1ce4572d936c96c9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1ce4572d936c96c9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1ce4572d936c96c9$export$2e2bcd8739ae039 = $1ce4572d936c96c9$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $f06ce2ace064ef8b$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $f06ce2ace064ef8b$var$parseOrdinalNumberPattern = /\d+/i;
var $f06ce2ace064ef8b$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $f06ce2ace064ef8b$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $f06ce2ace064ef8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $f06ce2ace064ef8b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f06ce2ace064ef8b$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $f06ce2ace064ef8b$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $f06ce2ace064ef8b$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $f06ce2ace064ef8b$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $f06ce2ace064ef8b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $f06ce2ace064ef8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $f06ce2ace064ef8b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $f06ce2ace064ef8b$var$matchOrdinalNumberPattern,
        parsePattern: $f06ce2ace064ef8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $f06ce2ace064ef8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f06ce2ace064ef8b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f06ce2ace064ef8b$export$2e2bcd8739ae039 = $f06ce2ace064ef8b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $a0bb6e8227855700$var$locale = {
    code: 'ca',
    formatDistance: (0, $59c097a7dfae9738$export$2e2bcd8739ae039),
    formatLong: (0, $f1313bdd9c00f010$export$2e2bcd8739ae039),
    formatRelative: (0, $bcb7cbecaf482a8f$export$2e2bcd8739ae039),
    localize: (0, $1ce4572d936c96c9$export$2e2bcd8739ae039),
    match: (0, $f06ce2ace064ef8b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a0bb6e8227855700$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $a0bb6e8227855700$var$locale;
module.exports["default"] = $a0bb6e8227855700$export$2e2bcd8739ae039;

});

parcelRegister("kLhpw", function(module, exports) {
var $6b5eda3b5b84016e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var $6b5eda3b5b84016e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6b5eda3b5b84016e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $6b5eda3b5b84016e$export$2e2bcd8739ae039 = $6b5eda3b5b84016e$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $d5c1809193fbb88c$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $d5c1809193fbb88c$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d5c1809193fbb88c$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d5c1809193fbb88c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d5c1809193fbb88c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d5c1809193fbb88c$export$2e2bcd8739ae039 = $d5c1809193fbb88c$var$formatLong;


var $4e79e869dd10c9dd$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var $4e79e869dd10c9dd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4e79e869dd10c9dd$var$formatRelativeLocale[token];
};
var $4e79e869dd10c9dd$export$2e2bcd8739ae039 = $4e79e869dd10c9dd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a78a99035aef8fad$var$eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var $a78a99035aef8fad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a78a99035aef8fad$var$monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var $a78a99035aef8fad$var$dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var $a78a99035aef8fad$var$dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var $a78a99035aef8fad$var$formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var $a78a99035aef8fad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var $a78a99035aef8fad$var$localize = {
    ordinalNumber: $a78a99035aef8fad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a78a99035aef8fad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a78a99035aef8fad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a78a99035aef8fad$export$2e2bcd8739ae039 = $a78a99035aef8fad$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $72117dbd6520e10a$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $72117dbd6520e10a$var$parseOrdinalNumberPattern = /\d+/i;
var $72117dbd6520e10a$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $72117dbd6520e10a$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $72117dbd6520e10a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $72117dbd6520e10a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $72117dbd6520e10a$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $72117dbd6520e10a$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $72117dbd6520e10a$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $72117dbd6520e10a$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $72117dbd6520e10a$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $72117dbd6520e10a$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $72117dbd6520e10a$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $72117dbd6520e10a$var$matchOrdinalNumberPattern,
        parsePattern: $72117dbd6520e10a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $72117dbd6520e10a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $72117dbd6520e10a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $72117dbd6520e10a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $72117dbd6520e10a$export$2e2bcd8739ae039 = $72117dbd6520e10a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $f1d5b3d786608fdf$var$locale = {
    code: 'cy',
    formatDistance: (0, $6b5eda3b5b84016e$export$2e2bcd8739ae039),
    formatLong: (0, $d5c1809193fbb88c$export$2e2bcd8739ae039),
    formatRelative: (0, $4e79e869dd10c9dd$export$2e2bcd8739ae039),
    localize: (0, $a78a99035aef8fad$export$2e2bcd8739ae039),
    match: (0, $72117dbd6520e10a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f1d5b3d786608fdf$export$2e2bcd8739ae039 = $f1d5b3d786608fdf$var$locale;
module.exports["default"] = $f1d5b3d786608fdf$export$2e2bcd8739ae039;

});

parcelRegister("jiiAs", function(module, exports) {

var $7rt4j = parcelRequire("7rt4j");


var $60sGp = parcelRequire("60sGp");


var $4BSGy = parcelRequire("4BSGy");


var $lT7Hr = parcelRequire("lT7Hr");


var $9v2ZC = parcelRequire("9v2ZC");

var $d509bb718bc58b9c$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $d509bb718bc58b9c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d509bb718bc58b9c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $d509bb718bc58b9c$var$formattingMonthValues = {
    narrow: $d509bb718bc58b9c$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $d509bb718bc58b9c$var$monthValues.wide
};
var $d509bb718bc58b9c$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $d509bb718bc58b9c$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $d509bb718bc58b9c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $d509bb718bc58b9c$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $d509bb718bc58b9c$var$localize = {
    ordinalNumber: $d509bb718bc58b9c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$monthValues,
        formattingValues: $d509bb718bc58b9c$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d509bb718bc58b9c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d509bb718bc58b9c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d509bb718bc58b9c$export$2e2bcd8739ae039 = $d509bb718bc58b9c$var$localize;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $e0be1dc70926ecdd$var$locale = {
    code: 'de-AT',
    formatDistance: (0, $7rt4j.default),
    formatLong: (0, $60sGp.default),
    formatRelative: (0, $4BSGy.default),
    localize: (0, $d509bb718bc58b9c$export$2e2bcd8739ae039),
    match: (0, $lT7Hr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e0be1dc70926ecdd$export$2e2bcd8739ae039 = $e0be1dc70926ecdd$var$locale;
module.exports["default"] = $e0be1dc70926ecdd$export$2e2bcd8739ae039;

});

parcelRegister("8RXQT", function(module, exports) {
var $aa3ed254233a3ddb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var $aa3ed254233a3ddb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $aa3ed254233a3ddb$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
var $aa3ed254233a3ddb$export$2e2bcd8739ae039 = $aa3ed254233a3ddb$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $585f32b0dcabc968$var$dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var $585f32b0dcabc968$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $585f32b0dcabc968$var$dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $585f32b0dcabc968$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $585f32b0dcabc968$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $585f32b0dcabc968$export$2e2bcd8739ae039 = $585f32b0dcabc968$var$formatLong;


var $a5e401d1352f6a4f$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var $a5e401d1352f6a4f$var$formatRelative = function formatRelative(token, date) {
    var format = $a5e401d1352f6a4f$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $a5e401d1352f6a4f$export$2e2bcd8739ae039 = $a5e401d1352f6a4f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $5ca78e9a2e618269$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var $5ca78e9a2e618269$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var $5ca78e9a2e618269$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var $5ca78e9a2e618269$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var $5ca78e9a2e618269$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var $5ca78e9a2e618269$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var $5ca78e9a2e618269$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var $5ca78e9a2e618269$var$localize = {
    ordinalNumber: $5ca78e9a2e618269$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $5ca78e9a2e618269$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $5ca78e9a2e618269$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $5ca78e9a2e618269$export$2e2bcd8739ae039 = $5ca78e9a2e618269$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $76af839f7cde7563$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $76af839f7cde7563$var$parseOrdinalNumberPattern = /\d+/i;
var $76af839f7cde7563$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $76af839f7cde7563$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $76af839f7cde7563$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $76af839f7cde7563$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $76af839f7cde7563$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $76af839f7cde7563$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $76af839f7cde7563$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $76af839f7cde7563$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $76af839f7cde7563$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $76af839f7cde7563$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $76af839f7cde7563$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $76af839f7cde7563$var$matchOrdinalNumberPattern,
        parsePattern: $76af839f7cde7563$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76af839f7cde7563$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $76af839f7cde7563$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $76af839f7cde7563$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $76af839f7cde7563$export$2e2bcd8739ae039 = $76af839f7cde7563$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $6751b35e65cddf94$var$locale = {
    code: 'el',
    formatDistance: (0, $aa3ed254233a3ddb$export$2e2bcd8739ae039),
    formatLong: (0, $585f32b0dcabc968$export$2e2bcd8739ae039),
    formatRelative: (0, $a5e401d1352f6a4f$export$2e2bcd8739ae039),
    localize: (0, $5ca78e9a2e618269$export$2e2bcd8739ae039),
    match: (0, $76af839f7cde7563$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6751b35e65cddf94$export$2e2bcd8739ae039 = $6751b35e65cddf94$var$locale;
module.exports["default"] = $6751b35e65cddf94$export$2e2bcd8739ae039;

});

parcelRegister("2Y0P5", function(module, exports) {

var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");

var $87a8120b7335ef09$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var $87a8120b7335ef09$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $87a8120b7335ef09$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $87a8120b7335ef09$export$2e2bcd8739ae039 = $87a8120b7335ef09$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $623ebfbc3220ddec$var$dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var $623ebfbc3220ddec$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $623ebfbc3220ddec$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $623ebfbc3220ddec$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $623ebfbc3220ddec$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $623ebfbc3220ddec$export$2e2bcd8739ae039 = $623ebfbc3220ddec$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $2291d2ce867d6353$var$locale = {
    code: 'en-CA',
    formatDistance: (0, $87a8120b7335ef09$export$2e2bcd8739ae039),
    formatLong: (0, $623ebfbc3220ddec$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2291d2ce867d6353$export$2e2bcd8739ae039 = $2291d2ce867d6353$var$locale;
module.exports["default"] = $2291d2ce867d6353$export$2e2bcd8739ae039;

});

parcelRegister("hWN4g", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $hJozw = parcelRequire("hJozw");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $d10dea4df914c5fc$var$locale = {
    code: 'en-IE',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $hJozw.default),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d10dea4df914c5fc$export$2e2bcd8739ae039 = $d10dea4df914c5fc$var$locale;
module.exports["default"] = $d10dea4df914c5fc$export$2e2bcd8739ae039;

});

parcelRegister("kuDO4", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $7676191eec54eace$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var $7676191eec54eace$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $7676191eec54eace$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7676191eec54eace$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7676191eec54eace$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7676191eec54eace$export$2e2bcd8739ae039 = $7676191eec54eace$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $eeb57cc39901ab85$var$locale = {
    code: 'en-IN',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $7676191eec54eace$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $eeb57cc39901ab85$export$2e2bcd8739ae039 = $eeb57cc39901ab85$var$locale;
module.exports["default"] = $eeb57cc39901ab85$export$2e2bcd8739ae039;

});

parcelRegister("5FUh4", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $1a31022000d28a51$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $1a31022000d28a51$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1a31022000d28a51$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1a31022000d28a51$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $1a31022000d28a51$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1a31022000d28a51$export$2e2bcd8739ae039 = $1a31022000d28a51$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $421c6f009356ec84$var$locale = {
    code: 'en-NZ',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $1a31022000d28a51$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $421c6f009356ec84$export$2e2bcd8739ae039 = $421c6f009356ec84$var$locale;
module.exports["default"] = $421c6f009356ec84$export$2e2bcd8739ae039;

});

parcelRegister("aSFVd", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $fcGXP = parcelRequire("fcGXP");

var $a98717589c893aaa$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $a98717589c893aaa$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a98717589c893aaa$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a98717589c893aaa$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $a98717589c893aaa$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a98717589c893aaa$export$2e2bcd8739ae039 = $a98717589c893aaa$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $7ebf774f233a99c8$var$locale = {
    code: 'en-ZA',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $a98717589c893aaa$export$2e2bcd8739ae039),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $7ebf774f233a99c8$export$2e2bcd8739ae039 = $7ebf774f233a99c8$var$locale;
module.exports["default"] = $7ebf774f233a99c8$export$2e2bcd8739ae039;

});

parcelRegister("6unLC", function(module, exports) {
var $689caf0ad95d2d80$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var $689caf0ad95d2d80$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $689caf0ad95d2d80$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
var $689caf0ad95d2d80$export$2e2bcd8739ae039 = $689caf0ad95d2d80$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8b770553daaf0f38$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var $8b770553daaf0f38$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8b770553daaf0f38$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $8b770553daaf0f38$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8b770553daaf0f38$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $8b770553daaf0f38$export$2e2bcd8739ae039 = $8b770553daaf0f38$var$formatLong;


var $9520a3db859d8bd3$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var $9520a3db859d8bd3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9520a3db859d8bd3$var$formatRelativeLocale[token];
};
var $9520a3db859d8bd3$export$2e2bcd8739ae039 = $9520a3db859d8bd3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $412c0b8e75f882cc$var$eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var $412c0b8e75f882cc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var $412c0b8e75f882cc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var $412c0b8e75f882cc$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var $412c0b8e75f882cc$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var $412c0b8e75f882cc$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var $412c0b8e75f882cc$var$localize = {
    ordinalNumber: $412c0b8e75f882cc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $412c0b8e75f882cc$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $412c0b8e75f882cc$export$2e2bcd8739ae039 = $412c0b8e75f882cc$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $b012c69f7af0e1fc$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $b012c69f7af0e1fc$var$parseOrdinalNumberPattern = /\d+/i;
var $b012c69f7af0e1fc$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $b012c69f7af0e1fc$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $b012c69f7af0e1fc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $b012c69f7af0e1fc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b012c69f7af0e1fc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $b012c69f7af0e1fc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b012c69f7af0e1fc$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $b012c69f7af0e1fc$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $b012c69f7af0e1fc$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $b012c69f7af0e1fc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $b012c69f7af0e1fc$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b012c69f7af0e1fc$var$matchOrdinalNumberPattern,
        parsePattern: $b012c69f7af0e1fc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b012c69f7af0e1fc$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b012c69f7af0e1fc$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b012c69f7af0e1fc$export$2e2bcd8739ae039 = $b012c69f7af0e1fc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $4b97fb0cc397e588$var$locale = {
    code: 'eo',
    formatDistance: (0, $689caf0ad95d2d80$export$2e2bcd8739ae039),
    formatLong: (0, $8b770553daaf0f38$export$2e2bcd8739ae039),
    formatRelative: (0, $9520a3db859d8bd3$export$2e2bcd8739ae039),
    localize: (0, $412c0b8e75f882cc$export$2e2bcd8739ae039),
    match: (0, $b012c69f7af0e1fc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4b97fb0cc397e588$export$2e2bcd8739ae039 = $4b97fb0cc397e588$var$locale;
module.exports["default"] = $4b97fb0cc397e588$export$2e2bcd8739ae039;

});

parcelRegister("jlS2G", function(module, exports) {
var $4c24c657b2344469$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var $4c24c657b2344469$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4c24c657b2344469$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
var $4c24c657b2344469$export$2e2bcd8739ae039 = $4c24c657b2344469$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $67992f7041fa2751$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var $67992f7041fa2751$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $67992f7041fa2751$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $67992f7041fa2751$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $67992f7041fa2751$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $67992f7041fa2751$export$2e2bcd8739ae039 = $67992f7041fa2751$var$formatLong;


var $f90ff09786de11af$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $f90ff09786de11af$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $f90ff09786de11af$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $f90ff09786de11af$var$formatRelativeLocalePlural[token];
    return $f90ff09786de11af$var$formatRelativeLocale[token];
};
var $f90ff09786de11af$export$2e2bcd8739ae039 = $f90ff09786de11af$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b1d18d2a8570b9d0$var$eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var $b1d18d2a8570b9d0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var $b1d18d2a8570b9d0$var$monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var $b1d18d2a8570b9d0$var$dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var $b1d18d2a8570b9d0$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var $b1d18d2a8570b9d0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var $b1d18d2a8570b9d0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b1d18d2a8570b9d0$var$localize = {
    ordinalNumber: $b1d18d2a8570b9d0$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b1d18d2a8570b9d0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b1d18d2a8570b9d0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b1d18d2a8570b9d0$export$2e2bcd8739ae039 = $b1d18d2a8570b9d0$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $02b2d46cae29f6e4$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $02b2d46cae29f6e4$var$parseOrdinalNumberPattern = /\d+/i;
var $02b2d46cae29f6e4$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $02b2d46cae29f6e4$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $02b2d46cae29f6e4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $02b2d46cae29f6e4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $02b2d46cae29f6e4$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $02b2d46cae29f6e4$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $02b2d46cae29f6e4$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $02b2d46cae29f6e4$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $02b2d46cae29f6e4$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $02b2d46cae29f6e4$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $02b2d46cae29f6e4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $02b2d46cae29f6e4$var$matchOrdinalNumberPattern,
        parsePattern: $02b2d46cae29f6e4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $02b2d46cae29f6e4$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $02b2d46cae29f6e4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $02b2d46cae29f6e4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $02b2d46cae29f6e4$export$2e2bcd8739ae039 = $02b2d46cae29f6e4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $e169e621ccbf7c3f$var$locale = {
    code: 'eu',
    formatDistance: (0, $4c24c657b2344469$export$2e2bcd8739ae039),
    formatLong: (0, $67992f7041fa2751$export$2e2bcd8739ae039),
    formatRelative: (0, $f90ff09786de11af$export$2e2bcd8739ae039),
    localize: (0, $b1d18d2a8570b9d0$export$2e2bcd8739ae039),
    match: (0, $02b2d46cae29f6e4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e169e621ccbf7c3f$export$2e2bcd8739ae039 = $e169e621ccbf7c3f$var$locale;
module.exports["default"] = $e169e621ccbf7c3f$export$2e2bcd8739ae039;

});

parcelRegister("eXL8E", function(module, exports) {
var $e1f5f92e7462ec6a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var $e1f5f92e7462ec6a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e1f5f92e7462ec6a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
var $e1f5f92e7462ec6a$export$2e2bcd8739ae039 = $e1f5f92e7462ec6a$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $768d64295664928c$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var $768d64295664928c$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $768d64295664928c$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $768d64295664928c$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $768d64295664928c$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $768d64295664928c$export$2e2bcd8739ae039 = $768d64295664928c$var$formatLong;


var $165a23a1bf205836$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var $165a23a1bf205836$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $165a23a1bf205836$var$formatRelativeLocale[token];
};
var $165a23a1bf205836$export$2e2bcd8739ae039 = $165a23a1bf205836$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $0c75d51c231950f6$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var $0c75d51c231950f6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0c75d51c231950f6$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var $0c75d51c231950f6$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var $0c75d51c231950f6$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $0c75d51c231950f6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $0c75d51c231950f6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $0c75d51c231950f6$var$localize = {
    ordinalNumber: $0c75d51c231950f6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $0c75d51c231950f6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0c75d51c231950f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0c75d51c231950f6$export$2e2bcd8739ae039 = $0c75d51c231950f6$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e106b2c915491db8$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $e106b2c915491db8$var$parseOrdinalNumberPattern = /\d+/i;
var $e106b2c915491db8$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $e106b2c915491db8$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $e106b2c915491db8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $e106b2c915491db8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e106b2c915491db8$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $e106b2c915491db8$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $e106b2c915491db8$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $e106b2c915491db8$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $e106b2c915491db8$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $e106b2c915491db8$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $e106b2c915491db8$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e106b2c915491db8$var$matchOrdinalNumberPattern,
        parsePattern: $e106b2c915491db8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e106b2c915491db8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e106b2c915491db8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e106b2c915491db8$export$2e2bcd8739ae039 = $e106b2c915491db8$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $ae4b242194ad94d3$var$locale = {
    code: 'fa-IR',
    formatDistance: (0, $e1f5f92e7462ec6a$export$2e2bcd8739ae039),
    formatLong: (0, $768d64295664928c$export$2e2bcd8739ae039),
    formatRelative: (0, $165a23a1bf205836$export$2e2bcd8739ae039),
    localize: (0, $0c75d51c231950f6$export$2e2bcd8739ae039),
    match: (0, $e106b2c915491db8$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $ae4b242194ad94d3$export$2e2bcd8739ae039 = $ae4b242194ad94d3$var$locale;
module.exports["default"] = $ae4b242194ad94d3$export$2e2bcd8739ae039;

});

parcelRegister("lFkXa", function(module, exports) {
// Same as fr

var $9J4Kh = parcelRequire("9J4Kh");


var $drrJx = parcelRequire("drrJx");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");


var $fcGXP = parcelRequire("fcGXP");

var $c978d3e01c1a17a6$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var $c978d3e01c1a17a6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c978d3e01c1a17a6$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c978d3e01c1a17a6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c978d3e01c1a17a6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c978d3e01c1a17a6$export$2e2bcd8739ae039 = $c978d3e01c1a17a6$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $fc5dae2d3dae4e08$var$locale = {
    code: 'fr-CA',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $c978d3e01c1a17a6$export$2e2bcd8739ae039),
    formatRelative: (0, $drrJx.default),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fc5dae2d3dae4e08$export$2e2bcd8739ae039 = $fc5dae2d3dae4e08$var$locale;
module.exports["default"] = $fc5dae2d3dae4e08$export$2e2bcd8739ae039;

});

parcelRegister("2p0ts", function(module, exports) {
// Same as fr

var $9J4Kh = parcelRequire("9J4Kh");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");


var $fcGXP = parcelRequire("fcGXP");

var $71891e3ae7b8239f$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $71891e3ae7b8239f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $71891e3ae7b8239f$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $71891e3ae7b8239f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $71891e3ae7b8239f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $71891e3ae7b8239f$export$2e2bcd8739ae039 = $71891e3ae7b8239f$var$formatLong;


var $f5f7876a83348f0f$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var $f5f7876a83348f0f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f5f7876a83348f0f$var$formatRelativeLocale[token];
};
var $f5f7876a83348f0f$export$2e2bcd8739ae039 = $f5f7876a83348f0f$var$formatRelative;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $1bfe48bab1fbf1f1$var$locale = {
    code: 'fr-CH',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $71891e3ae7b8239f$export$2e2bcd8739ae039),
    formatRelative: (0, $f5f7876a83348f0f$export$2e2bcd8739ae039),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1bfe48bab1fbf1f1$export$2e2bcd8739ae039 = $1bfe48bab1fbf1f1$var$locale;
module.exports["default"] = $1bfe48bab1fbf1f1$export$2e2bcd8739ae039;

});

parcelRegister("aa0X5", function(module, exports) {
var $fc6edd505d9f3212$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var $fc6edd505d9f3212$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fc6edd505d9f3212$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
var $fc6edd505d9f3212$export$2e2bcd8739ae039 = $fc6edd505d9f3212$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $4e120632c870007e$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $4e120632c870007e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4e120632c870007e$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $4e120632c870007e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $4e120632c870007e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4e120632c870007e$export$2e2bcd8739ae039 = $4e120632c870007e$var$formatLong;


var $97b974594ddec5fd$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $97b974594ddec5fd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $97b974594ddec5fd$var$formatRelativeLocale[token];
};
var $97b974594ddec5fd$export$2e2bcd8739ae039 = $97b974594ddec5fd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $f973dfd4f1422b6c$var$eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var $f973dfd4f1422b6c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var $f973dfd4f1422b6c$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var $f973dfd4f1422b6c$var$dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var $f973dfd4f1422b6c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var $f973dfd4f1422b6c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $f973dfd4f1422b6c$var$localize = {
    ordinalNumber: $f973dfd4f1422b6c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $f973dfd4f1422b6c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $f973dfd4f1422b6c$export$2e2bcd8739ae039 = $f973dfd4f1422b6c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4ac62522d0b02eec$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $4ac62522d0b02eec$var$parseOrdinalNumberPattern = /\d+/i;
var $4ac62522d0b02eec$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $4ac62522d0b02eec$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $4ac62522d0b02eec$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $4ac62522d0b02eec$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4ac62522d0b02eec$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $4ac62522d0b02eec$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $4ac62522d0b02eec$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $4ac62522d0b02eec$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $4ac62522d0b02eec$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $4ac62522d0b02eec$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $4ac62522d0b02eec$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4ac62522d0b02eec$var$matchOrdinalNumberPattern,
        parsePattern: $4ac62522d0b02eec$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4ac62522d0b02eec$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4ac62522d0b02eec$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4ac62522d0b02eec$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4ac62522d0b02eec$export$2e2bcd8739ae039 = $4ac62522d0b02eec$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $765b939adfae76b5$var$locale = {
    code: 'fy',
    formatDistance: (0, $fc6edd505d9f3212$export$2e2bcd8739ae039),
    formatLong: (0, $4e120632c870007e$export$2e2bcd8739ae039),
    formatRelative: (0, $97b974594ddec5fd$export$2e2bcd8739ae039),
    localize: (0, $f973dfd4f1422b6c$export$2e2bcd8739ae039),
    match: (0, $4ac62522d0b02eec$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $765b939adfae76b5$export$2e2bcd8739ae039 = $765b939adfae76b5$var$locale;
module.exports["default"] = $765b939adfae76b5$export$2e2bcd8739ae039;

});

parcelRegister("inBOb", function(module, exports) {
var $afe280511868369c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $afe280511868369c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $afe280511868369c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
var $afe280511868369c$export$2e2bcd8739ae039 = $afe280511868369c$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e41716130eec6e6f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $e41716130eec6e6f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $e41716130eec6e6f$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e41716130eec6e6f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e41716130eec6e6f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e41716130eec6e6f$export$2e2bcd8739ae039 = $e41716130eec6e6f$var$formatLong;


var $9dfd3f39b2f8b8b1$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var $9dfd3f39b2f8b8b1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9dfd3f39b2f8b8b1$var$formatRelativeLocale[token];
};
var $9dfd3f39b2f8b8b1$export$2e2bcd8739ae039 = $9dfd3f39b2f8b8b1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $3f8e9ab09f860163$var$eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var $3f8e9ab09f860163$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $3f8e9ab09f860163$var$monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var $3f8e9ab09f860163$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var $3f8e9ab09f860163$var$dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var $3f8e9ab09f860163$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var $3f8e9ab09f860163$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var $3f8e9ab09f860163$var$localize = {
    ordinalNumber: $3f8e9ab09f860163$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $3f8e9ab09f860163$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3f8e9ab09f860163$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3f8e9ab09f860163$export$2e2bcd8739ae039 = $3f8e9ab09f860163$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $84bc5bc1bd588d93$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $84bc5bc1bd588d93$var$parseOrdinalNumberPattern = /\d+/i;
var $84bc5bc1bd588d93$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $84bc5bc1bd588d93$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $84bc5bc1bd588d93$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $84bc5bc1bd588d93$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $84bc5bc1bd588d93$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $84bc5bc1bd588d93$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $84bc5bc1bd588d93$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $84bc5bc1bd588d93$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $84bc5bc1bd588d93$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $84bc5bc1bd588d93$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $84bc5bc1bd588d93$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $84bc5bc1bd588d93$var$matchOrdinalNumberPattern,
        parsePattern: $84bc5bc1bd588d93$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $84bc5bc1bd588d93$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $84bc5bc1bd588d93$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $84bc5bc1bd588d93$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $84bc5bc1bd588d93$export$2e2bcd8739ae039 = $84bc5bc1bd588d93$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $d617b3f522183e80$var$locale = {
    code: 'gd',
    formatDistance: (0, $afe280511868369c$export$2e2bcd8739ae039),
    formatLong: (0, $e41716130eec6e6f$export$2e2bcd8739ae039),
    formatRelative: (0, $9dfd3f39b2f8b8b1$export$2e2bcd8739ae039),
    localize: (0, $3f8e9ab09f860163$export$2e2bcd8739ae039),
    match: (0, $84bc5bc1bd588d93$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $d617b3f522183e80$export$2e2bcd8739ae039 = $d617b3f522183e80$var$locale;
module.exports["default"] = $d617b3f522183e80$export$2e2bcd8739ae039;

});

parcelRegister("2gRR9", function(module, exports) {
var $99e0298d8ade624e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var $99e0298d8ade624e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $99e0298d8ade624e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
var $99e0298d8ade624e$export$2e2bcd8739ae039 = $99e0298d8ade624e$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $b34cdad1898f8bc6$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $b34cdad1898f8bc6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b34cdad1898f8bc6$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b34cdad1898f8bc6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $b34cdad1898f8bc6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b34cdad1898f8bc6$export$2e2bcd8739ae039 = $b34cdad1898f8bc6$var$formatLong;


var $50f5c110f853c3b5$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var $50f5c110f853c3b5$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var $50f5c110f853c3b5$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $50f5c110f853c3b5$var$formatRelativeLocalePlural[token];
    return $50f5c110f853c3b5$var$formatRelativeLocale[token];
};
var $50f5c110f853c3b5$export$2e2bcd8739ae039 = $50f5c110f853c3b5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $cacf44f79fbb79da$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var $cacf44f79fbb79da$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $cacf44f79fbb79da$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var $cacf44f79fbb79da$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var $cacf44f79fbb79da$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var $cacf44f79fbb79da$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var $cacf44f79fbb79da$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $cacf44f79fbb79da$var$localize = {
    ordinalNumber: $cacf44f79fbb79da$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cacf44f79fbb79da$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cacf44f79fbb79da$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cacf44f79fbb79da$export$2e2bcd8739ae039 = $cacf44f79fbb79da$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7371370cf9aa28df$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $7371370cf9aa28df$var$parseOrdinalNumberPattern = /\d+/i;
var $7371370cf9aa28df$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $7371370cf9aa28df$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $7371370cf9aa28df$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $7371370cf9aa28df$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7371370cf9aa28df$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $7371370cf9aa28df$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $7371370cf9aa28df$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $7371370cf9aa28df$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $7371370cf9aa28df$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $7371370cf9aa28df$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $7371370cf9aa28df$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7371370cf9aa28df$var$matchOrdinalNumberPattern,
        parsePattern: $7371370cf9aa28df$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7371370cf9aa28df$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7371370cf9aa28df$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7371370cf9aa28df$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7371370cf9aa28df$export$2e2bcd8739ae039 = $7371370cf9aa28df$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $1a76da21f46bddf9$var$locale = {
    code: 'gl',
    formatDistance: (0, $99e0298d8ade624e$export$2e2bcd8739ae039),
    formatLong: (0, $b34cdad1898f8bc6$export$2e2bcd8739ae039),
    formatRelative: (0, $50f5c110f853c3b5$export$2e2bcd8739ae039),
    localize: (0, $cacf44f79fbb79da$export$2e2bcd8739ae039),
    match: (0, $7371370cf9aa28df$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1a76da21f46bddf9$export$2e2bcd8739ae039 = $1a76da21f46bddf9$var$locale;
module.exports["default"] = $1a76da21f46bddf9$export$2e2bcd8739ae039;

});

parcelRegister("lgykd", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $c10c1a6ef4545ea0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var $c10c1a6ef4545ea0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c10c1a6ef4545ea0$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
var $c10c1a6ef4545ea0$export$2e2bcd8739ae039 = $c10c1a6ef4545ea0$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $b8e77e64f6655059$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var $b8e77e64f6655059$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var $b8e77e64f6655059$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var $b8e77e64f6655059$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $b8e77e64f6655059$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b8e77e64f6655059$export$2e2bcd8739ae039 = $b8e77e64f6655059$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $33f266e4f0161513$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var $33f266e4f0161513$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $33f266e4f0161513$var$formatRelativeLocale[token];
};
var $33f266e4f0161513$export$2e2bcd8739ae039 = $33f266e4f0161513$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// #1621 - #1630
var $7db9f48c1aa86abc$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $7db9f48c1aa86abc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $7db9f48c1aa86abc$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $7db9f48c1aa86abc$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $7db9f48c1aa86abc$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7db9f48c1aa86abc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $7db9f48c1aa86abc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $7db9f48c1aa86abc$var$localize = {
    ordinalNumber: $7db9f48c1aa86abc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $7db9f48c1aa86abc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $7db9f48c1aa86abc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $7db9f48c1aa86abc$export$2e2bcd8739ae039 = $7db9f48c1aa86abc$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9416017814d06a96$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $9416017814d06a96$var$parseOrdinalNumberPattern = /\d+/i;
var $9416017814d06a96$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $9416017814d06a96$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $9416017814d06a96$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $9416017814d06a96$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9416017814d06a96$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $9416017814d06a96$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $9416017814d06a96$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $9416017814d06a96$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $9416017814d06a96$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $9416017814d06a96$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $9416017814d06a96$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9416017814d06a96$var$matchOrdinalNumberPattern,
        parsePattern: $9416017814d06a96$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9416017814d06a96$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9416017814d06a96$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9416017814d06a96$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9416017814d06a96$export$2e2bcd8739ae039 = $9416017814d06a96$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $f7b5b7da971def3e$var$locale = {
    code: 'gu',
    formatDistance: (0, $c10c1a6ef4545ea0$export$2e2bcd8739ae039),
    formatLong: (0, $b8e77e64f6655059$export$2e2bcd8739ae039),
    formatRelative: (0, $33f266e4f0161513$export$2e2bcd8739ae039),
    localize: (0, $7db9f48c1aa86abc$export$2e2bcd8739ae039),
    match: (0, $9416017814d06a96$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f7b5b7da971def3e$export$2e2bcd8739ae039 = $f7b5b7da971def3e$var$locale;
module.exports["default"] = $f7b5b7da971def3e$export$2e2bcd8739ae039;

});

parcelRegister("114nq", function(module, exports) {
var $d40a550254a6a129$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var $d40a550254a6a129$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = $d40a550254a6a129$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
var $d40a550254a6a129$export$2e2bcd8739ae039 = $d40a550254a6a129$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e513144e2c159c76$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var $e513144e2c159c76$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e513144e2c159c76$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e513144e2c159c76$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e513144e2c159c76$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e513144e2c159c76$export$2e2bcd8739ae039 = $e513144e2c159c76$var$formatLong;


var $2a4fb7c5b982707d$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var $2a4fb7c5b982707d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2a4fb7c5b982707d$var$formatRelativeLocale[token];
};
var $2a4fb7c5b982707d$export$2e2bcd8739ae039 = $2a4fb7c5b982707d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $158ba1ef3de7c8a6$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var $158ba1ef3de7c8a6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var $158ba1ef3de7c8a6$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var $158ba1ef3de7c8a6$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var $158ba1ef3de7c8a6$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var $158ba1ef3de7c8a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var $158ba1ef3de7c8a6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $158ba1ef3de7c8a6$var$localize = {
    ordinalNumber: $158ba1ef3de7c8a6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $158ba1ef3de7c8a6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $158ba1ef3de7c8a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $158ba1ef3de7c8a6$export$2e2bcd8739ae039 = $158ba1ef3de7c8a6$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6339a5836aa9aa57$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $6339a5836aa9aa57$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $6339a5836aa9aa57$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $6339a5836aa9aa57$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $6339a5836aa9aa57$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $6339a5836aa9aa57$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6339a5836aa9aa57$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $6339a5836aa9aa57$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $6339a5836aa9aa57$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $6339a5836aa9aa57$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $6339a5836aa9aa57$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $6339a5836aa9aa57$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $6339a5836aa9aa57$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var $6339a5836aa9aa57$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6339a5836aa9aa57$var$matchOrdinalNumberPattern,
        parsePattern: $6339a5836aa9aa57$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $6339a5836aa9aa57$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6339a5836aa9aa57$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6339a5836aa9aa57$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6339a5836aa9aa57$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6339a5836aa9aa57$export$2e2bcd8739ae039 = $6339a5836aa9aa57$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $0bd94791b3452e6f$var$locale = {
    code: 'he',
    formatDistance: (0, $d40a550254a6a129$export$2e2bcd8739ae039),
    formatLong: (0, $e513144e2c159c76$export$2e2bcd8739ae039),
    formatRelative: (0, $2a4fb7c5b982707d$export$2e2bcd8739ae039),
    localize: (0, $158ba1ef3de7c8a6$export$2e2bcd8739ae039),
    match: (0, $6339a5836aa9aa57$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0bd94791b3452e6f$export$2e2bcd8739ae039 = $0bd94791b3452e6f$var$locale;
module.exports["default"] = $0bd94791b3452e6f$export$2e2bcd8739ae039;

});

parcelRegister("68vmh", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $b7376d96070ba6ad$var$numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var $b7376d96070ba6ad$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var $b7376d96070ba6ad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $b7376d96070ba6ad$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var $b7376d96070ba6ad$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var $b7376d96070ba6ad$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $b7376d96070ba6ad$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $b7376d96070ba6ad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $b7376d96070ba6ad$export$3e1d599946644f03(number);
};
function $b7376d96070ba6ad$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $b7376d96070ba6ad$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $b7376d96070ba6ad$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $b7376d96070ba6ad$var$numberValues.locale[match];
    });
}
var $b7376d96070ba6ad$var$localize = {
    ordinalNumber: $b7376d96070ba6ad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b7376d96070ba6ad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b7376d96070ba6ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b7376d96070ba6ad$export$2e2bcd8739ae039 = $b7376d96070ba6ad$var$localize;


var $697269c9bc61dfba$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var $697269c9bc61dfba$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $697269c9bc61dfba$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $b7376d96070ba6ad$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
var $697269c9bc61dfba$export$2e2bcd8739ae039 = $697269c9bc61dfba$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e4bedee83ffb3d64$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var $e4bedee83ffb3d64$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var $e4bedee83ffb3d64$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var $e4bedee83ffb3d64$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e4bedee83ffb3d64$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e4bedee83ffb3d64$export$2e2bcd8739ae039 = $e4bedee83ffb3d64$var$formatLong;


var $dda737b874e7276a$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var $dda737b874e7276a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $dda737b874e7276a$var$formatRelativeLocale[token];
};
var $dda737b874e7276a$export$2e2bcd8739ae039 = $dda737b874e7276a$var$formatRelative;




var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");


var $5c2fb7221e285922$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $5c2fb7221e285922$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $5c2fb7221e285922$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $5c2fb7221e285922$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $5c2fb7221e285922$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $5c2fb7221e285922$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5c2fb7221e285922$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $5c2fb7221e285922$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $5c2fb7221e285922$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $5c2fb7221e285922$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $5c2fb7221e285922$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $5c2fb7221e285922$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $5c2fb7221e285922$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5c2fb7221e285922$var$matchOrdinalNumberPattern,
        parsePattern: $5c2fb7221e285922$var$parseOrdinalNumberPattern,
        valueCallback: (0, $b7376d96070ba6ad$export$b431cabd737c2a)
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c2fb7221e285922$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5c2fb7221e285922$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5c2fb7221e285922$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5c2fb7221e285922$export$2e2bcd8739ae039 = $5c2fb7221e285922$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $477bd08f7b4eccd7$var$locale = {
    code: 'hi',
    formatDistance: (0, $697269c9bc61dfba$export$2e2bcd8739ae039),
    formatLong: (0, $e4bedee83ffb3d64$export$2e2bcd8739ae039),
    formatRelative: (0, $dda737b874e7276a$export$2e2bcd8739ae039),
    localize: (0, $b7376d96070ba6ad$export$2e2bcd8739ae039),
    match: (0, $5c2fb7221e285922$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $477bd08f7b4eccd7$export$2e2bcd8739ae039 = $477bd08f7b4eccd7$var$locale;
module.exports["default"] = $477bd08f7b4eccd7$export$2e2bcd8739ae039;

});

parcelRegister("c4pIC", function(module, exports) {
var $887b3aabd69f0b31$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $887b3aabd69f0b31$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $887b3aabd69f0b31$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $887b3aabd69f0b31$export$2e2bcd8739ae039 = $887b3aabd69f0b31$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $c652e4da380961d9$var$dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var $c652e4da380961d9$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c652e4da380961d9$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c652e4da380961d9$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c652e4da380961d9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c652e4da380961d9$export$2e2bcd8739ae039 = $c652e4da380961d9$var$formatLong;


var $b87cf77a432b4dc3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $b87cf77a432b4dc3$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b87cf77a432b4dc3$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $b87cf77a432b4dc3$export$2e2bcd8739ae039 = $b87cf77a432b4dc3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $69be126a3e0143d8$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var $69be126a3e0143d8$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $69be126a3e0143d8$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var $69be126a3e0143d8$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var $69be126a3e0143d8$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $69be126a3e0143d8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $69be126a3e0143d8$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $69be126a3e0143d8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $69be126a3e0143d8$var$localize = {
    ordinalNumber: $69be126a3e0143d8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $69be126a3e0143d8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $69be126a3e0143d8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $69be126a3e0143d8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $69be126a3e0143d8$export$2e2bcd8739ae039 = $69be126a3e0143d8$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5f08344913d92eb2$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $5f08344913d92eb2$var$parseOrdinalNumberPattern = /\d+/i;
var $5f08344913d92eb2$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $5f08344913d92eb2$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $5f08344913d92eb2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $5f08344913d92eb2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5f08344913d92eb2$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $5f08344913d92eb2$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $5f08344913d92eb2$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $5f08344913d92eb2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $5f08344913d92eb2$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $5f08344913d92eb2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $5f08344913d92eb2$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5f08344913d92eb2$var$matchOrdinalNumberPattern,
        parsePattern: $5f08344913d92eb2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f08344913d92eb2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5f08344913d92eb2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5f08344913d92eb2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5f08344913d92eb2$export$2e2bcd8739ae039 = $5f08344913d92eb2$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $8c99cef5c80e00e5$var$locale = {
    code: 'hr',
    formatDistance: (0, $887b3aabd69f0b31$export$2e2bcd8739ae039),
    formatLong: (0, $c652e4da380961d9$export$2e2bcd8739ae039),
    formatRelative: (0, $b87cf77a432b4dc3$export$2e2bcd8739ae039),
    localize: (0, $69be126a3e0143d8$export$2e2bcd8739ae039),
    match: (0, $5f08344913d92eb2$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8c99cef5c80e00e5$export$2e2bcd8739ae039 = $8c99cef5c80e00e5$var$locale;
module.exports["default"] = $8c99cef5c80e00e5$export$2e2bcd8739ae039;

});

parcelRegister("h3dgf", function(module, exports) {
var $12e9469258421737$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $12e9469258421737$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $12e9469258421737$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $12e9469258421737$export$2e2bcd8739ae039 = $12e9469258421737$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $939a3f00db0f30fb$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $939a3f00db0f30fb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $939a3f00db0f30fb$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $939a3f00db0f30fb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $939a3f00db0f30fb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $939a3f00db0f30fb$export$2e2bcd8739ae039 = $939a3f00db0f30fb$var$formatLong;


var $80fc6ed686f906ea$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var $80fc6ed686f906ea$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $80fc6ed686f906ea$var$formatRelativeLocale[token];
};
var $80fc6ed686f906ea$export$2e2bcd8739ae039 = $80fc6ed686f906ea$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $64af0b6c6617128c$var$eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var $64af0b6c6617128c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $64af0b6c6617128c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var $64af0b6c6617128c$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var $64af0b6c6617128c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var $64af0b6c6617128c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var $64af0b6c6617128c$var$localize = {
    ordinalNumber: $64af0b6c6617128c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $64af0b6c6617128c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $64af0b6c6617128c$export$2e2bcd8739ae039 = $64af0b6c6617128c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $f61a10fe7eeb78ff$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $f61a10fe7eeb78ff$var$parseOrdinalNumberPattern = /\d+/i;
var $f61a10fe7eeb78ff$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $f61a10fe7eeb78ff$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $f61a10fe7eeb78ff$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $f61a10fe7eeb78ff$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f61a10fe7eeb78ff$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $f61a10fe7eeb78ff$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $f61a10fe7eeb78ff$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $f61a10fe7eeb78ff$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $f61a10fe7eeb78ff$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $f61a10fe7eeb78ff$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $f61a10fe7eeb78ff$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $f61a10fe7eeb78ff$var$matchOrdinalNumberPattern,
        parsePattern: $f61a10fe7eeb78ff$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f61a10fe7eeb78ff$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $f61a10fe7eeb78ff$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f61a10fe7eeb78ff$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f61a10fe7eeb78ff$export$2e2bcd8739ae039 = $f61a10fe7eeb78ff$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $c69d00d5d9b85a64$var$locale = {
    code: 'ht',
    formatDistance: (0, $12e9469258421737$export$2e2bcd8739ae039),
    formatLong: (0, $939a3f00db0f30fb$export$2e2bcd8739ae039),
    formatRelative: (0, $80fc6ed686f906ea$export$2e2bcd8739ae039),
    localize: (0, $64af0b6c6617128c$export$2e2bcd8739ae039),
    match: (0, $f61a10fe7eeb78ff$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c69d00d5d9b85a64$export$2e2bcd8739ae039 = $c69d00d5d9b85a64$var$locale;
module.exports["default"] = $c69d00d5d9b85a64$export$2e2bcd8739ae039;

});

parcelRegister("kOmGW", function(module, exports) {
var $cc3bea7a3c847918$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var $cc3bea7a3c847918$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cc3bea7a3c847918$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
var $cc3bea7a3c847918$export$2e2bcd8739ae039 = $cc3bea7a3c847918$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $fa6c5afafcd1241d$var$dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var $fa6c5afafcd1241d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $fa6c5afafcd1241d$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fa6c5afafcd1241d$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $fa6c5afafcd1241d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fa6c5afafcd1241d$export$2e2bcd8739ae039 = $fa6c5afafcd1241d$var$formatLong;


var $ca4dd8f7f1cc068b$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var $ca4dd8f7f1cc068b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ca4dd8f7f1cc068b$var$formatRelativeLocale[token];
};
var $ca4dd8f7f1cc068b$export$2e2bcd8739ae039 = $ca4dd8f7f1cc068b$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e5a70dbdbec17b0b$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var $e5a70dbdbec17b0b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var $e5a70dbdbec17b0b$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var $e5a70dbdbec17b0b$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var $e5a70dbdbec17b0b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var $e5a70dbdbec17b0b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var $e5a70dbdbec17b0b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var $e5a70dbdbec17b0b$var$localize = {
    ordinalNumber: $e5a70dbdbec17b0b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e5a70dbdbec17b0b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e5a70dbdbec17b0b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e5a70dbdbec17b0b$export$2e2bcd8739ae039 = $e5a70dbdbec17b0b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4940c97c17bee60b$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $4940c97c17bee60b$var$parseOrdinalNumberPattern = /\d+/i;
var $4940c97c17bee60b$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $4940c97c17bee60b$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $4940c97c17bee60b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $4940c97c17bee60b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4940c97c17bee60b$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $4940c97c17bee60b$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $4940c97c17bee60b$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $4940c97c17bee60b$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $4940c97c17bee60b$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $4940c97c17bee60b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $4940c97c17bee60b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4940c97c17bee60b$var$matchOrdinalNumberPattern,
        parsePattern: $4940c97c17bee60b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4940c97c17bee60b$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4940c97c17bee60b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4940c97c17bee60b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4940c97c17bee60b$export$2e2bcd8739ae039 = $4940c97c17bee60b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $f26a144182f8ffd8$var$locale = {
    code: 'hy',
    formatDistance: (0, $cc3bea7a3c847918$export$2e2bcd8739ae039),
    formatLong: (0, $fa6c5afafcd1241d$export$2e2bcd8739ae039),
    formatRelative: (0, $ca4dd8f7f1cc068b$export$2e2bcd8739ae039),
    localize: (0, $e5a70dbdbec17b0b$export$2e2bcd8739ae039),
    match: (0, $4940c97c17bee60b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f26a144182f8ffd8$export$2e2bcd8739ae039 = $f26a144182f8ffd8$var$locale;
module.exports["default"] = $f26a144182f8ffd8$export$2e2bcd8739ae039;

});

parcelRegister("1ZhxU", function(module, exports) {
var $a4b642ca6812ce67$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $a4b642ca6812ce67$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a4b642ca6812ce67$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $a4b642ca6812ce67$export$2e2bcd8739ae039 = $a4b642ca6812ce67$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6eb382ad05339f9e$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $6eb382ad05339f9e$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $6eb382ad05339f9e$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6eb382ad05339f9e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6eb382ad05339f9e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6eb382ad05339f9e$export$2e2bcd8739ae039 = $6eb382ad05339f9e$var$formatLong;


var $7d830fb5166679d6$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var $7d830fb5166679d6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7d830fb5166679d6$var$formatRelativeLocale[token];
};
var $7d830fb5166679d6$export$2e2bcd8739ae039 = $7d830fb5166679d6$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// https://www.unicode.org/cldr/charts/32/summary/id.html
var $1c6f317ec89ef798$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var $1c6f317ec89ef798$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1c6f317ec89ef798$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $1c6f317ec89ef798$var$dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var $1c6f317ec89ef798$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $1c6f317ec89ef798$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $1c6f317ec89ef798$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var $1c6f317ec89ef798$var$localize = {
    ordinalNumber: $1c6f317ec89ef798$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1c6f317ec89ef798$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1c6f317ec89ef798$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1c6f317ec89ef798$export$2e2bcd8739ae039 = $1c6f317ec89ef798$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4dbd016405b9659d$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $4dbd016405b9659d$var$parseOrdinalNumberPattern = /\d+/i;
var $4dbd016405b9659d$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $4dbd016405b9659d$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $4dbd016405b9659d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $4dbd016405b9659d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4dbd016405b9659d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $4dbd016405b9659d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4dbd016405b9659d$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $4dbd016405b9659d$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $4dbd016405b9659d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $4dbd016405b9659d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $4dbd016405b9659d$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4dbd016405b9659d$var$matchOrdinalNumberPattern,
        parsePattern: $4dbd016405b9659d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4dbd016405b9659d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4dbd016405b9659d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4dbd016405b9659d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4dbd016405b9659d$export$2e2bcd8739ae039 = $4dbd016405b9659d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $1729193190f543bd$var$locale = {
    code: 'id',
    formatDistance: (0, $a4b642ca6812ce67$export$2e2bcd8739ae039),
    formatLong: (0, $6eb382ad05339f9e$export$2e2bcd8739ae039),
    formatRelative: (0, $7d830fb5166679d6$export$2e2bcd8739ae039),
    localize: (0, $1c6f317ec89ef798$export$2e2bcd8739ae039),
    match: (0, $4dbd016405b9659d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1729193190f543bd$export$2e2bcd8739ae039 = $1729193190f543bd$var$locale;
module.exports["default"] = $1729193190f543bd$export$2e2bcd8739ae039;

});

parcelRegister("56vLn", function(module, exports) {

var $ellkl = parcelRequire("ellkl");


var $geJmU = parcelRequire("geJmU");


var $c2vlP = parcelRequire("c2vlP");


var $bk6Tz = parcelRequire("bk6Tz");


var $fcGXP = parcelRequire("fcGXP");

var $3dc391f99be53c03$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $3dc391f99be53c03$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3dc391f99be53c03$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $3dc391f99be53c03$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $3dc391f99be53c03$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3dc391f99be53c03$export$2e2bcd8739ae039 = $3dc391f99be53c03$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $3b7626d012109d91$var$locale = {
    code: 'it-CH',
    formatDistance: (0, $ellkl.default),
    formatLong: (0, $3dc391f99be53c03$export$2e2bcd8739ae039),
    formatRelative: (0, $geJmU.default),
    localize: (0, $c2vlP.default),
    match: (0, $bk6Tz.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3b7626d012109d91$export$2e2bcd8739ae039 = $3b7626d012109d91$var$locale;
module.exports["default"] = $3b7626d012109d91$export$2e2bcd8739ae039;

});

parcelRegister("O69wG", function(module, exports) {
var $66027255bb71c244$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var $66027255bb71c244$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $66027255bb71c244$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
var $66027255bb71c244$export$2e2bcd8739ae039 = $66027255bb71c244$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f645f61a599929e8$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $f645f61a599929e8$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $f645f61a599929e8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f645f61a599929e8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f645f61a599929e8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f645f61a599929e8$export$2e2bcd8739ae039 = $f645f61a599929e8$var$formatLong;


var $895f09ac55cffb9d$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var $895f09ac55cffb9d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $895f09ac55cffb9d$var$formatRelativeLocale[token];
};
var $895f09ac55cffb9d$export$2e2bcd8739ae039 = $895f09ac55cffb9d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $09200d1d1fa4ae89$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var $09200d1d1fa4ae89$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var $09200d1d1fa4ae89$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var $09200d1d1fa4ae89$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var $09200d1d1fa4ae89$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $09200d1d1fa4ae89$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $09200d1d1fa4ae89$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var $09200d1d1fa4ae89$var$localize = {
    ordinalNumber: $09200d1d1fa4ae89$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $09200d1d1fa4ae89$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $09200d1d1fa4ae89$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $09200d1d1fa4ae89$export$2e2bcd8739ae039 = $09200d1d1fa4ae89$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b7fe29f5ef2935aa$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $b7fe29f5ef2935aa$var$parseOrdinalNumberPattern = /\d+/i;
var $b7fe29f5ef2935aa$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $b7fe29f5ef2935aa$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $b7fe29f5ef2935aa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $b7fe29f5ef2935aa$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $b7fe29f5ef2935aa$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $b7fe29f5ef2935aa$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $b7fe29f5ef2935aa$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $b7fe29f5ef2935aa$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $b7fe29f5ef2935aa$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $b7fe29f5ef2935aa$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $b7fe29f5ef2935aa$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b7fe29f5ef2935aa$var$matchOrdinalNumberPattern,
        parsePattern: $b7fe29f5ef2935aa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b7fe29f5ef2935aa$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b7fe29f5ef2935aa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b7fe29f5ef2935aa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b7fe29f5ef2935aa$export$2e2bcd8739ae039 = $b7fe29f5ef2935aa$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $09697169fa584236$var$locale = {
    code: 'ja-Hira',
    formatDistance: (0, $66027255bb71c244$export$2e2bcd8739ae039),
    formatLong: (0, $f645f61a599929e8$export$2e2bcd8739ae039),
    formatRelative: (0, $895f09ac55cffb9d$export$2e2bcd8739ae039),
    localize: (0, $09200d1d1fa4ae89$export$2e2bcd8739ae039),
    match: (0, $b7fe29f5ef2935aa$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $09697169fa584236$export$2e2bcd8739ae039 = $09697169fa584236$var$locale;
module.exports["default"] = $09697169fa584236$export$2e2bcd8739ae039;

});

parcelRegister("bDc9o", function(module, exports) {
var $005d7df00ab5c749$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var $005d7df00ab5c749$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $005d7df00ab5c749$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
var $005d7df00ab5c749$export$2e2bcd8739ae039 = $005d7df00ab5c749$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6d0da585d6977313$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var $6d0da585d6977313$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $6d0da585d6977313$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6d0da585d6977313$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6d0da585d6977313$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6d0da585d6977313$export$2e2bcd8739ae039 = $6d0da585d6977313$var$formatLong;


var $49d1bae32c5d85c1$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var $49d1bae32c5d85c1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $49d1bae32c5d85c1$var$formatRelativeLocale[token];
};
var $49d1bae32c5d85c1$export$2e2bcd8739ae039 = $49d1bae32c5d85c1$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $c734bfc73db01838$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var $c734bfc73db01838$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c734bfc73db01838$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var $c734bfc73db01838$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var $c734bfc73db01838$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var $c734bfc73db01838$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var $c734bfc73db01838$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var $c734bfc73db01838$var$localize = {
    ordinalNumber: $c734bfc73db01838$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c734bfc73db01838$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c734bfc73db01838$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c734bfc73db01838$export$2e2bcd8739ae039 = $c734bfc73db01838$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3d791e7a49c7aa8b$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $3d791e7a49c7aa8b$var$parseOrdinalNumberPattern = /\d+/i;
var $3d791e7a49c7aa8b$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $3d791e7a49c7aa8b$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $3d791e7a49c7aa8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $3d791e7a49c7aa8b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3d791e7a49c7aa8b$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $3d791e7a49c7aa8b$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $3d791e7a49c7aa8b$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $3d791e7a49c7aa8b$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $3d791e7a49c7aa8b$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $3d791e7a49c7aa8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $3d791e7a49c7aa8b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3d791e7a49c7aa8b$var$matchOrdinalNumberPattern,
        parsePattern: $3d791e7a49c7aa8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3d791e7a49c7aa8b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3d791e7a49c7aa8b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3d791e7a49c7aa8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3d791e7a49c7aa8b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3d791e7a49c7aa8b$export$2e2bcd8739ae039 = $3d791e7a49c7aa8b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $877cc31222df215b$var$locale = {
    code: 'ka',
    formatDistance: (0, $005d7df00ab5c749$export$2e2bcd8739ae039),
    formatLong: (0, $6d0da585d6977313$export$2e2bcd8739ae039),
    formatRelative: (0, $49d1bae32c5d85c1$export$2e2bcd8739ae039),
    localize: (0, $c734bfc73db01838$export$2e2bcd8739ae039),
    match: (0, $3d791e7a49c7aa8b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $877cc31222df215b$export$2e2bcd8739ae039 = $877cc31222df215b$var$locale;
module.exports["default"] = $877cc31222df215b$export$2e2bcd8739ae039;

});

parcelRegister("5U0go", function(module, exports) {
var $52b4f252d39cc465$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $52b4f252d39cc465$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var $52b4f252d39cc465$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $52b4f252d39cc465$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $52b4f252d39cc465$var$declension(tokenValue.future, count);
            else return $52b4f252d39cc465$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $52b4f252d39cc465$var$declension(tokenValue.past, count);
            else return $52b4f252d39cc465$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $52b4f252d39cc465$var$declension(tokenValue.regular, count);
};
var $52b4f252d39cc465$export$2e2bcd8739ae039 = $52b4f252d39cc465$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $579428ac7180bb68$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var $579428ac7180bb68$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $579428ac7180bb68$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $579428ac7180bb68$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $579428ac7180bb68$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $579428ac7180bb68$export$2e2bcd8739ae039 = $579428ac7180bb68$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $71f1fe58755fe129$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $71f1fe58755fe129$var$_lastWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $71f1fe58755fe129$var$thisWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $71f1fe58755fe129$var$_nextWeek(day) {
    var weekday = $71f1fe58755fe129$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var $71f1fe58755fe129$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $71f1fe58755fe129$var$thisWeek(day);
        else return $71f1fe58755fe129$var$_lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $71f1fe58755fe129$var$thisWeek(day);
        else return $71f1fe58755fe129$var$_nextWeek(day);
    },
    other: 'P'
};
var $71f1fe58755fe129$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $71f1fe58755fe129$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $71f1fe58755fe129$export$2e2bcd8739ae039 = $71f1fe58755fe129$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $ce94cd106747f6bd$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var $ce94cd106747f6bd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $ce94cd106747f6bd$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var $ce94cd106747f6bd$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var $ce94cd106747f6bd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var $ce94cd106747f6bd$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var $ce94cd106747f6bd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $ce94cd106747f6bd$var$suffixes[number] || $ce94cd106747f6bd$var$suffixes[mod10] || b && $ce94cd106747f6bd$var$suffixes[b] || '';
    return number + suffix;
};
var $ce94cd106747f6bd$var$localize = {
    ordinalNumber: $ce94cd106747f6bd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $ce94cd106747f6bd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $ce94cd106747f6bd$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $ce94cd106747f6bd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ce94cd106747f6bd$export$2e2bcd8739ae039 = $ce94cd106747f6bd$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $1a36bf9f30a0e53c$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $1a36bf9f30a0e53c$var$parseOrdinalNumberPattern = /\d+/i;
var $1a36bf9f30a0e53c$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $1a36bf9f30a0e53c$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $1a36bf9f30a0e53c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $1a36bf9f30a0e53c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1a36bf9f30a0e53c$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $1a36bf9f30a0e53c$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $1a36bf9f30a0e53c$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $1a36bf9f30a0e53c$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $1a36bf9f30a0e53c$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $1a36bf9f30a0e53c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $1a36bf9f30a0e53c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $1a36bf9f30a0e53c$var$matchOrdinalNumberPattern,
        parsePattern: $1a36bf9f30a0e53c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $1a36bf9f30a0e53c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1a36bf9f30a0e53c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1a36bf9f30a0e53c$export$2e2bcd8739ae039 = $1a36bf9f30a0e53c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $44c2630ac689a09d$var$locale = {
    code: 'kk',
    formatDistance: (0, $52b4f252d39cc465$export$2e2bcd8739ae039),
    formatLong: (0, $579428ac7180bb68$export$2e2bcd8739ae039),
    formatRelative: (0, $71f1fe58755fe129$export$2e2bcd8739ae039),
    localize: (0, $ce94cd106747f6bd$export$2e2bcd8739ae039),
    match: (0, $1a36bf9f30a0e53c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $44c2630ac689a09d$export$2e2bcd8739ae039 = $44c2630ac689a09d$var$locale;
module.exports["default"] = $44c2630ac689a09d$export$2e2bcd8739ae039;

});

parcelRegister("kNEVA", function(module, exports) {
var $45de21bb0ca0a89b$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var $45de21bb0ca0a89b$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $45de21bb0ca0a89b$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
var $45de21bb0ca0a89b$export$2e2bcd8739ae039 = $45de21bb0ca0a89b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $1a43eee8e3514c2f$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $1a43eee8e3514c2f$var$timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1a43eee8e3514c2f$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1a43eee8e3514c2f$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $1a43eee8e3514c2f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1a43eee8e3514c2f$export$2e2bcd8739ae039 = $1a43eee8e3514c2f$var$formatLong;


var $4913e2b2e49b4a27$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var $4913e2b2e49b4a27$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4913e2b2e49b4a27$var$formatRelativeLocale[token];
};
var $4913e2b2e49b4a27$export$2e2bcd8739ae039 = $4913e2b2e49b4a27$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $fa8bcb65fbc37bbf$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var $fa8bcb65fbc37bbf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var $fa8bcb65fbc37bbf$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var $fa8bcb65fbc37bbf$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var $fa8bcb65fbc37bbf$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $fa8bcb65fbc37bbf$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $fa8bcb65fbc37bbf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $fa8bcb65fbc37bbf$var$localize = {
    ordinalNumber: $fa8bcb65fbc37bbf$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $fa8bcb65fbc37bbf$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $fa8bcb65fbc37bbf$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $fa8bcb65fbc37bbf$export$2e2bcd8739ae039 = $fa8bcb65fbc37bbf$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $963c43d54611b540$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $963c43d54611b540$var$parseOrdinalNumberPattern = /\d+/i;
var $963c43d54611b540$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $963c43d54611b540$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $963c43d54611b540$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $963c43d54611b540$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $963c43d54611b540$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $963c43d54611b540$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $963c43d54611b540$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $963c43d54611b540$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $963c43d54611b540$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $963c43d54611b540$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $963c43d54611b540$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $963c43d54611b540$var$matchOrdinalNumberPattern,
        parsePattern: $963c43d54611b540$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $963c43d54611b540$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $963c43d54611b540$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $963c43d54611b540$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $963c43d54611b540$export$2e2bcd8739ae039 = $963c43d54611b540$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $f24821a5b064f160$var$locale = {
    code: 'km',
    formatDistance: (0, $45de21bb0ca0a89b$export$2e2bcd8739ae039),
    formatLong: (0, $1a43eee8e3514c2f$export$2e2bcd8739ae039),
    formatRelative: (0, $4913e2b2e49b4a27$export$2e2bcd8739ae039),
    localize: (0, $fa8bcb65fbc37bbf$export$2e2bcd8739ae039),
    match: (0, $963c43d54611b540$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f24821a5b064f160$export$2e2bcd8739ae039 = $f24821a5b064f160$var$locale;
module.exports["default"] = $f24821a5b064f160$export$2e2bcd8739ae039;

});

parcelRegister("dv5xe", function(module, exports) {
// note: no implementation for weeks
var $97d24967eacd1186$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $97d24967eacd1186$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $97d24967eacd1186$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $97d24967eacd1186$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $97d24967eacd1186$var$getResultByTense(tokenValue.one, options);
    else result = $97d24967eacd1186$var$getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
var $97d24967eacd1186$export$2e2bcd8739ae039 = $97d24967eacd1186$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6b7efba750647d27$var$dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var $6b7efba750647d27$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var $6b7efba750647d27$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var $6b7efba750647d27$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6b7efba750647d27$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6b7efba750647d27$export$2e2bcd8739ae039 = $6b7efba750647d27$var$formatLong;


var $edb2f44bce7e28f5$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var $edb2f44bce7e28f5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $edb2f44bce7e28f5$var$formatRelativeLocale[token];
};
var $edb2f44bce7e28f5$export$2e2bcd8739ae039 = $edb2f44bce7e28f5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $776315a63575708a$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var $776315a63575708a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $776315a63575708a$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var $776315a63575708a$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var $776315a63575708a$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $776315a63575708a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $776315a63575708a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var $776315a63575708a$var$localize = {
    ordinalNumber: $776315a63575708a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $776315a63575708a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $776315a63575708a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $776315a63575708a$export$2e2bcd8739ae039 = $776315a63575708a$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7a3fd193d2180ce9$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $7a3fd193d2180ce9$var$parseOrdinalNumberPattern = /\d+/i;
var $7a3fd193d2180ce9$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $7a3fd193d2180ce9$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $7a3fd193d2180ce9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $7a3fd193d2180ce9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7a3fd193d2180ce9$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $7a3fd193d2180ce9$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $7a3fd193d2180ce9$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $7a3fd193d2180ce9$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $7a3fd193d2180ce9$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $7a3fd193d2180ce9$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $7a3fd193d2180ce9$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7a3fd193d2180ce9$var$matchOrdinalNumberPattern,
        parsePattern: $7a3fd193d2180ce9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7a3fd193d2180ce9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7a3fd193d2180ce9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7a3fd193d2180ce9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7a3fd193d2180ce9$export$2e2bcd8739ae039 = $7a3fd193d2180ce9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $9d4276bb8cd8c998$var$locale = {
    code: 'kn',
    formatDistance: (0, $97d24967eacd1186$export$2e2bcd8739ae039),
    formatLong: (0, $6b7efba750647d27$export$2e2bcd8739ae039),
    formatRelative: (0, $edb2f44bce7e28f5$export$2e2bcd8739ae039),
    localize: (0, $776315a63575708a$export$2e2bcd8739ae039),
    match: (0, $7a3fd193d2180ce9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $9d4276bb8cd8c998$export$2e2bcd8739ae039 = $9d4276bb8cd8c998$var$locale;
module.exports["default"] = $9d4276bb8cd8c998$export$2e2bcd8739ae039;

});

parcelRegister("a6iKE", function(module, exports) {
var $c83f7ecba3f0f0b0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var $c83f7ecba3f0f0b0$var$EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var $c83f7ecba3f0f0b0$var$VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var $c83f7ecba3f0f0b0$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $c83f7ecba3f0f0b0$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $c83f7ecba3f0f0b0$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($c83f7ecba3f0f0b0$var$VOWELS.indexOf(firstLetter) != -1 || $c83f7ecba3f0f0b0$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $c83f7ecba3f0f0b0$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $c83f7ecba3f0f0b0$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $c83f7ecba3f0f0b0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c83f7ecba3f0f0b0$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + ($c83f7ecba3f0f0b0$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + ($c83f7ecba3f0f0b0$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
var $c83f7ecba3f0f0b0$export$2e2bcd8739ae039 = $c83f7ecba3f0f0b0$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $c7c6cd06308059d7$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var $c7c6cd06308059d7$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c7c6cd06308059d7$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c7c6cd06308059d7$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c7c6cd06308059d7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c7c6cd06308059d7$export$2e2bcd8739ae039 = $c7c6cd06308059d7$var$formatLong;


var $e113410456dbcbd3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $e113410456dbcbd3$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $e113410456dbcbd3$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $e113410456dbcbd3$export$2e2bcd8739ae039 = $e113410456dbcbd3$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $fca65a60c0cf6d5b$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var $fca65a60c0cf6d5b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var $fca65a60c0cf6d5b$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var $fca65a60c0cf6d5b$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var $fca65a60c0cf6d5b$var$dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var $fca65a60c0cf6d5b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var $fca65a60c0cf6d5b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $fca65a60c0cf6d5b$var$localize = {
    ordinalNumber: $fca65a60c0cf6d5b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $fca65a60c0cf6d5b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $fca65a60c0cf6d5b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $fca65a60c0cf6d5b$export$2e2bcd8739ae039 = $fca65a60c0cf6d5b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $e628cc10b21dd87f$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e628cc10b21dd87f$var$parseOrdinalNumberPattern = /\d+/i;
var $e628cc10b21dd87f$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $e628cc10b21dd87f$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $e628cc10b21dd87f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $e628cc10b21dd87f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e628cc10b21dd87f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $e628cc10b21dd87f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e628cc10b21dd87f$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $e628cc10b21dd87f$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $e628cc10b21dd87f$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $e628cc10b21dd87f$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $e628cc10b21dd87f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $e628cc10b21dd87f$var$matchOrdinalNumberPattern,
        parsePattern: $e628cc10b21dd87f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $e628cc10b21dd87f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e628cc10b21dd87f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e628cc10b21dd87f$export$2e2bcd8739ae039 = $e628cc10b21dd87f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $75a90291e110f884$var$locale = {
    code: 'lb',
    formatDistance: (0, $c83f7ecba3f0f0b0$export$2e2bcd8739ae039),
    formatLong: (0, $c7c6cd06308059d7$export$2e2bcd8739ae039),
    formatRelative: (0, $e113410456dbcbd3$export$2e2bcd8739ae039),
    localize: (0, $fca65a60c0cf6d5b$export$2e2bcd8739ae039),
    match: (0, $e628cc10b21dd87f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $75a90291e110f884$export$2e2bcd8739ae039 = $75a90291e110f884$var$locale;
module.exports["default"] = $75a90291e110f884$export$2e2bcd8739ae039;

});

parcelRegister("9Z9AE", function(module, exports) {
var $54329adf6acb8089$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var $54329adf6acb8089$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var $54329adf6acb8089$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $54329adf6acb8089$var$forms(key)[0] : isFuture ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[2];
};
var $54329adf6acb8089$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + $54329adf6acb8089$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($54329adf6acb8089$var$special(number) ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[0]);
    else {
        if (isFuture) return result + $54329adf6acb8089$var$forms(key)[1];
        else return result + ($54329adf6acb8089$var$special(number) ? $54329adf6acb8089$var$forms(key)[1] : $54329adf6acb8089$var$forms(key)[2]);
    }
};
function $54329adf6acb8089$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $54329adf6acb8089$var$forms(key) {
    return $54329adf6acb8089$var$translations[key].split('_');
}
var $54329adf6acb8089$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $54329adf6acb8089$var$translateSeconds,
        other: $54329adf6acb8089$var$translate
    },
    xSeconds: {
        one: $54329adf6acb8089$var$translateSeconds,
        other: $54329adf6acb8089$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xMinutes: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXHours: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xHours: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xDays: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXWeeks: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xWeeks: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXMonths: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xMonths: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    aboutXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    xYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    overXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    },
    almostXYears: {
        one: $54329adf6acb8089$var$translateSingular,
        other: $54329adf6acb8089$var$translate
    }
};
var $54329adf6acb8089$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $54329adf6acb8089$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $54329adf6acb8089$var$translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
var $54329adf6acb8089$export$2e2bcd8739ae039 = $54329adf6acb8089$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $6a75f66e2353f8ff$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var $6a75f66e2353f8ff$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6a75f66e2353f8ff$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6a75f66e2353f8ff$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6a75f66e2353f8ff$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6a75f66e2353f8ff$export$2e2bcd8739ae039 = $6a75f66e2353f8ff$var$formatLong;


var $a8232bfcb96c009f$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var $a8232bfcb96c009f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a8232bfcb96c009f$var$formatRelativeLocale[token];
};
var $a8232bfcb96c009f$export$2e2bcd8739ae039 = $a8232bfcb96c009f$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $401c4b93c50401bc$var$eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var $401c4b93c50401bc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $401c4b93c50401bc$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $401c4b93c50401bc$var$monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var $401c4b93c50401bc$var$formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var $401c4b93c50401bc$var$dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var $401c4b93c50401bc$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var $401c4b93c50401bc$var$dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $401c4b93c50401bc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $401c4b93c50401bc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var $401c4b93c50401bc$var$localize = {
    ordinalNumber: $401c4b93c50401bc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $401c4b93c50401bc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $401c4b93c50401bc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $401c4b93c50401bc$export$2e2bcd8739ae039 = $401c4b93c50401bc$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $89d00f1d25d790b6$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $89d00f1d25d790b6$var$parseOrdinalNumberPattern = /\d+/i;
var $89d00f1d25d790b6$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $89d00f1d25d790b6$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $89d00f1d25d790b6$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $89d00f1d25d790b6$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $89d00f1d25d790b6$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $89d00f1d25d790b6$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $89d00f1d25d790b6$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $89d00f1d25d790b6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $89d00f1d25d790b6$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $89d00f1d25d790b6$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $89d00f1d25d790b6$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $89d00f1d25d790b6$var$matchOrdinalNumberPattern,
        parsePattern: $89d00f1d25d790b6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89d00f1d25d790b6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $89d00f1d25d790b6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $89d00f1d25d790b6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $89d00f1d25d790b6$export$2e2bcd8739ae039 = $89d00f1d25d790b6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $74513ff69c3b5b9b$var$locale = {
    code: 'lt',
    formatDistance: (0, $54329adf6acb8089$export$2e2bcd8739ae039),
    formatLong: (0, $6a75f66e2353f8ff$export$2e2bcd8739ae039),
    formatRelative: (0, $a8232bfcb96c009f$export$2e2bcd8739ae039),
    localize: (0, $401c4b93c50401bc$export$2e2bcd8739ae039),
    match: (0, $89d00f1d25d790b6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $74513ff69c3b5b9b$export$2e2bcd8739ae039 = $74513ff69c3b5b9b$var$locale;
module.exports["default"] = $74513ff69c3b5b9b$export$2e2bcd8739ae039;

});

parcelRegister("hskCx", function(module, exports) {
function $c4531ec11ec67017$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var $c4531ec11ec67017$var$formatDistanceLocale = {
    lessThanXSeconds: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: $c4531ec11ec67017$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var $c4531ec11ec67017$var$formatDistance = function formatDistance(token, count, options) {
    var result = $c4531ec11ec67017$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
var $c4531ec11ec67017$export$2e2bcd8739ae039 = $c4531ec11ec67017$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $70a0c1e25812278d$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var $70a0c1e25812278d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $70a0c1e25812278d$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $70a0c1e25812278d$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $70a0c1e25812278d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $70a0c1e25812278d$export$2e2bcd8739ae039 = $70a0c1e25812278d$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $52283af7c315694c$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var $52283af7c315694c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $gQ473.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $52283af7c315694c$var$weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $gQ473.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $52283af7c315694c$var$weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var $52283af7c315694c$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $52283af7c315694c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $52283af7c315694c$export$2e2bcd8739ae039 = $52283af7c315694c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $94ff1f0d217179ff$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var $94ff1f0d217179ff$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var $94ff1f0d217179ff$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var $94ff1f0d217179ff$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var $94ff1f0d217179ff$var$formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var $94ff1f0d217179ff$var$dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var $94ff1f0d217179ff$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var $94ff1f0d217179ff$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var $94ff1f0d217179ff$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var $94ff1f0d217179ff$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $94ff1f0d217179ff$var$localize = {
    ordinalNumber: $94ff1f0d217179ff$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $94ff1f0d217179ff$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $94ff1f0d217179ff$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $94ff1f0d217179ff$export$2e2bcd8739ae039 = $94ff1f0d217179ff$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $b0cd0a84d61e0dc1$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $b0cd0a84d61e0dc1$var$parseOrdinalNumberPattern = /\d+/i;
var $b0cd0a84d61e0dc1$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $b0cd0a84d61e0dc1$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $b0cd0a84d61e0dc1$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $b0cd0a84d61e0dc1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $b0cd0a84d61e0dc1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $b0cd0a84d61e0dc1$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $b0cd0a84d61e0dc1$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $b0cd0a84d61e0dc1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $b0cd0a84d61e0dc1$var$matchOrdinalNumberPattern,
        parsePattern: $b0cd0a84d61e0dc1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $b0cd0a84d61e0dc1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b0cd0a84d61e0dc1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b0cd0a84d61e0dc1$export$2e2bcd8739ae039 = $b0cd0a84d61e0dc1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $cb550c0314b78ea3$var$locale = {
    code: 'lv',
    formatDistance: (0, $c4531ec11ec67017$export$2e2bcd8739ae039),
    formatLong: (0, $70a0c1e25812278d$export$2e2bcd8739ae039),
    formatRelative: (0, $52283af7c315694c$export$2e2bcd8739ae039),
    localize: (0, $94ff1f0d217179ff$export$2e2bcd8739ae039),
    match: (0, $b0cd0a84d61e0dc1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $cb550c0314b78ea3$export$2e2bcd8739ae039 = $cb550c0314b78ea3$var$locale;
module.exports["default"] = $cb550c0314b78ea3$export$2e2bcd8739ae039;

});

parcelRegister("678Ci", function(module, exports) {
var $38e2b37ba914e452$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $38e2b37ba914e452$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $38e2b37ba914e452$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
var $38e2b37ba914e452$export$2e2bcd8739ae039 = $38e2b37ba914e452$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $868d6b47fbbcda84$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $868d6b47fbbcda84$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $868d6b47fbbcda84$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $868d6b47fbbcda84$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $868d6b47fbbcda84$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $868d6b47fbbcda84$export$2e2bcd8739ae039 = $868d6b47fbbcda84$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $c07fb254ca400e91$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $c07fb254ca400e91$var$_lastWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $c07fb254ca400e91$var$thisWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $c07fb254ca400e91$var$_nextWeek(day) {
    var weekday = $c07fb254ca400e91$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var $c07fb254ca400e91$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $c07fb254ca400e91$var$thisWeek(day);
        else return $c07fb254ca400e91$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $c07fb254ca400e91$var$thisWeek(day);
        else return $c07fb254ca400e91$var$_nextWeek(day);
    },
    other: 'P'
};
var $c07fb254ca400e91$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $c07fb254ca400e91$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $c07fb254ca400e91$export$2e2bcd8739ae039 = $c07fb254ca400e91$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e60acd06b2ad8108$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $e60acd06b2ad8108$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $e60acd06b2ad8108$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $e60acd06b2ad8108$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var $e60acd06b2ad8108$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var $e60acd06b2ad8108$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var $e60acd06b2ad8108$var$localize = {
    ordinalNumber: $e60acd06b2ad8108$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e60acd06b2ad8108$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e60acd06b2ad8108$export$2e2bcd8739ae039 = $e60acd06b2ad8108$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $a0ca05f3aabab83f$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $a0ca05f3aabab83f$var$parseOrdinalNumberPattern = /\d+/i;
var $a0ca05f3aabab83f$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $a0ca05f3aabab83f$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $a0ca05f3aabab83f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $a0ca05f3aabab83f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0ca05f3aabab83f$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $a0ca05f3aabab83f$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $a0ca05f3aabab83f$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $a0ca05f3aabab83f$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $a0ca05f3aabab83f$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $a0ca05f3aabab83f$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $a0ca05f3aabab83f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $a0ca05f3aabab83f$var$matchOrdinalNumberPattern,
        parsePattern: $a0ca05f3aabab83f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a0ca05f3aabab83f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $a0ca05f3aabab83f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a0ca05f3aabab83f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a0ca05f3aabab83f$export$2e2bcd8739ae039 = $a0ca05f3aabab83f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $473a149f18af00f6$var$locale = {
    code: 'mk',
    formatDistance: (0, $38e2b37ba914e452$export$2e2bcd8739ae039),
    formatLong: (0, $868d6b47fbbcda84$export$2e2bcd8739ae039),
    formatRelative: (0, $c07fb254ca400e91$export$2e2bcd8739ae039),
    localize: (0, $e60acd06b2ad8108$export$2e2bcd8739ae039),
    match: (0, $a0ca05f3aabab83f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $473a149f18af00f6$export$2e2bcd8739ae039 = $473a149f18af00f6$var$locale;
module.exports["default"] = $473a149f18af00f6$export$2e2bcd8739ae039;

});

parcelRegister("2QzpI", function(module, exports) {
var $e810e4e5450b9d02$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var $e810e4e5450b9d02$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e810e4e5450b9d02$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
var $e810e4e5450b9d02$export$2e2bcd8739ae039 = $e810e4e5450b9d02$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $352dae2a336c4394$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var $352dae2a336c4394$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $352dae2a336c4394$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $352dae2a336c4394$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $352dae2a336c4394$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $352dae2a336c4394$export$2e2bcd8739ae039 = $352dae2a336c4394$var$formatLong;


var $c21320992b3177f4$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var $c21320992b3177f4$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c21320992b3177f4$var$formatRelativeLocale[token];
};
var $c21320992b3177f4$export$2e2bcd8739ae039 = $c21320992b3177f4$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e37ecca7df4d0d01$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var $e37ecca7df4d0d01$var$quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $e37ecca7df4d0d01$var$monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $e37ecca7df4d0d01$var$formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $e37ecca7df4d0d01$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var $e37ecca7df4d0d01$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var $e37ecca7df4d0d01$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var $e37ecca7df4d0d01$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $e37ecca7df4d0d01$var$localize = {
    ordinalNumber: $e37ecca7df4d0d01$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $e37ecca7df4d0d01$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $e37ecca7df4d0d01$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e37ecca7df4d0d01$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e37ecca7df4d0d01$export$2e2bcd8739ae039 = $e37ecca7df4d0d01$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $97cfa91eb6b85723$var$matchOrdinalNumberPattern = /\d+/i;
var $97cfa91eb6b85723$var$parseOrdinalNumberPattern = /\d+/i;
var $97cfa91eb6b85723$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $97cfa91eb6b85723$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $97cfa91eb6b85723$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $97cfa91eb6b85723$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $97cfa91eb6b85723$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $97cfa91eb6b85723$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $97cfa91eb6b85723$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $97cfa91eb6b85723$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $97cfa91eb6b85723$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $97cfa91eb6b85723$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $97cfa91eb6b85723$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $97cfa91eb6b85723$var$matchOrdinalNumberPattern,
        parsePattern: $97cfa91eb6b85723$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97cfa91eb6b85723$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $97cfa91eb6b85723$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $97cfa91eb6b85723$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $97cfa91eb6b85723$export$2e2bcd8739ae039 = $97cfa91eb6b85723$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $212be88776eaf75b$var$locale = {
    code: 'mn',
    formatDistance: (0, $e810e4e5450b9d02$export$2e2bcd8739ae039),
    formatLong: (0, $352dae2a336c4394$export$2e2bcd8739ae039),
    formatRelative: (0, $c21320992b3177f4$export$2e2bcd8739ae039),
    localize: (0, $e37ecca7df4d0d01$export$2e2bcd8739ae039),
    match: (0, $97cfa91eb6b85723$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $212be88776eaf75b$export$2e2bcd8739ae039 = $212be88776eaf75b$var$locale;
module.exports["default"] = $212be88776eaf75b$export$2e2bcd8739ae039;

});

parcelRegister("5CNN8", function(module, exports) {
var $bbc53934109fa733$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $bbc53934109fa733$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bbc53934109fa733$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $bbc53934109fa733$export$2e2bcd8739ae039 = $bbc53934109fa733$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $37bbceb49b350fc8$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $37bbceb49b350fc8$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $37bbceb49b350fc8$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $37bbceb49b350fc8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $37bbceb49b350fc8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $37bbceb49b350fc8$export$2e2bcd8739ae039 = $37bbceb49b350fc8$var$formatLong;


var $b32d1fd63afd0e78$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var $b32d1fd63afd0e78$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b32d1fd63afd0e78$var$formatRelativeLocale[token];
};
var $b32d1fd63afd0e78$export$2e2bcd8739ae039 = $b32d1fd63afd0e78$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $d7391c0bf4ff28af$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var $d7391c0bf4ff28af$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d7391c0bf4ff28af$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var $d7391c0bf4ff28af$var$dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var $d7391c0bf4ff28af$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $d7391c0bf4ff28af$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $d7391c0bf4ff28af$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var $d7391c0bf4ff28af$var$localize = {
    ordinalNumber: $d7391c0bf4ff28af$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d7391c0bf4ff28af$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d7391c0bf4ff28af$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d7391c0bf4ff28af$export$2e2bcd8739ae039 = $d7391c0bf4ff28af$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $eabc763c6dd11778$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $eabc763c6dd11778$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $eabc763c6dd11778$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $eabc763c6dd11778$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $eabc763c6dd11778$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $eabc763c6dd11778$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $eabc763c6dd11778$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $eabc763c6dd11778$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $eabc763c6dd11778$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $eabc763c6dd11778$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $eabc763c6dd11778$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $eabc763c6dd11778$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $eabc763c6dd11778$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $eabc763c6dd11778$var$matchOrdinalNumberPattern,
        parsePattern: $eabc763c6dd11778$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $eabc763c6dd11778$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $eabc763c6dd11778$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $eabc763c6dd11778$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $eabc763c6dd11778$export$2e2bcd8739ae039 = $eabc763c6dd11778$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $41871fe51a1f0fa9$var$locale = {
    code: 'ms',
    formatDistance: (0, $bbc53934109fa733$export$2e2bcd8739ae039),
    formatLong: (0, $37bbceb49b350fc8$export$2e2bcd8739ae039),
    formatRelative: (0, $b32d1fd63afd0e78$export$2e2bcd8739ae039),
    localize: (0, $d7391c0bf4ff28af$export$2e2bcd8739ae039),
    match: (0, $eabc763c6dd11778$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $41871fe51a1f0fa9$export$2e2bcd8739ae039 = $41871fe51a1f0fa9$var$locale;
module.exports["default"] = $41871fe51a1f0fa9$export$2e2bcd8739ae039;

});

parcelRegister("3SSHw", function(module, exports) {
var $1b8fb988881d4677$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var $1b8fb988881d4677$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1b8fb988881d4677$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
var $1b8fb988881d4677$export$2e2bcd8739ae039 = $1b8fb988881d4677$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cc0f3d79cd7a78e1$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $cc0f3d79cd7a78e1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cc0f3d79cd7a78e1$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $cc0f3d79cd7a78e1$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cc0f3d79cd7a78e1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cc0f3d79cd7a78e1$export$2e2bcd8739ae039 = $cc0f3d79cd7a78e1$var$formatLong;


var $a8fdaa0ba623362d$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var $a8fdaa0ba623362d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a8fdaa0ba623362d$var$formatRelativeLocale[token];
};
var $a8fdaa0ba623362d$export$2e2bcd8739ae039 = $a8fdaa0ba623362d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $04c04cb13867a139$var$eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var $04c04cb13867a139$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var $04c04cb13867a139$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var $04c04cb13867a139$var$dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var $04c04cb13867a139$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var $04c04cb13867a139$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var $04c04cb13867a139$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $04c04cb13867a139$var$localize = {
    ordinalNumber: $04c04cb13867a139$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $04c04cb13867a139$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $04c04cb13867a139$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $04c04cb13867a139$export$2e2bcd8739ae039 = $04c04cb13867a139$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $99e10bd1e560d471$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $99e10bd1e560d471$var$parseOrdinalNumberPattern = /\d+/i;
var $99e10bd1e560d471$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $99e10bd1e560d471$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $99e10bd1e560d471$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $99e10bd1e560d471$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $99e10bd1e560d471$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $99e10bd1e560d471$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $99e10bd1e560d471$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $99e10bd1e560d471$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $99e10bd1e560d471$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $99e10bd1e560d471$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $99e10bd1e560d471$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $99e10bd1e560d471$var$matchOrdinalNumberPattern,
        parsePattern: $99e10bd1e560d471$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $99e10bd1e560d471$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $99e10bd1e560d471$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $99e10bd1e560d471$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $99e10bd1e560d471$export$2e2bcd8739ae039 = $99e10bd1e560d471$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $2d40d8bbfdb109fe$var$locale = {
    code: 'mt',
    formatDistance: (0, $1b8fb988881d4677$export$2e2bcd8739ae039),
    formatLong: (0, $cc0f3d79cd7a78e1$export$2e2bcd8739ae039),
    formatRelative: (0, $a8fdaa0ba623362d$export$2e2bcd8739ae039),
    localize: (0, $04c04cb13867a139$export$2e2bcd8739ae039),
    match: (0, $99e10bd1e560d471$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2d40d8bbfdb109fe$export$2e2bcd8739ae039 = $2d40d8bbfdb109fe$var$locale;
module.exports["default"] = $2d40d8bbfdb109fe$export$2e2bcd8739ae039;

});

parcelRegister("3OBut", function(module, exports) {
var $11aacb0c7b81e292$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $11aacb0c7b81e292$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $11aacb0c7b81e292$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $11aacb0c7b81e292$export$2e2bcd8739ae039 = $11aacb0c7b81e292$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $ce23a664b355d3e9$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $ce23a664b355d3e9$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ce23a664b355d3e9$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ce23a664b355d3e9$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ce23a664b355d3e9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ce23a664b355d3e9$export$2e2bcd8739ae039 = $ce23a664b355d3e9$var$formatLong;


var $a094dba7e33d0bfd$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $a094dba7e33d0bfd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a094dba7e33d0bfd$var$formatRelativeLocale[token];
};
var $a094dba7e33d0bfd$export$2e2bcd8739ae039 = $a094dba7e33d0bfd$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $50a92d75eb7ce83f$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $50a92d75eb7ce83f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $50a92d75eb7ce83f$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $50a92d75eb7ce83f$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $50a92d75eb7ce83f$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $50a92d75eb7ce83f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $50a92d75eb7ce83f$var$localize = {
    ordinalNumber: $50a92d75eb7ce83f$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $50a92d75eb7ce83f$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $50a92d75eb7ce83f$export$2e2bcd8739ae039 = $50a92d75eb7ce83f$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $901631b0ebb1db4d$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $901631b0ebb1db4d$var$parseOrdinalNumberPattern = /\d+/i;
var $901631b0ebb1db4d$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $901631b0ebb1db4d$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $901631b0ebb1db4d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $901631b0ebb1db4d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $901631b0ebb1db4d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $901631b0ebb1db4d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $901631b0ebb1db4d$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $901631b0ebb1db4d$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $901631b0ebb1db4d$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $901631b0ebb1db4d$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $901631b0ebb1db4d$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $901631b0ebb1db4d$var$matchOrdinalNumberPattern,
        parsePattern: $901631b0ebb1db4d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $901631b0ebb1db4d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $901631b0ebb1db4d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $901631b0ebb1db4d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $901631b0ebb1db4d$export$2e2bcd8739ae039 = $901631b0ebb1db4d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $2c731f6c6ccdc7d7$var$locale = {
    code: 'nl-BE',
    formatDistance: (0, $11aacb0c7b81e292$export$2e2bcd8739ae039),
    formatLong: (0, $ce23a664b355d3e9$export$2e2bcd8739ae039),
    formatRelative: (0, $a094dba7e33d0bfd$export$2e2bcd8739ae039),
    localize: (0, $50a92d75eb7ce83f$export$2e2bcd8739ae039),
    match: (0, $901631b0ebb1db4d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2c731f6c6ccdc7d7$export$2e2bcd8739ae039 = $2c731f6c6ccdc7d7$var$locale;
module.exports["default"] = $2c731f6c6ccdc7d7$export$2e2bcd8739ae039;

});

parcelRegister("blOmo", function(module, exports) {
var $bb3d2b071e5b0a0b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $bb3d2b071e5b0a0b$var$wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var $bb3d2b071e5b0a0b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bb3d2b071e5b0a0b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $bb3d2b071e5b0a0b$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
var $bb3d2b071e5b0a0b$export$2e2bcd8739ae039 = $bb3d2b071e5b0a0b$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $46829a671889ff1b$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $46829a671889ff1b$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $46829a671889ff1b$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $46829a671889ff1b$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $46829a671889ff1b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $46829a671889ff1b$export$2e2bcd8739ae039 = $46829a671889ff1b$var$formatLong;


var $0d09e7622dee752c$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $0d09e7622dee752c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0d09e7622dee752c$var$formatRelativeLocale[token];
};
var $0d09e7622dee752c$export$2e2bcd8739ae039 = $0d09e7622dee752c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $1e6e9dc176a60a79$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $1e6e9dc176a60a79$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $1e6e9dc176a60a79$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $1e6e9dc176a60a79$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var $1e6e9dc176a60a79$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $1e6e9dc176a60a79$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $1e6e9dc176a60a79$var$localize = {
    ordinalNumber: $1e6e9dc176a60a79$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1e6e9dc176a60a79$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $1e6e9dc176a60a79$export$2e2bcd8739ae039 = $1e6e9dc176a60a79$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $260157d5bf24e2f9$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $260157d5bf24e2f9$var$parseOrdinalNumberPattern = /\d+/i;
var $260157d5bf24e2f9$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $260157d5bf24e2f9$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $260157d5bf24e2f9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $260157d5bf24e2f9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $260157d5bf24e2f9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $260157d5bf24e2f9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $260157d5bf24e2f9$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $260157d5bf24e2f9$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $260157d5bf24e2f9$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $260157d5bf24e2f9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $260157d5bf24e2f9$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $260157d5bf24e2f9$var$matchOrdinalNumberPattern,
        parsePattern: $260157d5bf24e2f9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $260157d5bf24e2f9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $260157d5bf24e2f9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $260157d5bf24e2f9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $260157d5bf24e2f9$export$2e2bcd8739ae039 = $260157d5bf24e2f9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $8438b856cdbd5c09$var$locale = {
    code: 'nn',
    formatDistance: (0, $bb3d2b071e5b0a0b$export$2e2bcd8739ae039),
    formatLong: (0, $46829a671889ff1b$export$2e2bcd8739ae039),
    formatRelative: (0, $0d09e7622dee752c$export$2e2bcd8739ae039),
    localize: (0, $1e6e9dc176a60a79$export$2e2bcd8739ae039),
    match: (0, $260157d5bf24e2f9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8438b856cdbd5c09$export$2e2bcd8739ae039 = $8438b856cdbd5c09$var$locale;
module.exports["default"] = $8438b856cdbd5c09$export$2e2bcd8739ae039;

});

parcelRegister("h5aPN", function(module, exports) {
var $ea5fa2bcb921d4c2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var $ea5fa2bcb921d4c2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ea5fa2bcb921d4c2$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
var $ea5fa2bcb921d4c2$export$2e2bcd8739ae039 = $ea5fa2bcb921d4c2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $acd0ce0420d6464e$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $acd0ce0420d6464e$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $acd0ce0420d6464e$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $acd0ce0420d6464e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $acd0ce0420d6464e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $acd0ce0420d6464e$export$2e2bcd8739ae039 = $acd0ce0420d6464e$var$formatLong;


var $9a19abbbfd2e4b84$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var $9a19abbbfd2e4b84$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9a19abbbfd2e4b84$var$formatRelativeLocale[token];
};
var $9a19abbbfd2e4b84$export$2e2bcd8739ae039 = $9a19abbbfd2e4b84$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $993896cb8fef315c$var$eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $993896cb8fef315c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $993896cb8fef315c$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var $993896cb8fef315c$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var $993896cb8fef315c$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $993896cb8fef315c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var $993896cb8fef315c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var $993896cb8fef315c$var$localize = {
    ordinalNumber: $993896cb8fef315c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $993896cb8fef315c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $993896cb8fef315c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $993896cb8fef315c$export$2e2bcd8739ae039 = $993896cb8fef315c$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $a1079df3ee9e0c14$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $a1079df3ee9e0c14$var$parseOrdinalNumberPattern = /\d+/i;
var $a1079df3ee9e0c14$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $a1079df3ee9e0c14$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $a1079df3ee9e0c14$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $a1079df3ee9e0c14$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a1079df3ee9e0c14$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $a1079df3ee9e0c14$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a1079df3ee9e0c14$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $a1079df3ee9e0c14$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $a1079df3ee9e0c14$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $a1079df3ee9e0c14$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $a1079df3ee9e0c14$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $a1079df3ee9e0c14$var$matchOrdinalNumberPattern,
        parsePattern: $a1079df3ee9e0c14$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a1079df3ee9e0c14$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $a1079df3ee9e0c14$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a1079df3ee9e0c14$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a1079df3ee9e0c14$export$2e2bcd8739ae039 = $a1079df3ee9e0c14$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $c6fb4ec7265e6e58$var$locale = {
    code: 'oc',
    formatDistance: (0, $ea5fa2bcb921d4c2$export$2e2bcd8739ae039),
    formatLong: (0, $acd0ce0420d6464e$export$2e2bcd8739ae039),
    formatRelative: (0, $9a19abbbfd2e4b84$export$2e2bcd8739ae039),
    localize: (0, $993896cb8fef315c$export$2e2bcd8739ae039),
    match: (0, $a1079df3ee9e0c14$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c6fb4ec7265e6e58$export$2e2bcd8739ae039 = $c6fb4ec7265e6e58$var$locale;
module.exports["default"] = $c6fb4ec7265e6e58$export$2e2bcd8739ae039;

});

parcelRegister("bKFGE", function(module, exports) {
function $17de68ded390b230$var$isPluralType(val) {
    return val.one !== undefined;
}
var $17de68ded390b230$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function $17de68ded390b230$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var $17de68ded390b230$var$formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = $17de68ded390b230$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = $17de68ded390b230$var$getFormFromCount(count);
        if ($17de68ded390b230$var$isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
var $17de68ded390b230$export$2e2bcd8739ae039 = $17de68ded390b230$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $ab31f68934a87c9a$var$dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var $ab31f68934a87c9a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ab31f68934a87c9a$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ab31f68934a87c9a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ab31f68934a87c9a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ab31f68934a87c9a$export$2e2bcd8739ae039 = $ab31f68934a87c9a$var$formatLong;


var $dd96cdfd91797cb9$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var $dd96cdfd91797cb9$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $dd96cdfd91797cb9$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $dd96cdfd91797cb9$export$2e2bcd8739ae039 = $dd96cdfd91797cb9$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $31078dbe30a60b94$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var $31078dbe30a60b94$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var $31078dbe30a60b94$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $31078dbe30a60b94$var$dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var $31078dbe30a60b94$var$dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var $31078dbe30a60b94$var$formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var $31078dbe30a60b94$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $31078dbe30a60b94$var$localize = {
    ordinalNumber: $31078dbe30a60b94$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $31078dbe30a60b94$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $31078dbe30a60b94$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $31078dbe30a60b94$export$2e2bcd8739ae039 = $31078dbe30a60b94$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $26e2860cd3e3549e$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $26e2860cd3e3549e$var$parseOrdinalNumberPattern = /\d+/i;
var $26e2860cd3e3549e$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $26e2860cd3e3549e$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $26e2860cd3e3549e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $26e2860cd3e3549e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $26e2860cd3e3549e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $26e2860cd3e3549e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $26e2860cd3e3549e$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $26e2860cd3e3549e$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $26e2860cd3e3549e$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $26e2860cd3e3549e$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $26e2860cd3e3549e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $26e2860cd3e3549e$var$matchOrdinalNumberPattern,
        parsePattern: $26e2860cd3e3549e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $26e2860cd3e3549e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $26e2860cd3e3549e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $26e2860cd3e3549e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $26e2860cd3e3549e$export$2e2bcd8739ae039 = $26e2860cd3e3549e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $88e453c36c670e10$var$locale = {
    code: 'sl',
    formatDistance: (0, $17de68ded390b230$export$2e2bcd8739ae039),
    formatLong: (0, $ab31f68934a87c9a$export$2e2bcd8739ae039),
    formatRelative: (0, $dd96cdfd91797cb9$export$2e2bcd8739ae039),
    localize: (0, $31078dbe30a60b94$export$2e2bcd8739ae039),
    match: (0, $26e2860cd3e3549e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $88e453c36c670e10$export$2e2bcd8739ae039 = $88e453c36c670e10$var$locale;
module.exports["default"] = $88e453c36c670e10$export$2e2bcd8739ae039;

});

parcelRegister("bL8hA", function(module, exports) {
var $b88850c4a5a39786$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var $b88850c4a5a39786$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b88850c4a5a39786$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $b88850c4a5a39786$export$2e2bcd8739ae039 = $b88850c4a5a39786$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $2c21d89f088e6670$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $2c21d89f088e6670$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $2c21d89f088e6670$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2c21d89f088e6670$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $2c21d89f088e6670$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2c21d89f088e6670$export$2e2bcd8739ae039 = $2c21d89f088e6670$var$formatLong;


var $fcb260b9dbabf662$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $fcb260b9dbabf662$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fcb260b9dbabf662$var$formatRelativeLocale[token];
};
var $fcb260b9dbabf662$export$2e2bcd8739ae039 = $fcb260b9dbabf662$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $05ffcfbe310acae3$var$eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var $05ffcfbe310acae3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $05ffcfbe310acae3$var$monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var $05ffcfbe310acae3$var$dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var $05ffcfbe310acae3$var$dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $05ffcfbe310acae3$var$formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $05ffcfbe310acae3$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var $05ffcfbe310acae3$var$localize = {
    ordinalNumber: $05ffcfbe310acae3$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $05ffcfbe310acae3$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $05ffcfbe310acae3$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $05ffcfbe310acae3$export$2e2bcd8739ae039 = $05ffcfbe310acae3$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3c3fffed6cb7350e$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $3c3fffed6cb7350e$var$parseOrdinalNumberPattern = /\d+/i;
var $3c3fffed6cb7350e$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $3c3fffed6cb7350e$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $3c3fffed6cb7350e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $3c3fffed6cb7350e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3c3fffed6cb7350e$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $3c3fffed6cb7350e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $3c3fffed6cb7350e$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $3c3fffed6cb7350e$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $3c3fffed6cb7350e$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $3c3fffed6cb7350e$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $3c3fffed6cb7350e$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3c3fffed6cb7350e$var$matchOrdinalNumberPattern,
        parsePattern: $3c3fffed6cb7350e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3c3fffed6cb7350e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3c3fffed6cb7350e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3c3fffed6cb7350e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3c3fffed6cb7350e$export$2e2bcd8739ae039 = $3c3fffed6cb7350e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $88fa82430361922c$var$locale = {
    code: 'sq',
    formatDistance: (0, $b88850c4a5a39786$export$2e2bcd8739ae039),
    formatLong: (0, $2c21d89f088e6670$export$2e2bcd8739ae039),
    formatRelative: (0, $fcb260b9dbabf662$export$2e2bcd8739ae039),
    localize: (0, $05ffcfbe310acae3$export$2e2bcd8739ae039),
    match: (0, $3c3fffed6cb7350e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $88fa82430361922c$export$2e2bcd8739ae039 = $88fa82430361922c$var$locale;
module.exports["default"] = $88fa82430361922c$export$2e2bcd8739ae039;

});

parcelRegister("1iyef", function(module, exports) {
var $b1a5ec7c73dde335$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var $b1a5ec7c73dde335$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b1a5ec7c73dde335$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
var $b1a5ec7c73dde335$export$2e2bcd8739ae039 = $b1a5ec7c73dde335$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $0001b8e6bbbafa4a$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $0001b8e6bbbafa4a$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $0001b8e6bbbafa4a$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $0001b8e6bbbafa4a$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0001b8e6bbbafa4a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0001b8e6bbbafa4a$export$2e2bcd8739ae039 = $0001b8e6bbbafa4a$var$formatLong;


var $716f8472913c48fe$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var $716f8472913c48fe$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $716f8472913c48fe$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $716f8472913c48fe$export$2e2bcd8739ae039 = $716f8472913c48fe$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $b2d55e8f384e317a$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var $b2d55e8f384e317a$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $b2d55e8f384e317a$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $b2d55e8f384e317a$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $b2d55e8f384e317a$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $b2d55e8f384e317a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $b2d55e8f384e317a$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $b2d55e8f384e317a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $b2d55e8f384e317a$var$localize = {
    ordinalNumber: $b2d55e8f384e317a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b2d55e8f384e317a$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $b2d55e8f384e317a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b2d55e8f384e317a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b2d55e8f384e317a$export$2e2bcd8739ae039 = $b2d55e8f384e317a$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $67771ef1242517f1$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $67771ef1242517f1$var$parseOrdinalNumberPattern = /\d+/i;
var $67771ef1242517f1$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $67771ef1242517f1$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $67771ef1242517f1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $67771ef1242517f1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $67771ef1242517f1$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $67771ef1242517f1$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $67771ef1242517f1$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $67771ef1242517f1$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $67771ef1242517f1$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $67771ef1242517f1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $67771ef1242517f1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $67771ef1242517f1$var$matchOrdinalNumberPattern,
        parsePattern: $67771ef1242517f1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67771ef1242517f1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $67771ef1242517f1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $67771ef1242517f1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $67771ef1242517f1$export$2e2bcd8739ae039 = $67771ef1242517f1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $0f220603889f00e8$var$locale = {
    code: 'sr',
    formatDistance: (0, $b1a5ec7c73dde335$export$2e2bcd8739ae039),
    formatLong: (0, $0001b8e6bbbafa4a$export$2e2bcd8739ae039),
    formatRelative: (0, $716f8472913c48fe$export$2e2bcd8739ae039),
    localize: (0, $b2d55e8f384e317a$export$2e2bcd8739ae039),
    match: (0, $67771ef1242517f1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $0f220603889f00e8$export$2e2bcd8739ae039 = $0f220603889f00e8$var$locale;
module.exports["default"] = $0f220603889f00e8$export$2e2bcd8739ae039;

});

parcelRegister("6AuV3", function(module, exports) {
var $ebb18e1a9736c5e5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $ebb18e1a9736c5e5$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ebb18e1a9736c5e5$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
var $ebb18e1a9736c5e5$export$2e2bcd8739ae039 = $ebb18e1a9736c5e5$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $8f06af5f6a2580dc$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $8f06af5f6a2580dc$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8f06af5f6a2580dc$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $8f06af5f6a2580dc$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $8f06af5f6a2580dc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8f06af5f6a2580dc$export$2e2bcd8739ae039 = $8f06af5f6a2580dc$var$formatLong;


var $ec41f18baa0c98de$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $ec41f18baa0c98de$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $ec41f18baa0c98de$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $ec41f18baa0c98de$export$2e2bcd8739ae039 = $ec41f18baa0c98de$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $104f4b796d67c972$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var $104f4b796d67c972$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $104f4b796d67c972$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $104f4b796d67c972$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $104f4b796d67c972$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $104f4b796d67c972$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $104f4b796d67c972$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $104f4b796d67c972$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $104f4b796d67c972$var$localize = {
    ordinalNumber: $104f4b796d67c972$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $104f4b796d67c972$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $104f4b796d67c972$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $104f4b796d67c972$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $104f4b796d67c972$export$2e2bcd8739ae039 = $104f4b796d67c972$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $425dbc81921db028$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $425dbc81921db028$var$parseOrdinalNumberPattern = /\d+/i;
var $425dbc81921db028$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $425dbc81921db028$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $425dbc81921db028$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $425dbc81921db028$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $425dbc81921db028$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $425dbc81921db028$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $425dbc81921db028$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $425dbc81921db028$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $425dbc81921db028$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $425dbc81921db028$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $425dbc81921db028$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $425dbc81921db028$var$matchOrdinalNumberPattern,
        parsePattern: $425dbc81921db028$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $425dbc81921db028$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $425dbc81921db028$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $425dbc81921db028$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $425dbc81921db028$export$2e2bcd8739ae039 = $425dbc81921db028$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $013cdf55dcd74a60$var$locale = {
    code: 'sr-Latn',
    formatDistance: (0, $ebb18e1a9736c5e5$export$2e2bcd8739ae039),
    formatLong: (0, $8f06af5f6a2580dc$export$2e2bcd8739ae039),
    formatRelative: (0, $ec41f18baa0c98de$export$2e2bcd8739ae039),
    localize: (0, $104f4b796d67c972$export$2e2bcd8739ae039),
    match: (0, $425dbc81921db028$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $013cdf55dcd74a60$export$2e2bcd8739ae039 = $013cdf55dcd74a60$var$locale;
module.exports["default"] = $013cdf55dcd74a60$export$2e2bcd8739ae039;

});

parcelRegister("iZ7nC", function(module, exports) {
function $a2c784cbbde0fca2$var$isPluralType(val) {
    return val.one !== undefined;
}
var $a2c784cbbde0fca2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var $a2c784cbbde0fca2$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = $a2c784cbbde0fca2$var$formatDistanceLocale[token];
    if (!$a2c784cbbde0fca2$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
var $a2c784cbbde0fca2$export$2e2bcd8739ae039 = $a2c784cbbde0fca2$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

// CLDR #1846 - #1849
var $0f4e17aade46fc3e$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var $0f4e17aade46fc3e$var$timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $0f4e17aade46fc3e$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0f4e17aade46fc3e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $0f4e17aade46fc3e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0f4e17aade46fc3e$export$2e2bcd8739ae039 = $0f4e17aade46fc3e$var$formatLong;


var $d2703bfda6306fbc$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var $d2703bfda6306fbc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d2703bfda6306fbc$var$formatRelativeLocale[token];
};
var $d2703bfda6306fbc$export$2e2bcd8739ae039 = $d2703bfda6306fbc$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $28d90120fe093d15$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var $28d90120fe093d15$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var $28d90120fe093d15$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var $28d90120fe093d15$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var $28d90120fe093d15$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var $28d90120fe093d15$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var $28d90120fe093d15$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $28d90120fe093d15$var$localize = {
    ordinalNumber: $28d90120fe093d15$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $28d90120fe093d15$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $28d90120fe093d15$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $28d90120fe093d15$export$2e2bcd8739ae039 = $28d90120fe093d15$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $c5c84d9dc1e46147$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $c5c84d9dc1e46147$var$parseOrdinalNumberPattern = /\d+/i;
var $c5c84d9dc1e46147$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $c5c84d9dc1e46147$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $c5c84d9dc1e46147$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $c5c84d9dc1e46147$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $c5c84d9dc1e46147$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $c5c84d9dc1e46147$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $c5c84d9dc1e46147$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $c5c84d9dc1e46147$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $c5c84d9dc1e46147$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $c5c84d9dc1e46147$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $c5c84d9dc1e46147$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $c5c84d9dc1e46147$var$matchOrdinalNumberPattern,
        parsePattern: $c5c84d9dc1e46147$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c5c84d9dc1e46147$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $c5c84d9dc1e46147$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c5c84d9dc1e46147$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c5c84d9dc1e46147$export$2e2bcd8739ae039 = $c5c84d9dc1e46147$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $dd23a600421da365$var$locale = {
    code: 'ta',
    formatDistance: (0, $a2c784cbbde0fca2$export$2e2bcd8739ae039),
    formatLong: (0, $0f4e17aade46fc3e$export$2e2bcd8739ae039),
    formatRelative: (0, $d2703bfda6306fbc$export$2e2bcd8739ae039),
    localize: (0, $28d90120fe093d15$export$2e2bcd8739ae039),
    match: (0, $c5c84d9dc1e46147$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $dd23a600421da365$export$2e2bcd8739ae039 = $dd23a600421da365$var$locale;
module.exports["default"] = $dd23a600421da365$export$2e2bcd8739ae039;

});

parcelRegister("cz4ad", function(module, exports) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $c97829d24532b1bc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var $c97829d24532b1bc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $c97829d24532b1bc$var$formatDistanceLocale[token].withPreposition : $c97829d24532b1bc$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
var $c97829d24532b1bc$export$2e2bcd8739ae039 = $c97829d24532b1bc$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

// CLDR #1807 - #1811
var $ad642022a6bd54af$var$dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var $ad642022a6bd54af$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var $ad642022a6bd54af$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ad642022a6bd54af$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ad642022a6bd54af$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ad642022a6bd54af$export$2e2bcd8739ae039 = $ad642022a6bd54af$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $2ddaa488616cd720$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var $2ddaa488616cd720$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2ddaa488616cd720$var$formatRelativeLocale[token];
};
var $2ddaa488616cd720$export$2e2bcd8739ae039 = $2ddaa488616cd720$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $d41e3af6d9634a1d$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var $d41e3af6d9634a1d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var $d41e3af6d9634a1d$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var $d41e3af6d9634a1d$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var $d41e3af6d9634a1d$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $d41e3af6d9634a1d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $d41e3af6d9634a1d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var $d41e3af6d9634a1d$var$localize = {
    ordinalNumber: $d41e3af6d9634a1d$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $d41e3af6d9634a1d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d41e3af6d9634a1d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d41e3af6d9634a1d$export$2e2bcd8739ae039 = $d41e3af6d9634a1d$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0c0cf53124a7cb5f$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $0c0cf53124a7cb5f$var$parseOrdinalNumberPattern = /\d+/i;
var $0c0cf53124a7cb5f$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $0c0cf53124a7cb5f$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $0c0cf53124a7cb5f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $0c0cf53124a7cb5f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0c0cf53124a7cb5f$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $0c0cf53124a7cb5f$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $0c0cf53124a7cb5f$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $0c0cf53124a7cb5f$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $0c0cf53124a7cb5f$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $0c0cf53124a7cb5f$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $0c0cf53124a7cb5f$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0c0cf53124a7cb5f$var$matchOrdinalNumberPattern,
        parsePattern: $0c0cf53124a7cb5f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0c0cf53124a7cb5f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0c0cf53124a7cb5f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0c0cf53124a7cb5f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0c0cf53124a7cb5f$export$2e2bcd8739ae039 = $0c0cf53124a7cb5f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $925bfbbb6b5645ba$var$locale = {
    code: 'te',
    formatDistance: (0, $c97829d24532b1bc$export$2e2bcd8739ae039),
    formatLong: (0, $ad642022a6bd54af$export$2e2bcd8739ae039),
    formatRelative: (0, $2ddaa488616cd720$export$2e2bcd8739ae039),
    localize: (0, $d41e3af6d9634a1d$export$2e2bcd8739ae039),
    match: (0, $0c0cf53124a7cb5f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $925bfbbb6b5645ba$export$2e2bcd8739ae039 = $925bfbbb6b5645ba$var$locale;
module.exports["default"] = $925bfbbb6b5645ba$export$2e2bcd8739ae039;

});

parcelRegister("fJC8B", function(module, exports) {
var $e829db4d66c9f675$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var $e829db4d66c9f675$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e829db4d66c9f675$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
var $e829db4d66c9f675$export$2e2bcd8739ae039 = $e829db4d66c9f675$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $70d1647f8fe41014$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $70d1647f8fe41014$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $70d1647f8fe41014$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $70d1647f8fe41014$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $70d1647f8fe41014$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $70d1647f8fe41014$export$2e2bcd8739ae039 = $70d1647f8fe41014$var$formatLong;


var $e175164e889defa4$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var $e175164e889defa4$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e175164e889defa4$var$formatRelativeLocale[token];
};
var $e175164e889defa4$export$2e2bcd8739ae039 = $e175164e889defa4$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $4850993d53703564$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var $4850993d53703564$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $4850993d53703564$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var $4850993d53703564$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var $4850993d53703564$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var $4850993d53703564$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var $4850993d53703564$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $4850993d53703564$var$localize = {
    ordinalNumber: $4850993d53703564$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $4850993d53703564$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4850993d53703564$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4850993d53703564$export$2e2bcd8739ae039 = $4850993d53703564$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $0a8e779d31ea8cea$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0a8e779d31ea8cea$var$parseOrdinalNumberPattern = /\d+/i;
var $0a8e779d31ea8cea$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $0a8e779d31ea8cea$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $0a8e779d31ea8cea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $0a8e779d31ea8cea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0a8e779d31ea8cea$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $0a8e779d31ea8cea$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $0a8e779d31ea8cea$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $0a8e779d31ea8cea$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $0a8e779d31ea8cea$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $0a8e779d31ea8cea$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $0a8e779d31ea8cea$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $0a8e779d31ea8cea$var$matchOrdinalNumberPattern,
        parsePattern: $0a8e779d31ea8cea$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a8e779d31ea8cea$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $0a8e779d31ea8cea$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0a8e779d31ea8cea$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0a8e779d31ea8cea$export$2e2bcd8739ae039 = $0a8e779d31ea8cea$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $b748a45582dcf19c$var$locale = {
    code: 'ug',
    formatDistance: (0, $e829db4d66c9f675$export$2e2bcd8739ae039),
    formatLong: (0, $70d1647f8fe41014$export$2e2bcd8739ae039),
    formatRelative: (0, $e175164e889defa4$export$2e2bcd8739ae039),
    localize: (0, $4850993d53703564$export$2e2bcd8739ae039),
    match: (0, $0a8e779d31ea8cea$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b748a45582dcf19c$export$2e2bcd8739ae039 = $b748a45582dcf19c$var$locale;
module.exports["default"] = $b748a45582dcf19c$export$2e2bcd8739ae039;

});

parcelRegister("74d4N", function(module, exports) {
var $dc578db66e275af8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var $dc578db66e275af8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $dc578db66e275af8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
var $dc578db66e275af8$export$2e2bcd8739ae039 = $dc578db66e275af8$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cfdda3ed87baaa54$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $cfdda3ed87baaa54$var$timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var $cfdda3ed87baaa54$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $cfdda3ed87baaa54$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cfdda3ed87baaa54$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $cfdda3ed87baaa54$export$2e2bcd8739ae039 = $cfdda3ed87baaa54$var$formatLong;


var $8560410d7f1753cc$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var $8560410d7f1753cc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8560410d7f1753cc$var$formatRelativeLocale[token];
};
var $8560410d7f1753cc$export$2e2bcd8739ae039 = $8560410d7f1753cc$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $53603606c32ae9de$var$eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var $53603606c32ae9de$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $53603606c32ae9de$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $53603606c32ae9de$var$dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var $53603606c32ae9de$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $53603606c32ae9de$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $53603606c32ae9de$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $53603606c32ae9de$var$localize = {
    ordinalNumber: $53603606c32ae9de$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $53603606c32ae9de$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $53603606c32ae9de$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $53603606c32ae9de$export$2e2bcd8739ae039 = $53603606c32ae9de$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $dd05b0e9278d6956$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $dd05b0e9278d6956$var$parseOrdinalNumberPattern = /\d+/i;
var $dd05b0e9278d6956$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $dd05b0e9278d6956$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $dd05b0e9278d6956$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $dd05b0e9278d6956$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dd05b0e9278d6956$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $dd05b0e9278d6956$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dd05b0e9278d6956$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $dd05b0e9278d6956$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $dd05b0e9278d6956$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $dd05b0e9278d6956$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $dd05b0e9278d6956$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $dd05b0e9278d6956$var$matchOrdinalNumberPattern,
        parsePattern: $dd05b0e9278d6956$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd05b0e9278d6956$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $dd05b0e9278d6956$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dd05b0e9278d6956$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dd05b0e9278d6956$export$2e2bcd8739ae039 = $dd05b0e9278d6956$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $52530cd208ccbbc3$var$locale = {
    code: 'uz',
    formatDistance: (0, $dc578db66e275af8$export$2e2bcd8739ae039),
    formatLong: (0, $cfdda3ed87baaa54$export$2e2bcd8739ae039),
    formatRelative: (0, $8560410d7f1753cc$export$2e2bcd8739ae039),
    localize: (0, $53603606c32ae9de$export$2e2bcd8739ae039),
    match: (0, $dd05b0e9278d6956$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $52530cd208ccbbc3$export$2e2bcd8739ae039 = $52530cd208ccbbc3$var$locale;
module.exports["default"] = $52530cd208ccbbc3$export$2e2bcd8739ae039;

});

parcelRegister("f2nvb", function(module, exports) {
var $a43b52d6735a2757$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var $a43b52d6735a2757$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a43b52d6735a2757$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
var $a43b52d6735a2757$export$2e2bcd8739ae039 = $a43b52d6735a2757$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $93b03e6985c59e51$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $93b03e6985c59e51$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $93b03e6985c59e51$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $93b03e6985c59e51$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $93b03e6985c59e51$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $93b03e6985c59e51$export$2e2bcd8739ae039 = $93b03e6985c59e51$var$formatLong;


var $3c93c08e5f6f548d$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var $3c93c08e5f6f548d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3c93c08e5f6f548d$var$formatRelativeLocale[token];
};
var $3c93c08e5f6f548d$export$2e2bcd8739ae039 = $3c93c08e5f6f548d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $6bea0cc63238eb84$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var $6bea0cc63238eb84$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var $6bea0cc63238eb84$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var $6bea0cc63238eb84$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var $6bea0cc63238eb84$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $6bea0cc63238eb84$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $6bea0cc63238eb84$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $6bea0cc63238eb84$var$localize = {
    ordinalNumber: $6bea0cc63238eb84$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $6bea0cc63238eb84$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $6bea0cc63238eb84$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
var $6bea0cc63238eb84$export$2e2bcd8739ae039 = $6bea0cc63238eb84$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $2b4f49167631d8c1$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $2b4f49167631d8c1$var$parseOrdinalNumberPattern = /\d+/i;
var $2b4f49167631d8c1$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $2b4f49167631d8c1$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $2b4f49167631d8c1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $2b4f49167631d8c1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2b4f49167631d8c1$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $2b4f49167631d8c1$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $2b4f49167631d8c1$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $2b4f49167631d8c1$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $2b4f49167631d8c1$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $2b4f49167631d8c1$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $2b4f49167631d8c1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $2b4f49167631d8c1$var$matchOrdinalNumberPattern,
        parsePattern: $2b4f49167631d8c1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2b4f49167631d8c1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $2b4f49167631d8c1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2b4f49167631d8c1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2b4f49167631d8c1$export$2e2bcd8739ae039 = $2b4f49167631d8c1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $af2945e4fd7e3cab$var$locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, $a43b52d6735a2757$export$2e2bcd8739ae039),
    formatLong: (0, $93b03e6985c59e51$export$2e2bcd8739ae039),
    formatRelative: (0, $3c93c08e5f6f548d$export$2e2bcd8739ae039),
    localize: (0, $6bea0cc63238eb84$export$2e2bcd8739ae039),
    match: (0, $2b4f49167631d8c1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $af2945e4fd7e3cab$export$2e2bcd8739ae039 = $af2945e4fd7e3cab$var$locale;
module.exports["default"] = $af2945e4fd7e3cab$export$2e2bcd8739ae039;

});

parcelRegister("l8E94", function(module, exports) {
var $55026f65778f3fd9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $55026f65778f3fd9$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $55026f65778f3fd9$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $55026f65778f3fd9$export$2e2bcd8739ae039 = $55026f65778f3fd9$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $44f86483cdd479a5$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $44f86483cdd479a5$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $44f86483cdd479a5$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $44f86483cdd479a5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $44f86483cdd479a5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $44f86483cdd479a5$export$2e2bcd8739ae039 = $44f86483cdd479a5$var$formatLong;


var $4001880b7e9a8952$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $4001880b7e9a8952$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4001880b7e9a8952$var$formatRelativeLocale[token];
};
var $4001880b7e9a8952$export$2e2bcd8739ae039 = $4001880b7e9a8952$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $3a77168ee116457b$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $3a77168ee116457b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $3a77168ee116457b$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $3a77168ee116457b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $3a77168ee116457b$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $3a77168ee116457b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $3a77168ee116457b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $3a77168ee116457b$var$localize = {
    ordinalNumber: $3a77168ee116457b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $3a77168ee116457b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3a77168ee116457b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3a77168ee116457b$export$2e2bcd8739ae039 = $3a77168ee116457b$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5afa2632335d5009$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $5afa2632335d5009$var$parseOrdinalNumberPattern = /\d+/i;
var $5afa2632335d5009$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $5afa2632335d5009$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $5afa2632335d5009$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $5afa2632335d5009$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $5afa2632335d5009$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $5afa2632335d5009$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $5afa2632335d5009$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $5afa2632335d5009$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $5afa2632335d5009$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $5afa2632335d5009$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $5afa2632335d5009$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5afa2632335d5009$var$matchOrdinalNumberPattern,
        parsePattern: $5afa2632335d5009$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5afa2632335d5009$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5afa2632335d5009$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5afa2632335d5009$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5afa2632335d5009$export$2e2bcd8739ae039 = $5afa2632335d5009$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $f6397c55030101fe$var$locale = {
    code: 'zh-HK',
    formatDistance: (0, $55026f65778f3fd9$export$2e2bcd8739ae039),
    formatLong: (0, $44f86483cdd479a5$export$2e2bcd8739ae039),
    formatRelative: (0, $4001880b7e9a8952$export$2e2bcd8739ae039),
    localize: (0, $3a77168ee116457b$export$2e2bcd8739ae039),
    match: (0, $5afa2632335d5009$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f6397c55030101fe$export$2e2bcd8739ae039 = $f6397c55030101fe$var$locale;
module.exports["default"] = $f6397c55030101fe$export$2e2bcd8739ae039;

});

parcelRegister("26gmS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc4009de593579510dac1f1a04fe71b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1878d6a1b5423b21$var$_react = $1878d6a1b5423b21$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1878d6a1b5423b21$var$_baseNew = $1878d6a1b5423b21$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1878d6a1b5423b21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1878d6a1b5423b21$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $1878d6a1b5423b21$var$_react.default.createElement($1878d6a1b5423b21$var$_baseNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$1878d6a1b5423b21$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $1878d6a1b5423b21$var$_default = module.exports.default = $1878d6a1b5423b21$var$ExpandElementIcon;

});

parcelRegister("bRHnZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e437ff979ed52fe3fc89de1b184e851d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a364c786091fd04$var$_react = $8a364c786091fd04$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8a364c786091fd04$var$_baseNew = $8a364c786091fd04$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8a364c786091fd04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a364c786091fd04$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $8a364c786091fd04$var$_react.default.createElement($8a364c786091fd04$var$_baseNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$8a364c786091fd04$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $8a364c786091fd04$var$_default = module.exports.default = $8a364c786091fd04$var$TextLetterCaseIcon;

});

parcelRegister("doGhB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $d7c88558fa026ef9$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('helpDialogPlugin');
module.exports["pluginKey"] = $d7c88558fa026ef9$export$18d4026d1ea86bb1;

});

parcelRegister("gjFO5", function(module, exports) {
var $3657d91fd05ab098$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $3657d91fd05ab098$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});
module.exports["LAYOUT_TYPE"] = $3657d91fd05ab098$export$9710eda883ce7be2;
module.exports["SMART_LINK_TYPE"] = $3657d91fd05ab098$export$804a928ffc86c02c;

});

parcelRegister("aiyg1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lFU5S = parcelRequire("lFU5S");

const $109d988df0072b68$var$fullWidthLabelWrapperStyles = (0, $buxP3.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $109d988df0072b68$var$fullWidthLabelStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $109d988df0072b68$export$46c20f09a5d207e4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { layout: breakoutLayout } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    bb0: switch(breakoutLayout){
        case "max":
            {
                let t2;
                if ($[0] !== formatMessage) {
                    t2 = formatMessage((0, $lFU5S.messages).maxWidthLabel);
                    $[0] = formatMessage;
                    $[1] = t2;
                } else t2 = $[1];
                t1 = t2;
                break bb0;
            }
        case "full-width":
            {
                let t2;
                if ($[2] !== formatMessage) {
                    t2 = formatMessage((0, $lFU5S.messages).fullWidthLabel);
                    $[2] = formatMessage;
                    $[3] = t2;
                } else t2 = $[3];
                t1 = t2;
                break bb0;
            }
        case "wide":
            {
                let t2;
                if ($[4] !== formatMessage) {
                    t2 = formatMessage((0, $lFU5S.messages).wideWidthLabel);
                    $[4] = formatMessage;
                    $[5] = t2;
                } else t2 = $[5];
                t1 = t2;
                break bb0;
            }
        default:
            t1 = null;
    }
    const message = t1;
    let t2;
    if ($[6] !== message) {
        t2 = message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: "resizer-breakout-mode-label",
            xcss: $109d988df0072b68$var$fullWidthLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $109d988df0072b68$var$fullWidthLabelStyles
        }, message));
        $[6] = message;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ layout: breakoutLayout })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        switch(breakoutLayout){
            case 'max':
                return formatMessage((0, $lFU5S.messages).maxWidthLabel);
            case 'full-width':
                return formatMessage((0, $lFU5S.messages).fullWidthLabel);
            case 'wide':
                return formatMessage((0, $lFU5S.messages).wideWidthLabel);
            default:
                return null;
        }
    }, [
        breakoutLayout,
        formatMessage
    ]);
    return message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: "resizer-breakout-mode-label",
        xcss: $109d988df0072b68$var$fullWidthLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $109d988df0072b68$var$fullWidthLabelStyles
    }, message));
};
module.exports["ResizerBreakoutModeLabel"] = $109d988df0072b68$export$46c20f09a5d207e4;

});

parcelRegister("372k4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5ed43bd1b2094ab64a758cd4316351a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2443d3c74c2fffb3$var$_react = $2443d3c74c2fffb3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2443d3c74c2fffb3$var$_baseNew = $2443d3c74c2fffb3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $2443d3c74c2fffb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionBottom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Bottom-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2443d3c74c2fffb3$var$AlignPositionBottomIcon = (props)=>/*#__PURE__*/ $2443d3c74c2fffb3$var$_react.default.createElement($2443d3c74c2fffb3$var$_baseNew.default, Object.assign({
        name: "AlignPositionBottomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m0-6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 13.5h16V15H0z" clip-rule="evenodd"/>`
    }, props));
$2443d3c74c2fffb3$var$AlignPositionBottomIcon.displayName = 'AlignPositionBottomIcon';
var $2443d3c74c2fffb3$var$_default = module.exports.default = $2443d3c74c2fffb3$var$AlignPositionBottomIcon;

});

parcelRegister("2v0Un", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d0289e9acb4bb747362ef3accbc9ad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d1f2e61f20d64df$var$_react = $1d1f2e61f20d64df$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1d1f2e61f20d64df$var$_baseNew = $1d1f2e61f20d64df$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1d1f2e61f20d64df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionCenterVertical".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Center-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d1f2e61f20d64df$var$AlignPositionCenterVerticalIcon = (props)=>/*#__PURE__*/ $1d1f2e61f20d64df$var$_react.default.createElement($1d1f2e61f20d64df$var$_baseNew.default, Object.assign({
        name: "AlignPositionCenterVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-7 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 7.25h16v1.5H0z" clip-rule="evenodd"/>`
    }, props));
$1d1f2e61f20d64df$var$AlignPositionCenterVerticalIcon.displayName = 'AlignPositionCenterVerticalIcon';
var $1d1f2e61f20d64df$var$_default = module.exports.default = $1d1f2e61f20d64df$var$AlignPositionCenterVerticalIcon;

});

parcelRegister("j0Bn2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90b4915c4447168157799df2556b049d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd6b0169e5106b08$var$_react = $dd6b0169e5106b08$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dd6b0169e5106b08$var$_baseNew = $dd6b0169e5106b08$var$_interopRequireDefault((parcelRequire("gElAV")));
function $dd6b0169e5106b08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionTop".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Top-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd6b0169e5106b08$var$AlignPositionTopIcon = (props)=>/*#__PURE__*/ $dd6b0169e5106b08$var$_react.default.createElement($dd6b0169e5106b08$var$_baseNew.default, Object.assign({
        name: "AlignPositionTopIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1h16v1.5H0z" clip-rule="evenodd"/><path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m-7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/>`
    }, props));
$dd6b0169e5106b08$var$AlignPositionTopIcon.displayName = 'AlignPositionTopIcon';
var $dd6b0169e5106b08$var$_default = module.exports.default = $dd6b0169e5106b08$var$AlignPositionTopIcon;

});

parcelRegister("3ymEf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::718366f0455684b58aea71d9f899bda7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29661d873488d465$var$_react = $29661d873488d465$var$_interopRequireDefault((parcelRequire("cozmU")));

var $29661d873488d465$var$_baseNew = $29661d873488d465$var$_interopRequireDefault((parcelRequire("gElAV")));
function $29661d873488d465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29661d873488d465$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $29661d873488d465$var$_react.default.createElement($29661d873488d465$var$_baseNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$29661d873488d465$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $29661d873488d465$var$_default = module.exports.default = $29661d873488d465$var$LayoutFiveColumnsIcon;

});

parcelRegister("bhIPc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a5e2e2e2e660297affa5a42c34e8591>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83740d87d4809498$var$_react = $83740d87d4809498$var$_interopRequireDefault((parcelRequire("cozmU")));

var $83740d87d4809498$var$_baseNew = $83740d87d4809498$var$_interopRequireDefault((parcelRequire("gElAV")));
function $83740d87d4809498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83740d87d4809498$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $83740d87d4809498$var$_react.default.createElement($83740d87d4809498$var$_baseNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$83740d87d4809498$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $83740d87d4809498$var$_default = module.exports.default = $83740d87d4809498$var$LayoutFourColumnsIcon;

});

parcelRegister("ctpKQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bb7f91405d2eac61849c57ae62c714b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $914c2bc71540bb85$var$_react = $914c2bc71540bb85$var$_interopRequireDefault((parcelRequire("cozmU")));

var $914c2bc71540bb85$var$_baseNew = $914c2bc71540bb85$var$_interopRequireDefault((parcelRequire("gElAV")));
function $914c2bc71540bb85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $914c2bc71540bb85$var$_react.default.createElement($914c2bc71540bb85$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $914c2bc71540bb85$var$_default = module.exports.default = $914c2bc71540bb85$var$LayoutThreeColumnsSidebarsLeftIcon;

});

parcelRegister("4dPfL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27da858e2434ed3b2bc030478f1ba16b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31302224f1376c36$var$_react = $31302224f1376c36$var$_interopRequireDefault((parcelRequire("cozmU")));

var $31302224f1376c36$var$_baseNew = $31302224f1376c36$var$_interopRequireDefault((parcelRequire("gElAV")));
function $31302224f1376c36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $31302224f1376c36$var$_react.default.createElement($31302224f1376c36$var$_baseNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $31302224f1376c36$var$_default = module.exports.default = $31302224f1376c36$var$LayoutThreeColumnsSidebarsRightIcon;

});

parcelRegister("hS5Am", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $fqVYq = parcelRequire("fqVYq");

const $8308b87cf41e8ff3$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $7Y8M5.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7Y8M5.akEditorFullWidthLayoutWidth));
};
module.exports["calcMediaSingleMaxWidth"] = $8308b87cf41e8ff3$export$a2e7f6320d796a21;

});

parcelRegister("3li0w", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $4G6PK = parcelRequire("4G6PK");

const $39c3c09b8e4e85bd$export$4ab195f543459515 = (origWidth = (0, $4G6PK.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth), minWidth = (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
module.exports["getMediaSingleInitialWidth"] = $39c3c09b8e4e85bd$export$4ab195f543459515;

});

parcelRegister("3mJu6", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $3954ed696f0dd882$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $kCECX.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};
module.exports["currentMediaNodeWithPos"] = $3954ed696f0dd882$export$22e4c8c04f58169d;

});

parcelRegister("b8ZJI", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $89gPK = parcelRequire("89gPK");


var $e3qgT = parcelRequire("e3qgT");


var $yNGEI = parcelRequire("yNGEI");


var $34CLe = parcelRequire("34CLe");


const $4f7a300912d0ecb6$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $4f7a300912d0ecb6$export$adfc02948d64a4f2 = (layout)=>$4f7a300912d0ecb6$var$validWidthModes.indexOf(layout) > -1;
const $4f7a300912d0ecb6$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil((0, $yNGEI.calcPxFromPct)(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $4f7a300912d0ecb6$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $4f7a300912d0ecb6$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7Y8M5.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7Y8M5.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ((0, $34CLe.wrappedLayouts).indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return calculatedPctWidth;
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && (0, $34CLe.wrappedLayouts).indexOf(layout) !== -1) // when layout is wrap-left, wrap-right, align-start, align-end
    // but no pctWidth is defined
    return Math.min((0, $yNGEI.calcPxFromPct)(0.5, lineLength || width), origWidth);
    return origWidth;
};
const $4f7a300912d0ecb6$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = (0, $yNGEI.calcPxFromPct)(gridWidth / 100, lineLength);
    const columnSpan = Math.round((0, $89gPK.calcColumnsFromPx)(pxWidth, lineLength, gridSize));
    const alignedWidth = (0, $e3qgT.calcPxFromColumns)(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcMediaPxWidth"] = $4f7a300912d0ecb6$export$5e51fc02b9ada5af;

});

parcelRegister("76kDm", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

function $d7bd499ffb775b71$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
module.exports["calcPctFromPx"] = $d7bd499ffb775b71$export$55ddb36b3404ec6d;

});

parcelRegister("bfl0n", function(module, exports) {
const $037ce7e6baaea8b0$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
module.exports["handleSides"] = $037ce7e6baaea8b0$export$8ee741c8b9b43371;

});

parcelRegister("fb9eF", function(module, exports) {
const $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};
module.exports["imageAlignmentMap"] = $d4d7391d9317696f$export$9aaf3d5fbdfcf5c5;

});

parcelRegister("3GQSw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $9to0k = parcelRequire("9to0k");


var $7Y8M5 = parcelRequire("7Y8M5");


var $krYZG = parcelRequire("krYZG");


var $l3s1y = parcelRequire("l3s1y");


var $8dGm2 = parcelRequire("8dGm2");


var $bfl0n = parcelRequire("bfl0n");


var $h5qPS = parcelRequire("h5qPS");

const $8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $krYZG.ACTION_SUBJECT).EMBEDS : (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $krYZG.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $8fc8e2ef5831c0bb$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $bfl0n.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $7Y8M5.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $l3s1y.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9to0k.Resizable), {
            ref: this.resizable,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart
        }, children);
    }
    constructor(...args){
        super(...args);
        this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.state = {
            isResizing: false
        };
        this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints, onResizeStart: onResizeStart } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            if (onResizeStart) onResizeStart();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(layout), newHighlights);
            });
        };
        this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        };
        this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $8fc8e2ef5831c0bb$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $h5qPS.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($8fc8e2ef5831c0bb$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $8dGm2.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $8dGm2.gridTypeForLayout)(layout), []);
            });
        };
    }
}
module.exports["default"] = $8fc8e2ef5831c0bb$export$2e2bcd8739ae039;

});

parcelRegister("h5qPS", function(module, exports) {
const $3866694567b9f2f6$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? // extreme last case if there are no points somehow
    target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
module.exports["snapTo"] = $3866694567b9f2f6$export$ce5a040a76868800;

});

parcelRegister("jU5kz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $hZR9z = parcelRequire("hZR9z");


var $6aEgq = parcelRequire("6aEgq");


var $4ezc2 = parcelRequire("4ezc2");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");


var $4mxZP = parcelRequire("4mxZP");


var $f4MCV = parcelRequire("f4MCV");


var $iUhs4 = parcelRequire("iUhs4");


var $9V98o = parcelRequire("9V98o");


var $ieeJu = parcelRequire("ieeJu");


var $krYZG = parcelRequire("krYZG");


var $5I4Vo = parcelRequire("5I4Vo");


var $ldqjS = parcelRequire("ldqjS");


var $2xhuI = parcelRequire("2xhuI");

var $2BvhC = parcelRequire("2BvhC");


var $6keIx = parcelRequire("6keIx");


var $dAzds = parcelRequire("dAzds");

var $gtLXJ = parcelRequire("gtLXJ");

var $8qft0 = parcelRequire("8qft0");

const $a9d84f7bb61ac6b4$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6aEgq))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hZR9z))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ezc2))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bH62g))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $ldqjS.alignRight)
    }
];
const $a9d84f7bb61ac6b4$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4MCV))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iUhs4))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $a9d84f7bb61ac6b4$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4mxZP)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9V98o)))
    }
];
const $a9d84f7bb61ac6b4$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $2BvhC.toolbarMessages).wrapLeft,
    center: (0, $2xhuI.default).alignImageCenter,
    'wrap-right': (0, $2BvhC.toolbarMessages).wrapRight,
    wide: (0, $2xhuI.default).layoutWide,
    'full-width': (0, $2xhuI.default).layoutFullWidth,
    'align-end': (0, $2xhuI.default).alignImageRight,
    'align-start': (0, $2xhuI.default).alignImageLeft
};
const $a9d84f7bb61ac6b4$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $a9d84f7bb61ac6b4$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $a9d84f7bb61ac6b4$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $dAzds.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $5I4Vo.insideTable)(state) || (0, $gtLXJ.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).SELECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $a9d84f7bb61ac6b4$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $8qft0.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[value]),
            selected: $a9d84f7bb61ac6b4$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $a9d84f7bb61ac6b4$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6keIx.Shortcut), null, (0, $ldqjS.tooltip)(layoutOption.keyboardShortcut))
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $bjg0G.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $ieeJu.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $a9d84f7bb61ac6b4$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $a9d84f7bb61ac6b4$var$mapIconsToToolbarItem($a9d84f7bb61ac6b4$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $a9d84f7bb61ac6b4$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || !selection.node || !nodeType || $a9d84f7bb61ac6b4$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$a9d84f7bb61ac6b4$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$a9d84f7bb61ac6b4$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$a9d84f7bb61ac6b4$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $a9d84f7bb61ac6b4$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($a9d84f7bb61ac6b4$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $a9d84f7bb61ac6b4$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $8qft0.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $a9d84f7bb61ac6b4$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $a9d84f7bb61ac6b4$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a9d84f7bb61ac6b4$export$2e2bcd8739ae039 = $a9d84f7bb61ac6b4$var$buildLayoutButtons;
module.exports["alignmentIcons"] = $a9d84f7bb61ac6b4$export$45400139bf999022;
module.exports["wrappingIcons"] = $a9d84f7bb61ac6b4$export$88511ca1ca567d46;
module.exports["layoutToMessages"] = $a9d84f7bb61ac6b4$export$b978ceeb25a89f87;
module.exports["buildLayoutDropdown"] = $a9d84f7bb61ac6b4$export$31e29507a90f6f72;
module.exports["default"] = $a9d84f7bb61ac6b4$export$2e2bcd8739ae039;

});

parcelRegister("4w6dd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::681080601a94d93e230b18e8fab2b5f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $349ef82bf320a7df$var$_react = $349ef82bf320a7df$var$_interopRequireDefault((parcelRequire("cozmU")));

var $349ef82bf320a7df$var$_baseNew = $349ef82bf320a7df$var$_interopRequireDefault((parcelRequire("gElAV")));
function $349ef82bf320a7df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageCrop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for cropping images
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $349ef82bf320a7df$var$ImageCropIcon = (props)=>/*#__PURE__*/ $349ef82bf320a7df$var$_react.default.createElement($349ef82bf320a7df$var$_baseNew.default, Object.assign({
        name: "ImageCropIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 3V0h1.5v3H11a2 2 0 0 1 2 2v6.5h3V13h-3v3h-1.5V5a.5.5 0 0 0-.5-.5H0V3zm0 8V6h1.5v5a.5.5 0 0 0 .5.5h5V13H5a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$349ef82bf320a7df$var$ImageCropIcon.displayName = 'ImageCropIcon';
var $349ef82bf320a7df$var$_default = module.exports.default = $349ef82bf320a7df$var$ImageCropIcon;

});

parcelRegister("dsePF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba10fe2c4ef1ea336b2035e8f15b8f37>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cb965499c25e705$var$_react = $9cb965499c25e705$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9cb965499c25e705$var$_baseNew = $9cb965499c25e705$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9cb965499c25e705$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageAltText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for creating alt text for an image
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cb965499c25e705$var$ImageAltTextIcon = (props)=>/*#__PURE__*/ $9cb965499c25e705$var$_react.default.createElement($9cb965499c25e705$var$_baseNew.default, Object.assign({
        name: "ImageAltTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8h-3.5V6.5H16zm0 3.5h-3.5V10H16zm0 3.5H5v-1.5h11zM0 3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.206 5.001a.75.75 0 0 1 .55.196l3 2.75-1.013 1.106-2.43-2.228-4.245 4.915-1.136-.98 4.75-5.5A.75.75 0 0 1 7.206 5" clip-rule="evenodd"/><path fill="currentcolor" d="M5 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$9cb965499c25e705$var$ImageAltTextIcon.displayName = 'ImageAltTextIcon';
var $9cb965499c25e705$var$_default = module.exports.default = $9cb965499c25e705$var$ImageAltTextIcon;

});

parcelRegister("7TpAR", function(module, exports) {

var $1A89X = parcelRequire("1A89X");


var $jbOus = parcelRequire("jbOus");


var $2mgqy = parcelRequire("2mgqy");

const $7de8957bf346ce42$export$f4585563863d37bf = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    // Array#find... no IE support
    return mediaNodes.reduce((memo, nodeWithPos)=>{
        if (memo) return memo;
        const { node: node } = nodeWithPos;
        if (node.attrs.id === id) return nodeWithPos;
        return memo;
    }, null);
};
const $7de8957bf346ce42$export$691b82c623e6f45f = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    return mediaNodes.filter((nodeWithHandler)=>nodeWithHandler.node.attrs.id === id);
};
const $7de8957bf346ce42$export$d6ca4605aefeca32 = (pos, state)=>{
    const node = state.doc.nodeAt(pos);
    return node && [
        'media',
        'mediaInline'
    ].includes(node.type.name);
};
const $7de8957bf346ce42$export$9ab762e6df73c440 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodes = $7de8957bf346ce42$export$691b82c623e6f45f(mediaPluginState, id);
        const validMediaNodePositions = mediaNodes.reduce((acc, { getPos: getPos })=>{
            const pos = getPos();
            if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$7de8957bf346ce42$export$d6ca4605aefeca32(pos, state)) return acc;
            acc.push(pos);
            return acc;
        }, []);
        if (validMediaNodePositions.length === 0) return false;
        const tr = state.tr;
        validMediaNodePositions.forEach((pos)=>tr.step(new (0, $1A89X.SetAttrsStep)(pos, attrs)));
        tr.setMeta('addToHistory', false);
        (0, $jbOus.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $7de8957bf346ce42$export$fb68358a5cd1917e = (attrs, mediaNode, tintDirtyTr)=>(state, dispatch)=>{
        const pos = mediaNode.getPos();
        if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$7de8957bf346ce42$export$d6ca4605aefeca32(pos, state)) return false;
        const tr = state.tr;
        tr.step(new (0, $1A89X.SetAttrsStep)(pos, attrs));
        tr.setMeta('addToHistory', false);
        if (tintDirtyTr) (0, $jbOus.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $7de8957bf346ce42$export$b75bb49e34d97d07 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $2mgqy.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodeWithPos = $7de8957bf346ce42$export$f4585563863d37bf(mediaPluginState, id);
        if (!mediaNodeWithPos) return false;
        const tr = state.tr;
        const pos = mediaNodeWithPos.getPos();
        if (typeof pos !== 'number' || !$7de8957bf346ce42$export$d6ca4605aefeca32(pos, state)) return false;
        tr.step(new (0, $1A89X.SetAttrsStep)(pos, attrs)).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
const $7de8957bf346ce42$export$8c2989a33c6f5bd5 = (pos, attrs)=>(state, dispatch)=>{
        const tr = state.tr;
        const node = tr.doc.nodeAt(pos);
        if (!node || node.type.name !== 'media') return false;
        tr.step(new (0, $1A89X.SetAttrsStep)(pos, {
            type: 'file',
            url: null,
            ...attrs
        })).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
module.exports["findMediaNode"] = $7de8957bf346ce42$export$f4585563863d37bf;
module.exports["updateCurrentMediaNodeAttrs"] = $7de8957bf346ce42$export$fb68358a5cd1917e;
module.exports["updateMediaNodeAttrs"] = $7de8957bf346ce42$export$b75bb49e34d97d07;
module.exports["replaceExternalMedia"] = $7de8957bf346ce42$export$8c2989a33c6f5bd5;

});

parcelRegister("2mgqy", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $b00a4023790d1386$export$77b371d6becc8882 = new (0, $kCECX.PluginKey)('mediaPlugin');
module.exports["stateKey"] = $b00a4023790d1386$export$77b371d6becc8882;

});

parcelRegister("geUVX", function(module, exports) {

var $lVAkE = parcelRequire("lVAkE");

var $c2E4R = parcelRequire("c2E4R");

var $c7UOz = parcelRequire("c7UOz");

var $4EksL = parcelRequire("4EksL");

var $inM0i = parcelRequire("inM0i");


var $77KCc = parcelRequire("77KCc");


var $iUNgd = parcelRequire("iUNgd");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $PGUCj = parcelRequire("PGUCj");

var $6wYuL = parcelRequire("6wYuL");


var $2ETaj = parcelRequire("2ETaj");


var $9k4mh = parcelRequire("9k4mh");


var $d55P7 = parcelRequire("d55P7");

const $454ea75ba6826788$var$isTemporary = (id)=>{
    return id.indexOf('temporary:') === 0;
};
const $454ea75ba6826788$export$2111a084b5e4465d = (attrs)=>{
    return !!(attrs && attrs.type === 'external' && (0, $6wYuL.isMediaBlobUrl)(attrs.url));
};
const $454ea75ba6826788$export$7abbbf8335ec653 = (state)=>{
    return $454ea75ba6826788$export$6f3a1f1a8fe30200(state) || $454ea75ba6826788$var$posOfFollowingMediaGroup(state) || $454ea75ba6826788$export$365a04aece6dfb6(state) || $454ea75ba6826788$var$posOfMediaGroupNextToGapCursor(state);
};
const $454ea75ba6826788$export$5921300994784ec4 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type !== state.schema.nodes.media && node.isBlock;
};
const $454ea75ba6826788$export$e5cc26eb78c044a3 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaSingle;
};
const $454ea75ba6826788$var$isSelectionMediaInlineNode = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaInline;
};
const $454ea75ba6826788$export$365a04aece6dfb6 = (state)=>{
    if (!(0, $lVAkE.atTheBeginningOfBlock)(state)) return;
    return $454ea75ba6826788$var$posOfMediaGroupAbove(state, state.selection.$from);
};
const $454ea75ba6826788$var$posOfMediaGroupNextToGapCursor = (state)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $4EksL.GapCursorSelection)) {
        const $pos = state.selection.$from;
        const mediaGroupType = state.schema.nodes.mediaGroup;
        return $454ea75ba6826788$var$posOfImmediatePrecedingMediaGroup($pos, mediaGroupType) || $454ea75ba6826788$var$posOfImmediateFollowingMediaGroup($pos, mediaGroupType);
    }
};
const $454ea75ba6826788$var$posOfImmediatePrecedingMediaGroup = ($pos, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
mediaGroupType)=>{
    if ($pos.nodeBefore && $pos.nodeBefore.type === mediaGroupType) return $pos.pos - $pos.nodeBefore.nodeSize + 1;
};
const $454ea75ba6826788$var$posOfImmediateFollowingMediaGroup = ($pos, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
mediaGroupType)=>{
    if ($pos.nodeAfter && $pos.nodeAfter.type === mediaGroupType) return $pos.pos + 1;
};
const $454ea75ba6826788$var$posOfFollowingMediaGroup = (state)=>{
    if (!(0, $lVAkE.atTheEndOfBlock)(state)) return;
    return $454ea75ba6826788$var$posOfMediaGroupBelow(state, state.selection.$to);
};
const $454ea75ba6826788$var$posOfMediaGroupAbove = (state, $pos)=>{
    let adjacentPos;
    let adjacentNode;
    if ($454ea75ba6826788$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeBefore;
    } else {
        adjacentPos = (0, $inM0i.startPositionOfParent)($pos) - 1;
        adjacentNode = state.doc.resolve(adjacentPos).nodeBefore;
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return adjacentPos - adjacentNode.nodeSize + 1;
    return;
};
const $454ea75ba6826788$export$c64712b0ea25772a = (state)=>{
    const { $from: $from } = state.selection;
    return $from.parent.type === state.schema.nodes.paragraph && (0, $lVAkE.atTheBeginningOfBlock)(state) && (0, $lVAkE.atTheEndOfBlock)(state);
};
const $454ea75ba6826788$var$posOfMediaGroupBelow = (state, $pos, prepend = true)=>{
    let adjacentPos;
    let adjacentNode;
    if ($454ea75ba6826788$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeAfter;
    } else {
        adjacentPos = (0, $c7UOz.endPositionOfParent)($pos);
        adjacentNode = state.doc.nodeAt(adjacentPos);
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return prepend ? adjacentPos + 1 : adjacentPos + adjacentNode.nodeSize - 1;
    return;
};
const $454ea75ba6826788$export$6f3a1f1a8fe30200 = (state, $pos, prepend = false)=>{
    const { $from: $from } = state.selection;
    $pos = $pos || $from;
    if ($pos.parent.type === state.schema.nodes.mediaGroup) return prepend ? (0, $inM0i.startPositionOfParent)($pos) : (0, $c7UOz.endPositionOfParent)($pos) - 1;
    return;
};
const $454ea75ba6826788$export$ddc636b287a33575 = (view, node, getPos)=>{
    const { id: id } = node.attrs;
    const { state: state } = view;
    const { tr: tr, selection: selection, doc: doc } = state;
    const currentMediaNodePos = getPos();
    if (typeof currentMediaNodePos !== 'number') return;
    tr.deleteRange(currentMediaNodePos, currentMediaNodePos + node.nodeSize);
    if ($454ea75ba6826788$var$isTemporary(id)) tr.setMeta('addToHistory', false);
    const $currentMediaNodePos = doc.resolve(currentMediaNodePos);
    const { nodeBefore: nodeBefore, parent: parent } = $currentMediaNodePos;
    const isLastMediaNode = $currentMediaNodePos.index() === parent.childCount - 1;
    // If deleting a selected media node, we need to tell where the cursor to go next.
    // Prosemirror didn't gave us the behaviour of moving left if the media node is not the last one.
    // So we handle it ourselves.
    if (selection.from === currentMediaNodePos && !isLastMediaNode && !(0, $c2E4R.atTheBeginningOfDoc)(state) && nodeBefore && nodeBefore.type.name === 'media') {
        const nodeBefore = (0, $bjg0G.findPositionOfNodeBefore)(tr.selection);
        if (nodeBefore) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, nodeBefore));
    }
    view.dispatch(tr);
};
const $454ea75ba6826788$export$60aa99908f1d280f = (view)=>{
    const { selection: selection } = view.state;
    // if selection is not a media node, do nothing.
    if (!(selection instanceof (0, $kCECX.NodeSelection)) || selection.node.type !== view.state.schema.nodes.media) return false;
    (0, $iUNgd.deleteSelection)(view.state, view.dispatch);
    if (selection.$to.nodeAfter) {
        (0, $iUNgd.splitBlock)(view.state, view.dispatch);
        (0, $77KCc.createParagraphNear)(false)(view.state, view.dispatch);
    } else (0, $77KCc.createNewParagraphBelow)(view.state, view.dispatch);
    return true;
};
const $454ea75ba6826788$var$isOptionalAttr = (attr)=>attr.length > 1 && attr[0] === '_' && attr[1] === '_';
const $454ea75ba6826788$export$21d5b3d9cf01948c = (mediaState, node)=>{
    Object.keys(node.attrs).filter($454ea75ba6826788$var$isOptionalAttr).forEach((key)=>{
        const mediaStateKey = key.substring(2);
        const attrValue = mediaState[mediaStateKey];
        if (attrValue !== undefined) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
        node.attrs[key] = attrValue;
    });
};
const $454ea75ba6826788$export$9b24cf4bc5375bda = (state)=>{
    if (!$454ea75ba6826788$export$e5cc26eb78c044a3(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from + 1;
    const mediaNode = tr.doc.nodeAt(pos);
    if (mediaNode && mediaNode.type === state.schema.nodes.media) return mediaNode;
    return null;
};
const $454ea75ba6826788$var$getMediaInlineNodeFromSelection = (state)=>{
    if (!$454ea75ba6826788$var$isSelectionMediaInlineNode(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from;
    const mediaNode = tr.doc.nodeAt(pos);
    return mediaNode;
};
const $454ea75ba6826788$export$5410c0ed8420fc75 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $9k4mh.getMediaPluginState)(state);
    return $454ea75ba6826788$export$e5cc26eb78c044a3(state) || allowInlineImages && $454ea75ba6826788$var$isSelectionMediaInlineNode(state);
};
const $454ea75ba6826788$export$e9f7b6e4ebb6d186 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $9k4mh.getMediaPluginState)(state);
    const mediaNode = $454ea75ba6826788$export$9b24cf4bc5375bda(state) || allowInlineImages && $454ea75ba6826788$var$getMediaInlineNodeFromSelection(state);
    return mediaNode || null;
};
const $454ea75ba6826788$export$a556482c8c054147 = (state)=>{
    const { node: node } = state.selection;
    // Specifically for media supported nodes, double click could have been initiated on the media caption
    if (!node) return null;
    switch(node.type){
        case node.type.schema.nodes.media:
        case node.type.schema.nodes.mediaInline:
            return node;
        case node.type.schema.nodes.mediaSingle:
        case node.type.schema.nodes.mediaGroup:
            return node.firstChild;
        default:
            return null;
    }
};
const $454ea75ba6826788$export$7940ab1d031fef29 = (isViewMode, node)=>{
    if (!node) return false;
    // Double Click is not supported for video nodes on both views
    if ((0, $d55P7.isVideo)(node.attrs.__fileMimeType)) return false;
    // Double click is supported for all editor media nodes
    if (!isViewMode) return true;
    // Double Click is not supported for mediaGroup and mediaInline nodes that are file
    if (node.type === node.type.schema.nodes.mediaGroup || node.type === node.type.schema.nodes.mediaInline && node.attrs.type === 'file') return false;
    // Double Click supported for all other media nodes
    return true;
};
const $454ea75ba6826788$export$adb27ddab077e944 = (attrs)=>{
    if ((0, $2ETaj.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $454ea75ba6826788$export$a22092fc57f1d693 = (doc)=>{
    const mediaNodes = [];
    doc.descendants((node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') mediaNodes.push(node);
    });
    return mediaNodes;
};
const $454ea75ba6826788$export$be91ba10d8a4f435 = (mediaNodes)=>{
    const mediaIdentifierMap = new Map();
    mediaNodes.forEach((item)=>{
        const attrs = item.attrs;
        if (!attrs) return;
        if ((0, $d55P7.isVideo)(attrs.__fileMimeType)) return;
        const identifier = $454ea75ba6826788$export$adb27ddab077e944(attrs);
        // Add only if not already processed
        const idKey = (0, $PGUCj.isExternalImageIdentifier)(identifier) ? identifier.dataURI : identifier.id;
        if (!mediaIdentifierMap.has(idKey)) mediaIdentifierMap.set(idKey, identifier);
    });
    return [
        ...mediaIdentifierMap.values()
    ];
};
module.exports["isMediaBlobUrlFromAttrs"] = $454ea75ba6826788$export$2111a084b5e4465d;
module.exports["posOfMediaGroupNearby"] = $454ea75ba6826788$export$7abbbf8335ec653;
module.exports["posOfParentMediaGroup"] = $454ea75ba6826788$export$6f3a1f1a8fe30200;
module.exports["posOfPrecedingMediaGroup"] = $454ea75ba6826788$export$365a04aece6dfb6;
module.exports["isSelectionNonMediaBlockNode"] = $454ea75ba6826788$export$5921300994784ec4;
module.exports["isSelectionMediaSingleNode"] = $454ea75ba6826788$export$e5cc26eb78c044a3;
module.exports["isInsidePotentialEmptyParagraph"] = $454ea75ba6826788$export$c64712b0ea25772a;
module.exports["removeMediaNode"] = $454ea75ba6826788$export$ddc636b287a33575;
module.exports["splitMediaGroup"] = $454ea75ba6826788$export$60aa99908f1d280f;
module.exports["copyOptionalAttrsFromMediaState"] = $454ea75ba6826788$export$21d5b3d9cf01948c;
module.exports["isMediaSingleOrInlineNodeSelected"] = $454ea75ba6826788$export$5410c0ed8420fc75;
module.exports["getMediaSingleOrInlineNodeFromSelection"] = $454ea75ba6826788$export$e9f7b6e4ebb6d186;
module.exports["getMediaFromSupportedMediaNodesFromSelection"] = $454ea75ba6826788$export$a556482c8c054147;
module.exports["isNodeDoubleClickSupportedInLivePagesViewMode"] = $454ea75ba6826788$export$7940ab1d031fef29;
module.exports["getIdentifier"] = $454ea75ba6826788$export$adb27ddab077e944;
module.exports["extractMediaNodes"] = $454ea75ba6826788$export$a22092fc57f1d693;
module.exports["createMediaIdentifierArray"] = $454ea75ba6826788$export$be91ba10d8a4f435;

});

parcelRegister("d55P7", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $krYZG = parcelRequire("krYZG");


var $8tXCb = parcelRequire("8tXCb");


var $4G6PK = parcelRequire("4G6PK");

var $p7uR0 = parcelRequire("p7uR0");

var $3li0w = parcelRequire("3li0w");


var $lVAkE = parcelRequire("lVAkE");

var $inM0i = parcelRequire("inM0i");


var $2w79Z = parcelRequire("2w79Z");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8Z43Z = parcelRequire("8Z43Z");


var $ixfCV = parcelRequire("ixfCV");


var $geUVX = parcelRequire("geUVX");


var $hLkNo = parcelRequire("hLkNo");


var $8f29X = parcelRequire("8f29X");

const $4eeca7ab174b90c3$var$TABLE_CELL_HORIZONTAL_PADDING = 16;
const $4eeca7ab174b90c3$var$getPositiveWidth = (width)=>typeof width === 'number' && width > 0 ? width : undefined;
const $4eeca7ab174b90c3$var$getClosestNodeDepth = ($pos, nodeNames)=>{
    for(let depth = $pos.depth; depth > 0; depth--){
        if (nodeNames.includes($pos.node(depth).type.name)) return depth;
    }
};
const $4eeca7ab174b90c3$var$getTableCellWidthFromPosition = (doc, pos)=>{
    if (typeof pos !== 'number') return undefined;
    try {
        const $pos = doc.resolve(pos);
        const cellDepth = $4eeca7ab174b90c3$var$getClosestNodeDepth($pos, [
            'tableCell',
            'tableHeader'
        ]);
        const tableDepth = $4eeca7ab174b90c3$var$getClosestNodeDepth($pos, [
            'table'
        ]);
        if (cellDepth === undefined || tableDepth === undefined || tableDepth >= cellDepth) return undefined;
        const tableNode = $pos.node(tableDepth);
        const cellNode = $pos.node(cellDepth);
        const tableMap = (0, $8Z43Z.TableMap).get(tableNode);
        const tableStart = $pos.before(tableDepth) + 1;
        const cellPositionInTable = $pos.before(cellDepth) - tableStart;
        const cellRect = tableMap.findCell(cellPositionInTable);
        const columnSpan = cellRect.right - cellRect.left;
        const colwidth = cellNode.attrs.colwidth;
        const explicitCellWidth = colwidth?.slice(0, columnSpan).reduce((total, width)=>total + width, 0);
        const tableWidth = $4eeca7ab174b90c3$var$getPositiveWidth(tableNode.attrs.width) ?? (0, $7Y8M5.akEditorDefaultLayoutWidth);
        const inferredCellWidth = tableWidth / tableMap.width * columnSpan;
        const cellWidth = $4eeca7ab174b90c3$var$getPositiveWidth(explicitCellWidth) ?? $4eeca7ab174b90c3$var$getPositiveWidth(inferredCellWidth);
        return cellWidth ? cellWidth - $4eeca7ab174b90c3$var$TABLE_CELL_HORIZONTAL_PADDING : undefined;
    } catch  {
        return undefined;
    }
};
const $4eeca7ab174b90c3$var$getMediaSingleMaxWidthForInsertion = (view, pos, widthPluginState)=>$4eeca7ab174b90c3$var$getPositiveWidth((0, $p7uR0.getMaxWidthForNestedNodeNext)(view, pos, true)) ?? $4eeca7ab174b90c3$var$getPositiveWidth($4eeca7ab174b90c3$var$getTableCellWidthFromPosition(view.state.doc, pos)) ?? $4eeca7ab174b90c3$var$getPositiveWidth(widthPluginState?.lineLength) ?? $4eeca7ab174b90c3$var$getPositiveWidth(widthPluginState?.width);
const $4eeca7ab174b90c3$var$getInsertMediaAnalytics = (inputMethod, fileExtension, insertMediaVia)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            inputMethod: inputMethod,
            insertMediaVia: insertMediaVia,
            fileExtension: fileExtension,
            type: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
function $4eeca7ab174b90c3$var$shouldAddParagraph(state) {
    return (0, $lVAkE.atTheBeginningOfBlock)(state) && !(0, $2w79Z.checkNodeDown)(state.selection, state.doc, (0, $2w79Z.isEmptyParagraph));
}
function $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraph({ nodes: nodes, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        if ((0, $ixfCV.fg)('platform_editor_introduce_insert_media_command')) {
            const updatedTr = $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraphCommand({
                nodes: nodes,
                analyticsAttributes: analyticsAttributes,
                editorAnalyticsAPI: editorAnalyticsAPI,
                insertMediaVia: insertMediaVia
            })({
                tr: tr
            });
            if (updatedTr && dispatch) {
                dispatch?.(updatedTr);
                return true;
            }
            return false;
        }
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        if (state.selection.empty) {
            const insertFrom = (0, $lVAkE.atTheBeginningOfBlock)(state) ? state.selection.$from.before() : state.selection.from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else updatedTr.replaceSelection(new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, openEnd));
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($4eeca7ab174b90c3$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI?.attachAnalyticsEvent((0, $hLkNo.getChangeMediaAnalytics)(previousType, newType, (0, $hLkNo.findChangeFromLocation)(state.selection)))(updatedTr);
        if (dispatch) dispatch(updatedTr);
        return true;
    };
}
function $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraphCommand({ nodes: nodes, positions: positions, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return ({ tr: tr })=>{
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        const { selection: selection } = tr;
        const from = positions ? positions[0] : selection.from;
        const to = positions ? positions[1] : selection.to;
        const $from = positions ? tr.doc.resolve(from) : selection.$from;
        const isEmpty = positions ? from === to : selection.empty;
        if (isEmpty) {
            const isAtTheBeginningOfBlock = positions ? (0, $inM0i.startPositionOfParent)($from) === $from.pos : (0, $lVAkE.selectionIsAtTheBeginningOfBlock)(selection);
            const insertFrom = isAtTheBeginningOfBlock ? $from.before() : from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else {
            const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, openEnd);
            updatedTr = positions ? updatedTr.replaceRange(from, to, slice) : updatedTr.replaceSelection(slice);
        }
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($4eeca7ab174b90c3$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI?.attachAnalyticsEvent((0, $hLkNo.getChangeMediaAnalytics)(previousType, newType, (0, $hLkNo.findChangeFromLocation)(tr.selection)))(updatedTr);
        return updatedTr;
    };
}
const $4eeca7ab174b90c3$export$e5065363a261ea68 = (schema, fileMimeType)=>!!schema.nodes.mediaSingle && (0, $8f29X.isImage)(fileMimeType);
const $4eeca7ab174b90c3$export$62e6f072fbcbc210 = (view, node, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle) return false;
    // if not an image type media node
    if (node.type !== media || !(0, $8f29X.isImage)(node.attrs.__fileMimeType) && node.attrs.type !== 'external') return false;
    const mediaSingleMaxWidth = $4eeca7ab174b90c3$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos);
    if ((0, $ixfCV.fg)('platform_editor_introduce_insert_media_command')) {
        const updatedTr = $4eeca7ab174b90c3$export$ad66fa9805ac027a(node.attrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, undefined, undefined, mediaSingleMaxWidth)({
            tr: state.tr
        });
        if (updatedTr && dispatch) {
            dispatch?.(updatedTr);
            return true;
        }
        return false;
    }
    const mediaSingleAttrs = allowPixelResizing ? {
        widthType: 'pixel',
        width: (0, $3li0w.getMediaSingleInitialWidth)(node.attrs.width ?? (0, $4G6PK.DEFAULT_IMAGE_WIDTH), mediaSingleMaxWidth),
        layout: 'center'
    } : {};
    const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, node);
    const nodes = [
        mediaSingleNode
    ];
    const analyticsAttributes = {
        inputMethod: inputMethod,
        fileExtension: node.attrs.__fileMimeType
    };
    return $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraph({
        nodes: nodes,
        analyticsAttributes: analyticsAttributes,
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
};
const $4eeca7ab174b90c3$export$ad66fa9805ac027a = (mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, positions, dataConsumerSource, mediaSingleMaxWidth)=>{
    return ({ tr: tr })=>{
        const { mediaSingle: mediaSingle, media: media } = tr.doc.type.schema.nodes;
        if (!mediaSingle || !media) return null;
        if (mediaAttrs.type !== 'external' && !(0, $8f29X.isImage)(mediaAttrs.__fileMimeType ?? undefined)) return null;
        const resolvedMediaSingleMaxWidth = $4eeca7ab174b90c3$var$getPositiveWidth(mediaSingleMaxWidth) ?? $4eeca7ab174b90c3$var$getPositiveWidth($4eeca7ab174b90c3$var$getTableCellWidthFromPosition(tr.doc, positions ? positions[0] : tr.selection.from));
        const mediaSingleAttrs = allowPixelResizing ? {
            widthType: 'pixel',
            width: (0, $3li0w.getMediaSingleInitialWidth)(mediaAttrs.width ?? (0, $4G6PK.DEFAULT_IMAGE_WIDTH), resolvedMediaSingleMaxWidth),
            layout: 'center'
        } : {};
        const dataConsumerMarkType = dataConsumerSource ? tr.doc.type.schema.marks.dataConsumer : undefined;
        const mediaNode = dataConsumerSource && dataConsumerMarkType ? media.create(mediaAttrs, undefined, [
            dataConsumerMarkType.create({
                sources: [
                    dataConsumerSource
                ]
            })
        ]) : media.create(mediaAttrs);
        const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, mediaNode);
        const nodes = [
            mediaSingleNode
        ];
        const analyticsAttributes = {
            inputMethod: inputMethod,
            // External images have no file extension
            fileExtension: mediaAttrs.type !== 'external' && mediaAttrs.__fileMimeType ? mediaAttrs.__fileMimeType ?? undefined : undefined
        };
        return $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraphCommand({
            nodes: nodes,
            positions: positions,
            analyticsAttributes: analyticsAttributes,
            editorAnalyticsAPI: editorAnalyticsAPI,
            insertMediaVia: insertMediaVia
        })({
            tr: tr
        });
    };
};
const $4eeca7ab174b90c3$var$getFileExtension = (fileName)=>{
    if (fileName) {
        const extensionIdx = fileName.lastIndexOf('.');
        return extensionIdx >= 0 ? fileName.substring(extensionIdx + 1) : undefined;
    }
    return undefined;
};
const $4eeca7ab174b90c3$export$653e52366db7c5b6 = (view, mediaState, inputMethod, collection, alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, onNodeInserted, insertMediaVia, allowPixelResizing)=>{
    if (collection === undefined) return false;
    const { state: state, dispatch: dispatch } = view;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = $4eeca7ab174b90c3$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos, widthPluginState) ?? undefined;
    const node = $4eeca7ab174b90c3$var$createMediaSingleNode(state.schema, collection, contentWidth, mediaState.status !== 'error' && $4eeca7ab174b90c3$export$ac5608bbe92d6fdc(mediaState.fileMimeType) ? (0, $4G6PK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), alignLeftOnInsert, allowPixelResizing)(mediaState);
    let fileExtension;
    if (mediaState.fileName) {
        const extensionIdx = mediaState.fileName.lastIndexOf('.');
        fileExtension = extensionIdx >= 0 ? mediaState.fileName.substring(extensionIdx + 1) : undefined;
    }
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $8tXCb.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            inputMethod: inputMethod
        },
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
    else {
        let tr = null;
        tr = (0, $8tXCb.safeInsert)(node, state.selection.from)(state.tr);
        if (!tr) {
            const content = $4eeca7ab174b90c3$var$shouldAddParagraph(view.state) ? (0, $aPdNQ.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $bjg0G.safeInsert)(content, undefined, true)(state.tr);
        }
        if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent($4eeca7ab174b90c3$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(tr);
        dispatch(tr);
    }
    if (onNodeInserted) onNodeInserted(mediaState.id, view.state.selection.to);
    return true;
};
const $4eeca7ab174b90c3$export$276040c239babb42 = (view, fromNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaInline: mediaInline } = state.schema.nodes;
    if (fromNode.type !== mediaInline) return false;
    const grandParentNodeType = state.selection.$from.node(-1)?.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = $4eeca7ab174b90c3$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos, widthPluginState) ?? undefined;
    const node = $4eeca7ab174b90c3$var$replaceWithMediaSingleNode(state.schema, contentWidth, (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), allowPixelResizing)(fromNode);
    const fileExtension = $4eeca7ab174b90c3$var$getFileExtension(fromNode.attrs.__fileName);
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $8tXCb.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) return $4eeca7ab174b90c3$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            newType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            previousType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE
        },
        editorAnalyticsAPI: editorAnalyticsAPI
    })(state, dispatch);
    else {
        const nodePos = state.tr.doc.resolve(state.selection.from).end();
        let tr = null;
        tr = (0, $bjg0G.removeSelectedNode)(state.tr);
        tr = (0, $8tXCb.safeInsert)(node, nodePos)(tr);
        if (!tr) {
            const content = $4eeca7ab174b90c3$var$shouldAddParagraph(view.state) ? (0, $aPdNQ.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $bjg0G.safeInsert)(content, undefined, true)(state.tr);
        }
        editorAnalyticsAPI?.attachAnalyticsEvent((0, $hLkNo.getChangeMediaAnalytics)((0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $hLkNo.findChangeFromLocation)(state.selection)))(tr);
        dispatch(tr);
    }
    return true;
};
const $4eeca7ab174b90c3$var$createMediaSingleNode = (schema, collection, maxWidth, minWidth, alignLeftOnInsert, allowPixelResizing)=>(mediaState)=>{
        const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const { width: width, height: height } = dimensions || {
            height: undefined,
            width: undefined
        };
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const scaledWidth = width && Math.round(width / scaleFactor);
        const mediaNode = media.create({
            id: id,
            type: 'file',
            collection: collection,
            contextId: contextId,
            width: scaledWidth,
            height: height && Math.round(height / scaleFactor),
            ...fileName && {
                alt: fileName
            }
        });
        const mediaSingleAttrs = alignLeftOnInsert ? {
            layout: 'align-start'
        } : {};
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            ...mediaSingleAttrs,
            width: (0, $3li0w.getMediaSingleInitialWidth)(scaledWidth, maxWidth, minWidth),
            // TODO: ED-26962 - change to use enum
            widthType: 'pixel'
        } : mediaSingleAttrs;
        (0, $geUVX.copyOptionalAttrsFromMediaState)(mediaState, mediaNode);
        return mediaSingle.createChecked(extendedMediaSingleAttrs, mediaNode);
    };
const $4eeca7ab174b90c3$var$replaceWithMediaSingleNode = (schema, maxWidth, minWidth, allowPixelResizing)=>(mediaNode)=>{
        const { width: width } = mediaNode.attrs;
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const copiedMediaNode = media.create({
            ...mediaNode.attrs,
            type: 'file'
        }, mediaNode.content, mediaNode.marks);
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            width: (0, $3li0w.getMediaSingleInitialWidth)(width, maxWidth, minWidth),
            widthType: 'pixel'
        } : {};
        return mediaSingle.createChecked(extendedMediaSingleAttrs, copiedMediaNode);
    };
const $4eeca7ab174b90c3$export$ac5608bbe92d6fdc = (0, $dOBRD.default)((fileType)=>{
    return !!fileType && fileType.includes('video');
});
module.exports["isMediaSingle"] = $4eeca7ab174b90c3$export$e5065363a261ea68;
module.exports["insertMediaAsMediaSingle"] = $4eeca7ab174b90c3$export$62e6f072fbcbc210;
module.exports["createInsertMediaAsMediaSingleCommand"] = $4eeca7ab174b90c3$export$ad66fa9805ac027a;
module.exports["insertMediaSingleNode"] = $4eeca7ab174b90c3$export$653e52366db7c5b6;
module.exports["isVideo"] = $4eeca7ab174b90c3$export$ac5608bbe92d6fdc;
module.exports["changeFromMediaInlineToMediaSingleNode"] = $4eeca7ab174b90c3$export$276040c239babb42;

});

parcelRegister("7mc9A", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $eEdSM = parcelRequire("eEdSM");


var $3mJu6 = parcelRequire("3mJu6");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $hLkNo = parcelRequire("hLkNo");


var $4JRVn = parcelRequire("4JRVn");


var $geUVX = parcelRequire("geUVX");


var $d55P7 = parcelRequire("d55P7");


var $2ETaj = parcelRequire("2ETaj");

const $dd8b9220e3463be8$export$f54f5cacf382b9f2 = '#091e4224';
const $dd8b9220e3463be8$export$5346947b21be4717 = 2;
const $dd8b9220e3463be8$export$d168cba70360dd3d = (state)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    return (0, $geUVX.isSelectionMediaSingleNode)(state) ? mediaSingle.name : mediaInline.name;
};
const $dd8b9220e3463be8$export$8cf8c3c101907002 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, mediaGroup: mediaGroup, paragraph: paragraph, heading: heading } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        const { id: id, type: type, collection: collection } = selectedNode.attrs;
        const mediaNode = media.createChecked({
            id: id,
            type: type,
            collection: collection
        });
        const group = mediaGroup.createChecked({}, mediaNode);
        const parent = (0, $bjg0G.findParentNodeClosestToPos)(state.selection.$from, (node)=>{
            return node.type === paragraph || node.type === heading;
        })?.node;
        let tr = state.tr;
        let insertPos;
        if (!!parent && parent.content.size === 2 && parent.content.firstChild?.type.name === 'mediaInline' && parent.content.lastChild?.type.name === 'text' && parent.content.lastChild?.text?.trim() === '') {
            /// Empty paragraph or empty heading
            /// Drop the corresponding card on the current line
            insertPos = state.tr.doc.resolve(state.selection.from).start() - 1;
            if (insertPos < 0) return false;
            tr = tr.delete(insertPos, insertPos + parent.nodeSize);
            tr = (0, $bjg0G.safeInsert)(group, insertPos, false)(tr);
        } else {
            /// Non-empty paragraph, non-empty heading, or other nodes (e.g., action, list)
            /// Drop the corresponding card underneath the current line
            insertPos = state.tr.doc.resolve(state.selection.from).end();
            tr = (0, $bjg0G.removeSelectedNode)(tr);
            tr = (0, $bjg0G.safeInsert)(group, insertPos, false)(tr);
        }
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_GROUP,
                    previousType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE
                }
            })(tr);
            const $endOfNode = tr.doc.resolve(insertPos + 1);
            const newSelection = new (0, $kCECX.NodeSelection)($endOfNode);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.thumbnail-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $dd8b9220e3463be8$export$f1c1c33109f7b728 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node;
        // @ts-ignore - [unblock prosemirror bump] redundant check comparing boolean to media
        if (!selectedNode || !selectedNode.type === media) return false;
        const mediaInlineNode = mediaInline.create({
            id: selectedNode.attrs.id,
            collection: selectedNode.attrs.collection
        });
        const space = state.schema.text(' ');
        const content = (0, $aPdNQ.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const nodePos = state.tr.doc.resolve(state.selection.from).start();
        let tr = (0, $2ETaj.removeMediaGroupNode)(state);
        // Minus 1 to insert the node before the media group
        tr = (0, $bjg0G.safeInsert)(node, nodePos - 1, false)(tr);
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE,
                    previousType: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_GROUP
                }
            })(tr);
            const newSelection = (0, $kCECX.NodeSelection).create(tr.doc, nodePos);
            tr.setSelection(newSelection);
            forceFocusSelector?.(`.inline-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $dd8b9220e3463be8$export$697a66ccfb9355d9 = (editorAnalyticsAPI, widthPluginState, allowPixelResizing)=>(state, dispatch, view)=>{
        const { mediaInline: mediaInline } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        if (view) return (0, $d55P7.changeFromMediaInlineToMediaSingleNode)(view, selectedNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing);
        return true;
    };
const $dd8b9220e3463be8$export$736937947f2887f2 = (editorAnalyticsAPI)=>{
    return (0, $eEdSM.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_INLINE,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })($dd8b9220e3463be8$export$c8abec9f794b33a4);
};
const $dd8b9220e3463be8$export$c8abec9f794b33a4 = (state, dispatch)=>{
    if ((0, $bjg0G.isNodeSelection)(state.selection)) {
        if (dispatch) dispatch((0, $bjg0G.removeSelectedNode)(state.tr));
        return true;
    }
    return false;
};
const $dd8b9220e3463be8$export$422bbbda8886cfb6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const nodeWithPos = (0, $3mJu6.currentMediaNodeWithPos)(state) || (0, $4JRVn.currentMediaInlineNodeWithPos)(state);
        if (!nodeWithPos) return false;
        const { node: node, pos: pos } = nodeWithPos;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(borderMark ? [] : state.schema.marks.border.create({
            color: $dd8b9220e3463be8$export$f54f5cacf382b9f2,
            size: $dd8b9220e3463be8$export$5346947b21be4717
        }));
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $kCECX.NodeSelection)) {
            if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
        }
        if (dispatch) {
            const type = $dd8b9220e3463be8$export$d168cba70360dd3d(state);
            if (borderMark?.attrs) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    previousColor: borderMark.attrs.color,
                    previousSize: borderMark.attrs.size,
                    mediaType: node.attrs.type
                }
            })(tr);
            else editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).ADDED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    color: $dd8b9220e3463be8$export$f54f5cacf382b9f2,
                    size: $dd8b9220e3463be8$export$5346947b21be4717,
                    mediaType: node.attrs.type
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $dd8b9220e3463be8$export$40f3bc13e4908fe6 = (editorAnalyticsAPI)=>(attrs)=>(state, dispatch)=>{
            const nodeWithPos = (0, $3mJu6.currentMediaNodeWithPos)(state) || (0, $4JRVn.currentMediaInlineNodeWithPos)(state);
            if (!nodeWithPos) return false;
            const { node: node, pos: pos } = nodeWithPos;
            const borderMark = node.marks.find((m)=>m.type.name === 'border')?.attrs;
            const color = attrs.color ?? borderMark?.color ?? $dd8b9220e3463be8$export$f54f5cacf382b9f2;
            const size = attrs.size ?? borderMark?.size ?? $dd8b9220e3463be8$export$5346947b21be4717;
            const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(state.schema.marks.border.create({
                color: color,
                size: size
            }));
            const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
            tr.setMeta('scrollIntoView', false);
            if (state.selection instanceof (0, $kCECX.NodeSelection)) {
                if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, state.selection.from));
            }
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).UPDATED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BORDER,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        type: $dd8b9220e3463be8$export$d168cba70360dd3d(state),
                        mediaType: node.attrs.type,
                        previousColor: borderMark?.color,
                        previousSize: borderMark?.size,
                        newColor: color,
                        newSize: size
                    }
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $dd8b9220e3463be8$export$2cb0367d661a3966 = (editorAnalyticsAPI, state, width, validation, inputMethod, layout)=>{
    const selectedMediaSingleNode = (0, $2ETaj.getSelectedMediaSingle)(state);
    if (!selectedMediaSingleNode) return null;
    const tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
        ...selectedMediaSingleNode.node.attrs,
        width: width,
        widthType: 'pixel',
        layout: layout
    });
    tr.setMeta('scrollIntoView', false);
    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
    const $pos = state.doc.resolve(selectedMediaSingleNode.pos);
    const parentNodeType = $pos ? $pos.parent.type.name : undefined;
    const payload = (0, $hLkNo.getMediaInputResizeAnalyticsEvent)('mediaSingle', {
        width: width,
        layout: layout,
        validation: validation,
        inputMethod: inputMethod,
        parentNode: parentNodeType
    });
    if (payload) editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    return tr;
};
const $dd8b9220e3463be8$export$c71ac81378eeb0c2 = (editorAnalyticsAPI)=>(width, validation, inputMethod, layout)=>(state, dispatch)=>{
            const tr = $dd8b9220e3463be8$export$2cb0367d661a3966(editorAnalyticsAPI, state, width, validation, inputMethod, layout);
            if (!tr) return false;
            if (dispatch) dispatch(tr);
            return true;
        };
const $dd8b9220e3463be8$export$f68bb2b466cc4cc6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const selectedNodeWithPos = (0, $2ETaj.getSelectedMediaSingle)(state);
        const { mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        if (!selectedNodeWithPos) return false;
        const mediaSingleNode = selectedNodeWithPos.node;
        const mediaNode = mediaSingleNode.firstChild;
        if (!mediaNode) return false;
        const mediaInlineNode = mediaInline.create({
            ...mediaNode.attrs,
            type: 'image'
        }, null, mediaNode.marks);
        const space = state.schema.text(' ');
        const content = (0, $aPdNQ.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const { from: from } = state.selection;
        let tr = state.tr;
        tr = (0, $bjg0G.removeSelectedNode)(tr);
        tr = (0, $bjg0G.safeInsert)(node, from, false)(tr);
        // 3 accounts for  paragraph 1 + mediaInline size 1 + space 1
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, from + 3));
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent((0, $hLkNo.getChangeMediaAnalytics)((0, $krYZG.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $hLkNo.findChangeFromLocation)(state.selection)))(tr);
            dispatch(tr);
        }
        return true;
    };
module.exports["getNodeType"] = $dd8b9220e3463be8$export$d168cba70360dd3d;
module.exports["changeInlineToMediaCard"] = $dd8b9220e3463be8$export$8cf8c3c101907002;
module.exports["changeMediaCardToInline"] = $dd8b9220e3463be8$export$f1c1c33109f7b728;
module.exports["changeMediaInlineToMediaSingle"] = $dd8b9220e3463be8$export$697a66ccfb9355d9;
module.exports["removeInlineCardWithAnalytics"] = $dd8b9220e3463be8$export$736937947f2887f2;
module.exports["toggleBorderMark"] = $dd8b9220e3463be8$export$422bbbda8886cfb6;
module.exports["setBorderMark"] = $dd8b9220e3463be8$export$40f3bc13e4908fe6;
module.exports["updateMediaSingleWidthTr"] = $dd8b9220e3463be8$export$2cb0367d661a3966;
module.exports["updateMediaSingleWidth"] = $dd8b9220e3463be8$export$c71ac81378eeb0c2;
module.exports["changeMediaSingleToMediaInline"] = $dd8b9220e3463be8$export$f68bb2b466cc4cc6;

});

parcelRegister("dQMlg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9gPd6 = parcelRequire("9gPd6");


var $kejMu = parcelRequire("kejMu");

const $7649994f3ed4ddc3$export$86ec1cc3842ae5f = ({ surface: surface, components: components, fallbacks: fallbacks })=>{
    const { root: root, childrenMap: childrenMap, topLevelChildren: topLevelChildren } = (0, $cozmU.useMemo)(()=>{
        const root = (0, $kejMu.findSurface)(components, surface);
        const childrenMap = (0, $kejMu.buildChildrenMap)(components);
        const topLevelChildren = root ? childrenMap.get(root.key) : undefined;
        return {
            root: root,
            childrenMap: childrenMap,
            topLevelChildren: topLevelChildren
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        components,
        surface.key,
        surface.type
    ]);
    if (!root) return null;
    const RootComponent = root.component ?? (0, $kejMu.PassThrough);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gPd6.SurfaceComponents), {
        components: topLevelChildren,
        childrenMap: childrenMap,
        fallbacks: fallbacks,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ parents: [
            {
                key: root.key,
                type: root.type
            }
        ]
    }));
};
module.exports["SurfaceRenderer"] = $7649994f3ed4ddc3$export$86ec1cc3842ae5f;

});

parcelRegister("aKpkp", function(module, exports) {
/**
 * Returns true if the given text node's sole mark is a `link` mark whose href
 * matches the node's text content exactly (i.e. the link label IS the URL).
 * Or if the text content is a parseable URL.
 */ const $6adb54a1a94dcf00$var$isUrlOnlyLinkTextNode = (node)=>{
    if (!node.isText) return false;
    if (node.marks.length !== 1 || node.marks[0].type.name !== 'link') return false;
    const href = node.marks[0].attrs?.href ?? '';
    // Check if the text content is a URL
    const textOfNode = node.text ?? '';
    const parseableUrl = $6adb54a1a94dcf00$var$isParseableUrl(textOfNode);
    return node.text === href || parseableUrl;
};
/**
 * Checks if a given string is parseable as a URL.
 */ const $6adb54a1a94dcf00$var$isParseableUrl = (text)=>{
    if (typeof URL?.canParse === 'function') return URL.canParse(text);
    // Fallback for older environments
    try {
        new URL(text);
        return true;
    } catch (e) {
        return false;
    }
};
const $6adb54a1a94dcf00$var$isSupportedCard = (node)=>node.type.name === 'inlineCard' || node.type.name === 'blockCard';
const $6adb54a1a94dcf00$var$transparentSingleChildContainerNodeTypes = new Set([
    'paragraph',
    'listItem',
    'bulletList',
    'orderedList'
]);
/**
 * Returns the children of a Fragment, filtering out whitespace-only text nodes.
 * This handles trailing/leading spaces that browsers sometimes include when
 * copying a link (e.g. `<a href="...">URL</a> `).
 */ const $6adb54a1a94dcf00$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        if (child.isText && child.text?.trim() === '') return;
        children.push(child);
    });
    return children;
};
/**
 * Returns true when the fragment contains exactly one meaningful leaf that
 * satisfies `isSupportedLeaf`.
 *
 * Transparent single-child containers (paragraph, listItem, bulletList, and
 * orderedList) are traversed recursively. Whitespace-only sibling text nodes
 * are ignored at each level.
 */ const $6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf = (fragment, isSupportedLeaf)=>{
    const children = $6adb54a1a94dcf00$var$significantChildren(fragment);
    if (children.length !== 1) return false;
    const [child] = children;
    if (isSupportedLeaf(child)) return true;
    if (!$6adb54a1a94dcf00$var$transparentSingleChildContainerNodeTypes.has(child.type.name)) return false;
    return $6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(child.content, isSupportedLeaf);
};
const $6adb54a1a94dcf00$var$isSingleSmartLinkCard = (slice)=>$6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(slice.content, $6adb54a1a94dcf00$var$isSupportedCard);
const $6adb54a1a94dcf00$var$isSingleBareLink = (slice)=>$6adb54a1a94dcf00$var$containsExactlyOneMeaningfulLeaf(slice.content, $6adb54a1a94dcf00$var$isUrlOnlyLinkTextNode);
const $6adb54a1a94dcf00$export$b9183df0a8583e6b = (slice)=>{
    if (!slice || !slice.content.size) // No rich-text slice → plain text paste, not a single link in the relevant sense
    return true;
    return !$6adb54a1a94dcf00$var$isSingleBareLink(slice) && !$6adb54a1a94dcf00$var$isSingleSmartLinkCard(slice);
};
module.exports["isNotSingleLink"] = $6adb54a1a94dcf00$export$b9183df0a8583e6b;

});

parcelRegister("2xHHU", function(module, exports) {
const $0cc0ecd769e90d15$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());
module.exports["cloneTr"] = $0cc0ecd769e90d15$export$5add988076756575;

});

parcelRegister("6i2ZP", function(module, exports) {

var $ksfbF = parcelRequire("ksfbF");


var $f719K = parcelRequire("f719K");

function $7c7e6e9a6fe0ade2$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $f719K.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $7c7e6e9a6fe0ade2$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col) {
    let refColumn = col > 0 ? -1 : 0;
    if ($7c7e6e9a6fe0ade2$export$c71ebdbebc3fa79b(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $ksfbF.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $ksfbF.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $f719K.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}
module.exports["columnIsHeader"] = $7c7e6e9a6fe0ade2$export$c71ebdbebc3fa79b;
module.exports["addColumn"] = $7c7e6e9a6fe0ade2$export$9e26b0bcc810b84c;

});

parcelRegister("6PhB4", function(module, exports) {
const $ff24b18269a36502$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};
module.exports["createGuidesFromLengths"] = $ff24b18269a36502$export$192a1a4af16beb38;

});

parcelRegister("3pVtP", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $ieeJu = parcelRequire("ieeJu");


var $c9tks = parcelRequire("c9tks");


var $kPKLu = parcelRequire("kPKLu");


var $lCuAc = parcelRequire("lCuAc");


var $96Kjp = parcelRequire("96Kjp");


var $bQgtm = parcelRequire("bQgtm");


var $jSggL = parcelRequire("jSggL");




const $daa920ce404d1b98$var$getContentSupportChecker = (targetNodeType)=>{
    return (node)=>{
        try {
            return targetNodeType.validContent((0, $aPdNQ.Fragment).from(node));
        } catch  {
            return false;
        }
    };
};
const $daa920ce404d1b98$export$95df50ae6315ead6 = (props, onhandleUnsupportedContent)=>{
    const transformedItems = [];
    const { listNode: listNode, isSourceBulletOrOrdered: isSourceBulletOrOrdered, isTargetBulletOrOrdered: isTargetBulletOrOrdered, isSourceTask: isSourceTask, isTargetTask: isTargetTask, supportedListTypes: supportedListTypes, schema: schema, targetNodeType: targetNodeType } = props;
    const { taskList: taskList, listItem: listItem, taskItem: taskItem, paragraph: paragraph, blockTaskItem: blockTaskItem } = schema.nodes;
    // gating behind platform_editor_small_font_size to support task lists with font size applied,
    // but keep this solution general
    const isBlockTaskEnabled = !!blockTaskItem && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    /**
   * Extracts paragraph children from a blockTaskItem, preserving their marks.
   */ const extractParagraphsFromBlockTaskItem = (node)=>{
        const paragraphs = [];
        node.forEach((child)=>{
            if (child.type === paragraph) paragraphs.push(child);
        });
        return paragraphs;
    };
    listNode.forEach((child)=>{
        if (isSourceBulletOrOrdered && isTargetTask) // Convert bullet/ordered => task
        {
            if (child.type === listItem) {
                const inlineContent = [];
                const nestedTaskLists = [];
                let blockMarks = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== taskList) nestedTaskLists.push($daa920ce404d1b98$export$95df50ae6315ead6({
                        ...props,
                        listNode: grandChild
                    }, onhandleUnsupportedContent));
                    else if (!$daa920ce404d1b98$var$getContentSupportChecker(taskItem)(grandChild) && !grandChild.isTextblock) onhandleUnsupportedContent?.(grandChild);
                    else {
                        if (isBlockTaskEnabled && grandChild.type === paragraph && grandChild.marks.length > 0) blockMarks = grandChild.marks;
                        inlineContent.push(...(0, $c9tks.convertBlockToInlineContent)(grandChild, schema));
                    }
                });
                if (isBlockTaskEnabled && blockMarks.length > 0) transformedItems.push((0, $kPKLu.createBlockTaskItem)({
                    content: inlineContent,
                    marks: blockMarks,
                    schema: schema
                }));
                else transformedItems.push(taskItem.create(null, inlineContent.length > 0 ? inlineContent : null));
                transformedItems.push(...nestedTaskLists);
            }
        } else if (isSourceTask && isTargetBulletOrOrdered) {
            // Convert task => bullet/ordered
            if (child.type === taskItem) {
                const inlineContent = [
                    ...child.content.content
                ];
                // Transfer taskItem's block marks to the paragraph.
                // Use listItem.allowsMarkType since the paragraph will be inside a listItem
                // (which uses ParagraphWithFontSizeStage0 that allows fontSize).
                const paragraphMarks = isBlockTaskEnabled && child.marks.length > 0 ? child.marks.filter((mark)=>listItem.allowsMarkType(mark.type)) : undefined;
                const paragraphNode = paragraph.create(null, inlineContent.length > 0 ? inlineContent : null, paragraphMarks);
                transformedItems.push(listItem.create(null, [
                    paragraphNode
                ]));
            } else if (isBlockTaskEnabled && child.type === blockTaskItem) {
                // blockTaskItem wraps content in paragraphs — extract them directly,
                // preserving their fontSize marks
                const paragraphs = extractParagraphsFromBlockTaskItem(child);
                if (paragraphs.length > 0) transformedItems.push(listItem.create(null, paragraphs));
            } else if (child.type === taskList) {
                const transformedNestedList = $daa920ce404d1b98$export$95df50ae6315ead6({
                    ...props,
                    listNode: child
                }, onhandleUnsupportedContent);
                const lastItem = transformedItems[transformedItems.length - 1];
                if (lastItem?.type === listItem) {
                    // Attach nested list to previous item
                    const updatedContent = [
                        ...lastItem.content.content,
                        transformedNestedList
                    ];
                    transformedItems[transformedItems.length - 1] = listItem.create(lastItem.attrs, updatedContent);
                } else // No previous item, flatten nested items
                transformedItems.push(...transformedNestedList.content.content);
            }
        } else if (isSourceBulletOrOrdered && isTargetBulletOrOrdered) {
            if (child.type === listItem) {
                const convertedNestedLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== targetNodeType) {
                        const convertedNode = $daa920ce404d1b98$export$95df50ae6315ead6({
                            ...props,
                            listNode: grandChild
                        }, onhandleUnsupportedContent);
                        convertedNestedLists.push(convertedNode);
                    } else convertedNestedLists.push(grandChild);
                });
                transformedItems.push(listItem.create(null, convertedNestedLists));
            }
        }
    });
    return targetNodeType.create(null, transformedItems);
};
const $daa920ce404d1b98$export$2f7df9065a975ace = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const { nodes: nodes } = tr.doc.type.schema;
    const sourceListType = sourceNode.type;
    const isSourceBulletOrOrdered = (0, $lCuAc.isBulletOrOrderedList)(sourceListType);
    const isTargetTask = (0, $96Kjp.isTaskList)(targetNodeType);
    const isSourceTask = (0, $96Kjp.isTaskList)(sourceListType);
    const isTargetBulletOrOrdered = (0, $lCuAc.isBulletOrOrderedList)(targetNodeType);
    // Check if we need structure transformation
    const needsStructureTransform = isSourceBulletOrOrdered && isTargetTask || isSourceTask && isTargetBulletOrOrdered;
    try {
        if (!needsStructureTransform) {
            // Simple type change for same structure lists (bullet <-> ordered)
            // Apply to the main list
            tr.setNodeMarkup(sourcePos, targetNodeType);
            // Apply to nested lists
            const listStart = sourcePos;
            const listEnd = sourcePos + sourceNode.nodeSize;
            const supportedListTypesSet = (0, $bQgtm.getSupportedListTypesSet)(nodes);
            tr.doc.nodesBetween(listStart, listEnd, (node, pos, parent)=>{
                // Only process nested lists (not the root list we already handled)
                if (supportedListTypesSet.has(node.type) && pos !== sourcePos) {
                    const isNestedList = parent && (supportedListTypesSet.has(parent.type) || parent.type === nodes.listItem);
                    if (isNestedList) {
                        const shouldTransformNode = node.type === sourceListType || (0, $lCuAc.isBulletOrOrderedList)(node.type) && isTargetBulletOrOrdered;
                        if (shouldTransformNode) tr.setNodeMarkup(pos, targetNodeType);
                    }
                }
                return true; // Continue traversing
            });
            return tr;
        } else return (0, $jSggL.transformListStructure)(context);
    } catch  {
        return null;
    }
};
const $daa920ce404d1b98$export$201fb3474673bbf3 = (tr, range, targetNodeType, targetAttrs, nodes)=>{
    try {
        const { taskItem: taskItem, paragraph: paragraph, blockTaskItem: blockTaskItem } = nodes;
        // gating behind platform_editor_small_font_size to support task lists with font size applied,
        // but keep this solution general
        const isBlockTaskItemEnabled = !!blockTaskItem && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        const listItems = [];
        // Process each block in the range
        tr.doc.nodesBetween(range.start, range.end, (node)=>{
            if (node.isBlock) {
                const inlineContent = [
                    ...node.content.content
                ];
                if (inlineContent.length > 0) {
                    if (isBlockTaskItemEnabled && node.type === paragraph && node.marks.length > 0) listItems.push((0, $kPKLu.createBlockTaskItem)({
                        attrs: targetAttrs,
                        content: inlineContent,
                        marks: node.marks,
                        schema: tr.doc.type.schema
                    }));
                    else listItems.push(taskItem.create(targetAttrs, inlineContent));
                }
            }
            return false;
        });
        if (listItems.length === 0) return null;
        // Create the new task list
        const newList = targetNodeType.create(targetAttrs, listItems);
        // Replace the range with the new list
        tr.replaceWith(range.start, range.end, newList);
        return tr;
    } catch  {
        return null;
    }
};
module.exports["transformListRecursively"] = $daa920ce404d1b98$export$95df50ae6315ead6;
module.exports["transformBetweenListTypes"] = $daa920ce404d1b98$export$2f7df9065a975ace;
module.exports["transformToTaskList"] = $daa920ce404d1b98$export$201fb3474673bbf3;

});

parcelRegister("9HWym", function(module, exports) {

var $9kbTQ = parcelRequire("9kbTQ");


var $kHija = parcelRequire("kHija");


var $57Rmq = parcelRequire("57Rmq");


var $ieeJu = parcelRequire("ieeJu");


var $SlYRR = parcelRequire("SlYRR");

const $b6f82fec0791dd8e$export$4a66a44681ab4c77 = 'drop-target-decoration';
const $b6f82fec0791dd8e$export$eac9eb77d42744c8 = 'drag-handle';
const $b6f82fec0791dd8e$export$ab0e97a1d4f97633 = 'node-decoration';
const $b6f82fec0791dd8e$export$4a19606d812406a7 = 100;
const $b6f82fec0791dd8e$export$20dcf6d6c6a1b068 = (node)=>{
    const handleId = $b6f82fec0791dd8e$var$ObjHash.getForNode(node);
    return `--node-anchor-${node.type.name}-${handleId}`;
};
const $b6f82fec0791dd8e$var$getSubType = (node)=>{
    if (node.attrs.level) return `-${node.attrs.level}`;
    if ((0, $SlYRR.isFontSizeMarkActive)(node)) return '-small';
    return '';
};
const $b6f82fec0791dd8e$export$b0da2ac7a61aa72c = (node)=>{
    const subType = (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $b6f82fec0791dd8e$var$getSubType(node) : node.attrs.level ? `-${node.attrs.level}` : '';
    const typeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(node.type) : node.type.name;
    return typeName + subType;
};
class $b6f82fec0791dd8e$var$ObjHash {
    static getForNode(node) {
        if (this.caching.has(node)) return this.caching.get(node);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
        this.caching.set(node, uniqueId);
        return uniqueId;
    }
}
$b6f82fec0791dd8e$var$ObjHash.caching = new WeakMap();
const $b6f82fec0791dd8e$export$ad2994468d2cac1a = (nodeViewPortalProviderAPI, selector, key)=>{
    // Removing decorations manually instead of using native destroy function in prosemirror API
    // as it was more responsive and causes less re-rendering
    const decorationsToRemove = document.querySelectorAll(`[${selector}="true"]`);
    decorationsToRemove.forEach((el)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(el);
    });
};
module.exports["TYPE_DROP_TARGET_DEC"] = $b6f82fec0791dd8e$export$4a66a44681ab4c77;
module.exports["TYPE_HANDLE_DEC"] = $b6f82fec0791dd8e$export$eac9eb77d42744c8;
module.exports["TYPE_NODE_DEC"] = $b6f82fec0791dd8e$export$ab0e97a1d4f97633;
module.exports["NESTED_DEPTH"] = $b6f82fec0791dd8e$export$4a19606d812406a7;
module.exports["getNodeAnchor"] = $b6f82fec0791dd8e$export$20dcf6d6c6a1b068;
module.exports["getNodeTypeWithLevel"] = $b6f82fec0791dd8e$export$b0da2ac7a61aa72c;
module.exports["unmountDecorations"] = $b6f82fec0791dd8e$export$ad2994468d2cac1a;

});

parcelRegister("j28nv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $kHija = parcelRequire("kHija");


var $8nvEM = parcelRequire("8nvEM");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $hTjcC = parcelRequire("hTjcC");


var $1uWpr = parcelRequire("1uWpr");


var $9HWym = parcelRequire("9HWym");


var $a2W6S = parcelRequire("a2W6S");

const $a198263af814c63a$var$TYPE_ACTIVE_HANDLE_DEC = 'active-drag-handle-node';
const $a198263af814c63a$export$4a4d976428c4c181 = (pos, nodeSize)=>(0, $8nvEM.Decoration).node(pos, pos + nodeSize, {
        [(0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR)]: 'true'
    }, {
        type: $a198263af814c63a$var$TYPE_ACTIVE_HANDLE_DEC
    });
const $a198263af814c63a$export$88c77bebe4a56da8 = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $a198263af814c63a$var$TYPE_ACTIVE_HANDLE_DEC);
const $a198263af814c63a$export$613641ee4757989 = ()=>{
    const anchorName = `--node-anchor-paragraph-0`;
    const style = `anchor-name: ${anchorName}; margin-top: 0px;`;
    return (0, $8nvEM.Decoration).node(0, 2, {
        style: style,
        ['data-drag-handler-anchor-name']: anchorName
    }, {
        type: (0, $9HWym.TYPE_NODE_DEC)
    });
};
const $a198263af814c63a$export$3ec2b0df4b056a96 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $9HWym.TYPE_HANDLE_DEC));
};
const $a198263af814c63a$export$38a5c9b9faf26cd8 = ({ api: api, formatMessage: formatMessage, pos: pos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, handleOptions: handleOptions, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    (0, $9HWym.unmountDecorations)(nodeViewPortalProviderAPI, 'data-blocks-drag-handle-container', 'data-blocks-drag-handle-key');
    let unbind;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    const widgetSpec = (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -1,
        type: (0, $9HWym.TYPE_HANDLE_DEC),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $9HWym.TYPE_HANDLE_DEC}-${(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()}`,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $a2W6S.getMatchingBlockMarks)(editorState, pos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]) : [],
        destroy: (node)=>{
            unbind && unbind();
        }
    } : {
        side: -1,
        type: (0, $9HWym.TYPE_HANDLE_DEC),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${0, $9HWym.TYPE_HANDLE_DEC}-${(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()}`,
        marks: (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $a2W6S.getMatchingBlockMarks)(editorState, pos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]) : [],
        destroy: (node)=>{
            unbind && unbind();
        }
    };
    return (0, $8nvEM.Decoration).widget(pos, (view, getPosUnsafe)=>{
        const element = document.createElement('span');
        // inline decoration causes focus issues when refocusing Editor into first line
        element.style.display = 'block';
        if ((0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')) element.setAttribute('data-blocks-decorator-widget', 'true');
        element.setAttribute('data-testid', 'block-ctrl-decorator-widget');
        element.setAttribute('data-blocks-drag-handle-container', 'true');
        element.setAttribute('data-blocks-drag-handle-key', key);
        let isTopLevelNode = true;
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch  {
                // Ignore errors from getPosUnsafe
                return undefined;
            }
        };
        const newPos = getPos();
        if (typeof newPos === 'number') {
            const $pos = view.state.doc.resolve(newPos);
            isTopLevelNode = $pos?.parent.type.name === 'doc';
        }
        /*
     * We disable mouseover event to fix flickering issue on hover
     * However, the tooltip for nested drag handle is no long working.
     */ if (newPos === undefined || !isTopLevelNode) {
            if ((0, $ixfCV.fg)('platform_editor_fix_widget_destroy')) element.onmouseover = (e)=>{
                e.stopPropagation();
            };
            else unbind = (0, $cbY7C.bind)(element, {
                type: 'mouseover',
                listener: (e)=>{
                    e.stopPropagation();
                }
            });
        }
        // There are times when global clear: "both" styles are applied to this decoration causing jumpiness
        // due to margins applied to other nodes eg. Headings
        element.style.clear = 'unset';
        // temporarily re-instating ReactDOM.render to fix drag handle focus issue, fix to
        // follow via ED-26546
        // previous under platform_editor_react18_plugin_portalprovider
        // 	nodeViewPortalProviderAPI.render(
        // 		() =>
        // 			createElement(DragHandle, {
        // 				view,
        // 				api,
        // 				formatMessage,
        // 				getPos,
        // 				anchorName,
        // 				nodeType,
        // 				handleOptions,
        // 				isTopLevelNode,
        // 			}),
        // 		element,
        // 		key,
        // 	);
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render((0, $cozmU.createElement)((0, $1uWpr.DragHandleWithVisibility), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        else (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render((0, $cozmU.createElement)((0, $1uWpr.DragHandle), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        return element;
    }, widgetSpec);
};
module.exports["createActiveDragHandleNodeDecoration"] = $a198263af814c63a$export$4a4d976428c4c181;
module.exports["findActiveDragHandleNodeDec"] = $a198263af814c63a$export$88c77bebe4a56da8;
module.exports["emptyParagraphNodeDecorations"] = $a198263af814c63a$export$613641ee4757989;
module.exports["findHandleDec"] = $a198263af814c63a$export$3ec2b0df4b056a96;
module.exports["dragHandleDecoration"] = $a198263af814c63a$export$38a5c9b9faf26cd8;

});

parcelRegister("djgGr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $kHija = parcelRequire("kHija");


var $iQ6F7 = parcelRequire("iQ6F7");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $8nvEM = parcelRequire("8nvEM");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $hTjcC = parcelRequire("hTjcC");


var $64pwY = parcelRequire("64pwY");


var $ddJ8T = parcelRequire("ddJ8T");


var $9HWym = parcelRequire("9HWym");


var $icvkv = parcelRequire("icvkv");


var $SlYRR = parcelRequire("SlYRR");

const $3ceda6f169422654$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'layoutColumn',
    'listItem',
    'caption'
];
const $3ceda6f169422654$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
const $3ceda6f169422654$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $3ceda6f169422654$var$getParentTypesWithEndDropTarget = (0, $dOBRD.default)(()=>[
        ...$3ceda6f169422654$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? [
            'multiBodiedExtension'
        ] : [],
        ...(0, $fqVYq.editorExperiment)('platform_synced_block', true) ? [
            'bodiedSyncBlock'
        ] : []
    ]);
const $3ceda6f169422654$var$shouldDescend = (node)=>{
    return ![
        'mediaSingle',
        'paragraph',
        'heading'
    ].includes(node.type.name);
};
const $3ceda6f169422654$var$getNodeMargins = (node)=>{
    if (!node) return (0, $hTjcC.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.nodeMargins)[`heading${node.attrs.level}`] || (0, $hTjcC.nodeMargins)['default'];
    return (0, $hTjcC.nodeMargins)[nodeTypeName] || (0, $hTjcC.nodeMargins)['default'];
};
const $3ceda6f169422654$var$shouldCollapseMargin = (prevNode, nextNode)=>{
    if ((prevNode?.type.name === 'mediaSingle' || nextNode?.type.name === 'mediaSingle') && prevNode?.type.name !== nextNode?.type.name) return false;
    return true;
};
const $3ceda6f169422654$var$getGapAndOffset = (prevNode, nextNode, parentNode)=>{
    const isSyncBlockOffsetPatchEnabled = (0, $fqVYq.editorExperiment)('platform_synced_block', true);
    if (!prevNode && nextNode) {
        // first node - adjust for bodied containers
        let offset = 0;
        if (isSyncBlockOffsetPatchEnabled && parentNode?.type.name && parentNode.type.name === 'bodiedSyncBlock') offset += 4;
        return {
            gap: 0,
            offset: offset
        };
    } else if (prevNode && !nextNode) {
        // last node - adjust for bodied containers
        let offset = 0;
        if (isSyncBlockOffsetPatchEnabled && parentNode?.type.name && parentNode.type.name === 'bodiedSyncBlock') offset -= 4;
        return {
            gap: 0,
            offset: offset
        };
    }
    const top = $3ceda6f169422654$var$getNodeMargins(nextNode).top || 4;
    const bottom = $3ceda6f169422654$var$getNodeMargins(prevNode).bottom || 4;
    const gap = $3ceda6f169422654$var$shouldCollapseMargin(prevNode, nextNode) ? Math.max(top, bottom) : top + bottom;
    let offset = top - gap / 2;
    if (prevNode?.type.name === 'mediaSingle' && nextNode?.type.name === 'mediaSingle') offset = -offset;
    else if (prevNode?.type.name && [
        'tableCell',
        'tableHeader'
    ].includes(prevNode?.type.name)) offset = 0;
    return {
        gap: gap,
        offset: offset
    };
};
const $3ceda6f169422654$export$99bd791313c07808 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $9HWym.TYPE_DROP_TARGET_DEC));
};
const $3ceda6f169422654$export$fc632359c395fc7 = (pos, props, nodeViewPortalProviderAPI, side, anchorRectCache, isSameLayout)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    return (0, $8nvEM.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const { gap: gap, offset: offset } = $3ceda6f169422654$var$getGapAndOffset(props.prevNode, props.nextNode, props.parentNode);
        element.style.setProperty((0, $64pwY.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $64pwY.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP), `${gap}px`);
        element.style.setProperty('display', 'block');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $64pwY.DropTarget), {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache,
                isSameLayout: isSameLayout
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $9HWym.TYPE_DROP_TARGET_DEC),
        side: side,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $3ceda6f169422654$export$eb62fe530f14234e = (pos, props, nodeViewPortalProviderAPI, anchorRectCache)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    return (0, $8nvEM.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const DropTargetLayoutComponent = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? (0, $ddJ8T.DropTargetLayoutNativeAnchorSupport) : (0, $ddJ8T.DropTargetLayout);
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)(DropTargetLayoutComponent, {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $9HWym.TYPE_DROP_TARGET_DEC),
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $3ceda6f169422654$export$248c2f3619ca4fdf = (newState, api, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache, from, to)=>{
    const decs = [];
    const POS_END_OF_DOC = newState.doc.nodeSize - 2;
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > POS_END_OF_DOC ? POS_END_OF_DOC : to;
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && newState.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    anchorRectCache?.clear();
    const prevNodeStack = [];
    const popNodeStack = (depth)=>{
        let result;
        const toDepth = Math.max(depth, 0);
        while(prevNodeStack.length > toDepth)result = prevNodeStack.pop();
        return result;
    };
    const pushNodeStack = (node, depth)=>{
        popNodeStack(depth);
        prevNodeStack.push(node);
    };
    const isAdvancedLayoutsPreRelease2 = (0, $fqVYq.editorExperiment)('advanced_layouts', true);
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = newState.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const parentTypesWithEndDropTarget = $3ceda6f169422654$var$getParentTypesWithEndDropTarget();
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, index)=>{
        let depth = 0;
        // drop target deco at the end position
        let endPos;
        const $pos = newState.doc.resolve(pos);
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, $pos);
        depth = $pos.depth;
        if (isAdvancedLayoutsPreRelease2) {
            if (activeNode?.pos === pos && activeNode.nodeType !== 'layoutColumn') return false;
            if (node.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 && // Not the first node
            (parent?.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout)) // Add drop target for layout columns
            decs.push($3ceda6f169422654$export$eb62fe530f14234e(pos, {
                api: api,
                parent: parent,
                formatMessage: formatMessage
            }, nodeViewPortalProviderAPI, anchorRectCache));
        }
        if (node.isInline || !parent || $3ceda6f169422654$var$DISABLE_CHILD_DROP_TARGET.includes(parent.type.name)) {
            pushNodeStack(node, depth);
            return false;
        }
        if ($3ceda6f169422654$var$IGNORE_NODES.includes(node.type.name)) {
            pushNodeStack(node, depth);
            return $3ceda6f169422654$var$shouldDescend(node); //skip over, don't consider it a valid depth
        }
        // validate all the nodes in the selection instead of just the handle node
        const selectionSlice = newState.doc.slice(selectionFrom, selectionTo, false);
        const selectionSliceChildCount = selectionSlice.content.childCount;
        let canDropSingleNode = true;
        let canDropMultipleNodes = true;
        // when there is only one node in the slice, use the same logic as when multi select is not on
        if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $SlYRR.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $pos);
        else canDropSingleNode = !!(activePMNode && (0, $SlYRR.canMoveNodeToIndex)(parent, index, activePMNode, $pos, node));
        if (!canDropMultipleNodes || !canDropSingleNode) {
            pushNodeStack(node, depth);
            return false; //not valid pos, so nested not valid either
        }
        const parentTypeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(parent.type) : parent.type.name;
        if (parent.lastChild === node && !(0, $2w79Z.isEmptyParagraph)(node) && parentTypesWithEndDropTarget.includes(parentTypeName)) endPos = pos + node.nodeSize;
        const previousNode = popNodeStack(depth); // created scoped variable
        // only table and layout need to render full height drop target
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $2w79Z.isEmptyParagraph)(node);
        decs.push($3ceda6f169422654$export$fc632359c395fc7(pos, {
            api: api,
            prevNode: previousNode,
            nextNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        if (endPos !== undefined) decs.push($3ceda6f169422654$export$fc632359c395fc7(endPos, {
            api: api,
            prevNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'remainingHeight'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache));
        pushNodeStack(node, depth);
        return depth < (0, $9HWym.NESTED_DEPTH) && $3ceda6f169422654$var$shouldDescend(node);
    });
    if (docTo === POS_END_OF_DOC) decs.push($3ceda6f169422654$export$fc632359c395fc7(POS_END_OF_DOC, {
        api: api,
        formatMessage: formatMessage,
        prevNode: newState.doc.lastChild || undefined,
        parentNode: newState.doc
    }, nodeViewPortalProviderAPI, undefined, anchorRectCache));
    return decs;
};
module.exports["findDropTargetDecs"] = $3ceda6f169422654$export$99bd791313c07808;
module.exports["createDropTargetDecoration"] = $3ceda6f169422654$export$fc632359c395fc7;
module.exports["createLayoutDropTargetDecoration"] = $3ceda6f169422654$export$eb62fe530f14234e;
module.exports["dropTargetDecorations"] = $3ceda6f169422654$export$248c2f3619ca4fdf;

});

parcelRegister("g8ZIt", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $iQ6F7 = parcelRequire("iQ6F7");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $bjg0G = parcelRequire("bjg0G");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $9HWym = parcelRequire("9HWym");


var $djgGr = parcelRequire("djgGr");


var $cX57A = parcelRequire("cX57A");


var $d1Uph = parcelRequire("d1Uph");


var $icvkv = parcelRequire("icvkv");


var $SlYRR = parcelRequire("SlYRR");

/**
 * List of parent node types that can have child nodes
 */ const $4da6fa97a78aba31$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
/**
 * List of node types that does not allow drop targets at before or after the node.
 */ const $4da6fa97a78aba31$var$NODE_WITH_NO_PARENT_POS = [
    'tableCell',
    'tableHeader',
    'layoutColumn'
];
const $4da6fa97a78aba31$var$UNSUPPORTED_LAYOUT_CONTENT = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $4da6fa97a78aba31$var$getContainerNodeTypes = (0, $dOBRD.default)(()=>[
        ...$4da6fa97a78aba31$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? [
            'multiBodiedExtension'
        ] : [],
        ...(0, $fqVYq.editorExperiment)('platform_synced_block', true) ? [
            'bodiedSyncBlock'
        ] : []
    ]);
const $4da6fa97a78aba31$var$isContainerNode = (node)=>{
    const nodeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)(node.type) : node.type.name;
    return $4da6fa97a78aba31$var$getContainerNodeTypes().includes(nodeName);
};
const $4da6fa97a78aba31$export$40c317c5c02ece25 = (state, node, parent, index, $toPos, activeNode)=>{
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = state.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const selectionSlice = state.doc.slice(selectionFrom, selectionTo, false);
    const selectionSliceChildCount = selectionSlice.content.childCount;
    let canDropSingleNode = true;
    let canDropMultipleNodes = true;
    // when there is only one node in the slice, use the same logic as when multi select is not on
    if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $SlYRR.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $toPos);
    else canDropSingleNode = !!(activePMNode && (0, $SlYRR.canMoveNodeToIndex)(parent, index, activePMNode, $toPos, node));
    if (!canDropMultipleNodes || !canDropSingleNode) return false;
    return true;
};
const $4da6fa97a78aba31$export$181f339130769cb6 = (activeDropTargetNode, state, api, existingDecs, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache)=>{
    const decsToAdd = [];
    let decsToRemove = existingDecs.filter((dec)=>!!dec);
    const activeNodePos = activeNode?.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const $toPos = state.doc.resolve(activeDropTargetNode.pos);
    const existingDecsPos = decsToRemove.map((dec)=>dec.from);
    const { parent: parent, index: index, node: node, pos: pos, before: before, after: after, depth: depth } = (0, $cX57A.findSurroundingNodes)(state, $toPos, activeDropTargetNode.nodeTypeName);
    /**
   * If the current node is a container node, we show the drop targets
   * above the first child and below the last child.
   */ if ($4da6fa97a78aba31$var$isContainerNode(node)) {
        const isEmptyContainer = node.childCount === 0 || node.childCount === 1 && (0, $2w79Z.isEmptyParagraph)(node.firstChild);
        // can move to before first child
        const posBeforeFirstChild = pos + 1; // +1 to get the position of the first child
        if (node.firstChild && $4da6fa97a78aba31$export$40c317c5c02ece25(state, node.firstChild, node, 0, state.doc.resolve(posBeforeFirstChild), activeNode)) {
            if (existingDecsPos.includes(posBeforeFirstChild)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posBeforeFirstChild);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posBeforeFirstChild, {
                api: api,
                prevNode: undefined,
                nextNode: node.firstChild,
                parentNode: node,
                formatMessage: formatMessage,
                dropTargetStyle: isEmptyContainer ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, 1, anchorRectCache));
        }
        // can move to after last child
        // if the node is empty, we don't show the drop target at the end of the node
        if (!isEmptyContainer) {
            const posAfterLastChild = pos + node.nodeSize - 1; // -1 to get the position after last child
            if (node.lastChild && $4da6fa97a78aba31$export$40c317c5c02ece25(state, node.lastChild, node, node.childCount - 1, state.doc.resolve(posAfterLastChild), // -1 to get the position after last child
            activeNode)) {
                if (existingDecsPos.includes(posAfterLastChild)) // if the decoration already exists, we don't add it again.
                decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterLastChild);
                else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posAfterLastChild, {
                    api: api,
                    prevNode: node.lastChild,
                    nextNode: undefined,
                    parentNode: node,
                    formatMessage: formatMessage,
                    dropTargetStyle: 'remainingHeight'
                }, nodeViewPortalProviderAPI, -1, anchorRectCache));
            }
        }
    }
    /**
   * Create drop target before and after the current node
   */ if (!$4da6fa97a78aba31$var$NODE_WITH_NO_PARENT_POS.includes(node.type.name)) {
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, $toPos);
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes(parent?.type.name || '');
        const shouldShowFullHeight = isInSupportedContainer && parent?.lastChild === node && (0, $2w79Z.isEmptyParagraph)(node);
        if ($4da6fa97a78aba31$export$40c317c5c02ece25(state, node, parent, index, $toPos, activeNode)) {
            if (existingDecsPos.includes(pos)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== pos);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(pos, {
                api: api,
                prevNode: before || undefined,
                nextNode: node,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
        // if the node is a container node, we show the drop target after the node
        const posAfterNode = pos + node.nodeSize;
        if ($4da6fa97a78aba31$export$40c317c5c02ece25(state, node, parent, index + 1, state.doc.resolve(posAfterNode), activeNode)) {
            if (existingDecsPos.includes(posAfterNode)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterNode);
            else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(posAfterNode, {
                api: api,
                prevNode: node,
                nextNode: after || undefined,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
    }
    let rootNodeWithPos = {
        node: node,
        pos: pos
    };
    // if the current node is not a top level node, we create one for advanced layout drop targets
    if (depth > 1) {
        const root = (0, $cX57A.findSurroundingNodes)(state, state.doc.resolve($toPos.before(2)));
        if (existingDecsPos.includes(root.pos)) // if the decoration already exists, we don't add it again.
        decsToRemove = decsToRemove.filter((dec)=>dec.from !== root.pos);
        else decsToAdd.push((0, $djgGr.createDropTargetDecoration)(root.pos, {
            api: api,
            prevNode: root.before || undefined,
            nextNode: root.node,
            parentNode: state.doc || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, false));
        rootNodeWithPos = {
            node: root.node,
            pos: root.pos
        };
    }
    let anchorEmitNodeWithPos = rootNodeWithPos;
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            const schema = rootNodeWithPos.node.type.schema;
            const { layoutSection: layoutSection } = schema.nodes;
            const isLayoutSectionChildOfRoot = (0, $bjg0G.findChildrenByType)(rootNodeWithPos.node, layoutSection, false).length > 0;
            if (isLayoutSectionChildOfRoot) {
                // if node has layoutSection as a child, get the layoutSection node and pos
                for(let ancestorDepth = $toPos.depth; ancestorDepth >= 1; ancestorDepth--)if ($toPos.node(ancestorDepth).type.name === 'layoutSection') {
                    anchorEmitNodeWithPos = {
                        node: $toPos.node(ancestorDepth),
                        pos: $toPos.before(ancestorDepth)
                    };
                    break;
                }
            } else anchorEmitNodeWithPos = rootNodeWithPos;
        } else anchorEmitNodeWithPos = rootNodeWithPos;
        const isSameLayout = $activeNodePos && (0, $SlYRR.isInSameLayout)($activeNodePos, state.doc.resolve(anchorEmitNodeWithPos.pos));
        const hasUnsupportedContent = $4da6fa97a78aba31$var$UNSUPPORTED_LAYOUT_CONTENT.includes(activeNode?.nodeType || '') && (0, $fqVYq.editorExperiment)('platform_synced_block', true);
        if (anchorEmitNodeWithPos.node.type.name === 'layoutSection' && !hasUnsupportedContent) {
            const layoutSectionNode = anchorEmitNodeWithPos.node;
            if (layoutSectionNode.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout) layoutSectionNode.descendants((childNode, childPos, parent, index)=>{
                if (childNode.type.name === 'layoutColumn' && parent?.type.name === 'layoutSection' && index !== 0 // Not the first node
                ) {
                    const currentPos = anchorEmitNodeWithPos.pos + childPos + 1;
                    if (existingDecsPos.includes(currentPos)) // if the decoration already exists, we don't add it again.
                    decsToRemove = decsToRemove.filter((dec)=>dec.from !== currentPos);
                    else decsToAdd.push((0, $djgGr.createLayoutDropTargetDecoration)(anchorEmitNodeWithPos.pos + childPos + 1, {
                        api: api,
                        parent: parent,
                        formatMessage: formatMessage
                    }, nodeViewPortalProviderAPI, anchorRectCache));
                }
                return false;
            });
        }
    }
    (0, $d1Uph.defaultActiveAnchorTracker).emit((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? api.core.actions.getAnchorIdForNode(anchorEmitNodeWithPos.node, anchorEmitNodeWithPos.pos) || '' : (0, $9HWym.getNodeAnchor)(anchorEmitNodeWithPos.node));
    return {
        decsToAdd: decsToAdd,
        decsToRemove: decsToRemove
    };
};
module.exports["getActiveDropTargetDecorations"] = $4da6fa97a78aba31$export$181f339130769cb6;

});

parcelRegister("hYw7t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $8nvEM = parcelRequire("8nvEM");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $hTjcC = parcelRequire("hTjcC");


var $2ZDdD = parcelRequire("2ZDdD");


var $a2W6S = parcelRequire("a2W6S");

const $d34f0626fb94450e$var$TYPE_QUICK_INSERT = 'INSERT_BUTTON';
const $d34f0626fb94450e$var$TYPE_ACTIVE_QUICK_INSERT_NODE = 'active-quick-insert-node';
const $d34f0626fb94450e$export$a6ab3402831bd7d8 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $d34f0626fb94450e$var$TYPE_QUICK_INSERT);
};
const $d34f0626fb94450e$export$5b9210fd80ac3dfb = (pos, nodeSize)=>(0, $8nvEM.Decoration).node(pos, pos + nodeSize, {
        [(0, $hTjcC.ACTIVE_QUICK_INSERT_ATTR)]: 'true'
    }, {
        type: $d34f0626fb94450e$var$TYPE_ACTIVE_QUICK_INSERT_NODE
    });
const $d34f0626fb94450e$export$678e19285f8625bb = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $d34f0626fb94450e$var$TYPE_ACTIVE_QUICK_INSERT_NODE);
const $d34f0626fb94450e$export$ab399427af69a61 = ({ api: api, formatMessage: formatMessage, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    const cleanupCallbacks = [];
    const widgetSpec = (0, $fqVYq.editorExperiment)('platform_editor_breakout_resizing', true) ? {
        side: -2,
        type: $d34f0626fb94450e$var$TYPE_QUICK_INSERT,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $a2W6S.getMatchingBlockMarks)(editorState, rootPos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]) : [],
        destroy: (_)=>{
            if ((0, $ixfCV.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    } : {
        side: -2,
        type: $d34f0626fb94450e$var$TYPE_QUICK_INSERT,
        destroy: (_)=>{
            if ((0, $ixfCV.fg)('platform_editor_fix_widget_destroy')) nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    };
    return (0, $8nvEM.Decoration).widget(rootPos, (view, getPos)=>{
        const element = document.createElement('span');
        // inline decoration causes cursor disappear when focusing editor at the first line (e.g. press Tab when title is focused)
        element.style.display = 'block';
        // make sure it does not interfere with elements floating next to each other e.g. paragraph next to image with wrap-right
        element.style.clear = 'unset';
        element.contentEditable = 'false';
        element.setAttribute('data-blocks-quick-insert-container', 'true');
        if ((0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')) element.setAttribute('data-blocks-quick-insert-button', 'true');
        element.setAttribute('data-testid', 'block-ctrl-quick-insert-button');
        nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $2ZDdD.QuickInsertWithVisibility), {
                api: api,
                getPos: getPos,
                formatMessage: formatMessage,
                view: view,
                nodeType: nodeType,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, widgetSpec);
};
module.exports["findQuickInsertInsertButtonDecoration"] = $d34f0626fb94450e$export$a6ab3402831bd7d8;
module.exports["createActiveQuickInsertNodeDecoration"] = $d34f0626fb94450e$export$5b9210fd80ac3dfb;
module.exports["findActiveQuickInsertNodeDec"] = $d34f0626fb94450e$export$678e19285f8625bb;
module.exports["quickInsertButtonDecoration"] = $d34f0626fb94450e$export$ab399427af69a61;

});

parcelRegister("9UAss", function(module, exports) {

var $kAPZe = parcelRequire("kAPZe");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");

const $e5dceea5395d1c13$export$b4a93e0b711d8f7 = (api)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        if (!view.editable) {
            const targetPos = view.posAtDOM(event.target, 0);
            // always fetch top level position for mouseDown to avoid drag handle positions being incorrect
            const rootPos = view.state.doc.resolve(targetPos).before(1);
            const rootNode = view.state.doc.nodeAt(rootPos);
            if (!rootNode) return false;
            if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const anchorName = api?.core.actions.getAnchorIdForNode(rootNode, rootPos);
                // don't show the handles if we can't find an anchor
                if (!anchorName) return false;
                api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, anchorName, rootNode.type.name ?? '', undefined, rootPos, anchorName, rootNode.type.name ?? ''));
            } else api?.core.actions.execute(api?.blockControls.commands.showDragHandleAt(rootPos, '', rootNode.type.name ?? '', undefined, rootPos, '', rootNode.type.name ?? ''));
        } else {
            const isDragHandle = event.target.closest((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? (0, $kAPZe.DRAG_HANDLE_SELECTOR) : '[data-editor-block-ctrl-drag-handle]') !== null;
            api?.core.actions.execute(({ tr: tr })=>{
                api?.blockControls.commands.setSelectedViaDragHandle(isDragHandle)({
                    tr: tr
                });
                /**
				 * When block menu is enabled, reset intent back to 'default' as editor-plugin-block-menu sets the user intent to 'blockMenuOpen', and setting here
				 * causes flickering as this runs before editor-plugin-block-menu.
				 */ if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) // if target is drag handle, block menu will be opened
                {
                    if (!isDragHandle) api?.userIntent?.commands.setCurrentUserIntent('default')({
                        tr: tr
                    });
                } else api.userIntent?.commands.setCurrentUserIntent(isDragHandle ? 'dragHandleSelected' : 'default')({
                    tr: tr
                });
                return tr;
            });
        }
        return false;
    };
module.exports["handleMouseDown"] = $e5dceea5395d1c13$export$b4a93e0b711d8f7;

});

parcelRegister("h7MdN", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $lVAkE = parcelRequire("lVAkE");


var $g6uqx = parcelRequire("g6uqx");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $fKt2m = parcelRequire("fKt2m");


var $rOV4B = parcelRequire("rOV4B");


var $6FQH1 = parcelRequire("6FQH1");

const $022924a8fbeb2a1a$var$isEmptyNestedParagraphOrHeading = (target)=>{
    if (target instanceof HTMLHeadingElement || target instanceof HTMLParagraphElement) return !target.parentElement?.classList.contains('ProseMirror') && target.textContent === '';
    return false;
};
const $022924a8fbeb2a1a$var$getNodeSelector = (ignoreNodes, ignoreNodeDescendants)=>{
    const baseSelector = `[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`;
    if (ignoreNodes.length === 0 && ignoreNodeDescendants.length === 0) return baseSelector;
    const ignoreNodeSelectorList = ignoreNodes.map((node)=>`[data-prosemirror-node-name="${node}"]`);
    const ignoreNodeDescendantsSelectorList = ignoreNodeDescendants.map((node)=>{
        if (node === 'table') // Special case for table to exclude its direct descendants
        return [
            `[data-prosemirror-node-name="tableCell"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableCell"] > *:not([data-node-anchor]) > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > *:not([data-node-anchor]) > [data-node-anchor]`
        ];
        return `[data-prosemirror-node-name="${node}"] [data-node-anchor]`;
    });
    const ignoreSelector = [
        ...ignoreNodeSelectorList,
        ...ignoreNodeDescendantsSelectorList.flat(),
        '[data-prosemirror-node-inline="true"]'
    ].join(', ');
    return `${baseSelector}:not(${ignoreSelector})`;
};
const $022924a8fbeb2a1a$var$getDefaultNodeSelector = (0, $dOBRD.default)(()=>{
    // we don't show handler for node nested in table
    return $022924a8fbeb2a1a$var$getNodeSelector([
        ...(0, $rOV4B.IGNORE_NODES_NEXT),
        'media'
    ], [
        ...(0, $rOV4B.IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT),
        'table'
    ]);
});
// Block marks (e.g. font-size) wrap paragraphs in an extra div, making parentRootElement
// the mark wrapper instead of the panel content container. When that happens, recalculate
// the index relative to the panel content so the first-child check stays accurate.
const $022924a8fbeb2a1a$var$getBlockMarkPanelIndexAdjustment = (parentRootElement, index)=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && parentRootElement.classList.contains('fabric-editor-block-mark') && parentRootElement.parentElement) return Array.from(parentRootElement.parentElement.childNodes).indexOf(parentRootElement);
    return index;
};
/**
 * If the hovered element is a paragraph adjacent to a wrapped mediaSingle/embedCard,
 * redirect to the media node so only one drag handle shows (ED-26959).
 */ const $022924a8fbeb2a1a$var$redirectParagraphToWrappedMedia = (rootElement, isNativeAnchorSupported)=>{
    const hoveredNodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootElement) : rootElement.getAttribute('data-drag-handler-node-type');
    if (hoveredNodeType !== 'paragraph') return rootElement;
    const isWrappedMediaEmbedSibling = (sibling)=>{
        if (!sibling || !sibling.getAttribute((0, $fKt2m.getAnchorAttrName)())) return false;
        const siblingType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(sibling) : sibling.getAttribute('data-drag-handler-node-type');
        const siblingLayout = sibling.getAttribute('layout') || '';
        return (siblingType === 'mediaSingle' || siblingType === 'embedCard') && [
            'wrap-left',
            'wrap-right'
        ].includes(siblingLayout);
    };
    const prevSibling = rootElement.previousElementSibling;
    const nextSibling = rootElement.nextElementSibling;
    if (prevSibling && isWrappedMediaEmbedSibling(prevSibling)) return prevSibling;
    else if (nextSibling && isWrappedMediaEmbedSibling(nextSibling)) return nextSibling;
    return rootElement;
};
const $022924a8fbeb2a1a$export$321c2da35903b013 = (view, event, api)=>{
    const { isDragging: isDragging, activeNode: activeNode, isMenuOpen: isMenuOpen, menuTriggerBy: originalAnchorName, blockMenuOptions: blockMenuOptions } = api?.blockControls?.sharedState.currentState() || {};
    const { editorDisabled: editorDisabled } = api?.editorDisabled?.sharedState.currentState() || {
        editorDisabled: false
    };
    const editorViewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
    const isViewMode = editorViewMode === 'view';
    const toolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    // We shouldn't be firing mouse over transactions when the editor is disabled,
    // except in view mode when right-side controls are enabled (show controls on block hover)
    const rightSideControlsEnabled = api?.blockControls?.sharedState.currentState()?.rightSideControlsEnabled ?? false;
    if (editorDisabled && (!isViewMode || !(rightSideControlsEnabled && (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')))) return false;
    // If the editor view is not in focus when the block menu is open, do not update the drag handle
    if (!view.hasFocus() && isMenuOpen && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) return false;
    // Most mouseover events don't fire during drag but some can slip through
    // when the drag begins. This prevents those.
    if (isDragging) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isNativeAnchorSupported = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    if (target?.classList?.contains('ProseMirror')) return false;
    let rootElement = target?.closest(isNativeAnchorSupported ? $022924a8fbeb2a1a$var$getDefaultNodeSelector() : `[data-drag-handler-anchor-name]`);
    // Fallback for table nodes in view mode: the table-anchor-names plugin sets data-node-anchor on
    // the first <tr> element.
    // - When platform_editor_native_anchor_with_dnd is disabled, the primary closest() uses
    //   [data-drag-handler-anchor-name] and misses table rows. Try data-node-anchor via closest().
    // - For wide/max breakout tables, hovering in the left/right margin area of the full-viewport-
    //   width breakout wrapper (ak-editor-breakout-mark) sets event.target to the wrapper div, which
    //   has no anchor attribute. Use querySelector to find the [data-node-anchor] descendant inside.
    // Both cases apply only in view mode with right-side remix controls.
    if (!rootElement && isViewMode && rightSideControlsEnabled) rootElement = target?.closest(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`) ?? (target instanceof HTMLElement ? target.querySelector(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`) : null) ?? null;
    // When hovering over the right-edge button (rendered in a portal outside the block), resolve the
    // block from the container's anchor so activeNode stays set and the button remains visible.
    if (!rootElement && rightSideControlsEnabled && (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg')) {
        const rightEdgeContainer = target?.closest('[data-blocks-right-edge-button-container]');
        if (rightEdgeContainer) {
            const anchor = rightEdgeContainer.getAttribute('data-blocks-right-edge-button-anchor');
            if (anchor) rootElement = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${CSS.escape(anchor)}"]`);
        }
    }
    if (rootElement) {
        // We want to exlude handles from showing for empty paragraph and heading nodes
        if ($022924a8fbeb2a1a$var$isEmptyNestedParagraphOrHeading(rootElement)) return false;
        if (rootElement.getAttribute((0, $fKt2m.getTypeNameAttrName)()) === 'media' && (0, $fqVYq.editorExperiment)('advanced_layouts', true) && !isNativeAnchorSupported) {
            rootElement = rootElement.closest(`[${(0, $fKt2m.getAnchorAttrName)()}][${(0, $fKt2m.getTypeNameAttrName)()}="mediaSingle"]`);
            if (!rootElement) return false;
        }
        const parentElement = rootElement.parentElement?.closest(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
        const parentElementType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(parentElement) : parentElement?.getAttribute('data-drag-handler-node-type');
        if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
            // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
            if (parentElement && parentElementType === 'table') rootElement = parentElement;
            else if (parentElement && parentElementType === 'tableRow') {
                const grandparentElement = parentElement?.parentElement?.closest(`[${(0, $fKt2m.getAnchorAttrName)()}]`);
                const grandparentElementType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(grandparentElement) : grandparentElement?.getAttribute('data-drag-handler-node-type');
                if (grandparentElement && grandparentElementType === 'table') rootElement = grandparentElement;
            }
        } else // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
        if (parentElement && parentElementType === 'table') rootElement = parentElement;
        // A wrapped mediaSingle/embedCard and the paragraph(s) it floats next to both have
        // anchor decorations. If the hovered rootElement is a paragraph whose adjacent DOM sibling
        // is a wrapped mediaSingle/embedCard with an anchor, redirect the handle to the media node
        // so only one handle shows (ED-26959).
        // We check previousElementSibling (wrap-left: media precedes text in DOM) and
        // nextElementSibling (wrap-right: media follows text in DOM).
        // This must happen before anchorName is read so the correct node's handle is shown.
        rootElement = $022924a8fbeb2a1a$var$redirectParagraphToWrappedMedia(rootElement, isNativeAnchorSupported);
        let anchorName;
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            anchorName = rootElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
            // don't show handles if we can't find an anchor
            if (!anchorName) return false;
        } else {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorName = rootElement.getAttribute((0, $fKt2m.getAnchorAttrName)());
            // Fallback for table nodes that only have data-node-anchor (not data-drag-handler-anchor-name).
            if (!anchorName) anchorName = rootElement.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME)) ?? anchorName;
        }
        // No need to update handle position if its already there
        if (activeNode?.anchorName === anchorName) return false;
        const parentRootElement = rootElement.parentElement;
        let pos;
        if (parentRootElement) {
            const childNodes = Array.from(parentRootElement.childNodes);
            const index = childNodes.indexOf(rootElement);
            pos = view.posAtDOM(parentRootElement, index);
            const panelIndex = $022924a8fbeb2a1a$var$getBlockMarkPanelIndexAdjustment(parentRootElement, index);
            // We want to exlude handles showing for first element in a Panel, ignoring widgets like gapcursor
            const firstChildIsWidget = parentRootElement?.children[0]?.classList.contains('ProseMirror-widget');
            if (parentElement && parentElementType === 'panel' && !parentElement.classList.contains('ak-editor-panel__no-icon') && (panelIndex === 0 || firstChildIsWidget && panelIndex === 1)) return false;
        } else pos = view.posAtDOM(rootElement, 0);
        if (parentRootElement && parentRootElement.getAttribute('data-layout-section') === 'true' && parentRootElement.querySelectorAll('[data-layout-column]').length === 1 && (0, $fqVYq.editorExperiment)('advanced_layouts', true) && !(0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) // Don't show drag handle for layout column in a single column layout,
        // unless the layout column menu is enabled (menu needs the handle to be accessible).
        return false;
        const targetPos = view.state.doc.resolve(pos).pos;
        let rootAnchorName;
        let rootNodeType;
        let rootPos;
        // platform_editor_controls note: enables quick insert
        if (toolbarFlagsEnabled) {
            rootPos = view.state.doc.resolve(pos).before(1);
            if (targetPos !== rootPos) {
                const rootDOM = view.nodeDOM(rootPos);
                if (rootDOM instanceof HTMLElement) {
                    rootAnchorName = rootDOM.getAttribute((0, $fKt2m.getAnchorAttrName)()) ?? rootDOM.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME)) ?? undefined;
                    rootNodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootDOM) : // Fallback: breakout mark wrappers have no data-drag-handler-node-type;
                    // use data-prosemirror-node-name instead.
                    rootDOM.getAttribute('data-drag-handler-node-type') ?? (0, $fKt2m.getTypeNameFromDom)(rootDOM);
                }
            }
        }
        const nodeType = isNativeAnchorSupported ? (0, $fKt2m.getTypeNameFromDom)(rootElement) : // Fallback for table nodes: tr has data-prosemirror-node-name but not data-drag-handler-node-type.
        rootElement.getAttribute('data-drag-handler-node-type') ?? (0, $fKt2m.getTypeNameFromDom)(rootElement);
        if (nodeType) {
            // platform_editor_controls note: enables quick insert
            if (toolbarFlagsEnabled) {
                if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
                    const preservedSelection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection;
                    const selection = preservedSelection || view.state.selection;
                    const isMultipleSelected = selection && (0, $lVAkE.isMultiBlockSelection)(selection);
                    // Only execute when selection is not a multi-selection, block menu is open, and menu is opened via keyboard
                    // as when it is a multi-selection, the showDragHandleAt command interfere with selection
                    // sometimes makes the multi-selection not continous after block menu is opened with keyboard
                    if (!(isMultipleSelected && isMenuOpen && blockMenuOptions?.openedViaKeyboard)) api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
                } else api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
            } else api?.core?.actions.execute(api?.blockControls?.commands.showDragHandleAt(targetPos, anchorName, nodeType));
            if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
                if (isMenuOpen && originalAnchorName && api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen') api?.core?.actions.execute(api?.blockControls?.commands.toggleBlockMenu());
            }
        }
    }
};
module.exports["handleMouseOver"] = $022924a8fbeb2a1a$export$321c2da35903b013;

});

parcelRegister("jdNrc", function(module, exports) {

var $ldqjS = parcelRequire("ldqjS");


var $1xYQH = parcelRequire("1xYQH");


var $44cyU = parcelRequire("44cyU");


var $b3nYA = parcelRequire("b3nYA");


var $dhlUl = parcelRequire("dhlUl");

function $b8798c8225018002$var$keymapList(api, formatMessage) {
    const keymapList = {};
    if (api) {
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.showElementDragHandle).common, (state, dispatch, view)=>{
            (0, $dhlUl.showDragHandleAtSelection)(api)(state, dispatch, view);
            //we always want to handle this shortcut to prevent default browser special char insert when option + alphabetical key is used
            return true;
        }, keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveUp).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).UP, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveDown).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).DOWN, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveLeft).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).LEFT, formatMessage), keymapList);
        (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $ldqjS.dragToMoveRight).common, (0, $b3nYA.moveNodeViaShortcut)(api, (0, $1xYQH.DIRECTION).RIGHT, formatMessage), keymapList);
    }
    return keymapList;
}
const $b8798c8225018002$export$2734319938f9e9db = (api, formatMessage)=>(0, $44cyU.keydownHandler)($b8798c8225018002$var$keymapList(api, formatMessage));
module.exports["boundKeydownHandler"] = $b8798c8225018002$export$2734319938f9e9db;

});

parcelRegister("d1Uph", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $cozmU = parcelRequire("cozmU");


var $fqVYq = parcelRequire("fqVYq");

class $0a2dbdea21e1cb22$export$d16dfd16e2bbb367 {
    getActiveAnchor() {
        return this.lastActiveAnchor;
    }
    subscribe(anchorName, callback) {
        if (this.emitter) this.emitter.on(anchorName, callback);
    }
    unsubscribe(anchorName, callback) {
        if (this.emitter) this.emitter.removeListener(anchorName, callback);
    }
    emit(anchorName) {
        if (this.lastActiveAnchor !== anchorName && this.emitter) {
            this.emitter.emit(this.lastActiveAnchor, false);
            this.emitter.emit(anchorName, true);
            this.lastActiveAnchor = anchorName;
        }
    }
    reset() {
        if (this.emitter) {
            // To prevent any potential memory leaks,
            // we set the event emitter to null and then create a new event emitter.
            this.emitter.removeAllListeners();
            this.emitter = null;
            this.emitter = new (0, $eSa5t.EventEmitter)();
        }
    }
    constructor(){
        this.emitter = void 0;
        this.lastActiveAnchor = '';
        this.emitter = new (0, $eSa5t.EventEmitter)();
    }
}
const $0a2dbdea21e1cb22$export$73b394ea452decfd = new $0a2dbdea21e1cb22$export$d16dfd16e2bbb367();
const $0a2dbdea21e1cb22$export$8f015ea2e0aa57d4 = (anchorName, activeAnchorTracker = $0a2dbdea21e1cb22$export$73b394ea452decfd)=>{
    const [isActive, setIsActive] = (0, $cozmU.useState)(false);
    const onActive = (eventIsActive)=>{
        setIsActive(eventIsActive);
    };
    (0, $cozmU.useEffect)(()=>{
        if (activeAnchorTracker && anchorName && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
            activeAnchorTracker.subscribe(anchorName, onActive);
            if (activeAnchorTracker.getActiveAnchor() === anchorName) setIsActive(true);
            const unsubscribe = ()=>{
                activeAnchorTracker.unsubscribe(anchorName, onActive);
            };
            return unsubscribe;
        }
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    const setActive = (0, $cozmU.useCallback)(()=>{
        activeAnchorTracker.emit(anchorName);
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    return [
        isActive,
        setActive
    ];
};
module.exports["defaultActiveAnchorTracker"] = $0a2dbdea21e1cb22$export$73b394ea452decfd;
module.exports["useActiveAnchorTracker"] = $0a2dbdea21e1cb22$export$8f015ea2e0aa57d4;

});

parcelRegister("aHnsS", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ixfCV = parcelRequire("ixfCV");

const $a4ec4184fd7ff62b$export$991fd708287269fd = (tr, inputMethod, fromDepth, fromNodeTypes, toDepth, toNodeType, isSameParent, api, hasSelectedMultipleNodes)=>{
    return api?.analytics?.actions?.attachAnalyticsEvent({
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).MOVED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
        attributes: {
            nodeDepth: fromDepth,
            nodeTypes: fromNodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            destinationNodeDepth: toDepth,
            destinationNodeType: toNodeType,
            isSameParent: isSameParent,
            inputMethod: inputMethod
        }
    })(tr);
};
const $a4ec4184fd7ff62b$export$9d441c3a20655711 = (tr, api, nodeTypes, hasSelectedMultipleNodes, columnCount)=>{
    api?.analytics?.actions?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).LAYOUT,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP,
            nodeTypes: nodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            columnCount: columnCount
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
};
const $a4ec4184fd7ff62b$export$9f4024dd9bfa7336 = (tr, anchor, head)=>{
    const nodeTypes = [];
    const from = Math.min(anchor, head);
    const to = Math.max(anchor, head);
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (pos < from) // ignore parent node
        return true;
        nodeTypes.push(node.type.name);
        // only care about the top level (relatively in the range) nodes
        return false;
    });
    return {
        nodeTypes: (0, $ixfCV.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};
module.exports["attachMoveNodeAnalytics"] = $a4ec4184fd7ff62b$export$991fd708287269fd;
module.exports["fireInsertLayoutAnalytics"] = $a4ec4184fd7ff62b$export$9d441c3a20655711;
module.exports["getMultiSelectAnalyticsAttributes"] = $a4ec4184fd7ff62b$export$9f4024dd9bfa7336;

});

parcelRegister("a4QVD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $fKt2m = parcelRequire("fKt2m");

const $29a324c3089ed6e2$export$2073a24f9367a16f = (0, $dOBRD.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $29a324c3089ed6e2$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll(`[${(0, $fKt2m.getAnchorAttrName)()}]`) || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute((0, $fKt2m.getAnchorAttrName)());
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $29a324c3089ed6e2$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}
module.exports["isAnchorSupported"] = $29a324c3089ed6e2$export$2073a24f9367a16f;
module.exports["AnchorRectCache"] = $29a324c3089ed6e2$export$e1d230f644ff05aa;

});

parcelRegister("bOZni", function(module, exports) {

var $j8XGH = parcelRequire("j8XGH");


var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $WABbQ = parcelRequire("WABbQ");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");

const $d4922fc90af8294c$export$eefc237c5f2aa5b9 = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    // To trigger the annotation floating toolbar for non-selectable node, we need to select inline nodes
    // Find the first inline node in the node
    let inlineNodePos = start;
    let foundInlineNode = false;
    let inlineNodeEndPos = 0;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n, pos)=>{
        if (n.isInline) inlineNodeEndPos = pos + n.nodeSize;
        if (n.isInline && !foundInlineNode) {
            inlineNodePos = pos;
            foundInlineNode = true;
        }
        return true;
    });
    return {
        inlineNodePos: inlineNodePos,
        inlineNodeEndPos: inlineNodeEndPos
    };
};
const $d4922fc90af8294c$export$e7d12bf383139ed5 = (tr, start, nodeSize)=>{
    const $startPos = tr.doc.resolve(start);
    let hasCodeBlock = false;
    tr.doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n)=>{
        if ([
            'codeBlock'
        ].includes(n.type.name)) hasCodeBlock = true;
    });
    return hasCodeBlock;
};
const $d4922fc90af8294c$var$isNodeWithMediaOrExtension = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    let hasMediaOrExtension = false;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n)=>{
        if ([
            'media',
            'extension'
        ].includes(n.type.name)) hasMediaOrExtension = true;
    });
    return hasMediaOrExtension;
};
const $d4922fc90af8294c$var$oldGetSelection = (tr, start)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $kCECX.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    const $startPos = tr.doc.resolve(start);
    const nodeName = node?.type.name;
    const isBlockQuoteWithMediaOrExtension = nodeName === 'blockquote' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize);
    const isListWithMediaOrExtension = nodeName === 'bulletList' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize) || nodeName === 'orderedList' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(tr.doc, start, nodeSize);
    if (isNodeSelection && nodeName !== 'blockquote' || isListWithMediaOrExtension || isBlockQuoteWithMediaOrExtension || // decisionList/layoutColumn node is not selectable, but we want to select the whole node not just text
    [
        'decisionList',
        'layoutColumn'
    ].includes(nodeName || '')) return new (0, $kCECX.NodeSelection)($startPos);
    else if (nodeName === 'mediaGroup' && node?.childCount === 1) {
        const $mediaStartPos = tr.doc.resolve(start + 1);
        return new (0, $kCECX.NodeSelection)($mediaStartPos);
    } else if (// Even though mediaGroup is not selectable,
    // we need a quick way to make all child media nodes appear as selected without the need for a custom selection
    nodeName === 'mediaGroup') return new (0, $kCECX.NodeSelection)($startPos);
    else if (nodeName === 'taskList') return (0, $kCECX.TextSelection).create(tr.doc, start, start + nodeSize);
    else {
        const { inlineNodePos: inlineNodePos, inlineNodeEndPos: inlineNodeEndPos } = $d4922fc90af8294c$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
        return new (0, $kCECX.TextSelection)(tr.doc.resolve(inlineNodePos), tr.doc.resolve(inlineNodeEndPos));
    }
};
const $d4922fc90af8294c$export$2ad544f897362d62 = (doc, selectionEmpty, start)=>{
    // Under the gate, delegate to getNodeSelectionForPos only when
    // platform_editor_block_menu is on — getNodeSelectionForPos matches that
    // simplified path (NodeSelection for all nodes). When block_menu is off,
    // fall through to the oldGetSelection branch which handles expand/taskList/
    // inline nodes correctly with TextSelection.
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $ixfCV.fg)('platform_editor_maui_jira_updates') && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return (0, $j8XGH.getNodeSelectionForPos)(doc, start) || false;
    const node = doc.nodeAt(start);
    const isNodeSelection = node && (0, $kCECX.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    const nodeName = node?.type.name;
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
        // if mediaGroup only has a single child, we want to select the child
        if (nodeName === 'mediaGroup' && node?.childCount === 1) {
            const $mediaStartPos = doc.resolve(start + 1);
            return new (0, $kCECX.NodeSelection)($mediaStartPos);
        }
        return new (0, $kCECX.NodeSelection)(doc.resolve(start));
    }
    // this is a fix for empty paragraph selection - put first to avoid any extra work
    if (nodeName === 'paragraph' && selectionEmpty && node?.childCount === 0) return false;
    const isBlockQuoteWithMediaOrExtension = nodeName === 'blockquote' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(doc, start, nodeSize);
    const isListWithMediaOrExtension = nodeName === 'bulletList' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(doc, start, nodeSize) || nodeName === 'orderedList' && $d4922fc90af8294c$var$isNodeWithMediaOrExtension(doc, start, nodeSize);
    if (isNodeSelection && nodeName !== 'blockquote' || isListWithMediaOrExtension || isBlockQuoteWithMediaOrExtension || // decisionList/layoutColumn node is not selectable, but we want to select the whole node not just text
    [
        'decisionList',
        'layoutColumn'
    ].includes(nodeName || '') || nodeName === 'mediaGroup' && typeof node?.childCount === 'number' && node?.childCount > 1) return new (0, $kCECX.NodeSelection)(doc.resolve(start));
    // if mediaGroup only has a single child, we want to select the child
    if (nodeName === 'mediaGroup') {
        const $mediaStartPos = doc.resolve(start + 1);
        return new (0, $kCECX.NodeSelection)($mediaStartPos);
    }
    if (nodeName === 'taskList') return (0, $kCECX.TextSelection).create(doc, start, start + nodeSize);
    const { inlineNodePos: inlineNodePos, inlineNodeEndPos: inlineNodeEndPos } = $d4922fc90af8294c$export$eefc237c5f2aa5b9(doc, start, nodeSize);
    return new (0, $kCECX.TextSelection)(doc.resolve(inlineNodePos), doc.resolve(inlineNodeEndPos));
};
const $d4922fc90af8294c$export$ca798a7e6e94638c = (tr, start, api)=>{
    if ((0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) || (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return $d4922fc90af8294c$export$2ad544f897362d62(tr.doc, tr.selection.empty, start);
    return $d4922fc90af8294c$var$oldGetSelection(tr, start);
};
const $d4922fc90af8294c$export$cbcb4f775d907a9e = (tr, start, nodeType, api)=>{
    // Only use the platform path when already on the simplified newGetSelection
    // branch — i.e. when platform_editor_block_menu is on or toolbar flags are
    // enabled. This preserves oldGetSelection behaviour (e.g. taskList →
    // TextSelection) in legacy contexts where those flags are off.
    if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $ixfCV.fg)('platform_editor_maui_jira_updates') && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return (0, $j8XGH.selectNodeAtPos)(tr, start, nodeType);
    if (nodeType === 'table') {
        tr = (0, $WABbQ.selectTableClosestToPos)(tr, tr.doc.resolve(start + 1));
        return tr;
    }
    const selection = $d4922fc90af8294c$export$ca798a7e6e94638c(tr, start, api);
    if (selection) tr.setSelection(selection);
    return tr;
};
const $d4922fc90af8294c$export$4b5c09668d5b4e01 = (tr, start, api)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $kCECX.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    let selection;
    // decisionList node is not selectable, but we want to select the whole node not just text
    // blockQuote is selectable, but we want to set cursor at the inline end Pos instead of the gap cursor as this causes jittering post drop
    if (isNodeSelection && node.type.name !== 'blockquote' || node?.type.name === 'decisionList') {
        selection = new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(start + node.nodeSize), (0, $eaLat.Side).RIGHT);
        tr.setSelection(selection);
        return tr;
    }
    // this is a fix for empty paragraph selection - can safely use start position as the paragraph is empty
    if (node?.type.name === 'paragraph' && node?.childCount === 0 && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) {
        const selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(start));
        tr.setSelection(selection);
        return tr;
    }
    const { inlineNodeEndPos: inlineNodeEndPos } = $d4922fc90af8294c$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
    selection = new (0, $kCECX.TextSelection)(tr.doc.resolve(inlineNodeEndPos));
    tr.setSelection(selection);
    return tr;
};
const $d4922fc90af8294c$export$e89bc339b843c7b = (state, selection, handlePos)=>{
    if (selection.empty) return false;
    let nodeStart;
    const $selectionFrom = selection.$from;
    nodeStart = $selectionFrom.before($selectionFrom.sharedDepth(selection.to) + 1);
    if (nodeStart === $selectionFrom.pos) nodeStart = $selectionFrom.depth ? $selectionFrom.before() : $selectionFrom.pos;
    const $resolvedNodePos = state.doc.resolve(nodeStart);
    if ([
        'tableRow',
        'tableCell',
        'tableHeader'
    ].includes($resolvedNodePos.node().type.name)) {
        const parentNodeFindRes = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes['table'])(selection);
        const tablePos = parentNodeFindRes?.pos;
        nodeStart = typeof tablePos === 'undefined' ? nodeStart : tablePos;
    } else if ([
        'listItem'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before($d4922fc90af8294c$export$3ee0594e8fdf55d5($resolvedNodePos));
    else if ([
        'taskList'
    ].includes($resolvedNodePos.node().type.name)) {
        const listdepth = $d4922fc90af8294c$export$7116b8011b79af5e($resolvedNodePos);
        nodeStart = $resolvedNodePos.before(listdepth);
    } else if ([
        'blockquote'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before();
    return Boolean(handlePos < selection.$to.pos && handlePos >= nodeStart);
};
const $d4922fc90af8294c$export$3ee0594e8fdf55d5 = (itemPos)=>{
    let depth;
    for(let i = itemPos.depth; i > 1; i -= 2){
        const node = itemPos.node(i);
        if (node.type.name === 'listItem') depth = i - 1;
        else break;
    }
    return depth;
};
const $d4922fc90af8294c$export$7116b8011b79af5e = (taskListPos)=>{
    let depth;
    for(let i = taskListPos.depth; i > 0; i--){
        const node = taskListPos.node(i);
        if (node.type.name === 'taskList' || node.type.name === 'taskItem') depth = i;
        else break;
    }
    return depth;
};
module.exports["newGetSelection"] = $d4922fc90af8294c$export$2ad544f897362d62;
module.exports["selectNode"] = $d4922fc90af8294c$export$cbcb4f775d907a9e;
module.exports["setCursorPositionAtMovedNode"] = $d4922fc90af8294c$export$4b5c09668d5b4e01;
module.exports["isHandleCorrelatedToSelection"] = $d4922fc90af8294c$export$e89bc339b843c7b;

});

parcelRegister("i2jOy", function(module, exports) {

var $lwsLh = parcelRequire("lwsLh");


var $lVAkE = parcelRequire("lVAkE");

var $1GYCH = parcelRequire("1GYCH");


var $kCECX = parcelRequire("kCECX");


var $WABbQ = parcelRequire("WABbQ");


var $3BXSc = parcelRequire("3BXSc");


var $bOZni = parcelRequire("bOZni");

const $ab609c7acfa1dbd4$export$4e8a3dde481e0452 = (api, pos, tr)=>{
    const pluginState = api?.blockControls?.sharedState.currentState();
    // With move nodes shortcut, we expand selection and move node within one transaction,
    // Hence we also look for `multiSelectDnD` in transaction meta
    const multiSelectDnD = pluginState?.multiSelectDnD ?? tr?.getMeta((0, $3BXSc.key))?.multiSelectDnD;
    if (multiSelectDnD && multiSelectDnD.anchor >= 0 && multiSelectDnD.head >= 0) {
        const multiFrom = Math.min(multiSelectDnD.anchor, multiSelectDnD.head);
        const multiTo = Math.max(multiSelectDnD.anchor, multiSelectDnD.head);
        // We subtract one as the handle position is before the node
        return pos >= multiFrom - 1 && pos < multiTo ? {
            anchor: multiSelectDnD.anchor,
            head: multiSelectDnD.head
        } : {};
    }
    return {};
};
const $ab609c7acfa1dbd4$export$5e3fa240bc795f26 = (handlePos, tr, api)=>{
    const { anchor: anchor, head: head } = $ab609c7acfa1dbd4$export$4e8a3dde481e0452(api, handlePos, tr);
    const inSelection = anchor !== undefined && head !== undefined;
    const from = inSelection ? Math.min(anchor || 0, head || 0) : handlePos;
    const activeNode = tr.doc.nodeAt(handlePos);
    const activeNodeEndPos = handlePos + (activeNode?.nodeSize ?? 1);
    const to = inSelection ? Math.max(anchor || 0, head || 0) : activeNodeEndPos;
    return {
        from: from,
        to: to
    };
};
const $ab609c7acfa1dbd4$export$20b0d24b8a2c2db1 = (selection, nodePos)=>{
    const doc = selection.$anchor.doc;
    if (nodePos < 0 || nodePos > doc.nodeSize - 2 || selection.empty) return selection;
    const $pos = doc.resolve(nodePos);
    const node = $pos.nodeAfter;
    if ($pos.node().isTextblock || !node) return selection;
    const $newHead = nodePos < selection.anchor ? $pos : doc.resolve(node.nodeSize + nodePos);
    const textSelection = new (0, $kCECX.TextSelection)(selection.$anchor, $newHead);
    return textSelection;
};
const $ab609c7acfa1dbd4$export$d7b7394e7527c1b6 = (selection, pos)=>{
    return selection instanceof (0, $kCECX.NodeSelection) && Math.max(pos, selection.anchor) === selection.anchor ? new (0, $kCECX.TextSelection)(selection.$head, selection.$anchor) : selection;
};
const $ab609c7acfa1dbd4$export$e21678cf246ba963 = (selection, tr)=>{
    const { preservedSelectionMapping: preservedSelectionMapping } = (0, $3BXSc.getBlockControlsMeta)(tr) || {};
    const mapping = preservedSelectionMapping || tr.mapping;
    const from = mapping.map(selection.from);
    // When lastNodeMustBeParagraph inserts a trailing paragraph exactly at the end boundary
    // of a preserved block selection, keep the mapped end position on the left side of the
    // inserted paragraph so it is not included in the preserved selection.
    const shouldTrimTrailingParagraph = tr.getMeta((0, $lwsLh.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META)) === true;
    const to = shouldTrimTrailingParagraph ? mapping.map(selection.to, -1) : mapping.map(selection.to);
    const isSelectionEmpty = from === to;
    const wasSelectionEmpty = selection.from === selection.to;
    if (isSelectionEmpty && !wasSelectionEmpty) // If selection has become empty i.e. content has been deleted, stop preserving
    return undefined;
    return $ab609c7acfa1dbd4$export$fa43757966d274e3(tr.doc.resolve(from), tr.doc.resolve(to));
};
const $ab609c7acfa1dbd4$var$isInsideEmptyTextblock = ($pos)=>$pos.parent.isTextblock && $pos.parent.content.size === 0;
const $ab609c7acfa1dbd4$var$isAtEndOfParent = ($pos)=>$pos.parentOffset === $pos.parent.content.size;
const $ab609c7acfa1dbd4$var$isAtStartOfParent = ($pos)=>$pos.parentOffset === 0;
const $ab609c7acfa1dbd4$export$59e281d427887933 = ($from, $to)=>{
    const { doc: doc } = $from;
    // Walk $from forward while at end of ancestors
    let adjustedFrom = $from;
    if (!$ab609c7acfa1dbd4$var$isInsideEmptyTextblock($from)) while(adjustedFrom.depth > 0 && $ab609c7acfa1dbd4$var$isAtEndOfParent(adjustedFrom)){
        const nextPos = adjustedFrom.after();
        if (nextPos > doc.content.size || nextPos === adjustedFrom.pos) break;
        adjustedFrom = doc.resolve(nextPos);
    }
    // Walk $to backward while at start of ancestors
    let adjustedTo = $to;
    if (!$ab609c7acfa1dbd4$var$isInsideEmptyTextblock($to)) while(adjustedTo.depth > 0 && $ab609c7acfa1dbd4$var$isAtStartOfParent(adjustedTo)){
        const prevPos = adjustedTo.before();
        if (prevPos < 0 || prevPos === adjustedTo.pos) break;
        adjustedTo = doc.resolve(prevPos);
    }
    return {
        $from: adjustedFrom,
        $to: adjustedTo
    };
};
const $ab609c7acfa1dbd4$export$fa43757966d274e3 = ($from, $to)=>{
    const { doc: doc } = $from;
    const isCollapsed = $from.pos === $to.pos;
    const adjusted = isCollapsed ? {
        $from: $from,
        $to: $to
    } : $ab609c7acfa1dbd4$export$59e281d427887933($from, $to);
    if (!isCollapsed && adjusted.$from.pos >= adjusted.$to.pos) return undefined;
    // expand the selection range to block boundaries, so selection always includes whole nodes
    const expanded = (0, $lVAkE.expandToBlockRange)(adjusted.$from, adjusted.$to);
    // stop preserving if selection becomes invalid
    if (expanded.$from.pos < 0 || expanded.$to.pos > doc.content.size || expanded.$from.pos >= expanded.$to.pos) return undefined;
    // If multiple blocks selected, create TextSelection from start of first node to end of last node
    if (expanded.range && (0, $1GYCH.isMultiBlockRange)(expanded.range)) return new (0, $kCECX.TextSelection)(expanded.$from, expanded.$to);
    const nodeType = doc.nodeAt(expanded.$from.pos)?.type?.name;
    if (!nodeType) return undefined;
    if (nodeType === 'table') return (0, $WABbQ.getTableSelectionClosesToPos)($from);
    return (0, $bOZni.newGetSelection)(doc, false, expanded.$from.pos) || undefined;
};
module.exports["getMultiSelectionIfPosInside"] = $ab609c7acfa1dbd4$export$4e8a3dde481e0452;
module.exports["getSelectedSlicePosition"] = $ab609c7acfa1dbd4$export$5e3fa240bc795f26;
module.exports["expandSelectionHeadToNodeAtPos"] = $ab609c7acfa1dbd4$export$20b0d24b8a2c2db1;
module.exports["alignAnchorHeadInDirectionOfPos"] = $ab609c7acfa1dbd4$export$d7b7394e7527c1b6;
module.exports["mapPreservedSelection"] = $ab609c7acfa1dbd4$export$e21678cf246ba963;
module.exports["createPreservedSelection"] = $ab609c7acfa1dbd4$export$fa43757966d274e3;
module.exports["adjustSelectionBoundsForEdgePositions"] = $ab609c7acfa1dbd4$export$59e281d427887933;

});

parcelRegister("bOCgz", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");

const $dafa623a4437f2ee$export$3e44da64b47beb51 = (s)=>{
    const content = s.slice.content.firstChild;
    return s.from === s.to && s.slice.content.childCount === 1 && !!content && !!content.text;
};
const $dafa623a4437f2ee$export$84cb963246195c8 = (s)=>{
    const content = s.slice.content;
    return s.to === s.from + 1 && content.size === 0;
};
/**
 * Check if content being replaced is replaced with another of the same size
 * This can occur on empty docs and 'backspace' is pressed, the paragraph node is re-drawn
 * @param s
 * @returns True if content being replaced is replaced with another of the same size
 */ const $dafa623a4437f2ee$var$isStepContentReplacedWithAnotherOfSameSize = (s)=>{
    if (s instanceof (0, $eOaGc.ReplaceAroundStep)) {
        const replacedContentSize = s.to - s.from;
        return s.slice.content.size === replacedContentSize;
    }
    return false;
};
const $dafa623a4437f2ee$export$5a67a4a1d2fbf068 = (tr, flags)=>{
    let from;
    let to;
    let numReplaceSteps = 0;
    let isAllText = true;
    let isReplacedWithSameSize = false;
    tr.steps.forEach((s)=>{
        if (s instanceof (0, $eOaGc.ReplaceStep) || s instanceof (0, $eOaGc.ReplaceAroundStep)) {
            if (s instanceof (0, $eOaGc.ReplaceAroundStep) || s instanceof (0, $eOaGc.ReplaceStep) && !$dafa623a4437f2ee$export$3e44da64b47beb51(s) && !$dafa623a4437f2ee$export$84cb963246195c8(s)) isAllText = false;
            // Fixes drag handle and quick insert button overlap issues
            if (flags.toolbarFlagsEnabled) // platform_editor_controls note: fixes drag handle and quick insert button overlap issues
            isReplacedWithSameSize = $dafa623a4437f2ee$var$isStepContentReplacedWithAnotherOfSameSize(s);
            const mappedTo = tr.mapping.map(s.to);
            let $to = s.from + s.slice.size;
            $to = $to > mappedTo ? $to : mappedTo;
            from = from === undefined || from > s.from ? s.from : from;
            to = to === undefined || to < $to ? $to : to;
            numReplaceSteps++;
        }
    });
    if (from === undefined) from = 0;
    if (to === undefined || to > tr.doc.nodeSize - 2) to = tr.doc.nodeSize - 2;
    return {
        from: from,
        to: to,
        numReplaceSteps: numReplaceSteps,
        isAllText: isAllText,
        isReplacedWithSameSize: isReplacedWithSameSize
    };
};
module.exports["getTrMetadata"] = $dafa623a4437f2ee$export$5a67a4a1d2fbf068;

});

parcelRegister("3o30f", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $bI2nS = parcelRequire("bI2nS");


var $4hfky = parcelRequire("4hfky");


var $k3XQC = parcelRequire("k3XQC");


var $kCECX = parcelRequire("kCECX");


var $gbf0M = parcelRequire("gbf0M");


var $cMyWi = parcelRequire("cMyWi");


var $4ez2K = parcelRequire("4ez2K");


var $6JWmx = parcelRequire("6JWmx");


var $kcs7l = parcelRequire("kcs7l");


var $54N0Y = parcelRequire("54N0Y");


var $cRImW = parcelRequire("cRImW");

function $fee70d3190aaad52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fee70d3190aaad52$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $cRImW.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $cozmU.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $kcs7l.pluginKey).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $6JWmx.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $k3XQC.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
        css: $fee70d3190aaad52$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $54N0Y.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $fee70d3190aaad52$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $cMyWi.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)($fee70d3190aaad52$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["DatasourceAppearanceButton"] = $fee70d3190aaad52$export$76de8066d79563a4;

});

parcelRegister("KRqQR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");

var $eaCAt = parcelRequire("eaCAt");


var $gjTdl = parcelRequire("gjTdl");


var $3FyXx = parcelRequire("3FyXx");


var $iEFx5 = parcelRequire("iEFx5");


var $2VYYv = parcelRequire("2VYYv");


var $kCECX = parcelRequire("kCECX");


var $cbp6v = parcelRequire("cbp6v");


var $6JWmx = parcelRequire("6JWmx");


var $4eqn3 = parcelRequire("4eqn3");

function $49f259ed34811056$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3FyXx.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $49f259ed34811056$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $cbp6v.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49f259ed34811056$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $cbp6v.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $iEFx5.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $49f259ed34811056$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $kCECX.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $cbp6v.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $49f259ed34811056$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $4eqn3.displayInfoForCard)(node, (0, $4eqn3.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49f259ed34811056$export$3d21e16152ee408f, {
                key: idx,
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $gjTdl.commandWithMetadata)((0, $6JWmx.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $krYZG.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $6JWmx.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            });
        }
    };
};
const $49f259ed34811056$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker, linkPickerOptions)=>{
    if (!showLinkingToolbar) return {};
    return {
        height: linkPickerOptions?.popupHeight ?? (lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX)),
        width: linkPickerOptions?.popupWidth ?? (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        // forcePlacement is always true to prevent the popup from rendering off-screen
        forcePlacement: true
    };
};
module.exports["getEditLinkCallback"] = $49f259ed34811056$export$c389e1daeae312a9;
module.exports["buildEditLinkToolbar"] = $49f259ed34811056$export$dec3901e38d4e7ff;
module.exports["editLinkToolbarConfig"] = $49f259ed34811056$export$acaefd190fd8ff4d;

});

parcelRegister("b161W", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $bI2nS = parcelRequire("bI2nS");

var $iEFx5 = parcelRequire("iEFx5");


var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");


var $cMyWi = parcelRequire("cMyWi");


var $9d7Pd = parcelRequire("9d7Pd");


var $4ez2K = parcelRequire("4ez2K");


var $fqVYq = parcelRequire("fqVYq");


var $4eqn3 = parcelRequire("4eqn3");


var $drvNu = parcelRequire("drvNu");


var $khHv2 = parcelRequire("khHv2");


var $cRImW = parcelRequire("cRImW");


var $dY8XA = parcelRequire("dY8XA");

const $f6409fd8f1fd2ba8$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $cRImW.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $4eqn3.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $cozmU.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $4eqn3.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $drvNu.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $4eqn3.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $f6409fd8f1fd2ba8$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $cRImW.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $4eqn3.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dY8XA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $cozmU.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $khHv2.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $cozmU.useMemo)(()=>{
        if (!datasourceId || !(0, $4eqn3.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dY8XA.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $f6409fd8f1fd2ba8$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $cMyWi.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)($f6409fd8f1fd2ba8$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["EditToolbarButton"] = $f6409fd8f1fd2ba8$export$4f24788e7d04736b;

});

parcelRegister("7IbuD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $g6uqx = parcelRequire("g6uqx");


var $huoxr = parcelRequire("huoxr");


var $4ez2K = parcelRequire("4ez2K");


var $3o30f = parcelRequire("3o30f");


var $iPc0t = parcelRequire("iPc0t");

function $61781900f6775ac5$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPc0t.LinkToolbarAppearance), {
        key: "link-appearance",
        url: url,
        intl: intl,
        editorView: editorView,
        editorState: editorState,
        allowEmbeds: cardOptions?.allowEmbeds,
        allowBlockCards: cardOptions?.allowBlockCards,
        editorAnalyticsApi: editorAnalyticsApi,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), cardOptions?.allowDatasource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o30f.DatasourceAppearanceButton), {
        intl: intl,
        url: url,
        editorState: editorState,
        editorView: editorView,
        editorAnalyticsApi: editorAnalyticsApi,
        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
}
module.exports["HyperlinkToolbarAppearance"] = $61781900f6775ac5$export$33d351e602b13f5c;

});

parcelRegister("bSOGe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gxKDp = parcelRequire("gxKDp");


var $g6uqx = parcelRequire("g6uqx");


var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");


var $4ez2K = parcelRequire("4ez2K");


var $38tfT = parcelRequire("38tfT");

const $f03f24584f0ca413$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $cozmU.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const cardProvider = (0, $cozmU.useRef)(undefined);
    const containerRef = (0, $cozmU.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            // eslint-disable-line no-unused-vars
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $cozmU.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $gxKDp.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        ref: containerRef,
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GNtS.DropdownContainer), {
        mountTo: containerRef.current,
        isOpen: isOpen,
        handleClickOutside: close,
        handleEscapeKeydown: close,
        trigger: trigger,
        scrollableElement: containerRef.current,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU
        },
        fitHeight: 400,
        fitWidth: 200
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38tfT.LinkAppearanceMenu), {
        url: url,
        intl: intl,
        currentAppearance: undefined,
        editorState: editorView.state,
        allowEmbeds: cardOptions?.allowEmbeds,
        allowBlockCards: cardOptions?.allowBlockCards,
        editorAnalyticsApi: editorAnalyticsApi,
        isDatasourceView: isDatasourceView,
        allowDatasource: allowDatasource,
        dispatchCommand: dispatchCommand,
        settingsConfig: settingsConfig,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    })), !(0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(props.editorPluginApi?.toolbar))
    }));
};
const $f03f24584f0ca413$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f03f24584f0ca413$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};
module.exports["getCustomHyperlinkAppearanceDropdown"] = $f03f24584f0ca413$export$5b48c4cfa5ad82e1;

});

parcelRegister("iPc0t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $krYZG = parcelRequire("krYZG");


var $gjTdl = parcelRequire("gjTdl");

var $eNCVl = parcelRequire("eNCVl");

var $8a6fP = parcelRequire("8a6fP");


var $bI2nS = parcelRequire("bI2nS");

var $2xhuI = parcelRequire("2xhuI");


var $iso5o = parcelRequire("iso5o");


var $aPdNQ = parcelRequire("aPdNQ");


var $6JWmx = parcelRequire("6JWmx");


var $4eqn3 = parcelRequire("4eqn3");


var $eHuhD = parcelRequire("eHuhD");


var $7vzxX = parcelRequire("7vzxX");


var $brpLB = parcelRequire("brpLB");


var $9PpVE = parcelRequire("9PpVE");

class $311c13dda34631e5$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PpVE.WithCardContext), null, (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value));
    }
    constructor(...args){
        super(...args);
        this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $bI2nS.messages).embed),
                onClick: (0, $6JWmx.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $bI2nS.messages).block),
                onClick: (0, $6JWmx.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $311c13dda34631e5$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $bI2nS.messages).url),
                    onClick: (0, $gjTdl.commandWithMetadata)((0, $6JWmx.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $krYZG.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $bI2nS.messages).inline),
                    onClick: (0, $6JWmx.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a6fP.LinkToolbarButtonGroup), {
                key: "link-toolbar-button-group",
                options: options.map((option)=>(0, $eNCVl.getButtonGroupOption)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            });
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $brpLB.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $4eqn3.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vzxX.DiscoveryPulse), {
                    localStorageKey: (0, $eHuhD.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                    testId: "toolbar-discovery-pulse"
                }, LinkToolbarButtons)));
            }
            return LinkToolbarButtons;
        };
    }
}
const $311c13dda34631e5$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $2xhuI.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        return intl.formatMessage((0, $bI2nS.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $2xhuI.default).defaultBlockNode)
        });
    }
};
module.exports["LinkToolbarAppearance"] = $311c13dda34631e5$export$2a8c6fb42753b13e;
module.exports["getUnavailableMessage"] = $311c13dda34631e5$export$74e77d31eb18de27;

});

parcelRegister("38tfT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gxKDp = parcelRequire("gxKDp");

var $gjTdl = parcelRequire("gjTdl");

var $hXw4C = parcelRequire("hXw4C");


var $bI2nS = parcelRequire("bI2nS");

var $iEFx5 = parcelRequire("iEFx5");


var $iso5o = parcelRequire("iso5o");


var $aPdNQ = parcelRequire("aPdNQ");


var $cMyWi = parcelRequire("cMyWi");


var $9d7Pd = parcelRequire("9d7Pd");

var $8oBbn = parcelRequire("8oBbn");

var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


var $fqVYq = parcelRequire("fqVYq");


var $6JWmx = parcelRequire("6JWmx");


var $rwCCm = parcelRequire("rwCCm");


var $iPc0t = parcelRequire("iPc0t");

const $8f28eb0ccb03280c$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $cMyWi.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $iso5o.isSupportedInParent)(editorState, (0, $aPdNQ.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $bI2nS.messages).embed),
        onClick: (0, $6JWmx.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $iPc0t.getUnavailableMessage)(editorState, intl),
        description: (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $bI2nS.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $bI2nS.messages).block),
        onClick: (0, $6JWmx.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $iPc0t.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $bI2nS.messages).url),
            onClick: (0, $gjTdl.commandWithMetadata)((0, $6JWmx.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $krYZG.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $bI2nS.messages).inline),
            onClick: (0, $6JWmx.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $hXw4C.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $gjTdl.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, finalOptions.map((option)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: option.title,
            iconBefore: option.icon,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>option.onClick(),
            isSelected: option.selected,
            description: option.description,
            shouldDescriptionWrap: true
        }, option.title);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $rwCCm.DatasourceDropdownOption), {
        allowDatasource: allowDatasource,
        intl: intl,
        url: url ?? '',
        selected: Boolean(isDatasourceView),
        inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
        dispatchCommand: dispatchCommand
    })), 'href' in settingsConfig && settingsConfig.href && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        iconBefore: Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "Settings"
        }),
        href: settingsConfig.href,
        target: 'target' in settingsConfig ? settingsConfig.target : undefined
    }, intl.formatMessage((0, $iEFx5.linkToolbarMessages).preferencesLink))));
};
const $8f28eb0ccb03280c$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f28eb0ccb03280c$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $rwCCm.datasourceDisplayInformation) : (0, $gxKDp.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};
module.exports["LinkAppearanceMenu"] = $8f28eb0ccb03280c$export$6ce0ca681c51cdfb;
module.exports["getLinkAppearanceDropdown"] = $8f28eb0ccb03280c$export$1faf5b64d0bbe935;

});

parcelRegister("lwOI6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4hfky = parcelRequire("4hfky");


var $V3JOP = parcelRequire("V3JOP");


var $f21H2 = parcelRequire("f21H2");

const $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b = ({ url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorView: editorView, onClick: onClick, title: title })=>{
    const destinationUrl = (0, $f21H2.useDestinationUrl)(url);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick(editorView.state, editorView.dispatch);
    }, [
        editorView,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "hyperlink-open-link",
        title: title,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: ""
        }),
        href: destinationUrl,
        target: "_blank",
        onClick: handleClick,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
module.exports["OpenLinkToolbarButton"] = $c1d9f7da3ec39a4c$export$ba65a32bf3972d3b;

});

parcelRegister("1zg27", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $91WyP = parcelRequire("91WyP");


var $4hfky = parcelRequire("4hfky");


var $gDx2k = parcelRequire("gDx2k");


var $jawC3 = parcelRequire("jawC3");


var $cMyWi = parcelRequire("cMyWi");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $2Q7sv = parcelRequire("2Q7sv");


var $ieeJu = parcelRequire("ieeJu");


var $4eqn3 = parcelRequire("4eqn3");


var $kwknI = parcelRequire("kwknI");

const $d66c3a4348634727$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $cMyWi.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $kwknI.appearanceForLink)(node);
    const cardState = store?.getState()[url];
    if (cardState) {
        const ari = (0, $2Q7sv.getObjectAri)(cardState.details);
        const name = (0, $2Q7sv.getObjectName)(cardState.details);
        const iconUrl = (0, $2Q7sv.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && isPreviewPanelAvailable?.({
            ari: ari
        });
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) openPreviewPanel({
                url: url,
                ari: ari,
                name: name || '',
                iconUrl: iconUrl,
                panelData: {
                    embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $jawC3.extractSmartLinkEmbed)(cardState?.details)?.src : undefined
                }
            });
            editorAnalyticsApi?.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $4eqn3.getResolvedAttributesFromStore)(url, display, store)
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $91WyP.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            as: "span",
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "span",
            "aria-hidden": true,
            role: "presentation"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
            label: "",
            spacing: "spacious"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "span",
            "aria-hidden": true,
            role: "presentation"
        }));
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
            testId: "open-preview-panel-floating-toolbar-button",
            onClick: handleOpenGlancePanelClick,
            icon: icon,
            title: title,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }
    return null;
};
module.exports["OpenPreviewPanelToolbarButton"] = $d66c3a4348634727$export$9ed3225219cdbbe9;

});

parcelRegister("dkZll", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $cbp6v = parcelRequire("cbp6v");


var $8AEvG = parcelRequire("8AEvG");


var $4eqn3 = parcelRequire("4eqn3");


var $byDyt = parcelRequire("byDyt");

const $32749362d6e128b7$var$areResolvedAttributesEqual = (current, next)=>current?.displayCategory === next?.displayCategory && current?.extensionKey === next?.extensionKey && current?.status === next?.status && current?.statusDetails === next?.statusDetails;
/**
 * Handles firing the toolbar viewed event
 */ const $32749362d6e128b7$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext, editorView: editorView })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $cozmU.useEffect)(()=>{
        const resolvedAttributes = (0, $4eqn3.getResolvedAttributesFromStore)(url, display, store);
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...resolvedAttributes,
                display: display
            }
        }).fire('media');
        if (!editorView) return;
        const currentResolvedAttributes = (0, $8AEvG.getPluginState)(editorView.state)?.resolvedToolbarAttributesByUrl[url];
        if ($32749362d6e128b7$var$areResolvedAttributesEqual(currentResolvedAttributes, resolvedAttributes)) return;
        editorView.dispatch((0, $cbp6v.setResolvedToolbarAttributes)(url, resolvedAttributes)(editorView.state.tr));
    }, [
        createAnalyticsEvent,
        display,
        editorView,
        url,
        store
    ]);
    return null;
};
const $32749362d6e128b7$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $cMyWi.useSmartLinkContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $byDyt.EditorAnalyticsContext), {
        editorView: editorView
    }, url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32749362d6e128b7$var$ToolbarViewedEventBase, {
        url: url,
        display: display,
        cardContext: cardContext,
        editorView: editorView
    }) : null);
};
module.exports["ToolbarViewedEvent"] = $32749362d6e128b7$export$998ac2a59a1547dd;

});

parcelRegister("1pvv7", function(module, exports) {

var $9p0BY = parcelRequire("9p0BY");


var $h6b2D = parcelRequire("h6b2D");

function $0462314fb21236fe$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $9p0BY.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $9p0BY.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $9p0BY.normalizeUrl)((0, $h6b2D.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}
module.exports["shouldReplaceLink"] = $0462314fb21236fe$export$f85e921f66e987fa;

});

parcelRegister("iEnX6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $3ed3bd154193b72f$var$pulseKeyframes = null;
const $3ed3bd154193b72f$var$pulseStyles = null;
const $3ed3bd154193b72f$var$commonStyles = null;
const $3ed3bd154193b72f$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $cozmU.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $hekY6.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rkofajl _16qs1l47 _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onAnimationIteration: stopPropagation,
        onAnimationStart: stopPropagation
    }, children));
};
var $3ed3bd154193b72f$export$2e2bcd8739ae039 = $3ed3bd154193b72f$export$927d63e2511364c0;
module.exports["Pulse"] = $3ed3bd154193b72f$export$927d63e2511364c0;

});

parcelRegister("9k4mh", function(module, exports) {

var $9Rq82 = parcelRequire("9Rq82");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kHija = parcelRequire("kHija");


var $1A89X = parcelRequire("1A89X");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $nnUSM = parcelRequire("nnUSM");


var $4G6PK = parcelRequire("4G6PK");

var $p7uR0 = parcelRequire("p7uR0");


var $kpCD8 = parcelRequire("kpCD8");


var $dldpg = parcelRequire("dldpg");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");


var $8nvEM = parcelRequire("8nvEM");


var $8HW7o = parcelRequire("8HW7o");


var $PGUCj = parcelRequire("PGUCj");


var $c2smn = parcelRequire("c2smn");


var $ixfCV = parcelRequire("ixfCV");


var $1wNII = parcelRequire("1wNII");


var $7TpAR = parcelRequire("7TpAR");


var $geUVX = parcelRequire("geUVX");


var $H8AVk = parcelRequire("H8AVk");


var $7O00G = parcelRequire("7O00G");


var $d55P7 = parcelRequire("d55P7");


var $1c9Nx = parcelRequire("1c9Nx");


var $fw4RS = parcelRequire("fw4RS");


var $3pg0a = parcelRequire("3pg0a");


var $IRDCg = parcelRequire("IRDCg");


var $2mgqy = parcelRequire("2mgqy");

const $c08dfbb8b3812a7c$export$fcef64fdeaf6f18a = 'media-content-wrap';
const $c08dfbb8b3812a7c$export$2955196e6685aaf4 = 'mediaSinglePlugin.isResizing';
const $c08dfbb8b3812a7c$export$ea728aeacba173d1 = 'mediaSinglePlugin.resizing-width';
const $c08dfbb8b3812a7c$var$createDropPlaceholder = (intl, nodeViewPortalProviderAPI, dropPlaceholderKey, allowDropLine)=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const dropPlaceholder = document.createElement('div');
    const createElement = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement;
    if (allowDropLine) nodeViewPortalProviderAPI.render(()=>createElement((0, $kSwu1.RawIntlProvider), {
            value: intl
        }, createElement((0, $1c9Nx.default), {
            type: 'single'
        })), dropPlaceholder, dropPlaceholderKey);
    else nodeViewPortalProviderAPI.render(()=>createElement((0, $kSwu1.RawIntlProvider), {
            value: intl
        }, createElement((0, $1c9Nx.default))), dropPlaceholder, dropPlaceholderKey);
    return dropPlaceholder;
};
const $c08dfbb8b3812a7c$var$MEDIA_RESOLVED_STATES = [
    'ready',
    'error',
    'cancelled'
];
class $c08dfbb8b3812a7c$export$a013ab53254c388d {
    clone() {
        const clonedAt = (performance || Date).now();
        // Prevent double wrapping
        // If clone is repeatedly called, we want to proxy the underlying MediaPluginStateImplementation target, rather than the proxy itself
        // If we proxy the proxy, then calling get in future will need to recursively unwrap proxies to find the original target, which causes performance issues
        // Instead, we check if there is an original target stored on "this", and if so, we use that as the proxy target instead
        return new Proxy(this.originalTarget ?? this, {
            get (target, prop, receiver) {
                if (prop === 'singletonCreatedAt') return clonedAt;
                if (prop === 'originalTarget') return target;
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    subscribeToUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions.push(fn);
    }
    unsubscribeFromUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions = this.uploadInProgressSubscriptions.filter((subscribedFn)=>subscribedFn !== fn);
    }
    async setMediaProvider(mediaProvider) {
        // Prevent someone trying to set the exact same provider twice for performance reasons
        if (this.previousMediaProvider === mediaProvider) return;
        this.previousMediaProvider = mediaProvider;
        if (!mediaProvider) {
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $2mgqy.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO disable (not destroy!) pickers until mediaProvider is resolved
        try {
            if (mediaProvider instanceof Promise) this.mediaProvider = await mediaProvider;
            else this.mediaProvider = mediaProvider;
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO [MS-2038]: remove once context api is removed
            // We want to re assign the view and upload configs if they are missing for backwards compatibility
            // as currently integrators can pass context || mediaClientConfig
            if (!this.mediaProvider.viewMediaClientConfig) {
                const viewMediaClientConfig = this.mediaProvider.viewMediaClientConfig;
                if (viewMediaClientConfig) this.mediaProvider.viewMediaClientConfig = viewMediaClientConfig;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($9Rq82)))(this.mediaProvider.viewMediaClientConfig, `MediaProvider promise did not resolve to a valid instance of MediaProvider - ${this.mediaProvider}`);
        } catch (err) {
            const wrappedError = new Error(`Media functionality disabled due to rejected provider: ${err instanceof Error ? err.message : String(err)}`);
            this.errorReporter.captureException(wrappedError);
            this.destroyPickers();
            this.allowsUploads = false;
            if (!this.destroyed) this.view.dispatch(this.view.state.tr.setMeta((0, $2mgqy.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        this.mediaClientConfig = this.mediaProvider.viewMediaClientConfig;
        this.allowsUploads = !!this.mediaProvider.uploadMediaClientConfig;
        const { view: view, allowsUploads: allowsUploads } = this;
        // make sure editable DOM node is mounted
        if (!this.destroyed && view && view.dom.parentNode) // make PM plugin aware of the state change to update UI during 'apply' hook
        view.dispatch(view.state.tr.setMeta((0, $2mgqy.stateKey), {
            allowsUploads: allowsUploads
        }));
        if (this.allowsUploads) {
            this.uploadMediaClientConfig = this.mediaProvider.uploadMediaClientConfig;
            if (this.mediaProvider.uploadParams && this.uploadMediaClientConfig) await this.initPickers(this.mediaProvider.uploadParams, (0, $IRDCg.default));
            else this.destroyPickers();
        } else this.destroyPickers();
    }
    setIsResizing(isResizing) {
        this.isResizing = isResizing;
    }
    setResizingWidth(width) {
        this.resizingWidth = width;
    }
    updateElement() {
        let newElement;
        const selectedContainer = this.selectedMediaContainerNode();
        if (selectedContainer && this.isMediaSchemaNode(selectedContainer)) {
            newElement = this.getDomElement(this.view.domAtPos.bind(this.view));
            if (selectedContainer.type === this.view.state.schema.nodes.mediaSingle) this.currentMaxWidth = (0, $p7uR0.getMaxWidthForNestedNodeNext)(this.view, this.view.state.selection.$anchor.pos) || undefined;
            else this.currentMaxWidth = undefined;
        }
        if (this.element !== newElement) this.element = newElement;
    }
    getDomElement(domAtPos) {
        const { selection: selection } = this.view.state;
        if (!(selection instanceof (0, $kCECX.NodeSelection))) return;
        if (!this.isMediaSchemaNode(selection.node)) return;
        const node = (0, $bjg0G.findDomRefAtPos)(selection.from, domAtPos);
        if (node) {
            if (!node.childNodes.length) return node.parentNode;
            return node;
        }
        return;
    }
    get contextIdentifierProvider() {
        return this.pluginInjectionApi?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    selectLastAddedMediaNode() {
        // if preventAutoFocusOnUpload is enabled, skip auto-selection and just clear the tracking array
        if (this.mediaOptions?.preventAutoFocusOnUpload) {
            this.lastAddedMediaSingleFileIds = [];
            return;
        }
        // if lastAddedMediaSingleFileIds is empty exit because there are no added media single nodes to be selected
        if (this.lastAddedMediaSingleFileIds.length !== 0) this.waitForPendingTasks().then(()=>{
            const lastTrackedAddedNode = this.lastAddedMediaSingleFileIds[0];
            // execute selection only if selection did not change after the node has been inserted
            if (lastTrackedAddedNode?.selectionPosition === this.view.state.selection.from) {
                const lastAddedNode = this.mediaNodes.find((node)=>{
                    return node.node.attrs.id === lastTrackedAddedNode.id;
                });
                const lastAddedNodePos = lastAddedNode?.getPos();
                if (lastAddedNodePos) {
                    const { dispatch: dispatch, state: state } = this.view;
                    const tr = state.tr;
                    tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, lastAddedNodePos));
                    if (dispatch) dispatch(tr);
                }
            }
            // reset temp constant after uploads finished
            this.lastAddedMediaSingleFileIds = [];
        });
    }
    setView(view) {
        this.view = view;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        const { mediaNodes: mediaNodes } = this;
        mediaNodes.splice(0, mediaNodes.length);
        this.removeOnCloseListener();
        this.destroyPickers();
    }
    async initPickers(uploadParams, Picker) {
        if (this.destroyed || !this.uploadMediaClientConfig) return;
        const { errorReporter: errorReporter, pickers: pickers, pickerPromises: pickerPromises } = this;
        // create pickers if they don't exist, re-use otherwise
        if (!pickers.length) {
            const pickerFacadeConfig = {
                mediaClientConfig: this.uploadMediaClientConfig,
                errorReporter: errorReporter
            };
            if (this.options.customMediaPicker) {
                const customPicker = new Picker('customMediaPicker', pickerFacadeConfig, this.options.customMediaPicker).init();
                pickerPromises.push(customPicker);
                pickers.push(this.customPicker = await customPicker);
            }
            pickers.forEach((picker)=>{
                picker.onNewMedia(this.insertFile);
            });
        }
        // set new upload params for the pickers
        pickers.forEach((picker)=>picker.setUploadParams(uploadParams));
    }
    collectionFromProvider() {
        return this.mediaProvider && this.mediaProvider.uploadParams && this.mediaProvider.uploadParams.collection;
    }
    updateAndDispatch(props) {
        // update plugin state
        Object.keys(props).forEach((_key)=>{
            const key = _key;
            const value = props[key];
            if (value !== undefined) this[key] = value;
        });
        if (this.dispatch) this.dispatch((0, $2mgqy.stateKey), {
            ...this
        });
    }
    constructor(_state, options, mediaOptions, _dispatch, pluginInjectionApi){
        this.allowsUploads = false;
        this.mediaClientConfig = void 0;
        this.uploadMediaClientConfig = void 0;
        this.ignoreLinks = false;
        this.waitForMediaUpload = true;
        this.allUploadsFinished = true;
        this.previewRenderedMediaIds = new Set();
        this.showDropzone = false;
        this.isFullscreen = false;
        this.element = void 0;
        this.layout = 'center';
        this.mediaNodes = [];
        this.options = void 0;
        this.mediaProvider = void 0;
        this.isResizing = false;
        this.resizingWidth = 0;
        this.currentMaxWidth = void 0;
        this.allowInlineImages = false;
        this.uploadInProgressSubscriptions = [];
        this.uploadInProgressSubscriptionsNotified = false;
        // this is only a temporary variable, which gets cleared after the last inserted node has been selected
        this.lastAddedMediaSingleFileIds = [];
        this.view = void 0;
        this.destroyed = false;
        this.errorReporter = void 0;
        // @ts-ignore: private is OK
        this.customPicker = void 0;
        this.removeOnCloseListener = ()=>{};
        this.openMediaPickerBrowser = void 0;
        this.onPopupToggleCallback = ()=>{};
        // When non-null, holds the file ID of the media node being replaced. Used both as a
        // flag (non-null = replace mode) and as a cross-check to ensure the correct node is
        // updated if the selection moves between the picker opening and the file being picked.
        this.replaceMediaFileId = null;
        // The display height (in pixels) of the mediaSingle being replaced, computed at replace time
        // from its display width and the old media node's intrinsic aspect ratio.
        // Used by the nodeview to recompute display width from the new file's aspect ratio after
        // dimensions are fetched, preserving visual height rather than visual width.
        this.replaceMediaTargetDisplayHeight = null;
        this.identifierCount = new Map();
        // This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
        // see: trackOutOfScopeIdentifier
        this.outOfEditorScopeIdentifierMap = new Map();
        this.taskManager = new (0, $3pg0a.MediaTaskManager)();
        this.pickers = [];
        this.pickerPromises = [];
        this.editingMediaSinglePos = void 0;
        this.showEditingDialog = void 0;
        this.mediaOptions = void 0;
        this.dispatch = void 0;
        this.pluginInjectionApi = void 0;
        this.singletonCreatedAt = void 0;
        this.previousMediaProvider = void 0;
        this.getMediaOptions = ()=>this.options;
        this.isMediaSchemaNode = ({ type: type })=>{
            const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = this.view.state.schema.nodes;
            if ((0, $c2smn.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags)) return type === mediaSingle || type === media || type === mediaInline;
            return type === mediaSingle;
        };
        // callback to flag that a node has been inserted
        this.onNodeInserted = (id, selectionPosition)=>{
            this.lastAddedMediaSingleFileIds.unshift({
                id: id,
                selectionPosition: selectionPosition
            });
        };
        /**
     * we insert a new file by inserting a initial state for that file.
     *
     * called when we insert a new file via the picker (connected via pickerfacade)
     */ this.insertFile = (mediaState, onMediaStateChanged, pickerType, insertMediaVia)=>{
            const { state: state } = this.view;
            const editorAnalyticsAPI = this.pluginInjectionApi?.analytics?.actions;
            const mediaStateWithContext = {
                ...mediaState,
                contextId: this.contextIdentifierProvider ? this.contextIdentifierProvider.objectId : undefined
            };
            const collection = mediaState.collection ?? this.collectionFromProvider();
            if (collection === undefined) return;
            // If replace mode was set but the selection has moved away from a mediaSingle
            // (e.g. the user cancelled the replace picker and then inserted media elsewhere),
            // clear replace state so this insertion proceeds as a normal insert.
            if (this.replaceMediaFileId !== null) {
                const { mediaSingle: mediaSingle } = state.schema.nodes;
                const isStillOnTargetMedia = state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.type === mediaSingle && state.selection.node.firstChild?.attrs.id === this.replaceMediaFileId;
                if (!isStillOnTargetMedia) {
                    this.replaceMediaFileId = null;
                    this.replaceMediaTargetDisplayHeight = null;
                }
            }
            // We need to dispatch the change to event dispatcher only for successful files
            if (mediaState.status !== 'error') this.updateAndDispatch({
                allUploadsFinished: false
            });
            if (this.uploadInProgressSubscriptions.length > 0 && !this.uploadInProgressSubscriptionsNotified) {
                this.uploadInProgressSubscriptions.forEach((fn)=>fn(true));
                this.uploadInProgressSubscriptionsNotified = true;
            }
            // Replace mode: if a media node is being replaced, update its attrs in-place
            // rather than inserting a new node. This preserves layout, width, and caption.
            if (this.replaceMediaFileId !== null) {
                // Clear replace mode immediately so subsequent insertions behave normally
                this.replaceMediaFileId = null;
                const { state: currentState } = this.view;
                const mediaSinglePos = currentState.selection.from;
                const mediaPos = mediaSinglePos + 1;
                const mediaNode = currentState.doc.nodeAt(mediaPos);
                if (!mediaNode || mediaNode.type.name !== 'media') return;
                // Build a single transaction that:
                // 1. Updates the media child node attrs (new file identity + cleared dimensions)
                // 2. Re-creates the NodeSelection so the toolbar picks up the fresh node
                const tr = currentState.tr;
                tr.step(new (0, $1A89X.SetAttrsStep)(mediaPos, {
                    id: mediaState.id,
                    collection: collection,
                    type: 'file',
                    __fileMimeType: mediaState.fileMimeType ?? null,
                    __fileName: mediaState.fileName ?? null,
                    __fileSize: mediaState.fileSize ?? null,
                    __mediaTraceId: null,
                    // Clear intrinsic dimensions — they'll be fetched once the file
                    // is processed and applied via updateDimensions in a single tx
                    // with the height-preserving mediaSingle width adjustment.
                    width: null,
                    height: null
                }));
                // Re-create the selection so the floating toolbar picks up
                // the updated node and renders the full set of controls.
                tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, mediaSinglePos));
                tr.setMeta('scrollIntoView', false);
                this.view.dispatch(tr);
                // Still register the state-change listener so upload completion is tracked
                onMediaStateChanged(this.handleMediaState);
                const isEndState = (state)=>state.status && $c08dfbb8b3812a7c$var$MEDIA_RESOLVED_STATES.includes(state.status);
                // After the file finishes uploading/processing, trigger a dimension fetch.
                // getRemoteDimensions may fail if called too early (isImageRepresentationReady
                // returns false while processing), so we wait for the ready state first.
                const triggerDimensionFetch = ()=>{
                    // Find the media node in the doc by id and create a temporary
                    // MediaNodeUpdater to fetch and apply dimensions
                    const { state: editorState } = this.view;
                    const { mediaSingle: mediaSingleType } = editorState.schema.nodes;
                    let mediaChildNode = null;
                    editorState.doc.descendants((node)=>{
                        if (mediaChildNode) return false;
                        if (node.type === mediaSingleType) {
                            const child = node.firstChild;
                            if (child && child.attrs.id === mediaState.id) mediaChildNode = child;
                        }
                        return true;
                    });
                    if (mediaChildNode) {
                        const updater = (0, $1wNII.createMediaNodeUpdater)({
                            view: this.view,
                            mediaProvider: this.mediaProvider ? Promise.resolve(this.mediaProvider) : undefined,
                            contextIdentifierProvider: this.contextIdentifierProvider ? Promise.resolve(this.contextIdentifierProvider) : undefined,
                            node: mediaChildNode,
                            isMediaSingle: true,
                            lineLength: this.pluginInjectionApi?.width?.sharedState.currentState()?.lineLength
                        });
                        updater.getRemoteDimensions().then((dims)=>{
                            if (dims) updater.updateDimensions(dims);
                        }).catch(()=>{
                        // Silently ignore — if dimensions can't be fetched (e.g. network error),
                        // the image will render at its current size without the height-preserving
                        // width adjustment. This is an acceptable degraded experience.
                        });
                    }
                };
                if (!isEndState(mediaStateWithContext)) {
                    const uploadingPromise = new Promise((resolve)=>{
                        onMediaStateChanged((newState)=>{
                            if (isEndState(newState)) resolve(newState);
                        });
                    });
                    this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                        this.updateAndDispatch({
                            allUploadsFinished: true
                        });
                        triggerDimensionFetch();
                    });
                } else // File is already in a resolved state — fetch dimensions immediately
                triggerDimensionFetch();
                const { view: view } = this;
                if (!view.hasFocus()) view.focus();
                return;
            }
            switch((0, $7O00G.getMediaNodeInsertionType)(state, this.mediaOptions, mediaStateWithContext.fileMimeType)){
                case 'inline':
                    (0, $H8AVk.insertMediaInlineNode)(editorAnalyticsAPI)(this.view, mediaStateWithContext, collection, this.allowInlineImages, this.getInputMethod(pickerType), insertMediaVia);
                    break;
                case 'block':
                    // read width state right before inserting to get up-to-date and define values
                    const widthPluginState = this.pluginInjectionApi?.width?.sharedState.currentState();
                    (0, $d55P7.insertMediaSingleNode)(this.view, mediaStateWithContext, this.getInputMethod(pickerType), collection, this.mediaOptions && this.mediaOptions.alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, this.onNodeInserted, insertMediaVia, this.mediaOptions && this.mediaOptions.allowPixelResizing);
                    break;
                case 'group':
                    (0, $H8AVk.insertMediaGroupNode)(editorAnalyticsAPI)(this.view, [
                        mediaStateWithContext
                    ], collection, this.getInputMethod(pickerType), insertMediaVia);
                    break;
            }
            // do events when media state changes
            onMediaStateChanged(this.handleMediaState);
            // handle waiting for upload complete
            const isEndState = (state)=>state.status && $c08dfbb8b3812a7c$var$MEDIA_RESOLVED_STATES.indexOf(state.status) !== -1;
            if (!isEndState(mediaStateWithContext)) {
                const uploadingPromise = new Promise((resolve)=>{
                    onMediaStateChanged((newState)=>{
                        // When media item reaches its final state, remove listener and resolve
                        if (isEndState(newState)) resolve(newState);
                    });
                });
                this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                    this.updateAndDispatch({
                        allUploadsFinished: true
                    });
                });
            }
            // refocus the view
            const { view: view } = this;
            if (!view.hasFocus()) view.focus();
            this.waitForPendingTasks().then(()=>{
                if (this.uploadInProgressSubscriptions.length > 0 && this.uploadInProgressSubscriptionsNotified) {
                    this.uploadInProgressSubscriptions.forEach((fn)=>fn(false));
                    this.uploadInProgressSubscriptionsNotified = false;
                }
            });
            this.selectLastAddedMediaNode();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task)=>{
            this.taskManager.addPendingTask(task);
        };
        this.splitMediaGroup = ()=>(0, $geUVX.splitMediaGroup)(this.view);
        this.onPopupPickerClose = ()=>{
            this.onPopupToggleCallback(false);
        };
        this.showMediaPicker = ()=>{
            if (this.openMediaPickerBrowser) return this.openMediaPickerBrowser();
            this.onPopupToggleCallback(true);
        };
        /**
     * Opens the media picker in "replace" mode. The next file selected/uploaded
     * will replace the currently selected mediaSingle node's media child in-place,
     * preserving layout, width, and caption.
     *
     * The display height is computed and stored so that after the new file's intrinsic
     * dimensions are fetched, the mediaSingle display width can be adjusted to maintain
     * visual height stability rather than width stability.
     */ this.showMediaPickerForReplace = ()=>{
            const { state: state } = this.view;
            const { mediaSingle: mediaSingle } = state.schema.nodes;
            const { selection: selection } = state;
            // Only activate replace mode when a mediaSingle is selected
            if (!(selection instanceof (0, $kCECX.NodeSelection)) || selection.node.type !== mediaSingle) return;
            const mediaSingleNode = selection.node;
            const mediaNode = mediaSingleNode.firstChild;
            if (!mediaNode) return;
            // Store the current media node's id so insertFile can identify and replace it
            this.replaceMediaFileId = mediaNode.attrs.id;
            // Compute and store the current display height so we can preserve it after
            // the new file's intrinsic dimensions are known.
            // displayHeight = displayWidth * (intrinsicHeight / intrinsicWidth)
            const widthAttr = mediaSingleNode.attrs.width;
            const widthType = mediaSingleNode.attrs.widthType;
            const intrinsicWidth = mediaNode.attrs.width;
            const intrinsicHeight = mediaNode.attrs.height;
            // Resolve actual pixel display width from mediaSingle attrs.
            const lineLength = this.pluginInjectionApi?.width?.sharedState.currentState()?.lineLength ?? 760;
            let displayWidth = null;
            if (widthAttr && widthType === 'pixel') displayWidth = widthAttr;
            else if (widthAttr) // Default widthType is 'percentage' — convert to pixels
            displayWidth = widthAttr / 100 * lineLength;
            else if (intrinsicWidth) // No width set at all (never resized) — fall back to intrinsic width
            displayWidth = intrinsicWidth;
            if (displayWidth && intrinsicWidth && intrinsicHeight && intrinsicWidth > 0) this.replaceMediaTargetDisplayHeight = displayWidth * (intrinsicHeight / intrinsicWidth);
            else // Can't compute display height — fall back to preserving width
            this.replaceMediaTargetDisplayHeight = null;
            // Finally, show the media picker
            this.showMediaPicker();
        };
        this.setBrowseFn = (browseFn)=>{
            this.openMediaPickerBrowser = browseFn;
        };
        this.onPopupToggle = (onPopupToggleCallback)=>{
            this.onPopupToggleCallback = onPopupToggleCallback;
        };
        /**
     * Returns a promise that is resolved after all pending operations have been finished.
     * An optional timeout will cause the promise to reject if the operation takes too long
     *
     * NOTE: The promise will resolve even if some of the media have failed to process.
     */ this.waitForPendingTasks = this.taskManager.waitForPendingTasks;
        /**
     * Called from React UI Component when user clicks on "Delete" icon
     * inside of it
     */ this.handleMediaNodeRemoval = (node, getPos)=>{
            let getNode = node;
            if (!getNode) {
                const pos = getPos();
                if (typeof pos !== 'number') return;
                getNode = this.view.state.doc.nodeAt(pos);
            }
            (0, $geUVX.removeMediaNode)(this.view, getNode, getPos);
        };
        this.getIdentifierKey = (identifier)=>{
            if (identifier.mediaItemType === 'file') return identifier.id;
            else return identifier.dataURI;
        };
        this.trackMediaNodeAddition = (node)=>{
            const identifier = (0, $geUVX.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 0) this.taskManager.resumePendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count + 1
            });
        };
        this.trackMediaNodeRemoval = (node)=>{
            const identifier = (0, $geUVX.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 1) this.taskManager.cancelPendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count - 1
            });
        };
        this.isIdentifierInEditorScope = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            // rely on has instead of count > 0 because if the user cuts and pastes the same media
            // the count will temporarily be 0 but the media is still in the scope of editor.
            return !this.outOfEditorScopeIdentifierMap.has(key) && this.identifierCount.has(key);
        };
        /**
     * This is used in on Paste of media, this tracks which if the pasted media originated from a outside the editor
     * i.e. the pasted media was not uplaoded to the current editor.
     * This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
     */ this.trackOutOfScopeIdentifier = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            this.outOfEditorScopeIdentifierMap.set(key, {
                identifier: identifier
            });
        };
        /**
     * Called from React UI Component on componentDidMount
     */ this.handleMediaNodeMount = (node, getPos)=>{
            this.trackMediaNodeAddition(node);
            this.mediaNodes.unshift({
                node: node,
                getPos: getPos
            });
        };
        /**
     * Called from React UI Component on componentWillUnmount and UNSAFE_componentWillReceiveProps
     * when React component's underlying node property is replaced with a new node
     */ this.handleMediaNodeUnmount = (oldNode)=>{
            this.trackMediaNodeRemoval(oldNode);
            this.mediaNodes = this.mediaNodes.filter(({ node: node })=>oldNode !== node);
        };
        this.handleMediaGroupUpdate = (oldNodes, newNodes)=>{
            const addedNodes = newNodes.filter((node)=>oldNodes.every((oldNode)=>oldNode.attrs.id !== node.attrs.id));
            const removedNodes = oldNodes.filter((node)=>newNodes.every((newNode)=>newNode.attrs.id !== node.attrs.id));
            addedNodes.forEach((node)=>{
                this.trackMediaNodeAddition(node);
            });
            removedNodes.forEach((oldNode)=>{
                this.trackMediaNodeRemoval(oldNode);
            });
        };
        this.findMediaNode = (id)=>{
            return $7TpAR.findMediaNode(this, id);
        };
        this.destroyAllPickers = (pickers)=>{
            pickers.forEach((picker)=>picker.destroy());
            this.pickers.splice(0, this.pickers.length);
        };
        this.destroyPickers = ()=>{
            const { pickers: pickers, pickerPromises: pickerPromises } = this;
            // If pickerPromises and pickers are the same length
            // All pickers have resolved and we safely destroy them
            // Otherwise wait for them to resolve then destroy.
            if (pickerPromises.length === pickers.length) this.destroyAllPickers(this.pickers);
            else Promise.all(pickerPromises).then((resolvedPickers)=>this.destroyAllPickers(resolvedPickers));
            this.customPicker = undefined;
        };
        this.getInputMethod = (pickerType)=>{
            switch(pickerType){
                case (0, $krYZG.INPUT_METHOD).PICKER_CLOUD:
                    return (0, $krYZG.INPUT_METHOD).PICKER_CLOUD;
                case (0, $krYZG.INPUT_METHOD).MEDIA_PICKER:
                    return (0, $krYZG.INPUT_METHOD).MEDIA_PICKER;
                case 'clipboard':
                    return (0, $krYZG.INPUT_METHOD).CLIPBOARD;
                case 'dropzone':
                    return (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP;
                case 'browser':
                    return (0, $krYZG.INPUT_METHOD).BROWSER;
            }
            return;
        };
        this.updateMediaSingleNodeAttrs = (id, attrs)=>{
            const { view: view } = this;
            if (!view) return;
            return (0, $7TpAR.updateMediaNodeAttrs)(id, attrs)(view.state, view.dispatch);
        };
        this.handleMediaState = (state)=>{
            switch(state.status){
                case 'error':
                    const { uploadErrorHandler: uploadErrorHandler } = this.options;
                    if (uploadErrorHandler) uploadErrorHandler(state);
                    break;
            }
        };
        this.removeSelectedMediaContainer = ()=>{
            const { view: view } = this;
            const selectedNode = this.selectedMediaContainerNode();
            if (!selectedNode) return false;
            const { from: from } = view.state.selection;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $geUVX.removeMediaNode)(view, selectedNode.firstChild, ()=>from + 1);
            return true;
        };
        this.selectedMediaContainerNode = ()=>{
            const selection = this.view?.state?.selection;
            if (selection instanceof (0, $kCECX.NodeSelection) && this.isMediaSchemaNode(selection.node)) return selection.node;
            return;
        };
        this.handleDrag = (dragState)=>{
            const isActive = dragState === 'enter';
            if (this.showDropzone === isActive) return;
            this.showDropzone = isActive;
            const { dispatch: dispatch, state: state } = this.view;
            const { tr: tr, selection: selection, doc: doc } = state;
            const { media: media, mediaGroup: mediaGroup } = state.schema.nodes;
            // Workaround for wrong upload position
            // @see https://product-fabric.atlassian.net/browse/MEX-2457
            // If the media node is the last selectable item in the current cursor position and it is located within a mediaGroup,
            // we relocate the cursor to the first child of the mediaGroup.
            const pos = Math.max(0, selection.$from.pos - 1);
            const sel = (0, $kCECX.Selection).findFrom(doc.resolve(pos), -1);
            if (sel && (0, $bjg0G.findSelectedNodeOfType)(media)(sel)) {
                const parent = (0, $bjg0G.findParentNodeOfType)(mediaGroup)(sel);
                if (parent) tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, parent.start));
            }
            // Trigger state change to be able to pick it up in the decorations handler
            dispatch(tr);
        };
        this.options = options;
        this.mediaOptions = mediaOptions;
        this.dispatch = _dispatch;
        this.pluginInjectionApi = pluginInjectionApi;
        this.waitForMediaUpload = options.waitForMediaUpload === undefined ? true : options.waitForMediaUpload;
        const { nodes: nodes } = _state.schema;
        (0, (/*@__PURE__*/$parcel$interopDefault($9Rq82)))(nodes.media && (nodes.mediaGroup || nodes.mediaSingle), 'Editor: unable to init media plugin - media or mediaGroup/mediaSingle node absent in schema');
        if (mediaOptions?.syncProvider) this.setMediaProvider(mediaOptions?.syncProvider);
        else if (mediaOptions?.provider) this.setMediaProvider(mediaOptions?.provider);
        if ((0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag')) {
            if (this.mediaOptions?.allowMediaInlineImages) this.allowInlineImages = true;
        } else if ((0, $nnUSM.mediaInlineImagesEnabled)((0, $c2smn.getMediaFeatureFlag)('mediaInline', this.mediaOptions?.featureFlags), this.mediaOptions?.allowMediaInlineImages)) this.allowInlineImages = true;
        this.errorReporter = options.errorReporter || new (0, $dldpg.ErrorReporter)();
        this.singletonCreatedAt = (performance || Date).now();
    }
}
const $c08dfbb8b3812a7c$export$c2bb38320d6be1f2 = (state)=>(0, $2mgqy.stateKey).getState(state);
const $c08dfbb8b3812a7c$export$ae829ec7b2625219 = (_schema, options, getIntl, pluginInjectionApi, nodeViewPortalProviderAPI, dispatch, mediaOptions)=>{
    const intl = getIntl();
    return new (0, $kpCD8.SafePlugin)({
        state: {
            init (_config, state) {
                return new $c08dfbb8b3812a7c$export$a013ab53254c388d(state, options, mediaOptions, dispatch, pluginInjectionApi);
            },
            apply (tr, pluginState) {
                const isResizing = tr.getMeta($c08dfbb8b3812a7c$export$2955196e6685aaf4);
                const resizingWidth = tr.getMeta($c08dfbb8b3812a7c$export$ea728aeacba173d1);
                const mediaProvider = tr.getMeta((0, $2mgqy.stateKey))?.mediaProvider;
                // Yes, I agree with you; this approach, using the clone() fuction, below is horrifying.
                // However, we needed to implement this workaround to solve the singleton Media PluginState.
                // The entire PluginInjectionAPI relies on the following axiom: "A PluginState that reflects a new EditorState.". We can not have the mutable singleton instance for all EditorState.
                // Unfortunately, we can't implement a proper fix for this media state situation. So, we are faking a new object using a Proxy instance.
                let nextPluginState = pluginState;
                if (isResizing !== undefined) {
                    pluginState.setIsResizing(isResizing);
                    nextPluginState = nextPluginState.clone();
                }
                if (mediaProvider) pluginState.setMediaProvider(mediaProvider);
                if (resizingWidth) {
                    pluginState.setResizingWidth(resizingWidth);
                    nextPluginState = nextPluginState.clone();
                }
                // remap editing media single position if we're in collab
                if (typeof pluginState.editingMediaSinglePos === 'number') {
                    pluginState.editingMediaSinglePos = tr.mapping.map(pluginState.editingMediaSinglePos);
                    nextPluginState = nextPluginState.clone();
                }
                const meta = tr.getMeta((0, $2mgqy.stateKey));
                if (meta && meta.type !== 'PREVIEW_RENDERED') {
                    const { allowsUploads: allowsUploads } = meta;
                    pluginState.updateAndDispatch({
                        allowsUploads: typeof allowsUploads === 'undefined' ? pluginState.allowsUploads : allowsUploads
                    });
                    nextPluginState = nextPluginState.clone();
                }
                // Handle preview render notifications — add the file ID to the
                // previewRenderedMediaIds Set so sharedState subscribers can react.
                if (meta?.type === 'PREVIEW_RENDERED' && typeof meta.fileId === 'string') {
                    const newSet = new Set(pluginState.previewRenderedMediaIds);
                    newSet.add(meta.fileId);
                    pluginState.previewRenderedMediaIds = newSet;
                    nextPluginState = nextPluginState.clone();
                }
                // ACTIONS
                switch(meta?.type){
                    case (0, $fw4RS.ACTIONS).SHOW_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = meta.mediaViewerSelectedMedia;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $fw4RS.ACTIONS).HIDE_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = undefined;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $fw4RS.ACTIONS).TRACK_MEDIA_PASTE:
                        const { identifier: identifier } = meta;
                        const isIdentifierInEditorScope = pluginState.isIdentifierInEditorScope(identifier);
                        if (!isIdentifierInEditorScope && (0, $PGUCj.isFileIdentifier)(identifier)) {
                            pluginState.trackOutOfScopeIdentifier(identifier);
                            nextPluginState = pluginState.clone();
                        }
                        break;
                }
                // NOTE: We're not calling passing new state to the Editor, because we depend on the view.state reference
                //       throughout the lifetime of view. We injected the view into the plugin state, because we dispatch()
                //       transformations from within the plugin state (i.e. when adding a new file).
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            for (const transaction of transactions){
                const isSelectionOnMediaInsideMediaSingle = transaction.selectionSet && (0, $bjg0G.isNodeSelection)(transaction.selection) && transaction.selection.node.type === newState.schema.nodes.media && transaction.selection.$anchor.parent.type === newState.schema.nodes.mediaSingle;
                // Note: this causes an additional transaction when selecting a media node
                // through clicking  on it with the cursor.
                if (isSelectionOnMediaInsideMediaSingle) // If a selection has been placed on a media inside a media single,
                // we shift it to the media single parent as other code is opinionated about
                // the selection landing there. In particular the caption insertion and selection
                // action.
                return newState.tr.setSelection((0, $kCECX.NodeSelection).create(newState.doc, transaction.selection.$from.pos - 1));
            }
            return;
        },
        key: (0, $2mgqy.stateKey),
        view: (view)=>{
            const pluginState = $c08dfbb8b3812a7c$export$c2bb38320d6be1f2(view.state);
            pluginState.setView(view);
            pluginState.updateElement();
            return {
                update: ()=>{
                    pluginState.updateElement();
                }
            };
        },
        props: {
            decorations: (state)=>{
                // Use this to indicate that the media node is selected
                const mediaNodes = [];
                const { schema: schema, selection: { $anchor: $anchor }, doc: doc } = state;
                // Find any media nodes in the current selection
                if (state.selection instanceof (0, $kCECX.TextSelection) || state.selection instanceof (0, $kCECX.AllSelection) || state.selection instanceof (0, $8HW7o.CellSelection)) doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
                    if (node.type === schema.nodes.media) {
                        mediaNodes.push((0, $8nvEM.Decoration).node(pos, pos + node.nodeSize, {}, {
                            type: 'media',
                            selected: true
                        }));
                        return false;
                    }
                    return true;
                });
                else if (state.selection instanceof (0, $kCECX.NodeSelection)) {
                    const { node: node, $from: $from } = state.selection;
                    if (node.type === schema.nodes.mediaSingle || node.type === schema.nodes.mediaGroup) doc.nodesBetween($from.pos, $from.pos + node.nodeSize, (mediaNode, mediaPos)=>{
                        if (mediaNode.type === schema.nodes.media) {
                            mediaNodes.push((0, $8nvEM.Decoration).node(mediaPos, mediaPos + mediaNode.nodeSize, {}, {
                                type: 'media',
                                selected: true
                            }));
                            return false;
                        }
                        return true;
                    });
                }
                const pluginState = $c08dfbb8b3812a7c$export$c2bb38320d6be1f2(state);
                if (!pluginState.showDropzone) return (0, $8nvEM.DecorationSet).create(state.doc, mediaNodes);
                // When a media is already selected
                if (state.selection instanceof (0, $kCECX.NodeSelection)) {
                    const node = state.selection.node;
                    if (node.type === schema.nodes.mediaSingle) {
                        const deco = (0, $8nvEM.Decoration).node(state.selection.from, state.selection.to, {
                            class: 'richMedia-selected'
                        });
                        return (0, $8nvEM.DecorationSet).create(state.doc, [
                            deco,
                            ...mediaNodes
                        ]);
                    }
                    return (0, $8nvEM.DecorationSet).create(state.doc, mediaNodes);
                }
                let pos = $anchor.pos;
                if ($anchor.parent.type !== schema.nodes.paragraph && $anchor.parent.type !== schema.nodes.codeBlock) pos = (0, $eOaGc.insertPoint)(state.doc, pos, schema.nodes.mediaGroup);
                if (pos === null || pos === undefined) return (0, $8nvEM.DecorationSet).create(state.doc, mediaNodes);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const dropPlaceholderKey = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
                const dropPlaceholders = [
                    (0, $8nvEM.Decoration).widget(pos, ()=>{
                        return $c08dfbb8b3812a7c$var$createDropPlaceholder(intl, nodeViewPortalProviderAPI, dropPlaceholderKey, mediaOptions && mediaOptions.allowDropzoneDropLine);
                    }, {
                        key: 'drop-placeholder',
                        destroy: (elem)=>{
                            if (elem instanceof HTMLElement) nodeViewPortalProviderAPI.remove(dropPlaceholderKey);
                        }
                    }),
                    ...mediaNodes
                ];
                return (0, $8nvEM.DecorationSet).create(state.doc, dropPlaceholders);
            },
            nodeViews: options.nodeViews,
            handleTextInput (view, from, to, text) {
                const { selection: selection } = view.state;
                if (text === ' ' && selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'mediaSingle') {
                    const videoControlsWrapperRef = (0, $2mgqy.stateKey).getState(view.state)?.element;
                    const videoControls = videoControlsWrapperRef?.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
                    if (videoControls) {
                        const isVideoControl = Array.from(videoControls).some((videoControl)=>{
                            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                            return document.activeElement === videoControl;
                        });
                        if (isVideoControl) return true;
                    }
                }
                $c08dfbb8b3812a7c$export$c2bb38320d6be1f2(view.state).splitMediaGroup();
                return false;
            },
            handleClick: (_editorView, _pos, event)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const clickedInsideCaptionPlaceholder = event.target?.closest(`[data-id="${(0, $4G6PK.CAPTION_PLACEHOLDER_ID)}"]`);
                const browser = (0, $8dxef.getBrowserInfo)();
                // Workaround for Chrome given a regression introduced in prosemirror-view@1.18.6
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/compare/1.18.5...1.18.6
                if ((browser.chrome || browser.safari) && clickedInsideCaptionPlaceholder) return true;
                // Workaound for iOS 16 Caption selection issue
                // @see https://product-fabric.atlassian.net/browse/MEX-2012
                if (browser.ios) // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return !!event.target?.closest(`[class="${$c08dfbb8b3812a7c$export$fcef64fdeaf6f18a}"]`);
                return false;
            },
            handleDoubleClickOn: (view)=>{
                // Check if media viewer is enabled
                const pluginState = $c08dfbb8b3812a7c$export$c2bb38320d6be1f2(view.state);
                if (!pluginState.mediaOptions?.allowImagePreview) return false;
                const isLivePagesViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Double Click support for Media Viewer Nodes
                const maybeMediaNode = (0, $geUVX.getMediaFromSupportedMediaNodesFromSelection)(view.state);
                if (maybeMediaNode) {
                    // If media type is video, do not open media viewer
                    if (!(0, $geUVX.isNodeDoubleClickSupportedInLivePagesViewMode)(isLivePagesViewMode, maybeMediaNode)) return false;
                    // Show media viewer
                    pluginInjectionApi?.core.actions.execute(pluginInjectionApi?.media.commands.showMediaViewer(maybeMediaNode.attrs));
                    // Call analytics event
                    pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).OPENED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA_VIEWER,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            nodeType: maybeMediaNode.type.name,
                            inputMethod: (0, $krYZG.INPUT_METHOD).DOUBLE_CLICK
                        }
                    });
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                keydown: (view, event)=>{
                    const { selection: selection } = view.state;
                    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'mediaSingle') // handle keydown events for video controls panel to prevent fire of rest prosemirror listeners;
                    {
                        if (event?.target instanceof HTMLElement) {
                            const a11yDefaultKeys = [
                                'Tab',
                                'Space',
                                'Enter',
                                'Shift',
                                'Esc'
                            ];
                            const targetsAndButtons = {
                                button: a11yDefaultKeys,
                                range: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ],
                                combobox: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'Esc'
                                ],
                                slider: [
                                    'Tab',
                                    'Shift',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ]
                            };
                            const targetRole = event.target.role;
                            const targetType = event.target.type;
                            const allowedTargets = targetRole || targetType;
                            // only if targeting interactive elements fe. button, slider, range, dropdown
                            if (allowedTargets && allowedTargets in targetsAndButtons) {
                                const targetRelatedA11YKeys = targetsAndButtons[allowedTargets];
                                const allowedKeys = new Set(targetRelatedA11YKeys);
                                if (allowedKeys.has(event.key) || allowedKeys.has(event.code)) // allow event to bubble to be handled by react handlers
                                return true;
                                else // otherwise focus editor to allow setting gapCursor. (e.g.: arrowRightFromMediaSingle)
                                view.focus();
                            }
                        }
                    }
                    // fire regular prosemirror listeners;
                    return false;
                }
            }
        }
    });
};
module.exports["MEDIA_CONTENT_WRAP_CLASS_NAME"] = $c08dfbb8b3812a7c$export$fcef64fdeaf6f18a;
module.exports["MEDIA_PLUGIN_IS_RESIZING_KEY"] = $c08dfbb8b3812a7c$export$2955196e6685aaf4;
module.exports["MEDIA_PLUGIN_RESIZING_WIDTH_KEY"] = $c08dfbb8b3812a7c$export$ea728aeacba173d1;
module.exports["getMediaPluginState"] = $c08dfbb8b3812a7c$export$c2bb38320d6be1f2;
module.exports["createPlugin"] = $c08dfbb8b3812a7c$export$ae829ec7b2625219;

});

parcelRegister("p7uR0", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $4mCw6 = parcelRequire("4mCw6");


var $hS5Am = parcelRequire("hS5Am");


var $4G6PK = parcelRequire("4G6PK");


var $3li0w = parcelRequire("3li0w");







const $7240d46a6f1e3048$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $7240d46a6f1e3048$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return (0, $hS5Am.calcMediaSingleMaxWidth)(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $4G6PK.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return (0, $3li0w.getMediaSingleInitialWidth)(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $7240d46a6f1e3048$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $7Y8M5.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $7240d46a6f1e3048$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $7240d46a6f1e3048$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $7240d46a6f1e3048$export$7cc71489edfd26f8($pos, view) : $7240d46a6f1e3048$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $7240d46a6f1e3048$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $4mCw6.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $7240d46a6f1e3048$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $7240d46a6f1e3048$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $7240d46a6f1e3048$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
module.exports["calcMediaSinglePixelWidth"] = $7240d46a6f1e3048$export$5091b2c0d1cd2361;
module.exports["getMaxWidthForNestedNodeNext"] = $7240d46a6f1e3048$export$bcefe8f1d5d7bbf3;

});

parcelRegister("hLkNo", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $bjg0G = parcelRequire("bjg0G");

const $2862cca54bf77c89$export$d3bec2d7dfd57a94 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, widthType: widthType, layout: layout, snapType: snapType, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $krYZG.ACTION_SUBJECT).EMBEDS : (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $krYZG.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            widthType: widthType,
            snapType: snapType,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $2862cca54bf77c89$export$e861d73ef59c0864 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, layout: layout, validation: validation, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $krYZG.ACTION_SUBJECT).EMBEDS : (0, $krYZG.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $krYZG.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            validation: validation,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).UI
    };
};
const $2862cca54bf77c89$export$3a6429e633acb640 = (previousType, newType, changeFromLocation)=>({
        action: (0, $krYZG.ACTION).CHANGED_TYPE,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newType: newType,
            previousType: previousType,
            changeFromLocation: changeFromLocation
        }
    });
function $2862cca54bf77c89$export$cc94f10add475df5(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    const parentNodeInfo = (0, $bjg0G.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
module.exports["getMediaResizeAnalyticsEvent"] = $2862cca54bf77c89$export$d3bec2d7dfd57a94;
module.exports["getMediaInputResizeAnalyticsEvent"] = $2862cca54bf77c89$export$e861d73ef59c0864;
module.exports["getChangeMediaAnalytics"] = $2862cca54bf77c89$export$3a6429e633acb640;
module.exports["findChangeFromLocation"] = $2862cca54bf77c89$export$cc94f10add475df5;

});

parcelRegister("4JRVn", function(module, exports) {

var $3mJu6 = parcelRequire("3mJu6");


var $kCECX = parcelRequire("kCECX");

const $b913bf153aa6fc0e$export$de57f5901ccaf81a = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $kCECX.NodeSelection)) || selection.node.type !== schema.nodes.mediaInline) return;
    const pos = selection.$anchor.pos;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.mediaInline) return;
    return {
        node: node,
        pos: pos
    };
};
const $b913bf153aa6fc0e$export$61c1b21ac50e0a02 = (editorState)=>{
    return (0, $3mJu6.currentMediaNodeWithPos)(editorState)?.node;
};
const $b913bf153aa6fc0e$export$948c2f536cfeec35 = (editorState)=>{
    return $b913bf153aa6fc0e$export$de57f5901ccaf81a(editorState)?.node;
};
const $b913bf153aa6fc0e$export$ab2a65138449fdc1 = (editorState)=>{
    const node = $b913bf153aa6fc0e$export$61c1b21ac50e0a02(editorState) || $b913bf153aa6fc0e$export$948c2f536cfeec35(editorState);
    if (!node) return;
    const borderMark = node.marks.find((m)=>m.type.name === 'border');
    if (!borderMark) return;
    return borderMark.attrs;
};
module.exports["currentMediaInlineNodeWithPos"] = $b913bf153aa6fc0e$export$de57f5901ccaf81a;
module.exports["currentMediaNode"] = $b913bf153aa6fc0e$export$61c1b21ac50e0a02;
module.exports["currentMediaInlineNode"] = $b913bf153aa6fc0e$export$948c2f536cfeec35;
module.exports["currentMediaOrInlineNodeBorderMark"] = $b913bf153aa6fc0e$export$ab2a65138449fdc1;

});

parcelRegister("9gPd6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ca8W8 = parcelRequire("ca8W8");

const $fbc51f83c4a984ab$export$e96f1fc68164e845 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { components: components, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents } = t0;
    if (!components?.length) return null;
    let t1;
    if ($[0] !== childrenMap || $[1] !== components || $[2] !== fallbacks || $[3] !== parents) {
        let t2;
        if ($[5] !== childrenMap || $[6] !== fallbacks || $[7] !== parents) {
            t2 = (component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca8W8.SurfaceComponent), {
                    key: component.key,
                    component: component,
                    childrenMap: childrenMap,
                    fallbacks: fallbacks,
                    parents: parents
                });
            $[5] = childrenMap;
            $[6] = fallbacks;
            $[7] = parents;
            $[8] = t2;
        } else t2 = $[8];
        t1 = components.map(t2);
        $[0] = childrenMap;
        $[1] = components;
        $[2] = fallbacks;
        $[3] = parents;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[9] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ components: components, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents })=>{
    if (!components?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, components.map((component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca8W8.SurfaceComponent), {
            key: component.key,
            component: component,
            childrenMap: childrenMap,
            fallbacks: fallbacks,
            parents: parents
        })));
};
module.exports["SurfaceComponents"] = $fbc51f83c4a984ab$export$e96f1fc68164e845;

});

parcelRegister("kejMu", function(module, exports) {
const $166e831ed2e10f58$export$b5d6a35b0cce4297 = (props)=>props.children ?? null;
const $166e831ed2e10f58$export$c3213ee7169ceb28 = (components, surface)=>{
    return components.find((c)=>c.key === surface.key && c.type === surface.type && (!c.parents || c.parents.length === 0));
};
const $166e831ed2e10f58$export$93e686d60d327014 = (components)=>{
    const childrenMap = new Map();
    for (const component of components){
        if (component.parents && component.parents.length > 0) for (const parent of component.parents){
            const existing = childrenMap.get(parent.key) || [];
            existing.push(component);
            childrenMap.set(parent.key, existing);
        }
    }
    for (const [parentKey, children] of childrenMap.entries())children.sort((a, b)=>{
        const rankA = a.parents?.find((p)=>p.key === parentKey)?.rank ?? 0;
        const rankB = b.parents?.find((p)=>p.key === parentKey)?.rank ?? 0;
        return rankA - rankB;
    });
    return childrenMap;
};
const $166e831ed2e10f58$export$51a8f8a5d7877637 = (component, childrenMap)=>{
    if (component.isHidden?.()) return false;
    const children = childrenMap.get(component.key);
    if (!children || children.length === 0) return true;
    return children.some((child)=>$166e831ed2e10f58$export$51a8f8a5d7877637(child, childrenMap));
};
module.exports["PassThrough"] = $166e831ed2e10f58$export$b5d6a35b0cce4297;
module.exports["findSurface"] = $166e831ed2e10f58$export$c3213ee7169ceb28;
module.exports["buildChildrenMap"] = $166e831ed2e10f58$export$93e686d60d327014;
module.exports["willComponentRender"] = $166e831ed2e10f58$export$51a8f8a5d7877637;

});

parcelRegister("lCuAc", function(module, exports) {
const $8eae4ed37894b0ec$export$1d7e7dcd2590e9c6 = (nodeType)=>{
    return nodeType.name === 'bulletList' || nodeType.name === 'orderedList';
};
module.exports["isBulletOrOrderedList"] = $8eae4ed37894b0ec$export$1d7e7dcd2590e9c6;

});

parcelRegister("96Kjp", function(module, exports) {
const $c329e4e8b1769151$export$adef7a5f125e0514 = (nodeType)=>{
    return nodeType.name === 'taskList';
};
module.exports["isTaskList"] = $c329e4e8b1769151$export$adef7a5f125e0514;

});

parcelRegister("bQgtm", function(module, exports) {

var $7ux9d = parcelRequire("7ux9d");




const $a0e2dc22dbe965f2$export$3fd351b2ea86488c = (nodes)=>{
    return new Set((0, $7ux9d.getSupportedListTypes)(nodes));
};
module.exports["getSupportedListTypesSet"] = $a0e2dc22dbe965f2$export$3fd351b2ea86488c;

});

parcelRegister("jSggL", function(module, exports) {

var $lCuAc = parcelRequire("lCuAc");


var $96Kjp = parcelRequire("96Kjp");


var $3pVtP = parcelRequire("3pVtP");


var $bQgtm = parcelRequire("bQgtm");

const $d854cb4d998e00eb$export$f6e356fc6d93cbb1 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const nodes = tr.doc.type.schema.nodes;
    const unsupportedContent = [];
    const onhandleUnsupportedContent = (content)=>{
        unsupportedContent.push(content);
    };
    try {
        const listNode = {
            node: sourceNode,
            pos: sourcePos
        };
        const { node: sourceList, pos: listPos } = listNode;
        // const { taskList, listItem, taskItem, paragraph } = nodes;
        const isSourceBulletOrOrdered = (0, $lCuAc.isBulletOrOrderedList)(sourceList.type);
        const isTargetTask = (0, $96Kjp.isTaskList)(targetNodeType);
        const isSourceTask = (0, $96Kjp.isTaskList)(sourceList.type);
        const isTargetBulletOrOrdered = (0, $lCuAc.isBulletOrOrderedList)(targetNodeType);
        const supportedListTypes = (0, $bQgtm.getSupportedListTypesSet)(nodes);
        const newList = (0, $3pVtP.transformListRecursively)({
            isSourceBulletOrOrdered: isSourceBulletOrOrdered,
            isSourceTask: isSourceTask,
            isTargetBulletOrOrdered: isTargetBulletOrOrdered,
            isTargetTask: isTargetTask,
            listNode: sourceList,
            schema: tr.doc.type.schema,
            supportedListTypes: supportedListTypes,
            targetNodeType: targetNodeType
        }, onhandleUnsupportedContent);
        tr.replaceWith(listPos, listPos + sourceList.nodeSize, [
            newList,
            ...unsupportedContent
        ]);
        return tr;
    } catch  {
        return tr;
    }
};
module.exports["transformListStructure"] = $d854cb4d998e00eb$export$f6e356fc6d93cbb1;

});

parcelRegister("7oNan", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");

const $dcd8bf8fe6d07a01$export$d9cdacbed7444a4a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const { blockTaskItem: blockTaskItem } = schema.nodes;
    // gating behind platform_editor_small_font_size to support task lists with font size applied,
    // but keep this solution general
    const isBlockTaskItemEnabled = !!blockTaskItem && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    if (isBlockTaskItemEnabled) {
        const blockTaskItemsResult = (0, $bjg0G.findChildrenByType)(sourceNode, blockTaskItem);
        if (blockTaskItemsResult.length > 0 && targetNodeType === schema.nodes.paragraph) {
            // blockTaskItem content is (paragraph | extension)+
            // Extract paragraph children directly — they may carry block marks (e.g. fontSize)
            const targetNodes = [];
            for (const { node: blockItem } of blockTaskItemsResult)blockItem.forEach((child)=>{
                if (child.type === schema.nodes.paragraph) targetNodes.push(child);
            });
            if (targetNodes.length === 0) return null;
            const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(targetNodes), 0, 0);
            const rangeStart = sourcePos !== null ? sourcePos : selection.from;
            tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
            return tr;
        }
    }
    // Original logic for regular taskItem children
    const taskItemsResult = (0, $bjg0G.findChildrenByType)(sourceNode, schema.nodes.taskItem);
    const taskItems = taskItemsResult.map((item)=>item.node);
    const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
    let targetNodes = [];
    // Convert fragments to headings if target is heading
    if (targetNodeType === schema.nodes.heading && targetAttrs) {
        // convert the fragments to headings
        const targetHeadingLevel = targetAttrs.level;
        targetNodes = taskItemFragments.map((fragment)=>schema.nodes.heading.createChecked({
                level: targetHeadingLevel
            }, fragment.content));
    }
    // Convert fragments to paragraphs if target is paragraphs
    if (targetNodeType === schema.nodes.paragraph) // convert the fragments to paragraphs
    targetNodes = taskItemFragments.map((fragment)=>schema.nodes.paragraph.createChecked({}, fragment.content));
    // Convert fragments to code block if target is code block
    if (targetNodeType === schema.nodes.codeBlock) {
        // convert the fragments to one code block
        const codeBlockContent = taskItemFragments.map((fragment)=>fragment.textBetween(0, fragment.size, '\n')).join('\n');
        targetNodes = [
            schema.nodes.codeBlock.createChecked({}, schema.text(codeBlockContent))
        ];
    }
    // Replace the task list node with the new content in the transaction
    const slice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).fromArray(targetNodes), 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};
module.exports["transformTaskListToBlockNodes"] = $dcd8bf8fe6d07a01$export$d9cdacbed7444a4a;

});

parcelRegister("cR6yj", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");

const $07a679f5f8144da3$export$c0b9021b626ac150 = (tr)=>{
    const { selection: selection } = tr;
    const { nodes: nodes } = tr.doc.type.schema;
    // gating behind platform_editor_small_font_size to support task lists with font size applied,
    // but keep this solution general
    const isBlockTaskItemEnabled = !!nodes.blockTaskItem && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    // Find the node to format from the current selection
    let nodeToFormat;
    let nodePos = selection.from;
    // Try to find the current node from selection
    const selectedNode = (0, $bjg0G.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.expand,
        nodes.codeBlock,
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.layoutSection
    ])(selection);
    if (selectedNode) {
        nodeToFormat = selectedNode.node;
        nodePos = selectedNode.pos;
    } else {
        // Try to find parent node (including list parents)
        const parentNodeTypes = [
            nodes.blockquote,
            nodes.panel,
            nodes.expand,
            nodes.codeBlock,
            nodes.listItem,
            nodes.taskItem,
            nodes.layoutSection
        ];
        if (isBlockTaskItemEnabled) parentNodeTypes.push(nodes.blockTaskItem);
        const parentNode = (0, $bjg0G.findParentNodeOfType)(parentNodeTypes)(selection);
        if (parentNode) {
            nodeToFormat = parentNode.node;
            nodePos = parentNode.pos;
            const paragraphOrHeadingNode = (0, $bjg0G.findParentNodeOfType)([
                nodes.paragraph,
                nodes.heading
            ])(selection);
            // Special case: if we found a listItem/taskItem/blockTaskItem, check if we need the parent list instead
            if (parentNode.node.type === nodes.listItem || parentNode.node.type === nodes.taskItem || isBlockTaskItemEnabled && parentNode.node.type === nodes.blockTaskItem) {
                const listParent = (0, $bjg0G.findParentNodeOfType)([
                    nodes.bulletList,
                    nodes.orderedList,
                    nodes.taskList
                ])(selection);
                if (listParent) {
                    // For list transformations, we want the list parent, not the listItem
                    nodeToFormat = listParent.node;
                    nodePos = listParent.pos;
                }
            } else if (parentNode.node.type !== nodes.blockquote && paragraphOrHeadingNode) {
                nodeToFormat = paragraphOrHeadingNode.node;
                nodePos = paragraphOrHeadingNode.pos;
            }
        }
    }
    if (!nodeToFormat) {
        nodeToFormat = selection.$from.node();
        nodePos = selection.$from.pos;
    }
    return {
        node: nodeToFormat,
        pos: nodePos
    };
};
module.exports["getFormattedNode"] = $07a679f5f8144da3$export$c0b9021b626ac150;

});

parcelRegister("SlYRR", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $euISL = parcelRequire("euISL");

var $hZ5o2 = parcelRequire("hZ5o2");


var $57Rmq = parcelRequire("57Rmq");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");

const $37fff4366474b40a$export$199dae4875feadcd = (nodeType)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = nodeType.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].indexOf(nodeType) >= 0;
};
const $37fff4366474b40a$export$51b69e9dc2d60fca = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.layoutColumn;
};
const $37fff4366474b40a$export$a528a4f84f239e18 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.doc;
};
const $37fff4366474b40a$export$a1d4506bfd61c0e4 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.expand;
};
const $37fff4366474b40a$export$174a46ad1de68ba = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.nestedExpand;
};
const $37fff4366474b40a$export$7787d47a1b8939d0 = (node)=>{
    return node.type.name === 'paragraph' && node.marks.some((mark)=>mark.type.name === 'fontSize');
};
const $37fff4366474b40a$export$9d5fcdcf2394fab8 = ($from, $to)=>{
    const fromNode = $from.nodeAfter;
    const toNode = $to.nodeAfter;
    return !!(fromNode && toNode && fromNode.type.name === 'layoutColumn' && [
        'layoutSection',
        'layoutColumn'
    ].includes(toNode.type.name) && // fromNode can either be in the same layoutSection as toNode or is a layoutColumn inside the toNode (type layoutSection)
    ($from.sameParent($to) || $from.parent === toNode));
};
const $37fff4366474b40a$export$c78c24bf7f1a36c2 = (expandNode)=>{
    const { expand: expand, nestedExpand: nestedExpand } = expandNode.type.schema.nodes;
    if (expandNode.type === expand) return nestedExpand.createChecked(expandNode.attrs, expandNode.content, expandNode.marks);
    return null;
};
const $37fff4366474b40a$export$ca1d8e12fb5b3277 = (fragment)=>{
    const children = [];
    try {
        fragment.forEach((node)=>{
            if ($37fff4366474b40a$export$a1d4506bfd61c0e4(node.type)) {
                const nestedExpandNode = $37fff4366474b40a$export$c78c24bf7f1a36c2(node);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
};
const $37fff4366474b40a$export$ce4d3d0e85e5e737 = (fragment, schema, fromType, toType)=>{
    const children = [];
    const targetType = schema.nodes[toType];
    if (!targetType) return null;
    try {
        fragment.forEach((node)=>{
            if (node.type.name === fromType) children.push(targetType.create(node.attrs, node.content, node.marks));
            else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $aPdNQ.Fragment).fromArray(children);
};
const $37fff4366474b40a$export$805d193712b3b932 = (slice, schema, fromType, toType)=>{
    const fragment = $37fff4366474b40a$export$ce4d3d0e85e5e737(slice.content, schema, fromType, toType);
    if (!fragment) return null;
    return new (0, $aPdNQ.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $37fff4366474b40a$export$447e90e618548243 = (slice)=>{
    const fragment = $37fff4366474b40a$export$ca1d8e12fb5b3277(slice.content);
    if (!fragment) return null;
    return new (0, $aPdNQ.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $37fff4366474b40a$export$e639988f4c2f87a3 = (0, $dOBRD.default)((node)=>{
    try {
        return $37fff4366474b40a$export$c78c24bf7f1a36c2(node);
    } catch (e) {
        return null;
    }
});
const $37fff4366474b40a$export$bfcc41199ff04884 = (nodeTypesToCreate, nodeWithTargetFragment)=>{
    try {
        return !!nodeTypesToCreate.every((nodeTypeToCreate)=>nodeTypeToCreate.createChecked({}, nodeWithTargetFragment));
    } catch (e) {
        return false;
    }
};
function $37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, srcNode, $destNodePos, destNode) {
    let srcNodeType = srcNode.type;
    const schema = srcNodeType.schema;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader, expand: expand, nestedExpand: nestedExpand, doc: doc, panel: panel, panel_c1: panel_c1, layoutColumn: layoutColumn, layoutSection: layoutSection } = schema.nodes;
    const destParentNodeType = destParent?.type;
    const activeNodeType = srcNode?.type;
    const layoutColumnContent = srcNode.content;
    const isNestingTablesSupported = (0, $hZ5o2.isNestedTablesSupported)(schema);
    if (activeNodeType === layoutColumn && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
        // Allow drag layout column and drop into layout section
        if (destNode?.type === layoutSection || destParentNodeType === doc) return true;
        if (destParentNodeType === tableCell || destParentNodeType === tableHeader) {
            const contentContainsExpand = (0, $bjg0G.findChildrenByType)(srcNode, expand).length > 0;
            //convert expand to nestedExpand if there are expands inside the layout column
            // otherwise, the createChecked will fail as expand is not a valid child of tableCell/tableHeader, but nestedExpand is
            const convertedFragment = contentContainsExpand ? $37fff4366474b40a$export$ca1d8e12fb5b3277(layoutColumnContent) : layoutColumnContent;
            if (!convertedFragment) return false;
            return $37fff4366474b40a$export$bfcc41199ff04884([
                tableCell,
                tableHeader
            ], convertedFragment);
        }
        if (destParentNodeType === panel || (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && destParentNodeType === panel_c1) return $37fff4366474b40a$export$bfcc41199ff04884([
            panel
        ], layoutColumnContent);
        if (destParentNodeType === expand) return $37fff4366474b40a$export$bfcc41199ff04884([
            expand
        ], layoutColumnContent);
        if (destParentNodeType === nestedExpand) return $37fff4366474b40a$export$bfcc41199ff04884([
            nestedExpand
        ], layoutColumnContent);
    }
    // NOTE: this will block drop targets from showing for dragging a table into another table
    // unless nested tables are supported and the nesting depth does not exceed 1
    if ((destParentNodeType === tableCell || destParentNodeType === tableHeader) && activeNodeType === table) {
        const nestingDepth = (0, $euISL.getParentOfTypeCount)(table)($destNodePos);
        if (!isNestingTablesSupported || isNestingTablesSupported && nestingDepth > 1) return false;
    }
    if ($37fff4366474b40a$export$199dae4875feadcd(destParent.type) && $37fff4366474b40a$export$a1d4506bfd61c0e4(srcNodeType)) {
        if ($37fff4366474b40a$export$e639988f4c2f87a3(srcNode)) srcNodeType = nestedExpand;
        else return false;
    } else if (($37fff4366474b40a$export$a528a4f84f239e18(destParent.type) || $37fff4366474b40a$export$51b69e9dc2d60fca(destParent.type)) && $37fff4366474b40a$export$174a46ad1de68ba(srcNodeType)) srcNodeType = expand;
    // Downgrade variant node (e.g. panel_c1 → panel) when dest doesn't support it
    if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
        const baseName = (0, $57Rmq.getBaseNodeTypeName)(srcNodeType);
        if (baseName !== srcNodeType.name && !destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType)) {
            const baseType = schema.nodes[baseName];
            // Check if the node's content is valid in the base type (e.g. panel with table can't be downgraded)
            if (!baseType || !baseType.validContent(srcNode.content)) return false;
            srcNodeType = baseType;
        }
    }
    return destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType);
}
function $37fff4366474b40a$export$35c44269895720b6(slice, sliceFromPos, sliceToPos, destParent, indexIntoParent, $destNodePos, destNode) {
    let canMoveNodes = true;
    const doc = $destNodePos.doc;
    const nodesPos = [];
    // Drag multiple nodes to be inside themselves not allowed
    if ($destNodePos.pos < sliceToPos && $destNodePos.pos >= sliceFromPos) return false;
    // Multiple layout columns do not drop correctly.
    if (slice.content.firstChild?.type.name === 'layoutColumn') return false;
    for(let i = 0; i < slice.content.childCount; i++){
        const node = slice.content.maybeChild(i);
        if (i === 0) nodesPos[i] = sliceFromPos;
        else nodesPos[i] = nodesPos[i - 1] + (slice.content.maybeChild(i - 1)?.nodeSize || 0);
        if (node && node.isInline) {
            // If the node is an inline node, we need to find the parent node
            // as passing in them into canMoveNodeToIndex will return false
            const $nodePos = doc.resolve(nodesPos[i]);
            const parentNode = $nodePos.parent;
            if (!parentNode || parentNode && !$37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, parentNode, $destNodePos, destNode)) {
                canMoveNodes = false;
                break;
            }
        } else if (node && !$37fff4366474b40a$export$918b4fd27bccdab5(destParent, indexIntoParent, node, $destNodePos, destNode)) {
            canMoveNodes = false;
            break;
        }
    }
    return canMoveNodes;
}
module.exports["isInsideTable"] = $37fff4366474b40a$export$199dae4875feadcd;
module.exports["isFontSizeMarkActive"] = $37fff4366474b40a$export$7787d47a1b8939d0;
module.exports["isInSameLayout"] = $37fff4366474b40a$export$9d5fcdcf2394fab8;
module.exports["transformFragmentExpandToNestedExpand"] = $37fff4366474b40a$export$ca1d8e12fb5b3277;
module.exports["transformSliceNodeType"] = $37fff4366474b40a$export$805d193712b3b932;
module.exports["transformSliceExpandToNestedExpand"] = $37fff4366474b40a$export$447e90e618548243;
module.exports["canMoveNodeToIndex"] = $37fff4366474b40a$export$918b4fd27bccdab5;
module.exports["canMoveSliceToIndex"] = $37fff4366474b40a$export$35c44269895720b6;

});

parcelRegister("1uWpr", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $haNN4 = parcelRequire("haNN4");


var $krYZG = parcelRequire("krYZG");


var $8dxef = parcelRequire("8dxef");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $i6cU6 = parcelRequire("i6cU6");


var $kAPZe = parcelRequire("kAPZe");

var $k8PFz = parcelRequire("k8PFz");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8LYsc = parcelRequire("8LYsc");


var $ixfCV = parcelRequire("ixfCV");


var $iSrRp = parcelRequire("iSrRp");


var $cDMxg = parcelRequire("cDMxg");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $9HWym = parcelRequire("9HWym");


var $3BXSc = parcelRequire("3BXSc");


var $6FQH1 = parcelRequire("6FQH1");


var $aHnsS = parcelRequire("aHnsS");


var $jWiWP = parcelRequire("jWiWP");


var $2w4SV = parcelRequire("2w4SV");


var $bOZni = parcelRequire("bOZni");


var $i2jOy = parcelRequire("i2jOy");


var $hTjcC = parcelRequire("hTjcC");


var $frZvB = parcelRequire("frZvB");


var $9BGzJ = parcelRequire("9BGzJ");


var $eYPgl = parcelRequire("eYPgl");


var $bdkuW = parcelRequire("bdkuW");


var $fKt2m = parcelRequire("fKt2m");


var $lhJQI = parcelRequire("lhJQI");

function $4a329e028fe22022$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a329e028fe22022$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $4a329e028fe22022$var$buttonWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        background: `linear-gradient(to bottom, ${"var(--ds-surface, #FFFFFF)"} 90%, transparent)`,
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        background: `linear-gradient(to bottom, ${"var(--ds-surface, #FFFFFF)"} 90%, transparent)`,
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    }
});
// EDITOR-6790 - When the `platform_editor_table_col_insert` experiment is enabled,
// drop the linear-gradient background that paints over the legacy `tr.sticky` table
// header so the new left-edge column-insert affordance is not visually clipped.
// Keep all paddings / margins identical to `buttonWrapperStyles` so the drag-handle
// layout does not shift between the two variants.
const $4a329e028fe22022$var$buttonWrapperStylesNoBackground = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    }
});
const $4a329e028fe22022$var$buttonWrapperStylesPatch = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $7Y8M5.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $7Y8M5.akEditorTableToolbarSize)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $7Y8M5.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $7Y8M5.akEditorTableToolbarSize)
    }
});
// update color to match quick insert button for new editor controls
const $4a329e028fe22022$var$dragHandleColor = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
const $4a329e028fe22022$var$dragHandleButtonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $hTjcC.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $kAPZe.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $hTjcC.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $hTjcC.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24h x 12w, Dense: 13px -> 18h x 9w, Jira: 14px -> 21h x 12w
const $4a329e028fe22022$var$dragHandleButtonScaledStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.DRAG_HANDLE_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $kAPZe.DRAG_HANDLE_WIDTH))
});
const $4a329e028fe22022$var$dragHandleButtonSmallScreenStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $4a329e028fe22022$var$dragHandleButtonStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    paddingTop: `${"var(--ds-space-025, 2px)"}`,
    paddingBottom: `${"var(--ds-space-025, 2px)"}`,
    paddingLeft: '0',
    paddingRight: '0',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $hTjcC.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $kAPZe.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $hTjcC.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $hTjcC.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
const $4a329e028fe22022$var$focusedStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $4a329e028fe22022$var$focusedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:focus-visible': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $4a329e028fe22022$var$keyboardFocusedDragHandleStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $4a329e028fe22022$var$dragHandleContainerStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    boxSizing: 'border-box'
});
const $4a329e028fe22022$var$tooltipContainerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    bottom: `-${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    position: 'sticky',
    display: 'block',
    zIndex: 100 // card = 100
});
const $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    }
});
const $4a329e028fe22022$var$tooltipContainerStylesImprovedStickyHeaderWithMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] > [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithoutMask = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $4a329e028fe22022$var$dragHandleMultiLineSelectionFixFirefox = {
    name: "ut0e3u",
    styles: "&::selection{background-color:transparent;}"
};
const $4a329e028fe22022$var$layoutColumnDragHandleStyles = {
    name: "jbgpyq",
    styles: "transform:rotate(90deg)"
};
const $4a329e028fe22022$var$selectedStyles = {
    name: "1qq3fmc",
    styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-icon-selected, #1868DB)"
};
// [Chrome only] When selection contains multiple nodes and then drag a drag handle that is within the selection range,
// icon span receives dragStart event, instead of button, and since it is not registered as a draggable element
// with pragmatic DnD and pragmatic DnD is not triggered
const $4a329e028fe22022$var$handleIconDragStart = (e)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    if (!browser.chrome) return;
    // prevent dragStart handler triggered by icon
    e.stopPropagation();
    const dragEvent = new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: e.dataTransfer
    });
    if (e.target instanceof HTMLElement) // re-dispatch drag event on button so that pragmatic DnD can be triggered properly
    e.target.closest('button')?.dispatchEvent(dragEvent);
};
const $4a329e028fe22022$var$getNodeSpacingForPreview = (node)=>{
    if (!node) return (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.spacingBetweenNodesForPreview)[`heading${node.attrs.level}`] || (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
    return (0, $hTjcC.spacingBetweenNodesForPreview)[nodeTypeName] || (0, $hTjcC.spacingBetweenNodesForPreview)['default'];
};
const $4a329e028fe22022$var$getNodeMargins = (node)=>{
    if (!node) return (0, $hTjcC.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $hTjcC.nodeMargins)[`heading${node.attrs.level}`] || (0, $hTjcC.nodeMargins)['default'];
    return (0, $hTjcC.nodeMargins)[nodeTypeName] || (0, $hTjcC.nodeMargins)['default'];
};
// Kill switch OFF: omit `isOpen` so the reducer toggles per clicked column. ON: keep
// `isOpen: true` for legacy always-open. Centralised so all dispatch sites stay in sync.
const $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta = (anchorPos, openedViaKeyboard)=>({
        anchorPos: anchorPos,
        ...(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1') ? {
            isOpen: true
        } : {},
        openedViaKeyboard: openedViaKeyboard
    });
const $4a329e028fe22022$export$a0c24614540b0efb = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode = true, anchorRectCache: anchorRectCache })=>{
    const buttonRef = (0, $cozmU.useRef)(null);
    const mouseDownRef = (0, $cozmU.useRef)(false);
    const [dragHandleSelected, setDragHandleSelected] = (0, $cozmU.useState)(false);
    const [dragHandleDisabled, setDragHandleDisabled] = (0, $cozmU.useState)(false);
    const [blockCardWidth, setBlockCardWidth] = (0, $cozmU.useState)(768);
    const [positionStylesOld, setPositionStylesOld] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Tracks whether the initial position calculation has been performed at least once.
    // The reliable-anchor early-return optimisation must not fire before the first calculation,
    // otherwise positionStylesOld stays as { display: 'none' } and the handle is never shown.
    const hasCalculatedInitialPosition = (0, $cozmU.useRef)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(Boolean(handleOptions?.isFocused));
    const { macroInteractionUpdates: macroInteractionUpdates, selection: selection, isShiftDown: isShiftDown, interactionState: interactionState, currentUserIntent: currentUserIntent } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'selection',
        'blockControls',
        'interaction',
        'userIntent'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates,
            selection: states.selectionState?.selection,
            isShiftDown: states.blockControlsState?.isShiftDown,
            interactionState: states.interactionState?.interactionState,
            currentUserIntent: states.userIntentState?.currentUserIntent
        }));
    const start = getPos();
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Dynamically calculate if node is top-level based on current position (gated by experiment)
    const isTopLevelNodeDynamic = (0, $cozmU.useMemo)(()=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true)) return isTopLevelNode;
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            return $pos?.parent.type.name === 'doc';
        }
        return true;
    }, [
        getPos,
        view.state.doc,
        isTopLevelNode
    ]);
    // Use the dynamic value when experiment is on, otherwise use the prop
    // When cleaning up the experiment, you can safely remove the isTopLevelNode as an prop and
    // just rely on the dynamic value (rename it to isTopLevelNode for simplicitiy)
    const isTopLevelNodeValue = (0, $ieeJu.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true) ? isTopLevelNodeDynamic : isTopLevelNode;
    (0, $cozmU.useEffect)(()=>{
        // blockCard/datasource width is rendered correctly after this decoraton does. We need to observe for changes.
        if (nodeType === 'blockCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            const container = dom?.querySelector('.datasourceView-content-inner-wrap');
            if (container) {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const width = entries[0].contentBoxSize[0].inlineSize;
                    setBlockCardWidth(width);
                });
                resizeObserver.observe(container);
                return ()=>resizeObserver.unobserve(container);
            }
        }
    }, [
        anchorName,
        nodeType,
        view.dom
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) return;
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'mouseUp',
            listener: ()=>mouseDownRef.current = false
        });
        return ()=>unbind();
    }, []);
    const handleMouseDown = (0, $cozmU.useCallback)(()=>{
        mouseDownRef.current = true;
    }, []);
    const handleMouseUp = (0, $cozmU.useCallback)((e)=>{
        // Stop propagation so that for drag handles in nested scenarios the click is captured
        // and doesn't propagate to the edge of the element and trigger a node selection
        // on the parent element
        if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) e.stopPropagation();
        // Fixes bug where selection toolbar is blocked when mouse is released on drag handle
        if (mouseDownRef.current) e.stopPropagation();
    }, []);
    const handleOnClickNew = (0, $cozmU.useCallback)((e)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn' && (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) tr.setMeta('toggleLayoutColumnMenu', $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta(startPos, false));
            const resolvedStartPos = tr.doc.resolve(startPos);
            const selection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection || tr.selection;
            api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeTypes: resolvedStartPos.nodeAfter?.type.name || ''
                }
            })(tr);
            (0, $2w4SV.expandAndUpdateSelection)({
                tr: tr,
                selection: selection,
                startPos: startPos,
                isShiftPressed: e.shiftKey,
                nodeType: nodeType,
                api: api
            });
            api?.blockControls?.commands.startPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands.toggleBlockMenu({
                anchorName: anchorName,
                openedViaKeyboard: false,
                triggerByNode: (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                } : undefined
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        api,
        view,
        getPos,
        nodeType,
        anchorName
    ]);
    const handleOnClick = (0, $cozmU.useCallback)((e)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn' && (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) tr.setMeta('toggleLayoutColumnMenu', $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta(startPos, false));
            const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
            const $anchor = mSelect?.anchor !== undefined ? tr.doc.resolve(mSelect?.anchor) : tr.selection.$anchor;
            if (tr.selection.empty || !e.shiftKey) tr = (0, $bOZni.selectNode)(tr, startPos, nodeType, api);
            else if (isTopLevelNodeValue && $anchor.depth <= (0, $hTjcC.DRAG_HANDLE_MAX_SHIFT_CLICK_DEPTH) && e.shiftKey && (0, $ixfCV.fg)('platform_editor_elements_dnd_shift_click_select')) {
                const alignAnchorHeadToSel = (0, $i2jOy.alignAnchorHeadInDirectionOfPos)(tr.selection, startPos);
                const selectionWithExpandedHead = (0, $i2jOy.expandSelectionHeadToNodeAtPos)(alignAnchorHeadToSel, startPos);
                tr.setSelection(selectionWithExpandedHead);
                api?.blockControls?.commands.setMultiSelectPositions()({
                    tr: tr
                });
            }
            const resolvedMovingNode = tr.doc.resolve(startPos);
            const maybeNode = resolvedMovingNode.nodeAfter;
            tr.setMeta('scrollIntoView', false);
            api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedMovingNode.depth,
                    nodeTypes: maybeNode?.type.name || ''
                }
            })(tr);
            return tr;
        });
        view.focus();
    }, [
        api,
        view,
        getPos,
        isTopLevelNodeValue,
        nodeType
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (!e.repeat && e.key === ' ') {
            const startPos = getPos();
            api?.core?.actions.execute(({ tr: tr })=>{
                if (startPos === undefined) return tr;
                const node = tr.doc.nodeAt(startPos);
                if (!node) return tr;
                const $startPos = tr.doc.resolve(startPos + node.nodeSize);
                const selection = new (0, $kCECX.TextSelection)($startPos);
                tr.setSelection(selection);
                return tr;
            });
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api?.core?.actions,
        view
    ]);
    const handleKeyDownNew = (0, $cozmU.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (e.key === 'Enter' || !e.repeat && e.key === ' ') {
            if ((0, $haNN4.getDocument)()?.activeElement !== buttonRef.current) return;
            e.preventDefault();
            e.stopPropagation();
            const startPos = getPos();
            api?.core?.actions.execute(({ tr: tr })=>{
                if (startPos === undefined) return tr;
                const selection = (0, $6FQH1.selectionPreservationPluginKey).getState(view.state)?.preservedSelection || tr.selection;
                (0, $2w4SV.expandAndUpdateSelection)({
                    tr: tr,
                    selection: selection,
                    startPos: startPos,
                    isShiftPressed: e.shiftKey,
                    nodeType: nodeType,
                    api: api
                });
                api?.blockControls?.commands.startPreservingSelection()({
                    tr: tr
                });
                if (nodeType === 'layoutColumn' && (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true)) tr.setMeta('toggleLayoutColumnMenu', $4a329e028fe22022$var$buildToggleLayoutColumnMenuMeta(startPos, true));
                const rootPos = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? tr.doc.resolve(startPos).before(1) : undefined;
                const triggerByNode = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: rootPos
                } : undefined;
                api?.blockControls?.commands.toggleBlockMenu({
                    anchorName: anchorName,
                    triggerByNode: triggerByNode,
                    openedViaKeyboard: true
                })({
                    tr: tr
                });
                api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen')({
                    tr: tr
                });
                return tr;
            });
            view.focus();
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api,
        nodeType,
        anchorName,
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element) return;
        return (0, $iSrRp.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                api?.core?.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    const newHandlePosCheck = (0, $bOZni.isHandleCorrelatedToSelection)(view.state, tr.selection, handlePos);
                    if (!tr.selection.empty && newHandlePosCheck) api?.blockControls?.commands.setMultiSelectPositions()({
                        tr: tr
                    });
                    else tr = (0, $bOZni.selectNode)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const state = view.state;
                const { doc: doc, selection: selection } = state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                if (mSelect) {
                    const { anchor: anchor, head: head } = mSelect;
                    sliceFrom = Math.min(anchor, head);
                    sliceTo = Math.max(anchor, head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultiLine = startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $cDMxg.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultiLine) return {
                            x: 0,
                            y: 0
                        };
                        else {
                            // Calculate the offset of the preview container,
                            // So when drag multiple nodes, the preview align with the position of the selected nodes
                            const domAtPos = view.domAtPos.bind(view);
                            let domElementsHeightBeforeHandle = 0;
                            const nodesStartPos = [];
                            const nodesEndPos = [];
                            let activeNodeMarginTop = 0;
                            for(let i = 0; i < expandedSlice.content.childCount; i++){
                                if (i === 0) {
                                    nodesStartPos[i] = sliceFrom;
                                    nodesEndPos[i] = sliceFrom + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                } else {
                                    nodesStartPos[i] = nodesEndPos[i - 1];
                                    nodesEndPos[i] = nodesStartPos[i] + (expandedSlice.content.maybeChild(i)?.nodeSize || 0);
                                }
                                // when the node is before the handle, calculate the height of the node
                                if (nodesEndPos[i] <= startPos) {
                                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                                    const currentNodeElement = (0, $bjg0G.findDomRefAtPos)(nodesStartPos[i], domAtPos);
                                    const maybeCurrentNode = expandedSlice.content.maybeChild(i);
                                    const currentNodeSpacing = maybeCurrentNode ? $4a329e028fe22022$var$getNodeMargins(maybeCurrentNode).top + $4a329e028fe22022$var$getNodeMargins(maybeCurrentNode).bottom : 0;
                                    domElementsHeightBeforeHandle = domElementsHeightBeforeHandle + currentNodeElement.offsetHeight + currentNodeSpacing;
                                } else {
                                    // when the node is after the handle, calculate the top margin of the active node
                                    const maybeNextNode = expandedSlice.content.maybeChild(i);
                                    activeNodeMarginTop = maybeNextNode ? $4a329e028fe22022$var$getNodeMargins(maybeNextNode).top : 0;
                                    break;
                                }
                            }
                            return {
                                x: 0,
                                y: domElementsHeightBeforeHandle + activeNodeMarginTop
                            };
                        }
                    },
                    render: ({ container: container })=>{
                        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
                        if (!dom) return;
                        if (!isDraggingMultiLine) return (0, $9BGzJ.dragPreview)(container, {
                            dom: dom,
                            nodeType: nodeType
                        });
                        else {
                            const domAtPos = view.domAtPos.bind(view);
                            const previewContent = [];
                            expandedSlice.content.descendants((node, pos)=>{
                                // Get the dom element of the node
                                //eslint-disable-next-line @atlaskit/editor/no-as-casting
                                const nodeDomElement = (0, $bjg0G.findDomRefAtPos)(sliceFrom + pos, domAtPos);
                                const currentNodeSpacing = $4a329e028fe22022$var$getNodeSpacingForPreview(node);
                                previewContent.push({
                                    dom: nodeDomElement,
                                    nodeType: node.type.name,
                                    nodeSpacing: currentNodeSpacing
                                });
                                return false; // Only iterate through the first level of nodes
                            });
                            return (0, $9BGzJ.dragPreview)(container, previewContent);
                        }
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart () {
                if (start === undefined) return;
                api?.core?.actions.execute(({ tr: tr })=>{
                    let nodeTypes, hasSelectedMultipleNodes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const maybeNode = resolvedMovingNode.nodeAfter;
                    const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
                    if (mSelect) {
                        const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, mSelect.anchor, mSelect.head);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    } else {
                        nodeTypes = maybeNode?.type.name;
                        hasSelectedMultipleNodes = false;
                    }
                    api?.blockControls?.commands.setNodeDragged(getPos, anchorName, nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api?.analytics?.actions.attachAnalyticsEvent({
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        action: (0, $krYZG.ACTION).DRAGGED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        anchorName,
        api,
        getPos,
        nodeType,
        start,
        view
    ]);
    const calculatePositionOld = (0, $cozmU.useCallback)(()=>{
        const pos = getPos();
        const $pos = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? typeof pos === 'number' && view.state.doc.resolve(pos) : pos && view.state.doc.resolve(pos);
        const parentPos = $pos && $pos.depth ? $pos.before() : undefined;
        const node = parentPos !== undefined ? view.state.doc.nodeAt(parentPos) : undefined;
        const parentNodeType = node?.type.name;
        const supportsAnchor = CSS.supports('top', `anchor(${anchorName} start)`) && CSS.supports('left', `anchor(${anchorName} start)`);
        const safeAnchorName = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: anchorName
        }) : anchorName;
        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: since the node decoration sets data-active-drag-handle on the
        // active node, we check for it directly. This is a cheap DOM attribute read (no reflow,
        // no style recalculation) and hides the control if the decoration hasn't been applied yet.
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !dom?.hasAttribute((0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR))) return {
            display: 'none'
        };
        const hasResizer = nodeType === 'table' || nodeType === 'mediaSingle';
        const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension' || nodeType === 'multiBodiedExtension' && (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension');
        const isBlockCard = nodeType === 'blockCard' && !!blockCardWidth;
        const isEmbedCard = nodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $jWiWP.shouldBeSticky)(nodeType);
        if (supportsAnchor) {
            const bottom = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $jWiWP.getControlBottomCSSValue)(safeAnchorName, isSticky, isTopLevelNodeValue, isLayoutColumn) : {};
            return {
                left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $fqVYq.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc((anchor(${safeAnchorName} right) + anchor(${safeAnchorName} left))/2 - ${(0, $hTjcC.DRAG_HANDLE_HEIGHT) / 2}px)` : `calc(anchor(${safeAnchorName} start) - ${0, $kAPZe.DRAG_HANDLE_WIDTH}px - ${(0, $hTjcC.dragHandleGap)(nodeType, parentNodeType)}px)`,
                top: (0, $fqVYq.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc(anchor(${safeAnchorName} top) - ${0, $kAPZe.DRAG_HANDLE_WIDTH}px)` : `calc(anchor(${safeAnchorName} start) + ${(0, $hTjcC.topPositionAdjustment)((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? $pos && $pos.nodeAfter && (0, $9HWym.getNodeTypeWithLevel)($pos.nodeAfter) || nodeType : nodeType, dom?.getAttribute('layout') || '')}px)`,
                ...bottom
            };
        }
        const height = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $jWiWP.getControlHeightCSSValue)((0, $jWiWP.getNodeHeight)(dom, safeAnchorName, anchorRectCache) || 0, isSticky, isTopLevelNodeValue, `${(0, $hTjcC.DRAG_HANDLE_HEIGHT)}`, isLayoutColumn) : {};
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $jWiWP.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType),
            top: (0, $jWiWP.getTopPosition)(dom, nodeType),
            ...height
        };
    }, [
        anchorName,
        getPos,
        view,
        nodeType,
        blockCardWidth,
        macroInteractionUpdates,
        anchorRectCache,
        isTopLevelNodeValue,
        isLayoutColumn
    ]);
    const isReliableAnchorEnabled = (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true);
    const docDepForReliableAnchor = isReliableAnchorEnabled ? view.state.doc : undefined;
    // Effect 1 (reliable-anchor ON): fires when non-doc deps change (e.g. blockCardWidth,
    // anchorRectCache, macroInteractionUpdates, isTopLevelNodeValue, isLayoutColumn via
    // calculatePositionOld) — always recalculates without the doc guard, so non-doc position
    // changes are never incorrectly skipped.
    (0, $cozmU.useEffect)(()=>{
        if (!isReliableAnchorEnabled) return;
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType
    ]);
    // Effect 2 (reliable-anchor ON): fires when the doc changes — carries the DOM-attribute
    // guard to skip recalc when a drag handle is active (pure keystroke during drag).
    // Effect (reliable-anchor OFF): single combined effect, original behaviour.
    (0, $cozmU.useEffect)(()=>{
        if (isReliableAnchorEnabled) {
            // Doc-change only effect: apply the DOM-attribute guard.
            // React's dep comparison already ensures this only runs when docDepForReliableAnchor
            // (i.e. view.state.doc) changed, so no manual ref tracking is needed.
            if (!hasCalculatedInitialPosition.current) return;
            const calcPos = requestAnimationFrame(()=>{
                const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
                if (dom?.hasAttribute((0, $hTjcC.ACTIVE_DRAG_HANDLE_ATTR))) return;
                setPositionStylesOld(calculatePositionOld());
            });
            return ()=>{
                cancelAnimationFrame(calcPos);
            };
        }
        // reliable-anchor OFF: original single-effect behaviour (no guard).
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType,
        docDepForReliableAnchor
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (handleOptions?.isFocused && buttonRef.current) {
            const id = requestAnimationFrame(()=>{
                buttonRef.current?.focus();
            });
            return ()=>{
                cancelAnimationFrame(id);
                view.focus();
            };
        }
    }, [
        buttonRef,
        handleOptions?.isFocused,
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (typeof start !== 'number' || !selection) return;
        setDragHandleSelected((0, $bOZni.isHandleCorrelatedToSelection)(view.state, selection, start));
    }, [
        start,
        selection,
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isShiftDown === undefined || view.state.selection.empty || !(0, $ixfCV.fg)('platform_editor_elements_dnd_shift_click_select')) return;
        const mSelect = api?.blockControls.sharedState.currentState()?.multiSelectDnD;
        const $anchor = mSelect?.anchor !== undefined ? view.state.doc.resolve(mSelect?.anchor) : view.state.selection.$anchor;
        const isLayoutColumnMenuEnabled = (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
        if (isShiftDown && !(isLayoutColumnMenuEnabled && isLayoutColumn) && (!isTopLevelNodeValue || isTopLevelNodeValue && $anchor.depth > (0, $hTjcC.DRAG_HANDLE_MAX_SHIFT_CLICK_DEPTH))) setDragHandleDisabled(true);
        else setDragHandleDisabled(false);
    }, [
        api?.blockControls?.sharedState,
        isLayoutColumn,
        isShiftDown,
        isTopLevelNodeValue,
        view
    ]);
    const dragHandleMessage = (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
        br: /*#__PURE__*/ (0, $lOiVq.jsx)("br", null)
    }) : formatMessage((0, $i6cU6.messages).dragToMove);
    // Create a string version for aria-label
    const dragHandleAriaLabel = (0, $ieeJu.expValEquals)('platform_editor_block_menu', 'isEnabled', true) ? formatMessage((0, $i6cU6.messages).dragToMoveClickToOpen, {
        br: ' '
    }) : formatMessage((0, $i6cU6.messages).dragToMove);
    let helpDescriptors = isTopLevelNodeValue ? [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveLeft),
            keymap: (0, $ldqjS.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveRight),
            keymap: (0, $ldqjS.dragToMoveRight)
        }
    ] : [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        }
    ];
    let isParentNodeOfTypeLayout;
    if (!isTopLevelNodeValue) {
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            isParentNodeOfTypeLayout = $pos?.parent?.type.name === 'layoutColumn';
        }
        if (isParentNodeOfTypeLayout) helpDescriptors = [
            ...helpDescriptors,
            {
                description: formatMessage((0, $i6cU6.messages).moveLeft),
                keymap: (0, $ldqjS.dragToMoveLeft)
            },
            {
                description: formatMessage((0, $i6cU6.messages).moveRight),
                keymap: (0, $ldqjS.dragToMoveRight)
            }
        ];
    }
    // When advanced layout is on, layout column drag handle show only show 'Drag to move', no shortcuts
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true) && nodeType === 'layoutColumn') helpDescriptors = [
        {
            description: formatMessage((0, $i6cU6.messages).dragToRearrange)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveUp),
            keymap: (0, $ldqjS.dragToMoveUp)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveDown),
            keymap: (0, $ldqjS.dragToMoveDown)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveLeft),
            keymap: (0, $ldqjS.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $i6cU6.messages).moveRight),
            keymap: (0, $ldqjS.dragToMoveRight)
        }
    ];
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) helpDescriptors = [
        {
            description: dragHandleMessage
        }
    ];
    const message = helpDescriptors.map((descriptor)=>{
        return descriptor.keymap ? [
            descriptor.description,
            (0, $ldqjS.getAriaKeyshortcuts)(descriptor.keymap)
        ] : [
            descriptor.description
        ];
    }).join('. ');
    const handleOnDrop = (event)=>{
        event.stopPropagation();
    };
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    const browser = (0, $8dxef.getBrowserInfo)();
    const renderButton = ()=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
            type: "button",
            css: [
                (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? $4a329e028fe22022$var$dragHandleButtonStyles : $4a329e028fe22022$var$dragHandleButtonStylesOld,
                (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && $4a329e028fe22022$var$dragHandleColor,
                // ED-26266: Fixed the drag handle highlight when selecting multiple line in Firefox
                // See https://product-fabric.atlassian.net/browse/ED-26266
                browser.gecko && $4a329e028fe22022$var$dragHandleMultiLineSelectionFixFirefox,
                (0, $fqVYq.editorExperiment)('advanced_layouts', true) && isLayoutColumn && $4a329e028fe22022$var$layoutColumnDragHandleStyles,
                dragHandleSelected && hasHadInteraction && $4a329e028fe22022$var$selectedStyles,
                (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') && $4a329e028fe22022$var$dragHandleButtonSmallScreenStyles,
                (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) && isFocused && $4a329e028fe22022$var$keyboardFocusedDragHandleStyles,
                (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? $4a329e028fe22022$var$focusedStyles : $4a329e028fe22022$var$focusedStylesOld,
                $4a329e028fe22022$var$dragHandleButtonScaledStyles
            ],
            ref: buttonRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? positionStylesOld : {},
            onMouseDown: (0, $anBbz.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true) ? handleMouseDown : undefined,
            onMouseUp: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? handleMouseUp : undefined,
            onClick: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? handleOnClickNew : handleOnClick,
            onKeyDown: (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? handleKeyDownNew : handleKeyDown,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDrop: handleOnDrop,
            disabled: dragHandleDisabled,
            "data-editor-block-ctrl-drag-handle": true,
            "data-blocks-drag-handle": (0, $ixfCV.fg)('confluence_remix_button_right_side_block_fg') || undefined,
            "data-testid": "block-ctrl-drag-handle",
            "aria-label": dragHandleAriaLabel,
            onBlur: ()=>{
                if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) setIsFocused(false);
                if ((0, $ieeJu.expValEquals)('platform_editor_drag_handle_keyboard_a11y', 'isEnabled', true)) {
                    const pos = getPos();
                    if (pos !== undefined) api?.core?.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $3BXSc.key), {
                            activeNode: {
                                pos: pos,
                                anchorName: anchorName,
                                nodeType: nodeType,
                                handleOptions: {
                                    isFocused: false
                                }
                            }
                        });
                        return tr;
                    });
                }
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
            xcss: $4a329e028fe22022$var$iconWrapperStyles,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: $4a329e028fe22022$var$handleIconDragStart
        }, (0, $eYPgl.shouldUseNestedDragHandleIcon)(isTopLevelNodeValue, isLayoutColumn) ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $frZvB.DragHandleNestedIcon), null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            spacing: "spacious",
            label: "",
            size: "small"
        })));
    const stickyWithTooltip = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: positionStylesOld,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $4a329e028fe22022$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                $4a329e028fe22022$var$tooltipContainerStyles,
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && ((0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_6') ? $4a329e028fe22022$var$tooltipContainerStylesImprovedStickyHeaderWithMask : $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithMask),
                !(0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            position: 'top',
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && // EDITOR-6790 - drop the masking background under the new
                // column-insert experiment so the left-edge dot is not clipped.
                ((0, $ieeJu.expValEquals)('platform_editor_table_col_insert', 'isEnabled', true) ? $4a329e028fe22022$var$buttonWrapperStylesNoBackground : $4a329e028fe22022$var$buttonWrapperStyles),
                $4a329e028fe22022$var$buttonWrapperStylesPatch
            ]
        }, renderButton()))));
    const stickyWithoutTooltip = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: positionStylesOld,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $4a329e028fe22022$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                $4a329e028fe22022$var$tooltipContainerStyles,
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithMask,
                !(0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $4a329e028fe22022$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                (0, $jWiWP.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && // EDITOR-6790 - drop the masking background under the new
                // column-insert experiment so the left-edge dot is not clipped.
                ((0, $ieeJu.expValEquals)('platform_editor_table_col_insert', 'isEnabled', true) ? $4a329e028fe22022$var$buttonWrapperStylesNoBackground : $4a329e028fe22022$var$buttonWrapperStyles),
                $4a329e028fe22022$var$buttonWrapperStylesPatch
            ]
        }, renderButton())));
    const buttonWithTooltip = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                api?.accessibilityUtils?.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, renderButton());
    const tooltipContent = isLayoutColumn && (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true) && currentUserIntent === 'layoutColumnMenuPopupOpen' ? null : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.TooltipContentWithMultipleShortcuts), {
        helpDescriptors: helpDescriptors
    });
    const isTooltip = !dragHandleDisabled;
    const stickyRender = isTooltip ? stickyWithTooltip() : stickyWithoutTooltip();
    const render = isTooltip ? buttonWithTooltip() : renderButton();
    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? stickyRender : render;
};
const $4a329e028fe22022$export$c3c91925cdbf4b0b = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false
        })).rightSideControlsEnabled;
    // Layout column drag handles sit at the top-centre of each column, not on a left/right edge.
    // Don't restrict by hoverSide for layout columns — the drag handle should always be visible
    // when hovering anywhere over the column, regardless of which side of the layoutSection the
    // column is on. (The right-side remix button is a separate node decoration and is unaffected.)
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Skip the right-side controlSide restriction for non-top-level nodes. The restriction exists
    // to avoid showing the drag handle and remix button simultaneously — but remix only applies to
    // top-level nodes, so non-top-level nodes should never be restricted.
    // Gated behind platform_editor_controls_reliable_anchor.
    const skipControlSideRestriction = (0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && isTopLevelNode === false;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: !isLayoutColumn && !skipControlSideRestriction && rightSideControlsEnabled ? 'left' : undefined,
        forceVisibleOnMouseOut: (0, $ieeJu.expValEquals)('platform_editor_drag_handle_keyboard_a11y', 'isEnabled', true) && !!handleOptions?.isFocused
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($4a329e028fe22022$export$a0c24614540b0efb, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        anchorName: anchorName,
        nodeType: nodeType,
        handleOptions: handleOptions,
        isTopLevelNode: isTopLevelNode,
        anchorRectCache: anchorRectCache
    }));
};
module.exports["DragHandle"] = $4a329e028fe22022$export$a0c24614540b0efb;
module.exports["DragHandleWithVisibility"] = $4a329e028fe22022$export$c3c91925cdbf4b0b;

});

parcelRegister("a2W6S", function(module, exports) {
/** True when `mark` has an equal counterpart (type + attrs) in `marks`. */ const $45d5967a4988fece$var$hasMatchingMark = (mark, marks)=>{
    const found = mark.type.isInSet(marks);
    return !!found && mark.eq(found);
};
const $45d5967a4988fece$export$53f82211cca2767d = (state, pos, supportedMarkTypes)=>{
    const resolvedPos = state.doc.resolve(pos);
    const validMarkTypes = supportedMarkTypes.filter(Boolean);
    const supportedMarks = resolvedPos.marks().filter((mark)=>validMarkTypes.includes(mark.type));
    if (supportedMarks.length === 0) return [];
    const { nodeAfter: nodeAfter, nodeBefore: nodeBefore } = resolvedPos;
    const nextMarks = nodeAfter?.marks ?? [];
    const prevMarks = nodeBefore?.marks ?? [];
    const nextSupported = nextMarks.filter((m)=>validMarkTypes.includes(m.type));
    const allMatchNext = supportedMarks.every((m)=>$45d5967a4988fece$var$hasMatchingMark(m, nextMarks));
    // First node — no previous sibling to compare against.
    if (!nodeBefore) return nextSupported.length === supportedMarks.length && allMatchNext ? supportedMarks : [];
    // `supportedMarks` already comes from `nodeBefore` (via resolvedPos.marks()).
    // Compare counts to guard against extra supported marks on either side.
    const prevSupported = prevMarks.filter((m)=>validMarkTypes.includes(m.type));
    return prevSupported.length === nextSupported.length && allMatchNext ? supportedMarks : [];
};
module.exports["getMatchingBlockMarks"] = $45d5967a4988fece$export$53f82211cca2767d;

});

parcelRegister("64pwY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $57Rmq = parcelRequire("57Rmq");


var $vZEJe = parcelRequire("vZEJe");


var $iSrRp = parcelRequire("iSrRp");


var $jp2Q3 = parcelRequire("jp2Q3");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $4LOJc = parcelRequire("4LOJc");


var $hTjcC = parcelRequire("hTjcC");


var $fmErs = parcelRequire("fmErs");

function $17032211a95616ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH = 760;
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH = '--editor-block-controls-drop-indicator-width';
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN = '--editor-block-controls-drop-target-leftMargin';
const $17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX = '--editor-block-controls-drop-target-zindex';
const $17032211a95616ca$export$b172475a7115c36a = '--editor-block-controls-drop-indicator-offset';
const $17032211a95616ca$export$d522271cd3bfae1d = '--editor-block-controls-drop-indicator-gap';
const $17032211a95616ca$var$styleDropTarget = /*#__PURE__*/ (0, $lOiVq.css)({
    marginLeft: `calc(-1 * var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0))`,
    paddingLeft: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0)`,
    position: 'absolute',
    left: '0',
    display: 'block',
    zIndex: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX}, 110)`,
    transform: `translateY(var(${$17032211a95616ca$export$b172475a7115c36a}, 0))`
});
const $17032211a95616ca$var$styleDropIndicator = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    margin: '0 auto',
    position: 'relative',
    width: `var(${$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH}, 100%)`,
    display: 'none'
});
const $17032211a95616ca$var$styleDropIndicatorVisible = {
    name: "4zleql",
    styles: "display:block"
};
const $17032211a95616ca$var$nestedDropIndicatorStyle = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $17032211a95616ca$var$dropZoneStyles = {
    name: "y3ufic",
    styles: "margin:0;position:absolute;width:100%;z-index:110;min-height:4px"
};
const $17032211a95616ca$var$nestedDropZoneStyle = {
    name: "1h4fcj3",
    styles: "left:4px;right:4px;width:unset"
};
const $17032211a95616ca$var$enableDropZoneNext = [
    'paragraph',
    'mediaSingle',
    'heading',
    'codeBlock',
    'decisionList',
    'bulletList',
    'orderedList',
    'taskList',
    'extension',
    'blockCard',
    'syncBlock'
];
const $17032211a95616ca$var$getEnableDropZone = ()=>{
    return $17032211a95616ca$var$enableDropZoneNext;
};
// This z index is used in container like layout
const $17032211a95616ca$var$fullHeightStyleAdjustZIndexStyle = {
    name: "125wnaz",
    styles: "z-index:0"
};
const $17032211a95616ca$var$HoverZone = ({ onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop, node: node, pos: pos, parent: parent, editorWidth: editorWidth, anchorRectCache: anchorRectCache, position: position, isNestedDropTarget: isNestedDropTarget, dropTargetStyle: dropTargetStyle, api: api })=>{
    const ref = (0, $cozmU.useRef)(null);
    const isRemainingheight = dropTargetStyle === 'remainingHeight';
    const anchorName = (0, $cozmU.useMemo)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            if (node && typeof pos === 'number') {
                const posOffset = position === 'upper' ? -node.nodeSize : 0;
                return api?.core.actions.getAnchorIdForNode(node, pos + posOffset) || '';
            }
            return '';
        }
        return node ? (0, $9HWym.getNodeAnchor)(node) : '';
    }, [
        api,
        node,
        pos,
        position
    ]);
    const [_isActive, setActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const isInsideBodiedSyncBlock = parent && parent.type.name === 'bodiedSyncBlock' && (0, $fqVYq.editorExperiment)('platform_synced_block', true);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $iSrRp.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                if ((!isNestedDropTarget || isInsideBodiedSyncBlock) && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) setActiveAnchor();
                onDragEnter();
            },
            onDragLeave: onDragLeave,
            onDrop: onDrop
        });
    }, [
        isNestedDropTarget,
        isInsideBodiedSyncBlock,
        onDragEnter,
        onDragLeave,
        onDrop,
        setActiveAnchor
    ]);
    const hoverZoneUpperStyle = (0, $cozmU.useMemo)(()=>{
        const heightStyleOffset = `var(--editor-block-controls-drop-indicator-gap, 0)/2`;
        const transformOffset = `var(${$17032211a95616ca$export$b172475a7115c36a}, 0)`;
        const heightStyle = anchorName && $17032211a95616ca$var$getEnableDropZone().includes(node?.type.name || '') ? (0, $a4QVD.isAnchorSupported)() ? `calc(anchor-size(${anchorName} height)/2 + ${heightStyleOffset})` : `calc(${(anchorRectCache?.getHeight(anchorName) || 0) / 2}px + ${heightStyleOffset})` : '4px';
        const transform = position === 'upper' ? `translateY(calc(-100% + ${transformOffset}))` : `translateY(${transformOffset})`;
        return /*#__PURE__*/ (0, $lOiVq.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: heightStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            transform: transform,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${editorWidth || 0}px`
        });
    }, [
        anchorName,
        anchorRectCache,
        editorWidth,
        node?.type.name,
        position
    ]);
    /**
   * 1. Above the last empty line
   * 2. Below the last element
   *
   * Both cases will take the remaining height of the the container
   */ const heightStyle = (0, $cozmU.useMemo)(()=>{
        // only apply upper drop zone
        if (isRemainingheight && position === 'upper') {
            // previous node
            const anchorName = node ? (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? api?.core.actions.getAnchorIdForNode(node, pos || -1) || '' : (0, $9HWym.getNodeAnchor)(node) : '';
            let top = 'unset';
            if (anchorName) {
                const enabledDropZone = $17032211a95616ca$var$getEnableDropZone().includes(node?.type.name || '');
                if ((0, $a4QVD.isAnchorSupported)()) top = enabledDropZone ? `calc(anchor(${anchorName} 50%))` : `calc(anchor(${anchorName} bottom) - 4px)`;
                else if (anchorRectCache) {
                    const preNodeTopPos = anchorRectCache.getTop(anchorName) || 0;
                    const prevNodeHeight = anchorRectCache.getHeight(anchorName) || 0;
                    top = enabledDropZone ? `calc(${preNodeTopPos}px + ${prevNodeHeight / 2}px)` : `calc(${preNodeTopPos}px + ${prevNodeHeight}px - 4px)`;
                } else // Should not happen
                return null;
            } else // first empty paragraph
            top = '4px';
            return /*#__PURE__*/ (0, $lOiVq.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                top: top,
                bottom: '4px',
                height: 'unset',
                zIndex: 10,
                transform: 'none'
            });
        }
        return null;
    }, [
        anchorRectCache,
        api,
        isRemainingheight,
        node,
        pos,
        position
    ]);
    const isFullHeightInLayout = isRemainingheight && parent?.type.name === 'layoutColumn';
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `drop-target-hover-zone-${position}`,
        "data-testid": `drop-target-zone-${position}`,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $17032211a95616ca$var$dropZoneStyles,
            isNestedDropTarget && $17032211a95616ca$var$nestedDropZoneStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            hoverZoneUpperStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            heightStyle,
            isFullHeightInLayout && $17032211a95616ca$var$fullHeightStyleAdjustZIndexStyle
        ]
    });
};
const $17032211a95616ca$export$79660a248b11010 = (props)=>{
    const { api: api, getPos: getPos, prevNode: prevNode, nextNode: nextNode, parentNode: parentNode, formatMessage: formatMessage, anchorRectCache: anchorRectCache, dropTargetStyle: dropTargetStyle = 'default', isSameLayout: isSameLayout } = props;
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const { lineLength: lineLength } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>({
            lineLength: states.widthState?.lineLength || $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH
        }));
    const isNestedDropTarget = parentNode?.type.name !== 'doc';
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = ()=>{
        if (!activeNode) return;
        const pos = getPos();
        if (activeNode && pos !== undefined) {
            const { pos: start } = activeNode;
            api?.core?.actions.execute(api?.blockControls?.commands?.moveNode(start, pos, undefined, formatMessage));
        }
    };
    const dynamicStyle = {
        width: isNestedDropTarget ? 'unset' : '100%',
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH]: isNestedDropTarget ? '100%' : `${lineLength || $17032211a95616ca$var$DEFAULT_DROP_INDICATOR_WIDTH}px`,
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN]: isNestedDropTarget ? (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && parentNode?.type ? (0, $hTjcC.getNestedNodeLeftPaddingMargin)((0, $57Rmq.getBaseNodeTypeName)(parentNode.type)) : (0, $hTjcC.getNestedNodeLeftPaddingMargin)(parentNode?.type.name) : '0',
        [$17032211a95616ca$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX]: (0, $jp2Q3.layers).navigation()
    };
    const isShowInlineDropTarget = (0, $4LOJc.shouldAllowInlineDropTarget)(isNestedDropTarget, nextNode, isSameLayout, activeNode, parentNode);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)($17032211a95616ca$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: prevNode,
        pos: getPos(),
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "upper",
        isNestedDropTarget: isNestedDropTarget,
        dropTargetStyle: dropTargetStyle,
        api: api
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $17032211a95616ca$var$styleDropTarget,
            isNestedDropTarget && $17032211a95616ca$var$nestedDropIndicatorStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyle,
        "data-testid": "block-ctrl-drop-target"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $17032211a95616ca$var$styleDropIndicator,
            isDraggedOver && $17032211a95616ca$var$styleDropIndicatorVisible
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "bottom"
    }))), dropTargetStyle !== 'remainingHeight' && /*#__PURE__*/ (0, $lOiVq.jsx)($17032211a95616ca$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: nextNode,
        pos: getPos(),
        parent: parentNode,
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "lower",
        isNestedDropTarget: isNestedDropTarget,
        api: api
    }), isShowInlineDropTarget && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fmErs.InlineDropTarget), {
        ...props,
        position: "left"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fmErs.InlineDropTarget), {
        ...props,
        position: "right"
    })));
};
module.exports["EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET"] = $17032211a95616ca$export$b172475a7115c36a;
module.exports["EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP"] = $17032211a95616ca$export$d522271cd3bfae1d;
module.exports["DropTarget"] = $17032211a95616ca$export$79660a248b11010;

});

parcelRegister("ddJ8T", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $vZEJe = parcelRequire("vZEJe");


var $iSrRp = parcelRequire("iSrRp");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $8v85f = parcelRequire("8v85f");


var $fKt2m = parcelRequire("fKt2m");

// 8px gap + 16px on left and right
const $210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH = 40;
const $210cdee26edd8583$var$dropTargetLayoutStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    width: `${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`,
    transform: 'translateX(-50%)',
    zIndex: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
});
const $210cdee26edd8583$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    position: 'relative',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0
});
const $210cdee26edd8583$export$448a3db73d1a77fe = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $9HWym.getNodeAnchor)(parent);
    const nextNodeAnchorName = ref.current?.parentElement?.nextElementSibling?.getAttribute((0, $fKt2m.getAnchorAttrName)());
    let height = '100%';
    if (nextNodeAnchorName) {
        if ((0, $a4QVD.isAnchorSupported)()) height = `anchor-size(${nextNodeAnchorName} height)`;
        else if (anchorRectCache) {
            const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
            height = `${layoutColumnRect?.height || 0}px`;
        }
    }
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $7Y8M5.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $cozmU.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $iSrRp.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $210cdee26edd8583$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "right",
        gap: `-${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $210cdee26edd8583$var$dropTargetLayoutHintStyle
    }));
};
const $210cdee26edd8583$export$2afcb78657666b75 = (props)=>{
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $9HWym.getNodeAnchor)(parent);
    const [nextNodeAnchorName, setNextNodeAnchorName] = (0, $cozmU.useState)(null);
    const readNextNodeAnchor = (0, $cozmU.useCallback)(()=>{
        const nextElementSibling = ref.current?.parentElement?.nextElementSibling;
        const attrName = (0, $fKt2m.getAnchorAttrName)();
        const nextAnchorName = nextElementSibling?.getAttribute(attrName) ?? null;
        setNextNodeAnchorName((prev)=>prev === nextAnchorName ? prev : nextAnchorName);
    }, []);
    const height = (0, $cozmU.useMemo)(()=>{
        if (nextNodeAnchorName) {
            if ((0, $a4QVD.isAnchorSupported)()) return `anchor-size(${nextNodeAnchorName} height)`;
            else if (anchorRectCache) {
                const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
                return `${layoutColumnRect?.height || 0}px`;
            }
        }
        // Stacked mode fallback: minimal height to avoid oversized hint on first render
        return '0px';
    }, [
        nextNodeAnchorName,
        anchorRectCache
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const raf = requestAnimationFrame(()=>{
            readNextNodeAnchor();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        readNextNodeAnchor
    ]);
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $7Y8M5.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
    const onDrop = (0, $cozmU.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            const { pos: from } = activeNode;
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $iSrRp.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
                readNextNodeAnchor();
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        readNextNodeAnchor
    ]);
    if (activeNode?.nodeType === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $210cdee26edd8583$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: "right",
        gap: `-${$210cdee26edd8583$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $210cdee26edd8583$var$dropTargetLayoutHintStyle
    }));
};
module.exports["DropTargetLayout"] = $210cdee26edd8583$export$448a3db73d1a77fe;
module.exports["DropTargetLayoutNativeAnchorSupport"] = $210cdee26edd8583$export$2afcb78657666b75;

});

parcelRegister("icvkv", function(module, exports) {

var $fqVYq = parcelRequire("fqVYq");

const $de3138cce29e20cc$export$b8ad888c900fcbc2 = ()=>{
    return (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? 5 : 3;
};
const $de3138cce29e20cc$export$8a51600ccf088851 = 2;
module.exports["maxLayoutColumnSupported"] = $de3138cce29e20cc$export$b8ad888c900fcbc2;
module.exports["MIN_LAYOUT_COLUMN"] = $de3138cce29e20cc$export$8a51600ccf088851;

});

parcelRegister("cX57A", function(module, exports) {
const $e491c6d921040aae$var$IGNORE_NODES = [
    'tableRow',
    'listItem',
    'caption',
    'media'
];
const $e491c6d921040aae$var$blockLeafNodeNext = [
    'blockCard',
    'rule',
    'extension',
    'syncBlock'
];
const $e491c6d921040aae$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $e491c6d921040aae$export$2f588816c7e80081 = (state, $pos, nodeType)=>{
    const depth = $pos.depth;
    const blockLeafNodeList = $e491c6d921040aae$var$blockLeafNodeNext;
    // special cases like hr rule here
    if (blockLeafNodeList.includes(nodeType || '') || $pos.pos === 0) {
        const parent = $pos.node(depth);
        const node = $pos.nodeAfter;
        const index = $pos.index();
        const before = index > 0 ? parent.child(index - 1) : null;
        const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
        return {
            pos: $pos.pos,
            node: node,
            parent: parent,
            before: before,
            after: after,
            index: index,
            depth: depth
        };
    }
    const isRootNode = depth === 1;
    const node = $pos.node(depth);
    // go through the path to find the first node that is not allow child drop target
    // From top to bottom, we check the node types at each depth
    for(let i = 1; i < depth; i++){
        const nodeType = $pos.node(i).type.name;
        if ($e491c6d921040aae$var$DISABLE_CHILD_DROP_TARGET.includes(nodeType)) return $e491c6d921040aae$export$2f588816c7e80081(state, state.doc.resolve($pos.before(i + 1)), nodeType);
    }
    if ($e491c6d921040aae$var$IGNORE_NODES.includes(node.type.name) && !isRootNode) // If the node is an ignored node, we return the surrounding nodes of its parent
    return $e491c6d921040aae$export$2f588816c7e80081(state, state.doc.resolve($pos.before(depth - 1)));
    const pos = depth > 0 ? $pos.before(depth) : 0;
    const parent = isRootNode ? state.doc : $pos.node(depth - 1);
    const index = $pos.index(depth - 1);
    const before = index > 0 ? parent.child(index - 1) : null;
    const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
    return {
        pos: pos,
        node: node,
        parent: parent,
        before: before,
        after: after,
        index: index,
        depth: depth
    };
};
module.exports["findSurroundingNodes"] = $e491c6d921040aae$export$2f588816c7e80081;

});

parcelRegister("2ZDdD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $i6cU6 = parcelRequire("i6cU6");


var $k8PFz = parcelRequire("k8PFz");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8HW7o = parcelRequire("8HW7o");


var $gFEZF = parcelRequire("gFEZF");


var $ixfCV = parcelRequire("ixfCV");


var $3izAL = parcelRequire("3izAL");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9HWym = parcelRequire("9HWym");


var $jWiWP = parcelRequire("jWiWP");


var $69FTU = parcelRequire("69FTU");


var $hTjcC = parcelRequire("hTjcC");


var $bdkuW = parcelRequire("bdkuW");


var $g7xpB = parcelRequire("g7xpB");


var $fKt2m = parcelRequire("fKt2m");


var $5Cc13 = parcelRequire("5Cc13");


var $lhJQI = parcelRequire("lhJQI");

function $49dc35a076557bab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $49dc35a076557bab$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
const $49dc35a076557bab$var$stickyButtonStyles = (0, $buxP3.xcss)({
    top: '0',
    position: 'sticky',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)",
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.full',
    zIndex: 'card',
    outline: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24px x 24px, Dense: 13px -> ~18.5px x ~18.5px
const $49dc35a076557bab$var$stickyButtonDenseModeStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.QUICK_INSERT_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $7Y8M5.relativeSizeToBaseFontSize)((0, $hTjcC.QUICK_INSERT_WIDTH))
});
const $49dc35a076557bab$var$containerStaticStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    zIndex: 'card'
});
const $49dc35a076557bab$var$tooltipContainerStyles = {
    name: "1hhl1l9",
    styles: "top:8px;bottom:-8px;position:sticky;display:block;z-index:card"
};
const $49dc35a076557bab$var$tooltipContainerStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
const $49dc35a076557bab$var$tooltipContainerImprovedStylesStickyHeader = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $49dc35a076557bab$var$tooltipContainerStylesStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $49dc35a076557bab$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $k8PFz.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $hTjcC.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $49dc35a076557bab$export$c64bb72e819f7e01 = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const { macroInteractionUpdates: macroInteractionUpdates } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            macroInteractionUpdates: states.featureFlagsState?.macroInteractionUpdates
        }));
    const [positionStyles, setPositionStyles] = (0, $cozmU.useState)({
        display: 'none'
    });
    // Adapted from `src/ui/drag-handle.tsx` as positioning logic is similar
    // CHANGES - added an offset so quick insert button can be positioned beside drag handle
    // CHANGES - removed `editorExperiment('nested-dnd', true)` check and rootNodeType calculation
    // CHANGES - replace anchorName with rootAnchorName
    // CHANGES - `removed editorExperiment('advanced_layouts', true) && isLayoutColumn` checks as quick insert button will not be positioned for layout column
    const calculatePosition = (0, $cozmU.useCallback)(()=>{
        const supportsAnchor = CSS.supports('top', `anchor(${rootAnchorName} start)`) && CSS.supports('left', `anchor(${rootAnchorName} start)`);
        const pos = getPos();
        const node = pos !== undefined ? view.state.doc.nodeAt(pos) : undefined;
        const safeAnchorName = (0, $bdkuW.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName
        });
        const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: the node decoration sets data-active-quick-insert on the
        // active root node. Check for it directly — cheap DOM attribute read, no reflow.
        if ((0, $ieeJu.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !dom?.hasAttribute((0, $hTjcC.ACTIVE_QUICK_INSERT_ATTR))) return {
            display: 'none'
        };
        const hasResizer = rootNodeType === 'table' || rootNodeType === 'mediaSingle';
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension' || rootNodeType === 'multiBodiedExtension' && (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension');
        const isBlockCard = rootNodeType === 'blockCard';
        const isEmbedCard = rootNodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $jWiWP.shouldBeSticky)(rootNodeType);
        const bottom = (0, $jWiWP.getControlBottomCSSValue)(safeAnchorName || anchorName, isSticky, true);
        if (supportsAnchor) return {
            left: isEdgeCase ? `calc(anchor(${safeAnchorName} start) + ${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(anchor(${safeAnchorName} start) - ${(0, $hTjcC.QUICK_INSERT_DIMENSIONS).width}px - ${(0, $hTjcC.rootElementGap)(rootNodeType)}px + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)`,
            // small text requires further tweaking to positioning, re-using existing methods to calculate to keep it unified with drag handle
            top: `calc(anchor(${safeAnchorName} start) + ${(0, $hTjcC.topPositionAdjustment)(node && node.type.name === 'paragraph' && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $9HWym.getNodeTypeWithLevel)(node) : rootNodeType)}px)`,
            ...bottom
        };
        // expensive, calls offsetHeight
        const nodeHeight = (0, $jWiWP.getNodeHeight)(dom, safeAnchorName || anchorName, anchorRectCache) || 0;
        const height = (0, $jWiWP.getControlHeightCSSValue)(nodeHeight, isSticky, true, "var(--ds-space-300, 24px)");
        return {
            left: isEdgeCase ? `calc(${dom?.offsetLeft || 0}px + ${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(${(0, $69FTU.getLeftPositionForRootElement)(dom, rootNodeType, (0, $hTjcC.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $hTjcC.QUICK_INSERT_LEFT_OFFSET}px)`,
            top: (0, $jWiWP.getTopPosition)(dom, rootNodeType),
            ...height
        };
    }, [
        rootAnchorName,
        getPos,
        view,
        rootNodeType,
        macroInteractionUpdates,
        anchorName,
        anchorRectCache
    ]);
    (0, $cozmU.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $fKt2m.getAnchorAttrName)()}="${rootAnchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $cbY7C.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStyles(calculatePosition());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStyles(calculatePosition());
        });
        return ()=>{
            cancelAnimationFrame(calcPos);
            cleanUpTransitionListener?.();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType
    ]);
    const handleQuickInsert = (0, $cozmU.useCallback)(()=>{
        // if the selection is not within the node this decoration is rendered at
        // then insert a newline and trigger quick insert
        const start = getPos();
        if (start !== undefined) {
            // if the selection is not within the node this decoration is rendered at
            // or the node is non-editable, then insert a newline and trigger quick insert
            const isSelectionInsideNode = (0, $g7xpB.isSelectionInNode)(start, view);
            if (!isSelectionInsideNode || (0, $g7xpB.isNonEditableBlock)(start, view)) api.core.actions.execute((0, $5Cc13.createNewLine)(start));
            const { codeBlock: codeBlock } = view.state.schema.nodes;
            const { selection: selection } = view.state;
            const codeBlockParentNode = (0, $bjg0G.findParentNodeOfType)(codeBlock)(selection);
            if (codeBlockParentNode) // Slash command is not meant to be triggered inside code block, hence always insert slash in a new line following
            api.core.actions.execute((0, $5Cc13.createNewLine)(codeBlockParentNode.pos));
            else if (isSelectionInsideNode) {
                // text or element with be deselected and the / added immediately after the paragraph
                // unless the selection is empty
                const currentSelection = view.state.selection;
                if ((0, $g7xpB.isInTextSelection)(view) && currentSelection.from !== currentSelection.to) {
                    const currentParagraphNode = (0, $bjg0G.findParentNode)((node)=>$49dc35a076557bab$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
                    if (currentParagraphNode) {
                        const newPos = //if the current selection is selected from right to left, then set the selection to the start of the paragraph
                        currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                        api.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $kCECX.TextSelection).create(view.state.selection.$from.doc, newPos));
                            return tr;
                        });
                    }
                }
                if ((0, $g7xpB.isNestedNodeSelected)(view)) {
                    // if the nested selected node is non-editable, then insert a newline below the selected node
                    if ((0, $g7xpB.isNonEditableBlock)(view.state.selection.from, view)) api.core.actions.execute((0, $5Cc13.createNewLine)(view.state.selection.from));
                    else // otherwise need to force the selection to be at the start of the node, because
                    // prosemirror is keeping it as NodeSelection for nested nodes. Do this to keep it
                    // consistent NodeSelection for root level nodes.
                    api.core.actions.execute(({ tr: tr })=>{
                        (0, $5Cc13.createNewLine)(view.state.selection.from)({
                            tr: tr
                        });
                        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, view.state.selection.from));
                        return tr;
                    });
                }
                if (currentSelection instanceof (0, $8HW7o.CellSelection)) {
                    // find the last inline position in the selection
                    const lastInlinePosition = (0, $kCECX.TextSelection).near(view.state.selection.$to, -1);
                    lastInlinePosition && api.core.actions.execute(({ tr: tr })=>{
                        if (!(lastInlinePosition instanceof (0, $kCECX.TextSelection))) {
                            // this will create a new line after the node
                            (0, $5Cc13.createNewLine)(lastInlinePosition.from)({
                                tr: tr
                            });
                            // this will find the next valid text position after the node
                            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, lastInlinePosition.to));
                        } else tr.setSelection(lastInlinePosition);
                        return tr;
                    });
                }
            }
        }
        api.quickInsert?.actions.openTypeAhead('blockControl', true);
    }, [
        api,
        getPos,
        view
    ]);
    const handleMouseDown = (0, $cozmU.useCallback)(()=>{
        // close typeahead if it is open, must happen in mouseDown otherwise typeAhead popup will be dismissed and text is left
        if (api.typeAhead?.actions.isOpen(view.state)) api.typeAhead.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        api,
        view.state
    ]);
    const tooltipPressable = ()=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
            position: "top",
            content: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldqjS.ToolTipContent), {
                description: formatMessage((0, $i6cU6.messages).insert)
            })
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kh0hi.default), {
            testId: "editor-quick-insert-button",
            type: "button",
            "aria-label": formatMessage((0, $i6cU6.messages).insert),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $49dc35a076557bab$var$stickyButtonStyles,
                $49dc35a076557bab$var$stickyButtonDenseModeStyles
            ],
            onClick: handleQuickInsert,
            onMouseDown: handleMouseDown
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
            label: "add",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        })));
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: positionStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $49dc35a076557bab$var$containerStaticStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: [
            $49dc35a076557bab$var$tooltipContainerStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_6') ? $49dc35a076557bab$var$tooltipContainerImprovedStylesStickyHeader : $49dc35a076557bab$var$tooltipContainerStylesStickyHeader,
            (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $ixfCV.fg)('platform_editor_table_sticky_header_patch_6') ? $49dc35a076557bab$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix : $49dc35a076557bab$var$tooltipContainerStylesStickyHeaderWithMarksFix
        ]
    }, tooltipPressable()));
};
const $49dc35a076557bab$export$6ffb15bf86dea6dd = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, nodeType: nodeType, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            rightSideControlsEnabled: states.blockControlsState?.rightSideControlsEnabled ?? false
        })).rightSideControlsEnabled;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lhJQI.VisibilityContainer), {
        api: api,
        controlSide: rightSideControlsEnabled ? 'left' : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($49dc35a076557bab$export$c64bb72e819f7e01, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        nodeType: nodeType,
        anchorName: anchorName,
        rootAnchorName: rootAnchorName,
        rootNodeType: rootNodeType,
        anchorRectCache: anchorRectCache
    }));
};
module.exports["QuickInsertWithVisibility"] = $49dc35a076557bab$export$6ffb15bf86dea6dd;

});

parcelRegister("6FQH1", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $aca3bcee9aa84af2$export$4d3f50627e188696 = new (0, $kCECX.PluginKey)('selectionPreservationPlugin');
module.exports["selectionPreservationPluginKey"] = $aca3bcee9aa84af2$export$4d3f50627e188696;

});

parcelRegister("b3nYA", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8QOo3 = parcelRequire("8QOo3");


var $i6cU6 = parcelRequire("i6cU6");


var $iQ6F7 = parcelRequire("iQ6F7");

var $4EksL = parcelRequire("4EksL");


var $jPUdw = parcelRequire("jPUdw");


var $1xYQH = parcelRequire("1xYQH");


var $2w79Z = parcelRequire("2w79Z");


var $57Rmq = parcelRequire("57Rmq");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");


var $cycWk = parcelRequire("cycWk");

var $kWLy1 = parcelRequire("kWLy1");

var $8imfU = parcelRequire("8imfU");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $3BXSc = parcelRequire("3BXSc");


var $aHnsS = parcelRequire("aHnsS");


var $bnCpE = parcelRequire("bnCpE");


var $bOZni = parcelRequire("bOZni");


var $izfLh = parcelRequire("izfLh");


var $i2jOy = parcelRequire("i2jOy");


var $8v85f = parcelRequire("8v85f");


var $SlYRR = parcelRequire("SlYRR");


var $9aKak = parcelRequire("9aKak");

/**
 * This function transforms the slice to move
 * @param nodeCopy The slice contains the node to be moved
 * @param destType The type of the destiation node
 * @returns transformed slice or null if unable to
 */ function $ef5137d75ace3d5c$var$transformSourceSlice(nodeCopy, destType) {
    const srcNode = nodeCopy.content.firstChild;
    const schema = srcNode?.type.schema;
    if (!schema) return nodeCopy;
    const { doc: doc, layoutColumn: layoutColumn } = schema.nodes;
    const destTypeInTable = (0, $SlYRR.isInsideTable)(destType);
    const destTypeInDocOrLayoutCol = [
        doc,
        layoutColumn
    ].includes(destType);
    // Only run transformation loop if destination may need node conversions:
    // - Table destinations may need expand → nestedExpand
    // - Doc/layoutColumn destinations may need nestedExpand → expand
    // - When panel_c1 experiment is on:
    // - Expand/table/bodied extension destinations may need panel_c1 → panel downgrade
    // - Doc/layoutColumn destinations may need panel → panel_c1 upgrade
    const needsTransformCheck = destTypeInTable || destTypeInDocOrLayoutCol || (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
    if (!needsTransformCheck) return nodeCopy;
    let containsExpand = false;
    let containsNestedExpand = false;
    // Track variant nodes (e.g. panel_c1) and their base forms (e.g. panel).
    // Uses getBaseNodeTypeName to auto-detect variants — new variants only need
    // to be added to variantToBaseNameMap, no changes needed in the detection loop.
    let variantType = null;
    let baseOfVariantType = null;
    for(let i = 0; i < nodeCopy.content.childCount; i++){
        const node = nodeCopy.content.child(i);
        if (node.type === schema.nodes.expand) containsExpand = true;
        else if (node.type === schema.nodes.nestedExpand) containsNestedExpand = true;
        if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
            const baseName = (0, $57Rmq.getBaseNodeTypeName)(node.type);
            if (baseName !== node.type.name) variantType = node.type.name;
            else if (schema.nodes[`${baseName}_c1`]) baseOfVariantType = node.type.name;
        }
        if (containsExpand && containsNestedExpand && (variantType || baseOfVariantType)) break;
    }
    if (containsExpand && destTypeInTable) return (0, $SlYRR.transformSliceExpandToNestedExpand)(nodeCopy);
    else if (containsNestedExpand && destTypeInDocOrLayoutCol) return (0, $jPUdw.transformSliceNestedExpandToExpand)(nodeCopy, schema);
    // Downgrade variant → base (e.g. panel_c1 → panel) when dest doesn't support the variant
    if (variantType && schema.nodes[variantType]) {
        const destParent = destType.createAndFill();
        if (destParent && !(0, $57Rmq.isNodeTypeValidChildOf)(variantType, destParent, schema)) {
            const baseName = (0, $57Rmq.getBaseNodeTypeName)(schema.nodes[variantType]);
            return (0, $SlYRR.transformSliceNodeType)(nodeCopy, schema, variantType, baseName);
        }
    }
    // Upgrade base → variant (e.g. panel → panel_c1) when dest supports the variant
    if (baseOfVariantType) {
        const variantName = `${baseOfVariantType}_c1`;
        if (schema.nodes[variantName]) {
            const destParent = destType.createAndFill();
            if (destParent && (0, $57Rmq.isNodeTypeValidChildOf)(variantName, destParent, schema)) return (0, $SlYRR.transformSliceNodeType)(nodeCopy, schema, baseOfVariantType, variantName);
        }
    }
    return nodeCopy;
}
const $ef5137d75ace3d5c$var$nodesSupportDragLayoutColumnInto = [
    'tableCell',
    'tableHeader',
    'panel',
    'expand',
    'nestedExpand'
];
const $ef5137d75ace3d5c$var$isDragLayoutColumnIntoSupportedNodes = ($from, $to)=>{
    const isTopLevel = $to.depth === 0;
    const toParentTypeName = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $57Rmq.getBaseNodeTypeName)($to.parent.type) : $to.parent.type.name;
    const isDragIntoNodes = $ef5137d75ace3d5c$var$nodesSupportDragLayoutColumnInto.includes(toParentTypeName);
    const supportedCondition = isDragIntoNodes || isTopLevel;
    return $from.nodeAfter?.type.name === 'layoutColumn' && $from.parent.type.name === 'layoutSection' && supportedCondition;
};
/**
 *
 * @returns the start position of a node if the node can be moved, otherwise -1
 */ const $ef5137d75ace3d5c$var$getCurrentNodePos = (state)=>{
    const { selection: selection } = state;
    let currentNodePos = -1;
    // There are 3 cases when a node can be moved
    const focusedHandle = $ef5137d75ace3d5c$var$getFocusedHandle(state);
    if (focusedHandle) // 1. drag handle of the node is focused
    currentNodePos = focusedHandle.pos;
    else if ((0, $kWLy1.isInTable)(state)) {
        if ((0, $8imfU.isTableSelected)(selection)) // We only move table node if it's fully selected
        // to avoid shortcut collision with table drag and drop
        currentNodePos = (0, $cycWk.findTable)(selection)?.pos ?? currentNodePos;
    } else if (!(state.selection instanceof (0, $4EksL.GapCursorSelection))) {
        // 2. caret cursor is inside the node
        // 3. the start of the selection is inside the node
        currentNodePos = selection.$from.before(1);
        if (selection.$from.depth > 0) currentNodePos = (0, $bnCpE.getNestedNodePosition)({
            selection: selection,
            schema: state.schema,
            resolve: state.doc.resolve.bind(state.doc)
        });
    }
    return currentNodePos;
};
const $ef5137d75ace3d5c$var$getFocusedHandle = (state)=>{
    const { activeNode: activeNode } = (0, $3BXSc.key).getState(state) || {};
    return activeNode && activeNode.handleOptions?.isFocused ? activeNode : undefined;
};
const $ef5137d75ace3d5c$export$3438b98b9a6e008b = (api, direction, formatMessage)=>{
    return (state)=>{
        const { selection: selection } = state;
        const isParentNodeOfTypeLayout = !!(0, $bjg0G.findParentNodeOfType)([
            state.schema.nodes.layoutSection
        ])(state.selection);
        const expandedSelection = (0, $iQ6F7.expandSelectionBounds)(selection.$anchor, selection.$head);
        const expandedAnchor = expandedSelection.$anchor.pos;
        const expandedHead = expandedSelection.$head.pos;
        let hoistedPos;
        const from = Math.min(expandedAnchor, expandedHead);
        // Nodes like lists nest within themselves, we need to find the top most position
        if (isParentNodeOfTypeLayout) {
            const LAYOUT_COL_DEPTH = 3;
            hoistedPos = state.doc.resolve(from).before(LAYOUT_COL_DEPTH);
        }
        const currentNodePos = !$ef5137d75ace3d5c$var$getFocusedHandle(state) && !selection.empty ? hoistedPos ?? from : $ef5137d75ace3d5c$var$getCurrentNodePos(state);
        if (currentNodePos > -1) {
            const $currentNodePos = state.doc.resolve(currentNodePos);
            const nodeAfterPos = !$ef5137d75ace3d5c$var$getFocusedHandle(state) ? Math.max(expandedAnchor, expandedHead) : $currentNodePos.posAtIndex($currentNodePos.index() + 1);
            const isTopLevelNode = $currentNodePos.depth === 0;
            let moveToPos = -1;
            const isLayoutColumnSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'layoutColumn';
            if (direction === (0, $1xYQH.DIRECTION).LEFT) {
                if (isTopLevelNode && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
                    const nodeBefore = $currentNodePos.nodeBefore;
                    if (nodeBefore) moveToPos = currentNodePos - nodeBefore.nodeSize;
                    if (moveToPos < 0) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveToEnd: true,
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $8v85f.updateSelection)(tr, mappedTo, true);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    moveToPos = selection.from - ($currentNodePos.nodeBefore?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    // get the previous layoutSection node
                    const index = $currentNodePos.index($currentNodePos.depth - 1);
                    const grandParent = $currentNodePos.node($currentNodePos.depth - 1);
                    const previousNode = grandParent ? grandParent.maybeChild(index - 1) : null;
                    moveToPos = $currentNodePos.start() - (previousNode?.nodeSize || 1);
                }
            } else if (direction === (0, $1xYQH.DIRECTION).RIGHT) {
                if (isTopLevelNode && (0, $fqVYq.editorExperiment)('advanced_layouts', true)) {
                    const endOfDoc = $currentNodePos.end();
                    moveToPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
                    if (moveToPos >= endOfDoc) return false;
                    api?.core?.actions.execute(({ tr: tr })=>{
                        api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $8v85f.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep?.from;
                        (0, $8v85f.updateSelection)(tr, mappedTo);
                        return tr;
                    });
                    api?.core?.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    const index = $currentNodePos.index($currentNodePos.depth);
                    const parent = $currentNodePos.node($currentNodePos.depth);
                    // get the next layoutColumn node
                    const nextNode = parent ? parent.maybeChild(index + 1) : null;
                    // if the current node is the last node, don't do anything
                    if (index >= parent.childCount - 1) // prevent event propagation to avoid moving the cursor and still select the node
                    return true;
                    const moveToEnd = index === parent.childCount - 2;
                    moveToPos = moveToEnd ? $currentNodePos.before() : selection.to + (nextNode?.nodeSize || 1);
                    api?.core?.actions.execute(api?.blockControls?.commands?.moveToLayout(currentNodePos, moveToPos, {
                        moveToEnd: moveToEnd,
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    moveToPos = $currentNodePos.after($currentNodePos.depth) + 1;
                }
            } else if (direction === (0, $1xYQH.DIRECTION).UP) {
                if (isLayoutColumnSelected) moveToPos = $currentNodePos.start() - 1;
                else moveToPos = (0, $9aKak.getPosWhenMoveNodeUp)($currentNodePos, currentNodePos);
            } else {
                const endOfDoc = $currentNodePos.end();
                if (nodeAfterPos > endOfDoc) return false;
                if (isLayoutColumnSelected) moveToPos = state.selection.$from.end() + 1;
                else moveToPos = (0, $9aKak.getPosWhenMoveNodeDown)({
                    $currentNodePos: $currentNodePos,
                    nodeAfterPos: nodeAfterPos,
                    tr: state.tr
                });
            }
            const nodeType = state.doc.nodeAt(currentNodePos)?.type.name;
            let shouldMoveNode = false;
            if (moveToPos > -1) {
                const isDestDepthSameAsSource = $currentNodePos.depth === state.doc.resolve(moveToPos).depth;
                const isSourceLayoutColumn = nodeType === 'layoutColumn';
                shouldMoveNode = isDestDepthSameAsSource || isSourceLayoutColumn;
            }
            const { $anchor: $newAnchor, $head: $newHead } = (0, $iQ6F7.expandSelectionBounds)($currentNodePos, selection.$to);
            if (shouldMoveNode) {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    $ef5137d75ace3d5c$export$83751492c88cf2ca(api)(currentNodePos, moveToPos, (0, $krYZG.INPUT_METHOD).SHORTCUT, formatMessage)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            } else {
                api?.core?.actions.execute(({ tr: tr })=>{
                    api?.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            }
        }
        return false;
    };
};
const $ef5137d75ace3d5c$export$83751492c88cf2ca = (api)=>(start, to, inputMethod = (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP, formatMessage)=>({ tr: tr })=>{
            if (!api || start < 0 || to < 0) return tr;
            const handleNode = tr.doc.nodeAt(start);
            if (!handleNode) return tr;
            let sliceFrom = start;
            let sliceTo;
            let sourceNodeTypes, hasSelectedMultipleNodes;
            if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.setContentMoved()({
                tr: tr
            });
            const preservedSelection = (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true) ? api?.blockControls.sharedState.currentState()?.preservedSelection : undefined;
            if (preservedSelection) {
                const $from = tr.doc.resolve(Math.min(start, preservedSelection.from));
                const expandedRange = $from.blockRange(preservedSelection.$to);
                sliceFrom = expandedRange ? expandedRange.start : preservedSelection.from;
                sliceTo = expandedRange ? expandedRange.end : preservedSelection.to;
                const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            } else {
                const slicePosition = (0, $i2jOy.getSelectedSlicePosition)(start, tr, api);
                sliceFrom = slicePosition.from;
                sliceTo = slicePosition.to;
                const attributes = (0, $aHnsS.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            }
            const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
            const $to = tr.doc.resolve(to);
            const $handlePos = tr.doc.resolve(start);
            const nodeCopy = tr.doc.slice(sliceFrom, sliceTo, false); // cut the content
            const destNode = $to.node();
            const destType = destNode.type;
            const destParent = $to.node($to.depth);
            const sourceNode = $handlePos.nodeAfter;
            //TODO: ED-26959 - Does this need to be updated with new selection logic above? ^
            // Move a layout column to top level, or table cell, or panel, or expand, only moves the content into them
            if (sourceNode && $ef5137d75ace3d5c$var$isDragLayoutColumnIntoSupportedNodes($handlePos, $to)) {
                // need update after we support single column layout.
                const layoutColumnContent = sourceNode.content;
                let fragment;
                // if drop into table, and layout column contains expand, transform it to nestedExpand
                if ([
                    'tableCell',
                    'tableHeader'
                ].includes($to.parent.type.name)) {
                    const contentContainsExpand = (0, $bjg0G.findChildrenByType)(sourceNode, expand).length > 0;
                    fragment = contentContainsExpand ? (0, $SlYRR.transformFragmentExpandToNestedExpand)((0, $aPdNQ.Fragment).from(layoutColumnContent)) : (0, $aPdNQ.Fragment).from(layoutColumnContent);
                    if (!fragment) return tr;
                } else fragment = (0, $aPdNQ.Fragment).from(layoutColumnContent);
                (0, $izfLh.removeFromSource)(tr, $handlePos, $handlePos.pos + sourceNode.nodeSize);
                const mappedTo = tr.mapping.map(to);
                tr.insert(mappedTo, fragment).setSelection((0, $kCECX.Selection).near(tr.doc.resolve(mappedTo))).scrollIntoView();
                return tr;
            }
            if (!(0, $SlYRR.canMoveNodeToIndex)(destParent, $to.index(), $handlePos.node().child($handlePos.index()), $to)) return tr;
            let convertedNodeSlice = $ef5137d75ace3d5c$var$transformSourceSlice(nodeCopy, destType);
            let convertedNode = convertedNodeSlice?.content;
            if (!convertedNode) return tr;
            // Currently we don't support breakout mark for children nodes of bodiedSyncBlock node
            // Hence strip out the mark for now
            if (destNode.type.name === 'bodiedSyncBlock' && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
                const nodes = [];
                convertedNodeSlice?.content.forEach((node)=>{
                    nodes.push(node.mark(node.marks.filter((mark)=>mark.type.name !== 'breakout')));
                });
                convertedNodeSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(nodes), 0, 0);
                convertedNode = convertedNodeSlice.content;
            }
            // delete the content from the original position
            tr.delete(sliceFrom, sliceTo);
            const mappedTo = tr.mapping.map(to);
            const isDestNestedLoneEmptyParagraph = destParent.type.name !== 'doc' && destParent.childCount === 1 && (0, $2w79Z.isEmptyParagraph)($to.nodeAfter);
            if (convertedNodeSlice && isDestNestedLoneEmptyParagraph) // if only a single empty paragraph within container, replace it
            tr.replace(mappedTo, mappedTo + 1, convertedNodeSlice);
            else // otherwise just insert the content at the new position
            tr.insert(mappedTo, convertedNode);
            const sliceSize = sliceTo - sliceFrom;
            if (inputMethod === (0, $krYZG.INPUT_METHOD).DRAG_AND_DROP) tr = (0, $bOZni.setCursorPositionAtMovedNode)(tr, mappedTo, api);
            else if (preservedSelection) {
                const currMeta = tr.getMeta((0, $3BXSc.key));
                const nodeMovedOffset = mappedTo - sliceFrom;
                tr.setMeta((0, $3BXSc.key), {
                    ...currMeta,
                    preservedSelectionMapping: new (0, $eOaGc.Mapping)([
                        new (0, $eOaGc.StepMap)([
                            0,
                            0,
                            nodeMovedOffset
                        ])
                    ])
                });
            } else tr = api?.blockControls.commands.setMultiSelectPositions(mappedTo, mappedTo + sliceSize)({
                tr: tr
            }) ?? tr;
            const currMeta = tr.getMeta((0, $3BXSc.key));
            tr.setMeta((0, $3BXSc.key), {
                ...currMeta,
                nodeMoved: true
            });
            if (// when move node via block menu, we need to keep the focus on block menu popup, so don't move focus to editor in this scenario
            !(inputMethod === (0, $krYZG.INPUT_METHOD).BLOCK_MENU && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true))) api?.core.actions.focus();
            const $mappedTo = tr.doc.resolve(mappedTo);
            const expandAncestor = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($to, [
                expand,
                nestedExpand
            ]);
            if (expandAncestor) {
                const wasExpandExpanded = (0, $8QOo3.expandedState).get(expandAncestor.node);
                const updatedExpandAncestor = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($mappedTo, [
                    expand,
                    nestedExpand
                ]);
                if (wasExpandExpanded !== undefined && updatedExpandAncestor) (0, $8QOo3.expandedState).set(updatedExpandAncestor.node, wasExpandExpanded);
            }
            if ((0, $fqVYq.editorExperiment)('advanced_layouts', true)) (0, $aHnsS.attachMoveNodeAnalytics)(tr, inputMethod, $handlePos.depth, sourceNodeTypes, $mappedTo?.depth, $mappedTo?.parent.type.name, $handlePos.sameParent($mappedTo), api, hasSelectedMultipleNodes);
            else api?.analytics?.actions.attachAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).MOVED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: $handlePos.depth,
                    nodeTypes: sourceNodeTypes,
                    destinationNodeDepth: $mappedTo?.depth,
                    destinationNodeType: $mappedTo?.parent.type.name,
                    inputMethod: inputMethod,
                    hasSelectedMultipleNodes: hasSelectedMultipleNodes
                }
            })(tr);
            const movedMessage = to > sliceFrom ? (0, $i6cU6.messages).movedDown : (0, $i6cU6.messages).movedup;
            api?.accessibilityUtils?.actions.ariaNotify(formatMessage ? formatMessage(movedMessage) : movedMessage.defaultMessage, {
                priority: 'important'
            });
            return tr;
        };
module.exports["moveNodeViaShortcut"] = $ef5137d75ace3d5c$export$3438b98b9a6e008b;
module.exports["moveNode"] = $ef5137d75ace3d5c$export$83751492c88cf2ca;

});

parcelRegister("dhlUl", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $ieeJu = parcelRequire("ieeJu");


var $rOV4B = parcelRequire("rOV4B");


var $3BXSc = parcelRequire("3BXSc");


var $bnCpE = parcelRequire("bnCpE");


var $fKt2m = parcelRequire("fKt2m");

const $a2edf59f0dfc13ac$var$findParentPosForHandle = (state)=>{
    const { selection: { $from: $from } } = state;
    const { activeNode: activeNode } = (0, $3BXSc.key).getState(state) || {};
    // if a node handle is already focused, return the parent pos of that node (with focused handle)
    if (activeNode && activeNode.handleOptions?.isFocused) {
        const $activeNodePos = state.doc.resolve(activeNode.pos);
        // if the handle is at the top level already, do nothing
        if ($activeNodePos.depth === 0) return undefined;
        return $activeNodePos.before();
    }
    // if we are in second level of nested node, we should focus the node at level 1
    if ($from.depth <= 1) return $from.before(1);
    // if we are inside a table, we should focus the table's handle
    const parentTableNode = (0, $bjg0G.findParentNodeOfType)([
        state.schema.nodes.table
    ])(state.selection);
    if (parentTableNode) return parentTableNode.pos;
    // else find closest parent node
    return (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? // as opposed to old approach, node decoration is only added to the node that have drag handle,
    // hence, we need to return the exact position of the node that can have drag handle
    (0, $bnCpE.getNestedNodeStartingPosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    }) : (0, $bnCpE.getNestedNodePosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    });
};
const $a2edf59f0dfc13ac$var$findNextAnchorDecoration = (state)=>{
    const decorations = (0, $3BXSc.getDecorations)(state);
    if (!decorations) return undefined;
    const nextHandleNodePos = $a2edf59f0dfc13ac$var$findParentPosForHandle(state);
    if (nextHandleNodePos === undefined) return undefined;
    const nextHandleNode = state.doc.nodeAt(nextHandleNodePos);
    let nodeDecorations = nextHandleNode && (0, $rOV4B.findNodeDecs)(state, decorations, nextHandleNodePos, nextHandleNodePos + nextHandleNode.nodeSize);
    if (!nodeDecorations || nodeDecorations.length === 0) return undefined;
    // ensure the decoration covers the position of the look up node
    nodeDecorations = nodeDecorations.filter((decoration)=>{
        return decoration.from <= nextHandleNodePos;
    });
    if (nodeDecorations.length === 0) return undefined;
    // sort the decorations by the position of the node
    // so we can find the closest decoration to the node
    nodeDecorations.sort((a, b)=>{
        if (a.from === b.from) return a.to - b.to;
        return b.from - a.from;
    });
    // return the closest decoration to the node
    return nodeDecorations[0];
};
const $a2edf59f0dfc13ac$var$findNextAnchorNode = (view)=>{
    const nextHandleNodePos = $a2edf59f0dfc13ac$var$findParentPosForHandle(view.state);
    if (nextHandleNodePos === undefined) return undefined;
    const dom = view.nodeDOM(nextHandleNodePos);
    if (!(dom instanceof HTMLElement)) return undefined;
    const nodeDOM = dom.closest(`[${(0, $fKt2m.NODE_ANCHOR_ATTR_NAME)}]`);
    if (!nodeDOM) return undefined;
    const nodeType = nodeDOM?.getAttribute((0, $fKt2m.NODE_NODE_TYPE_ATTR_NAME));
    const anchorName = nodeDOM?.getAttribute((0, $fKt2m.NODE_ANCHOR_ATTR_NAME));
    if (nodeType && anchorName) return {
        pos: nextHandleNodePos,
        nodeType: nodeType,
        anchorName: anchorName
    };
};
const $a2edf59f0dfc13ac$export$c78ece06e89c3c69 = (api)=>(state, _, view)=>{
        if (view && (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            const anchorNode = $a2edf59f0dfc13ac$var$findNextAnchorNode(view);
            if (api && anchorNode) {
                const { pos: pos, anchorName: anchorName, nodeType: nodeType } = anchorNode;
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, nodeType, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        } else {
            const decoration = $a2edf59f0dfc13ac$var$findNextAnchorDecoration(state);
            if (api && decoration) {
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(decoration.from, decoration.spec.anchorName, decoration.spec.nodeTypeWithLevel, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        }
    };
module.exports["showDragHandleAtSelection"] = $a2edf59f0dfc13ac$export$c78ece06e89c3c69;

});

parcelRegister("54N0Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3PHGt = parcelRequire("3PHGt");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");

const $ca4324df41e9ccf2$var$wrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $ca4324df41e9ccf2$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $ca4324df41e9ccf2$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))), {
        label: props?.label
    }));
};
module.exports["DatasourceIcon"] = $ca4324df41e9ccf2$export$8819453811a57211;

});

parcelRegister("cRImW", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");

const $7ee17a04603997de$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $cozmU.useState)(undefined);
    const [parameters, setParameters] = (0, $cozmU.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $cozmU.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceInfo"] = $7ee17a04603997de$export$d01c44dffc996c80;

});

parcelRegister("drvNu", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $4EZEs = parcelRequire("4EZEs");


var $cbp6v = parcelRequire("cbp6v");

const $e5629c0e58eb7677$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $4EZEs.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $cbp6v.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };
module.exports["editDatasource"] = $e5629c0e58eb7677$export$687401cc190b9ec3;

});

parcelRegister("khHv2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $3u1Hp = parcelRequire("3u1Hp");

const $a8f1460a9920d336$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $cozmU.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $3u1Hp.useDatasourceClientExtension)();
    (0, $cozmU.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $3u1Hp.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};
module.exports["useFetchDatasourceDataInfo"] = $a8f1460a9920d336$export$25222ec28f4cbba5;

});

parcelRegister("dY8XA", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $bI2nS = parcelRequire("bI2nS");

var $iEFx5 = parcelRequire("iEFx5");


var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $7sJoX = parcelRequire("7sJoX");


var $gC2EJ = parcelRequire("gC2EJ");


var $9d7Pd = parcelRequire("9d7Pd");


var $4ez2K = parcelRequire("4ez2K");


var $4eqn3 = parcelRequire("4eqn3");


var $drvNu = parcelRequire("drvNu");

const $57525b57aab09e0a$var$dropdownExpandContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $57525b57aab09e0a$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $cozmU.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $4eqn3.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $cozmU.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $drvNu.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $4eqn3.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                ariaLabel: areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink) : undefined,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $iEFx5.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                        css: $57525b57aab09e0a$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: intl.formatMessage((0, $bI2nS.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $huoxr.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9GNtS.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $9RT19.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9d7Pd.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $bI2nS.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $57525b57aab09e0a$export$2e2bcd8739ae039 = $57525b57aab09e0a$var$EditToolbarButtonPresentation;
module.exports["default"] = $57525b57aab09e0a$export$2e2bcd8739ae039;

});

parcelRegister("eNCVl", function(module, exports) {

var $gxKDp = parcelRequire("gxKDp");

const $fff22d9fe7ec96c7$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};
module.exports["getButtonGroupOption"] = $fff22d9fe7ec96c7$export$9de0d67eaa25f178;

});

parcelRegister("8a6fP", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7joZr = parcelRequire("7joZr");


var $4hfky = parcelRequire("4hfky");

function $a737b0b67ea1264f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $a737b0b67ea1264f$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $a737b0b67ea1264f$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $a737b0b67ea1264f$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: disabled ? $a737b0b67ea1264f$var$disallowedWrapperStyle : $a737b0b67ea1264f$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $a737b0b67ea1264f$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $a737b0b67ea1264f$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $a737b0b67ea1264f$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $7joZr.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $lOiVq.jsx)($a737b0b67ea1264f$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4hfky.default), {
            css: disabled ? $a737b0b67ea1264f$var$buttonStyleNoneEvent : $a737b0b67ea1264f$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};
module.exports["LinkToolbarButtonGroup"] = $a737b0b67ea1264f$export$41ba5f90e13b0c51;

});

parcelRegister("hXw4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gxKDp = parcelRequire("gxKDp");

const $4047da273e09ef71$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $gxKDp.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};
module.exports["getDropdownOption"] = $4047da273e09ef71$export$1405b80fcb4301ca;

});

parcelRegister("rwCCm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI2nS = parcelRequire("bI2nS");


var $kCECX = parcelRequire("kCECX");


var $3PHGt = parcelRequire("3PHGt");


var $gbf0M = parcelRequire("gbf0M");


var $cMyWi = parcelRequire("cMyWi");


var $9d7Pd = parcelRequire("9d7Pd");


var $6JWmx = parcelRequire("6JWmx");


var $kcs7l = parcelRequire("kcs7l");


var $cRImW = parcelRequire("cRImW");

const $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9 = {
    title: (0, $bI2nS.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))
};
const $ced5d6f40b3ce51c$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $cMyWi.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $cRImW.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $kcs7l.pluginKey).getState(editorState);
        const newAdf = (0, $gbf0M.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $kCECX.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $6JWmx.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        key: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle),
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($3PHGt)))({
            label: intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle)
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected
    }, intl.formatMessage((0, $bI2nS.messages).datasourceAppearanceTitle));
};
module.exports["datasourceDisplayInformation"] = $ced5d6f40b3ce51c$export$12f82ee4a2a1a1c9;
module.exports["DatasourceDropdownOption"] = $ced5d6f40b3ce51c$export$b08a863b9d82986d;

});

parcelRegister("kwknI", function(module, exports) {

var $4eqn3 = parcelRequire("4eqn3");


var $aeh46 = parcelRequire("aeh46");

function $735ee273a357b497$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $735ee273a357b497$export$26ada819291bd8df = (node)=>{
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $4eqn3.appearanceForNodeType)(node.type)) return true;
    return $735ee273a357b497$var$hasLinkMark(node);
};
function $735ee273a357b497$export$d3d4c2526aede29a(node) {
    if ($735ee273a357b497$export$962cfe99b8da8614(node)) return (0, $aeh46.EVENT_SUBJECT).DATASOURCE;
    if ($735ee273a357b497$export$26ada819291bd8df(node)) return (0, $aeh46.EVENT_SUBJECT).LINK;
    return null;
}
function $735ee273a357b497$export$599e1b655555ab1d(node) {
    const appearance = (0, $4eqn3.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $735ee273a357b497$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $735ee273a357b497$var$hasLinkMark = (node)=>{
    return !!$735ee273a357b497$var$getLinkMark(node);
};
function $735ee273a357b497$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $735ee273a357b497$var$getLinkMark(node)?.attrs?.href;
}
const $735ee273a357b497$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $735ee273a357b497$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $735ee273a357b497$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $735ee273a357b497$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $735ee273a357b497$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($735ee273a357b497$export$94df0e59ebebf4a7(a.node) !== $735ee273a357b497$export$94df0e59ebebf4a7(b.node) || $735ee273a357b497$export$599e1b655555ab1d(a.node) !== $735ee273a357b497$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};
module.exports["getNodeSubject"] = $735ee273a357b497$export$d3d4c2526aede29a;
module.exports["appearanceForLink"] = $735ee273a357b497$export$599e1b655555ab1d;
module.exports["getUrl"] = $735ee273a357b497$export$94df0e59ebebf4a7;
module.exports["getNodeContext"] = $735ee273a357b497$export$c63a892fcfc539bc;
module.exports["findAtPositions"] = $735ee273a357b497$export$7ea2145b3909e5c6;
module.exports["findInNodeRange"] = $735ee273a357b497$export$dbc52ec0d340ce50;
module.exports["areSameNodes"] = $735ee273a357b497$export$1f3592a520a7960d;

});

parcelRegister("nnUSM", function(module, exports) {
/**
 * Enable media inline images feature based on
 * mediaOptions.featureFlags.mediaInline, mediaOptions.allowMediaInlineImages
 *
 * The reason not using mediaOption as param is because MediaOption is from editor-plugin-media
 * we want to avoid circular deps
 * @param allowMediaInline MediaOptions.featureFlags.mediaInline
 * @param allowMediaInlineImages MediaOptions.allowMediaInlineImages
 * @returns boolean
 */ const $f038d7c047d84918$export$a82bf3f59adcc8aa = (allowMediaInline, allowMediaInlineImages)=>{
    return allowMediaInline && allowMediaInlineImages;
};
module.exports["mediaInlineImagesEnabled"] = $f038d7c047d84918$export$a82bf3f59adcc8aa;

});

parcelRegister("H8AVk", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $b8DpU = parcelRequire("b8DpU");


var $lVAkE = parcelRequire("lVAkE");

var $jzePg = parcelRequire("jzePg");

var $c7UOz = parcelRequire("c7UOz");

var $inM0i = parcelRequire("inM0i");


var $2w79Z = parcelRequire("2w79Z");

var $gtLXJ = parcelRequire("gtLXJ");

var $iso5o = parcelRequire("iso5o");

var $eS0D9 = parcelRequire("eS0D9");

var $95ME4 = parcelRequire("95ME4");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $bjg0G = parcelRequire("bjg0G");


var $8f29X = parcelRequire("8f29X");


var $geUVX = parcelRequire("geUVX");


var $7O00G = parcelRequire("7O00G");

const $7692f098a0f49996$export$bbcb7fa97854e414 = (state)=>{
    const node = state.schema.nodes.mediaInline.create({});
    return (0, $bjg0G.canInsert)(state.selection.$to, (0, $aPdNQ.Fragment).from(node));
};
const $7692f098a0f49996$var$getInsertMediaGroupAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    let media = '';
    if (mediaState.length === 1) media = mediaState[0].fileMimeType || 'unknown';
    else if (mediaState.length > 1) media = 'multiple';
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_GROUP,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
const $7692f098a0f49996$var$getInsertMediaInlineAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
};
const $7692f098a0f49996$export$226108e53ed56d7b = (mediaState, actionSubjectId, inputMethod, insertMediaVia, reason)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $krYZG.ACTION).FAILED_TO_INSERT,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia,
            reason: reason
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
};
/**
 * Check if current editor selections is a media group or not.
 * @param state Editor state
 */ function $7692f098a0f49996$var$isSelectionMediaGroup(state) {
    const { schema: schema } = state;
    const selectionParent = state.selection.$anchor.node();
    return selectionParent && selectionParent.type === schema.nodes.mediaGroup;
}
/**
 * Insert a paragraph after if reach the end of doc
 * and there is no media group in the front or selection is a non media block node
 * @param node Node at insertion point
 * @param state Editor state
 */ function $7692f098a0f49996$var$shouldAppendParagraph(state, node) {
    const { schema: { nodes: { media: media } } } = state;
    const wasMediaNode = node && node.type === media;
    return ((0, $2w79Z.insideTableCell)(state) || (0, $2w79Z.isInListItem)(state) || (0, $gtLXJ.isInLayoutColumn)(state) || (0, $jzePg.atTheEndOfDoc)(state) && (!(0, $geUVX.posOfPrecedingMediaGroup)(state) || (0, $geUVX.isSelectionNonMediaBlockNode)(state))) && !wasMediaNode;
}
/**
 * Check if node of type has been inserted successfully
 */ const $7692f098a0f49996$var$hasInsertedNodeOfType = (tr, nodeType)=>{
    let insertPos = -1;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $eOaGc.ReplaceStep)) step.slice.content.forEach((node)=>{
            if (node.type.name === nodeType) insertPos = step.from;
        });
    });
    if (insertPos === -1 || tr.doc.nodeAt(insertPos)?.type.name !== nodeType) return false;
    return true;
};
const $7692f098a0f49996$export$9996196b21d597d4 = (editorAnalyticsAPI)=>(view, mediaState, collection, allowInlineImages, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { schema: schema, tr: tr } = state;
        const { mediaInline: mediaInline } = schema.nodes;
        // Do nothing if no media found
        if (!mediaInline || !mediaState || collection === undefined) return false;
        const { id: id, dimensions: dimensions, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const mediaInlineAttrs = {
            id: id,
            collection: collection
        };
        if (allowInlineImages && (0, $8f29X.isImage)(mediaState.fileMimeType)) {
            const { width: width, height: height } = dimensions || {
                width: undefined,
                height: undefined
            };
            const scaledWidth = width ? Math.round(width / scaleFactor) : (0, $b8DpU.DEFAULT_IMAGE_WIDTH);
            const scaledHeight = height ? Math.round(height / scaleFactor) : (0, $b8DpU.DEFAULT_IMAGE_HEIGHT);
            mediaInlineAttrs.width = scaledWidth;
            mediaInlineAttrs.height = scaledHeight;
            mediaInlineAttrs.type = 'image';
            mediaInlineAttrs.alt = fileName;
        }
        const mediaInlineNode = mediaInline.create(mediaInlineAttrs);
        const space = state.schema.text(' ');
        let pos = state.selection.$to.pos;
        // If the selection is inside an empty list item or panel set pos inside paragraph
        if ((0, $7O00G.isInSupportedInlineImageParent)(state) && (0, $geUVX.isInsidePotentialEmptyParagraph)(state)) pos = pos + 1;
        const content = (0, $aPdNQ.Fragment).from([
            mediaInlineNode,
            space
        ]);
        // Delete the selection if a selection is made
        const deleteRange = $7692f098a0f49996$var$findDeleteRange(state);
        let payload;
        try {
            if (!deleteRange) tr.insert(pos, content);
            else tr.insert(pos, content).deleteRange(deleteRange.start, deleteRange.end);
            if ($7692f098a0f49996$var$hasInsertedNodeOfType(tr, 'mediaInline')) payload = $7692f098a0f49996$var$getInsertMediaInlineAnalytics(mediaState, inputMethod, insertMediaVia);
            else payload = $7692f098a0f49996$export$226108e53ed56d7b(mediaState, (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia);
        } catch (error) {
            payload = $7692f098a0f49996$export$226108e53ed56d7b(mediaState, (0, $krYZG.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.toString());
        }
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        dispatch(tr);
        return true;
    };
const $7692f098a0f49996$export$9cc886ab7b992a97 = (editorAnalyticsAPI)=>(view, mediaStates, collection, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { tr: tr, schema: schema } = state;
        const { media: media, paragraph: paragraph } = schema.nodes;
        // Do nothing if no media found
        if (!media || !mediaStates.length) return;
        const mediaNodes = $7692f098a0f49996$var$createMediaFileNodes(mediaStates, collection, media);
        const mediaInsertPos = $7692f098a0f49996$var$findMediaInsertPos(state);
        const resolvedInsertPos = tr.doc.resolve(mediaInsertPos);
        const parent = resolvedInsertPos.parent;
        const nodeAtInsertionPoint = tr.doc.nodeAt(mediaInsertPos);
        const shouldSplit = !$7692f098a0f49996$var$isSelectionMediaGroup(state) && (0, $iso5o.isSupportedInParent)(state, (0, $aPdNQ.Fragment).from(state.schema.nodes.mediaGroup.createChecked({}, mediaNodes)));
        const withParagraph = $7692f098a0f49996$var$shouldAppendParagraph(state, nodeAtInsertionPoint);
        let content = parent.type === schema.nodes.mediaGroup ? mediaNodes // If parent is a mediaGroup do not wrap items again.
         : [
            schema.nodes.mediaGroup.createChecked({}, mediaNodes)
        ];
        if (shouldSplit) {
            content = withParagraph ? content.concat(paragraph.create()) : content;
            // delete the selection or empty paragraph
            const deleteRange = $7692f098a0f49996$var$findDeleteRange(state);
            if (!deleteRange) tr.insert(mediaInsertPos, content);
            else if (mediaInsertPos <= deleteRange.start) tr.deleteRange(deleteRange.start, deleteRange.end).insert(mediaInsertPos, content);
            else tr.insert(mediaInsertPos, content).deleteRange(deleteRange.start, deleteRange.end);
            editorAnalyticsAPI?.attachAnalyticsEvent($7692f098a0f49996$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
            dispatch(tr);
            $7692f098a0f49996$var$setSelectionAfterMediaInsertion(view);
            return;
        }
        // Don't append new paragraph when adding media to a existing mediaGroup
        if (withParagraph && parent.type !== schema.nodes.mediaGroup) content.push(paragraph.create());
        editorAnalyticsAPI?.attachAnalyticsEvent($7692f098a0f49996$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
        dispatch((0, $bjg0G.safeInsert)((0, $aPdNQ.Fragment).fromArray(content), mediaInsertPos)(tr));
    };
const $7692f098a0f49996$var$createMediaFileNodes = (mediaStates, collection, media)=>{
    const nodes = mediaStates.map((mediaState)=>{
        const { id: id } = mediaState;
        const node = media.create({
            id: id,
            type: 'file',
            collection: collection
        });
        (0, $geUVX.copyOptionalAttrsFromMediaState)(mediaState, node);
        return node;
    });
    return nodes;
};
/**
 * Find root list node if exist from current selection
 * @param state Editor state
 */ const $7692f098a0f49996$var$findRootListNode = (state)=>{
    const { schema: { nodes: { bulletList: bulletList, orderedList: orderedList } } } = state;
    return (0, $2w79Z.findFarthestParentNode)((node)=>node.type === bulletList || node.type === orderedList)(state.selection.$from);
};
const $7692f098a0f49996$export$cbffff148fb3b8a6 = (state)=>{
    const { schema: { nodes: { mediaGroup: mediaGroup, listItem: listItem } } } = state;
    // 1. Check if I am inside a list.
    if ((0, $bjg0G.hasParentNode)((node)=>node.type === listItem)(state.selection)) {
        // 2. Get end position of root list
        const rootListNode = $7692f098a0f49996$var$findRootListNode(state);
        if (rootListNode) {
            const pos = rootListNode.pos + rootListNode.node.nodeSize;
            // 3. Fint the first location inside the media group
            const nextNode = state.doc.nodeAt(pos);
            if (nextNode && nextNode.type === mediaGroup) return pos + 1;
            return pos;
        }
    }
    return;
};
/**
 * Find insertion point,
 * If it is in a List it will return position to the next block,
 * If there are any media group close it will return this position
 * Otherwise, It will return the respective block given selection.
 * @param content Content to be inserted
 * @param state Editor state
 */ const $7692f098a0f49996$var$findMediaInsertPos = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    // Check if selection is inside a list.
    const posInList = $7692f098a0f49996$export$cbffff148fb3b8a6(state);
    if (posInList) // If I have a position in lists, I should return, otherwise I am not inside a list
    return posInList;
    const nearbyMediaGroupPos = (0, $geUVX.posOfMediaGroupNearby)(state);
    if (nearbyMediaGroupPos && (!(0, $geUVX.isSelectionNonMediaBlockNode)(state) || $from.pos < nearbyMediaGroupPos && $to.pos < nearbyMediaGroupPos)) return nearbyMediaGroupPos;
    if ((0, $geUVX.isSelectionNonMediaBlockNode)(state)) return $to.pos;
    if ((0, $lVAkE.atTheEndOfBlock)(state)) return $to.pos + 1;
    if ((0, $lVAkE.atTheBeginningOfBlock)(state)) return $from.pos - 1;
    return $to.pos;
};
const $7692f098a0f49996$var$findDeleteRange = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ((0, $geUVX.posOfParentMediaGroup)(state)) return;
    if (!(0, $geUVX.isInsidePotentialEmptyParagraph)(state) || (0, $geUVX.posOfMediaGroupNearby)(state)) return $7692f098a0f49996$var$range($from.pos, $to.pos);
    return $7692f098a0f49996$var$range((0, $inM0i.startPositionOfParent)($from) - 1, (0, $c7UOz.endPositionOfParent)($to));
};
const $7692f098a0f49996$var$range = (start, end = start)=>{
    return {
        start: start,
        end: end
    };
};
const $7692f098a0f49996$var$setSelectionAfterMediaInsertion = (view)=>{
    const { state: state } = view;
    const { doc: doc } = state;
    const mediaPos = (0, $geUVX.posOfMediaGroupNearby)(state);
    if (!mediaPos) return;
    const $mediaPos = doc.resolve(mediaPos);
    const endOfMediaGroup = (0, $c7UOz.endPositionOfParent)($mediaPos);
    if (endOfMediaGroup + 1 >= doc.nodeSize - 1) // if nothing after the media group, fallback to select the newest uploaded media item
    (0, $eS0D9.setNodeSelection)(view, mediaPos);
    else (0, $95ME4.setTextSelection)(view, endOfMediaGroup + 1);
};
module.exports["canInsertMediaInline"] = $7692f098a0f49996$export$bbcb7fa97854e414;
module.exports["insertMediaInlineNode"] = $7692f098a0f49996$export$9996196b21d597d4;
module.exports["insertMediaGroupNode"] = $7692f098a0f49996$export$9cc886ab7b992a97;

});

parcelRegister("7O00G", function(module, exports) {

var $nnUSM = parcelRequire("nnUSM");


var $2w79Z = parcelRequire("2w79Z");


var $bjg0G = parcelRequire("bjg0G");


var $c2smn = parcelRequire("c2smn");


var $ixfCV = parcelRequire("ixfCV");


var $H8AVk = parcelRequire("H8AVk");


var $d55P7 = parcelRequire("d55P7");


var $8f29X = parcelRequire("8f29X");


var $geUVX = parcelRequire("geUVX");

const $c4ae61056a4cbca8$export$31a926ac827892a0 = (state)=>{
    return (0, $bjg0G.hasParentNodeOfType)([
        state.schema.nodes.listItem
    ])(state.selection);
};
const $c4ae61056a4cbca8$export$600118b0ad66a68c = (state, mediaOptions, fileMimeType)=>{
    if ((0, $8f29X.isImage)(fileMimeType) && (0, $ixfCV.fg)('platform_editor_media_block_default')) {
        if ((0, $d55P7.isMediaSingle)(state.schema, fileMimeType)) return 'block';
        return 'group';
    }
    const canInsertInlineNode = (0, $c2smn.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags) && !(0, $2w79Z.isInEmptyLine)(state) && (!(0, $geUVX.isInsidePotentialEmptyParagraph)(state) || $c4ae61056a4cbca8$export$31a926ac827892a0(state)) && (0, $H8AVk.canInsertMediaInline)(state);
    if ((0, $ixfCV.fg)('platform_editor_remove_media_inline_feature_flag')) {
        if (mediaOptions?.allowMediaInlineImages) {
            if (canInsertInlineNode && !(0, $8f29X.isVideo)(fileMimeType)) return 'inline';
        }
    } else if ((0, $nnUSM.mediaInlineImagesEnabled)((0, $c2smn.getMediaFeatureFlag)('mediaInline', mediaOptions?.featureFlags), mediaOptions?.allowMediaInlineImages)) {
        if (canInsertInlineNode && !(0, $8f29X.isVideo)(fileMimeType)) return 'inline';
    }
    if ((0, $d55P7.isMediaSingle)(state.schema, fileMimeType)) return 'block';
    else if (canInsertInlineNode) return 'inline';
    return 'group';
};
module.exports["isInSupportedInlineImageParent"] = $c4ae61056a4cbca8$export$31a926ac827892a0;
module.exports["getMediaNodeInsertionType"] = $c4ae61056a4cbca8$export$600118b0ad66a68c;

});

parcelRegister("1c9Nx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ee09825f32649dc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $2gLCX = parcelRequire("2gLCX");


var $kkFbH = parcelRequire("kkFbH");


var $7SGh9 = parcelRequire("7SGh9");

const $9ee09825f32649dc$var$iconWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-icon-accent-blue, #357DE8)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-accent-blue-subtle, #669DF1)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-300, 24px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7SGh9.FILE_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $7SGh9.MEDIA_HEIGHT)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $9ee09825f32649dc$var$dropLineStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-border-focused, #4688EC)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-025, 2px)"} 0`,
    width: '100%',
    height: '2px'
});
const $9ee09825f32649dc$var$IconWrapperComponent = (props)=>{
    const { intl: intl } = props;
    const { dropPlaceholderLabel: dropPlaceholderLabel } = (0, $2gLCX.dropPlaceholderMessages);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9ee09825f32649dc$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: intl.formatMessage(dropPlaceholderLabel)
    }));
};
const $9ee09825f32649dc$var$IntlIconWrapper = (0, $kSwu1.injectIntl)($9ee09825f32649dc$var$IconWrapperComponent);
var $9ee09825f32649dc$export$2e2bcd8739ae039 = ({ type: type = 'group' })=>type === 'single' ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $9ee09825f32649dc$var$dropLineStyles
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)($9ee09825f32649dc$var$IntlIconWrapper, null);

});

parcelRegister("fw4RS", function(module, exports) {
const $41a00781868123b2$export$92a1a3b7554e9387 = {
    SHOW_MEDIA_VIEWER: 'SHOW_MEDIA_VIEWER',
    HIDE_MEDIA_VIEWER: 'HIDE_MEDIA_VIEWER',
    TRACK_MEDIA_PASTE: 'TRACK_MEDIA_PASTE',
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};
module.exports["ACTIONS"] = $41a00781868123b2$export$92a1a3b7554e9387;

});

parcelRegister("3pg0a", function(module, exports) {
class $36de7dc3b0914486$export$8e609ae1a23dff23 {
    constructor(){
        this.pendingTask = Promise.resolve(null);
        this.taskMap = new Map();
        this.cancelPendingTask = (id)=>{
            const task = this.taskMap.get(id);
            if (task && !task.cancelController.signal.aborted) task.cancelController.abort();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.waitForPendingTasks = async (timeout, lastTask)=>{
            if (lastTask && this.pendingTask === lastTask) return lastTask;
            const chainedPromise = this.pendingTask.then(()=>// Call ourselves to make sure that no new pending tasks have been
                // added before the current promise has resolved.
                this.waitForPendingTasks(undefined, this.pendingTask));
            if (!timeout) return chainedPromise;
            let rejectTimeout;
            const timeoutPromise = new Promise((_resolve, reject)=>{
                rejectTimeout = window.setTimeout(()=>reject(new Error(`Media operations did not finish in ${timeout} ms`)), timeout);
            });
            return Promise.race([
                timeoutPromise,
                chainedPromise.then((value)=>{
                    clearTimeout(rejectTimeout);
                    return value;
                })
            ]);
        };
        this.resumePendingTask = (id)=>{
            const mediaTask = this.taskMap.get(id);
            if (mediaTask && mediaTask.cancelController.signal.aborted) this.addPendingTask(mediaTask.task, id);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task, id)=>{
            let currentTask = task;
            if (id) {
                const cancelController = new AbortController();
                const signal = cancelController.signal;
                this.taskMap.set(id, {
                    task: task,
                    cancelController: cancelController
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                currentTask = new Promise((resolve)=>{
                    task.then(resolve, resolve).finally(()=>{
                        this.taskMap.delete(id);
                    });
                    signal.onabort = ()=>{
                        resolve(null);
                    };
                });
            }
            // Chain the previous promise with a new one for this media item
            const currentPendingTask = this.pendingTask;
            const pendingPromise = ()=>currentPendingTask;
            this.pendingTask = currentTask.then(pendingPromise, pendingPromise);
            return this.pendingTask;
        };
    }
}
module.exports["MediaTaskManager"] = $36de7dc3b0914486$export$8e609ae1a23dff23;

});

parcelRegister("IRDCg", function(module, exports) {

var $eJkRA = parcelRequire("eJkRA");

class $5415f4aae275fe53$export$2e2bcd8739ae039 {
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async init() {
        let picker;
        if (this.pickerType === 'customMediaPicker') picker = this.picker = this.pickerConfig;
        if (!picker) return this;
        picker.on('upload-preview-update', this.handleUploadPreviewUpdate);
        picker.on('upload-end', this.handleReady);
        picker.on('upload-error', this.handleUploadError);
        picker.on('mobile-upload-end', this.handleMobileUploadEnd);
        return this;
    }
    get type() {
        return this.pickerType;
    }
    get mediaPicker() {
        return this.picker;
    }
    destroy() {
        const { picker: picker } = this;
        if (!picker) return;
        picker.removeAllListeners('upload-preview-update');
        picker.removeAllListeners('upload-end');
        picker.removeAllListeners('upload-error');
        this.onStartListeners = [];
        this.onDragListeners = [];
    }
    setUploadParams(params) {
        if (this.picker) this.picker.setUploadParams(params);
    }
    onNewMedia(cb) {
        this.onStartListeners.push(cb);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onDrag(cb) {
        this.onDragListeners.push(cb);
    }
    constructor(pickerType, config, pickerConfig, analyticsName){
        this.config = config;
        this.pickerConfig = pickerConfig;
        this.picker = void 0;
        this.onDragListeners = [];
        this.pickerType = void 0;
        this.onStartListeners = [];
        this.eventListeners = {};
        this.analyticsName = void 0;
        this.erroredFiles = void 0;
        this.handleUploadPreviewUpdate = (event)=>{
            const { file: file, preview: preview } = event;
            //check if upload-error was called before upload-preview-update
            const isErroredFile = this.erroredFiles.has(file.id);
            const { dimensions: dimensions, scaleFactor: scaleFactor } = (0, $eJkRA.isImagePreview)(preview) ? preview : {
                dimensions: undefined,
                scaleFactor: undefined
            };
            const state = {
                id: file.id,
                fileName: file.name,
                fileSize: file.size,
                fileMimeType: file.type,
                collection: file.collectionName,
                dimensions: dimensions,
                scaleFactor: scaleFactor,
                status: isErroredFile ? 'error' : undefined
            };
            this.eventListeners[file.id] = [];
            this.onStartListeners.forEach((cb)=>cb(state, (evt)=>this.subscribeStateChanged(file, evt), this.analyticsName || this.pickerType));
        };
        this.subscribeStateChanged = (file, onStateChanged)=>{
            const subscribers = this.eventListeners[file.id];
            if (!subscribers) return;
            subscribers.push(onStateChanged);
        };
        this.handleUploadError = ({ error: error, fileId: fileId })=>{
            const listeners = this.eventListeners[fileId];
            this.erroredFiles.add(fileId);
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: fileId,
                    status: 'error',
                    error: error && {
                        description: error.description,
                        name: error.name
                    }
                }));
            // remove listeners
            delete this.eventListeners[fileId];
        };
        this.handleMobileUploadEnd = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'mobile-upload-end',
                    fileMimeType: file.type,
                    collection: file.collectionName,
                    publicId: file.publicId
                }));
        };
        this.handleReady = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'ready'
                }));
            // remove listeners
            delete this.eventListeners[file.id];
        };
        this.pickerType = pickerType;
        this.analyticsName = analyticsName;
        this.erroredFiles = new Set();
    }
}
module.exports["default"] = $5415f4aae275fe53$export$2e2bcd8739ae039;

});

parcelRegister("gdCrd", function(module, exports) {
function $91314dde49c4d0b6$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
module.exports["calculateOffsetLeft"] = $91314dde49c4d0b6$export$ab1f1890e4428242;

});

parcelRegister("cRsJ5", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

const $7110be196546c8f0$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $4G6PK.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $4G6PK.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
module.exports["calcMinWidth"] = $7110be196546c8f0$export$c7eaa4d46a45395;

});

parcelRegister("7ZFkz", function(module, exports) {

var $4mCw6 = parcelRequire("4mCw6");


var $jsWW5 = parcelRequire("jsWW5");

const $19ce70a877fe6092$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $jsWW5.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $4mCw6.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
module.exports["getMaxWidthForNestedNode"] = $19ce70a877fe6092$export$4147ff5cc31ec064;

});

parcelRegister("ca8W8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9gPd6 = parcelRequire("9gPd6");


var $kejMu = parcelRequire("kejMu");

const $1a9f4c10e7a8eec7$export$f6eb6537c5785f1e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { component: component, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents } = t0;
    if (!(0, $kejMu.willComponentRender)(component, childrenMap)) return null;
    let t1;
    if ($[0] !== childrenMap || $[1] !== component.key) {
        t1 = childrenMap.get(component.key);
        $[0] = childrenMap;
        $[1] = component.key;
        $[2] = t1;
    } else t1 = $[2];
    const children = t1;
    const Component = component.component ?? fallbacks?.[component.type] ?? (0, $kejMu.PassThrough);
    let t2;
    if ($[3] !== component.key || $[4] !== component.type) {
        t2 = {
            key: component.key,
            type: component.type
        };
        $[3] = component.key;
        $[4] = component.type;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== parents || $[7] !== t2) {
        t3 = [
            ...parents,
            t2
        ];
        $[6] = parents;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const newParents = t3;
    if (!children || children.length === 0) {
        let t4;
        if ($[9] !== Component || $[10] !== parents) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                parents: parents
            }, null);
            $[9] = Component;
            $[10] = parents;
            $[11] = t4;
        } else t4 = $[11];
        return t4;
    }
    let t4;
    if ($[12] !== children || $[13] !== childrenMap || $[14] !== fallbacks || $[15] !== newParents) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gPd6.SurfaceComponents), {
            components: children,
            childrenMap: childrenMap,
            fallbacks: fallbacks,
            parents: newParents
        });
        $[12] = children;
        $[13] = childrenMap;
        $[14] = fallbacks;
        $[15] = newParents;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== Component || $[18] !== parents || $[19] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            parents: parents
        }, t4);
        $[17] = Component;
        $[18] = parents;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    return t5;
} : ({ component: component, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents })=>{
    if (!(0, $kejMu.willComponentRender)(component, childrenMap)) return null;
    const children = childrenMap.get(component.key);
    const Component = component.component ?? fallbacks?.[component.type] ?? (0, $kejMu.PassThrough);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (!children || children.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        parents: parents
    }, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        parents: parents
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gPd6.SurfaceComponents), {
        components: children,
        childrenMap: childrenMap,
        fallbacks: fallbacks,
        parents: newParents
    }));
};
module.exports["SurfaceComponent"] = $1a9f4c10e7a8eec7$export$f6eb6537c5785f1e;

});

parcelRegister("7ux9d", function(module, exports) {
const $b71ea0f2bbb43450$export$98148b07df5ff68c = (nodes)=>{
    return [
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList
    ].filter(Boolean);
};
module.exports["getSupportedListTypes"] = $b71ea0f2bbb43450$export$98148b07df5ff68c;

});

parcelRegister("c9tks", function(module, exports) {
const $2d70832f610b56f2$export$3b2ae917fa66948c = (node, schema)=>{
    const { paragraph: paragraph, hardBreak: hardBreak } = schema.nodes;
    if (node.type === paragraph) return [
        ...node.content.content
    ];
    if (node.isBlock) {
        const textContent = node.textContent;
        const lines = textContent.split('\n');
        const newText = [];
        lines.forEach((line, index)=>{
            if (line !== '') newText.push(line ? schema.text(line) : schema.text(' '));
            if (lines.length > 1 && index !== lines.length - 1) newText.push(hardBreak.create());
        });
        return newText;
    }
    return [
        node
    ];
};
module.exports["convertBlockToInlineContent"] = $2d70832f610b56f2$export$3b2ae917fa66948c;

});

parcelRegister("2w4SV", function(module, exports) {

var $j8XGH = parcelRequire("j8XGH");


var $lVAkE = parcelRequire("lVAkE");

var $1GYCH = parcelRequire("1GYCH");


var $g6uqx = parcelRequire("g6uqx");


var $kCECX = parcelRequire("kCECX");


var $WABbQ = parcelRequire("WABbQ");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $bOZni = parcelRequire("bOZni");


var $i2jOy = parcelRequire("i2jOy");

const $2741375fabeec33a$var$isPosWithinRange = (pos, range)=>{
    return range.start <= pos && range.end >= pos + 1;
};
/**
 * Expands the current selection to encompass the full block range
 * starting from the given resolved position.
 */ const $2741375fabeec33a$var$getExpandedSelectionRange = ({ selection: selection, doc: doc, resolvedStartPos: resolvedStartPos, isShiftPressed: isShiftPressed })=>{
    // When not pressing shift, expand the current selection
    // When shift selecting upwards, expand from start of node to selection end
    // When shift selecting downwards, expand from selection start to end of node
    const selectUp = resolvedStartPos.pos < selection.from;
    const $from = isShiftPressed && selectUp ? resolvedStartPos : selection.$from;
    const $to = isShiftPressed && !selectUp ? doc.resolve(resolvedStartPos.pos + 1) : selection.$to;
    const adjusted = isShiftPressed ? {
        $from: $from,
        $to: $to
    } : (0, $i2jOy.adjustSelectionBoundsForEdgePositions)($from, $to);
    return (0, $lVAkE.expandToBlockRange)(adjusted.$from, adjusted.$to);
};
const $2741375fabeec33a$export$35df69b489f451a1 = ({ tr: tr, selection: selection, startPos: startPos, isShiftPressed: isShiftPressed, nodeType: nodeType, api: api })=>{
    const resolvedStartPos = tr.doc.resolve(startPos);
    const expandedRange = $2741375fabeec33a$var$getExpandedSelectionRange({
        doc: tr.doc,
        selection: selection,
        resolvedStartPos: resolvedStartPos,
        isShiftPressed: isShiftPressed
    });
    // Set selection to expanded selection range if it encompasses the clicked drag handle
    if (expandedRange.range && $2741375fabeec33a$var$isPosWithinRange(startPos, expandedRange.range) && (0, $1GYCH.isMultiBlockRange)(expandedRange.range)) // Then create a selection from the start of the first node to the end of the last node
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(selection.from, expandedRange.$from.pos), Math.max(selection.to, expandedRange.$to.pos)));
    else if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $ixfCV.fg)('platform_editor_maui_jira_updates') && ((0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)) || (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true))) // Under the gate (and when on the simplified newGetSelection path), use
    // the platform-level composer — same path as open-remix-modal, no drift.
    (0, $j8XGH.selectNodeAtPos)(tr, startPos, nodeType);
    else if (nodeType === 'table') (0, $WABbQ.selectTableClosestToPos)(tr, tr.doc.resolve(startPos + 1));
    else // Select the clicked drag handle's node only
    (0, $bOZni.selectNode)(tr, startPos, nodeType, api);
};
module.exports["expandAndUpdateSelection"] = $2741375fabeec33a$export$35df69b489f451a1;

});

parcelRegister("frZvB", function(module, exports) {
/** @jsxRuntime classic */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $lOiVq = parcelRequire("lOiVq");

function $11a45f4f8c8dbe6d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $11a45f4f8c8dbe6d$var$spanStyles = {
    name: "jpyn4z",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0"
};
const $11a45f4f8c8dbe6d$var$svgSizeStyles = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $11a45f4f8c8dbe6d$var$svgStyles = {
    name: "1l1mozn",
    styles: "color:currentColor;overflow:hidden;pointer-events:none;vertical-align:bottom"
};
const $11a45f4f8c8dbe6d$export$bd2793d885851030 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "aria-hidden": true,
        css: $11a45f4f8c8dbe6d$var$spanStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "-8 -8 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        css: [
            $11a45f4f8c8dbe6d$var$svgStyles,
            $11a45f4f8c8dbe6d$var$svgSizeStyles
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "2.75",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("circle", {
        cx: "8",
        cy: "13.25",
        r: "1.75",
        fill: "currentColor"
    })));
};
module.exports["DragHandleNestedIcon"] = $11a45f4f8c8dbe6d$export$bd2793d885851030;

});

parcelRegister("9BGzJ", function(module, exports) {

var $8dxef = parcelRequire("8dxef");

const $eb345a349d4a6459$var$previewStyle = {
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 3px)",
    borderWidth: "var(--ds-border-width-selected, 2px)",
    backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $eb345a349d4a6459$var$getPreviewContainerDimensionsForSingle = (dom, nodeType)=>{
    let nodeContainer = dom;
    const iframeContainer = dom.querySelector('iframe');
    if (nodeType === 'embedCard') nodeContainer = dom.querySelector('.rich-media-item') || dom;
    else if (nodeType === 'extension' && iframeContainer) nodeContainer = iframeContainer;
    const nodeContainerRect = nodeContainer.getBoundingClientRect();
    return {
        width: nodeContainerRect.width,
        height: nodeContainerRect.height
    };
};
const $eb345a349d4a6459$var$getPreviewContainerDimensions = (dragPreviewContent)=>{
    let maxWidth = 0;
    let heightSum = 0;
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const { width: width, height: height } = $eb345a349d4a6459$var$getPreviewContainerDimensionsForSingle(element.dom, element.nodeType);
        if (width > maxWidth) maxWidth = width;
        heightSum += height;
    }
    return {
        width: maxWidth,
        height: heightSum
    };
};
const $eb345a349d4a6459$var$createGenericPreview = ()=>{
    const generalPreview = document.createElement('div');
    // ProseMirror class is required to make sure the cloned dom is styled correctly
    generalPreview.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    generalPreview.style.border = `${$eb345a349d4a6459$var$previewStyle.borderWidth} ${$eb345a349d4a6459$var$previewStyle.borderStyle} ${$eb345a349d4a6459$var$previewStyle.borderColor}`;
    generalPreview.style.borderRadius = $eb345a349d4a6459$var$previewStyle.borderRadius;
    generalPreview.style.backgroundColor = $eb345a349d4a6459$var$previewStyle.backgroundColor;
    generalPreview.style.height = '100%';
    generalPreview.setAttribute('data-testid', 'block-ctrl-generic-drag-preview');
    return generalPreview;
};
const $eb345a349d4a6459$var$createContentPreviewElement = (dom, nodeType, nodeSpacing)=>{
    const contentPreviewOneElement = document.createElement('div');
    contentPreviewOneElement.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    const resizer = dom.querySelector('.resizer-item');
    const clonedDom = resizer && [
        'mediaSingle',
        'table'
    ].includes(nodeType) ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    resizer.cloneNode(true) : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom.cloneNode(true);
    const browser = (0, $8dxef.getBrowserInfo)();
    clonedDom.style.marginLeft = '0';
    clonedDom.style.marginTop = nodeSpacing ? `${nodeSpacing.top}` : '0';
    clonedDom.style.marginRight = '0';
    clonedDom.style.marginBottom = nodeSpacing ? `${nodeSpacing.bottom}` : '0';
    clonedDom.style.boxShadow = 'none';
    clonedDom.style.opacity = browser.windows ? '1' : '0.31';
    contentPreviewOneElement.appendChild(clonedDom);
    return contentPreviewOneElement;
};
const $eb345a349d4a6459$var$isGenericPreview = (dom, nodeType)=>{
    const embedCard = dom.querySelector('.embedCardView-content-wrap');
    return nodeType === 'embedCard' || !!embedCard || nodeType === 'extension' && !!dom.querySelector('iframe');
};
const $eb345a349d4a6459$var$createPreviewForElement = (dom, nodeType, nodeSpacing)=>{
    const shouldBeGenericPreview = $eb345a349d4a6459$var$isGenericPreview(dom, nodeType);
    if (shouldBeGenericPreview) return $eb345a349d4a6459$var$createGenericPreview();
    else return $eb345a349d4a6459$var$createContentPreviewElement(dom, nodeType, nodeSpacing);
};
const $eb345a349d4a6459$export$3ec2e625089820fa = (container, dragPreviewContent)=>{
    container.style.pointerEvents = 'none';
    if (!Array.isArray(dragPreviewContent) && typeof dragPreviewContent === 'object') dragPreviewContent = [
        dragPreviewContent
    ];
    const { width: maxWidth, height: maxHeight } = $eb345a349d4a6459$var$getPreviewContainerDimensions(dragPreviewContent);
    container.style.width = `${maxWidth}px`;
    container.style.height = `${maxHeight}px`;
    const previewWrapperFragment = document.createDocumentFragment();
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const contentPreviewOneElement = $eb345a349d4a6459$var$createPreviewForElement(element.dom, element.nodeType, element.nodeSpacing);
        previewWrapperFragment.appendChild(contentPreviewOneElement);
    }
    container.appendChild(previewWrapperFragment);
    const scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    const scrollParentClassNames = scrollParent?.className;
    // Add the scroll parent class to the container to ensure the cloned element is styled correctly
    container.className = scrollParentClassNames || '';
    container.classList.remove('fabric-editor-popup-scroll-parent');
    // Prevents a scrollbar from showing
    container.style.overflow = 'visible';
    return ()=>container;
};
module.exports["dragPreview"] = $eb345a349d4a6459$export$3ec2e625089820fa;

});

parcelRegister("eYPgl", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");

const $aed74123127af613$export$148a39002dbd1689 = (isTopLevelNode, isLayoutColumn)=>{
    if (!(0, $ieeJu.expValEquals)('platform_editor_nested_drag_handle_icon', 'isEnabled', true)) return false;
    if (isTopLevelNode) return false;
    if (isLayoutColumn && !(0, $ixfCV.fg)('platform_editor_layout_column_menu_kill_switch_1')) return false;
    return true;
};
module.exports["shouldUseNestedDragHandleIcon"] = $aed74123127af613$export$148a39002dbd1689;

});

parcelRegister("4LOJc", function(module, exports) {

var $2w79Z = parcelRequire("2w79Z");


var $fqVYq = parcelRequire("fqVYq");


var $1gg4H = parcelRequire("1gg4H");


var $icvkv = parcelRequire("icvkv");

const $119770649cfd47fd$var$syncedBlockTypes = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $119770649cfd47fd$export$9d1974d3f03f9d59 = (isNested, node, /**
	 * Is the active node in the same layout as the target node
	 */ isSameLayout = false, activeNode, parentNode)=>{
    const isInsideBodiedSyncBlock = parentNode?.type.name === 'bodiedSyncBlock';
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', false) || isNested) {
        // If nested inside bodiedSyncBlock, enable inline drop target so user can drop to create a layout inside it
        if (isInsideBodiedSyncBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) return true;
        return false;
    }
    if ((0, $1gg4H.isWrappedMedia)(node)) return false;
    if (activeNode?.nodeType === 'layoutSection') return false;
    if (($119770649cfd47fd$var$syncedBlockTypes.includes(activeNode?.nodeType || '') || $119770649cfd47fd$var$syncedBlockTypes.includes(node?.type.name || '')) && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) return false;
    if (node?.type.name === 'layoutSection') return node.childCount < (0, $icvkv.maxLayoutColumnSupported)() || isSameLayout;
    return !(0, $2w79Z.isEmptyParagraph)(node);
};
module.exports["shouldAllowInlineDropTarget"] = $119770649cfd47fd$export$9d1974d3f03f9d59;

});

parcelRegister("fmErs", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ixfCV = parcelRequire("ixfCV");


var $vZEJe = parcelRequire("vZEJe");


var $iSrRp = parcelRequire("iSrRp");


var $ieeJu = parcelRequire("ieeJu");


var $9HWym = parcelRequire("9HWym");


var $d1Uph = parcelRequire("d1Uph");


var $a4QVD = parcelRequire("a4QVD");


var $8v85f = parcelRequire("8v85f");

function $64b8abc41abcb6e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH = '--editor-blocks-inline-hover-zone-width';
const $64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT = '--editor-blocks-inline-hover-zone-height';
const $64b8abc41abcb6e2$var$HOVER_ZONE_TOP = '--editor-blocks-inline-hover-zone-top';
const $64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM = '--editor-blocks-inline-hover-zone-bottom';
const $64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME = '--editor-blocks-inline-hover-zone-anchor-name';
const $64b8abc41abcb6e2$var$hoverZoneCommonStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    position: 'absolute',
    // above the top and bottom drop zone as block hover zone
    zIndex: 120,
    positionAnchor: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME})`,
    minWidth: "var(--ds-space-100, 8px)",
    left: 0,
    right: 0,
    width: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH})`,
    height: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT})`
});
const $64b8abc41abcb6e2$var$leftHoverZoneStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    right: `unset`,
    top: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_TOP})`,
    bottom: 'unset'
});
const $64b8abc41abcb6e2$var$rightHoverZoneStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    left: `unset`,
    top: 'unset',
    bottom: `var(${$64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM})`
});
// gap between node boundary and drop indicator/drop zone
const $64b8abc41abcb6e2$var$GAP = 4;
const $64b8abc41abcb6e2$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    height: '100%',
    position: 'absolute',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0,
    left: 0
});
const $64b8abc41abcb6e2$var$dropTargetLayoutHintLeftStyle = {
    name: "go864d",
    styles: "left:unset;right:0"
};
const $64b8abc41abcb6e2$var$defaultNodeDimension = {
    width: '0',
    height: '0',
    top: 'unset',
    bottom: 'unset'
};
const $64b8abc41abcb6e2$var$getWidthOffset = (node, width, position)=>{
    if ([
        'mediaSingle',
        'table',
        'embedCard'
    ].includes(node.type.name) || // block card (without datasource) is positioned left-aligned, hence share the same logic as align-start
    node.type.name === 'blockCard' && !node.attrs.datasource) {
        const isLeftPosition = position === 'left';
        if (node.attrs.layout === 'align-start' || node.type.name === 'blockCard') return isLeftPosition ? `-0.5*(var(--ak-editor--line-length) - ${width})` : `0.5*(var(--ak-editor--line-length) - ${width})`;
        else if (node?.attrs.layout === 'align-end') return isLeftPosition ? `0.5*(var(--ak-editor--line-length) - ${width})` : `-0.5*(var(--ak-editor--line-length) - ${width})`;
    }
    if (node.type.name === 'bodiedExtension' || node.type.name === 'extension' || node.type.name === 'multiBodiedExtension' && (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension')) return '-12px';
};
const $64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH = 42;
const $64b8abc41abcb6e2$export$ade48236ff38648e = ({ api: api, nextNode: nextNode, position: position, anchorRectCache: anchorRectCache, getPos: getPos })=>{
    const ref = (0, $cozmU.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const anchorName = (0, $cozmU.useMemo)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return nextNode ? api?.core.actions.getAnchorIdForNode(nextNode, getPos() ?? -1) || '' : '';
        return nextNode ? (0, $9HWym.getNodeAnchor)(nextNode) : '';
    }, [
        api,
        getPos,
        nextNode
    ]);
    const [isActiveAnchor] = (0, $d1Uph.useActiveAnchorTracker)(anchorName);
    const isLeftPosition = position === 'left';
    const nodeDimension = (0, $cozmU.useMemo)(()=>{
        if (!nextNode) return $64b8abc41abcb6e2$var$defaultNodeDimension;
        const nextNodePos = getPos();
        let innerContainerWidth = null;
        let targetAnchorName = anchorName;
        if ([
            'blockCard',
            'embedCard',
            'extension'
        ].includes(nextNode.type.name)) {
            if (nextNode.attrs.layout === 'wide') innerContainerWidth = `max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))`;
            else if (nextNode.attrs.layout === 'full-width') innerContainerWidth = `min(calc(100cqw - ${0, $7Y8M5.akEditorBreakoutPadding}px), 1800px)`;
            if (nextNode.type.name === 'blockCard' && !nextNode.attrs.layout && nextNode.attrs.datasource) // block card with sourceNode and without layout has different width in full-width vs fixed-width editor
            // Hence we need to set it based on editor mode
            innerContainerWidth = 'var(--ak-editor-block-card-width)';
            if (nextNode.type.name === 'embedCard' && [
                'center',
                'align-start',
                'align-end'
            ].includes(nextNode.attrs.layout)) {
                const percentageWidth = ((parseFloat(nextNode.attrs.width) || 100) / 100).toFixed(2);
                innerContainerWidth = `calc(var(--ak-editor--line-length) * ${percentageWidth})`;
            }
        } else if (nextNode.type.name === 'table' && nextNode.firstChild) {
            const tableWidthAnchor = (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? typeof nextNodePos === 'number' ? api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '' : '' : (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
            const isNumberColumnEnabled = Boolean(nextNode.attrs.isNumberColumnEnabled);
            if ((0, $a4QVD.isAnchorSupported)()) innerContainerWidth = isNumberColumnEnabled ? `calc(anchor-size(${tableWidthAnchor} width) + ${$64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH}px)` : `anchor-size(${tableWidthAnchor} width)`;
            else innerContainerWidth = `${(anchorRectCache?.getRect(tableWidthAnchor)?.width || 0) + $64b8abc41abcb6e2$var$TABLE_NUMBERED_COLUMN_WIDTH}px`;
            if (nextNode.attrs.width) // when the table has horizontal scroll
            innerContainerWidth = `min(${nextNode.attrs.width}px, ${innerContainerWidth})`;
        } else if (nextNode.type.name === 'mediaSingle' && nextNode.firstChild) {
            if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) // check pos is a number
            {
                if (typeof nextNodePos === 'number' && nextNode.firstChild?.type.name === 'media') targetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
            } else targetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
        }
        // Set the height target anchor name to the first or last column of the layout section so that it also works for stacked layout
        let heightTargetAnchorName = targetAnchorName;
        if (nextNode.type.name === 'layoutSection' && nextNode.firstChild && nextNode.lastChild) {
            if (isLeftPosition) {
                if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                    if (typeof nextNodePos === 'number') heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1) || '';
                    else heightTargetAnchorName = '';
                } else heightTargetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.firstChild);
            } else if ((0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                if (typeof nextNodePos === 'number') {
                    const lastNodeStartPos = nextNode.content.size - nextNode.lastChild.nodeSize;
                    heightTargetAnchorName = api?.core.actions.getAnchorIdForNode(nextNode.lastChild, lastNodeStartPos + 1) || '';
                } else heightTargetAnchorName = '';
            } else heightTargetAnchorName = (0, $9HWym.getNodeAnchor)(nextNode.lastChild);
        }
        if ((0, $a4QVD.isAnchorSupported)()) {
            const width = innerContainerWidth || `anchor-size(${targetAnchorName} width)`;
            const height = `anchor-size(${heightTargetAnchorName} height)`;
            return {
                width: width,
                height: height,
                top: 'anchor(top)',
                bottom: 'anchor(bottom)',
                widthOffset: $64b8abc41abcb6e2$var$getWidthOffset(nextNode, width, position)
            };
        }
        if (anchorRectCache) {
            const nodeRect = anchorRectCache.getRect(targetAnchorName);
            const width = innerContainerWidth || `${nodeRect?.width || 0}px`;
            const top = nodeRect?.top ? `${nodeRect?.top}px` : 'unset';
            const bottom = `100% - ${nodeRect?.bottom || 0}px + ${$64b8abc41abcb6e2$var$GAP}px`;
            let height = `${nodeRect?.height || 0}px`;
            if (heightTargetAnchorName !== targetAnchorName) {
                const nodeHeightRect = anchorRectCache.getRect(heightTargetAnchorName);
                height = `${nodeHeightRect?.height || 0}px + ${$64b8abc41abcb6e2$var$GAP}px`;
            }
            return {
                width: width,
                height: height,
                top: top,
                bottom: bottom,
                widthOffset: $64b8abc41abcb6e2$var$getWidthOffset(nextNode, width, position)
            };
        }
        return $64b8abc41abcb6e2$var$defaultNodeDimension;
    }, [
        nextNode,
        anchorName,
        anchorRectCache,
        getPos,
        api,
        isLeftPosition,
        position
    ]);
    const onDrop = (0, $cozmU.useCallback)(()=>{
        const { activeNode: activeNode } = api?.blockControls?.sharedState.currentState() || {};
        if (!activeNode) return;
        const toPos = getPos();
        let mappedTo;
        if (activeNode && toPos !== undefined) {
            const { pos: start } = activeNode;
            const moveToEnd = position === 'right';
            api?.core?.actions.execute(({ tr: tr })=>{
                api?.blockControls?.commands?.moveToLayout(start, toPos, {
                    moveToEnd: moveToEnd
                })({
                    tr: tr
                });
                const insertLayoutStep = (0, $8v85f.getInsertLayoutStep)(tr);
                mappedTo = insertLayoutStep?.from;
                return tr;
            });
            api?.core?.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $8v85f.updateSelection)(tr, mappedTo, moveToEnd);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        position
    ]);
    const hoverZoneRectStyle = (0, $cozmU.useMemo)(()=>{
        const isLayoutNode = nextNode?.type.name === 'layoutSection';
        const layoutAdjustment = isLayoutNode ? {
            width: 11,
            height: 4,
            top: 6,
            bottom: 2
        } : undefined;
        return {
            [$64b8abc41abcb6e2$var$HOVER_ZONE_WIDTH]: nodeDimension.widthOffset ? `calc((100% - ${nodeDimension.width})/2 - ${$64b8abc41abcb6e2$var$GAP}px + ${nodeDimension.widthOffset} - ${layoutAdjustment?.width || 0}px)` : `calc((100% - ${nodeDimension.width})/2 - ${$64b8abc41abcb6e2$var$GAP}px - ${layoutAdjustment?.width || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_HEIGHT]: `calc(${nodeDimension.height} + ${layoutAdjustment?.height || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_TOP]: `calc(${nodeDimension.top} + ${layoutAdjustment?.top || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_BOTTOM]: `calc(${nodeDimension.bottom} - ${layoutAdjustment?.bottom || 0}px)`,
            [$64b8abc41abcb6e2$var$HOVER_ZONE_ANCHOR_NAME]: anchorName
        };
    }, [
        nextNode?.type.name,
        nodeDimension,
        anchorName
    ]);
    const dropIndicatorPos = (0, $cozmU.useMemo)(()=>{
        return isLeftPosition ? 'right' : 'left';
    }, [
        isLeftPosition
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) return (0, $iSrRp.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        setIsDraggedOver
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: ref,
        "data-testid": `drop-target-hover-zone-${position}`,
        css: [
            $64b8abc41abcb6e2$var$hoverZoneCommonStyle,
            isLeftPosition ? $64b8abc41abcb6e2$var$leftHoverZoneStyle : $64b8abc41abcb6e2$var$rightHoverZoneStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hoverZoneRectStyle
    }, isDraggedOver ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $vZEJe.DropIndicator), {
        edge: dropIndicatorPos
    }) : isActiveAnchor && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: [
            $64b8abc41abcb6e2$var$dropTargetLayoutHintStyle,
            isLeftPosition && $64b8abc41abcb6e2$var$dropTargetLayoutHintLeftStyle
        ]
    }));
};
module.exports["InlineDropTarget"] = $64b8abc41abcb6e2$export$ade48236ff38648e;

});

parcelRegister("8v85f", function(module, exports) {

var $4EksL = parcelRequire("4EksL");

var $eaLat = parcelRequire("eaLat");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");

const $f1fa1884dbbf5a48$export$fc81c36e83ce2f6b = (tr)=>tr.steps.find((step)=>step instanceof (0, $eOaGc.ReplaceStep) && [
            'layoutSection',
            'layoutColumn'
        ].includes(step.slice.content.firstChild?.type.name || ''));
const $f1fa1884dbbf5a48$export$2e8776145e31b87 = (tr, to, insertAtRight)=>{
    const $to = tr.doc.resolve(to);
    const toNode = $to.nodeAfter;
    let lastNode = toNode?.content.lastChild;
    if (!toNode || !lastNode) return tr;
    let offset = toNode.nodeSize;
    // drop at the start of the layoutSection or to create a new layoutSection
    if (toNode.type.name === 'layoutSection') {
        if (insertAtRight) {
            lastNode = toNode.content.lastChild?.lastChild;
            offset = toNode.nodeSize - 1;
        } else {
            lastNode = toNode.content.firstChild?.lastChild;
            offset = 1 + (toNode.content.firstChild?.nodeSize || 0);
        }
    }
    if ([
        'paragraph',
        'heading'
    ].includes(lastNode?.type.name || '')) tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(to + offset - 2)));
    else if (lastNode) tr.setSelection(new (0, $4EksL.GapCursorSelection)(tr.doc.resolve(to + offset - 1), (0, $eaLat.Side).RIGHT));
    return tr;
};
module.exports["getInsertLayoutStep"] = $f1fa1884dbbf5a48$export$fc81c36e83ce2f6b;
module.exports["updateSelection"] = $f1fa1884dbbf5a48$export$2e8776145e31b87;

});

parcelRegister("g7xpB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $445fdc1231eed741$export$714e822c87fefc18 = (view)=>{
    const selection = view.state.selection;
    return selection instanceof (0, $kCECX.NodeSelection) && selection.$from.depth > 0;
};
const $445fdc1231eed741$export$9aa13fc11fb69569 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    const endPos = start + node.nodeSize;
    const startPos = start;
    const { $from: $from, $to: $to } = view.state.selection;
    return $from.pos >= startPos && endPos >= $to.pos;
};
const $445fdc1231eed741$export$ec6e1e8159855f97 = (view)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $kCECX.TextSelection)) return true;
    else if (selection instanceof (0, $kCECX.NodeSelection)) // check if this is a node that can appear among text
    return selection.node.isInline;
};
const $445fdc1231eed741$export$907327ee9908a2 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    // We want to treat some elements as if they are non-editable blocks for
    // the purposes of quick insert.
    switch(node.type.name){
        // mediaSingle and mediaGroup always contain a media child node, which is
        // both a block and an atom. mediaSingle can also have a caption child node
        // which is an editable block.
        case 'mediaGroup':
        case 'mediaSingle':
            return true;
    }
    return node.isBlock && (node.isAtom || node.isLeaf);
};
module.exports["isNestedNodeSelected"] = $445fdc1231eed741$export$714e822c87fefc18;
module.exports["isSelectionInNode"] = $445fdc1231eed741$export$9aa13fc11fb69569;
module.exports["isInTextSelection"] = $445fdc1231eed741$export$ec6e1e8159855f97;
module.exports["isNonEditableBlock"] = $445fdc1231eed741$export$907327ee9908a2;

});

parcelRegister("5Cc13", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $a11aceeda7cf57c6$export$3ca0fafcb5f79c56 = (start)=>({ tr: tr })=>{
        const nodeSize = tr.doc.nodeAt(start)?.nodeSize;
        if (nodeSize === undefined) return tr;
        const position = start + nodeSize;
        tr.insert(position, tr.doc.type.schema.nodes.paragraph.create());
        return tr.setSelection((0, $kCECX.TextSelection).near(tr.doc.resolve(position)));
    };
module.exports["createNewLine"] = $a11aceeda7cf57c6$export$3ca0fafcb5f79c56;

});

parcelRegister("bnCpE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $dc8372ba6657a890$export$35954ff4e514ba11 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $kCECX.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const parentNodeOfSpecificTypes = (0, $bjg0G.findParentNodeOfType)([
            schema.nodes.bulletList,
            schema.nodes.orderedList,
            schema.nodes.blockquote,
            schema.nodes.taskList,
            schema.nodes.decisionList
        ])(selection);
        if (parentNodeOfSpecificTypes) {
            const parentNodeType = parentNodeOfSpecificTypes.node.type.name;
            nestedNodePos = [
                'bulletList',
                'orderedList'
            ].includes(parentNodeType) ? $pos.before($pos.depth - 1) : [
                'blockquote',
                'taskList',
                'decisionList'
            ].includes(parentNodeType) ? $pos.before() : nestedNodePos;
        }
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $dc8372ba6657a890$export$ac406f4d57a10c33 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $kCECX.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const { bulletList: bulletList, orderedList: orderedList, taskList: taskList, decisionList: decisionList, caption: caption } = schema.nodes;
        const isInList = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            orderedList,
            taskList
        ])(selection);
        const isInNodeWithoutDragHandle = (0, $bjg0G.findParentNodeOfType)([
            caption,
            decisionList
        ])(selection);
        if (isInList) // Only show drag handle at outermost list parent
        nestedNodePos = $dc8372ba6657a890$var$getOutermostListPos($pos, resolve);
        else if (isInNodeWithoutDragHandle) // return the position of their parent if there should be no drag handle before the node
        nestedNodePos = $pos.before();
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $dc8372ba6657a890$var$getOutermostListPos = ($pos, resolve)=>{
    if ($pos.depth === 0) return $pos.pos;
    const parentPos = $pos.before();
    const parentNode = $pos.parent;
    if (parentNode && [
        'bulletList',
        'listItem',
        'orderedList',
        'taskList',
        'taskItem'
    ].includes(parentNode.type.name)) return $dc8372ba6657a890$var$getOutermostListPos(resolve(parentPos), resolve);
    return $pos.pos;
};
module.exports["getNestedNodePosition"] = $dc8372ba6657a890$export$35954ff4e514ba11;
module.exports["getNestedNodeStartingPosition"] = $dc8372ba6657a890$export$ac406f4d57a10c33;

});

parcelRegister("izfLh", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $fqVYq = parcelRequire("fqVYq");


var $irTNm = parcelRequire("irTNm");


var $icvkv = parcelRequire("icvkv");


var $7vrPh = parcelRequire("7vrPh");

const $0896a2e13569b3ce$export$29bd206d467fd44 = (tr, $from, to)=>{
    const sourceContent = tr.doc.slice($from.pos, to).content;
    const isLayoutColumn = (0, $irTNm.isFragmentOfType)(sourceContent, 'layoutColumn');
    /**
	 * This logic is used to handle the case when a user tries to delete a layout column
	 * that contains only 2 child node, and single column layouts are not enabled.
	 * In this case, we delete the layout column and replace it with its content.
	 */ if (isLayoutColumn && !(0, $fqVYq.editorExperiment)('single_column_layouts', true)) {
        const sourceParent = $from.parent;
        if (sourceParent.childCount === (0, $icvkv.MIN_LAYOUT_COLUMN)) {
            // Only delete the layout content, but keep the layout column itself
            // This logic should be remove when we clean up the code for single column layouts.
            // since this step has no effect on the layout column, because the parent node is removed in the later step.
            tr.delete($from.pos + 1, to - 1);
            // This check should be remove when clean up the code for single column layouts.
            // since it has been checked in the previous step.
            if (sourceParent.childCount === 2) {
                const layoutContentFragment = $from.parentOffset === 0 ? (0, $aPdNQ.Fragment).from($from.parent.lastChild?.content) : (0, $aPdNQ.Fragment).from($from.parent.firstChild?.content);
                const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>{
                    return node.type.name === 'layoutSection';
                });
                if (parent && layoutContentFragment) {
                    const layoutSectionPos = tr.mapping.map(parent.pos);
                    // get the updated layout node size
                    const layoutSectionNodeSize = tr.doc.resolve(layoutSectionPos).nodeAfter?.nodeSize || 0;
                    tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment);
                }
            }
            return tr;
        } else (0, $7vrPh.updateColumnWidths)(tr, $from.parent, $from.before($from.depth), sourceParent.childCount - 1);
    }
    tr.delete($from.pos, to);
    return tr;
};
module.exports["removeFromSource"] = $0896a2e13569b3ce$export$29bd206d467fd44;

});

parcelRegister("9aKak", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $cycWk = parcelRequire("cycWk");

var $8imfU = parcelRequire("8imfU");


var $fqVYq = parcelRequire("fqVYq");


var $i2jOy = parcelRequire("i2jOy");

const $7a64999ea229affc$export$c57c553e4ac98a48 = (selection)=>{
    // Special case: if a table is selected, we want to move the entire table node
    const tableInfo = (0, $cycWk.findTable)(selection);
    if (tableInfo && (0, $8imfU.isTableSelected)(selection)) {
        const tablePos = tableInfo.pos;
        const tableTo = tablePos + tableInfo.node.nodeSize;
        return {
            from: tablePos,
            to: tableTo
        };
    }
    // Special case: if a media node (file) is selected, we need to get the parent mediaGroup
    // This handles the case where clicking on a file creates a NodeSelection of the media node
    // but we want to move the entire mediaGroup that wraps it
    if (selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file' && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
        // The media node is wrapped in a mediaGroup, so we need to get the parent position
        const mediaGroupPos = selection.$from.pos - 1;
        const mediaGroupNode = selection.$from.doc.nodeAt(mediaGroupPos);
        if (mediaGroupNode && mediaGroupNode.type.name === 'mediaGroup') return {
            from: mediaGroupPos,
            to: mediaGroupPos + mediaGroupNode.nodeSize
        };
    }
    // Use createPreservedSelection to get properly expanded block boundaries
    const preservedSelection = (0, $i2jOy.createPreservedSelection)(selection.$from, selection.$to);
    if (!preservedSelection) return undefined;
    return {
        from: preservedSelection.from,
        to: preservedSelection.to
    };
};
const $7a64999ea229affc$export$6e259a78a1c38d78 = ($currentNodePos, currentNodePos)=>{
    const nodeIndex = $currentNodePos.index();
    const nodeBefore = $currentNodePos.depth > 1 && nodeIndex === 0 ? $currentNodePos.node($currentNodePos.depth) : $currentNodePos.nodeBefore;
    if (nodeBefore?.type.name === 'layoutColumn' && (0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) return -1;
    return nodeBefore ? currentNodePos - nodeBefore.nodeSize : -1;
};
const $7a64999ea229affc$export$3545fa32cdadf3ca = ({ $currentNodePos: $currentNodePos, nodeAfterPos: nodeAfterPos, tr: tr })=>{
    const endOfDoc = $currentNodePos.end();
    if (nodeAfterPos > endOfDoc) return -1;
    const nodeAfter = tr.doc.nodeAt(nodeAfterPos);
    if ((0, $fqVYq.editorExperiment)('platform_editor_block_menu', true)) {
        const nodeAtCurrentPos = tr.doc.nodeAt($currentNodePos.pos);
        // if move empty line down to another empty line, move to the position of the next empty line
        if (nodeAtCurrentPos?.content.size === 0 && nodeAtCurrentPos.type.name !== 'extension' && nodeAfter?.content.size === 0 && nodeAfter.type.name !== 'extension') return nodeAfterPos;
    }
    // if not the last node, move to the end of the next node
    return nodeAfter ? nodeAfterPos + nodeAfter.nodeSize : -1;
};
const $7a64999ea229affc$export$c6093962982030d2 = ({ currentNodePos: currentNodePos, moveToPos: moveToPos, tr: tr })=>{
    // only move the node if the destination is at the same depth, not support moving a nested node to a parent node
    return moveToPos > -1 && tr.doc.resolve(currentNodePos).depth === tr.doc.resolve(moveToPos).depth;
};
const $7a64999ea229affc$export$cc4db90b9d5a445a = (tr)=>{
    const nodeBounds = $7a64999ea229affc$export$c57c553e4ac98a48(tr.selection);
    if (!nodeBounds || nodeBounds.from <= -1) return {
        moveUp: false,
        moveDown: false
    };
    const currentNodePos = nodeBounds.from;
    const $currentNodePos = tr.doc.resolve(currentNodePos);
    const nodeAfterPos = nodeBounds.to;
    const moveUpPos = $7a64999ea229affc$export$6e259a78a1c38d78($currentNodePos, currentNodePos);
    const moveDownPos = $7a64999ea229affc$export$3545fa32cdadf3ca({
        $currentNodePos: $currentNodePos,
        nodeAfterPos: nodeAfterPos,
        tr: tr
    });
    return {
        moveUp: $7a64999ea229affc$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveUpPos,
            tr: tr
        }),
        moveDown: $7a64999ea229affc$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveDownPos,
            tr: tr
        })
    };
};
module.exports["getNodeBoundsFromSelection"] = $7a64999ea229affc$export$c57c553e4ac98a48;
module.exports["getPosWhenMoveNodeUp"] = $7a64999ea229affc$export$6e259a78a1c38d78;
module.exports["getPosWhenMoveNodeDown"] = $7a64999ea229affc$export$3545fa32cdadf3ca;
module.exports["canMoveNodeUpOrDown"] = $7a64999ea229affc$export$cc4db90b9d5a445a;

});

parcelRegister("aeh46", function(module, exports) {
var $1f3d721a90b66bdf$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $1f3d721a90b66bdf$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});
module.exports["EVENT"] = $1f3d721a90b66bdf$export$e39a34cfd532e15;
module.exports["EVENT_SUBJECT"] = $1f3d721a90b66bdf$export$97c6cb64ce06a88a;

});

parcelRegister("2gLCX", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0311cba0dc6d9699$export$5ac810f4a4d76ba2 = (0, $kSwu1.defineMessages)({
    dropPlaceholderLabel: {
        id: "fabric.editor.dropPlaceholderLabel",
        defaultMessage: "Document"
    }
});
module.exports["dropPlaceholderMessages"] = $0311cba0dc6d9699$export$5ac810f4a4d76ba2;

});

parcelRegister("7SGh9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dOBRD = parcelRequire("dOBRD");


var $eq1BO = parcelRequire("eq1BO");


var $gBjHb = parcelRequire("gBjHb");


var $krYZG = parcelRequire("krYZG");


var $g6uqx = parcelRequire("g6uqx");


var $eS0D9 = parcelRequire("eS0D9");

var $95ME4 = parcelRequire("95ME4");

var $gckmL = parcelRequire("gckmL");


var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");


var $17wiG = parcelRequire("17wiG");

var $3lbOc = parcelRequire("3lbOc");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $2mgqy = parcelRequire("2mgqy");


var $5arVd = parcelRequire("5arVd");

const $5651dda67da50697$export$c9940009a015ae53 = 125;
const $5651dda67da50697$export$e9329f8fc8b15625 = 156;
class $5651dda67da50697$export$56a8c4089468c01e extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps, nextState) {
        const hasNewViewMediaClientConfig = !this.state.viewMediaClientConfig && nextState.viewMediaClientConfig;
        const hasNewViewAndUploadMediaClientConfig = !this.state.viewAndUploadMediaClientConfig && nextState.viewAndUploadMediaClientConfig;
        if (this.props.selected !== nextProps.selected || this.props.node.attrs.id !== nextProps.node.attrs.id || this.props.node.attrs.collection !== nextProps.node.attrs.collection || this.props.isAIGenerating !== nextProps.isAIGenerating || this.props.maxDimensions.height !== nextProps.maxDimensions.height || this.props.maxDimensions.width !== nextProps.maxDimensions.width || this.props.contextIdentifierProvider !== nextProps.contextIdentifierProvider || this.props.isLoading !== nextProps.isLoading || this.props.isViewOnly !== nextProps.isViewOnly || this.props.mediaProvider !== nextProps.mediaProvider || this.props.syncProvider !== nextProps.syncProvider || hasNewViewMediaClientConfig || hasNewViewAndUploadMediaClientConfig) return true;
        return false;
    }
    async componentDidMount() {
        this.handleNewNode(this.props);
        const { node: node, pluginInjectionApi: pluginInjectionApi } = this.props;
        const dataConsumerMark = this.getDataConsumerMark();
        const infographicType = dataConsumerMark?.attrs.sources?.[0];
        if (infographicType) pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).RENDERED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MEDIA,
            actionSubjectId: node.attrs.id,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                infographicType: infographicType,
                pageMode: 'edit',
                mediaId: node.attrs.id
            }
        });
        const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
        this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        await this.setViewMediaClientConfig();
    }
    componentWillUnmount() {
        const { node: node } = this.props;
        this.mediaPluginState?.handleMediaNodeUnmount(node);
        if (this.unbindKeyDown && typeof this.unbindKeyDown === 'function') this.unbindKeyDown();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.node.attrs.id !== this.props.node.attrs.id) {
            this.mediaPluginState?.handleMediaNodeUnmount(prevProps.node);
            this.handleNewNode(this.props);
        }
        this.mediaPluginState?.updateElement();
        this.setViewMediaClientConfig();
        // this.videoControlsWrapperRef is null on componentDidMount. We need to wait until it has value
        if (this.videoControlsWrapperRef && this.videoControlsWrapperRef.current) {
            if (!this.mediaPluginState?.videoControlsWrapperRef) {
                this.bindKeydown();
                this.mediaPluginState?.updateAndDispatch({
                    videoControlsWrapperRef: this.videoControlsWrapperRef.current
                });
            }
        }
    }
    bindKeydown() {
        const onKeydown = (event)=>{
            if (event.key === 'Tab') {
                // Add focus trap for controls panel
                let firstElement;
                let lastElement;
                const focusableElements = this.videoControlsWrapperRef?.current?.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
                if (focusableElements && focusableElements.length) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    firstElement = focusableElements[0];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    lastElement = focusableElements[focusableElements.length - 1];
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement?.focus();
                    }
                }
            }
        };
        if (this.videoControlsWrapperRef?.current) this.unbindKeyDown = (0, $cbY7C.bind)(this.videoControlsWrapperRef.current, {
            type: 'keydown',
            listener: onKeydown,
            options: {
                capture: true,
                passive: false
            }
        });
    }
    render() {
        const { node: node, selected: selected, originalDimensions: originalDimensions, isLoading: isLoading, maxDimensions: maxDimensions, mediaOptions: mediaOptions } = this.props;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const dataConsumerMark = this.getDataConsumerMark();
        const { viewMediaClientConfig: viewMediaClientConfig, viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig, contextIdentifierProvider: contextIdentifierProvider } = this.state;
        const { id: id, type: type, collection: collection, url: url, alt: alt } = node.attrs;
        // Check if we have any media client config available (syncProvider, state, or upload config)
        const hasNoMediaClientConfig = !viewMediaClientConfig && ((0, $ixfCV.fg)('platform_media_video_captions') ? !viewAndUploadMediaClientConfig : true);
        if (isLoading || type !== 'external' && hasNoMediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5arVd.MediaCardWrapper), {
            dimensions: originalDimensions,
            borderWidth: borderMark?.attrs.size,
            selected: selected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            interactionName: "editor-media-card-loading"
        }));
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = type === 'external' ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        } : {
            id: id,
            mediaItemType: 'file',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            collectionName: collection
        };
        const resolvedViewAndUploadMediaClientConfig = (0, $ixfCV.fg)('platform_media_video_captions') ? viewAndUploadMediaClientConfig : undefined;
        // mediaClientConfig is not needed for "external" case. So we have to cheat here.
        // there is a possibility mediaClientConfig will be part of a identifier,
        // so this might be not an issue
        const mediaClientConfig = resolvedViewAndUploadMediaClientConfig || viewMediaClientConfig || {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            authProvider: ()=>({})
        };
        const ssr = 'client';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5arVd.MediaCardWrapper), {
            dimensions: originalDimensions,
            onContextMenu: this.selectMediaSingle,
            borderWidth: borderMark?.attrs.size,
            selected: selected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                [(0, $eq1BO.MEDIA_CONTEXT)]: {
                    border: !!borderMark,
                    // Only defined for remix-generated media (i.e. media nodes with a dataConsumer mark).
                    // Format: "remix:{type}:{subtype}" e.g. "remix:infographic:corporate-doodle"
                    remixSource: dataConsumerMark?.attrs.sources?.[0]
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17wiG.default), {
            mediaClientConfig: mediaClientConfig,
            resizeMode: "stretchy-fit",
            dimensions: maxDimensions,
            originalDimensions: originalDimensions,
            identifier: identifier,
            selectable: true,
            selected: selected,
            disableOverlay: true,
            onFullscreenChange: this.onFullscreenChange,
            onClick: this.selectMediaSingleFromCard,
            useInlinePlayer: mediaOptions && mediaOptions.allowLazyLoading,
            isLazy: mediaOptions && mediaOptions.allowLazyLoading,
            featureFlags: mediaOptions && mediaOptions.featureFlags,
            contextId: contextId,
            alt: alt,
            videoControlsWrapperRef: this.videoControlsWrapperRef,
            ssr: ssr,
            mediaSettings: this.getMediaSettings(viewAndUploadMediaClientConfig, this.props.isViewOnly),
            isAIGenerating: !!this.props.isAIGenerating,
            onPreviewRender: this.onPreviewRender,
            fallbackMediaNameFetcher: mediaOptions?.fallbackMediaNameFetcher,
            onError: (0, $ieeJu.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
        })));
    }
    constructor(_props){
        super(_props);
        this.mediaPluginState = void 0;
        this.state = {};
        this.videoControlsWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.unbindKeyDown = null;
        this.getDataConsumerMark = ()=>(0, $ixfCV.fg)('cc-maui-add-mark-for-remix-generated-images') ? this.props.node.marks.find((m)=>m.type.name === 'dataConsumer') : undefined;
        this.setViewMediaClientConfig = async ()=>{
            // mediaProvider is Promise<MediaProvider>, so await it first to get the actual provider
            const mediaProvider = await this.props.mediaProvider;
            if (mediaProvider) {
                const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
                const viewAndUploadMediaClientConfig = mediaProvider.viewAndUploadMediaClientConfig;
                // Only update state if new configs are available and different from current state
                if (viewMediaClientConfig && this.state.viewMediaClientConfig !== viewMediaClientConfig || viewAndUploadMediaClientConfig && this.state.viewAndUploadMediaClientConfig !== viewAndUploadMediaClientConfig) this.setState({
                    viewMediaClientConfig: viewMediaClientConfig,
                    viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
                });
            }
        };
        this.selectMediaSingleFromCard = ({ event: event })=>{
            this.selectMediaSingle(event);
            // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
            // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if (this.props.isViewOnly && (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(this.props.pluginInjectionApi?.toolbar))) event.preventDefault();
        };
        this.selectMediaSingle = (event)=>{
            const propPos = this.props.getPos();
            if (typeof propPos !== 'number') return;
            // NOTE: This does not prevent the link navigation in the editor view mode, .preventDefault is needed (see selectMediaSingleFromCard)
            // Hence it should be removed
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'control')) event.stopPropagation();
            const { state: state } = this.props.view;
            if (event.shiftKey) {
                // don't select text if there is current selection in a table (as this would override selected cells)
                if (state.selection instanceof (0, $8HW7o.CellSelection)) return;
                (0, $95ME4.setTextSelection)(this.props.view, state.selection.from < propPos ? state.selection.from : propPos - 1, // + 3 needed for offset of the media inside mediaSingle and cursor to make whole mediaSingle selected
                state.selection.to > propPos ? state.selection.to : propPos + 2);
            } else (0, $eS0D9.setNodeSelection)(this.props.view, propPos - 1);
        };
        this.getMediaSettings = (0, $dOBRD.default)((viewAndUploadMediaClientConfig, isViewOnly)=>{
            return {
                canUpdateVideoCaptions: (0, $ixfCV.fg)('platform_media_video_captions') ? (0, $ixfCV.fg)('platform_editor_video_caption_commit') ? !!viewAndUploadMediaClientConfig && !isViewOnly : !!viewAndUploadMediaClientConfig : false
            };
        });
        this.onPreviewRender = (fileId)=>{
            if ((0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true)) this.props.pluginInjectionApi?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $2mgqy.stateKey), {
                    type: 'PREVIEW_RENDERED',
                    fileId: fileId
                }));
        };
        this.onError = (reason)=>{
            const nestedUnder = this.getNestedUnder();
            this.props.api?.media.actions.handleMediaNodeRenderError(this.props.node, reason, nestedUnder);
        };
        /**
     * This function checks if the media node is nested under a certain nodes, and if so,
     * returns the name of the parent node type. This is used for providing more context in media render errors.
     * @returns
     */ this.getNestedUnder = ()=>{
            const pos = this.props.getPos();
            if (typeof pos !== 'number') return undefined;
            const { doc: doc, schema: schema } = this.props.view.state;
            const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
            if (!bodiedSyncBlock) return undefined;
            const resolvedPos = doc.resolve(pos);
            const bodiedSyncBlockNode = (0, $bjg0G.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === bodiedSyncBlock);
            return bodiedSyncBlockNode?.node.type.name;
        };
        this.onFullscreenChange = (fullscreen)=>{
            this.mediaPluginState?.updateAndDispatch({
                isFullscreen: fullscreen
            });
        };
        this.handleNewNode = (props)=>{
            const { node: node } = props;
            this.mediaPluginState?.handleMediaNodeMount(node, ()=>this.props.getPos());
        };
        const { view: view, syncProvider: syncProvider } = this.props;
        this.mediaPluginState = (0, $2mgqy.stateKey).getState(view.state);
        // Initialize state from syncProvider (available on both server and client for SSR)
        if (syncProvider) this.state = {
            viewMediaClientConfig: syncProvider.viewMediaClientConfig,
            viewAndUploadMediaClientConfig: syncProvider.viewAndUploadMediaClientConfig
        };
    }
}
const $5651dda67da50697$var$_default_1 = (0, $gckmL.withImageLoader)($5651dda67da50697$export$56a8c4089468c01e);
var $5651dda67da50697$export$2e2bcd8739ae039 = $5651dda67da50697$var$_default_1;
module.exports["MEDIA_HEIGHT"] = $5651dda67da50697$export$c9940009a015ae53;
module.exports["FILE_WIDTH"] = $5651dda67da50697$export$e9329f8fc8b15625;
module.exports["default"] = $5651dda67da50697$export$2e2bcd8739ae039;

});

parcelRegister("eJkRA", function(module, exports) {
const $fbdfcc99ac4248e2$export$5fe5572478566289 = (preview)=>!!preview.dimensions;
module.exports["isImagePreview"] = $fbdfcc99ac4248e2$export$5fe5572478566289;

});

parcelRegister("1gg4H", function(module, exports) {
const $16341d19456791c3$export$a5a8e8321fc18ce = (node)=>{
    if ('mediaSingle' === node?.type.name) {
        if ([
            'wrap-right',
            'wrap-left'
        ].includes(node.attrs.layout)) return true;
    }
    return false;
};
module.exports["isWrappedMedia"] = $16341d19456791c3$export$a5a8e8321fc18ce;

});

parcelRegister("irTNm", function(module, exports) {
const $054dddf2eb579832$export$2b4dd9f6b8f819da = (fragment, type)=>fragment.childCount === 1 && fragment.firstChild?.type.name === type;
const $054dddf2eb579832$export$8cb5c38ddf4d519f = (fragment, type)=>{
    for(let i = 0; i < fragment.childCount; i++){
        const child = fragment.child(i);
        if (child.type.name === type) return true;
    }
    return false;
};
module.exports["isFragmentOfType"] = $054dddf2eb579832$export$2b4dd9f6b8f819da;
module.exports["containsNodeOfType"] = $054dddf2eb579832$export$8cb5c38ddf4d519f;

});

parcelRegister("7vrPh", function(module, exports) {

var $hTjcC = parcelRequire("hTjcC");

const $fa015684aa46543e$export$6688b13ec132acdf = (tr, layoutNode, layoutNodePos, childCount)=>{
    const newColumnWidth = (0, $hTjcC.DEFAULT_COLUMN_DISTRIBUTIONS)[childCount];
    if (newColumnWidth) layoutNode.content.forEach((node, offset)=>{
        if (node.type.name === 'layoutColumn') tr.setNodeAttribute(layoutNodePos + offset + 1, 'width', newColumnWidth);
    });
    return {
        newColumnWidth: newColumnWidth,
        tr: tr
    };
};
module.exports["updateColumnWidths"] = $fa015684aa46543e$export$6688b13ec132acdf;

});

parcelRegister("5arVd", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $hNvnn = parcelRequire("hNvnn");


var $ixfCV = parcelRequire("ixfCV");

function $d5d02b89244f7d35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d5d02b89244f7d35$export$91aa6761f022a358 = 'media-single-node';
const $d5d02b89244f7d35$var$absoluteDivStyles = {
    name: "19s8nj4",
    styles: "position:absolute;width:100%;height:100%"
};
const $d5d02b89244f7d35$var$forcedDimensionsStyles = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $d5d02b89244f7d35$var$pointerCursorStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $d5d02b89244f7d35$export$d307b3919391b84f = ({ dimensions: dimensions, children: children, selected: selected, borderWidth: borderWidth = 0, onContextMenu: onContextMenu })=>{
    const calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
    // [FEATURE FLAG: platform_editor_media_border_radius_fix]
    // Fixes border radius calculation to properly fit image with 8px radius
    // To clean up: keep only flag-on behavior (calculatedBorderWidth + 8)
    const borderRadius = (0, $ixfCV.fg)('platform_editor_media_border_radius_fix') ? `${calculatedBorderWidth + 8}px` : `${calculatedBorderWidth * 2}px`; // OLD BEHAVIOR (to be removed when flag is cleaned up)
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "media-card-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "media-card-wrapper",
        css: $d5d02b89244f7d35$var$pointerCursorStyle,
        style: {
            borderColor: `var(--custom-palette-color)`,
            borderWidth: `${calculatedBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderStyle: 'solid',
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $d5d02b89244f7d35$var$forcedDimensionsStyles,
        style: {
            paddingBottom: `${dimensions.height / dimensions.width * 100}%`
        },
        onContextMenuCapture: onContextMenu
    }, borderWidth > 0 && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaBorderGapFiller), {
        borderColor: `var(--custom-palette-color)`
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $d5d02b89244f7d35$var$absoluteDivStyles
    }, children)));
};
module.exports["MediaSingleNodeSelector"] = $d5d02b89244f7d35$export$91aa6761f022a358;
module.exports["MediaCardWrapper"] = $d5d02b89244f7d35$export$d307b3919391b84f;

});


$parcel$global.rlb("eRcQY")
//# sourceMappingURL=ConversationAssistant.89479e74.js.map
